/*! For license information please see elements-common.js.LICENSE.txt */
(function webpackUniversalModuleDefinition(root, factory) {
    if (typeof exports === "object" && typeof module === "object") module.exports = factory(require("d3")); else if (typeof define === "function" && define.amd) define([ "d3" ], factory); else {
        var a = typeof exports === "object" ? factory(require("d3")) : factory(root["d3"]);
        for (var i in a) (typeof exports === "object" ? exports : root)[i] = a[i];
    }
})(window, (function(__WEBPACK_EXTERNAL_MODULE_d3__) {
    return function(modules) {
        function webpackJsonpCallback(data) {
            var chunkIds = data[0];
            var moreModules = data[1];
            var executeModules = data[2];
            var moduleId, chunkId, i = 0, resolves = [];
            for (;i < chunkIds.length; i++) {
                chunkId = chunkIds[i];
                if (Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
                    resolves.push(installedChunks[chunkId][0]);
                }
                installedChunks[chunkId] = 0;
            }
            for (moduleId in moreModules) {
                if (Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
                    modules[moduleId] = moreModules[moduleId];
                }
            }
            if (parentJsonpFunction) parentJsonpFunction(data);
            while (resolves.length) {
                resolves.shift()();
            }
            deferredModules.push.apply(deferredModules, executeModules || []);
            return checkDeferredModules();
        }
        function checkDeferredModules() {
            var result;
            for (var i = 0; i < deferredModules.length; i++) {
                var deferredModule = deferredModules[i];
                var fulfilled = true;
                for (var j = 1; j < deferredModule.length; j++) {
                    var depId = deferredModule[j];
                    if (installedChunks[depId] !== 0) fulfilled = false;
                }
                if (fulfilled) {
                    deferredModules.splice(i--, 1);
                    result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
                }
            }
            return result;
        }
        var installedModules = {};
        var installedChunks = {
            "elements-common": 0
        };
        var deferredModules = [];
        function __webpack_require__(moduleId) {
            if (installedModules[moduleId]) {
                return installedModules[moduleId].exports;
            }
            var module = installedModules[moduleId] = {
                i: moduleId,
                l: false,
                exports: {}
            };
            modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
            module.l = true;
            return module.exports;
        }
        __webpack_require__.m = modules;
        __webpack_require__.c = installedModules;
        __webpack_require__.d = function(exports, name, getter) {
            if (!__webpack_require__.o(exports, name)) {
                Object.defineProperty(exports, name, {
                    enumerable: true,
                    get: getter
                });
            }
        };
        __webpack_require__.r = function(exports) {
            if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
                Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
            }
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
        };
        __webpack_require__.t = function(value, mode) {
            if (mode & 1) value = __webpack_require__(value);
            if (mode & 8) return value;
            if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
            var ns = Object.create(null);
            __webpack_require__.r(ns);
            Object.defineProperty(ns, "default", {
                enumerable: true,
                value: value
            });
            if (mode & 2 && typeof value != "string") for (var key in value) __webpack_require__.d(ns, key, function(key) {
                return value[key];
            }.bind(null, key));
            return ns;
        };
        __webpack_require__.n = function(module) {
            var getter = module && module.__esModule ? function getDefault() {
                return module["default"];
            } : function getModuleExports() {
                return module;
            };
            __webpack_require__.d(getter, "a", getter);
            return getter;
        };
        __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        __webpack_require__.p = "";
        var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
        var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
        jsonpArray.push = webpackJsonpCallback;
        jsonpArray = jsonpArray.slice();
        for (var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
        var parentJsonpFunction = oldJsonpFunction;
        deferredModules.push([ "./src/index-common.js", "elements-core" ]);
        return checkDeferredModules();
    }({
        "./node_modules/@brightcove/player-loader/dist/brightcove-player-loader.es.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var global_document__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/global/document.js");
            var global_document__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(global_document__WEBPACK_IMPORTED_MODULE_0__);
            var global_window__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/global/window.js");
            var global_window__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(global_window__WEBPACK_IMPORTED_MODULE_1__);
            function _extends() {
                _extends = Object.assign || function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            var version = "1.7.1";
            var version$1 = "1.2.0";
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            var JSON_ALLOWED_PARAMS = [ "catalogSearch", "catalogSequence" ];
            var IFRAME_ALLOWED_QUERY_PARAMS = [ "adConfigId", "applicationId", "catalogSearch", "catalogSequence", "playlistId", "playlistVideoId", "videoId" ];
            var getQueryParamValue = function getQueryParamValue(params, key) {
                if (!params || params[key] === undefined) {
                    return;
                }
                if (typeof params[key] !== "string" && JSON_ALLOWED_PARAMS.indexOf(key) !== -1) {
                    try {
                        return encodeURIComponent(JSON.stringify(params[key]));
                    } catch (x) {
                        return;
                    }
                }
                return encodeURIComponent(String(params[key]).trim()) || undefined;
            };
            var getQueryString = function getQueryString(params) {
                return Object.keys(params).filter((function(k) {
                    return IFRAME_ALLOWED_QUERY_PARAMS.indexOf(k) !== -1;
                })).reduce((function(qs, k) {
                    var value = getQueryParamValue(params, k);
                    if (value !== undefined) {
                        qs += qs ? "&" : "?";
                        qs += encodeURIComponent(k) + "=" + value;
                    }
                    return qs;
                }), "");
            };
            var brightcovePlayerUrl = function brightcovePlayerUrl(_ref) {
                var accountId = _ref.accountId, _ref$base = _ref.base, base = _ref$base === undefined ? "https://players.brightcove.net" : _ref$base, _ref$playerId = _ref.playerId, playerId = _ref$playerId === undefined ? "default" : _ref$playerId, _ref$embedId = _ref.embedId, embedId = _ref$embedId === undefined ? "default" : _ref$embedId, _ref$iframe = _ref.iframe, iframe = _ref$iframe === undefined ? false : _ref$iframe, _ref$minified = _ref.minified, minified = _ref$minified === undefined ? true : _ref$minified, _ref$queryParams = _ref.queryParams, queryParams = _ref$queryParams === undefined ? null : _ref$queryParams;
                var ext = "";
                if (iframe) {
                    ext += "html";
                } else {
                    if (minified) {
                        ext += "min.";
                    }
                    ext += "js";
                }
                if (base.charAt(base.length - 1) === "/") {
                    base = base.substring(0, base.length - 1);
                }
                var qs = "";
                if (iframe && queryParams && (typeof queryParams === "undefined" ? "undefined" : _typeof(queryParams)) === "object") {
                    qs = getQueryString(queryParams);
                }
                accountId = encodeURIComponent(accountId);
                playerId = encodeURIComponent(playerId);
                embedId = encodeURIComponent(embedId);
                return base + "/" + accountId + "/" + playerId + "_" + embedId + "/index." + ext + qs;
            };
            brightcovePlayerUrl.VERSION = version$1;
            var DEFAULTS = {
                embedId: "default",
                embedType: "in-page",
                playerId: "default",
                Promise: global_window__WEBPACK_IMPORTED_MODULE_1___default.a.Promise,
                refNodeInsert: "append"
            };
            var DEFAULT_ASPECT_RATIO = "16:9";
            var DEFAULT_IFRAME_HORIZONTAL_PLAYLIST = false;
            var DEFAULT_MAX_WIDTH = "100%";
            var EMBED_TAG_NAME_VIDEO = "video";
            var EMBED_TAG_NAME_VIDEOJS = "video-js";
            var EMBED_TYPE_IN_PAGE = "in-page";
            var EMBED_TYPE_IFRAME = "iframe";
            var REF_NODE_INSERT_APPEND = "append";
            var REF_NODE_INSERT_PREPEND = "prepend";
            var REF_NODE_INSERT_BEFORE = "before";
            var REF_NODE_INSERT_AFTER = "after";
            var REF_NODE_INSERT_REPLACE = "replace";
            var JSON_ALLOWED_ATTRS = [ "catalogSearch", "catalogSequence" ];
            var BASE_URL = "https://players.brightcove.net/";
            var getUrl = function getUrl(params) {
                if (params.playerUrl) {
                    return params.playerUrl;
                }
                var accountId = params.accountId, playerId = params.playerId, embedId = params.embedId, embedOptions = params.embedOptions;
                var iframe = params.embedType === EMBED_TYPE_IFRAME;
                return brightcovePlayerUrl({
                    accountId: accountId,
                    playerId: playerId,
                    embedId: embedId,
                    iframe: iframe,
                    base: BASE_URL,
                    minified: embedOptions ? !embedOptions.unminified : true,
                    queryParams: params
                });
            };
            var getBaseUrl = function getBaseUrl() {
                return BASE_URL;
            };
            var setBaseUrl = function setBaseUrl(baseUrl) {
                BASE_URL = baseUrl;
            };
            var urls = {
                getUrl: getUrl,
                getBaseUrl: getBaseUrl,
                setBaseUrl: setBaseUrl
            };
            var isEl = function isEl(el) {
                return Boolean(el && el.nodeType === 1);
            };
            var isElInDom = function isElInDom(el) {
                return Boolean(isEl(el) && el.parentNode);
            };
            var createIframeEmbed = function createIframeEmbed(params) {
                var el = global_document__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("iframe");
                el.setAttribute("allow", "autoplay;encrypted-media;fullscreen");
                el.setAttribute("allowfullscreen", "allowfullscreen");
                el.src = urls.getUrl(params);
                return el;
            };
            var createInPageEmbed = function createInPageEmbed(params) {
                var embedOptions = params.embedOptions;
                var paramsToAttrs = {
                    adConfigId: "data-ad-config-id",
                    applicationId: "data-application-id",
                    catalogSearch: "data-catalog-search",
                    catalogSequence: "data-catalog-sequence",
                    deliveryConfigId: "data-delivery-config-id",
                    playlistId: "data-playlist-id",
                    playlistVideoId: "data-playlist-video-id",
                    videoId: "data-video-id"
                };
                var tagName = embedOptions && embedOptions.tagName || EMBED_TAG_NAME_VIDEOJS;
                var el = global_document__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(tagName);
                Object.keys(paramsToAttrs).filter((function(key) {
                    return params[key];
                })).forEach((function(key) {
                    var value;
                    if (typeof params[key] !== "string" && JSON_ALLOWED_ATTRS.indexOf(key) !== -1) {
                        try {
                            value = JSON.stringify(params[key]);
                        } catch (x) {
                            return;
                        }
                    } else {
                        value = String(params[key]).trim();
                    }
                    el.setAttribute(paramsToAttrs[key], value);
                }));
                el.setAttribute("controls", "controls");
                el.classList.add("video-js");
                return el;
            };
            var wrapResponsive = function wrapResponsive(embedType, embedOptions, el) {
                if (!embedOptions.responsive) {
                    return el;
                }
                el.style.position = "absolute";
                el.style.top = "0px";
                el.style.right = "0px";
                el.style.bottom = "0px";
                el.style.left = "0px";
                el.style.width = "100%";
                el.style.height = "100%";
                var responsive = _extends({
                    aspectRatio: DEFAULT_ASPECT_RATIO,
                    iframeHorizontalPlaylist: DEFAULT_IFRAME_HORIZONTAL_PLAYLIST,
                    maxWidth: DEFAULT_MAX_WIDTH
                }, embedOptions.responsive);
                var aspectRatio = responsive.aspectRatio.split(":").map(Number);
                var inner = global_document__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div");
                var paddingTop = aspectRatio[1] / aspectRatio[0] * 100;
                if (embedType === EMBED_TYPE_IFRAME && responsive.iframeHorizontalPlaylist) {
                    paddingTop *= 1.25;
                }
                inner.style.paddingTop = paddingTop + "%";
                inner.appendChild(el);
                var outer = global_document__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div");
                outer.style.position = "relative";
                outer.style.display = "block";
                outer.style.maxWidth = responsive.maxWidth;
                outer.appendChild(inner);
                return outer;
            };
            var wrapPip = function wrapPip(embedOptions, el) {
                if (!embedOptions.pip) {
                    return el;
                }
                var pip = global_document__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div");
                pip.classList.add("vjs-pip-container");
                pip.appendChild(el);
                return pip;
            };
            var wrapEmbed = function wrapEmbed(embedType, embedOptions, embed) {
                if (!embedOptions) {
                    return embed;
                }
                return wrapPip(embedOptions, wrapResponsive(embedType, embedOptions, embed));
            };
            var insertEmbed = function insertEmbed(params, embed) {
                var refNode = params.refNode, refNodeInsert = params.refNodeInsert;
                var refNodeParent = refNode.parentNode;
                var wrapped = wrapEmbed(params.embedType, params.embedOptions, embed);
                if (refNodeInsert === REF_NODE_INSERT_BEFORE) {
                    refNodeParent.insertBefore(wrapped, refNode);
                } else if (refNodeInsert === REF_NODE_INSERT_AFTER) {
                    refNodeParent.insertBefore(wrapped, refNode.nextElementSibling || null);
                } else if (refNodeInsert === REF_NODE_INSERT_REPLACE) {
                    refNodeParent.replaceChild(wrapped, refNode);
                } else if (refNodeInsert === REF_NODE_INSERT_PREPEND) {
                    refNode.insertBefore(wrapped, refNode.firstChild || null);
                } else {
                    refNode.appendChild(wrapped);
                }
                if (params.embedOptions && params.embedOptions.playlist) {
                    var playlistTagName = params.embedOptions.playlist.legacy ? "ul" : "div";
                    var playlist = global_document__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(playlistTagName);
                    playlist.classList.add("vjs-playlist");
                    embed.parentNode.insertBefore(playlist, embed.nextElementSibling || null);
                }
                params.refNode = null;
                return embed;
            };
            var onEmbedCreated = function onEmbedCreated(params, embed) {
                if (typeof params.onEmbedCreated !== "function") {
                    return embed;
                }
                var result = params.onEmbedCreated(embed);
                if (isEl(result)) {
                    return result;
                }
                return embed;
            };
            var createEmbed = function createEmbed(params) {
                var embed = params.embedType === EMBED_TYPE_IFRAME ? createIframeEmbed(params) : createInPageEmbed(params);
                return insertEmbed(params, onEmbedCreated(params, embed));
            };
            var actualCache = new global_window__WEBPACK_IMPORTED_MODULE_1___default.a.Map;
            var key = function key(_ref) {
                var accountId = _ref.accountId, playerId = _ref.playerId, embedId = _ref.embedId;
                return (accountId || "*") + "_" + playerId + "_" + embedId;
            };
            var store = function store(props) {
                actualCache.set(key(props), props.accountId ? urls.getUrl(props) : "");
            };
            var has = function has(props) {
                return actualCache.has(key(props));
            };
            var get = function get(props) {
                return actualCache.get(key(props));
            };
            var clear = function clear() {
                actualCache.clear();
            };
            var forEach = function forEach(fn) {
                actualCache.forEach(fn);
            };
            var playerScriptCache = {
                clear: clear,
                forEach: forEach,
                get: get,
                has: has,
                key: key,
                store: store
            };
            var REGEX_PLAYER_EMBED = /^([A-Za-z0-9]+)_([A-Za-z0-9]+)$/;
            var getBcGlobalKeys = function getBcGlobalKeys() {
                return global_window__WEBPACK_IMPORTED_MODULE_1___default.a.bc ? Object.keys(global_window__WEBPACK_IMPORTED_MODULE_1___default.a.bc).filter((function(k) {
                    return REGEX_PLAYER_EMBED.test(k);
                })) : [];
            };
            var getGlobalKeys = function getGlobalKeys() {
                return Object.keys(global_window__WEBPACK_IMPORTED_MODULE_1___default.a).filter((function(k) {
                    return /^videojs/i.test(k) || /^(bc)$/.test(k);
                }));
            };
            var disposeAll = function disposeAll(videojs) {
                if (!videojs) {
                    return;
                }
                Object.keys(videojs.players).forEach((function(k) {
                    var p = videojs.players[k];
                    if (p) {
                        p.dispose();
                    }
                }));
            };
            var reset = function reset() {
                playerScriptCache.forEach((function(value, key) {
                    if (!value) {
                        return;
                    }
                    Array.prototype.slice.call(global_document__WEBPACK_IMPORTED_MODULE_0___default.a.querySelectorAll('script[src="' + value + '"]')).forEach((function(el) {
                        return el.parentNode.removeChild(el);
                    }));
                }));
                playerScriptCache.clear();
                disposeAll(global_window__WEBPACK_IMPORTED_MODULE_1___default.a.videojs);
                getBcGlobalKeys().forEach((function(k) {
                    return disposeAll(global_window__WEBPACK_IMPORTED_MODULE_1___default.a.bc[k].videojs);
                }));
                getGlobalKeys().forEach((function(k) {
                    delete global_window__WEBPACK_IMPORTED_MODULE_1___default.a[k];
                }));
            };
            var detectPlayers = function detectPlayers() {
                getBcGlobalKeys().forEach((function(k) {
                    var matches = k.match(REGEX_PLAYER_EMBED);
                    var props = {
                        playerId: matches[1],
                        embedId: matches[2]
                    };
                    if (!playerScriptCache.has(props)) {
                        playerScriptCache.store(props);
                    }
                }));
            };
            var env = {
                detectPlayers: detectPlayers,
                reset: reset
            };
            env.detectPlayers();
            var isFn = function isFn(fn) {
                return typeof fn === "function";
            };
            var isValidEmbedType = function isValidEmbedType(embedType) {
                return embedType === EMBED_TYPE_IN_PAGE || embedType === EMBED_TYPE_IFRAME;
            };
            var isValidTagName = function isValidTagName(tagName) {
                return tagName === EMBED_TAG_NAME_VIDEOJS || tagName === EMBED_TAG_NAME_VIDEO;
            };
            var isValidRootInsert = function isValidRootInsert(refNodeInsert) {
                return refNodeInsert === REF_NODE_INSERT_APPEND || refNodeInsert === REF_NODE_INSERT_PREPEND || refNodeInsert === REF_NODE_INSERT_BEFORE || refNodeInsert === REF_NODE_INSERT_AFTER || refNodeInsert === REF_NODE_INSERT_REPLACE;
            };
            var checkParams = function checkParams(params) {
                var accountId = params.accountId, embedOptions = params.embedOptions, embedType = params.embedType, options = params.options, refNode = params.refNode, refNodeInsert = params.refNodeInsert;
                if (!accountId) {
                    throw new Error("accountId is required");
                } else if (!isElInDom(refNode)) {
                    throw new Error("refNode must resolve to a node attached to the DOM");
                } else if (!isValidEmbedType(embedType)) {
                    throw new Error("embedType is missing or invalid");
                } else if (embedType === EMBED_TYPE_IFRAME && options) {
                    throw new Error("cannot use options with an iframe embed");
                } else if (embedOptions && embedOptions.tagName !== undefined && !isValidTagName(embedOptions.tagName)) {
                    throw new Error('embedOptions.tagName is invalid (value: "' + embedOptions.tagName + '")');
                } else if (embedOptions && embedOptions.responsive && embedOptions.responsive.aspectRatio && !/^\d+\:\d+$/.test(embedOptions.responsive.aspectRatio)) {
                    throw new Error('embedOptions.responsive.aspectRatio must be in the "n:n" format (value: "' + embedOptions.responsive.aspectRatio + '")');
                } else if (!isValidRootInsert(refNodeInsert)) {
                    throw new Error("refNodeInsert is missing or invalid");
                }
            };
            var resolveRefNode = function resolveRefNode(refNode) {
                if (isElInDom(refNode)) {
                    return refNode;
                }
                if (typeof refNode === "string") {
                    return global_document__WEBPACK_IMPORTED_MODULE_0___default.a.querySelector(refNode);
                }
                return null;
            };
            var initPlayer = function initPlayer(params, embed, resolve, reject) {
                var embedId = params.embedId, playerId = params.playerId;
                var bc = global_window__WEBPACK_IMPORTED_MODULE_1___default.a.bc[playerId + "_" + embedId] || global_window__WEBPACK_IMPORTED_MODULE_1___default.a.bc;
                if (!bc) {
                    return reject(new Error("missing bc function for " + playerId));
                }
                playerScriptCache.store(params);
                var player;
                try {
                    player = bc(embed, params.options);
                    if (player.bcinfo) {
                        player.bcinfo.PLAYER_LOADER = true;
                    }
                } catch (x) {
                    var message = "Could not initialize the Brightcove Player.";
                    if (params.embedOptions.tagName === EMBED_TAG_NAME_VIDEOJS) {
                        message += ' You are attempting to embed using a "video-js" element.' + " Please ensure that your Player is v6.11.0 or newer in order to" + ' support this embed type. Alternatively, pass `"video"` for' + " `embedOptions.tagName`.";
                    }
                    return reject(new Error(message));
                }
                resolve({
                    type: EMBED_TYPE_IN_PAGE,
                    ref: player
                });
            };
            var loadPlayer = function loadPlayer(params, resolve, reject) {
                params.refNode = resolveRefNode(params.refNode);
                checkParams(params);
                var refNode = params.refNode, refNodeInsert = params.refNodeInsert;
                var refNodeParent = refNode.parentNode;
                var embed = createEmbed(params);
                if (params.embedType === EMBED_TYPE_IFRAME) {
                    resolve({
                        type: EMBED_TYPE_IFRAME,
                        ref: embed
                    });
                    return;
                }
                if (playerScriptCache.has(params)) {
                    return initPlayer(params, embed, resolve, reject);
                }
                var script = global_document__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("script");
                script.onload = function() {
                    return initPlayer(params, embed, resolve, reject);
                };
                script.onerror = function() {
                    reject(new Error("player script could not be downloaded"));
                };
                script.async = true;
                script.charset = "utf-8";
                script.src = urls.getUrl(params);
                if (refNodeInsert === REF_NODE_INSERT_REPLACE) {
                    refNodeParent.appendChild(script);
                } else {
                    refNode.appendChild(script);
                }
            };
            var brightcovePlayerLoader = function brightcovePlayerLoader(parameters) {
                var params = _extends({}, DEFAULTS, parameters);
                var Promise = params.Promise, onSuccess = params.onSuccess, onFailure = params.onFailure;
                if (!isFn(Promise) || isFn(onSuccess) || isFn(onFailure)) {
                    return loadPlayer(params, isFn(onSuccess) ? onSuccess : function() {}, isFn(onFailure) ? onFailure : function(err) {
                        throw err;
                    });
                }
                return new Promise((function(resolve, reject) {
                    return loadPlayer(params, resolve, reject);
                }));
            };
            var expose = function expose(key, value) {
                Object.defineProperty(brightcovePlayerLoader, key, {
                    configurable: false,
                    enumerable: true,
                    value: value,
                    writable: false
                });
            };
            expose("getBaseUrl", (function() {
                return urls.getBaseUrl();
            }));
            expose("setBaseUrl", (function(baseUrl) {
                urls.setBaseUrl(baseUrl);
            }));
            expose("getUrl", (function(options) {
                return urls.getUrl(options);
            }));
            expose("reset", (function() {
                return env.reset();
            }));
            [ [ "EMBED_TAG_NAME_VIDEO", EMBED_TAG_NAME_VIDEO ], [ "EMBED_TAG_NAME_VIDEOJS", EMBED_TAG_NAME_VIDEOJS ], [ "EMBED_TYPE_IN_PAGE", EMBED_TYPE_IN_PAGE ], [ "EMBED_TYPE_IFRAME", EMBED_TYPE_IFRAME ], [ "REF_NODE_INSERT_APPEND", REF_NODE_INSERT_APPEND ], [ "REF_NODE_INSERT_PREPEND", REF_NODE_INSERT_PREPEND ], [ "REF_NODE_INSERT_BEFORE", REF_NODE_INSERT_BEFORE ], [ "REF_NODE_INSERT_AFTER", REF_NODE_INSERT_AFTER ], [ "REF_NODE_INSERT_REPLACE", REF_NODE_INSERT_REPLACE ], [ "VERSION", version ] ].forEach((function(arr) {
                expose(arr[0], arr[1]);
            }));
            __webpack_exports__["default"] = brightcovePlayerLoader;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/abstract-combo-button/mds-combo-button.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, "", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/abstract-data-table/data-table-combo-button/mds-data-table-combo-button.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host{display:inline-block}:host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .data-table-combo-button__button-container{display:flex;align-items:center;border-radius:var(--MdsComboButton__containerBackgroundBorderRadius,4px)}:host .data-table-combo-button__button-container--disabled{border-width:var(--MdsComboButton__containerBackgroundBorderWidth--disabled,0)}:host .data-table-combo-button__button-container--secondary{padding:.0625rem}:host .data-table-combo-button__button-container .data-table-combo-button-combo-button__menu-button{align-self:stretch}:host .data-table-combo-button__divider{display:inline-block;vertical-align:middle;height:var(--MdsComboButton__dividerHeight,20px);min-width:var(--MdsComboButton__dividerWidth,1px);width:var(--MdsComboButton__dividerWidth,1px);padding:var(--MdsComboButton__dividerTopPadding,8px) var(--MdsComboButton__dividerTrailingPadding,0) var(--MdsComboButton__dividerBottomPadding,8px) var(--MdsComboButton__dividerLeadingPadding,0)}:host .data-table-combo-button__menu-container{position:relative}:host .data-table-combo-button__menu-container .data-table-combo-button__menu-list{min-width:var(--MdsComboButton__menuContainerMinWidth,120px);max-width:var(--MdsComboButton__menuContainerMaxWidth,300px);border-width:var(--MdsComboButton__menuContainerBorderWidth,1px);border-radius:var(--MdsComboButton__menuContainerBorderRadius,0);list-style-type:none;margin:.0625rem .0625rem 0;padding:0;position:absolute;right:0;z-index:1100}:host .data-table-combo-button__menu-container .data-table-combo-button__menu-list .data-table-combo-button__menu-item{-webkit-appearance:none;-moz-appearance:none;appearance:none;cursor:pointer;list-style-type:none;display:flex;width:var(--MdsComboButton_MenuItem-_widthType-layout__width,100%);font-weight:var(--MdsComboButton_MenuItem__textWeight,400);font-size:var(--MdsComboButton_MenuItem__textSize,1rem);line-height:var(--MdsComboButton_MenuItem__textLineHeightm,1.5rem);padding:var(--MdsComboButton_MenuItem__topPadding,8px) var(--MdsComboButton_MenuItem__trailingPadding,8px) var(--MdsComboButton_MenuItem__bottomPadding,8px) var(--MdsComboButton_MenuItem__leadingPadding,8px);text-align:var(--MdsComboButton_MenuItem__textAlignment,left);background-color:var(--MdsComboButton_MenuItem__backgroundColor,#fff)}:host .data-table-combo-button__menu-container .data-table-combo-button__menu-list .data-table-combo-button__menu-item:focus{border-width:var(--MdsComboButton_MenuItem__borderWidth--focused,1px)}:host .data-table-combo-button__menu-container .data-table-combo-button__menu-list .data-table-combo-button__menu-item:focus:focus{outline:.0625rem dashed #717171}:host .data-table-combo-button__menu-container .data-table-combo-button__menu-list .data-table-combo-button__menu-item:hover{border-width:var(--MdsComboButton_MenuItem__borderWidth--hover,0)}:host .data-table-combo-button__menu-container .data-table-combo-button__menu-list .data-table-combo-button__menu-item:active{border-width:var(--MdsComboButton_MenuItem__borderWidth--pressed,0)}:host .data-table-combo-button__menu-container .data-table-combo-button__menu-list .data-table-combo-button__menu-item-icon{margin-right:var(--MdsComboButton_MenuItem__iconTextHorizontalPadding,8px);margin-top:.125rem}:host .data-table-combo-button__menu-container .data-table-combo-button__menu-list .data-table-combo-button__menu-item-icon svg{height:var(--MdsComboButton_MenuItem__iconHeight,20px);width:var(--MdsComboButton_MenuItem__iconWidth,20px)}:host .data-table-combo-button__menu-container .data-table-combo-button__menu-list .data-table-combo-button__menu-item--disabled{cursor:default;border-width:var(--MdsComboButton_MenuItem__borderWidth--disabled,0);background-color:var(--MdsComboButton__containerBackgroundColor--disabled,#ededed)}:host .data-table-combo-button__menu-container .data-table-combo-button__menu-list .data-table-combo-button__menu-item--disabled:active,:host .data-table-combo-button__menu-container .data-table-combo-button__menu-list .data-table-combo-button__menu-item--disabled:focus,:host .data-table-combo-button__menu-container .data-table-combo-button__menu-list .data-table-combo-button__menu-item--disabled:hover{border-width:var(--MdsComboButton_MenuItem__borderWidth--disabledFocused,1px)}:host .data-table-combo-button__divider{height:var(--AbstractMdsDataTable__comboButtonDividerHeight,16px)}.data-table-combo-button__button-container--disabled{background-color:var(--MdsComboButton__containerBackgroundColor--disabled,#ededed)}.data-table-combo-button__button-container:not(.data-table-combo-button__button-container--disabled).data-table-combo-button__button-container--primary{border:var(--MdsComboButton-_variant-primary__containerBackgroundBorderWidth,0) solid var(--MdsComboButton-_variant-primary__containerBackgroundBorderColor,transparent);background-color:var(--MdsComboButton-_variant-primary__containerBackgroundColor,#005eb8)}.data-table-combo-button__button-container:not(.data-table-combo-button__button-container--disabled).data-table-combo-button__button-container--primary .data-table-combo-button__divider{box-shadow:inset var(--MdsComboButton__dividerWidth,1px) 0 0 var(--MdsComboButton-_variant-primary__dividerColor,#fff)}.data-table-combo-button__button-container:not(.data-table-combo-button__button-container--disabled).data-table-combo-button__button-container--secondary{border:var(--MdsComboButton-_variant-secondary__containerBackgroundBorderWidth,1px) solid var(--MdsComboButton-_variant-secondary__containerBackgroundBorderColor,#005eb8);background-color:var(--MdsComboButton-_variant-secondary__containerBackgroundColor,transparent)}.data-table-combo-button__button-container:not(.data-table-combo-button__button-container--disabled).data-table-combo-button__button-container--secondary .data-table-combo-button__divider{box-shadow:inset var(--MdsComboButton__dividerWidth,1px) 0 0 var(--MdsComboButton-_variant-secondary__dividerColor,#005eb8)}.data-table-combo-button__button-container:not(.data-table-combo-button__button-container--disabled).data-table-combo-button__button-container--tertiary{border:var(--MdsComboButton-_variant-tertiary__containerBackgroundBorderWidth,0) solid var(--MdsComboButton-_variant-tertiary__containerBackgroundBorderColor,transparent);background-color:var(--MdsComboButton-_variant-tertiary__containerBackgroundColor,transparent)}.data-table-combo-button__button-container:not(.data-table-combo-button__button-container--disabled).data-table-combo-button__button-container--tertiary .data-table-combo-button__divider{box-shadow:inset var(--MdsComboButton__dividerWidth,1px) 0 0 var(--MdsComboButton-_variant-tertiary__dividerColor,#005eb8)}.data-table-combo-button__divider--disabled{box-shadow:inset var(--MdsComboButton__dividerWidth,1px) 0 0 var(--MdsComboButton__dividerColor--disabled,#949494)}.data-table-combo-button__menu-container .data-table-combo-button__menu-list{background-color:var(--MdsComboButton_MenuItem__backgroundColor,#fff);box-shadow:var(--MdsComboButton__menuContainerBoxShadowHorizontalOffset,0) var(--MdsComboButton__menuContainerBoxShadowVerticalOffset,2px) var(--MdsComboButton__menuContainerBoxShadowBlurOffset,3px) var(--MdsComboButton__menuContainerBoxShadowSpreadOffset,0) var(--MdsComboButton__menuContainerBoxShadowColor,rgba(0,0,0,.28));border-color:var(--MdsComboButton__menuContainerborderColor,rgba(0,0,0,.17))}.data-table-combo-button__menu-container .data-table-combo-button__menu-list .data-table-combo-button__menu-item{color:var(--MdsComboButton_MenuItem__textColor,#414042)}.data-table-combo-button__menu-container .data-table-combo-button__menu-list .data-table-combo-button__menu-item:focus{color:var(--MdsComboButton_MenuItem__textColor--focused,#414042);background-color:var(--MdsComboButton_MenuItem__backgroundColor--focused,#fff);border-color:var(--MdsComboButton_MenuItem__borderColor--focused,#717171)}.data-table-combo-button__menu-container .data-table-combo-button__menu-list .data-table-combo-button__menu-item:focus .data-table-combo-button__menu-item-icon svg{fill:var(--MdsComboButton_MenuItem__iconColor--focused,#414042)}.data-table-combo-button__menu-container .data-table-combo-button__menu-list .data-table-combo-button__menu-item:hover{color:var(--MdsComboButton_MenuItem__textColor--hover,#414042);background-color:var(--MdsComboButton_MenuItem__backgroundColor--hover,#f9f6f3);border-color:var(--MdsComboButton_MenuItem__borderColor--hover,transparent)}.data-table-combo-button__menu-container .data-table-combo-button__menu-list .data-table-combo-button__menu-item:hover .data-table-combo-button__menu-item-icon svg{fill:var(--MdsComboButton_MenuItem__iconColor--hover,#414042)}.data-table-combo-button__menu-container .data-table-combo-button__menu-list .data-table-combo-button__menu-item:active{color:var(--MdsComboButton_MenuItem__textColor--pressed,#fff);background-color:var(--MdsComboButton_MenuItem__backgroundColor--pressed,#0091da);border-color:var(--MdsComboButton_MenuItem__borderColor--pressed,transparent)}.data-table-combo-button__menu-container .data-table-combo-button__menu-list .data-table-combo-button__menu-item:active .data-table-combo-button__menu-item-icon svg{fill:var(--MdsComboButton_MenuItem__iconColor--pressed,#fff)}.data-table-combo-button__menu-container .data-table-combo-button__menu-list .data-table-combo-button__menu-item-icon svg{fill:var(--MdsComboButton_MenuItem__iconColor,#414042)}.data-table-combo-button__menu-container .data-table-combo-button__menu-list .data-table-combo-button__menu-item--disabled{color:var(--MdsComboButton_MenuItem__textColor--disabled,#bcbcbc);background-color:var(--MdsComboButton_MenuItem__backgroundColor--disabled,#ededed);border-color:var(--MdsComboButton_MenuItem__borderColor--disabled,transparent)}.data-table-combo-button__menu-container .data-table-combo-button__menu-list .data-table-combo-button__menu-item--disabled .data-table-combo-button__menu-item-icon{fill:var(--MdsComboButton_MenuItem__iconColor--disabled,#bcbcbc)}.data-table-combo-button__menu-container .data-table-combo-button__menu-list .data-table-combo-button__menu-item--disabled:active,.data-table-combo-button__menu-container .data-table-combo-button__menu-list .data-table-combo-button__menu-item--disabled:focus,.data-table-combo-button__menu-container .data-table-combo-button__menu-list .data-table-combo-button__menu-item--disabled:hover{color:var(--MdsComboButton_MenuItem__textColor--disabledFocused,#bcbcbc);background-color:var(--MdsComboButton_MenuItem__backgroundColor--disabledFocused,#ededed);border-color:var(--MdsComboButton_MenuItem__borderColor--disabledFocused,#717171)}.data-table-combo-button__menu-container .data-table-combo-button__menu-list .data-table-combo-button__menu-item--disabled:active .data-table-combo-button__menu-item-icon,.data-table-combo-button__menu-container .data-table-combo-button__menu-list .data-table-combo-button__menu-item--disabled:focus .data-table-combo-button__menu-item-icon,.data-table-combo-button__menu-container .data-table-combo-button__menu-list .data-table-combo-button__menu-item--disabled:hover .data-table-combo-button__menu-item-icon{fill:var(--MdsComboButton_MenuItem__iconColor--disabledFocused,)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/abstract-data-table/data-table-input/mds-data-table-text-input.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ".mds-container{box-sizing:border-box;margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px;width:100%}@media print,screen and (min-width:576px){.mds-container{max-width:540px}}@media print,screen and (min-width:768px){.mds-container{max-width:720px}}@media print,screen and (min-width:992px){.mds-container{max-width:960px}}@media print,screen and (min-width:1200px){.mds-container{max-width:1140px}}.mds-container-at-576,.mds-container-at-768,.mds-container-at-992,.mds-container-at-1200,.mds-container-fluid{box-sizing:border-box;margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px;width:100%}@media print,screen and (min-width:576px){.mds-container,.mds-container-at-576{max-width:var(--mds-container-max-width-at-576,540px)}}@media print,screen and (min-width:768px){.mds-container,.mds-container-at-576,.mds-container-at-768{max-width:var(--mds-container-max-width-at-768,720px)}}@media print,screen and (min-width:992px){.mds-container,.mds-container-at-576,.mds-container-at-768,.mds-container-at-992{max-width:var(--mds-container-max-width-at-992,960px)}}@media print,screen and (min-width:1200px){.mds-container,.mds-container-at-576,.mds-container-at-768,.mds-container-at-992,.mds-container-at-1200{max-width:var(--mds-container-max-width-at-1200,1140px)}}.mds-row{display:flex;flex-wrap:wrap;margin-left:-15px;margin-right:-15px}.mds-no-gutters{margin-left:0;margin-right:0}.mds-no-gutters>.mds-col,.mds-no-gutters>[class*=mds-col-]{padding-left:0;padding-right:0}.mds-col,.mds-col-1,.mds-col-2,.mds-col-3,.mds-col-4,.mds-col-5,.mds-col-6,.mds-col-7,.mds-col-8,.mds-col-9,.mds-col-10,.mds-col-11,.mds-col-12,.mds-col-at-576,.mds-col-at-576-1,.mds-col-at-576-2,.mds-col-at-576-3,.mds-col-at-576-4,.mds-col-at-576-5,.mds-col-at-576-6,.mds-col-at-576-7,.mds-col-at-576-8,.mds-col-at-576-9,.mds-col-at-576-10,.mds-col-at-576-11,.mds-col-at-576-12,.mds-col-at-576-auto,.mds-col-at-768,.mds-col-at-768-1,.mds-col-at-768-2,.mds-col-at-768-3,.mds-col-at-768-4,.mds-col-at-768-5,.mds-col-at-768-6,.mds-col-at-768-7,.mds-col-at-768-8,.mds-col-at-768-9,.mds-col-at-768-10,.mds-col-at-768-11,.mds-col-at-768-12,.mds-col-at-768-auto,.mds-col-at-992,.mds-col-at-992-1,.mds-col-at-992-2,.mds-col-at-992-3,.mds-col-at-992-4,.mds-col-at-992-5,.mds-col-at-992-6,.mds-col-at-992-7,.mds-col-at-992-8,.mds-col-at-992-9,.mds-col-at-992-10,.mds-col-at-992-11,.mds-col-at-992-12,.mds-col-at-992-auto,.mds-col-at-1200,.mds-col-at-1200-1,.mds-col-at-1200-2,.mds-col-at-1200-3,.mds-col-at-1200-4,.mds-col-at-1200-5,.mds-col-at-1200-6,.mds-col-at-1200-7,.mds-col-at-1200-8,.mds-col-at-1200-9,.mds-col-at-1200-10,.mds-col-at-1200-11,.mds-col-at-1200-12,.mds-col-at-1200-auto,.mds-col-auto{box-sizing:border-box;position:relative;width:100%;padding-left:8px;padding-right:8px}@media print,screen and (min-width:576px){.mds-col,.mds-col-1,.mds-col-2,.mds-col-3,.mds-col-4,.mds-col-5,.mds-col-6,.mds-col-7,.mds-col-8,.mds-col-9,.mds-col-10,.mds-col-11,.mds-col-12,.mds-col-at-576,.mds-col-at-576-1,.mds-col-at-576-2,.mds-col-at-576-3,.mds-col-at-576-4,.mds-col-at-576-5,.mds-col-at-576-6,.mds-col-at-576-7,.mds-col-at-576-8,.mds-col-at-576-9,.mds-col-at-576-10,.mds-col-at-576-11,.mds-col-at-576-12,.mds-col-at-576-auto,.mds-col-at-768,.mds-col-at-768-1,.mds-col-at-768-2,.mds-col-at-768-3,.mds-col-at-768-4,.mds-col-at-768-5,.mds-col-at-768-6,.mds-col-at-768-7,.mds-col-at-768-8,.mds-col-at-768-9,.mds-col-at-768-10,.mds-col-at-768-11,.mds-col-at-768-12,.mds-col-at-768-auto,.mds-col-at-992,.mds-col-at-992-1,.mds-col-at-992-2,.mds-col-at-992-3,.mds-col-at-992-4,.mds-col-at-992-5,.mds-col-at-992-6,.mds-col-at-992-7,.mds-col-at-992-8,.mds-col-at-992-9,.mds-col-at-992-10,.mds-col-at-992-11,.mds-col-at-992-12,.mds-col-at-992-auto,.mds-col-at-1200,.mds-col-at-1200-1,.mds-col-at-1200-2,.mds-col-at-1200-3,.mds-col-at-1200-4,.mds-col-at-1200-5,.mds-col-at-1200-6,.mds-col-at-1200-7,.mds-col-at-1200-8,.mds-col-at-1200-9,.mds-col-at-1200-10,.mds-col-at-1200-11,.mds-col-at-1200-12,.mds-col-at-1200-auto,.mds-col-auto{padding-left:8px;padding-right:8px}}@media print,screen and (min-width:768px){.mds-col,.mds-col-1,.mds-col-2,.mds-col-3,.mds-col-4,.mds-col-5,.mds-col-6,.mds-col-7,.mds-col-8,.mds-col-9,.mds-col-10,.mds-col-11,.mds-col-12,.mds-col-at-576,.mds-col-at-576-1,.mds-col-at-576-2,.mds-col-at-576-3,.mds-col-at-576-4,.mds-col-at-576-5,.mds-col-at-576-6,.mds-col-at-576-7,.mds-col-at-576-8,.mds-col-at-576-9,.mds-col-at-576-10,.mds-col-at-576-11,.mds-col-at-576-12,.mds-col-at-576-auto,.mds-col-at-768,.mds-col-at-768-1,.mds-col-at-768-2,.mds-col-at-768-3,.mds-col-at-768-4,.mds-col-at-768-5,.mds-col-at-768-6,.mds-col-at-768-7,.mds-col-at-768-8,.mds-col-at-768-9,.mds-col-at-768-10,.mds-col-at-768-11,.mds-col-at-768-12,.mds-col-at-768-auto,.mds-col-at-992,.mds-col-at-992-1,.mds-col-at-992-2,.mds-col-at-992-3,.mds-col-at-992-4,.mds-col-at-992-5,.mds-col-at-992-6,.mds-col-at-992-7,.mds-col-at-992-8,.mds-col-at-992-9,.mds-col-at-992-10,.mds-col-at-992-11,.mds-col-at-992-12,.mds-col-at-992-auto,.mds-col-at-1200,.mds-col-at-1200-1,.mds-col-at-1200-2,.mds-col-at-1200-3,.mds-col-at-1200-4,.mds-col-at-1200-5,.mds-col-at-1200-6,.mds-col-at-1200-7,.mds-col-at-1200-8,.mds-col-at-1200-9,.mds-col-at-1200-10,.mds-col-at-1200-11,.mds-col-at-1200-12,.mds-col-at-1200-auto,.mds-col-auto{padding-left:12px;padding-right:12px}}@media print,screen and (min-width:992px){.mds-col,.mds-col-1,.mds-col-2,.mds-col-3,.mds-col-4,.mds-col-5,.mds-col-6,.mds-col-7,.mds-col-8,.mds-col-9,.mds-col-10,.mds-col-11,.mds-col-12,.mds-col-at-576,.mds-col-at-576-1,.mds-col-at-576-2,.mds-col-at-576-3,.mds-col-at-576-4,.mds-col-at-576-5,.mds-col-at-576-6,.mds-col-at-576-7,.mds-col-at-576-8,.mds-col-at-576-9,.mds-col-at-576-10,.mds-col-at-576-11,.mds-col-at-576-12,.mds-col-at-576-auto,.mds-col-at-768,.mds-col-at-768-1,.mds-col-at-768-2,.mds-col-at-768-3,.mds-col-at-768-4,.mds-col-at-768-5,.mds-col-at-768-6,.mds-col-at-768-7,.mds-col-at-768-8,.mds-col-at-768-9,.mds-col-at-768-10,.mds-col-at-768-11,.mds-col-at-768-12,.mds-col-at-768-auto,.mds-col-at-992,.mds-col-at-992-1,.mds-col-at-992-2,.mds-col-at-992-3,.mds-col-at-992-4,.mds-col-at-992-5,.mds-col-at-992-6,.mds-col-at-992-7,.mds-col-at-992-8,.mds-col-at-992-9,.mds-col-at-992-10,.mds-col-at-992-11,.mds-col-at-992-12,.mds-col-at-992-auto,.mds-col-at-1200,.mds-col-at-1200-1,.mds-col-at-1200-2,.mds-col-at-1200-3,.mds-col-at-1200-4,.mds-col-at-1200-5,.mds-col-at-1200-6,.mds-col-at-1200-7,.mds-col-at-1200-8,.mds-col-at-1200-9,.mds-col-at-1200-10,.mds-col-at-1200-11,.mds-col-at-1200-12,.mds-col-at-1200-auto,.mds-col-auto{padding-left:12px;padding-right:12px}}@media print,screen and (min-width:1200px){.mds-col,.mds-col-1,.mds-col-2,.mds-col-3,.mds-col-4,.mds-col-5,.mds-col-6,.mds-col-7,.mds-col-8,.mds-col-9,.mds-col-10,.mds-col-11,.mds-col-12,.mds-col-at-576,.mds-col-at-576-1,.mds-col-at-576-2,.mds-col-at-576-3,.mds-col-at-576-4,.mds-col-at-576-5,.mds-col-at-576-6,.mds-col-at-576-7,.mds-col-at-576-8,.mds-col-at-576-9,.mds-col-at-576-10,.mds-col-at-576-11,.mds-col-at-576-12,.mds-col-at-576-auto,.mds-col-at-768,.mds-col-at-768-1,.mds-col-at-768-2,.mds-col-at-768-3,.mds-col-at-768-4,.mds-col-at-768-5,.mds-col-at-768-6,.mds-col-at-768-7,.mds-col-at-768-8,.mds-col-at-768-9,.mds-col-at-768-10,.mds-col-at-768-11,.mds-col-at-768-12,.mds-col-at-768-auto,.mds-col-at-992,.mds-col-at-992-1,.mds-col-at-992-2,.mds-col-at-992-3,.mds-col-at-992-4,.mds-col-at-992-5,.mds-col-at-992-6,.mds-col-at-992-7,.mds-col-at-992-8,.mds-col-at-992-9,.mds-col-at-992-10,.mds-col-at-992-11,.mds-col-at-992-12,.mds-col-at-992-auto,.mds-col-at-1200,.mds-col-at-1200-1,.mds-col-at-1200-2,.mds-col-at-1200-3,.mds-col-at-1200-4,.mds-col-at-1200-5,.mds-col-at-1200-6,.mds-col-at-1200-7,.mds-col-at-1200-8,.mds-col-at-1200-9,.mds-col-at-1200-10,.mds-col-at-1200-11,.mds-col-at-1200-12,.mds-col-at-1200-auto,.mds-col-auto{padding-left:12px;padding-right:12px}}.mds-col{flex-basis:0;flex-grow:1;max-width:100%}.mds-col-auto{flex:0 0 auto;max-width:100%;width:auto}.mds-col-1{flex:0 0 8.33333%;max-width:8.33333%}.mds-col-2{flex:0 0 16.66667%;max-width:16.66667%}.mds-col-3{flex:0 0 25%;max-width:25%}.mds-col-4{flex:0 0 33.33333%;max-width:33.33333%}.mds-col-5{flex:0 0 41.66667%;max-width:41.66667%}.mds-col-6{flex:0 0 50%;max-width:50%}.mds-col-7{flex:0 0 58.33333%;max-width:58.33333%}.mds-col-8{flex:0 0 66.66667%;max-width:66.66667%}.mds-col-9{flex:0 0 75%;max-width:75%}.mds-col-10{flex:0 0 83.33333%;max-width:83.33333%}.mds-col-11{flex:0 0 91.66667%;max-width:91.66667%}.mds-col-12{flex:0 0 100%;max-width:100%}.mds-offset-1{margin-left:8.33333%}.mds-offset-2{margin-left:16.66667%}.mds-offset-3{margin-left:25%}.mds-offset-4{margin-left:33.33333%}.mds-offset-5{margin-left:41.66667%}.mds-offset-6{margin-left:50%}.mds-offset-7{margin-left:58.33333%}.mds-offset-8{margin-left:66.66667%}.mds-offset-9{margin-left:75%}.mds-offset-10{margin-left:83.33333%}.mds-offset-11{margin-left:91.66667%}@media print,screen and (min-width:576px){.mds-col-at-576{flex-basis:0;flex-grow:1;max-width:100%}.mds-col-at-576-auto{flex:0 0 auto;max-width:100%;width:auto}.mds-col-at-576-1{flex:0 0 8.33333%;max-width:8.33333%}.mds-col-at-576-2{flex:0 0 16.66667%;max-width:16.66667%}.mds-col-at-576-3{flex:0 0 25%;max-width:25%}.mds-col-at-576-4{flex:0 0 33.33333%;max-width:33.33333%}.mds-col-at-576-5{flex:0 0 41.66667%;max-width:41.66667%}.mds-col-at-576-6{flex:0 0 50%;max-width:50%}.mds-col-at-576-7{flex:0 0 58.33333%;max-width:58.33333%}.mds-col-at-576-8{flex:0 0 66.66667%;max-width:66.66667%}.mds-col-at-576-9{flex:0 0 75%;max-width:75%}.mds-col-at-576-10{flex:0 0 83.33333%;max-width:83.33333%}.mds-col-at-576-11{flex:0 0 91.66667%;max-width:91.66667%}.mds-col-at-576-12{flex:0 0 100%;max-width:100%}.mds-offset-at-576-0{margin-left:0}.mds-offset-at-576-1{margin-left:8.33333%}.mds-offset-at-576-2{margin-left:16.66667%}.mds-offset-at-576-3{margin-left:25%}.mds-offset-at-576-4{margin-left:33.33333%}.mds-offset-at-576-5{margin-left:41.66667%}.mds-offset-at-576-6{margin-left:50%}.mds-offset-at-576-7{margin-left:58.33333%}.mds-offset-at-576-8{margin-left:66.66667%}.mds-offset-at-576-9{margin-left:75%}.mds-offset-at-576-10{margin-left:83.33333%}.mds-offset-at-576-11{margin-left:91.66667%}}@media print,screen and (min-width:768px){.mds-col-at-768{flex-basis:0;flex-grow:1;max-width:100%}.mds-col-at-768-auto{flex:0 0 auto;max-width:100%;width:auto}.mds-col-at-768-1{flex:0 0 8.33333%;max-width:8.33333%}.mds-col-at-768-2{flex:0 0 16.66667%;max-width:16.66667%}.mds-col-at-768-3{flex:0 0 25%;max-width:25%}.mds-col-at-768-4{flex:0 0 33.33333%;max-width:33.33333%}.mds-col-at-768-5{flex:0 0 41.66667%;max-width:41.66667%}.mds-col-at-768-6{flex:0 0 50%;max-width:50%}.mds-col-at-768-7{flex:0 0 58.33333%;max-width:58.33333%}.mds-col-at-768-8{flex:0 0 66.66667%;max-width:66.66667%}.mds-col-at-768-9{flex:0 0 75%;max-width:75%}.mds-col-at-768-10{flex:0 0 83.33333%;max-width:83.33333%}.mds-col-at-768-11{flex:0 0 91.66667%;max-width:91.66667%}.mds-col-at-768-12{flex:0 0 100%;max-width:100%}.mds-offset-at-768-0{margin-left:0}.mds-offset-at-768-1{margin-left:8.33333%}.mds-offset-at-768-2{margin-left:16.66667%}.mds-offset-at-768-3{margin-left:25%}.mds-offset-at-768-4{margin-left:33.33333%}.mds-offset-at-768-5{margin-left:41.66667%}.mds-offset-at-768-6{margin-left:50%}.mds-offset-at-768-7{margin-left:58.33333%}.mds-offset-at-768-8{margin-left:66.66667%}.mds-offset-at-768-9{margin-left:75%}.mds-offset-at-768-10{margin-left:83.33333%}.mds-offset-at-768-11{margin-left:91.66667%}}@media print,screen and (min-width:992px){.mds-col-at-992{flex-basis:0;flex-grow:1;max-width:100%}.mds-col-at-992-auto{flex:0 0 auto;max-width:100%;width:auto}.mds-col-at-992-1{flex:0 0 8.33333%;max-width:8.33333%}.mds-col-at-992-2{flex:0 0 16.66667%;max-width:16.66667%}.mds-col-at-992-3{flex:0 0 25%;max-width:25%}.mds-col-at-992-4{flex:0 0 33.33333%;max-width:33.33333%}.mds-col-at-992-5{flex:0 0 41.66667%;max-width:41.66667%}.mds-col-at-992-6{flex:0 0 50%;max-width:50%}.mds-col-at-992-7{flex:0 0 58.33333%;max-width:58.33333%}.mds-col-at-992-8{flex:0 0 66.66667%;max-width:66.66667%}.mds-col-at-992-9{flex:0 0 75%;max-width:75%}.mds-col-at-992-10{flex:0 0 83.33333%;max-width:83.33333%}.mds-col-at-992-11{flex:0 0 91.66667%;max-width:91.66667%}.mds-col-at-992-12{flex:0 0 100%;max-width:100%}.mds-offset-at-992-0{margin-left:0}.mds-offset-at-992-1{margin-left:8.33333%}.mds-offset-at-992-2{margin-left:16.66667%}.mds-offset-at-992-3{margin-left:25%}.mds-offset-at-992-4{margin-left:33.33333%}.mds-offset-at-992-5{margin-left:41.66667%}.mds-offset-at-992-6{margin-left:50%}.mds-offset-at-992-7{margin-left:58.33333%}.mds-offset-at-992-8{margin-left:66.66667%}.mds-offset-at-992-9{margin-left:75%}.mds-offset-at-992-10{margin-left:83.33333%}.mds-offset-at-992-11{margin-left:91.66667%}}@media print,screen and (min-width:1200px){.mds-col-at-1200{flex-basis:0;flex-grow:1;max-width:100%}.mds-col-at-1200-auto{flex:0 0 auto;max-width:100%;width:auto}.mds-col-at-1200-1{flex:0 0 8.33333%;max-width:8.33333%}.mds-col-at-1200-2{flex:0 0 16.66667%;max-width:16.66667%}.mds-col-at-1200-3{flex:0 0 25%;max-width:25%}.mds-col-at-1200-4{flex:0 0 33.33333%;max-width:33.33333%}.mds-col-at-1200-5{flex:0 0 41.66667%;max-width:41.66667%}.mds-col-at-1200-6{flex:0 0 50%;max-width:50%}.mds-col-at-1200-7{flex:0 0 58.33333%;max-width:58.33333%}.mds-col-at-1200-8{flex:0 0 66.66667%;max-width:66.66667%}.mds-col-at-1200-9{flex:0 0 75%;max-width:75%}.mds-col-at-1200-10{flex:0 0 83.33333%;max-width:83.33333%}.mds-col-at-1200-11{flex:0 0 91.66667%;max-width:91.66667%}.mds-col-at-1200-12{flex:0 0 100%;max-width:100%}.mds-offset-at-1200-0{margin-left:0}.mds-offset-at-1200-1{margin-left:8.33333%}.mds-offset-at-1200-2{margin-left:16.66667%}.mds-offset-at-1200-3{margin-left:25%}.mds-offset-at-1200-4{margin-left:33.33333%}.mds-offset-at-1200-5{margin-left:41.66667%}.mds-offset-at-1200-6{margin-left:50%}.mds-offset-at-1200-7{margin-left:58.33333%}.mds-offset-at-1200-8{margin-left:66.66667%}.mds-offset-at-1200-9{margin-left:75%}.mds-offset-at-1200-10{margin-left:83.33333%}.mds-offset-at-1200-11{margin-left:91.66667%}}:host{display:block}:host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .text-input .text-input__input-wrap{padding:0;width:100%;position:relative}:host .text-input .text-input__input{width:100%;display:block;-webkit-appearance:none;-moz-appearance:none;appearance:none;font-size:var(--MdsDataTableForSecurities__inputColumnTextSize,1rem);padding:var(--MdsDataTableForSecurities__inputColumnTextFieldPaddingTop,8px) var(--MdsDataTableForSecurities__inputColumnTextFieldPaddingTrailing,16px) var(--MdsDataTableForSecurities__inputColumnTextFieldPaddingBottom,8px) var(--MdsDataTableForSecurities__inputColumnTextFieldPaddingLeading,16px);margin-top:var(--MdsDataTableForSecurities__inputColumnTextFieldPaddingTop,8px);font-weight:var(--MdsDataTableForSecurities__inputColumnTextWeight,400);line-height:var(--MdsDataTableForSecurities__inputColumnTextLineHeight,1.5rem);text-align:left;border:0;font-family:inherit}:host .text-input .text-input__input:focus{outline:none}:host .text-input .text-input__input::-moz-placeholder{opacity:1}:host .text-input .text-input__input::placeholder{opacity:1}:host .text-input__microcopy_container{margin:0}:host .text-input__microcopy{font-size:var(--MdsDataTableForSecurities__inputColumnMicrocopyTextSize,.75rem);line-height:var(--MdsDataTableForSecurities__inputColumnMicrocopyTextLineHeight,1rem);font-weight:var(--MdsDataTableForSecurities__inputColumnMicrocopyTextWeight,400);text-align:left;padding:0;margin-top:var(--MdsDataTableForSecurities__inputColumnMicrocopyMarginTop,4px);margin-bottom:var(--MdsDataTableForSecurities__inputColumnMicrocopyMarginTop,4px)}:host .text-input__error-microcopy{margin-top:var(--MdsDataTableForSecurities__inputColumnErrorMesssageMarginTop,4px);display:flex}:host .accessible-text,:host .text-input__error-microcopy-accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .text-input__input,:host .text-input__microcopy{color:var(--MdsDataTableForSecurities__inputColumnTextColor,#565a5d)}:host .text-input__input{background-color:var(--MdsDataTableForSecurities__inputColumnTextFieldBackgroundColor,#fff);box-shadow:inset 0 0 0 var(--MdsDataTableForSecurities__inputColumnTextFieldBorderWidth,1px) var(--MdsDataTableForSecurities__inputColumnTextFieldBorderColor,#8c8e90)}:host .text-input__input:focus{color:var(--MdsDataTableForSecurities__inputColumnActiveTextColor,#101820)}:host .text-input__input::-moz-placeholder{color:var(--MdsDataTableForSecurities__inputColumnTextColor,#565a5d)}:host .text-input__input::placeholder{color:var(--MdsDataTableForSecurities__inputColumnTextColor,#565a5d)}:host .text-input__input:disabled{box-shadow:inset 0 0 0 var(--MdsDataTableForSecurities__inputColumnTextFieldBorderWidth,1px) var(--MdsTextInput__borderColor--disabled,#bcbcbc);color:var(--MdsTextInput__fieldTextColor--disabled,#565a5d)}:host .text-input__input--error{box-shadow:inset 0 0 0 var(--MdsDataTableForSecurities__inputColumnTextFieldBorderWidth,1px) var(--MdsDataTableForSecurities__inputColumnErrorTextFieldBorderColor,#b80009)}:host .text-input__input--error:focus{box-shadow:inset 0 0 0 var(--MdsDataTableForSecurities__inputColumnActiveTextFieldBorderWidth,2px) var(--MdsDataTableForSecurities__inputColumnErrorTextFieldBorderColor,#b80009)}:host .text-input__input:not(.text-input__input--error):focus{box-shadow:inset 0 0 0 2px var(--MdsDataTableForSecurities__inputColumnActiveTextFieldBorderColor,#005eb8)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/accordion/accordion-item/mds-accordion-item.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .accordion-item{flex-direction:column;margin-bottom:var(--MdsAccordion__accordionVerticalMarginBetween,0)}:host .accordion-item,:host .accordion-item .accordion-item__heading-container{display:flex;width:100%}:host .accordion-item .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .accordion-item .accordion-item__heading{z-index:1;display:inline-flex;width:100%;cursor:pointer;padding:var(--MdsAccordion__headerTopPadding,4px) var(--MdsAccordion__headerTrailingPadding,8px) var(--MdsAccordion__headerBottomPadding,4px) var(--MdsAccordion__headerLeadingPadding,0);background-color:var(--MdsAccordion__backgroundColor,transparent)}:host .accordion-item .accordion-item__heading:focus{outline:.0625rem dashed #717171}:host .accordion-item .accordion-item__heading::-moz-focus-inner{border:0}:host .accordion-item .accordion-item__heading-alert{display:flex;text-align:left;margin-top:var(--MdsAccordion_item__alertTopMargin,4px);pointer-events:none}:host .accordion-item .accordion-item__heading-content-container{width:100%}:host .accordion-item .accordion-item__heading--large .accordion-item__heading-primary-label{line-height:var(--MdsAccordion-_size-18px__labelLineHeight,1.75rem);font-size:var(--MdsAccordion-_size-18px__labelTextSize,1.125rem)}:host .accordion-item .accordion-item__heading--large .accordion-item__heading-secondary-label{line-height:var(--MdsAccordion-_size-18px__secondaryTextLineHeight,1.25rem);font-size:var(--MdsAccordion-_size-18px__secondaryTextSize,.875rem);padding-top:var(--MdsAccordion-_size-18px__secondaryTextTopPadding,6px)}:host .accordion-item .accordion-item__heading--large .accordion-item__heading-caret-icon{margin-top:var(--MdsAccordion-_size-18px__caretTopPadding,6px);padding-top:0}:host .accordion-item .accordion-item__heading--large .accordion-item__heading-caret-icon--with-leading-visual{margin-top:0}:host .accordion-item .accordion-item__heading--large .accordion-item__heading-icon{padding-top:.5rem}:host .accordion-item .accordion-item__heading--vertically-centered,:host .accordion-item .accordion-item__heading--vertically-centered .accordion-item__heading-labels{align-items:center}:host .accordion-item .accordion-item__heading--vertically-centered .accordion-item__heading-labels--below{align-items:flex-start}:host .accordion-item .accordion-item__heading--vertically-centered .accordion-item__heading-labels .accordion-item__heading-secondary-label:not(.accordion-item__heading-secondary-label--below){padding-top:0}:host .accordion-item .accordion-item__heading--vertically-centered .accordion-item__heading-caret-icon{margin-top:0}:host .accordion-item .accordion-item__heading--vertically-centered .accordion-item__heading-icon{padding-top:0}:host .accordion-item .accordion-item__heading:disabled{cursor:default}:host .accordion-item .accordion-item__heading:disabled .accordion-item__heading-primary-label{color:var(--MdsAccordion_item__labelColor--disabled,#717171)}:host .accordion-item .accordion-item__heading:disabled .accordion-item__heading-caret-icon svg{fill:var(--MdsAccordion_item__caretColor--disabled,#bcbcbc)}:host .accordion-item--borderless .accordion-item__heading{border:0}:host .accordion-item--fullBorder{margin-bottom:var(--MdsAccordion-_variant-fullBorder__accordionVerticalMarginBetween,4px)}:host .accordion-item--fullBorder .accordion-item__heading{padding:var(--MdsAccordion-_variant-fullBorder__headerTopPadding,16px) var(--MdsAccordion-_variant-fullBorder__headerTrailingPadding,16px) var(--MdsAccordion-_variant-fullBorder__headerBottomPadding,16px) var(--MdsAccordion-_variant-fullBorder__headerLeadingPadding,16px);border:0 solid var(--MdsAccordion__borderColor,#c1c3c3);box-shadow:inset 0 0 0 var(--MdsAccordion__borderWidth,1px) var(--MdsAccordion__borderColor,#c1c3c3);background-color:var(--MdsAccordion-_variant-fullBorder__backgroundColor,#fff)}:host .accordion-item--openBorder .accordion-item__heading{padding:calc(var(--MdsAccordion-_variant-openBorder__headerTopPadding, 16px) - 1px) var(--MdsAccordion-_variant-openBorder__headerTrailingPadding,16px) calc(var(--MdsAccordion-_variant-openBorder__headerBottomPadding, 16px) - 1px) var(--MdsAccordion-_variant-openBorder__headerLeadingPadding,16px);margin:0;border:solid var(--MdsAccordion__borderColor,#c1c3c3);border-width:var(--MdsAccordion__borderWidth,1px) 0 0;box-shadow:0 .1875rem 0 -.125rem var(--MdsAccordion__borderColor,#c1c3c3)}:host .accordion-item--openBorder .accordion-item__heading:focus{border:.0625rem dashed #717171;outline:none}:host .accordion-item--openBorder .accordion-item__heading--expanded{box-shadow:none}:host .accordion-item .accordion-item__heading-labels{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif;display:flex;width:100%;align-items:flex-start;text-align:left}:host .accordion-item .accordion-item__heading-labels--right{justify-content:space-between}:host .accordion-item .accordion-item__heading-labels--below{flex-direction:column}:host .accordion-item .accordion-item__heading-labels--below .accordion-item__heading-secondary-label{padding-top:var(--MdsAccordion-_secondaryTextAlignment-below__secondaryTextTopPadding,4px);padding-left:0}:host .accordion-item .accordion-item__heading-primary-label{color:var(--MdsAccordion_item__labelColor,#414042);font-size:var(--MdsAccordion__labelTextSize,.875rem);font-weight:var(--MdsAccordion__labelWeight,600);line-height:var(--MdsAccordion__labelLineHeight,1.25rem)}:host .accordion-item .accordion-item__heading-secondary-label{color:var(--MdsAccordion_item__secondaryTextColor,#717171);padding-top:var(--MdsAccordion__secondaryTextTopPadding,2px);padding-left:var(--MdsAccordion__secondaryTextLeadingPadding,8px);font-size:var(--MdsAccordion__secondaryTextSize,.75rem);font-weight:var(--MdsAccordion__secondaryTextWeight,400);line-height:var(--MdsAccordion__secondaryTextLineHeight,1rem)}:host .accordion-item .accordion-item__heading-caret-icon{height:1rem;width:1rem;margin-top:var(--MdsAccordion__caretTopPadding,2px);margin-right:var(--MdsAccordion__caretTrailingPadding,8px);transition-property:all;transition-duration:.5s;transition-timing-function:cubic-bezier(0,.2,.1,1)}:host .accordion-item .accordion-item__heading-caret-icon svg{height:1rem;width:1rem;fill:var(--MdsAccordion_item__caretColor,#005eb8)}:host .accordion-item .accordion-item__heading-caret-icon--expanded{transform:rotate(90deg)}:host .accordion-item .accordion-item__heading-icon{display:inline-flex;padding-left:var(--MdsAccordion__iconLeadingPadding,16px)}:host .accordion-item .accordion-item__heading-icon svg{height:1rem;width:1rem}:host .accordion-item .accordion-item__panel{background-color:var(--MdsAccordion__backgroundColor,transparent);overflow:hidden;padding:var(--MdsAccordion-_variant-openBorder__panelTopPadding,0) var(--MdsAccordion__panelTrailingPadding,0) var(--MdsAccordion__panelBottomPadding,0) var(--MdsAccordion__panelLeadingPadding,24px);opacity:0;transition-property:height;transition-duration:.2s;transition-timing-function:cubic-bezier(0,.2,.1,1)}:host .accordion-item .accordion-item__panel--expanded{opacity:1}:host .accordion-item .accordion-item__panel--expanded.accordion-item__panel--openBorder{box-shadow:0 .1875rem 0 -.125rem var(--MdsAccordion__borderColor,#c1c3c3);padding:var(--MdsAccordion-_variant-openBorder__panelTopPadding,0) var(--MdsAccordion-_variant-openBorder__panelTrailingPadding,16px) var(--MdsAccordion-_variant-openBorder__panelBottomPadding,16px) var(--MdsAccordion-_variant-openBorder__panelLeadingPadding,16px)}:host .accordion-item .accordion-item__panel--expanded.accordion-item__panel--fullBorder{border:var(--MdsAccordion__borderWidth,1px) solid var(--MdsAccordion__borderColor,#c1c3c3);padding:var(--MdsAccordion-_variant-fullBorder__panelTopPadding,16px) var(--MdsAccordion-_variant-fullBorder__panelTrailingPadding,16px) var(--MdsAccordion-_variant-fullBorder__panelBottomPadding,16px) var(--MdsAccordion-_variant-fullBorder__panelLeadingPadding,16px);border-top:0}:host .accordion-item .accordion-item__panel--collapsing{animation-name:panel-opacity;animation-duration:.2s;animation-delay:0s;animation-timing-function:cubic-bezier(0,.2,.1,1);animation-fill-mode:forwards}@keyframes panel-opacity{0%{opacity:1}to{opacity:0}}:host .accordion-item .accordion-item__panel--transitioned{opacity:1}:host .accordion-item .accordion-item__panel--fullBorder{background-color:var(--MdsAccordion-_variant-fullBorder__backgroundColor,#fff)}:host .accordion-item__leading-visual{margin-right:var(--MdsAccordion_item__leadingVisualElementTrailingMargin,8px)}:host .accordion-item__leading-visual--icon svg{height:var(--MdsAccordion_item__leadingIconWidth,24px);width:var(--MdsAccordion_item__leadingIconWidth,24px);fill:var(--MdsAccordion_item__leadingIconColor,#565a5d)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/avatar-banner/mds-avatar-banner.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .avatar-banner{box-sizing:border-box;display:flex;align-items:center}:host .avatar-banner__img{width:var(--MdsAvatarBanner__avatarWidth,36px);height:var(--MdsAvatarBanner__avatarHeight,36px);border-radius:100%;display:inline-block;margin-right:var(--MdsAvatarBanner__avatarTrailingPadding,8px)}:host .avatar-banner__img,:host .avatar-banner__title{animation:visibility-animation var(--MdsAvatarBanner__avatarArrivalTiming,.35s) var(--MdsAvatarBanner__avatarArrivalEase,linear)}:host .avatar-banner__title{color:var(--MdsAvatarBanner__titleTextColor,#101820);font-size:var(--MdsAvatarBanner__titleTextSize,.75rem);font-weight:var(--MdsAvatarBanner__titleTextWeight,600);line-height:var(--MdsAvatarBanner__titleLineHeight,1rem)}:host .avatar-banner__subtitle{color:var(--MdsAvatarBanner__subtitleTextColor,#565a5d);font-size:var(--MdsAvatarBanner__subtitleTextSize,.75rem);font-weight:var(--MdsAvatarBanner__subtitleTextWeight,400);line-height:var(--MdsAvatarBanner__subtitleTextLineHeight,1rem);padding-top:var(--MdsAvatarBanner__subtitleTopPadding,2px);opacity:0;animation:visibility-animation var(--MdsAvatarBanner__subtitleArrivalOpacityTiming,.35s) var(--MdsAvatarBanner__subtitleArrivalOpacityEase,linear) var(--MdsAvatarBanner__subtitleArrivalOpacityDelay,0ms) forwards,subTitle-arrival var(--MdsAvatarBanner__subtitleArrivalTiming,.35s) var(--MdsAvatarBanner__subtitleArrivalEase,cubic-bezier(0,0,0,1)) var(--MdsAvatarBanner__subtitleArrivalDelay,0ms) forwards}@keyframes visibility-animation{0%{opacity:var(--MdsAvatarBanner__avatarArrivalStartOpacity,0)}to{opacity:var(--MdsAvatarBanner__avatarArrivalEndOpacity,1)}}@keyframes subTitle-arrival{0%{transform:translate(var(--MdsAvatarBanner__subtitleArrivalStartPosition,-30px))}to{transform:translate(var(--MdsAvatarBanner__subtitleArrivalEndPosition,0))}}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/banner-for-employee-messaging/mds-banner-for-employee-messaging.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif;box-sizing:border-box}:host .banner-for-employee-messaging{width:100%;position:relative;display:inline-flex;flex-direction:column;border-style:var(--MdsBannerForEmployeeMessaging__leadingBorderStyle,solid);border-left-width:var(--MdsBannerForEmployeeMessaging__leadingBorderThickness,4px);border-bottom-width:0;border-right-width:0;border-top-width:0;background-color:var(--MdsBannerForEmployeeMessaging__primaryBackgroundColor,#fff);padding:var(--MdsBannerForEmployeeMessaging__paddingTop,12px) var(--MdsBannerForEmployeeMessaging__paddingTrailing,24px) var(--MdsBannerForEmployeeMessaging__paddingBottom,12px) var(--MdsBannerForEmployeeMessaging__paddingLeading,60px)}:host .banner-for-employee-messaging--outline{border-width:var(--MdsBannerForEmployeeMessaging-_outline-true__borderThickness,1px) var(--MdsBannerForEmployeeMessaging-_outline-true__borderThickness,1px) var(--MdsBannerForEmployeeMessaging-_outline-true__borderThickness,1px) var(--MdsBannerForEmployeeMessaging__leadingBorderThickness,4px)}:host .banner-for-employee-messaging--required{border-color:var(--MdsBannerForEmployeeMessaging-_variant-required__borderColor,#e35205)}:host .banner-for-employee-messaging--requiredVerbatim{border-color:var(--MdsBannerForEmployeeMessaging-_variant-requiredVerbatim__borderColor,#b80009)}:host .banner-for-employee-messaging--optional{border-color:var(--MdsBannerForEmployeeMessaging-_variant-optional__borderColor,#005eb8)}:host .banner-for-employee-messaging .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .banner-for-employee-messaging__header{display:flex;flex-direction:row;align-items:center;padding-right:var(--MdsBanner__closeButtonWidth,24px);padding-bottom:var(--MdsBannerForEmployeeMessaging__bannerMessagePaddingTop,4px)}:host .banner-for-employee-messaging__icon{display:inline-flex;margin-right:var(--MdsBanner__iconTrailingMargin,16px);margin-left:calc(var(--MdsBanner__iconTrailingMargin, 16px)*-1 - var(--MdsBanner__closeButtonWidth, 24px));border:0;padding:0}:host .banner-for-employee-messaging__icon svg{height:var(--MdsBanner__closeButtonHeight,24px);width:var(--MdsBanner__closeButtonWidth,24px)}:host .banner-for-employee-messaging__icon--requiredVerbatim svg{fill:var(--MdsBannerForEmployeeMessaging-_variant-requiredVerbatim__iconColor,#b80009)}:host .banner-for-employee-messaging__icon--required svg{fill:var(--MdsBannerForEmployeeMessaging-_variant-required__iconColor,#e35205)}:host .banner-for-employee-messaging__icon--optional svg{fill:var(--MdsBannerForEmployeeMessaging-_variant-optional__iconColor,#005eb8)}:host .banner-for-employee-messaging__message{color:var(--MdsBannerForEmployeeMessaging__bannerMessageTextColor,#101820);line-height:var(--MdsBannerForEmployeeMessaging__bannerMessageTextLineHeight,28px);font-size:var(--MdsBannerForEmployeeMessaging__bannerMessageTextSize,.875rem);font-weight:var(--MdsBannerForEmployeeMessaging__bannerMessageTextWeight,400)}:host .banner-for-employee-messaging__title{color:var(--MdsBannerForEmployeeMessaging__bannerTitleTextColor,#101820);font-weight:var(--MdsBannerForEmployeeMessaging__bannerTitleTextWeight,600);line-height:var(--MdsBannerForEmployeeMessaging__bannerTitleTextLineHeight,1.5rem);font-size:var(--MdsBannerForEmployeeMessaging__bannerTitleTextSize,1rem);overflow-wrap:break-word;display:inline;margin:0}:host .banner-for-employee-messaging__title--ada{white-space:nowrap}:host .banner-for-employee-messaging__title-text:focus{outline:none}:host .banner-for-employee-messaging__button{margin-left:var(--MdsBannerForEmployeeMessaging__buttonLeadingMargin,16px)}:host .banner-for-employee-messaging__link{font-size:var(--MdsBannerForEmployeeMessaging__linkTextSize,.875rem);line-height:var(--MdsBannerForEmployeeMessaging__linkLineHeight,1.25rem);font-weight:var(--MdsBannerForEmployeeMessaging__linkTextWeight,400);margin-top:var(--MdsBannerForEmployeeMessaging__linkTopMargin,8px)}:host #title-focus-target:focus{outline:none}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/banner/mds-banner.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, '@charset "UTF-8";:host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif;box-sizing:border-box}:host .banner{width:100%;position:relative;display:inline-flex;flex-direction:column;border-left:var(--MdsBanner__primaryBackgroundColor,#fff) var(--MdsBanner__leadingBorderStyle,solid) var(--MdsBanner__leadingBorderThickness,4px);padding:var(--MdsBanner__paddingTop,12px) var(--MdsBanner__paddingTrailing,24px) var(--MdsBanner__paddingBottom,12px) var(--MdsBanner__paddingLeading,60px);border-left-color:var(--MdsBanner__primaryBackgroundColor,#fff)}:host .banner--background-primary,:host .banner--outer-container{background-color:var(--MdsBanner__primaryBackgroundColor,#fff)}:host .banner--warning{background-color:var(--MdsBanner-_variant-warning__backgroundColor,rgba(227,82,5,.1));border-left:var(--MdsBanner-_variant-warning__borderColor,#e35205) var(--MdsBanner__leadingBorderStyle,solid) var(--MdsBanner__leadingBorderThickness,4px)}:host .banner--soft{background-color:var(--MdsBanner-_variant-soft__backgroundColor,rgba(227,82,5,.1));border-left:var(--MdsBanner-_variant-soft__borderColor,#e35205) var(--MdsBanner__leadingBorderStyle,solid) var(--MdsBanner__leadingBorderThickness,4px)}:host .banner--critical{background-color:var(--MdsBanner-_variant-critical__backgroundColor,rgba(184,0,9,.1));border-left:var(--MdsBanner-_variant-critical__borderColor,#b80009) var(--MdsBanner__leadingBorderStyle,solid) var(--MdsBanner__leadingBorderThickness,4px)}:host .banner--informational{background-color:var(--MdsBanner-_variant-informational__backgroundColor,rgba(0,94,184,.1));border-left:var(--MdsBanner-_variant-informational__borderColor,#005eb8) var(--MdsBanner__leadingBorderStyle,solid) var(--MdsBanner__leadingBorderThickness,4px)}:host .banner .banner-wrapper{background-color:var(--MdsBanner__primaryBackgroundColor,#fff)}:host .banner .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .banner__header{display:flex;flex-direction:row;align-items:flex-start;padding-right:var(--MdsBanner__closeButtonWidth,24px);padding-bottom:var(--MdsBanner__bannerMessagePaddingTop,4px)}:host .banner__icon{margin-right:var(--MdsBanner__iconTrailingMargin,16px);margin-left:calc(var(--MdsBanner__iconTrailingMargin, 16px)*-1 - var(--MdsBanner__closeButtonWidth, 24px));border:0;padding:0}:host .banner__icon svg{height:var(--MdsBanner__closeButtonHeight,24px);width:var(--MdsBanner__closeButtonWidth,24px)}:host .banner__icon--critical svg{fill:var(--MdsBanner-_variant-critical__iconColor,#b80009)}:host .banner__icon--warning svg{fill:var(--MdsBanner-_variant-warning__iconColor,#e35205)}:host .banner__icon--soft svg{fill:var(--MdsBanner-_variant-soft__iconColor,#e35205)}:host .banner__icon--informational svg{fill:var(--MdsBanner-_variant-informational__iconColor,#005eb8)}:host .banner__close-button{cursor:pointer;height:calc(var(--MdsBanner__closeButtonHeight, 24px) + .25rem);width:calc(var(--MdsBanner__closeButtonWidth, 24px) + .25rem);position:absolute;right:var(--MdsBanner__paddingTrailing,24px);top:calc(var(--MdsBanner__paddingTop, 12px) - .125rem);padding:0;background-color:transparent;border-color:transparent;outline:none}:host .banner__close-button:focus{outline:.0625rem dashed #717171}:host .banner__close-button::-moz-focus-inner{border:0}:host .banner__close-icon svg{height:var(--MdsBanner__closeButtonHeight,24px);width:var(--MdsBanner__closeButtonWidth,24px);fill:var(--MdsBanner__closeButtonColor,#565a5d)}:host .banner__message{color:var(--MdsBanner__bannerMessageTextColor,#101820);font-weight:var(--MdsBanner__bannerMessageTextWeight,);line-height:var(--MdsBanner__bannerMessageTextLineHeight,1.25rem);font-size:var(--MdsBanner__bannerMessageTextSize,.875rem)}:host .banner__message br{margin:var(--MdsBanner__bannerMessageParagraphBreakMargin,8px);content:"";display:block}:host .banner__message ol,:host .banner__message ul{list-style:none;padding:0;margin:0}:host .banner__message ol li,:host .banner__message ul li{position:relative;margin-bottom:var(--MdsBanner__bannerMessageListItemMarginBottom,8px)}:host .banner__message ol{margin-left:1rem;counter-reset:list-counter}:host .banner__message ol li{counter-increment:list-counter}:host .banner__message ol li:before{content:counter(list-counter) ".";position:absolute;left:-2rem;text-align:right;width:2em}:host .banner__message ul{margin-left:.75rem}:host .banner__message ul li:before{content:"•";position:absolute;font-size:1.5em;vertical-align:text-bottom;left:-.75rem}:host .banner__title{color:var(--MdsBanner__bannerTitleTextColor,#101820);font-weight:var(--MdsBanner__bannerTitleTextWeight,600);line-height:var(--MdsBanner__bannerTitleTextLineHeight,1.5rem);font-size:var(--MdsBanner__bannerTitleTextSize,1rem);overflow-wrap:break-word;display:inline;margin:0}:host .banner__title--ada{white-space:nowrap}:host #title-focus-target:focus,:host .banner__title-text:focus{outline:none}@-moz-document url-prefix(""){.banner__close-button{height:1.5rem}}', "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/bottom-sheet-dialog/bottom-sheet-dialog.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .mds-bottom-sheet-dialog{position:fixed;top:0;right:0;left:0;bottom:0;z-index:99999;align-items:flex-end;justify-content:flex-end}:host .mds-bottom-sheet-dialog__main{color:var(--MdsBottomSheetDialog__messageTextColor,#565a5d);font-size:var(--MdsBottomSheetDialog__messageTextSize,.875rem);line-height:var(--MdsBottomSheetDialog__messageTextLineHeight,1.25rem);font-weight:var(--MdsBottomSheetDialog__messageTextWeight,400);text-align:var(--MdsBottomSheetDialog__messageTextAlignment,center);margin-top:var(--MdsBottomSheetDialog__messageTopMargin,0)}:host .mds-bottom-sheet-dialog__backdrop{height:100%;width:100%;opacity:var(--MdsBottomSheetDialog__departStartOpacity,1);z-index:-1;background-color:var(--MdsDialog__overlayColor,rgba(0,0,0,.8))}:host .mds-bottom-sheet-dialog__heading{display:inline-block;font-size:var(--MdsBottomSheet__headerTextSize,);line-height:var(--MdsBottomSheet__headerTextLineHeight,);font-weight:var(--MdsBottomSheet__headerTextWeight,);margin:0;height:100%}:host .mds-bottom-sheet-dialog__heading--hidden{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:0!important;width:.0625rem!important;overflow:hidden}:host .mds-bottom-sheet-dialog__panel-container{max-width:100%;display:flex;flex-direction:column;overflow-x:hidden;position:absolute;left:0;right:0;padding:var(--MdsBottomSheetDialog__topMargin,32px);border-top-right-radius:var(--MdsBottomSheetDialog__sheetTopTrailingBorderRadius,);border-top-left-radius:var(--MdsBottomSheetDialog__sheetTopTrailingBorderRadius,);background-color:var(--MdsBottomSheetDialog__sheetBackgroundColor,#fff);min-height:calc(var(--MdsBottomSheetDialog__sheetMinHeight, default-brand-get(mds-bottom-sheet-dialog-sheet-min-height)) - var(--MdsBottomSheetDialog__topMargin, 32px) - var(--MdsBottomSheetDialog__bottomMargin, 32px));height:auto}@media (orientation:portrait){:host .mds-bottom-sheet-dialog__panel-container{max-height:calc(50vh - var(--MdsBottomSheetDialog__topMargin, 32px) - var(--MdsBottomSheetDialog__bottomMargin, 32px))}}@media (orientation:landscape){:host .mds-bottom-sheet-dialog__panel-container{max-height:calc(100vh - var(--MdsBottomSheet__sheetMinTopMargin, 64px) - var(--MdsBottomSheetDialog__topMargin, 32px) - var(--MdsBottomSheetDialog__bottomMargin, 32px))}}@media screen and (min-width:37.5rem){:host .mds-bottom-sheet-dialog__panel-container{max-width:var(--MdsBottomSheetDialog__sheetTabletMaxWidth,600px);margin-left:auto;margin-right:auto}}:host .mds-bottom-sheet-dialog__footer-actions__horizontal{display:flex;flex-direction:row;justify-content:center;margin-top:var(--MdsBottomSheetDialog__buttonTopMargin,16px)}:host .mds-bottom-sheet-dialog__footer-actions__horizontal__first-button{margin-right:var(--MdsBottomSheetDialog__buttonsHorizontalSpacing,8px)}:host .mds-bottom-sheet-dialog__footer-actions__vertical{display:flex;flex-direction:column;align-items:center;width:100%;margin-top:var(--MdsBottomSheetDialog__buttonTopMargin,16px)}:host .mds-bottom-sheet-dialog__footer-actions__vertical__second-button{margin-top:var(--MdsBottomSheetDialog__buttonsVerticalSpacing,8px);width:100%}:host .mds-bottom-sheet-dialog__footer-actions__vertical__first-button{width:100%}:host .mds-bottom-sheet-dialog .mds-bottom-sheet-dialog__backdrop{transition:opacity var(--MdsBottomSheetDialog__arriveOpacityTime,150) var(--MdsBottomSheetDialog__arriveOpacityEase,cubic-bezier(1,0,1,1))}:host .mds-bottom-sheet-dialog .mds-bottom-sheet-dialog__panel-container{transition:bottom var(--MdsBottomSheetDialog__arriveTransitionTime,500) var(--MdsBottomSheetDialog__arriveTransitionEase,cubic-bezier(0,0,0,1));bottom:0}:host .mds-bottom-sheet-dialog--slide-out .mds-bottom-sheet-dialog__backdrop{transition:opacity var(--MdsBottomSheetDialog__departOpacityTime,150) var(--MdsBottomSheetDialog__backgroundDim,rgba(0,0,0,.4)) var(--MdsBottomSheetDialog__departOpacityEase,cubic-bezier(1,0,1,1))}:host .mds-bottom-sheet-dialog--slide-out .mds-bottom-sheet-dialog__panel-container{transition:bottom var(--MdsBottomSheetDialog__departTransitionTime,500) var(--MdsBottomSheetDialog__departTransitionEase,cubic-bezier(1,0,1,1));bottom:-100%}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/bottom-sheet/bottom-sheet.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .mds-bottom-sheet{position:fixed;top:0;right:0;left:0;bottom:0;z-index:99999;align-items:flex-end;justify-content:flex-end}:host .mds-bottom-sheet__main{overflow-y:auto;flex-grow:1;display:flex}:host .mds-bottom-sheet__main--scrollable{background:linear-gradient(#fff,#fff)}:host .mds-bottom-sheet__backdrop{height:100%;width:100%;opacity:var(--MdsBottomSheet__departStartOpacity,1);z-index:-1;background-color:var(--MdsDialog__overlayColor,rgba(0,0,0,.8))}:host .mds-bottom-sheet__tier-two{z-index:100000}:host .mds-bottom-sheet__tier-two .mds-bottom-sheet__backdrop{background:transparent}:host .mds-bottom-sheet__title-container{display:flex;justify-content:center}:host .mds-bottom-sheet__heading{display:inline-block;font-size:calc(var(--MdsBottomSheet__headingTextSize, .875rem) + .125rem);line-height:calc(var(--MdsBottomSheet__headingTextLineHeight, 1.25rem) + .25rem);padding:calc(var(--MdsBottomSheet__headingTopPadding, 16px) - .5rem) calc(var(--MdsBottomSheet__headingTrailingPadding, 16px)*2.5) calc(var(--MdsBottomSheet__headingTopPadding, 16px) - .5rem) calc(var(--MdsBottomSheet__headingLeadingPadding, 16px)*2.5);margin:0;height:100%;text-align:center}:host .mds-bottom-sheet__heading--scrollable{border-bottom:var(--MdsBottomSheet__headingBorderBottomWidth,1px) solid var(--MdsBottomSheet__headingBorderBottomColor,#ccc)}:host .mds-bottom-sheet__heading--text:focus{outline:.0625rem dashed #717171}:host .mds-bottom-sheet__back--container,:host .mds-bottom-sheet__close--container{position:absolute;right:0;top:0;margin:calc(var(--MdsBottomSheet__headingTopPadding, 16px)*0.75) var(--MdsBottomSheet__buttonLeadingMargin,16px) calc(var(--MdsBottomSheet__headingTopPadding, 16px)*0.75) var(--MdsBottomSheet__buttonTrailingMargin,16px)}:host .mds-bottom-sheet__back--container{left:0;right:auto;display:block}:host .mds-bottom-sheet__panel-container{display:flex;flex-direction:column;overflow-x:hidden;overflow-y:hidden;position:absolute;left:0;right:0;max-height:calc(100vh - var(--MdsBottomSheet__sheetMinTopMargin, 64px));padding-top:0;border-top-right-radius:var(--MdsBottomSheet__headingTopPadding,16px);border-top-left-radius:var(--MdsBottomSheet__headingTopPadding,16px);background-color:var(--MdsBottomSheet__sheetBackgroundColor,#fff);min-height:var(--MdsBottomSheet__sheetMinHeight,256px);max-width:var(--MdsBottomSheet__sheetTabletMaxWidth,600px);margin-left:auto;margin-right:auto;height:auto}:host .mds-bottom-sheet__footer-actions{display:flex;flex-direction:row;justify-content:center;margin-top:var(--MdsBottomSheet__buttonTopMargin,16px);margin-bottom:2rem}:host .mds-bottom-sheet__footer-actions__primary-button{position:absolute;bottom:0;left:0;right:0;margin-right:var(--MdsBottomSheet__buttonTrailingMargin,16px);margin-left:var(--MdsBottomSheet__buttonLeadingMargin,16px);margin-bottom:var(--MdsBottomSheet__buttonBottomMargin,16px)}:host .mds-bottom-sheet__icon-button{background-color:var(--MdsBottomSheet__sheetBackgroundColor,#fff);display:flex;align-items:center;justify-content:center;border:0;margin:0;cursor:pointer}:host .mds-bottom-sheet__icon-button:focus{outline:.0625rem dashed #717171}:host .mds-bottom-sheet__icon-button::-moz-focus-inner{border:0}:host .mds-bottom-sheet__icon-button .mds-bottom-sheet__icon{display:inline-flex}:host .mds-bottom-sheet__icon-button--back,:host .mds-bottom-sheet__icon-button--close{padding:0}:host .mds-bottom-sheet__icon-button--back .mds-bottom-sheet__icon svg,:host .mds-bottom-sheet__icon-button--close .mds-bottom-sheet__icon svg{height:var(--MdsBottomSheet__closeIconHeight,16px);width:var(--MdsBottomSheet__closeIconWidth,16px);fill:var(--MdsBottomSheet__closeIconColor,#565a5d)}:host .mds-bottom-sheet .mds-bottom-sheet__backdrop{transition:opacity var(--MdsBottomSheetDialog__arriveOpacityTime,150) var(--MdsBottomSheetDialog__arriveOpacityEase,cubic-bezier(1,0,1,1))}:host .mds-bottom-sheet .mds-bottom-sheet__panel-container{transition:bottom var(--MdsBottomSheetDialog__arriveTransitionTime,500) var(--MdsBottomSheetDialog__arriveTransitionEase,cubic-bezier(0,0,0,1));bottom:0}:host .mds-bottom-sheet--slide-out .mds-bottom-sheet__backdrop{transition:opacity var(--MdsBottomSheetDialog__departOpacityTime,150) var(--MdsBottomSheetDialog__backgroundDim,rgba(0,0,0,.4)) var(--MdsBottomSheetDialog__departOpacityEase,cubic-bezier(1,0,1,1))}:host .mds-bottom-sheet--slide-out .mds-bottom-sheet__panel-container{transition:bottom var(--MdsBottomSheetDialog__departTransitionTime,500) var(--MdsBottomSheetDialog__departTransitionEase,cubic-bezier(1,0,1,1));bottom:-100%}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/brand-bar/mds-brand-bar.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .brand-bar{display:block;left:0;width:100%;overflow:unset;background-color:var(--MdsBrandBar__barBackgroundColor,);overflow-x:unset}:host .brand-bar::-webkit-scrollbar,:host .brand-bar::-webkit-scrollbar-thumb{background:transparent;height:.375rem}:host .brand-bar--custom{overflow-x:overlay;overflow-y:hidden}:host .brand-bar--opaque{background-color:var(--MdsBrandBar-_opaque-true__barBackgroundColor,#005eb8)}:host .brand-bar-custom--full{opacity:var(--MdsBrandBar-_opacity-full__barBackgroundOpacity,1)}:host .brand-bar-custom--high{opacity:var(--MdsBrandBar-_opacity-high__barBackgroundOpacity,.9)}:host .brand-bar:hover::-webkit-scrollbar,:host .brand-bar:hover::-webkit-scrollbar-thumb{height:.375rem}:host .brand-bar:hover::-webkit-scrollbar-thumb{background:hsla(0,0%,100%,.88);border-radius:.1875rem}:host .brand-bar--search-box{overflow:visible}@media screen and (min--moz-device-pixel-ratio:0){:host .brand-bar--search-box:hover{overflow-x:visible}}:host .brand-bar--full{opacity:var(--MdsBrandBar-_opacity-full__barBackgroundOpacity,1)}:host .brand-bar--high{opacity:var(--MdsBrandBar-_opacity-high__barBackgroundOpacity,.9)}:host .brand-bar__container-wrap{display:flex;justify-content:center}:host .brand-bar__container-wrap-inner{display:flex;flex-direction:column;width:100%}:host .brand-bar__hamburger-wrap{display:flex}:host .brand-bar__container{position:relative;width:100%;display:flex;align-items:center;justify-content:space-between;min-height:var(--MdsBrandBar__barHeightMobile,52px);padding-left:var(--MdsBrandBar__barLeadingTrailingPaddingMobile,16px);padding-right:var(--MdsBrandBar__barLeadingTrailingPaddingMobile,16px);transition:margin .25s cubic-bezier(0,0,0,1)}@media screen and (min-width:768px){:host .brand-bar__container{min-height:var(--MdsBrandBar__barHeightTablet,60px);padding-left:var(--MdsBrandBar__barLeadingTrailingPaddingTablet,24px);padding-right:var(--MdsBrandBar__barLeadingTrailingPaddingDesktop,24px)}}@media screen and (min-width:992px){:host .brand-bar__container{min-height:var(--MdsBrandBar__barHeightDesktop,60px);padding-left:var(--MdsBrandBar__barLeadingTrailingPaddingDesktop,24px);padding-right:var(--MdsBrandBar__barLeadingTrailingPaddingDesktop,24px)}}:host .hide-default-slot{display:none}:host .brand-bar__slot{padding-left:var(--MdsBrandBar__barLeadingTrailingPaddingMobile,16px);padding-right:var(--MdsBrandBar__barLeadingTrailingPaddingMobile,16px);visibility:hidden;z-index:-1;opacity:0;height:0;overflow:hidden;position:absolute;top:0;transition:all .25s cubic-bezier(0,0,0,1),opacity 0s,z-index .5s}@media screen and (min-width:992px){:host .brand-bar__slot{height:var(--MdsBrandBar__barHeightDesktop,60px);padding-left:var(--MdsBrandBar__barLeadingTrailingPaddingDesktop,24px);padding-right:var(--MdsBrandBar__barLeadingTrailingPaddingDesktop,24px)}}@media screen and (min-width:768px){:host .brand-bar__slot{height:var(--MdsBrandBar__barHeightTablet,60px);padding-left:var(--MdsBrandBar__barLeadingTrailingPaddingTablet,24px);padding-right:var(--MdsBrandBar__barLeadingTrailingPaddingDesktop,24px)}}:host .brand-bar__slot--expanded{top:100%;z-index:1;visibility:visible;opacity:1}:host .brand-bar__slot--custom{position:absolute;width:100%;left:0;opacity:1}:host .brand-bar__slot--collapsing{animation-name:panel-opacity;animation-duration:.2s;animation-delay:0s;animation-timing-function:cubic-bezier(0,.2,.1,1);animation-fill-mode:forwards}@keyframes panel-opacity{0%{opacity:1}to{opacity:0}}:host .brand-bar__slot--transitioned{opacity:1}:host .brand-bar__slot--default.brand-bar__slot--expanded{position:static;height:auto}:host .brand-bar__left-container{display:flex;flex:1;align-items:center;justify-content:flex-start}:host .brand-bar__controls--buttons{font-weight:var(--MdsBrandBar__buttonTextWeight,);font-size:var(--MdsBrandBar__buttonTextSize,);line-height:var(--MdsBrandBar__buttonTextLineHeight,);border-radius:var(--MdsBrandBar__buttonBorderRaidus,);min-height:var(--MdsBrandBar__buttonMinHeight,)}:host .brand-bar__controls--links{color:var(--MdsButton-_variant-tertiary-_inverse-true__textColor,#fff);text-decoration:none;padding:var(--MdsButton__topPadding,6px) var(--MdsButton-_variant-tertiary__trailingPadding,8px) var(--MdsButton__bottomPadding,6px) var(--MdsButton-_variant-tertiary__leadingPadding,8px);font-weight:var(--MdsButton__textWeight,600);font-size:var(--MdsButton__textSize,1rem);line-height:var(--MdsButton__textLineHeight,1.5rem);min-height:var(--MdsButton__minHeight,36px)}:host .brand-bar__controls--links:focus{outline:.0625rem dashed #fff}:host .brand-bar__controls--links:active{background-color:var(--MdsButton-_variant-tertiary-_inverse-true__backgroundColor--pressed,rgba(0,145,218,.5));border-radius:var(----MdsButton__borderRadius,4px)}:host .brand-bar__controls--links:hover{background-color:var(--MdsButton-_variant-tertiary-_inverse-true__backgroundColor--hovered,rgba(0,70,146,.5));border-radius:var(----MdsButton__borderRadius,4px)}:host .brand-bar__hamburger-button{margin-right:var(--MdsBrandBar__buttonSpaceBetween,8px)}:host .brand-bar__left-controls{display:flex;align-items:center}:host .brand-bar__left-controls .brand-bar__controls--buttons,:host .brand-bar__left-controls .brand-bar__controls--links{margin-right:var(--MdsBrandBar__buttonSpaceBetween,8px)}@media print{:host .brand-bar__left-controls{visibility:hidden}}:host .brand-bar__logo-container{display:flex;justify-content:center}:host .brand-bar__logo-text{display:flex;text-align:center;color:var(--MdsBrandBar__logoTextColor,#fff);line-height:var(--MdsBrandBar__xsLogoTextLineHeight,1.75rem);font-size:var(--MdsBrandBar__xsLogoTextSize,1.125rem)}@media screen and (min-width:768px){:host .brand-bar__logo-text{line-height:var(--MdsBrandBar__logoTextLineHeight,2rem);font-size:var(--MdsBrandBar__logoTextSize,1.5rem)}}@media print{:host .brand-bar__logo-text{visibility:hidden}}:host .brand-bar__logo-link{outline:none;display:flex;align-items:center;text-decoration:none}:host .brand-bar__logo-link:focus{outline:.0625rem dashed #fff}:host .brand-bar__image{pointer-events:none;height:var(--MdsBrandBar__logoHeight,24px);min-width:100%}:host .brand-bar__right-controls{display:flex;align-items:center}:host .brand-bar__right-controls .brand-bar__controls--buttons,:host .brand-bar__right-controls .brand-bar__controls--links{margin-left:var(--MdsBrandBar__buttonSpaceBetween,8px)}@media print{:host .brand-bar__right-controls{visibility:hidden}}:host .brand-bar__right-container{display:flex;align-items:center;justify-content:flex-end}:host .brand-bar__right-container--hide{display:none}@media screen and (min-width:767px){:host .brand-bar__right-container--hide{display:flex}}:host .brand-bar__right-container--custom{flex:1}:host .brand-bar__utilities{margin-right:var(--MdsBrandBar__utilityButtonTrailingPaddingMobile,8px)}@media screen and (min-width:768px){:host .brand-bar__utilities{margin-right:var(--MdsBrandBar__utilityButtonTrailingPaddingTablet,16px)}}@media screen and (min-width:992px){:host .brand-bar__utilities{margin-right:var(--MdsBrandBar__utilityButtonTrailingPaddingDesktop,16px)}}:host .brand-bar__utilities--button-hidden{display:none}:host .brand-bar__search-box-container{display:flex;align-items:center;overflow:hidden;height:calc(var(--MdsButton-_iconPosition-icon_only__minWidth, 36px) + .25rem);width:calc(var(--MdsButton-_iconPosition-icon_only__minWidth, 36px) + var(--MdsBrandBar__utilityButtonTrailingPaddingMobile, 8px));padding-top:.5rem;padding-bottom:.5rem;transition-property:width;transition-duration:var(--MdsBrandBar__animationBoxAnimationTime,.5s);transition-timing-function:var(--MdsBrandBar__animationBoxAnimationEase,cubic-bezier(0,0,0,1))}@media screen and (min-width:768px){:host .brand-bar__search-box-container{width:calc(var(--MdsButton-_iconPosition-icon_only__minWidth, 36px) + var(--MdsBrandBar__utilityButtonTrailingPaddingTablet, 16px))}}@media screen and (min-width:992px){:host .brand-bar__search-box-container{width:calc(var(--MdsButton-_iconPosition-icon_only__minWidth, 36px) + var(--MdsBrandBar__utilityButtonTrailingPaddingDesktop, 16px))}}:host .brand-bar__search-box-container--expanded{display:none}:host .brand-bar__search-box-container--not-expanding{overflow:visible}:host .brand-bar__search-box-container--expanding{overflow:visible;width:var(--MdsBrandBar__searchBoxInlineWidth,260px);background-color:var(--MdsBrandBar__animationBoxBackgroundColor,hsla(0,0%,100%,.13));margin:0 1rem 0 0}:host .brand-bar__search-box-container--expanding.brand-bar__search-box-container--slot{background-color:transparent}:host .brand-bar__search-box-overflow-container{display:flex;overflow:hidden;height:0;opacity:0;transition-property:all;transition-duration:var(--MdsBrandBar__animationBoxAnimationTime,.5s);transition-timing-function:var(--MdsBrandBar__animationBoxAnimationEase,cubic-bezier(0,0,0,1))}:host .brand-bar__search-box-overflow-container--expand{overflow:visible;height:3.5rem;opacity:1}:host .brand-bar__search-box-button{margin-left:.125rem}:host .brand-bar__search-box-button--expanded{display:none}:host .brand-bar__search-box-cancel-button,:host .brand-bar__search-box-slot{display:none;margin:0}:host .brand-bar__search-box-cancel-button--expanding,:host .brand-bar__search-box-slot--expanding{display:flex;overflow:hidden}:host .brand-bar__search-box-cancel-button--expanded,:host .brand-bar__search-box-slot--expanded{opacity:1;display:flex;overflow:visible}:host .brand-bar__search-box-cancel-button--collapsing,:host .brand-bar__search-box-slot--collapsing{opacity:0}@media screen and (min-width:768px){:host .brand-bar__search-box-cancel-button--collapsing.brand-bar__utilities--button-hidden,:host .brand-bar__search-box-cancel-button--expanded.brand-bar__utilities--button-hidden,:host .brand-bar__search-box-cancel-button--expanding.brand-bar__utilities--button-hidden,:host .brand-bar__search-box-slot--collapsing.brand-bar__utilities--button-hidden,:host .brand-bar__search-box-slot--expanded.brand-bar__utilities--button-hidden,:host .brand-bar__search-box-slot--expanding.brand-bar__utilities--button-hidden{display:none}}:host .brand-bar__search-box{width:var(--MdsBrandBar__searchBoxInlineWidth,260px);opacity:0;transition-property:opacity;transition-duration:var(--MdsBrandBar__searchBoxAnimationTime,.5s);transition-timing-function:var(--MdsBrandBar__searchBoxAnimationEase,cubic-bezier(0,0,0,1));transition-delay:var(--MdsBrandBar__animationOverlapTime,.1s);display:none}:host .brand-bar__search-box--expanded{opacity:1;display:block}:host .brand-bar__search-box--collapsing{opacity:0}:host .brand-bar__search-box-overflow{width:100%;padding-right:var(--MdsBrandBar__searchBoxOverflowTrailingPadding,20px);padding-left:var(--MdsBrandBar__searchBoxOverflowLeadingPadding,20px);padding-bottom:var(--MdsBrandBar__searchBoxOverflowBottomPadding,8px)}.brand-bar__hidden{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/breadcrumb/mds-breadcrumb.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif;display:flex}:host .breadcrumb__list{display:flex;list-style:none;flex-wrap:wrap;padding:0;margin:0;align-items:baseline}:host .breadcrumb__list-item{display:flex;align-items:center;font-size:var(--MdsBreadcrumb__labelTextSize,1rem);line-height:var(--MdsBreadcrumb__labelLineHeight,1.5rem);color:var(--MdsBreadcrumb__labelTextColor,#101820)}:host .breadcrumb__link{white-space:nowrap}:host .breadcrumb__link--inactive{color:var(--MdsBreadcrumb__disabledLabelTextColor,#101820);text-decoration:none}:host .breadcrumb__separator{padding-left:var(--MdsBreadcrumb__separatorLeadingPadding,8px);padding-right:var(--MdsBreadcrumb__separatorTrailingPadding,8px);font-size:var(--MdsBreadcrumb__separatorTextSize,1rem);line-height:var(--MdsBreadcrumb__separatorLineHeight,1.5rem);color:var(--MdsBreadcrumb__separatorColor,#565a5d)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/breadcrumbs/mds-breadcrumbs.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif;display:flex}:host .breadcrumbs__list{display:flex;list-style:none;flex-wrap:wrap;padding:0;margin:0}:host .breadcrumbs__list-item{display:flex;align-items:center;font-size:var(--MdsBreadcrumb__labelTextSize,1rem);line-height:var(--MdsBreadcrumb__labelLineHeight,1.5rem);color:var(--MdsBreadcrumb__labelTextColor,#101820)}:host .breadcrumbs__link{white-space:nowrap}:host .breadcrumbs__link--inactive{color:var(--MdsBreadcrumb__disabledLabelTextColor,#101820);text-decoration:none}:host .breadcrumbs__separator{padding-left:var(--MdsBreadcrumb__separatorLeadingPadding,8px);padding-right:var(--MdsBreadcrumb__separatorTrailingPadding,8px);font-size:var(--MdsBreadcrumb__separatorTextSize,1rem);line-height:var(--MdsBreadcrumb__separatorLineHeight,1.5rem);color:var(--MdsBreadcrumb__separatorColor,#565a5d)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/calendar/mds-calendar.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host .grid-column-start-1{grid-column-start:1}:host .grid-column-start-2{grid-column-start:2}:host .grid-column-start-3{grid-column-start:3}:host .grid-column-start-4{grid-column-start:4}:host .grid-column-start-5{grid-column-start:5}:host .grid-column-start-6{grid-column-start:6}:host .grid-column-start-7{grid-column-start:7}:host .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .activity-indicator,:host .activity-indicator-legend{height:var(--MdsCalendar__activityIndicatorHeight,8px);width:var(--MdsCalendar__activityIndicatorWidth,8px);background-color:var(--MdsCalendar__activityIndicatorColor,#005eb8);border-radius:50%;display:inline-block}:host .activity-indicator-legend{margin-left:var(--MdsCalendar__legendActivityIndicatorLeadingPadding,8px);margin-right:var(--MdsCalendar__legendActivityIndicatorTrailingPadding,6px)}:host .current-date-indicator,:host .current-date-indicator-legend{border:var(--MdsCalendar__currentDateIndicatorBorderWidth,1px) solid var(--MdsCalendar__currentDateIndicatorBorderColor,#565a5d);border-radius:var(--MdsCalendar__currentDateIndicatorBorderRadius,4px)}:host .current-date-indicator{padding:var(--MdsCalendar__currentDateIndicatorTopPadding,4px) var(--MdsCalendar__currentDateIndicatorTrailingPadding,8px) var(--MdsCalendar__currentDateIndicatorBottomPadding,4px) var(--MdsCalendar__currentDateIndicatorLeadingPadding,8px)}:host .current-date-indicator-legend{width:var(--MdsCalendar__legendCurrentDateIndicatorWidth,10px);height:var(--MdsCalendar__legendCurrentDateIndicatorHeight,10px);margin-right:var(--MdsCalendar__legendCurrentDateIndicatorTrailingPadding,4px)}:host .initial-calendar-body-padding{padding-top:var(--MdsCalendar__containerBottomPadding,16px)}:host .past-date{color:var(--MdsCalendar__dateTextDimColor,#565a5d)}:host .calendar{display:flex;flex-direction:column;padding-top:var(--MdsCalendar__containerTopPadding,16px);padding-bottom:var(--MdsCalendar__containerBottomPadding,16px);border:var(--MdsCalendar__containerBorderWidth,1px) solid var(--MdsCalendar__containerBorderColor,#e2e4e5)}:host .calendar__body,:host .calendar__legend,:host .calendar__weekday-header{padding-left:var(--MdsCalendar__containerLeadingPadding,16px);padding-right:var(--MdsCalendar__containerTrailingPadding,16px)}:host .calendar__body__date-list,:host .calendar__weekday-header{display:grid;grid-template-columns:repeat(7,1fr);grid-template-rows:repeat(auto-fill,1fr)}:host .calendar__weekday-header{border:var(--MdsCalendar__containerBorderWidth,1px) var(--MdsCalendar__containerBorderColor,#e2e4e5);border-style:none none solid}:host .calendar__weekday-header__weekday{padding-bottom:var(--MdsCalendar__dayOfTheWeekTextBottomPadding,8px);font-size:var(--MdsCalendar__dayOfTheWeekTextSize,.875rem);font-weight:var(--MdsCalendar__dayOfTheWeekTextWeight,600);color:var(--MdsCalendar__dayOfTheWeekTextColo,#565a5d);line-height:var(--MdsCalendar__dayOfTheWeekTextLineHeight,1.25rem);display:flex;justify-content:center;align-items:center}:host .calendar__body__month-heading{padding-top:var(--MdsCalendar__monthTextTopPadding,16px);padding-bottom:var(--MdsCalendar__monthTextBottomPadding,12px);font-size:var(--MdsCalendar__monthTextSize,1rem);font-weight:var(--MdsCalendar__monthTextWeight,600);color:var(--MdsCalendar__monthTextColor,#565a5d);line-height:var(--MdsCalendar__monthTextLineHeight,1.5rem)}:host .calendar__body__date-list{align-items:baseline}:host .calendar__body__date-list__grid-cell{padding-bottom:var(--MdsCalendar__dateTextBottomPadding,20px);font-size:var(--MdsCalendar__dateTextSize,1.125rem);color:var(--MdsCalendar__dateTextColor,#101820);font-weight:var(--MdsCalendar__dateTextWeight,400);line-height:var(--MdsCalendar__dateTextLineHeight,1.75rem);display:flex;justify-content:space-evenly;align-items:center}:host .calendar__body__date-list__grid-cell__content{display:flex;align-items:center;flex-direction:column}:host .calendar__legend{padding-top:var(--MdsCalendar__legendTopPadding,28px);display:flex;flex-direction:row;justify-content:flex-end;align-items:center}:host .calendar__legend__label{font-size:var(--MdsCalendar__legendTextSize,.75rem);font-weight:var(--MdsCalendar__legendTextWeight,400);line-height:var(--MdsCalendar__legendTextLineHeight,1rem);color:var(--MdsCalendar__legendTextColor,#101820)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/callout/mds-callout.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ':host *{font-family:Open Sans}:host .callout{position:absolute;z-index:99998;border-radius:var(--MdsCallout__calloutBorderRadius,8px);width:-moz-max-content;width:max-content;white-space:pre-wrap;text-align:left;box-sizing:border-box;display:none;background-color:var(--MdsCallout-_variant-contextual__backgroundColor,#f5f7f8);border:var(--MdsCallout__calloutBorderWeight,1px) var(--MdsCallout__calloutBorderStyle,solid) var(--MdsCallout-_variant-contextual__calloutBorderColor,transparent)}@media (-ms-high-contrast:active),(-ms-high-contrast:none){:host .callout{width:auto}}:host .callout__close{cursor:pointer;background-color:transparent;border-color:transparent;outline:none;margin-right:var(--MdsCallout__closeIconTrailingMargin,8px);margin-top:var(--MdsCallout__closeIconTopMargin,8px);padding:0;display:flex;align-self:flex-start;position:absolute;top:0;right:0}:host .callout__close:focus{outline:.0625rem dashed #717171}:host .callout__close-icon{display:inline-flex}:host .callout__close-icon svg{height:var(--MdsCallout__closeIconHeight,14px);width:var(--MdsCallout__closeIconWidth,14px);fill:var(--MdsCallout__closeIconColor,#565a5d)}:host .callout__close::-moz-focus-inner{border:0}:host .callout__message{margin:0;padding-right:var(--MdsCallout__calloutTrailingPadding,28px);font-size:var(--MdsCallout-_variant-web__messageTextSize,.75rem);line-height:var(--MdsCallout-_variant-web__messageTextLineHeight,1rem);font-weight:var(--MdsCallout-_variant-web__messageTextWeight,400);color:var(--MdsCallout__messageTextColor,#101820)}:host .callout--contextual{width:100%}:host .callout--overlay,:host .callout--web{background:radial-gradient(var(--MdsCallout__backgroundGradientStart,#daeffe),var(--MdsCallout__backgroundGradientEnd,#eaf6ff));background-color:var(--MdsCallout__backgroundGradientEnd,#eaf6ff);border-color:var(--MdsCallout__calloutBorderColor,#0091da)}:host .callout__title{margin-top:0;margin-bottom:0;padding-right:var(--MdsCallout__calloutTrailingPadding,28px);font-size:var(--MdsCallout-_title-true__titleTextSize,.875rem);line-height:var(--MdsCallout-_title-true__titleTextLineHeight,1.25rem);font-weight:var(--MdsCallout-_title-true__titleTextWeight,600);color:var(--MdsCallout-_title-true__titleTextColor,#101820)}:host .callout__button{margin-bottom:var(--MdsCallout-_buttonText-true__calloutBottomPadding,16px);margin-right:var(--MdsCallout-_buttonText-true__buttonTrailingMargin,16px);float:right}:host .callout__button::-moz-focus-inner{border:0}:host .callout__content-container{display:flex;flex-direction:row;padding-top:var(--MdsCallout__calloutTopPadding,16px);padding-left:var(--MdsCallout__calloutLeadingPadding,16px)}:host .callout__content-container--no-button{padding-bottom:var(--MdsCallout__calloutBottomPadding,16px)}:host .callout__pointer{height:var(--MdsCallout__pointerWidth,12px);width:var(--MdsCallout__pointerWidth,12px);position:absolute;z-index:-1;background:radial-gradient(var(--MdsCallout__backgroundGradientStart,#daeffe),var(--MdsCallout__backgroundGradientEnd,#eaf6ff));background-color:var(--MdsCallout__backgroundGradientEnd,#eaf6ff);border-left-color:var(--MdsCallout__backgroundGradientEnd,#eaf6ff);border-bottom:var(--MdsCallout__calloutBorderWeight,1px) var(--MdsCallout__calloutBorderStyle,solid) var(--MdsCallout__backgroundGradientEnd,#eaf6ff);border-right:var(--MdsCallout__calloutBorderWeight,1px) var(--MdsCallout__calloutBorderStyle,solid) var(--MdsCallout__backgroundGradientEnd,#eaf6ff);border-top-color:var(--MdsCallout__backgroundGradientEnd,#eaf6ff);border-top:var(--MdsCallout__calloutBorderWeight,1px) var(--MdsCallout__calloutBorderStyle,solid) var(--MdsCallout__calloutBorderColor,#0091da);border-left:var(--MdsCallout__calloutBorderWeight,1px) var(--MdsCallout__calloutBorderStyle,solid) var(--MdsCallout__calloutBorderColor,#0091da)}:host .callout__pointer--contextual{height:var(--MdsCallout-_variant-contextual__pointerHeight,0);width:var(--MdsCallout-_variant-contextual__pointerHeight,0);border-color:var(--MdsCallout-_variant-contextual__calloutBorderColor,transparent)}:host .callout__pointer--above{bottom:-7.07107px;transform:rotate(225deg)}:host .callout__pointer--above.callout__pointer--center{transform:translateX(-50%) rotate(225deg)}:host .callout__pointer--below{top:-7.07107px;border-right-color:transparent;border-bottom-color:transparent;transform:rotate(45deg)}@-moz-document url-prefix(""){:host .callout__pointer{box-sizing:content-box}}:host .callout__pointer--center{transform:translateX(-50%) rotate(45deg);left:50%}:host .callout__pointer--left{left:.5rem}:host .callout__pointer--right{right:.5rem}:host .callout--above{transform:translateY(-.75rem);bottom:100%}:host .callout--above.callout--center{transform:translate(-50%,-.75rem)}:host .callout--below{transform:translateY(.75rem)}:host .callout--below.callout--center,:host .callout--below.callout--safari.callout--wrapped-trigger{transform:translate(-50%,.75rem)}:host .callout--below.callout--right.callout--wrapped-trigger{transform:translate(50%,.75rem)}:host .callout--center{left:50%}:host .callout--right{right:0}:host .callout .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .callout__icon{padding-right:var(--MdsCallout__iconTrailingPadding,8px)}:host .callout__icon svg{width:var(--MdsCallout__iconWidth,24px);height:var(--MdsCallout__iconHeight,24px);fill:var(--MdsCallout__iconColor,#f5f7f8)}', "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/carousel/mds-carousel.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ':host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .carousel{display:flex;flex-direction:column-reverse;margin-right:var(--MdsCarousel__trailingMargin,-2px);background-color:var(--MdsCarousel__backgroundColor,#fff)}:host .carousel--slideshow{border-top-left-radius:var(--MdsCarousel-_variant-slideshow__borderRadiusLeadingTop,6px);border-top-right-radius:var(--MdsCarousel-_variant-slideshow__borderRadiusTrailingTop,6px);min-width:var(--MdsCarousel-_variant-slideshow__minWidth,300px);margin-right:var(--MdsCarousel-_variant-slideshow__trailingMargin,0)}:host .carousel--hero{margin-right:var(--MdsCarousel-_variant-hero__trailingMargin,0)}:host .carousel__tabpanel{height:100%}:host .carousel__tabpanel:focus{outline:.0625rem dashed #717171}:host .carousel__tabpanel--hero{display:flex;flex-direction:column;height:-moz-fit-content;height:fit-content;min-width:var(--MdsCarousel-_variant-hero__minWidth,300px)}@media screen and (min-width:576px){:host .carousel__tabpanel--hero{flex-direction:row}}@media screen and (min-width:576px){:host .carousel__tabpanel--reverse{flex-direction:row-reverse}}:host .carousel__track{overflow:hidden}:host .carousel__track .carousel__slides-container{display:inline-flex;transition-property:transform;transition-timing-function:var(--MdsCarousel__trackTransitionEaze,cubic-bezier(0,0,0,1));transition-duration:var(--MdsCarousel__trackTransitionDuration,.35s)}@media (prefers-reduced-motion:reduce){:host .carousel__track .carousel__slides-container{transition-duration:0s}}:host .carousel__track .carousel__slides-container .carousel__tabpanel{margin-top:var(--MdsCarousel_slide__margin,1px);margin-bottom:var(--MdsCarousel_slide__margin,1px);margin-left:var(--MdsCarousel_slide__marginBetween,16px);cursor:pointer;position:relative}:host .carousel__track .carousel__slides-container .carousel__tabpanel--hero{visibility:hidden;transition-property:visibility;transition-delay:var(--MdsCarousel__trackTransitionDuration,.35s)}:host .carousel__track .carousel__slides-container .carousel__tabpanel--hero:focus{outline:none}:host .carousel__track .carousel__slides-container .carousel__tabpanel--hero:focus:after{position:absolute;content:"";height:100%;width:calc(100% + var(--MdsCarousel__trailingMargin, -2px));outline:.0625rem dashed #717171;z-index:-1}:host .carousel__track .carousel__slides-container .carousel__tabpanel--active{cursor:default;visibility:visible;transition-delay:0s}:host .carousel__track .carousel__slides-container .carousel__tabpanel:first-of-type{margin-left:var(--MdsCarousel_slide__margin,1px)}:host .carousel__track .carousel__slides-container .carousel__tabpanel:last-of-type{margin-right:var(--MdsCarousel_slide__margin,1px)}:host .carousel__slide{margin:0}:host .carousel__slide-content{cursor:auto;padding:var(--MdsCarousel_slide__contentTopPadding,16px) var(--MdsCarousel_slide__contentTrailingPadding,16px) var(--MdsCarousel_slide__contentBottomPadding,16px) var(--MdsCarousel_slide__contentLeadingPadding,16px);border-bottom-left-radius:var(--MdsCarousel_slide__borderRadius,4px);border-bottom-right-radius:var(--MdsCarousel_slide__borderRadius,4px);border:var(--MdsCarousel_slide__borderWidth,1px) var(--MdsCarousel_slide__borderStyle,solid) var(--MdsCarousel_slide__borderColor,rgba(0,0,0,.25));border-top:0 var(--MdsCarousel_slide__borderStyle,solid) var(--MdsCarousel_slide__borderColor,rgba(0,0,0,.25))}:host .carousel__slide-content--hero{padding:0;border:0}@media screen and (max-width:35.9375rem){:host .carousel__slide-content--hero{width:100%!important}}:host .carousel__slide-content--slideshow{border:0;padding:var(--MdsCarousel_slideshow_slide__contentTopPadding,16px) var(--MdsCarousel_slideshow_slide__contentTrailingPadding,16px) 0 var(--MdsCarousel_slideshow_slide__contentLeadingPadding,16px)}:host .carousel__slide-heading{display:block;margin:var(--MdsCarousel_slide__headingTopMargin,0) var(--MdsCarousel_slide__headingTrailingMargin,0) var(--MdsCarousel_slide__headingBottomMargin,8px) var(--MdsCarousel_slide__headingLeadingMargin,0);font-size:var(--MdsCarousel_slide__headingTextSize,1rem);line-height:var(--MdsCarousel_slide__headingLineHeight,1.5rem);text-align:var(--MdsCarousel_slide__headingTextAlign,left);font-weight:var(--MdsCarousel_slide__headingTextWeight,600);color:var(--MdsCarousel_slide__contentTextColor,#414042)}:host .carousel__slide-heading--hero{margin-bottom:var(--MdsCarousel_hero_slide__mobileHeadingBottomMargin,8px);font-size:var(--MdsCarousel_hero_slide__headingTextSize,2.25rem);line-height:var(--MdsCarousel_hero_slide__headingLineHeight,3rem);font-weight:var(--MdsCarousel_hero_slide__headingTextWeight,300);color:var(--MdsCarousel_hero_slide__headingTextColor,#101820)}@media screen and (min-width:576px){:host .carousel__slide-heading--hero{margin-bottom:var(--MdsCarousel_hero_slide__headingBottomMargin,16px)}}:host .carousel__slide-heading--slideshow{color:var(--MdsCarousel_slideshow_slide__contentTextColor,#414042)}:host .carousel__slide-subheading{display:block;margin:0;padding-top:var(--MdsCarousel_hero_slide__mobileSubheadingTopMargin,8px);font-size:var(--MdsCarousel_hero_slide__subheadingTextSize,1.125rem);line-height:var(--MdsCarousel_hero_slide__subheadingTextLineHeight,1.75rem);font-weight:var(--MdsCarousel_hero_slide__subheadingTextWeight,600);color:var(--MdsCarousel_hero_slide__subheadingTextColor,#101820)}@media screen and (min-width:576px){:host .carousel__slide-subheading{padding-top:0}}:host .carousel__slide-description{color:var(--MdsCarousel_slide__contentTextColor,#414042);font-size:var(--MdsCarousel_slide__descriptionTextSize,.75rem);line-height:var(--MdsCarousel_slide__descriptionLineHeight,1rem);text-align:var(--MdsCarousel_slide__descriptionTextAlign,left);font-weight:var(--MdsCarousel_slide__descriptionTextWeight,400);margin:0}:host .carousel__slide-description--hero{overflow:auto;display:block;font-size:var(--MdsCarousel_hero_slide__descriptionTextSize,.875rem);line-height:var(--MdsCarousel_hero_slide__descriptionLineHeight,1.25rem);font-weight:var(--MdsCarousel_hero_slide__descriptionTextWeight,400);color:var(--MdsCarousel_hero_slide__descriptionTextColor,#101820)}:host .carousel__slide-description--slideshow{color:var(--MdsCarousel_slideshow_slide__contentTextColor,#414042)}:host .carousel__slide--hero{display:block;margin:0;padding:0;border:0}@media screen and (max-width:35.9375rem){:host .carousel__slide--hero{width:100%!important}}:host .carousel__slide-border{border-bottom-width:var(--MdsCarousel_slide__borderWidth,1px);border-top-left-radius:var(--MdsCarousel_slide__borderRadius,4px);border-top-right-radius:var(--MdsCarousel_slide__borderRadius,4px);border:var(--MdsCarousel_slide__borderWidth,1px) var(--MdsCarousel_slide__borderStyle,solid) var(--MdsCarousel_slide__borderColor,rgba(0,0,0,.25));border-bottom:0 var(--MdsCarousel_slide__borderStyle,solid) var(--MdsCarousel_slide__borderColor,rgba(0,0,0,.25))}:host .carousel__controls{display:flex;justify-content:center;align-items:center;list-style:none;margin:0;padding:var(--MdsCarousel__controlsFooterTopPadding,24px) var(--MdsCarousel__controlsFooterTrailingPadding,0) var(--MdsCarousel__controlsFooterBottomPadding,16px) var(--MdsCarousel__controlsFooterLeadingPadding,0)}:host .carousel__controls .carousel__control-button-container{margin-right:var(--MdsCarousel__controlsFooterButtonMarginBetween,8px)}:host .carousel__controls .carousel__control-button-container--hidden{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden;left:0}:host .carousel__controls .carousel__control-button--arrow:first-of-type{margin-right:var(--MdsCarousel__controlsFooterButtonMarginBetween,8px)}:host .carousel__controls--hero{padding-top:var(--MdsCarousel-_variant-hero__mobileControlsFooterTopPadding,16px)}@media screen and (min-width:992px){:host .carousel__controls--hero{padding-top:var(--MdsCarousel-_variant-hero__desktopControlsFooterTopPadding,32px)}}:host .carousel__cta-container{display:block;margin-top:var(--MdsCarousel_slide__ctaTopMargin,16px)}:host .carousel__cta-container--hero{margin-top:var(--MdsCarousel_hero_slide__ctaTopMargin,16px);margin-bottom:var(--MdsCarousel_hero_slide__mobileCtaBottomMargin,16px)}@media screen and (min-width:576px){:host .carousel__cta-container--hero{margin-bottom:0}}:host .carousel__image{display:block;width:100%;border-top-left-radius:var(--MdsCarousel_slide__imageBorderRadius,3px);border-top-right-radius:var(--MdsCarousel_slide__imageBorderRadius,3px);height:100%;-o-object-fit:contain;object-fit:contain}:host .carousel__image--hero{height:auto;border-radius:0;width:100%}@media screen and (min-width:576px){:host .carousel__image--hero{padding-right:var(--MdsCarousel_hero_slide__imageContentHorizontalPadding,12%)}}@media screen and (min-width:576px){:host .carousel__image--reverse{padding-right:0;padding-left:var(--MdsCarousel_hero_slide__imageContentHorizontalPadding,12%)}}', "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/chat-bubble/mds-chat-bubble.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host{display:block;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .mds-chat-bubble{display:flex;flex-direction:column;align-items:flex-start}:host .mds-chat-bubble--customer{align-items:flex-end}:host .mds-chat-bubble--customer .mds-chat-bubble__container,:host .mds-chat-bubble--customer .mds-chat-bubble__container .mds-chat-bubble__message-container{justify-content:flex-end}:host .mds-chat-bubble--customer .mds-chat-bubble__container--error .mds-chat-bubble__icon{box-sizing:border-box}:host .mds-chat-bubble__image{display:block;max-width:calc(var(--MdsChatBubble__maxWidth, 272px) - var(--MdsChatbubble__leadingPadding, 16px) + var(--MdsChatbubble__trailingPadding, 16px));margin-bottom:var(--MdsChatBubble__imageBottomMargin,8px)}:host .mds-chat-bubble .mds-chat-bubble__container{display:flex;flex-direction:row;justify-content:flex-start;align-items:center}:host .mds-chat-bubble .mds-chat-bubble__container:focus{outline:.0625rem dashed #717171}:host .mds-chat-bubble .mds-chat-bubble__container .mds-chat-bubble__message-container{display:flex;position:relative}:host .mds-chat-bubble .mds-chat-bubble__container .mds-chat-bubble__message-container .mds-chat-bubble__message{position:relative;opacity:0}:host .mds-chat-bubble .mds-chat-bubble__container .mds-chat-bubble__message-container .mds-chat-bubble__message-text{white-space:pre-line}:host .mds-chat-bubble .mds-chat-bubble__container .mds-chat-bubble__message-container .mds-chat-bubble__message-background{position:absolute;border-style:solid;box-sizing:border-box;opacity:0;width:100%;height:100%}:host .mds-chat-bubble .mds-chat-bubble__container--customer+.mds-chat-bubble__microcopy-container{display:flex;justify-content:flex-end;opacity:0}:host .mds-chat-bubble .mds-chat-bubble__container--customer+.mds-chat-bubble__microcopy-container .mds-chat-bubble__microcopy{display:contents}:host .mds-chat-bubble.mds-chat-bubble--customer .mds-chat-bubble__container .mds-chat-bubble__message-container{max-width:var(--MdsChatBubble__maxWidth,272px);word-break:break-word}:host .mds-chat-bubble.mds-chat-bubble--customer .mds-chat-bubble__container .mds-chat-bubble__message-container .mds-chat-bubble__message{animation-name:customer-message-motion,customer-message-opacity;animation-duration:var(--MdsChatBubble__bubbleSizeMotionTiming,.35s),var(--MdsChatBubble__bubbleOpacityMotionTiming,.35s);animation-delay:var(--MdsChatBubble__messagePositionMotionDelay,0ms),var(--MdsChatBubble__messageOpacityMotionDelay,0ms);animation-timing-function:var(--MdsChatBubble__bubbleSizeMotionEasing,cubic-bezier(0,0,0,1)),var(--MdsChatBubble__bubbleOpacityMotionEasing,linear);animation-fill-mode:forwards,forwards}@keyframes customer-message-motion{0%{left:calc(var(--MdsChatBubble__messagePositionMotionOffset, 0px)*1)}to{left:0}}@keyframes customer-message-opacity{0%{opacity:var(--MdsChatBubble__messageOpacityMotionStart,0)}to{opacity:var(--MdsChatBubble__messageOpacityMotionEnd,1)}}:host .mds-chat-bubble.mds-chat-bubble--customer .mds-chat-bubble__container--error+.mds-chat-bubble__microcopy-container .mds-chat-bubble__microcopy{color:var(--MdsChatBubble-_error-true__microcopyTextColor,#b80009)}:host .mds-chat-bubble.mds-chat-bubble--customer .mds-chat-bubble__container--error .mds-chat-bubble__icon{margin-top:var(--MdsChatBubble-_error-true__errorIconTopMargin,8px);padding-right:var(--MdsChatBubble-_error-true__errorIconTrailingPadding,4px)}:host .mds-chat-bubble.mds-chat-bubble--customer .mds-chat-bubble__container--error .mds-chat-bubble__icon svg{height:var(--MdsChatBubble-_error-true__errorIconHeight,20px);width:var(--MdsChatBubble-_error-true__errorIconWidth,20px);fill:var(--MdsChatBubble-_error-true__errorIconBackgroundColor,#b80009)}:host .mds-chat-bubble .mds-chat-bubble__container .mds-chat-bubble__message-container{max-width:var(--MdsChatBubble__maxWidth,272px)}:host .mds-chat-bubble .mds-chat-bubble__container .mds-chat-bubble__message-container .mds-chat-bubble__message{color:var(--MdsChatBubble__messageTextColor,#101820);font-size:var(--MdsChatBubble__messageTextSize,.875rem);font-weight:var(--MdsChatBubble__messageTextWeight,400);line-height:var(--MdsChatBubble__messageTextLineHeight,1.25rem);padding:var(--MdsChatBubble__topPadding,8px) var(--MdsChatBubble__trailingPadding,16px) var(--MdsChatBubble__bottomPadding,8px) var(--MdsChatBubble__leadingPadding,16px);left:calc(var(--MdsChatBubble__messagePositionMotionOffset, 0px)*-1);animation-name:message-motion,message-opacity;animation-duration:calc(var(--MdsChatBubble__bubbleSizeMotionTiming, 350)*1ms),calc(var(--MdsChatBubble__bubbleOpacityMotionTiming, 350)*1ms);animation-delay:calc(var(--MdsChatBubble__messagePositionMotionDelay, 0)*1ms),calc(var(--MdsChatBubble__messageOpacityMotionDelay, 0)*1ms);animation-timing-function:var(--MdsChatBubble__bubbleSizeMotionEasing,cubic-bezier(0,0,0,1)),var(--MdsChatBubble__bubbleOpacityMotionEasing,linear);animation-fill-mode:forwards,forwards}@keyframes message-motion{0%{left:calc(var(--MdsChatBubble__messagePositionMotionOffset, 0px)*-1)}to{left:0}}@keyframes message-opacity{0%{opacity:var(--MdsChatBubble__messageOpacityMotionStart,0)}to{opacity:var(--MdsChatBubble__messageOpacityMotionEnd,1)}}:host .mds-chat-bubble .mds-chat-bubble__container .mds-chat-bubble__message-container .mds-chat-bubble__message-background{border-top-left-radius:var(--MdsChatBubble__borderRadiusTopLeading,12px);border-top-right-radius:var(--MdsChatBubble__borderRadiusTopTrailing,12px);border-bottom-left-radius:var(--MdsChatBubble__borderRadiusBottomLeading,12px);border-bottom-right-radius:var(--MdsChatBubble__borderRadiusBottomTrailing,12px);border-width:var(--MdsChatBubble__borderWidth,1px);padding:var(--MdsChatBubble__topPadding,8px) var(--MdsChatBubble__trailingPadding,16px) var(--MdsChatBubble__bottomPadding,8px) var(--MdsChatBubble__leadingPadding,16px);animation-name:motion,opacity;animation-duration:var(--MdsChatBubble__bubbleSizeMotionTiming,.35s),var(--MdsChatBubble__bubbleOpacityMotionTiming,.35s);animation-timing-function:var(--MdsChatBubble__bubbleSizeMotionEasing,cubic-bezier(0,0,0,1)),var(--MdsChatBubble__bubbleOpacityMotionEasing,linear);animation-fill-mode:forwards,forwards}@keyframes motion{0%{width:calc(var(--MdsChatBubble__bubbleSizeMotionStart, 0)*100%)}to{width:calc(var(--MdsChatBubble__bubbleSizeMotionEnd, 1)*100%)}}@keyframes opacity{0%{opacity:var(--MdsChatBubble__bubbleOpacityMotionStart,0)}to{opacity:var(--MdsChatBubble__bubbleOpacityMotionEnd,1)}}:host .mds-chat-bubble .mds-chat-bubble__container--first .mds-chat-bubble__message-container .mds-chat-bubble__message-background{border-top-left-radius:var(--MdsChatBubble-_firstInGroup-true__borderRadiusTopLeading,2px)}:host .mds-chat-bubble .mds-chat-bubble__container--agent .mds-chat-bubble__message-container .mds-chat-bubble__message-background{border-color:var(--MdsChatBubble-_variant-agent__borderColor,#eceff1);background-color:var(--MdsChatBubble-_variant-agent__backgroundColor,#eceff1)}:host .mds-chat-bubble .mds-chat-bubble__container--assistant .mds-chat-bubble__message-container .mds-chat-bubble__message-background{border-color:var(--MdsChatBubble-_variant-assistant__borderColor,#c1c3c3);background-color:var(--MdsChatBubble-_variant-assistant__backgroundColor,#fff)}:host .mds-chat-bubble .mds-chat-bubble__container--customer .mds-chat-bubble__message-container .mds-chat-bubble__message-background{border-color:var(--MdsChatBubble-_variant-customer__borderColor,#daeffe);background-color:var(--MdsChatBubble-_variant-customer__backgroundColor,#daeffe)}:host .mds-chat-bubble .mds-chat-bubble__container--customer+.mds-chat-bubble__microcopy-container{animation-name:microcopy-motion,microcopy-opacity;animation-duration:var(--MdsChatBubble__microcopyPositionMotionTiming,.35s),var(--MdsChatBubble__microcopyOpacityMotionTiming,350 * 1ms);animation-delay:var(--MdsChatBubble__microcopyPositionMotionDelay,0ms),var(--MdsChatBubble__microcopyOpacityMotionDelay,0 * 1ms);animation-timing-function:var(--MdsChatBubble__microcopyPositionMotionEasing,cubic-bezier(0,0,0,1)),var(--MdsChatBubble__microcopyOpacityMotionEasing,linear);transform:translateX(var(--MdsChatBubble__microcopyPositionMotionOffset,0));animation-fill-mode:forwards,forwards}@keyframes microcopy-motion{0%{transform:translateX(var(--MdsChatBubble__microcopyPositionMotionOffset,0))}to{transform:translateX(0)}}@keyframes microcopy-opacity{0%{opacity:var(--MdsChatBubble__microcopyOpacityMotionStart,0)}to{opacity:var(--MdsChatBubble__microcopyOpacityMotionEnd,1)}}:host .mds-chat-bubble .mds-chat-bubble__container--customer+.mds-chat-bubble__microcopy-container .mds-chat-bubble__microcopy{color:var(--MdsChatBubble__microcopyTextColor,#565a5d);font-size:var(--MdsChatBubble__microcopyTextWeight,.75rem);font-weight:var(--MdsChatBubble__microcopyTextWeight,400);line-height:var(--MdsChatBubble__microcopyTextLineHeight,1rem);padding-top:var(--MdsChatBubble__microcopyTopPadding,4px)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/chat-input/mds-chat-input.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .mds-chat-input{display:flex}:host .mds-chat-input .mds-chat-input__questionmark-wrap{display:flex;flex-direction:column;justify-content:flex-end;padding:calc(var(--MdsChatInput_leadingButton__buttonHeight, 44px) - var(--MdsChatInput_leadingButton__iconHeight, 24px)) calc(var(--MdsChatInput_leadingButton__buttonWidth, 44px) - var(--MdsChatInput_leadingButton__iconWidth, 24px))}:host .mds-chat-input .mds-chat-input__questionmark-wrap .mds-chat-input__questionmark-button{padding-left:0;transition-property:background-color;transition-duration:var(--MdsChatInput_button__stateChangeColorTransitionTime,0ms);transition-timing-function:var(--MdsChatInput_button__stateChangeColorTransitionEase,cubic-bezier(0,.4,.2,1));width:var(--MdsChatInput_leadingButton__iconWidth,24px);height:var(--MdsChatInput_leadingButton__iconHeight,24px);border-radius:50%;background-color:var(--MdsChatInput__backgroundColor,#fff);border-width:var(--MdsButton-_variant-primary__borderWidth,0)}:host .mds-chat-input .mds-chat-input__questionmark-wrap .mds-chat-input__questionmark-button:disabled .mds-chat-input__questionmark-button-icon svg{fill:var(--MdsChatInput_leadingButton__iconColor--disabled,#8c8e90)}:host .mds-chat-input .mds-chat-input__questionmark-wrap .mds-chat-input__questionmark-button .mds-chat-input__questionmark-button-icon svg{width:var(--MdsChatInput_leadingButton__iconWidth,24px);height:var(--MdsChatInput_leadingButton__iconHeight,24px);fill:var(--MdsChatInput_leadingButton__iconColor,#005eb8)}:host .mds-chat-input .mds-chat-input__questionmark-wrap .mds-chat-input__questionmark-button--active .mds-chat-input__questionmark-button-icon svg{fill:var(--MdsChatInput_leadingButton__iconColor,#005eb8)}:host .mds-chat-input .mds-chat-input__questionmark-wrap .mds-chat-input__questionmark-button--active:focus .mds-chat-input__questionmark-button-icon svg{fill:var(--MdsChatInput_leadingButton__iconColor--focused,#005eb8)}:host .mds-chat-input .mds-chat-input__questionmark-wrap .mds-chat-input__questionmark-button--active:hover{cursor:pointer}:host .mds-chat-input .mds-chat-input__questionmark-wrap .mds-chat-input__questionmark-button--active:hover .mds-chat-input__questionmark-button-icon svg{fill:var(--MdsChatInput_leadingButton__iconColor--hovered,#004692)}:host .mds-chat-input .mds-chat-input__questionmark-wrap .mds-chat-input__questionmark-button--active:active .mds-chat-input__questionmark-button-icon svg{fill:var(--MdsChatInput_leadingButton__iconColor,#005eb8)}:host .mds-chat-input .mds-chat-input__wrap{display:flex;flex-direction:row;width:100%;position:relative}:host .mds-chat-input .mds-chat-input__wrap .mds-chat-input__textarea{z-index:2;display:block;resize:none;width:100%;border:0;box-sizing:border-box;overflow:auto}:host .mds-chat-input .mds-chat-input__wrap .mds-chat-input__textarea:focus{outline:none}:host .mds-chat-input .mds-chat-input__wrap .mds-chat-input__textarea:hover::-webkit-scrollbar{width:.5rem}:host .mds-chat-input .mds-chat-input__wrap .mds-chat-input__textarea:hover::-webkit-scrollbar-thumb{width:.5rem;background:grey;border-radius:.25rem}:host .mds-chat-input .mds-chat-input__wrap .mds-chat-input__textarea--active{outline:none}:host .mds-chat-input .mds-chat-input__wrap .mds-chat-input__button-wrap{z-index:3;position:absolute;box-sizing:border-box}:host .mds-chat-input .mds-chat-input__wrap .mds-chat-input__button-wrap .mds-chat-input__button{display:flex;position:relative;justify-content:center;box-sizing:border-box;text-align:center;white-space:nowrap;vertical-align:middle}@media screen and (-webkit-min-device-pixel-ratio:0) and (min-resolution:0.001dpcm){:host .mds-chat-input .mds-chat-input__wrap .mds-chat-input__button-wrap .mds-chat-input__button .mds-chat-input__button-icon{position:relative;top:calc(var(--MdsChatInput_button__topPadding, 8px)/4)}}:host .mds-chat-input .mds-chat-input__wrap .mds-chat-input__button-wrap .mds-chat-input__button--active{cursor:pointer}:host .mds-chat-input .mds-chat-input__wrap .mds-chat-input__button-wrap .mds-chat-input__button:disabled{cursor:default}:host .mds-chat-input .mds-chat-input__wrap .mds-chat-input__button-wrap .mds-chat-input__button::-moz-focus-inner{border:0}:host .mds-chat-input .mds-chat-input__wrap .mds-chat-input__button-wrap .mds-chat-input__button:focus{outline:.0625rem dashed #717171}:host .mds-chat-input .mds-chat-input__focus{z-index:5;width:100%;display:flex;flex-direction:row;position:absolute;left:var(--MdsChatInput__borderRadius,12px)}:host .mds-chat-input .mds-chat-input__text-area-button-container{position:relative;display:flex;justify-content:flex-end;align-items:flex-end;width:100%}:host .mds-chat-input .mds-chat-input__label-wrap .mds-chat-input__label{z-index:3;position:absolute;box-sizing:border-box;border:0;vertical-align:middle;white-space:nowrap}:host .mds-chat-input .mds-chat-input__label-wrap .mds-chat-input__label--floating{display:block}:host .mds-chat-input .mds-chat-input__wrap .mds-chat-input__textarea{border:var(--MdsChatInput__borderWidth,1px) solid var(--MdsChatInput__borderColor,#565a5d);border-radius:var(--MdsChatInput__borderRadius,12px);max-height:var(--MdsChatInput__maxHeight,156px);min-height:var(--MdsChatInput__minHeight,56px);margin-top:var(--MdsChatInput__fieldTopMargin,0);padding:calc(var(--MdsChatInput__fieldTopPadding, 4px) + var(--MdsChatInput__fieldTextLineHeight, 24px) + var(--MdsChatInput__borderTopWidth--focused, 2px)*2) calc(var(--MdsChatInput_button__topPadding, 8px)*2 + var(--MdsChatInput_button__topMargin, 8px)*2 + var(--MdsChatInput_button__circleRadius, 14px)*2) var(--MdsChatInput__fieldBottomPadding,8px) var(--MdsChatInput__fieldLeadingPadding,16px);color:var(--MdsChatInput__fieldTextColor,#101820);font-size:var(--MdsChatInput__fieldTextSize,.875rem);line-height:var(--MdsChatInput__fieldTextLineHeight,1.5rem);font-weight:var(--MdsChatInput__fieldTextWeight,400);text-align:var(--MdsChatInput__fieldTextAlignment,left)}:host .mds-chat-input .mds-chat-input__wrap .mds-chat-input__textarea:focus{border-color:var(--MdsChatInput_leadingButton__iconColor,#005eb8);border-width:var(--MdsChatInput__borderWidth--focused,2px)}:host .mds-chat-input .mds-chat-input__wrap .mds-chat-input__button-wrap{height:calc(var(--MdsChatInput_button__topPadding, 8px)*2 + var(--MdsChatInput_button__topMargin, 8px)*2 + var(--MdsChatInput_button__circleRadius, 14px)*2);width:calc(var(--MdsChatInput_button__topPadding, 8px)*2 + var(--MdsChatInput_button__topMargin, 8px)*2 + var(--MdsChatInput_button__circleRadius, 14px)*2);padding:var(--MdsChatInput_button__topPadding,8px) var(--MdsChatInput_button__trailingPadding,8px) var(--MdsChatInput_button__bottomPadding,8px) var(--MdsChatInput_button__leadingPadding,8px)}:host .mds-chat-input .mds-chat-input__wrap .mds-chat-input__button-wrap .mds-chat-input__button{margin:var(--MdsChatInput_button__topMargin,8px);transition-property:background-color;transition-duration:var(--MdsChatInput_button__stateChangeColorTransitionTime,0ms);transition-timing-function:var(--MdsChatInput_button__stateChangeColorTransitionEase,cubic-bezier(0,.4,.2,1));width:calc(var(--MdsChatInput_button__circleRadius, 14px)*2);height:calc(var(--MdsChatInput_button__circleRadius, 14px)*2);border-radius:50%;background-color:var(--MdsChatInput_button__circleColor--disabled,#e2e4e5);border-width:var(--MdsButton-_variant-primary__borderWidth,0)}:host .mds-chat-input .mds-chat-input__wrap .mds-chat-input__button-wrap .mds-chat-input__button .mds-chat-input__button-icon svg{height:var(--MdsChatInput_button__iconHeight,20px);width:var(--MdsChatInput_button__iconWidth,20px);fill:var(--MdsChatInput_button__iconColor--disabled,#fff)}:host .mds-chat-input .mds-chat-input__wrap .mds-chat-input__button-wrap .mds-chat-input__button--active{background-color:var(--MdsChatInput_button__circleColor,#005eb8)}:host .mds-chat-input .mds-chat-input__wrap .mds-chat-input__button-wrap .mds-chat-input__button--active .mds-chat-input__button-icon svg{fill:var(--MdsChatInput_button__iconColor,#fff)}:host .mds-chat-input .mds-chat-input__wrap .mds-chat-input__button-wrap .mds-chat-input__button--active:focus{background-color:var(--MdsChatInput_button__circleColor--focused,#005eb8)}:host .mds-chat-input .mds-chat-input__wrap .mds-chat-input__button-wrap .mds-chat-input__button--active:focus .mds-chat-input__button-icon svg{fill:var(--MdsChatInput_button__iconColor--focused,#fff)}:host .mds-chat-input .mds-chat-input__wrap .mds-chat-input__button-wrap .mds-chat-input__button--active:hover{background-color:var(--MdsChatInput_button__circleColor--hovered,#004692)}:host .mds-chat-input .mds-chat-input__wrap .mds-chat-input__button-wrap .mds-chat-input__button--active:hover .mds-chat-input__button-icon svg{fill:var(--MdsChatInput_button__iconColor--hovered,#fff)}:host .mds-chat-input .mds-chat-input__wrap .mds-chat-input__button-wrap .mds-chat-input__button--active:active{background-color:var(--MdsChatInput_button__circleColor--pressed,#0091da)}:host .mds-chat-input .mds-chat-input__wrap .mds-chat-input__button-wrap .mds-chat-input__button--active:active .mds-chat-input__button-icon svg{fill:var(--MdsChatInput_button__iconColor--pressed,#fff)}:host .mds-chat-input .mds-chat-input__focus{height:var(--MdsChatInput__borderTopWidth,1px);background-color:var(--MdsChatInput__borderTopColor,#c1c3c3)}:host .mds-chat-input .mds-chat-input__focus--active{height:var(--MdsChatInput__borderTopWidth--focused,2px);background-color:var(--MdsChatInput__borderTopColor--focused,#005eb8)}:host .mds-chat-input .mds-chat-input__label-wrap .mds-chat-input__label{width:calc(100% - var(--MdsChatInput_button__topPadding, 8px)*2 - var(--MdsChatInput_button__topMargin, 8px)*2 - var(--MdsChatInput_button__circleRadius, 14px)*2);min-height:var(--MdsChatInput__minHeight,56px);margin-top:var(--MdsChatInput__fieldTopMargin,0);margin-left:calc(var(--MdsChatInput__borderWidth, 1px)*2);padding:calc(var(--MdsChatInput__fieldTopPadding, 4px)/2 + var(--MdsChatInput__fieldTextLineHeight, 24px)/2 + var(--MdsChatInput__borderTopWidth--focused, 2px)*2/2 + var(--MdsChatInput__fieldBottomPadding, 8px)/2) var(--MdsChatInput__labelTrailingPadding,8px) calc(var(--MdsChatInput__fieldTopPadding, 4px)/2 + var(--MdsChatInput__fieldTextLineHeight, 24px)/2 + var(--MdsChatInput__borderTopWidth--focused, 2px)*2/2 + var(--MdsChatInput__fieldBottomPadding, 8px)/2) var(--MdsChatInput__labelLeadingPadding,16px);color:var(--MdsChatInput__labelTextColor,#565a5d);font-size:var(--MdsChatInput__fieldTextSize,.875rem);line-height:var(--MdsChatInput__fieldTextLineHeight,1.5rem);font-weight:var(--MdsChatInput__fieldTextWeight,400);text-align:var(--MdsChatInput__fieldTextAlignment,left);transition-property:all;transition-duration:var(--MdsChatInput__labelTransitionTime,.2s);transition-timing-function:var(--MdsChatInput__labelTransitionEase,cubic-bezier(0,.2,.1,1))}:host .mds-chat-input .mds-chat-input__label-wrap .mds-chat-input__label--floating{min-height:0;background-color:#fff;height:calc(var(--MdsChatInput__fieldTextLineHeight, 24px) + var(--MdsChatInput__borderTopWidth--focused, 2px));margin-top:calc(var(--MdsChatInput__borderWidth, 1px)*2);padding-top:calc(var(--MdsChatInput__labelTopPadding, 8px) - var(--MdsChatInput__borderTopWidth, 1px));padding-bottom:calc(var(--MdsChatInput__labelBottomPadding, 8px) + var(--MdsChatInput__borderTopWidth, 1px));padding-left:0;padding-right:var(--MdsChatInput__labelTrailingPadding,8px);margin-left:var(--MdsChatInput__labelLeadingPadding,16px);font-size:var(--MdsChatInput__labelTextSize,.875rem);line-height:var(--MdsChatInput__labelTextLineHeight,1.25rem);font-weight:var(--MdsChatInput__labelTextWeight,400);text-align:var(--MdsChatInput__labelTextAlignment,left);color:var(--MdsChatInput__labelTextColor,#565a5d)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/combo-button/mds-combo-button.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host{display:inline-block}:host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .combo-button__button-container{display:flex;align-items:center;border-radius:var(--MdsComboButton__containerBackgroundBorderRadius,4px)}:host .combo-button__button-container--disabled{border-width:var(--MdsComboButton__containerBackgroundBorderWidth--disabled,0)}:host .combo-button__button-container--secondary{padding:.0625rem}:host .combo-button__button-container .combo-button-combo-button__menu-button{align-self:stretch}:host .combo-button__divider{display:inline-block;vertical-align:middle;height:var(--MdsComboButton__dividerHeight,20px);min-width:var(--MdsComboButton__dividerWidth,1px);width:var(--MdsComboButton__dividerWidth,1px);padding:var(--MdsComboButton__dividerTopPadding,8px) var(--MdsComboButton__dividerTrailingPadding,0) var(--MdsComboButton__dividerBottomPadding,8px) var(--MdsComboButton__dividerLeadingPadding,0)}:host .combo-button__menu-container{position:relative}:host .combo-button__menu-container .combo-button__menu-list{min-width:var(--MdsComboButton__menuContainerMinWidth,120px);max-width:var(--MdsComboButton__menuContainerMaxWidth,300px);border-width:var(--MdsComboButton__menuContainerBorderWidth,1px);border-radius:var(--MdsComboButton__menuContainerBorderRadius,0);list-style-type:none;margin:.0625rem .0625rem 0;padding:0;position:absolute;right:0;z-index:1100}:host .combo-button__menu-container .combo-button__menu-list .combo-button__menu-item{-webkit-appearance:none;-moz-appearance:none;appearance:none;cursor:pointer;list-style-type:none;display:flex;width:var(--MdsComboButton_MenuItem-_widthType-layout__width,100%);font-weight:var(--MdsComboButton_MenuItem__textWeight,400);font-size:var(--MdsComboButton_MenuItem__textSize,1rem);line-height:var(--MdsComboButton_MenuItem__textLineHeightm,1.5rem);padding:var(--MdsComboButton_MenuItem__topPadding,8px) var(--MdsComboButton_MenuItem__trailingPadding,8px) var(--MdsComboButton_MenuItem__bottomPadding,8px) var(--MdsComboButton_MenuItem__leadingPadding,8px);text-align:var(--MdsComboButton_MenuItem__textAlignment,left);background-color:var(--MdsComboButton_MenuItem__backgroundColor,#fff)}:host .combo-button__menu-container .combo-button__menu-list .combo-button__menu-item:focus{border-width:var(--MdsComboButton_MenuItem__borderWidth--focused,1px)}:host .combo-button__menu-container .combo-button__menu-list .combo-button__menu-item:focus:focus{outline:.0625rem dashed #717171}:host .combo-button__menu-container .combo-button__menu-list .combo-button__menu-item:hover{border-width:var(--MdsComboButton_MenuItem__borderWidth--hover,0)}:host .combo-button__menu-container .combo-button__menu-list .combo-button__menu-item:active{border-width:var(--MdsComboButton_MenuItem__borderWidth--pressed,0)}:host .combo-button__menu-container .combo-button__menu-list .combo-button__menu-item-icon{margin-right:var(--MdsComboButton_MenuItem__iconTextHorizontalPadding,8px);margin-top:.125rem}:host .combo-button__menu-container .combo-button__menu-list .combo-button__menu-item-icon svg{height:var(--MdsComboButton_MenuItem__iconHeight,20px);width:var(--MdsComboButton_MenuItem__iconWidth,20px)}:host .combo-button__menu-container .combo-button__menu-list .combo-button__menu-item--disabled{cursor:default;border-width:var(--MdsComboButton_MenuItem__borderWidth--disabled,0);background-color:var(--MdsComboButton__containerBackgroundColor--disabled,#ededed)}:host .combo-button__menu-container .combo-button__menu-list .combo-button__menu-item--disabled:active,:host .combo-button__menu-container .combo-button__menu-list .combo-button__menu-item--disabled:focus,:host .combo-button__menu-container .combo-button__menu-list .combo-button__menu-item--disabled:hover{border-width:var(--MdsComboButton_MenuItem__borderWidth--disabledFocused,1px)}.combo-button__button-container--disabled{background-color:var(--MdsComboButton__containerBackgroundColor--disabled,#ededed)}.combo-button__button-container:not(.combo-button__button-container--disabled).combo-button__button-container--primary{border:var(--MdsComboButton-_variant-primary__containerBackgroundBorderWidth,0) solid var(--MdsComboButton-_variant-primary__containerBackgroundBorderColor,transparent);background-color:var(--MdsComboButton-_variant-primary__containerBackgroundColor,#005eb8)}.combo-button__button-container:not(.combo-button__button-container--disabled).combo-button__button-container--primary .combo-button__divider{box-shadow:inset var(--MdsComboButton__dividerWidth,1px) 0 0 var(--MdsComboButton-_variant-primary__dividerColor,#fff)}.combo-button__button-container:not(.combo-button__button-container--disabled).combo-button__button-container--secondary{border:var(--MdsComboButton-_variant-secondary__containerBackgroundBorderWidth,1px) solid var(--MdsComboButton-_variant-secondary__containerBackgroundBorderColor,#005eb8);background-color:var(--MdsComboButton-_variant-secondary__containerBackgroundColor,transparent)}.combo-button__button-container:not(.combo-button__button-container--disabled).combo-button__button-container--secondary .combo-button__divider{box-shadow:inset var(--MdsComboButton__dividerWidth,1px) 0 0 var(--MdsComboButton-_variant-secondary__dividerColor,#005eb8)}.combo-button__button-container:not(.combo-button__button-container--disabled).combo-button__button-container--tertiary{border:var(--MdsComboButton-_variant-tertiary__containerBackgroundBorderWidth,0) solid var(--MdsComboButton-_variant-tertiary__containerBackgroundBorderColor,transparent);background-color:var(--MdsComboButton-_variant-tertiary__containerBackgroundColor,transparent)}.combo-button__button-container:not(.combo-button__button-container--disabled).combo-button__button-container--tertiary .combo-button__divider{box-shadow:inset var(--MdsComboButton__dividerWidth,1px) 0 0 var(--MdsComboButton-_variant-tertiary__dividerColor,#005eb8)}.combo-button__divider--disabled{box-shadow:inset var(--MdsComboButton__dividerWidth,1px) 0 0 var(--MdsComboButton__dividerColor--disabled,#949494)}.combo-button__menu-container .combo-button__menu-list{background-color:var(--MdsComboButton_MenuItem__backgroundColor,#fff);box-shadow:var(--MdsComboButton__menuContainerBoxShadowHorizontalOffset,0) var(--MdsComboButton__menuContainerBoxShadowVerticalOffset,2px) var(--MdsComboButton__menuContainerBoxShadowBlurOffset,3px) var(--MdsComboButton__menuContainerBoxShadowSpreadOffset,0) var(--MdsComboButton__menuContainerBoxShadowColor,rgba(0,0,0,.28));border-color:var(--MdsComboButton__menuContainerborderColor,rgba(0,0,0,.17))}.combo-button__menu-container .combo-button__menu-list .combo-button__menu-item{color:var(--MdsComboButton_MenuItem__textColor,#414042)}.combo-button__menu-container .combo-button__menu-list .combo-button__menu-item:focus{color:var(--MdsComboButton_MenuItem__textColor--focused,#414042);background-color:var(--MdsComboButton_MenuItem__backgroundColor--focused,#fff);border-color:var(--MdsComboButton_MenuItem__borderColor--focused,#717171)}.combo-button__menu-container .combo-button__menu-list .combo-button__menu-item:focus .combo-button__menu-item-icon svg{fill:var(--MdsComboButton_MenuItem__iconColor--focused,#414042)}.combo-button__menu-container .combo-button__menu-list .combo-button__menu-item:hover{color:var(--MdsComboButton_MenuItem__textColor--hover,#414042);background-color:var(--MdsComboButton_MenuItem__backgroundColor--hover,#f9f6f3);border-color:var(--MdsComboButton_MenuItem__borderColor--hover,transparent)}.combo-button__menu-container .combo-button__menu-list .combo-button__menu-item:hover .combo-button__menu-item-icon svg{fill:var(--MdsComboButton_MenuItem__iconColor--hover,#414042)}.combo-button__menu-container .combo-button__menu-list .combo-button__menu-item:active{color:var(--MdsComboButton_MenuItem__textColor--pressed,#fff);background-color:var(--MdsComboButton_MenuItem__backgroundColor--pressed,#0091da);border-color:var(--MdsComboButton_MenuItem__borderColor--pressed,transparent)}.combo-button__menu-container .combo-button__menu-list .combo-button__menu-item:active .combo-button__menu-item-icon svg{fill:var(--MdsComboButton_MenuItem__iconColor--pressed,#fff)}.combo-button__menu-container .combo-button__menu-list .combo-button__menu-item-icon svg{fill:var(--MdsComboButton_MenuItem__iconColor,#414042)}.combo-button__menu-container .combo-button__menu-list .combo-button__menu-item--disabled{color:var(--MdsComboButton_MenuItem__textColor--disabled,#bcbcbc);background-color:var(--MdsComboButton_MenuItem__backgroundColor--disabled,#ededed);border-color:var(--MdsComboButton_MenuItem__borderColor--disabled,transparent)}.combo-button__menu-container .combo-button__menu-list .combo-button__menu-item--disabled .combo-button__menu-item-icon{fill:var(--MdsComboButton_MenuItem__iconColor--disabled,#bcbcbc)}.combo-button__menu-container .combo-button__menu-list .combo-button__menu-item--disabled:active,.combo-button__menu-container .combo-button__menu-list .combo-button__menu-item--disabled:focus,.combo-button__menu-container .combo-button__menu-list .combo-button__menu-item--disabled:hover{color:var(--MdsComboButton_MenuItem__textColor--disabledFocused,#bcbcbc);background-color:var(--MdsComboButton_MenuItem__backgroundColor--disabledFocused,#ededed);border-color:var(--MdsComboButton_MenuItem__borderColor--disabledFocused,#717171)}.combo-button__menu-container .combo-button__menu-list .combo-button__menu-item--disabled:active .combo-button__menu-item-icon,.combo-button__menu-container .combo-button__menu-list .combo-button__menu-item--disabled:focus .combo-button__menu-item-icon,.combo-button__menu-container .combo-button__menu-list .combo-button__menu-item--disabled:hover .combo-button__menu-item-icon{fill:var(--MdsComboButton_MenuItem__iconColor--disabledFocused,)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/commerce-tile/mds-commerce-tile.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ':host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .commerce-tile{border-radius:var(--MdsCommerceTile__borderRadius,8px);border:var(--MdsCommerceTile__borderWidth,1px) var(--MdsCommerceTile__borderStyle,solid) var(--MdsCommerceTile__borderColor,#e2e4e5);min-width:5rem;overflow:hidden}:host .commerce-tile--interactive{cursor:pointer}:host .commerce-tile--inverse .commerce-tile-content--relative{position:relative;z-index:2}:host .commerce-tile--inverse .commerce-tile-logo_spacing--condensed-inverse_no-img{margin-left:0}:host .commerce-tile--inverse .commerce-tile--gradient_fixed--with-no--height-img{background:transparent}:host .commerce-tile--inverse.commerce-tile--with_no-logo--condensed .commerce-tile-content--title{padding-top:var(--MdsCommerceTile__tagTopPadding,4px)}:host .commerce-tile--inverse.commerce-tile--with_no-logo--relaxed .commerce-tile-content--title{padding-top:var(--MdsCommerceTile__contentContainerWithoutLogoTopPadding,8px)}:host .commerce-tile--inverse.commerce-tile-content--title--condensed{margin-top:var(--MdsCommerceTile__logoContainerPaddingCondensedBottom,4px)}:host .commerce-tile--inverse.commerce-tile-content--title--relaxed{margin-top:var(--MdsCommerceTile__logoContainerPaddingRelaxedBottom,8px)}:host .commerce-tile--inverse.commerce-tile__container{position:relative}:host .commerce-tile--inverse.commerce-tile--gradient-fill--no_img-height .commerce-tile--gradient_fill-no--img{background:transparent}:host .commerce-tile--inverse .commerce-tile__wrapper{position:relative}:host .commerce-tile--inverse .commerce-tile__wrapper>div:first-of-type{position:absolute;height:100%;width:100%;left:0;top:0}:host .commerce-tile--inverse .commerce-tile__wrapper>div:last-of-type{position:relative;background:transparent}:host .commerce-tile__wrapper{display:flex;flex-direction:column}:host .commerce-tile-content{padding:var(--MdsCommerceTile__contentContainerTopPadding,) var(--MdsCommerceTile__contentContainerRightPadding,16px) var(--MdsCommerceTile__contentContainerBottomPadding,16px) var(--MdsCommerceTile__contentContainerLeftPadding,16px)}:host .commerce-tile-content--with-content-slot{padding-bottom:calc(var(--MdsCommerceTile__contentContainerBottomPadding, 16px)/2)}:host .commerce-tile-content--with-content-slot .commerce-tile-content--wrapper-regular{height:100%}:host .commerce-tile-content--with-content-slot .commerce-tile-content--wrapper-inverse{height:auto}:host .commerce-tile-content--no-bottom-padding{padding-bottom:0}:host .commerce-tile-content--no-bottom-padding .commerce-tile-content--gradient_fill{transform:translate(var(---MdsCommerceTile__contentContainerLeftPadding,-16px),-.75rem)}:host .commerce-tile-content--title--condensed{padding-top:var(--MdsCommerceTile__logoContainerPaddingCondensedBottom,4px)}:host .commerce-tile-content--title--relaxed{padding-top:var(--MdsCommerceTile__logoContainerPaddingRelaxedBottom,8px)}:host .commerce-tile-content--slot-spaced{display:flex;flex-direction:column;justify-content:space-between;height:100%}:host .commerce-tile-content .microcopyText,:host .commerce-tile-content .subtitleText,:host .commerce-tile-content .titleText{margin:0}:host .commerce-tile-content .microcopyText--line-clamp,:host .commerce-tile-content .subtitleText--line-clamp,:host .commerce-tile-content .titleText--line-clamp{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden}:host .commerce-tile-content .microcopyText--character-clamp--hidden,:host .commerce-tile-content .microcopyText--line-clamp--hidden,:host .commerce-tile-content .subtitleText--character-clamp--hidden,:host .commerce-tile-content .subtitleText--line-clamp--hidden,:host .commerce-tile-content .titleText--character-clamp--hidden,:host .commerce-tile-content .titleText--line-clamp--hidden{display:none}:host .commerce-tile-content p,:host .commerce-tile-content span{margin:0}:host .commerce-tile-content h3{color:var(--MdsCommerceTile__titleColor,#101820)}:host .commerce-tile-content p{color:var(--MdsCommerceTile__subtitleColor,#101820)}:host .commerce-tile-content span{color:var(--MdsCommerceTile__microcopyColor,#565a5d)}:host .commerce-tile-content--small-title .titleText{font-family:var(--MdsCommerceTile__smallTitle__family,"Open Sans","Helvetica Neue",helvetica,arial,sans-serif);font-size:var(--MdsCommerceTile__smallTitle__size,1rem);line-height:var(--MdsCommerceTile__smallTitle__size_line_height,1.5rem);font-weight:var(--MdsCommerceTile__smallTitle__weight,600)}:host .commerce-tile-content--small-subtitle p{font-family:var(--MdsCommerceTile__smallSubtitle__family,"Open Sans","Helvetica Neue",helvetica,arial,sans-serif);font-size:var(--MdsCommerceTile__smallSubtitle__size,.75rem);line-height:var(--MdsCommerceTile__smallSubtitle__size_line_height,1rem);font-weight:var(--MdsCommerceTile__smallSubtitle__weight,600)}:host .commerce-tile-content--small-microcopy{line-height:var(--MdsCommerceTile__smallMicrocopy__size_line_height,1rem)}:host .commerce-tile-content--small-microcopy span{font-family:var(--MdsCommerceTile__smallMicrocopy__family,"Open Sans","Helvetica Neue",helvetica,arial,sans-serif);font-size:var(--MdsCommerceTile__smallMicrocopy__size,.75rem);line-height:inherit;font-weight:var(--MdsCommerceTile__smallMicrocopy__weight,400)}:host .commerce-tile-content--medium-title .titleText{font-family:var(--MdsCommerceTile__mediumTitle__family,"Open Sans","Helvetica Neue",helvetica,arial,sans-serif);font-size:var(--MdsCommerceTile__mediumTitle__size,1.125rem);line-height:var(--MdsCommerceTile__mediumTitle__size_line_height,1.75rem);font-weight:var(--MdsCommerceTile__mediumTitle__weight,600)}:host .commerce-tile-content--medium-subtitle p{font-family:var(--MdsCommerceTile__mediumSubtitle__family,"Open Sans","Helvetica Neue",helvetica,arial,sans-serif);font-size:var(--MdsCommerceTile__mediumSubtitle__size,.875rem);line-height:var(--MdsCommerceTile__mediumSubtitle__size_line_height,1.25rem);font-weight:var(--MdsCommerceTile__mediumSubtitle__weight,400)}:host .commerce-tile-content--medium-microcopy{line-height:var(--MdsCommerceTile__mediumMicrocopy__size_line_height,1.25rem)}:host .commerce-tile-content--medium-microcopy span{font-family:var(--MdsCommerceTile__mediumMicrocopy__family,"Open Sans","Helvetica Neue",helvetica,arial,sans-serif);font-size:var(--MdsCommerceTile__mediumMicrocopy__size,.875rem);line-height:inherit;font-weight:var(--MdsCommerceTile__mediumMicrocopy__weight,400)}:host .commerce-tile-content--large-title .titleText{font-family:var(--MdsCommerceTile__largeTitle__family,"Open Sans","Helvetica Neue",helvetica,arial,sans-serif);font-size:var(--MdsCommerceTile__largeTitle__size,1.5rem);line-height:var(--MdsCommerceTile__largeTitle__size_line_height,2rem);font-weight:var(--MdsCommerceTile__largeTitle__weight,600)}:host .commerce-tile-content--large-subtitle p{font-family:var(--MdsCommerceTile__largeSubtitle__family,"Open Sans","Helvetica Neue",helvetica,arial,sans-serif);font-size:var(--MdsCommerceTile__largeSubtitle__size,1rem);line-height:var(--MdsCommerceTile__largeSubtitle__size_line_height,1.5rem);font-weight:var(--MdsCommerceTile__largeSubtitle__weight,400)}:host .commerce-tile-content--large-microcopy span{font-family:var(--MdsCommerceTile__largeMicrocopy__family,"Open Sans","Helvetica Neue",helvetica,arial,sans-serif);font-size:var(--MdsCommerceTile__largeMicrocopy__size,1rem);line-height:var(--MdsCommerceTile__largeMicrocopy__size_line_height,1.5rem);font-weight:var(--MdsCommerceTile__largeMicrocopy__weight,400)}:host .commerce-tile-content--inverse{display:flex;align-items:flex-end}:host .commerce-tile-content--inverse .commerce-tile-content--wrapper{width:100%;position:relative}:host .commerce-tile-content--inverse .commerce-tile-content--logo-wrapper{position:relative;z-index:4}:host .commerce-tile-content--inverse .titleText{color:var(--MdsCommerceTile__inverseTitleColor,#fff)}:host .commerce-tile-content--inverse p{color:var(--MdsCommerceTile__inverseSubtitleColor,#fff)}:host .commerce-tile-content--inverse span{color:var(--MdsCommerceTile__inverseMicrocopyColor,hsla(0,0%,100%,.75))}:host .commerce-tile-content--inverse-with_logo-no_height{padding-top:var(--MdsCommerceTile__tileWithoutImageTopPadding,24px)}:host .commerce-tile-content--regular-with_logo{padding-top:0}:host .commerce-tile-content--regular-with--no_logo-tag-top{padding-top:var(--MdsCommerceTile__contentContainerWithoutLogoTopPadding,8px)}:host .commerce-tile-content--gradient_fill{height:calc(100% + .75rem);position:absolute;width:calc(100% + var(--MdsCommerceTile__contentContainerRightPadding, default-brand-get(mds-commerce-tile-content-container-right-padding)) + var(--MdsCommerceTile__contentContainerLeftPadding, default-brand-get(mds-commerce-tile-content-container-left-padding)));background-color:var(--MdsCommerceTile__overlayGradient0Color,rgba(0,0,0,.65));z-index:1;transform:translate(var(---MdsCommerceTile__contentContainerLeftPadding,-16px),var(---MdsCommerceTile__logoContainerPaddingCondensedBottom,-4px))}:host .commerce-tile-content--gradient_fill-condensed_no-slot{transform:translate(var(---MdsCommerceTile__contentContainerLeftPadding,-16px),var(--MdsCommerceTile__logoContainerPaddingCondensedBottom,4px))}:host .commerce-tile-content--gradient_fill-relaxed{height:calc(100% + 1rem);transform:translate(var(---MdsCommerceTile__contentContainerLeftPadding,-16px),var(---MdsCommerceTile__logoContainerPaddingRelaxedBottom,-8px))}:host .commerce-tile-content--gradient_fill-relaxed_no-slot{transform:translate(var(---MdsCommerceTile__contentContainerLeftPadding,-16px))}:host .commerce-tile-content--gradient_fixed{height:calc(100% + .75rem);position:absolute;width:calc(100% + var(--MdsCommerceTile__contentContainerRightPadding, default-brand-get(mds-commerce-tile-content-container-right-padding)) + var(--MdsCommerceTile__contentContainerLeftPadding, default-brand-get(mds-commerce-tile-content-container-left-padding)));background-color:var(--MdsCommerceTile__overlayGradient0Color,rgba(0,0,0,.65));z-index:1;transform:translateX(var(---MdsCommerceTile__contentContainerLeftPadding,-16px))}:host .commerce-tile-content--gradient_fixed-condensed{height:calc(100% + 1rem)}:host .commerce-tile-content--gradient_fixed-condensed_no-slot{transform:translate(var(---MdsCommerceTile__contentContainerLeftPadding,-16px))}:host .commerce-tile-content--gradient_fixed-relaxed{height:calc(100% + 1rem)}:host .commerce-tile-content--gradient_no-img_height{background-color:transparent}:host .commerce-tile-content_prominent--small-title .titleText{font-size:var(--MdsCommerceTile__smallSubtitle__size,.75rem);line-height:var(--MdsCommerceTile__smallSubtitle__size_line_height,1rem);font-weight:var(--MdsCommerceTile__smallSubtitle__weight,600)}:host .commerce-tile-content_prominent--small-subtitle p{font-size:var(--MdsCommerceTile__smallTitle__size,1rem);line-height:var(--MdsCommerceTile__smallTitle__size_line_height,1.5rem);font-weight:var(--MdsCommerceTile__smallTitle__weight,600)}:host .commerce-tile-content_prominent--medium-title .titleText{font-size:var(--MdsCommerceTile__mediumSubtitle__size,.875rem);line-height:var(--MdsCommerceTile__mediumSubtitle__size_line_height,1.25rem);font-weight:var(--MdsCommerceTile__mediumSubtitle__weight,400)}:host .commerce-tile-content_prominent--medium-subtitle p{font-size:var(--MdsCommerceTile__mediumTitle__size,1.125rem);line-height:var(--MdsCommerceTile__mediumTitle__size_line_height,1.75rem);font-weight:var(--MdsCommerceTile__mediumTitle__weight,600)}:host .commerce-tile-content_prominent--large-title .titleText{font-size:var(--MdsCommerceTile__largeSubtitle__size,1rem);line-height:var(--MdsCommerceTile__largeSubtitle__size_line_height,1.5rem);font-weight:var(--MdsCommerceTile__largeSubtitle__weight,400)}:host .commerce-tile-content_prominent--large-subtitle p{font-size:var(--MdsCommerceTile__largeTitle__size,1.5rem);line-height:var(--MdsCommerceTile__largeTitle__size_line_height,2rem);font-weight:var(--MdsCommerceTile__largeTitle__weight,600)}:host .commerce-tile__image{background-size:cover;background-repeat:no-repeat}:host .commerce-tile__image_inverse_alignment--vertical-top,:host .commerce-tile__image_regular_alignment--vertical-top{background-position-y:top}:host .commerce-tile__image_inverse_alignment--vertical-center,:host .commerce-tile__image_regular_alignment--vertical-center{background-position-y:center}:host .commerce-tile__image_inverse_alignment--vertical-bottom,:host .commerce-tile__image_regular_alignment--vertical-bottom{background-position-y:bottom}:host .commerce-tile__image_inverse_alignment--horizontal-left,:host .commerce-tile__image_regular_alignment--horizontal-left{background-position-x:left}:host .commerce-tile__image_inverse_alignment--horizontal-center,:host .commerce-tile__image_regular_alignment--horizontal-center{background-position-x:center}:host .commerce-tile__image_inverse_alignment--horizontal-right,:host .commerce-tile__image_regular_alignment--horizontal-right{background-position-x:right}:host .commerce-tile__image_height_no-img{background:linear-gradient(var(--MdsCommerceTile__emptyStateGradient0Color,#e2e4e5),var(--MdsCommerceTile__emptyStateGradient1Color,transparent))}:host .commerce-tile--gradient_fill,:host .commerce-tile--gradient_fixed{background:linear-gradient(var(--MdsCommerceTile__overlayGradient1Color,transparent),var(--MdsCommerceTile__overlayGradient0Color,rgba(0,0,0,.65)))}:host .commerce-tile--gradient_fill-no--img,:host .commerce-tile--gradient_fixed-no--img{background-color:var(--MdsCommerceTile__overlayGradient0Color,rgba(0,0,0,.65))}:host .commerce-tile--gradient_fill-no--imgHeight,:host .commerce-tile--gradient_fixed-no--imgHeight{background:transparent}:host .commerce-tile--gradient-fill--no_img-height,:host .commerce-tile--gradient-fixed--no_img-height{background-color:var(--MdsCommerceTile__overlayGradient0Color,rgba(0,0,0,.65))}:host .commerce-tile--gradient_fill{height:100%;width:100%;position:absolute;top:0;left:0}:host .commerce-tile--gradient_fixed{position:absolute;width:calc(100% + var(--MdsCommerceTile__contentContainerRightPadding, default-brand-get(mds-commerce-tile-content-container-right-padding)) + var(--MdsCommerceTile__contentContainerLeftPadding, default-brand-get(mds-commerce-tile-content-container-left-padding)));height:2rem;margin-left:var(---MdsCommerceTile__contentContainerLeftPadding,-16px);margin-right:var(---MdsCommerceTile__contentContainerRightPadding,-16px);top:0;z-index:1}:host .commerce-tile--gradient_fixed--with_no-logo{transform:translateY(-2rem)}:host .commerce-tile--gradient_fixed--with_logo{transform:translateY(var(--MdsCommerceTile__contentContainerWithLogoTopPadding,16px))}:host .commerce-tile--gradient_fixed--with-height_no-img{background:var(--MdsCommerceTile__overlayGradient0Color,rgba(0,0,0,.65))}:host .commerce-tile--gradient_fixed--with-no_height-img{background:transparent}:host .commerce-tile--slot{margin-left:calc(var(--MdsCommerceTile__contentContainerLeftPadding, 16px)*-1);margin-right:calc(var(--MdsCommerceTile__contentContainerRightPadding, 16px)*-1)}:host .commerce-tile--slot,:host .commerce-tile--slot_inverse{padding-top:var(--MdsCommerceTile__slotContainerTopPaddingPadding,8px)}:host .commerce-tile .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .commerce-tile-logo{width:var(--MdsCommerceTile__logoMaxWidth,88px);height:var(--MdsCommerceTile__logoMaxHeight,48px);position:relative}:host .commerce-tile-logo_spacing--condensed-regular{margin-top:-2rem;margin-bottom:var(--MdsCommerceTile__logoContainerPaddingCondensedBottom,4px);margin-left:var(--MdsCommerceTile__logoContainerPaddingCondensedLeft,8px)}:host .commerce-tile-logo_spacing--condensed-regular_no-img{margin-left:var(--MdsCommerceTile__logoContainerPaddingCondensedLeftNoImage,16px);margin-top:var(--MdsCommerceTile__tileWithoutImageTopPadding,24px)}:host .commerce-tile-logo_spacing--condensed-inverse{margin-top:0;margin-left:var(---MdsCommerceTile__logoContainerPaddingCondensedLeft,-8px)}:host .commerce-tile-logo_spacing--condensed-inverse_no_img{margin-left:0;margin-top:var(--MdsCommerceTile__tileWithoutImageTopPadding,24px)}:host .commerce-tile-logo_spacing--relaxed-regular{margin-top:-2rem;margin-bottom:var(--MdsCommerceTile__logoContainerPaddingRelaxedBottom,8px);margin-left:var(--MdsCommerceTile__logoContainerPaddingRelaxedLeft,16px)}:host .commerce-tile-logo_spacing--relaxed-regular_no-img{margin-left:var(--MdsCommerceTile__logoContainerPaddingCondensedLeftNoImage,);margin-top:var(--MdsCommerceTile__tileWithoutImageTopPadding,24px)}:host .commerce-tile-logo_spacing--relaxed-inverse{margin-top:0;margin-left:0}:host .commerce-tile-logo_spacing--relaxed-inverse_no_img{margin-top:var(--MdsCommerceTile__tileWithoutImageTopPadding,24px)}:host .commerce-tile-logo img{max-width:100%;max-height:100%;position:absolute;left:0;bottom:0}:host .commerce-tile--with_tag--middle .commerce-tile__container,:host .commerce-tile--with_tag--middle .commerce-tile__wrapper>div:last-of-type,:host .commerce-tile--with_tag--top .commerce-tile__container{position:relative}:host .commerce-tile--tag{position:absolute;line-height:1rem}:host .commerce-tile--tag_placement--middle{right:var(--MdsCommerceTile__tagRightPadding,);top:-.5rem;padding-bottom:var(--MdsCommerceTile__tagBottomPadding,4px)}:host .commerce-tile--tag_placement--middle-set,:host .commerce-tile--tag_placement--top{top:var(--MdsCommerceTile__tagTopPadding,4px)}:host .commerce-tile--tag_placement--top{right:var(--MdsCommerceTile__tagRightPadding,)}:host .commerce-tile--tag_placement--top-set{top:var(--MdsCommerceTile__tagTopPadding,4px)}', "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/comparison-table/mds-comparison-table.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host .comparison-table{display:table;font-family:Open Sans;table-layout:fixed;width:100%}@media screen and (min-width:767px){:host .comparison-table{table-layout:auto}}@media screen and (max-width:767px){:host .comparison-table__row-header{grid-column:span 3}}:host .comparison-table__row-twoColumn{display:grid;grid-template-columns:var(--MdsComparisonTable__rowHeaderWidth,40%) repeat(2,calc(50% - var(--MdsComparisonTable__rowHeaderWidth, 40%)/2))}@media screen and (max-width:767px){:host .comparison-table__row-twoColumn{display:grid;grid-template-columns:repeat(2,1fr)}}:host .comparison-table__row-threeColumn{display:grid;grid-template-columns:var(--MdsComparisonTable__rowHeaderWidth,40%) repeat(3,calc(33.33333% - var(--MdsComparisonTable__rowHeaderWidth, 40%)/3))}@media screen and (max-width:767px){:host .comparison-table__row-threeColumn{display:grid;grid-template-columns:repeat(3,1fr)}}:host .comparison-table__cell{display:table-cell;vertical-align:middle;border-right-width:var(--MdsComparisonTable__columnBorderBottomWidth,1px);border-right-style:solid}:host .comparison-table__cell-value{font-size:var(--MdsComparisonTable__rowValueTextSize,.875rem);line-height:var(--MdsComparisonTable__rowValueTextLineHeight,1.25rem);font-weight:var(--MdsComparisonTable__rowValueTextWeight,400);text-align:center;padding:var(--MdsComparisonTable__columnVerticalPadding,16px) var(--MdsComparisonTable-_columnRowHeaderHorizontal-small__padding,16px)}:host .comparison-table__cell-caption{font-size:var(--MdsComparisonTable__captionTextSize,1.125rem);line-height:var(--MdsComparisonTable__captionTextLineHeight,1.75rem);font-weight:var(--MdsComparisonTable__captionTextWeight,400);padding:var(--MdsComparisonTable_series__captionTopPadding,32px) var(--MdsComparisonTable-_columnRowHeaderHorizontal-large__padding,24px) var(--MdsComparisonTable_series__captionBottomPadding,16px)}@media screen and (max-width:991px){:host .comparison-table__cell-caption{padding:var(--MdsComparisonTable_series__captionTopPadding,32px) var(--MdsComparisonTable-_columnRowHeaderHorizontal-small__padding,16px) var(--MdsComparisonTable_series__captionBottomPadding,16px)}}:host .comparison-table__cell-header{font-size:var(--MdsComparisonTable__rowHeaderTextSize,1rem);line-height:var(--MdsComparisonTable__rowHeaderTextLineHeight,1.5rem);font-weight:var(--MdsComparisonTable__rowHeaderTextWeight,600);padding:var(--MdsComparisonTable__columnRowHeaderVerticalPadding,16px) var(--MdsComparisonTable-_columnRowHeaderHorizontal-large__padding,24px)}@media screen and (max-width:991px){:host .comparison-table__cell-header{padding:var(--MdsComparisonTable__columnHeaderVerticalPadding,16px) var(--MdsComparisonTable-_columnRowHeaderHorizontal-small__padding,16px)}}:host .comparison-table__cell-subtopic{font-size:var(--MdsComparisonTable__subtopicRowHeaderTextSize,1rem);line-height:var(--MdsComparisonTable__subtopicRowHeaderTextLineHeight,1.5rem);font-weight:var(--MdsComparisonTable__subtopicRowHeaderTextWeight,400);padding:var(--MdsComparisonTable_series__subtopicColumnVerticalPadding,16px) var(--MdsComparisonTable_series-_subtopic-large__trailingPadding,24px) var(--MdsComparisonTable_series__subtopicColumnVerticalPadding,16px) var(--MdsComparisonTable_series__subtopicLeadingPadding,48px)}@media screen and (max-width:768px){:host .comparison-table__cell-subtopic{padding:var(--MdsComparisonTable_series__subtopicColumnVerticalPadding,16px) var(--MdsComparisonTable_series__subtopicHorizontalPadding,16px)}}@media screen and (min-width:768px) and (max-width:991px){:host .comparison-table__cell-subtopic{padding:var(--MdsComparisonTable_series__subtopicColumnVerticalPadding,16px) var(--MdsComparisonTable_series__subtopicTrailingPadding,16px) var(--MdsComparisonTable_series__subtopicColumnVerticalPadding,16px) var(--MdsComparisonTable_series-_subtopic-small__leadingPadding,32px)}}:host .comparison-table__cell:last-child{border-right:none}@media screen and (max-width:767px){:host .comparison-table__cell:first-child{border-right:none}}:host .comparison-table__column-header{font-size:var(--MdsComparisonTable__columnHeaderTextSize,1.125rem);line-height:var(--MdsComparisonTable__columnHeaderTextLineHeight,24px);font-weight:var(--MdsComparisonTable__columnHeaderTextWeight,600);text-align:center;padding:var(--MdsComparisonTable__columnHeaderVerticalPadding,16px) var(--MdsComparisonTable__columnHeaderHorizontalPadding,16px)}:host .comparison-table__icon{display:inline-flex;vertical-align:middle;align-items:center}:host .comparison-table__empty-table{font-size:var(--MdsComparisonTable__nullStateTextSize,1.5rem);line-height:var(--MdsComparisonTable__nullStateTextLineHeight,2rem);font-weight:var(--MdsComparisonTable__nullStateTextWeight,300);text-align:center}:host .comparison-table__sticky{position:sticky;top:0;box-shadow:var(--MdsComparisonTable__dropShadowVerticalOffset,0) var(--MdsComparisonTable__dropShadowVerticalOffset,2px) var(--MdsComparisonTable__dropShadowBlurRadius,4px) var(--MdsComparisonTable__dropShadowSpreadRadius,0) var(--MdsComparisonTable__dropShadowColor,rgba(0,0,0,.4))}:host .comparison-table .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}@media screen and (max-width:767px){:host .comparison-table__xs-hidden{display:none}}:host .comparison-table__hidden{display:none}.comparison-table__cell{background-color:var(--MdsComparisonTable__backgroundRowColor,#fff);border-right-color:var(--MdsComparisonTable__columnBorderBottomColor,#e2e4e5)}.comparison-table__cell-shaded{background-color:var(--MdsComparisonTable__backgroundAlternateRowColor,#f5f7f8)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/data-table-action-bar/mds-data-table-action-bar.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .action-bar{height:100%;display:flex;padding-bottom:var(--MdsDataTableActionBar__filteringPaddingBottom,8px)}:host .action-bar__filter-container{min-height:100%;flex-grow:1;padding-left:var(--MdsDataTableActionBar__filteringPaddingLeading,8px);display:flex;flex-wrap:wrap;align-items:center}:host .action-bar__utility-container{display:flex;align-items:flex-start;max-height:var(--MdsDataTableActionBar__actionBarHeight,60px);padding-top:var(--MdsDataTableActionBar__filteringPaddingBottom,8px)}:host .action-bar__utility,:host .action-bar__utility-slot::slotted(*){padding-right:var(--MdsDataTableActionBar__utilityPaddingTrailing,8px)}:host .action-bar__filter,:host .action-bar__filter-slot::slotted(*){padding-right:var(--MdsDataTableActionBar__filteringPaddingTrailing,24px);padding-top:var(--MdsDataTableActionBar__filteringPaddingTop,8px)}:host .action-bar .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .action-bar{border-top:var(--MdsDataTableActionBar__borderHeight,1px) solid var(--MdsDataTableActionBar__borderColor,#c1c3c3);border-bottom:var(--MdsDataTableActionBar__borderHeight,1px) solid var(--MdsDataTableActionBar__borderColor,#c1c3c3)}:host .action-bar__filter-slot::slotted(*){color:var(--MdsDataTableActionBar__filteringFeedbackLabelTextColor,#101820)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/data-table-for-accounts/mds-data-table-for-accounts.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif;font-size:var(--AbstractMdsDataTable__rowHeaderTextSize,.875rem);line-height:1.25rem}:host .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .data-table-for-accounts__stacked-container{overflow:auto}:host .data-table-for-accounts__stacked-container .data-table-for-accounts{padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px)}:host .data-table-for-accounts{display:table;width:100%;position:relative;border-spacing:0}:host .data-table-for-accounts__row--relaxed .data-table-for-accounts__row-header:not(.data-table-for-accounts__row-header--select){padding-top:var(--AbstractMdsDataTable-_mode-relaxed__verticalPadding,12px);padding-bottom:var(--AbstractMdsDataTable-_mode-relaxed__verticalPadding,12px)}:host .data-table-for-accounts__row--compact .data-table-for-accounts__row-header:not(.data-table-for-accounts__row-header--select){padding-top:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px);padding-bottom:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-accounts__row--solid:not(.data-table-for-accounts__row--footer) .data-table-for-accounts__row-header{border-bottom:var(--AbstractMdsDataTable-_rowStyle-solid__width,1px) var(--AbstractMdsDataTable-_rowStyle-solid__style,solid) var(--AbstractMdsDataTable-_rowStyle-solid__color,#c1c3c3)}:host .data-table-for-accounts__row--dashed:not(.data-table-for-accounts__row--footer) .data-table-for-accounts__row-header{border-bottom:var(--AbstractMdsDataTable-_rowStyle-dashed__width,1px) var(--AbstractMdsDataTable-_rowStyle-dashed__style,dashed) var(--AbstractMdsDataTable-_rowStyle-dashed__color,#c1c3c3)}:host .data-table-for-accounts__row-header--footer{border-top:var(--AbstractMdsDataTable__columnHeaderBorderWidth,2px) solid var(--AbstractMdsDataTable__columnHeaderBorderColor,#c1c3c3)}:host .data-table-for-accounts__row-header{text-align:left;font-weight:600;display:table-cell;vertical-align:top}:host .data-table-for-accounts__column-header{font-weight:600;display:table-cell;vertical-align:bottom;text-align:right;padding:0;border-bottom:var(--AbstractMdsDataTable__columnHeaderBorderWidth,2px) solid var(--AbstractMdsDataTable__columnHeaderBorderColor,#c1c3c3)}:host .data-table-for-accounts__column-header--left,:host .data-table-for-accounts__column-header:first-child{text-align:left}:host .data-table-for-accounts__column-header--value{padding:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px) var(--AbstractMdsDataTable__columnSidePadding,8px);box-sizing:border-box}:host .data-table-for-accounts__column-header--sparkline{text-align:left}:host .data-table-for-accounts__column-header--sparkline .data-table-for-accounts__column-header--value{padding:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-accounts__column-header-action{padding-left:0}:host .data-table-for-accounts__column-header--sortable{position:relative;padding:0}:host .data-table-for-accounts__column-header-sort-button{background-color:transparent;position:absolute;top:0;margin:0;bottom:0;right:0;left:0;border:0;padding:0;width:100%}:host .data-table-for-accounts__column-header-sort-button::-moz-focus-inner{border:0}:host .data-table-for-accounts__column-header-sort-button:focus{outline:.0625rem dashed #717171}:host .data-table-for-accounts__column-header-sort-text-container{font-weight:inherit;text-align:inherit;display:inline-block;pointer-events:none;position:relative;z-index:1;width:100%;box-sizing:border-box;padding:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px) var(--AbstractMdsDataTable__columnSidePadding,8px)}:host .data-table-for-accounts__column-header-sort-text{max-width:calc(100% - 1rem)}:host .data-table-for-accounts__column-header-sort-icon{display:inline-flex;pointer-events:none;vertical-align:middle;padding-bottom:.125rem;padding-left:.125rem}:host .data-table-for-accounts__column-header-sort-icon svg{height:1em;width:1em;fill:var(--AbstractMdsDataTable__sortIconColor,#565a5d)}:host .data-table-for-accounts__row-header-container{display:flex}:host .data-table-for-accounts__row--activated:not(.data-table-for-accounts__row--footer):hover,:host .data-table-for-accounts__row--highlight{background-color:var(--AbstractMdsDataTable__rowHighlightedBackgroundColor,#eceff1)}:host .data-table-for-accounts__row--relaxed .data-table-for-accounts__row-value{padding-top:var(--AbstractMdsDataTable-_mode-relaxed__verticalPadding,12px);padding-bottom:var(--AbstractMdsDataTable-_mode-relaxed__verticalPadding,12px)}:host .data-table-for-accounts__row--compact .data-table-for-accounts__inline-caption-row,:host .data-table-for-accounts__row--compact .data-table-for-accounts__row-value,:host .data-table-for-accounts__row--relaxed .data-table-for-accounts__inline-caption-row{padding-top:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px);padding-bottom:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-accounts__row--compact .data-table-for-accounts__row-action{padding-top:0}:host .data-table-for-accounts__row--solid:not(.data-table-for-accounts__row--footer) .data-table-for-accounts__inline-caption-row,:host .data-table-for-accounts__row--solid:not(.data-table-for-accounts__row--footer) .data-table-for-accounts__row-action,:host .data-table-for-accounts__row--solid:not(.data-table-for-accounts__row--footer) .data-table-for-accounts__row-value{border-bottom:var(--AbstractMdsDataTable-_rowStyle-solid__width,1px) var(--AbstractMdsDataTable-_rowStyle-solid__style,solid) var(--AbstractMdsDataTable-_rowStyle-solid__color,#c1c3c3)}:host .data-table-for-accounts__row--dashed:not(.data-table-for-accounts__row--footer) .data-table-for-accounts__inline-caption-row,:host .data-table-for-accounts__row--dashed:not(.data-table-for-accounts__row--footer) .data-table-for-accounts__row-action,:host .data-table-for-accounts__row--dashed:not(.data-table-for-accounts__row--footer) .data-table-for-accounts__row-value{border-bottom:var(--AbstractMdsDataTable-_rowStyle-dashed__width,1px) var(--AbstractMdsDataTable-_rowStyle-dashed__style,dashed) var(--AbstractMdsDataTable-_rowStyle-dashed__color,#c1c3c3)}:host .data-table-for-accounts__row--inline-caption-row:not(.data-table-for-accounts__row--footer) .data-table-for-accounts__inline-caption-row,:host .data-table-for-accounts__row--inline-caption-row:not(.data-table-for-accounts__row--footer) .data-table-for-accounts__row-action,:host .data-table-for-accounts__row--inline-caption-row:not(.data-table-for-accounts__row--footer) .data-table-for-accounts__row-header,:host .data-table-for-accounts__row--inline-caption-row:not(.data-table-for-accounts__row--footer) .data-table-for-accounts__row-value{border-bottom:var(--AbstractMdsDataTable__columnHeaderBorderWidth,2px) solid var(--AbstractMdsDataTable__columnHeaderBorderColor,#c1c3c3)}:host .data-table-for-accounts__row-value--footer,:host .data-table-for-accounts__row-value--footer-cell{border-top:var(--AbstractMdsDataTable__columnHeaderBorderWidth,2px) solid var(--AbstractMdsDataTable__columnHeaderBorderColor,#c1c3c3)}:host .data-table-for-accounts__row-action,:host .data-table-for-accounts__row-value{padding:0;font-weight:400;display:table-cell;vertical-align:top;border-bottom:var(--AbstractMdsDataTable-_rowStyle-solid__width,1px) var(--AbstractMdsDataTable-_rowStyle-solid__style,solid) transparent;text-align:right}:host .data-table-for-accounts__row-action--text,:host .data-table-for-accounts__row-value--text{box-sizing:border-box;padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px);padding-right:var(--AbstractMdsDataTable__columnSidePadding,8px);word-break:break-word}:host .data-table-for-accounts__row-action:first-child,:host .data-table-for-accounts__row-value:first-child{text-align:left}:host .data-table-for-accounts__row-action--dashed,:host .data-table-for-accounts__row-value--dashed{border-bottom:var(--AbstractMdsDataTable-_rowStyle-dashed__width,1px) var(--AbstractMdsDataTable-_rowStyle-dashed__style,dashed) var(--AbstractMdsDataTable-_rowStyle-dashed__color,#c1c3c3)}:host .data-table-for-accounts__row-action--stacked{padding-top:var(--AbstractMdsDataTable__stackedDataTableVerticalPadding,8px)}:host .data-table-for-accounts__row-value--footer{font-weight:600;word-break:break-word;border-bottom:0;padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px);padding-right:var(--AbstractMdsDataTable__columnSidePadding,8px)}:host .data-table-for-accounts__grouping-for-secondary-tertiary-text{padding:0;margin:0;list-style-type:none}:host .data-table-for-accounts__grouping-for-secondary-tertiary-text--with-padding{padding-left:1.875rem}:host .data-table-for-accounts__alert-message{display:block}:host .data-table-for-accounts__secondary-text{color:var(--AbstractMdsDataTable__secondaryValueTextColor,#101820);list-style:none;padding-left:0;font-weight:var(--AbstractMdsDataTable__secondaryValueTextWeight,400);font-size:var(--AbstractMdsDataTable__secondaryValueTextSize,.875rem);line-height:var(--AbstractMdsDataTable__secondaryValueTextLineHeight,1.25rem)}:host .data-table-for-accounts__tertiary-text{color:var(--AbstractMdsDataTable__tertiaryValueTextColor,#565a5d);list-style:none;padding-left:0;font-weight:var(--AbstractMdsDataTable__tertiaryValueTextWeight,400);font-size:var(--AbstractMdsDataTable__tertiaryValueTextSize,.875rem);line-height:var(--AbstractMdsDataTable__tertiaryValueTextLineHeight,1.25rem)}:host .data-table-for-accounts__tag{margin-left:var(--AbstractMdsDataTable__tagLeadingMargin,8px)}:host .data-table-for-accounts__multi-level-sorting{display:none;position:absolute;right:0;margin-top:var(--AbstractMdsDataTable__multiLevelSortingMenuTopPadding,4px);box-shadow:var(--AbstractMdsDataTable__multiLevelSortingMenuBoxShadowHorizontalOffset,0),var(--AbstractMdsDataTable__multiLevelSortingMenuBoxShadowVerticalOffset,2px),var(--AbstractMdsDataTable__multiLevelSortingMenuBoxShadowBlurRadius,4px),var(--AbstractMdsDataTable__multiLevelSortingMenuBoxShadowSpreadRadius,0),var(--AbstractMdsDataTable__multiLevelSortingMenuBoxShadowColor,rgba(0,0,0,.4))}:host .data-table-for-accounts__multi-level-sorting--displayed{display:block!important;z-index:999}:host .data-table-for-accounts__multi-level-sorting-group{margin:0;padding:0}:host .data-table-for-accounts__multi-level-sorting-item__header{text-align:left;font-size:var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderTextSize,.75rem);line-height:var(----AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderLineHeight,1rem);font-weight:var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderTextWeight,600);padding:var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderTopPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderTrailingPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderBottomPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderLeadingPadding,8px);color:var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderTextColor,#565a5d);background-color:var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderBackgroundColor,#f5f7f8)}:host .data-table-for-accounts__multi-level-sorting-menu-item{list-style:none;position:relative}:host .data-table-for-accounts__multi-level-sorting-menu-item--selected .data-table-for-accounts__multi-level-sorting-menu-item__bar{position:absolute;height:var(--AbstractMdsDataTable_multiLevelSortingMenuItem-_selected-true__multiLevelSortingMenuItemBarHeight,100%);width:var(--AbstractMdsDataTable_multiLevelSortingMenuItem-_selected-true__multiLevelSortingMenuItemBarWidth,4px)}:host .data-table-for-accounts__multi-level-sorting-menu-item--selected .data-table-for-accounts__multi-level-sorting-menu-item__item{font-weight:var(--AbstractMdsDataTable_multiLevelSortingMenuItem-_selected-true__multiLevelSortingMenuItemLabelTextWeight,600)}:host .data-table-for-accounts__multi-level-sorting-menu-item__item{border:0;text-align:left;margin:0;width:100%;color:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__labelTextColor,#101820);font-size:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__labelTextSize,.875rem);line-height:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__labelTextLineHeight,1.25rem);font-weight:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__labelTextWeight,400);background-color:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemBackgroundColor,#fff);padding:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemTopPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemTrailingPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemBottomPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemLeadingPadding,8px)}:host .data-table-for-accounts__multi-level-sorting-menu-item__item:hover{background-color:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemBackgroundColor--hovered,#f5f7f8)}:host .data-table-for-accounts__multi-level-sorting-menu-item__item:focus{z-index:1}:host .data-table-for-accounts__multi-level-sorting-menu-item__item:focus::-moz-focus-inner{border:0}:host .data-table-for-accounts__multi-level-sorting-menu-item__item:focus:focus{outline:.0625rem dashed #717171;outline-offset:-.0625rem}:host .data-table-for-accounts__row-value--left{text-align:left}:host .data-table-for-accounts__row-value--right{text-align:right}:host .data-table-for-accounts__secondary-tertiary-value-block{display:block}:host .data-table-for-accounts__secondary-value{display:inline-block}:host .data-table-for-accounts__secondary-value,:host .data-table-for-accounts__tertiary-value{color:var(--MdsDataTableForTransactions__rightAlignedColumnSecondaryTertiaryTextColor,#565a5d);padding-top:var(--MdsDataTableForTransactions__rightAlignedColumnSecondaryTertiaryInterValueVerticalPadding,2px);padding-left:var(--MdsDataTableForTransactions__rightAlignedColumnSecondaryTertiaryInterValueHorizontalPadding,4px)}:host .data-table-for-accounts__row-value--gain,:host .data-table-for-accounts__secondary-value--gain,:host .data-table-for-accounts__tertiary-value--gain{color:var(--AbstractMdsDataTable__gainTextColor,#398100)}:host .data-table-for-accounts__row-value--loss,:host .data-table-for-accounts__secondary-value--loss,:host .data-table-for-accounts__tertiary-value--loss{color:var(--AbstractMdsDataTable__lossTextColor,#b80009)}:host .data-table-for-accounts__caption{text-align:left}:host .data-table-for-accounts__caption--hidden{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .data-table-for-accounts__caption--block{display:table-caption;font-weight:300;font-size:var(--AbstractMdsDataTable__captionTextSize,1.125rem);margin-bottom:var(--AbstractMdsDataTable__captionBottomMargin,16px);line-height:var(--AbstractMdsDataTable__captionTextLineHeight,1.75rem)}:host .data-table-for-accounts__caption--is-safari{position:absolute;top:0}:host .data-table-for-accounts__caption--is-ios{display:flex}:host .data-table-for-accounts__caption--stacked{font-weight:600;font-size:var(--AbstractMdsDataTable-_stacked-true__captionTextSize,.875rem);padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px);margin-top:var(--AbstractMdsDataTable-_stacked-true__captionTopMargin,8px);margin-bottom:var(--AbstractMdsDataTable-_stacked-true__captionBottomMargin,8px);line-height:var(--AbstractMdsDataTable-_stacked-true__captionTextLineHeight,1.25rem);white-space:pre-wrap}:host .data-table-for-accounts__caption--stacked-footer{margin-top:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px);margin-bottom:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-accounts__stacked-caption-heading{color:var(--AbstractMdsDataTable__stackedCaptionHeadingColor,#101820);font-size:var(--AbstractMdsDataTable__stackedCaptionHeadingTextSize,1.125rem);line-height:var(--AbstractMdsDataTable__stackedCaptionHeadingLineHeight,1.75rem);margin:0 0 var(--AbstractMdsDataTable__stackedCaptionHeadingBottomMargin,16px) 0}:host .data-table-for-accounts__stacked-caption-heading--with-reduced-spacing{margin-bottom:calc(var(--AbstractMdsDataTable__stackedCaptionHeadingBottomMargin, 16px) - var(--AbstractMdsDataTable-_stacked-true__captionTopMargin, 8px))}:host .data-table-for-accounts__stacked-caption-heading--hidden{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .data-table-for-accounts__stacked-caption-heading-container{display:flex}:host .data-table-for-accounts__stacked-caption-heading-container--with-checkbox{margin-top:var(--AbstractMdsDataTable-_stacked-true__captionCheckboxTopMargin,4px)}:host .data-table-for-accounts__empty-table{text-align:center;font-weight:400}:host .data-table-for-accounts__empty-table--inline{padding-top:var(--AbstractMdsDataTable__nullMessageVerticalPaddingWithHeader,40px);padding-bottom:var(--AbstractMdsDataTable__nullMessageVerticalPaddingWithHeader,40px)}:host .data-table-for-accounts__empty-table--block{padding-top:var(--AbstractMdsDataTable__nullMessageVerticalPaddingWithoutHeader,64px);padding-bottom:var(--AbstractMdsDataTable__nullMessageVerticalPaddingWithoutHeader,64px)}:host .data-table-for-accounts__column-header--action{padding-left:var(--AbstractMdsDataTable__actionColumnLeadingPadding,16px)}:host .data-table-for-accounts__column-header--action:last-child{text-align:left}:host .data-table-for-accounts__link{text-decoration:none;display:inline;color:var(--MdsLink__textColor,#005eb8)}:host .data-table-for-accounts__link:hover,:host .data-table-for-accounts__link:hover>span{color:var(--MdsLink__textColor--hovered,#004692)}:host .data-table-for-accounts__link:hover .data-table-for-accounts__link-icon svg,:host .data-table-for-accounts__link:hover>span .data-table-for-accounts__link-icon svg{fill:var(--MdsLink__iconColor--hovered,#002f6c)}:host .data-table-for-accounts__link:active{color:var(--MdsLink__textColor--pressed,#004692)}:host .data-table-for-accounts__link:active .data-table-for-accounts__link-icon svg{fill:var(--MdsLink__iconColor--pressed,#002f6c)}:host .data-table-for-accounts__link:focus:focus{outline:.0625rem dashed #717171}:host .data-table-for-accounts__link--trailing{white-space:nowrap}:host .data-table-for-accounts__link-icon{display:inline-flex;vertical-align:middle;padding-left:var(--MdsLink__trailingIconLeadingPadding,4px);position:relative;bottom:.0625rem}:host .data-table-for-accounts__link-icon svg{pointer-events:none;height:var(--AbstractMdsDataTable__linkNavigationIconSize,1rem);width:var(--AbstractMdsDataTable__linkNavigationIconSize,1rem);fill:var(--MdsLink__iconColor,#005eb8)}:host .data-table-for-accounts__link-icon--navigation{padding-left:var(--AbstractMdsDataTable__linkNavigationIconHorizontalPadding,14px);padding-right:var(--AbstractMdsDataTable__linkNavigationIconHorizontalPadding,14px);padding-top:var(--AbstractMdsDataTable__linkIconVerticalPadding,4px);bottom:.125rem}:host .data-table-for-accounts__link--navigation{display:flex;justify-content:center}:host .data-table-for-accounts__link--navigation-stacked{justify-content:flex-end}:host .data-table-for-accounts__link__accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .data-table-for-accounts--checkbox-no-caption{padding-top:calc(var(--MdsCheckbox__checkboxWidth, 20px) + var(--AbstractMdsDataTable-_mode-compact__verticalPadding, default-brand-get(abstract-mds-data-table-mode-compact-vertical-padding)))}:host .data-table-for-accounts__caption--checkbox-offset{padding-bottom:calc(var(--MdsCheckbox__checkboxWidth, 20px) + var(--AbstractMdsDataTable-_mode-compact__verticalPadding, default-brand-get(abstract-mds-data-table-mode-compact-vertical-padding)))}:host .data-table-for-accounts__column-header--checkbox{position:relative;padding-bottom:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px);padding-top:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-accounts__column-header--checkbox-only{position:relative;text-align:left}:host .data-table-for-accounts__column-header--checkbox-only .data-table-for-accounts__checkbox{display:inline-flex;width:var(--MdsCheckbox__checkboxWidth,20px)}:host .data-table-for-accounts__column-header--checkbox-only .data-table-for-accounts__checkbox-descriptor{left:var(--MdsCheckbox__checkboxWidth,20px)calc(var(--AbstractMdsDataTable__columnSidePadding, default-brand-get(abstract-mds-data-table-column-side-padding))*3);top:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-accounts__column-header--checkbox-only .data-table-for-accounts__checkbox-descriptor--no-top-checkbox{left:var(--AbstractMdsDataTable__noGroupCheckboxDynamicDescriptionLeadingMargin,0)}:host .data-table-for-accounts__column-header--no-top-checkbox-no-column-headers{padding-top:calc(var(--MdsCheckbox__checkboxWidth, 20px) + var(--AbstractMdsDataTable-_mode-compact__verticalPadding, default-brand-get(abstract-mds-data-table-mode-compact-vertical-padding)));padding-left:var(--AbstractMdsDataTable__noGroupCheckboxDynamicDescriptionLeadingMargin,0);width:-moz-max-content;width:max-content}:host .data-table-for-accounts__checkbox,:host .data-table-for-accounts__row-value--checkbox{width:var(--MdsCheckbox__checkboxWidth,20px)}:host .data-table-for-accounts__checkbox{height:var(--MdsCheckbox__checkboxWidth,20px);padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px);padding-right:var(--AbstractMdsDataTable__columnSidePadding,8px)}:host .data-table-for-accounts__checkbox--stacked{display:inline-block;margin-right:var(--AbstractMdsDataTable-_stacked-true__checkboxColumnCheckboxTrailingPadding,16px)}:host .data-table-for-accounts__checkbox-descriptor{color:var(--AbstractMdsDataTable__checkboxColumnDynamicDescriptionTextColor,#101820);position:absolute;top:calc(var(--MdsCheckbox__checkboxWidth, 20px)*-1 + var(--AbstractMdsDataTable-_mode-compact__verticalPadding, default-brand-get(abstract-mds-data-table-mode-compact-vertical-padding))*-1);left:0;white-space:nowrap;line-height:var(--AbstractMdsDataTable__checkboxColumnDynamicDescriptionTextLineHeight,1.25rem);font-size:var(--AbstractMdsDataTable__checkboxColumnDynamicDescriptionTextSize,.875rem)}:host .data-table-for-accounts__descriptor-term{font-weight:var(--AbstractMdsDataTable__checkboxColumnDynamicDescriptionKeyTextWeight,600);padding-right:var(--AbstractMdsDataTable__checkboxColumnDynamicDescriptionKeyTrailingPadding,4px)}:host .data-table-for-accounts__descriptor-value{font-weight:var(--AbstractMdsDataTable__checkboxColumnDynamicDescriptionValueTextWeight,400)}:host .data-table-for-accounts__top-stacked-checkbox-container{display:flex;padding:var(--AbstractMdsDataTable-_stacked-true__checkboxColumnDynamicDescriptionTopPadding,8px);border-bottom:var(--AbstractMdsDataTable-_stacked-true__checkboxColumnDynamicDescriptionBorderBottomWidth,2px) var(--AbstractMdsDataTable-_stacked-true__checkboxColumnDynamicDescriptionBorderBottomStyle,solid) var(--AbstractMdsDataTable-_stacked-true__checkboxColumnDynamicDescriptionBorderBottomColor)}:host .data-table-for-accounts__top-stacked-checkbox-container .data-table-for-accounts__checkbox{margin-right:var(--AbstractMdsDataTable-_stacked-true__checkboxColumnCheckboxTrailingPadding,16px)}:host .data-table-for-accounts__top-stacked-checkbox-container .data-table-for-accounts__checkbox-descriptor{white-space:normal;position:static}:host .data-table-for-accounts__top-stacked-checkbox-container-no-top-checkbox{padding-left:var(--AbstractMdsDataTable__noGroupCheckboxDynamicDescriptionLeadingMargin,0)}:host .data-table-for-accounts__row--compact:not(.data-table-for-accounts__row--footer) .data-table-for-accounts__row-value--menu-button{width:var(--MdsDataTableForAccounts-_mode-compact__menuButtonWidth,28px);padding:var(--MdsDataTableForAccounts-_mode-compact__menuButtonVerticalPadding,0) var(--MdsDataTableForAccounts-_mode-compact__menuButtonHorizontalPadding,8px)}:host .data-table-for-accounts__row--relaxed:not(.data-table-for-accounts__row--footer) .data-table-for-accounts__row-value--menu-button{width:var(--MdsDataTableForAccounts-_mode-relaxed__menuButtonWidth,36px);padding:var(--MdsDataTableForAccounts-_mode-relaxed__menuButtonVerticalPadding,4px) var(--MdsDataTableForAccounts-_mode-relaxed__menuButtonHorizontalPadding,8px)}:host .data-table-for-accounts__buttons-container{display:flex;flex-wrap:wrap;position:relative;padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px);padding-right:var(--AbstractMdsDataTable__columnSidePadding,8px);right:var(--AbstractMdsDataTable__buttonsHorizontalPadding,8px)}:host .data-table-for-accounts__buttons-container--icontext{right:calc(var(--AbstractMdsDataTable__buttonsHorizontalPadding, 8px) + .125rem)}:host .data-table-for-accounts__button{padding-left:var(--AbstractMdsDataTable__buttonsHorizontalPadding,8px);padding-right:var(--AbstractMdsDataTable__buttonsHorizontalPadding,8px)}:host .data-table-for-accounts__button--relaxed{padding-bottom:var(--AbstractMdsDataTable__buttonsColumnRelaxedVerticalPadding,8px);padding-top:var(--AbstractMdsDataTable__buttonsColumnRelaxedVerticalPadding,8px)}:host .data-table-for-accounts__buttons-container--stacked{justify-content:flex-end;flex-wrap:nowrap;right:0}:host .data-table-for-accounts__buttons-container--stacked .data-table-for-accounts__button:last-child{padding-right:0}:host .data-table-for-accounts__data-table-combo-button--relaxed{padding-top:var(--AbstractMdsDataTable__comboColumnRelaxedTopPadding,8px)}:host .data-table-for-accounts__row:not(.data-table-for-accounts__row--footer) .data-table-for-accounts__row-value--select{padding:var(--AbstractMdsDataTable__selectColumnCellPadding,0)}:host .data-table-for-accounts__column-header.data-table-for-accounts__column-header--select.data-table-for-accounts__column-header--left{text-align:left}:host .data-table-for-accounts__row-header--select{padding-top:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-accounts__row-header--select.data-table-for-accounts__row-header--compact{padding-bottom:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-accounts__row-header--select.data-table-for-accounts__row-header--compact .data-table-for-accounts__select-header{padding-top:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-accounts__row-header--select.data-table-for-accounts__row-header--relaxed{padding-bottom:var(--AbstractMdsDataTable-_mode-relaxed__verticalPadding,12px)}:host .data-table-for-accounts__row-header--select.data-table-for-accounts__row-header--relaxed .data-table-for-accounts__select-header{padding-top:var(--AbstractMdsDataTable-_mode-relaxed__verticalPadding,12px)}:host .data-table-for-accounts__row-header--select .data-table-for-accounts__select-container{display:flex}:host .data-table-for-accounts__row-header--select .data-table-for-accounts__select--stacked{width:100%}:host .data-table-for-accounts__row-header--select .data-table-for-accounts__select-header{padding-right:var(--AbstractMdsDataTable__stackedSelectTrailingPadding,16px)}:host .data-table-for-accounts__row-value--stacked{position:absolute}:host .data-table-for-accounts__column-header--sortable .data-table-for-accounts__column-header-sort-button:hover{background-color:var(--AbstractMdsDataTable__sortedColumnHeaderHoverBackgroundColor,rgba(0,94,184,.08))}:host .data-table-for-accounts__column-header--sortable .data-table-for-accounts__column-header-sort-button:active{background-color:var(--AbstractMdsDataTable__sortedColumnHeaderPressedBackgroundColor,rgba(0,94,184,.08))}:host .data-table-for-accounts__multi-level-sorting-menu-item--selected .data-table-for-accounts__multi-level-sorting-menu-item__bar{background-color:var(--AbstractMdsDataTable_MultiLevelSortingMenuItem-_selected-true__multiLevelSortingMenuItemBarColor,#005eb8)}:host .data-table-for-accounts__separator{border-bottom:var(--AbstractMdsDataTable-_rowStyle-solid__width,1px) var(--AbstractMdsDataTable-_rowStyle-solid__style,solid) var(--AbstractMdsDataTable-_rowStyle-solid__color,#c1c3c3)}:host .data-table-for-accounts__separator--footer{border-bottom:var(--AbstractMdsDataTable__columnHeaderBorderWidth,2px) var(--AbstractMdsDataTable-_rowStyle-solid__style,solid) var(--AbstractMdsDataTable-_rowStyle-solid__color,#c1c3c3)}:host .data-table-for-accounts__column-header--alert{text-align:left}:host .data-table-for-accounts__row-value--alert{text-align:left;padding-left:8px;padding-right:8px}:host .empty-alert-cell{display:none}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/data-table-for-chart/mds-data-table-for-chart.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif;font-size:var(--AbstractMdsDataTable__rowHeaderTextSize,.875rem);line-height:1.25rem}:host .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .data-table-for-chart__stacked-container{overflow:auto}:host .data-table-for-chart__stacked-container .data-table-for-chart{padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px)}:host .data-table-for-chart{display:table;width:100%;position:relative;border-spacing:0}:host .data-table-for-chart__row--relaxed .data-table-for-chart__row-header:not(.data-table-for-chart__row-header--select){padding-top:var(--AbstractMdsDataTable-_mode-relaxed__verticalPadding,12px);padding-bottom:var(--AbstractMdsDataTable-_mode-relaxed__verticalPadding,12px)}:host .data-table-for-chart__row--compact .data-table-for-chart__row-header:not(.data-table-for-chart__row-header--select){padding-top:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px);padding-bottom:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-chart__row--solid:not(.data-table-for-chart__row--footer) .data-table-for-chart__row-header{border-bottom:var(--AbstractMdsDataTable-_rowStyle-solid__width,1px) var(--AbstractMdsDataTable-_rowStyle-solid__style,solid) var(--AbstractMdsDataTable-_rowStyle-solid__color,#c1c3c3)}:host .data-table-for-chart__row--dashed:not(.data-table-for-chart__row--footer) .data-table-for-chart__row-header{border-bottom:var(--AbstractMdsDataTable-_rowStyle-dashed__width,1px) var(--AbstractMdsDataTable-_rowStyle-dashed__style,dashed) var(--AbstractMdsDataTable-_rowStyle-dashed__color,#c1c3c3)}:host .data-table-for-chart__row-header--footer{border-top:var(--AbstractMdsDataTable__columnHeaderBorderWidth,2px) solid var(--AbstractMdsDataTable__columnHeaderBorderColor,#c1c3c3)}:host .data-table-for-chart__row-header{text-align:left;font-weight:600;display:table-cell;vertical-align:top}:host .data-table-for-chart__link{text-decoration:none;display:inline;color:var(--MdsLink__textColor,#005eb8)}:host .data-table-for-chart__link:hover,:host .data-table-for-chart__link:hover>span{color:var(--MdsLink__textColor--hovered,#004692)}:host .data-table-for-chart__link:hover .data-table-for-chart__link-icon svg,:host .data-table-for-chart__link:hover>span .data-table-for-chart__link-icon svg{fill:var(--MdsLink__iconColor--hovered,#002f6c)}:host .data-table-for-chart__link:active{color:var(--MdsLink__textColor--pressed,#004692)}:host .data-table-for-chart__link:active .data-table-for-chart__link-icon svg{fill:var(--MdsLink__iconColor--pressed,#002f6c)}:host .data-table-for-chart__link:focus:focus{outline:.0625rem dashed #717171}:host .data-table-for-chart__link--trailing{white-space:nowrap}:host .data-table-for-chart__link-icon{display:inline-flex;vertical-align:middle;padding-left:var(--MdsLink__trailingIconLeadingPadding,4px);position:relative;bottom:.0625rem}:host .data-table-for-chart__link-icon svg{pointer-events:none;height:var(--AbstractMdsDataTable__linkNavigationIconSize,1rem);width:var(--AbstractMdsDataTable__linkNavigationIconSize,1rem);fill:var(--MdsLink__iconColor,#005eb8)}:host .data-table-for-chart__link-icon--navigation{padding-left:var(--AbstractMdsDataTable__linkNavigationIconHorizontalPadding,14px);padding-right:var(--AbstractMdsDataTable__linkNavigationIconHorizontalPadding,14px);padding-top:var(--AbstractMdsDataTable__linkIconVerticalPadding,4px);bottom:.125rem}:host .data-table-for-chart__link--navigation{display:flex;justify-content:center}:host .data-table-for-chart__link--navigation-stacked{justify-content:flex-end}:host .data-table-for-chart__link__accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .data-table-for-chart__column-header{font-weight:600;display:table-cell;vertical-align:bottom;text-align:right;padding:0;border-bottom:var(--AbstractMdsDataTable__columnHeaderBorderWidth,2px) solid var(--AbstractMdsDataTable__columnHeaderBorderColor,#c1c3c3)}:host .data-table-for-chart__column-header--left,:host .data-table-for-chart__column-header:first-child{text-align:left}:host .data-table-for-chart__column-header--value{padding:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px) var(--AbstractMdsDataTable__columnSidePadding,8px);box-sizing:border-box}:host .data-table-for-chart__column-header--sparkline{text-align:left}:host .data-table-for-chart__column-header--sparkline .data-table-for-chart__column-header--value{padding:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-chart__column-header-action{padding-left:0}:host .data-table-for-chart__column-header--sortable{position:relative;padding:0}:host .data-table-for-chart__column-header-sort-button{background-color:transparent;position:absolute;top:0;margin:0;bottom:0;right:0;left:0;border:0;padding:0;width:100%}:host .data-table-for-chart__column-header-sort-button::-moz-focus-inner{border:0}:host .data-table-for-chart__column-header-sort-button:focus{outline:.0625rem dashed #717171}:host .data-table-for-chart__column-header-sort-text-container{font-weight:inherit;text-align:inherit;display:inline-block;pointer-events:none;position:relative;z-index:1;width:100%;box-sizing:border-box;padding:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px) var(--AbstractMdsDataTable__columnSidePadding,8px)}:host .data-table-for-chart__column-header-sort-text{max-width:calc(100% - 1rem)}:host .data-table-for-chart__column-header-sort-icon{display:inline-flex;pointer-events:none;vertical-align:middle;padding-bottom:.125rem;padding-left:.125rem}:host .data-table-for-chart__column-header-sort-icon svg{height:1em;width:1em;fill:var(--AbstractMdsDataTable__sortIconColor,#565a5d)}:host .data-table-for-chart__row-header-container{display:flex}:host .data-table-for-chart__row--activated:not(.data-table-for-chart__row--footer):hover,:host .data-table-for-chart__row--highlight{background-color:var(--AbstractMdsDataTable__rowHighlightedBackgroundColor,#eceff1)}:host .data-table-for-chart__row--relaxed .data-table-for-chart__row-value{padding-top:var(--AbstractMdsDataTable-_mode-relaxed__verticalPadding,12px);padding-bottom:var(--AbstractMdsDataTable-_mode-relaxed__verticalPadding,12px)}:host .data-table-for-chart__row--compact .data-table-for-chart__inline-caption-row,:host .data-table-for-chart__row--compact .data-table-for-chart__row-value,:host .data-table-for-chart__row--relaxed .data-table-for-chart__inline-caption-row{padding-top:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px);padding-bottom:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-chart__row--compact .data-table-for-chart__row-action{padding-top:0}:host .data-table-for-chart__row--solid:not(.data-table-for-chart__row--footer) .data-table-for-chart__inline-caption-row,:host .data-table-for-chart__row--solid:not(.data-table-for-chart__row--footer) .data-table-for-chart__row-action,:host .data-table-for-chart__row--solid:not(.data-table-for-chart__row--footer) .data-table-for-chart__row-value{border-bottom:var(--AbstractMdsDataTable-_rowStyle-solid__width,1px) var(--AbstractMdsDataTable-_rowStyle-solid__style,solid) var(--AbstractMdsDataTable-_rowStyle-solid__color,#c1c3c3)}:host .data-table-for-chart__row--dashed:not(.data-table-for-chart__row--footer) .data-table-for-chart__inline-caption-row,:host .data-table-for-chart__row--dashed:not(.data-table-for-chart__row--footer) .data-table-for-chart__row-action,:host .data-table-for-chart__row--dashed:not(.data-table-for-chart__row--footer) .data-table-for-chart__row-value{border-bottom:var(--AbstractMdsDataTable-_rowStyle-dashed__width,1px) var(--AbstractMdsDataTable-_rowStyle-dashed__style,dashed) var(--AbstractMdsDataTable-_rowStyle-dashed__color,#c1c3c3)}:host .data-table-for-chart__row-value--footer,:host .data-table-for-chart__row-value--footer-cell{border-top:var(--AbstractMdsDataTable__columnHeaderBorderWidth,2px) solid var(--AbstractMdsDataTable__columnHeaderBorderColor,#c1c3c3)}:host .data-table-for-chart__row-action,:host .data-table-for-chart__row-value{padding:0;font-weight:400;display:table-cell;vertical-align:top;border-bottom:var(--AbstractMdsDataTable-_rowStyle-solid__width,1px) var(--AbstractMdsDataTable-_rowStyle-solid__style,solid) transparent;text-align:right}:host .data-table-for-chart__row-action--text,:host .data-table-for-chart__row-value--text{box-sizing:border-box;padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px);padding-right:var(--AbstractMdsDataTable__columnSidePadding,8px);word-break:break-word}:host .data-table-for-chart__row-action:first-child,:host .data-table-for-chart__row-value:first-child{text-align:left}:host .data-table-for-chart__row-action--dashed,:host .data-table-for-chart__row-value--dashed{border-bottom:var(--AbstractMdsDataTable-_rowStyle-dashed__width,1px) var(--AbstractMdsDataTable-_rowStyle-dashed__style,dashed) var(--AbstractMdsDataTable-_rowStyle-dashed__color,#c1c3c3)}:host .data-table-for-chart__row-action--stacked{padding-top:var(--AbstractMdsDataTable__stackedDataTableVerticalPadding,8px)}:host .data-table-for-chart__row-value--footer{font-weight:600;word-break:break-word;border-bottom:0;padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px);padding-right:var(--AbstractMdsDataTable__columnSidePadding,8px)}:host .data-table-for-chart__grouping-for-secondary-tertiary-text{padding:0;margin:0;list-style-type:none}:host .data-table-for-chart__grouping-for-secondary-tertiary-text--with-padding{padding-left:1.875rem}:host .data-table-for-chart__alert-message{display:block}:host .data-table-for-chart__secondary-text{color:var(--AbstractMdsDataTable__secondaryValueTextColor,#101820);list-style:none;padding-left:0;font-weight:var(--AbstractMdsDataTable__secondaryValueTextWeight,400);font-size:var(--AbstractMdsDataTable__secondaryValueTextSize,.875rem);line-height:var(--AbstractMdsDataTable__secondaryValueTextLineHeight,1.25rem)}:host .data-table-for-chart__tertiary-text{color:var(--AbstractMdsDataTable__tertiaryValueTextColor,#565a5d);list-style:none;padding-left:0;font-weight:var(--AbstractMdsDataTable__tertiaryValueTextWeight,400);font-size:var(--AbstractMdsDataTable__tertiaryValueTextSize,.875rem);line-height:var(--AbstractMdsDataTable__tertiaryValueTextLineHeight,1.25rem)}:host .data-table-for-chart__tag{margin-left:var(--AbstractMdsDataTable__tagLeadingMargin,8px)}:host .data-table-for-chart__multi-level-sorting{display:none;position:absolute;right:0;margin-top:var(--AbstractMdsDataTable__multiLevelSortingMenuTopPadding,4px);box-shadow:var(--AbstractMdsDataTable__multiLevelSortingMenuBoxShadowHorizontalOffset,0),var(--AbstractMdsDataTable__multiLevelSortingMenuBoxShadowVerticalOffset,2px),var(--AbstractMdsDataTable__multiLevelSortingMenuBoxShadowBlurRadius,4px),var(--AbstractMdsDataTable__multiLevelSortingMenuBoxShadowSpreadRadius,0),var(--AbstractMdsDataTable__multiLevelSortingMenuBoxShadowColor,rgba(0,0,0,.4))}:host .data-table-for-chart__multi-level-sorting--displayed{display:block!important;z-index:999}:host .data-table-for-chart__multi-level-sorting-group{margin:0;padding:0}:host .data-table-for-chart__multi-level-sorting-item__header{text-align:left;font-size:var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderTextSize,.75rem);line-height:var(----AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderLineHeight,1rem);font-weight:var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderTextWeight,600);padding:var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderTopPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderTrailingPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderBottomPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderLeadingPadding,8px);color:var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderTextColor,#565a5d);background-color:var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderBackgroundColor,#f5f7f8)}:host .data-table-for-chart__multi-level-sorting-menu-item{list-style:none;position:relative}:host .data-table-for-chart__multi-level-sorting-menu-item--selected .data-table-for-chart__multi-level-sorting-menu-item__bar{position:absolute;height:var(--AbstractMdsDataTable_multiLevelSortingMenuItem-_selected-true__multiLevelSortingMenuItemBarHeight,100%);width:var(--AbstractMdsDataTable_multiLevelSortingMenuItem-_selected-true__multiLevelSortingMenuItemBarWidth,4px)}:host .data-table-for-chart__multi-level-sorting-menu-item--selected .data-table-for-chart__multi-level-sorting-menu-item__item{font-weight:var(--AbstractMdsDataTable_multiLevelSortingMenuItem-_selected-true__multiLevelSortingMenuItemLabelTextWeight,600)}:host .data-table-for-chart__multi-level-sorting-menu-item__item{border:0;text-align:left;margin:0;width:100%;color:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__labelTextColor,#101820);font-size:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__labelTextSize,.875rem);line-height:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__labelTextLineHeight,1.25rem);font-weight:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__labelTextWeight,400);background-color:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemBackgroundColor,#fff);padding:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemTopPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemTrailingPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemBottomPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemLeadingPadding,8px)}:host .data-table-for-chart__multi-level-sorting-menu-item__item:hover{background-color:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemBackgroundColor--hovered,#f5f7f8)}:host .data-table-for-chart__multi-level-sorting-menu-item__item:focus{z-index:1}:host .data-table-for-chart__multi-level-sorting-menu-item__item:focus::-moz-focus-inner{border:0}:host .data-table-for-chart__multi-level-sorting-menu-item__item:focus:focus{outline:.0625rem dashed #717171;outline-offset:-.0625rem}:host .data-table-for-chart__row-value--left{text-align:left}:host .data-table-for-chart__row-value--right{text-align:right}:host .data-table-for-chart__secondary-tertiary-value-block{display:block}:host .data-table-for-chart__secondary-value{display:inline-block}:host .data-table-for-chart__secondary-value,:host .data-table-for-chart__tertiary-value{color:var(--MdsDataTableForTransactions__rightAlignedColumnSecondaryTertiaryTextColor,#565a5d);padding-top:var(--MdsDataTableForTransactions__rightAlignedColumnSecondaryTertiaryInterValueVerticalPadding,2px);padding-left:var(--MdsDataTableForTransactions__rightAlignedColumnSecondaryTertiaryInterValueHorizontalPadding,4px)}:host .data-table-for-chart__row-value--gain,:host .data-table-for-chart__secondary-value--gain,:host .data-table-for-chart__tertiary-value--gain{color:var(--AbstractMdsDataTable__gainTextColor,#398100)}:host .data-table-for-chart__row-value--loss,:host .data-table-for-chart__secondary-value--loss,:host .data-table-for-chart__tertiary-value--loss{color:var(--AbstractMdsDataTable__lossTextColor,#b80009)}:host .data-table-for-chart__column-header--sortable .data-table-for-chart__column-header-sort-button:hover{background-color:var(--AbstractMdsDataTable__sortedColumnHeaderHoverBackgroundColor,rgba(0,94,184,.08))}:host .data-table-for-chart__column-header--sortable .data-table-for-chart__column-header-sort-button:active{background-color:var(--AbstractMdsDataTable__sortedColumnHeaderPressedBackgroundColor,rgba(0,94,184,.08))}:host .data-table-for-chart__multi-level-sorting-menu-item--selected .data-table-for-chart__multi-level-sorting-menu-item__bar{background-color:var(--AbstractMdsDataTable_MultiLevelSortingMenuItem-_selected-true__multiLevelSortingMenuItemBarColor,#005eb8)}:host .data-table-for-chart__separator{border-bottom:var(--AbstractMdsDataTable-_rowStyle-solid__width,1px) var(--AbstractMdsDataTable-_rowStyle-solid__style,solid) var(--AbstractMdsDataTable-_rowStyle-solid__color,#c1c3c3)}:host .data-table-for-chart__separator--footer{border-bottom:var(--AbstractMdsDataTable__columnHeaderBorderWidth,2px) var(--AbstractMdsDataTable-_rowStyle-solid__style,solid) var(--AbstractMdsDataTable-_rowStyle-solid__color,#c1c3c3)}:host .data-table-for-chart__caption{text-align:left}:host .data-table-for-chart__caption--hidden{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .data-table-for-chart__caption--block{display:table-caption;font-weight:300;font-size:var(--AbstractMdsDataTable__captionTextSize,1.125rem);margin-bottom:var(--AbstractMdsDataTable__captionBottomMargin,16px);line-height:var(--AbstractMdsDataTable__captionTextLineHeight,1.75rem)}:host .data-table-for-chart__caption--is-safari{position:absolute;top:0}:host .data-table-for-chart__caption--is-ios{display:flex}:host .data-table-for-chart__caption--stacked{font-weight:600;font-size:var(--AbstractMdsDataTable-_stacked-true__captionTextSize,.875rem);padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px);margin-top:var(--AbstractMdsDataTable-_stacked-true__captionTopMargin,8px);margin-bottom:var(--AbstractMdsDataTable-_stacked-true__captionBottomMargin,8px);line-height:var(--AbstractMdsDataTable-_stacked-true__captionTextLineHeight,1.25rem);white-space:pre-wrap}:host .data-table-for-chart__caption--stacked-footer{margin-top:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px);margin-bottom:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-chart__stacked-caption-heading{color:var(--AbstractMdsDataTable__stackedCaptionHeadingColor,#101820);font-size:var(--AbstractMdsDataTable__stackedCaptionHeadingTextSize,1.125rem);line-height:var(--AbstractMdsDataTable__stackedCaptionHeadingLineHeight,1.75rem);margin:0 0 var(--AbstractMdsDataTable__stackedCaptionHeadingBottomMargin,16px) 0}:host .data-table-for-chart__stacked-caption-heading--with-reduced-spacing{margin-bottom:calc(var(--AbstractMdsDataTable__stackedCaptionHeadingBottomMargin, 16px) - var(--AbstractMdsDataTable-_stacked-true__captionTopMargin, 8px))}:host .data-table-for-chart__stacked-caption-heading--hidden{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .data-table-for-chart__stacked-caption-heading-container{display:flex}:host .data-table-for-chart__stacked-caption-heading-container--with-checkbox{margin-top:var(--AbstractMdsDataTable-_stacked-true__captionCheckboxTopMargin,4px)}:host .data-table-for-chart__caption--inline{display:inline;font-weight:600;position:relative;font-size:var(--AbstractMdsDataTable__rowHeaderTextSize,.875rem);top:1.5rem;left:var(--AbstractMdsDataTable__firstColumnLeadingPadding,8px);padding:0;margin:0;line-height:0}:host .data-table-for-chart__caption--empty-inline-caption{padding-bottom:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px);display:block}:host .data-table-for-chart__empty-table{text-align:center;font-weight:400}:host .data-table-for-chart__empty-table--inline{padding-top:var(--AbstractMdsDataTable__nullMessageVerticalPaddingWithHeader,40px);padding-bottom:var(--AbstractMdsDataTable__nullMessageVerticalPaddingWithHeader,40px)}:host .data-table-for-chart__empty-table--block{padding-top:var(--AbstractMdsDataTable__nullMessageVerticalPaddingWithoutHeader,64px);padding-bottom:var(--AbstractMdsDataTable__nullMessageVerticalPaddingWithoutHeader,64px)}:host .data-table-for-chart__column-header--action{padding-left:var(--AbstractMdsDataTable__actionColumnLeadingPadding,16px)}:host .data-table-for-chart__column-header--action:last-child{text-align:left}:host .data-table-for-chart__swatch-container{display:flex}:host .data-table-for-chart__swatch{color:var(--MdsDataTableForChart__swatchShapeNullBackgroundColor,#c1c3c3);background-color:var(--MdsDataTableForChart__swatchShapeNullBackgroundColor,#c1c3c3);align-self:top;margin-top:.1875rem;vertical-align:top;width:var(--MdsDataTableForChart__swatchShapeWidth,14px);height:var(--MdsDataTableForChart__swatchShapeWidth,14px);min-width:var(--MdsDataTableForChart__swatchShapeWidth,14px);min-height:var(--MdsDataTableForChart__swatchShapeWidth,14px);margin-left:var(--MdsDataTableForChart__swatchShapePadding,8px);margin-right:var(--MdsDataTableForChart__swatchShapePadding,8px)}:host .data-table-for-chart__swatch--circle{border-radius:50%}:host .data-table-for-chart__stacked-container .data-table-for-chart__swatch{margin-left:0}:host .data-table-for-chart__row-header--with-swatch{padding-left:0}:host .data-table-for-chart__row--inline-caption-row:not(.data-table-for-chart__row--footer) .data-table-for-chart__inline-caption-row,:host .data-table-for-chart__row--inline-caption-row:not(.data-table-for-chart__row--footer) .data-table-for-chart__row-action,:host .data-table-for-chart__row--inline-caption-row:not(.data-table-for-chart__row--footer) .data-table-for-chart__row-header,:host .data-table-for-chart__row--inline-caption-row:not(.data-table-for-chart__row--footer) .data-table-for-chart__row-value{font-weight:600;text-align:right;padding-right:var(--AbstractMdsDataTable__columnSidePadding,8px);border-bottom:var(--AbstractMdsDataTable__columnHeaderBorderWidth,2px) solid var(--AbstractMdsDataTable__columnHeaderBorderColor,#c1c3c3)}:host .data-table-for-chart__row--inline-caption-row:not(.data-table-for-chart__row--footer) .data-table-for-chart__inline-caption-row:not(:last-child),:host .data-table-for-chart__row--inline-caption-row:not(.data-table-for-chart__row--footer) .data-table-for-chart__row-action:not(:last-child),:host .data-table-for-chart__row--inline-caption-row:not(.data-table-for-chart__row--footer) .data-table-for-chart__row-header:not(:last-child),:host .data-table-for-chart__row--inline-caption-row:not(.data-table-for-chart__row--footer) .data-table-for-chart__row-value:not(:last-child){padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px)}:host .data-table-for-chart--empty-inline-caption-with-border{border-bottom:var(--AbstractMdsDataTable__columnHeaderBorderWidth,2px) solid var(--AbstractMdsDataTable__columnHeaderBorderColor,#c1c3c3)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/data-table-for-files/mds-data-table-for-files.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif;font-size:var(--AbstractMdsDataTable__rowHeaderTextSize,.875rem);line-height:1.25rem}:host .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .data-table-for-files__stacked-container{overflow:auto}:host .data-table-for-files__stacked-container .data-table-for-files{padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px)}:host .data-table-for-files{display:table;width:100%;position:relative;border-spacing:0}:host .data-table-for-files__row--relaxed .data-table-for-files__row-header:not(.data-table-for-files__row-header--select){padding-top:var(--AbstractMdsDataTable-_mode-relaxed__verticalPadding,12px);padding-bottom:var(--AbstractMdsDataTable-_mode-relaxed__verticalPadding,12px)}:host .data-table-for-files__row--compact .data-table-for-files__row-header:not(.data-table-for-files__row-header--select){padding-top:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px);padding-bottom:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-files__row--solid:not(.data-table-for-files__row--footer) .data-table-for-files__row-header{border-bottom:var(--AbstractMdsDataTable-_rowStyle-solid__width,1px) var(--AbstractMdsDataTable-_rowStyle-solid__style,solid) var(--AbstractMdsDataTable-_rowStyle-solid__color,#c1c3c3)}:host .data-table-for-files__row--dashed:not(.data-table-for-files__row--footer) .data-table-for-files__row-header{border-bottom:var(--AbstractMdsDataTable-_rowStyle-dashed__width,1px) var(--AbstractMdsDataTable-_rowStyle-dashed__style,dashed) var(--AbstractMdsDataTable-_rowStyle-dashed__color,#c1c3c3)}:host .data-table-for-files__row-header--footer{border-top:var(--AbstractMdsDataTable__columnHeaderBorderWidth,2px) solid var(--AbstractMdsDataTable__columnHeaderBorderColor,#c1c3c3)}:host .data-table-for-files__row-header{text-align:left;font-weight:600;display:table-cell;vertical-align:top}:host .data-table-for-files__column-header{font-weight:600;display:table-cell;vertical-align:bottom;text-align:right;padding:0;border-bottom:var(--AbstractMdsDataTable__columnHeaderBorderWidth,2px) solid var(--AbstractMdsDataTable__columnHeaderBorderColor,#c1c3c3)}:host .data-table-for-files__column-header--left,:host .data-table-for-files__column-header:first-child{text-align:left}:host .data-table-for-files__column-header--value{padding:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px) var(--AbstractMdsDataTable__columnSidePadding,8px);box-sizing:border-box}:host .data-table-for-files__column-header--sparkline{text-align:left}:host .data-table-for-files__column-header--sparkline .data-table-for-files__column-header--value{padding:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-files__column-header-action{padding-left:0}:host .data-table-for-files__column-header--sortable{position:relative;padding:0}:host .data-table-for-files__column-header-sort-button{background-color:transparent;position:absolute;top:0;margin:0;bottom:0;right:0;left:0;border:0;padding:0;width:100%}:host .data-table-for-files__column-header-sort-button::-moz-focus-inner{border:0}:host .data-table-for-files__column-header-sort-button:focus{outline:.0625rem dashed #717171}:host .data-table-for-files__column-header-sort-text-container{font-weight:inherit;text-align:inherit;display:inline-block;pointer-events:none;position:relative;z-index:1;width:100%;box-sizing:border-box;padding:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px) var(--AbstractMdsDataTable__columnSidePadding,8px)}:host .data-table-for-files__column-header-sort-text{max-width:calc(100% - 1rem)}:host .data-table-for-files__column-header-sort-icon{display:inline-flex;pointer-events:none;vertical-align:middle;padding-bottom:.125rem;padding-left:.125rem}:host .data-table-for-files__column-header-sort-icon svg{height:1em;width:1em;fill:var(--AbstractMdsDataTable__sortIconColor,#565a5d)}:host .data-table-for-files__row-header-container{display:flex}:host .data-table-for-files__row--activated:not(.data-table-for-files__row--footer):hover,:host .data-table-for-files__row--highlight{background-color:var(--AbstractMdsDataTable__rowHighlightedBackgroundColor,#eceff1)}:host .data-table-for-files__row--relaxed .data-table-for-files__row-value{padding-top:var(--AbstractMdsDataTable-_mode-relaxed__verticalPadding,12px);padding-bottom:var(--AbstractMdsDataTable-_mode-relaxed__verticalPadding,12px)}:host .data-table-for-files__row--compact .data-table-for-files__inline-caption-row,:host .data-table-for-files__row--compact .data-table-for-files__row-value,:host .data-table-for-files__row--relaxed .data-table-for-files__inline-caption-row{padding-top:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px);padding-bottom:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-files__row--compact .data-table-for-files__row-action{padding-top:0}:host .data-table-for-files__row--solid:not(.data-table-for-files__row--footer) .data-table-for-files__inline-caption-row,:host .data-table-for-files__row--solid:not(.data-table-for-files__row--footer) .data-table-for-files__row-action,:host .data-table-for-files__row--solid:not(.data-table-for-files__row--footer) .data-table-for-files__row-value{border-bottom:var(--AbstractMdsDataTable-_rowStyle-solid__width,1px) var(--AbstractMdsDataTable-_rowStyle-solid__style,solid) var(--AbstractMdsDataTable-_rowStyle-solid__color,#c1c3c3)}:host .data-table-for-files__row--dashed:not(.data-table-for-files__row--footer) .data-table-for-files__inline-caption-row,:host .data-table-for-files__row--dashed:not(.data-table-for-files__row--footer) .data-table-for-files__row-action,:host .data-table-for-files__row--dashed:not(.data-table-for-files__row--footer) .data-table-for-files__row-value{border-bottom:var(--AbstractMdsDataTable-_rowStyle-dashed__width,1px) var(--AbstractMdsDataTable-_rowStyle-dashed__style,dashed) var(--AbstractMdsDataTable-_rowStyle-dashed__color,#c1c3c3)}:host .data-table-for-files__row--inline-caption-row:not(.data-table-for-files__row--footer) .data-table-for-files__inline-caption-row,:host .data-table-for-files__row--inline-caption-row:not(.data-table-for-files__row--footer) .data-table-for-files__row-action,:host .data-table-for-files__row--inline-caption-row:not(.data-table-for-files__row--footer) .data-table-for-files__row-header,:host .data-table-for-files__row--inline-caption-row:not(.data-table-for-files__row--footer) .data-table-for-files__row-value{border-bottom:var(--AbstractMdsDataTable__columnHeaderBorderWidth,2px) solid var(--AbstractMdsDataTable__columnHeaderBorderColor,#c1c3c3)}:host .data-table-for-files__row-value--footer,:host .data-table-for-files__row-value--footer-cell{border-top:var(--AbstractMdsDataTable__columnHeaderBorderWidth,2px) solid var(--AbstractMdsDataTable__columnHeaderBorderColor,#c1c3c3)}:host .data-table-for-files__row-action,:host .data-table-for-files__row-value{padding:0;font-weight:400;display:table-cell;vertical-align:top;border-bottom:var(--AbstractMdsDataTable-_rowStyle-solid__width,1px) var(--AbstractMdsDataTable-_rowStyle-solid__style,solid) transparent;text-align:right}:host .data-table-for-files__row-action--text,:host .data-table-for-files__row-value--text{box-sizing:border-box;padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px);padding-right:var(--AbstractMdsDataTable__columnSidePadding,8px);word-break:break-word}:host .data-table-for-files__row-action:first-child,:host .data-table-for-files__row-value:first-child{text-align:left}:host .data-table-for-files__row-action--dashed,:host .data-table-for-files__row-value--dashed{border-bottom:var(--AbstractMdsDataTable-_rowStyle-dashed__width,1px) var(--AbstractMdsDataTable-_rowStyle-dashed__style,dashed) var(--AbstractMdsDataTable-_rowStyle-dashed__color,#c1c3c3)}:host .data-table-for-files__row-action--stacked{padding-top:var(--AbstractMdsDataTable__stackedDataTableVerticalPadding,8px)}:host .data-table-for-files__row-value--footer{font-weight:600;word-break:break-word;border-bottom:0;padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px);padding-right:var(--AbstractMdsDataTable__columnSidePadding,8px)}:host .data-table-for-files__grouping-for-secondary-tertiary-text{padding:0;margin:0;list-style-type:none}:host .data-table-for-files__grouping-for-secondary-tertiary-text--with-padding{padding-left:1.875rem}:host .data-table-for-files__alert-message{display:block}:host .data-table-for-files__secondary-text{color:var(--AbstractMdsDataTable__secondaryValueTextColor,#101820);list-style:none;padding-left:0;font-weight:var(--AbstractMdsDataTable__secondaryValueTextWeight,400);font-size:var(--AbstractMdsDataTable__secondaryValueTextSize,.875rem);line-height:var(--AbstractMdsDataTable__secondaryValueTextLineHeight,1.25rem)}:host .data-table-for-files__tertiary-text{color:var(--AbstractMdsDataTable__tertiaryValueTextColor,#565a5d);list-style:none;padding-left:0;font-weight:var(--AbstractMdsDataTable__tertiaryValueTextWeight,400);font-size:var(--AbstractMdsDataTable__tertiaryValueTextSize,.875rem);line-height:var(--AbstractMdsDataTable__tertiaryValueTextLineHeight,1.25rem)}:host .data-table-for-files__tag{margin-left:var(--AbstractMdsDataTable__tagLeadingMargin,8px)}:host .data-table-for-files__multi-level-sorting{display:none;position:absolute;right:0;margin-top:var(--AbstractMdsDataTable__multiLevelSortingMenuTopPadding,4px);box-shadow:var(--AbstractMdsDataTable__multiLevelSortingMenuBoxShadowHorizontalOffset,0),var(--AbstractMdsDataTable__multiLevelSortingMenuBoxShadowVerticalOffset,2px),var(--AbstractMdsDataTable__multiLevelSortingMenuBoxShadowBlurRadius,4px),var(--AbstractMdsDataTable__multiLevelSortingMenuBoxShadowSpreadRadius,0),var(--AbstractMdsDataTable__multiLevelSortingMenuBoxShadowColor,rgba(0,0,0,.4))}:host .data-table-for-files__multi-level-sorting--displayed{display:block!important;z-index:999}:host .data-table-for-files__multi-level-sorting-group{margin:0;padding:0}:host .data-table-for-files__multi-level-sorting-item__header{text-align:left;font-size:var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderTextSize,.75rem);line-height:var(----AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderLineHeight,1rem);font-weight:var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderTextWeight,600);padding:var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderTopPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderTrailingPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderBottomPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderLeadingPadding,8px);color:var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderTextColor,#565a5d);background-color:var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderBackgroundColor,#f5f7f8)}:host .data-table-for-files__multi-level-sorting-menu-item{list-style:none;position:relative}:host .data-table-for-files__multi-level-sorting-menu-item--selected .data-table-for-files__multi-level-sorting-menu-item__bar{position:absolute;height:var(--AbstractMdsDataTable_multiLevelSortingMenuItem-_selected-true__multiLevelSortingMenuItemBarHeight,100%);width:var(--AbstractMdsDataTable_multiLevelSortingMenuItem-_selected-true__multiLevelSortingMenuItemBarWidth,4px)}:host .data-table-for-files__multi-level-sorting-menu-item--selected .data-table-for-files__multi-level-sorting-menu-item__item{font-weight:var(--AbstractMdsDataTable_multiLevelSortingMenuItem-_selected-true__multiLevelSortingMenuItemLabelTextWeight,600)}:host .data-table-for-files__multi-level-sorting-menu-item__item{border:0;text-align:left;margin:0;width:100%;color:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__labelTextColor,#101820);font-size:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__labelTextSize,.875rem);line-height:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__labelTextLineHeight,1.25rem);font-weight:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__labelTextWeight,400);background-color:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemBackgroundColor,#fff);padding:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemTopPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemTrailingPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemBottomPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemLeadingPadding,8px)}:host .data-table-for-files__multi-level-sorting-menu-item__item:hover{background-color:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemBackgroundColor--hovered,#f5f7f8)}:host .data-table-for-files__multi-level-sorting-menu-item__item:focus{z-index:1}:host .data-table-for-files__multi-level-sorting-menu-item__item:focus::-moz-focus-inner{border:0}:host .data-table-for-files__multi-level-sorting-menu-item__item:focus:focus{outline:.0625rem dashed #717171;outline-offset:-.0625rem}:host .data-table-for-files__row-value--left{text-align:left}:host .data-table-for-files__row-value--progress-bar{padding-top:18px;padding-left:8px}:host .data-table-for-files__caption{text-align:left}:host .data-table-for-files__caption--hidden{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .data-table-for-files__caption--block{display:table-caption;font-weight:300;font-size:var(--AbstractMdsDataTable__captionTextSize,1.125rem);margin-bottom:var(--AbstractMdsDataTable__captionBottomMargin,16px);line-height:var(--AbstractMdsDataTable__captionTextLineHeight,1.75rem)}:host .data-table-for-files__caption--is-safari{position:absolute;top:0}:host .data-table-for-files__caption--is-ios{display:flex}:host .data-table-for-files__caption--stacked{font-weight:600;font-size:var(--AbstractMdsDataTable-_stacked-true__captionTextSize,.875rem);padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px);margin-top:var(--AbstractMdsDataTable-_stacked-true__captionTopMargin,8px);margin-bottom:var(--AbstractMdsDataTable-_stacked-true__captionBottomMargin,8px);line-height:var(--AbstractMdsDataTable-_stacked-true__captionTextLineHeight,1.25rem);white-space:pre-wrap}:host .data-table-for-files__caption--stacked-footer{margin-top:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px);margin-bottom:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-files__stacked-caption-heading{color:var(--AbstractMdsDataTable__stackedCaptionHeadingColor,#101820);font-size:var(--AbstractMdsDataTable__stackedCaptionHeadingTextSize,1.125rem);line-height:var(--AbstractMdsDataTable__stackedCaptionHeadingLineHeight,1.75rem);margin:0 0 var(--AbstractMdsDataTable__stackedCaptionHeadingBottomMargin,16px) 0}:host .data-table-for-files__stacked-caption-heading--with-reduced-spacing{margin-bottom:calc(var(--AbstractMdsDataTable__stackedCaptionHeadingBottomMargin, 16px) - var(--AbstractMdsDataTable-_stacked-true__captionTopMargin, 8px))}:host .data-table-for-files__stacked-caption-heading--hidden{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .data-table-for-files__stacked-caption-heading-container{display:flex}:host .data-table-for-files__stacked-caption-heading-container--with-checkbox{margin-top:var(--AbstractMdsDataTable-_stacked-true__captionCheckboxTopMargin,4px)}:host .data-table-for-files__column-header--action{padding-left:var(--AbstractMdsDataTable__actionColumnLeadingPadding,16px)}:host .data-table-for-files__column-header--action:last-child{text-align:left}:host .data-table-for-files__empty-table{text-align:center;font-weight:400}:host .data-table-for-files__empty-table--inline{padding-top:var(--AbstractMdsDataTable__nullMessageVerticalPaddingWithHeader,40px);padding-bottom:var(--AbstractMdsDataTable__nullMessageVerticalPaddingWithHeader,40px)}:host .data-table-for-files__empty-table--block{padding-top:var(--AbstractMdsDataTable__nullMessageVerticalPaddingWithoutHeader,64px);padding-bottom:var(--AbstractMdsDataTable__nullMessageVerticalPaddingWithoutHeader,64px)}:host .data-table-for-files__link{text-decoration:none;display:inline;color:var(--MdsLink__textColor,#005eb8)}:host .data-table-for-files__link:hover,:host .data-table-for-files__link:hover>span{color:var(--MdsLink__textColor--hovered,#004692)}:host .data-table-for-files__link:hover .data-table-for-files__link-icon svg,:host .data-table-for-files__link:hover>span .data-table-for-files__link-icon svg{fill:var(--MdsLink__iconColor--hovered,#002f6c)}:host .data-table-for-files__link:active{color:var(--MdsLink__textColor--pressed,#004692)}:host .data-table-for-files__link:active .data-table-for-files__link-icon svg{fill:var(--MdsLink__iconColor--pressed,#002f6c)}:host .data-table-for-files__link:focus:focus{outline:.0625rem dashed #717171}:host .data-table-for-files__link--trailing{white-space:nowrap}:host .data-table-for-files__link-icon{display:inline-flex;vertical-align:middle;padding-left:var(--MdsLink__trailingIconLeadingPadding,4px);position:relative;bottom:.0625rem}:host .data-table-for-files__link-icon svg{pointer-events:none;height:var(--AbstractMdsDataTable__linkNavigationIconSize,1rem);width:var(--AbstractMdsDataTable__linkNavigationIconSize,1rem);fill:var(--MdsLink__iconColor,#005eb8)}:host .data-table-for-files__link-icon--navigation{padding-left:var(--AbstractMdsDataTable__linkNavigationIconHorizontalPadding,14px);padding-right:var(--AbstractMdsDataTable__linkNavigationIconHorizontalPadding,14px);padding-top:var(--AbstractMdsDataTable__linkIconVerticalPadding,4px);bottom:.125rem}:host .data-table-for-files__link--navigation{display:flex;justify-content:center}:host .data-table-for-files__link--navigation-stacked{justify-content:flex-end}:host .data-table-for-files__link__accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .data-table-for-files__buttons-container{display:flex;flex-wrap:wrap;position:relative;padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px);padding-right:var(--AbstractMdsDataTable__columnSidePadding,8px);right:var(--AbstractMdsDataTable__buttonsHorizontalPadding,8px)}:host .data-table-for-files__buttons-container--icontext{right:calc(var(--AbstractMdsDataTable__buttonsHorizontalPadding, 8px) + .125rem)}:host .data-table-for-files__button{padding-left:var(--AbstractMdsDataTable__buttonsHorizontalPadding,8px);padding-right:var(--AbstractMdsDataTable__buttonsHorizontalPadding,8px)}:host .data-table-for-files__button--relaxed{padding-bottom:var(--AbstractMdsDataTable__buttonsColumnRelaxedVerticalPadding,8px);padding-top:var(--AbstractMdsDataTable__buttonsColumnRelaxedVerticalPadding,8px)}:host .data-table-for-files__buttons-container--stacked{justify-content:flex-end;flex-wrap:nowrap;right:0}:host .data-table-for-files__buttons-container--stacked .data-table-for-files__button:last-child{padding-right:0}:host .data-table-for-files__column-header--alert{text-align:left}:host .data-table-for-files__row-value--alert{text-align:left;padding-left:8px;padding-right:8px}:host .empty-alert-cell{display:none}:host .data-table-BEM-tag__row--solid:not(.data-table-BEM-tag__row--footer) .data-table-BEM-tag__row-header{border-bottom:var(--AbstractMdsDataTable-_rowStyle-solid__width,1px) var(--AbstractMdsDataTable-_rowStyle-solid__style,solid) var(--AbstractMdsDataTable-_rowStyle-solid__color,#c1c3c3)}:host .data-table-BEM-tag__row--dashed:not(.data-table-BEM-tag__row--footer) .data-table-BEM-tag__row-header{border-bottom:var(--AbstractMdsDataTable-_rowStyle-dashed__width,1px) var(--AbstractMdsDataTable-_rowStyle-dashed__style,dashed) var(--AbstractMdsDataTable-_rowStyle-dashed__color,#c1c3c3)}:host .data-table-BEM-tag__row-header--footer{border-top:var(--AbstractMdsDataTable__columnHeaderBorderWidth,2px) solid var(--AbstractMdsDataTable__columnHeaderBorderColor,#c1c3c3)}:host .data-table-BEM-tag__row-header{text-align:left;font-weight:600;display:table-cell;vertical-align:top}:host .mds-data-table-for-files{color:var(--AbstractMdsDataTable__rowHeaderTextColor,#101820)}:host .data-table-for-files__row--buttons,:host .data-table-for-files__row-action--stacked{width:var(--MdsDataTableForFiles__buttonsWidth,40px)}:host .data-table-for-files__row-action--stacked{padding-top:0}:host .data-table-for-files__buttons-container{width:var(--MdsDataTableForFiles__buttonsWidth,40px);float:right}:host .data-table-for-files__row-value--text{-webkit-box-orient:vertical;display:-webkit-box;text-overflow:ellipsis;overflow:hidden}:host .data-table-for-files__row--relaxed .data-table-for-files__row--buttons{padding-top:0;padding-bottom:0}:host .data-table-for-files__row--relaxed .data-table-for-files__row-value--progress-bar{padding-top:.5rem}:host .data-table-for-files__row--relaxed .data-table-for-files__row-value--progress-bar--stacked{padding-left:0}:host .data-table-for-files__row--relaxed .data-table-for-files__row-value .data-table-for-files__button{padding-top:.375rem}:host .data-table-for-files__row--relaxed .data-table-for-files__row-value--alert--stacked{padding-left:0}:host .data-table-for-files__row--relaxed .data-table-for-files__button--stacked{padding-top:.375rem}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/data-table-for-securities/mds-data-table-for-securities.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif;font-size:var(--AbstractMdsDataTable__rowHeaderTextSize,.875rem);line-height:1.25rem}:host .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .data-table-for-securities__stacked-container{overflow:auto}:host .data-table-for-securities__stacked-container .data-table-for-securities{padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px)}:host .data-table-for-securities{display:table;width:100%;position:relative;border-spacing:0}:host .data-table-for-securities__row--relaxed .data-table-for-securities__row-header:not(.data-table-for-securities__row-header--select){padding-top:var(--AbstractMdsDataTable-_mode-relaxed__verticalPadding,12px);padding-bottom:var(--AbstractMdsDataTable-_mode-relaxed__verticalPadding,12px)}:host .data-table-for-securities__row--compact .data-table-for-securities__row-header:not(.data-table-for-securities__row-header--select){padding-top:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px);padding-bottom:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-securities__row--solid:not(.data-table-for-securities__row--footer) .data-table-for-securities__row-header{border-bottom:var(--AbstractMdsDataTable-_rowStyle-solid__width,1px) var(--AbstractMdsDataTable-_rowStyle-solid__style,solid) var(--AbstractMdsDataTable-_rowStyle-solid__color,#c1c3c3)}:host .data-table-for-securities__row--dashed:not(.data-table-for-securities__row--footer) .data-table-for-securities__row-header{border-bottom:var(--AbstractMdsDataTable-_rowStyle-dashed__width,1px) var(--AbstractMdsDataTable-_rowStyle-dashed__style,dashed) var(--AbstractMdsDataTable-_rowStyle-dashed__color,#c1c3c3)}:host .data-table-for-securities__row-header--footer{border-top:var(--AbstractMdsDataTable__columnHeaderBorderWidth,2px) solid var(--AbstractMdsDataTable__columnHeaderBorderColor,#c1c3c3)}:host .data-table-for-securities__row-header{text-align:left;font-weight:600;display:table-cell;vertical-align:top}:host .data-table-for-securities__link{text-decoration:none;display:inline;color:var(--MdsLink__textColor,#005eb8)}:host .data-table-for-securities__link:hover,:host .data-table-for-securities__link:hover>span{color:var(--MdsLink__textColor--hovered,#004692)}:host .data-table-for-securities__link:hover .data-table-for-securities__link-icon svg,:host .data-table-for-securities__link:hover>span .data-table-for-securities__link-icon svg{fill:var(--MdsLink__iconColor--hovered,#002f6c)}:host .data-table-for-securities__link:active{color:var(--MdsLink__textColor--pressed,#004692)}:host .data-table-for-securities__link:active .data-table-for-securities__link-icon svg{fill:var(--MdsLink__iconColor--pressed,#002f6c)}:host .data-table-for-securities__link:focus:focus{outline:.0625rem dashed #717171}:host .data-table-for-securities__link--trailing{white-space:nowrap}:host .data-table-for-securities__link-icon{display:inline-flex;vertical-align:middle;padding-left:var(--MdsLink__trailingIconLeadingPadding,4px);position:relative;bottom:.0625rem}:host .data-table-for-securities__link-icon svg{pointer-events:none;height:var(--AbstractMdsDataTable__linkNavigationIconSize,1rem);width:var(--AbstractMdsDataTable__linkNavigationIconSize,1rem);fill:var(--MdsLink__iconColor,#005eb8)}:host .data-table-for-securities__link-icon--navigation{padding-left:var(--AbstractMdsDataTable__linkNavigationIconHorizontalPadding,14px);padding-right:var(--AbstractMdsDataTable__linkNavigationIconHorizontalPadding,14px);padding-top:var(--AbstractMdsDataTable__linkIconVerticalPadding,4px);bottom:.125rem}:host .data-table-for-securities__link--navigation{display:flex;justify-content:center}:host .data-table-for-securities__link--navigation-stacked{justify-content:flex-end}:host .data-table-for-securities__link__accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .data-table-for-securities__column-header{font-weight:600;display:table-cell;vertical-align:bottom;text-align:right;padding:0;border-bottom:var(--AbstractMdsDataTable__columnHeaderBorderWidth,2px) solid var(--AbstractMdsDataTable__columnHeaderBorderColor,#c1c3c3)}:host .data-table-for-securities__column-header--left,:host .data-table-for-securities__column-header:first-child{text-align:left}:host .data-table-for-securities__column-header--value{padding:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px) var(--AbstractMdsDataTable__columnSidePadding,8px);box-sizing:border-box}:host .data-table-for-securities__column-header--sparkline{text-align:left}:host .data-table-for-securities__column-header--sparkline .data-table-for-securities__column-header--value{padding:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-securities__column-header-action{padding-left:0}:host .data-table-for-securities__column-header--sortable{position:relative;padding:0}:host .data-table-for-securities__column-header-sort-button{background-color:transparent;position:absolute;top:0;margin:0;bottom:0;right:0;left:0;border:0;padding:0;width:100%}:host .data-table-for-securities__column-header-sort-button::-moz-focus-inner{border:0}:host .data-table-for-securities__column-header-sort-button:focus{outline:.0625rem dashed #717171}:host .data-table-for-securities__column-header-sort-text-container{font-weight:inherit;text-align:inherit;display:inline-block;pointer-events:none;position:relative;z-index:1;width:100%;box-sizing:border-box;padding:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px) var(--AbstractMdsDataTable__columnSidePadding,8px)}:host .data-table-for-securities__column-header-sort-text{max-width:calc(100% - 1rem)}:host .data-table-for-securities__column-header-sort-icon{display:inline-flex;pointer-events:none;vertical-align:middle;padding-bottom:.125rem;padding-left:.125rem}:host .data-table-for-securities__column-header-sort-icon svg{height:1em;width:1em;fill:var(--AbstractMdsDataTable__sortIconColor,#565a5d)}:host .data-table-for-securities__row-header-container{display:flex}:host .data-table-for-securities__row--activated:not(.data-table-for-securities__row--footer):hover,:host .data-table-for-securities__row--highlight{background-color:var(--AbstractMdsDataTable__rowHighlightedBackgroundColor,#eceff1)}:host .data-table-for-securities__row--relaxed .data-table-for-securities__row-value{padding-top:var(--AbstractMdsDataTable-_mode-relaxed__verticalPadding,12px);padding-bottom:var(--AbstractMdsDataTable-_mode-relaxed__verticalPadding,12px)}:host .data-table-for-securities__row--compact .data-table-for-securities__inline-caption-row,:host .data-table-for-securities__row--compact .data-table-for-securities__row-value,:host .data-table-for-securities__row--relaxed .data-table-for-securities__inline-caption-row{padding-top:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px);padding-bottom:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-securities__row--compact .data-table-for-securities__row-action{padding-top:0}:host .data-table-for-securities__row--solid:not(.data-table-for-securities__row--footer) .data-table-for-securities__inline-caption-row,:host .data-table-for-securities__row--solid:not(.data-table-for-securities__row--footer) .data-table-for-securities__row-action,:host .data-table-for-securities__row--solid:not(.data-table-for-securities__row--footer) .data-table-for-securities__row-value{border-bottom:var(--AbstractMdsDataTable-_rowStyle-solid__width,1px) var(--AbstractMdsDataTable-_rowStyle-solid__style,solid) var(--AbstractMdsDataTable-_rowStyle-solid__color,#c1c3c3)}:host .data-table-for-securities__row--dashed:not(.data-table-for-securities__row--footer) .data-table-for-securities__inline-caption-row,:host .data-table-for-securities__row--dashed:not(.data-table-for-securities__row--footer) .data-table-for-securities__row-action,:host .data-table-for-securities__row--dashed:not(.data-table-for-securities__row--footer) .data-table-for-securities__row-value{border-bottom:var(--AbstractMdsDataTable-_rowStyle-dashed__width,1px) var(--AbstractMdsDataTable-_rowStyle-dashed__style,dashed) var(--AbstractMdsDataTable-_rowStyle-dashed__color,#c1c3c3)}:host .data-table-for-securities__row--inline-caption-row:not(.data-table-for-securities__row--footer) .data-table-for-securities__inline-caption-row,:host .data-table-for-securities__row--inline-caption-row:not(.data-table-for-securities__row--footer) .data-table-for-securities__row-action,:host .data-table-for-securities__row--inline-caption-row:not(.data-table-for-securities__row--footer) .data-table-for-securities__row-header,:host .data-table-for-securities__row--inline-caption-row:not(.data-table-for-securities__row--footer) .data-table-for-securities__row-value{border-bottom:var(--AbstractMdsDataTable__columnHeaderBorderWidth,2px) solid var(--AbstractMdsDataTable__columnHeaderBorderColor,#c1c3c3)}:host .data-table-for-securities__row-value--footer,:host .data-table-for-securities__row-value--footer-cell{border-top:var(--AbstractMdsDataTable__columnHeaderBorderWidth,2px) solid var(--AbstractMdsDataTable__columnHeaderBorderColor,#c1c3c3)}:host .data-table-for-securities__row-action,:host .data-table-for-securities__row-value{padding:0;font-weight:400;display:table-cell;vertical-align:top;border-bottom:var(--AbstractMdsDataTable-_rowStyle-solid__width,1px) var(--AbstractMdsDataTable-_rowStyle-solid__style,solid) transparent;text-align:right}:host .data-table-for-securities__row-action--text,:host .data-table-for-securities__row-value--text{box-sizing:border-box;padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px);padding-right:var(--AbstractMdsDataTable__columnSidePadding,8px);word-break:break-word}:host .data-table-for-securities__row-action:first-child,:host .data-table-for-securities__row-value:first-child{text-align:left}:host .data-table-for-securities__row-action--dashed,:host .data-table-for-securities__row-value--dashed{border-bottom:var(--AbstractMdsDataTable-_rowStyle-dashed__width,1px) var(--AbstractMdsDataTable-_rowStyle-dashed__style,dashed) var(--AbstractMdsDataTable-_rowStyle-dashed__color,#c1c3c3)}:host .data-table-for-securities__row-action--stacked{padding-top:var(--AbstractMdsDataTable__stackedDataTableVerticalPadding,8px)}:host .data-table-for-securities__row-value--footer{font-weight:600;word-break:break-word;border-bottom:0;padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px);padding-right:var(--AbstractMdsDataTable__columnSidePadding,8px)}:host .data-table-for-securities__grouping-for-secondary-tertiary-text{padding:0;margin:0;list-style-type:none}:host .data-table-for-securities__grouping-for-secondary-tertiary-text--with-padding{padding-left:1.875rem}:host .data-table-for-securities__alert-message{display:block}:host .data-table-for-securities__secondary-text{color:var(--AbstractMdsDataTable__secondaryValueTextColor,#101820);list-style:none;padding-left:0;font-weight:var(--AbstractMdsDataTable__secondaryValueTextWeight,400);font-size:var(--AbstractMdsDataTable__secondaryValueTextSize,.875rem);line-height:var(--AbstractMdsDataTable__secondaryValueTextLineHeight,1.25rem)}:host .data-table-for-securities__tertiary-text{color:var(--AbstractMdsDataTable__tertiaryValueTextColor,#565a5d);list-style:none;padding-left:0;font-weight:var(--AbstractMdsDataTable__tertiaryValueTextWeight,400);font-size:var(--AbstractMdsDataTable__tertiaryValueTextSize,.875rem);line-height:var(--AbstractMdsDataTable__tertiaryValueTextLineHeight,1.25rem)}:host .data-table-for-securities__tag{margin-left:var(--AbstractMdsDataTable__tagLeadingMargin,8px)}:host .data-table-for-securities__multi-level-sorting{display:none;position:absolute;right:0;margin-top:var(--AbstractMdsDataTable__multiLevelSortingMenuTopPadding,4px);box-shadow:var(--AbstractMdsDataTable__multiLevelSortingMenuBoxShadowHorizontalOffset,0),var(--AbstractMdsDataTable__multiLevelSortingMenuBoxShadowVerticalOffset,2px),var(--AbstractMdsDataTable__multiLevelSortingMenuBoxShadowBlurRadius,4px),var(--AbstractMdsDataTable__multiLevelSortingMenuBoxShadowSpreadRadius,0),var(--AbstractMdsDataTable__multiLevelSortingMenuBoxShadowColor,rgba(0,0,0,.4))}:host .data-table-for-securities__multi-level-sorting--displayed{display:block!important;z-index:999}:host .data-table-for-securities__multi-level-sorting-group{margin:0;padding:0}:host .data-table-for-securities__multi-level-sorting-item__header{text-align:left;font-size:var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderTextSize,.75rem);line-height:var(----AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderLineHeight,1rem);font-weight:var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderTextWeight,600);padding:var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderTopPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderTrailingPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderBottomPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderLeadingPadding,8px);color:var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderTextColor,#565a5d);background-color:var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderBackgroundColor,#f5f7f8)}:host .data-table-for-securities__multi-level-sorting-menu-item{list-style:none;position:relative}:host .data-table-for-securities__multi-level-sorting-menu-item--selected .data-table-for-securities__multi-level-sorting-menu-item__bar{position:absolute;height:var(--AbstractMdsDataTable_multiLevelSortingMenuItem-_selected-true__multiLevelSortingMenuItemBarHeight,100%);width:var(--AbstractMdsDataTable_multiLevelSortingMenuItem-_selected-true__multiLevelSortingMenuItemBarWidth,4px)}:host .data-table-for-securities__multi-level-sorting-menu-item--selected .data-table-for-securities__multi-level-sorting-menu-item__item{font-weight:var(--AbstractMdsDataTable_multiLevelSortingMenuItem-_selected-true__multiLevelSortingMenuItemLabelTextWeight,600)}:host .data-table-for-securities__multi-level-sorting-menu-item__item{border:0;text-align:left;margin:0;width:100%;color:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__labelTextColor,#101820);font-size:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__labelTextSize,.875rem);line-height:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__labelTextLineHeight,1.25rem);font-weight:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__labelTextWeight,400);background-color:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemBackgroundColor,#fff);padding:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemTopPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemTrailingPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemBottomPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemLeadingPadding,8px)}:host .data-table-for-securities__multi-level-sorting-menu-item__item:hover{background-color:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemBackgroundColor--hovered,#f5f7f8)}:host .data-table-for-securities__multi-level-sorting-menu-item__item:focus{z-index:1}:host .data-table-for-securities__multi-level-sorting-menu-item__item:focus::-moz-focus-inner{border:0}:host .data-table-for-securities__multi-level-sorting-menu-item__item:focus:focus{outline:.0625rem dashed #717171;outline-offset:-.0625rem}:host .data-table-for-securities__row-value--left{text-align:left}:host .data-table-for-securities__row-value--right{text-align:right}:host .data-table-for-securities__secondary-tertiary-value-block{display:block}:host .data-table-for-securities__secondary-value{display:inline-block}:host .data-table-for-securities__secondary-value,:host .data-table-for-securities__tertiary-value{color:var(--MdsDataTableForTransactions__rightAlignedColumnSecondaryTertiaryTextColor,#565a5d);padding-top:var(--MdsDataTableForTransactions__rightAlignedColumnSecondaryTertiaryInterValueVerticalPadding,2px);padding-left:var(--MdsDataTableForTransactions__rightAlignedColumnSecondaryTertiaryInterValueHorizontalPadding,4px)}:host .data-table-for-securities__row-value--gain,:host .data-table-for-securities__secondary-value--gain,:host .data-table-for-securities__tertiary-value--gain{color:var(--AbstractMdsDataTable__gainTextColor,#398100)}:host .data-table-for-securities__row-value--loss,:host .data-table-for-securities__secondary-value--loss,:host .data-table-for-securities__tertiary-value--loss{color:var(--AbstractMdsDataTable__lossTextColor,#b80009)}:host .data-table-for-securities__caption{text-align:left}:host .data-table-for-securities__caption--hidden{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .data-table-for-securities__caption--block{display:table-caption;font-weight:300;font-size:var(--AbstractMdsDataTable__captionTextSize,1.125rem);margin-bottom:var(--AbstractMdsDataTable__captionBottomMargin,16px);line-height:var(--AbstractMdsDataTable__captionTextLineHeight,1.75rem)}:host .data-table-for-securities__caption--is-safari{position:absolute;top:0}:host .data-table-for-securities__caption--is-ios{display:flex}:host .data-table-for-securities__caption--stacked{font-weight:600;font-size:var(--AbstractMdsDataTable-_stacked-true__captionTextSize,.875rem);padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px);margin-top:var(--AbstractMdsDataTable-_stacked-true__captionTopMargin,8px);margin-bottom:var(--AbstractMdsDataTable-_stacked-true__captionBottomMargin,8px);line-height:var(--AbstractMdsDataTable-_stacked-true__captionTextLineHeight,1.25rem);white-space:pre-wrap}:host .data-table-for-securities__caption--stacked-footer{margin-top:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px);margin-bottom:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-securities__stacked-caption-heading{color:var(--AbstractMdsDataTable__stackedCaptionHeadingColor,#101820);font-size:var(--AbstractMdsDataTable__stackedCaptionHeadingTextSize,1.125rem);line-height:var(--AbstractMdsDataTable__stackedCaptionHeadingLineHeight,1.75rem);margin:0 0 var(--AbstractMdsDataTable__stackedCaptionHeadingBottomMargin,16px) 0}:host .data-table-for-securities__stacked-caption-heading--with-reduced-spacing{margin-bottom:calc(var(--AbstractMdsDataTable__stackedCaptionHeadingBottomMargin, 16px) - var(--AbstractMdsDataTable-_stacked-true__captionTopMargin, 8px))}:host .data-table-for-securities__stacked-caption-heading--hidden{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .data-table-for-securities__stacked-caption-heading-container{display:flex}:host .data-table-for-securities__stacked-caption-heading-container--with-checkbox{margin-top:var(--AbstractMdsDataTable-_stacked-true__captionCheckboxTopMargin,4px)}:host .data-table-for-securities__column-header--action{padding-left:var(--AbstractMdsDataTable__actionColumnLeadingPadding,16px)}:host .data-table-for-securities__column-header--action:last-child{text-align:left}:host .data-table-for-securities__empty-table{text-align:center;font-weight:400}:host .data-table-for-securities__empty-table--inline{padding-top:var(--AbstractMdsDataTable__nullMessageVerticalPaddingWithHeader,40px);padding-bottom:var(--AbstractMdsDataTable__nullMessageVerticalPaddingWithHeader,40px)}:host .data-table-for-securities__empty-table--block{padding-top:var(--AbstractMdsDataTable__nullMessageVerticalPaddingWithoutHeader,64px);padding-bottom:var(--AbstractMdsDataTable__nullMessageVerticalPaddingWithoutHeader,64px)}:host .data-table-for-securities--checkbox-no-caption{padding-top:calc(var(--MdsCheckbox__checkboxWidth, 20px) + var(--AbstractMdsDataTable-_mode-compact__verticalPadding, default-brand-get(abstract-mds-data-table-mode-compact-vertical-padding)))}:host .data-table-for-securities__caption--checkbox-offset{padding-bottom:calc(var(--MdsCheckbox__checkboxWidth, 20px) + var(--AbstractMdsDataTable-_mode-compact__verticalPadding, default-brand-get(abstract-mds-data-table-mode-compact-vertical-padding)))}:host .data-table-for-securities__column-header--checkbox{position:relative;padding-bottom:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px);padding-top:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-securities__column-header--checkbox-only{position:relative;text-align:left}:host .data-table-for-securities__column-header--checkbox-only .data-table-for-securities__checkbox{display:inline-flex;width:var(--MdsCheckbox__checkboxWidth,20px)}:host .data-table-for-securities__column-header--checkbox-only .data-table-for-securities__checkbox-descriptor{left:var(--MdsCheckbox__checkboxWidth,20px)calc(var(--AbstractMdsDataTable__columnSidePadding, default-brand-get(abstract-mds-data-table-column-side-padding))*3);top:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-securities__column-header--checkbox-only .data-table-for-securities__checkbox-descriptor--no-top-checkbox{left:var(--AbstractMdsDataTable__noGroupCheckboxDynamicDescriptionLeadingMargin,0)}:host .data-table-for-securities__column-header--no-top-checkbox-no-column-headers{padding-top:calc(var(--MdsCheckbox__checkboxWidth, 20px) + var(--AbstractMdsDataTable-_mode-compact__verticalPadding, default-brand-get(abstract-mds-data-table-mode-compact-vertical-padding)));padding-left:var(--AbstractMdsDataTable__noGroupCheckboxDynamicDescriptionLeadingMargin,0);width:-moz-max-content;width:max-content}:host .data-table-for-securities__checkbox,:host .data-table-for-securities__row-value--checkbox{width:var(--MdsCheckbox__checkboxWidth,20px)}:host .data-table-for-securities__checkbox{height:var(--MdsCheckbox__checkboxWidth,20px);padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px);padding-right:var(--AbstractMdsDataTable__columnSidePadding,8px)}:host .data-table-for-securities__checkbox--stacked{display:inline-block;margin-right:var(--AbstractMdsDataTable-_stacked-true__checkboxColumnCheckboxTrailingPadding,16px)}:host .data-table-for-securities__checkbox-descriptor{color:var(--AbstractMdsDataTable__checkboxColumnDynamicDescriptionTextColor,#101820);position:absolute;top:calc(var(--MdsCheckbox__checkboxWidth, 20px)*-1 + var(--AbstractMdsDataTable-_mode-compact__verticalPadding, default-brand-get(abstract-mds-data-table-mode-compact-vertical-padding))*-1);left:0;white-space:nowrap;line-height:var(--AbstractMdsDataTable__checkboxColumnDynamicDescriptionTextLineHeight,1.25rem);font-size:var(--AbstractMdsDataTable__checkboxColumnDynamicDescriptionTextSize,.875rem)}:host .data-table-for-securities__descriptor-term{font-weight:var(--AbstractMdsDataTable__checkboxColumnDynamicDescriptionKeyTextWeight,600);padding-right:var(--AbstractMdsDataTable__checkboxColumnDynamicDescriptionKeyTrailingPadding,4px)}:host .data-table-for-securities__descriptor-value{font-weight:var(--AbstractMdsDataTable__checkboxColumnDynamicDescriptionValueTextWeight,400)}:host .data-table-for-securities__top-stacked-checkbox-container{display:flex;padding:var(--AbstractMdsDataTable-_stacked-true__checkboxColumnDynamicDescriptionTopPadding,8px);border-bottom:var(--AbstractMdsDataTable-_stacked-true__checkboxColumnDynamicDescriptionBorderBottomWidth,2px) var(--AbstractMdsDataTable-_stacked-true__checkboxColumnDynamicDescriptionBorderBottomStyle,solid) var(--AbstractMdsDataTable-_stacked-true__checkboxColumnDynamicDescriptionBorderBottomColor)}:host .data-table-for-securities__top-stacked-checkbox-container .data-table-for-securities__checkbox{margin-right:var(--AbstractMdsDataTable-_stacked-true__checkboxColumnCheckboxTrailingPadding,16px)}:host .data-table-for-securities__top-stacked-checkbox-container .data-table-for-securities__checkbox-descriptor{white-space:normal;position:static}:host .data-table-for-securities__top-stacked-checkbox-container-no-top-checkbox{padding-left:var(--AbstractMdsDataTable__noGroupCheckboxDynamicDescriptionLeadingMargin,0)}:host .data-table-for-securities__data-table-combo-button--relaxed{padding-top:var(--AbstractMdsDataTable__comboColumnRelaxedTopPadding,8px)}:host .data-table-for-securities__buttons-container{display:flex;flex-wrap:wrap;position:relative;padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px);padding-right:var(--AbstractMdsDataTable__columnSidePadding,8px);right:var(--AbstractMdsDataTable__buttonsHorizontalPadding,8px)}:host .data-table-for-securities__buttons-container--icontext{right:calc(var(--AbstractMdsDataTable__buttonsHorizontalPadding, 8px) + .125rem)}:host .data-table-for-securities__button{padding-left:var(--AbstractMdsDataTable__buttonsHorizontalPadding,8px);padding-right:var(--AbstractMdsDataTable__buttonsHorizontalPadding,8px)}:host .data-table-for-securities__button--relaxed{padding-bottom:var(--AbstractMdsDataTable__buttonsColumnRelaxedVerticalPadding,8px);padding-top:var(--AbstractMdsDataTable__buttonsColumnRelaxedVerticalPadding,8px)}:host .data-table-for-securities__buttons-container--stacked{justify-content:flex-end;flex-wrap:nowrap;right:0}:host .data-table-for-securities__buttons-container--stacked .data-table-for-securities__button:last-child{padding-right:0}:host .data-table-for-securities__column-header--sortable .data-table-for-securities__column-header-sort-button:hover{background-color:var(--AbstractMdsDataTable__sortedColumnHeaderHoverBackgroundColor,rgba(0,94,184,.08))}:host .data-table-for-securities__column-header--sortable .data-table-for-securities__column-header-sort-button:active{background-color:var(--AbstractMdsDataTable__sortedColumnHeaderPressedBackgroundColor,rgba(0,94,184,.08))}:host .data-table-for-securities__multi-level-sorting-menu-item--selected .data-table-for-securities__multi-level-sorting-menu-item__bar{background-color:var(--AbstractMdsDataTable_MultiLevelSortingMenuItem-_selected-true__multiLevelSortingMenuItemBarColor,#005eb8)}:host .data-table-for-securities__separator{border-bottom:var(--AbstractMdsDataTable-_rowStyle-solid__width,1px) var(--AbstractMdsDataTable-_rowStyle-solid__style,solid) var(--AbstractMdsDataTable-_rowStyle-solid__color,#c1c3c3)}:host .data-table-for-securities__separator--footer{border-bottom:var(--AbstractMdsDataTable__columnHeaderBorderWidth,2px) var(--AbstractMdsDataTable-_rowStyle-solid__style,solid) var(--AbstractMdsDataTable-_rowStyle-solid__color,#c1c3c3)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/data-table-for-transactions/mds-data-table-for-transactions.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif;font-size:var(--AbstractMdsDataTable__rowHeaderTextSize,.875rem);line-height:1.25rem}:host .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .data-table-for-transactions__stacked-container{overflow:auto}:host .data-table-for-transactions__stacked-container .data-table-for-transactions{padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px)}:host .data-table-for-transactions{display:table;width:100%;position:relative;border-spacing:0}:host .data-table-for-transactions__row--relaxed .data-table-for-transactions__row-header:not(.data-table-for-transactions__row-header--select){padding-top:var(--AbstractMdsDataTable-_mode-relaxed__verticalPadding,12px);padding-bottom:var(--AbstractMdsDataTable-_mode-relaxed__verticalPadding,12px)}:host .data-table-for-transactions__row--compact .data-table-for-transactions__row-header:not(.data-table-for-transactions__row-header--select){padding-top:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px);padding-bottom:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-transactions__row--solid:not(.data-table-for-transactions__row--footer) .data-table-for-transactions__row-header{border-bottom:var(--AbstractMdsDataTable-_rowStyle-solid__width,1px) var(--AbstractMdsDataTable-_rowStyle-solid__style,solid) var(--AbstractMdsDataTable-_rowStyle-solid__color,#c1c3c3)}:host .data-table-for-transactions__row--dashed:not(.data-table-for-transactions__row--footer) .data-table-for-transactions__row-header{border-bottom:var(--AbstractMdsDataTable-_rowStyle-dashed__width,1px) var(--AbstractMdsDataTable-_rowStyle-dashed__style,dashed) var(--AbstractMdsDataTable-_rowStyle-dashed__color,#c1c3c3)}:host .data-table-for-transactions__row-header--footer{border-top:var(--AbstractMdsDataTable__columnHeaderBorderWidth,2px) solid var(--AbstractMdsDataTable__columnHeaderBorderColor,#c1c3c3)}:host .data-table-for-transactions__row-header{text-align:left;font-weight:600;display:table-cell;vertical-align:top}:host .data-table-for-transactions__column-header{font-weight:600;display:table-cell;vertical-align:bottom;text-align:right;padding:0;border-bottom:var(--AbstractMdsDataTable__columnHeaderBorderWidth,2px) solid var(--AbstractMdsDataTable__columnHeaderBorderColor,#c1c3c3)}:host .data-table-for-transactions__column-header--left,:host .data-table-for-transactions__column-header:first-child{text-align:left}:host .data-table-for-transactions__column-header--value{padding:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px) var(--AbstractMdsDataTable__columnSidePadding,8px);box-sizing:border-box}:host .data-table-for-transactions__column-header--sparkline{text-align:left}:host .data-table-for-transactions__column-header--sparkline .data-table-for-transactions__column-header--value{padding:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-transactions__column-header-action{padding-left:0}:host .data-table-for-transactions__column-header--sortable{position:relative;padding:0}:host .data-table-for-transactions__column-header-sort-button{background-color:transparent;position:absolute;top:0;margin:0;bottom:0;right:0;left:0;border:0;padding:0;width:100%}:host .data-table-for-transactions__column-header-sort-button::-moz-focus-inner{border:0}:host .data-table-for-transactions__column-header-sort-button:focus{outline:.0625rem dashed #717171}:host .data-table-for-transactions__column-header-sort-text-container{font-weight:inherit;text-align:inherit;display:inline-block;pointer-events:none;position:relative;z-index:1;width:100%;box-sizing:border-box;padding:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px) var(--AbstractMdsDataTable__columnSidePadding,8px)}:host .data-table-for-transactions__column-header-sort-text{max-width:calc(100% - 1rem)}:host .data-table-for-transactions__column-header-sort-icon{display:inline-flex;pointer-events:none;vertical-align:middle;padding-bottom:.125rem;padding-left:.125rem}:host .data-table-for-transactions__column-header-sort-icon svg{height:1em;width:1em;fill:var(--AbstractMdsDataTable__sortIconColor,#565a5d)}:host .data-table-for-transactions__row-header-container{display:flex}:host .data-table-for-transactions__row--activated:not(.data-table-for-transactions__row--footer):hover,:host .data-table-for-transactions__row--highlight{background-color:var(--AbstractMdsDataTable__rowHighlightedBackgroundColor,#eceff1)}:host .data-table-for-transactions__row--relaxed .data-table-for-transactions__row-value{padding-top:var(--AbstractMdsDataTable-_mode-relaxed__verticalPadding,12px);padding-bottom:var(--AbstractMdsDataTable-_mode-relaxed__verticalPadding,12px)}:host .data-table-for-transactions__row--compact .data-table-for-transactions__inline-caption-row,:host .data-table-for-transactions__row--compact .data-table-for-transactions__row-value,:host .data-table-for-transactions__row--relaxed .data-table-for-transactions__inline-caption-row{padding-top:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px);padding-bottom:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-transactions__row--compact .data-table-for-transactions__row-action{padding-top:0}:host .data-table-for-transactions__row--solid:not(.data-table-for-transactions__row--footer) .data-table-for-transactions__inline-caption-row,:host .data-table-for-transactions__row--solid:not(.data-table-for-transactions__row--footer) .data-table-for-transactions__row-action,:host .data-table-for-transactions__row--solid:not(.data-table-for-transactions__row--footer) .data-table-for-transactions__row-value{border-bottom:var(--AbstractMdsDataTable-_rowStyle-solid__width,1px) var(--AbstractMdsDataTable-_rowStyle-solid__style,solid) var(--AbstractMdsDataTable-_rowStyle-solid__color,#c1c3c3)}:host .data-table-for-transactions__row--dashed:not(.data-table-for-transactions__row--footer) .data-table-for-transactions__inline-caption-row,:host .data-table-for-transactions__row--dashed:not(.data-table-for-transactions__row--footer) .data-table-for-transactions__row-action,:host .data-table-for-transactions__row--dashed:not(.data-table-for-transactions__row--footer) .data-table-for-transactions__row-value{border-bottom:var(--AbstractMdsDataTable-_rowStyle-dashed__width,1px) var(--AbstractMdsDataTable-_rowStyle-dashed__style,dashed) var(--AbstractMdsDataTable-_rowStyle-dashed__color,#c1c3c3)}:host .data-table-for-transactions__row--inline-caption-row:not(.data-table-for-transactions__row--footer) .data-table-for-transactions__inline-caption-row,:host .data-table-for-transactions__row--inline-caption-row:not(.data-table-for-transactions__row--footer) .data-table-for-transactions__row-action,:host .data-table-for-transactions__row--inline-caption-row:not(.data-table-for-transactions__row--footer) .data-table-for-transactions__row-header,:host .data-table-for-transactions__row--inline-caption-row:not(.data-table-for-transactions__row--footer) .data-table-for-transactions__row-value{border-bottom:var(--AbstractMdsDataTable__columnHeaderBorderWidth,2px) solid var(--AbstractMdsDataTable__columnHeaderBorderColor,#c1c3c3)}:host .data-table-for-transactions__row-value--footer,:host .data-table-for-transactions__row-value--footer-cell{border-top:var(--AbstractMdsDataTable__columnHeaderBorderWidth,2px) solid var(--AbstractMdsDataTable__columnHeaderBorderColor,#c1c3c3)}:host .data-table-for-transactions__row-action,:host .data-table-for-transactions__row-value{padding:0;font-weight:400;display:table-cell;vertical-align:top;border-bottom:var(--AbstractMdsDataTable-_rowStyle-solid__width,1px) var(--AbstractMdsDataTable-_rowStyle-solid__style,solid) transparent;text-align:right}:host .data-table-for-transactions__row-action--text,:host .data-table-for-transactions__row-value--text{box-sizing:border-box;padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px);padding-right:var(--AbstractMdsDataTable__columnSidePadding,8px);word-break:break-word}:host .data-table-for-transactions__row-action:first-child,:host .data-table-for-transactions__row-value:first-child{text-align:left}:host .data-table-for-transactions__row-action--dashed,:host .data-table-for-transactions__row-value--dashed{border-bottom:var(--AbstractMdsDataTable-_rowStyle-dashed__width,1px) var(--AbstractMdsDataTable-_rowStyle-dashed__style,dashed) var(--AbstractMdsDataTable-_rowStyle-dashed__color,#c1c3c3)}:host .data-table-for-transactions__row-action--stacked{padding-top:var(--AbstractMdsDataTable__stackedDataTableVerticalPadding,8px)}:host .data-table-for-transactions__row-value--footer{font-weight:600;word-break:break-word;border-bottom:0;padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px);padding-right:var(--AbstractMdsDataTable__columnSidePadding,8px)}:host .data-table-for-transactions__grouping-for-secondary-tertiary-text{padding:0;margin:0;list-style-type:none}:host .data-table-for-transactions__grouping-for-secondary-tertiary-text--with-padding{padding-left:1.875rem}:host .data-table-for-transactions__alert-message{display:block}:host .data-table-for-transactions__secondary-text{color:var(--AbstractMdsDataTable__secondaryValueTextColor,#101820);list-style:none;padding-left:0;font-weight:var(--AbstractMdsDataTable__secondaryValueTextWeight,400);font-size:var(--AbstractMdsDataTable__secondaryValueTextSize,.875rem);line-height:var(--AbstractMdsDataTable__secondaryValueTextLineHeight,1.25rem)}:host .data-table-for-transactions__tertiary-text{color:var(--AbstractMdsDataTable__tertiaryValueTextColor,#565a5d);list-style:none;padding-left:0;font-weight:var(--AbstractMdsDataTable__tertiaryValueTextWeight,400);font-size:var(--AbstractMdsDataTable__tertiaryValueTextSize,.875rem);line-height:var(--AbstractMdsDataTable__tertiaryValueTextLineHeight,1.25rem)}:host .data-table-for-transactions__tag{margin-left:var(--AbstractMdsDataTable__tagLeadingMargin,8px)}:host .data-table-for-transactions__multi-level-sorting{display:none;position:absolute;right:0;margin-top:var(--AbstractMdsDataTable__multiLevelSortingMenuTopPadding,4px);box-shadow:var(--AbstractMdsDataTable__multiLevelSortingMenuBoxShadowHorizontalOffset,0),var(--AbstractMdsDataTable__multiLevelSortingMenuBoxShadowVerticalOffset,2px),var(--AbstractMdsDataTable__multiLevelSortingMenuBoxShadowBlurRadius,4px),var(--AbstractMdsDataTable__multiLevelSortingMenuBoxShadowSpreadRadius,0),var(--AbstractMdsDataTable__multiLevelSortingMenuBoxShadowColor,rgba(0,0,0,.4))}:host .data-table-for-transactions__multi-level-sorting--displayed{display:block!important;z-index:999}:host .data-table-for-transactions__multi-level-sorting-group{margin:0;padding:0}:host .data-table-for-transactions__multi-level-sorting-item__header{text-align:left;font-size:var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderTextSize,.75rem);line-height:var(----AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderLineHeight,1rem);font-weight:var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderTextWeight,600);padding:var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderTopPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderTrailingPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderBottomPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderLeadingPadding,8px);color:var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderTextColor,#565a5d);background-color:var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderBackgroundColor,#f5f7f8)}:host .data-table-for-transactions__multi-level-sorting-menu-item{list-style:none;position:relative}:host .data-table-for-transactions__multi-level-sorting-menu-item--selected .data-table-for-transactions__multi-level-sorting-menu-item__bar{position:absolute;height:var(--AbstractMdsDataTable_multiLevelSortingMenuItem-_selected-true__multiLevelSortingMenuItemBarHeight,100%);width:var(--AbstractMdsDataTable_multiLevelSortingMenuItem-_selected-true__multiLevelSortingMenuItemBarWidth,4px)}:host .data-table-for-transactions__multi-level-sorting-menu-item--selected .data-table-for-transactions__multi-level-sorting-menu-item__item{font-weight:var(--AbstractMdsDataTable_multiLevelSortingMenuItem-_selected-true__multiLevelSortingMenuItemLabelTextWeight,600)}:host .data-table-for-transactions__multi-level-sorting-menu-item__item{border:0;text-align:left;margin:0;width:100%;color:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__labelTextColor,#101820);font-size:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__labelTextSize,.875rem);line-height:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__labelTextLineHeight,1.25rem);font-weight:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__labelTextWeight,400);background-color:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemBackgroundColor,#fff);padding:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemTopPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemTrailingPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemBottomPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemLeadingPadding,8px)}:host .data-table-for-transactions__multi-level-sorting-menu-item__item:hover{background-color:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemBackgroundColor--hovered,#f5f7f8)}:host .data-table-for-transactions__multi-level-sorting-menu-item__item:focus{z-index:1}:host .data-table-for-transactions__multi-level-sorting-menu-item__item:focus::-moz-focus-inner{border:0}:host .data-table-for-transactions__multi-level-sorting-menu-item__item:focus:focus{outline:.0625rem dashed #717171;outline-offset:-.0625rem}:host .data-table-for-transactions__row-value--left{text-align:left}:host .data-table-for-transactions__row-value--right{text-align:right}:host .data-table-for-transactions__secondary-tertiary-value-block{display:block}:host .data-table-for-transactions__secondary-value{display:inline-block}:host .data-table-for-transactions__secondary-value,:host .data-table-for-transactions__tertiary-value{color:var(--MdsDataTableForTransactions__rightAlignedColumnSecondaryTertiaryTextColor,#565a5d);padding-top:var(--MdsDataTableForTransactions__rightAlignedColumnSecondaryTertiaryInterValueVerticalPadding,2px);padding-left:var(--MdsDataTableForTransactions__rightAlignedColumnSecondaryTertiaryInterValueHorizontalPadding,4px)}:host .data-table-for-transactions__row-value--gain,:host .data-table-for-transactions__secondary-value--gain,:host .data-table-for-transactions__tertiary-value--gain{color:var(--AbstractMdsDataTable__gainTextColor,#398100)}:host .data-table-for-transactions__row-value--loss,:host .data-table-for-transactions__secondary-value--loss,:host .data-table-for-transactions__tertiary-value--loss{color:var(--AbstractMdsDataTable__lossTextColor,#b80009)}:host .data-table-for-transactions__caption{text-align:left}:host .data-table-for-transactions__caption--hidden{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .data-table-for-transactions__caption--block{display:table-caption;font-weight:300;font-size:var(--AbstractMdsDataTable__captionTextSize,1.125rem);margin-bottom:var(--AbstractMdsDataTable__captionBottomMargin,16px);line-height:var(--AbstractMdsDataTable__captionTextLineHeight,1.75rem)}:host .data-table-for-transactions__caption--is-safari{position:absolute;top:0}:host .data-table-for-transactions__caption--is-ios{display:flex}:host .data-table-for-transactions__caption--stacked{font-weight:600;font-size:var(--AbstractMdsDataTable-_stacked-true__captionTextSize,.875rem);padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px);margin-top:var(--AbstractMdsDataTable-_stacked-true__captionTopMargin,8px);margin-bottom:var(--AbstractMdsDataTable-_stacked-true__captionBottomMargin,8px);line-height:var(--AbstractMdsDataTable-_stacked-true__captionTextLineHeight,1.25rem);white-space:pre-wrap}:host .data-table-for-transactions__caption--stacked-footer{margin-top:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px);margin-bottom:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-transactions__stacked-caption-heading{color:var(--AbstractMdsDataTable__stackedCaptionHeadingColor,#101820);font-size:var(--AbstractMdsDataTable__stackedCaptionHeadingTextSize,1.125rem);line-height:var(--AbstractMdsDataTable__stackedCaptionHeadingLineHeight,1.75rem);margin:0 0 var(--AbstractMdsDataTable__stackedCaptionHeadingBottomMargin,16px) 0}:host .data-table-for-transactions__stacked-caption-heading--with-reduced-spacing{margin-bottom:calc(var(--AbstractMdsDataTable__stackedCaptionHeadingBottomMargin, 16px) - var(--AbstractMdsDataTable-_stacked-true__captionTopMargin, 8px))}:host .data-table-for-transactions__stacked-caption-heading--hidden{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .data-table-for-transactions__stacked-caption-heading-container{display:flex}:host .data-table-for-transactions__stacked-caption-heading-container--with-checkbox{margin-top:var(--AbstractMdsDataTable-_stacked-true__captionCheckboxTopMargin,4px)}:host .data-table-for-transactions__column-header--action{padding-left:var(--AbstractMdsDataTable__actionColumnLeadingPadding,16px)}:host .data-table-for-transactions__column-header--action:last-child{text-align:left}:host .data-table-for-transactions__empty-table{text-align:center;font-weight:400}:host .data-table-for-transactions__empty-table--inline{padding-top:var(--AbstractMdsDataTable__nullMessageVerticalPaddingWithHeader,40px);padding-bottom:var(--AbstractMdsDataTable__nullMessageVerticalPaddingWithHeader,40px)}:host .data-table-for-transactions__empty-table--block{padding-top:var(--AbstractMdsDataTable__nullMessageVerticalPaddingWithoutHeader,64px);padding-bottom:var(--AbstractMdsDataTable__nullMessageVerticalPaddingWithoutHeader,64px)}:host .data-table-for-transactions__link{text-decoration:none;display:inline;color:var(--MdsLink__textColor,#005eb8)}:host .data-table-for-transactions__link:hover,:host .data-table-for-transactions__link:hover>span{color:var(--MdsLink__textColor--hovered,#004692)}:host .data-table-for-transactions__link:hover .data-table-for-transactions__link-icon svg,:host .data-table-for-transactions__link:hover>span .data-table-for-transactions__link-icon svg{fill:var(--MdsLink__iconColor--hovered,#002f6c)}:host .data-table-for-transactions__link:active{color:var(--MdsLink__textColor--pressed,#004692)}:host .data-table-for-transactions__link:active .data-table-for-transactions__link-icon svg{fill:var(--MdsLink__iconColor--pressed,#002f6c)}:host .data-table-for-transactions__link:focus:focus{outline:.0625rem dashed #717171}:host .data-table-for-transactions__link--trailing{white-space:nowrap}:host .data-table-for-transactions__link-icon{display:inline-flex;vertical-align:middle;padding-left:var(--MdsLink__trailingIconLeadingPadding,4px);position:relative;bottom:.0625rem}:host .data-table-for-transactions__link-icon svg{pointer-events:none;height:var(--AbstractMdsDataTable__linkNavigationIconSize,1rem);width:var(--AbstractMdsDataTable__linkNavigationIconSize,1rem);fill:var(--MdsLink__iconColor,#005eb8)}:host .data-table-for-transactions__link-icon--navigation{padding-left:var(--AbstractMdsDataTable__linkNavigationIconHorizontalPadding,14px);padding-right:var(--AbstractMdsDataTable__linkNavigationIconHorizontalPadding,14px);padding-top:var(--AbstractMdsDataTable__linkIconVerticalPadding,4px);bottom:.125rem}:host .data-table-for-transactions__link--navigation{display:flex;justify-content:center}:host .data-table-for-transactions__link--navigation-stacked{justify-content:flex-end}:host .data-table-for-transactions__link__accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .data-table-for-transactions--checkbox-no-caption{padding-top:calc(var(--MdsCheckbox__checkboxWidth, 20px) + var(--AbstractMdsDataTable-_mode-compact__verticalPadding, default-brand-get(abstract-mds-data-table-mode-compact-vertical-padding)))}:host .data-table-for-transactions__caption--checkbox-offset{padding-bottom:calc(var(--MdsCheckbox__checkboxWidth, 20px) + var(--AbstractMdsDataTable-_mode-compact__verticalPadding, default-brand-get(abstract-mds-data-table-mode-compact-vertical-padding)))}:host .data-table-for-transactions__column-header--checkbox{position:relative;padding-bottom:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px);padding-top:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-transactions__column-header--checkbox-only{position:relative;text-align:left}:host .data-table-for-transactions__column-header--checkbox-only .data-table-for-transactions__checkbox{display:inline-flex;width:var(--MdsCheckbox__checkboxWidth,20px)}:host .data-table-for-transactions__column-header--checkbox-only .data-table-for-transactions__checkbox-descriptor{left:var(--MdsCheckbox__checkboxWidth,20px)calc(var(--AbstractMdsDataTable__columnSidePadding, default-brand-get(abstract-mds-data-table-column-side-padding))*3);top:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-transactions__column-header--checkbox-only .data-table-for-transactions__checkbox-descriptor--no-top-checkbox{left:var(--AbstractMdsDataTable__noGroupCheckboxDynamicDescriptionLeadingMargin,0)}:host .data-table-for-transactions__column-header--no-top-checkbox-no-column-headers{padding-top:calc(var(--MdsCheckbox__checkboxWidth, 20px) + var(--AbstractMdsDataTable-_mode-compact__verticalPadding, default-brand-get(abstract-mds-data-table-mode-compact-vertical-padding)));padding-left:var(--AbstractMdsDataTable__noGroupCheckboxDynamicDescriptionLeadingMargin,0);width:-moz-max-content;width:max-content}:host .data-table-for-transactions__row-value--checkbox{width:var(--MdsCheckbox__checkboxWidth,20px)}:host .data-table-for-transactions__checkbox{height:var(--MdsCheckbox__checkboxWidth,20px);width:var(--MdsCheckbox__checkboxWidth,20px);padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px);padding-right:var(--AbstractMdsDataTable__columnSidePadding,8px)}:host .data-table-for-transactions__checkbox--stacked{display:inline-block;margin-right:var(--AbstractMdsDataTable-_stacked-true__checkboxColumnCheckboxTrailingPadding,16px)}:host .data-table-for-transactions__checkbox-descriptor{color:var(--AbstractMdsDataTable__checkboxColumnDynamicDescriptionTextColor,#101820);position:absolute;top:calc(var(--MdsCheckbox__checkboxWidth, 20px)*-1 + var(--AbstractMdsDataTable-_mode-compact__verticalPadding, default-brand-get(abstract-mds-data-table-mode-compact-vertical-padding))*-1);left:0;white-space:nowrap;line-height:var(--AbstractMdsDataTable__checkboxColumnDynamicDescriptionTextLineHeight,1.25rem);font-size:var(--AbstractMdsDataTable__checkboxColumnDynamicDescriptionTextSize,.875rem)}:host .data-table-for-transactions__descriptor-term{font-weight:var(--AbstractMdsDataTable__checkboxColumnDynamicDescriptionKeyTextWeight,600);padding-right:var(--AbstractMdsDataTable__checkboxColumnDynamicDescriptionKeyTrailingPadding,4px)}:host .data-table-for-transactions__descriptor-value{font-weight:var(--AbstractMdsDataTable__checkboxColumnDynamicDescriptionValueTextWeight,400)}:host .data-table-for-transactions__top-stacked-checkbox-container{display:flex;padding:var(--AbstractMdsDataTable-_stacked-true__checkboxColumnDynamicDescriptionTopPadding,8px);border-bottom:var(--AbstractMdsDataTable-_stacked-true__checkboxColumnDynamicDescriptionBorderBottomWidth,2px) var(--AbstractMdsDataTable-_stacked-true__checkboxColumnDynamicDescriptionBorderBottomStyle,solid) var(--AbstractMdsDataTable-_stacked-true__checkboxColumnDynamicDescriptionBorderBottomColor)}:host .data-table-for-transactions__top-stacked-checkbox-container .data-table-for-transactions__checkbox{margin-right:var(--AbstractMdsDataTable-_stacked-true__checkboxColumnCheckboxTrailingPadding,16px)}:host .data-table-for-transactions__top-stacked-checkbox-container .data-table-for-transactions__checkbox-descriptor{white-space:normal;position:static}:host .data-table-for-transactions__top-stacked-checkbox-container-no-top-checkbox{padding-left:var(--AbstractMdsDataTable__noGroupCheckboxDynamicDescriptionLeadingMargin,0)}:host .data-table-for-transactions__data-table-combo-button--relaxed{padding-top:var(--AbstractMdsDataTable__comboColumnRelaxedTopPadding,8px)}:host .data-table-for-transactions__buttons-container{display:flex;flex-wrap:wrap;position:relative;padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px);padding-right:var(--AbstractMdsDataTable__columnSidePadding,8px);right:var(--AbstractMdsDataTable__buttonsHorizontalPadding,8px)}:host .data-table-for-transactions__buttons-container--icontext{right:calc(var(--AbstractMdsDataTable__buttonsHorizontalPadding, 8px) + .125rem)}:host .data-table-for-transactions__button{padding-left:var(--AbstractMdsDataTable__buttonsHorizontalPadding,8px);padding-right:var(--AbstractMdsDataTable__buttonsHorizontalPadding,8px)}:host .data-table-for-transactions__button--relaxed{padding-bottom:var(--AbstractMdsDataTable__buttonsColumnRelaxedVerticalPadding,8px);padding-top:var(--AbstractMdsDataTable__buttonsColumnRelaxedVerticalPadding,8px)}:host .data-table-for-transactions__buttons-container--stacked{justify-content:flex-end;flex-wrap:nowrap;right:0}:host .data-table-for-transactions__buttons-container--stacked .data-table-for-transactions__button:last-child{padding-right:0}:host .data-table-for-transactions__row:not(.data-table-for-transactions__row--footer) .data-table-for-transactions__row-value--select{padding:var(--AbstractMdsDataTable__selectColumnCellPadding,0)}:host .data-table-for-transactions__column-header.data-table-for-transactions__column-header--select.data-table-for-transactions__column-header--left{text-align:left}:host .data-table-for-transactions__row-header--select{padding-top:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-transactions__row-header--select.data-table-for-transactions__row-header--compact{padding-bottom:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-transactions__row-header--select.data-table-for-transactions__row-header--compact .data-table-for-transactions__select-header{padding-top:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-for-transactions__row-header--select.data-table-for-transactions__row-header--relaxed{padding-bottom:var(--AbstractMdsDataTable-_mode-relaxed__verticalPadding,12px)}:host .data-table-for-transactions__row-header--select.data-table-for-transactions__row-header--relaxed .data-table-for-transactions__select-header{padding-top:var(--AbstractMdsDataTable-_mode-relaxed__verticalPadding,12px)}:host .data-table-for-transactions__row-header--select .data-table-for-transactions__select-container{display:flex}:host .data-table-for-transactions__row-header--select .data-table-for-transactions__select--stacked{width:100%}:host .data-table-for-transactions__row-header--select .data-table-for-transactions__select-header{padding-right:var(--AbstractMdsDataTable__stackedSelectTrailingPadding,16px)}:host .data-table-for-transactions__row-value--stacked{position:absolute}:host .data-table-for-transactions__column-header--sortable .data-table-for-transactions__column-header-sort-button:hover{background-color:var(--AbstractMdsDataTable__sortedColumnHeaderHoverBackgroundColor,rgba(0,94,184,.08))}:host .data-table-for-transactions__column-header--sortable .data-table-for-transactions__column-header-sort-button:active{background-color:var(--AbstractMdsDataTable__sortedColumnHeaderPressedBackgroundColor,rgba(0,94,184,.08))}:host .data-table-for-transactions__multi-level-sorting-menu-item--selected .data-table-for-transactions__multi-level-sorting-menu-item__bar{background-color:var(--AbstractMdsDataTable_MultiLevelSortingMenuItem-_selected-true__multiLevelSortingMenuItemBarColor,#005eb8)}:host .data-table-for-transactions__separator{border-bottom:var(--AbstractMdsDataTable-_rowStyle-solid__width,1px) var(--AbstractMdsDataTable-_rowStyle-solid__style,solid) var(--AbstractMdsDataTable-_rowStyle-solid__color,#c1c3c3)}:host .data-table-for-transactions__separator--footer{border-bottom:var(--AbstractMdsDataTable__columnHeaderBorderWidth,2px) var(--AbstractMdsDataTable-_rowStyle-solid__style,solid) var(--AbstractMdsDataTable-_rowStyle-solid__color,#c1c3c3)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/data-table-simple/mds-data-table-simple.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif;font-size:var(--AbstractMdsDataTable__rowHeaderTextSize,.875rem);line-height:1.25rem}:host .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .data-table-simple__stacked-container{overflow:auto}:host .data-table-simple__stacked-container .data-table-simple{padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px)}:host .data-table-simple{display:table;width:100%;position:relative;border-spacing:0}:host .data-table-simple__row--relaxed .data-table-simple__row-header:not(.data-table-simple__row-header--select){padding-top:var(--AbstractMdsDataTable-_mode-relaxed__verticalPadding,12px);padding-bottom:var(--AbstractMdsDataTable-_mode-relaxed__verticalPadding,12px)}:host .data-table-simple__row--compact .data-table-simple__row-header:not(.data-table-simple__row-header--select){padding-top:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px);padding-bottom:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-simple__row--solid:not(.data-table-simple__row--footer) .data-table-simple__row-header{border-bottom:var(--AbstractMdsDataTable-_rowStyle-solid__width,1px) var(--AbstractMdsDataTable-_rowStyle-solid__style,solid) var(--AbstractMdsDataTable-_rowStyle-solid__color,#c1c3c3)}:host .data-table-simple__row--dashed:not(.data-table-simple__row--footer) .data-table-simple__row-header{border-bottom:var(--AbstractMdsDataTable-_rowStyle-dashed__width,1px) var(--AbstractMdsDataTable-_rowStyle-dashed__style,dashed) var(--AbstractMdsDataTable-_rowStyle-dashed__color,#c1c3c3)}:host .data-table-simple__row-header--footer{border-top:var(--AbstractMdsDataTable__columnHeaderBorderWidth,2px) solid var(--AbstractMdsDataTable__columnHeaderBorderColor,#c1c3c3)}:host .data-table-simple__row-header{text-align:left;font-weight:600;display:table-cell;vertical-align:top}:host .data-table-simple__column-header{font-weight:600;display:table-cell;vertical-align:bottom;text-align:right;padding:0;border-bottom:var(--AbstractMdsDataTable__columnHeaderBorderWidth,2px) solid var(--AbstractMdsDataTable__columnHeaderBorderColor,#c1c3c3)}:host .data-table-simple__column-header--left,:host .data-table-simple__column-header:first-child{text-align:left}:host .data-table-simple__column-header--value{padding:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px) var(--AbstractMdsDataTable__columnSidePadding,8px);box-sizing:border-box}:host .data-table-simple__column-header--sparkline{text-align:left}:host .data-table-simple__column-header--sparkline .data-table-simple__column-header--value{padding:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-simple__column-header-action{padding-left:0}:host .data-table-simple__column-header--sortable{position:relative;padding:0}:host .data-table-simple__column-header-sort-button{background-color:transparent;position:absolute;top:0;margin:0;bottom:0;right:0;left:0;border:0;padding:0;width:100%}:host .data-table-simple__column-header-sort-button::-moz-focus-inner{border:0}:host .data-table-simple__column-header-sort-button:focus{outline:.0625rem dashed #717171}:host .data-table-simple__column-header-sort-text-container{font-weight:inherit;text-align:inherit;display:inline-block;pointer-events:none;position:relative;z-index:1;width:100%;box-sizing:border-box;padding:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px) var(--AbstractMdsDataTable__columnSidePadding,8px)}:host .data-table-simple__column-header-sort-text{max-width:calc(100% - 1rem)}:host .data-table-simple__column-header-sort-icon{display:inline-flex;pointer-events:none;vertical-align:middle;padding-bottom:.125rem;padding-left:.125rem}:host .data-table-simple__column-header-sort-icon svg{height:1em;width:1em;fill:var(--AbstractMdsDataTable__sortIconColor,#565a5d)}:host .data-table-simple__row-header-container{display:flex}:host .data-table-simple__row--activated:not(.data-table-simple__row--footer):hover,:host .data-table-simple__row--highlight{background-color:var(--AbstractMdsDataTable__rowHighlightedBackgroundColor,#eceff1)}:host .data-table-simple__row--relaxed .data-table-simple__row-value{padding-top:var(--AbstractMdsDataTable-_mode-relaxed__verticalPadding,12px);padding-bottom:var(--AbstractMdsDataTable-_mode-relaxed__verticalPadding,12px)}:host .data-table-simple__row--compact .data-table-simple__inline-caption-row,:host .data-table-simple__row--compact .data-table-simple__row-value,:host .data-table-simple__row--relaxed .data-table-simple__inline-caption-row{padding-top:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px);padding-bottom:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-simple__row--compact .data-table-simple__row-action{padding-top:0}:host .data-table-simple__row--solid:not(.data-table-simple__row--footer) .data-table-simple__inline-caption-row,:host .data-table-simple__row--solid:not(.data-table-simple__row--footer) .data-table-simple__row-action,:host .data-table-simple__row--solid:not(.data-table-simple__row--footer) .data-table-simple__row-value{border-bottom:var(--AbstractMdsDataTable-_rowStyle-solid__width,1px) var(--AbstractMdsDataTable-_rowStyle-solid__style,solid) var(--AbstractMdsDataTable-_rowStyle-solid__color,#c1c3c3)}:host .data-table-simple__row--dashed:not(.data-table-simple__row--footer) .data-table-simple__inline-caption-row,:host .data-table-simple__row--dashed:not(.data-table-simple__row--footer) .data-table-simple__row-action,:host .data-table-simple__row--dashed:not(.data-table-simple__row--footer) .data-table-simple__row-value{border-bottom:var(--AbstractMdsDataTable-_rowStyle-dashed__width,1px) var(--AbstractMdsDataTable-_rowStyle-dashed__style,dashed) var(--AbstractMdsDataTable-_rowStyle-dashed__color,#c1c3c3)}:host .data-table-simple__row--inline-caption-row:not(.data-table-simple__row--footer) .data-table-simple__inline-caption-row,:host .data-table-simple__row--inline-caption-row:not(.data-table-simple__row--footer) .data-table-simple__row-action,:host .data-table-simple__row--inline-caption-row:not(.data-table-simple__row--footer) .data-table-simple__row-header,:host .data-table-simple__row--inline-caption-row:not(.data-table-simple__row--footer) .data-table-simple__row-value{border-bottom:var(--AbstractMdsDataTable__columnHeaderBorderWidth,2px) solid var(--AbstractMdsDataTable__columnHeaderBorderColor,#c1c3c3)}:host .data-table-simple__row-value--footer,:host .data-table-simple__row-value--footer-cell{border-top:var(--AbstractMdsDataTable__columnHeaderBorderWidth,2px) solid var(--AbstractMdsDataTable__columnHeaderBorderColor,#c1c3c3)}:host .data-table-simple__row-action,:host .data-table-simple__row-value{padding:0;font-weight:400;display:table-cell;vertical-align:top;border-bottom:var(--AbstractMdsDataTable-_rowStyle-solid__width,1px) var(--AbstractMdsDataTable-_rowStyle-solid__style,solid) transparent;text-align:right}:host .data-table-simple__row-action--text,:host .data-table-simple__row-value--text{box-sizing:border-box;padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px);padding-right:var(--AbstractMdsDataTable__columnSidePadding,8px);word-break:break-word}:host .data-table-simple__row-action:first-child,:host .data-table-simple__row-value:first-child{text-align:left}:host .data-table-simple__row-action--dashed,:host .data-table-simple__row-value--dashed{border-bottom:var(--AbstractMdsDataTable-_rowStyle-dashed__width,1px) var(--AbstractMdsDataTable-_rowStyle-dashed__style,dashed) var(--AbstractMdsDataTable-_rowStyle-dashed__color,#c1c3c3)}:host .data-table-simple__row-action--stacked{padding-top:var(--AbstractMdsDataTable__stackedDataTableVerticalPadding,8px)}:host .data-table-simple__row-value--footer{font-weight:600;word-break:break-word;border-bottom:0;padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px);padding-right:var(--AbstractMdsDataTable__columnSidePadding,8px)}:host .data-table-simple__grouping-for-secondary-tertiary-text{padding:0;margin:0;list-style-type:none}:host .data-table-simple__grouping-for-secondary-tertiary-text--with-padding{padding-left:1.875rem}:host .data-table-simple__alert-message{display:block}:host .data-table-simple__secondary-text{color:var(--AbstractMdsDataTable__secondaryValueTextColor,#101820);list-style:none;padding-left:0;font-weight:var(--AbstractMdsDataTable__secondaryValueTextWeight,400);font-size:var(--AbstractMdsDataTable__secondaryValueTextSize,.875rem);line-height:var(--AbstractMdsDataTable__secondaryValueTextLineHeight,1.25rem)}:host .data-table-simple__tertiary-text{color:var(--AbstractMdsDataTable__tertiaryValueTextColor,#565a5d);list-style:none;padding-left:0;font-weight:var(--AbstractMdsDataTable__tertiaryValueTextWeight,400);font-size:var(--AbstractMdsDataTable__tertiaryValueTextSize,.875rem);line-height:var(--AbstractMdsDataTable__tertiaryValueTextLineHeight,1.25rem)}:host .data-table-simple__tag{margin-left:var(--AbstractMdsDataTable__tagLeadingMargin,8px)}:host .data-table-simple__multi-level-sorting{display:none;position:absolute;right:0;margin-top:var(--AbstractMdsDataTable__multiLevelSortingMenuTopPadding,4px);box-shadow:var(--AbstractMdsDataTable__multiLevelSortingMenuBoxShadowHorizontalOffset,0),var(--AbstractMdsDataTable__multiLevelSortingMenuBoxShadowVerticalOffset,2px),var(--AbstractMdsDataTable__multiLevelSortingMenuBoxShadowBlurRadius,4px),var(--AbstractMdsDataTable__multiLevelSortingMenuBoxShadowSpreadRadius,0),var(--AbstractMdsDataTable__multiLevelSortingMenuBoxShadowColor,rgba(0,0,0,.4))}:host .data-table-simple__multi-level-sorting--displayed{display:block!important;z-index:999}:host .data-table-simple__multi-level-sorting-group{margin:0;padding:0}:host .data-table-simple__multi-level-sorting-item__header{text-align:left;font-size:var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderTextSize,.75rem);line-height:var(----AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderLineHeight,1rem);font-weight:var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderTextWeight,600);padding:var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderTopPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderTrailingPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderBottomPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderLeadingPadding,8px);color:var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderTextColor,#565a5d);background-color:var(--AbstractMdsDataTable_multiLevelSortingGroup__customMenuItemHeaderBackgroundColor,#f5f7f8)}:host .data-table-simple__multi-level-sorting-menu-item{list-style:none;position:relative}:host .data-table-simple__multi-level-sorting-menu-item--selected .data-table-simple__multi-level-sorting-menu-item__bar{position:absolute;height:var(--AbstractMdsDataTable_multiLevelSortingMenuItem-_selected-true__multiLevelSortingMenuItemBarHeight,100%);width:var(--AbstractMdsDataTable_multiLevelSortingMenuItem-_selected-true__multiLevelSortingMenuItemBarWidth,4px)}:host .data-table-simple__multi-level-sorting-menu-item--selected .data-table-simple__multi-level-sorting-menu-item__item{font-weight:var(--AbstractMdsDataTable_multiLevelSortingMenuItem-_selected-true__multiLevelSortingMenuItemLabelTextWeight,600)}:host .data-table-simple__multi-level-sorting-menu-item__item{border:0;text-align:left;margin:0;width:100%;color:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__labelTextColor,#101820);font-size:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__labelTextSize,.875rem);line-height:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__labelTextLineHeight,1.25rem);font-weight:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__labelTextWeight,400);background-color:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemBackgroundColor,#fff);padding:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemTopPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemTrailingPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemBottomPadding,8px) var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemLeadingPadding,8px)}:host .data-table-simple__multi-level-sorting-menu-item__item:hover{background-color:var(--AbstractMdsDataTable_multiLevelSortingMenuItem__multiLevelSortingMenuItemBackgroundColor--hovered,#f5f7f8)}:host .data-table-simple__multi-level-sorting-menu-item__item:focus{z-index:1}:host .data-table-simple__multi-level-sorting-menu-item__item:focus::-moz-focus-inner{border:0}:host .data-table-simple__multi-level-sorting-menu-item__item:focus:focus{outline:.0625rem dashed #717171;outline-offset:-.0625rem}:host .data-table-simple__row-value--left{text-align:left}:host .data-table-simple__row-value--right{text-align:right}:host .data-table-simple__secondary-tertiary-value-block{display:block}:host .data-table-simple__secondary-value{display:inline-block}:host .data-table-simple__secondary-value,:host .data-table-simple__tertiary-value{color:var(--MdsDataTableForTransactions__rightAlignedColumnSecondaryTertiaryTextColor,#565a5d);padding-top:var(--MdsDataTableForTransactions__rightAlignedColumnSecondaryTertiaryInterValueVerticalPadding,2px);padding-left:var(--MdsDataTableForTransactions__rightAlignedColumnSecondaryTertiaryInterValueHorizontalPadding,4px)}:host .data-table-simple__row-value--gain,:host .data-table-simple__secondary-value--gain,:host .data-table-simple__tertiary-value--gain{color:var(--AbstractMdsDataTable__gainTextColor,#398100)}:host .data-table-simple__row-value--loss,:host .data-table-simple__secondary-value--loss,:host .data-table-simple__tertiary-value--loss{color:var(--AbstractMdsDataTable__lossTextColor,#b80009)}:host .data-table-simple__caption{text-align:left}:host .data-table-simple__caption--hidden{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .data-table-simple__caption--block{display:table-caption;font-weight:300;font-size:var(--AbstractMdsDataTable__captionTextSize,1.125rem);margin-bottom:var(--AbstractMdsDataTable__captionBottomMargin,16px);line-height:var(--AbstractMdsDataTable__captionTextLineHeight,1.75rem)}:host .data-table-simple__caption--is-safari{position:absolute;top:0}:host .data-table-simple__caption--is-ios{display:flex}:host .data-table-simple__caption--stacked{font-weight:600;font-size:var(--AbstractMdsDataTable-_stacked-true__captionTextSize,.875rem);padding-left:var(--AbstractMdsDataTable__columnSidePadding,8px);margin-top:var(--AbstractMdsDataTable-_stacked-true__captionTopMargin,8px);margin-bottom:var(--AbstractMdsDataTable-_stacked-true__captionBottomMargin,8px);line-height:var(--AbstractMdsDataTable-_stacked-true__captionTextLineHeight,1.25rem);white-space:pre-wrap}:host .data-table-simple__caption--stacked-footer{margin-top:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px);margin-bottom:var(--AbstractMdsDataTable-_mode-compact__verticalPadding,4px)}:host .data-table-simple__stacked-caption-heading{color:var(--AbstractMdsDataTable__stackedCaptionHeadingColor,#101820);font-size:var(--AbstractMdsDataTable__stackedCaptionHeadingTextSize,1.125rem);line-height:var(--AbstractMdsDataTable__stackedCaptionHeadingLineHeight,1.75rem);margin:0 0 var(--AbstractMdsDataTable__stackedCaptionHeadingBottomMargin,16px) 0}:host .data-table-simple__stacked-caption-heading--with-reduced-spacing{margin-bottom:calc(var(--AbstractMdsDataTable__stackedCaptionHeadingBottomMargin, 16px) - var(--AbstractMdsDataTable-_stacked-true__captionTopMargin, 8px))}:host .data-table-simple__stacked-caption-heading--hidden{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .data-table-simple__stacked-caption-heading-container{display:flex}:host .data-table-simple__stacked-caption-heading-container--with-checkbox{margin-top:var(--AbstractMdsDataTable-_stacked-true__captionCheckboxTopMargin,4px)}:host .data-table-simple__empty-table{text-align:center;font-weight:400}:host .data-table-simple__empty-table--inline{padding-top:var(--AbstractMdsDataTable__nullMessageVerticalPaddingWithHeader,40px);padding-bottom:var(--AbstractMdsDataTable__nullMessageVerticalPaddingWithHeader,40px)}:host .data-table-simple__empty-table--block{padding-top:var(--AbstractMdsDataTable__nullMessageVerticalPaddingWithoutHeader,64px);padding-bottom:var(--AbstractMdsDataTable__nullMessageVerticalPaddingWithoutHeader,64px)}:host .data-table-simple__column-header--sortable .data-table-simple__column-header-sort-button:hover{background-color:var(--AbstractMdsDataTable__sortedColumnHeaderHoverBackgroundColor,rgba(0,94,184,.08))}:host .data-table-simple__column-header--sortable .data-table-simple__column-header-sort-button:active{background-color:var(--AbstractMdsDataTable__sortedColumnHeaderPressedBackgroundColor,rgba(0,94,184,.08))}:host .data-table-simple__multi-level-sorting-menu-item--selected .data-table-simple__multi-level-sorting-menu-item__bar{background-color:var(--AbstractMdsDataTable_MultiLevelSortingMenuItem-_selected-true__multiLevelSortingMenuItemBarColor,#005eb8)}:host .data-table-simple__separator{border-bottom:var(--AbstractMdsDataTable-_rowStyle-solid__width,1px) var(--AbstractMdsDataTable-_rowStyle-solid__style,solid) var(--AbstractMdsDataTable-_rowStyle-solid__color,#c1c3c3)}:host .data-table-simple__separator--footer{border-bottom:var(--AbstractMdsDataTable__columnHeaderBorderWidth,2px) var(--AbstractMdsDataTable-_rowStyle-solid__style,solid) var(--AbstractMdsDataTable-_rowStyle-solid__color,#c1c3c3)}:host .data-table-simple__column-header--alert{text-align:left}:host .data-table-simple__row-value--alert{text-align:left;padding-left:8px;padding-right:8px}:host .empty-alert-cell{display:none}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/date-badge/mds-date-badge.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .date-badge{display:inline-block}:host .date-badge__frame{display:inline-block;border-radius:var(--MdsDateBadge__borderRadius,8px);border-style:solid;border-width:var(--MdsDateBadge__iconBorderWidth,1px);position:relative;background-color:var(--MdsDateBadge__backgroundColor,#fff)}:host .date-badge__month{font-weight:var(--MdsDateBadge__monthTextWeight,400);color:var(--MdsDateBadge__monthTextColor,#565a5d)}:host .date-badge__day{font-weight:var(--MdsDateBadge__dayTextWeight,600);line-height:var(--MdsDateBadge__dayLineHeight,1.25rem);font-size:var(--MdsDateBadge__dayTextSize,.875rem);color:var(--MdsDateBadge__dayTextColor,#101820)}:host .date-badge__status{font-size:var(--MdsDateBadge__statusLabelTextSize,.75rem);line-height:var(--MdsDateBadge__statusLabelLineHeight,1rem);font-weight:var(--MdsDateBadge__statusLabelTextWeight,400);color:var(--MdsDateBadge__statusLabelTextColor,#565a5d)}:host .date-badge__icon{display:inline-flex;position:absolute;z-index:1;right:calc(var(--MdsDateBadge__iconSize, 16px)/2*-1 + var(--MdsDateBadge__iconBorderWidth, 1px)*-1);border-radius:50%;background-color:var(--MdsDateBadge__backgroundColor,#fff)}:host .date-badge__icon svg{height:var(--MdsDateBadge__iconSize,16px);width:var(--MdsDateBadge__iconSize,16px)}:host .date-badge--horizontal .date-badge__month{line-height:var(--MdsDateBadge-_layout-horizontal__monthLineHeight,1.25rem);font-size:var(--MdsDateBadge-_layout-horizontal__monthTextSize,.875rem)}:host .date-badge--horizontal .date-badge__frame{display:inline-flex;padding:var(--MdsDateBadge-_layout-horizontal__topPadding,4px) var(--MdsDateBadge-_layout-horizontal__trailingPadding,10px) var(--MdsDateBadge-_layout-horizontal__bottomPadding,4px) var(--MdsDateBadge-_layout-horizontal__leadingPadding,8px)}:host .date-badge--horizontal .date-badge__day{margin-left:var(--MdsDateBadge-_layout-horizontal__dayLeadingMargin,4px)}:host .date-badge--horizontal .date-badge__status{margin-left:calc(var(--MdsDateBadge__iconSize, 16px)/2 + var(--MdsDateBadge-_layout-horizontal-_statusLabel-true__leadingMargin, 2px))}:host .date-badge--horizontal .date-badge__icon{bottom:50%;transform:translateY(50%)}:host .date-badge--vertical .date-badge__frame{padding:var(--MdsDateBadge-_layout-vertical__topPadding,4px) var(--MdsDateBadge-_layout-vertical__trailingPadding,8px) var(--MdsDateBadge-_layout-vertical__bottomPadding,8px) var(--MdsDateBadge-_layout-vertical__leadingPadding,8px)}:host .date-badge--vertical .date-badge__month{line-height:var(--MdsDateBadge-_layout-vertical__monthLineHeight,1rem);font-size:var(--MdsDateBadge-_layout-vertical__monthTextSize,.75rem);display:block}:host .date-badge--vertical .date-badge__day{display:block;text-align:center}:host .date-badge--vertical .date-badge__status{text-align:center;display:block;margin-top:var(--MdsDateBadge-_layout-vertical__statusLabelTopMargin,2px)}:host .date-badge--vertical .date-badge__icon{bottom:var(--MdsDateBadge-_layout-vertical__iconBottomMargin,10px)}:host .date-badge--informational .date-badge__frame{border-color:var(--MdsDateBadge-_level-informational__borderColor,#8c8e90)}:host .date-badge--informational.date-badge--horizontal .date-badge__frame{padding-right:var(--MdsDateBadge-_level-informational-_layout-horizontal__trailingPadding,8px)}:host .date-badge--informational.date-badge--horizontal .date-badge__status{margin-left:var(--MdsDateBadge-_level-informational-_layout-horizontal-_statusLabel-true__leadingMargin,4px)}:host .date-badge--error .date-badge__frame{border-color:var(--MdsDateBadge-_level-error__borderColor,#b80009)}:host .date-badge--error .date-badge__status{color:var(--MdsDateBadge-_level-error-_statusLabel-true__textColor,#b80009)}:host .date-badge--error .date-badge__icon svg{fill:var(--MdsDateBadge-_level-error__borderColor,#b80009)}:host .date-badge--success .date-badge__icon svg{fill:var(--MdsDateBadge-_level-success__borderColor,#4ea000)}:host .date-badge--success .date-badge__frame{border-color:var(--MdsDateBadge-_level-success__borderColor,#4ea000)}:host .date-badge--soft .date-badge__icon svg{fill:var(--MdsDateBadge-_level-soft__borderColor,#e35205)}:host .date-badge--soft .date-badge__frame{border-color:var(--MdsDateBadge-_level-soft__borderColor,#e35205)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/datepicker/mds-datepicker.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, '@keyframes show-opacity{0%{opacity:var(--MdsDatepicker__openAnimationStartingOpacity,0)}to{opacity:var(--MdsDatepicker__openAnimationEndingOpacity,1)}}@keyframes show-margin{0%{margin-top:calc(var(--MdsDatepicker__containerTopMargin, 4px)*-1)}to{margin-top:0}}:host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .datepicker{position:relative}:host .datepicker__accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .datepicker__calendar{position:absolute;padding-bottom:var(--MdsDatepicker__bottomPadding,);z-index:99999;animation:show-margin calc(var(--MdsDatePicker__openAnimationTiming, .2s)/2) ease 0s forwards,show-opacity var(--MdsDatePicker__openAnimationTiming,.2s) ease 0s forwards;min-width:var(--MdsDatepicker__minContainerWidth,320px);max-width:var(--MdsDatepicker__maxContainerWidth,356px);width:100%;background-color:var(--MdsDatepicker__containerBackgroundColor,#fff);box-shadow:var(--MdsDatepicker__containerBoxShadowHorizontalOffset,0) var(--MdsDatepicker__containerBoxShadowVerticalOffset,2px) var(--MdsDatepicker__containerBoxShadowBlurRadius,3px) var(--MdsDatepicker__containerBoxShadowSpreadRadius,0) var(--MdsDatepicker__containerBoxShadowColor,rgba(0,0,0,.28));border:var(--MdsDatepicker__containerBorderWidth,1px) var(--MdsDatepicker__containerBorderStyle,solid) var(--MdsDatepicker__containerBorderColor,#c1c3c3)}:host .datepicker__calendar-heading{display:flex;justify-content:space-between;padding:var(--MdsDatepicker__headerTopMargin,16px) var(--MdsDatepicker__headerTrailingMargin,16px) var(--MdsDatepicker__headingDayHeaderTopMargin,12px) var(--MdsDatepicker__headerLeadingMargin,16px);position:relative}:host .datepicker__calendar-heading-title{font-size:var(--MdsDatepicker__monthYearTextSize,1.125rem);font-weight:var(--MdsDatepicker__monthYearTextWeight,300);line-height:var(--MdsDatepicker__monthYearLineHeight,1.75rem);text-align:var(--MdsDatepicker__monthYearTextAlignment,center);text-transform:capitalize;margin:calc(var(--MdsButton__minHeight, 36px)/2 - var(--MdsDatepicker__monthYearLineHeight, 28px)/2) 0 0 0;color:var(--MdsDatepicker__monthYearTextColor,#101820)}:host .datepicker__calendar-heading-button:last-child{margin-left:.0625rem}:host .datepicker__calendar-heading-button-container{display:flex;align-items:flex-start;align-self:flex-start}:host .datepicker__calendar-heading:not(.datepicker__calendar-heading--monthpicker):after{content:"";position:absolute;border-width:0;left:0;right:0;bottom:calc(var(--MdsDatepicker__dateTableCellTextLineHeight, 1.5rem)*-1);border-bottom:var(--MdsDatepicker__headingSeparatorWidth,1px) var(--MdsDatepicker__headingSeparatorColor,#c1c3c3);border-style:var(--MdsDatepicker__headingSeparatorStyle,solid)}:host .datepicker__calendar-table{border-spacing:2px 10px;border-collapse:separate;padding-left:.25rem;padding-right:.25rem;margin:auto}:host .datepicker__calendar-table-heading-day{width:var(--MdsDatepicker__headingDayTableCellWidth,44px);font-size:var(--MdsDatepicker__headingDayTextSize,.75rem);font-weight:var(--MdsDatepicker__headingDayTextWeight,300);line-height:0;text-transform:capitalize;color:var(--MdsDatepicker__headingDayTextColor,#565a5d)}:host .datepicker__calendar-table-row{height:calc(var(--MdsDatepicker__dateTableCellHeight, 54px) - 10px)}:host .datepicker__calendar-table-cell{padding:0;border:calc(var(--MdsDatepicker__dateTableCellWidth, 44px)/2 - var(--MdsDatepicker__dateTableCellCircleWidth, 28px)/2) var(--MdsDatepicker__containerBorderStyle,solid) var(--MdsDatepicker__containerBackgroundColor,#fff);position:relative}:host .datepicker__calendar-table-cell--enabled{cursor:pointer}:host .datepicker__calendar-table-cell--enabled .datepicker__calendar-table-cell-circle--today{box-shadow:inset 0 0 0 var(--MdsDatepicker__dateTableCellCircleBorderWidth,1px) var(--MdsDatepicker__dateTableCellCircleTodayBorderColor,#005eb8)}:host .datepicker__calendar-table-cell--enabled .datepicker__calendar-table-cell-circle--selected{background-color:var(--MdsDatepicker__dateTableCellCircleBackgroundColor--selected,#005eb8)}:host .datepicker__calendar-table-cell--enabled:hover .datepicker__calendar-table-cell-circle{box-shadow:inset 0 0 0 var(--MdsDatepicker__dateTableCellCircleBorderWidth,1px) var(--MdsDatepicker__dateTableCellCircleBackgroundColor--hovered,#004692);background-color:var(--MdsDatepicker__dateTableCellCircleBackgroundColor--hovered,#004692);color:var(--MdsDatepicker__dateTableCellTextColor--hovered,#fff)}:host .datepicker__calendar-table-cell--enabled:active .datepicker__calendar-table-cell-circle{box-shadow:inset 0 0 0 var(--MdsDatepicker__dateTableCellCircleBorderWidth,1px) var(--MdsDatepicker__dateTableCellCircleBackgroundColor--pressed,#0091da);background-color:var(--MdsDatepicker__dateTableCellCircleBackgroundColor--pressed,#0091da)}:host .datepicker__calendar-table-cell--disabled{cursor:default;pointer-events:none}:host .datepicker__calendar-table-cell--disabled .datepicker__calendar-table-cell-circle--today{color:var(--MdsDatepicker__todayOnBlockedDateTextColor,#565a5d);box-shadow:inset 0 0 0 var(--MdsDatepicker__dateTableCellCircleBorderWidth,1px) var(--MdsDatepicker__todayOnBlockedDateCircleBorderColor,#005eb8)}:host .datepicker__calendar-table-cell--disabled .datepicker__calendar-table-cell-circle--selected{color:var(--MdsDatepicker__dateTableCellTextColor--disabled,#565a5d)}:host .datepicker__calendar-table-cell--disabled .datepicker__calendar-table-cell-circle--due{color:var(--MdsDatepicker__dueOnBlockedDateTextColor,#565a5d);box-shadow:inset 0 0 0 var(--MdsDatepicker__dateTableCellCircleBorderWidth,1px) var(--MdsDatepicker__dueOnBlockedDateCircleBorderColor,#8c8e90)}:host .datepicker__calendar-table-cell--disabled .datepicker__calendar-table-cell-circle--due--today{color:var(--MdsDatepicker__todayAndBlockedOnDueDateTextColor,#565a5d);box-shadow:inset 0 0 0 var(--MdsDatepicker__dateTableCellCircleBorderWidth,1px) var(--MdsDatepicker__todayAndBlockedOnDueDateCircleBorderColor,#005eb8)}:host .datepicker__calendar-table-cell-circle{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);font-size:var(--MdsDatepicker__dateTableCellTextSize,1rem);font-weight:var(--MdsDatepicker__dateTableCellTextFontWeight,400);border-radius:50%;width:var(--MdsDatepicker__dateTableCellCircleWidth,28px);height:var(--MdsDatepicker__dateTableCellCircleWidth,28px);line-height:var(--MdsDatepicker__dateTableCellTextLineHeight,1.5rem);text-align:var(--MdsDatepicker__dateTableCellTextAlignment,center);padding:0;border:0;cursor:pointer;color:var(--MdsDatepicker__dateTableCellTextColor,#101820);background-color:var(--MdsDatepicker__containerBackgroundColor,#fff)}:host .datepicker__calendar-table-cell-circle--due{box-shadow:inset 0 0 0 var(--MdsDatepicker__dateTableCellCircleBorderWidth,1px) var(--MdsDatepicker__dateTableCellCircleDueBorderColor,#565a5d)}:host .datepicker__calendar-table-cell-circle:focus{outline:.0625rem dashed #717171}:host .datepicker__calendar-table-cell-circle:focus::-moz-focus-inner{border:0}:host .datepicker__calendar-table-cell-circle--disabled{font-weight:var(--MdsDatepicker__dateTableCellTextFontWeight--disabled,300);cursor:default;pointer-events:none;color:var(--MdsDatepicker__dateTableCellTextColor--disabled,#565a5d)}:host .datepicker__calendar-table-cell-circle--selected{box-shadow:none;color:var(--MdsDatepicker__dateTableCellTextColor--selected,#fff)}:host .datepicker__calendar-table-cell-text{position:absolute;top:var(--MdsDatepicker__dateTableCellCircleWidth,28px);left:50%;transform:translateX(-50%);font-size:var(--MdsDatepicker__dateTableCellCircleBottomTextSize,.75rem);font-weight:var(--MdsDatepicker__dateTableCellCircleBottomTextWeight,400);text-transform:uppercase;pointer-events:none;white-space:nowrap;color:var(--MdsDatepicker__dateTableCellCircleBottomTextColor,#101820)}:host .datepicker__calendar-table-cell-tooltip{position:absolute;width:var(--MdsDatepicker__tooltipMaxWidth,160px);cursor:default;top:2rem}:host .datepicker__calendar-table-cell-tooltip[alignment=center]{left:-4.125rem}:host .datepicker__calendar-table-cell-tooltip[alignment=left]{left:-.125rem}:host .datepicker__calendar-table-cell-tooltip[alignment=right]{left:-8.125rem}:host .datepicker__calendar-table-cell-tooltip[tooltip-placement=above]{top:.25rem}:host .datepicker__calendar-table-cell-tooltip--text-below[tooltip-placement=below]{top:2.75rem}:host .datepicker__calendar-footer{display:flex;flex-direction:row-reverse;justify-content:space-between;margin:calc(var(--MdsDatepicker__footerTopMargin, 8px) + .5rem) var(--MdsDatepicker__footerTrailingMargin,16px) var(--MdsDatepicker__footerBottomMargin,16px) var(--MdsDatepicker__footerLeadingMargin,16px)}:host .datepicker__calendar-footer--monthpicker{margin-top:0}:host .datepicker__month-grid{display:flex;flex-wrap:wrap;padding:16px 16px 8px;background-color:var(--MdsDatepicker__containerBackgroundColor,#fff);border:solid var(--MdsDatepicker__headingSeparatorColor,#c1c3c3);border-width:1px 0 0}:host .datepicker__month-grid-row{display:flex;width:100%}:host .datepicker__month{flex-basis:25%;display:flex;justify-content:center;height:var(--MdsDatepicker__monthBlockHeight,54px);position:relative}:host .datepicker__month-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;margin-top:var(--MdsDatepicker__monthButtonTopMargin,6px);min-width:var(--MdsDatepicker__monthButtonMinWidth,56px);height:var(--MdsDatepicker__monthButtonHeight,28px);border:var(--MdsDatepicker__dateTableCellCircleBorderWidth,1px) solid transparent;border-radius:var(--MdsDatepicker__monthButtonBorderRadius,4px);font-size:var(--MdsDatepicker__dateTableCellTextSize,1rem);font-weight:var(--MdsDatepicker__dateTableCellTextFontWeight,400);cursor:pointer;background-color:var(--MdsDatepicker__containerBackgroundColor,#fff);color:var(--MdsDatepicker__dateTableCellTextColor,#101820)}:host .datepicker__month-button:disabled{font-weight:var(--MdsDatepicker__dateTableCellTextFontWeight--disabled,300);cursor:default;color:var(--MdsDatepicker__dateTableCellTextColor--disabled,#565a5d)}:host .datepicker__month-button--selected:not(:disabled),:host .datepicker__month-button:active,:host .datepicker__month-button:hover{color:var(--MdsDatepicker__containerBackgroundColor,#fff)}:host .datepicker__month-button:hover:not(:disabled){background-color:var(--MdsDatepicker__dateTableCellCircleBackgroundColor--hovered,#004692);box-shadow:none}:host .datepicker__month-button:active{background-color:var(--MdsDatepicker__dateTableCellCircleBackgroundColor--pressed,#0091da);box-shadow:none}:host .datepicker__month-button--selected{background-color:var(--MdsDatepicker__dateTableCellCircleBackgroundColor--selected,#005eb8);box-shadow:none}:host .datepicker__month-button--current{box-shadow:inset 0 0 0 var(--MdsDatepicker__dateTableCellCircleBorderWidth,1px) var(--MdsDatepicker__dateTableCellCircleTodayBorderColor,#005eb8)}:host .datepicker__month-button--due{box-shadow:inset 0 0 0 var(--MdsDatepicker__dateTableCellCircleBorderWidth,1px) var(--MdsDatepicker__dateTableCellCircleDueBorderColor,#565a5d)}:host .datepicker__month-button:focus{outline:.0625rem dashed #717171}:host .datepicker__month-button:focus::-moz-focus-inner{border:0}:host .datepicker__month-caption{position:absolute;top:calc(var(--MdsDatepicker__monthButtonHeight, 28px) + var(--MdsDatepicker__monthButtonTopMargin, 6px));left:50%;transform:translateX(-50%);font-size:var(--MdsDatepicker__dateTableCellCircleBottomTextSize,.75rem);font-weight:var(--MdsDatepicker__dateTableCellCircleBottomTextWeight,400);text-transform:uppercase;pointer-events:none;white-space:nowrap;color:var(--MdsDatepicker__dateTableCellCircleBottomTextColor,#101820)}@keyframes flash{0%{background-color:var(--MdsDatepicker__containerBackgroundColor,#fff);color:var(--MdsDatepicker__dateTableCellTextColor,#101820)}50%{background-color:var(--MdsDatepicker__dateTableCellCircleTodayFillAnimationColor,#005eb8);color:var(--MdsDatepicker__dateTableCellTextColor--selected,#fff)}to{background-color:var(--MdsDatepicker__containerBackgroundColor,#fff);color:var(--MdsDatepicker__dateTableCellTextColor,#101820)}}:host(mds-datepicker[inactive=true]){pointer-events:none}', "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/description-list/mds-description-list.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host{display:block}:host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif;box-sizing:border-box}:host dd,:host dl,:host dt{margin:0}:host .description-list__item{display:flex;color:var(--MdsDescriptionList__textColor,#101820);font-size:var(--MdsDescriptionList__textSize,.875rem);font-weight:var(--MdsDescriptionList__textWeight,400);line-height:var(--MdsDescriptionList__textLineHeight,1.25rem);padding-top:var(--MdsDescriptionList__itemTopPadding,8px);padding-bottom:var(--MdsDescriptionList__itemBottomPadding,8px)}:host .description-list__item-term{padding-right:var(--MdsDescriptionList__termTextTrailingPadding,16px);text-align:left}:host .description-list__item-term-content{display:inline}:host .description-list__item-term-content--tagged{padding-right:var(--MdsDescriptionList__tagLeadingMargin,8px)}:host .description-list__item-term-tag{display:inline-block}:host .description-list__item-term--bold{font-weight:var(--MdsDescriptionList__textWeightBold,600)}:host .description-list__item-description{text-align:var(--MdsDescriptionList__descriptionHorizontalTextAlignment,left);word-break:break-word}:host .description-list__item-description--alignment-right{text-align:var(--MdsDescriptionList-_descriptionAlignment-right__descriptionHorizontalTextAlignment,right)}:host .description-list__item-description--bold{font-weight:var(--MdsDescriptionList__textWeightBold,600)}:host .description-list__item-description--positive{color:var(--MdsDescriptionList__positiveTextColor,#398100)}:host .description-list__item-description--negative{color:var(--MdsDescriptionList__negativeTextColor,#b80009)}:host .description-list__item-separator{display:inline-flex;justify-content:center;width:var(--MdsDescriptionList__verticalSeparatorWidth,8px);margin-left:var(--MdsDescriptionList__verticalSeparatorHorizontalMargin,8px)}:host .description-list__item--compact{padding-top:var(--MdsDescriptionList-_mode-compact__itemTopPadding,4px);padding-bottom:var(--MdsDescriptionList-_mode-compact__itemBottomPadding,4px)}:host .description-list__item--horizontal-rule{border-left-color:var(--MdsDescriptionList__horizontalRuleBorderColor,#c1c3c3);border-bottom:var(--MdsDescriptionList__horizontalRuleBorderBottomWidth,1px) var(--MdsDescriptionList__horizontalRuleBorderBottomStyle,solid) var(--MdsDescriptionList__horizontalRuleBorderColor,#c1c3c3);border-right-color:var(--MdsDescriptionList__horizontalRuleBorderColor,#c1c3c3);border-top-color:var(--MdsDescriptionList__horizontalRuleBorderColor,#c1c3c3)}:host .description-list__item--vertical{flex-direction:column}:host .description-list__item--vertical .description-list__item-term{margin-bottom:var(--MdsDescriptionList-_itemLayout-vertical__termBottomMargin,4px);padding-right:var(--MdsDescriptionList__termTextTrailingPadding,16px)}:host .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/dialog/mds-dialog.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ':host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .mds-dialog{position:fixed;top:0;right:0;left:0;bottom:0;z-index:100000;align-items:flex-end;justify-content:flex-end}:host .mds-dialog__backdrop{height:100%;width:100%;opacity:.8;z-index:-1;background-color:var(--MdsDialog__overlayColor,rgba(0,0,0,.8))}:host .mds-dialog__panel-container{display:flex;flex-direction:column;overflow-x:hidden;overflow-y:hidden;height:100%;width:100%;left:50%;top:50%;transform:translate(-50%,-50%);position:absolute;background-color:var(--MdsDialog__dialogWindowBackgroundColor,#fff);box-shadow:var(--MdsDialog__dialogWindowShadowHorizontalOffset,0) var(--MdsDialog__dialogWindowShadowVerticalOffset,0) var(--MdsDialog__dialogWindowShadowBlurRadius,4px) var(--MdsDialog__dialogWindowShadowSpreadRadius,0) var(--MdsDialog__dialogWindowShadowColor,rgba(0,0,0,.35))}:host .mds-dialog--slide-out .mds-dialog__backdrop{opacity:0}:host .mds-dialog--slide-out .mds-dialog__panel-container{right:-100%}:host .mds-dialog__title-container:focus{outline:.0625rem dashed #717171}:host .mds-dialog__heading{display:inline-block;color:var(--MdsDialog__headerTextColor,#101820);font-size:var(--MdsDialog__headerTextColor,1rem);line-height:var(--MdsDialog__headerTextLineHeight,1.5rem);font-weight:var(--MdsDialog__headerTextWeight,600);margin:0;height:100%}:host .mds-dialog__heading--hidden{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .mds-dialog__main{box-sizing:border-box;flex-grow:1;flex-shrink:1;flex-basis:100%;width:100vw;max-width:100%;overflow:auto;color:var(--MdsDialog__dialogContentTextColor,#101820);font-size:var(--MdsDialog__dialogContentTextSize,.875rem);line-height:var(--MdsDialog__dialogContentTextLineHeight,1.25rem);font-weight:var(--MdsDialog__dialogContentTextWeight,400);padding:var(--MdDialog__headerIconLeadingMargin,16px);-webkit-overflow-scrolling:touch}:host .mds-dialog__main:focus{outline:.0625rem dashed #717171}:host .mds-dialog__sticky-footer{width:100%;position:relative}:host .mds-dialog__icon{margin-right:var(--MdsDialog__headerIconTrailingMargin,8px)}:host .mds-dialog__icon svg{height:var(--MdsDialog__headerIconHeight,24px);width:var(--MdsDialog__headerIconWidth,24px);fill:var(--MdsDialog__headerIconColor,#565a5d)}:host .mds-dialog__header-container{display:flex;padding:var(--MdsDialog__headerContainerPadding,16px);position:relative}:host .mds-dialog__header-container:after{content:"";position:absolute;top:0;bottom:0;left:0;right:0;opacity:0;z-index:-1;transition-property:opacity;transition-duration:var(--MdsDialog__headerShadowTransitionDuration,.2s);transition-timing-function:var(--MdsDialog__headerShadowTransitionEase,cubic-bezier(.4,0,.2,1));box-shadow:var(--MdsDialog__headerShadowHorizontalOffset,0) var(--MdsDialog__headerShadowVerticalOffset,0) var(--MdsDialog__headerShadowBlueRadius,4px) var(--MdsDialog__headerShadowSpreadRadius,0) var(--MdsDialog__headerShadowColor,rgba(0,0,0,.35))}:host .mds-dialog__header-container--hidden{padding:0}:host .mds-dialog__header-container--scrolled:after{opacity:1}:host .mds-dialog .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}@media (min-width:48.5rem){:host .mds-dialog__panel-container{max-height:calc(100% - var(--MdsDialog__dialogWindowMargin, 72px)*2);max-width:calc(100% - var(--MdsDialog__dialogWindowMargin, 72px)*2);width:auto;height:auto;border-radius:var(--MdsDialog__dialogWindowBorderRadius,4px)}}', "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/document-viewer/mds-document-viewer.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host .document-viewer{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif;position:relative;width:100%}:host .document-viewer__title{color:var(--MdsDocumentViewer__titleTextColor,#101820);font-size:var(--MdsDocumentViewer__titleTextSize,1.5rem);line-height:var(--MdsDocumentViewer__titleLineHeight,2rem);font-weight:var(--MdsDocumentViewer__titleTextWeight,300);padding-bottom:var(--MdsDocumentViewer__titleBottomMargin,8px)}:host .document-viewer__title--hidden{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .document-viewer__description{color:var(--MdsDocumentViewer__descriptionTextColor,#101820);font-size:var(--MdsDocumentViewer__descriptionTextSize,1rem);line-height:var(--MdsDocumentViewer__descriptionLineHeight,1.5rem);font-weight:var(--MdsDocumentViewer__descriptionTextWeight,400);padding-bottom:var(--MdsDocumentViewer__descriptionBottomMargin,8px)}:host .document-viewer__button{position:absolute;right:0}:host .document-viewer__empty-tab-bar{height:calc(var(--MdsTabBar_tab__verticalPadding, 8px) + var(--MdsTabBar_tab__verticalPadding, 8px) + var(--MdsTabBar_tab__textLineHeight, 1.25rem) - var(--MdsDocumentViewer__tabBarBottomMargin, 8px))}:host .document-viewer__iframe{margin-top:var(--MdsDocumentViewer__tabBarBottomMargin,8px);width:100%;box-sizing:border-box;display:block;overflow:scroll;border:var(--MdsDocumentViewer__viewerBorderStyle,solid) var(--MdsDocumentViewer__viewerBorderWeight,1px) var(--MdsDocumentViewer__viewerBorderColor,#8c8e90)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/drop-zone/mds-drop-zone.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif;box-sizing:border-box}:host .drop-zone{min-width:var(--MdsDropZone__containerMinWidth,280px)}:host .drop-zone__input-wrapper{display:flex;justify-content:center;align-items:center;position:relative;border:var(--MdsDropZone__containerBorderWidth,1px) var(--MdsDropZone__containerBorderStyle--active,solid) transparent;border-radius:calc(var(--MdsDropZone__containerBorderRadius, 4px) - .0625rem)}:host .drop-zone__border{border-radius:var(--MdsDropZone__containerBorderRadius,4px);padding:.0625rem}:host .drop-zone__label{text-align:var(--MdsDropZone__labelTextAlignment,left);font-size:var(--MdsDropZone__labelTextSize,1rem);font-weight:var(--MdsDropZone__labelTextTextWeight,400);line-height:var(--MdsDropZone__labelTextLineHeight,1.5rem);padding-bottom:var(--MdsDropZone__labelTextBottomPadding,4px)}:host .drop-zone__input{position:absolute;width:100%;top:0;bottom:0;left:0;right:0;opacity:0}:host .drop-zone__button{z-index:1}:host .drop-zone__microcopy{padding-top:var(--MdsDropZone__microcopyKeyTextTitleTopPadding,8px);display:flex}:host .drop-zone__microcopy-key{font-size:var(--MdsDropZone__microcopyKeyTextSize,.875rem);font-weight:var(--MdsDropZone__microcopyKeyTextWeight,600);line-height:var(--MdsDropZone__microcopyKeyTextLineHeight,1.25rem);margin:0}:host .drop-zone__microcopy-value{font-size:var(--MdsDropZone__microcopyValueTextSize,.75rem);font-weight:var(--MdsDropZone__microcopyValueTextWeight,400);line-height:var(--MdsDropZone__microcopyValueTextLineHeight,1rem);padding-top:var(--MdsDropZone__microcopyValueTextTopPadding,4px);margin:0}:host .drop-zone__accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .drop-zone__label{color:var(--MdsDropZone__labelTextColor,#565a5d)}:host .drop-zone__microcopy-key{color:var(--MdsDropZone__microcopyKeyTextColor,#565a5d)}:host .drop-zone__microcopy-value{color:var(--MdsDropZone__microcopyValueTextColor,#565a5d)}:host .drop-zone__border{height:var(--MdsDropZone__containerHeight,80px);background:repeating-linear-gradient(90deg,var(--MdsDropZone__containerBorderColor,#005eb8),var(--MdsDropZone__containerBorderColor,#005eb8) 50%,transparent 0,transparent),repeating-linear-gradient(90deg,var(--MdsDropZone__containerBorderColor,#005eb8),var(--MdsDropZone__containerBorderColor,#005eb8) 50%,transparent 0,transparent),repeating-linear-gradient(180deg,var(--MdsDropZone__containerBorderColor,#005eb8),var(--MdsDropZone__containerBorderColor,#005eb8) 50%,transparent 0,transparent),repeating-linear-gradient(180deg,var(--MdsDropZone__containerBorderColor,#005eb8),var(--MdsDropZone__containerBorderColor,#005eb8) 50%,transparent 0,transparent);background-position:0 0,0 100%,0 0,100% 0;background-repeat:repeat-x,repeat-x,repeat-y,repeat-y;background-size:.625rem var(--MdsDropZone__containerBorderWidth,1px),.625rem var(--MdsDropZone__containerBorderWidth,1px),var(--MdsDropZone__containerBorderWidth,1px) .625rem,var(--MdsDropZone__containerBorderWidth,1px) .625rem}:host .drop-zone__border:active{background:var(--MdsDropZone__containerBorderColor--active,#0091da)}:host .drop-zone__border:focus-within:not(:active):not(.drop-zone--valid){outline:.0625rem dashed #717171}:host .drop-zone__border:focus-within:not(:active):not(.drop-zone--valid) .drop-zone__input-wrapper .drop-zone__icon svg{fill:var(--MdsDropZone__iconColor--focused,#005eb8)}:host .drop-zone__input-wrapper{height:calc(var(--MdsDropZone__containerHeight, default-brand-get(mds-drop-zone-container-height)) - var(--MdsDropZone__containerBorderWidth, default-brand-get(mds-drop-zone-container-border-width))*2);background-color:var(--MdsDropZone__containerBackgroundColor,#fff)}:host .drop-zone__input-wrapper:active{background-color:var(--MdsDropZone__containerBackgroundColor--active,#eaf6ff)}:host .drop-zone__input-wrapper:active .drop-zone__icon svg{fill:var(--MdsDropZone__iconColor--active,#005eb8)}:host .drop-zone--disabled .drop-zone__label{color:var(--MdsDropZone__labelTextColor--disabled,#8c8e90)}:host .drop-zone--disabled .drop-zone__microcopy-key{color:var(--MdsDropZone__microcopyKeyTextColor--disabled,#8c8e90)}:host .drop-zone--disabled .drop-zone__microcopy-value{color:var(--MdsDropZone__microcopyValueTextColor--disabled,#8c8e90)}:host .drop-zone--disabled .drop-zone__border{background-image:repeating-linear-gradient(90deg,var(--MdsDropZone__containerBorderColor--disabled,#8c8e90),var(--MdsDropZone__containerBorderColor--disabled,#8c8e90) 50%,transparent 0,transparent),repeating-linear-gradient(90deg,var(--MdsDropZone__containerBorderColor--disabled,#8c8e90),var(--MdsDropZone__containerBorderColor--disabled,#8c8e90) 50%,transparent 0,transparent),repeating-linear-gradient(180deg,var(--MdsDropZone__containerBorderColor--disabled,#8c8e90),var(--MdsDropZone__containerBorderColor--disabled,#8c8e90) 50%,transparent 0,transparent),repeating-linear-gradient(180deg,var(--MdsDropZone__containerBorderColor--disabled,#8c8e90),var(--MdsDropZone__containerBorderColor--disabled,#8c8e90) 50%,transparent 0,transparent)}:host .drop-zone--disabled .drop-zone__input-wrapper{background-color:var(--MdsDropZone__containerBackgroundColor--disabled,#fff)}:host .drop-zone--disabled .drop-zone__icon svg{fill:var(--MdsDropZone__iconColor--disabled,#8c8e90)}:host .drop-zone--disabled .drop-zone__input{cursor:auto}:host .drop-zone--drag .drop-zone__border{background-image:repeating-linear-gradient(90deg,var(--MdsDropZone__containerBorderColor--hovered,#004692),var(--MdsDropZone__containerBorderColor--hovered,#004692) 50%,transparent 0,transparent),repeating-linear-gradient(90deg,var(--MdsDropZone__containerBorderColor--hovered,#004692),var(--MdsDropZone__containerBorderColor--hovered,#004692) 50%,transparent 0,transparent),repeating-linear-gradient(180deg,var(--MdsDropZone__containerBorderColor--hovered,#004692),var(--MdsDropZone__containerBorderColor--hovered,#004692) 50%,transparent 0,transparent),repeating-linear-gradient(180deg,var(--MdsDropZone__containerBorderColor--hovered,#004692),var(--MdsDropZone__containerBorderColor--hovered,#004692) 50%,transparent 0,transparent)}:host .drop-zone--drag .drop-zone__input-wrapper{background-color:var(--MdsDropZone__containerBackgroundColor--hovered,rgba(0,94,184,.08))}:host .drop-zone--drag .drop-zone__icon svg{fill:var(--MdsDropZone__iconColor--hovered,#004692)}:host .drop-zone--drag .drop-zone__input{z-index:2}:host .drop-zone__icon svg{fill:var(--MdsDropZone__iconColor,#565a5d)}:host(mds-drop-zone[inactive=true]){pointer-events:none}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/expandable-text/mds-expandable-text.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif;display:flex}:host .expandable-text{width:100%}:host .expandable-text-label{text-align:left}:host .expandable-text-container{width:100%}:host .expandable-text-button{font:inherit;cursor:pointer;display:inline-flex;align-items:baseline;background-color:transparent;outline:none;border:0;padding:.125em 0;transform:translateY(.125em);color:var(--MdsExpandableText__labelTextColor,#005eb8)}:host .expandable-text-button:focus{outline:.0625rem dashed #717171}:host .expandable-text-button--regular{color:var(--MdsExpandableText-_textColor-textColorRegular__labelTextColor,#101820)}:host .expandable-text-button--disabled{color:var(--MdsExpandableText__labelTextColor--disabled,#565a5d);cursor:unset}:host .expandable-text-button--disabled .expandable-text-icon svg{fill:var(--MdsExpandableText__iconColor--disabled,#c1c3c3)}:host .expandable-text-button::-moz-focus-inner{border:0}:host .expandable-text-leading-text-content{padding-right:.25em}:host .expandable-text-revealed-content-container{display:none;z-index:1;opacity:0;overflow:hidden;transition-property:height;transition-duration:.2s;transition-timing-function:cubic-bezier(0,.2,.1,1)}:host .expandable-text-revealed-content-container--expanded{opacity:1}:host .expandable-text-revealed-content-container--collapsing{animation-name:panel-opacity;animation-duration:.2s;animation-delay:0s;animation-timing-function:cubic-bezier(0,.2,.1,1);animation-fill-mode:forwards}@keyframes panel-opacity{0%{opacity:1}to{opacity:0}}:host .expandable-text-revealed-content-container--transitioned{opacity:1}:host .expandable-text-icon{margin-right:var(--MdsExpandableText__iconTrailingMargin,4px);transform:translateY(.125em)}:host .expandable-text-icon--expanded{transform:rotate(90deg)}:host .expandable-text-icon svg{height:1em;width:1em;fill:var(--MdsExpandableText__iconColor,#005eb8)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/fieldset/mds-fieldset.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ".mds-container{box-sizing:border-box;margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px;width:100%}@media print,screen and (min-width:576px){.mds-container{max-width:540px}}@media print,screen and (min-width:768px){.mds-container{max-width:720px}}@media print,screen and (min-width:992px){.mds-container{max-width:960px}}@media print,screen and (min-width:1200px){.mds-container{max-width:1140px}}.mds-container-at-576,.mds-container-at-768,.mds-container-at-992,.mds-container-at-1200,.mds-container-fluid{box-sizing:border-box;margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px;width:100%}@media print,screen and (min-width:576px){.mds-container,.mds-container-at-576{max-width:var(--mds-container-max-width-at-576,540px)}}@media print,screen and (min-width:768px){.mds-container,.mds-container-at-576,.mds-container-at-768{max-width:var(--mds-container-max-width-at-768,720px)}}@media print,screen and (min-width:992px){.mds-container,.mds-container-at-576,.mds-container-at-768,.mds-container-at-992{max-width:var(--mds-container-max-width-at-992,960px)}}@media print,screen and (min-width:1200px){.mds-container,.mds-container-at-576,.mds-container-at-768,.mds-container-at-992,.mds-container-at-1200{max-width:var(--mds-container-max-width-at-1200,1140px)}}.mds-row{display:flex;flex-wrap:wrap;margin-left:-15px;margin-right:-15px}.mds-no-gutters{margin-left:0;margin-right:0}.mds-no-gutters>.mds-col,.mds-no-gutters>[class*=mds-col-]{padding-left:0;padding-right:0}.mds-col,.mds-col-1,.mds-col-2,.mds-col-3,.mds-col-4,.mds-col-5,.mds-col-6,.mds-col-7,.mds-col-8,.mds-col-9,.mds-col-10,.mds-col-11,.mds-col-12,.mds-col-at-576,.mds-col-at-576-1,.mds-col-at-576-2,.mds-col-at-576-3,.mds-col-at-576-4,.mds-col-at-576-5,.mds-col-at-576-6,.mds-col-at-576-7,.mds-col-at-576-8,.mds-col-at-576-9,.mds-col-at-576-10,.mds-col-at-576-11,.mds-col-at-576-12,.mds-col-at-576-auto,.mds-col-at-768,.mds-col-at-768-1,.mds-col-at-768-2,.mds-col-at-768-3,.mds-col-at-768-4,.mds-col-at-768-5,.mds-col-at-768-6,.mds-col-at-768-7,.mds-col-at-768-8,.mds-col-at-768-9,.mds-col-at-768-10,.mds-col-at-768-11,.mds-col-at-768-12,.mds-col-at-768-auto,.mds-col-at-992,.mds-col-at-992-1,.mds-col-at-992-2,.mds-col-at-992-3,.mds-col-at-992-4,.mds-col-at-992-5,.mds-col-at-992-6,.mds-col-at-992-7,.mds-col-at-992-8,.mds-col-at-992-9,.mds-col-at-992-10,.mds-col-at-992-11,.mds-col-at-992-12,.mds-col-at-992-auto,.mds-col-at-1200,.mds-col-at-1200-1,.mds-col-at-1200-2,.mds-col-at-1200-3,.mds-col-at-1200-4,.mds-col-at-1200-5,.mds-col-at-1200-6,.mds-col-at-1200-7,.mds-col-at-1200-8,.mds-col-at-1200-9,.mds-col-at-1200-10,.mds-col-at-1200-11,.mds-col-at-1200-12,.mds-col-at-1200-auto,.mds-col-auto{box-sizing:border-box;position:relative;width:100%;padding-left:8px;padding-right:8px}@media print,screen and (min-width:576px){.mds-col,.mds-col-1,.mds-col-2,.mds-col-3,.mds-col-4,.mds-col-5,.mds-col-6,.mds-col-7,.mds-col-8,.mds-col-9,.mds-col-10,.mds-col-11,.mds-col-12,.mds-col-at-576,.mds-col-at-576-1,.mds-col-at-576-2,.mds-col-at-576-3,.mds-col-at-576-4,.mds-col-at-576-5,.mds-col-at-576-6,.mds-col-at-576-7,.mds-col-at-576-8,.mds-col-at-576-9,.mds-col-at-576-10,.mds-col-at-576-11,.mds-col-at-576-12,.mds-col-at-576-auto,.mds-col-at-768,.mds-col-at-768-1,.mds-col-at-768-2,.mds-col-at-768-3,.mds-col-at-768-4,.mds-col-at-768-5,.mds-col-at-768-6,.mds-col-at-768-7,.mds-col-at-768-8,.mds-col-at-768-9,.mds-col-at-768-10,.mds-col-at-768-11,.mds-col-at-768-12,.mds-col-at-768-auto,.mds-col-at-992,.mds-col-at-992-1,.mds-col-at-992-2,.mds-col-at-992-3,.mds-col-at-992-4,.mds-col-at-992-5,.mds-col-at-992-6,.mds-col-at-992-7,.mds-col-at-992-8,.mds-col-at-992-9,.mds-col-at-992-10,.mds-col-at-992-11,.mds-col-at-992-12,.mds-col-at-992-auto,.mds-col-at-1200,.mds-col-at-1200-1,.mds-col-at-1200-2,.mds-col-at-1200-3,.mds-col-at-1200-4,.mds-col-at-1200-5,.mds-col-at-1200-6,.mds-col-at-1200-7,.mds-col-at-1200-8,.mds-col-at-1200-9,.mds-col-at-1200-10,.mds-col-at-1200-11,.mds-col-at-1200-12,.mds-col-at-1200-auto,.mds-col-auto{padding-left:8px;padding-right:8px}}@media print,screen and (min-width:768px){.mds-col,.mds-col-1,.mds-col-2,.mds-col-3,.mds-col-4,.mds-col-5,.mds-col-6,.mds-col-7,.mds-col-8,.mds-col-9,.mds-col-10,.mds-col-11,.mds-col-12,.mds-col-at-576,.mds-col-at-576-1,.mds-col-at-576-2,.mds-col-at-576-3,.mds-col-at-576-4,.mds-col-at-576-5,.mds-col-at-576-6,.mds-col-at-576-7,.mds-col-at-576-8,.mds-col-at-576-9,.mds-col-at-576-10,.mds-col-at-576-11,.mds-col-at-576-12,.mds-col-at-576-auto,.mds-col-at-768,.mds-col-at-768-1,.mds-col-at-768-2,.mds-col-at-768-3,.mds-col-at-768-4,.mds-col-at-768-5,.mds-col-at-768-6,.mds-col-at-768-7,.mds-col-at-768-8,.mds-col-at-768-9,.mds-col-at-768-10,.mds-col-at-768-11,.mds-col-at-768-12,.mds-col-at-768-auto,.mds-col-at-992,.mds-col-at-992-1,.mds-col-at-992-2,.mds-col-at-992-3,.mds-col-at-992-4,.mds-col-at-992-5,.mds-col-at-992-6,.mds-col-at-992-7,.mds-col-at-992-8,.mds-col-at-992-9,.mds-col-at-992-10,.mds-col-at-992-11,.mds-col-at-992-12,.mds-col-at-992-auto,.mds-col-at-1200,.mds-col-at-1200-1,.mds-col-at-1200-2,.mds-col-at-1200-3,.mds-col-at-1200-4,.mds-col-at-1200-5,.mds-col-at-1200-6,.mds-col-at-1200-7,.mds-col-at-1200-8,.mds-col-at-1200-9,.mds-col-at-1200-10,.mds-col-at-1200-11,.mds-col-at-1200-12,.mds-col-at-1200-auto,.mds-col-auto{padding-left:12px;padding-right:12px}}@media print,screen and (min-width:992px){.mds-col,.mds-col-1,.mds-col-2,.mds-col-3,.mds-col-4,.mds-col-5,.mds-col-6,.mds-col-7,.mds-col-8,.mds-col-9,.mds-col-10,.mds-col-11,.mds-col-12,.mds-col-at-576,.mds-col-at-576-1,.mds-col-at-576-2,.mds-col-at-576-3,.mds-col-at-576-4,.mds-col-at-576-5,.mds-col-at-576-6,.mds-col-at-576-7,.mds-col-at-576-8,.mds-col-at-576-9,.mds-col-at-576-10,.mds-col-at-576-11,.mds-col-at-576-12,.mds-col-at-576-auto,.mds-col-at-768,.mds-col-at-768-1,.mds-col-at-768-2,.mds-col-at-768-3,.mds-col-at-768-4,.mds-col-at-768-5,.mds-col-at-768-6,.mds-col-at-768-7,.mds-col-at-768-8,.mds-col-at-768-9,.mds-col-at-768-10,.mds-col-at-768-11,.mds-col-at-768-12,.mds-col-at-768-auto,.mds-col-at-992,.mds-col-at-992-1,.mds-col-at-992-2,.mds-col-at-992-3,.mds-col-at-992-4,.mds-col-at-992-5,.mds-col-at-992-6,.mds-col-at-992-7,.mds-col-at-992-8,.mds-col-at-992-9,.mds-col-at-992-10,.mds-col-at-992-11,.mds-col-at-992-12,.mds-col-at-992-auto,.mds-col-at-1200,.mds-col-at-1200-1,.mds-col-at-1200-2,.mds-col-at-1200-3,.mds-col-at-1200-4,.mds-col-at-1200-5,.mds-col-at-1200-6,.mds-col-at-1200-7,.mds-col-at-1200-8,.mds-col-at-1200-9,.mds-col-at-1200-10,.mds-col-at-1200-11,.mds-col-at-1200-12,.mds-col-at-1200-auto,.mds-col-auto{padding-left:12px;padding-right:12px}}@media print,screen and (min-width:1200px){.mds-col,.mds-col-1,.mds-col-2,.mds-col-3,.mds-col-4,.mds-col-5,.mds-col-6,.mds-col-7,.mds-col-8,.mds-col-9,.mds-col-10,.mds-col-11,.mds-col-12,.mds-col-at-576,.mds-col-at-576-1,.mds-col-at-576-2,.mds-col-at-576-3,.mds-col-at-576-4,.mds-col-at-576-5,.mds-col-at-576-6,.mds-col-at-576-7,.mds-col-at-576-8,.mds-col-at-576-9,.mds-col-at-576-10,.mds-col-at-576-11,.mds-col-at-576-12,.mds-col-at-576-auto,.mds-col-at-768,.mds-col-at-768-1,.mds-col-at-768-2,.mds-col-at-768-3,.mds-col-at-768-4,.mds-col-at-768-5,.mds-col-at-768-6,.mds-col-at-768-7,.mds-col-at-768-8,.mds-col-at-768-9,.mds-col-at-768-10,.mds-col-at-768-11,.mds-col-at-768-12,.mds-col-at-768-auto,.mds-col-at-992,.mds-col-at-992-1,.mds-col-at-992-2,.mds-col-at-992-3,.mds-col-at-992-4,.mds-col-at-992-5,.mds-col-at-992-6,.mds-col-at-992-7,.mds-col-at-992-8,.mds-col-at-992-9,.mds-col-at-992-10,.mds-col-at-992-11,.mds-col-at-992-12,.mds-col-at-992-auto,.mds-col-at-1200,.mds-col-at-1200-1,.mds-col-at-1200-2,.mds-col-at-1200-3,.mds-col-at-1200-4,.mds-col-at-1200-5,.mds-col-at-1200-6,.mds-col-at-1200-7,.mds-col-at-1200-8,.mds-col-at-1200-9,.mds-col-at-1200-10,.mds-col-at-1200-11,.mds-col-at-1200-12,.mds-col-at-1200-auto,.mds-col-auto{padding-left:12px;padding-right:12px}}.mds-col{flex-basis:0;flex-grow:1;max-width:100%}.mds-col-auto{flex:0 0 auto;max-width:100%;width:auto}.mds-col-1{flex:0 0 8.33333%;max-width:8.33333%}.mds-col-2{flex:0 0 16.66667%;max-width:16.66667%}.mds-col-3{flex:0 0 25%;max-width:25%}.mds-col-4{flex:0 0 33.33333%;max-width:33.33333%}.mds-col-5{flex:0 0 41.66667%;max-width:41.66667%}.mds-col-6{flex:0 0 50%;max-width:50%}.mds-col-7{flex:0 0 58.33333%;max-width:58.33333%}.mds-col-8{flex:0 0 66.66667%;max-width:66.66667%}.mds-col-9{flex:0 0 75%;max-width:75%}.mds-col-10{flex:0 0 83.33333%;max-width:83.33333%}.mds-col-11{flex:0 0 91.66667%;max-width:91.66667%}.mds-col-12{flex:0 0 100%;max-width:100%}.mds-offset-1{margin-left:8.33333%}.mds-offset-2{margin-left:16.66667%}.mds-offset-3{margin-left:25%}.mds-offset-4{margin-left:33.33333%}.mds-offset-5{margin-left:41.66667%}.mds-offset-6{margin-left:50%}.mds-offset-7{margin-left:58.33333%}.mds-offset-8{margin-left:66.66667%}.mds-offset-9{margin-left:75%}.mds-offset-10{margin-left:83.33333%}.mds-offset-11{margin-left:91.66667%}@media print,screen and (min-width:576px){.mds-col-at-576{flex-basis:0;flex-grow:1;max-width:100%}.mds-col-at-576-auto{flex:0 0 auto;max-width:100%;width:auto}.mds-col-at-576-1{flex:0 0 8.33333%;max-width:8.33333%}.mds-col-at-576-2{flex:0 0 16.66667%;max-width:16.66667%}.mds-col-at-576-3{flex:0 0 25%;max-width:25%}.mds-col-at-576-4{flex:0 0 33.33333%;max-width:33.33333%}.mds-col-at-576-5{flex:0 0 41.66667%;max-width:41.66667%}.mds-col-at-576-6{flex:0 0 50%;max-width:50%}.mds-col-at-576-7{flex:0 0 58.33333%;max-width:58.33333%}.mds-col-at-576-8{flex:0 0 66.66667%;max-width:66.66667%}.mds-col-at-576-9{flex:0 0 75%;max-width:75%}.mds-col-at-576-10{flex:0 0 83.33333%;max-width:83.33333%}.mds-col-at-576-11{flex:0 0 91.66667%;max-width:91.66667%}.mds-col-at-576-12{flex:0 0 100%;max-width:100%}.mds-offset-at-576-0{margin-left:0}.mds-offset-at-576-1{margin-left:8.33333%}.mds-offset-at-576-2{margin-left:16.66667%}.mds-offset-at-576-3{margin-left:25%}.mds-offset-at-576-4{margin-left:33.33333%}.mds-offset-at-576-5{margin-left:41.66667%}.mds-offset-at-576-6{margin-left:50%}.mds-offset-at-576-7{margin-left:58.33333%}.mds-offset-at-576-8{margin-left:66.66667%}.mds-offset-at-576-9{margin-left:75%}.mds-offset-at-576-10{margin-left:83.33333%}.mds-offset-at-576-11{margin-left:91.66667%}}@media print,screen and (min-width:768px){.mds-col-at-768{flex-basis:0;flex-grow:1;max-width:100%}.mds-col-at-768-auto{flex:0 0 auto;max-width:100%;width:auto}.mds-col-at-768-1{flex:0 0 8.33333%;max-width:8.33333%}.mds-col-at-768-2{flex:0 0 16.66667%;max-width:16.66667%}.mds-col-at-768-3{flex:0 0 25%;max-width:25%}.mds-col-at-768-4{flex:0 0 33.33333%;max-width:33.33333%}.mds-col-at-768-5{flex:0 0 41.66667%;max-width:41.66667%}.mds-col-at-768-6{flex:0 0 50%;max-width:50%}.mds-col-at-768-7{flex:0 0 58.33333%;max-width:58.33333%}.mds-col-at-768-8{flex:0 0 66.66667%;max-width:66.66667%}.mds-col-at-768-9{flex:0 0 75%;max-width:75%}.mds-col-at-768-10{flex:0 0 83.33333%;max-width:83.33333%}.mds-col-at-768-11{flex:0 0 91.66667%;max-width:91.66667%}.mds-col-at-768-12{flex:0 0 100%;max-width:100%}.mds-offset-at-768-0{margin-left:0}.mds-offset-at-768-1{margin-left:8.33333%}.mds-offset-at-768-2{margin-left:16.66667%}.mds-offset-at-768-3{margin-left:25%}.mds-offset-at-768-4{margin-left:33.33333%}.mds-offset-at-768-5{margin-left:41.66667%}.mds-offset-at-768-6{margin-left:50%}.mds-offset-at-768-7{margin-left:58.33333%}.mds-offset-at-768-8{margin-left:66.66667%}.mds-offset-at-768-9{margin-left:75%}.mds-offset-at-768-10{margin-left:83.33333%}.mds-offset-at-768-11{margin-left:91.66667%}}@media print,screen and (min-width:992px){.mds-col-at-992{flex-basis:0;flex-grow:1;max-width:100%}.mds-col-at-992-auto{flex:0 0 auto;max-width:100%;width:auto}.mds-col-at-992-1{flex:0 0 8.33333%;max-width:8.33333%}.mds-col-at-992-2{flex:0 0 16.66667%;max-width:16.66667%}.mds-col-at-992-3{flex:0 0 25%;max-width:25%}.mds-col-at-992-4{flex:0 0 33.33333%;max-width:33.33333%}.mds-col-at-992-5{flex:0 0 41.66667%;max-width:41.66667%}.mds-col-at-992-6{flex:0 0 50%;max-width:50%}.mds-col-at-992-7{flex:0 0 58.33333%;max-width:58.33333%}.mds-col-at-992-8{flex:0 0 66.66667%;max-width:66.66667%}.mds-col-at-992-9{flex:0 0 75%;max-width:75%}.mds-col-at-992-10{flex:0 0 83.33333%;max-width:83.33333%}.mds-col-at-992-11{flex:0 0 91.66667%;max-width:91.66667%}.mds-col-at-992-12{flex:0 0 100%;max-width:100%}.mds-offset-at-992-0{margin-left:0}.mds-offset-at-992-1{margin-left:8.33333%}.mds-offset-at-992-2{margin-left:16.66667%}.mds-offset-at-992-3{margin-left:25%}.mds-offset-at-992-4{margin-left:33.33333%}.mds-offset-at-992-5{margin-left:41.66667%}.mds-offset-at-992-6{margin-left:50%}.mds-offset-at-992-7{margin-left:58.33333%}.mds-offset-at-992-8{margin-left:66.66667%}.mds-offset-at-992-9{margin-left:75%}.mds-offset-at-992-10{margin-left:83.33333%}.mds-offset-at-992-11{margin-left:91.66667%}}@media print,screen and (min-width:1200px){.mds-col-at-1200{flex-basis:0;flex-grow:1;max-width:100%}.mds-col-at-1200-auto{flex:0 0 auto;max-width:100%;width:auto}.mds-col-at-1200-1{flex:0 0 8.33333%;max-width:8.33333%}.mds-col-at-1200-2{flex:0 0 16.66667%;max-width:16.66667%}.mds-col-at-1200-3{flex:0 0 25%;max-width:25%}.mds-col-at-1200-4{flex:0 0 33.33333%;max-width:33.33333%}.mds-col-at-1200-5{flex:0 0 41.66667%;max-width:41.66667%}.mds-col-at-1200-6{flex:0 0 50%;max-width:50%}.mds-col-at-1200-7{flex:0 0 58.33333%;max-width:58.33333%}.mds-col-at-1200-8{flex:0 0 66.66667%;max-width:66.66667%}.mds-col-at-1200-9{flex:0 0 75%;max-width:75%}.mds-col-at-1200-10{flex:0 0 83.33333%;max-width:83.33333%}.mds-col-at-1200-11{flex:0 0 91.66667%;max-width:91.66667%}.mds-col-at-1200-12{flex:0 0 100%;max-width:100%}.mds-offset-at-1200-0{margin-left:0}.mds-offset-at-1200-1{margin-left:8.33333%}.mds-offset-at-1200-2{margin-left:16.66667%}.mds-offset-at-1200-3{margin-left:25%}.mds-offset-at-1200-4{margin-left:33.33333%}.mds-offset-at-1200-5{margin-left:41.66667%}.mds-offset-at-1200-6{margin-left:50%}.mds-offset-at-1200-7{margin-left:58.33333%}.mds-offset-at-1200-8{margin-left:66.66667%}.mds-offset-at-1200-9{margin-left:75%}.mds-offset-at-1200-10{margin-left:83.33333%}.mds-offset-at-1200-11{margin-left:91.66667%}}:host{display:block}:host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .fieldset{padding:0;margin:0;border:0}:host .fieldset__content-container{display:flex}:host .fieldset__content-container--vertical{flex-direction:column}:host .fieldset__error-message{display:flex}:host .fieldset__error-message--right{justify-content:flex-end}:host .fieldset__legend{float:left;text-align:var(--Mdsfieldset-_labelAlignment-left__labelTextAlignment,left)}:host .fieldset__legend--vertical{margin-bottom:var(--MdsFieldset-_layout-vertical__labelContainerBottomMargin,16px);margin-right:0;float:none;outline:none}:host .fieldset__legend--vertical--prominent{margin-bottom:var(--MdsFieldset-_layout-vertical-_labelSize-prominent__labelContainerBottomMargin,24px)}:host .fieldset__legend--right{text-align:var(--MdsFieldset-_labelAlignment-right__labelTextAlignment,right)}:host .fieldset__legend-label{border:0;color:var(--MdsFieldset__legendTextColor,#565a5d);font-weight:var(--MdsFieldset__legendTextWeight,400);font-size:var(--MdsFieldset-_layout-horizontal__legendTextSize,1rem);line-height:var(--MdsFieldset-_layout-horizontal__legendTextLineHeight,1.5rem)}:host .fieldset__legend-label--vertical{color:var(--MdsFieldset-_layout-vertical__legendTextColor,#101820);font-size:var(--MdsFieldset-_layout-vertical__legendTextSize,.875rem);line-height:var(--MdsFieldset-_layout-vertical__legendTextLineHeight,1.25rem)}:host .fieldset__legend-label--vertical--regular{font-size:var(--MdsFieldset-_layout-vertical-_labelSize-regular__labelTextSize,.875rem);line-height:var(--MdsFieldset-_layout-vertical-_labelSize-regular__labelLineHeight,1.25rem);font-weight:var(--MdsFieldset-_layout-vertical-_labelSize-regular__labelTextWeight,400)}:host .fieldset__legend-label--vertical--medium{font-size:var(--MdsFieldset-_layout-vertical-_labelSize-medium,1rem);line-height:var(--MdsFieldset-_layout-vertical-_labelSize-medium__labelLineHeight,1.5rem);font-weight:var(--MdsFieldset-_layout-vertical-_labelSize-medium__labelTextWeight,600)}:host .fieldset__legend-label--vertical--prominent{font-size:var(--MdsFieldset-_layout-vertical-_labelSize-prominent,1.5rem);line-height:var(--MdsFieldset-_layout-vertical-_labelSize-prominent__labelLineHeight,2rem);font-weight:var(--MdsFieldset-_layout-vertical-_labelSize-prominent__labelTextWeight,600)}:host .fieldset__legend-label--horizontal{color:var(--MdsFieldset-_layout-vertical__legendTextColor,#101820)}:host .fieldset__legend-label--horizontal--regular{font-size:var(--MdsFieldset-_layout-horizontal-_labelSize-regular__labelTextSize,1rem);line-height:var(--MdsFieldset-_layout-horizontal-_labelSize-regular__labelLineHeight,1.5rem);font-weight:var(--MdsFieldset-_layout-horizontal-_labelSize-regular__labelTextWeight,400)}:host .fieldset__legend-label--error{color:var(--MdsFieldset__legendTextColor--error,#b80009);font-weight:var(--MdsFieldset__legendTextWeight--error,600);margin-top:var(--MdsFieldset__legendTopMargin--error,4px)}:host .fieldset__legend-label--error--vertical--regular{font-size:var(--MdsFieldset-_layout-vertical-_labelSize-regular__labelTextSize--error,.875rem);line-height:var(--MdsFieldset-_layout-vertical-_labelSize-regular__labelLineHeight--error,1.25rem);font-weight:var(--MdsFieldset-_layout-vertical-_labelSize-regular__labelTextWeight--error,600)}:host .fieldset__legend-label--error--horizontal--regular{font-size:var(--MdsFieldset-_layout-horizontal-_labelSize-regular__labelTextSize--error,1rem);line-height:var(--MdsFieldset-_layout-horizontal-_labelSize-regular__labelLineHeight--error,1.5rem);font-weight:var(--MdsFieldset-_layout-horizontal-_labelSize-regular__labelTextWeight--error,600)}:host .fieldset__legend-microcopy{color:var(--MdsFieldset__microcopyTextColor,#565a5d);font-size:var(--MdsFieldset__microcopyTextSize,.75rem);font-weight:var(--MdsFieldset__microcopyTextWeight,400);line-height:var(--MdsFieldset__microcopyTextLineHeight,1rem);margin-top:var(--MdsFieldset__microcopyMarginTop,4px)}:host .fieldset__legend-microcopy--vertical--prominent{font-size:var(--MdsFieldset-_layout-vertical-_labelSize-prominent__microcopyTextSize,.875rem);line-height:var(--MdsFieldset-_layout-vertical-_labelSize-prominent__microcopyTextLineHeight,1.25rem);font-weight:var(--MdsFieldset-_layout-vertical-_labelSize-prominent__microcopyTextWeight,400)}:host .fieldset__accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/hero-header/mds-hero-header.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .hero-header{align-items:center;max-width:var(--MdsHeroHeader__maxWidthDesktop,396px)}:host .hero-header,:host .hero-header__leading{display:flex;flex-direction:column;justify-content:center;width:100%}:host .hero-header__leading{align-items:left}:host .hero-header__heading-container{display:flex;flex-direction:column;align-items:center}:host .hero-header__heading-container--leading{flex-direction:row;align-items:left;animation:fadeIn var(--MdsHeroHeader__progressAnimationTextTimingFunction,ease) var(--MdsHeroHeader__progressAnimationTextDuration,.5s)}:host .hero-header__progress-bar{position:relative;width:100%;animation:animateDone var(--MdsHeroHeader__progressAnimationEndDuration,500) var(--MdsHeroHeader__progressAnimationEndTimingFunction,ease-in-out) var(--MdsHeroHeader__progressAnimationEndFillMode,forwards);animation-delay:var(--MdsHeroHeader__progressAnimationEndDelay,2s)}:host .hero-header__progress-bar,:host .hero-header__progress-bar--animation{border-radius:var(--MdsHeroHeader-_variant-leading__progressBarBorderRadius,4px);height:var(--MdsHeroHeader-_variant-leading__progressBarHeight,4px);display:inline-block}:host .hero-header__progress-bar--animation{position:absolute;animation:progress var(--MdsHeroHeader__progressAnimationDuration,1.5s) var(--MdsHeroHeader__progressAnimationTimingFunction,ease) var(--MdsHeroHeader__progressAnimationDelay,.5s) var(--MdsHeroHeader__progressAnimationFillMode,forwards)}:host .hero-header__icon{display:inline-flex}:host .hero-header__icon svg{height:var(--MdsHeroHeader__iconHeight,64px);width:var(--MdsHeroHeader__iconWidth,64px)}:host .hero-header__icon--leading svg{height:var(--MdsHeroHeader-_variant-leading__iconHeight,28px);width:var(--MdsHeroHeader-_variant-leading__iconWidth,28px)}:host .hero-header__image{height:var(--MdsHeroHeader__iconHeight,64px);width:var(--MdsHeroHeader__iconWidth,64px)}:host .hero-header__heading{text-align:center;width:100%;font-size:var(--MdsHeroHeader__headingTextSize,1.5rem);font-weight:var(--MdsHeroHeader__headingTextWeight,600);line-height:var(--MdsHeroHeader__headingTextLineHeight,2rem);margin-top:var(--MdsHeroHeader__headingTextTopMargin,12px)}:host .hero-header__heading--leading{text-align:left;width:100%;font-size:var(--MdsHeroHeader-_variant-leading__headingTextSize,1.125rem);font-weight:var(--MdsHeroHeader-_variant-leading__headingTextWeight,600);line-height:var(--MdsHeroHeader-_variant-leading__headingTextLineHeight,2.25rem);margin-left:var(--MdsHeroHeader-_variant-leading__headingTextLeadingMargin,8px)}:host #hero-header-focus-target:focus{outline:none}:host .hero-header__description{text-align:center;width:100%;font-size:var(--MdsHeroHeader__descriptionTextSize,1rem);font-weight:var(--MdsHeroHeader__descriptionTextWeight,400);line-height:var(--MdsHeroHeader__descriptionTextLineHeight,1.5rem);margin-top:var(--MdsHeroHeader__descriptionTextTopMargin,8px)}:host .hero-header__description--leading{text-align:left;width:100%;font-size:var(--MdsHeroHeader-_variant-leading__descriptionTextSize,.875rem);font-weight:var(--MdsHeroHeader-_variant-leading__descriptionTextWeight,400);line-height:var(--MdsHeroHeader-_variant-leading__descriptionTextLineHeight,2rem);margin-top:var(--MdsHeroHeader-_variant-leading__descriptionTextTopMargin,8px);margin-bottom:var(--MdsHeroHeader-_variant-leading__descriptionTextBottomMargin,8px);animation:fadeIn var(--MdsHeroHeader__progressAnimationTextTimingFunction,ease) var(--MdsHeroHeader__progressAnimationTextDuration,.5s)}:host .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}@keyframes progress{0%{width:0}to{width:100%}}@keyframes animateDone{to{opacity:0}}@keyframes fadeIn{0%{opacity:var(--MdsHeroHeader__textAnimationStartingOpacity,0)}50%{opacity:var(--MdsHeroHeader__textAnimationMiddleOpacity,.5)}to{opacity:var(--MdsHeroHeader__textAnimationEndingOpacity,1)}}@media (prefers-reduced-motion:reduce){:host .hero-header__description--leading,:host .hero-header__heading-container,:host .hero-header__progress-bar--animation{animation:none}:host .hero-header__progress-bar{display:none}}.hero-header__icon--regular svg{fill:var(--MdsHeroHeader__iconColorRegular,#565a5d)}.hero-header__icon--success svg{fill:var(--MdsHeroHeader__iconColorSuccess,#4ea000)}.hero-header__heading{color:var(--MdsHeroHeader__headingTextColor,#101820)}.hero-header__heading--leading{color:var(--MdsHeroHeader-_variant-leading__headingTextColor,#101820)}.hero-header__description{color:var(--MdsHeroHeader__descriptionTextColor,#101820)}.hero-header__progress-bar{background-color:var(--MdsHeroHeader-_variant-confirmationAnimation__progressBarTrackColor,#ccc)}.hero-header__progress-bar--animation{background-color:var(--MdsHeroHeader-_variant-leading__progressBarColor,#4ea000)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/icon/mds-icon.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host(.horizontal-margin){margin-right:var(--MdsIcon__trailingMargin,8px);margin-left:var(--MdsIcon__leadingMargin,8px)}:host,:host .icon,:host .icon-container{display:inline-flex}:host .icon--16 svg{width:var(--MdsIcon-_size-16__width,16px);height:var(--MdsIcon-_size-16__height,16px)}:host .icon--20 svg{width:var(--MdsIcon-_size-20__width,20px);height:var(--MdsIcon-_size-20__height,20px)}:host .icon--24 svg{width:var(--MdsIcon-_size-24__width,24px);height:var(--MdsIcon-_size-24__height,24px)}:host .icon--48 svg,:host .icon--md svg{width:var(--MdsIcon-_size-48__width,48px);height:var(--MdsIcon-_size-48__height,48px)}:host .icon--default svg{fill:var(--MdsIcon-_color-default__color,#565a5d)}:host .icon--inverse svg{fill:var(--MdsIcon-_color-inverse__color,#fff)}:host .icon--warning svg{fill:var(--MdsIcon-_color-warning__color,#e35205)}:host .icon--error svg{fill:var(--MdsIcon-_color-error__color,#b80009)}:host .icon--success svg{fill:var(--MdsIcon-_color-success__color,#4ea000)}:host .icon--interactive svg{fill:var(--MdsIcon-_color-interactive__color,#005eb8)}:host .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/image/mds-image.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host .image--cover{-o-object-fit:cover;object-fit:cover}:host .image--contain{-o-object-fit:contain;object-fit:contain}:host .image--fill{-o-object-fit:fill;object-fit:fill}:host .image--position_center{-o-object-position:center center;object-position:center center;-o-object-fit:none;object-fit:none}:host .image--position_left{-o-object-position:left center;object-position:left center;-o-object-fit:none;object-fit:none}:host .image--position_right{-o-object-position:right center;object-position:right center;-o-object-fit:none;object-fit:none}:host .image--position_verticalPositions{-o-object-position:center verticalPositions;object-position:center verticalPositions;-o-object-fit:none;object-fit:none}:host .image--position_center-center{-o-object-position:center center;object-position:center center;-o-object-fit:none;object-fit:none}:host .image--position_center-top{-o-object-position:center top;object-position:center top;-o-object-fit:none;object-fit:none}:host .image--position_center-bottom{-o-object-position:center bottom;object-position:center bottom;-o-object-fit:none;object-fit:none}:host .image--position_left-center{-o-object-position:left center;object-position:left center;-o-object-fit:none;object-fit:none}:host .image--position_left-top{-o-object-position:left top;object-position:left top;-o-object-fit:none;object-fit:none}:host .image--position_left-bottom{-o-object-position:left bottom;object-position:left bottom;-o-object-fit:none;object-fit:none}:host .image--position_right-center{-o-object-position:right center;object-position:right center;-o-object-fit:none;object-fit:none}:host .image--position_right-top{-o-object-position:right top;object-position:right top;-o-object-fit:none;object-fit:none}:host .image--position_right-bottom{-o-object-position:right bottom;object-position:right bottom;-o-object-fit:none;object-fit:none}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/inline-form/inline-input/mds-inline-input.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .inline-input{display:inline;line-height:var(--MdsInlineInput__containerLineHeight,2rem)}:host .inline-input__input{padding:var(--MdsInlineInput__textFieldTopPadding,0) var(--MdsInlineInput__textFieldTrailingPadding,10px) var(--MdsInlineInput__textFieldBottomPadding,2px) var(--MdsInlineInput__textFieldLeadingPadding,10px);margin:0;border:0;font-size:var(--MdsInlineInput__textFieldTextSize,.875rem);line-height:var(--MdsInlineInput__textFieldLineHeight,1.25rem);font-weight:var(--MdsInlineInput__textFieldFontWeight,400);vertical-align:var(--MdsInlineInput__textFieldVerticalAlignment,middle);-webkit-appearance:none;-moz-appearance:none;appearance:none;border-radius:0}:host .inline-input__input:focus{outline:none}:host .inline-input__input::-moz-placeholder{text-align:var(--MdsInlineInput__textFieldPlaceholderTextAlignment,center);font-weight:var(--MdsInlineInput__textFieldFontWeight,400);opacity:1}:host .inline-input__input::placeholder{text-align:var(--MdsInlineInput__textFieldPlaceholderTextAlignment,center);font-weight:var(--MdsInlineInput__textFieldFontWeight,400);opacity:1}:host .inline-input__input--trailing-text{margin-right:var(--MdsInlineInput__textFieldAnchorTextMarginBetween,8px)}:host .inline-input__accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .inline-input .inline-form__text{font-size:var(--MdsInlineInput__anchorTextTextSize,1rem);line-height:var(--MdsInlineInput__anchorTextLineHeight,1.5rem)}:host .inline-input .inline-form__text--leading{margin-right:var(--MdsInlineInput__textFieldAnchorTextMarginBetween,8px)}:host .inline-input__width-mirror{visibility:hidden;position:absolute;left:0;white-space:nowrap;font-size:var(--MdsInlineInput__textFieldTextSize,.875rem);line-height:var(--MdsInlineInput__textFieldLineHeight,1.25rem);font-weight:var(--MdsInlineInput__textFieldFontWeight,400)}.inline-form__text{color:var(--MdsInlineInput__anchorTextTextColor,#101820)}.inline-input__input{box-shadow:inset 0 calc(var(--MdsInlineInput__textFieldBottomBorderWidth, 1px)*-1) 0 0 var(--MdsInlineInput__textFieldBottomBorderColor,#8c8e90);color:var(--MdsInlineInput__textFieldTextColor,#005eb8)}.inline-input__input::-moz-placeholder{color:var(--MdsInlineInput__textFieldTextColor,#005eb8)}.inline-input__input::placeholder{color:var(--MdsInlineInput__textFieldTextColor,#005eb8)}.inline-input__input:focus{box-shadow:inset 0 calc(var(--MdsInlineInput__textFieldBottomBorderWidth--active, 2px)*-1) 0 0 var(--MdsInlineInput__textFieldBottomBorderColor--active,#005eb8)}.inline-input__input:focus.inline-input__input--error{box-shadow:inset 0 calc(var(--MdsInlineInput__textFieldBottomBorderWidth--active, 2px)*-1) 0 0 var(--MdsInlineInput__textFieldBottomBorderColor--error,#b80009)}.inline-input__input--error{box-shadow:inset 0 calc(var(--MdsInlineInput__textFieldBottomBorderWidth--error, 1px)*-1) 0 0 var(--MdsInlineInput__textFieldBottomBorderColor--error,#b80009)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/inline-form/inline-select/mds-inline-select.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, '@charset "UTF-8";:host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host * ul{list-style:none;padding:0}:host .inline-select{display:inline;line-height:var(--MdsInlineSelect__containerLineHeight,2rem)}:host .inline-select__label{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .inline-select__select-container{position:relative;display:inline-flex;vertical-align:var(--MdsInlineSelect__textFieldVerticalAlignment,middle)}:host .inline-select__select-container--trailing-text{margin-right:var(--MdsInlineSelect__textFieldAnchorTextMarginBetween,8px)}:host .inline-select__select{padding:var(--MdsInlineSelect__textFieldTopPadding,0) var(--MdsInlineSelect__textFieldTrailingPadding,26px) var(--MdsInlineSelect__textFieldBottomPadding,2px) var(--MdsInlineSelect__textFieldLeadingPadding,10px);font-weight:var(--MdsInlineSelect__textFieldFontWeight,400);font-size:var(--MdsInlineSelect__textFieldTextSize,.875rem);line-height:var(--MdsInlineSelect__textFieldLineHeight,1.25rem);-webkit-appearance:none;-moz-appearance:none;appearance:none;display:block;width:100%;background-color:transparent;border:0;border-radius:0;white-space:pre-wrap;margin:0;z-index:1;cursor:pointer}:host .inline-select__select:focus{outline:none}:host .inline-select__select:focus::-moz-focus-inner{border:0}@-moz-document url-prefix(""){:host .inline-select__select{text-indent:-.125rem}}:host .inline-select__icon{display:inline-flex;position:absolute;right:0;z-index:2;padding-top:var(--MdsInlineSelect__chevronTopPadding,4px);padding-right:var(--MdsInlineSelect__chevronTrailingPadding,10px);pointer-events:none}:host .inline-select__icon svg{height:var(--MdsInlineSelect__chevronHeight,12px);width:var(--MdsInlineSelect__chevronWidth,12px)}:host .inline-select__menu{position:absolute;left:0;top:100%;width:-moz-fit-content;width:fit-content;z-index:1100}:host .inline-select__menu-list{max-height:var(--MdsInlineSelect__menuMaxHeight,380px);overflow-y:auto;margin:0;margin-top:var(--MdsInlineSelect__menuTopPadding,4px)}:host .inline-select__menu-list .inline-select__option{font-size:var(--MdsInlineSelect_MenuItem__labelTextSize,.875rem);font-weight:var(--MdsInlineSelect_MenuItem__labelTextWeight,400);line-height:var(--MdsInlineSelect_MenuItem__labelLineHeight,1.25rem);text-align:var(--MdsInlineSelect_MenuItem__labelTextAlignment,left);padding:var(--MdsInlineSelect_MenuItem__topPadding,8px) var(--MdsInlineSelect_MenuItem__trailingPadding,8px) var(--MdsInlineSelect_MenuItem__bottomPadding,8px) var(--MdsInlineSelect_MenuItem__leadingPadding,8px);cursor:pointer;display:block}:host .inline-select__menu-list .inline-select__option:focus:focus{outline:.0625rem dashed #717171}:host .inline-select__menu-list .inline-select__option--selected{border-left-width:var(--MdsInlineSelect_MenuItem__barWidth--selected,);border-left-style:solid;padding-left:var(--MdsInlineSelect_MenuItem__barWidth--selected,);font-weight:var(--MdsInlineSelect_MenuItem__labelTextWeight--selected,)}:host .inline-select__menu-list .inline-select__option--selected:before{content:"✓";position:absolute;opacity:0}:host .inline-select__menu-list .inline-select__option-label{pointer-events:none}:host .inline-select__accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .inline-form__text{font-size:var(--MdsInlineSelect__anchorTextTextSize,1rem);line-height:var(--MdsInlineSelect__anchorTextLineHeight,1.5rem)}:host .inline-form__text--leading{margin-right:var(--MdsInlineSelect__textFieldAnchorTextMarginBetween,8px)}.inline-form__text{color:var(--MdsInlineSelect__anchorTextTextColor,#101820)}.inline-select__icon svg{fill:var(--MdsInlineSelect__chevronIconColor,#565a5d)}.inline-select__select{color:var(--MdsInlineSelect__textFieldTextColor,#005eb8);box-shadow:inset 0 calc(var(--MdsInlineSelect__textFieldBottomBorderWidth, 1px)*-1) 0 0 var(--MdsInlineSelect__textFieldBottomBorderColor,#8c8e90)}.inline-select__select:active,.inline-select__select:focus{box-shadow:inset 0 calc(var(--MdsInlineSelect__textFieldBottomBorderWidth--active, 2px)*-1) 0 0 var(--MdsInlineSelect__textFieldBottomBorderColor--active,#005eb8)}.inline-select__select:active.inline-select__select--error,.inline-select__select:focus.inline-select__select--error{box-shadow:inset 0 calc(var(--MdsInlineSelect__textFieldBottomBorderWidth--active, 2px)*-1) 0 0 var(--MdsInlineSelect__textFieldBottomBorderColor--error,#b80009)}.inline-select__select--error{box-shadow:inset 0 calc(var(--MdsInlineSelect__textFieldBottomBorderWidth--error, 1px)*-1) 0 0 var(--MdsInlineSelect__textFieldBottomBorderColor--error,#b80009)}.inline-select__menu-list{background-color:var(--MdsInlineSelect_MenuItem__backgroundColor,#fff);box-shadow:var(--MdsInlineSelect__menuBoxShadowHorizontalOffset,0) var(--MdsInlineSelect__menuBoxShadowVerticalOffset,2px) var(--MdsInlineSelect__menuBoxShadowBlurRadius,3px) var(--MdsInlineSelect__menuBoxShadowSpreadRadius,0) var(--MdsInlineSelect__menuBoxShadowColor,rgba(0,0,0,.28))}.inline-select__menu-list .inline-select__option{color:var(--MdsInlineSelect_MenuItem__labelTextColor,#101820)}.inline-select__menu-list .inline-select__option:hover{background-color:var(--MdsInlineSelect_MenuItem__backgroundColor--hovered,#f5f7f8)}.inline-select__menu-list .inline-select__option:active{color:var(--MdsInlineSelect_MenuItem__labelTextColor--pressed,#fff);background-color:var(--MdsInlineSelect_MenuItem__backgroundColor--pressed,#0091da)}.inline-select__menu-list .inline-select__option--selected{border-left-color:var(--MdsInlineSelect_MenuItem__barColor,#005eb8)}', "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/inline-form/mds-inline-form.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host .inline-form__error-microcopy-accessible-text--hidden{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .inline-form{background-color:var(--MdsInlineForm__backgroundColor,#fff)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/list/mds-list.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ':host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .list-item{list-style:none;padding:0;margin:0}@media screen and (min-width:992px){:host .list-item__multiColumn{width:100%;height:auto}}:host .list-item__input-container{position:relative}:host .list-item__panel{z-index:1;overflow-y:hidden;transition-property:height;transition-duration:var(--MdsList__headerContentTransitionTiming,.2s);transition-timing-function:var(--MdsList__headerContentTransitionEase,cubic-bezier(0,.2,.1,1));border:0}:host .list-item__panel--expanded{opacity:1}@media screen and (min-width:992px){:host .list-item__panel--multiColumn{display:grid;grid-template-columns:repeat(2,1fr);gap:var(--MdsList_item__imageLeadingPadding,16px)}}:host .list-item__panel--collapsing{animation-name:panel-opacity;animation-duration:var(--MdsList__headerContentTransitionTiming,.2s);animation-delay:0s;animation-timing-function:var(--MdsList__headerContentTransitionEase,cubic-bezier(0,.2,.1,1));animation-fill-mode:forwards}@keyframes panel-opacity{0%{opacity:var(--MdsList__headerContentExpandedOpacity,1)}to{opacity:var(--MdsList__headerContentCollapsedOpacity,0)}}:host .list-item__container{display:inline-flex;padding-left:var(--MdsList_item__imageLeadingPadding,16px);width:100%;-moz-column-break-inside:avoid;break-inside:avoid;page-break-inside:avoid}:host .list-item__visual-element{display:flex;max-width:var(--MdsList_item__imageMaxWidth,96px);padding-top:var(--MdsList_item__textAreaTopMargin,16px);padding-bottom:var(--MdsList_item__textAreaBottomMargin,16px);padding-right:var(--MdsList_item__textAreaLeadingMargin,8px)}:host .list-item__visual-element .list-item__image{overflow:hidden;align-self:center}:host .list-item__visual-element--condensed{padding-top:var(--MdsList_item__condensedTextAreaTopMargin,4px);padding-bottom:var(--MdsList_item__condensedTextAreaBottomMargin,4px);padding-right:var(--MdsList_item-_image-true__labelLeadingPadding,8px)}:host .list-item__visual-element--condensed-with-divider{padding-top:var(--MdsList_item-_showDividers-true__condensedTextAreaTopMargin,8px);padding-bottom:var(--MdsList_item-_showDividers-true__condensedTextAreaBottomMargin,8px)}:host .list-item__visual-element .list-item__icon{display:inline-flex;align-items:center}:host .list-item__visual-element .list-item__icon svg{height:24px;width:24px}:host .list-item__text-container{flex-grow:100;display:flex;justify-content:space-between;padding-right:var(--MdsList_item__selectableIconLeadingPadding,8px)}:host .list-item__text-container .list-item__secondary-container{display:flex;align-items:center}:host .list-item__text{display:flex;flex-direction:column;justify-content:center;margin:var(--MdsList_item__textAreaTopMargin,16px) var(--MdsList_item__textAreaTrailingMargin,16px) var(--MdsList_item__textAreaBottomMargin,16px) 0}:host .list-item__text--condensed{margin-top:var(--MdsList_item__condensedTextAreaTopMargin,4px);margin-bottom:var(--MdsList_item__condensedTextAreaBottomMargin,4px);margin-left:0}:host .list-item__text--condensed-with-divider{margin-top:var(--MdsList_item-_showDividers-true__condensedTextAreaTopMargin,8px);margin-bottom:var(--MdsList_item-_showDividers-true__condensedTextAreaBottomMargin,8px)}:host .list-item__text--secondary{margin-right:0;margin-left:0}:host .list-item__text--secondary .list-item__label{text-align:var(--MdsList_item__secondaryLabelTextAlignment,right);font-size:var(--MdsList_item__secondaryLabelTextSize,.875rem);line-height:var(----MdsList_item__secondaryLabelTextLineHeight,1.25rem);font-weight:var(--MdsList_item__secondaryLabelTextWeight,400)}:host .list-item__text--secondary .list-item__description{text-align:var(--MdsList_item__secondaryDescriptionTextAlignment,right);font-size:var(--MdsList_item__secondaryDescriptionTextSize,.75rem);line-height:var(--MdsList_item__secondaryDescriptionTextLineHeight,1rem);font-weight:var(--MdsList_item__secondaryDescriptionTextWeight,400)}:host .list-item__label{text-align:var(--MdsList_item__labelTextAlignment,left);font-size:var(--MdsList_item__labelTextSize,.875rem);line-height:var(--MdsList_item__labelTextLineHeight,1.25rem);font-weight:var(--MdsList_item__labelTextWeight,400)}:host .list-item__badge{display:flex;flex-direction:column;justify-content:center;padding-left:var(--MdsList_item__badgeLeadingPadding,8px)}:host .list-item__badge--withBadgeLabel{padding-bottom:.188rem}:host .list-item__description{text-align:var(--MdsList_item__descriptionTextAlignment,left);font-size:var(--MdsList_item__descriptionTextSize,.75rem);line-height:var(--MdsList_item__descriptionTextLineHeight,1rem);font-weight:var(--MdsList_item__descriptionTextWeight,400)}:host .list-item__input-button{display:flex;justify-content:center;flex-direction:column;padding-right:var(--MdsList_item__selectorTrailingMargin,16px);cursor:pointer;position:relative;padding-top:var(--MdsList_item__textAreaTopMargin,16px);padding-bottom:var(--MdsList_item__textAreaTopMargin,16px)}:host .list-item__input-button--condensed{padding-top:var(--MdsList_item__condensedTextAreaTopMargin,4px);padding-bottom:var(--MdsList_item__condensedTextAreaBottomMargin,4px);margin-left:0}:host .list-item__input-button--condensed-with-divider{padding-top:var(--MdsList_item-_showDividers-true__condensedTextAreaTopMargin,8px);padding-bottom:var(--MdsList_item-_showDividers-true__condensedTextAreaBottomMargin,8px)}:host .list-item__input{cursor:pointer;width:var(--MdsList_item__radioCircleSize,22px);height:var(--MdsList_item__radioCircleSize,22px);position:absolute;left:.0625rem;opacity:0;z-index:1}:host .list-item__input:focus~.list-item__multi-select-container,:host .list-item__input:focus~.list-item__outer-circle,:host .list-item__input:focus~.list-item__quick-select-checkmark{outline:.0625rem dashed #717171}:host .list-item__outer-circle{width:var(--MdsList_item__radioCircleSize,22px);height:var(--MdsList_item__radioCircleSize,22px);border-width:var(--MdsList_item__radioCircleThickness,2px);border-style:solid;border-radius:50%;display:flex;justify-content:center;align-items:center}:host .list-item__outer-circle .list-item__inner-circle{width:var(--MdsList_item__radioDotSize,14px);height:var(--MdsList_item__radioDotSize,14px);border-radius:50%}:host .list-item__multi-select-container{width:var(--MdsCheckbox__checkboxWidth,20px);height:var(--MdsCheckbox__checkboxHeight,20px);border-radius:var(--MdsCheckbox__checkboxBorderRadius,4px);background-color:var(--MdsCheckbox__containerBackgroundColor,transparent);border:var(--MdsCheckbox__checkboxBorderWidth,2px) solid var(--MdsCheckbox__containerBorderColor,#8c8e90);display:flex;justify-content:center;align-items:center}:host .list-item__multi-select-container .list-item__multi-select-input{width:var(--MdsCheckbox__checkboxWidth,20px);height:var(--MdsCheckbox__checkboxHeight,20px);border-radius:var(--MdsCheckbox__checkboxBorderRadius,4px)}:host .list-item__multi-select-container .list-item__multi-select-input svg{width:var(--MdsCheckbox__checkboxWidth,20px);height:var(--MdsCheckbox__checkboxHeight,20px);fill:none}:host .list-item__quick-select-checkmark{display:flex;justify-content:center;align-items:center}:host .list-item__quick-select-checkmark,:host .list-item__quick-select-checkmark svg{height:var(--MdsList_item__quickSelectIconHeight,24px);width:var(--MdsList_item__quickSelectIconWidth,24px)}:host .list-item__quick-select-checkmark svg{fill:none}:host .list-item--selectable{outline:none;cursor:pointer;position:relative;padding-right:var(--MdsList_item__selectorTrailingMargin,16px)}:host .list-item--selectable:focus{outline:.0625rem dashed #717171}:host .list-item--selectable::-moz-focus-inner{border:0}:host .list-item--selectable:focus{outline-offset:-.0625rem}:host .list-item--navigational{position:relative;display:flex}@media screen and (min-width:992px){:host .list-item--navigational__multiColumn{display:inline-flex;width:100%}}:host .list-item--read-only{display:flex}:host .list-item--read-only .list-item__text-container{padding-right:var(--MdsList_item__textAreaTrailingMargin,16px)}:host .list-item__navigational{text-decoration:none;display:flex;flex-direction:column;justify-content:center;padding-right:var(--MdsList_item__chevronIconTrailingPadding,8px);outline:none;cursor:pointer;padding-top:var(--MdsList_item__textAreaTopMargin,16px);padding-bottom:var(--MdsList_item__textAreaBottomMargin,16px)}:host .list-item__navigational:focus .list-item__navigational-icon{outline:.0625rem dashed #717171}:host .list-item__navigational:before{content:"";position:absolute;top:0;bottom:0;left:0;right:0}:host .list-item__navigational-icon{display:inline-flex}:host .list-item__navigational-icon svg{height:1rem;width:1rem}:host .list-item__navigational--condensed{padding-top:var(--MdsList_item__condensedTextAreaTopMargin,4px);padding-bottom:var(--MdsList_item__condensedTextAreaBottomMargin,4px);margin-left:0}:host .list-item__navigational--condensed-with-divider{padding-top:var(--MdsList_item-_showDividers-true__condensedTextAreaTopMargin,8px);padding-bottom:var(--MdsList_item-_showDividers-true__condensedTextAreaBottomMargin,8px)}:host .list__header{border:0;display:flex;justify-content:space-between;padding:var(--MdsList__headerTopPadding,14px) var(--MdsList__headerTrailingPadding,16px) var(--MdsList__headerBottomPadding,14px) var(--MdsList__headerLeadingPadding,16px);font-weight:var(--MdsList__headerTextWeight,600);text-align:var(--MdsList__headerTextAlignment,left);font-size:var(--MdsList__headerTextSize,.75rem);line-height:var(--MdsList__headerTextLineHeight,1rem);outline:none;cursor:default}:host .list__header--collapsible{width:100%;cursor:pointer;padding-right:var(--MdsList__headerLeadingIconTrailingMargin,)}:host .list__header--collapsible::-moz-focus-inner{border:0}:host .list__header--collapsible:focus{z-index:1}:host .list__header--collapsible:focus:focus{outline:.0625rem dashed #717171}:host .list-header__chevron-icon{display:inline-flex;transition-property:all;transition-duration:var(--MdsList__headerCaretRotationTiming,.5s);transition-timing-function:var(--MdsList__headerCaretRotationEase,cubic-bezier(0,.2,.1,1))}:host .list-header__chevron-icon--expanded{transform:rotate(90deg)}:host .list-header__chevron-icon svg{width:var(--MdsList__headerIconWidth,16px);height:var(--MdsList__headerIconHeight,16px);fill:var(--MdsList_item__chevronIconColor,#565a5d)}:host .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}.list-item{background-color:var(--MdsList_item__backgroundColor,#fff)}.list-item__navigational--divider{border-bottom:var(--MdsList_item__dividerBorderColor,#c1c3c3) var(--MdsList_item__dividerBorderStyle,solid) var(--MdsList_item__dividerBorderWidth,1px)}.list-item__navigational svg{fill:var(--MdsList_item__chevronIconColor,#565a5d)}.list-item__input-button--divider{border-bottom:var(--MdsList_item__dividerBorderColor,#c1c3c3) var(--MdsList_item__dividerBorderStyle,solid) var(--MdsList_item__dividerBorderWidth,1px)}.list-item__outer-circle{border-color:var(--MdsList_item__radioContainerBorderColor,#8c8e90)}.list-item__input:checked~.list-item__outer-circle .list-item__inner-circle{border-color:var(--MdsList_item__radioDotColor,#005eb8);background:var(--MdsList_item__radioDotColor,#005eb8)}.list-item__input:checked~.list-item__multi-select-container{border-color:var(--MdsCheckbox__containerBorderColor--checked,#005eb8);background-color:var(--MdsCheckbox__iconBackgroundColor--checked,#005eb8)}.list-item__input:checked~.list-item__multi-select-container .list-item__multi-select-input svg{fill:var(--MdsCheckbox__iconColor--checked,#fff)}.list-item__input:checked~.list-item__quick-select-checkmark svg{height:var(--MdsList_item__quickSelectIconHeight,24px);width:var(--MdsList_item__quickSelectIconWidth,24px);fill:var(--MdsList_item__quickSelectIconColor,#005eb8)}.list-item__description{color:var(--MdsList_item-_descriptionColor-subdued__descriptionTextColor,#565a5d)}.list-item__description--regular{color:var(--MdsList_item-_descriptionColor-regular__descriptionTextColor,#101820)}.list-item__description--gain{color:var(--MdsList_item-_descriptionColor-gain__descriptionTextColor,#398100)}.list-item__description--loss{color:var(--MdsList_item-_descriptionColor-loss__descriptionTextColor,#b80009)}.list-item__label{color:var(--MdsList_item__labelTextColor,#101820)}.list-item__text-container--divider{border-bottom:var(--MdsList_item__dividerBorderColor,#c1c3c3) var(--MdsList_item__dividerBorderStyle,solid) var(--MdsList_item__dividerBorderWidth,1px)}.list-item__text--secondary .list-item__label{color:var(--MdsList_item-_secondaryLabelColor-regular__secondaryLabelTextColor,#101820)}.list-item__text--secondary .list-item__label--subdued{color:var(--MdsList_item-_secondaryLabelColor-subdued__secondaryLabelTextColor,#565a5d)}.list-item__text--secondary .list-item__label--gain{color:var(--MdsList_item-_secondaryLabelColor-gain__secondaryLabelTextColor,#398100)}.list-item__text--secondary .list-item__label--loss{color:var(--MdsList_item-_secondaryLabelColor-loss__secondaryLabelTextColor,#b80009)}.list-item__text--secondary .list-item__description{color:var(--MdsList_item-_secondaryDescriptionColor-subdued__secondaryDescriptionTextColor,#565a5d)}.list-item__text--secondary .list-item__description--regular{color:var(--MdsList_item-_secondaryDescriptionColor-regular__secondaryDescriptionTextColor,#101820)}.list-item__text--secondary .list-item__description--gain{color:var(--MdsList_item-_secondaryDescriptionColor-gain__secondaryDescriptionTextColor,#398100)}.list-item__text--secondary .list-item__description--loss{color:var(--MdsList_item-_secondaryDescriptionColor-loss__secondaryDescriptionTextColor,#b80009)}.list-item__visual-element--divider{border-bottom:var(--MdsList_item__dividerBorderColor,#c1c3c3) var(--MdsList_item__dividerBorderStyle,solid) var(--MdsList_item__dividerBorderWidth,1px)}.list-item--navigational:active,.list-item--selectable:active{background:var(--MdsList_item__backgroundColor--pressed,#ededed)}.list__header{background-color:var(--MdsList__headerBackgroundColor,#f6f6f6);color:var(--MdsList__headerTextColor,#565a5d)}', "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/load-more/mds-load-more.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ':host{display:block}:host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .load-more{display:flex;flex-direction:column;justify-content:center;align-items:center}:host .load-more__button{margin-bottom:var(--MdsLoadMore__ctaButtonBottomMargin,16px)}:host .load-more__button--without-status-text{margin-top:var(--MdsLoadMore__statusTextBottomMargin,16px)}:host .load-more__horizontal-rule{position:relative}:host .load-more__horizontal-rule:before{content:"";position:absolute;height:.0625rem;top:0;left:0;right:0;box-shadow:inset 0 calc(var(--MdsLoadMore__horizontalRuleHeight, 1px)*-1) 0 0 var(--MdsLoadMore__horizontalRuleColor,#c1c3c3)}:host .load-more__status-text{margin-top:var(--MdsLoadMore__statusTextTopMargin,16px);margin-bottom:var(--MdsLoadMore__statusTextBottomMargin,16px);color:var(--MdsLoadMore__statusTextColor,#101820);font-size:var(--MdsLoadMore__statusTextSize,1rem);line-height:var(--MdsLoadMore__statusTextLineHeight,1.5rem);font-weight:var(--MdsLoadMore__statusTextWeight,400);pointer-events:none}:host .load-more__status-text:focus{outline:.0625rem dashed #717171}:host .load-more__accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}', "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/loading-bubble/mds-loading-bubble.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, "@keyframes slide{0%{width:calc(var(--MdsLoadingBubble__width, 68px)*var(--MdsLoadingBubble__bubbleSizeMotionStart, default-brand-get(mds-loading-bubble-bubble-size-motion-start)));overflow:hidden}to{width:calc(var(--MdsLoadingBubble__width, 68px)*var(--MdsLoadingBubble__bubbleSizeMotionEnd, default-brand-get(mds-loading-bubble-bubble-size-motion-end)));overflow:hidden}}@keyframes fadeIn{0%{opacity:calc(var(--MdsLoadingBubble__bubbleOpacityMotionStart, default-brand-get(mds-loading-bubble-bubble-opacity-motion-start))*1)}to{opacity:calc(var(--MdsLoadingBubble__bubbleOpacityMotionEnd, default-brand-get(mds-loading-bubble-bubble-opacity-motion-end))*1)}}@keyframes blink{0%{opacity:var(--MdsLoadingBubble__dotOpacityState1,.3);transform:scale(var(--MdsLoadingBubble__dotScaleState1,1))}33%{opacity:var(--MdsLoadingBubble__dotOpacityState2,.6);transform:scale(var(--MdsLoadingBubble__dotScaleState2,1))}66%{opacity:1;transform:scale(var(--MdsLoadingBubble__dotScaleState3,1.25))}}:host .mds-loading-bubble{border-top-left-radius:var(--MdsLoadingBubble__borderRadiusTopLeading,12px);border-top-right-radius:var(--MdsLoadingBubble__borderRadiusTopTrailing,12px);border-bottom-left-radius:var(--MdsLoadingBubble__borderRadiusBottomLeading,12px);border-bottom-right-radius:var(--MdsLoadingBubble__borderRadiusBottomTrailing,12px);border-width:var(--MdsLoadingBubble__borderWidth,1px);border-style:solid;height:var(--MdsLoadingBubble__height,36px);max-width:var(--MdsLoadingBubble__width,68px);width:var(--MdsLoadingBubble__width,68px);display:flex;align-items:center;justify-content:center;margin-top:var(--MdsLoadingBubble__topPadding,8px);margin-bottom:var(--MdsLoadingBubble__bottomPadding,8px);animation-name:slide,fadeIn;animation-duration:var(--MdsLoadingBubble__bubbleSizeMotionTiming,.35s),var(--MdsLoadingBubble__bubbleOpacityMotionTiming,.35s);animation-timing-function:var(--MdsLoadingBubble__bubbleSizeMotionEasing,cubic-bezier(0,0,0,1)),var(--MdsLoadingBubble__bubbleOpacityMotionEasing,linear);animation-fill-mode:none}:host .mds-loading-bubble--first{border-top-left-radius:var(--MdsLoadingBubble-_firstInGroup-true__borderRadiusTopLeading,2px)}:host .mds-loading-bubble__dot{height:var(--MdsLoadingBubble__dotHeight,8px);width:var(--MdsLoadingBubble__dotWidth,8px);border-radius:100%;margin-right:var(--MdsLoadingBubble__dotTrailingMargin,6px);animation-name:blink;animation-duration:calc(var(--MdsLoadingBubble__dotStateTiming, .35s)*3);animation-iteration-count:infinite;animation-fill-mode:both;animation-timing-function:var(--MdsLoadingBubble__dotStateEase,cubic-bezier(0,.2,.1,1));border:0}:host .mds-loading-bubble__dot:nth-child(2){animation-delay:calc(var(--MdsLoadingBubble__dotStateTiming, .35s)*1)}:host .mds-loading-bubble__dot:nth-child(3){animation-delay:calc(var(--MdsLoadingBubble__dotStateTiming, .35s)*2);margin-right:0}.mds-loading-bubble__dot{background-color:var(--MdsLoadingBubble__dotColor,#005eb8)}.mds-loading-bubble--agent{border-color:var(--MdsLoadingBubble-_variant-agent__borderColor,#eceff1);background-color:var(--MdsLoadingBubble-_variant-agent__backgroundColor,#eceff1)}.mds-loading-bubble--assistant{border-color:var(--MdsLoadingBubble-_variant-assistant__borderColor,#c1c3c3);background-color:var(--MdsLoadingBubble-_variant-assistant__backgroundColor,#fff)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/map-static/mds-map-static.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{box-sizing:border-box}:host .map-static{display:flex}:host .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/map/map-marker/map-marker-overlay/mds-map-marker-overlay.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ':host{position:absolute;max-width:320px}:host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif;box-sizing:border-box}:host .map-marker-overlay{cursor:auto;background-color:var(--MdsMapMarker__overlayBackgroundColor,#fff);padding:var(--MdsMapMarker__overlayTopPadding,16px) var(--MdsMapMarker__overlayTrailingPadding,16px) var(--MdsMapMarker__overlayBottomPadding,16px) var(--MdsMapMarker__overlayLeadingPadding,16px);font-size:var(--MdsMapMarker__overlayTextSize,.875rem);line-height:var(--MdsMapMarker__overlayTextLineHeight,1.25rem);width:-moz-max-content;width:max-content;min-width:var(--MdsMapMarker__overlayMinWidth,128px);max-width:var(--MdsMapMarker__overlayMaxWidth,320px);border:var(--MdsMapMarker__overlayBorderWidth,1px) var(--MdsMapMarker__overlayBorderStyle,solid) var(--MdsMapMarker__overlayBorderColor,#c1c3c3);box-shadow:var(--MdsMapMarker__overlayBoxShadowHorizontalOffset,0) var(--MdsMapMarker__overlayBoxShadowVerticalOffset,2px) var(--MdsMapMarker__overlayBoxShadowBlurRadius,4px) var(--MdsMapMarker__overlayBoxShadowSpreadRadius,0) var(--MdsMapMarker__overlayBoxShadowColor,rgba(0,0,0,.4))}:host .map-marker-overlay:focus{outline:none}:host .map-marker-overlay__title{margin:0;font-weight:var(--MdsMapMarker__overlayTitleTextWeight,600);padding-right:calc(var(--MdsMapMarker__overlayCloseIconWidth, 20px) + var(--MdsMapMarker__overlayCloseIconLeadingMargin, 16px))}:host .map-marker-overlay__detail{margin:var(--MdsMapMarker__overlayDetailTopMargin,4px) 0 0;font-weight:var(--MdsMapMarker__overlayDetailTextWeight,400)}:host .map-marker-overlay__detail a:focus{outline:.0625rem dashed #717171}:host .map-marker-overlay__caret{background:var(--MdsMapMarker__overlayBackgroundColor,#fff);border:var(--MdsMapMarker__caretBorderWidth,1px) var(--MdsMapMarker__caretBorderStyle,solid) var(--MdsMapMarker__caretBorderColor,#c1c3c3);height:var(--MdsMapMarker__caretHeight,20px);width:var(--MdsMapMarker__caretWidth,20px);position:absolute;transform:rotate(45deg)}:host .map-marker-overlay__close-button{position:absolute;top:var(--MdsMapMarker__overlayTopPadding,16px);right:var(--MdsMapMarker__overlayTrailingPadding,16px);display:flex;border:0;margin:0;padding:0;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;cursor:pointer}:host .map-marker-overlay__close-button:focus{outline:.0625rem dashed #717171}:host .map-marker-overlay__close-button::-moz-focus-inner{border:0}:host .map-marker-overlay__close-icon{pointer-events:none;display:inline-flex}:host .map-marker-overlay__close-icon svg{width:var(--MdsMapMarker__overlayCloseIconWidth,20px);height:var(--MdsMapMarker__overlayCloseIconHeight,20px);fill:var(--MdsMapMarker__overlayCloseIconColor,#565a5d)}:host(mds-map-marker-overlay[vertical-position=above]){bottom:calc(var(--MdsMapMarker__buttonHeight, 44px) + var(--MdsMapMarker__caretHeight, 20px))}:host(mds-map-marker-overlay[vertical-position=above]):after{content:"";background:var(--MdsMapMarker__overlayBackgroundColor,#fff);height:calc(var(--MdsMapMarker__overlayTopPadding, 16px) - 1);width:calc(100% - var(--MdsMapMarker__overlayBorderWidth, 1px)*2);position:absolute;left:var(--MdsMapMarker__overlayBorderWidth,1px);bottom:0;pointer-events:none}:host(mds-map-marker-overlay[vertical-position=above]) .map-marker-overlay__caret{border-left-color:transparent;border-top-color:transparent;bottom:calc(var(--MdsMapMarker__caretHeight, 20px)/2*-1);box-shadow:var(--MdsMapMarker__caretBoxShadowHorizontalOffset,2px) var(--MdsMapMarker__caretBoxShadowVerticalOffset,2px) var(--MdsMapMarker__caretBoxShadowBlurRadius,4px) var(--MdsMapMarker__caretBoxShadowSpreadRadius,0) var(--MdsMapMarker__caretBoxShadowColor,rgba(0,0,0,.4))}:host(mds-map-marker-overlay[vertical-position=below]){top:calc(var(--MdsMapMarker__buttonHeight, 44px) + var(--MdsMapMarker__caretHeight, 20px))}:host(mds-map-marker-overlay[vertical-position=below]) .map-marker-overlay__caret{border-bottom-color:transparent;border-right-color:transparent;top:calc(var(--MdsMapMarker__caretHeight, 20px)/2*-1)}:host(mds-map-marker-overlay[horizontal-position=left]){left:-1px}:host(mds-map-marker-overlay[horizontal-position=left]) .map-marker-overlay__caret{left:calc(var(--MdsMapMarker__caretWidth, 20px) - var(--MdsMapMarker__caretOutsideMargin, 8px) + var(--MdsMapMarker__overlayBorderWidth, 1px))}:host(mds-map-marker-overlay[horizontal-position=center]){left:50%;transform:translateX(-50%)}:host(mds-map-marker-overlay[horizontal-position=center]) .map-marker-overlay__caret{left:50%;transform:translateX(-50%) rotate(45deg)}:host(mds-map-marker-overlay[horizontal-position=right]){right:-1px}:host(mds-map-marker-overlay[horizontal-position=right]) .map-marker-overlay__caret{right:calc(var(--MdsMapMarker__caretWidth, 20px) - var(--MdsMapMarker__caretOutsideMargin, 8px) + var(--MdsMapMarker__overlayBorderWidth, 1px))}:host(mds-map-marker-overlay[is-mobile=true]){left:0;bottom:0;width:100%;max-width:none}:host(mds-map-marker-overlay[is-mobile=true]) .map-marker-overlay{width:unset;max-width:none;box-shadow:none}:host(mds-map-marker-overlay[is-mobile=true]) .map-marker-overlay:before{content:"";position:absolute;height:var(--MdsMapMarker__overlayBoxShadowVerticalOffset,2px);top:calc(var(--MdsMapMarker__overlayBoxShadowVerticalOffset, 2px)*-1);left:0;right:0;box-shadow:inset var(--MdsMapMarker__overlayBoxShadowHorizontalOffset,0) calc(var(--MdsMapMarker__overlayBoxShadowVerticalOffset, 2px)*-1) var(--MdsMapMarker__overlayBoxShadowBlurRadius,4px) calc(var(--MdsMapMarker__overlayBoxShadowVerticalOffset, 2px)*-1) var(--MdsMapMarker__overlayBoxShadowColor,rgba(0,0,0,.4))}', "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/map/map-marker/mds-map-marker.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host{position:absolute;top:0;left:0;transform:translate(-50%,-100%)}:host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif;box-sizing:border-box}:host .map-marker{position:relative}:host .map-marker__button{height:var(--MdsMapMarker__buttonHeight,44px);width:var(--MdsMapMarker__buttonWidth,44px);display:flex;border:0;margin:0;padding:0;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;cursor:pointer}:host .map-marker__button::-moz-focus-inner{border:0}:host .map-marker__button--open,:host .map-marker__button:active,:host .map-marker__button:focus{outline:none}:host .map-marker__button--open .map-marker__pin g,:host .map-marker__button:active .map-marker__pin g,:host .map-marker__button:focus .map-marker__pin g{stroke-width:calc(var(--MdsMapMarker__borderWidth--focused, 4px)*2)}:host .map-marker__pin{overflow:visible;pointer-events:none;position:absolute;height:var(--MdsMapMarker__pinHeight,39px);width:var(--MdsMapMarker__pinWidth,32px);left:50%;top:50%;transform:translate(-50%,-50%)}:host .map-marker__pin text{font-size:var(--MdsMapMarker__labelTextSize,.875rem);line-height:var(--MdsMapMarker__labelTextLineHeight,1.25rem);text-anchor:middle;stroke:var(--MdsMapMarker__labelTextColor,#fff);stroke-width:initial}:host .map-marker__pin g{stroke-width:calc(var(--MdsMapMarker__borderWidth, 1px)*2);stroke:var(--MdsMapMarker__borderColor,#fff);paint-order:stroke;fill:none;fill-rule:evenodd}:host .map-marker__icon{display:inline-flex;position:absolute;top:var(--MdsMapMarker__iconMarginTop,6px);left:50%;transform:translate(-50%);pointer-events:none}:host .map-marker__icon svg{height:var(--MdsMapMarker__iconHeight,24px);width:var(--MdsMapMarker__iconWidth,24px);fill:var(--MdsMapMarker__iconColor,#fff)}:host .map-marker__pin path{fill:var(--MdsMapMarker__backgroundColor,#005eb8)}:host .map-marker__button:focus .map-marker__pin g{stroke:var(--MdsMapMarker__borderColor--focused,rgba(0,145,218,.5))}:host .map-marker__button--open .map-marker__pin g,:host .map-marker__button:active .map-marker__pin g{stroke:var(--MdsMapMarker__borderColor--active,rgba(0,145,218,.5))}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/map/mds-map.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host{display:block}:host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif;box-sizing:border-box}:host .map{position:relative}:host .map--focused{outline:.0625rem dashed #717171}:host .map__container{height:100%}:host .map__focusable-container:focus{cursor:move!important}:host .gm-control-active:focus{z-index:1}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/menu/mds-menu.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ':host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .menu{position:absolute;z-index:99999;border-radius:var(--MdsMenu__containerBorderRadius,8px);border-style:solid;box-sizing:border-box;min-width:var(--MdsMenu__containerMinWidth,120px);display:none}:host .menu--above{transform:translateY(-.625rem);bottom:100%}:host .menu--above.menu--center{transform:translateY(-.125rem) translate(-50%,-12px)}:host .menu--below{transform:translateY(.625rem)}:host .menu--below.menu--center{transform:translateY(.125rem) translate(-50%,12px)}:host .menu--center{left:50%}:host .menu--right{max-width:none;right:0}:host .menu__pointer{height:.75rem;width:.75rem;position:absolute;border-style:solid;transform:rotate(45deg);z-index:-1}:host .menu__pointer--above{transform:translateY(18%) rotate(45deg);border-left-color:transparent;border-top-color:transparent;bottom:-4.24264px}:host .menu__pointer--below{transform:translateY(-18%) rotate(45deg);top:-4.24264px;border-right-color:transparent;border-bottom-color:transparent;border-width:var(--MdsMenuButton__tooltipBorderWidth,1px)}@-moz-document url-prefix(""){:host .menu__pointer{box-sizing:content-box}}:host .menu__pointer--center{left:50%}:host .menu__pointer--left{left:12px}:host .menu__pointer--right{right:12px}:host .menu__pointer--noShow{display:none}:host .menu__slot{display:flex}:host .menu__footnote{padding-top:var(--MdsMenu__footnoteTopPadding,8px);padding-right:var(--MdsMenu__footnoteTrailingPadding,16px);padding-bottom:.75rem;padding-left:var(--MdsMenu__footnoteLeadingPadding,16px);font-size:var(--MdsMenu__footnoteTextSize,16px);color:var(--MdsMenu__footnoteTextColor,#565a5d);font-weight:var(--MdsMenu__footnoteTextWeight,400);line-height:var(--MdsMenu__footnoteLineHeight,1rem);text-align:var(--MdsMenu__footnoteTextAlignment,left)}:host .menu .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .menu{box-shadow:var(--MdsMenu__containerBoxShadowHorizontalOffset,0) var(--MdsMenu__containerBoxShadowVerticalOffset,2px) var(--MdsMenu__containerBoxShadowBlurRadius,4px) var(--MdsMenu__containerBoxShadowSpreadRadius,0) var(--MdsMenu__containerBoxShadowColor,rgba(0,0,0,.4));border:var(--MdsMenuButton__tooltipBorderWidth,1px) solid var(--MdsMenu__containerBorderColor,#e2e4e5)}:host .menu,:host .menu__pointer{background-color:var(--MdsMenu__containerBackgroundColor,#fff)}:host .menu__pointer{border-color:transparent}:host .menu__pointer--below{border-top-color:var(--MdsMenu__containerBorderColor,#e2e4e5);border-left-color:var(--MdsMenu__containerBorderColor,#e2e4e5)}:host .menu__pointer--above{border-bottom-color:var(--MdsMenu__containerBorderColor,#e2e4e5);border-right-color:var(--MdsMenu__containerBorderColor,#e2e4e5);border-width:var(--MdsMenu__containerBorderWidth,1px)}:host .menu__footnote{border-top:var(--MdsMenu__footnoteDividerBorderWidth,1px) var(--MdsMenu__footnoteDividerBorderStyle,solid) var(--MdsMenu__containerBorderColor,#e2e4e5)}', "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/menu/menu-column/mds-menu-column.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .menu-column__container{padding-top:var(--MdsMenu__containerTopPadding,4px);box-sizing:border-box;height:100%}:host .menu-column__header{padding:var(--MdsMenu_Column__headerTopPadding,16px) var(--MdsMenu_Column__headerTrailingPadding,16px) var(--MdsMenu_Column__headerBottomPadding,16px) var(--MdsMenu_Column__headerLeadingPadding,16px);font-size:var(--MdsMenu_Column__headerTextSize,1rem);color:var(--MdsMenu_Column__headerTextColor,#101820);font-weight:var(--MdsMenu_Column__headerTextWeight,600);line-height:var(--MdsMenu_Column__headerTextLineHeight,1.5rem);text-align:var(--MdsMenu_Column__headerTextAlignment,left)}:host .menu-column__divider{border-right:var(--MdsMenu_Column__dividerBorderWidth,1px) var(--MdsMenu_Column__dividerBorderStyle,solid) #bcbcbc}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/menu/menu-group/mds-menu-group.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ':host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .menu-group{width:100%}:host .menu-group__header{display:flex;justify-content:space-between;align-items:flex-start;width:100%;border:0;background-color:var(--MdsMenu_Group__backgroundColor,#fff);padding:var(--MdsMenu_Group__topPadding,16px) var(--MdsMenu_Group__trailingPadding,16px) var(--MdsMenu_Group__bottomPadding,16px) var(--MdsMenu_Group__leadingPadding,16px);position:relative}:host .menu-group__header-label{font-size:var(--MdsMenu_Group__headerTextSize,.875rem);color:var(--MdsMenu_Group__headerTextColor,#101820);font-weight:var(--MdsMenu_Group__headerTextWeight,400);line-height:var(--MdsMenu_Group__headerLineHeight,1.25rem);text-align:var(--MdsMenu_Group__headerHorizontalAlignment,left)}:host .menu-group__header--expanded{border-left:var(--MdsMenu_Group__expandedIndicatorBorderWidth,4px) solid var(--MdsMenu_Group__expandedIndicatorBorderColor,#005eb8);padding-left:calc(var(--MdsMenu_Group__leadingPadding, default-brand-get(mds-menu-group-leading-padding)) - var(--MdsMenu_Group__expandedIndicatorBorderWidth, default-brand-get(mds-menu-group-expanded-indicator-border-width)))}:host .menu-group__header--divider{border-bottom:var(--MdsMenu_Group__dividerBorderWidth,1px) var(--MdsMenu_Group__dividerBorderStyle,solid) #bcbcbc}:host .menu-group__header:hover{background-color:var(--MdsMenu_Group__backgroundColor--hovered,rgba(0,94,184,.08))}:host .menu-group__header:hover .menu-group__header-label{color:var(--MdsMenu_Group__headerTextColor--hovered,#004692)}:host .menu-group__header:hover .menu-group__chevron-icon svg{fill:var(--MdsMenu_Group__chevronIconColor--hovered,#004692)}:host .menu-group__header:focus{z-index:1;background-color:var(--MdsMenu_Group__backgroundColor--focused,rgba(0,94,184,.08))}:host .menu-group__header:focus:focus{outline:.0625rem dashed #717171}:host .menu-group__header:focus .menu-group__header-label{color:var(--MdsMenu_Group__headerTextColor--focused,#004692)}:host .menu-group__header:focus .menu-group__chevron-icon svg{fill:var(--MdsMenu_Group__chevronIconColor--focused,#004692)}:host .menu-group__trailing-content{display:flex;align-items:center}:host .menu-group__badge,:host .menu-group__tag{margin-left:.5rem}:host .menu-group__chevron-icon{margin-left:var(--MdsMenu_Group__chevronIconLeadingPadding,8px);width:var(--MdsMenu_Group__chevronIconWidth,16px);height:var(--MdsMenu_Group__chevronIconHeight,16px)}:host .menu-group__chevron-icon--expanded{transform:rotate(-180deg);margin-left:var(--MdsMenu_Group__chevronIconLeadingPadding,8px)}:host .menu-group__chevron-icon svg{width:var(--MdsMenu_Group__chevronIconWidth,16px);height:var(--MdsMenu_Group__chevronIconHeight,16px);fill:var(--MdsMenu_Group__chevronIconColor,#565a5d)}:host .menu-group__slot--indented-divider{position:relative}:host .menu-group__slot--indented-divider:after{content:"";position:absolute;left:var(--MdsMenu_Item__nestedItemLeadingPadding,32px);right:0;bottom:0;height:var(--MdsMenu_Group__dividerBorderWidth,1px);background-color:#bcbcbc}:host .menu-group__slot--full-divider{border-bottom:var(--MdsMenu_Group__dividerBorderWidth,1px) var(--MdsMenu_Group__dividerBorderStyle,solid) #bcbcbc}', "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/menu/menu-item/mds-menu-item.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .menu-item{width:100%;display:flex;justify-content:space-between;background-color:var(--MdsMenu_Item__backgroundColor,#fff);padding:var(--MdsMenu_Item__topPadding,12px) var(--MdsMenu_Item__trailingPadding,16px) var(--MdsMenu_Item__bottomPadding,12px) var(--MdsMenu_Item__leadingPadding,16px);border:0;position:relative}:host .menu-item:hover:not(.menu-item:disabled){background-color:var(--MdsMenu_Item__backgroundColor--hovered,rgba(0,94,184,.08))}:host .menu-item:hover:not(.menu-item:disabled) .menu-item__label{color:var(--MdsMenu_Item__labelTextColor--hovered,#004692)}:host .menu-item:focus:not(.menu-item:disabled){z-index:1;background-color:var(--MdsMenu_Item__backgroundColor--focused,rgba(0,94,184,.08))}:host .menu-item:focus:not(.menu-item:disabled):focus{outline:.0625rem dashed #717171}:host .menu-item:focus:not(.menu-item:disabled) .menu-item__label{color:var(--MdsMenu_Item__labelTextColor--focused,#004692)}:host .menu-item:active:not(.menu-item:disabled){background-color:var(--MdsMenu_Item__backgroundColor--pressed,rgba(0,94,184,.08))}:host .menu-item:active:not(.menu-item:disabled) .menu-item__label{color:var(--MdsMenu_Item__labelTextColor--pressed,#0091da)}:host .menu-item:disabled{background-color:var(--MdsMenu_Item-_inactive-true__backgroundColor,)}:host .menu-item:disabled .menu-item__label{color:var(--MdsMenu_Item-_inactive-true__labelTextColor,)}:host .menu-item__leading-content{display:inline-flex;align-items:flex-start}:host .menu-item__icon{padding-right:var(--MdsMenu_Item__iconTrailingPadding,16px);height:var(--MdsMenu_Item__iconHeight,20px)}:host .menu-item__icon svg{height:var(--MdsMenu_Item__iconHeight,20px);width:var(--MdsMenu_Item__iconWidth,20px);fill:var(--MdsMenu_Item__iconColor,#565a5d)}:host .menu-item__label{text-align:var(--MdsMenu_Item__labelHorizontalAlignment,left);font-size:var(MdsMenu_Item__labelTextSize,.875rem);color:var(--MdsMenu_Item__labelTextColor,#101820);font-weight:var(--MdsMenu_Item__labelTextWeight,400);line-height:var(--MdsMenu_Item__labelLineHeight,1.25rem)}:host .menu-item__badge{padding-left:var(--MdsMenu_Item__badgeLeadingPadding,8px)}:host .menu-item__tag{padding-left:var(--MdsMenu_Item__tagLeadingPadding,8px)}:host .menu-item__divider{border-bottom:var(--MdsMenu_Group__dividerBorderWidth,1px) var(--MdsMenu_Group__dividerBorderStyle,solid) #bcbcbc}:host .menu-item--nested{padding-left:var(--MdsMenu_Item__nestedItemLeadingPadding,32px)}:host .menu-item--selected{border-left:var(--MdsMenu_Item__selectionIndicatorBorderWidth,4px) solid var(--MdsMenu_Item__selectionIndicatorBorderColor,#005eb8)}:host .menu-item--selected:hover{border-left:var(--MdsMenu_Item__selectionIndicatorBorderWidth,4px) solid var(--MdsMenu_Item__selectionIndicatorBorderColor--hovered,#005eb8)}:host .menu-item--selected:focus{border-left:var(--MdsMenu_Item__selectionIndicatorBorderWidth,4px) solid var(--MdsMenu_Item__selectionIndicatorBorderColor--focused,#005eb8)}:host .menu-item--selected:focus:focus{outline:.0625rem dashed #717171}:host .menu-item--selected:active{border-left:var(--MdsMenu_Item__selectionIndicatorBorderWidth,4px) solid var(--MdsMenu_Item__selectionIndicatorBorderColor--pressed,#0091da)}:host .menu-item--selected:disabled{border-left:var(--MdsMenu_Item__selectionIndicatorBorderWidth,4px) solid #c1c3c3}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/message-drawer/mds-message-drawer.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host .message-drawer{transition-property:max-height;transition-duration:var(--MdsMessageDrawer__animationTiming,.5s);transition-timing-function:var(--MdsMessageDrawer__animationEase,cubic-bezier(0,0,0,1));overflow:hidden}:host .message-drawer--closed{display:none}:host .message-drawer__list{padding:0;margin:0}:host .message-drawer__list-item{list-style-type:none;margin:0}:host .message-drawer__list-item:not(:last-of-type){border-bottom:var(--MdsMessageDrawer__separatorHeight,1px) solid var(--MdsMessageDrawer__separatorColor,1px)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/multiselect/mds-multiselect.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ".mds-container{box-sizing:border-box;margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px;width:100%}@media print,screen and (min-width:576px){.mds-container{max-width:540px}}@media print,screen and (min-width:768px){.mds-container{max-width:720px}}@media print,screen and (min-width:992px){.mds-container{max-width:960px}}@media print,screen and (min-width:1200px){.mds-container{max-width:1140px}}.mds-container-at-576,.mds-container-at-768,.mds-container-at-992,.mds-container-at-1200,.mds-container-fluid{box-sizing:border-box;margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px;width:100%}@media print,screen and (min-width:576px){.mds-container,.mds-container-at-576{max-width:var(--mds-container-max-width-at-576,540px)}}@media print,screen and (min-width:768px){.mds-container,.mds-container-at-576,.mds-container-at-768{max-width:var(--mds-container-max-width-at-768,720px)}}@media print,screen and (min-width:992px){.mds-container,.mds-container-at-576,.mds-container-at-768,.mds-container-at-992{max-width:var(--mds-container-max-width-at-992,960px)}}@media print,screen and (min-width:1200px){.mds-container,.mds-container-at-576,.mds-container-at-768,.mds-container-at-992,.mds-container-at-1200{max-width:var(--mds-container-max-width-at-1200,1140px)}}.mds-row{display:flex;flex-wrap:wrap;margin-left:-15px;margin-right:-15px}.mds-no-gutters{margin-left:0;margin-right:0}.mds-no-gutters>.mds-col,.mds-no-gutters>[class*=mds-col-]{padding-left:0;padding-right:0}.mds-col,.mds-col-1,.mds-col-2,.mds-col-3,.mds-col-4,.mds-col-5,.mds-col-6,.mds-col-7,.mds-col-8,.mds-col-9,.mds-col-10,.mds-col-11,.mds-col-12,.mds-col-at-576,.mds-col-at-576-1,.mds-col-at-576-2,.mds-col-at-576-3,.mds-col-at-576-4,.mds-col-at-576-5,.mds-col-at-576-6,.mds-col-at-576-7,.mds-col-at-576-8,.mds-col-at-576-9,.mds-col-at-576-10,.mds-col-at-576-11,.mds-col-at-576-12,.mds-col-at-576-auto,.mds-col-at-768,.mds-col-at-768-1,.mds-col-at-768-2,.mds-col-at-768-3,.mds-col-at-768-4,.mds-col-at-768-5,.mds-col-at-768-6,.mds-col-at-768-7,.mds-col-at-768-8,.mds-col-at-768-9,.mds-col-at-768-10,.mds-col-at-768-11,.mds-col-at-768-12,.mds-col-at-768-auto,.mds-col-at-992,.mds-col-at-992-1,.mds-col-at-992-2,.mds-col-at-992-3,.mds-col-at-992-4,.mds-col-at-992-5,.mds-col-at-992-6,.mds-col-at-992-7,.mds-col-at-992-8,.mds-col-at-992-9,.mds-col-at-992-10,.mds-col-at-992-11,.mds-col-at-992-12,.mds-col-at-992-auto,.mds-col-at-1200,.mds-col-at-1200-1,.mds-col-at-1200-2,.mds-col-at-1200-3,.mds-col-at-1200-4,.mds-col-at-1200-5,.mds-col-at-1200-6,.mds-col-at-1200-7,.mds-col-at-1200-8,.mds-col-at-1200-9,.mds-col-at-1200-10,.mds-col-at-1200-11,.mds-col-at-1200-12,.mds-col-at-1200-auto,.mds-col-auto{box-sizing:border-box;position:relative;width:100%;padding-left:8px;padding-right:8px}@media print,screen and (min-width:576px){.mds-col,.mds-col-1,.mds-col-2,.mds-col-3,.mds-col-4,.mds-col-5,.mds-col-6,.mds-col-7,.mds-col-8,.mds-col-9,.mds-col-10,.mds-col-11,.mds-col-12,.mds-col-at-576,.mds-col-at-576-1,.mds-col-at-576-2,.mds-col-at-576-3,.mds-col-at-576-4,.mds-col-at-576-5,.mds-col-at-576-6,.mds-col-at-576-7,.mds-col-at-576-8,.mds-col-at-576-9,.mds-col-at-576-10,.mds-col-at-576-11,.mds-col-at-576-12,.mds-col-at-576-auto,.mds-col-at-768,.mds-col-at-768-1,.mds-col-at-768-2,.mds-col-at-768-3,.mds-col-at-768-4,.mds-col-at-768-5,.mds-col-at-768-6,.mds-col-at-768-7,.mds-col-at-768-8,.mds-col-at-768-9,.mds-col-at-768-10,.mds-col-at-768-11,.mds-col-at-768-12,.mds-col-at-768-auto,.mds-col-at-992,.mds-col-at-992-1,.mds-col-at-992-2,.mds-col-at-992-3,.mds-col-at-992-4,.mds-col-at-992-5,.mds-col-at-992-6,.mds-col-at-992-7,.mds-col-at-992-8,.mds-col-at-992-9,.mds-col-at-992-10,.mds-col-at-992-11,.mds-col-at-992-12,.mds-col-at-992-auto,.mds-col-at-1200,.mds-col-at-1200-1,.mds-col-at-1200-2,.mds-col-at-1200-3,.mds-col-at-1200-4,.mds-col-at-1200-5,.mds-col-at-1200-6,.mds-col-at-1200-7,.mds-col-at-1200-8,.mds-col-at-1200-9,.mds-col-at-1200-10,.mds-col-at-1200-11,.mds-col-at-1200-12,.mds-col-at-1200-auto,.mds-col-auto{padding-left:8px;padding-right:8px}}@media print,screen and (min-width:768px){.mds-col,.mds-col-1,.mds-col-2,.mds-col-3,.mds-col-4,.mds-col-5,.mds-col-6,.mds-col-7,.mds-col-8,.mds-col-9,.mds-col-10,.mds-col-11,.mds-col-12,.mds-col-at-576,.mds-col-at-576-1,.mds-col-at-576-2,.mds-col-at-576-3,.mds-col-at-576-4,.mds-col-at-576-5,.mds-col-at-576-6,.mds-col-at-576-7,.mds-col-at-576-8,.mds-col-at-576-9,.mds-col-at-576-10,.mds-col-at-576-11,.mds-col-at-576-12,.mds-col-at-576-auto,.mds-col-at-768,.mds-col-at-768-1,.mds-col-at-768-2,.mds-col-at-768-3,.mds-col-at-768-4,.mds-col-at-768-5,.mds-col-at-768-6,.mds-col-at-768-7,.mds-col-at-768-8,.mds-col-at-768-9,.mds-col-at-768-10,.mds-col-at-768-11,.mds-col-at-768-12,.mds-col-at-768-auto,.mds-col-at-992,.mds-col-at-992-1,.mds-col-at-992-2,.mds-col-at-992-3,.mds-col-at-992-4,.mds-col-at-992-5,.mds-col-at-992-6,.mds-col-at-992-7,.mds-col-at-992-8,.mds-col-at-992-9,.mds-col-at-992-10,.mds-col-at-992-11,.mds-col-at-992-12,.mds-col-at-992-auto,.mds-col-at-1200,.mds-col-at-1200-1,.mds-col-at-1200-2,.mds-col-at-1200-3,.mds-col-at-1200-4,.mds-col-at-1200-5,.mds-col-at-1200-6,.mds-col-at-1200-7,.mds-col-at-1200-8,.mds-col-at-1200-9,.mds-col-at-1200-10,.mds-col-at-1200-11,.mds-col-at-1200-12,.mds-col-at-1200-auto,.mds-col-auto{padding-left:12px;padding-right:12px}}@media print,screen and (min-width:992px){.mds-col,.mds-col-1,.mds-col-2,.mds-col-3,.mds-col-4,.mds-col-5,.mds-col-6,.mds-col-7,.mds-col-8,.mds-col-9,.mds-col-10,.mds-col-11,.mds-col-12,.mds-col-at-576,.mds-col-at-576-1,.mds-col-at-576-2,.mds-col-at-576-3,.mds-col-at-576-4,.mds-col-at-576-5,.mds-col-at-576-6,.mds-col-at-576-7,.mds-col-at-576-8,.mds-col-at-576-9,.mds-col-at-576-10,.mds-col-at-576-11,.mds-col-at-576-12,.mds-col-at-576-auto,.mds-col-at-768,.mds-col-at-768-1,.mds-col-at-768-2,.mds-col-at-768-3,.mds-col-at-768-4,.mds-col-at-768-5,.mds-col-at-768-6,.mds-col-at-768-7,.mds-col-at-768-8,.mds-col-at-768-9,.mds-col-at-768-10,.mds-col-at-768-11,.mds-col-at-768-12,.mds-col-at-768-auto,.mds-col-at-992,.mds-col-at-992-1,.mds-col-at-992-2,.mds-col-at-992-3,.mds-col-at-992-4,.mds-col-at-992-5,.mds-col-at-992-6,.mds-col-at-992-7,.mds-col-at-992-8,.mds-col-at-992-9,.mds-col-at-992-10,.mds-col-at-992-11,.mds-col-at-992-12,.mds-col-at-992-auto,.mds-col-at-1200,.mds-col-at-1200-1,.mds-col-at-1200-2,.mds-col-at-1200-3,.mds-col-at-1200-4,.mds-col-at-1200-5,.mds-col-at-1200-6,.mds-col-at-1200-7,.mds-col-at-1200-8,.mds-col-at-1200-9,.mds-col-at-1200-10,.mds-col-at-1200-11,.mds-col-at-1200-12,.mds-col-at-1200-auto,.mds-col-auto{padding-left:12px;padding-right:12px}}@media print,screen and (min-width:1200px){.mds-col,.mds-col-1,.mds-col-2,.mds-col-3,.mds-col-4,.mds-col-5,.mds-col-6,.mds-col-7,.mds-col-8,.mds-col-9,.mds-col-10,.mds-col-11,.mds-col-12,.mds-col-at-576,.mds-col-at-576-1,.mds-col-at-576-2,.mds-col-at-576-3,.mds-col-at-576-4,.mds-col-at-576-5,.mds-col-at-576-6,.mds-col-at-576-7,.mds-col-at-576-8,.mds-col-at-576-9,.mds-col-at-576-10,.mds-col-at-576-11,.mds-col-at-576-12,.mds-col-at-576-auto,.mds-col-at-768,.mds-col-at-768-1,.mds-col-at-768-2,.mds-col-at-768-3,.mds-col-at-768-4,.mds-col-at-768-5,.mds-col-at-768-6,.mds-col-at-768-7,.mds-col-at-768-8,.mds-col-at-768-9,.mds-col-at-768-10,.mds-col-at-768-11,.mds-col-at-768-12,.mds-col-at-768-auto,.mds-col-at-992,.mds-col-at-992-1,.mds-col-at-992-2,.mds-col-at-992-3,.mds-col-at-992-4,.mds-col-at-992-5,.mds-col-at-992-6,.mds-col-at-992-7,.mds-col-at-992-8,.mds-col-at-992-9,.mds-col-at-992-10,.mds-col-at-992-11,.mds-col-at-992-12,.mds-col-at-992-auto,.mds-col-at-1200,.mds-col-at-1200-1,.mds-col-at-1200-2,.mds-col-at-1200-3,.mds-col-at-1200-4,.mds-col-at-1200-5,.mds-col-at-1200-6,.mds-col-at-1200-7,.mds-col-at-1200-8,.mds-col-at-1200-9,.mds-col-at-1200-10,.mds-col-at-1200-11,.mds-col-at-1200-12,.mds-col-at-1200-auto,.mds-col-auto{padding-left:12px;padding-right:12px}}.mds-col{flex-basis:0;flex-grow:1;max-width:100%}.mds-col-auto{flex:0 0 auto;max-width:100%;width:auto}.mds-col-1{flex:0 0 8.33333%;max-width:8.33333%}.mds-col-2{flex:0 0 16.66667%;max-width:16.66667%}.mds-col-3{flex:0 0 25%;max-width:25%}.mds-col-4{flex:0 0 33.33333%;max-width:33.33333%}.mds-col-5{flex:0 0 41.66667%;max-width:41.66667%}.mds-col-6{flex:0 0 50%;max-width:50%}.mds-col-7{flex:0 0 58.33333%;max-width:58.33333%}.mds-col-8{flex:0 0 66.66667%;max-width:66.66667%}.mds-col-9{flex:0 0 75%;max-width:75%}.mds-col-10{flex:0 0 83.33333%;max-width:83.33333%}.mds-col-11{flex:0 0 91.66667%;max-width:91.66667%}.mds-col-12{flex:0 0 100%;max-width:100%}.mds-offset-1{margin-left:8.33333%}.mds-offset-2{margin-left:16.66667%}.mds-offset-3{margin-left:25%}.mds-offset-4{margin-left:33.33333%}.mds-offset-5{margin-left:41.66667%}.mds-offset-6{margin-left:50%}.mds-offset-7{margin-left:58.33333%}.mds-offset-8{margin-left:66.66667%}.mds-offset-9{margin-left:75%}.mds-offset-10{margin-left:83.33333%}.mds-offset-11{margin-left:91.66667%}@media print,screen and (min-width:576px){.mds-col-at-576{flex-basis:0;flex-grow:1;max-width:100%}.mds-col-at-576-auto{flex:0 0 auto;max-width:100%;width:auto}.mds-col-at-576-1{flex:0 0 8.33333%;max-width:8.33333%}.mds-col-at-576-2{flex:0 0 16.66667%;max-width:16.66667%}.mds-col-at-576-3{flex:0 0 25%;max-width:25%}.mds-col-at-576-4{flex:0 0 33.33333%;max-width:33.33333%}.mds-col-at-576-5{flex:0 0 41.66667%;max-width:41.66667%}.mds-col-at-576-6{flex:0 0 50%;max-width:50%}.mds-col-at-576-7{flex:0 0 58.33333%;max-width:58.33333%}.mds-col-at-576-8{flex:0 0 66.66667%;max-width:66.66667%}.mds-col-at-576-9{flex:0 0 75%;max-width:75%}.mds-col-at-576-10{flex:0 0 83.33333%;max-width:83.33333%}.mds-col-at-576-11{flex:0 0 91.66667%;max-width:91.66667%}.mds-col-at-576-12{flex:0 0 100%;max-width:100%}.mds-offset-at-576-0{margin-left:0}.mds-offset-at-576-1{margin-left:8.33333%}.mds-offset-at-576-2{margin-left:16.66667%}.mds-offset-at-576-3{margin-left:25%}.mds-offset-at-576-4{margin-left:33.33333%}.mds-offset-at-576-5{margin-left:41.66667%}.mds-offset-at-576-6{margin-left:50%}.mds-offset-at-576-7{margin-left:58.33333%}.mds-offset-at-576-8{margin-left:66.66667%}.mds-offset-at-576-9{margin-left:75%}.mds-offset-at-576-10{margin-left:83.33333%}.mds-offset-at-576-11{margin-left:91.66667%}}@media print,screen and (min-width:768px){.mds-col-at-768{flex-basis:0;flex-grow:1;max-width:100%}.mds-col-at-768-auto{flex:0 0 auto;max-width:100%;width:auto}.mds-col-at-768-1{flex:0 0 8.33333%;max-width:8.33333%}.mds-col-at-768-2{flex:0 0 16.66667%;max-width:16.66667%}.mds-col-at-768-3{flex:0 0 25%;max-width:25%}.mds-col-at-768-4{flex:0 0 33.33333%;max-width:33.33333%}.mds-col-at-768-5{flex:0 0 41.66667%;max-width:41.66667%}.mds-col-at-768-6{flex:0 0 50%;max-width:50%}.mds-col-at-768-7{flex:0 0 58.33333%;max-width:58.33333%}.mds-col-at-768-8{flex:0 0 66.66667%;max-width:66.66667%}.mds-col-at-768-9{flex:0 0 75%;max-width:75%}.mds-col-at-768-10{flex:0 0 83.33333%;max-width:83.33333%}.mds-col-at-768-11{flex:0 0 91.66667%;max-width:91.66667%}.mds-col-at-768-12{flex:0 0 100%;max-width:100%}.mds-offset-at-768-0{margin-left:0}.mds-offset-at-768-1{margin-left:8.33333%}.mds-offset-at-768-2{margin-left:16.66667%}.mds-offset-at-768-3{margin-left:25%}.mds-offset-at-768-4{margin-left:33.33333%}.mds-offset-at-768-5{margin-left:41.66667%}.mds-offset-at-768-6{margin-left:50%}.mds-offset-at-768-7{margin-left:58.33333%}.mds-offset-at-768-8{margin-left:66.66667%}.mds-offset-at-768-9{margin-left:75%}.mds-offset-at-768-10{margin-left:83.33333%}.mds-offset-at-768-11{margin-left:91.66667%}}@media print,screen and (min-width:992px){.mds-col-at-992{flex-basis:0;flex-grow:1;max-width:100%}.mds-col-at-992-auto{flex:0 0 auto;max-width:100%;width:auto}.mds-col-at-992-1{flex:0 0 8.33333%;max-width:8.33333%}.mds-col-at-992-2{flex:0 0 16.66667%;max-width:16.66667%}.mds-col-at-992-3{flex:0 0 25%;max-width:25%}.mds-col-at-992-4{flex:0 0 33.33333%;max-width:33.33333%}.mds-col-at-992-5{flex:0 0 41.66667%;max-width:41.66667%}.mds-col-at-992-6{flex:0 0 50%;max-width:50%}.mds-col-at-992-7{flex:0 0 58.33333%;max-width:58.33333%}.mds-col-at-992-8{flex:0 0 66.66667%;max-width:66.66667%}.mds-col-at-992-9{flex:0 0 75%;max-width:75%}.mds-col-at-992-10{flex:0 0 83.33333%;max-width:83.33333%}.mds-col-at-992-11{flex:0 0 91.66667%;max-width:91.66667%}.mds-col-at-992-12{flex:0 0 100%;max-width:100%}.mds-offset-at-992-0{margin-left:0}.mds-offset-at-992-1{margin-left:8.33333%}.mds-offset-at-992-2{margin-left:16.66667%}.mds-offset-at-992-3{margin-left:25%}.mds-offset-at-992-4{margin-left:33.33333%}.mds-offset-at-992-5{margin-left:41.66667%}.mds-offset-at-992-6{margin-left:50%}.mds-offset-at-992-7{margin-left:58.33333%}.mds-offset-at-992-8{margin-left:66.66667%}.mds-offset-at-992-9{margin-left:75%}.mds-offset-at-992-10{margin-left:83.33333%}.mds-offset-at-992-11{margin-left:91.66667%}}@media print,screen and (min-width:1200px){.mds-col-at-1200{flex-basis:0;flex-grow:1;max-width:100%}.mds-col-at-1200-auto{flex:0 0 auto;max-width:100%;width:auto}.mds-col-at-1200-1{flex:0 0 8.33333%;max-width:8.33333%}.mds-col-at-1200-2{flex:0 0 16.66667%;max-width:16.66667%}.mds-col-at-1200-3{flex:0 0 25%;max-width:25%}.mds-col-at-1200-4{flex:0 0 33.33333%;max-width:33.33333%}.mds-col-at-1200-5{flex:0 0 41.66667%;max-width:41.66667%}.mds-col-at-1200-6{flex:0 0 50%;max-width:50%}.mds-col-at-1200-7{flex:0 0 58.33333%;max-width:58.33333%}.mds-col-at-1200-8{flex:0 0 66.66667%;max-width:66.66667%}.mds-col-at-1200-9{flex:0 0 75%;max-width:75%}.mds-col-at-1200-10{flex:0 0 83.33333%;max-width:83.33333%}.mds-col-at-1200-11{flex:0 0 91.66667%;max-width:91.66667%}.mds-col-at-1200-12{flex:0 0 100%;max-width:100%}.mds-offset-at-1200-0{margin-left:0}.mds-offset-at-1200-1{margin-left:8.33333%}.mds-offset-at-1200-2{margin-left:16.66667%}.mds-offset-at-1200-3{margin-left:25%}.mds-offset-at-1200-4{margin-left:33.33333%}.mds-offset-at-1200-5{margin-left:41.66667%}.mds-offset-at-1200-6{margin-left:50%}.mds-offset-at-1200-7{margin-left:58.33333%}.mds-offset-at-1200-8{margin-left:66.66667%}.mds-offset-at-1200-9{margin-left:75%}.mds-offset-at-1200-10{margin-left:83.33333%}.mds-offset-at-1200-11{margin-left:91.66667%}}:host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .multiselect{position:relative}:host .multiselect--horizontal{display:flex}:host .multiselect--horizontal .multiselect__label-wrap{display:flex;justify-content:flex-end}:host .multiselect--horizontal .multiselect__header{margin-top:0}:host .multiselect__header{padding-left:var(--MdsMultiselect__textFieldOptionsSelectedLeadingPadding,8px);padding-right:calc(var(--MdsMultiselect__chevronLeadingPadding, 12px) + var(--MdsMultiSelect-_variant-box__chevronTrailingPadding, 12px) + var(--MdsMultiselect__chevronWidth, 16px));position:relative;min-height:calc(var(--MdsMultiselect-_variant-box__fieldTopPadding, 8px) + var(--MdsMultiselect-_variant-box__fieldTopPadding, 8px))var(--MdsMultiselect__fieldTextLineHeight,24px);margin-top:var(--MdsMultiselect-_layout-vertical__labelBottomPadding,8px);cursor:text}:host .multiselect__header--line{padding-right:calc(var(--MdsMultiselect__chevronLeadingPadding, 12px) + var(--MdsMultiselect__chevronWidth, 16px));padding-top:0;padding-left:0;margin-top:0;min-height:calc(var(--MdsMultiselect__fieldTopPadding, 0px) + var(--MdsMultiselect__fieldBottomPadding, 8px))var(--MdsMultiselect__fieldTextLineHeight,24px)}:host .multiselect__header--no-selection{padding-left:var(--MdsMultiselect-_variant-box__fieldLeadingPadding,16px)}:host .multiselect__header-icon{display:flex;position:absolute;right:var(--MdsMultiSelect-_variant-box__chevronTrailingPadding,12px);top:var(--MdsMultiselect-_variant-box__chevronTopPadding,12px)}:host .multiselect__header-icon svg{width:var(--MdsMultiselect__chevronWidth,16px);height:var(--MdsMultiselect__chevronHeight,16px)}:host .multiselect__header-icon--line{right:var(--MdsMultiselect__chevronTrailingPadding,0);top:var(--MdsMultiselect__chevronTopPadding,4px);transform:none}:host .multiselect__header--disabled{cursor:default}:host .multiselect__input{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:transparent;padding:0 0 var(--MdsMultiselect-_variant-box__textFieldBottomMargin,6px);font-size:var(--MdsMultiselect__fieldTextSize,1rem);line-height:var(--MdsMultiselect__fieldTextLineHeight,1.5rem);transform:translateY(.0625rem);border:0;outline:none;width:100%;margin:0}:host .multiselect__input::-moz-placeholder{opacity:1}:host .multiselect__input::placeholder{opacity:1}:host .multiselect__input--no-selection{padding-top:var(--MdsSelect-_variant-box__fieldTopPadding,8px);padding-bottom:var(--MdsSelect-_variant-box__fieldBottomPadding,8px);transform:translateY(0)}:host .multiselect__input--line{padding-bottom:var(--MdsMultiselect__textFieldBottomMargin,4px);transform:translateY(0)}:host .multiselect__input-wrap{position:relative}:host .multiselect__input-mirror{position:absolute;white-space:nowrap;visibility:hidden;top:0;left:0}:host .multiselect__input-mirror-wrap{position:relative;display:inline-block}:host .multiselect__pill-list{display:inline}:host .multiselect__pill{display:inline-flex;align-items:center;max-width:100%;border-style:solid;border-width:var(--MdsMultiselect_pill__borderWidth,1px);border-radius:var(--MdsMultiselect_pill__borderRadus,6px);padding:var(--MdsMultiselect_pill__topPadding,3px) var(--MdsMultiselect_pill__trailingPadding,8px) var(--MdsMultiselect_pill__bottomPadding,3px) var(--MdsMultiselect_pill__leadingPadding,8px);margin-bottom:var(--MdsMultiselect-_variant-box__textFieldBottomMargin,6px);margin-right:var(--MdsMultiselect_pill__trailingMargin,4px);cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none}:host .multiselect__pill:focus:focus{outline:.0625rem dashed #717171}:host .multiselect__pill--disabled{pointer-events:none}:host .multiselect__pill--line{margin-bottom:var(--MdsMultiselect_pill__bottomMargin,4px)}:host .multiselect__pill-container:first-of-type .multiselect__pill--box{margin-top:var(--MdsMultiselect-_variant-box__textFieldTopMargin,6px)}:host .multiselect__pill-text{font-size:var(--MdsMultiselect_pill__textSize,.875rem);line-height:var(--MdsMultiselect_pill__textLineHeight,1.25rem);font-weight:var(--MdsMultiselect_pill__textWeight,400);margin-right:var(--MdsMultiselect_pill__textTrailingMargin,4px);overflow:hidden;white-space:nowrap;text-overflow:ellipsis;pointer-events:none}:host .multiselect__pill-container{display:inline}:host .multiselect__pill-icon{display:flex;pointer-events:none}:host .multiselect__pill-icon svg{height:var(--MdsMultiselect_pill__iconHeight,12px);width:var(--MdsMultiselect_pill__iconWidth,12px)}:host .multiselect__menu{position:absolute;visibility:hidden;overflow-y:auto;width:100%;max-height:var(--MdsMultiselect__menuMaxHeight,380px);margin:0;padding:0;margin-top:var(--MdsMultiselect__menuTopMargin,4px);z-index:99998}:host .multiselect__menu--visible{visibility:visible}:host .multiselect__menu-no-options{padding:var(--MdsMultiselect__menuNoOptionsTopPadding,8px) var(--MdsMultiselect__menuNoOptionsTrailingPadding,16px) var(--MdsMultiselect__menuNoOptionsBottomPadding,8px) var(--MdsMultiselect__menuNoOptionsLeadingPadding,16px);font-size:var(--MdsMultiselect__menuNoOptionsTextSize,.875rem);font-weight:var(--MdsMultiselect__menuNoOptionsTextTextWeight,400);line-height:var(--MdsMultiselect__menuNoOptionsTextLineHeight,1.25rem);cursor:default}:host .multiselect__label{display:inline-block;font-size:var(--MdsMultiselect__labelTextSize,.875rem);line-height:var(--MdsMultiselect__labelTextLineHeight,1.25rem);font-weight:var(--MdsMultiselect__labelTextWeight,400);text-align:var(--MdsMultiselect__labelTextAlignment,left);height:-moz-fit-content;height:fit-content;letter-spacing:0;text-decoration:none}:host .multiselect__label--error{font-weight:var(--MdsMultiselect__labelTextWeight--error,600)}:host .multiselect__label--horizontal{line-height:var(--MdsMultiselect__fieldTextLineHeight,1.5rem);font-size:var(--MdsMultiselect-_layout-horizontal__labelTextSize,1rem);text-align:right;margin-top:var(--MdsMultiselect-_layout-vertical__labelBottomPadding,8px)}:host .multiselect__label--horizontal.multiselect__label--line{margin-top:0}:host .multiselect__label--floating{position:absolute;line-height:var(--MdsMultiselect__fieldTextLineHeight,1.5rem);font-size:var(--MdsMultiselect-_layout-horizontal__labelTextSize,1rem);transition-property:font-size,line-height,transform;transition-duration:var(--MdsMultiselect-_floatingLabel-true__labelTransitionTime,.2s);transition-timing-function:var(--MdsMultiselect-_floatingLabel-true__labelTransitionEase,cubic-bezier(0,.2,.1,1));z-index:1}:host .multiselect__label--floating.multiselect__label--box:not(.multiselect__label--floating-above){transform:translate(var(--MdsMultiselect-_variant-box__fieldLeadingPadding,16px),var(--MdsMultiselect-_variant-box__fieldTopPadding,8px))}:host .multiselect__label--floating-above{font-size:var(--MdsMultiselect__labelTextSize,.875rem);line-height:var(--MdsMultiselect__labelTextLineHeight,1.25rem);transform:translateY(calc(var(--MdsMultiselect__labelTextLineHeight, 20px)*-1 + var(--MdsMultiselect-_layout-vertical__labelBottomPadding, 8px)*-1))}:host .multiselect__label--floating-above.multiselect__label--line{transform:translateY(calc(var(--MdsMultiselect__labelTextLineHeight, 20px)*-1))}:host .multiselect__error-microcopy{display:flex;padding-top:var(--AbstractMdsTextField__errorMessageTopPadding--error,4px)}:host .multiselect__microcopy{font-size:var(--MdsMultiselect__microcopyTextSize,.75rem);line-height:var(--MdsMultiselect__microcopyTextLineHeight,1rem);font-weight:var(--MdsMultiselect__microcopyTextWeight,400);text-align:var(--MdsMultiselect__microcopyTextAlignment,left);padding-top:var(--MdsMultiselect__microcopyTopPadding,4px);margin:0}:host .multiselect__accessible-text,:host .multiselect__error-microcopy-accessible-text--hidden{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .multiselect-option{display:flex;padding:var(--MdsMultiselect_option__topPadding,8px) var(--MdsMultiselect_option__trailingPadding,8px) var(--MdsMultiselect_option__bottomPadding,8px) var(--MdsMultiselect_option__leadingPadding,8px);cursor:pointer;position:relative}:host .multiselect-option--active,:host .multiselect-option:focus{outline:.0625rem dashed #717171;outline-offset:-.0625rem}:host .multiselect-option--hidden{display:none}:host .multiselect-option__label{font-size:var(--MdsMultiselect_option__labelTextSize,.875rem);font-weight:var(--MdsMultiselect_option__labelTextWeight,400);line-height:var(--MdsMultiselect_option__labelLineHeight,1.25rem);overflow-wrap:break-word;pointer-events:none}:host .multiselect-option__icon{display:inline-flex;border-radius:var(--MdsCheckbox__checkboxBorderRadius,4px);border-width:var(--MdsCheckbox__checkboxBorderWidth,2px);border-style:solid;font-size:var(--MdsCheckbox__labelTextSize,1rem);margin-right:var(--MdsMultiselect_option__checkboxTrailingMargin,8px);pointer-events:none;max-height:var(--MdsCheckbox__checkboxHeight,20px)}:host .multiselect-option__icon svg{height:1em;width:1em}.multiselect__header{box-shadow:inset 0 0 0 var(--MdsMultiselect__borderBottomWidth,1px) var(--MdsMultiselect__borderColor);background:var(--MdsMultiselect__backgroundColor,#fff)}.multiselect__header-icon svg{fill:var(--MdsMultiselect__chevronIconColor,#565a5d)}.multiselect__header--focused{box-shadow:inset 0 0 0 2px var(--MdsMultiselect__borderColor--active,#005eb8)}.multiselect__header--line{box-shadow:inset 0 calc(var(--MdsMultiselect__borderBottomWidth, 1px)*-1) 0 0 var(--MdsMultiselect__borderColor,#949494)}.multiselect__header--line.multiselect__header--focused{box-shadow:inset 0 -2px 0 0 var(--MdsMultiselect__borderColor--active,#005eb8)}.multiselect__header--disabled{box-shadow:inset 0 0 0 .0625rem var(--MdsMultiselect__borderColor--disabled,#bcbcbc)}.multiselect__header--disabled .multiselect__header-icon svg{fill:var(--MdsMultiselect__chevronIconColor--disabled,#c1c3c3)}.multiselect__header--disabled.multiselect__header--line{box-shadow:inset 0 calc(var(--MdsMultiselect__borderBottomWidth, 1px)*-1) 0 0 var(--MdsMultiselect__borderColor--disabled,#bcbcbc)}.multiselect__header--error{box-shadow:inset 0 0 0 var(--MdsMultiselect__borderBottomWidth--error,1px) var(--MdsMultiselect__borderColor--error,#b80009)}.multiselect__header--error.multiselect__header--focused{box-shadow:inset 0 0 0 var(--MdsMultiselect__borderBottomWidth--active,2px) var(--MdsMultiselect__borderColor--error,#b80009)}.multiselect__header--error.multiselect__header--line{box-shadow:inset 0 calc(var(--MdsMultiselect__borderBottomWidth--error, 1px)*-1) 0 0 var(--MdsMultiselect__borderColor--error,#b80009)}.multiselect__header--error.multiselect__header--line.multiselect__header--focused{box-shadow:inset 0 calc(var(--MdsMultiselect__borderBottomWidth--active, 2px)) 0 0 var(--MdsMultiselect__borderColor--error,#b80009)}.multiselect__input{color:var(--MdsMultiselect__fieldTextColor,#101820)}.multiselect__input::-moz-placeholder{color:var(--MdsMultiselect__placeholderTextColor,#565a5d)}.multiselect__input::placeholder{color:var(--MdsMultiselect__placeholderTextColor,#565a5d)}.multiselect__input:disabled{color:var(--MdsMultiselect__fieldTextColor--disabled,#565a5d)}.multiselect__pill{border-color:var(--MdsMultiselect_pill__borderColor,#565a5d);background-color:var(--MdsMultiselect_pill__backgroundColor,#fff)}.multiselect__pill:hover{background-color:var(--MdsMultiselect_pill__backgroundColor--hovered,#f5f7f8)}.multiselect__pill-text{color:var(--MdsMultiselect_pill__textColor,#565a5d)}.multiselect__pill-icon svg{fill:var(--MdsMultiselect_pill__iconColor,#565a5d)}.multiselect__menu{background-color:var(--MdsMultiselect__menuBackgroundColor,#fff);box-shadow:var(--MdsMultiselect__menuBoxShadowHorizontalOffset,0) var(--MdsMultiselect__menuBoxShadowVerticalOffset,2px) var(--MdsMultiselect__menuBoxShadowBlurRadius,3px) var(--MdsMultiselect__menuBoxShadowSpreadRadius,0) var(--MdsMultiselect__menuBoxShadowColor,rgba(0,0,0,.28))}.multiselect__menu-no-options{background-color:var(--MdsMultiselect__backgroundColor,#fff);color:var(--MdsMultiselect__menuNoOptionsTextColor,#fff)}.multiselect__label{color:var(--MdsMultiselect__labelTextColor,#565a5d)}.multiselect__label--error{color:var(--MdsMultiselect__labelTextColor--error,#b80009)}.multiselect__microcopy{color:var(--MdsMultiselect__microcopyTextColor,#565a5d)}.multiselect-option{background-color:var(--MdsMultiselect_option__backgroundColor,#fff)}.multiselect-option:hover,.multiselect-option:hover .multiselect-option__icon:not(.multiselect-option__icon--checked){background-color:var(--MdsMultiselect_option__backgroundColor--hovered,#f5f7f8)}.multiselect-option:hover .multiselect-option__icon:not(.multiselect-option__icon--checked) svg{fill:var(--MdsMultiselect_option__backgroundColor--hovered,#f5f7f8)}.multiselect-option__label{color:var(--MdsMultiselect_option__labelTextColor,#101820)}.multiselect-option__icon{background-color:var(--MdsMultiselect_option__backgroundColor,#fff);border-color:var(--MdsCheckbox__containerBorderColor,#8c8e90)}.multiselect-option__icon svg{fill:var(--MdsMultiselect_option__backgroundColor,#fff)}.multiselect-option__icon--checked{border-color:var(--MdsCheckbox__containerBorderColor--checked,#c1c3c3);background-color:var(--MdsCheckbox__iconBackgroundColor--checked,#005eb8)}.multiselect-option__icon--checked svg{fill:var(--MdsCheckbox__iconColor--checked,#fff)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/navigation-bar/mds-navigation-bar.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ':host{display:block}:host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .navigation-bar{min-width:var(--MdsNavigationBar_L2Bar__minWidth,320px)}:host .navigation-bar__top-row-container{padding-left:var(--MdsNavigationBar_L1Bar__horizontalPaddingMobile,);padding-right:var(--MdsNavigationBar_L1Bar__horizontalPaddingMobile,)}@media screen and (min-width:768px){:host .navigation-bar__top-row-container{padding-left:24px;padding-right:24px}}:host .navigation-bar__bottom-row-container{background-color:var(--MdsNavigationBar_L2Bar__backgroundColor,#fff)}:host .navigation-bar__row{display:flex;justify-content:space-between;position:relative;max-width:var(--MdsNavigationBar_L2Bar__interactiveAreaMaxWidth,1200px);margin:auto}:host .navigation-bar__list{display:none}@media screen and (min-width:768px){:host .navigation-bar__list{display:flex;width:100%}}:host .navigation-bar__items{display:flex}:host .navigation-bar__caret{position:absolute;height:var(--MdsNavigationBar_L1Bar__pointerHeight,7px);transition:transform .5s cubic-bezier(0,.2,.1,1);bottom:0}:host .navigation-bar__caret:after{content:"";position:absolute;border-left:var(--MdsNavigationBar_L1Bar__pointerHeight,7px) solid transparent;border-right:var(--MdsNavigationBar_L1Bar__pointerHeight,7px) solid transparent;border-bottom:var(--MdsNavigationBar_L1Bar__pointerHeight,7px) solid var(--MdsNavigationBar_L1Bar__pointerBackgroundColor,#fff)}:host .navigation-bar__back-button{display:flex;align-items:center;cursor:pointer;background-color:transparent;text-decoration:none;white-space:nowrap;border:0;padding:var(--MdsNavigationBar_L1Bar__backButtonVerticalPadding,4px) var(--MdsNavigationBar_L1Bar__backButtonHorizontalPadding,8px)}:host .navigation-bar__back-button:focus{outline:.0625rem dashed #717171}:host .navigation-bar__back-button-container{display:flex;align-items:flex-start;flex:1}:host .navigation-bar__back-button-icon{display:inline-flex;pointer-events:none}:host .navigation-bar__back-button-icon svg{height:16px;width:16px;fill:#565a5d}:host .navigation-bar__back-button-text{display:none;padding:0;margin-left:var(--MdsNavigationBar_L1Bar__backButtonTextLeftPadding,4px);line-height:1.25rem;font-size:.875rem;font-weight:600;color:#565a5d;min-width:0;text-align:left;pointer-events:none}@media screen and (min-width:768px){:host .navigation-bar__back-button-text{display:inline-block;white-space:nowrap;word-break:normal}}:host .navigation-bar__xs-button{display:flex;align-items:center;height:28px;font-size:.875rem;font-weight:600;line-height:1.25rem;padding:10px 8px;border-radius:8px;text-decoration:none;margin-top:16px;margin-bottom:var(--MdsNavigationBar_L1Bar-_variant-secondary__bottomPaddingMobile,20px);cursor:pointer;white-space:nowrap;border:1px solid #005eb8;color:#005eb8;background-color:rgba(0,94,184,.1)}:host .navigation-bar__xs-button:focus{outline:.0625rem dashed #fff;outline-offset:-.0625rem;color:#004692;border-color:#004692;background-color:rgba(0,70,146,.1)}:host .navigation-bar__xs-button:focus .navigation-bar__xs-button-icon svg{fill:#004692}:host .navigation-bar__xs-button:hover{color:#004692;border-color:#004692;background-color:rgba(0,70,146,.1)}:host .navigation-bar__xs-button:hover .navigation-bar__xs-button-icon svg{fill:#004692}:host .navigation-bar__xs-button:active{color:#005eb8;border-color:#005eb8;background-color:rgba(0,145,218,.1)}:host .navigation-bar__xs-button:active .navigation-bar__xs-button-icon svg{fill:#005eb8}:host .navigation-bar__xs-button .navigation-bar__xs-button-content{display:flex;justify-content:center;align-items:center;pointer-events:none;height:0}:host .navigation-bar__xs-button .navigation-bar__xs-button-icon{display:inline-flex;margin-top:8px;margin-bottom:8px;margin-left:8px}:host .navigation-bar__xs-button .navigation-bar__xs-button-icon svg{height:.75rem;width:.75rem;fill:#005eb8}:host .navigation-bar .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .navigation-bar slot[name=product-marker]{display:flex;height:100%;justify-content:center;align-items:center}:host .navigation-bar slot[name=product-marker]::slotted(*){max-width:15.625rem;padding:10px 8px}:host .navigation-bar slot[name=product-marker]::slotted(span){justify-content:center;align-items:center;display:flex}:host .navigation-bar--secondary{background-color:var(--MdsNavigationBar_L1Item-_variant-inApp__backgroundColor,#fff)}:host .navigation-bar--secondary .navigation-bar__row{flex-wrap:wrap}:host .navigation-bar--secondary .navigation-bar__list{flex:1;padding-top:var(--MdsNavigationBar_L1Bar-_variant-secondary__verticalPadding,16px);padding-bottom:var(--MdsNavigationBar_L1Bar-_variant-secondary__verticalPadding,16px)}:host .navigation-bar--secondary .navigation-bar__experience{flex-direction:column;padding-left:0;padding-right:0;padding-top:var(--MdsNavigationBar_L1Bar-_variant-secondary__topPaddingMobile,8px)}@media screen and (min-width:768px){:host .navigation-bar--secondary .navigation-bar__experience{padding-right:var(--MdsNavigationBar_L1Bar__experienceNameTrailingPadding,32px);padding-top:var(--MdsNavigationBar_L1Bar-_variant-secondary__verticalPadding,16px)}}:host .navigation-bar--secondary .navigation-bar__experience-name{font-size:var(--MdsNavigationBar_L1Bar-_secondaryXsButtonText-true__experienceNameTextSize,1.75rem);line-height:var(--MdsNavigationBar_L1Bar-_secondaryXsButtonText-true__experienceNameLineHeight,2.25rem);font-weight:var(--MdsNavigationBar_L1Bar-_secondaryXsButtonText-true__experienceNameTextWeight,600)}:host .navigation-bar--secondary .navigation-bar__experience-name:focus{outline:.0625rem dashed #717171}@media screen and (min-width:768px){:host .navigation-bar--secondary .navigation-bar__experience-name{font-size:var(--MdsNavigationBar_L1Bar__experienceNameTextSize,1.125rem);line-height:var(--MdsNavigationBar_L1Bar__experienceNameLineHeight,1.75rem);font-weight:var(--MdsNavigationBar_L1Bar__experienceNameTextWeight,600)}}:host .navigation-bar--secondary .navigation-bar__experience-name--sticky{font-size:var(--MdsNavigationBar_L1Bar-_secondaryXsButtonText-true-_sticky-true__experienceNameTextSize,1rem);font-weight:var(--MdsNavigationBar_L1Bar-_secondaryXsButtonText-true-_sticky-true__experienceNameTextWeight,600);line-height:var(--MdsNavigationBar_L1Bar-_secondaryXsButtonText-true-_sticky-true__experienceNameLineHeight,1.5rem)}:host .navigation-bar--secondary .navigation-bar__experience-name--sticky:focus{outline:.0625rem dashed #717171}@media screen and (min-width:768px){:host .navigation-bar--secondary .navigation-bar__experience-name--sticky{font-size:var(--MdsNavigationBar_L1Bar__experienceNameTextSize,1.125rem);line-height:var(--MdsNavigationBar_L1Bar__experienceNameLineHeight,1.75rem);font-weight:var(--MdsNavigationBar_L1Bar__experienceNameTextWeight,600)}}:host .navigation-bar--sticky{position:fixed;z-index:9;top:0;left:0;right:0;border-bottom:1px solid #e2e4e5}:host .navigation-bar--sticky .navigation-bar__xs-button{margin-bottom:var(--MdsNavigationBar_L1Bar-_variant-secondary-_sticky-true__bottomPaddingMobile,16px)}:host .navigation-bar--back{background-color:#fff}:host .navigation-bar--back .navigation-bar__list{display:block}:host .navigation-bar--back .navigation-bar__row{padding-top:var(--MdsNavigationBar_L1Bar-_variant-back__verticalPaddingMobile,10px);padding-bottom:var(--MdsNavigationBar_L1Bar-_variant-back__verticalPaddingMobile,10px)}@media screen and (min-width:768px){:host .navigation-bar--back .navigation-bar__row{padding-top:var(--MdsNavigationBar_L1Bar-_variant-back__verticalPadding,16px);padding-bottom:var(--MdsNavigationBar_L1Bar-_variant-back__verticalPadding,16px)}}:host .navigation-bar--back .navigation-bar__experience{display:flex;align-items:center;margin-right:var(--MdsNavigationBar_L1Bar-_secondaryXsButtonText-true__pageNameRightMargin,8px);margin-left:var(--MdsNavigationBar_L1Bar-_secondaryXsButtonText-true__pageNameLeftMargin,8px)}@media screen and (min-width:768px){:host .navigation-bar--back .navigation-bar__experience{margin-right:var(--MdsNavigationBar_L1Bar__pageNameRightMargin,16px);margin-left:var(--MdsNavigationBar_L1Bar__pageNameLeftMargin,16px)}}:host .navigation-bar--back .navigation-bar__page-name{text-align:center;font-size:var(--MdsNavigationBar_L1Bar-_secondaryXsButtonText-true__pageNameTextSize,1rem);font-weight:var(--MdsNavigationBar_L1Bar-_secondaryXsButtonText-true__pageNameTextWeight,600);line-height:var(--MdsNavigationBar_L1Bar-_secondaryXsButtonText-true__pageNameLineHeight,1.5rem)}:host .navigation-bar--back .navigation-bar__page-name:focus{outline:.0625rem dashed #717171}@media screen and (min-width:768px){:host .navigation-bar--back .navigation-bar__page-name{font-size:var(--MdsNavigationBar_L1Bar__pageNameTextSize,1.125rem);font-weight:var(--MdsNavigationBar_L1Bar__pageNameTextWeight,600);line-height:var(--MdsNavigationBar_L1Bar__pageNameLineHeight,1.75rem)}}:host .navigation-bar--secondary-background,:host .navigation-bar--secondary-background .navigation-bar__bottom-row-container{background-color:var(--MdsNavigationBar_L1Bar-_variant-secondary-_backgroundColor-secondary__backgroundColor,#f5f7f8)}:host .navigation-bar--secondary-background .navigation-bar__caret:after{content:"";border-bottom-color:var(--MdsNavigationBar_L1Bar-_variant-secondary-_backgroundColor-secondary__pointerBackgroundColor,#f5f7f8)}:host .navigation-bar--global .navigation-bar__top-row-container,:host .navigation-bar--primary{background-color:var(--MdsNavigationBar_L1Bar__backgroundColor,#005eb8)}:host .navigation-bar--global .navigation-bar__list,:host .navigation-bar--inApp .navigation-bar__list,:host .navigation-bar--primary .navigation-bar__list{padding-top:var(--MdsNavigationBar_L1Bar-_variant-primary__verticalPadding,8px);padding-bottom:var(--MdsNavigationBar_L1Bar-_variant-primary__verticalPadding,8px);display:flex;justify-content:space-between;width:100%}@media screen and (min-width:768px){:host .navigation-bar--global .navigation-bar__list,:host .navigation-bar--inApp .navigation-bar__list,:host .navigation-bar--primary .navigation-bar__list{display:flex;justify-content:normal;width:100%}}:host .navigation-bar--inApp{background-color:var(--MdsNavigationBar_L1Item-_variant-inApp__backgroundColor,#fff)}:host .navigation-bar--inApp .navigation-bar__list{padding-top:var(--MdsNavigationBar_L1Item__verticalPadding,10px);padding-bottom:var(--MdsNavigationBar_L1Item__verticalPadding,10px);justify-content:space-between}@media screen and (min-width:768px){:host .navigation-bar--inApp .navigation-bar__list{justify-content:center}}:host .navigation-bar--inApp slot[name=overflow]{position:absolute;right:0}:host .navigation-bar .navigation-bar__search-box-container{display:flex;margin-top:var(--MdsNavigationBar_L1Bar__searchBoxTopMargin,10px);margin-bottom:var(--MdsNavigationBar_L1Bar__searchBoxTopMargin,10px);min-width:282px}:host .navigation-bar .navigation-bar__action-button-container{display:flex;align-items:flex-start;flex:1;justify-content:flex-end}', "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/navigation-bar/navigation-bar-bottom/mds-navigation-bar-bottom.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host{display:block;width:100%}:host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .navigation-bar-bottom{display:flex;justify-content:space-between;min-width:var(--MdsNavigationBar_L2Bar__minWidth,320px);background-color:var(--MdsNavigationBar_L2Bar__backgroundColor,#fff);padding-left:24px;padding-right:24px;padding-top:var(--MdsNavigationBar_L2Bar__journeyMarkerTextVerticalPadding,12px)}:host .navigation-bar-bottom--secondary-background{background-color:var(--MdsNavigationBar_L1Bar-_variant-secondary-_backgroundColor-secondary__backgroundColor,#f5f7f8)}:host .navigation-bar-bottom--hidden{display:none}:host .navigation-bar-bottom__experience-name{margin-right:var(--MdsNavigationBar_L2Bar__journeyMarkerTextHorizontalPadding,24px);margin-left:0;margin-bottom:var(--MdsNavigationBar_L2Bar__journeyMarkerTextVerticalPadding,12px);font-size:1.125rem;line-height:1.75rem;font-weight:600}:host .navigation-bar-bottom__experience-name:focus{outline:.0625rem dashed #717171}@media screen and (max-width:576px){:host .navigation-bar-bottom__experience-name{display:none}}:host .navigation-bar-bottom__slot{display:flex;flex-direction:row;margin-bottom:var(--MdsNavigationBar_L2Bar__journeyMarkerTextVerticalPadding,12px)}:host .navigation-bar-bottom__main-content{display:flex;flex-wrap:wrap;flex-direction:row}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/navigation-bar/navigation-bar-item/mds-navigation-bar-item.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ':host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .navigation-bar-item{display:flex;margin-right:16px;position:relative}:host .navigation-bar-item__link{display:flex;height:28px;font-size:1rem;font-weight:var(--MdsNavigationBar_L1Item__labelTextWeight,600);line-height:var(--MdsNavigationBar_L1Item__labelTextLineHeight,1.5rem);padding:10px 8px;border-radius:8px;text-decoration:none;cursor:pointer;white-space:nowrap;transition-property:background-color;transition-duration:var(--MdsNavigationBar_L1Item__backgroundColorTransitionDuration,200)ms;transition-timing-function:var(--MdsNavigationBar_L1Item__backgroundColorTransitionEase,cubic-bezier(0,.4,.2,1));color:var(--MdsNavigationBar_L1Item__labelTextColor,#fff)}:host .navigation-bar-item__link:focus{outline:.0625rem dashed #fff}:host .navigation-bar-item__link-badge{display:inline-flex;margin-left:var(--MdsNavigationBar_L1Item__badgeLeadingMargin,4px)}:host .navigation-bar-item__link-content{display:flex;justify-content:center;align-items:center}:host .navigation-bar-item__link--top:hover{background-color:var(--MdsNavigationBar_L1Item__backgroundColor--hovered,#004692)}:host .navigation-bar-item__link--top:focus{background-color:var(--MdsNavigationBar_L1Item__backgroundColor--focused,#004692)}:host .navigation-bar-item__link--top.navigation-bar-item__link--open-menu,:host .navigation-bar-item__link--top:active{background-color:var(--MdsNavigationBar_L1Item__backgroundColor--pressed,#0091da)}:host .navigation-bar-item__link--bottom,:host .navigation-bar-item__link--inApp,:host .navigation-bar-item__link--secondary{font-size:.875rem;font-weight:600;color:#565a5d;background-color:var(--MdsNavigationBar_L1Item-_variant-inApp__backgroundColor,#fff);border:1px solid var(--MdsNavigationBar_L1Item-_variant-inApp__bottomBorderColor,#fff)}:host .navigation-bar-item__link--bottom.navigation-bar-item__link--secondary-background,:host .navigation-bar-item__link--inApp.navigation-bar-item__link--secondary-background,:host .navigation-bar-item__link--secondary.navigation-bar-item__link--secondary-background{background-color:var(--MdsNavigationBar_L1Bar-_variant-secondary-_backgroundColor-secondary__backgroundColor,#f5f7f8)}:host .navigation-bar-item__link--bottom.navigation-bar-item__link-content,:host .navigation-bar-item__link--inApp.navigation-bar-item__link-content,:host .navigation-bar-item__link--secondary.navigation-bar-item__link-content{position:relative}:host .navigation-bar-item__link--bottom.navigation-bar-item__link--active,:host .navigation-bar-item__link--inApp.navigation-bar-item__link--active,:host .navigation-bar-item__link--secondary.navigation-bar-item__link--active{background-color:var(--MdsNavigationBar_L1Item-_variant-inApp-_active-true__backgroundColor,rgba(0,94,184,.1));border-color:var(--MdsNavigationBar_L1Item-_variant-inApp-_active-true__bottomBorderColor,#005eb8);color:var(--MdsNavigationBar_L1Item-_variant-inApp-_active-true__bottomBorderColor,#005eb8)}:host .navigation-bar-item__link--bottom.navigation-bar-item__link--active .navigation-bar-item__link-trailing-icon--secondary svg,:host .navigation-bar-item__link--inApp.navigation-bar-item__link--active .navigation-bar-item__link-trailing-icon--secondary svg,:host .navigation-bar-item__link--secondary.navigation-bar-item__link--active .navigation-bar-item__link-trailing-icon--secondary svg{fill:var(--MdsNavigationBar_L1Item-_variant-inApp-_active-true__bottomBorderColor,#005eb8)}:host .navigation-bar-item__link--bottom.navigation-bar-item__link--active:hover,:host .navigation-bar-item__link--inApp.navigation-bar-item__link--active:hover,:host .navigation-bar-item__link--secondary.navigation-bar-item__link--active:hover{border-color:#004692}:host .navigation-bar-item__link--bottom.navigation-bar-item__link--active:hover .navigation-bar-item__link-trailing-icon--secondary svg,:host .navigation-bar-item__link--inApp.navigation-bar-item__link--active:hover .navigation-bar-item__link-trailing-icon--secondary svg,:host .navigation-bar-item__link--secondary.navigation-bar-item__link--active:hover .navigation-bar-item__link-trailing-icon--secondary svg{fill:var(--MdsNavigationBar_L1Item-_variant-inApp__trailingIconColor--hovered,#004692)}:host .navigation-bar-item__link--bottom.navigation-bar-item__link--active:focus,:host .navigation-bar-item__link--inApp.navigation-bar-item__link--active:focus,:host .navigation-bar-item__link--secondary.navigation-bar-item__link--active:focus{border-color:#004692}:host .navigation-bar-item__link--bottom.navigation-bar-item__link--active:focus .navigation-bar-item__link-trailing-icon--secondary svg,:host .navigation-bar-item__link--inApp.navigation-bar-item__link--active:focus .navigation-bar-item__link-trailing-icon--secondary svg,:host .navigation-bar-item__link--secondary.navigation-bar-item__link--active:focus .navigation-bar-item__link-trailing-icon--secondary svg{fill:var(--MdsNavigationBar_L1Item-_variant-inApp__trailingIconColor--focused,#004692)}:host .navigation-bar-item__link--bottom.navigation-bar-item__link--active:active,:host .navigation-bar-item__link--inApp.navigation-bar-item__link--active:active,:host .navigation-bar-item__link--secondary.navigation-bar-item__link--active:active{border-color:var(--MdsNavigationBar_L1Item__backgroundColor--pressed,#0091da)}:host .navigation-bar-item__link--bottom.navigation-bar-item__link--active:active .navigation-bar-item__link-trailing-icon--secondary svg,:host .navigation-bar-item__link--inApp.navigation-bar-item__link--active:active .navigation-bar-item__link-trailing-icon--secondary svg,:host .navigation-bar-item__link--secondary.navigation-bar-item__link--active:active .navigation-bar-item__link-trailing-icon--secondary svg{fill:var(--MdsNavigationBar_L1Item-_variant-inApp__trailingIconColor--pressed,#005eb8)}:host .navigation-bar-item__link--bottom:hover,:host .navigation-bar-item__link--inApp:hover,:host .navigation-bar-item__link--secondary:hover{background-color:rgba(0,70,146,.1);color:#004692}:host .navigation-bar-item__link--bottom:hover .navigation-bar-item__link-trailing-icon--secondary svg,:host .navigation-bar-item__link--inApp:hover .navigation-bar-item__link-trailing-icon--secondary svg,:host .navigation-bar-item__link--secondary:hover .navigation-bar-item__link-trailing-icon--secondary svg{fill:var(--MdsNavigationBar_L1Item-_variant-inApp__trailingIconColor--hovered,#004692)}:host .navigation-bar-item__link--bottom:focus,:host .navigation-bar-item__link--inApp:focus,:host .navigation-bar-item__link--secondary:focus{background-color:rgba(0,70,146,.1);color:#004692;outline:.0625rem dashed #717171}:host .navigation-bar-item__link--bottom:focus .navigation-bar-item__link-trailing-icon--secondary svg,:host .navigation-bar-item__link--inApp:focus .navigation-bar-item__link-trailing-icon--secondary svg,:host .navigation-bar-item__link--secondary:focus .navigation-bar-item__link-trailing-icon--secondary svg{fill:var(--MdsNavigationBar_L1Item-_variant-inApp__trailingIconColor--focused,#004692)}:host .navigation-bar-item__link--bottom.navigation-bar-item__link--open-menu,:host .navigation-bar-item__link--bottom:active,:host .navigation-bar-item__link--inApp.navigation-bar-item__link--open-menu,:host .navigation-bar-item__link--inApp:active,:host .navigation-bar-item__link--secondary.navigation-bar-item__link--open-menu,:host .navigation-bar-item__link--secondary:active{color:var(--MdsNavigationBar_L1Item-_variant-inApp__labelTextColor--pressed,#005eb8);background-color:rgba(0,70,146,.1)}:host .navigation-bar-item__link--bottom.navigation-bar-item__link--open-menu .navigation-bar-item__link-trailing-icon--secondary svg,:host .navigation-bar-item__link--bottom:active .navigation-bar-item__link-trailing-icon--secondary svg,:host .navigation-bar-item__link--inApp.navigation-bar-item__link--open-menu .navigation-bar-item__link-trailing-icon--secondary svg,:host .navigation-bar-item__link--inApp:active .navigation-bar-item__link-trailing-icon--secondary svg,:host .navigation-bar-item__link--secondary.navigation-bar-item__link--open-menu .navigation-bar-item__link-trailing-icon--secondary svg,:host .navigation-bar-item__link--secondary:active .navigation-bar-item__link-trailing-icon--secondary svg{fill:var(--MdsNavigationBar_L1Item-_variant-inApp__trailingIconColor--pressed,#005eb8)}:host .navigation-bar-item__link--bottom.navigation-bar-item__link--active .navigation-bar-item__link-content:after,:host .navigation-bar-item__link--inApp.navigation-bar-item__link--active .navigation-bar-item__link-content:after,:host .navigation-bar-item__link--secondary.navigation-bar-item__link--active .navigation-bar-item__link-content:after{background-color:#005eb8}:host .navigation-bar-item__link--bottom:focus .navigation-bar-item__link-content:after,:host .navigation-bar-item__link--bottom:hover .navigation-bar-item__link-content:after{background-color:#c1c3c3}:host .navigation-bar-item__link--bottom.navigation-bar-item__link--active .navigation-bar-item__link-content:after,:host .navigation-bar-item__link--bottom:active .navigation-bar-item__link-content:after{background-color:#005eb8}:host .navigation-bar-item--bottom{height:100%;align-items:center}:host .navigation-bar-item__link-trailing-icon{display:flex;margin-left:var(--MdsNavigationBar_L1Item__badgeLeadingMargin,4px)}:host .navigation-bar-item__link-trailing-icon svg{width:var(--MdsNavigationBar_L1Item__trailingIconWidth,16px);height:var(--MdsNavigationBar_L1Item__trailingIconHeight,16px);fill:var(--MdsNavigationBar_L1Item__trailingIconColor,#fff)}:host .navigation-bar-item__link-trailing-icon--secondary svg{fill:#565a5d}:host .navigation-bar-item__button{display:flex;-webkit-appearance:none;-moz-appearance:none;appearance:none;margin:0;border:0;cursor:pointer;padding:0;border-radius:8px;transition-property:background-color;transition-duration:.2s;transition-timing-function:cubic-bezier(0,.4,.2,1)}:host .navigation-bar-item__button:focus{outline:.0625rem dashed #fff}:host .navigation-bar-item__button::-moz-focus-inner{border:0}:host .navigation-bar-item__button-icon{display:inline-flex;pointer-events:none}:host .navigation-bar-item__button-icon svg{height:28px;width:28px;fill:#fff}:host .navigation-bar-item__button-icon--bottom svg,:host .navigation-bar-item__button-icon--inApp svg,:host .navigation-bar-item__button-icon--secondary svg{fill:#565a5d}:host .navigation-bar-item__button--top{background-color:var(--MdsNavigationBar_L1Bar__backgroundColor,#005eb8)}:host .navigation-bar-item__button--top:focus,:host .navigation-bar-item__button--top:hover{background-color:var(--MdsNavigationBar_L1Item__backgroundColor--hovered,#004692)}:host .navigation-bar-item__button--top.navigation-bar-item__button--open-menu,:host .navigation-bar-item__button--top:active{background-color:var(--MdsNavigationBar_L1Item__backgroundColor--pressed,#0091da)}:host .navigation-bar-item__button--bottom{background-color:#fff}:host .navigation-bar-item__button--bottom:focus:after,:host .navigation-bar-item__button--bottom:hover:after{background-color:#c1c3c3}:host .navigation-bar-item__button--bottom:active{outline:1px dashed #717171}:host .navigation-bar-item__button--bottom.navigation-bar-item__button--open-menu,:host .navigation-bar-item__button--bottom:active{background-color:#0091da}:host .navigation-bar-item__button--bottom.navigation-bar-item__button--open-menu:after,:host .navigation-bar-item__button--bottom:active:after{background-color:transparent}:host .navigation-bar-item__button--bottom.navigation-bar-item__button--open-menu .navigation-bar-item__button-icon svg,:host .navigation-bar-item__button--bottom:active .navigation-bar-item__button-icon svg{fill:#fff}:host .navigation-bar-item__button--bottom.navigation-bar-item__button--active:after{background-color:#005eb8}:host .navigation-bar-item__button--bottom,:host .navigation-bar-item__button--inApp,:host .navigation-bar-item__button--secondary{position:relative;border:1px solid var(--MdsNavigationBar_L1Item-_variant-inApp__bottomBorderColor,#fff);background-color:#fff}:host .navigation-bar-item__button--bottom:after,:host .navigation-bar-item__button--inApp:after,:host .navigation-bar-item__button--secondary:after{content:"";position:absolute;width:calc(100% - .125rem);height:0;bottom:.0625rem;left:.0625rem}:host .navigation-bar-item__button--bottom.navigation-bar-item__link--active,:host .navigation-bar-item__button--inApp.navigation-bar-item__link--active,:host .navigation-bar-item__button--secondary.navigation-bar-item__link--active{border:1px solid #005eb8;color:#005eb8}:host .navigation-bar-item__button--bottom.navigation-bar-item__button--secondary-background,:host .navigation-bar-item__button--inApp.navigation-bar-item__button--secondary-background,:host .navigation-bar-item__button--secondary.navigation-bar-item__button--secondary-background{background-color:var(--MdsNavigationBar_L1Bar-_variant-secondary-_backgroundColor-secondary__backgroundColor,#f5f7f8)}:host .navigation-bar-item__button--bottom:hover,:host .navigation-bar-item__button--inApp:hover,:host .navigation-bar-item__button--secondary:hover{background-color:rgba(0,70,146,.1)}:host .navigation-bar-item__button--bottom:hover .navigation-bar-item__button-icon svg,:host .navigation-bar-item__button--inApp:hover .navigation-bar-item__button-icon svg,:host .navigation-bar-item__button--secondary:hover .navigation-bar-item__button-icon svg{fill:#004692}:host .navigation-bar-item__button--bottom:focus,:host .navigation-bar-item__button--inApp:focus,:host .navigation-bar-item__button--secondary:focus{background-color:rgba(0,70,146,.1);outline:.0625rem dashed #717171}:host .navigation-bar-item__button--bottom:focus .navigation-bar-item__button-icon svg,:host .navigation-bar-item__button--inApp:focus .navigation-bar-item__button-icon svg,:host .navigation-bar-item__button--secondary:focus .navigation-bar-item__button-icon svg{fill:#004692}:host .navigation-bar-item__button--bottom.navigation-bar-item__button--active,:host .navigation-bar-item__button--inApp.navigation-bar-item__button--active,:host .navigation-bar-item__button--secondary.navigation-bar-item__button--active{background-color:var(--MdsNavigationBar_L1Item-_variant-inApp-_active-true__backgroundColor,rgba(0,94,184,.1));border:1px solid var(--MdsNavigationBar_L1Item-_variant-inApp-_active-true__bottomBorderColor,#005eb8)}:host .navigation-bar-item__button--bottom.navigation-bar-item__button--active svg,:host .navigation-bar-item__button--inApp.navigation-bar-item__button--active svg,:host .navigation-bar-item__button--secondary.navigation-bar-item__button--active svg{fill:var(--MdsNavigationBar_L1Item-_variant-inApp-_active-true__bottomBorderColor,#005eb8)}:host .navigation-bar-item__button--bottom.navigation-bar-item__button--active:focus,:host .navigation-bar-item__button--bottom.navigation-bar-item__button--active:hover,:host .navigation-bar-item__button--inApp.navigation-bar-item__button--active:focus,:host .navigation-bar-item__button--inApp.navigation-bar-item__button--active:hover,:host .navigation-bar-item__button--secondary.navigation-bar-item__button--active:focus,:host .navigation-bar-item__button--secondary.navigation-bar-item__button--active:hover{border-color:#004692}:host .navigation-bar-item__button--bottom.navigation-bar-item__button--active:active,:host .navigation-bar-item__button--inApp.navigation-bar-item__button--active:active,:host .navigation-bar-item__button--secondary.navigation-bar-item__button--active:active{border-color:var(--MdsNavigationBar_L1Item__backgroundColor--pressed,#0091da)}:host .navigation-bar-item__button--bottom.navigation-bar-item__button--open-menu,:host .navigation-bar-item__button--bottom:active,:host .navigation-bar-item__button--inApp.navigation-bar-item__button--open-menu,:host .navigation-bar-item__button--inApp:active,:host .navigation-bar-item__button--secondary.navigation-bar-item__button--open-menu,:host .navigation-bar-item__button--secondary:active{background-color:rgba(0,145,218,.1)}:host .navigation-bar-item__button--bottom.navigation-bar-item__button--open-menu .navigation-bar-item__button-icon svg,:host .navigation-bar-item__button--bottom:active .navigation-bar-item__button-icon svg,:host .navigation-bar-item__button--inApp.navigation-bar-item__button--open-menu .navigation-bar-item__button-icon svg,:host .navigation-bar-item__button--inApp:active .navigation-bar-item__button-icon svg,:host .navigation-bar-item__button--secondary.navigation-bar-item__button--open-menu .navigation-bar-item__button-icon svg,:host .navigation-bar-item__button--secondary:active .navigation-bar-item__button-icon svg{fill:#005eb8}:host .navigation-bar-item ::slotted(mds-navigation-bar-menu){top:calc(100% + .5rem)}:host .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}', "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/navigation-bar/navigation-bar-menu/mds-navigation-bar-menu.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ':host{position:absolute;display:block;pointer-events:none;min-width:100%;z-index:1100}:host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .navigation-bar-menu{display:none;max-width:var(--MdsNavigationBar_Menu__maxWidth,396px);background-color:var(--MdsNavigationBar_Menu__backgroundColor,#fff);box-shadow:var(--MdsNavigationBar_Menu__shadowHorizontalOffset,0) var(--MdsNavigationBar_Menu__shadowVerticalOffset,5px) var(--MdsNavigationBar_Menu__shadowBlurRadius,10px) var(--MdsNavigationBar_Menu__shadowSpreadRadius,0) var(--MdsNavigationBar_Menu__shadowColor,rgba(0,0,0,.4))}:host .navigation-bar-menu--visible{display:block}@-moz-document url-prefix(""){:host .navigation-bar-menu{min-width:var(--MdsNavigationBar_Menu__minWidth,172px)}}:host .navigation-bar-menu--mega{max-width:none}:host .navigation-bar-menu--overflow{display:block;visibility:hidden;height:0;width:0}:host .navigation-bar-menu--overflow.navigation-bar-menu--visible{visibility:visible;height:auto;width:auto}:host .navigation-bar-menu__menu-items{max-height:var(--MdsNavigationBar_Menu__maxHeight,384px);overflow-y:auto}:host .navigation-bar-menu__column-container{display:flex}:host .navigation-bar-menu__column-container ::slotted(div:not(:last-child)){position:relative;margin-right:var(--MdsNavigationBar_Menu__verticalSeparatorWidth,1px);background-position:100%;background-repeat:no-repeat;background-size:var(--MdsNavigationBar_Menu__verticalSeparatorWidth,1px) calc(100% - var(--MdsNavigationBar_Menu__verticalSeparatorVerticalPadding, 16px)*2);padding-right:var(--MdsNavigationBar_Menu__verticalSeparatorWidth,1px)}:host .navigation-bar-menu__column-container ::slotted(div:not(:last-child)):after{content:"";position:absolute;width:var(--MdsNavigationBar_Menu__verticalSeparatorWidth,1px);right:calc(var(--MdsNavigationBar_Menu__verticalSeparatorWidth, 1px)*-1);top:var(--MdsNavigationBar_Menu__verticalSeparatorVerticalPadding,16px);bottom:var(--MdsNavigationBar_Menu__verticalSeparatorVerticalPadding,16px);background-color:var(--MdsNavigationBar_Menu__verticalSeparatorColor,#e2e4e5)}:host .navigation-bar-menu__column-container--inactive ::slotted(div){padding-bottom:var(--MdsNavigationBar_Menu__inactiveMessageTopMargin,16px)}:host .navigation-bar-menu__inactive-message{line-height:var(--MdsNavigationBar_Menu__inactiveMessageTextLineHeight,1.25rem);font-weight:var(--MdsNavigationBar_Menu__inactiveMessageTextWeight,400);font-size:var(--MdsNavigationBar_Menu__inactiveMessageTextSize,.875rem);margin:0;padding:var(--MdsNavigationBar_Menu__inactiveMessageTopPadding,16px) var(--MdsNavigationBar_Menu__inactiveMessageTrailingPadding,16px) var(--MdsNavigationBar_Menu__inactiveMessageBottomPadding,16px) var(--MdsNavigationBar_Menu__inactiveMessageLeadingPadding,16px);color:var(--MdsNavigationBar_Menu__inactiveMessageTextColor,#565a5d);border-top:var(--MdsNavigationBar_Menu__inactiveMessageHorizontalSeparatorWidth,1px) solid var(--MdsNavigationBar_Menu__inactiveMessageHorizontalSeparatorColor,#e2e4e5)}:host(mds-navigation-bar-menu[variant=overflow]){left:0}.navigation-bar-menu__column-container ::slotted(div:not(:last-child)){background-image:linear-gradient(var(--MdsNavigationBar_Menu__verticalSeparatorColor,#e2e4e5),var(--MdsNavigationBar_Menu__verticalSeparatorColor,#e2e4e5))}', "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/navigation-bar/navigation-bar-menu/navigation-bar-menu-item/mds-navigation-bar-menu-item.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host{display:block}:host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .navigation-bar-menu-item{display:flex;width:100%;max-width:var(--MdsNavigationBar_Menu__maxWidth,396px);-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:var(--MdsNavigationBar_MenuItem__verticalPadding,12px) var(--MdsNavigationBar_MenuItem__trailingPadding,16px) var(--MdsNavigationBar_MenuItem__verticalPadding,12px) var(--MdsNavigationBar_MenuItem__leadingPadding,16px);font-size:var(--MdsNavigationBar_MenuItem__labelTextSize,1rem);font-weight:var(--MdsNavigationBar_MenuItem__labelTextWeight,400);line-height:var(--MdsNavigationBar_MenuItem__labelTextLineHeight,1.5rem);text-decoration:none;text-align:left}:host .navigation-bar-menu-item:focus{outline:.0625rem dashed #717171;outline-offset:-.0625rem}:host .navigation-bar-menu-item--collapsible{cursor:pointer;border:0;margin:0;-webkit-appearance:none;-moz-appearance:none;appearance:none}:host .navigation-bar-menu-item--collapsible::-moz-focus-inner{border:0}:host .navigation-bar-menu-item--heading{font-weight:var(--MdsNavigationBar_MenuItem-_type-heading__textWeight,600)}:host .navigation-bar-menu-item--hidden{visibility:hidden}:host .navigation-bar-menu-item--nested{padding-left:var(--MdsNavigationBar_MenuItem__nestedOneLevelLeadingPadding,32px);padding-right:var(--MdsNavigationBar_MenuItem__nestedTrailingPadding,20px)}:host .navigation-bar-menu-item--nested-twice{padding-left:var(--MdsNavigationBar_MenuItem__nestedTwoLevelsLeadingPadding,52px);padding-right:var(--MdsNavigationBar_MenuItem__nestedTrailingPadding,20px)}:host .navigation-bar-menu-item__text{position:relative;pointer-events:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}:host .navigation-bar-menu-item__icon{display:inline-flex;pointer-events:none}:host .navigation-bar-menu-item__icon--collapsible{margin-top:var(--MdsNavigationBar_MenuItem-_type-collapsible__iconTopMargin,4px);margin-right:var(--MdsNavigationBar_MenuItem-_type-collapsible__iconTrailingMargin,4px);transition-property:transform;transition-duration:var(--MdsNavigationBar_MenuItem-_type-collapsible__iconRotationTransitionDuration,.2s);transition-timing-function:var(--MdsNavigationBar_MenuItem-_type-collapsible__iconRotationTransitionEasingFunction,cubic-bezier(.4,0,.2,1))}:host .navigation-bar-menu-item__icon--collapsible svg{height:var(--MdsNavigationBar_MenuItem-_type-collapsible__iconHeight,1rem);width:var(--MdsNavigationBar_MenuItem-_type-collapsible__iconWidth,1rem)}:host .navigation-bar-menu-item__icon--expanded{transform:rotate(90deg)}:host .navigation-bar-menu-item__submenu{transform:scaleY(0);transition-property:transform,height,opacity;transition-duration:var(--MdsNavigationBar_MenuItem-_type-collapsible__submenuExpandCollapseTransitionDuration,.2s);transition-timing-function:var(--MdsNavigationBar_MenuItem-_type-collapsible__submenuExpandCollapseTransitionEasingFunction,cubic-bezier(.4,0,.2,1));transform-origin:top;opacity:var(--MdsNavigationBar_MenuItem-_type-collapsible__submenuExpandCollapseTransitionStartOpacity,0);height:0}:host .navigation-bar-menu-item__submenu--expanded{transform:scaleY(1);opacity:var(--MdsNavigationBar_MenuItem-_type-collapsible__submenuExpandCollapseTransitionEndOpacity,1)}:host .navigation-bar-menu-item .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}.navigation-bar-menu-item{background-color:var(--MdsNavigationBar_Menu__backgroundColor,#fff);color:var(--MdsNavigationBar_MenuItem__labelTextColor,#101820)}.navigation-bar-menu-item:focus:not(.navigation-bar-menu-item--active) .navigation-bar-menu-item__text{box-shadow:0 var(--MdsNavigationBar_MenuItem__bottomBorderWidth--focused,4px) 0 var(--MdsNavigationBar_MenuItem__bottomBorderColor--focused,#ccc)}.navigation-bar-menu-item.navigation-bar-menu-item--interactive:hover:not(.navigation-bar-menu-item--active):not(.navigation-bar-menu-item--inactive) .navigation-bar-menu-item__text{box-shadow:0 var(--MdsNavigationBar_MenuItem__bottomBorderWidth--hovered,4px) 0 var(--MdsNavigationBar_MenuItem__bottomBorderColor--hovered,#ccc)}.navigation-bar-menu-item--active .navigation-bar-menu-item__text{box-shadow:0 var(--MdsNavigationBar_MenuItem-_active-true__bottomBorderWidth,4px) 0 var(--MdsNavigationBar_MenuItem-_active-true__bottomBorderColor,#005eb8)}.navigation-bar-menu-item--inactive{color:var(--MdsNavigationBar_MenuItem-_inactive-true__labelTextColor,#8c8e90)}.navigation-bar-menu-item__icon--collapsible svg{fill:var(--MdsNavigationBar_MenuItem-_type-collapsible__iconColor,#005eb8)}.navigation-bar-menu-item--heading{color:var(--MdsNavigationBar_MenuItem-_type-heading__textColor,#565a5d)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/progress-bar-radial/mds-progress-bar-radial.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .progress-bar-radial__container{position:relative}:host .progress-bar-radial__container--small{height:var(--MdsProgressBarRadial-_size-small__diameter,108px);width:var(--MdsProgressBarRadial-_size-small__diameter,108px)}:host .progress-bar-radial__container--regular{height:var(--MdsProgressBarRadial-_size-regular__diameter,188px);width:var(--MdsProgressBarRadial-_size-regular__diameter,188px)}:host .progress-bar-radial__track{stroke-width:var(--MdsProgressBarRadial__trackWidth,8px);stroke:var(--MdsProgressBarRadial__trackColor,#c1c3c3);fill:var(--MdsProgressBarRadial__backgroundColor,transparent)}:host .progress-bar-radial__indicator-border{stroke-width:var(--MdsProgressBarRadial__trackWidth,8px);stroke-linecap:round;stroke:var(--MdsProgressBarRadial__indicatorBorderColor,#fff)}:host .progress-bar-radial__indicator,:host .progress-bar-radial__indicator-border{transform-origin:50% 50%;transition:stroke-dashoffset var(--MdsProgressBarRadial__indicatorTransitionTime,.35s) var(--MdsProgressBarRadial__indicatorTransitionEase,cubic-bezier(0,0,0,1));fill:var(--MdsProgressBarRadial__backgroundColor,transparent)}:host .progress-bar-radial__indicator{stroke-width:var(--MdsProgressBarRadial__trackWidth,8px);stroke:var(--MdsProgressBarRadial__indicatorColor,#005eb8)}:host .progress-bar-radial__indicator--with-round-border{stroke-linecap:round}:host .progress-bar-radial__indicator--with-straight-border{stroke-linecap:butt}:host .progress-bar-radial__text-value{color:var(--MdsProgressBarRadial__valueTextColor,#101820);display:flex;position:absolute;left:50%;transform:translateX(-50%);font-weight:300;font-size:var(--MdsProgressBarRadial-_size-regular__valueTextSize,4rem);line-height:var(--MdsProgressBarRadial-_size-regular__valueTextLineHeight,90px);top:25%}:host .progress-bar-radial__text-value--small{font-weight:400;font-size:var(--MdsProgressBarRadial-_size-small__valueTextSize,2rem);line-height:var(--MdsProgressBarRadial-_size-small__valueTextLineHeight,40px);top:calc(50% - var(--MdsProgressBarRadial-_size-small__valueTextLineHeight, 40px)/2)}:host .progress-bar-radial__text-value--with-key{top:var(--MdsProgressBarRadial-_size-regular__valueTextTopMarginWithKey,32px)}:host .progress-bar-radial__text-value--with-key.progress-bar-radial__text-value--small{top:var(--MdsProgressBarRadial-_size-small__valueTextTopMarginWithKey,28px)}:host .progress-bar-radial__percent-sign{color:var(--MdsProgressBarRadial__valueTextColor,#101820);text-align:center;display:flex;justify-content:center;left:50%;position:absolute;transform:translateX(-50%);font-size:var(--MdsProgressBarRadial-_size-regular__percentSignTextSize,1.125rem);top:calc(25% + var(--MdsProgressBarRadial-_size-regular__percentSignTopMarginWithThreeDigits, 16px))}:host .progress-bar-radial__percent-sign--small{font-size:var(--MdsProgressBarRadial-_size-small__percentSignTextSize,.75rem);top:calc(50% - var(--MdsProgressBarRadial-_size-small__valueTextLineHeight, 40px)/2)}:host .progress-bar-radial__percent-sign--with-key{top:calc(var(--MdsProgressBarRadial-_size-regular__valueTextTopMarginWithKey, 32px) + var(--MdsProgressBarRadial-_size-regular__percentSignTopMarginWithThreeDigits, 16px))}:host .progress-bar-radial__percent-sign--with-key.progress-bar-radial__percent-sign--small{top:var(--MdsProgressBarRadial-_size-small__valueTextTopMarginWithKey,28px)}:host .progress-bar-radial__text-key{text-align:center;display:flex;justify-content:center;position:absolute;left:50%;transform:translateX(-50%);word-break:break-all;color:var(--MdsProgressBarRadial__valueTextColor,#101820);font-size:var(--MdsProgressBarRadial-_size-regular__keyTextSize,1rem);line-height:var(--MdsProgressBarRadial-_size-regular__keyTextLineHeight,24px);width:var(--MdsProgressBarRadial-_size-regular__valueTextMaxWidth,110px);top:calc(var(--MdsProgressBarRadial-_size-regular__valueTextTopMarginWithKey, 32px) + var(--MdsProgressBarRadial-_size-regular__valueTextLineHeight, 90px))}:host .progress-bar-radial__text-key--small{font-size:var(--MdsProgressBarRadial-_size-small__keyTextSize,.75rem);line-height:var(--MdsProgressBarRadial-_size-small__keyTextLineHeight,16px);width:75px;top:calc(var(--MdsProgressBarRadial-_size-small__valueTextTopMarginWithKey, 28px) + var(--MdsProgressBarRadial-_size-small__valueTextLineHeight, 40px))}:host .progress-bar-radial__icon-dash{text-align:center;display:flex;justify-content:center;position:absolute;left:50%;transform:translateX(-50%);top:calc(50% - .6rem);height:var(--MdsProgressBarRadial__nullValueIconWidth,20px);width:var(--MdsProgressBarRadial__nullValueIconWidth,20px);align-items:center}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/progress-bar/mds-progress-bar.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ':host *{box-sizing:border-box}:host .progress-bar{position:relative;height:var(--MdsProgressBar__indicatorHeight,8px)}:host .progress-bar__accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .progress-bar__track{height:var(--MdsProgressBar__trackHeight,4px);border-radius:var(--MdsProgressBar__trackBorderRadius,2px);position:relative;top:calc(var(--MdsProgressBar__indicatorHeight, 8px)/2 - var(--MdsProgressBar__trackHeight, 4px)/2)}:host .progress-bar__indicator{height:var(--MdsProgressBar__indicatorHeight,8px);border-radius:var(--MdsProgressBar__indicatorBorderRadius,4px);position:absolute;transition-duration:var(--MdsProgressBar__trackMotionTiming,.35s);transition-property:width;transition-timing-function:var(--MdsProgressBar__trackMotionEase,cubic-bezier(0,0,0,1));top:0}@-moz-document url-prefix(""){:host .progress-bar__indicator{height:0}}:host .progress-bar__indicator--empty{border:0}:host .progress-bar__indicator-outer-border{height:var(--MdsProgressBar__indicatorHeight,8px);border-radius:calc(var(--MdsProgressBar__indicatorHeight, 8px)/2);position:absolute;transition-duration:var(--MdsProgressBar__trackMotionTiming,.35s);transition-property:width;transition-timing-function:var(--MdsProgressBar__trackMotionEase,cubic-bezier(0,0,0,1));top:0;left:calc(var(--MdsProgressBar__indicatorOuterBorderWidth, 2px)*-1)}:host .progress-bar__indicator-outer-border--empty{border:0}:host .progress-bar__track{border:calc(var(--MdsProgressBar__trackHeight, 4px)/2) solid var(--MdsProgressBar__trackColor,#8c8e90);background-color:var(--MdsProgressBar__trackColor,#8c8e90)}:host .progress-bar__indicator{border:calc(var(--MdsProgressBar__indicatorHeight, 8px)/2) solid var(--MdsProgressBar__indicatorColor,#005eb8);background-color:var(--MdsProgressBar__indicatorColor,#005eb8)}:host .progress-bar__indicator-outer-border{border-right:calc(var(--MdsProgressBar__indicatorHeight, 8px)/2) solid var(--MdsProgressBar__indicatorOuterBorderColor,#fff)}', "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/progress-spinner/mds-progress-spinner.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .progress-spinner{position:fixed;top:0;right:0;left:0;bottom:0;z-index:100000}:host .progress-spinner__backdrop{height:100%;width:100%;z-index:-1;background-color:var(--MdsProgressSpinner__overlayColor,hsla(0,0%,100%,.9));-webkit-backdrop-filter:blur(var(--MdsProgressSpinner__spinnerBackdropBlurEffectIntensity,4px));backdrop-filter:blur(var(--MdsProgressSpinner__spinnerBackdropBlurEffectIntensity,4px))}:host .progress-spinner__container{width:100%;height:100%;display:flex;flex-direction:row;overflow:hidden;left:50%;top:50%;transform:translate(-50%,-50%);position:absolute;justify-content:center;align-items:center;padding-left:var(--MdsProgressSpinner__containerLeadingMargin,16px);padding-right:var(--MdsProgressSpinner__containerTrailingMargin,16px)}:host .progress-spinner__container--inverse{background-color:var(--MdsProgressSpinner__inverseTrueOverlayColor,rgba(0,0,0,.8))}:host .progress-spinner__spinner{display:flex;justify-content:center;align-items:center}:host .progress-spinner__accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .progress-spinner__label{display:block;font-size:var(--MdsProgressSpinner__loadingLabelTextSize,1rem);font-weight:var(--MdsProgressSpinner__loadingLabelTextWeight,400);margin-left:var(--MdsProgressSpinner__loadingLabelTextLeadingMargin,8px);color:var(--MdsProgressSpinner__loadingLabelTextColor,#101820)}:host .progress-spinner__label--inverse{color:var(--MdsProgressSpinner__inverseTrueLoadingLabelTextColor,#fff)}:host .progress-spinner__label:focus{outline:none}@keyframes rotateThis{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@media (max-width:768px){:host .progress-spinner__circle{width:var(--MdsProgressSpinner__spinnerSmallScreenContainerWidth,24px);min-width:var(--MdsProgressSpinner__spinnerSmallScreenContainerWidth,24px);height:var(--MdsProgressSpinner__spinnerSmallScreenContainerHeight,24px)}:host .progress-spinner__label{font-size:var(--MdsProgressSpinner__loadingLabelSmallScreenTextSize,.875rem)}}@media (prefers-reduced-motion:reduce){:host .progress-spinner__circle{animation:none}}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/progress-steps/mds-progress-steps.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{box-sizing:border-box}:host .progress-steps{display:flex;align-items:center;height:var(--MdsProgressSteps__highlightedStepHeight,8px)}:host .progress-steps__accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .progress-steps__step{flex-grow:1;margin-right:var(--MdsProgressSteps__interStepSmallSizeMargin,8px);border-radius:var(--MdsProgressSteps__stepBorderRadius,2px);height:var(--MdsProgressSteps__stepHeight,4px);border:calc(var(--MdsProgressSteps__stepHeight, 4px)/2) solid var(--MdsProgressSteps__uncompletedStepColor,#8c8e90)}:host .progress-steps__step--visited{border-color:var(--MdsProgressSteps__completedStepColor,#005eb8);background-color:var(--MdsProgressSteps__completedStepColor,#005eb8)}:host .progress-steps__step--unvisited{border-width:.0625rem;background-color:var(--MdsProgressSteps__uncompletedStepColor,#8c8e90)}:host .progress-steps__step--current{height:var(--MdsProgressSteps__highlightedStepHeight,8px);border-width:calc(var(--MdsProgressSteps__highlightedStepHeight, 8px)/2);border-radius:var(--MdsProgressSteps__highlightedStepBorderRadius,4px);border-color:var(--MdsProgressSteps__completedStepColor,#005eb8);background-color:var(--MdsProgressSteps__completedStepColor,#005eb8)}:host .progress-steps__step:last-of-type{margin-right:0}@media (min-width:768px){:host .progress-steps__step{margin-right:var(--MdsProgressSteps__interStepMargin,16px)}:host .progress-steps__step:last-of-type{margin-right:0}}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/quick-action-bar/mds-quick-action-bar.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ':host .accessible-text{display:none}:host .mds-quick-action-bar{overflow-x:scroll;white-space:nowrap;box-sizing:border-box;padding:0;margin:0;list-style-type:none;display:flex}@-moz-document url-prefix(""){:host .mds-quick-action-bar{scrollbar-width:none}}:host .mds-quick-action-bar::-webkit-scrollbar,:host .mds-quick-action-bar::-webkit-scrollbar-thumb{background:transparent;height:0;display:none}@media screen and (min--moz-device-pixel-ratio:0){:host .mds-quick-action-bar:hover{overflow-x:scroll}}:host .mds-quick-action-bar:hover::-webkit-scrollbar,:host .mds-quick-action-bar:hover::-webkit-scrollbar-thumb{height:0;display:none}:host .mds-quick-action-bar--leading{justify-content:flex-start}:host .mds-quick-action-bar--center,:host .mds-quick-action-bar--trailing{justify-content:flex-start;margin-left:auto;max-width:-moz-fit-content;max-width:fit-content}:host .mds-quick-action-bar--center{margin-right:auto}:host .mds-quick-action-bar__line-break{display:flex}:host .mds-quick-action-bar__button{background-color:var(--MdsQuickActionBar_button__backgroundColor,#fff);color:var(--MdsQuickActionBar_button__textColor,#005eb8);box-shadow:var(--MdsQuickActionBar_button__boxShadowHorizontalOffset,0) var(--MdsQuickActionBar_button__boxShadowVerticalOffset,1px) var(--MdsQuickActionBar_button__boxShadowBlurRadius,1px) var(--MdsQuickActionBar_button__boxShadowSpreadRadius,0) var(--MdsQuickActionBar_button__boxShadowColor,rgba(0,0,0,.14));font-size:var(--MdsQuickActionBar_button__textSize,.75rem);line-height:var(--MdsQuickActionBar_button__textLineHeight,1rem);font-weight:var(--MdsQuickActionBar_button__textWeight,600);min-width:-moz-fit-content;min-width:fit-content;display:flex;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif;border:0;margin:.0625rem;padding:var(--MdsQuickActionBar_button__topPadding,10px) var(--MdsQuickActionBar_button__trailingPadding,16px) var(--MdsQuickActionBar_button__bottomPadding,10px) var(--MdsQuickActionBar_button__leadingPadding,16px);border-radius:var(--MdsQuickActionBar_button__borderRadius,18px);cursor:pointer}:host .mds-quick-action-bar__button:active{background-color:var(--MdsQuickActionBar_button__backgroundColor--pressed,#eaf6ff);color:var(--MdsQuickActionBar_button__textColor--pressed,#0091da)}:host .mds-quick-action-bar__button::-moz-focus-inner{border:0}:host .mds-quick-action-bar__button-container{display:flex}@-moz-document url-prefix(""){:host .mds-quick-action-bar__button-container{min-width:-moz-min-content}}:host .mds-quick-action-bar__button-container:not(:last-child){margin-right:var(--MdsQuickActionBar__buttonsMarginBetween,8px)}:host .mds-quick-action-bar__button-container:first-of-type{margin-left:.0625rem}:host .mds-quick-action-bar__button-container:last-of-type{margin-right:.0625rem}:host .mds-quick-action-bar__button:focus{outline:.0625rem dashed #717171}:host .mds-quick-action-bar__button--more{padding:var(--MdsQuickActionBar_button-_moreButton-true__topPadding,4px) var(--MdsQuickActionBar_button-_moreButton-true__trailingPadding,16px) var(--MdsQuickActionBar_button-_moreButton-true__bottomPadding,4px) var(--MdsQuickActionBar_button-_moreButton-true__leadingPadding,16px);align-items:center}:host .mds-quick-action-bar__button--multiline-first-row{margin-bottom:var(--MdsQuickActionBar__buttonsMarginBetween,8px)}:host .mds-quick-action-bar__label{display:inline;padding-bottom:0;pointer-events:none}:host .mds-quick-action-bar__icon{display:flex;vertical-align:var(--MdsQuickActionBar_button__iconVerticalAlignment,top);pointer-events:none}:host .mds-quick-action-bar__icon svg{width:var(--MdsQuickActionBar_button-_moreButton-true__iconWidth,28px);height:var(--MdsQuickActionBar_button-_moreButton-true__iconHeight,28px);fill:var(--MdsQuickActionBar_button__textColor,#005eb8)}', "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/quick-reply-bar/mds-quick-reply-bar.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host .mds-quick-reply-bar{overflow-x:auto;white-space:nowrap;box-sizing:border-box;padding-top:var(--MdsQuickReplyBar__topPadding,0);display:block;margin:0;padding-left:0}:host .mds-quick-reply-bar--leading{text-align:left}:host .mds-quick-reply-bar--centered{text-align:center}:host .mds-quick-reply-bar--multiline{overflow-x:visible;white-space:normal}:host .mds-quick-reply-bar--multiline .mds-quick-reply-bar__button-container{display:inline-block;margin-bottom:var(--MdsQuickReplyBar__buttonsMarginBetween,8px)}:host .mds-quick-reply-bar--multiline .mds-quick-reply-bar__button-container:first-child{margin-left:var(--MdsQuickReplyBar__buttonsMarginBetween,8px)}:host .mds-quick-reply-bar--multiline .mds-quick-reply-bar__button-container:last-child{margin-right:var(--MdsQuickReplyBar__buttonsMarginBetween,8px)}:host .mds-quick-reply-bar--trailing{text-align:right}:host .mds-quick-reply-bar::-webkit-scrollbar,:host .mds-quick-reply-bar::-webkit-scrollbar-thumb{background:transparent;height:.5rem}:host .mds-quick-reply-bar:hover::-webkit-scrollbar,:host .mds-quick-reply-bar:hover::-webkit-scrollbar-thumb{height:.5rem}:host .mds-quick-reply-bar:hover::-webkit-scrollbar-thumb{background:grey;border-radius:.25rem}:host .mds-quick-reply-bar__line-break{display:inline}:host .mds-quick-reply-bar__button{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif;margin-top:.0625rem;margin-bottom:.0625rem;display:inline-block;overflow-x:visible;padding-bottom:calc(var(--MdsQuickReplyBar_button__bottomPadding, 4px) - var(--MdsQuickReplyBar_button__borderWidth, 1px));padding-top:calc(var(--MdsQuickReplyBar_button__topPadding, 4px) - var(--MdsQuickReplyBar_button__borderWidth, 1px));border-radius:var(--MdsQuickReplyBar_button__borderRadius,12px);font-weight:var(--MdsQuickReplyBar_button__textWeight,600);cursor:pointer;background-color:var(--MdsQuickReplyBar_button__backgroundColor,transparent);color:var(--MdsQuickReplyBar_button__textColor,#005eb8);border:var(--MdsQuickReplyBar_button__borderWidth,1px) solid var(--MdsQuickReplyBar_button__borderColor,#005eb8)}:host .mds-quick-reply-bar__button::-moz-focus-inner{border:0}:host .mds-quick-reply-bar__button-container{display:inline;padding-bottom:0}:host .mds-quick-reply-bar__button-container:not(:last-child){margin-right:var(--MdsQuickReplyBar__buttonsMarginBetween,8px)}:host .mds-quick-reply-bar__button:focus{outline:.0625rem dashed #717171}:host .mds-quick-reply-bar__button--base{font-size:var(--MdsQuickReplyBar_button__textSize,.875rem);padding-left:calc(var(--MdsQuickReplyBar_button__leadingPadding, 16px) - var(--MdsQuickReplyBar_button__borderWidth, 1px));padding-right:calc(var(--MdsQuickReplyBar_button__trailingPadding, 16px) - var(--MdsQuickReplyBar_button__borderWidth, 1px));line-height:var(--MdsQuickReplyBar_button__textLineHeight,1.25rem);font-weight:var(--MdsQuickReplyBar_button__textWeight,600);min-width:-moz-fit-content;min-width:fit-content;white-space:nowrap;display:inline-flex;align-items:center;justify-content:center}:host .mds-quick-reply-bar__button--image{font-size:var(--MdsQuickReplyBar_button-_image-true__textSize,.75rem);line-height:var(--MdsQuickReplyBar_button-_image-true__textLineHeight,1rem);padding:calc(var(--MdsQuickReplyBar_button-_image-true__topPadding, 8px) - var(--MdsQuickReplyBar_button__borderWidth, 1px)) var(--MdsQuickReplyBar_button-_image-true__trailingPadding,8px) calc(var(--MdsQuickReplyBar_button-_image-true__bottomPadding, 8px) - var(--MdsQuickReplyBar_button__borderWidth, 1px)) var(--MdsQuickReplyBar_button-_image-true__leadingPadding,8px);text-align:left;box-sizing:content-box}:host .mds-quick-reply-bar__button--image>.mds-quick-reply-bar__image-container{pointer-events:none}:host .mds-quick-reply-bar__button--image>.mds-quick-reply-bar__label{pointer-events:none;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;display:block}:host .mds-quick-reply-bar__button--multiline-first-row{margin-bottom:var(--MdsQuickReplyBar__buttonsMarginBetween,8px)}:host .mds-quick-reply-bar__button:hover{background-color:var(--MdsQuickReplyBar_button__backgroundColor--hovered,rgba(0,94,184,.08));color:var(--MdsQuickReplyBar_button__textColor--hovered,#004692);border-color:var(--MdsQuickReplyBar_button__borderColor--hovered,#004692)}:host .mds-quick-reply-bar__button:active{background-color:var(--MdsQuickReplyBar_button__backgroundColor--pressed,rgba(0,94,184,.08));color:var(--MdsQuickReplyBar_button__textColor--pressed,#0091da);border-color:var(--MdsQuickReplyBar_button__borderColor--pressed,#0091da)}:host .mds-quick-reply-bar__label{pointer-events:none;display:inline;padding-bottom:0}:host .mds-quick-reply-bar__label--secondary{margin-top:var(--MdsQuickReplyBar_button-_image-true__secondaryTextTopMargin,4px)}:host .mds-quick-reply-bar__image{padding-bottom:0;margin-bottom:var(--MdsQuickReplyBar_button-_image-true__imageBottomMargin,4px);display:block;-o-object-fit:cover;object-fit:cover;-o-object-position:center top;object-position:center top}:host .mds-quick-reply-bar__image-container{padding-bottom:0}:host .mds-quick-reply-bar__icon{pointer-events:none;display:inline-block;vertical-align:top;line-height:0;padding-bottom:0;margin-left:var(--MdsQuickReplyBar_button__iconLeadingPadding,4px);margin-top:var(--MdsQuickReplyBar_button__iconTopPadding,6px)-var(--MdsQuickReplyBar_button__topPadding,4px) + var(--MdsQuickReplyBar_button__borderWidth,1px)}:host .mds-quick-reply-bar__icon svg{height:1em;width:1em;fill:var(--MdsQuickReplyBar_button__iconColor,#005eb8)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/quick-reply-button/mds-quick-reply-button.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host .mds-quick-reply-button__base{font-size:.875rem;padding-left:15px;padding-right:15px;line-height:1.25rem;font-weight:600;min-width:-moz-fit-content;min-width:fit-content;white-space:nowrap;display:inline-block;border-width:1px;border-radius:12px;border-style:solid;cursor:pointer}:host .mds-quick-reply-button{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif;background:transparent;color:#0060f0;border-color:#0060f0}:host .mds-quick-reply-button:focus{outline:.0625rem dashed #717171}:host .mds-quick-reply-button:hover{background-color:var(--MdsQuickReplyBar_button__backgroundColor--hovered,rgba(0,94,184,.08));color:var(--MdsQuickReplyBar_button__textColor--hovered,#004692);border-color:var(--MdsQuickReplyBar_button__borderColor--hovered,#004692)}:host .mds-quick-reply-button:active{background-color:var(--MdsQuickReplyBar_button__backgroundColor--pressed,rgba(0,94,184,.08));color:var(--MdsQuickReplyBar_button__textColor--pressed,#0091da);border-color:var(--MdsQuickReplyBar_button__borderColor--pressed,#0091da)}:host .mds-quick-reply-button__icon{pointer-events:none;display:inline-block;vertical-align:top;line-height:0;padding-bottom:0;margin-left:var(--MdsQuickReplyBar_button__iconLeadingPadding,4px);margin-top:4px}:host .mds-quick-reply-button__icon svg{height:1em;width:1em;fill:var(--MdsQuickReplyBar_button__iconColor,#005eb8)}:host .mds-quick-reply-button-image{margin-top:4px;margin-bottom:4px;display:block;-o-object-fit:cover;object-fit:cover;-o-object-position:center top;object-position:center top}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/radio-group/mds-radio-group.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host{display:block}:host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .radio-group{margin:0;padding:0;border:0}:host .radio-group--base .radio-button{display:flex;align-items:center;position:relative;border:.0625rem solid transparent}:host .radio-group--base .radio-button--horizontal{display:inline-block;margin-right:var(--MdsRadioGroup-_layout-horizontal__radioTrailingMargin,32px);margin-top:var(--MdsRadioGroup-_layout-vertical__radioBottomMargin,16px)}:host .radio-group--base .radio-button--horizontal:last-of-type{margin-bottom:var(--MdsRadioGroup-_layout-vertical__radioBottomMargin,16px)}:host .radio-group--base .radio-button--vertical{margin:var(--MdsRadioGroup-_layout-vertical__radioBottomMargin,16px) 0}:host .radio-group--base .radio-button--vertical .radio-button__secondary-label{margin-top:var(--MdsRadioGroup-_layout-vertical__radioPrimaryLabelBottomMargin,4px)}:host .radio-group--base .radio-button .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .radio-group--base .radio-button__input{opacity:0;position:absolute;left:0;top:0;height:var(--MdsRadioGroup_radio__radioCircleSize,22px);width:var(--MdsRadioGroup_radio__radioCircleSize,22px);z-index:1;margin:.0625rem 0 0;cursor:pointer}:host .radio-group--base .radio-button__input:focus~.radio-button__label{outline:.0625rem dashed #717171}:host .radio-group--base .radio-button__input:checked .radio-button__a11y-dot{display:block;position:absolute;color:transparent;font-size:1.75rem;height:0;left:.125rem;top:-.25rem;z-index:1;cursor:pointer}:host .radio-group--base .radio-button__input:checked:not(:disabled)~.radio-button__label:not(.radio-button__label--error) .radio-button__outer-circle{border-color:var(--MdsRadioGroup_radio-_checked-true__containerBorderColor,#005eb8)}:host .radio-group--base .radio-button__input:checked:not(:disabled)~.radio-button__label:not(.radio-button__label--error) .radio-button__outer-circle .radio-button__inner-circle{background-color:var(--MdsRadioGroup_radio-_checked-true__radioDotColor,#005eb8);border-color:var(--MdsRadioGroup_radio-_checked-true__containerBorderColor,#005eb8)}:host .radio-group--base .radio-button__input:checked:disabled~.radio-button__a11y-dot{cursor:default}:host .radio-group--base .radio-button__input:checked:disabled~.radio-button__label .radio-button__inner-circle{background-color:var(--MdsRadioGroup_radio-_checked-true__radioDotColor--disabled,transparent)}:host .radio-group--base .radio-button__input:disabled,:host .radio-group--base .radio-button__input:disabled~.radio-button__label{cursor:default}:host .radio-group--base .radio-button__input:disabled~.radio-button__label .radio-button__outer-circle{background-color:var(--MdsRadioGroup_radio__containerBackgroundColor--disabled,#e2e4e5);border-color:var(--MdsRadioGroup_radio__containerBorderColor--disabled,#c1c3c3)}:host .radio-group--base .radio-button__label{display:flex;align-items:flex-start;position:relative;cursor:pointer;text-align:var(--MdsRadioGroup_radio__labelTextAlignment,left);padding-right:var(--MdsRadioGroup_radio__labelTrailingPadding,0)}:host .radio-group--base .radio-button__label .radio-button__label-content{background-color:var(--MdsRadioGroup_button__backgroundColor,transparent);color:var(--MdsRadioGroup_radio__labelTextColor,#101820);padding-left:var(--MdsRadioGroup_radio__labelLeadingPadding,16px);font-weight:var(--MdsRadioGroup_radio__labelTextWeight,400);width:100%}:host .radio-group--base .radio-button__label .radio-button__label-content .radio-button__primary-label{font-size:var(--MdsRadioGroup_radio__labelTextSize,1rem);line-height:var(--MdsRadioGroup_radio__labelTextLineHeight,1.5rem)}:host .radio-group--base .radio-button__label .radio-button__label-content .radio-button__secondary-label{color:var(--MdsRadioGroup_radio__secondaryLabelTextColor,#565a5d);font-size:var(--MdsRadioGroup_radio__secondaryLabelTextSize,.875rem);line-height:var(--MdsRadioGroup_radio__secondaryLabelTextLineHeight,1.25rem)}:host .radio-group--base .radio-button__label .radio-button__outer-circle{background-color:var(--MdsRadioGroup_radio__containerBackgroundColor,transparent);height:var(--MdsRadioGroup_radio__radioCircleSize,22px);width:var(--MdsRadioGroup_radio__radioCircleSize,22px);min-width:var(--MdsRadioGroup_radio__radioCircleSize,22px);padding:var(--MdsRadioGroup_radio__radioCircleThickness,2px);margin-top:.0625rem;border:var(--MdsRadioGroup_radio__radioCircleThickness,2px) solid var(--MdsRadioGroup_radio__containerBorderColor,#8c8e90);border-radius:50%}:host .radio-group--base .radio-button__label .radio-button__outer-circle .radio-button__inner-circle{position:relative;display:flex;justify-content:center;width:var(--MdsRadioGroup_radio__radioDotSize,14px);height:var(--MdsRadioGroup_radio__radioDotSize,14px);border-radius:50%}:host .radio-group--base .radio-button__a11y-dot{display:none}:host .radio-group--button .radio-group__radio-buttons{width:100%}:host .radio-group--button .radio-button{display:flex;align-items:center;position:relative;border:.0625rem solid transparent}:host .radio-group--button .radio-button--horizontal{display:inline-block;margin-right:var(--MdsRadioGroup-_layout-horizontal__buttonTrailingMargin,8px);margin-bottom:var(--MdsRadioGroup-_layout-horizontal__buttonBottomMargin,8px);margin-top:var(--MdsRadioGroup-_layout-horizontal__buttonBottomMargin,8px)}:host .radio-group--button .radio-button--vertical{display:block;margin:var(--MdsRadioGroup-_layout-vertical__radioBottomMargin,16px) 0}:host .radio-group--button .radio-button--vertical .radio-button__primary-label{text-align:center}:host .radio-group--button .radio-button .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .radio-group--button .radio-button__input{opacity:0;position:absolute;left:0;top:0;height:var(--MdsRadioGroup_radio__radioCircleSize,22px);width:var(--MdsRadioGroup_radio__radioCircleSize,22px);z-index:1;margin:.0625rem 0 0;cursor:pointer}:host .radio-group--button .radio-button__input:focus~.radio-button__label .radio-button__label-content{outline:.0625rem dashed #717171}:host .radio-group--button .radio-button__input:checked:not(:disabled)~.radio-button__label:not(.radio-button__label--error) .radio-button__label-content{color:var(--MdsRadioGroup_button-_checked-true__labelTextColor,#fff);border-color:var(--MdsRadioGroup_button__borderColor,);background-color:var(--MdsRadioGroup_button-_checked-true__backgroundColor,#005eb8)}:host .radio-group--button .radio-button__input:checked:not(:disabled)~.radio-button__label:not(.radio-button__label--error) .radio-button__label-content .radio-button__leading-icon svg{fill:var(--MdsRadioGroup_button-_checked-true__leadingIconColor,#fff)}:host .radio-group--button .radio-button__input:checked~.radio-button__label .radio-button__label-content{color:var(--MdsRadioGroup_button-_checked-true__labelTextColor--error,#fff)}:host .radio-group--button .radio-button__input:checked:disabled~.radio-button__label .radio-button__label-content{border-color:var(--MdsRadioGroup_button-_checked-true__borderColor--disabled,transparent);background-color:var(--MdsRadioGroup_button-_checked-true__backgroundColor--disabled,#e2e4e5)}:host .radio-group--button .radio-button__input:not(:checked):not(:disabled)~.radio-button__label:not(.radio-button__label--error) .radio-button__label-content{color:var(--MdsRadioGroup_button__labelTextColor,#005eb8);border-color:var(--MdsRadioGroup_button__borderColor,#005eb8)}:host .radio-group--button .radio-button__input:disabled{cursor:default}:host .radio-group--button .radio-button__input:disabled~.radio-button__label .radio-button__label-content{color:var(--MdsRadioGroup_button__labelTextColor--disabled,#8c8e90);border-color:var(--MdsRadioGroup_button__borderColor--disabled,#8c8e90);background-color:var(--MdsRadioGroup_button__backgroundColor--disabled,transparent);cursor:default}:host .radio-group--button .radio-button__input:disabled~.radio-button__label .radio-button__label-content .radio-button__leading-icon svg{fill:var(--MdsRadioGroup_button__leadingIconColor--disabled,#8c8e90)}:host .radio-group--button .radio-button__label{color:var(--MdsRadioGroup_button__labelTextColor,#005eb8);cursor:pointer}:host .radio-group--button .radio-button__label .radio-button__label-content{display:flex;justify-content:center;background-color:var(--MdsRadioGroup_button__backgroundColor,transparent);border:var(--MdsRadioGroup_button__borderWeight,1px) solid var(--MdsRadioGroup_button__borderColor,#005eb8);border-radius:var(--MdsRadioGroup_button__borderRadius,4px);padding:var(--MdsRadioGroup_button__topPadding,6px) var(--MdsRadioGroup_button__trailingPadding,16px) var(--MdsRadioGroup_button__bottomPadding,6px) var(--MdsRadioGroup_button__leadingPadding,16px);font-size:var(--MdsRadioGroup_button__labelTextSize,1rem);line-height:var(--MdsRadioGroup_button__labelTextLineHeight,1.5rem);font-weight:var(--MdsRadioGroup_radio__labelTextWeight,400)}:host .radio-group--button .radio-button__label .radio-button__label-content .radio-button__leading-icon{padding-top:var(--MdsRadioGroup_button__leadingIconTopPadding,2px);padding-right:var(--MdsRadioGroup_button__leadingIconTrailingPadding,8px);height:var(--MdsRadioGroup_button__leadingIconHeight,20px)}:host .radio-group--button .radio-button__label .radio-button__label-content .radio-button__leading-icon svg{width:var(--MdsRadioGroup_button__leadingIconWidth,20px);height:var(--MdsRadioGroup_button__leadingIconHeight,20px);fill:var(--MdsRadioGroup_button__leadingIconColor,#005eb8)}:host .radio-group--button .radio-button__label .radio-button__label-content .radio-button__leading-icon--small{padding-right:var(--MdsRadioGroup_button-_buttonSize-small__leadingIconTrailingPadding,4px);height:var(--MdsRadioGroup_button-_buttonSize-small__leadingIconHeight,16px)}:host .radio-group--button .radio-button__label .radio-button__label-content .radio-button__leading-icon--small svg{width:var(--MdsRadioGroup_button-_buttonSize-small__leadingIconWidth,16px);height:var(--MdsRadioGroup_button-_buttonSize-small__leadingIconHeight,16px);fill:var(--MdsRadioGroup_button-_buttonSize-small__leadingIconColor,#005eb8)}:host .radio-group--button .radio-button__label .radio-button__label-content--small{background-color:var(--MdsRadioGroup_button_buttonSize-small__backgroundColor,transparent);border:var(--MdsRadioGroup_button-_buttonSize-small__borderWeight,1px) solid var(--MdsRadioGroup_button-_buttonSize-small__borderColor,#005eb8);border-radius:var(--MdsRadioGroup_button-_buttonSize-small__borderRadius,4px);padding:var(--MdsRadioGroup_button-_buttonSize-small__topPadding,4px) var(--MdsRadioGroup_button-_buttonSize-small__trailingPadding,8px) var(--MdsRadioGroup_button-_buttonSize-small__bottomPadding,4px) var(--MdsRadioGroup_button-_buttonSize-small__leadingPadding,8px);font-size:var(--MdsRadioGroup_button-_buttonSize-small__labelTextSize,.875rem);line-height:var(--MdsRadioGroup_button-_buttonSize-small__labelTextLineHeight,1.25rem);font-weight:var(--MdsRadioGroup_button-_buttonSize-small__labelTextWeight,600)}:host .radio-group--button .radio-button__label--small{color:var(--MdsRadioGroup_button_buttonSize-small__labelTextColor,#005eb8);cursor:pointer}:host .radio-group--button .radio-button__a11y-dot{display:none}.radio-group__radio-buttons{overflow:hidden}.radio-group--base .radio-group__radio-buttons--inner-container{margin-top:calc(var(--MdsRadioGroup-_layout-vertical__radioBottomMargin, default-brand-get(mds-radio-group-layout-vertical-radio-bottom-margin))*-1)}.radio-group--base .radio-group__radio-buttons--remove-bottom-margin{margin-bottom:calc(var(--MdsRadioGroup-_layout-vertical__radioBottomMargin, default-brand-get(mds-radio-group-layout-vertical-radio-bottom-margin))*-1)}.radio-group--base .radio-button__input:checked:not(:disabled)~.radio-button__label:not(.radio-button__label--error) .radio-button__outer-circle{border-color:var(--MdsRadioGroup_radio-_checked-true__containerBorderColor,#005eb8)}.radio-group--base .radio-button__input:checked:not(:disabled)~.radio-button__label:not(.radio-button__label--error) .radio-button__outer-circle .radio-button__inner-circle{background-color:var(--MdsRadioGroup_radio-_checked-true__radioDotColor,#005eb8);border-color:var(--MdsRadioGroup_radio-_checked-true__containerBorderColor,#005eb8)}.radio-group--base .radio-button__input:checked(:disabled)~.radio-button__label .radio-button__inner-circle{background-color:var(--MdsRadioGroup_radio__radioDotColor--disabled,transparent)}.radio-group--base .radio-button__input:disabled~.radio-button__label .radio-button__outer-circle{background-color:var(--MdsRadioGroup_radio__containerBackgroundColor--disabled,#e2e4e5);border-color:var(--MdsRadioGroup_radio__containerBorderColor--disabled,#c1c3c3)}.radio-group--base .radio-button__input:disabled~.radio-button__label .radio-button__label-content,.radio-group--base .radio-button__input:disabled~.radio-button__label .radio-button__secondary-label{color:var(--MdsRadioGroup_radio__labelTextColor--disabled,#8c8e90)}.radio-group--base .radio-button__label-content{background-color:var(--MdsRadioGroup_button__backgroundColor,transparent);color:var(--MdsRadioGroup_radio__labelTextColor,#101820)}.radio-group--base .radio-button__secondary-label{color:var(--MdsRadioGroup_radio__secondaryLabelTextColor,#565a5d)}.radio-group--base .radio-button__outer-circle{border-color:var(--MdsRadioGroup_radio__containerBorderColor--disabled,#c1c3c3);background-color:var(--MdsRadioGroup_radio__containerBackgroundColor,transparent)}.radio-group--button .radio-group__radio-buttons--inner-container{margin-top:calc(var(--MdsRadioGroup-_layout-vertical__radioBottomMargin, default-brand-get(mds-radio-group-layout-vertical-radio-bottom-margin))*-1)}.radio-group--button .radio-group__radio-buttons--remove-bottom-margin{margin-bottom:calc(var(--MdsRadioGroup-_layout-vertical__radioBottomMargin, default-brand-get(mds-radio-group-layout-vertical-radio-bottom-margin))*-1)}.radio-group--button .radio-group__radio-buttons--remove-bottom-margin-horizontal{margin-bottom:calc(var(--MdsRadioGroup-_layout-horizontal__buttonBottomMargin, default-brand-get(mds-radio-group-layout-horizontal-button-bottom-margin))*-1)}.radio-group--button .radio-group__radio-buttons--inner-container-horizontal,.radio-group--button .radio-group__radio-buttons--inner-container-layout-horizontal{margin-top:calc(var(--MdsRadioGroup-_layout-horizontal__buttonBottomMargin, default-brand-get(mds-radio-group-layout-horizontal-button-bottom-margin))*-1)}.radio-group--button .radio-button__input:checked:not(:disabled)~.radio-button__label:not(.radio-button__label--error) .radio-button__label-content{color:var(--MdsRadioGroup_button-_checked-true__labelTextColor,#fff);border-color:var(--MdsRadioGroup_button__borderColor,);background-color:var(--MdsRadioGroup_button-_checked-true__backgroundColor,#005eb8)}.radio-group--button .radio-button__input:checked:not(:disabled)~.radio-button__label:not(.radio-button__label--error) .radio-button__label-content .radio-button__leading-icon svg{fill:var(--MdsRadioGroup_button-_checked-true__leadingIconColor,#fff)}.radio-group--button .radio-button__input:checked~.radio-button__label .radio-button__label-content{color:var(--MdsRadioGroup_button-_checked-true__labelTextColor,#fff)}.radio-group--button .radio-button__input:checked:disabled~.radio-button__label .radio-button__label-content{border-color:var(--MdsRadioGroup_button-_checked-true__borderColor--disabled,transparent);background-color:var(--MdsRadioGroup_button-_checked-true__backgroundColor--disabled,#e2e4e5)}.radio-group--button .radio-button__input:not(:checked):not(:disabled)~.radio-button__label:not(.radio-button__label--error) .radio-button__label-content{color:var(--MdsRadioGroup_button__labelTextColor,#005eb8);border-color:var(--MdsRadioGroup_button__borderColor,)}.radio-group--button .radio-button__input:disabled~.radio-button__label .radio-button__label-content{color:var(--MdsRadioGroup_button__labelTextColor--disabled,#8c8e90);border-color:var(--MdsRadioGroup_button__borderColor--disabled,#8c8e90);background-color:var(--MdsRadioGroup_button__backgroundColor,transparent)}.radio-group--button .radio-button__input:disabled~.radio-button__label .radio-button__label-content .radio-button__leading-icon svg{fill:var(--MdsRadioGroup_button__leadingIconColor--disabled,#8c8e90)}.radio-group--button .radio-button__label{color:var(--MdsRadioGroup_button__labelTextColor,#005eb8)}.radio-group--button .radio-button__label .radio-button__label-content{background-color:var(--MdsRadioGroup_button__backgroundColor,transparent);border:var(--MdsRadioGroup_button__borderWeight,1px) solid var(--MdsRadioGroup_button__borderColor,)}.radio-group--button .radio-button__label .radio-button__label-content .radio-button__leading-icon svg{fill:var(--MdsRadioGroup_button__leadingIconColor,#005eb8)}:host(mds-radio-group[inactive=true]){pointer-events:none}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/rating-indicator/mds-rating-indicator.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .rating-indicator{display:flex;height:var(--MdsRatingIndicator__height,20px);width:var(--MdsRatingIndicator__width,100px)}:host .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .rating-indicator__half-star-wrap{position:relative;line-height:0}:host .rating-indicator__filled-star svg{fill:var(--MdsRatingIndicator__filledIconColor,#005eb8)}:host .rating-indicator__filled-star svg,:host .rating-indicator__outline-star svg{height:var(--MdsRatingIndicator__iconHeight,20px);width:var(--MdsRatingIndicator__iconWidth,20px)}:host .rating-indicator__half-star{position:absolute}:host .rating-indicator__half-star svg{fill:var(--MdsRatingIndicator__filledIconColor,#005eb8)}:host .rating-indicator__half-star-outline svg,:host .rating-indicator__half-star svg{height:var(--MdsRatingIndicator__iconHeight,20px);width:var(--MdsRatingIndicator__iconWidth,20px)}:host .rating-indicator__half-star-outline svg,:host .rating-indicator__outline-star svg{fill:var(--MdsRatingIndicator__outlineIconColor,#8c8e90)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/search-box/mds-search-box.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host * ul{list-style:none;padding:0;margin:0}:host .search-box{position:relative}:host .search-box__menu{position:absolute;max-height:var(--MdsSearchBox__menuMaxHeight,320px);overflow-y:auto;overflow-x:hidden;width:100%;z-index:1100;visibility:hidden;outline:none}:host .search-box__menu--visible{visibility:visible}:host .search-box__menu-option{font-size:var(--MdsSearchBox_OptionItem__textSize,.875rem);font-weight:var(--MdsSearchBox_OptionItem__textWeight,400);line-height:var(--MdsSearchBox_OptionItem__lineHeight,1.25rem);text-align:var(--MdsSearchBox_OptionItem__textAlignment,left);cursor:pointer;padding:var(--MdsSearchBox_OptionItem__topPadding,8px) var(--MdsSearchBox_OptionItem__trailingPadding,16px) var(--MdsSearchBox_OptionItem__bottomPadding,8px) var(--MdsSearchBox_OptionItem__leadingPadding,16px);display:flex}:host .search-box__menu-option-text{pointer-events:none}:host .search-box__menu-option-text--primary{flex-basis:var(--MdsSearchBox_OptionItem__primaryTextWidth,25%);max-width:var(--MdsSearchBox_OptionItem__primaryTextWidth,25%)}:host .search-box__menu-option-text--primary-no-tertiary{flex-basis:var(--MdsSearchBox_OptionItem__emptyTertiaryTextPrimaryTextWidth,75%);max-width:var(--MdsSearchBox_OptionItem__emptyTertiaryTextPrimaryTextWidth,75%)}:host .search-box__menu-option-text--primary-no-secondary{flex-basis:var(--MdsSearchBox_OptionItem__emptyTertiaryTextAndSecondaryTextPrimaryTextWidth,100%);max-width:var(--MdsSearchBox_OptionItem__emptyTertiaryTextAndSecondaryTextPrimaryTextWidth,100%)}:host .search-box__menu-option-text--secondary{flex-basis:var(--MdsSearchBox_OptionItem__secondaryTextWidth,50%);max-width:var(--MdsSearchBox_OptionItem__secondaryTextWidth,50%);padding-left:var(--MdsSearchBox_OptionItem__secondaryTextLeadingPadding,16px)}:host .search-box__menu-option-text--secondary-no-tertiary{flex-basis:var(--MdsSearchBox_OptionItem__emptyTertiaryTextSecondaryTextWidth,25%);max-width:var(--MdsSearchBox_OptionItem__emptyTertiaryTextSecondaryTextWidth,25%)}:host .search-box__menu-option-text--tertiary{flex-basis:var(--MdsSearchBox_OptionItem__tertiaryTextWidth,25%);max-width:var(--MdsSearchBox_OptionItem__tertiaryTextWidth,25%);padding-left:var(--MdsSearchBox_OptionItem__tertiaryTextLeadingPadding,16px)}:host .search-box__menu-option-text--decorator{display:flex;flex-direction:column;justify-content:center}:host .search-box__menu-option:focus{outline:.0625rem dashed #717171;outline-offset:-.0625rem}:host .search-box__menu-option--image{min-width:var(--MdsSearchBox__imageMinWidth,24px);-o-object-position:top;object-position:top;width:100%}:host .search-box__menu-option--image-wrapper{margin-right:var(--MdsSearchBox__decoratorTrailingPadding,16px);display:flex;width:var(--MdsSearchBox_OptionItem__leadingImageWrapperWidth,32px);overflow:hidden;max-height:var(--MdsSearchBox_OptionItem__leadingImageWrapperMaxHeight,32px);flex-shrink:0}:host .search-box__menu-option--icon{margin-left:0;margin-right:0;padding-right:var(--MdsSearchBox__decoratorTrailingPadding,16px)}:host .search-box__menu-group-label{font-size:var(--MdsSearchBox_GroupItem__textSize,.75rem);font-weight:var(--MdsSearchBox_GroupItem__textWeight,600);line-height:var(--MdsSearchBox_GroupItem__lineHeight,1rem);text-align:var(--MdsSearchBox_GroupItem__textAlignment,left);padding:var(--MdsSearchBox_GroupItem__topPadding,8px) var(--MdsSearchBox_GroupItem__trailingPadding,16px) var(--MdsSearchBox_GroupItem__bottomPadding,8px) var(--MdsSearchBox_GroupItem__leadingPadding,16px);cursor:default}:host .search-box__menu-empty-block{padding:var(--MdsSearchBox__menuNoOptionsTopPadding,16px) var(--MdsSearchBox__menuNoOptionsTrailingPadding,16px) var(--MdsSearchBox__menuNoOptionsBottomPadding,16px) var(--MdsSearchBox__menuNoOptionsLeadingPadding,16px);font-size:var(--MdsSearchBox__menuNoOptionsTextSize,1rem);line-height:var(--MdsSearchBox__menuNoOptionsTextLineHeight,1.5rem);font-weight:var(--MdsSearchBox__menuNoOptionsTextTextWeight,400);cursor:default}:host .search-box__input{outline:none}:host .search-box__accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}.search-box__menu{box-shadow:var(--MdsSearchBox__menuBoxShadowHorizontalOffset,0) var(--MdsSearchBox__menuBoxShadowVerticalOffset,2px) var(--MdsSearchBox__menuBoxShadowBlurRadius,3px) var(--MdsSearchBox__menuBoxShadowSpreadRadius,0) var(--MdsSearchBox__menuBoxShadowColor,rgba(0,0,0,.28));background-color:var(--MdsSearchBox_OptionItem__backgroundColor,#fff)}.search-box__menu-option{color:var(--MdsSearchBox_OptionItem__textColor,#101820)}.search-box__menu-option:hover{background-color:var(--MdsSearchBox_OptionItem__backgroundColor--hovered,#f5f7f8)}.search-box__menu-option:active{background-color:var(--MdsSearchBox_OptionItem__backgroundColor--pressed,#0091da);color:var(--MdsSearchBox_OptionItem__textColor--pressed,#fff)}.search-box__menu-empty-block{background-color:var(--MdsSearchBox__menuNoOptionsBackgroundColor,#fff);color:var(--MdsSearchBox__menuNoOptionsTextColor,#101820)}.search-box__menu-group-label{background-color:var(--MdsSearchBox_GroupItem__backgroundColor,#f5f7f8);color:var(--MdsSearchBox_GroupItem__textColor,#565a5d)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/selectable-tile/mds-selectable-tile.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif;display:flex}:host .selectable-tile{display:flex;flex-direction:column;box-shadow:inset 0 0 0 .06rem var(--MdsSelectableTile__tileBorderColor,#e2e4e5);box-sizing:border-box;border-width:0;border-style:solid;border-radius:var(--MdsSelectableTile__borderRadius,8px);padding:var(--MdsSelectableTile__tileTopPadding,16px) var(--MdsSelectableTile__tileTrailingPadding,16px) var(--MdsSelectableTile__tileBottomPadding,16px) var(--MdsSelectableTile__tileLeadingPadding,16px)}:host .selectable-tile__accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .selectable-tile--focused{outline:var(--MdsSelectableTile_tileBorderWeight,1px) dashed #717171}:host .selectable-tile:hover,:host .selectable-tile:hover .selectable-tile__label-wrap .selectable-tile__label{cursor:pointer}:host .selectable-tile:hover.selectable-tile--disabled,:host .selectable-tile:hover.selectable-tile--disabled .selectable-tile__label-wrap .selectable-tile__label{cursor:default}:host .selectable-tile .selectable-tile__label-wrap{display:flex;flex-direction:row;justify-content:space-between}:host .selectable-tile .selectable-tile__label-wrap .selectable-tile__icon-wrap .selectable-tile__input{opacity:0;position:absolute;width:var(--MdsSelectableTile__multiSelectionIndicatorWidth,20px);height:var(--MdsSelectableTile__multiSelectionIndicatorHeight,20px);border-radius:50%}:host .selectable-tile .selectable-tile__label-wrap .selectable-tile__icon-wrap .selectable-tile__input:hover,:host .selectable-tile .selectable-tile__label-wrap .selectable-tile__icon-wrap .selectable-tile__input:hover+.selectable-tile__icon{cursor:pointer}:host .selectable-tile .selectable-tile__label-wrap .selectable-tile__icon-wrap .selectable-tile__input:hover:disabled,:host .selectable-tile .selectable-tile__label-wrap .selectable-tile__icon-wrap .selectable-tile__input:hover:disabled+.selectable-tile__icon{cursor:default}:host .selectable-tile .selectable-tile__label-wrap .selectable-tile__icon-wrap .selectable-tile__icon{display:inline-flex;box-sizing:border-box;border-radius:var(--MdsSelectableTile__checkboxBorderRadius,4px);width:var(--MdsSelectableTile__multiSelectionIndicatorWidth,20px);height:var(--MdsSelectableTile__multiSelectionIndicatorHeight,20px);margin-top:calc(var(--MdsSelectableTile__labelLineHeight, 1.5rem)/2 - var(--MdsSelectableTile__multiSelectionIndicatorHeight, 1.25rem)/2)}:host .selectable-tile .selectable-tile__label-wrap .selectable-tile__icon-wrap .selectable-tile__icon svg{width:1em;height:1em}:host .selectable-tile .selectable-tile__label-wrap .selectable-tile__icon-wrap .radio-button__outer-circle{border-width:var(--MdsSelectableTile__radioOuterCircleThickness,2px);padding:var(--MdsSelectableTile__radioOuterCircleThickness,2px);margin-top:.1875rem;border-style:solid;border-radius:50%}:host .selectable-tile .selectable-tile__label-wrap .selectable-tile__icon-wrap .radio-button__outer-circle .radio-button__inner-circle{position:relative;display:flex;justify-content:center;width:var(--MdsSelectableTile__radioInnerCircleDiameter,14px);height:var(--MdsSelectableTile__radioInnerCircleDiameter,14px);border-radius:50%}:host .selectable-tile .selectable-tile__label-wrap .selectable-tile__label{font-size:var(--MdsSelectableTile__labelTextSize,1rem);font-weight:var(--MdsSelectableTile__labelTextWeight,600);line-height:var(--MdsSelectableTile__labelLineHeight,1.5rem);padding-right:var(--MdsSelectableTile__labelTrailingPadding,16px)}:host .selectable-tile .selectable-tile__content{padding-top:var(--MdsSelectableTile__contentAreaTopPadding,16px)}:host .selectable-tile,:host .selectable-tile .radio-button__outer-circle{background-color:var(--MdsSelectableTile__backgroundColor,#fff)}:host .selectable-tile .radio-button__outer-circle{border-color:var(--MdsSelectableTile__indicatorBorderColor,#8c8e90)}:host .selectable-tile .selectable-tile__icon{border:var(--MdsSelectableTile__indicatorBorderWeight,2px) solid var(--MdsSelectableTile__indicatorBorderColor,#8c8e90)}:host .selectable-tile .selectable-tile__icon svg{fill:var(--MdsSelectableTile-_checked-true__indicatorIconColor,#fff)}:host .selectable-tile .selectable-tile__label{color:var(--MdsSelectableTile__labelTextColor,#101820)}:host .selectable-tile--active{box-shadow:inset 0 0 0 .13rem var(--MdsSelectableTile-_checked-true__tileBorderColor,#005eb8);box-sizing:border-box}:host .selectable-tile--active .radio-button__outer-circle{border-color:var(--MdsSelectableTile-_checked-true__indicatorBorderColor,#005eb8)}:host .selectable-tile--active .radio-button__outer-circle .radio-button__inner-circle{background-color:var(--MdsSelectableTile-_checked-true__indicatorBorderColor,#005eb8);border-color:var(--MdsSelectableTile-_checked-true__indicatorBorderColor,#005eb8)}:host .selectable-tile--active.selectable-tile--disabled{border-color:var(--MdsSelectableTile-_disabled-checked-true__tileBorderColor,#c1c3c3)}:host .selectable-tile--active.selectable-tile--disabled .selectable-tile__label-wrap .selectable-tile__icon-wrap .radio-button__outer-circle{border-color:var(--MdsSelectableTile-_checked-true__indicatorBorderColor--disabled,#c1c3c3);background-color:var(--MdsSelectableTile__backgroundColor--disabled,#f5f7f8)}:host .selectable-tile--active.selectable-tile--disabled .selectable-tile__label-wrap .selectable-tile__icon-wrap .radio-button__outer-circle .radio-button__inner-circle{background-color:var(--MdsSelectableTile-_checked-true__indicatorBackgroundColor--disabled,#c1c3c3);border-color:var(--MdsSelectableTile-_checked-true__indicatorBorderColor--disabled,#c1c3c3)}:host .selectable-tile--active .selectable-tile__icon{border-color:var(--MdsSelectableTile-_checked-true__indicatorBorderColor,#005eb8);background-color:var(--MdsSelectableTile-_checked-true__indicatorBackgroundColor,#005eb8)}:host .selectable-tile .selectable-tile__input:disabled+.selectable-tile__icon{border-color:var(--MdsSelectableTile__indicatorBorderColor--disabled,#c1c3c3)}:host .selectable-tile .selectable-tile__input:disabled+.selectable-tile__icon svg{fill:var(--MdsSelectableTile__backgroundColor--disabled,#f5f7f8)}:host .selectable-tile .selectable-tile__input:disabled+.radio-button__outer-circle,:host .selectable-tile .selectable-tile__input:disabled+.radio-button__outer-circle .radio-button__inner-circle{background-color:var(--MdsSelectableTile__background--disabled,#f5f7f8)}:host .selectable-tile .selectable-tile__input:disabled:checked+.selectable-tile__icon{background-color:var(--MdsSelectableTile-_checked-true__indicatorBackgroundColor--disabled,#c1c3c3)}:host .selectable-tile .selectable-tile__input:disabled:checked+.selectable-tile__icon svg{fill:var(--MdsSelectableTile-_checked-true__indicatorIconColor--disabled,#fff)}:host .selectable-tile--error .selectable-tile__icon,:host .selectable-tile--error .selectable-tile__label-wrap .selectable-tile__icon-wrap .radio-button__outer-circle{border-color:var(--MdsSelectableTile-_error-true__indicatorBorderColor,#b80009)}:host .selectable-tile--disabled,:host .selectable-tile--disabled .radio-button__outer-circle{background-color:var(--MdsSelectableTile__backgroundColor--disabled,#f5f7f8)}:host .selectable-tile--disabled .radio-button__outer-circle{border-color:var(--MdsSelectableTile__indicatorBorderColor--disabled,#c1c3c3)}:host .selectable-tile--disabled .radio-button__outer-circle .radio-button__inner-circle{background-color:var(--MdsSelectableTile__backgroundColor--disabled,#f5f7f8)}:host .selectable-tile--disabled .selectable-tile__label-wrap .selectable-tile__label{color:var(--MdsSelectableTile__labelTextColor--disabled,#8c8e90)}:host .selectable-tile--disabled .selectable-tile__label-wrap+.selectable-tile__icon{border-color:var(--MdsSelectableTile__indicatorBorderColor--disabled,#c1c3c3)}:host .selectable-tile--disabled .selectable-tile__label-wrap+.selectable-tile__icon svg{fill:var(--MdsSelectableTile__backgroundColor--disabled,#f5f7f8)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/skeleton-loader/mds-skeleton-loader.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host .skeleton-loader{min-width:var(--MdsSkeletonLoader__contentAreaMinWidth,108px);min-height:var(--MdsSkeletonLoader__contentAreaMinHeight,108px);max-width:100%;overflow:auto;height:auto}:host .skeleton-loader .skeleton-loader__circle,:host .skeleton-loader .skeleton-loader__rectangle{background-color:var(--MdsSkeletonLoader__backgroundColor,#f5f7f8)}:host .skeleton-loader .skeleton-loader__circle--no-animation .skeleton-loader__shape-animate,:host .skeleton-loader .skeleton-loader__rectangle--no-animation .skeleton-loader__shape-animate{background-position-x:65%;animation:none}:host .skeleton-loader .skeleton-loader__shape-animate{z-index:2;height:100%;width:100%;overflow:hidden;display:flex;align-items:center;justify-content:center;animation-duration:var(--MdsSkeletonLoader__animationDuration,3s);animation-delay:var(--MdsSkeletonLoader__animationDelay,.75s);animation-timing-function:var(--MdsSkeletonLoader__gradientStartPointAnimation__easing,cubic-bezier(.4,0,.2,1)),var(--MdsSkeletonLoader__opacityAnimation__easing,linear);animation-fill-mode:forwards;animation-iteration-count:infinite;background:radial-gradient(ellipse 35% 150% at 50% 35%,var(--MdsSkeletonLoader__gradientColor,#565a5d),var(--MdsSkeletonLoader__backgroundColor,#f5f7f8));background-size:calc(var(--MdsSkeletonLoader__gradientWidthProportion, 2)*100%)}@media (prefers-reduced-motion:reduce){:host .skeleton-loader .skeleton-loader__shape-animate{animation:none}}:host .skeleton-loader__rectangle{z-index:1;overflow:hidden;height:var(--MdsSkeletonLoader__blockHeight,16px);border-radius:var(--MdsSkeletonLoader__blockBorderRadius,8px);margin-top:var(--MdsSkeletonLoader__blockMargin,16px)}:host .skeleton-loader__rectangle--hidden{visibility:hidden}:host .skeleton-loader__rectangle--zero-margin{margin-top:0}:host .skeleton-loader__rectangle-width40{width:40%}:host .skeleton-loader__rectangle-width30{width:60%}:host .skeleton-loader__rectangle-width36{width:72%}:host .skeleton-loader__rectangle-width95{width:95%}:host .skeleton-loader__rectangle-width35{width:35%}:host .skeleton-loader__rectangle-width100{width:100%}:host .skeleton-loader__rectangle-width70{width:70%}:host .skeleton-loader__circle{z-index:1;overflow:hidden;flex-shrink:0;border:var(--MdsSkeletonLoader__borderWidth,1px) solid #8a8a8a;border-radius:50%;width:var(--MdsSkeletonLoader__circleHeight,76px);height:var(--MdsSkeletonLoader__circleHeight,76px)}:host .skeleton-loader__circle .skeleton-loader__shape-animate__inner{border-radius:50%}@keyframes border-movement{0%{background-position:calc(var(--MdsSkeletonLoader__gradientStartPointAnimation__keyframes__0__constant__x, 0)*100%) calc(var(--MdsSkeletonLoader__gradientStartPointAnimation__keyframes__0__constant__y, 0)*100%)}35%{background-position:calc(var(--MdsSkeletonLoader__gradientStartPointAnimation__keyframes__1__constant__x, 1)*100%) calc(var(--MdsSkeletonLoader__gradientStartPointAnimation__keyframes__1__constant__y, 0)*100%)}to{background-position:calc(var(--MdsSkeletonLoader__gradientStartPointAnimation__keyframes__2__constant__x,)*100%) calc(var(--MdsSkeletonLoader__gradientStartPointAnimation__keyframes__2__constant__y,)*100%)}}:host .skeleton-loader__shape-animate{animation-name:border-movement;background-position:0 0;border-radius:var(--MdsSkeletonLoader__blockBorderRadius,8px)}:host .skeleton-loader__shape-animate__inner{display:flex;height:calc(100% - var(--MdsSkeletonLoader__borderWidth, 1px)*2);width:calc(100% - var(--MdsSkeletonLoader__borderWidth, 1px)*2);border-radius:var(--MdsSkeletonLoader__blockBorderRadius,8px);background-color:#f6f6f6}@media (prefers-reduced-motion:reduce){:host .skeleton-loader__shape-animate{background-position:65%}}:host .skeleton-loader__template-list{display:flex;flex-direction:row;flex-wrap:wrap;margin-top:var(--MdsSkeletonLoader__contentAreaTopPaddingList,16px);margin-left:var(--MdsSkeletonLoader__contentAreaLeadingPaddingList,16px);margin-right:var(--MdsSkeletonLoader__contentAreaTrailingPaddingList,16px);width:calc(100% - 2rem)}:host .skeleton-loader__template-list-heading-wrapper{width:100%}:host .skeleton-loader__template-list-wrapper{width:50%;display:flex;flex-direction:column;padding-top:calc(var(--MdsSkeletonLoader__blockHeadingMargin, 24px) - var(--MdsSkeletonLoader__blockMargin, 16px))}:host .skeleton-loader__template-list-wrapper:nth-child(3){align-items:flex-end}:host .skeleton-loader__template-content-block,:host .skeleton-loader__template-image-and-content{margin-top:var(--MdsSkeletonLoader__contentAreaTopPadding,32px);margin-left:var(--MdsSkeletonLoader__contentAreaLeadingPadding,32px);margin-right:var(--MdsSkeletonLoader__contentAreaTrailingPadding,32px)}:host .skeleton-loader__template-image-and-content{display:flex;flex-direction:row}:host .skeleton-loader__template-image-and-content-wrapper{width:100%;margin-left:var(--MdsSkeletonLoader__blockMargin,16px)}:host .fadeout{visibility:hidden;opacity:0;transition:visibility 0s var(--MdsSkeletonLoader__fadeoutDuration,50),opacity var(--MdsSkeletonLoader__fadeoutDuration,50) linear}@media (prefers-reduced-motion:reduce){:host .skeleton-loader__shape-animate{animation:none}}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/skip-link/mds-skip-link.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, "@keyframes hideLinks{to{position:absolute;left:624.938rem}}@keyframes collapse{0%{height:calc(var(--MdsSkipLink__bottomMargin, .375rem) + var(--MdsSkipLink__topMargin, .375rem) + var(--MdsSkipLink__labelLineHeight, 1.25rem))}to{height:0}}@keyframes expand{0%{height:0}to{height:calc(var(--MdsSkipLink__bottomMargin, .375rem) + var(--MdsSkipLink__topMargin, .375rem) + var(--MdsSkipLink__labelLineHeight, 1.25rem))}}:host .skip-link{list-style:none;padding-left:0;margin-bottom:var(--MdsSkipLink__bottomMargin,6px);margin-top:var(--MdsSkipLink__topMargin,6px);max-width:var(--MdsSkipLink__maxWidth,1200px);background-color:transparent;width:100%;text-align:left;display:inline-block;white-space:nowrap;opacity:0;position:absolute;top:-6.25rem}:host .skip-link .skip-link__item{display:inline-block;line-height:var(--MdsSkipLink__labelLineHeigh,1.25rem);font-size:var(--MdsSkipLink__labelTextSize,.875rem)}:host .skip-link .skip-link__item:not(:last-child){margin-right:var(--MdsSkipLink__linksMarginBetween,16px)}:host .skip-link__container{text-align:center;background-color:var(--MdsSkipLink__backgroundColor,#fff);overflow:hidden;position:relative}:host .skip-link__container--expanded{animation:expand calc(var(--MdsSkipLink__expandTiming, 250)*1ms) var(--MdsSkipLink__expandEase,cubic-bezier(1,0,1,1)) 0ms forwards}:host .skip-link__container--expanded .skip-link{position:static;opacity:1}:host .skip-link__container--collapsed{animation:collapse calc(var(--MdsSkipLink__collapseTiming, 350)*1ms) var(--MdsSkipLink__collapseEase,cubic-bezier(0,0,0,1)) 0ms forwards}:host .skip-link__container--collapsed .skip-link{animation:hideLinks 0ms ease calc(var(--MdsSkipLink__collapseTiming, 350)*1ms) forwards}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/slide-in-panel/mds-slide-in-panel.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host .mds-slide-in-panel{position:absolute;width:100%;height:100vh;z-index:99999;align-items:flex-end;justify-content:flex-end;overflow:hidden}:host .mds-slide-in-panel .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .mds-slide-in-panel__backdrop{background-color:#000;height:100%;width:100%;opacity:.8;z-index:-1}:host .mds-slide-in-panel__panel-container{height:100%;display:flex;flex-direction:column;overflow:hidden;right:0;top:0;position:absolute}:host .mds-slide-in-panel__panel-container--exit-confirmation{display:flex;align-items:center;justify-content:center}:host .mds-slide-in-panel__alert-container{padding:var(--MdsSlideInPanel__exitConfirmationAlertPadding,16px)}:host .mds-slide-in-panel__sticky-footer--mobile{position:fixed}:host .mds-slide-in-panel--slide-out .mds-slide-in-panel__backdrop{opacity:0}:host .mds-slide-in-panel--slide-out .mds-slide-in-panel__panel-container{right:-100%}:host .mds-slide-in-panel__header-container{box-sizing:border-box;flex:0 0 auto;position:sticky;top:0;z-index:99999}:host .mds-slide-in-panel__header-top-border{width:100%}:host .mds-slide-in-panel__header{display:flex;justify-content:flex-end}:host .mds-slide-in-panel__title-container{flex-grow:0;flex-shrink:0;flex-basis:calc(100% - var(--MdsSlideInPanel__closeIconWidth, 20px) - var(--MdsSlideInPanel__closeIconLeadingPadding, 16px) - var(--MdsSlideInPanel__closeIconTrailingPadding, 16px) - var(--MdsSlideInPanel-_backIcon-true__backIconWidth, 20px) - var(--MdsSlideInPanel-_backIcon-true__backIconLeadingPadding, 16px) - var(--MdsSlideInPanel-_backIcon-true__backIconTrailingPadding, 16px));text-align:center}:host .mds-slide-in-panel__heading-container{display:flex;align-items:center;justify-content:center}:host .mds-slide-in-panel__heading{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif;margin:0;cursor:default}:host .mds-slide-in-panel__heading--with-subtitle{font-size:.875rem;line-height:1.25rem}:host .mds-slide-in-panel__heading:focus{outline:none}:host .mds-slide-in-panel__heading-icon{align-self:flex-start}:host .mds-slide-in-panel__subtitle{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif;margin:0}:host .mds-slide-in-panel__icon-button{height:2.75rem;display:flex;align-items:center;justify-content:center;border:0;margin:0;cursor:pointer}:host .mds-slide-in-panel__icon-button:focus{outline:.0625rem dashed #717171}:host .mds-slide-in-panel__icon-button::-moz-focus-inner{border:0}:host .mds-slide-in-panel__main{box-sizing:border-box;flex-grow:1;flex-shrink:1;flex-basis:100%;width:100vw;max-width:100%;overflow:auto;-webkit-overflow-scrolling:touch}.mds-slide-in-panel__backdrop{transition:opacity var(--MdsSlideInPanel__panelSlideInOpacityTiming,.1s) linear}.mds-slide-in-panel__panel-container{background-color:var(--MdsSlideInPanel__panelBackgroundColor,#fff);transition:right var(--MdsSlideInPanel__panelSlideInTiming,.35s) var(--MdsSlideInPanel__panelSlideInEase,cubic-bezier(0,0,0,1));width:var(--MdsSlideInPanel__widthTypeFullWidth,100%)}.mds-slide-in-panel__title-container{padding:var(--MdsSlideInPanel__headerBarPaddingTop,8px) 0 var(--MdsSlideInPanel__headerBarPaddingBottom,8px) 0}.mds-slide-in-panel--slide-out .mds-slide-in-panel__backdrop{transition:opacity var(--MdsSlideInPanel__panelSlideOutOpacityTiming,50ms) var(--MdsSlideInPanel__panelSlideOutOpacityTimingDelay,.2s) linear}.mds-slide-in-panel--slide-out .mds-slide-in-panel__panel-container{transition:right var(--MdsSlideInPanel__panelSlideOutTiming,.25s) var(--MdsSlideInPanel__panelSlideOutEase,cubic-bezier(1,0,1,1));right:calc(var(--MdsSlideInPanel__widthTypeFullWidth, 100%)*-1)}.mds-slide-in-panel__header-container{background-color:var(--MdsSlideInPanel__headerBackgroundColor,#fff);min-height:var(--MdsSlideInPanel__headerBarHeight,52px);border-bottom:var(--MdsSlideInPanel__headerBorderBottomWidth,1px) var(--MdsSlideInPanel__headerBorderBottomStyle,solid) var(--MdsSlideInPanel__headerBorderBottomColor,#c1c3c3)}.mds-slide-in-panel__header-container--scrolled{box-shadow:var(--MdsSlideInPanel__headerBarDropShadowHorizontalOffset,0) var(--MdsSlideInPanel__headerBarDropShadowVerticalOffset,4px) var(--MdsSlideInPanel__headerBarDropShadowBlurRadius,3px) var(--MdsSlideInPanel__headerBarDropShadowSpreadRadius,-3px) var(--MdsSlideInPanel__headerBarDropShadowColor,rgba(110,114,117,.45))}.mds-slide-in-panel__header-top-border{background:linear-gradient(90deg,var(--MdsSlideInPanel__headerBorderTopGradientStart,#0074c7),var(--MdsSlideInPanel__headerBorderTopGradientEnd,#002f6c));height:var(--MdsSlideInPanel__headerBorderTopWidth,8px)}.mds-slide-in-panel__heading{color:var(--MdsSlideInPanel__titleTextColor,#101820);font-size:var(--MdsSlideInPanel__titleTextSize,1.125rem);line-height:var(--MdsSlideInPanel__titleLineHeight,1.75rem);font-weight:var(--MdsSlideInPanel__titleTextWeight,400)}.mds-slide-in-panel__heading--with-subtitle{font-size:var(--MdsSlideInPanel-_subtitle-true__titleTextSize,.875rem);line-height:var(--MdsSlideInPanel-_subtitle-true__titleLineHeight,1.25rem)}.mds-slide-in-panel__heading-icon{display:inline-flex;margin-right:var(--MdsSlideInPanel__titleIconTrailingMargin,8px)}.mds-slide-in-panel__heading-icon svg{height:var(--MdsSlideInPanel__titleIconHeight,28px);width:var(--MdsSlideInPanel__titleIconWidth,28px);fill:var(--MdsSlideInPanel__titleIconColor,#565a5d)}.mds-slide-in-panel__subtitle{color:var(--MdsSlideInPanel-_subtitle-true__subtitleTextColor,);font-size:var(--MdsSlideInPanel-_subtitle-true__subtitleTextSize,.75rem);line-height:var(--MdsSlideInPanel-_subtitle-true__subtitleLineHeight,1rem);font-weight:var(--MdsSlideInPanel-_subtitle-true__subtitleTextWeight,600)}.mds-slide-in-panel__icon-button{background-color:var(--MdsSlideInPanel__headerBackgroundColor,#fff)}.mds-slide-in-panel__icon-button .mds-slide-in-panel__icon{display:inline-flex}.mds-slide-in-panel__icon-button--close{padding:0 var(--MdsSlideInPanel__closeIconLeadingPadding,16px) 0 var(--MdsSlideInPanel__closeIconTrailingPadding,16px)}.mds-slide-in-panel__icon-button--close .mds-slide-in-panel__icon svg{height:var(--MdsSlideInPanel__closeIconHeight,20px);width:var(--MdsSlideInPanel__closeIconWidth,20px);fill:var(--MdsSlideInPanel__closeIconColor,#565a5d)}@media print{.mds-slide-in-panel__icon-button--close{visibility:hidden}}.mds-slide-in-panel__icon-button--back{padding:0 var(--MdsSlideInPanel-_backIcon-true__backIconLeadingPadding,16px) 0 var(--MdsSlideInPanel-_backIcon-true__backIconTrailingPadding,16px)}.mds-slide-in-panel__icon-button--back .mds-slide-in-panel__icon svg{height:var(--MdsSlideInPanel-_backIcon-true__backIconHeight,20px);width:var(--MdsSlideInPanel-_backIcon-true__backIconWidth,20px);fill:var(--MdsSlideInPanel-_backIcon-true__backIconColor,#565a5d)}.mds-slide-in-panel__main{background-color:var(--MdsSlideInPanel__panelBackgroundColor,#fff);max-width:var(--MdsSlideInPanel__widthTypeFullWidth,100%)}.mds-slide-in-panel__main-content{display:flex;flex-direction:column}.mds-slide-in-panel__main-content_wrapper{padding:var(--MdsSlideInPanel__contentPadding,16px)}@media (min-width:768px){.mds-slide-in-panel--small .mds-slide-in-panel__panel-container{max-width:var(--MdsSlideInPanel-_widthType-small__panelWidth,768px)}.mds-slide-in-panel--small .mds-slide-in-panel__main,.mds-slide-in-panel--small .mds-slide-in-panel__sticky-footer{max-width:var(--MdsSlideInPanel-_widthType-small__panellWidth,768px)}.mds-slide-in-panel--slide-out .mds-slide-in-panel__panel-container{right:calc(var(--MdsSlideInPanel-_widthType-small__panellWidth, 768px)*-1)}}@media (min-width:0){.mds-slide-in-panel--extraSmall .mds-slide-in-panel__main,.mds-slide-in-panel--extraSmall .mds-slide-in-panel__panel-container,.mds-slide-in-panel--extraSmall .mds-slide-in-panel__sticky-footer{max-width:var(--MdsSlideInPanel-_widthType-extraSmall__panelWidth,375px)}.mds-slide-in-panel--slide-out .mds-slide-in-panel__panel-container{right:calc(var(--MdsSlideInPanel-_widthType-extraSmall__panelWidth, 375px)*-1)}.mds-slide-in-panel__heading{font-size:var(--MdsSlideInPanel__titleTextSize,1.125rem);line-height:var(--MdsSlideInPanel__titleLineHeight,1.75rem)}.mds-slide-in-panel__heading--with-subtitle{font-size:var(--MdsSlideInPanel-_subtitle-true__titleTextSize,.875rem);line-height:var(--MdsSlideInPanel-_subtitle-true__titleLineHeight,1.25rem)}.mds-slide-in-panel__main-content_wrapper{padding:var(--MdsSlideInPanel__contentPadding,16px)}}@media (min-width:768px){.mds-slide-in-panel--small .mds-slide-in-panel__main,.mds-slide-in-panel--small .mds-slide-in-panel__panel-container,.mds-slide-in-panel--small .mds-slide-in-panel__sticky-footer{max-width:var(--MdsSlideInPanel-_widthType-small__panelWidth,768px)}.mds-slide-in-panel--slide-out .mds-slide-in-panel__panel-container{right:calc(var(--MdsSlideInPanel-_widthType-extraSmall__panelWidth, 375px)*-1)}.mds-slide-in-panel__main-content_wrapper{padding:var(--MdsSlideInPanel__contentPaddingTablet,24px)}}@media (min-width:992px){.mds-slide-in-panel--large .mds-slide-in-panel__main,.mds-slide-in-panel--large .mds-slide-in-panel__panel-container,.mds-slide-in-panel--large .mds-slide-in-panel__sticky-footer{max-width:var(--MdsSlideInPanel-_widthType-large__panelWidth,996px)}.mds-slide-in-panel--large--slide-out .mds-slide-in-panel__panel-container{right:calc(var(--MdsSlideInPanel-_widthType-large__panelWidth, 996px)*-1)}}@media print{.mds-slide-in-panel,.mds-slide-in-panel *{overflow:visible!important;top:0!important}.mds-slide-in-panel__panel-container{display:block!important;max-width:100%!important;width:100%!important}.mds-slide-in-panel__header-container{position:relative!important;top:0!important}}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/slider/mds-slider.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ':host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .slider__accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .slider__tick-labels{display:flex;justify-content:space-between;padding-left:1rem;padding-right:.5rem;font-size:var(--MdsSlider__rangeLabelTextColor,.75rem);line-height:var(--MdsSlider__rangeLabelTextLineHeight,1rem);font-weight:var(--MdsSlider__rangeLabelTextWeight,400)}:host .slider__tick-label{width:1rem;margin-left:.1875rem}:host .slider__tick-label:not(:first-child){text-align:center;padding-left:0;width:1.5rem}:host .slider__track-container{height:var(--MdsSlider__trackContainerHeight,24px);display:flex;flex-direction:column;justify-content:center;position:relative}:host .slider__track-container--range{height:24px}:host .slider__progress-bar{z-index:1;background:transparent;border:.00625rem solid transparent;height:var(--MdsSlider__trackHeight,4px);display:block;margin-left:0;margin-right:0;width:100%;position:absolute;top:8px;left:0;border-radius:var(--MdsSlider__trackBorderRadius,2px);background-color:var(--MdsSlider__selectedTrackColor,#005eb8);border:.0625rem solid var(--MdsSlider__selectedTrackColor,#005eb8)}:host .slider__progress-bar.slider__range{position:absolute}:host .slider__progress-bar:focus{outline:none}:host .slider__input{-webkit-appearance:none;z-index:1;background:transparent;border:.00625rem solid transparent;height:var(--MdsSlider__trackHeight,4px);display:block;margin-left:0;margin-right:0;width:100%}:host .slider__input.slider__range{position:absolute}:host .slider__input:focus{outline:none}:host .slider__input::-moz-range-track{visibility:hidden}:host .slider__input::-moz-focus-outer{border:0}:host .slider__range-textInput-container{display:flex}:host .slider--segment .slider__track-container{position:relative;width:100%;bottom:.125rem}:host .slider--segment .slider__track-container .slider__input{width:inherit;position:absolute;border:0}:host .slider--segment .slider__range-container{margin-top:var(--MdsSlider__trackBorderRadius,2px);display:flex;justify-content:space-around;position:absolute;height:var(--MdsSlider__trackHeight,4px)}:host .slider--segment .slider__range-container .slider__track-segment,:host .slider--segment .slider__range-container .slider__track-segment--selected{flex-grow:1;height:var(--MdsSlider__trackHeight,4px)}:host .slider--segment .slider__range-container .slider__track-tick{height:var(--MdsSlider__tickmarkHeight,4px);width:var(--MdsSlider__tickmarkWidth,4px)}:host .slider--segment .slider__segment-container{margin-top:var(--MdsSlider__trackBorderRadius,2px);width:100%;display:flex;justify-content:space-around;position:absolute;height:var(--MdsSlider__trackHeight,4px)}:host .slider--segment .slider__segment-container .slider__track-segment,:host .slider--segment .slider__segment-container .slider__track-segment--selected{flex-grow:1;height:var(--MdsSlider__trackHeight,4px)}:host .slider--segment .slider__segment-container .slider__track-tick{height:var(--MdsSlider__tickmarkHeight,4px);width:var(--MdsSlider__tickmarkWidth,4px);margin-left:calc(var(--MdsSlider__tickmarkWidth, 4px)/2)}:host .slider--segment .slider__segment-container .slider__track-tick:not(:first-child){width:var(--MdsSlider__tickmarkWidth,4px);margin-left:0}:host .slider--segment .slider__segment-container .slider__track-tick--selected{height:var(--MdsSlider__tickmarkHeight,4px);width:calc(var(--MdsSlider__tickmarkWidth, 4px) + var(--MdsSlider__tickmarkWidth, 4px)/2)}:host .slider--segment .slider__segment-container .slider__track-tick--selected:not(:first-child){width:var(--MdsSlider__tickmarkWidth,4px)}:host .slider__pseudo-track{position:relative;height:var(--MdsSlider__trackHeight,4px);border-radius:var(--MdsSlider__trackBorderRadius,2px);width:100%;bottom:calc(var(--MdsSlider__trackHeight, 4px) + var(--MdsSlider__trackHeight, 4px)/2)}:host .slider--range{font-size:var(--MdsSlider__rangeLabelTextColor,.75rem);line-height:var(--MdsSlider__rangeLabelTextLineHeight,1rem);font-weight:var(--MdsSlider__rangeLabelTextWeight,400)}:host .slider--range .mds-slider__label-container{height:var(--MdsSlider__rangeLabelTextHeight,)}:host .slider--range .slider__pseudo-track{bottom:var(--MdsSlider__trackHeight,4px)}:host .slider__label-container{padding-bottom:var(--MdsSlider__sliderLabelBottomPadding,6px);font-size:var(--MdsSlider__sliderLabelTextSize,1rem);line-height:var(--MdsSlider__sliderLabelTextLineHeight,1.5rem);font-weight:var(--MdsSlider__sliderLabelTextWeight,400);text-align:var(--MdsSlider__sliderLabelTextAlignment,center);word-break:break-word}:host .slider__label-value{font-size:var(--MdsSlider__selectedValuesLabelTextSize,1rem);line-height:var(--MdsSlider__selectedValuesLabelTextLineHeight,1.5rem);font-weight:var(--MdsSlider__selectedValuesLabelTextWeight,600);text-align:var(--MdsSlider__selectedValuesLabelTextAlignment,center)}:host .slider__microcopy{font-size:var(--MdsSlider__microcopyTextSize,.75rem);line-height:var(--MdsSlider__microcopyTextLineHeight,1rem);font-weight:var(--MdsSlider__microcopyTextWeight,400);text-align:var(--MdsSlider__microcopyTextAlignment,center)}:host .slider__data-value-container{display:flex;justify-content:center}:host .slider__data-value-container .slider__input-container{display:flex;flex-direction:column;justify-content:space-around;height:auto;padding-left:var(--MdsSlider__trackLeadingPadding,16px);padding-right:var(--MdsSlider__trackTrailingPadding,16px);align-self:flex-start}:host .slider__data-value-container .slider__input-container--range{position:relative}:host .slider__data-value-container .slider__input-container .slider__single{border-radius:var(--MdsSlider__trackBorderRadius,2px)}:host .slider__data-value-container .slider__input-container .slider__range{width:100%}:host .slider__data-value-container .slider__data-value{display:flex;min-height:1.25rem;font-size:var(--MdsSlider__leadingTrailingLabelTextSize,.875rem);line-height:var(--MdsSlider__leadingTrailingLabelTextLineHeight,1.25rem);font-weight:var(--MdsSlider__leadingTrailingLabelTextWeight,400);text-align:var(--MdsSlider__leadingTrailingLabelTextAlignment,left)}:host .slider__data-value-container .slider__data-value--min{display:flex;justify-content:flex-end}:host .slider__data-value-container .slider__data-value--min .slider__leading-trailing-label{text-align:left}:host .slider__data-value-container .slider__data-value .slider__leading-trailing-label{display:flex;align-items:flex-start}:host .slider__data-value-container .slider__data-value .slider__label-icon-container{display:flex;padding-left:var(--MdsSlider__leadingTrailingIconTopPadding,2px)}:host .slider__data-value-container .slider__data-value .slider__icon{display:flex;flex-direction:column;justify-content:center;text-align:center}:host .slider__data-value-container .slider__data-value .slider__icon svg{width:var(--MdsSlider__leadingTrailingIconWidth,20px);height:var(--MdsSlider__leadingTrailingIconHeight,20px)}:host .slider__data-value-container .slider__data-value .slider__input-container--range .slider__range-container{height:1rem}:host .slider__pseudo-range{height:var(--MdsSlider__trackHeight,4px);position:relative;z-index:1}:host .slider__pseudo-range--disabled{visibility:hidden}:host .slider__pseudo-thumb{width:var(--MdsSlider_thumb__defaultWidth,18px);height:var(--MdsSlider_thumb__defaultHeight,18px);border-radius:var(--MdsSlider_thumb__circleRadius,9px);z-index:1;background:var(--MdsSlider_thumb__circleColor,#005eb8);border-color:var(--MdsSlider_thumb__borderColor,transparent);position:absolute;right:0;top:.0625rem}:host .slider__pseudo-thumb:hover{background:var(--MdsSlider_thumb__circleColor--hovered,#004692);border-radius:var(--MdsSlider_thumb__circleRadius--hovered,12px)}:host .slider__pseudo-thumb:active,:host .slider__pseudo-thumb:hover{width:var(--MdsSlider_thumb__width,24px);height:var(--MdsSlider_thumb__height,24px)}:host .slider__pseudo-thumb:active{background:var(--MdsSlider_thumb__circleColor--pressed,#0091da);border-radius:var(--MdsSlider_thumb__circleRadius--pressed,12px);top:-.0625rem;border:0}:host .slider__pseudo-thumb:hover{top:-.0625rem}:host .slider__pseudo-thumb--focus{outline:.0625rem dotted #717171}:host .slider__pseudo-thumb--intervals{top:var(--MdsSlider__trackHeight,4px)}:host .slider__label-name{word-break:break-word}@-moz-document url-prefix(""){:host .slider::-moz-range-track{visibility:hidden}:host .slider::-moz-focus-outer{border:0}:host .slider .slider__tick-labels{padding-left:1.5rem;padding-right:.5rem}:host .slider .slider__tick-label{margin-left:.375rem;width:.5rem}:host .slider .slider__tick-label:not(:first-child){margin-left:0;width:1.25rem}:host .slider .slider__segment-container{padding-left:.5rem}}:host .slider--editable .slider__label-container,:host .slider--editable .slider__label-name{word-break:break-word}:host .slider--editable .slider__label-value{width:100%}:host .slider--editable .slider__editable{height:1.5rem;border:0;border-bottom:.0625rem solid;text-align:right;font-size:var(--MdsSlider__selectedValuesLabelTextSize,1rem);line-height:var(--MdsSlider__selectedValuesLabelTextLineHeight,1.5rem);outline:none}:host .slider--editable .slider__editable-container{display:flex}:host .slider--editable .slider__editable:focus{outline:.0625rem dashed #717171}:host .slider--editable .slider__editable-webkit-outer-spin-button,:host .slider--editable .slider__editable::-webkit-inner-spin-button{opacity:1;width:1rem;margin:0;padding:0}:host .slider--editable .slider__editable-suffix{white-space:nowrap}:host .slider__editable-alert{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .slider--narrow .slider__track-container{bottom:0}:host .slider--narrow .slider__label-name{font-size:var(--MdsSlider__sliderLabelTextSize,1rem);line-height:var(--MdsSlider__sliderLabelTextLineHeight,1.5rem);font-weight:var(--MdsSlider__sliderLabelTextWeight,400);text-align:right;word-break:break-word}:host .slider--narrow .slider__label-value{padding-top:var(--MdsSlider__leadingTrailingLabelTopPadding,2px)}:host .slider--narrow .slider__editable,:host .slider--narrow .slider__label-value{font-size:var(--MdsSlider__leadingTrailingLabelTextSize,.875rem);line-height:var(--MdsSlider__leadingTrailingLabelTextLineHeight,1.25rem);font-weight:var(--MdsSlider__leadingTrailingLabelTextWeight,400)}:host .slider--narrow .slider__editable{height:var(--MdsSlider__editableInputHeight,24px)}.slider__tick-labels{color:var(--MdsSlider__rangeLabelTextColor,#565a5d)}.slider__label-container{color:var(--MdsSlider__sliderLabelTextColor,#565a5d)}.slider__label-value{color:var(--MdsSlider__selectedValuesLabelTextColor,#565a5d)}.slider__progress-bar{background-color:var(--MdsSlider__selectedTrackColor,#005eb8);border:.0625rem solid var(--MdsSlider__selectedTrackColor,#005eb8)}.slider__microcopy{color:var(--MdsSlider__microcopyTextColor,#565a5d)}.slider__data-value-container .slider__data-value{color:var(--MdsSlider__leadingTrailingLabelTextColor,#565a5d)}.slider__data-value-container .slider__icon svg{fill:var(--MdsSlider__leadingTrailingIconColor,#565a5d)}.slider .slider__range{height:var(--MdsSlider__trackHeight,4px)}.slider .slider__range::-webkit-slider-thumb{display:none}.slider .slider__range::-moz-range-thumb{display:none;border:0;background:transparent}.slider__pseudo-range--activated{background-color:var(--MdsSlider__selectedTrackColor,#005eb8)}.slider__pseudo-track{background-color:var(--MdsSlider__unselectedTrackColor,#565a5d)}.slider__pseudo-thumb{background:var(--MdsSlider_thumb__circleColor,#005eb8);border-color:var(--MdsSlider_thumb__borderColor,transparent)}.slider__pseudo-thumb:active:not(.slider__pseudo-thumb--disabled){background:var(--MdsSlider_thumb__circleColor--pressed,#0091da)}.slider__pseudo-thumb:hover{background:var(--MdsSlider_thumb__circleColor--hovered,#004692)}.slider--segment .slider__segment-container .slider__track-tick{background-color:var(--MdsSlider__unselectedTickmarkColor,#c1c3c3)}.slider--segment .slider__segment-container .slider__track-tick--selected{background-color:var(--MdsSlider__selectedTickmarkColor,)}.slider--segment .slider__pseudo-range,.slider--segment .slider__pseudo-track{background-color:transparent}.slider--segment .slider__pseudo-thumb{top:var(--MdsSlider__trackHeight,4px)}.slider--segment .slider__pseudo-thumb:hover{top:calc(var(--MdsSlider__trackHeight, 4px)/2)}.slider--segment .slider__pseudo-thumb:active{top:2px;top:calc(var(--MdsSlider__trackHeight, 4px)/2)}.slider--narrow .slider__label-name{color:var(--MdsSlider__sliderLabelTextColor,#565a5d)}.slider--narrow .slider__editable,.slider--narrow .slider__label-value{color:var(--MdsSlider__leadingTrailingLabelTextColor,#565a5d)}.slider .slider__single::-webkit-slider-thumb{-webkit-appearance:none;display:none}.slider .slider__single::-moz-range-thumb{visibility:hidden}.slider .slider__segment-container .slider__track-segment{background-color:var(--MdsSlider__unselectedTrackColor,#565a5d);border:.0625rem solid var(--MdsSlider__unselectedTrackColor,#565a5d)}.slider .slider__segment-container .slider__track-segment--selected{background-color:var(--MdsSlider__selectedTrackColor,#005eb8);border:.0625rem solid var(--MdsSlider__selectedTrackColor,#005eb8)}.slider--editable .slider__editable{color:var(--MdsSlider__selectedValuesLabelTextColor,#565a5d);border-bottom:.0625rem solid var(--MdsSlider__editableInputBorderColor,#565a5d)}.slider--disabled .slider__input::-webkit-slider-thumb{background:var(--MdsSlider_thumb__circleColor--disabled,#e2e4e5);border:var(--MdsSlider_thumb__borderWidth--disabled,2px) solid var(--MdsSlider_thumb__borderColor--disabled,#fff);border-radius:var(--MdsSlider_thumb__circleRadius--hovered,12px)}.slider--disabled .slider__input::-webkit-slider-thumb:active,.slider--disabled .slider__input::-webkit-slider-thumb:hover{background:var(--MdsSlider_thumb__circleColor--disabled,#e2e4e5);border-radius:var(--MdsSlider_thumb__circleRadius--hovered,12px);width:var(--MdsSlider_thumb__defaultWidth,18px);height:var(--MdsSlider_thumb__defaultHeight,18px)}.slider--disabled .slider__input::-moz-range-thumb{background:var(--MdsSlider_thumb__circleColor--disabled,#e2e4e5);border:var(--MdsSlider_thumb__borderWidth--disabled,2px) solid var(--MdsSlider_thumb__borderColor--disabled,#fff);border-radius:var(--MdsSlider_thumb__circleRadius--hovered,12px)}.slider--disabled .slider__input::-moz-range-thumb:active,.slider--disabled .slider__input::-moz-range-thumb:hover{background:var(--MdsSlider_thumb__circleColor--disabled,#e2e4e5);border-radius:var(--MdsSlider_thumb__circleRadius--hovered,12px);width:var(--MdsSlider_thumb__defaultWidth,18px);height:var(--MdsSlider_thumb__defaultHeight,18px)}.slider--disabled .slider__pseudo-thumb{background:var(--MdsSlider_thumb__circleColor--disabled,#e2e4e5);border:var(--MdsSlider_thumb__borderWidth--disabled,2px) solid var(--MdsSlider_thumb__borderColor--disabled,#fff);border-radius:var(--MdsSlider_thumb__circleRadius--hovered,12px)}.slider--disabled .slider__pseudo-thumb:active,.slider--disabled .slider__pseudo-thumb:hover{background:var(--MdsSlider_thumb__circleColor--disabled,#e2e4e5);border-radius:var(--MdsSlider_thumb__circleRadius--hovered,12px);width:var(--MdsSlider_thumb__defaultWidth,18px);height:var(--MdsSlider_thumb__defaultHeight,18px)}.slider--disabled .slider__pseudo-thumb:hover{top:.3125rem}.slider--disabled .slider__pseudo-thumb:active{top:.3125rem;border:var(--MdsSlider_thumb__borderWidth--disabled,2px) solid var(--MdsSlider_thumb__borderColor--disabled,#fff)}.slider--disabled .slider__pseudo-thumb--focus{outline:none}.slider--disabled .slider__segment-container .slider__track-segment{background-color:var(--MdsSlider__unselectedTrackColor--disabled,#eceff1);border:.0625rem solid var(--MdsSlider__unselectedTrackColor--disabled,#eceff1)}.slider--disabled .slider__segment-container .slider__track-segment--selected{background-color:var(--MdsSlider__selectedTrackColor--disabled,#565a5d);border:.0625rem solid var(--MdsSlider__selectedTrackColor--disabled,#565a5d)}.slider--disabled .slider__segment-container .slider__track-tick{background-color:var(--MdsSlider__unselectedTickmarkColor,#c1c3c3)}.slider--disabled .slider__segment-container .slider__track-tick--selected{background-color:var(--MdsSlider__selectedTickmarkColor,#fff)}', "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/status-block/mds-status-block.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .status-block{display:flex;flex-direction:column;max-height:var(--MdsStatusBlock__statusBlockMaxHeight,80px);background-color:var(--MdsStatusBlock__statusBlockBackgroundColor,#f5f7f8);box-shadow:var(--MdsStatusBlock__statusBlockShadowHorizontalOffset,0) var(--MdsStatusBlock__statusBlockBoxShadowVerticalOffset,1px) var(--MdsStatusBlock__statusBlockBoxShadowBlurRadius,2px) var(--MdsStatusBlock__statusBlockBoxShadowColor,rgba(0,0,0,.4))}@keyframes top-bar-animation{0%{transform:translateX(calc(var(--MdsStatusBlock__barAnimationPositionStart, -1)*100%))}to{transform:translateX(calc(var(--MdsStatusBlock__barAnimationPositionEnd, 2)*100%))}}@keyframes top-bar-opacity{0%{opacity:1}to{opacity:0}}:host .status-block__top-bar{z-index:1;min-height:var(--MdsStatusBlock__barHeight,4px);overflow:hidden;background:var(--MdsStatusBlock__barBackgroundColor,#005eb8)}:host .status-block__top-bar-animating{z-index:2;min-height:var(--MdsStatusBlock__barHeight,4px);width:100%;background:linear-gradient(90deg,var(--MdsStatusBlock__barGradientColorStart,transparent),var(--MdsStatusBlock__barGradientColorCenter,#0091da),var(--MdsStatusBlock__barGradientColorEnd,transparent));animation:top-bar-animation var(--MdsStatusBlock__barAnimationTime,2s) var(--MdsStatusBlock__barAnimationEase,cubic-bezier(0,.2,.1,1)) 0s 2 forwards,top-bar-opacity 0s var(--MdsStatusBlock__barAnimationEase,cubic-bezier(0,.2,.1,1)) 4s forwards}:host .status-block__message{display:inline}:host .status-block__content-container{display:inline-flex;justify-content:space-between;align-items:center;margin:var(--MdsStatusBlock__statusBlockTopPadding,16px)}:host .status-block__message-container{overflow:auto;max-height:calc(var(--MdsStatusBlock__statusBlockMaxHeight, 80px)/2);font-weight:var(--MdsStatusBlock__messageTextWeight,600);line-height:var(--MdsStatusBlock__messageLineHeight,1rem);font-size:var(--MdsStatusBlock__messageTextSize,.75rem);margin:calc(var(--MdsStatusBlock__statusBlockTopPadding, 16px) - var(--MdsStatusBlock__barHeight, 4px)) var(--MdsStatusBlock__statusBlockTrailingPadding,16px) var(--MdsStatusBlock__statusBlockBotttomPadding,) var(--MdsStatusBlock__statusBlockLeadingPadding,16px);color:var(--MdsStatusBlock__messageTextColor,#101820)}:host .status-block__avatar{display:flex;justify-content:center;align-items:center;margin-left:var(--MdsStatusBlock__statusBlockTopPadding,16px)}:host .status-block__avatar-img{border-radius:50%;height:var(--MdsStatusBlock__avatarHeight,48px);width:var(--MdsStatusBlock__avatarWidth,48px)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/status-tracker/expandable-step/mds-expandable-step.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif;display:flex}:host .expandable-text,:host .expandable-text-container{width:100%}:host .expandable-text-button{display:inline-flex;align-items:baseline;color:var(--MdsExpandableText__labelTextColor,#005eb8)}:host .expandable-text-button--regular{color:var(--MdsExpandableText-_textColor-textColorRegular__labelTextColor,#101820)}:host .expandable-text-button--disabled{color:var(--MdsExpandableText__labelTextColor--disabled,#565a5d);cursor:unset}:host .expandable-text-button--disabled .expandable-text-icon svg{fill:var(--MdsExpandableText__iconColor--disabled,#c1c3c3)}:host .expandable-text-leading-text-content{padding-right:.25em}:host .expandable-text-revealed-content-container{display:none;z-index:1;opacity:0;overflow:hidden;transition-property:height;transition-duration:.2s;transition-timing-function:cubic-bezier(0,.2,.1,1)}:host .expandable-text-revealed-content-container--expanded{opacity:1}:host .expandable-text-revealed-content-container--collapsing{animation-name:panel-opacity;animation-duration:.2s;animation-delay:0s;animation-timing-function:cubic-bezier(0,.2,.1,1);animation-fill-mode:forwards}@keyframes panel-opacity{0%{opacity:1}to{opacity:0}}:host .expandable-text-revealed-content-container--transitioned{opacity:1}:host .expandable-text-icon{margin-right:var(--MdsExpandableText__iconTrailingMargin,4px);transform:translateY(.125em)}:host .expandable-text-icon--expanded{transform:rotate(90deg)}:host .expandable-text-icon svg{height:1em;width:1em;fill:var(--MdsExpandableText__iconColor,#005eb8)}:host .expandable-text-button{display:flex;justify-content:center;box-sizing:border-box;text-align:center;align-items:flex-start;white-space:pre-wrap;word-break:break-word;vertical-align:middle;font:inherit;cursor:pointer;background-color:transparent;outline:none;border:0;padding:.125em 0;transform:translateY(.125em)}:host .expandable-text-button:focus{outline:.0625rem dashed #717171}:host .expandable-text-button::-moz-focus-inner{border:0}:host .expandable-text-label{display:inline-block;white-space:pre-wrap;word-break:normal;text-align:left}:host .expandable-text-icon{line-height:0;margin-top:.125rem}:host .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/status-tracker/mds-status-tracker.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .mds-status-tracker{display:flex;flex-direction:row;height:100%}:host .mds-status-tracker .mds-status-tracker__icon{display:flex;flex-direction:column;justify-content:center;align-items:center}:host .mds-status-tracker .mds-status-tracker__icon svg{height:var(--MdsStatusTracker_step-_status-completed__iconHeightPhone,16px);width:var(--MdsStatusTracker_step-_status-completed__iconWidthPhone,16px)}:host .mds-status-tracker .mds-status-tracker__circle{width:var(--MdsStatusTracker_step__circleWidthPhone,20px);height:var(--MdsStatusTracker_step__circleHeightPhone,20px);display:flex;justify-content:center;align-items:center}:host .mds-status-tracker .mds-status-tracker__list-circles-lines{display:flex;flex-direction:column;width:auto}:host .mds-status-tracker .mds-status-tracker__step{height:100%;list-style:none;display:flex;flex-direction:row;align-items:flex-start}:host .mds-status-tracker .mds-status-tracker__step:last-child{align-self:flex-start;height:auto}:host .mds-status-tracker .mds-status-tracker__line{display:flex;width:.0625rem;height:100%}:host .mds-status-tracker .mds-status-tracker__line--completed{border-left-style:var(--MdsStatusTracker_step-_status-completed__lineStyle,solid);border-left-width:var(--MdsStatusTracker_step__lineThickness,2px)}:host .mds-status-tracker .mds-status-tracker__line--inprogress,:host .mds-status-tracker .mds-status-tracker__line--upcoming{border-left-style:var(--MdsStatusTracker_step-_status-upcoming__lineStyle,dashed);border-left-width:var(--MdsStatusTracker_step__lineThickness,2px)}:host .mds-status-tracker .mds-status-tracker--layout-vertical .mds-status-tracker__list-labels{height:100%}:host .mds-status-tracker .mds-status-tracker--layout-vertical .mds-status-tracker__list-item .mds-status-tracker__label{justify-content:center}:host .mds-status-tracker .mds-status-tracker--layout-vertical .mds-status-tracker__list-item:last-child{justify-content:flex-end}:host .mds-status-tracker .mds-status-tracker--layout-vertical .mds-status-tracker__list-item:last-child .mds-status-tracker__label{justify-content:flex-end;align-items:flex-end}:host .mds-status-tracker .mds-status-tracker--layout-vertical .mds-status-tracker__list-item:first-child,:host .mds-status-tracker .mds-status-tracker--layout-vertical .mds-status-tracker__list-item:first-child .mds-status-tracker__label{justify-content:flex-start;align-items:flex-start}:host .mds-status-tracker .mds-status-tracker--layout-vertical .mds-status-tracker__line__line{min-height:var(--MdsStatusTracker_step__lineMinHeight,24px)}:host .mds-status-tracker .mds-status-tracker__list-item{display:flex;flex-direction:column;justify-content:center}:host .mds-status-tracker .mds-status-tracker__list-item:not(:first-child):not(:last-child){padding-left:.5rem;padding-right:.5rem}:host .mds-status-tracker .mds-status-tracker__list-item .mds-status-tracker__label{align-items:center;justify-content:flex-start}:host .mds-status-tracker .mds-status-tracker__list-item:first-child{text-align:left;justify-content:flex-start;padding-right:.5rem}:host .mds-status-tracker .mds-status-tracker__list-item:first-child .mds-status-tracker__label{align-items:flex-start}@media (min-width:767px){:host .mds-status-tracker .mds-status-tracker__list-item:first-child .mds-status-tracker__label{padding-top:var(--MdsStatusTracker-_layout-vertical__firstStepTopPaddingDesktop,4px)}}:host .mds-status-tracker .mds-status-tracker__list-item:last-child{justify-content:flex-end;padding-left:.5rem}:host .mds-status-tracker .mds-status-tracker__list-item:last-child .mds-status-tracker__label{align-items:flex-end}@media (min-width:767px){:host .mds-status-tracker .mds-status-tracker__list-item:last-child .mds-status-tracker__label{padding-bottom:var(--MdsStatusTracker-_layout-vertical__lastStepBottomPaddingDesktop,4px)}}:host .mds-status-tracker .mds-status-tracker__label{font-size:var(--MdsStatusTracker_step__labelTextSize,.875rem);line-height:var(--MdsStatusTracker_step__labelLineHeight,1.25rem);font-weight:var(--MdsStatusTracker_step__labelTextWeight,400)}:host .mds-status-tracker .mds-status-tracker__label--inprogress{font-weight:var(--MdsStatusTracker_step-_status-inProgress__labelTextWeight,600)}:host .mds-status-tracker .mds-status-tracker__list-labels{margin-top:0;list-style-type:none;-webkit-margin-before:0;margin-block-start:0;-webkit-margin-after:0;margin-block-end:0;-webkit-margin-start:0;margin-inline-start:0;-webkit-margin-end:0;margin-inline-end:0;-webkit-padding-start:0;padding-inline-start:0;display:flex;flex-direction:column;align-items:flex-start;padding-left:var(--MdsStatusTracker-_layout-vertical__stepLabelLeadingPadding,8px);text-align:var(--MdsStatusTracker-_layout-vertical__stepLabelTextAlignment,left)}:host .mds-status-tracker .mds-status-tracker__decoration{display:flex;flex-direction:column;justify-content:flex-start;align-items:center;height:100%;width:auto}:host .mds-status-tracker__circle{width:var(--MdsStatusTracker_step__circleWidth,28px);height:var(--MdsStatusTracker_step__circleHeight,28px);border-width:var(--MdsStatusTracker_step__circleBorderThickness,2px);border-style:solid;border-radius:50%;flex-shrink:0}:host .mds-status-tracker__3-step-list .mds-status-tracker__list-item{flex-basis:calc(25% + var(--MdsStatusTracker_step__circleWidthPhone, 20px))}:host .mds-status-tracker__3-step-list .mds-status-tracker__list-item:not(:first-child):not(:last-child){flex-basis:calc(50% + var(--MdsStatusTracker_step__circleWidthPhone, 20px))}:host .mds-status-tracker__4-step-list .mds-status-tracker__list-item{flex-basis:calc(16.66667% + var(--MdsStatusTracker_step__circleWidthPhone, 20px))}:host .mds-status-tracker__4-step-list .mds-status-tracker__list-item:not(:first-child):not(:last-child){flex-basis:calc(33.33333% + var(--MdsStatusTracker_step__circleWidthPhone, 20px))}:host .mds-status-tracker__5-step-list .mds-status-tracker__list-item{flex-basis:calc(12.5% + var(--MdsStatusTracker_step__circleWidthPhone, 20px))}:host .mds-status-tracker__5-step-list .mds-status-tracker__list-item:not(:first-child):not(:last-child){flex-basis:calc(25% + var(--MdsStatusTracker_step__circleWidthPhone, 20px))}:host .mds-status-tracker__3-step-list .mds-status-tracker__step{flex-grow:1}:host .mds-status-tracker__3-step-list .mds-status-tracker__step:last-child{flex-grow:0}:host .mds-status-tracker__3-step-list .mds-status-tracker__list-item{flex-basis:calc(25% + var(--MdsStatusTracker_step__circleWidth, 28px))}:host .mds-status-tracker__3-step-list .mds-status-tracker__list-item:not(:first-child):not(:last-child){flex-basis:calc(50% + var(--MdsStatusTracker_step__circleWidth, 28px))}:host .mds-status-tracker__3-step-list .mds-status-tracker__list-item:first-child .mds-status-tracker__label{padding-top:0}:host .mds-status-tracker__3-step-list .mds-status-tracker__list-item:last-child .mds-status-tracker__label{padding-bottom:0}:host .mds-status-tracker__4-step-list .mds-status-tracker__step{flex-grow:1}:host .mds-status-tracker__4-step-list .mds-status-tracker__step:last-child{flex-grow:0}:host .mds-status-tracker__4-step-list .mds-status-tracker__list-item{flex-basis:calc(16.66667% + var(--MdsStatusTracker_step__circleWidth, 28px))}:host .mds-status-tracker__4-step-list .mds-status-tracker__list-item:not(:first-child):not(:last-child){flex-basis:calc(33.33333% + var(--MdsStatusTracker_step__circleWidth, 28px))}:host .mds-status-tracker__4-step-list .mds-status-tracker__list-item:first-child .mds-status-tracker__label{padding-top:0}:host .mds-status-tracker__4-step-list .mds-status-tracker__list-item:last-child .mds-status-tracker__label{padding-bottom:0}:host .mds-status-tracker__5-step-list .mds-status-tracker__step{flex-grow:1}:host .mds-status-tracker__5-step-list .mds-status-tracker__step:last-child{flex-grow:0}:host .mds-status-tracker__5-step-list .mds-status-tracker__list-item{flex-basis:calc(12.5% + var(--MdsStatusTracker_step__circleWidth, 28px))}:host .mds-status-tracker__5-step-list .mds-status-tracker__list-item:not(:first-child):not(:last-child){flex-basis:calc(25% + var(--MdsStatusTracker_step__circleWidth, 28px))}:host .mds-status-tracker__5-step-list .mds-status-tracker__list-item:first-child .mds-status-tracker__label{padding-top:0}:host .mds-status-tracker__5-step-list .mds-status-tracker__list-item:last-child .mds-status-tracker__label{padding-bottom:0}:host .mds-status-tracker__step .mds-status-tracker__vertical-label{padding-left:var(--MdsStatusTracker-_layout-vertical__stepLabelLeadingPadding,8px);margin-top:-.125rem}@media screen and (min-width:768px){:host .mds-status-tracker__step .mds-status-tracker__vertical-label{margin-top:.125rem}}:host .mds-status-tracker__step:not(:last-child) .mds-status-tracker__vertical-label{padding-bottom:var(--MdsStatusTracker_step__labelPaddingBottom,20px)}@media (min-width:767px){:host .mds-status-tracker{display:flex;flex-direction:column}:host .mds-status-tracker .mds-status-tracker__icon{height:var(--MdsStatusTracker_step__circleHeight,28px);width:var(--MdsStatusTracker_step__circleWidth,28px);display:flex;justify-content:center;align-items:center;border-width:.125rem;border-style:solid;box-sizing:border-box;border-radius:50%}:host .mds-status-tracker .mds-status-tracker__icon svg{height:var(--MdsStatusTracker_step-_status-completed__iconHeight,24px);width:var(--MdsStatusTracker_step-_status-completed__iconWidth,24px)}:host .mds-status-tracker .mds-status-tracker__circle{display:flex;flex-direction:row;justify-content:center;align-content:center;height:var(--MdsStatusTracker_step__circleHeight,28px);width:var(--MdsStatusTracker_step__circleWidth,28px)}:host .mds-status-tracker .mds-status-tracker__step{display:flex;flex-direction:column}:host .mds-status-tracker .mds-status-tracker__decoration{display:flex;flex-direction:row;align-items:center;width:100%;height:auto}:host .mds-status-tracker .mds-status-tracker__line{width:100%;height:.0625rem}:host .mds-status-tracker .mds-status-tracker__line--completed{height:.0625rem;border-left:0;border-bottom-style:var(--MdsStatusTracker_step-_status-completed__lineStyle,solid);border-bottom-width:var(--MdsStatusTracker_step__lineThickness,2px)}:host .mds-status-tracker .mds-status-tracker__line--inprogress,:host .mds-status-tracker .mds-status-tracker__line--upcoming{height:.0625rem;border-left:0;border-bottom-style:var(--MdsStatusTracker_step-_status-upcoming__lineStyle,dashed);border-bottom-width:var(--MdsStatusTracker_step__lineThickness,2px)}:host .mds-status-tracker .mds-status-tracker__list-circles-lines{display:flex;flex-direction:row;height:auto}:host .mds-status-tracker .mds-status-tracker__list-item{display:flex;flex-direction:row;height:100%;text-align:center}:host .mds-status-tracker .mds-status-tracker__list-item:first-child{text-align:start}:host .mds-status-tracker .mds-status-tracker__list-item:last-child{text-align:end}:host .mds-status-tracker .mds-status-tracker__list-labels{height:auto;display:inline-flex;flex-direction:row;padding-left:0;padding-top:4px}:host .mds-status-tracker .mds-status-tracker--layout-horizontal .mds-status-tracker__label{display:block;width:100%;text-align:center;padding-left:.5rem;padding-right:.5rem}:host .mds-status-tracker .mds-status-tracker--layout-horizontal .mds-status-tracker__list-item:first-child{text-align:left;padding-top:0;padding-left:0}:host .mds-status-tracker .mds-status-tracker--layout-horizontal .mds-status-tracker__list-item:last-child{text-align:right;padding-right:0}}:host .mds-status-tracker--layout-vertical{height:100%;flex-direction:row}:host .mds-status-tracker--layout-vertical .mds-status-tracker__list-circles-lines{display:flex;flex-direction:column;width:auto}:host .mds-status-tracker--layout-vertical .mds-status-tracker__step{height:100%;list-style:none;display:flex;flex-direction:row;align-items:flex-start}:host .mds-status-tracker--layout-vertical .mds-status-tracker__step:last-child{align-self:flex-start;height:auto}:host .mds-status-tracker--layout-vertical .mds-status-tracker__line{display:flex;width:.0625rem;height:100%}:host .mds-status-tracker--layout-vertical .mds-status-tracker__line--completed{border-left-style:var(--MdsStatusTracker_step-_status-completed__lineStyle,solid);border-left-width:var(--MdsStatusTracker_step__lineThickness,2px)}:host .mds-status-tracker--layout-vertical .mds-status-tracker__line--inprogress,:host .mds-status-tracker--layout-vertical .mds-status-tracker__line--upcoming{border-left-style:var(--MdsStatusTracker_step-_status-upcoming__lineStyle,dashed);border-left-width:var(--MdsStatusTracker_step__lineThickness,2px)}:host .mds-status-tracker--layout-vertical .mds-status-tracker--layout-vertical .mds-status-tracker__list-labels{height:100%}:host .mds-status-tracker--layout-vertical .mds-status-tracker--layout-vertical .mds-status-tracker__list-item .mds-status-tracker__label{justify-content:center}:host .mds-status-tracker--layout-vertical .mds-status-tracker--layout-vertical .mds-status-tracker__list-item:last-child{justify-content:flex-end}:host .mds-status-tracker--layout-vertical .mds-status-tracker--layout-vertical .mds-status-tracker__list-item:last-child .mds-status-tracker__label{justify-content:flex-end;align-items:flex-end}:host .mds-status-tracker--layout-vertical .mds-status-tracker--layout-vertical .mds-status-tracker__list-item:first-child,:host .mds-status-tracker--layout-vertical .mds-status-tracker--layout-vertical .mds-status-tracker__list-item:first-child .mds-status-tracker__label{justify-content:flex-start;align-items:flex-start}:host .mds-status-tracker--layout-vertical .mds-status-tracker--layout-vertical .mds-status-tracker__line__line{min-height:var(--MdsStatusTracker_step__lineMinHeight,24px)}:host .mds-status-tracker--layout-vertical .mds-status-tracker__list-item{display:flex;flex-direction:column;justify-content:center}:host .mds-status-tracker--layout-vertical .mds-status-tracker__list-item:not(:first-child):not(:last-child){padding-left:.5rem;padding-right:.5rem}:host .mds-status-tracker--layout-vertical .mds-status-tracker__list-item .mds-status-tracker__label{align-items:center;justify-content:flex-start}:host .mds-status-tracker--layout-vertical .mds-status-tracker__list-item:first-child{text-align:left;justify-content:flex-start;padding-right:.5rem}:host .mds-status-tracker--layout-vertical .mds-status-tracker__list-item:first-child .mds-status-tracker__label{align-items:flex-start}@media (min-width:767px){:host .mds-status-tracker--layout-vertical .mds-status-tracker__list-item:first-child .mds-status-tracker__label{padding-top:var(--MdsStatusTracker-_layout-vertical__firstStepTopPaddingDesktop,4px)}}:host .mds-status-tracker--layout-vertical .mds-status-tracker__list-item:last-child{justify-content:flex-end;padding-left:.5rem}:host .mds-status-tracker--layout-vertical .mds-status-tracker__list-item:last-child .mds-status-tracker__label{align-items:flex-end}@media (min-width:767px){:host .mds-status-tracker--layout-vertical .mds-status-tracker__list-item:last-child .mds-status-tracker__label{padding-bottom:var(--MdsStatusTracker-_layout-vertical__lastStepBottomPaddingDesktop,4px)}}:host .mds-status-tracker--layout-vertical .mds-status-tracker__label{font-size:var(--MdsStatusTracker_step__labelTextSize,.875rem);line-height:var(--MdsStatusTracker_step__labelLineHeight,1.25rem);font-weight:var(--MdsStatusTracker_step__labelTextWeight,400)}:host .mds-status-tracker--layout-vertical .mds-status-tracker__label--inprogress{font-weight:var(--MdsStatusTracker_step-_status-inProgress__labelTextWeight,600)}:host .mds-status-tracker--layout-vertical .mds-status-tracker__list-labels{margin-top:0;list-style-type:none;-webkit-margin-before:0;margin-block-start:0;-webkit-margin-after:0;margin-block-end:0;-webkit-margin-start:0;margin-inline-start:0;-webkit-margin-end:0;margin-inline-end:0;-webkit-padding-start:0;padding-inline-start:0;display:flex;flex-direction:column;align-items:flex-start;padding-left:var(--MdsStatusTracker-_layout-vertical__stepLabelLeadingPadding,8px);text-align:var(--MdsStatusTracker-_layout-vertical__stepLabelTextAlignment,left)}:host .mds-status-tracker--layout-vertical .mds-status-tracker__decoration{display:flex;flex-direction:column;justify-content:flex-start;align-items:center;height:100%;width:auto}:host .mds-status-tracker--layout-vertical__circle{width:var(--MdsStatusTracker_step__circleWidth,28px);height:var(--MdsStatusTracker_step__circleHeight,28px);border-width:var(--MdsStatusTracker_step__circleBorderThickness,2px);border-style:solid;border-radius:50%;flex-shrink:0}@media (min-width:767px){:host .mds-status-tracker--layout-vertical .mds-status-tracker__icon{height:var(--MdsStatusTracker_step__circleHeight,28px);width:var(--MdsStatusTracker_step__circleWidth,28px);display:flex;justify-content:center;align-items:center;border-width:.125rem;border-style:solid;box-sizing:border-box;border-radius:50%}:host .mds-status-tracker--layout-vertical .mds-status-tracker__icon svg{height:var(--MdsStatusTracker_step-_status-completed__iconHeight,24px);width:var(--MdsStatusTracker_step-_status-completed__iconWidth,24px)}:host .mds-status-tracker--layout-vertical .mds-status-tracker__circle{display:flex;flex-direction:row;justify-content:center;align-content:center;height:var(--MdsStatusTracker_step__circleHeight,28px);width:var(--MdsStatusTracker_step__circleWidth,28px)}}:host .mds-status-tracker--layout-vertical .mds-status-tracker__line{min-height:var(--MdsStatusTracker_step__lineMinHeight,24px)}:host .mds-status-tracker--layout-horizontal{height:auto;display:flex;flex-direction:column}:host .mds-status-tracker--layout-horizontal .mds-status-tracker__step{display:flex;flex-direction:column}:host .mds-status-tracker--layout-horizontal .mds-status-tracker__decoration{display:flex;flex-direction:row;align-items:center;width:100%;height:auto}:host .mds-status-tracker--layout-horizontal .mds-status-tracker__line{width:100%;height:.0625rem}:host .mds-status-tracker--layout-horizontal .mds-status-tracker__line--completed{height:.0625rem;border-left:0;border-bottom-style:var(--MdsStatusTracker_step-_status-completed__lineStyle,solid);border-bottom-width:var(--MdsStatusTracker_step__lineThickness,2px)}:host .mds-status-tracker--layout-horizontal .mds-status-tracker__line--inprogress,:host .mds-status-tracker--layout-horizontal .mds-status-tracker__line--upcoming{height:.0625rem;border-left:0;border-bottom-style:var(--MdsStatusTracker_step-_status-upcoming__lineStyle,dashed);border-bottom-width:var(--MdsStatusTracker_step__lineThickness,2px)}:host .mds-status-tracker--layout-horizontal .mds-status-tracker__list-circles-lines{display:flex;flex-direction:row;height:auto}:host .mds-status-tracker--layout-horizontal .mds-status-tracker__list-item{display:flex;flex-direction:row;height:100%;text-align:center}:host .mds-status-tracker--layout-horizontal .mds-status-tracker__list-item:first-child{text-align:start}:host .mds-status-tracker--layout-horizontal .mds-status-tracker__list-item:last-child{text-align:end}:host .mds-status-tracker--layout-horizontal .mds-status-tracker__list-labels{height:auto;display:inline-flex;flex-direction:row;padding-left:0;padding-top:4px}:host .mds-status-tracker--layout-horizontal .mds-status-tracker--layout-horizontal .mds-status-tracker__label{display:block;width:100%;text-align:center;padding-left:.5rem;padding-right:.5rem}:host .mds-status-tracker--layout-horizontal .mds-status-tracker--layout-horizontal .mds-status-tracker__list-item:first-child{text-align:left;padding-top:0;padding-left:0}:host .mds-status-tracker--layout-horizontal .mds-status-tracker--layout-horizontal .mds-status-tracker__list-item:last-child{text-align:right;padding-right:0}@media (min-width:767px){:host .mds-status-tracker--layout-horizontal .mds-status-tracker__icon{height:var(--MdsStatusTracker_step__circleHeight,28px);width:var(--MdsStatusTracker_step__circleWidth,28px);display:flex;justify-content:center;align-items:center;border-width:.125rem;border-style:solid;box-sizing:border-box;border-radius:50%}:host .mds-status-tracker--layout-horizontal .mds-status-tracker__icon svg{height:var(--MdsStatusTracker_step-_status-completed__iconHeight,24px);width:var(--MdsStatusTracker_step-_status-completed__iconWidth,24px)}:host .mds-status-tracker--layout-horizontal .mds-status-tracker__circle{display:flex;flex-direction:row;justify-content:center;align-content:center;height:var(--MdsStatusTracker_step__circleHeight,28px);width:var(--MdsStatusTracker_step__circleWidth,28px)}}:host .mds-status-tracker .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}.mds-status-tracker__icon{border-color:var(--MdsStatusTracker_step-_status-completed__circleBackgroundColor,#4ea000)}.mds-status-tracker__icon svg{fill:var(--MdsStatusTracker_step-_status-completed__iconColor,#fff)}.mds-status-tracker__icon--critical{border-color:var(--MdsStatusTracker_step-_status-completed-_variant-critical__circleBackgroundColor,#b80009)}.mds-status-tracker__line--completed{border-color:var(--MdsStatusTracker_step-_status-completed__lineColor,#4ea000)}.mds-status-tracker__line--completed.mds-status-tracker__line--critical{border-color:var(--MdsStatusTracker_step-_status-completed-_variant-critical__lineColor,#b80009)}.mds-status-tracker__line--inprogress,.mds-status-tracker__line--upcoming{border-color:var(--MdsStatusTracker_step-_status-upcoming__lineColor,#565a5d)}.mds-status-tracker__label--completed{color:var(--MdsStatusTracker_step-_status-completed__labelTextColor,#101820)}.mds-status-tracker__label--inprogress{color:var(--MdsStatusTracker_step-_status-inProgress__labelTextColor,#101820)}.mds-status-tracker__label--upcoming{color:var(--MdsStatusTracker_step-_status-upcoming__labelTextColor,#565a5d)}.mds-status-tracker__circle--completed{background-color:var(--MdsStatusTracker_step-_status-completed__circleBackgroundColor,#4ea000);border-color:var(--MdsStatusTracker_step-_status-completed__circleBorderColor,#4ea000)}.mds-status-tracker__circle--completed.mds-status-tracker__circle--critical{background-color:var(--MdsStatusTracker_step-_status-completed-_variant-critical__circleBackgroundColor,#b80009);border-color:var(--MdsStatusTracker_step-_status-completed-_variant-critical__circleBorderColor,#b80009)}.mds-status-tracker__circle--inprogress{background-color:var(--MdsStatusTracker_step-_status-inProgress__circleBackgroundColor,transparent);border-color:var(--MdsStatusTracker_step-_status-inProgress__circleBorderColor,#4ea000)}.mds-status-tracker__circle--inprogress.mds-status-tracker__circle--critical{border-color:var(--MdsStatusTracker_step-_status-inProgress-_variant-critical__circleBorderColor,#b80009)}.mds-status-tracker__circle--upcoming{background-color:var(--MdsStatusTracker_step-_status-upcoming__circleBackgroundColor,transparent);border-color:var(--MdsStatusTracker_step-_status-upcoming__circleBorderColor,#565a5d)}.mds-status-tracker--cancelled .mds-status-tracker__label.mds-status-tracker__label--inprogress{color:var(--MdsStatusTracker_step-_status-inProgress__labelTextColor,#101820)}.mds-status-tracker--cancelled .mds-status-tracker__circle--completed{background-color:var(--MdsStatusTracker_step-_cancelled-true-_status-completed__circleBackgroundColor,#565a5d);border-color:var(--MdsStatusTracker_step-_cancelled-true-_status-completed__circleBorderColor,#565a5d)}.mds-status-tracker--cancelled .mds-status-tracker__circle--inprogress{border-color:var(--MdsStatusTracker_step-_cancelled-true-_status-inProgress__circleBorderColor,#565a5d)}.mds-status-tracker--cancelled .mds-status-tracker__circle .mds-status-tracker__icon{border-color:var(--MdsStatusTracker_step-_cancelled-true-_status-completed__circleBorderColor,#565a5d)}.mds-status-tracker--cancelled .mds-status-tracker__decoration .mds-status-tracker__line--completed{border-bottom-color:var(--MdsStatusTracker_step-_cancelled-true-_status-completed__lineColor,#565a5d);border-left-color:var(--MdsStatusTracker_step-_cancelled-true-_status-completed__lineColor,#565a5d)}.mds-status-tracker--cancelled .mds-status-tracker__decoration .mds-status-tracker__line--inprogress{border-color:var(--MdsStatusTracker_step-_cancelled-true-_status-inProgress__lineColor,#565a5d)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/sticky-footer/mds-sticky-footer.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ':host{z-index:99998;width:100%;bottom:0}:host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .sticky-footer{display:flex;overflow-x:auto;padding-left:var(--MdsStickyFooter__footerLeadingPadding,16px);padding-top:var(--MdsStickyFooter__footerTopPadding,16px);padding-bottom:var(--MdsStickyFooter__footerBottomPadding,16px);min-height:var(--MdsStickyFooter__footerMinHeight,68px);justify-content:flex-end}:host .sticky-footer__button{margin:.0625rem}:host .sticky-footer--column{flex-direction:column;justify-content:center;padding-right:var(--MdsStickyFooter__footerTrailingPadding,16px)}:host .sticky-footer--column .sticky-footer__button{margin-bottom:var(--MdsStickyFooter__buttonsMarginBetween,16px)}:host .sticky-footer--column .sticky-footer__button:last-child{margin-bottom:0}:host .sticky-footer--three-buttons{justify-content:space-between}:host .sticky-footer__text{padding-top:var(--MdsStickyFooter__footerTopPadding,16px);padding-left:var(--MdsStickyFooter__footerTextTrailingPadding,16px);padding-right:var(--MdsStickyFooter__footerTextLeadingPadding,16px);color:var(--MdsStickyFooter__footerTextColor,#565a5d);line-height:var(--MdsStickyFooter__footerTextLineHeight,1.5rem);font-size:var(--MdsStickyFooter__footerTextSize,.75rem);font-weight:var(--MdsStickyFooter__footerTextWeight,400)}:host .sticky-footer__container{background-color:var(--MdsStickyFooter__footerBackgroundColor,#fff)}:host .sticky-footer__subcontainer{display:flex}:host .sticky-footer__subcontainer:not(.sticky-footer__subcontainer--column){padding-left:var(--MdsStickyFooter-_horizontalLayout-true__buttonsMarginBetween,16px)}:host .sticky-footer__subcontainer:not(.sticky-footer__subcontainer--column) .sticky-footer__button{padding-right:var(--MdsStickyFooter__footerTrailingPadding,16px)}:host .sticky-footer__subcontainer:not(.sticky-footer__subcontainer--column).sticky-footer__subcontainer--one-button,:host .sticky-footer__subcontainer:not(.sticky-footer__subcontainer--column).sticky-footer__subcontainer--two-buttons{padding-left:0;overflow-x:auto}:host .sticky-footer__subcontainer:not(.sticky-footer__subcontainer--column).sticky-footer__subcontainer--one-button.sticky-footer__subcontainer--one-button .sticky-footer__button,:host .sticky-footer__subcontainer:not(.sticky-footer__subcontainer--column).sticky-footer__subcontainer--two-buttons.sticky-footer__subcontainer--one-button .sticky-footer__button{padding-left:0}:host .sticky-footer__subcontainer--column{flex-direction:column}:host .sticky-footer__subcontainer--mobile-horizontal-layout{flex-direction:row}:host .sticky-footer__subcontainer--mobile-horizontal-layout .sticky-footer__button{flex-basis:50%;margin-left:0;margin-bottom:0;border:.0625rem solid transparent;padding:0}:host .sticky-footer__subcontainer--mobile-horizontal-layout .sticky-footer__button:first-of-type{padding-right:calc(var(--MdsStickyFooter-_horizontalLayout-true__buttonsMarginBetween, 16px)/2)}:host .sticky-footer__subcontainer--mobile-horizontal-layout .sticky-footer__button:last-of-type{padding-left:calc(var(--MdsStickyFooter-_horizontalLayout-true__buttonsMarginBetween, 16px)/2)}:host .sticky-footer:before{content:"";position:absolute;height:calc(var(--MdsStickyFooter__boxShadowVerticalOffset, -6px)*-1);top:var(--MdsStickyFooter__boxShadowVerticalOffset,-6px);left:0;right:0;opacity:0;transition-property:opacity;transition-duration:var(--MdsStickyFooter__boxShadowTransitionDuration,.2s);transition-timing-function:var(--MdsStickyFooter__boxShadowTransitionEase,cubic-bezier(.4,0,.2,1));box-shadow:inset var(--MdsStickyFooter__boxShadowHorizontalOffset,0) var(--MdsStickyFooter__boxShadowVerticalOffset,-6px) var(--MdsStickyFooter__boxShadowBlurRadius,4px) var(--MdsStickyFooter__boxShadowSpreadRadius,-6px) var(--MdsStickyFooter__boxShadowColor,rgba(0,0,0,.35))}:host .sticky-footer--ios:before{top:0}:host .sticky-footer--with-box-shadow:before{opacity:1}:host(mds-sticky-footer[stick-to-parent-container=false]){position:fixed}:host(mds-sticky-footer[stick-to-parent-container=true]){display:block;position:sticky}', "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/switch/mds-switch.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ':host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .switch{display:flex;flex-direction:row;justify-content:space-between;text-align:center;align-items:center}:host .switch--focus{outline:var(--MdsSwitch__borderWidth--focused,1px) dashed var(--MdsSwitch__borderColor--focused,#000)}:host .switch--disabled{pointer-events:none}:host .switch__label{font-weight:var(--MdsSwitch__labelTextWeight,400);text-align:var(--MdsSwitch__labelTextAlignment,left);color:var(--MdsSwitch__labelTextColor,#565a5d)}:host .switch__label--disabled{color:var(--MdsSwitch__checkedValueTextColor--disabled,#8c8e90)}:host .switch__label--large{font-size:var(--MdsSwitch-_labelSize-large__labelTextSize,1rem);line-height:var(--MdsSwitch-_labelSize-large__labelTextLineHeight,1.5rem)}:host .switch__label--medium{font-size:var(--MdsSwitch-_labelSize-medium__labelTextSize,.875rem);line-height:var(--MdsSwitch-_labelSize-medium__labelTextLineHeight,1.25rem)}:host .switch__label:focus{outline:none}:host .switch__wrap{text-align:right}:host .switch__state,:host .switch__wrap{padding-left:var(--MdsSwitch__labelTrailingPadding,16px)}:host .switch__state{line-height:var(--MdsSwitch__labelTextLineHeight,1.5rem);font-size:var(--MdsSwitch__checkedValueTextSize,.875rem);font-weight:var(--MdsSwitch__checkedValueTextWeight,600);cursor:pointer;color:var(--MdsSwitch__checkedValueTextColor,#565a5d)}:host .switch__state--disabled{color:var(--MdsSwitch__checkedValueTextColor--disabled,#8c8e90)}:host .switch__state:focus{outline:none}:host .switch__label-wrapper{position:relative;display:inline-block;width:var(--MdsSwitch__trackWidth,34px);height:var(--MdsSwitch__trackHeight,14px);border-radius:var(--MdsSwitch__trackCornerRadius,7px);vertical-align:middle}:host .switch__label-wrapper:hover{background-color:var(--MdsSwitch__trackBackgroundColor--hovered,#0091da)}:host .switch__label-wrapper.switch__label-wrapper--off:hover{background-color:var(--MdsSwitch-_checked-false__trackBackgroundColor--hovered,#949494)}:host .switch__label-wrapper--wide{width:var(--MdsSwitch__trackWidthWide,40px);height:var(--MdsSwitch__trackHeightWide,25px);border-radius:var(--MdsSwitch__trackCornerRadiusWide,25px)}:host .switch__label-wrapper--on{background-color:var(--MdsSwitch-_checked-true__trackBackgroundColor,#0091da)}:host .switch__label-wrapper--off{background-color:var(--MdsSwitch-_checked-false__trackBackgroundColor,#8c8e90)}:host .switch__label-wrapper--disabled-on{background-color:var(--MdsSwitch-_checked-true__trackBackgroundColor--disabled,#d7f0ff)}:host .switch__label-wrapper--disabled-off{background-color:var(--MdsSwitch-_checked-false__trackBackgroundColor--disabled,#eceff1)}:host .switch__checkbox{opacity:0;width:0;height:0}:host .switch__slider{cursor:pointer}:host .switch__slider:before{position:absolute;content:"";height:var(--MdsSwitch__thumbSize,20px);width:var(--MdsSwitch__thumbSize,20px);left:-.125rem;bottom:-.1875rem;transition:.4s;border-radius:50%;background-color:var(--MdsSwitch-_checked-false__thumbBackgroundColor,#fff);box-shadow:var(--MdsSwitch__thumbShadowHorizontalOffset,-1px) var(--MdsSwitch__thumbShadowVerticalOffset,1px) var(--MdsSwitch__thumbShadowBlurRadius,3px) var(--MdsSwitch__thumbShadowSpreadRadius,1px) var(--MdsSwitch__thumbShadowColor,#565a5d)}:host .switch__slider:hover:before{background-color:var(--MdsSwitch-_checked-false__thumbBackgroundColor--hovered,#ededed)}:host .switch__slider:active:before{background-color:var(--MdsSwitch__thumbBackgroundColor--active,#002f6c)}:host .switch__slider--wide{cursor:pointer}:host .switch__slider--wide:before{position:absolute;content:"";height:var(--MdsSwitch__thumbSize,20px);width:var(--MdsSwitch__thumbSize,20px);left:-.125rem;bottom:-.1875rem;transition:.4s;border-radius:50%;left:.125rem;bottom:.1875rem;box-shadow:var(--MdsSwitch__thumbShadowHorizontalOffset,-1px) var(--MdsSwitch__thumbShadowVerticalOffset,1px) var(--MdsSwitch__thumbShadowBlurRadius,3px) var(--MdsSwitch__thumbShadowSpreadRadius,1px) var(--MdsSwitch__thumbShadowColor,#565a5d)}:host .switch__slider--checked:before{transform:translateX(var(--MdsSwitch__thumbPositionMotionOffset,16px));background-color:var(--MdsSwitch-_checked-true__thumbBackgroundColor,#004692)}:host .switch__slider--checked:hover:before{background-color:var(--MdsSwitch__thumbBackgroundColor--hovered,#0074c7)}:host .switch__slider--checked:active:before{background-color:var(--MdsSwitch__thumbBackgroundColor--active,#002f6c)}:host .switch__slider--checked+.switch__thumb--disabled:before{transform:translateX(var(--MdsSwitch__thumbPositionMotionOffsetDisabled,14px));background-color:var(--MdsSwitch-_checked-false__thumbBackgroundColor,#fff)}:host .switch__slider--checked+.switch__thumb-wide--disabled:before{transform:translateX(var(--MdsSwitch__thumbPositionMotionOffsetDisabledWide,14px))}:host .switch__checkbox--wide:checked+.switch__slider:before{transform:translateX(var(--MdsSwitch__thumbPositionMotionOffsetWide,14px))}:host .switch__thumb--disabled:before{left:-.125rem;bottom:-.1875rem;background-color:var(--MdsSwitch-_checked-false__thumbBackgroundColor,#fff)}:host .switch__thumb--disabled:before,:host .switch__thumb-wide--disabled:before{position:absolute;content:"";height:var(--MdsSwitch__thumbSize,20px);width:var(--MdsSwitch__thumbSize,20px);transition:.4s;border-radius:50%;box-shadow:var(--MdsSwitch__thumbShadowHorizontalOffset,-1px) var(--MdsSwitch__thumbShadowVerticalOffset,1px) var(--MdsSwitch__thumbShadowBlurRadius,3px) var(--MdsSwitch__thumbShadowSpreadRadius,1px) var(--MdsSwitch__thumbShadowColor,#565a5d)}:host .switch__thumb-wide--disabled:before{left:-.125rem;bottom:-.1875rem;left:.1875rem;bottom:.1875rem}:host.switch__label-wrapper--off,:host .switch__slider:active:before{background-color:var(--MdsSwitch-_checked-false__thumbBackgroundColor--active,#ccc)}', "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/text-input-secure/mds-text-input-secure.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ".mds-container{box-sizing:border-box;margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px;width:100%}@media print,screen and (min-width:576px){.mds-container{max-width:540px}}@media print,screen and (min-width:768px){.mds-container{max-width:720px}}@media print,screen and (min-width:992px){.mds-container{max-width:960px}}@media print,screen and (min-width:1200px){.mds-container{max-width:1140px}}.mds-container-at-576,.mds-container-at-768,.mds-container-at-992,.mds-container-at-1200,.mds-container-fluid{box-sizing:border-box;margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px;width:100%}@media print,screen and (min-width:576px){.mds-container,.mds-container-at-576{max-width:var(--mds-container-max-width-at-576,540px)}}@media print,screen and (min-width:768px){.mds-container,.mds-container-at-576,.mds-container-at-768{max-width:var(--mds-container-max-width-at-768,720px)}}@media print,screen and (min-width:992px){.mds-container,.mds-container-at-576,.mds-container-at-768,.mds-container-at-992{max-width:var(--mds-container-max-width-at-992,960px)}}@media print,screen and (min-width:1200px){.mds-container,.mds-container-at-576,.mds-container-at-768,.mds-container-at-992,.mds-container-at-1200{max-width:var(--mds-container-max-width-at-1200,1140px)}}.mds-row{display:flex;flex-wrap:wrap;margin-left:-15px;margin-right:-15px}.mds-no-gutters{margin-left:0;margin-right:0}.mds-no-gutters>.mds-col,.mds-no-gutters>[class*=mds-col-]{padding-left:0;padding-right:0}.mds-col,.mds-col-1,.mds-col-2,.mds-col-3,.mds-col-4,.mds-col-5,.mds-col-6,.mds-col-7,.mds-col-8,.mds-col-9,.mds-col-10,.mds-col-11,.mds-col-12,.mds-col-at-576,.mds-col-at-576-1,.mds-col-at-576-2,.mds-col-at-576-3,.mds-col-at-576-4,.mds-col-at-576-5,.mds-col-at-576-6,.mds-col-at-576-7,.mds-col-at-576-8,.mds-col-at-576-9,.mds-col-at-576-10,.mds-col-at-576-11,.mds-col-at-576-12,.mds-col-at-576-auto,.mds-col-at-768,.mds-col-at-768-1,.mds-col-at-768-2,.mds-col-at-768-3,.mds-col-at-768-4,.mds-col-at-768-5,.mds-col-at-768-6,.mds-col-at-768-7,.mds-col-at-768-8,.mds-col-at-768-9,.mds-col-at-768-10,.mds-col-at-768-11,.mds-col-at-768-12,.mds-col-at-768-auto,.mds-col-at-992,.mds-col-at-992-1,.mds-col-at-992-2,.mds-col-at-992-3,.mds-col-at-992-4,.mds-col-at-992-5,.mds-col-at-992-6,.mds-col-at-992-7,.mds-col-at-992-8,.mds-col-at-992-9,.mds-col-at-992-10,.mds-col-at-992-11,.mds-col-at-992-12,.mds-col-at-992-auto,.mds-col-at-1200,.mds-col-at-1200-1,.mds-col-at-1200-2,.mds-col-at-1200-3,.mds-col-at-1200-4,.mds-col-at-1200-5,.mds-col-at-1200-6,.mds-col-at-1200-7,.mds-col-at-1200-8,.mds-col-at-1200-9,.mds-col-at-1200-10,.mds-col-at-1200-11,.mds-col-at-1200-12,.mds-col-at-1200-auto,.mds-col-auto{box-sizing:border-box;position:relative;width:100%;padding-left:8px;padding-right:8px}@media print,screen and (min-width:576px){.mds-col,.mds-col-1,.mds-col-2,.mds-col-3,.mds-col-4,.mds-col-5,.mds-col-6,.mds-col-7,.mds-col-8,.mds-col-9,.mds-col-10,.mds-col-11,.mds-col-12,.mds-col-at-576,.mds-col-at-576-1,.mds-col-at-576-2,.mds-col-at-576-3,.mds-col-at-576-4,.mds-col-at-576-5,.mds-col-at-576-6,.mds-col-at-576-7,.mds-col-at-576-8,.mds-col-at-576-9,.mds-col-at-576-10,.mds-col-at-576-11,.mds-col-at-576-12,.mds-col-at-576-auto,.mds-col-at-768,.mds-col-at-768-1,.mds-col-at-768-2,.mds-col-at-768-3,.mds-col-at-768-4,.mds-col-at-768-5,.mds-col-at-768-6,.mds-col-at-768-7,.mds-col-at-768-8,.mds-col-at-768-9,.mds-col-at-768-10,.mds-col-at-768-11,.mds-col-at-768-12,.mds-col-at-768-auto,.mds-col-at-992,.mds-col-at-992-1,.mds-col-at-992-2,.mds-col-at-992-3,.mds-col-at-992-4,.mds-col-at-992-5,.mds-col-at-992-6,.mds-col-at-992-7,.mds-col-at-992-8,.mds-col-at-992-9,.mds-col-at-992-10,.mds-col-at-992-11,.mds-col-at-992-12,.mds-col-at-992-auto,.mds-col-at-1200,.mds-col-at-1200-1,.mds-col-at-1200-2,.mds-col-at-1200-3,.mds-col-at-1200-4,.mds-col-at-1200-5,.mds-col-at-1200-6,.mds-col-at-1200-7,.mds-col-at-1200-8,.mds-col-at-1200-9,.mds-col-at-1200-10,.mds-col-at-1200-11,.mds-col-at-1200-12,.mds-col-at-1200-auto,.mds-col-auto{padding-left:8px;padding-right:8px}}@media print,screen and (min-width:768px){.mds-col,.mds-col-1,.mds-col-2,.mds-col-3,.mds-col-4,.mds-col-5,.mds-col-6,.mds-col-7,.mds-col-8,.mds-col-9,.mds-col-10,.mds-col-11,.mds-col-12,.mds-col-at-576,.mds-col-at-576-1,.mds-col-at-576-2,.mds-col-at-576-3,.mds-col-at-576-4,.mds-col-at-576-5,.mds-col-at-576-6,.mds-col-at-576-7,.mds-col-at-576-8,.mds-col-at-576-9,.mds-col-at-576-10,.mds-col-at-576-11,.mds-col-at-576-12,.mds-col-at-576-auto,.mds-col-at-768,.mds-col-at-768-1,.mds-col-at-768-2,.mds-col-at-768-3,.mds-col-at-768-4,.mds-col-at-768-5,.mds-col-at-768-6,.mds-col-at-768-7,.mds-col-at-768-8,.mds-col-at-768-9,.mds-col-at-768-10,.mds-col-at-768-11,.mds-col-at-768-12,.mds-col-at-768-auto,.mds-col-at-992,.mds-col-at-992-1,.mds-col-at-992-2,.mds-col-at-992-3,.mds-col-at-992-4,.mds-col-at-992-5,.mds-col-at-992-6,.mds-col-at-992-7,.mds-col-at-992-8,.mds-col-at-992-9,.mds-col-at-992-10,.mds-col-at-992-11,.mds-col-at-992-12,.mds-col-at-992-auto,.mds-col-at-1200,.mds-col-at-1200-1,.mds-col-at-1200-2,.mds-col-at-1200-3,.mds-col-at-1200-4,.mds-col-at-1200-5,.mds-col-at-1200-6,.mds-col-at-1200-7,.mds-col-at-1200-8,.mds-col-at-1200-9,.mds-col-at-1200-10,.mds-col-at-1200-11,.mds-col-at-1200-12,.mds-col-at-1200-auto,.mds-col-auto{padding-left:12px;padding-right:12px}}@media print,screen and (min-width:992px){.mds-col,.mds-col-1,.mds-col-2,.mds-col-3,.mds-col-4,.mds-col-5,.mds-col-6,.mds-col-7,.mds-col-8,.mds-col-9,.mds-col-10,.mds-col-11,.mds-col-12,.mds-col-at-576,.mds-col-at-576-1,.mds-col-at-576-2,.mds-col-at-576-3,.mds-col-at-576-4,.mds-col-at-576-5,.mds-col-at-576-6,.mds-col-at-576-7,.mds-col-at-576-8,.mds-col-at-576-9,.mds-col-at-576-10,.mds-col-at-576-11,.mds-col-at-576-12,.mds-col-at-576-auto,.mds-col-at-768,.mds-col-at-768-1,.mds-col-at-768-2,.mds-col-at-768-3,.mds-col-at-768-4,.mds-col-at-768-5,.mds-col-at-768-6,.mds-col-at-768-7,.mds-col-at-768-8,.mds-col-at-768-9,.mds-col-at-768-10,.mds-col-at-768-11,.mds-col-at-768-12,.mds-col-at-768-auto,.mds-col-at-992,.mds-col-at-992-1,.mds-col-at-992-2,.mds-col-at-992-3,.mds-col-at-992-4,.mds-col-at-992-5,.mds-col-at-992-6,.mds-col-at-992-7,.mds-col-at-992-8,.mds-col-at-992-9,.mds-col-at-992-10,.mds-col-at-992-11,.mds-col-at-992-12,.mds-col-at-992-auto,.mds-col-at-1200,.mds-col-at-1200-1,.mds-col-at-1200-2,.mds-col-at-1200-3,.mds-col-at-1200-4,.mds-col-at-1200-5,.mds-col-at-1200-6,.mds-col-at-1200-7,.mds-col-at-1200-8,.mds-col-at-1200-9,.mds-col-at-1200-10,.mds-col-at-1200-11,.mds-col-at-1200-12,.mds-col-at-1200-auto,.mds-col-auto{padding-left:12px;padding-right:12px}}@media print,screen and (min-width:1200px){.mds-col,.mds-col-1,.mds-col-2,.mds-col-3,.mds-col-4,.mds-col-5,.mds-col-6,.mds-col-7,.mds-col-8,.mds-col-9,.mds-col-10,.mds-col-11,.mds-col-12,.mds-col-at-576,.mds-col-at-576-1,.mds-col-at-576-2,.mds-col-at-576-3,.mds-col-at-576-4,.mds-col-at-576-5,.mds-col-at-576-6,.mds-col-at-576-7,.mds-col-at-576-8,.mds-col-at-576-9,.mds-col-at-576-10,.mds-col-at-576-11,.mds-col-at-576-12,.mds-col-at-576-auto,.mds-col-at-768,.mds-col-at-768-1,.mds-col-at-768-2,.mds-col-at-768-3,.mds-col-at-768-4,.mds-col-at-768-5,.mds-col-at-768-6,.mds-col-at-768-7,.mds-col-at-768-8,.mds-col-at-768-9,.mds-col-at-768-10,.mds-col-at-768-11,.mds-col-at-768-12,.mds-col-at-768-auto,.mds-col-at-992,.mds-col-at-992-1,.mds-col-at-992-2,.mds-col-at-992-3,.mds-col-at-992-4,.mds-col-at-992-5,.mds-col-at-992-6,.mds-col-at-992-7,.mds-col-at-992-8,.mds-col-at-992-9,.mds-col-at-992-10,.mds-col-at-992-11,.mds-col-at-992-12,.mds-col-at-992-auto,.mds-col-at-1200,.mds-col-at-1200-1,.mds-col-at-1200-2,.mds-col-at-1200-3,.mds-col-at-1200-4,.mds-col-at-1200-5,.mds-col-at-1200-6,.mds-col-at-1200-7,.mds-col-at-1200-8,.mds-col-at-1200-9,.mds-col-at-1200-10,.mds-col-at-1200-11,.mds-col-at-1200-12,.mds-col-at-1200-auto,.mds-col-auto{padding-left:12px;padding-right:12px}}.mds-col{flex-basis:0;flex-grow:1;max-width:100%}.mds-col-auto{flex:0 0 auto;max-width:100%;width:auto}.mds-col-1{flex:0 0 8.33333%;max-width:8.33333%}.mds-col-2{flex:0 0 16.66667%;max-width:16.66667%}.mds-col-3{flex:0 0 25%;max-width:25%}.mds-col-4{flex:0 0 33.33333%;max-width:33.33333%}.mds-col-5{flex:0 0 41.66667%;max-width:41.66667%}.mds-col-6{flex:0 0 50%;max-width:50%}.mds-col-7{flex:0 0 58.33333%;max-width:58.33333%}.mds-col-8{flex:0 0 66.66667%;max-width:66.66667%}.mds-col-9{flex:0 0 75%;max-width:75%}.mds-col-10{flex:0 0 83.33333%;max-width:83.33333%}.mds-col-11{flex:0 0 91.66667%;max-width:91.66667%}.mds-col-12{flex:0 0 100%;max-width:100%}.mds-offset-1{margin-left:8.33333%}.mds-offset-2{margin-left:16.66667%}.mds-offset-3{margin-left:25%}.mds-offset-4{margin-left:33.33333%}.mds-offset-5{margin-left:41.66667%}.mds-offset-6{margin-left:50%}.mds-offset-7{margin-left:58.33333%}.mds-offset-8{margin-left:66.66667%}.mds-offset-9{margin-left:75%}.mds-offset-10{margin-left:83.33333%}.mds-offset-11{margin-left:91.66667%}@media print,screen and (min-width:576px){.mds-col-at-576{flex-basis:0;flex-grow:1;max-width:100%}.mds-col-at-576-auto{flex:0 0 auto;max-width:100%;width:auto}.mds-col-at-576-1{flex:0 0 8.33333%;max-width:8.33333%}.mds-col-at-576-2{flex:0 0 16.66667%;max-width:16.66667%}.mds-col-at-576-3{flex:0 0 25%;max-width:25%}.mds-col-at-576-4{flex:0 0 33.33333%;max-width:33.33333%}.mds-col-at-576-5{flex:0 0 41.66667%;max-width:41.66667%}.mds-col-at-576-6{flex:0 0 50%;max-width:50%}.mds-col-at-576-7{flex:0 0 58.33333%;max-width:58.33333%}.mds-col-at-576-8{flex:0 0 66.66667%;max-width:66.66667%}.mds-col-at-576-9{flex:0 0 75%;max-width:75%}.mds-col-at-576-10{flex:0 0 83.33333%;max-width:83.33333%}.mds-col-at-576-11{flex:0 0 91.66667%;max-width:91.66667%}.mds-col-at-576-12{flex:0 0 100%;max-width:100%}.mds-offset-at-576-0{margin-left:0}.mds-offset-at-576-1{margin-left:8.33333%}.mds-offset-at-576-2{margin-left:16.66667%}.mds-offset-at-576-3{margin-left:25%}.mds-offset-at-576-4{margin-left:33.33333%}.mds-offset-at-576-5{margin-left:41.66667%}.mds-offset-at-576-6{margin-left:50%}.mds-offset-at-576-7{margin-left:58.33333%}.mds-offset-at-576-8{margin-left:66.66667%}.mds-offset-at-576-9{margin-left:75%}.mds-offset-at-576-10{margin-left:83.33333%}.mds-offset-at-576-11{margin-left:91.66667%}}@media print,screen and (min-width:768px){.mds-col-at-768{flex-basis:0;flex-grow:1;max-width:100%}.mds-col-at-768-auto{flex:0 0 auto;max-width:100%;width:auto}.mds-col-at-768-1{flex:0 0 8.33333%;max-width:8.33333%}.mds-col-at-768-2{flex:0 0 16.66667%;max-width:16.66667%}.mds-col-at-768-3{flex:0 0 25%;max-width:25%}.mds-col-at-768-4{flex:0 0 33.33333%;max-width:33.33333%}.mds-col-at-768-5{flex:0 0 41.66667%;max-width:41.66667%}.mds-col-at-768-6{flex:0 0 50%;max-width:50%}.mds-col-at-768-7{flex:0 0 58.33333%;max-width:58.33333%}.mds-col-at-768-8{flex:0 0 66.66667%;max-width:66.66667%}.mds-col-at-768-9{flex:0 0 75%;max-width:75%}.mds-col-at-768-10{flex:0 0 83.33333%;max-width:83.33333%}.mds-col-at-768-11{flex:0 0 91.66667%;max-width:91.66667%}.mds-col-at-768-12{flex:0 0 100%;max-width:100%}.mds-offset-at-768-0{margin-left:0}.mds-offset-at-768-1{margin-left:8.33333%}.mds-offset-at-768-2{margin-left:16.66667%}.mds-offset-at-768-3{margin-left:25%}.mds-offset-at-768-4{margin-left:33.33333%}.mds-offset-at-768-5{margin-left:41.66667%}.mds-offset-at-768-6{margin-left:50%}.mds-offset-at-768-7{margin-left:58.33333%}.mds-offset-at-768-8{margin-left:66.66667%}.mds-offset-at-768-9{margin-left:75%}.mds-offset-at-768-10{margin-left:83.33333%}.mds-offset-at-768-11{margin-left:91.66667%}}@media print,screen and (min-width:992px){.mds-col-at-992{flex-basis:0;flex-grow:1;max-width:100%}.mds-col-at-992-auto{flex:0 0 auto;max-width:100%;width:auto}.mds-col-at-992-1{flex:0 0 8.33333%;max-width:8.33333%}.mds-col-at-992-2{flex:0 0 16.66667%;max-width:16.66667%}.mds-col-at-992-3{flex:0 0 25%;max-width:25%}.mds-col-at-992-4{flex:0 0 33.33333%;max-width:33.33333%}.mds-col-at-992-5{flex:0 0 41.66667%;max-width:41.66667%}.mds-col-at-992-6{flex:0 0 50%;max-width:50%}.mds-col-at-992-7{flex:0 0 58.33333%;max-width:58.33333%}.mds-col-at-992-8{flex:0 0 66.66667%;max-width:66.66667%}.mds-col-at-992-9{flex:0 0 75%;max-width:75%}.mds-col-at-992-10{flex:0 0 83.33333%;max-width:83.33333%}.mds-col-at-992-11{flex:0 0 91.66667%;max-width:91.66667%}.mds-col-at-992-12{flex:0 0 100%;max-width:100%}.mds-offset-at-992-0{margin-left:0}.mds-offset-at-992-1{margin-left:8.33333%}.mds-offset-at-992-2{margin-left:16.66667%}.mds-offset-at-992-3{margin-left:25%}.mds-offset-at-992-4{margin-left:33.33333%}.mds-offset-at-992-5{margin-left:41.66667%}.mds-offset-at-992-6{margin-left:50%}.mds-offset-at-992-7{margin-left:58.33333%}.mds-offset-at-992-8{margin-left:66.66667%}.mds-offset-at-992-9{margin-left:75%}.mds-offset-at-992-10{margin-left:83.33333%}.mds-offset-at-992-11{margin-left:91.66667%}}@media print,screen and (min-width:1200px){.mds-col-at-1200{flex-basis:0;flex-grow:1;max-width:100%}.mds-col-at-1200-auto{flex:0 0 auto;max-width:100%;width:auto}.mds-col-at-1200-1{flex:0 0 8.33333%;max-width:8.33333%}.mds-col-at-1200-2{flex:0 0 16.66667%;max-width:16.66667%}.mds-col-at-1200-3{flex:0 0 25%;max-width:25%}.mds-col-at-1200-4{flex:0 0 33.33333%;max-width:33.33333%}.mds-col-at-1200-5{flex:0 0 41.66667%;max-width:41.66667%}.mds-col-at-1200-6{flex:0 0 50%;max-width:50%}.mds-col-at-1200-7{flex:0 0 58.33333%;max-width:58.33333%}.mds-col-at-1200-8{flex:0 0 66.66667%;max-width:66.66667%}.mds-col-at-1200-9{flex:0 0 75%;max-width:75%}.mds-col-at-1200-10{flex:0 0 83.33333%;max-width:83.33333%}.mds-col-at-1200-11{flex:0 0 91.66667%;max-width:91.66667%}.mds-col-at-1200-12{flex:0 0 100%;max-width:100%}.mds-offset-at-1200-0{margin-left:0}.mds-offset-at-1200-1{margin-left:8.33333%}.mds-offset-at-1200-2{margin-left:16.66667%}.mds-offset-at-1200-3{margin-left:25%}.mds-offset-at-1200-4{margin-left:33.33333%}.mds-offset-at-1200-5{margin-left:41.66667%}.mds-offset-at-1200-6{margin-left:50%}.mds-offset-at-1200-7{margin-left:58.33333%}.mds-offset-at-1200-8{margin-left:66.66667%}.mds-offset-at-1200-9{margin-left:75%}.mds-offset-at-1200-10{margin-left:83.33333%}.mds-offset-at-1200-11{margin-left:91.66667%}}:host{display:block}:host *{box-sizing:border-box}:host .mds-text-input__label{color:var(--MdsTextInput__labelTextColor,#565a5d);font-size:var(--MdsTextInput__labelTextSize,.875rem);line-height:var(--MdsTextInput__labelTextLineHeight,1.25rem);font-weight:var(--MdsTextInput__labelTextWeight,400);text-align:var(--MdsTextInput__labelTextAlignment,left)}:host .mds-text-input__label--error{color:var(--MdsTextInput__labelTextColor--error,#b80009);font-weight:var(--MdsTextInput__labelTextWeight--error,600)}:host .mds-text-input__label--hidden{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .mds-text-input .mds-text-input__input-wrap{width:100%;position:relative}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__input{padding-right:1rem}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__input--leading-icon.mds-text-input__input--line{padding-left:2rem}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__input--leading-icon.mds-text-input__input--box{padding-left:2.5rem}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__input--trailing-icon{padding-right:2.5rem}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__input--waiting-state.mds-text-input__input--line{padding-right:1.5rem}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__input--waiting-state.mds-text-input__input--box{padding-right:1.8125rem}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__icon{display:inline-flex;position:absolute}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__icon--field-prefix{pointer-events:none}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__icon--field-prefix svg{height:var(--MdsTextInput-_fieldPrefix-true__iconHeight,24px);width:var(--MdsTextInput-_fieldPrefix-true__iconWidth,24px);fill:var(--MdsTextInput__placeholderTextColor,#565a5d)}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__icon--field-suffix{top:calc(var(--MdsTextInput__borderBottomWidth--active, 2px)/2);right:calc(var(--MdsTextInput__borderBottomWidth--active, 2px)/2)}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__icon--field-suffix[hidden]{visibility:hidden}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__icon--field-suffix--horizontal{right:calc(var(--MdsTextInput__borderBottomWidth--active, 2px)/2 + .75rem)}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__icon--box.mds-text-input__icon--field-prefix{top:var(--MdsTextInput-_variant-box__fieldTopPadding,8px);left:var(--MdsTextInput-_fieldPrefix-true__iconTrailingPadding,8px)}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__icon--box.mds-text-input__icon--field-prefix--horizontal{left:calc(var(--MdsTextInput-_fieldPrefix-true__iconTrailingPadding, 8px) + .75rem)}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__icon--box.mds-text-input__icon--field-suffix{top:calc(var(--MdsTextInput-_variant-box__borderTopWidth--active, 2px) + .0625rem);right:calc(var(--MdsTextInput-_variant-box__borderTrailingWidth--active, 2px) + .0625rem)}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__icon--box.mds-text-input__icon--field-suffix--horizontal{right:calc(var(--MdsTextInput-_variant-box__borderTrailingWidth--active, 2px) + .8125rem)}:host .mds-text-input .mds-text-input__formatted-text{color:var(--MdsTextInput__formatterTextColor,#101820);font-weight:var(--MdsTextInput__formatterTextWeight,600);font-size:var(--MdsTextInput__formatterTextSize,.875rem);line-height:var(--MdsTextInput__formatterTextLineHeight,1.25rem);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}:host .mds-text-input .mds-text-input__formatted-text--horizontal{width:100%;margin-left:0;position:absolute;left:0;top:-1.75rem}:host .mds-text-input .mds-text-input__formatted-text--hidden{visibility:hidden}:host .mds-text-input .mds-text-input__formatted-text-vertical{margin-left:var(--MdsTextInput__formatterTextLeadingPadding,8px)}:host .mds-text-input .mds-text-input__formatted-text-horizontal{padding-left:.25rem}:host .mds-text-input .mds-text-input__input{width:100%;display:block;-webkit-appearance:none;-moz-appearance:none;appearance:none;color:var(--MdsTextInput__fieldTextColor,#101820);font-size:var(--MdsTextInput__fieldTextSize,1rem);padding:var(--MdsTextInput__fieldTopPadding,0) var(--MdsTextInput__fieldTrailingPadding,0) var(--MdsTextInput__fieldBottomPadding,8px) var(--MdsTextInput__fieldLeadingPadding,0);margin-top:var(--MdsTextInput__fieldTopMargin,0);font-weight:var(--MdsTextInput__fieldTextWeight,400);line-height:var(--MdsTextInput__fieldTextLineHeight,1.5rem);text-align:var(--MdsTextInput__fieldTextAlignment,left);border-radius:var(--MdsTextInput__borderRadius,0);border:0;font-family:inherit}:host .mds-text-input .mds-text-input__input:focus{outline:none}:host .mds-text-input .mds-text-input__input::-moz-placeholder{color:var(--MdsTextInput__placeholderTextColor,#565a5d);opacity:1}:host .mds-text-input .mds-text-input__input::placeholder{color:var(--MdsTextInput__placeholderTextColor,#565a5d);opacity:1}:host .mds-text-input .mds-text-input__input--box{padding:var(--MdsTextInput-_variant-box__fieldTopPadding,8px) var(--MdsTextInput-_variant-box__fieldTrailingPadding,16px) var(--MdsTextInput-_variant-box__fieldBottomPadding,8px) var(--MdsTextInput-_variant-box__fieldLeadingPadding,16px);min-height:calc(var(--MdsTextInput__fieldTextLineHeight, 1.5rem) + var(--MdsTextInput-_variant-box__fieldTopPadding, .5rem) + var(--MdsTextInput-_variant-box__fieldBottomPadding, .5rem));box-shadow:inset 0 0 0 var(--MdsTextInput__borderBottomWidth,1px) var(--MdsTextInput__borderColor,#949494)}:host .mds-text-input .mds-text-input__input--box:disabled{box-shadow:inset 0 0 0 var(--MdsTextInput__borderBottomWidth,1px) var(--MdsTextInput__borderColor--disabled,#bcbcbc);color:var(--MdsTextInput__fieldTextColor--disabled,#565a5d)}:host .mds-text-input .mds-text-input__input--line{box-shadow:inset 0 calc(var(--MdsTextInput__borderBottomWidth, 1px)*-1) 0 0 var(--MdsTextInput__borderColor,#949494);min-height:calc(var(--MdsTextInput__fieldTextLineHeight, 1.5rem) + var(--MdsTextInput__fieldBottomPadding, .5rem));background-color:transparent}:host .mds-text-input .mds-text-input__input--line:disabled{box-shadow:inset 0 calc(var(--MdsTextInput__borderBottomWidth, 1px)*-1) 0 0 var(--MdsTextInput__borderColor--disabled,#bcbcbc);color:var(--MdsTextInput__fieldTextColor--disabled,#565a5d)}:host .mds-text-input .mds-text-input__input--line.mds-text-input__input--hero{font-size:var(--MdsTextInput-_hero-true__fieldTextSize,2.5rem);line-height:var(--MdsTextInput-_hero-true__fieldTextLineHeight,3.25rem);font-weight:var(--MdsTextInput-_hero-true__fieldTextWeight,300)}:host .mds-text-input .mds-text-input__input--multiline{z-index:2;overflow:auto}:host .mds-text-input .mds-text-input__input--error{color:var(--MdsTextInput__fieldTextColor--error,#101820);box-shadow:inset 0 0 0 var(--MdsTextInput__borderBottomWidth--error,1px) var(--MdsTextInput__borderColor--error,#b80009)}:host .mds-text-input .mds-text-input__input--error.mds-text-input__input--line{box-shadow:inset 0 calc(var(--MdsTextInput__borderBottomWidth--error, 1px)*-1) 0 0 var(--MdsTextInput__borderColor--error,#b80009)}:host .mds-text-input .mds-text-input__input--error.mds-text-input__input--focused,:host .mds-text-input .mds-text-input__input--error:focus{box-shadow:inset 0 0 0 var(--MdsTextInput__borderBottomWidth--active,2px) var(--MdsTextInput__borderColor--error,#b80009)}:host .mds-text-input .mds-text-input__input--error.mds-text-input__input--focused.mds-text-input__input--line,:host .mds-text-input .mds-text-input__input--error:focus.mds-text-input__input--line{box-shadow:inset 0 calc(var(--MdsTextInput__borderBottomWidth--active, 2px)*-1) 0 0 var(--MdsTextInput__borderColor--error,#b80009)}:host .mds-text-input .mds-text-input__input--focused:not(.mds-text-input__input--error),:host .mds-text-input .mds-text-input__input:not(.mds-text-input__input--error):focus{box-shadow:inset 0 0 0 var(--MdsTextInput-_variant-box__borderTopWidth--active,2px) var(--MdsTextInput__borderColor--active,#005eb8)}:host .mds-text-input .mds-text-input__input--focused:not(.mds-text-input__input--error).mds-text-input__input--line,:host .mds-text-input .mds-text-input__input:not(.mds-text-input__input--error):focus.mds-text-input__input--line{box-shadow:inset 0 -2px 0 0 var(--MdsTextInput__borderColor--active,#005eb8)}:host .mds-text-input--centered .mds-text-input__label{display:flex;justify-content:var(--MdsTextInputSecure-_centered-true__microcopyTextAlignment,center)}:host .mds-text-input--centered .mds-text-input__input{text-align:var(--MdsTextInput-_centered-true__fieldTextAlignment,center)}:host .mds-text-input--centered .mds-text-input__microcopy{text-align:var(--MdsTextInput-_centered-true__labelTextAlignment,center)}:host .mds-text-input--centered .mds-text-input__error-microcopy{justify-content:var(--MdsTextInput-_centered-true__labelTextAlignment,center)}:host .mds-text-input--vertical-label .mds-text-input__label-wrap--box{padding-bottom:var(--MdsTextInput-_variant-box__fieldTopMargin,8px)}:host .mds-text-input--horizontal-label{display:flex}:host .mds-text-input--horizontal-label .mds-text-input__label-wrap{justify-content:flex-end;display:flex}:host .mds-text-input--horizontal-label .mds-text-input__label-wrap .mds-text-input__label{font-size:var(--MdsTextInput-_layout-horizontal__labelTextSize,1rem);text-align:right;line-height:var(--MdsTextInput__fieldTextLineHeight,1.5rem);align-self:inherit}:host .mds-text-input--horizontal-label .mds-text-input__label-wrap .mds-text-input__label.mds-text-input__label--box{margin-top:var(--MdsTextInput-_variant-box__fieldTopMargin,8px)}:host .mds-text-input--horizontal-label .mds-text-input__input{margin-top:var(--MdsTextInput__fieldTopMargin,0)}:host .mds-text-input--floating-label{position:relative}:host .mds-text-input--floating-label .mds-text-input__label{z-index:1;position:absolute;transition-property:all;transition-duration:var(--MdsTextInput-_floatingLabel-true__labelTransitionTime,.2s);transition-timing-function:var(--MdsTextInput-_floatingLabel-true__labelTransitionEase,cubic-bezier(0,.2,.1,1));font-size:var(--MdsTextInput__fieldTextSize,1rem)}:host .mds-text-input--floating-label .mds-text-input__label-wrap{display:block}:host .mds-text-input--floating-label .mds-text-input__label--box{top:.625rem;padding-left:var(--MdsTextInput-_variant-box__fieldLeadingPadding,16px)}:host .mds-text-input--floating-label .mds-text-input__label--box.mds-text-input__label--with-field-prefix{padding-left:calc(var(--MdsTextInput-_fieldPrefix-true__iconWidth, 24px) + var(--MdsTextInput-_variant-box__fieldLeadingPadding, 16px))}:host .mds-text-input--floating-label .mds-text-input__label--box.mds-text-input__label--floating{font-size:var(--MdsTextInput__labelTextSize,.875rem);transform:translate(calc(var(--MdsTextInput-_variant-box__fieldLeadingPadding, 16px)*-1),calc(var(--MdsTextInput__labelTextLineHeight, 1.25rem)*-1 + var(--MdsTextInput-_variant-box__fieldTopPadding, .5rem)*-1 + var(--MdsTextInput-_variant-box__fieldTopMargin, .5rem)*-1))}:host .mds-text-input--floating-label .mds-text-input__label--box.mds-text-input__label--floating-with-icon{transform:translate(calc(var(--MdsTextInput-_fieldPrefix-true__iconWidth, 24px) + var(--MdsTextInput-_variant-box__fieldLeadingPadding, 16px)*-1),calc(var(--MdsTextInput__labelTextLineHeight, 1.25rem)*-1 + var(--MdsTextInput-_variant-box__fieldTopPadding, .5rem)*-1 + var(--MdsTextInput-_variant-box__fieldTopMargin, .5rem)*-1))}:host .mds-text-input--floating-label .mds-text-input__label--line{top:.125rem}:host .mds-text-input--floating-label .mds-text-input__label--line.mds-text-input__label--with-field-prefix{padding-left:calc(var(--MdsTextInput-_fieldPrefix-true__iconWidth, 24px) + var(--MdsTextInput-_fieldPrefix-true__iconTrailingPadding, 8px))}:host .mds-text-input--floating-label .mds-text-input__label--line.mds-text-input__label--floating{transform:translateY(calc(var(--MdsTextInput__fieldTextLineHeight, 1.5rem)*-1));font-size:var(--MdsTextInput__labelTextSize,.875rem)}:host .mds-text-input--floating-label .mds-text-input__label--line.mds-text-input__label--floating-with-icon{transform:translate(-1.75rem,calc(var(--MdsTextInput__fieldTextLineHeight, 1.5rem)*-1))}:host .mds-text-input__spinner-container{display:flex;flex-direction:row;overflow:hidden;right:.3125rem;top:.5rem;position:absolute;justify-content:center;align-items:center}:host .mds-text-input__spinner-container--line{right:0;top:-.125rem}:host .mds-text-input__spinner-container--hero{bottom:0;top:0}:host .mds-text-input__spinner-circle{height:var(--MdsTextInput-_waitingState-true__spinnerContainerHeight,24px);width:var(--MdsTextInput-_waitingState-true__spinnerContainerWidth,24px);border-radius:50%;animation:rotateThis var(--MdsTextInput-_waitingState-true__spinnerAnimationDuration,1.5s) linear infinite;border-right:var(--MdsTextInput-_waitingState-true__spinnerBorderWidth,2px) solid var(--MdsTextInput-_waitingState-true__spinnerBorderColor,#daeffe);border:var(--MdsTextInput-_waitingState-true__spinnerBorderWidth,2px) solid var(--MdsTextInput-_waitingState-true__spinnerBorderColor,#daeffe);border-right-color:var(--MdsTextInput-_waitingState-true__spinnerDeterminateBorderColor,#005eb8)}@media (prefers-reduced-motion:reduce){:host .mds-text-input__spinner-circle .mds-text-input__spinner-circle{border-bottom:var(--MdsTextInput-_waitingState-true__spinnerBorderWidth,2px) solid var(--MdsTextInput-_waitingState-true__spinnerBorderColor,#daeffe);border-left:var(--MdsTextInput-_waitingState-true__spinnerBorderWidth,2px) solid var(--MdsTextInput-_waitingState-true__spinnerDeterminateBorderColor,#005eb8);transform:rotate(-45deg);animation:none}}@keyframes rotateThis{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}:host .mds-text-input__character-count{color:var(--MdsTextInput-_characterCount-true__textColor,#565a5d);font-size:var(--MdsTextInput__errorMessageTextSize--error,.75rem);line-height:var(--MdsTextInput__errorMessageTextLineHeight--error,1rem);padding-top:var(--MdsTextInput__microcopyTopPadding,4px);max-height:calc(var(--MdsTextInput-_characterCount-true__textLineHeight, 1rem) + var(--MdsTextInput__microcopyTopPadding, .25rem));margin:0;display:inline-block}:host .mds-text-input__character-count--error{display:flex;margin-top:var(--AbstractMdsTextField__errorMessageTopPadding--error,4px)}:host .mds-text-input__microcopy{color:var(--MdsTextInput__microcopyTextColor,#565a5d);font-size:var(--MdsTextInput__microcopyTextSize,.75rem);line-height:var(--MdsTextInput__microcopyTextLineHeight,1rem);font-weight:var(--MdsTextInput__microcopyTextWeight,400);text-align:var(--MdsTextInput__microcopyTextAlignment,left);padding-top:var(--MdsTextInput__microcopyTopPadding,4px);margin:0}:host .mds-text-input__error-microcopy{margin-top:calc(var(--AbstractMdsTextField__errorMessageTopPadding--error, 4px) - 2);display:flex}:host .mds-text-input__error-microcopy-accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .mds-text-input__error-microcopy-accessible-text--hidden{display:none}:host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .text-input-secure__icon--field-suffix.mds-text-input__icon{align-items:center;right:0;top:0}:host .text-input-secure__icon--field-suffix.mds-text-input__icon:focus{outline:.0625rem dashed #717171}:host .text-input-secure__icon--field-suffix.mds-text-input__icon--box{margin-right:var(--MdsTextInputSecure-_variant-box__buttonTrailingMargin,8px);margin-top:var(--MdsTextInputSecure-_variant-box__buttonTopMargin,6px);margin-bottom:var(--MdsTextInputSecure-_variant-box__buttonBottomMargin,6px)}:host .text-input-secure__icon--field-suffix.mds-text-input__icon--box--horizontal{right:var(--MdsTextInputSecure-_variant-box__buttonTrailingMargin,8px)}:host .text-input-secure__icon--field-suffix.mds-text-input__icon--line{margin-right:var(--MdsTextInputSecure__buttonTrailingMargin,0);margin-top:var(--MdsTextInputSecure__buttonTopMargin,0);margin-bottom:var(--MdsTextInputSecure__buttonBottomMargin,4px)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/text-input/error-message/mds-error-message.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ':host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif;box-sizing:border-box}:host .alert{background-color:transparent;position:relative;display:inline-flex;flex-direction:column}:host .alert__header{display:flex;flex-direction:row;align-items:flex-start}:host .alert--background{display:flex;padding-top:var(--MdsAlert-_background-true__topPadding,8px);padding-bottom:var(--MdsAlert-_background-true__bottomPadding,8px);background-color:var(--MdsAlert-_background-true__backgroundColor,#f5f7f8)}:host .alert--background.alert--inverse{background-color:var(--MdsAlert-_background-true-_inverse-true__backgroundColor,#414042)}:host .alert--background.alert--base.alert--message{padding-top:var(--MdsAlert-_background-true-_variant-informational-_size-small__topPadding,4px);padding-bottom:var(--MdsAlert-_background-true-_variant-informational-_size-small__bottomPadding,4px)}:host .alert--background.alert--informational.alert--small{padding-top:var(--MdsAlert-_background-true-_variant-informational-_size-small__containerTopMargin,8px);padding-bottom:var(--MdsAlert-_background-true-_variant-informational-_size-small__containerBottomMargin,8px)}:host .alert--background.alert--informational.alert--mini{padding-top:var(--MdsAlert-_background-true-_variant-informational-_size-mini__containerTopMargin,8px);padding-bottom:var(--MdsAlert-_background-true-_variant-informational-_size-mini__containerBottomMargin,8px)}:host .alert--background.alert--base{padding-top:var(--MdsAlert-_background-true-_size-base__topPadding,4px);padding-bottom:var(--MdsAlert-_background-true-_size-base__bottom_padding,4px)}:host .alert--background.alert--base.alert--informational{padding-top:var(--MdsAlert-_background-true-_variant-informational-_size-base__containerTopMargin,4px);padding-bottom:var(--MdsAlert-_background-true-_variant-informational-_size-base__containerBottomMargin,4px)}:host .alert .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .alert__icon{display:inline-flex;align-items:center;margin-right:var(--MdsAlert__iconTrailingMargin,8px);border:0;padding:0;margin-top:var(--MdsAlert__iconTopMargin,4px)}:host .alert__icon svg{height:var(--MdsAlert__iconHeight,20px);width:var(--MdsAlert__iconHeight,20px);fill:var(--MdsAlert-_variant-success__iconColor,#4ea000)}:host .alert__icon--small{margin-right:var(--MdsAlert__iconTrailingMargin,8px);margin-top:var(--MdsAlert-_size-small__iconTopMargin,2px)}:host .alert__icon--small svg{height:var(--MdsAlert-_size-small__iconHeight,16px);width:var(--MdsAlert-_size-small__iconHeight,16px)}:host .alert__icon--mini{margin-right:var(--MdsAlert__iconTrailingMargin,8px);margin-top:var(--MdsAlert-_size-mini__iconTopMargin,2px)}:host .alert__icon--mini svg{height:var(--MdsAlert-_size-mini__iconHeight,12px);width:var(--MdsAlert-_size-mini__iconHeight,12px)}:host .alert__icon--informational svg{fill:var(--MdsAlert-_variant-informational__iconColor,#004692)}:host .alert__icon--error svg{fill:var(--MdsAlert-_variant-error__iconColor,#b80009)}:host .alert__icon--soft svg{fill:var(--MdsAlert-_variant-soft__iconColor,#e35205)}:host .alert__icon--soft-full-width svg{fill:var(--MdsAlert-_variant-soft-_fullWidth-true__iconColor,#e35205)}:host .alert__close-button{margin-left:var(--MdsAlert__closeButtonLeadingMargin,8px);margin-top:calc(var(--MdsButton__minHeight, 36px)/2*-1 - var(--MdsAlert__titleTextLineHeight, 28px)/2*-1)}:host .alert__close-button--small{margin-top:calc(var(--MdsButton-_small-true__minHeight, 28px)/2*-1 - var(--MdsAlert-_size-small__titleTextLineHeight, 20px)/2*-1)}:host .alert__close-button--mini{margin-top:calc(var(--MdsButton-_small-true__minHeight, 28px)/2*-1 - var(--MdsAlert-_size-mini__titleTextLineHeight, 16px)/2*-1)}:host .alert__close-button--container{display:flex;flex-grow:2;justify-content:flex-end}:host .alert--full-width{display:flex}:host .alert--full-width .alert__close-button{margin-left:auto}:host .alert__desc{flex-direction:column}:host .alert__desc-blk1{flex-grow:1}:host .alert__title{color:var(--MdsAlert-_variant-success__titleTextColor,#101820);font-size:var(--MdsAlert__titleTextSize,1.125rem);font-weight:var(--MdsAlert__titleTextWeight,400);line-height:var(--MdsAlert__titleTextLineHeight,1.75rem);overflow-wrap:break-word;display:inline;margin:0}:host .alert__title--error{color:var(--MdsAlert-_variant-error__titleTextColor,#b80009)}:host .alert__title--soft{color:var(--MdsAlert-_variant-soft__titleTextColor,#101820)}:host .alert__title--informational{color:var(--MdsAlert-_variant-informational__titleTextColor,#414042)}:host .alert__title--ada{white-space:nowrap}:host .alert__title--small{font-size:var(--MdsAlert-_size-small__titleTextSize,.875rem);line-height:var(--MdsAlert-_size-small__titleTextLineHeight,1.25rem)}:host .alert__title--mini{font-size:var(--MdsAlert-_size-mini__titleTextSize,.75rem);line-height:var(--MdsAlert-_size-mini__titleTextLineHeight,1rem)}:host .alert__title-text:focus{outline:none}:host .alert__message{color:var(--MdsAlert__messageTextColor,#717171);font-size:var(--MdsAlert__messageTextSize,.875rem);font-weight:var(--MdsAlert__messageTextWeight,400);line-height:var(--MdsAlert__messageTextLineHeight,1.25rem);margin-top:var(--MdsAlert__messageTopMargin,4px);margin-left:var(--MdsAlert__messageLeadingMargin,28px)}:host .alert__message--mini{font-size:var(--MdsAlert-_size-mini__messageTextSize,.75rem);line-height:var(--MdsAlert-_size-mini__messageTextLineHeight,1rem);margin-top:var(--MdsAlert-_size-mini__messageTopMargin,0);margin-left:var(--MdsAlert-_size-mini__messageLeadingMargin,20px)}:host .alert__message--small{font-size:var(--MdsAlert-_size-small__messageTextSize,.75rem);line-height:var(--MdsAlert-_size-small__messageTextLineHeight,1rem);margin-top:var(--MdsAlert-_size-small__messageTopMargin,2px);margin-left:var(--MdsAlert-_size-small__messageLeadingMargin,24px)}:host .alert__message-informational--base{padding-bottom:var(--MdsAlert-_background-true-_variant-informational-_size-base__bottomPadding,)}:host .alert__message-informational--small{padding-bottom:var(--MdsAlert-_background-true-_variant-informational-_size-small__bottomPadding,)}:host .alert__message-informational--mini{padding-bottom:var(--MdsAlert-_background-true-_variant-informational-_size-mini__bottomPadding,)}:host .alert--inverse .alert__title{color:var(--MdsAlert-_inverse-true__titleTextColor,#fff)}:host .alert--inverse .alert__message{color:var(--MdsAlert-_inverse-true__messageTextColor,hsla(0,0%,100%,.75))}:host .alert--inverse .alert__icon--informational svg{fill:var(--MdsAlert-_variant-informational-_inverse-true__iconColor,#74bcf9)}:host .alert--inverse .alert__icon--error,:host .alert--inverse .alert__icon--success{position:relative;z-index:1}:host .alert--inverse .alert__icon--error:after,:host .alert--inverse .alert__icon--success:after{content:"";background-color:#fff;position:absolute;border-radius:50%;height:calc(var(--MdsAlert__iconHeight, 20px) - .4375rem);width:calc(var(--MdsAlert__iconWidth, 20px) - var(--MdsAlert__iconTopMargin, 4px));margin-left:calc(var(--MdsAlert__iconTopMargin, 4px)/2);margin-top:calc(var(--MdsAlert__iconTopMargin, 4px)/2);z-index:-1}:host .alert--inverse .alert__icon--error.alert__icon--small:after,:host .alert--inverse .alert__icon--success.alert__icon--small:after{height:calc(var(--MdsAlert-_size-small__iconHeight, 16px) - .4375rem);width:calc(var(--MdsAlert-_size-small__iconWidth, 16px) - var(--MdsAlert-_size-small__iconTopMargin, default-brand-get(mds-alert-size-small-icon-top-margin))*2);margin-top:var(--MdsAlert-_size-small__iconTopMargin,2px)}:host .alert--inverse .alert__icon--error.alert__icon--mini:after,:host .alert--inverse .alert__icon--success.alert__icon--mini:after{height:calc(var(--MdsAlert-_size-mini__iconHeight, 12px) - var(--MdsAlert-_size-mini__iconTopMargin, 2px)*2);width:calc(var(--MdsAlert-_size-mini__iconWidth, 12px) - var(--MdsAlert-_size-mini__iconTopMargin, 2px)*2);margin-top:var(--MdsAlert-_size-mini__iconTopMargin,2px)}:host #title-focus-target:focus{outline:none}:host .alert__icon--hide{opacity:0}:host .alert__title{text-align:left}', "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/text-input/mds-text-input.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ".mds-container{box-sizing:border-box;margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px;width:100%}@media print,screen and (min-width:576px){.mds-container{max-width:540px}}@media print,screen and (min-width:768px){.mds-container{max-width:720px}}@media print,screen and (min-width:992px){.mds-container{max-width:960px}}@media print,screen and (min-width:1200px){.mds-container{max-width:1140px}}.mds-container-at-576,.mds-container-at-768,.mds-container-at-992,.mds-container-at-1200,.mds-container-fluid{box-sizing:border-box;margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px;width:100%}@media print,screen and (min-width:576px){.mds-container,.mds-container-at-576{max-width:var(--mds-container-max-width-at-576,540px)}}@media print,screen and (min-width:768px){.mds-container,.mds-container-at-576,.mds-container-at-768{max-width:var(--mds-container-max-width-at-768,720px)}}@media print,screen and (min-width:992px){.mds-container,.mds-container-at-576,.mds-container-at-768,.mds-container-at-992{max-width:var(--mds-container-max-width-at-992,960px)}}@media print,screen and (min-width:1200px){.mds-container,.mds-container-at-576,.mds-container-at-768,.mds-container-at-992,.mds-container-at-1200{max-width:var(--mds-container-max-width-at-1200,1140px)}}.mds-row{display:flex;flex-wrap:wrap;margin-left:-15px;margin-right:-15px}.mds-no-gutters{margin-left:0;margin-right:0}.mds-no-gutters>.mds-col,.mds-no-gutters>[class*=mds-col-]{padding-left:0;padding-right:0}.mds-col,.mds-col-1,.mds-col-2,.mds-col-3,.mds-col-4,.mds-col-5,.mds-col-6,.mds-col-7,.mds-col-8,.mds-col-9,.mds-col-10,.mds-col-11,.mds-col-12,.mds-col-at-576,.mds-col-at-576-1,.mds-col-at-576-2,.mds-col-at-576-3,.mds-col-at-576-4,.mds-col-at-576-5,.mds-col-at-576-6,.mds-col-at-576-7,.mds-col-at-576-8,.mds-col-at-576-9,.mds-col-at-576-10,.mds-col-at-576-11,.mds-col-at-576-12,.mds-col-at-576-auto,.mds-col-at-768,.mds-col-at-768-1,.mds-col-at-768-2,.mds-col-at-768-3,.mds-col-at-768-4,.mds-col-at-768-5,.mds-col-at-768-6,.mds-col-at-768-7,.mds-col-at-768-8,.mds-col-at-768-9,.mds-col-at-768-10,.mds-col-at-768-11,.mds-col-at-768-12,.mds-col-at-768-auto,.mds-col-at-992,.mds-col-at-992-1,.mds-col-at-992-2,.mds-col-at-992-3,.mds-col-at-992-4,.mds-col-at-992-5,.mds-col-at-992-6,.mds-col-at-992-7,.mds-col-at-992-8,.mds-col-at-992-9,.mds-col-at-992-10,.mds-col-at-992-11,.mds-col-at-992-12,.mds-col-at-992-auto,.mds-col-at-1200,.mds-col-at-1200-1,.mds-col-at-1200-2,.mds-col-at-1200-3,.mds-col-at-1200-4,.mds-col-at-1200-5,.mds-col-at-1200-6,.mds-col-at-1200-7,.mds-col-at-1200-8,.mds-col-at-1200-9,.mds-col-at-1200-10,.mds-col-at-1200-11,.mds-col-at-1200-12,.mds-col-at-1200-auto,.mds-col-auto{box-sizing:border-box;position:relative;width:100%;padding-left:8px;padding-right:8px}@media print,screen and (min-width:576px){.mds-col,.mds-col-1,.mds-col-2,.mds-col-3,.mds-col-4,.mds-col-5,.mds-col-6,.mds-col-7,.mds-col-8,.mds-col-9,.mds-col-10,.mds-col-11,.mds-col-12,.mds-col-at-576,.mds-col-at-576-1,.mds-col-at-576-2,.mds-col-at-576-3,.mds-col-at-576-4,.mds-col-at-576-5,.mds-col-at-576-6,.mds-col-at-576-7,.mds-col-at-576-8,.mds-col-at-576-9,.mds-col-at-576-10,.mds-col-at-576-11,.mds-col-at-576-12,.mds-col-at-576-auto,.mds-col-at-768,.mds-col-at-768-1,.mds-col-at-768-2,.mds-col-at-768-3,.mds-col-at-768-4,.mds-col-at-768-5,.mds-col-at-768-6,.mds-col-at-768-7,.mds-col-at-768-8,.mds-col-at-768-9,.mds-col-at-768-10,.mds-col-at-768-11,.mds-col-at-768-12,.mds-col-at-768-auto,.mds-col-at-992,.mds-col-at-992-1,.mds-col-at-992-2,.mds-col-at-992-3,.mds-col-at-992-4,.mds-col-at-992-5,.mds-col-at-992-6,.mds-col-at-992-7,.mds-col-at-992-8,.mds-col-at-992-9,.mds-col-at-992-10,.mds-col-at-992-11,.mds-col-at-992-12,.mds-col-at-992-auto,.mds-col-at-1200,.mds-col-at-1200-1,.mds-col-at-1200-2,.mds-col-at-1200-3,.mds-col-at-1200-4,.mds-col-at-1200-5,.mds-col-at-1200-6,.mds-col-at-1200-7,.mds-col-at-1200-8,.mds-col-at-1200-9,.mds-col-at-1200-10,.mds-col-at-1200-11,.mds-col-at-1200-12,.mds-col-at-1200-auto,.mds-col-auto{padding-left:8px;padding-right:8px}}@media print,screen and (min-width:768px){.mds-col,.mds-col-1,.mds-col-2,.mds-col-3,.mds-col-4,.mds-col-5,.mds-col-6,.mds-col-7,.mds-col-8,.mds-col-9,.mds-col-10,.mds-col-11,.mds-col-12,.mds-col-at-576,.mds-col-at-576-1,.mds-col-at-576-2,.mds-col-at-576-3,.mds-col-at-576-4,.mds-col-at-576-5,.mds-col-at-576-6,.mds-col-at-576-7,.mds-col-at-576-8,.mds-col-at-576-9,.mds-col-at-576-10,.mds-col-at-576-11,.mds-col-at-576-12,.mds-col-at-576-auto,.mds-col-at-768,.mds-col-at-768-1,.mds-col-at-768-2,.mds-col-at-768-3,.mds-col-at-768-4,.mds-col-at-768-5,.mds-col-at-768-6,.mds-col-at-768-7,.mds-col-at-768-8,.mds-col-at-768-9,.mds-col-at-768-10,.mds-col-at-768-11,.mds-col-at-768-12,.mds-col-at-768-auto,.mds-col-at-992,.mds-col-at-992-1,.mds-col-at-992-2,.mds-col-at-992-3,.mds-col-at-992-4,.mds-col-at-992-5,.mds-col-at-992-6,.mds-col-at-992-7,.mds-col-at-992-8,.mds-col-at-992-9,.mds-col-at-992-10,.mds-col-at-992-11,.mds-col-at-992-12,.mds-col-at-992-auto,.mds-col-at-1200,.mds-col-at-1200-1,.mds-col-at-1200-2,.mds-col-at-1200-3,.mds-col-at-1200-4,.mds-col-at-1200-5,.mds-col-at-1200-6,.mds-col-at-1200-7,.mds-col-at-1200-8,.mds-col-at-1200-9,.mds-col-at-1200-10,.mds-col-at-1200-11,.mds-col-at-1200-12,.mds-col-at-1200-auto,.mds-col-auto{padding-left:12px;padding-right:12px}}@media print,screen and (min-width:992px){.mds-col,.mds-col-1,.mds-col-2,.mds-col-3,.mds-col-4,.mds-col-5,.mds-col-6,.mds-col-7,.mds-col-8,.mds-col-9,.mds-col-10,.mds-col-11,.mds-col-12,.mds-col-at-576,.mds-col-at-576-1,.mds-col-at-576-2,.mds-col-at-576-3,.mds-col-at-576-4,.mds-col-at-576-5,.mds-col-at-576-6,.mds-col-at-576-7,.mds-col-at-576-8,.mds-col-at-576-9,.mds-col-at-576-10,.mds-col-at-576-11,.mds-col-at-576-12,.mds-col-at-576-auto,.mds-col-at-768,.mds-col-at-768-1,.mds-col-at-768-2,.mds-col-at-768-3,.mds-col-at-768-4,.mds-col-at-768-5,.mds-col-at-768-6,.mds-col-at-768-7,.mds-col-at-768-8,.mds-col-at-768-9,.mds-col-at-768-10,.mds-col-at-768-11,.mds-col-at-768-12,.mds-col-at-768-auto,.mds-col-at-992,.mds-col-at-992-1,.mds-col-at-992-2,.mds-col-at-992-3,.mds-col-at-992-4,.mds-col-at-992-5,.mds-col-at-992-6,.mds-col-at-992-7,.mds-col-at-992-8,.mds-col-at-992-9,.mds-col-at-992-10,.mds-col-at-992-11,.mds-col-at-992-12,.mds-col-at-992-auto,.mds-col-at-1200,.mds-col-at-1200-1,.mds-col-at-1200-2,.mds-col-at-1200-3,.mds-col-at-1200-4,.mds-col-at-1200-5,.mds-col-at-1200-6,.mds-col-at-1200-7,.mds-col-at-1200-8,.mds-col-at-1200-9,.mds-col-at-1200-10,.mds-col-at-1200-11,.mds-col-at-1200-12,.mds-col-at-1200-auto,.mds-col-auto{padding-left:12px;padding-right:12px}}@media print,screen and (min-width:1200px){.mds-col,.mds-col-1,.mds-col-2,.mds-col-3,.mds-col-4,.mds-col-5,.mds-col-6,.mds-col-7,.mds-col-8,.mds-col-9,.mds-col-10,.mds-col-11,.mds-col-12,.mds-col-at-576,.mds-col-at-576-1,.mds-col-at-576-2,.mds-col-at-576-3,.mds-col-at-576-4,.mds-col-at-576-5,.mds-col-at-576-6,.mds-col-at-576-7,.mds-col-at-576-8,.mds-col-at-576-9,.mds-col-at-576-10,.mds-col-at-576-11,.mds-col-at-576-12,.mds-col-at-576-auto,.mds-col-at-768,.mds-col-at-768-1,.mds-col-at-768-2,.mds-col-at-768-3,.mds-col-at-768-4,.mds-col-at-768-5,.mds-col-at-768-6,.mds-col-at-768-7,.mds-col-at-768-8,.mds-col-at-768-9,.mds-col-at-768-10,.mds-col-at-768-11,.mds-col-at-768-12,.mds-col-at-768-auto,.mds-col-at-992,.mds-col-at-992-1,.mds-col-at-992-2,.mds-col-at-992-3,.mds-col-at-992-4,.mds-col-at-992-5,.mds-col-at-992-6,.mds-col-at-992-7,.mds-col-at-992-8,.mds-col-at-992-9,.mds-col-at-992-10,.mds-col-at-992-11,.mds-col-at-992-12,.mds-col-at-992-auto,.mds-col-at-1200,.mds-col-at-1200-1,.mds-col-at-1200-2,.mds-col-at-1200-3,.mds-col-at-1200-4,.mds-col-at-1200-5,.mds-col-at-1200-6,.mds-col-at-1200-7,.mds-col-at-1200-8,.mds-col-at-1200-9,.mds-col-at-1200-10,.mds-col-at-1200-11,.mds-col-at-1200-12,.mds-col-at-1200-auto,.mds-col-auto{padding-left:12px;padding-right:12px}}.mds-col{flex-basis:0;flex-grow:1;max-width:100%}.mds-col-auto{flex:0 0 auto;max-width:100%;width:auto}.mds-col-1{flex:0 0 8.33333%;max-width:8.33333%}.mds-col-2{flex:0 0 16.66667%;max-width:16.66667%}.mds-col-3{flex:0 0 25%;max-width:25%}.mds-col-4{flex:0 0 33.33333%;max-width:33.33333%}.mds-col-5{flex:0 0 41.66667%;max-width:41.66667%}.mds-col-6{flex:0 0 50%;max-width:50%}.mds-col-7{flex:0 0 58.33333%;max-width:58.33333%}.mds-col-8{flex:0 0 66.66667%;max-width:66.66667%}.mds-col-9{flex:0 0 75%;max-width:75%}.mds-col-10{flex:0 0 83.33333%;max-width:83.33333%}.mds-col-11{flex:0 0 91.66667%;max-width:91.66667%}.mds-col-12{flex:0 0 100%;max-width:100%}.mds-offset-1{margin-left:8.33333%}.mds-offset-2{margin-left:16.66667%}.mds-offset-3{margin-left:25%}.mds-offset-4{margin-left:33.33333%}.mds-offset-5{margin-left:41.66667%}.mds-offset-6{margin-left:50%}.mds-offset-7{margin-left:58.33333%}.mds-offset-8{margin-left:66.66667%}.mds-offset-9{margin-left:75%}.mds-offset-10{margin-left:83.33333%}.mds-offset-11{margin-left:91.66667%}@media print,screen and (min-width:576px){.mds-col-at-576{flex-basis:0;flex-grow:1;max-width:100%}.mds-col-at-576-auto{flex:0 0 auto;max-width:100%;width:auto}.mds-col-at-576-1{flex:0 0 8.33333%;max-width:8.33333%}.mds-col-at-576-2{flex:0 0 16.66667%;max-width:16.66667%}.mds-col-at-576-3{flex:0 0 25%;max-width:25%}.mds-col-at-576-4{flex:0 0 33.33333%;max-width:33.33333%}.mds-col-at-576-5{flex:0 0 41.66667%;max-width:41.66667%}.mds-col-at-576-6{flex:0 0 50%;max-width:50%}.mds-col-at-576-7{flex:0 0 58.33333%;max-width:58.33333%}.mds-col-at-576-8{flex:0 0 66.66667%;max-width:66.66667%}.mds-col-at-576-9{flex:0 0 75%;max-width:75%}.mds-col-at-576-10{flex:0 0 83.33333%;max-width:83.33333%}.mds-col-at-576-11{flex:0 0 91.66667%;max-width:91.66667%}.mds-col-at-576-12{flex:0 0 100%;max-width:100%}.mds-offset-at-576-0{margin-left:0}.mds-offset-at-576-1{margin-left:8.33333%}.mds-offset-at-576-2{margin-left:16.66667%}.mds-offset-at-576-3{margin-left:25%}.mds-offset-at-576-4{margin-left:33.33333%}.mds-offset-at-576-5{margin-left:41.66667%}.mds-offset-at-576-6{margin-left:50%}.mds-offset-at-576-7{margin-left:58.33333%}.mds-offset-at-576-8{margin-left:66.66667%}.mds-offset-at-576-9{margin-left:75%}.mds-offset-at-576-10{margin-left:83.33333%}.mds-offset-at-576-11{margin-left:91.66667%}}@media print,screen and (min-width:768px){.mds-col-at-768{flex-basis:0;flex-grow:1;max-width:100%}.mds-col-at-768-auto{flex:0 0 auto;max-width:100%;width:auto}.mds-col-at-768-1{flex:0 0 8.33333%;max-width:8.33333%}.mds-col-at-768-2{flex:0 0 16.66667%;max-width:16.66667%}.mds-col-at-768-3{flex:0 0 25%;max-width:25%}.mds-col-at-768-4{flex:0 0 33.33333%;max-width:33.33333%}.mds-col-at-768-5{flex:0 0 41.66667%;max-width:41.66667%}.mds-col-at-768-6{flex:0 0 50%;max-width:50%}.mds-col-at-768-7{flex:0 0 58.33333%;max-width:58.33333%}.mds-col-at-768-8{flex:0 0 66.66667%;max-width:66.66667%}.mds-col-at-768-9{flex:0 0 75%;max-width:75%}.mds-col-at-768-10{flex:0 0 83.33333%;max-width:83.33333%}.mds-col-at-768-11{flex:0 0 91.66667%;max-width:91.66667%}.mds-col-at-768-12{flex:0 0 100%;max-width:100%}.mds-offset-at-768-0{margin-left:0}.mds-offset-at-768-1{margin-left:8.33333%}.mds-offset-at-768-2{margin-left:16.66667%}.mds-offset-at-768-3{margin-left:25%}.mds-offset-at-768-4{margin-left:33.33333%}.mds-offset-at-768-5{margin-left:41.66667%}.mds-offset-at-768-6{margin-left:50%}.mds-offset-at-768-7{margin-left:58.33333%}.mds-offset-at-768-8{margin-left:66.66667%}.mds-offset-at-768-9{margin-left:75%}.mds-offset-at-768-10{margin-left:83.33333%}.mds-offset-at-768-11{margin-left:91.66667%}}@media print,screen and (min-width:992px){.mds-col-at-992{flex-basis:0;flex-grow:1;max-width:100%}.mds-col-at-992-auto{flex:0 0 auto;max-width:100%;width:auto}.mds-col-at-992-1{flex:0 0 8.33333%;max-width:8.33333%}.mds-col-at-992-2{flex:0 0 16.66667%;max-width:16.66667%}.mds-col-at-992-3{flex:0 0 25%;max-width:25%}.mds-col-at-992-4{flex:0 0 33.33333%;max-width:33.33333%}.mds-col-at-992-5{flex:0 0 41.66667%;max-width:41.66667%}.mds-col-at-992-6{flex:0 0 50%;max-width:50%}.mds-col-at-992-7{flex:0 0 58.33333%;max-width:58.33333%}.mds-col-at-992-8{flex:0 0 66.66667%;max-width:66.66667%}.mds-col-at-992-9{flex:0 0 75%;max-width:75%}.mds-col-at-992-10{flex:0 0 83.33333%;max-width:83.33333%}.mds-col-at-992-11{flex:0 0 91.66667%;max-width:91.66667%}.mds-col-at-992-12{flex:0 0 100%;max-width:100%}.mds-offset-at-992-0{margin-left:0}.mds-offset-at-992-1{margin-left:8.33333%}.mds-offset-at-992-2{margin-left:16.66667%}.mds-offset-at-992-3{margin-left:25%}.mds-offset-at-992-4{margin-left:33.33333%}.mds-offset-at-992-5{margin-left:41.66667%}.mds-offset-at-992-6{margin-left:50%}.mds-offset-at-992-7{margin-left:58.33333%}.mds-offset-at-992-8{margin-left:66.66667%}.mds-offset-at-992-9{margin-left:75%}.mds-offset-at-992-10{margin-left:83.33333%}.mds-offset-at-992-11{margin-left:91.66667%}}@media print,screen and (min-width:1200px){.mds-col-at-1200{flex-basis:0;flex-grow:1;max-width:100%}.mds-col-at-1200-auto{flex:0 0 auto;max-width:100%;width:auto}.mds-col-at-1200-1{flex:0 0 8.33333%;max-width:8.33333%}.mds-col-at-1200-2{flex:0 0 16.66667%;max-width:16.66667%}.mds-col-at-1200-3{flex:0 0 25%;max-width:25%}.mds-col-at-1200-4{flex:0 0 33.33333%;max-width:33.33333%}.mds-col-at-1200-5{flex:0 0 41.66667%;max-width:41.66667%}.mds-col-at-1200-6{flex:0 0 50%;max-width:50%}.mds-col-at-1200-7{flex:0 0 58.33333%;max-width:58.33333%}.mds-col-at-1200-8{flex:0 0 66.66667%;max-width:66.66667%}.mds-col-at-1200-9{flex:0 0 75%;max-width:75%}.mds-col-at-1200-10{flex:0 0 83.33333%;max-width:83.33333%}.mds-col-at-1200-11{flex:0 0 91.66667%;max-width:91.66667%}.mds-col-at-1200-12{flex:0 0 100%;max-width:100%}.mds-offset-at-1200-0{margin-left:0}.mds-offset-at-1200-1{margin-left:8.33333%}.mds-offset-at-1200-2{margin-left:16.66667%}.mds-offset-at-1200-3{margin-left:25%}.mds-offset-at-1200-4{margin-left:33.33333%}.mds-offset-at-1200-5{margin-left:41.66667%}.mds-offset-at-1200-6{margin-left:50%}.mds-offset-at-1200-7{margin-left:58.33333%}.mds-offset-at-1200-8{margin-left:66.66667%}.mds-offset-at-1200-9{margin-left:75%}.mds-offset-at-1200-10{margin-left:83.33333%}.mds-offset-at-1200-11{margin-left:91.66667%}}:host{display:block}:host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .mds-text-input__label{color:var(--MdsTextInput__labelTextColor,#565a5d);font-size:var(--MdsTextInput__labelTextSize,.875rem);line-height:var(--MdsTextInput__labelTextLineHeight,1.25rem);font-weight:var(--MdsTextInput__labelTextWeight,400);text-align:var(--MdsTextInput__labelTextAlignment,left)}:host .mds-text-input__label--error{color:var(--MdsTextInput__labelTextColor--error,#b80009);font-weight:var(--MdsTextInput__labelTextWeight--error,600)}:host .mds-text-input__label--hidden{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .mds-text-input .mds-text-input__input-wrap{width:100%;position:relative}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__input{padding-right:1rem}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__input--leading-icon.mds-text-input__input--line{padding-left:2rem}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__input--leading-icon.mds-text-input__input--box{padding-left:2.5rem}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__input--trailing-icon{padding-right:2.5rem}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__input--waiting-state.mds-text-input__input--line{padding-right:1.5rem}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__input--waiting-state.mds-text-input__input--box{padding-right:1.8125rem}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__icon{display:inline-flex;position:absolute}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__icon--field-prefix{pointer-events:none}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__icon--field-prefix svg{height:var(--MdsTextInput-_fieldPrefix-true__iconHeight,24px);width:var(--MdsTextInput-_fieldPrefix-true__iconWidth,24px);fill:var(--MdsTextInput__placeholderTextColor,#565a5d)}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__icon--field-suffix{top:calc(var(--MdsTextInput__borderBottomWidth--active, 2px)/2);right:calc(var(--MdsTextInput__borderBottomWidth--active, 2px)/2)}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__icon--field-suffix[hidden]{visibility:hidden}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__icon--field-suffix--horizontal{right:calc(var(--MdsTextInput__borderBottomWidth--active, 2px)/2 + .75rem)}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__icon--box.mds-text-input__icon--field-prefix{top:var(--MdsTextInput-_variant-box__fieldTopPadding,8px);left:var(--MdsTextInput-_fieldPrefix-true__iconTrailingPadding,8px)}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__icon--box.mds-text-input__icon--field-prefix--horizontal{left:calc(var(--MdsTextInput-_fieldPrefix-true__iconTrailingPadding, 8px) + .75rem)}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__icon--box.mds-text-input__icon--field-suffix{top:calc(var(--MdsTextInput-_variant-box__borderTopWidth--active, 2px) + .0625rem);right:calc(var(--MdsTextInput-_variant-box__borderTrailingWidth--active, 2px) + .0625rem)}:host .mds-text-input .mds-text-input__input-wrap .mds-text-input__icon--box.mds-text-input__icon--field-suffix--horizontal{right:calc(var(--MdsTextInput-_variant-box__borderTrailingWidth--active, 2px) + .8125rem)}:host .mds-text-input .mds-text-input__formatted-text{color:var(--MdsTextInput__formatterTextColor,#101820);font-weight:var(--MdsTextInput__formatterTextWeight,600);font-size:var(--MdsTextInput__formatterTextSize,.875rem);line-height:var(--MdsTextInput__formatterTextLineHeight,1.25rem);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}:host .mds-text-input .mds-text-input__formatted-text--horizontal{width:100%;margin-left:0;position:absolute;left:0;top:-1.75rem}:host .mds-text-input .mds-text-input__formatted-text--hidden{visibility:hidden}:host .mds-text-input .mds-text-input__formatted-text-vertical{margin-left:var(--MdsTextInput__formatterTextLeadingPadding,8px)}:host .mds-text-input .mds-text-input__formatted-text-horizontal{padding-left:.25rem}:host .mds-text-input .mds-text-input__input{width:100%;display:block;-webkit-appearance:none;-moz-appearance:none;appearance:none;color:var(--MdsTextInput__fieldTextColor,#101820);font-size:var(--MdsTextInput__fieldTextSize,1rem);padding:var(--MdsTextInput__fieldTopPadding,0) var(--MdsTextInput__fieldTrailingPadding,0) var(--MdsTextInput__fieldBottomPadding,8px) var(--MdsTextInput__fieldLeadingPadding,0);margin-top:var(--MdsTextInput__fieldTopMargin,0);font-weight:var(--MdsTextInput__fieldTextWeight,400);line-height:var(--MdsTextInput__fieldTextLineHeight,1.5rem);text-align:var(--MdsTextInput__fieldTextAlignment,left);border-radius:var(--MdsTextInput__borderRadius,0);border:0;font-family:inherit}:host .mds-text-input .mds-text-input__input:focus{outline:none}:host .mds-text-input .mds-text-input__input::-moz-placeholder{color:var(--MdsTextInput__placeholderTextColor,#565a5d);opacity:1}:host .mds-text-input .mds-text-input__input::placeholder{color:var(--MdsTextInput__placeholderTextColor,#565a5d);opacity:1}:host .mds-text-input .mds-text-input__input--box{padding:var(--MdsTextInput-_variant-box__fieldTopPadding,8px) var(--MdsTextInput-_variant-box__fieldTrailingPadding,16px) var(--MdsTextInput-_variant-box__fieldBottomPadding,8px) var(--MdsTextInput-_variant-box__fieldLeadingPadding,16px);min-height:calc(var(--MdsTextInput__fieldTextLineHeight, 1.5rem) + var(--MdsTextInput-_variant-box__fieldTopPadding, .5rem) + var(--MdsTextInput-_variant-box__fieldBottomPadding, .5rem));box-shadow:inset 0 0 0 var(--MdsTextInput__borderBottomWidth,1px) var(--MdsTextInput__borderColor,#949494)}:host .mds-text-input .mds-text-input__input--box:disabled{box-shadow:inset 0 0 0 var(--MdsTextInput__borderBottomWidth,1px) var(--MdsTextInput__borderColor--disabled,#bcbcbc);color:var(--MdsTextInput__fieldTextColor--disabled,#565a5d)}:host .mds-text-input .mds-text-input__input--line{box-shadow:inset 0 calc(var(--MdsTextInput__borderBottomWidth, 1px)*-1) 0 0 var(--MdsTextInput__borderColor,#949494);min-height:calc(var(--MdsTextInput__fieldTextLineHeight, 1.5rem) + var(--MdsTextInput__fieldBottomPadding, .5rem));background-color:transparent}:host .mds-text-input .mds-text-input__input--line:disabled{box-shadow:inset 0 calc(var(--MdsTextInput__borderBottomWidth, 1px)*-1) 0 0 var(--MdsTextInput__borderColor--disabled,#bcbcbc);color:var(--MdsTextInput__fieldTextColor--disabled,#565a5d)}:host .mds-text-input .mds-text-input__input--line.mds-text-input__input--hero{font-size:var(--MdsTextInput-_hero-true__fieldTextSize,2.5rem);line-height:var(--MdsTextInput-_hero-true__fieldTextLineHeight,3.25rem);font-weight:var(--MdsTextInput-_hero-true__fieldTextWeight,300)}:host .mds-text-input .mds-text-input__input--multiline{z-index:2;overflow:auto}:host .mds-text-input .mds-text-input__input--error{color:var(--MdsTextInput__fieldTextColor--error,#101820);box-shadow:inset 0 0 0 var(--MdsTextInput__borderBottomWidth--error,1px) var(--MdsTextInput__borderColor--error,#b80009)}:host .mds-text-input .mds-text-input__input--error.mds-text-input__input--line{box-shadow:inset 0 calc(var(--MdsTextInput__borderBottomWidth--error, 1px)*-1) 0 0 var(--MdsTextInput__borderColor--error,#b80009)}:host .mds-text-input .mds-text-input__input--error.mds-text-input__input--focused,:host .mds-text-input .mds-text-input__input--error:focus{box-shadow:inset 0 0 0 var(--MdsTextInput__borderBottomWidth--active,2px) var(--MdsTextInput__borderColor--error,#b80009)}:host .mds-text-input .mds-text-input__input--error.mds-text-input__input--focused.mds-text-input__input--line,:host .mds-text-input .mds-text-input__input--error:focus.mds-text-input__input--line{box-shadow:inset 0 calc(var(--MdsTextInput__borderBottomWidth--active, 2px)*-1) 0 0 var(--MdsTextInput__borderColor--error,#b80009)}:host .mds-text-input .mds-text-input__input--focused:not(.mds-text-input__input--error),:host .mds-text-input .mds-text-input__input:not(.mds-text-input__input--error):focus{box-shadow:inset 0 0 0 var(--MdsTextInput-_variant-box__borderTopWidth--active,2px) var(--MdsTextInput__borderColor--active,#005eb8)}:host .mds-text-input .mds-text-input__input--focused:not(.mds-text-input__input--error).mds-text-input__input--line,:host .mds-text-input .mds-text-input__input:not(.mds-text-input__input--error):focus.mds-text-input__input--line{box-shadow:inset 0 -2px 0 0 var(--MdsTextInput__borderColor--active,#005eb8)}:host .mds-text-input--centered .mds-text-input__label{display:flex;justify-content:var(--MdsTextInputSecure-_centered-true__microcopyTextAlignment,center)}:host .mds-text-input--centered .mds-text-input__input{text-align:var(--MdsTextInput-_centered-true__fieldTextAlignment,center)}:host .mds-text-input--centered .mds-text-input__microcopy{text-align:var(--MdsTextInput-_centered-true__labelTextAlignment,center)}:host .mds-text-input--centered .mds-text-input__error-microcopy{justify-content:var(--MdsTextInput-_centered-true__labelTextAlignment,center)}:host .mds-text-input--vertical-label .mds-text-input__label-wrap--box{padding-bottom:var(--MdsTextInput-_variant-box__fieldTopMargin,8px)}:host .mds-text-input--horizontal-label{display:flex}:host .mds-text-input--horizontal-label .mds-text-input__label-wrap{justify-content:flex-end;display:flex}:host .mds-text-input--horizontal-label .mds-text-input__label-wrap .mds-text-input__label{font-size:var(--MdsTextInput-_layout-horizontal__labelTextSize,1rem);text-align:right;line-height:var(--MdsTextInput__fieldTextLineHeight,1.5rem);align-self:inherit}:host .mds-text-input--horizontal-label .mds-text-input__label-wrap .mds-text-input__label.mds-text-input__label--box{margin-top:var(--MdsTextInput-_variant-box__fieldTopMargin,8px)}:host .mds-text-input--horizontal-label .mds-text-input__input{margin-top:var(--MdsTextInput__fieldTopMargin,0)}:host .mds-text-input--floating-label{position:relative}:host .mds-text-input--floating-label .mds-text-input__label{z-index:1;position:absolute;transition-property:all;transition-duration:var(--MdsTextInput-_floatingLabel-true__labelTransitionTime,.2s);transition-timing-function:var(--MdsTextInput-_floatingLabel-true__labelTransitionEase,cubic-bezier(0,.2,.1,1));font-size:var(--MdsTextInput__fieldTextSize,1rem)}:host .mds-text-input--floating-label .mds-text-input__label-wrap{display:block}:host .mds-text-input--floating-label .mds-text-input__label--box{top:.625rem;padding-left:var(--MdsTextInput-_variant-box__fieldLeadingPadding,16px)}:host .mds-text-input--floating-label .mds-text-input__label--box.mds-text-input__label--with-field-prefix{padding-left:calc(var(--MdsTextInput-_fieldPrefix-true__iconWidth, 24px) + var(--MdsTextInput-_variant-box__fieldLeadingPadding, 16px))}:host .mds-text-input--floating-label .mds-text-input__label--box.mds-text-input__label--floating{font-size:var(--MdsTextInput__labelTextSize,.875rem);transform:translate(calc(var(--MdsTextInput-_variant-box__fieldLeadingPadding, 16px)*-1),calc(var(--MdsTextInput__labelTextLineHeight, 1.25rem)*-1 + var(--MdsTextInput-_variant-box__fieldTopPadding, .5rem)*-1 + var(--MdsTextInput-_variant-box__fieldTopMargin, .5rem)*-1))}:host .mds-text-input--floating-label .mds-text-input__label--box.mds-text-input__label--floating-with-icon{transform:translate(calc(var(--MdsTextInput-_fieldPrefix-true__iconWidth, 24px) + var(--MdsTextInput-_variant-box__fieldLeadingPadding, 16px)*-1),calc(var(--MdsTextInput__labelTextLineHeight, 1.25rem)*-1 + var(--MdsTextInput-_variant-box__fieldTopPadding, .5rem)*-1 + var(--MdsTextInput-_variant-box__fieldTopMargin, .5rem)*-1))}:host .mds-text-input--floating-label .mds-text-input__label--line{top:.125rem}:host .mds-text-input--floating-label .mds-text-input__label--line.mds-text-input__label--with-field-prefix{padding-left:calc(var(--MdsTextInput-_fieldPrefix-true__iconWidth, 24px) + var(--MdsTextInput-_fieldPrefix-true__iconTrailingPadding, 8px))}:host .mds-text-input--floating-label .mds-text-input__label--line.mds-text-input__label--floating{transform:translateY(calc(var(--MdsTextInput__fieldTextLineHeight, 1.5rem)*-1));font-size:var(--MdsTextInput__labelTextSize,.875rem)}:host .mds-text-input--floating-label .mds-text-input__label--line.mds-text-input__label--floating-with-icon{transform:translate(-1.75rem,calc(var(--MdsTextInput__fieldTextLineHeight, 1.5rem)*-1))}:host .mds-text-input__spinner-container{display:flex;flex-direction:row;overflow:hidden;right:.3125rem;top:.5rem;position:absolute;justify-content:center;align-items:center}:host .mds-text-input__spinner-container--line{right:0;top:-.125rem}:host .mds-text-input__spinner-container--hero{bottom:0;top:0}:host .mds-text-input__spinner-circle{height:var(--MdsTextInput-_waitingState-true__spinnerContainerHeight,24px);width:var(--MdsTextInput-_waitingState-true__spinnerContainerWidth,24px);border-radius:50%;animation:rotateThis var(--MdsTextInput-_waitingState-true__spinnerAnimationDuration,1.5s) linear infinite;border-right:var(--MdsTextInput-_waitingState-true__spinnerBorderWidth,2px) solid var(--MdsTextInput-_waitingState-true__spinnerBorderColor,#daeffe);border:var(--MdsTextInput-_waitingState-true__spinnerBorderWidth,2px) solid var(--MdsTextInput-_waitingState-true__spinnerBorderColor,#daeffe);border-right-color:var(--MdsTextInput-_waitingState-true__spinnerDeterminateBorderColor,#005eb8)}@media (prefers-reduced-motion:reduce){:host .mds-text-input__spinner-circle .mds-text-input__spinner-circle{border-bottom:var(--MdsTextInput-_waitingState-true__spinnerBorderWidth,2px) solid var(--MdsTextInput-_waitingState-true__spinnerBorderColor,#daeffe);border-left:var(--MdsTextInput-_waitingState-true__spinnerBorderWidth,2px) solid var(--MdsTextInput-_waitingState-true__spinnerDeterminateBorderColor,#005eb8);transform:rotate(-45deg);animation:none}}@keyframes rotateThis{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}:host .mds-text-input__character-count{color:var(--MdsTextInput-_characterCount-true__textColor,#565a5d);font-size:var(--MdsTextInput__errorMessageTextSize--error,.75rem);line-height:var(--MdsTextInput__errorMessageTextLineHeight--error,1rem);padding-top:var(--MdsTextInput__microcopyTopPadding,4px);max-height:calc(var(--MdsTextInput-_characterCount-true__textLineHeight, 1rem) + var(--MdsTextInput__microcopyTopPadding, .25rem));margin:0;display:inline-block}:host .mds-text-input__character-count--error{display:flex;margin-top:var(--AbstractMdsTextField__errorMessageTopPadding--error,4px)}:host .mds-text-input__microcopy{color:var(--MdsTextInput__microcopyTextColor,#565a5d);font-size:var(--MdsTextInput__microcopyTextSize,.75rem);line-height:var(--MdsTextInput__microcopyTextLineHeight,1rem);font-weight:var(--MdsTextInput__microcopyTextWeight,400);text-align:var(--MdsTextInput__microcopyTextAlignment,left);padding-top:var(--MdsTextInput__microcopyTopPadding,4px);margin:0}:host .mds-text-input__error-microcopy{margin-top:calc(var(--AbstractMdsTextField__errorMessageTopPadding--error, 4px) - 2);display:flex}:host .mds-text-input__error-microcopy-accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .mds-text-input__error-microcopy-accessible-text--hidden{display:none}:host .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/text-input/text-input-button/mds-text-input-button.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .text-input-button{display:flex;justify-content:center;align-items:center;cursor:pointer;transition-property:background-color;transition-duration:var(--MdsButton__stateChangeColorTransitionTime,.2s);transition-timing-function:var(--MdsButton__stateChangeColorTransitionEase,cubic-bezier(0,.4,.2,1));-webkit-appearance:none;-moz-appearance:none;appearance:none;width:var(--MdsButton-_iconPosition-icon_only__minWidth,36px);padding:0;margin:0;border:0;border-radius:var(--MdsButton__borderRadius,4px);height:calc(var(--MdsTextInput__fieldTextLineHeight, 1.5rem) + var(--MdsTextInput__borderBottomWidth--active, .125rem)*2)}:host .text-input-button:focus{outline:.0625rem dashed #717171}:host .text-input-button::-moz-focus-inner{border:0}:host .text-input-button:disabled{cursor:default}:host .text-input-button--box{height:calc(var(--MdsTextInput__fieldTextLineHeight, 1.5rem) + var(--MdsTextInput-_variant-box__fieldTopPadding, .5rem) + var(--MdsTextInput-_variant-box__fieldBottomPadding, .5rem) - var(--MdsTextInput__borderBottomWidth--active, .125rem)*3)}:host .text-input-button--clear{background:transparent}:host .text-input-button__icon{display:inline-flex;pointer-events:none}:host .text-input-button__icon svg{width:var(--MdsButton__iconWidth,20px);height:var(--MdsButton__iconHeight,20px)}:host .text-input-button .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .text-input-button:not(.text-input-button--clear){background-color:var(--MdsButton-_variant-tertiary__backgroundColor,transparent)}:host .text-input-button:not(.text-input-button--clear):hover{background-color:var(--MdsButton-_variant-tertiary__backgroundColor--hovered,rgba(0,94,184,.08))}:host .text-input-button:not(.text-input-button--clear):hover svg{fill:var(--MdsButton-_variant-tertiary__iconColor--hovered,#004692)}:host .text-input-button:not(.text-input-button--clear):active{background-color:var(--MdsButton-_variant-tertiary__backgroundColor--pressed,rgba(0,94,184,.08))}:host .text-input-button:not(.text-input-button--clear):active svg{fill:var(--MdsButton-_variant-tertiary__iconColor--pressed,#0091da)}:host .text-input-button:not(.text-input-button--clear):disabled{background-color:var(--MdsButton-_variant-tertiary__backgroundColor--disabled,#e2e4e5)}:host .text-input-button:not(.text-input-button--clear):disabled svg{fill:var(--MdsButton-_variant-tertiary__iconColor--disabled,#949494)}:host .text-input-button:not(.text-input-button--clear) svg{fill:var(--MdsButton-_variant-tertiary__iconColor,#005eb8)}:host .text-input-button--clear svg{fill:var(--MdsTextInput__fieldClearIconColor,#565a5d)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/tile-accordion/tile-accordion-item/mds-tile-accordion-item.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .tile-accordion-item{display:flex;flex-direction:column;width:100%;margin-bottom:var(--MdsAccordion__accordionVerticalMarginBetween,0)}:host .tile-accordion-item .tile-accordion-item__heading-container{z-index:1;display:flex;justify-content:space-between;width:100%}:host .tile-accordion-item .tile-accordion-item__heading{display:inline-flex;width:100%;cursor:pointer;border:0;border-radius:var(--MdsTileAccordion_item__borderRadius,2px);padding:var(--MdsTileAccordion_item__headerTopPadding,16px);margin:0;box-shadow:var(--MdsTileAccordion_item__boxShadowHorizontalOffset,0) var(--MdsTileAccordion_item__boxShadowVerticalOffset,1px) var(--MdsTileAccordion_item__boxShadowBlurRadius,3px) var(--MdsTileAccordion_item__boxShadowSpreadRadius,0) var(--MdsTileAccordion_item__boxShadowColor,rgba(0,0,0,.2));background-color:var(--MdsTileAccordion_item__backgroundColor,#fff)}:host .tile-accordion-item .tile-accordion-item__heading:focus{outline:.0625rem dashed #717171}:host .tile-accordion-item .tile-accordion-item__heading--xs{box-shadow:var(--MdsTileAccordion_item__extraSmall__boxShadowHorizontalOffset,0) var(--MdsTileAccordion_item__extraSmall__boxShadowVerticalOffset,2px) var(--MdsTileAccordion_item__extraSmall__boxShadowBlurRadius,1px) var(--MdsTileAccordion_item__extraSmall__boxShadowSpreadRadius,0) var(--MdsTileAccordion_item__extraSmall__boxShadowColor,rgba(0,0,0,.14))}:host .tile-accordion-item .tile-accordion-item__heading--xs .tile-accordion-item__heading-primary-label,:host .tile-accordion-item .tile-accordion-item__heading--xs .tile-accordion-item__heading-secondary-label{font-size:var(--MdsTileAccordion_item__extraSmall__headerTextSize,.875rem);line-height:var(--MdsTileAccordion_item__extraSmall__headerTextLineHeight,1.25rem)}:host .tile-accordion-item .tile-accordion-item__heading--xs .tile-accordion-item__heading-caret-icon{margin-top:var(--MdsAccordion__caretTopPadding,2px);padding-top:0}:host .tile-accordion-item .tile-accordion-item__heading--xs.tile-accordion-item__heading--expanded{box-shadow:var(--MdsTileAccordion_item__extraSmall__boxShadowHorizontalOffset,0) 0 var(--MdsTileAccordion_item__extraSmall__boxShadowBlurRadius,1px) var(--MdsTileAccordion_item__extraSmall__boxShadowSpreadRadius,0) var(--MdsTileAccordion_item__extraSmall__boxShadowColor,rgba(0,0,0,.14))}:host .tile-accordion-item .tile-accordion-item__heading--expanded{border-radius:var(--MdsTileAccordion_item__borderRadius,2px) var(--MdsTileAccordion_item__borderRadius,2px) 0 0;box-shadow:var(--MdsTileAccordion_item__boxShadowHorizontalOffset,0) 0 var(--MdsTileAccordion_item__boxShadowBlurRadius,3px) var(--MdsTileAccordion_item__boxShadowSpreadRadius,0) var(--MdsTileAccordion_item__boxShadowColor,rgba(0,0,0,.2))}:host .tile-accordion-item .tile-accordion-item__heading:active .tile-accordion-item__heading-icon svg{fill:initial}:host .tile-accordion-item .tile-accordion-item__heading:disabled{cursor:default}:host .tile-accordion-item .tile-accordion-item__heading:disabled .tile-accordion-item__heading-primary-label{color:var(--MdsTileAccordion_item__headerTextColor--disabled,#565a5d)}:host .tile-accordion-item .tile-accordion-item__heading:disabled .tile-accordion-item__heading-caret-icon svg{fill:var(--MdsTileAccordion_item__caretColor--disabled,#c1c3c3)}:host .tile-accordion-item .tile-accordion-item__heading-labels{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif;display:flex;flex-direction:column;width:100%;align-items:flex-start;text-align:left}:host .tile-accordion-item .tile-accordion-item__heading-labels--right{justify-content:space-between}:host .tile-accordion-item .tile-accordion-item__heading-labels--below{flex-direction:column}:host .tile-accordion-item .tile-accordion-item__heading-labels--below .tile-accordion-item__heading-secondary-label{padding-top:var(--MdsAccordion-_secondaryTextAlignment-below__secondaryTextTopPadding,4px);padding-left:0}:host .tile-accordion-item .tile-accordion-item__heading-primary-label-container{display:flex;align-items:center}:host .tile-accordion-item .tile-accordion-item__heading-primary-label{color:var(--MdsAccordion_item__labelColor,#414042);font-size:var(--MdsTileAccordion_item__headerTextSize,1.125rem);font-weight:var(--MdsTileAccordion_item__headerTextFontWeight,600);line-height:var(--MdsTileAccordion_item__headerTextLineHeight,1.75rem)}:host .tile-accordion-item .tile-accordion-item__heading-secondary-label{color:var(--MdsAccordion_item__secondaryTextColor,#717171);font-size:var(--MdsTileAccordion_item__secondaryLabelTextSize,1.125rem);font-weight:var(--MdsTileAccordion_item__secondaryLabelTextWeight,400);line-height:var(--MdsTileAccordion_item__secondaryLabelTextLineHeight,1.75rem)}:host .tile-accordion-item .tile-accordion-item__heading-caret-icon{display:inline-flex;height:var(--MdsTileAccordion_item__caretHeight,16px);width:var(--MdsTileAccordion_item__caretWidth,16px);margin-top:var(--MdsAccordion-_size-18px__caretTopPadding,6px);margin-right:var(--MdsTileAccordion_item__caretTrailingPadding,8px);transition-property:all;transition-duration:.5s;transition-timing-function:cubic-bezier(0,.2,.1,1)}:host .tile-accordion-item .tile-accordion-item__heading-caret-icon--expanded{transform:rotate(90deg)}:host .tile-accordion-item .tile-accordion-item__heading-caret-icon svg{height:var(--MdsTileAccordion_item__caretHeight,16px);width:var(--MdsTileAccordion_item__caretWidth,16px);fill:var(--MdsTileAccordion_item__caretColor,#005eb8)}:host .tile-accordion-item .tile-accordion-item__tag{padding-left:var(--MdsTileAccordion_item__tagLeadingPadding,8px)}:host .tile-accordion-item .tile-accordion__error-message{display:flex;color:var(--MdsTileAccordion_item__errorLabelTextColor--error,#b80009);font-size:var(--MdsTileAccordion_item__errorLabelTextSize--error,.875rem);line-height:var(--MdsTileAccordion_item__errorLabelLineHeight--error,1.25rem);padding-top:var(--MdsTileAccordion_item__errorLabelTopPadding--error,4px);margin:0}:host .tile-accordion-item .tile-accordion__error-message-icon{display:inline-flex;margin:.125rem .5rem .125rem 0}:host .tile-accordion-item .tile-accordion__error-message-icon svg{height:var(--MdsTileAccordion_item__errorLabelTextSize--error,.875rem);width:var(--MdsTileAccordion_item__errorLabelTextSize--error,.875rem);fill:var(--MdsTileAccordion_item__errorLabelTextColor--error,#b80009)}:host .tile-accordion-item .tile-accordion-item__rule{height:var(--MdsTileAccordion_item__ruleHeight,1px);opacity:0;background-color:var(--MdsTileAccordion_item__ruleColor,#c1c3c3);box-shadow:var(--MdsTileAccordion_item__boxShadowHorizontalOffset,0) var(--MdsTileAccordion_item__boxShadowVerticalOffset,1px) var(--MdsTileAccordion_item__boxShadowBlurRadius,3px) var(--MdsTileAccordion_item__boxShadowSpreadRadius,0) var(--MdsTileAccordion_item__boxShadowColor,rgba(0,0,0,.2))}:host .tile-accordion-item .tile-accordion-item__rule--xs{box-shadow:var(--MdsTileAccordion_item__extraSmall__boxShadowHorizontalOffset,0) var(--MdsTileAccordion_item__extraSmall__boxShadowVerticalOffset,2px) var(--MdsTileAccordion_item__extraSmall__boxShadowBlurRadius,1px) var(--MdsTileAccordion_item__extraSmall__boxShadowSpreadRadius,0) var(--MdsTileAccordion_item__extraSmall__boxShadowColor,rgba(0,0,0,.14))}:host .tile-accordion-item .tile-accordion-item__rule--expanded{opacity:1}:host .tile-accordion-item .tile-accordion-item__panel{z-index:2;overflow:hidden;border-radius:0 0 var(--MdsTileAccordion_item__borderRadius,2px) var(--MdsTileAccordion_item__borderRadius,2px);padding:var(--MdsTileAccordion_item__panelTopPadding,4px) var(--MdsTileAccordion_item__panelTrailingPadding,0) var(--MdsTileAccordion_item__panelBottomPadding,0) var(--MdsTileAccordion_item__panelLeadingPadding,24px);opacity:0;transition-property:height;transition-duration:.2s;transition-timing-function:cubic-bezier(0,.2,.1,1);box-shadow:var(--MdsTileAccordion_item__boxShadowHorizontalOffset,0) var(--MdsTileAccordion_item__boxShadowVerticalOffset,1px) var(--MdsTileAccordion_item__boxShadowBlurRadius,3px) var(--MdsTileAccordion_item__boxShadowSpreadRadius,0) var(--MdsTileAccordion_item__boxShadowColor,rgba(0,0,0,.2));background-color:var(--MdsTileAccordion_item__backgroundColor,#fff)}:host .tile-accordion-item .tile-accordion-item__panel--expanded{opacity:1}:host .tile-accordion-item .tile-accordion-item__panel--collapsing{animation-name:panel-opacity;animation-duration:.2s;animation-delay:0s;animation-timing-function:cubic-bezier(0,.2,.1,1);animation-fill-mode:forwards}@keyframes panel-opacity{0%{opacity:1}to{opacity:0}}:host .tile-accordion-item .tile-accordion-item__panel--transitioned{opacity:1}:host .tile-accordion-item .tile-accordion-item__panel--xs{box-shadow:var(--MdsTileAccordion_item__extraSmall__boxShadowHorizontalOffset,0) var(--MdsTileAccordion_item__extraSmall__boxShadowVerticalOffset,2px) var(--MdsTileAccordion_item__extraSmall__boxShadowBlurRadius,1px) var(--MdsTileAccordion_item__extraSmall__boxShadowSpreadRadius,0) var(--MdsTileAccordion_item__extraSmall__boxShadowColor,rgba(0,0,0,.14))}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/tile/mds-tile.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, '@-moz-document url-prefix(""){:host{display:block;width:100%}}:host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif;box-sizing:border-box}:host .tile{width:100%;height:auto;padding:var(--MdsTile__tileTopPadding,8px) var(--MdsTile__tileTrailingPadding,16px) 0 var(--MdsTile__tileLeadingPadding,16px);box-shadow:var(--MdsTile__boxShadowHorizontalOffset,0) var(--MdsTile__boxShadowVerticalOffset,2px) var(--MdsTile__boxShadowBlurRadius,1px) var(--MdsTile__boxShadowSpreadRadius,0) var(--MdsTile__boxShadowColor,rgba(0,0,0,.2));border-radius:var(--MdsTile__borderRadius,2px);background-color:var(--MdsTile__backgroundColor,#fff)}:host .tile--next{border-radius:var(--MdsTile-_tileStyle-next__borderRadius,8px);padding:0 0 var(--MdsTile-_tileStyle-next__tileBottomPadding,16px);border:var(--MdsTile-_tileStyle-next__borderWidth,1px) var(--MdsTile-_tileStyle-next__borderStyle,solid) var(--MdsTile-_tileStyle-next__borderColor,#e2e4e5);box-shadow:var(--MdsTile-_tileStyle-next__boxShadowHorizontalOffset,0) var(--MdsTile-_tileStyle-next__boxShadowVerticalOffset,0) var(--MdsTile-_tileStyle-next__boxShadowBlurRadius,0) var(--MdsTile-_tileStyle-next__boxShadowSpreadRadius,0) var(--MdsTile-_tileStyle-next__boxShadowColor,transparent)}:host .tile--hero,:host .tile--next{display:flex;flex-direction:column;height:100%}:host .tile--hero{border-radius:var(--MdsTile-_variant-next__borderRadius,8px);padding:0 0 var(--MdsTile-_variant-next__tileBottomPadding,16px);border:var(--MdsTile-_variant-next__borderWidth,1px) var(--MdsTile-_variant-next__borderStyle,solid) var(--MdsTile-_variant-next__borderColor,#e2e4e5);box-shadow:var(--MdsTile-_variant-next__boxShadowHorizontalOffset,0) var(--MdsTile-_variant-next__boxShadowVerticalOffset,0) var(--MdsTile-_variant-next__boxShadowBlurRadius,0) var(--MdsTile-_variant-next__boxShadowSpreadRadius,0) var(--MdsTile-_variant-next__boxShadowColor,transparent)}@-moz-document url-prefix(""){:host .tile--hero{height:auto}}:host .tile--hero--stacked{padding:0 0 calc(var(--MdsTile-_variant-next__tileBottomPadding, 16px) + var(--MdsTile-_variant-hero__overlapRegion, 24px))}@-moz-document url-prefix(""){@media print{:host .tile--classic,:host .tile--hero,:host .tile--next{display:table}}}:host .tile--inverse{background-color:var(--MdsAlert-_background-true-_inverse-true__backgroundColor,#414042);color:var(--MdsAlert-_inverse-true__titleTextColor,#fff)}:host .tile__heading-anchor{display:flex;text-decoration:none;padding:var(--MdsTile-_tileStyle-next__tileTitleTopPadding,16px) var(--MdsTile__tileTrailingPadding,16px) 0 var(--MdsTile__tileLeadingPadding,16px)}:host .tile__heading-anchor:focus{outline:none}:host .tile__heading-anchor:focus .tile__title{outline:.0625rem dashed #717171}:host .tile__heading-anchor--disabled{outline:none;pointer-events:none}:host .tile__wrapper:focus{outline:.0625rem dashed #717171}:host .tile__wrapper--interactive{cursor:pointer}:host .tile__wrapper--next{height:100%;margin-bottom:auto}:host .tile__wrapper--next.tile__wrapper--without-title{padding-top:var(--MdsTile-_tileStyle-next__tileTitleTopPadding,16px)}:host .tile__wrapper--next.tile__wrapper--with-badge{overflow:hidden}:host .tile__wrapper--hero{height:100%}:host .tile__wrapper--hero.tile__wrapper--without-title{padding-top:var(--MdsTile-_tileStyle-next__tileTitleTopPadding,16px)}:host .tile__image{width:100%;-o-object-fit:cover;object-fit:cover;border-top-right-radius:var(--MdsTile_link__borderRadius,4px);border-top-left-radius:var(--MdsTile_link__borderRadius,4px)}:host .tile__image--left-top{-o-object-position:left top;object-position:left top}:host .tile__image--left-center{-o-object-position:left center;object-position:left center}:host .tile__image--left-bottom{-o-object-position:left bottom;object-position:left bottom}:host .tile__image--center-top{-o-object-position:center top;object-position:center top}:host .tile__image--center-center{-o-object-position:center;object-position:center}:host .tile__image--center-bottom{-o-object-position:center bottom;object-position:center bottom}:host .tile__image--right-top{-o-object-position:right top;object-position:right top}:host .tile__image--right-center{-o-object-position:right center;object-position:right center}:host .tile__image--right-bottom{-o-object-position:right bottom;object-position:right bottom}:host .tile__title{display:flex;margin:0;pointer-events:none;color:var(--MdsTile__tileTitleTextColor,#101820)}:host .tile__title-column{flex-direction:column-reverse}:host .tile__title-column .tile__badge-container{clear:both;margin-bottom:.5rem}:host .tile__title-column .tile__badge-container .tile__title-badge{display:block;float:right}:host .tile__title .tile__badge-container{margin-left:auto;max-width:100%}:host .tile__title--next{margin-bottom:var(--MdsTile-_tileStyle-next__tileSubtitleBottomMargin,4px)}:host .tile__title--next .tile__title-primary{color:var(--MdsTile-_tileStyle-next__tileTitleTextColor,#101820)}:host .tile__title--next .tile__badge-container{padding-top:var(--MdsTile-_tileStyle-next__badgeTopPadding,2px)}:host .tile__title--hero{margin-bottom:var(--MdsTile-_tileStyle-next__tileSubtitleBottomMargin,4px)}:host .tile__title--hero .tile__title-primary{color:var(--MdsTile-_tileStyle-next__tileTitleTextColor,#101820)}:host .tile__title--inverse{margin-bottom:var(--MdsTile-_tileStyle-next__tileSubtitleBottomMargin,4px)}:host .tile__title--inverse .tile__title-primary{color:var(--MdsAlert-_inverse-true__titleTextColor,#101820)}:host .tile__title--disabled{outline:none}:host .tile__title-text-container{display:flex;flex-direction:row}:host .tile__title-text-container mds-icon{margin-left:0}:host .tile__title-badge{margin-left:auto;white-space:nowrap}:host .tile__title-badge-interactive{display:flex;padding-left:var(--MdsTile-_tileStyle-next__badgeVerticalPadding,8px);padding-right:var(--MdsTile-_tileStyle-next__badgeVerticalPadding,8px)}:host .tile__title-primary{display:block;font-size:var(--MdsTile__tileTitleTextSize,1.125rem);line-height:var(--MdsTile__tileTitleLineHeight,1.75rem);font-weight:var(--MdsTile__tileTitleTextWeight,300);padding-right:calc(var(--MdsTile-_tileStyle-next__chevronIconLeadingPadding, 8px) + var(--MdsTile-_tileStyle-next__chevronIconWidth, 16px))}:host .tile__title-primary--next{flex:1}:host .tile__title-primary--hero,:host .tile__title-primary--next{font-size:var(--MdsTile-_tileStyle-next__tileTitleTextSize,1rem);line-height:var(--MdsTile-_tileStyle-next__tileTitleLineHeight,1.5rem);font-weight:var(--MdsTile-_tileStyle-next__tileTitleTextWeight,600)}:host .tile__title-sub{display:block;font-size:var(--MdsTile-_tileStyle-next__tileSubtitleTextSize,.875rem);line-height:var(--MdsTile-_tileStyle-next__tileSubtitleLineHeight,1.25rem);font-weight:var(--MdsTile-_tileStyle-next__tileSubtitleTextWeight,400);margin-top:var(--MdsTile-_tileStyle-next__tileTitleBottomMargin,4px);margin-left:0;margin-bottom:var(--MdsTile-_tileStyle-next__tileSubtitleBottomMargin,4px)}:host .tile__title-sub--hero,:host .tile__title-sub--next{color:var(--MdsTile-_tileStyle-next__tileSubtitleTextColor,#565a5d)}:host .tile__title-sub--inverse{color:var(--MdsAlert-_inverse-true__messageTextColor,#565a5d)}:host .tile__title-sub-with-icon{padding-left:calc(var(--MdsTile__tileTitleIconWidth, 24px) + var(--MdsTile__tileTitleIconTrailingMargin, 8px))}:host .tile__title-sub-interactive-no-icon{padding-left:0}:host .tile__title-icon{display:inline-flex;margin-top:var(--MdsTile__tileTitleIconTopPadding,2px);margin-right:var(--MdsTile__tileTitleIconTrailingMargin,8px);pointer-events:none}:host .tile__title-icon svg{height:var(--MdsTile__tileTitleIconHeight,24px);width:var(--MdsTile__tileTitleIconWidth,24px);fill:var(--MdsTile__tileTitleIconColor,#565a5d)}:host .tile__title-icon--hero,:host .tile__title-icon--next{margin-top:0}:host .tile__title-icon--interactive svg{fill:var(--MdsTile-_tileStyle-next-_titleIconColor-interactive__tileTitleIconColor,#005eb8)}:host .tile__title-icon--inverse svg{fill:var(--MdsIcon-_color-inverse__color,#fff)}:host .tile__title-container{width:100%}:host .tile__title-chevron{display:inline-flex;justify-content:flex-end;flex:auto;pointer-events:none}:host .tile__title-chevron--next{padding-top:var(--MdsTile-_tileStyle-next__badgeTopPadding,2px)}:host .tile__title-chevron svg{height:var(--MdsTile-_tileStyle-next__chevronIconHeight,16px);width:var(--MdsTile-_tileStyle-next__chevronIconWidth,16px);fill:var(--MdsTile-_tileStyle-next__chevronIconColor,#565a5d)}:host .tile__title-chevron--inverse svg{fill:var(--MdsIcon-_color-inverse__color,#fff)}:host .tile__title--non-interactive{padding:var(--MdsTile-_tileStyle-next__tileTitleTopPadding,16px) var(--MdsTile__tileTrailingPadding,16px) 0 var(--MdsTile__tileLeadingPadding,16px)}:host .tile__content{padding-bottom:var(--MdsTile__contentAreaBottomPadding,12px)}:host .tile__content--regular{padding:0 var(--MdsTile-_tileStyle-next-_horizontalPadding-regular__contentAreaTrailingPadding,16px) 0 var(--MdsTile-_tileStyle-next-_horizontalPadding-regular__contentAreaLeadingPadding,16px)}:host .tile__content--none{padding:0 var(--MdsTile-_tileStyle-next-_horizontalPadding-none__contentAreaTrailingPadding,0) 0 var(--MdsTile-_tileStyle-next-_horizontalPadding-none__contentAreaLeadingPadding,0)}:host .tile__buttons{display:flex;justify-content:center;padding-top:var(--MdsTile__buttonDividerTopPadding,4px);padding-bottom:var(--MdsTile__buttonDividerBottomPadding,4px);min-height:calc(var(--MdsButton__minHeight, 36px) + var(--MdsTile__buttonDividerTopPadding, 4px) + var(--MdsTile__buttonDividerBottomPadding, 4px));box-shadow:var(--MdsTile__boxShadowHorizontalOffset,0) calc(var(--MdsTile__contentAreaDividerThickness, 1px)*-1) var(--MdsTile__boxShadowHorizontalOffset,0) var(--MdsTile__contentAreaDividerColor,#c1c3c3)}:host .tile__button-container,:host .tile__link-container{display:flex;flex-grow:1;flex-basis:0;justify-content:center;align-items:center;padding-top:0;padding-bottom:0;border:solid var(--MdsTile__buttonDividerColor,#c1c3c3);border-width:0 .1rem 0 0}:host .tile__button-container:last-of-type,:host .tile__link-container:last-of-type{border-right:0}:host .tile__link{background-color:var(--MdsTile_link__backgroundColor,transparent);color:var(--MdsTile_link__textColor,#005eb8);display:flex;justify-content:center;box-sizing:border-box;text-align:center;white-space:nowrap;word-break:break-word;vertical-align:middle;text-decoration:none;cursor:pointer;transition-property:background-color;transition-duration:var(--MdsTile_link__stateChangeColorTransitionTime,0ms);transition-timing-function:var(--MdsTile_link__stateChangeColorTransitionEase,cubic-bezier(0,.4,.2,1));-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:var(--MdsTile_link__topPadding,4px) var(--MdsTile_link__trailingPadding,8px) var(--MdsTile_link__bottomPadding,4px) var(--MdsTile_link__leadingPadding,8px);border-radius:var(--MdsTile_link__borderRadius,4px);min-width:var(--MdsTile_link__minWidth,0);margin:0;line-height:var(--MdsTile_link__textLineHeight,1.25rem);font-size:var(--MdsTile_link__textSize,.875rem);font-weight:var(--MdsTile_link__textWeight,600);outline-offset:0}:host .tile__link:hover{background-color:var(--MdsTile_link__backgroundColor--hovered,rgba(0,94,184,.08));color:var(--MdsTile_link__textColor--hovered,#004692)}:host .tile__link:active{background-color:var(--MdsTile_link__backgroundColor--pressed,rgba(0,94,184,.08));color:var(--MdsTile_link__textColor--pressed,#0091da)}:host .tile__link:disabled{background-color:var(--MdsTile_link__backgroundColor--disabled,#e2e4e5);color:var(--MdsTile_link__textColor--disabled,#8c8e90)}:host .tile__link:focus{outline:.0625rem dashed #717171}:host .tile__link--primary{background-color:var(--MdsButton-_variant-primary__backgroundColor,#005eb8);color:var(--MdsButton-_variant-primary__textColor,#fff)}:host .tile__link--primary:hover{background-color:var(--MdsButton-_variant-primary__backgroundColor--hovered,#004692);color:var(--MdsButton-_variant-primary__textColor--hovered,#fff)}:host .tile__link--primary:active{background-color:var(--MdsButton-_variant-primary__backgroundColor--pressed,#0091da);color:var(--MdsButton-_variant-primary__textColor--pressed,#fff)}:host .tile__link--secondary{background-color:var(--MdsButton-_variant-secondary__backgroundColor,transparent);color:var(--MdsButton-_variant-secondary__textColor,#005eb8);box-shadow:inset 0 0 0 var(--MdsButton-_variant-secondary__borderWidth,1px) var(--MdsButton-_variant-secondary__borderColor,#005eb8)}:host .tile__link--secondary:hover{background-color:var(--MdsButton-_variant-secondary__backgroundColor--hovered,rgba(0,94,184,.08));box-shadow:inset 0 0 0 var(--MdsButton-_variant-secondary__borderWidth,1px) var(--MdsButton-_variant-secondary__borderColor--hovered,#004692);color:var(--MdsButton-_variant-secondary__textColor--hovered,#004692)}:host .tile__link--secondary:active{background-color:var(--MdsButton-_variant-secondary__backgroundColor--pressed,rgba(0,94,184,.08));box-shadow:inset 0 0 0 var(--MdsButton-_variant-secondary__borderWidth,1px) var(--MdsButton-_variant-secondary__borderColor--pressed,#0091da);color:var(--MdsButton-_variant-secondary__textColor--pressed,#0091da)}:host .tile__footer{display:flex;justify-content:flex-end;padding-left:var(--MdsTile__tileLeadingPadding,16px)}:host .tile__footer--with-help-button{justify-content:space-between;align-items:flex-end;padding-left:0}:host .tile__footer .tile__button,:host .tile__footer .tile__link-container{align-items:flex-start;margin-top:var(--MdsTile-_tileStyle-next__tileCTATopPadding,16px);margin-right:var(--MdsTile-_tileStyle-next__tileCTATrailingPadding,16px);border:0;flex:unset}:host .tile__footer .tile__button--layout,:host .tile__footer .tile__link-container--layout{flex:1}:host .tile__footer .tile__link-container--layout .tile__link{width:100%;align-items:center;white-space:normal;word-break:break-word}:host .tile__footer .tile__link{transition-property:background-color;transition-duration:var(--MdsButton__stateChangeColorTransitionTime,.2s);transition-timing-function:var(--MdsButton__stateChangeColorTransitionEase,cubic-bezier(0,.4,.2,1))}:host .tile__cta-container{display:flex}:host .tile__cta-container--horizontal{width:100%;flex-direction:row-reverse;justify-content:flex-start}:host .tile__cta-container--vertical{flex-direction:column-reverse}:host .tile__help-button{padding:var(--MdsTile-_tileStyle-next__helpButtonTopPadding,6px) var(--MdsTile-_tileStyle-next__helpButtonTrailingPadding,8px) 0 var(--MdsTile-_tileStyle-next__helpButtonLeadingPadding,8px)}@media print{:host .tile{display:block}}:host .stacked-tile{display:flex;flex-direction:column;height:auto;margin:calc(var(--MdsTile-_variant-hero__overlapRegion, 24px)*-1) var(--MdsTile-_variant-hero__rightChildPadding,16px) 0 var(--MdsTile-_variant-hero__leftChildPadding,16px);padding:var(--MdsTile__tileTopPadding,16px);border-radius:var(--MdsTile-_variant-next__borderRadius,8px);border:var(--MdsTile-_variant-next__borderWidth,1px) var(--MdsTile-_variant-next__borderStyle,solid) var(--MdsTile-_variant-next__borderColor,#e2e4e5);box-shadow:var(--MdsTile-_variant-next__boxShadowHorizontalOffset,0) var(--MdsTile-_variant-next__boxShadowVerticalOffset,0) var(--MdsTile-_variant-next__boxShadowBlurRadius,0) var(--MdsTile-_variant-next__boxShadowSpreadRadius,0) var(--MdsTile-_variant-next__boxShadowColor,transparent);background-color:var(--MdsTile__backgroundColor,#fff)}', "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/vertical-navigation/mds-vertical-navigation.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .vertical-navigation{min-width:var(--MdsVerticalNavigation__minWidth,280px);padding:0 .0625rem;background-color:var(--MdsVerticalNavigation__backgroundColor,#fff)}:host .vertical-navigation--inverse{background-color:var(--MdsVerticalNavigation-_inverse-true__backgroundColor,#1f1b17)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/vertical-navigation/vertical-navigation-footer/mds-vertical-navigation-footer.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .vertical-navigation-footer{padding:var(--MdsVerticalNavigation_footer__topPadding,16px) var(--MdsVerticalNavigation_footer__trailingPadding,16px) var(--MdsVerticalNavigation_footer__bottomPadding,16px) var(--MdsVerticalNavigation_footer__leadingPadding,16px);background-color:var(--MdsVerticalNavigation_footer__backgroundColor,#fff)}:host .vertical-navigation-footer ::slotted(*){display:block!important;font-size:var(--MdsVerticalNavigation_footer__textSize,.875rem)!important;line-height:var(--MdsVerticalNavigation_footer__textLineHeight,1.25rem)!important;margin-bottom:var(--MdsVerticalNavigation_footer__textBottomMargin,16px)!important;color:var(--MdsVerticalNavigation_footer__textColor,#101820)!important}:host .vertical-navigation-footer ::slotted(a){width:-moz-fit-content!important;width:fit-content!important}:host .vertical-navigation-footer ::slotted(:last-child){margin-bottom:0!important}:host .vertical-navigation-footer ::slotted(:focus){outline:.0625rem dashed #717171!important}:host .vertical-navigation-footer--inverse{background-color:var(--MdsVerticalNavigation_footer-_inverse-true__backgroundColor,#1f1b17)}:host .vertical-navigation-footer--inverse ::slotted(*){color:var(--MdsVerticalNavigation_footer-_inverse-true__textColor,#c1c3c3)!important}:host .vertical-navigation-footer--inverse ::slotted(:focus){outline:.0625rem dashed #fff!important}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/vertical-navigation/vertical-navigation-item/mds-vertical-navigation-item.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ':host{display:block;border:.0625rem solid transparent}:host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .vertical-navigation-item{display:flex;position:relative;align-items:center;width:100%;margin:0;font-size:var(--MdsVerticalNavigation_item__textSize,1rem);line-height:var(--MdsVerticalNavigation_item__textLineHeight,1.5rem);font-weight:var(--MdsVerticalNavigation_item__textWeight,400);padding:var(--MdsVerticalNavigation_item__topPadding,10px) var(--MdsVerticalNavigation_item__trailingPadding,16px) var(--MdsVerticalNavigation_item__bottomPadding,10px) var(--MdsVerticalNavigation_item__leadingPadding,16px);text-decoration:none;background-color:var(--MdsVerticalNavigation_item__backgroundColor,#fff);color:var(--MdsVerticalNavigation_item__textColor,#101820)}:host .vertical-navigation-item:hover{background-color:var(--MdsVerticalNavigation_item__backgroundColor--hovered,#f5f7f8)}:host .vertical-navigation-item:focus{outline:.0625rem dashed #717171}:host .vertical-navigation-item:active:not(.vertical-navigation-item--heading){font-weight:var(--MdsVerticalNavigation_item__textWeight--active,600);background-color:var(--MdsVerticalNavigation_item__backgroundColor--pressed,#0091da);color:var(--MdsVerticalNavigation_item__textColor--pressed,#fff)}:host .vertical-navigation-item:active:not(.vertical-navigation-item--heading) .vertical-navigation-item__icon svg{fill:var(--MdsVerticalNavigation_item-_type-collapsible__iconColor--pressed,#fff)}:host .vertical-navigation-item--active{font-weight:var(--MdsVerticalNavigation_item__textWeight--pressed,600)}:host .vertical-navigation-item--active:before{content:"";position:absolute;left:0;top:0;bottom:0;width:var(--MdsVerticalNavigation_item__indicatorWidth--active,4px);background-color:var(--MdsVerticalNavigation_item__indicatorColor--active,#0091da)}:host .vertical-navigation-item--collapsible{align-items:flex-start;border:0;color:var(--MdsVerticalNavigation_item-_type-collapsible__textColor,#101820);font-size:var(--MdsVerticalNavigation_item-_type-collapsible__textSize,1rem);line-height:var(--MdsVerticalNavigation_item-_type-collapsible__textLineHeight,1.5rem);font-weight:var(--MdsVerticalNavigation_item-_type-collapsible__textWeight,600);padding-left:var(--MdsVerticalNavigation_item-_type-collapsible__leadingPadding,12px);cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none}:host .vertical-navigation-item--collapsible::-moz-focus-inner{border:0}:host .vertical-navigation-item--heading{padding-top:var(--MdsVerticalNavigation_item-_type-heading__topPadding,8px);padding-bottom:var(--MdsVerticalNavigation_item-_type-heading__bottomPadding,8px);font-size:var(--MdsVerticalNavigation_item-_type-heading__textSize,.875rem);line-height:var(--MdsVerticalNavigation_item-_type-heading__textLineHeight,1.25rem);font-weight:var(--MdsVerticalNavigation_item-_type-heading__textWeight,600);background-color:var(--MdsVerticalNavigation_item-_type-heading__backgroundColor,#f5f7f8);color:var(--MdsVerticalNavigation_item-_type-heading__textColor,#101820);cursor:default}:host .vertical-navigation-item--nested{padding-left:var(--MdsVerticalNavigation_item__nestedOneLevelLeadingPadding,32px)}:host .vertical-navigation-item--nested-twice{padding-left:var(--MdsVerticalNavigation_item__nestedTwoLevelsLeadingPadding,52px)}:host .vertical-navigation-item--inverse{background-color:var(--MdsVerticalNavigation_item-_inverse-true__backgroundColor,#3e3734);color:var(--MdsVerticalNavigation_item-_inverse-true__textColor,#fff);font-weight:var(--MdsVerticalNavigation_item-_inverse-true__textWeight,600)}:host .vertical-navigation-item--inverse:focus{outline:.0625rem dashed #fff}:host .vertical-navigation-item--inverse:hover{background-color:var(--MdsVerticalNavigation_item-_inverse-true__backgroundColor--hovered,#47423f)}:host .vertical-navigation-item--inverse:active .vertical-navigation-item__icon svg{fill:var(--MdsVerticalNavigation_item-_inverse-true__iconColor--pressed,#fff)}:host .vertical-navigation-item--inverse:active .vertical-navigation-item__icon svg--collapsible{fill:var(--MdsVerticalNavigation_item-_inverse-true-_type-collapsible__iconColor,#c1c3c3)}:host .vertical-navigation-item--inverse.vertical-navigation-item--heading{background-color:var(--MdsVerticalNavigation_item-_inverse-true-_type-heading__backgroundColor,#1f1b17)}:host .vertical-navigation-item__submenu{transform:scaleY(0);transition-property:transform,height,opacity;transition-duration:var(--MdsVerticalNavigation_item-_type-collapsible__submenuExpandCollapseTransitionDuration,.2s);transition-timing-function:var(--MdsVerticalNavigation_item-_type-collapsible__submenuExpandCollapseTransitionEasingFunction,cubic-bezier(.4,0,.2,1));transform-origin:top;opacity:var(--MdsVerticalNavigation_item-_type-collapsible__submenuExpandCollapseTransitionStartOpacity,0);display:block;visibility:hidden;height:0}:host .vertical-navigation-item__submenu--expanded{transform:scaleY(1);opacity:var(--MdsVerticalNavigation_item-_type-collapsible__submenuExpandCollapseTransitionEndOpacity,1);display:block;visibility:visible;height:auto}:host .vertical-navigation-item__icon{display:inline-flex;pointer-events:none}:host .vertical-navigation-item__icon--collapsible{margin-top:var(--MdsVerticalNavigation_item-_type-collapsible__iconTopMargin,4px);margin-right:var(--MdsVerticalNavigation_item-_type-collapsible__iconTrailingMargin,4px);transition-property:transform;transition-duration:var(--MdsVerticalNavigation_item-_type-collapsible__iconRotationTransitionDuration,.2s);transition-timing-function:var(--MdsVerticalNavigation_item-_type-collapsible__iconRotationTransitionEasingFunction,cubic-bezier(.4,0,.2,1))}:host .vertical-navigation-item__icon--collapsible svg{height:var(--MdsVerticalNavigation_item-_type-collapsible__iconHeight,1rem);width:var(--MdsVerticalNavigation_item-_type-collapsible__iconWidth,1rem);fill:var(--MdsVerticalNavigation_item-_type-collapsible__iconColor,#005eb8)}:host .vertical-navigation-item__icon--collapsible.vertical-navigation-item__icon--inverse svg{fill:var(--MdsVerticalNavigation_item-_inverse-true-_type-collapsible__iconColor,#c1c3c3)}:host .vertical-navigation-item__icon--expanded{transform:rotate(90deg)}:host .vertical-navigation-item__icon--leading{position:absolute;top:calc(var(--MdsVerticalNavigation_item__textLineHeight, 24px)/2 + var(--MdsVerticalNavigation_item__topPadding, 10px)/2 + var(--MdsVerticalNavigation_item__bottomPadding, 10px)/2 - var(--MdsVerticalNavigation_item__leadingIconHeight, 24px)/2)}:host .vertical-navigation-item__icon--leading svg{height:var(--MdsVerticalNavigation_item__leadingIconHeight,24px);width:var(--MdsVerticalNavigation_item__leadingIconWidth,24px);fill:var(--MdsVerticalNavigation_item__leadingIconColor,#565a5d)}:host .vertical-navigation-item__icon--leading.vertical-navigation-item__icon--inverse svg{fill:var(--MdsVerticalNavigation_item-_inverse-true__iconColor,#fff)}:host .vertical-navigation-item__label{pointer-events:none;flex-basis:100%}:host .vertical-navigation-item__label--with-leading-icon{padding-left:calc(var(--MdsVerticalNavigation_item__leadingIconWidth, 24px) + var(--MdsVerticalNavigation_item__leadingIconTrailingMargin, 16px))}:host .vertical-navigation-item__label--with-badge{padding-right:calc(var(--MdsVerticalNavigation_item__badgeWidth, 20px) + var(--MdsVerticalNavigation_item__badgeLeadingMargin, 16px))}:host .vertical-navigation-item__badge{pointer-events:none;display:flex;position:absolute;top:calc(var(--MdsVerticalNavigation_item__textLineHeight, 24px)/2 + var(--MdsVerticalNavigation_item__topPadding, 10px)/2 + var(--MdsVerticalNavigation_item__bottomPadding, 10px)/2 - var(--MdsVerticalNavigation_item__badgeWidth, 20px)/2);right:var(--MdsVerticalNavigation_item__badgeLeadingMargin,16px)}', "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/video-player/mds-video-player-icon.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, '.video-js .vjs-big-play-button{font-family:mds-chase-icons;content:"\\E095"}.video-js .vjs-play-control .vjs-icon-placeholder:before{font-family:mds-chase-icons;content:"\\E09A"}.video-js .vjs-play-control.vjs-playing .vjs-icon-placeholder:before{font-family:mds-chase-icons;content:"\\E099"}.video-js .vjs-play-control.vjs-ended .vjs-icon-placeholder:before{font-family:mds-chase-icons;content:"\\E09A"}.video-js .vjs-mute-control .vjs-icon-volume-mute:before,.video-js .vjs-mute-control.vjs-vol-0 .vjs-icon-placeholder:before{font-family:mds-chase-icons;content:"\\E139"}.video-js .vjs-mute-control .vjs-icon-volume-low:before,.video-js .vjs-mute-control.vjs-vol-1 .vjs-icon-placeholder:before{font-family:mds-chase-icons;content:"\\E09D"}.video-js .vjs-mute-control .vjs-icon-volume-mid:before,.video-js .vjs-mute-control.vjs-vol-2 .vjs-icon-placeholder:before{font-family:mds-chase-icons;content:"\\E09E"}.video-js .vjs-mute-control .vjs-icon-placeholder:before,.video-js .vjs-mute-control .vjs-icon-volume-high:before{font-family:mds-chase-icons;content:"\\E09C"}.video-js .vjs-fullscreen-control .vjs-icon-placeholder:before,.video-js .vjs-icon-fullscreen-enter:before{font-family:mds-chase-icons;content:"\\E098"}.video-js.vjs-fullscreen .vjs-fullscreen-control .vjs-icon-placeholder:before,.video-js .vjs-icon-fullscreen-exit:before{font-family:mds-chase-icons;content:"\\E097"}.video-js .vjs-caption-toggle-control.vjs-icon-captions.vjs-control.vjs-button:before{font-family:mds-chase-icons;content:"\\E096"}.video-js .vjs-caption-toggle-control.vjs-selected{color:var(--MdsVideoPlayer__closeCaptionSelectedColor,#74bcf9)}.video-js .vjs-play-progress{background-color:var(--MdsVideoPlayer__progressColor,#74bcf9)}.video-js .vjs-volume-level{background-color:var(--MdsVideoPlayer__volumeSliderColor,#74bcf9)}', "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/video-player/mds-video-player.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host{display:block;width:40rem;height:22.5rem}:host ::slotted(video-js){width:100%!important;height:100%!important}", "" ]);
            module.exports = exports;
        },
        "./node_modules/global/document.js": function(module, exports, __webpack_require__) {
            (function(global) {
                var topLevel = typeof global !== "undefined" ? global : typeof window !== "undefined" ? window : {};
                var minDoc = __webpack_require__(0);
                var doccy;
                if (typeof document !== "undefined") {
                    doccy = document;
                } else {
                    doccy = topLevel["__GLOBAL_DOCUMENT_CACHE@4"];
                    if (!doccy) {
                        doccy = topLevel["__GLOBAL_DOCUMENT_CACHE@4"] = minDoc;
                    }
                }
                module.exports = doccy;
            }).call(this, __webpack_require__("./node_modules/webpack/buildin/global.js"));
        },
        "./node_modules/global/window.js": function(module, exports, __webpack_require__) {
            (function(global) {
                var win;
                if (typeof window !== "undefined") {
                    win = window;
                } else if (typeof global !== "undefined") {
                    win = global;
                } else if (typeof self !== "undefined") {
                    win = self;
                } else {
                    win = {};
                }
                module.exports = win;
            }).call(this, __webpack_require__("./node_modules/webpack/buildin/global.js"));
        },
        "./src/abstract-combo-button/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_combo_button_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-combo-button/mds-combo-button.scss");
            var _mds_combo_button_scss__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_combo_button_scss__WEBPACK_IMPORTED_MODULE_1__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            var arrayOf = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].arrayOf, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].boolean, string = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].stringRequired, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].enumerables, satisfies = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].satisfies;
            var menuItemEntity = {
                text: string.defaultsTo(""),
                inactive: boolean,
                iconType: enumerables.apply(void 0, [ string ].concat(_toConsumableArray(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["ICON_TYPES"])))
            };
            var entity = {
                menuButtonAccessibleText: string.defaultsTo("More options"),
                menuItems: arrayOf(satisfies(menuItemEntity)).withMinLength(1),
                iconType: enumerables.apply(void 0, [ string ].concat(_toConsumableArray(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["ICON_TYPES"]), [ "" ])),
                inactive: boolean.defaultsTo(false),
                text: stringRequired,
                variant: enumerables(string, "primary", "secondary", "tertiary").defaultsTo("primary")
            };
            var AbstractComboButton = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(AbstractComboButton, _AgaveComponent);
                _createClass(AbstractComboButton, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "AbstractComboButton";
                    }
                } ]);
                function AbstractComboButton() {
                    var _this;
                    _classCallCheck(this, AbstractComboButton);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(AbstractComboButton).call(this));
                    _this.rootClass = "abstract-combo-button";
                    _this.defineObservedProperty("open", false);
                    _this._handleButtonClick = _this._handleButtonClick.bind(_assertThisInitialized(_this));
                    _this._handleMenuClick = _this._handleMenuClick.bind(_assertThisInitialized(_this));
                    _this._handleMenuItemKeydown = _this._handleMenuItemKeydown.bind(_assertThisInitialized(_this));
                    _this._handleMenuItemKeyup = _this._handleMenuItemKeyup.bind(_assertThisInitialized(_this));
                    _this._handleMenuButtonKeydown = _this._handleMenuButtonKeydown.bind(_assertThisInitialized(_this));
                    _this._handleMenuButtonMousedown = _this._handleMenuButtonMousedown.bind(_assertThisInitialized(_this));
                    _this._handleMenuBlur = _this._handleMenuBlur.bind(_assertThisInitialized(_this));
                    _this._iosCloseOnBlur = _this._iosCloseOnBlur.bind(_assertThisInitialized(_this));
                    _this._shiftFocusDown = _this._shiftFocusDown.bind(_assertThisInitialized(_this));
                    _this._shiftFocusUp = _this._shiftFocusUp.bind(_assertThisInitialized(_this));
                    _this.toggleMenu = _this.toggleMenu.bind(_assertThisInitialized(_this));
                    _this.closeMenu = _this.closeMenu.bind(_assertThisInitialized(_this));
                    _this.openMenu = _this.openMenu.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(AbstractComboButton, [ {
                    key: "connectedCallback",
                    value: function connectedCallback(prefix) {
                        _get(_getPrototypeOf(AbstractComboButton.prototype), "connectedCallback", this).call(this);
                        this._componentPrefix = prefix;
                        this._menuButton = this.shadowRoot.querySelector(".".concat(prefix, "__menu-button"));
                        this._primaryButton = this.shadowRoot.querySelector(".".concat(prefix, "__primary-button"));
                    }
                }, {
                    key: "disconnectedCallback",
                    value: function disconnectedCallback() {
                        _get(_getPrototypeOf(AbstractComboButton.prototype), "disconnectedCallback", this) && _get(_getPrototypeOf(AbstractComboButton.prototype), "disconnectedCallback", this).call(this);
                        MDS.isIOS && document.body.removeEventListener("touchstart", this.iosCloseOnBlur);
                    }
                }, {
                    key: "_handleMenuBlur",
                    value: function _handleMenuBlur(event) {
                        !this._menu.contains(event.relatedTarget) && this.closeMenu();
                    }
                }, {
                    key: "_iosCloseOnBlur",
                    value: function _iosCloseOnBlur(event) {
                        this !== event.target && this.closeMenu();
                    }
                }, {
                    key: "_handleMenuItemKeydown",
                    value: function _handleMenuItemKeydown(event) {
                        if (!this._keyCodeActionMap) {
                            var _this$_keyCodeActionM;
                            this._keyCodeActionMap = (_this$_keyCodeActionM = {}, _defineProperty(_this$_keyCodeActionM, 13, this._handleMenuClick), 
                            _defineProperty(_this$_keyCodeActionM, 32, this._handleMenuClick), _defineProperty(_this$_keyCodeActionM, 37, this.closeMenu), 
                            _defineProperty(_this$_keyCodeActionM, 38, this._shiftFocusUp), _defineProperty(_this$_keyCodeActionM, 40, this._shiftFocusDown), 
                            _this$_keyCodeActionM);
                        }
                        if (this._keyCodeActionMap[event.keyCode]) {
                            event.preventDefault();
                            this._keyCodeActionMap[event.keyCode](event);
                        }
                    }
                }, {
                    key: "_handleMenuItemKeyup",
                    value: function _handleMenuItemKeyup(event) {
                        this.open && Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["isEscAndShouldClose"])(event) && this.closeMenu(event);
                    }
                }, {
                    key: "_handleMenuButtonKeydown",
                    value: function _handleMenuButtonKeydown(customEvent) {
                        var event = customEvent.detail;
                        if (!this.inactive && [ 13, 32, 39 ].includes(event.keyCode)) {
                            event.preventDefault();
                            this.openMenu();
                        }
                    }
                }, {
                    key: "_handleMenuButtonMousedown",
                    value: function _handleMenuButtonMousedown(event) {
                        this.open && event.preventDefault();
                    }
                }, {
                    key: "_shiftFocusDown",
                    value: function _shiftFocusDown(event) {
                        event.target.nextSibling ? event.target.nextSibling.focus() : this._menu.childNodes[0].focus();
                    }
                }, {
                    key: "_shiftFocusUp",
                    value: function _shiftFocusUp(event) {
                        event.target.previousSibling ? event.target.previousSibling.focus() : this._menu.childNodes[this._menu.childNodes.length - 1].focus();
                    }
                }, {
                    key: "toggleMenu",
                    value: function toggleMenu() {
                        if (!this.inactive) {
                            this.open ? this.closeMenu(true) : this.openMenu();
                        }
                    }
                }, {
                    key: "openMenu",
                    value: function openMenu() {
                        this.open = true;
                        this._menu.childNodes[0].focus();
                        MDS.isIOS && document.body.addEventListener("touchstart", this.iosCloseOnBlur);
                    }
                }, {
                    key: "closeMenu",
                    value: function closeMenu(focusonMenuButton) {
                        focusonMenuButton && this._menuButton.focus();
                        this.open = false;
                        MDS.isIOS && document.body.removeEventListener("touchstart", this.iosCloseOnBlur);
                    }
                }, {
                    key: "_menu",
                    get: function get() {
                        return this.shadowRoot.querySelector(".".concat(this._componentPrefix, "__menu-list"));
                    }
                } ]);
                return AbstractComboButton;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_0___default.a), _class2.styles = _mds_combo_button_scss__WEBPACK_IMPORTED_MODULE_1___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = AbstractComboButton;
        },
        "./src/abstract-combo-button/mds-combo-button.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/abstract-combo-button/mds-combo-button.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/abstract-data-table/AbstractMdsDataTable.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "_emptyWithHeadersTemplate", (function() {
                return _emptyWithHeadersTemplate;
            }));
            __webpack_require__.d(__webpack_exports__, "_emptyWithoutHeadersTemplate", (function() {
                return _emptyWithoutHeadersTemplate;
            }));
            __webpack_require__.d(__webpack_exports__, "_renderStackedCaption", (function() {
                return _renderStackedCaption;
            }));
            __webpack_require__.d(__webpack_exports__, "_renderCaption", (function() {
                return _renderCaption;
            }));
            __webpack_require__.d(__webpack_exports__, "_renderColumnHeader", (function() {
                return _renderColumnHeader;
            }));
            __webpack_require__.d(__webpack_exports__, "_generateCellRowHeaderChartTable", (function() {
                return _generateCellRowHeaderChartTable;
            }));
            __webpack_require__.d(__webpack_exports__, "_generateCellRowHeader", (function() {
                return _generateCellRowHeader;
            }));
            __webpack_require__.d(__webpack_exports__, "_generateCellRowValue", (function() {
                return _generateCellRowValue;
            }));
            __webpack_require__.d(__webpack_exports__, "_generateCellRowValueFooter", (function() {
                return _generateCellRowValueFooter;
            }));
            __webpack_require__.d(__webpack_exports__, "_generateCellRowHeaderInline", (function() {
                return _generateCellRowHeaderInline;
            }));
            __webpack_require__.d(__webpack_exports__, "_renderAriaLive", (function() {
                return _renderAriaLive;
            }));
            __webpack_require__.d(__webpack_exports__, "_renderAllStackedTables", (function() {
                return _renderAllStackedTables;
            }));
            __webpack_require__.d(__webpack_exports__, "_generateCellRowValueInline", (function() {
                return _generateCellRowValueInline;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_table_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/table-utils.jsx");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _footerValue$wrapper = function _footerValue$wrapper(_deferred, _args, _child) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "aria-hidden", "true");
                _renderArbitrary(_deferred.call(_args[0], _args[1], _args[2]));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                _renderArbitrary(_child);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            }, _footerValue$wrapper2 = function _footerValue$wrapper2(_appendingString) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text");
                _renderArbitrary(_appendingString);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            };
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _emptyWithHeadersTemplate() {
                var nullStateMessage = this.nullStateMessage, id = this.id, columnConfigs = this.columnConfigs;
                var idRowHeader = "".concat(this.rootClass, "__null-message-row");
                var headersLength = columnConfigs.length;
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("table", null, null, "id", id, "class", this.rootClass);
                _renderArbitrary(_renderCaption.call(this));
                _renderArbitrary(_renderColumnHeader.call(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("tbody");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("tr", null, null, "id", idRowHeader);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("td", null, null, "id", "row-header-row0-column0", "colSpan", headersLength, "class", "".concat(this.rootClass, "__empty-table ").concat(this.rootClass, "__empty-table--inline"));
                _renderArbitrary(nullStateMessage);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("td");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tr");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tbody");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("table");
            }
            function _renderEmptyWithoutHeaders(nullStateMessage) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", this.rootClass);
                _renderArbitrary(_renderCaption.call(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "".concat(this.rootClass, "__empty-table ").concat(this.rootClass, "__empty-table--block"));
                _renderArbitrary(nullStateMessage);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function _renderEmptyWithoutHeadersStacked(nullStateMessage, caption) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "".concat(this.rootClass, "__container"));
                _renderArbitrary(_renderStackedCaption.call(this, caption));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "".concat(this.rootClass, "__empty-table ").concat(this.rootClass, "__empty-table--inline"));
                _renderArbitrary(nullStateMessage);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function _emptyWithoutHeadersTemplate() {
                var nullStateMessage = this.nullStateMessage, layout = this.layout, caption = this.caption;
                if (this.stacked === true || layout === "rowInline") {
                    return _renderEmptyWithoutHeadersStacked.call(this, nullStateMessage, caption);
                }
                return _renderEmptyWithoutHeaders.call(this, nullStateMessage);
            }
            function _renderStackedCaption(caption) {
                var _captionClasses;
                var captionClasses = (_captionClasses = {}, _defineProperty(_captionClasses, "".concat(this.rootClass, "__caption"), true), 
                _defineProperty(_captionClasses, "".concat(this.rootClass, "__caption--stacked"), true), 
                _defineProperty(_captionClasses, "".concat(this.rootClass, "__caption--empty-inline-caption"), !this._hasRowDataValues()), 
                _defineProperty(_captionClasses, "".concat(this.rootClass, "__caption--empty-inline-caption-with-border"), !this._hasRowDataValues() && this.layout === "rowInline"), 
                _captionClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("caption", null, null, "class", captionClasses);
                _renderArbitrary(caption);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("caption");
            }
            function _renderRowInlineCaption() {
                var _captionInlineClasses;
                var summary = this.summary, hiddenAccessibleTotalSumText = this.hiddenAccessibleTotalSumText, caption = this.caption;
                var captionInlineClasses = (_captionInlineClasses = {}, _defineProperty(_captionInlineClasses, "".concat(this.rootClass, "__caption"), true), 
                _defineProperty(_captionInlineClasses, "".concat(this.rootClass, "__caption--inline"), true), 
                _captionInlineClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("caption", null, null, "class", captionInlineClasses);
                _renderArbitrary(caption);
                _renderArbitrary(hiddenAccessibleTotalSumText ? (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text"), 
                _renderArbitrary(hiddenAccessibleTotalSumText), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")) : "");
                _renderArbitrary(summary ? (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text"), 
                _renderArbitrary(summary), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")) : "");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("caption");
            }
            function _renderCaption() {
                var _captionClasses2;
                var layout = this.layout;
                if (layout === "rowInline") {
                    return _renderRowInlineCaption.call(this);
                }
                var hasVisibleCaption = this.hasVisibleCaption, summary = this.summary, caption = this.caption;
                var captionClasses = (_captionClasses2 = {}, _defineProperty(_captionClasses2, "".concat(this.rootClass, "__caption"), true), 
                _defineProperty(_captionClasses2, "".concat(this.rootClass, "__caption--is-safari"), MDS.isSafari && !MDS.isIOS), 
                _defineProperty(_captionClasses2, "".concat(this.rootClass, "__caption--is-ios"), MDS.isIOS), 
                _defineProperty(_captionClasses2, "".concat(this.rootClass, "__caption--checkbox-offset"), this._hasCheckboxAndHeaders()), 
                _defineProperty(_captionClasses2, "".concat(this.rootClass, "__caption--block"), true), 
                _defineProperty(_captionClasses2, "".concat(this.rootClass, "__caption--hidden"), !hasVisibleCaption), 
                _captionClasses2);
                if (MDS.isIOS) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", captionClasses, "id", "caption");
                    _renderArbitrary(caption);
                    _renderArbitrary(summary ? (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text"), 
                    _renderArbitrary(summary), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")) : "");
                    return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                }
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("caption", null, null, "class", captionClasses, "id", "caption");
                _renderArbitrary(caption);
                _renderArbitrary(summary ? (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text"), 
                _renderArbitrary(summary), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")) : "");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("caption");
            }
            function _generateColumn() {
                var _this = this;
                return this.columnConfigs.map(function(_, colIndex) {
                    _newArrowCheck(this, _this);
                    return this._columnObjects[colIndex].renderColumnHeader({}, {
                        sortedDirection: this._sortedColumn === colIndex && this._sortedDirection,
                        numRows: this.rowData.length
                    });
                }.bind(this));
            }
            function _renderColumnHeader() {
                var idColumnHeader = "".concat(this.rootClass, "__column-headers");
                if (!this._hasColumnHeaderValues()) {
                    return "";
                }
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("thead");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("tr", null, null, "id", idColumnHeader, "class", "".concat(this.rootClass, "__header-row--").concat(this.mode));
                _renderArbitrary(_generateColumn.call(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tr");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("thead");
            }
            function _generateCellRowHeaderChartTable(value, idRowHeader, rowHeaderClasses, columnWidth, swatchShape, swatchClasses, swatchStyle) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("th");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRowHeader);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("scope", "row");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", rowHeaderClasses);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    style: {
                        width: columnWidth
                    }
                }, !!columnWidth));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("th");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "data-table-for-chart__swatch-container");
                _renderArbitrary(swatchShape ? Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", swatchClasses, "style", swatchStyle) : "");
                _renderArbitrary(_utils_table_utils__WEBPACK_IMPORTED_MODULE_2__["cleanDisplayValue"].call(this, value));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("th");
            }
            function _generateCellRowHeader(value, idRowHeader, rowHeaderClasses, columnWidth) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("th");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRowHeader);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("scope", "row");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", rowHeaderClasses);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    style: {
                        width: columnWidth
                    }
                }, !!columnWidth));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("th");
                _renderArbitrary(_utils_table_utils__WEBPACK_IMPORTED_MODULE_2__["cleanDisplayValue"].call(this, value));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("th");
            }
            function _generateCellRowValue(value, idRowValue, rowValueClasses, columnWidth, footer) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("td");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRowValue);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", rowValueClasses);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    style: {
                        width: columnWidth
                    }
                }, !!columnWidth));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("td");
                _renderArbitrary(_utils_table_utils__WEBPACK_IMPORTED_MODULE_2__["cleanDisplayValue"].call(this, value, footer));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("td");
            }
            function _generateCellRowValueFooter(value, idRowValue, rowValueClasses, columnWidth, footer, colIndex) {
                var appendingString = "".concat(this.footer[0].value, " ").concat(value, " ");
                var footerValue = _jsxWrapper(_footerValue$wrapper, [ _utils_table_utils__WEBPACK_IMPORTED_MODULE_2__["cleanDisplayValue"], [ this, value, footer ], value && colIndex !== 0 && _jsxWrapper(_footerValue$wrapper2, [ appendingString ]) ]);
                if ((this.layout === "rowInline" || this.layout === "row") && colIndex === 0) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("th");
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRowValue);
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", rowValueClasses);
                    _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                        style: {
                            width: columnWidth
                        }
                    }, !!columnWidth));
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("th");
                    _renderArbitrary(footerValue);
                    return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("th");
                }
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("td");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRowValue);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", rowValueClasses);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    style: {
                        width: columnWidth
                    }
                }, !!columnWidth));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("td");
                _renderArbitrary(footerValue);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("td");
            }
            function _generateCellRowHeaderInline(idRowHeader, rowHeaderClasses, columnWidth) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("th");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRowHeader);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("scope", "row");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", rowHeaderClasses);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    style: {
                        width: columnWidth
                    }
                }, !!columnWidth));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("th");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("th");
            }
            function _renderAriaLive() {
                var liveText;
                if (this._liveTextType === "sort") {
                    liveText = this._columnObjects[this._sortedColumn].sortAccessibleText;
                } else if (this._liveTextType === "checkbox") {
                    var checkboxColumn = this._columnObjects[0];
                    liveText = "".concat(checkboxColumn.config.descriptionKey, " ").concat(checkboxColumn.getDescriptionValue(this.rowData.length));
                }
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "aria-live", "polite", "aria-atomic", "true", "class", "accessible-text");
                _renderArbitrary(this._ariaLiveActive && liveText);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function _renderAllStackedTables() {
                var _this2 = this, _captionClasses3;
                var rootClass = this.rootClass, id = this.id, columnConfigs = this.columnConfigs, sortMap = this.sortMap, rowDataCleaned = this.rowDataCleaned, hasVisibleCaption = this.hasVisibleCaption, stackedCaptionHeadingLevel = this.stackedCaptionHeadingLevel, caption = this.caption;
                var hasRowHeaders = this._hasRowHeaderValues() || this._hasRepeatRowHeaderValues();
                var hasColumnHeaders = this._hasColumnHeaderValues();
                if (!columnConfigs) {
                    this.throwConstraintError("column-configs should not be empty");
                }
                var hasCheckboxes = columnConfigs[0] && columnConfigs[0].columnType === "checkbox";
                var data = sortMap ? sortMap.map(function(index) {
                    _newArrowCheck(this, _this2);
                    return rowDataCleaned[index];
                }.bind(this)) : rowDataCleaned;
                var captionClasses = (_captionClasses3 = {}, _defineProperty(_captionClasses3, "".concat(rootClass, "__stacked-caption-heading"), true), 
                _defineProperty(_captionClasses3, "".concat(rootClass, "__stacked-caption-heading--with-reduced-spacing"), hasRowHeaders && hasColumnHeaders || hasCheckboxes), 
                _defineProperty(_captionClasses3, "".concat(rootClass, "__stacked-caption-heading--hidden"), !hasVisibleCaption), 
                _captionClasses3);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("section");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", id);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "".concat(rootClass, "__stacked-container"));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-labelledby", "".concat(id, "-stacked-caption-heading"));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onclick", this._handleClick);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    onchange: this._handleChange
                }, !!this._handleChange));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("section");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("h2", null, null, "id", "".concat(id, "-stacked-caption-heading"), "aria-level", stackedCaptionHeadingLevel, "class", captionClasses);
                _renderArbitrary(caption);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("h2");
                _renderArbitrary(hasCheckboxes && this._columnObjects[0].renderStackedTopCheckbox(_extends({}, columnConfigs[0], {
                    numRows: data.length
                })));
                _renderArbitrary(data.map(_renderSingleStackedTable.bind(this, hasRowHeaders, hasColumnHeaders, hasCheckboxes)));
                _renderArbitrary(this.footer && _renderStackedFooter.call(this, hasRowHeaders, hasColumnHeaders, hasCheckboxes, this.footer, data.length));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("section");
            }
            function _renderSingleStackedTable(hasRowHeaders, hasColumnHeaders, hasCheckboxes, row, rowIndex, rows) {
                this._lastStackedRowHeaderValue = null;
                var captionCellObject = this._columnObjects[hasCheckboxes ? 1 : 0];
                var headerData = row[hasCheckboxes ? 1 : 0];
                var hasExternalCaption = captionCellObject.needsExternalStackedCaption(headerData, {
                    hasCheckboxes: hasCheckboxes
                });
                var captionId = "".concat(this.id, "-subtable-").concat(rowIndex, "-caption");
                var rendersCheckbox = hasCheckboxes && hasRowHeaders && hasColumnHeaders;
                var checkbox = rendersCheckbox && this._columnObjects[0].renderStackedCheckbox.bind(this._columnObjects[0], row[0], rowIndex);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div");
                _renderArbitrary(hasRowHeaders && hasColumnHeaders && hasExternalCaption && captionCellObject.renderStackedCaption(headerData, rowIndex, {
                    renderAsDiv: true,
                    captionId: captionId,
                    checkbox: checkbox
                }));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("table");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "".concat(this.id, "-subtable-").concat(rowIndex));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", this.rootClass);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    "aria-labelledby": captionId
                }, hasRowHeaders && hasColumnHeaders && hasExternalCaption));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("table");
                _renderArbitrary(hasRowHeaders && hasColumnHeaders && !hasExternalCaption && captionCellObject.renderStackedCaption(headerData, rowIndex, {
                    checkbox: checkbox
                }));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("tbody");
                _renderArbitrary(row.map(_renderStackedRow.bind(this, rowIndex, hasRowHeaders, hasColumnHeaders, hasCheckboxes)));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tbody");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("table");
                _renderArbitrary(rowIndex !== rows.length - 1 && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "".concat(this.rootClass, "__separator")));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function _renderStackedRow(rowIndex, hasRowHeaders, hasColumnHeaders, hasCheckboxes, cellData, colIndex, row) {
                var _rowClasses;
                if (colIndex === 0 && (hasRowHeaders || hasCheckboxes) || colIndex === 1 && hasRowHeaders && hasCheckboxes) {
                    return "";
                }
                var columnConfig = this.columnConfigs[colIndex];
                var columnObject = this._columnObjects[colIndex];
                var rowClasses = (_rowClasses = {}, _defineProperty(_rowClasses, "".concat(this.rootClass, "__row"), true), 
                _defineProperty(_rowClasses, "".concat(this.rootClass, "__row--").concat(this.mode), true), 
                _defineProperty(_rowClasses, "".concat(this.rootClass, "__row--activated"), this.activated), 
                _defineProperty(_rowClasses, "".concat(this.rootClass, "__row--select"), this.columnConfigs[colIndex].columnType === "select"), 
                _rowClasses);
                var headerObject = columnObject;
                var headerValue = columnConfig.headerValue;
                var rendersCheckbox = hasCheckboxes && (colIndex === 1 || colIndex === 2 && hasRowHeaders && !hasColumnHeaders);
                var headerCellConfig = {
                    isHidden: false,
                    sortMap: this.sortMap,
                    hasInlineCaption: this.layout === "rowInline",
                    checkbox: rendersCheckbox && this._columnObjects[0].renderStackedCheckbox.bind(this._columnObjects[0], row[0], rowIndex)
                };
                if (!hasColumnHeaders) {
                    var headerIndex = hasCheckboxes ? 1 : 0;
                    headerValue = row[headerIndex].value;
                    headerCellConfig.cellData = row[headerIndex];
                    headerObject = this._columnObjects[headerIndex];
                    headerCellConfig.isHidden = headerValue === this._lastStackedRowHeaderValue;
                    this._lastStackedRowHeaderValue = headerValue;
                }
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("tr");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "table-".concat(rowIndex + 1, "-row-").concat(rowIndex + 1, "-stacked-row-").concat(colIndex + 1));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", rowClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-index", rowIndex + 1);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-values", [ headerValue, cellData.value ].toString());
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    onmouseenter: this.highlightRow
                }, this.activated));
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    onmouseleave: this.highlightRowOff
                }, this.activated));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("tr");
                _renderArbitrary(headerObject.renderStackedHeader(headerValue, rowIndex, this.stackedHeaderWidth || this.columnConfigs[0].width, headerCellConfig, colIndex));
                _renderArbitrary(columnObject.renderStackedCell(cellData, rowIndex, this.stackedCellWidth || this.columnConfigs[1].width, colIndex));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tr");
            }
            function _renderStackedFooter(hasRowHeaders, hasColumnHeaders, hasCheckboxes, row, rowIndex) {
                var captionCellObject = this._columnObjects[hasCheckboxes ? 1 : 0];
                var headerData = row[hasCheckboxes ? 1 : 0];
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "".concat(this.rootClass, "__separator--footer"));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("table", null, null, "id", "".concat(this.id, "-subtable-").concat(rowIndex), "class", this.rootClass);
                _renderArbitrary(this.layout !== "rowInline" && hasColumnHeaders && captionCellObject.renderStackedFooterCaption(headerData));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("tfoot");
                _renderArbitrary(row.map(_renderStackedFooterRow.bind(this, rowIndex, hasRowHeaders, hasColumnHeaders, hasCheckboxes)));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tfoot");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("table");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function _renderStackedFooterRow(rowIndex, hasRowHeaders, hasColumnHeaders, hasCheckboxes, cellData, colIndex, row) {
                var _rowClasses2;
                if (colIndex === 0 || hasCheckboxes && colIndex === 1) {
                    return "";
                }
                var columnConfig = this.columnConfigs[colIndex];
                var columnObject = this._columnObjects[colIndex];
                var rowClasses = (_rowClasses2 = {}, _defineProperty(_rowClasses2, "".concat(this.rootClass, "__row"), true), 
                _defineProperty(_rowClasses2, "".concat(this.rootClass, "__row--compact"), true), 
                _defineProperty(_rowClasses2, "".concat(this.rootClass, "__row--activated"), this.activated), 
                _rowClasses2);
                var headerObject = columnObject;
                var headerValue = columnConfig.headerValue;
                var headerCellConfig = {
                    isHidden: false,
                    sortMap: this.sortMap,
                    hasInlineCaption: this.layout === "rowInline"
                };
                if (!hasColumnHeaders) {
                    var headerIndex = hasCheckboxes ? 1 : 0;
                    headerValue = row[headerIndex].value;
                    headerObject = this._columnObjects[headerIndex];
                    headerCellConfig.isHidden = headerValue === this._lastStackedRowHeaderValue;
                    this._lastStackedRowHeaderValue = headerValue;
                }
                if (row[colIndex].value) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("tr");
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "table-".concat(rowIndex + 1, "-row-").concat(rowIndex + 1));
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", rowClasses);
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-index", rowIndex + 1);
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-values", [ headerValue, cellData.value ].toString());
                    _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                        onmouseenter: this.highlightRow
                    }, this.activated));
                    _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                        onmouseleave: this.highlightRowOff
                    }, this.activated));
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("tr");
                    _renderArbitrary(headerObject.renderStackedFooterHeadingCell(headerValue, rowIndex, this.stackedHeaderWidth || this.columnConfigs[0].width, headerCellConfig));
                    _renderArbitrary(columnObject.renderStackedFooterCell(cellData, rowIndex, this.stackedCellWidth || this.columnConfigs[1].width));
                    return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tr");
                }
            }
            function _generateCellRowValueInline(value, idRowValue, rowValueClasses, columnWidth) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("td");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRowValue);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", rowValueClasses);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    style: {
                        width: columnWidth
                    }
                }, !!columnWidth));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("td");
                _renderArbitrary(_utils_table_utils__WEBPACK_IMPORTED_MODULE_2__["cleanDisplayValue"].call(this, value));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("td");
            }
        },
        "./src/abstract-data-table/columns/abstract-column/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", (function() {
                return AbstractColumn;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_table_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/table-utils.jsx");
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/data-utils.js");
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var touchOrMousedown = "ontouchstart" in window ? "touchstart" : "click";
            var AbstractColumn = function() {
                function AbstractColumn(rootClass) {
                    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    _classCallCheck(this, AbstractColumn);
                    this._rootClass = rootClass;
                    this._canBeSortable = false;
                    this._canBeDate = false;
                    this._canHaveSecondaryTertiaryText = false;
                    this.config = config;
                    this._defaultAscendingA11yText = "sorted A to Z";
                    this._defaultDescendingA11yText = "sorted Z to A";
                    this._defaultUnsortedA11yText = "not sorted";
                    this._sortingGroupMenuExpanded = false;
                    this._expandSortingGroupMenu = this._expandSortingGroupMenu.bind(this);
                    this._collapseSortingGroupMenu = this._collapseSortingGroupMenu.bind(this);
                    this._setFocusOnFirstItem = this._setFocusOnFirstItem.bind(this);
                    this._updateSelectedMenuItem = this._updateSelectedMenuItem.bind(this);
                }
                _createClass(AbstractColumn, [ {
                    key: "validateColumn",
                    value: function validateColumn() {}
                }, {
                    key: "needsExternalStackedCaption",
                    value: function needsExternalStackedCaption() {
                        return false;
                    }
                }, {
                    key: "getInteractiveElement",
                    value: function getInteractiveElement(table, payload) {
                        var rowIndex = payload.rowIndex, colIndex = payload.colIndex, type = payload.type;
                        var interactiveElement = table.shadowRoot.querySelector('*[data-type="'.concat(type, '"][data-row="').concat(rowIndex, '"][data-column="').concat(colIndex, '"]'));
                        return {
                            interactiveElement: interactiveElement
                        };
                    }
                }, {
                    key: "_cleanDisplayValue",
                    value: function _cleanDisplayValue(val, handleNegatives) {
                        if (Object(_utils_table_utils__WEBPACK_IMPORTED_MODULE_2__["isEmptyValue"])(val)) {
                            return this._renderEmptyValue();
                        }
                        var minusSignIndex = val[0] === "(" ? 1 : 0;
                        var isNegativeValue = val[minusSignIndex] === "-" || val[minusSignIndex] === "−";
                        if (handleNegatives && isNegativeValue) {
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "aria-hidden", "true");
                            _renderArbitrary(Object(_utils_table_utils__WEBPACK_IMPORTED_MODULE_2__["cleanNegativeNum"])(val));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text");
                            _renderArbitrary("".concat(this.config.accessibleSingleValueNegative, " ").concat(val.slice(minusSignIndex + 1)));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                            return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        }
                        return val;
                    }
                }, {
                    key: "createSortMap",
                    value: function createSortMap(rows) {
                        var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ascending";
                        if (!this._canBeSortable) {
                            throw new Error("Column ".concat(this.config.colIndex, " is not sortable!"));
                        }
                        return Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["convertRange"])(0, rows.length - 1).sort(this._compare.bind(this, rows, direction === "ascending"));
                    }
                }, {
                    key: "_compare",
                    value: function _compare(rows, isAscending, rowIndex1, rowIndex2) {
                        var result = 0;
                        var value1 = rows[rowIndex1][this.config.colIndex].value;
                        var isValue1Empty = Object(_utils_table_utils__WEBPACK_IMPORTED_MODULE_2__["isEmptyValue"])(value1);
                        var value2 = rows[rowIndex2][this.config.colIndex].value;
                        var isValue2Empty = Object(_utils_table_utils__WEBPACK_IMPORTED_MODULE_2__["isEmptyValue"])(value2);
                        if (this._canBeDate && this.config.date) {
                            value1 = new Date(value1);
                            value2 = new Date(value2);
                        }
                        value1 = typeof value1 === "string" ? value1.toLowerCase() : value1;
                        value2 = typeof value2 === "string" ? value2.toLowerCase() : value2;
                        if (isValue1Empty && !isValue2Empty || value1 < value2) {
                            result = isAscending ? -1 : 1;
                        } else if (!isValue1Empty && isValue2Empty || value1 > value2) {
                            result = isAscending ? 1 : -1;
                        }
                        return result;
                    }
                }, {
                    key: "_expandSortingGroupMenu",
                    value: function _expandSortingGroupMenu(columnIndex, shadowRoot) {
                        this._sortingGroupMenuExpanded = true;
                        this._setMultiLevelSortingMenuPosition(columnIndex, shadowRoot);
                        window.addEventListener(touchOrMousedown, this.config.multiLevelSortingMenuBlurHandler);
                    }
                }, {
                    key: "_setFocusOnFirstItem",
                    value: function _setFocusOnFirstItem(columnIndex, shadowRoot) {
                        var firstMenuItem = shadowRoot.querySelector("#multiLevelSortingMenu-".concat(columnIndex, " .").concat(this._rootClass, "__multi-level-sorting-menu-item__item"));
                        firstMenuItem && firstMenuItem.focus();
                    }
                }, {
                    key: "_collapseSortingGroupMenu",
                    value: function _collapseSortingGroupMenu() {
                        this._sortingGroupMenuExpanded = false;
                        window.removeEventListener(touchOrMousedown, this.config.multiLevelSortingMenuBlurHandler);
                    }
                }, {
                    key: "_setMultiLevelSortingMenuPosition",
                    value: function _setMultiLevelSortingMenuPosition(columnIndex, shadowRoot) {
                        var multiLevelSortingMenu = shadowRoot.getElementById("multiLevelSortingMenu-".concat(columnIndex));
                        var multiLevelSortingButtonHeader = shadowRoot.getElementById("sort-button-".concat(columnIndex));
                        multiLevelSortingMenu.style.top = "".concat(multiLevelSortingButtonHeader.offsetHeight, "px");
                    }
                }, {
                    key: "_updateSelectedMenuItem",
                    value: function _updateSelectedMenuItem(event, currentSelectedMenuItem) {
                        var selectedItemInfo = event.target.dataset;
                        if (currentSelectedMenuItem) {
                            this.config.multiLevelSorting[currentSelectedMenuItem.groupindex].menuItems[currentSelectedMenuItem.itemindex].selected = false;
                        }
                        this.config.multiLevelSorting[selectedItemInfo.groupindex].menuItems[selectedItemInfo.itemindex].selected = true;
                        this._currentSelectedSortingMenuItem = selectedItemInfo;
                    }
                }, {
                    key: "_handleSortingGroupMenuBlur",
                    value: function _handleSortingGroupMenuBlur(event, columnIndex) {
                        event.stopPropagation();
                        var _columnObjects = this._columnObjects, shadowRoot = this.shadowRoot;
                        var columnObject = _columnObjects[columnIndex];
                        var sortingGroupMenu = shadowRoot.getElementById("column-header-".concat(columnIndex));
                        if (!sortingGroupMenu.contains(event.detail && event.detail.target)) {
                            columnObject._collapseSortingGroupMenu();
                            this._updateSortingMenuDisplayedState(columnObject._sortingGroupMenuExpanded);
                        }
                    }
                }, {
                    key: "handleMultiLevelSortingHeaderClick",
                    value: function handleMultiLevelSortingHeaderClick(event, columnIndex) {
                        event.stopPropagation();
                        if (event.originalEvent && event.originalEvent.detail > 1) {
                            return;
                        }
                        var _sortingGroupMenuExpanded = this._sortingGroupMenuExpanded, _columnObjects = this._columnObjects, shadowRoot = this.shadowRoot;
                        var columnObject = _columnObjects[columnIndex];
                        _sortingGroupMenuExpanded ? columnObject._collapseSortingGroupMenu(columnIndex) : columnObject._expandSortingGroupMenu(columnIndex, shadowRoot);
                        this._updateSortingMenuDisplayedState(columnObject._sortingGroupMenuExpanded);
                        if (this._sortingGroupMenuExpanded) {
                            columnObject._setFocusOnFirstItem(columnIndex, shadowRoot);
                        }
                    }
                }, {
                    key: "handleMultiLevelSortingMenuItemKeyDown",
                    value: function handleMultiLevelSortingMenuItemKeyDown(event, columnIndex) {
                        var shadowRoot = this.shadowRoot, _columnObjects = this._columnObjects;
                        var columnObject = _columnObjects[columnIndex];
                        var _focusableNodes = _toConsumableArray(shadowRoot.querySelectorAll("#multiLevelSortingMenu-".concat(columnIndex, " .").concat(this.rootClass, "__multi-level-sorting-menu-item__item")));
                        var targetIndex = _focusableNodes && _focusableNodes.indexOf(event.target);
                        if ([ 32, 13 ].includes(event.keyCode)) {
                            event.preventDefault();
                            event.target.click();
                        } else if (event.keyCode === 38) {
                            event.preventDefault();
                            targetIndex === 0 ? _focusableNodes[_focusableNodes.length - 1].focus() : _focusableNodes[targetIndex - 1].focus();
                        } else if (event.keyCode === 40) {
                            event.preventDefault();
                            targetIndex === _focusableNodes.length - 1 ? _focusableNodes[0].focus() : _focusableNodes[targetIndex + 1].focus();
                        } else if (event.keyCode === 9) {
                            columnObject._collapseSortingGroupMenu(columnIndex);
                            this._updateSortingMenuDisplayedState(columnObject._sortingGroupMenuExpanded);
                        }
                    }
                }, {
                    key: "handleMultiLevelSortingMenuItemKeyUp",
                    value: function handleMultiLevelSortingMenuItemKeyUp(event, columnIndex) {
                        var _columnObjects = this._columnObjects, shadowRoot = this.shadowRoot;
                        var columnObject = _columnObjects[columnIndex];
                        var multiLevelSortingHeader = shadowRoot.getElementById("sort-button-".concat(columnIndex));
                        if (Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["isEscAndShouldClose"])(event)) {
                            columnObject._collapseSortingGroupMenu(columnIndex);
                            this._updateSortingMenuDisplayedState(columnObject._sortingGroupMenuExpanded);
                            multiLevelSortingHeader.focus();
                        }
                    }
                }, {
                    key: "handleMultiLevelSortingMenuItemClick",
                    value: function handleMultiLevelSortingMenuItemClick(event, columnIndex) {
                        event.stopPropagation();
                        var _columnObjects = this._columnObjects, shadowRoot = this.shadowRoot;
                        var columnObject = _columnObjects[columnIndex];
                        var multiLevelSortingHeader = shadowRoot.getElementById("sort-button-".concat(columnIndex));
                        try {
                            columnObject._updateSelectedMenuItem(event, this._currentSelectedSortingMenuItem);
                            this._currentSelectedSortingMenuItem = columnObject._currentSelectedSortingMenuItem;
                        } catch (e) {
                            console.error("not able to update selected sorting option, please check: ".concat(e));
                        }
                        columnObject._collapseSortingGroupMenu(columnIndex);
                        this._updateSortingMenuDisplayedState(columnObject._sortingGroupMenuExpanded);
                        multiLevelSortingHeader && multiLevelSortingHeader.focus();
                        this._dispatchSortEvent(event, {
                            isMultiLevelSorting: true,
                            columnIndex: columnIndex,
                            value: event.target.value
                        });
                    }
                }, {
                    key: "renderColumnHeader",
                    value: function renderColumnHeader(additionalClasses, headerConfig) {
                        var _extends2;
                        var _this$config = this.config, width = _this$config.width, colIndex = _this$config.colIndex, headerValue = _this$config.headerValue, multiLevelSorting = _this$config.multiLevelSorting;
                        var idColumnHeader = "column-header-".concat(colIndex);
                        var columnHeaderClasses = _extends((_extends2 = {}, _defineProperty(_extends2, "".concat(this._rootClass, "__column-header"), true), 
                        _defineProperty(_extends2, "".concat(this._rootClass, "__column-header--sortable"), this._canBeSortable && this.config.sortable), 
                        _extends2), additionalClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("th");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("scope", "col");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idColumnHeader);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", columnHeaderClasses);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                            style: {
                                width: width
                            }
                        }, width));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("th");
                        _renderArbitrary(multiLevelSorting && multiLevelSorting.length ? this._generateMultiLevelSortingHeader(headerValue, headerConfig, multiLevelSorting) : this._generateHeader(headerValue, headerConfig));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("th");
                    }
                }, {
                    key: "_generateSortingHeader",
                    value: function _generateSortingHeader(headerValue, headerConfig, headClickAction, multiLevelSorting) {
                        var _headerClasses;
                        var width = this.config.width;
                        var headerClasses = (_headerClasses = {}, _defineProperty(_headerClasses, "".concat(this._rootClass, "__column-header--value"), true), 
                        _defineProperty(_headerClasses, "".concat(this._rootClass, "__column-header-action"), this.config.columnType === "buttons"), 
                        _headerClasses);
                        if (this._canBeSortable && this.config.sortable) {
                            var sortedDirection = headerConfig.sortedDirection;
                            var sortAccessibleText = this.config.unsortedAccessibleText || this._defaultUnsortedA11yText;
                            var type = "ico_sort";
                            if (sortedDirection === "ascending") {
                                type = "ico_caret_up";
                                sortAccessibleText = this.config.sortedAscendingAccessibleText || this._defaultAscendingA11yText;
                            } else if (sortedDirection === "descending") {
                                type = "ico_caret_down";
                                sortAccessibleText = this.config.sortedDescendingAccessibleText || this._defaultDescendingA11yText;
                            }
                            this.sortAccessibleText = "".concat(Object(_utils_table_utils__WEBPACK_IMPORTED_MODULE_2__["isEmptyValue"])(headerValue) ? this.config.accessibleSingleValueEmpty : headerValue, ", ").concat(sortAccessibleText);
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("button");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onclick", headClickAction);
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-index", this.config.colIndex);
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-direction", sortedDirection);
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "".concat(this._rootClass, "__column-header-sort-button"));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "sort-button-".concat(this.config.colIndex));
                            _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                                style: {
                                    "min-width": width
                                }
                            }, width));
                            _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                                "aria-expanded": this._sortingGroupMenuExpanded
                            }, multiLevelSorting));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("button");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text");
                            _renderArbitrary(this.sortAccessibleText);
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("button");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "aria-hidden", "true", "class", "".concat(this._rootClass, "__column-header-sort-text-container"));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "".concat(this._rootClass, "__column-header-sort-text"), "aria-hidden", "true");
                            _renderArbitrary(this._cleanDisplayValue(headerValue));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "innerHTML-prop", MDS.svgs[type], "class", "".concat(this._rootClass, "__column-header-sort-icon"), "aria-hidden", "true", "__skip", "true");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                            _renderArbitrary(multiLevelSorting && this._generateMultiLevelSortingGroup(multiLevelSorting));
                            return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        }
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", headerClasses);
                        _renderArbitrary(this._cleanDisplayValue(headerValue));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "_generateHeader",
                    value: function _generateHeader(headerValue, headerConfig) {
                        return this._generateSortingHeader(headerValue, headerConfig, this.config.sortClickHandler);
                    }
                }, {
                    key: "_generateMultiLevelSortingHeader",
                    value: function _generateMultiLevelSortingHeader(headerValue, headerConfig, multiLevelSorting) {
                        return this._generateSortingHeader(headerValue, headerConfig, this.config.multiLevelSortingHeaderClickHandler, multiLevelSorting);
                    }
                }, {
                    key: "_generateMultiLevelSortingGroup",
                    value: function _generateMultiLevelSortingGroup(multiLevelSorting) {
                        var _multiLevelSortingMen, _this = this;
                        var multiLevelSortingMenuClasses = (_multiLevelSortingMen = {}, _defineProperty(_multiLevelSortingMen, "".concat(this._rootClass, "__multi-level-sorting"), true), 
                        _defineProperty(_multiLevelSortingMen, "".concat(this._rootClass, "__multi-level-sorting--displayed"), this._sortingGroupMenuExpanded), 
                        _multiLevelSortingMen);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", multiLevelSortingMenuClasses, "id", "multiLevelSortingMenu-".concat(this.config.colIndex));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("ul", null, null, "class", "".concat(this._rootClass, "__multi-level-sorting-group"), "role", "menu");
                        _renderArbitrary(multiLevelSorting.map(function(multiLevelSortingGroup, groupIndex) {
                            var _this2 = this;
                            _newArrowCheck(this, _this);
                            this._renderMultiLevelSortingGroupHeader(multiLevelSortingGroup);
                            return multiLevelSortingGroup.menuItems.map(function(multiLevelSortingMenuItem, itemIndex) {
                                _newArrowCheck(this, _this2);
                                return this._renderMultiLevelSortingMenuItem(multiLevelSortingMenuItem, multiLevelSortingGroup.label, groupIndex, itemIndex);
                            }.bind(this));
                        }.bind(this)));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("ul");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "_renderMultiLevelSortingGroupHeader",
                    value: function _renderMultiLevelSortingGroupHeader(group) {
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "".concat(this._rootClass, "__multi-level-sorting-item__header"), "aria-hidden", "true");
                        _renderArbitrary(group.label);
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "_renderMultiLevelSortingMenuItem",
                    value: function _renderMultiLevelSortingMenuItem(multiLevelSortingMenuItem, label, groupIndex, itemIndex) {
                        var _multiLevelSortingMen2;
                        var accessibleLabel = "".concat(label, ", ").concat(multiLevelSortingMenuItem.label);
                        var multiLevelSortingMenuItemClasses = (_multiLevelSortingMen2 = {}, _defineProperty(_multiLevelSortingMen2, "".concat(this._rootClass, "__multi-level-sorting-menu-item"), true), 
                        _defineProperty(_multiLevelSortingMen2, "".concat(this._rootClass, "__multi-level-sorting-menu-item--selected"), multiLevelSortingMenuItem.selected), 
                        _multiLevelSortingMen2);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("li", null, null, "class", multiLevelSortingMenuItemClasses, "role", "presentation");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "".concat(this._rootClass, "__multi-level-sorting-menu-item__bar"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("button", null, null, "class", "".concat(this._rootClass, "__multi-level-sorting-menu-item__item"), "onclick", this.config.multiLevelSortingMenuItemClickHandler, "onkeydown", this.config.multiLevelSortingMenuKeyDownHandler, "onkeyup", this.config.multiLevelSortingMenuKeyUpHandler, "aria-label", accessibleLabel, "aria-current", multiLevelSortingMenuItem.selected, "role", "menuitem", "data-label", multiLevelSortingMenuItem.label, "value", multiLevelSortingMenuItem.value, "data-groupIndex", groupIndex, "data-itemIndex", itemIndex);
                        _renderArbitrary(multiLevelSortingMenuItem.label);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("button");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("li");
                    }
                }, {
                    key: "_renderHiddenCell",
                    value: function _renderHiddenCell(cellValue, cellData) {
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text");
                        _renderArbitrary(cellValue || this.config.accessibleSingleValueEmpty);
                        _renderArbitrary(this._canHaveSecondaryTertiaryText && cellData && cellData.secondaryValue && this._renderSecondaryTertiaryText(cellData));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                    }
                }, {
                    key: "_renderEmptyValue",
                    value: function _renderEmptyValue() {
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "aria-hidden", "true");
                        _renderArbitrary("—");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                    }
                }, {
                    key: "renderStackedCell",
                    value: function renderStackedCell(cellData, rowIndex, width, colIndex) {
                        var _stackedCellClasses;
                        var value = cellData.value;
                        var idRowValue = "value-row-".concat(rowIndex + 1, "-column-").concat(colIndex + 1);
                        var stackedCellClasses = (_stackedCellClasses = {}, _defineProperty(_stackedCellClasses, "".concat(this._rootClass, "__row-value"), true), 
                        _defineProperty(_stackedCellClasses, "".concat(this._rootClass, "__row-value--text"), true), 
                        _stackedCellClasses);
                        if (MDS.isSafari) {
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("td");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRowValue);
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", stackedCellClasses);
                            _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                                style: {
                                    width: width
                                }
                            }, width));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("td");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "role", "text");
                            _renderArbitrary(this._cleanDisplayValue.call(this, value));
                            _renderArbitrary(this._canHaveSecondaryTertiaryText && cellData.secondaryValue && this._renderSecondaryTertiaryText(cellData));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                            return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("td");
                        }
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("td");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRowValue);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", stackedCellClasses);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                            style: {
                                width: width
                            }
                        }, width));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("td");
                        _renderArbitrary(this._cleanDisplayValue.call(this, value));
                        _renderArbitrary(this._canHaveSecondaryTertiaryText && cellData.secondaryValue && this._renderSecondaryTertiaryText(cellData));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("td");
                    }
                }, {
                    key: "renderStackedHeader",
                    value: function renderStackedHeader(value, rowIndex, width, cellConfig, colIndex) {
                        var _rowHeaderClasses;
                        var isHidden = cellConfig.isHidden, cellData = cellConfig.cellData;
                        var idRowHeader = "row-header-row-".concat(rowIndex + 1, "-column-").concat(colIndex + 1);
                        var rowHeaderClasses = (_rowHeaderClasses = {}, _defineProperty(_rowHeaderClasses, "".concat(this._rootClass, "__row-header"), true), 
                        _defineProperty(_rowHeaderClasses, "".concat(this._rootClass, "__row-header--").concat(this.config.mode), true), 
                        _rowHeaderClasses);
                        if (!cellConfig.checkbox && MDS.isSafari) {
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("th");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRowHeader);
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("scope", "row");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", rowHeaderClasses);
                            _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                                style: {
                                    width: width
                                }
                            }, width));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("th");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "".concat(this._rootClass, "__row-header-container"), "role", "text");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span");
                            _renderArbitrary(isHidden ? this._renderHiddenCell(value) : this._cleanDisplayValue.call(this, value));
                            _renderArbitrary(this._canHaveSecondaryTertiaryText && !isHidden && cellData && cellData.secondaryValue && this._renderSecondaryTertiaryText(cellData));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                            return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("th");
                        }
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("th");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRowHeader);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("scope", "row");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", rowHeaderClasses);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                            style: {
                                width: width
                            }
                        }, width));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("th");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", `${this._rootClass}__row-header-container`);
                        _renderArbitrary(!!cellConfig.checkbox && cellConfig.checkbox());
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span");
                        _renderArbitrary(isHidden ? this._renderHiddenCell(value) : this._cleanDisplayValue.call(this, value));
                        _renderArbitrary(this._canHaveSecondaryTertiaryText && !isHidden && cellData && cellData.secondaryValue && this._renderSecondaryTertiaryText(cellData));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("th");
                    }
                }, {
                    key: "renderStackedFooterCaption",
                    value: function renderStackedFooterCaption(cellData) {
                        var _captionClasses;
                        var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        var caption = "".concat(cellData.value);
                        var captionClasses = (_captionClasses = {}, _defineProperty(_captionClasses, "".concat(this._rootClass, "__caption"), true), 
                        _defineProperty(_captionClasses, "".concat(this._rootClass, "__caption--stacked"), true), 
                        _defineProperty(_captionClasses, "".concat(this._rootClass, "__caption--stacked-footer"), true), 
                        _captionClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("caption", null, null, "class", captionClasses);
                        _renderArbitrary(caption);
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("caption");
                    }
                }, {
                    key: "renderStackedFooterHeadingCell",
                    value: function renderStackedFooterHeadingCell(value, rowIndex, width, cellConfig) {
                        var isHidden = cellConfig.isHidden;
                        var idRowHeader = "row-header-row".concat(rowIndex, "-column1");
                        var rowHeaderClasses = _defineProperty({}, "".concat(this._rootClass, "__row-header"), true);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("th");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRowHeader);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("scope", "row");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", rowHeaderClasses);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                            style: {
                                width: width
                            }
                        }, width));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("th");
                        _renderArbitrary(isHidden ? this._renderHiddenCell(value) : this._cleanDisplayValue.call(this, value));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("th");
                    }
                }, {
                    key: "renderStackedFooterCell",
                    value: function renderStackedFooterCell(cellData, rowIndex, width) {
                        var _stackedFooterCellCla;
                        var value = cellData.value;
                        var idRowValue = "value-row".concat(rowIndex, "-column0");
                        var stackedFooterCellClasses = (_stackedFooterCellCla = {}, _defineProperty(_stackedFooterCellCla, "".concat(this._rootClass, "__row-value"), true), 
                        _defineProperty(_stackedFooterCellCla, "".concat(this._rootClass, "__row-value--text"), true), 
                        _stackedFooterCellCla);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("td");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRowValue);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", stackedFooterCellClasses);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                            style: {
                                width: width
                            }
                        }, width));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("td");
                        _renderArbitrary(this._cleanDisplayValue.call(this, value));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("td");
                    }
                }, {
                    key: "_generateFooterClasses",
                    value: function _generateFooterClasses(value) {
                        var _ref;
                        var valueIsNumeric = Object(_utils_table_utils__WEBPACK_IMPORTED_MODULE_2__["isNumeric"])(value);
                        return _ref = {}, _defineProperty(_ref, "".concat(this._rootClass, "__row-value"), true), 
                        _defineProperty(_ref, "".concat(this._rootClass, "__row-value--left"), !valueIsNumeric), 
                        _defineProperty(_ref, "".concat(this._rootClass, "__row-value--footer"), true), 
                        _defineProperty(_ref, "".concat(this._rootClass, "__row-value--text"), true), _defineProperty(_ref, "".concat(this._rootClass, "__row-value"), true), 
                        _ref;
                    }
                }, {
                    key: "renderFooter",
                    value: function renderFooter(cellData, rowIndex) {
                        var value = cellData.value, firstValue = cellData.firstValue;
                        var colIndex = this.config.colIndex;
                        var classes = this._generateFooterClasses(value);
                        var labelledValue = "".concat(firstValue, " ").concat(value, " ");
                        var idRowValue = "value-row".concat(rowIndex, "-column").concat(colIndex);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("td", null, null, "id", idRowValue, "class", classes);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "aria-hidden", "true");
                        _renderArbitrary(!Object(_utils_table_utils__WEBPACK_IMPORTED_MODULE_2__["isEmptyValue"])(value) && this._cleanDisplayValue(value, true));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        _renderArbitrary(colIndex !== 0 && value && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text"), 
                        _renderArbitrary(labelledValue), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("td");
                    }
                } ]);
                return AbstractColumn;
            }();
        },
        "./src/abstract-data-table/columns/action-column/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _abstract_column__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-data-table/columns/abstract-column/index.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var ActionColumn = function(_AbstractColumn) {
                _inherits(ActionColumn, _AbstractColumn);
                _createClass(ActionColumn, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "ActionColumn";
                    }
                } ]);
                function ActionColumn(rootClass) {
                    var _this;
                    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    _classCallCheck(this, ActionColumn);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(ActionColumn).call(this, rootClass, config));
                    _this._canBeSortable = false;
                    _this._headerVisibility = _this.config.headerVisibility;
                    _this._defaultHeader = _this.config.headerValue || "Action";
                    return _this;
                }
                _createClass(ActionColumn, [ {
                    key: "renderColumnHeader",
                    value: function renderColumnHeader(additionalClasses, headerConfig) {
                        var _extends2;
                        return _get(_getPrototypeOf(ActionColumn.prototype), "renderColumnHeader", this).call(this, _extends((_extends2 = {}, 
                        _defineProperty(_extends2, "".concat(this._rootClass, "__column-header--left"), true), 
                        _defineProperty(_extends2, "".concat(this._rootClass, "__column-header--action"), true), 
                        _extends2), additionalClasses), headerConfig);
                    }
                }, {
                    key: "_generateHeader",
                    value: function _generateHeader(headerValue, headerConfig) {
                        if (this._headerVisibility) {
                            return _get(_getPrototypeOf(ActionColumn.prototype), "_generateHeader", this).call(this, headerValue, headerConfig);
                        }
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text");
                        _renderArbitrary(this._defaultHeader);
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                    }
                }, {
                    key: "renderCell",
                    value: function renderCell(cellData, rowIndex) {
                        var _extends3;
                        var cellConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        var _this$config = this.config, width = _this$config.width, colIndex = _this$config.colIndex, stacked = _this$config.stacked;
                        var idRowHeader = "value-row".concat(rowIndex, "-column").concat(colIndex);
                        var classes = _extends((_extends3 = {}, _defineProperty(_extends3, "".concat(this._rootClass, "__row-action"), true), 
                        _defineProperty(_extends3, "".concat(this._rootClass, "__row-action--stacked"), stacked), 
                        _defineProperty(_extends3, "".concat(this._rootClass, "__row-value--left"), !stacked), 
                        _extends3), cellConfig.additionalClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("td");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRowHeader);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", classes);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["conditionalAttribute"])({
                            style: {
                                width: width
                            }
                        }, width && this._rootClass !== "data-table-for-files"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("td");
                        _renderArbitrary(!cellConfig.isEmpty && cellData ? this._renderCellValue(cellData, rowIndex, cellConfig) : this._renderEmptyCell());
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("td");
                    }
                } ]);
                return ActionColumn;
            }(_abstract_column__WEBPACK_IMPORTED_MODULE_1__["default"]);
            __webpack_exports__["default"] = ActionColumn;
        },
        "./src/abstract-data-table/columns/alert-message-column/AlertMessageColumn.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "renderAlertMessage", (function() {
                return renderAlertMessage;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var alertMessageTables = new Set([ "data-table-for-accounts", "data-table-for-transactions", "data-table-for-files", "data-table-simple" ]);
            function renderCell(cellData, rowIndex) {
                var _objectSpread2;
                var cellConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var _this$config = this.config, width = _this$config.width, colIndex = _this$config.colIndex, stacked = _this$config.stacked;
                var idRowValue = "value-row".concat(rowIndex, "-column").concat(colIndex);
                var emptyAlert = typeof cellData.alertMessage === "undefined" || _typeof(cellData.alertMessage.variant) === "object";
                var cellDataCopy = _objectSpread({}, cellData);
                var classes = _objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, "".concat(this._rootClass, "__row-value"), true), 
                _defineProperty(_objectSpread2, "".concat(this._rootClass, "__row-value-cell--alert"), !stacked), 
                _defineProperty(_objectSpread2, "".concat(this._rootClass, "__row-value-cell--alert-empty"), emptyAlert), 
                _objectSpread2), cellConfig.additionalClasses);
                if (emptyAlert) {
                    cellDataCopy.alertMessage = {
                        accessibleTextIcon: "empty alert"
                    };
                    cellData.alertMessage = {
                        accessibleTextIcon: null,
                        variant: null,
                        title: null
                    };
                }
                var cellType = "alert";
                var isStacked = stacked ? "--stacked" : "";
                var emptyAlertClass = emptyAlert ? "empty-alert-cell" : "";
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("td");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRowValue);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", classes);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    style: {
                        width: width
                    }
                }, width));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("td");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "".concat(this._rootClass, "__row-value--").concat(cellType, " ").concat(this._rootClass, "__row-value--").concat(cellType).concat(isStacked));
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    role: "text"
                }, MDS.isSafari));
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    style: {
                        width: width
                    }
                }, width && !isPercent(width)));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-alert", null, null, "class", "".concat(this._rootClass, "__alert-message ").concat(emptyAlertClass), "variant", cellDataCopy.alertMessage.variant, "size", "small", "alert-title", cellDataCopy.alertMessage.title, "accessible-text-icon", cellDataCopy.alertMessage.accessibleTextIcon, "heading-level", "0", "shows-close-button", "false");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("td");
            }
            function renderAlertMessage(alertMessage) {
                var _this$config2 = this.config, colIndex = _this$config2.colIndex, tableId = _this$config2.tableId;
                var table = this.config.tableInstance;
                if (!alertMessageTables.has(this._rootClass)) {
                    throw new Error("".concat(tableId, ": Only data-table-for-accounts, data-table-for-files, data-table-for-transactions and data-table-simple are allowed to have alertMessage. Not ").concat(this._rootClass, "."));
                }
                if (typeof table.alertMessageColumn !== "number") {
                    table.alertMessageColumn = colIndex;
                } else if (table.alertMessageColumn !== colIndex) {
                    throw new Error("".concat(tableId, ": Only one column can have alertMessage. Column ").concat(colIndex, " and column ").concat(table.alertMessageColumn, " have alert message column."));
                }
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-alert", null, null, "class", "".concat(this._rootClass, "__alert-message"), "variant", alertMessage.variant, "size", "small", "alert-title", alertMessage.title, "accessible-text-icon", alertMessage.accessibleTextIcon, "heading-level", "0", "shows-close-button", "false");
            }
            __webpack_exports__["default"] = renderCell;
        },
        "./src/abstract-data-table/columns/alert-message-column/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", (function() {
                return AlertMessageColumn;
            }));
            var _abstract_column_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/abstract-data-table/columns/abstract-column/index.jsx");
            var _secondary_tertiary_text_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-data-table/columns/secondary-tertiary-text/index.jsx");
            var _utils_table_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/table-utils.jsx");
            var _AlertMessageColumn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/abstract-data-table/columns/alert-message-column/AlertMessageColumn.jsx");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var AlertMessageColumn = function(_AbstractColumn) {
                _inherits(AlertMessageColumn, _AbstractColumn);
                function AlertMessageColumn(rootClass) {
                    var _this;
                    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    _classCallCheck(this, AlertMessageColumn);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(AlertMessageColumn).call(this, rootClass, config));
                    _this._canBeSortable = true;
                    _this._canHaveSecondaryTertiaryText = true;
                    _this._renderSecondaryTertiaryText = _secondary_tertiary_text_index__WEBPACK_IMPORTED_MODULE_1__["_renderSecondaryTertiaryText"].bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(AlertMessageColumn, [ {
                    key: "_compare",
                    value: function _compare(rows, isAscending, rowIndex1, rowIndex2) {
                        var result = 0;
                        var varriantOrder = {
                            error: 4,
                            soft: 3,
                            informational: 2,
                            success: 1
                        };
                        var indexOneAlertMessage = rows[rowIndex1][this.config.colIndex].alertMessage;
                        var varriant1 = indexOneAlertMessage && indexOneAlertMessage.variant ? indexOneAlertMessage.variant : "";
                        var varriant1LowerCase = varriant1.toLowerCase();
                        var isvarriant1Empty = Object(_utils_table_utils__WEBPACK_IMPORTED_MODULE_2__["isEmptyValue"])(varriant1);
                        var title1 = indexOneAlertMessage && indexOneAlertMessage.title ? indexOneAlertMessage.title : "";
                        var title1LowerCase = title1.toLowerCase();
                        var indexTwoAlertMessage = rows[rowIndex2][this.config.colIndex].alertMessage;
                        var varriant2 = indexTwoAlertMessage && indexTwoAlertMessage.variant ? indexTwoAlertMessage.variant : "";
                        var varriant2LowerCase = varriant2.toLowerCase();
                        var isvarriant2Empty = Object(_utils_table_utils__WEBPACK_IMPORTED_MODULE_2__["isEmptyValue"])(varriant2);
                        var title2 = indexTwoAlertMessage && indexTwoAlertMessage.title ? indexTwoAlertMessage.title : "";
                        var title2LowerCase = title2.toLowerCase();
                        if (isvarriant1Empty && !isvarriant2Empty) {
                            return 1;
                        }
                        if (!isvarriant1Empty && isvarriant2Empty) {
                            return -1;
                        }
                        if (this._canBeDate && this.config.date) {
                            varriant1 = new Date(varriant1);
                            varriant2 = new Date(varriant2);
                        }
                        if (varriant1 !== varriant2) {
                            if (varriantOrder[varriant1LowerCase] < varriantOrder[varriant2LowerCase]) {
                                result = isAscending ? -1 : 1;
                            } else if (varriantOrder[varriant1LowerCase] > varriantOrder[varriant2LowerCase]) {
                                result = isAscending ? 1 : -1;
                            }
                        } else {
                            result = title1LowerCase.localeCompare(title2LowerCase);
                        }
                        return result;
                    }
                }, {
                    key: "getInteractiveElement",
                    value: function getInteractiveElement(table, payload) {
                        var row = payload.row, col = payload.col, type = payload.type;
                        var interactiveElement;
                        if (type === "alert" || type === "tag") {
                            var cell = table.shadowRoot.getElementById("value-row".concat(row, "-column").concat(col));
                            interactiveElement = cell.querySelector("mds-".concat(type));
                        }
                        return {
                            interactiveElement: interactiveElement
                        };
                    }
                }, {
                    key: "renderColumnHeader",
                    value: function renderColumnHeader(additionalClasses, headerConfig) {
                        return _get(_getPrototypeOf(AlertMessageColumn.prototype), "renderColumnHeader", this).call(this, _extends(_defineProperty({}, "".concat(this._rootClass, "__column-header--alert"), true), additionalClasses), headerConfig);
                    }
                }, {
                    key: "renderStackedCell",
                    value: function renderStackedCell(cellData, rowIndex) {
                        var cellConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        _AlertMessageColumn__WEBPACK_IMPORTED_MODULE_3__["default"].call(this, cellData, rowIndex, cellConfig);
                    }
                }, {
                    key: "renderCell",
                    value: function renderCell(cellData, rowIndex) {
                        var cellConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        _AlertMessageColumn__WEBPACK_IMPORTED_MODULE_3__["default"].call(this, cellData, rowIndex, cellConfig);
                    }
                } ]);
                return AlertMessageColumn;
            }(_abstract_column_index__WEBPACK_IMPORTED_MODULE_0__["default"]);
        },
        "./src/abstract-data-table/columns/buttons-column/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", (function() {
                return ButtonsColumn;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _action_column__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/abstract-data-table/columns/action-column/index.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/data-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function _enforceConsistency(item, iconPosition) {
                var text = item.text, icon = item.icon, tooltipText = item.tooltipText;
                var errorMessage = "";
                if (iconPosition === "leading" && (!text || !icon)) {
                    errorMessage = "If including iconPosition in columnConfigs and is set to leading, you should include text and icon";
                } else if (iconPosition === "icon_only" && (text || !tooltipText)) {
                    errorMessage = "If including iconPosition in columnConfigs and is set to icon_only, you should include a tooltip text and not include text";
                } else if (!iconPosition && icon) {
                    errorMessage = "If including an icon, you must provide an iconPosition in columnConfigs";
                }
                if (errorMessage) {
                    throw new _mds_agave__WEBPACK_IMPORTED_MODULE_1__["ConstraintError"]({
                        message: errorMessage,
                        elementName: this.config.tableInstance.constructor.getElementName(),
                        id: this.config.tableId
                    });
                }
            }
            var ButtonsColumn = function(_ActionColumn) {
                _inherits(ButtonsColumn, _ActionColumn);
                function ButtonsColumn(rootClass) {
                    var _this;
                    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    _classCallCheck(this, ButtonsColumn);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(ButtonsColumn).call(this, rootClass, config));
                    var test = {
                        leading: "leading",
                        icon_only: "icon_only"
                    };
                    _this.config.iconPosition = _this.config.iconPosition && test[_this.config.iconPosition];
                    return _this;
                }
                _createClass(ButtonsColumn, [ {
                    key: "getInteractiveElement",
                    value: function getInteractiveElement(table, payload) {
                        var rowIndex = payload.rowIndex, colIndex = payload.colIndex, type = payload.type, buttonIndex = payload.buttonIndex;
                        var interactiveElement = table.shadowRoot.querySelectorAll('mds-button[data-type="'.concat(type, '"][data-row="').concat(rowIndex, '"][data-column="').concat(colIndex, '"]'))[buttonIndex || 0];
                        return {
                            interactiveElement: interactiveElement
                        };
                    }
                }, {
                    key: "renderStackedCell",
                    value: function renderStackedCell(cellData, rowIndex) {
                        var cellConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        return this.renderCell(cellData, rowIndex, cellConfig);
                    }
                }, {
                    key: "validateColumn",
                    value: function validateColumn(columnConfigs) {
                        var _this2 = this;
                        var _columnConfigs$reduce = columnConfigs.reduce(function(conditions, column) {
                            _newArrowCheck(this, _this2);
                            conditions.numButtonColumns += column.columnType === "buttons" ? 1 : 0;
                            if (!missingColumnHeaders && !column.headerValue) {
                                conditions.missingColumnHeaders = true;
                            }
                            return conditions;
                        }.bind(this), {
                            numButtonColumns: 0,
                            missingColumnHeaders: false
                        }), numButtonColumns = _columnConfigs$reduce.numButtonColumns, missingColumnHeaders = _columnConfigs$reduce.missingColumnHeaders;
                        if (this.config.colIndex === 0) {
                            console.error("Column for buttons cannot be the first column in a table");
                        }
                        if (numButtonColumns > 2) {
                            console.error("A single table can have at most 2 columns for buttons");
                        }
                        if (missingColumnHeaders && this._rootClass !== "data-table-for-files") {
                            console.error("A table with column for buttons must have column headers");
                        }
                    }
                }, {
                    key: "_renderButton",
                    value: function _renderButton(item, rowIndex, cellConfig) {
                        var _buttonClasses;
                        var text = item.text, icon = item.icon, accessibleText = item.accessibleText, tooltipText = item.tooltipText, inactive = item.inactive, value = item.value;
                        var _this$config = this.config, iconPosition = _this$config.iconPosition, stacked = _this$config.stacked;
                        var buttonClasses = (_buttonClasses = {}, _defineProperty(_buttonClasses, "".concat(this._rootClass, "__button"), true), 
                        _defineProperty(_buttonClasses, "".concat(this._rootClass, "__button--").concat(this.config.mode), this.config.mode), 
                        _defineProperty(_buttonClasses, "mds-button--".concat(this.config.tableInstance.brand), true), 
                        _defineProperty(_buttonClasses, "".concat(this._rootClass, "__button--stacked"), stacked), 
                        _buttonClasses);
                        _enforceConsistency.call(this, item, iconPosition);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("mds-button");
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                            "icon-position": iconPosition
                        }, iconPosition));
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                            "icon-type": icon
                        }, icon && iconPosition));
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                            small: true
                        }, this._rootClass !== "data-table-for-files"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("text", text);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("accessible-text", accessibleText);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("variant", "tertiary");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("width-type", "content");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", buttonClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-type", "buttons");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-column", this.config.colIndex + 1);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-row", rowIndex + 1);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("inactive", inactive);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("value", value);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("mds-button");
                        _renderArbitrary(tooltipText && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-tooltip", null, null, "message", tooltipText));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-button");
                    }
                }, {
                    key: "_renderEmptyCell",
                    value: function _renderEmptyCell() {
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text");
                        _renderArbitrary(this.config.accessibleSingleValueEmpty);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                    }
                }, {
                    key: "_renderCellValue",
                    value: function _renderCellValue(cellData, rowIndex, cellConfig) {
                        var _buttonClasses2, _this3 = this;
                        var buttonItems = cellData.buttonItems;
                        var _this$config2 = this.config, stacked = _this$config2.stacked, width = _this$config2.width;
                        var buttonClasses = (_buttonClasses2 = {}, _defineProperty(_buttonClasses2, "".concat(this._rootClass, "__buttons-container"), true), 
                        _defineProperty(_buttonClasses2, "".concat(this._rootClass, "__buttons-container--stacked"), stacked), 
                        _defineProperty(_buttonClasses2, "".concat(this._rootClass, "__buttons-container--icontext"), buttonItems && buttonItems.length > 0 && buttonItems[0].icon && buttonItems[0].text), 
                        _buttonClasses2);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", buttonClasses);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                            style: {
                                width: width
                            }
                        }, width && !Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_4__["isPercent"])(width) && this._rootClass !== "data-table-for-files"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                        _renderArbitrary(buttonItems && buttonItems.length > 0 ? buttonItems.map(function(item, index) {
                            _newArrowCheck(this, _this3);
                            return this._renderButton(item, rowIndex, cellConfig, index);
                        }.bind(this)) : this._renderEmptyCell());
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return ButtonsColumn;
            }(_action_column__WEBPACK_IMPORTED_MODULE_2__["default"]);
        },
        "./src/abstract-data-table/columns/checkbox-column/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", (function() {
                return CheckboxColumn;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _abstract_column_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-data-table/columns/abstract-column/index.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var CheckboxColumn = function(_AbstractColumn) {
                _inherits(CheckboxColumn, _AbstractColumn);
                function CheckboxColumn() {
                    _classCallCheck(this, CheckboxColumn);
                    return _possibleConstructorReturn(this, _getPrototypeOf(CheckboxColumn).apply(this, arguments));
                }
                _createClass(CheckboxColumn, [ {
                    key: "validateColumn",
                    value: function validateColumn() {
                        if (this.config.colIndex !== 0) {
                            throw new Error("Checkbox column must be first column");
                        }
                    }
                }, {
                    key: "getInteractiveElement",
                    value: function getInteractiveElement(table, payload) {
                        var rowIndex = payload.rowIndex, colIndex = payload.colIndex, type = payload.type;
                        var interactiveElement;
                        if (type === "heading-checkbox") {
                            interactiveElement = table.shadowRoot.getElementById("".concat(this.config.tableId, "-heading-checkbox"));
                        } else {
                            interactiveElement = table.shadowRoot.querySelector('*[data-type="'.concat(type, '"][data-row="').concat(rowIndex, '"][data-column="').concat(colIndex, '"]'));
                        }
                        return {
                            interactiveElement: interactiveElement,
                            nextPayload: payload
                        };
                    }
                }, {
                    key: "handleChange",
                    value: function handleChange(event) {
                        var _this = this;
                        event.stopPropagation();
                        if (event.target.dataset.type === "checkbox") {
                            var _event$target$dataset = event.target.dataset, type = _event$target$dataset.type, headingCheckbox = _event$target$dataset.headingCheckbox;
                            var row = event.target.dataset.row && +event.target.dataset.row - 1;
                            var state = event.target.state;
                            var rowData = this.rowData, columnConfigs = this.columnConfigs;
                            var _ref = columnConfigs[0] || false, noTopCheckbox = _ref.noTopCheckbox;
                            if (headingCheckbox && !noTopCheckbox) {
                                rowData.forEach(function(individualRowData) {
                                    _newArrowCheck(this, _this);
                                    if (!individualRowData[0].inactive) {
                                        individualRowData[0].state = state;
                                    }
                                }.bind(this));
                                columnConfigs[0].state = state;
                            } else {
                                var sortedRowIndex = this.sortMap ? this.sortMap[row] : row;
                                var isMixed = rowData.some(function(individualRowData, index) {
                                    _newArrowCheck(this, _this);
                                    var cellState = individualRowData[0].state || "false";
                                    return index !== sortedRowIndex && !individualRowData[0].inactive && !(state === cellState || state === String(cellState));
                                }.bind(this));
                                rowData[sortedRowIndex][0].state = state;
                                if (noTopCheckbox) {
                                    columnConfigs[0].state = isMixed ? "mixed" : state;
                                }
                            }
                            this._liveTextType = "checkbox";
                            this.setState({
                                rowData: rowData
                            });
                            window.setTimeout(this._setAriaLiveText.bind(this), 2e3);
                            Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["createCustomEventDispatcher"])(function() {
                                _newArrowCheck(this, _this);
                                return "change";
                            }.bind(this), this)(event, _extends({}, event.detail, {
                                type: type,
                                rowIndex: typeof row === "number" && "".concat(row + 1),
                                state: state,
                                row: row,
                                isHeadingCheckbox: !noTopCheckbox && !!headingCheckbox
                            }));
                        }
                    }
                }, {
                    key: "renderColumnHeader",
                    value: function renderColumnHeader(additionalClasses, headerConfig) {
                        var _extends2;
                        var _this$config = this.config, colIndex = _this$config.colIndex, descriptionKey = _this$config.descriptionKey;
                        var descriptionValue = this.getDescriptionValue(headerConfig.numRows);
                        var idColumnHeader = "column-header-".concat(colIndex);
                        var columnHeaderClasses = _extends((_extends2 = {}, _defineProperty(_extends2, "".concat(this._rootClass, "__column-header"), true), 
                        _defineProperty(_extends2, "".concat(this._rootClass, "__column-header--checkbox"), true), 
                        _defineProperty(_extends2, "".concat(this._rootClass, "__column-header--no-top-checkbox"), this.config.noTopCheckbox), 
                        _extends2), additionalClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("td", null, null, "id", idColumnHeader, "class", columnHeaderClasses);
                        _renderArbitrary(!this.config.noTopCheckbox ? this._renderTopCheckbox(descriptionKey, descriptionValue) : (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text"), 
                        _renderArbitrary(this.config.headerValue || this.config.label), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "id", "checkbox-descriptor", "aria-hidden", "true", "class", "".concat(this._rootClass, "__checkbox-descriptor"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "".concat(this._rootClass, "__descriptor-term"));
                        _renderArbitrary(descriptionKey);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "".concat(this._rootClass, "__descriptor-value"));
                        _renderArbitrary(descriptionValue);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("td");
                    }
                }, {
                    key: "getDescriptionValue",
                    value: function getDescriptionValue(numRows) {
                        return this.config.descriptionValue || "".concat(this.config.getNumberOfSelectedCheckboxes(), " ").concat(this.config.cardinalitySeparator || "of", " ").concat(numRows);
                    }
                }, {
                    key: "renderTopCheckboxNoColumnHeaders",
                    value: function renderTopCheckboxNoColumnHeaders(headerConfig) {
                        var _checkboxDescriptorCl, _columnHeaderClasses;
                        var _this$config2 = this.config, colIndex = _this$config2.colIndex, descriptionKey = _this$config2.descriptionKey;
                        var numRows = headerConfig.numRows, numColumns = headerConfig.numColumns;
                        var descriptionValue = this.getDescriptionValue(numRows);
                        var idColumnHeader = "column-header-".concat(colIndex);
                        var checkboxDescriptorClasses = (_checkboxDescriptorCl = {}, _defineProperty(_checkboxDescriptorCl, "".concat(this._rootClass, "__checkbox-descriptor--no-top-checkbox"), this.config.noTopCheckbox), 
                        _defineProperty(_checkboxDescriptorCl, "".concat(this._rootClass, "__checkbox-descriptor"), true), 
                        _checkboxDescriptorCl);
                        var columnHeaderClasses = (_columnHeaderClasses = {}, _defineProperty(_columnHeaderClasses, "".concat(this._rootClass, "__column-header"), true), 
                        _defineProperty(_columnHeaderClasses, "".concat(this._rootClass, "__column-header--left"), true), 
                        _defineProperty(_columnHeaderClasses, "".concat(this._rootClass, "__column-header--checkbox"), true), 
                        _defineProperty(_columnHeaderClasses, "".concat(this._rootClass, "__column-header--checkbox-only"), true), 
                        _defineProperty(_columnHeaderClasses, "".concat(this._rootClass, "__column-header--no-top-checkbox-no-column-headers"), this.config.noTopCheckbox), 
                        _columnHeaderClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("tr");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("td", null, null, "id", idColumnHeader, "class", columnHeaderClasses, "colSpan", numColumns);
                        _renderArbitrary(!this.config.noTopCheckbox ? this._renderTopCheckbox(descriptionKey, descriptionValue) : (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text"), 
                        _renderArbitrary(this.config.headerValue || this.config.label), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "id", "checkbox-descriptor", "aria-hidden", "true", "class", checkboxDescriptorClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "".concat(this._rootClass, "__descriptor-term"));
                        _renderArbitrary(descriptionKey);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "".concat(this._rootClass, "__descriptor-value"));
                        _renderArbitrary(descriptionValue);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("td");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tr");
                    }
                }, {
                    key: "_renderTopCheckbox",
                    value: function _renderTopCheckbox(descriptionKey, descriptionValue) {
                        var _this$config3 = this.config, headerValue = _this$config3.headerValue, tableId = _this$config3.tableId, value = _this$config3.value, label = _this$config3.label, state = _this$config3.state, name = _this$config3.name, accessibleText = _this$config3.accessibleText;
                        if (!headerValue) {
                            throw new Error("Checkbox must have a label (under property name: headerValue or label)");
                        }
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-checkbox", null, null, "id", "".concat(tableId, "-heading-checkbox"), "class", "".concat(this._rootClass, "__checkbox"), "value", value, "label", headerValue || label, "state", state, "name", name, "data-type", "checkbox", "data-column", "1", "data-heading-checkbox", "true", "accessible-text", accessibleText, "accessible-description", "".concat(descriptionKey, " ").concat(descriptionValue), "hide-label", "true");
                    }
                }, {
                    key: "renderStackedCheckbox",
                    value: function renderStackedCheckbox(cellData, rowIndex) {
                        if (!cellData.label) {
                            throw new Error("Checkbox must have a label");
                        }
                        var tableId = this.config.tableId;
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-checkbox", null, null, "id", "".concat(tableId, "-checkbox-row-").concat(rowIndex), "class", "".concat(this._rootClass, "__checkbox ").concat(this._rootClass, "__checkbox--stacked"), "value", cellData.value, "label", cellData.label, "state", cellData.state || "false", "name", cellData.name, "data-type", "checkbox", "data-column", "1", "data-row", rowIndex + 1, "accessible-text", cellData.accessibleText, "inactive", cellData.inactive, "hide-label", "true");
                    }
                }, {
                    key: "renderStackedTopCheckbox",
                    value: function renderStackedTopCheckbox(headerConfig) {
                        var _checkboxContainerCla;
                        var descriptionKey = this.config.descriptionKey;
                        var numRows = headerConfig.numRows;
                        var descriptionValue = this.getDescriptionValue(numRows);
                        var checkboxContainerClasses = (_checkboxContainerCla = {}, _defineProperty(_checkboxContainerCla, "".concat(this._rootClass, "__top-stacked-checkbox-container-no-top-checkbox"), this.config.noTopCheckbox), 
                        _defineProperty(_checkboxContainerCla, "".concat(this._rootClass, "__top-stacked-checkbox-container"), true), 
                        _checkboxContainerCla);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", checkboxContainerClasses);
                        _renderArbitrary(!this.config.noTopCheckbox ? this._renderTopCheckbox(descriptionKey, descriptionValue) : (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text"), 
                        _renderArbitrary(this.config.headerValue || this.config.label), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "id", "checkbox-descriptor", "aria-hidden", "true", "class", "".concat(this._rootClass, "__checkbox-descriptor"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "".concat(this._rootClass, "__descriptor-term"));
                        _renderArbitrary(descriptionKey);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "".concat(this._rootClass, "__descriptor-value"));
                        _renderArbitrary(descriptionValue);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "renderCell",
                    value: function renderCell(cellData, rowIndex) {
                        var _extends3;
                        var cellConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        if (!cellData.label) {
                            throw new Error("Checkbox must have a label");
                        }
                        var _this$config4 = this.config, stacked = _this$config4.stacked, tableId = _this$config4.tableId;
                        var idRowValue = "value-row".concat(rowIndex, "-column0");
                        var classes = _extends((_extends3 = {}, _defineProperty(_extends3, "".concat(this._rootClass, "__row-value"), true), 
                        _defineProperty(_extends3, "".concat(this._rootClass, "__row-value--checkbox"), true), 
                        _defineProperty(_extends3, "".concat(this._rootClass, "__row-value--left"), !stacked), 
                        _extends3), cellConfig.additionalClasses);
                        var header = cellConfig.hasRowHeaderValues ? "row-header-row".concat(rowIndex, "-column1") : "value-row".concat(rowIndex, "-column1");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("td", null, null, "id", idRowValue, "class", classes, "headers", header);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-checkbox", null, null, "id", "".concat(tableId, "-checkbox-row-").concat(rowIndex), "class", "".concat(this._rootClass, "__checkbox"), "value", cellData.value, "label", cellData.label, "state", cellData.state || "false", "name", cellData.name, "data-type", "checkbox", "data-column", "1", "data-row", rowIndex + 1, "accessible-text", cellData.accessibleText, "inactive", cellData.inactive, "hide-label", "true");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("td");
                    }
                } ]);
                return CheckboxColumn;
            }(_abstract_column_index__WEBPACK_IMPORTED_MODULE_1__["default"]);
        },
        "./src/abstract-data-table/columns/combo-button-column/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", (function() {
                return ComboButtonColumn;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _action_column__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-data-table/columns/action-column/index.jsx");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var ComboButtonColumn = function(_ActionColumn) {
                _inherits(ComboButtonColumn, _ActionColumn);
                function ComboButtonColumn(rootClass) {
                    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    _classCallCheck(this, ComboButtonColumn);
                    return _possibleConstructorReturn(this, _getPrototypeOf(ComboButtonColumn).call(this, rootClass, config));
                }
                _createClass(ComboButtonColumn, [ {
                    key: "getInteractiveElement",
                    value: function getInteractiveElement(table, payload) {
                        return _objectSpread({}, _get(_getPrototypeOf(ComboButtonColumn.prototype), "getInteractiveElement", this).call(this, table, payload), {
                            nextPayload: payload
                        });
                    }
                }, {
                    key: "renderStackedCell",
                    value: function renderStackedCell(cellData, rowIndex) {
                        var cellConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        return this.renderCell(cellData, rowIndex, cellConfig);
                    }
                }, {
                    key: "validateColumn",
                    value: function validateColumn(columnConfigs) {
                        var _this = this;
                        this.config.colIndex !== columnConfigs.length - 1 && console.error("Combo button column must be the last column");
                        var isMissingHeaders = columnConfigs.reduce(function(isMissingHeader, column) {
                            _newArrowCheck(this, _this);
                            return isMissingHeader || !column.headerValue;
                        }.bind(this), false);
                        isMissingHeaders && console.error("A table with column for combo button must have column headers");
                    }
                }, {
                    key: "_renderCellValue",
                    value: function _renderCellValue(cellData, rowIndex, cellConfig) {
                        var menuItems = cellData.menuItems, value = cellData.value, menuButtonAccessibleText = cellData.menuButtonAccessibleText;
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "".concat(this._rootClass, "__data-table-combo-button ").concat(this._rootClass, "__data-table-combo-button--").concat(cellConfig.mode));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-data-table-combo-button", null, null, "text", value, "menu-items", JSON.stringify(menuItems), "menu-button-accessible-text", menuButtonAccessibleText, "data-type", "combo-button", "data-column", this.config.colIndex + 1, "data-row", rowIndex + 1);
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "_renderEmptyCell",
                    value: function _renderEmptyCell() {
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text");
                        _renderArbitrary(this.config.accessibleSingleValueEmpty);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                    }
                } ]);
                return ComboButtonColumn;
            }(_action_column__WEBPACK_IMPORTED_MODULE_1__["default"]);
        },
        "./src/abstract-data-table/columns/input-column/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", (function() {
                return InputColumn;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _action_column__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-data-table/columns/action-column/index.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var InputColumn = function(_ActionColumn) {
                _inherits(InputColumn, _ActionColumn);
                function InputColumn(rootClass) {
                    var _this;
                    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    _classCallCheck(this, InputColumn);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputColumn).call(this, rootClass, config));
                    _this.renderStackedCell = _this.renderCell;
                    return _this;
                }
                _createClass(InputColumn, [ {
                    key: "handleChange",
                    value: function handleChange(event) {
                        var _this2 = this;
                        event.stopPropagation();
                        if (event.target.dataset.type === "input") {
                            var _event$target$dataset = event.target.dataset, type = _event$target$dataset.type, row = _event$target$dataset.row, column = _event$target$dataset.column;
                            var rowIndex = row - 1;
                            var columnIndex = column - 1;
                            Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["createCustomEventDispatcher"])(function() {
                                _newArrowCheck(this, _this2);
                                return "change";
                            }.bind(this), this)(event, _extends({}, event.detail, {
                                type: type,
                                targetId: event.target.id,
                                label: event.target.label,
                                rowNumber: typeof row === "string" && "".concat(row),
                                rowIndex: rowIndex,
                                columnIndex: columnIndex,
                                name: event.target.name,
                                currentValue: event.target.value
                            }));
                        }
                    }
                }, {
                    key: "renderColumnHeader",
                    value: function renderColumnHeader(additionalClasses, headerConfig) {
                        return _get(_getPrototypeOf(InputColumn.prototype), "renderColumnHeader", this).call(this, _extends(_defineProperty({}, "".concat(this._rootClass, "__column-header--left"), true), additionalClasses), headerConfig);
                    }
                }, {
                    key: "renderCell",
                    value: function renderCell(cellData, rowIndex) {
                        var _extends3;
                        var cellConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        var inputInfo = cellData;
                        var cellLabel = "".concat(inputInfo.label, ", ").concat(this.config.headerValue);
                        var _this$config = this.config, colIndex = _this$config.colIndex, stacked = _this$config.stacked, stackedInputWidth = _this$config.stackedInputWidth;
                        var stackedWidth = stacked && stackedInputWidth;
                        var idRowValue = "value-row-".concat(rowIndex + 1, "-column-").concat(colIndex + 1);
                        var inputContainerClasses = _extends((_extends3 = {}, _defineProperty(_extends3, "".concat(this._rootClass, "__row-action"), true), 
                        _defineProperty(_extends3, "".concat(this._rootClass, "__row-value--left"), !stacked), 
                        _extends3), cellConfig.additionalClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("td");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRowValue);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", inputContainerClasses);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["conditionalAttribute"])({
                            style: {
                                width: stackedWidth
                            }
                        }, !!stackedWidth));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("td");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-data-table-text-input", null, null, "id", "".concat(idRowValue, "-input"), "name", inputInfo.name, "value", inputInfo.value, "label", cellLabel, "placeholder", inputInfo.placeholder, "microcopy", inputInfo.microcopy, "error-messages", JSON.stringify(inputInfo.errorMessages), "inactive", inputInfo.inactive, "autocomplete-value", "off", "data-type", "input", "data-column", colIndex + 1, "data-row", rowIndex + 1);
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("td");
                    }
                } ]);
                return InputColumn;
            }(_action_column__WEBPACK_IMPORTED_MODULE_1__["default"]);
        },
        "./src/abstract-data-table/columns/left-aligned-column/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", (function() {
                return LeftAlignedColumn;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _abstract_column_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-data-table/columns/abstract-column/index.jsx");
            var _columns_secondary_tertiary_text_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/abstract-data-table/columns/secondary-tertiary-text/index.jsx");
            var _tag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/abstract-data-table/columns/tag/index.jsx");
            var _alert_message_column_AlertMessageColumn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/abstract-data-table/columns/alert-message-column/AlertMessageColumn.jsx");
            var _progress_bar_column__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/abstract-data-table/columns/progress-bar-column/index.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/utils/data-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var LeftAlignedColumn = function(_AbstractColumn) {
                _inherits(LeftAlignedColumn, _AbstractColumn);
                function LeftAlignedColumn(rootClass) {
                    var _this;
                    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    _classCallCheck(this, LeftAlignedColumn);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(LeftAlignedColumn).call(this, rootClass, config));
                    _this._canBeSortable = true;
                    _this._canBeDate = true;
                    _this._canHaveSecondaryTertiaryText = true;
                    _this._renderSecondaryTertiaryText = _columns_secondary_tertiary_text_index__WEBPACK_IMPORTED_MODULE_2__["_renderSecondaryTertiaryText"].bind(_assertThisInitialized(_this));
                    if (config.date) {
                        _this._defaultAscendingA11yText = "sorted by oldest";
                        _this._defaultDescendingA11yText = "sorted by most recent";
                    }
                    return _this;
                }
                _createClass(LeftAlignedColumn, [ {
                    key: "getInteractiveElement",
                    value: function getInteractiveElement(table, payload) {
                        var row = payload.row, col = payload.col, type = payload.type;
                        var interactiveElement;
                        if (type === "alert" || type === "tag") {
                            var cell = table.shadowRoot.getElementById("value-row".concat(row, "-column").concat(col));
                            interactiveElement = cell.querySelector("mds-".concat(type));
                        }
                        return {
                            interactiveElement: interactiveElement
                        };
                    }
                }, {
                    key: "renderColumnHeader",
                    value: function renderColumnHeader(additionalClasses, headerConfig) {
                        return _get(_getPrototypeOf(LeftAlignedColumn.prototype), "renderColumnHeader", this).call(this, _extends(_defineProperty({}, "".concat(this._rootClass, "__column-header--left"), true), additionalClasses), headerConfig);
                    }
                }, {
                    key: "renderCell",
                    value: function renderCell(cellData, rowIndex) {
                        var _extends3;
                        var cellConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        var _this$config = this.config, width = _this$config.width, colIndex = _this$config.colIndex, stacked = _this$config.stacked;
                        var idRowValue = "value-row".concat(rowIndex, "-column").concat(colIndex);
                        var classes = _extends((_extends3 = {}, _defineProperty(_extends3, "".concat(this._rootClass, "__row-value"), true), 
                        _defineProperty(_extends3, "".concat(this._rootClass, "__row-value--left"), !stacked), 
                        _extends3), cellConfig.additionalClasses);
                        var cellType = cellData.progressBar || cellData.alertMessage ? cellData.progressBar ? "progress-bar" : "alert" : "text";
                        var isStacked = stacked ? "--stacked" : "";
                        if (MDS.isSafari) {
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("td");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRowValue);
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", classes);
                            _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_6__["conditionalAttribute"])({
                                style: {
                                    width: width
                                }
                            }, width));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("td");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("role", "text");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "".concat(this._rootClass, "__row-value--").concat(cellType, " ").concat(this._rootClass, "__row-value--").concat(cellType).concat(isStacked));
                            _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_6__["conditionalAttribute"])({
                                style: {
                                    width: width
                                }
                            }, width && !Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_7__["isPercent"])(width)));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                            _renderArbitrary(this._rootClass !== "data-table-for-files" && this._cleanDisplayValue(cellData.value, true));
                            _renderArbitrary(cellData.tagText && _tag__WEBPACK_IMPORTED_MODULE_3__["default"].call(this, cellData.tagText, cellData.tagColor));
                            _renderArbitrary(cellData.alertMessage && _alert_message_column_AlertMessageColumn__WEBPACK_IMPORTED_MODULE_4__["renderAlertMessage"].call(this, cellData.alertMessage));
                            _renderArbitrary(cellData.progressBar && _progress_bar_column__WEBPACK_IMPORTED_MODULE_5__["default"].call(this, cellData.progressBar));
                            _renderArbitrary(this._canHaveSecondaryTertiaryText && this._renderSecondaryTertiaryText(cellData));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                            return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("td");
                        }
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("td");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRowValue);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", classes);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_6__["conditionalAttribute"])({
                            style: {
                                width: width
                            }
                        }, width));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("td");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", `${this._rootClass}__row-value--${cellType} ${this._rootClass}__row-value--${cellType}${isStacked}`);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_6__["conditionalAttribute"])({
                            style: {
                                width: width
                            }
                        }, width && !Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_7__["isPercent"])(width)));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                        _renderArbitrary(this._rootClass !== "data-table-for-files" && this._cleanDisplayValue(cellData.value, true));
                        _renderArbitrary(cellData.tagText && _tag__WEBPACK_IMPORTED_MODULE_3__["default"].call(this, cellData.tagText, cellData.tagColor));
                        _renderArbitrary(cellData.alertMessage && _alert_message_column_AlertMessageColumn__WEBPACK_IMPORTED_MODULE_4__["renderAlertMessage"].call(this, cellData.alertMessage));
                        _renderArbitrary(cellData.progressBar && _progress_bar_column__WEBPACK_IMPORTED_MODULE_5__["default"].call(this, cellData.progressBar));
                        _renderArbitrary(this._canHaveSecondaryTertiaryText && this._renderSecondaryTertiaryText(cellData));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("td");
                    }
                }, {
                    key: "renderStackedCell",
                    value: function renderStackedCell(cellData, rowIndex) {
                        var cellConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        return this.renderCell(cellData, rowIndex, cellConfig);
                    }
                } ]);
                return LeftAlignedColumn;
            }(_abstract_column_index__WEBPACK_IMPORTED_MODULE_1__["default"]);
        },
        "./src/abstract-data-table/columns/menu-button-column/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", (function() {
                return MenuButtonColumn;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _abstract_column__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-data-table/columns/abstract-column/index.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _mdsTooltip$wrapper = function _mdsTooltip$wrapper(_$concat$concat, _headerValue, _$concat, _eventAttrs) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("mds-tooltip");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", _$concat$concat);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("message", _headerValue);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", _$concat);
                _spreadAttribute(_eventAttrs);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("mds-tooltip");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-tooltip");
            }, _mdsMenuButton$wrapper = function _mdsMenuButton$wrapper(_id, _JSON$stringify, _class, _eventAttrs2) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("mds-menu-button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", _id);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("custom-menu", _JSON$stringify);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("edge-detection", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", _class);
                _spreadAttribute(_eventAttrs2);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("mds-menu-button");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-menu-button");
            };
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var MenuButtonColumn = function(_AbstractColumn) {
                _inherits(MenuButtonColumn, _AbstractColumn);
                function MenuButtonColumn(rootClass) {
                    var _this;
                    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    _classCallCheck(this, MenuButtonColumn);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MenuButtonColumn).call(this, rootClass, config));
                    _this.config.width = "";
                    return _this;
                }
                _createClass(MenuButtonColumn, [ {
                    key: "renderStackedCell",
                    value: function renderStackedCell(cellData, rowIndex) {
                        var cellConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        return this.renderCell(cellData, rowIndex, cellConfig);
                    }
                }, {
                    key: "getInteractiveElement",
                    value: function getInteractiveElement(table, payload) {
                        var row = payload.row, target = payload.target;
                        var interactiveElement;
                        if (target === "menu") {
                            interactiveElement = table.shadowRoot.getElementById("".concat(this._rootClass, "-row-").concat(row, "-menu-button"));
                        } else {
                            interactiveElement = table.shadowRoot.getElementById("".concat(this._rootClass, "-row-").concat(row, "-menu-button-button"));
                        }
                        return {
                            interactiveElement: interactiveElement,
                            nextPayload: payload
                        };
                    }
                }, {
                    key: "validateColumn",
                    value: function validateColumn(columnConfigs) {
                        var _this2 = this;
                        if (!this.config.headerValue) {
                            throw new Error("Data table for accounts menu button column must have a headerValue");
                        } else if (columnConfigs.reduce(function(isMissingHeader, column) {
                            _newArrowCheck(this, _this2);
                            return isMissingHeader || !column.headerValue;
                        }.bind(this), false)) {
                            console.error("A table with column for menu button must have column headers");
                        }
                        if (this.config.colIndex !== columnConfigs.length - 1) {
                            throw new Error("Data table for accounts menu button column must be the last column in the table");
                        }
                    }
                }, {
                    key: "renderColumnHeader",
                    value: function renderColumnHeader(additionalClasses, headerConfig) {
                        return _get(_getPrototypeOf(MenuButtonColumn.prototype), "renderColumnHeader", this).call(this, _extends(_defineProperty({}, "".concat(this._rootClass, "__column-header--left"), true), additionalClasses), headerConfig);
                    }
                }, {
                    key: "_generateHeader",
                    value: function _generateHeader(headerValue) {
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text");
                        _renderArbitrary(headerValue);
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                    }
                }, {
                    key: "renderCell",
                    value: function renderCell(cellData, rowIndex) {
                        var _extends3;
                        var cellConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        var colIndex = this.config.colIndex;
                        var idRowHeader = "value-row-".concat(rowIndex + 1, "-column-").concat(colIndex + 1);
                        var classes = _extends((_extends3 = {}, _defineProperty(_extends3, "".concat(this._rootClass, "__row-value"), true), 
                        _defineProperty(_extends3, "".concat(this._rootClass, "__row-value--left"), !this.config.stacked), 
                        _defineProperty(_extends3, "".concat(this._rootClass, "__row-value--menu-button"), true), 
                        _extends3), cellConfig.additionalClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("td", null, null, "id", idRowHeader, "class", classes);
                        _renderArbitrary(this._renderCellValue(cellData, rowIndex));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("td");
                    }
                }, {
                    key: "addEventListeners",
                    value: function addEventListeners(table) {
                        var _this3 = this;
                        var rootClass = this._rootClass;
                        this.tooltips = table.shadowRoot.querySelectorAll(".".concat(rootClass, "__menu-button-tooltip"));
                        if (this.tooltips) {
                            var tableNode = table.shadowRoot.querySelector("table");
                            if (MDS.isIOS) {
                                tableNode.addEventListener("touchstart", function(event) {
                                    var _this4 = this;
                                    _newArrowCheck(this, _this3);
                                    event.stopPropagation();
                                    Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["createCustomEventDispatcher"])(function() {
                                        _newArrowCheck(this, _this4);
                                        return "touchstart";
                                    }.bind(this), table)(event, _extends({}, event.detail, {
                                        type: event.target.dataset.type,
                                        columnIndex: event.target.dataset.column,
                                        rowIndex: event.target.dataset.row,
                                        column: +event.target.dataset.column - 1,
                                        row: +event.target.dataset.row - 1
                                    }));
                                }.bind(this));
                            }
                            tableNode.addEventListener("click-menu", function(event) {
                                var _this5 = this;
                                _newArrowCheck(this, _this3);
                                event.stopPropagation();
                                Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["createCustomEventDispatcher"])(function() {
                                    _newArrowCheck(this, _this5);
                                    return "click-menu";
                                }.bind(this), table)(event, _extends({}, event.detail, {
                                    type: event.target.dataset.type,
                                    columnIndex: +event.target.dataset.column - 1,
                                    rowIndex: +event.target.dataset.row - 1,
                                    column: event.target.dataset.column,
                                    row: event.target.dataset.row,
                                    additionalData: event.target.dataset.additionalData
                                }));
                            }.bind(this));
                        }
                    }
                }, {
                    key: "_renderCellValue",
                    value: function _renderCellValue(cellData, rowIndex) {
                        var _this$config = this.config, mode = _this$config.mode, headerValue = _this$config.headerValue, colIndex = _this$config.colIndex;
                        var customMenu = cellData.customMenu, accessibleText = cellData.accessibleText, inactive = cellData.inactive;
                        var eventAttrs = {
                            "data-type": "menu-button",
                            "data-column": colIndex + 1,
                            "data-row": rowIndex + 1,
                            "data-additional-data": cellData.additionalData
                        };
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("mds-button");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "".concat(this._rootClass, "-row-").concat(rowIndex, "-menu-button-button"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "".concat(this._rootClass, "__menu-button-button"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("accessible-text", accessibleText);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("variant", "tertiary");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("icon-position", "icon_only");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("small", mode === "compact");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("icon-type", "ico_ellipsis");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("inactive", inactive);
                        _spreadAttribute(eventAttrs);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("mds-button");
                        _renderArbitrary(!inactive && [ _jsxWrapper(_mdsTooltip$wrapper, [ "".concat(this._rootClass, "-row-").concat(rowIndex, "-menu-button-tooltip"), headerValue, "".concat(this._rootClass, "__menu-button-tooltip"), eventAttrs ]), _jsxWrapper(_mdsMenuButton$wrapper, [ "".concat(this._rootClass, "-row-").concat(rowIndex, "-menu-button"), JSON.stringify(customMenu), "".concat(this._rootClass, "__menu-button"), eventAttrs ]) ]);
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-button");
                    }
                } ]);
                return MenuButtonColumn;
            }(_abstract_column__WEBPACK_IMPORTED_MODULE_1__["default"]);
        },
        "./src/abstract-data-table/columns/navigation-column/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", (function() {
                return NavigationColumn;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _abstract_column_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-data-table/columns/abstract-column/index.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var NavigationColumn = function(_AbstractColumn) {
                _inherits(NavigationColumn, _AbstractColumn);
                function NavigationColumn(rootClass) {
                    var _this;
                    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    _classCallCheck(this, NavigationColumn);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(NavigationColumn).call(this, rootClass, config));
                    _this._canBeSortable = false;
                    _this._defaultAccessibleNavigationHeader = _this.config.accessibleNavigationHeader || "Navigation";
                    return _this;
                }
                _createClass(NavigationColumn, [ {
                    key: "validateColumn",
                    value: function validateColumn(columnConfigs) {
                        this.config.colIndex !== columnConfigs.length - 1 && console.error("Navigation column must be the last column");
                    }
                }, {
                    key: "_renderEmptyValue",
                    value: function _renderEmptyValue() {
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("span", null, null, "aria-hidden", "true");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text");
                        _renderArbitrary(this._defaultAccessibleNavigationHeader);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                    }
                }, {
                    key: "renderStackedCell",
                    value: function renderStackedCell(cellData, rowIndex) {
                        var cellConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        this.renderCell(cellData, rowIndex, cellConfig);
                    }
                }, {
                    key: "renderCell",
                    value: function renderCell(cellData, rowIndex) {
                        var _extends2, _linkClasses;
                        var cellConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        var _this$config = this.config, width = _this$config.width, colIndex = _this$config.colIndex, stacked = _this$config.stacked, tableId = _this$config.tableId;
                        var href = cellData.href, accessibleText = cellData.accessibleText;
                        var idRowValue = "value-row-".concat(rowIndex + 1, "-column-").concat(colIndex + 1);
                        var classes = _extends((_extends2 = {}, _defineProperty(_extends2, "".concat(this._rootClass, "__row-value"), true), 
                        _defineProperty(_extends2, "".concat(this._rootClass, "__row-value--navigation"), !stacked), 
                        _extends2), cellConfig.additionalClasses);
                        var linkClasses = (_linkClasses = {}, _defineProperty(_linkClasses, "".concat(this._rootClass, "__link"), true), 
                        _defineProperty(_linkClasses, "".concat(this._rootClass, "__link--navigation"), true), 
                        _defineProperty(_linkClasses, "".concat(this._rootClass, "__link--navigation-stacked"), stacked), 
                        _linkClasses);
                        var eventData = {
                            "data-index": rowIndex + 1,
                            "data-type": "navigation",
                            "data-column": this.config.colIndex + 1,
                            "data-row": rowIndex + 1
                        };
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("td");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRowValue);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", classes);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["conditionalAttribute"])({
                            style: {
                                width: width
                            }
                        }, !!width));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("td");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("a", null, null, "id", "".concat(tableId, "-").concat(rowIndex + 1, "-navigation"), "data-index", rowIndex + 1, "href", href || "javascript:void(0)", "class", linkClasses, "aria-label", accessibleText, "data-type", "navigation-link", "data-column", this.config.colIndex + 1, "data-row", rowIndex + 1);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "".concat(this._rootClass, "__link-icon ").concat(this._rootClass, "__link-icon--navigation"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("innerHTML-prop", MDS.svgs.ico_chevron_right);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-hidden", "true");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("__skip", "true");
                        _spreadAttribute(eventData);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("a");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("td");
                    }
                } ]);
                return NavigationColumn;
            }(_abstract_column_index__WEBPACK_IMPORTED_MODULE_1__["default"]);
        },
        "./src/abstract-data-table/columns/progress-bar-column/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", (function() {
                return renderProgressBar;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var progressBarTables = new Set([ "data-table-for-files" ]);
            function renderProgressBar(progressBar) {
                var _this$config = this.config, colIndex = _this$config.colIndex, tableId = _this$config.tableId;
                var table = this.config.tableInstance;
                if (!progressBarTables.has(this._rootClass)) {
                    throw new Error("".concat(tableId, ": Only data-table-for-files are allowed to have progressBar. Not ").concat(this._rootClass, "."));
                }
                if (typeof table.progressBarColumn !== "number") {
                    table.progressBarColumn = colIndex;
                } else if (table.progressBarColumn !== colIndex) {
                    throw new Error("".concat(tableId, ": Only one column can have progressBar. Column ").concat(colIndex, " and column ").concat(table.progressBarColumn, " have progress bar column."));
                }
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-progress-bar", null, null, "progress-percentage", progressBar.progressPercentage, "accessible-text", progressBar.accessibleText);
            }
        },
        "./src/abstract-data-table/columns/repeat-row-column/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", (function() {
                return RepeatRowColumn;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _row_header_column__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-data-table/columns/row-header-column/index.jsx");
            var _tag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/abstract-data-table/columns/tag/index.jsx");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var RepeatRowColumn = function(_RowHeaderColumn) {
                _inherits(RepeatRowColumn, _RowHeaderColumn);
                function RepeatRowColumn(rootClass) {
                    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    _classCallCheck(this, RepeatRowColumn);
                    return _possibleConstructorReturn(this, _getPrototypeOf(RepeatRowColumn).call(this, rootClass, config));
                }
                _createClass(RepeatRowColumn, [ {
                    key: "renderCell",
                    value: function renderCell(cellData, rowIndex) {
                        var _extends2;
                        var cellConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        var colIndex = this.config.colIndex;
                        var idRowHeader = "row-header-row".concat(rowIndex, "-column").concat(colIndex);
                        var classes = _extends((_extends2 = {}, _defineProperty(_extends2, "".concat(this._rootClass, "__row-header"), true), 
                        _defineProperty(_extends2, "data-table-for-chart__row-header--with-swatch", this._rootClass === "data-table-for-chart" && this.config.swatchShape), 
                        _extends2), cellConfig.additionalClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("th", null, null, "id", idRowHeader, "scope", "row", "class", classes);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "".concat(this._rootClass, "__row-value--text"));
                        _renderArbitrary(!cellConfig.isFirstRowHeader ? this._renderHiddenCell(cellData.value) : !cellConfig.isEmpty && this._renderCellValue(cellData, rowIndex, cellConfig));
                        _renderArbitrary(cellData.tagText && _tag__WEBPACK_IMPORTED_MODULE_2__["default"].call(this, cellData.tagText, cellData.tagColor));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("th");
                    }
                } ]);
                return RepeatRowColumn;
            }(_row_header_column__WEBPACK_IMPORTED_MODULE_1__["default"]);
        },
        "./src/abstract-data-table/columns/right-aligned-column/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", (function() {
                return RightAlignedColumn;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _abstract_column_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-data-table/columns/abstract-column/index.jsx");
            var _utils_table_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/table-utils.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/data-utils.js");
            var _alert_message_column_AlertMessageColumn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/abstract-data-table/columns/alert-message-column/AlertMessageColumn.jsx");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var RightAlignedColumn = function(_AbstractColumn) {
                _inherits(RightAlignedColumn, _AbstractColumn);
                function RightAlignedColumn(rootClass) {
                    var _this;
                    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    _classCallCheck(this, RightAlignedColumn);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(RightAlignedColumn).call(this, rootClass, config));
                    _this._canBeSortable = true;
                    _this._defaultAscendingA11yText = "sorted low to high";
                    _this._defaultDescendingA11yText = "sorted high to low";
                    _this._canHaveSecondaryTertiaryText = true;
                    return _this;
                }
                _createClass(RightAlignedColumn, [ {
                    key: "_compare",
                    value: function _compare(rows, isAscending, rowIndex1, rowIndex2) {
                        var result = 0;
                        var value1 = rows[rowIndex1][this.config.colIndex].value;
                        var isValue1Empty = Object(_utils_table_utils__WEBPACK_IMPORTED_MODULE_2__["isEmptyValue"])(value1);
                        var value2 = rows[rowIndex2][this.config.colIndex].value;
                        var isValue2Empty = Object(_utils_table_utils__WEBPACK_IMPORTED_MODULE_2__["isEmptyValue"])(value2);
                        var parsedValue1 = Object(_utils_table_utils__WEBPACK_IMPORTED_MODULE_2__["cleanNumber"])(value1);
                        var parsedValue2 = Object(_utils_table_utils__WEBPACK_IMPORTED_MODULE_2__["cleanNumber"])(value2);
                        if (isValue1Empty && !isValue2Empty || parsedValue1 < parsedValue2) {
                            result = isAscending ? -1 : 1;
                        } else if (!isValue1Empty && isValue2Empty || parsedValue1 > parsedValue2) {
                            result = isAscending ? 1 : -1;
                        }
                        return result;
                    }
                }, {
                    key: "_generateFooterClasses",
                    value: function _generateFooterClasses() {
                        var _ref;
                        return _ref = {}, _defineProperty(_ref, "".concat(this._rootClass, "__row-value"), true), 
                        _defineProperty(_ref, "".concat(this._rootClass, "__row-value--footer"), true), 
                        _defineProperty(_ref, "".concat(this._rootClass, "__row-value"), true), _ref;
                    }
                }, {
                    key: "_renderSecondaryTertiaryText",
                    value: function _renderSecondaryTertiaryText(cellData) {
                        var _secondaryValueClasse, _tertiaryValueClasses;
                        var secondaryValueClasses = (_secondaryValueClasse = {}, _defineProperty(_secondaryValueClasse, "".concat(this._rootClass, "__secondary-value"), true), 
                        _defineProperty(_secondaryValueClasse, "".concat(this._rootClass, "__secondary-value--").concat(cellData.secondaryValueSemanticColor), !!cellData.secondaryValueSemanticColor), 
                        _secondaryValueClasse);
                        var tertiaryValueClasses = (_tertiaryValueClasses = {}, _defineProperty(_tertiaryValueClasses, "".concat(this._rootClass, "__tertiary-value"), true), 
                        _defineProperty(_tertiaryValueClasses, "".concat(this._rootClass, "__tertiary-value--").concat(cellData.secondaryValueSemanticColor), !!cellData.secondaryValueSemanticColor), 
                        _tertiaryValueClasses);
                        if (cellData.tertiaryValue !== undefined && cellData.secondaryValue !== undefined) {
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "".concat(this._rootClass, "__secondary-tertiary-value-block"));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", secondaryValueClasses);
                            _renderArbitrary(this._cleanDisplayValue(cellData.secondaryValue, true));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", tertiaryValueClasses);
                            _renderArbitrary(this._cleanDisplayValue(cellData.tertiaryValue, true));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                            return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        } else if (cellData.secondaryValue !== undefined) {
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", secondaryValueClasses);
                            _renderArbitrary(this._cleanDisplayValue(cellData.secondaryValue, true));
                            return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        }
                        return "";
                    }
                }, {
                    key: "renderCell",
                    value: function renderCell(cellData, rowIndex) {
                        var _extends2;
                        var cellConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        var _this$config = this.config, width = _this$config.width, colIndex = _this$config.colIndex, stacked = _this$config.stacked;
                        var idRowValue = "value-row".concat(rowIndex, "-column").concat(colIndex);
                        var semanticColor = cellData.semanticColor, secondaryValueSemanticColor = cellData.secondaryValueSemanticColor, accessibleGainText = cellData.accessibleGainText, accessibleLossText = cellData.accessibleLossText;
                        var classes = _extends((_extends2 = {}, _defineProperty(_extends2, "".concat(this._rootClass, "__row-value"), true), 
                        _defineProperty(_extends2, "".concat(this._rootClass, "__row-value--right"), !stacked), 
                        _defineProperty(_extends2, "".concat(this._rootClass, "__row-value--").concat(semanticColor), !!semanticColor), 
                        _extends2), cellConfig.additionalClasses);
                        var semanticColorEnum = [ "gain", "loss" ];
                        var hasHiddenTextForFirstValue = semanticColorEnum.includes(semanticColor);
                        var hasHiddenTextForSecondaryValue = !semanticColor && semanticColorEnum.includes(secondaryValueSemanticColor);
                        if (MDS.isSafari) {
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("td");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRowValue);
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", classes);
                            _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                                style: {
                                    width: width
                                }
                            }, width));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("td");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("role", "text");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "".concat(this._rootClass, "__row-value--text"));
                            _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                                style: {
                                    width: width
                                }
                            }, width && !Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_4__["isPercent"])(width)));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                            _renderArbitrary(hasHiddenTextForFirstValue && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text"), 
                            _renderArbitrary(semanticColor === "gain" ? accessibleGainText : accessibleLossText), 
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                            _renderArbitrary(this._cleanDisplayValue(cellData.value, true));
                            _renderArbitrary(hasHiddenTextForSecondaryValue && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text"), 
                            _renderArbitrary(secondaryValueSemanticColor === "gain" ? accessibleGainText : accessibleLossText), 
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                            _renderArbitrary(cellData.alertMessage && _alert_message_column_AlertMessageColumn__WEBPACK_IMPORTED_MODULE_5__["renderAlertMessage"].call(this, cellData.alertMessage));
                            _renderArbitrary(this._canHaveSecondaryTertiaryText && this._renderSecondaryTertiaryText(cellData));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                            return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("td");
                        }
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("td");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRowValue);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", classes);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                            style: {
                                width: width
                            }
                        }, width));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("td");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", `${this._rootClass}__row-value--text`);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                            style: {
                                width: width
                            }
                        }, width && !Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_4__["isPercent"])(width)));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                        _renderArbitrary(hasHiddenTextForFirstValue && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text"), 
                        _renderArbitrary(semanticColor === "gain" ? accessibleGainText : accessibleLossText), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        _renderArbitrary(this._cleanDisplayValue(cellData.value, true));
                        _renderArbitrary(hasHiddenTextForSecondaryValue && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text"), 
                        _renderArbitrary(secondaryValueSemanticColor === "gain" ? accessibleGainText : accessibleLossText), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        _renderArbitrary(cellData.alertMessage && _alert_message_column_AlertMessageColumn__WEBPACK_IMPORTED_MODULE_5__["renderAlertMessage"].call(this, cellData.alertMessage));
                        _renderArbitrary(this._canHaveSecondaryTertiaryText && this._renderSecondaryTertiaryText(cellData));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("td");
                    }
                } ]);
                return RightAlignedColumn;
            }(_abstract_column_index__WEBPACK_IMPORTED_MODULE_1__["default"]);
        },
        "./src/abstract-data-table/columns/row-header-column/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", (function() {
                return RowHeaderColumn;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _abstract_column_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-data-table/columns/abstract-column/index.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/common-utils.js");
            var _columns_secondary_tertiary_text_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/abstract-data-table/columns/secondary-tertiary-text/index.jsx");
            var _tag__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/abstract-data-table/columns/tag/index.jsx");
            var _alert_message_column_AlertMessageColumn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/abstract-data-table/columns/alert-message-column/AlertMessageColumn.jsx");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var RowHeaderColumn = function(_AbstractColumn) {
                _inherits(RowHeaderColumn, _AbstractColumn);
                function RowHeaderColumn(rootClass) {
                    var _this;
                    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    _classCallCheck(this, RowHeaderColumn);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(RowHeaderColumn).call(this, rootClass, config));
                    _this._canBeSortable = true;
                    _this._canBeDate = true;
                    _this._canHaveSecondaryTertiaryText = true;
                    _this._renderSecondaryTertiaryText = _columns_secondary_tertiary_text_index__WEBPACK_IMPORTED_MODULE_3__["_renderSecondaryTertiaryText"].bind(_assertThisInitialized(_this));
                    if (config.date) {
                        _this._defaultAscendingA11yText = "sorted by oldest";
                        _this._defaultDescendingA11yText = "sorted by most recent";
                    }
                    return _this;
                }
                _createClass(RowHeaderColumn, [ {
                    key: "validateColumn",
                    value: function validateColumn(columnConfigs) {
                        if (this.config.colIndex !== 0 && !(this.config.colIndex === 1 && columnConfigs[0].columnType === "checkbox")) {
                            console.error("Row headers must be the first column");
                        }
                    }
                }, {
                    key: "_renderCellValue",
                    value: function _renderCellValue(cellData, rowIndex, cellConfig) {
                        var cellValue = cellData.value;
                        var displayValue = cellConfig.isInlineCaption ? this._renderHiddenCell(cellValue) : this._cleanDisplayValue(cellValue);
                        if (this._rootClass === "data-table-for-chart" && this.config.swatchShape && !(cellConfig.hasInlineCaption && rowIndex === 0)) {
                            return this._renderSwatch(cellData, rowIndex, cellConfig, this._cleanDisplayValue(cellValue));
                        }
                        return displayValue;
                    }
                }, {
                    key: "_renderSwatch",
                    value: function _renderSwatch(cellData, rowIndex, cellConfig, cellContent) {
                        var unsortedSwatchIndex = cellConfig.hasInlineCaption ? rowIndex - 1 : rowIndex;
                        var _this$config = this.config, swatchShape = _this$config.swatchShape, swatchColors = _this$config.swatchColors;
                        var swatchIndex = cellConfig.sortMap ? cellConfig.sortMap[unsortedSwatchIndex] : unsortedSwatchIndex;
                        var color = swatchColors && swatchColors[swatchIndex];
                        var style = "background-color: ".concat(color);
                        var swatchClasses = _defineProperty({
                            "data-table-for-chart__swatch": true
                        }, "data-table-for-chart__swatch--".concat(swatchShape), swatchShape);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "data-table-for-chart__swatch-container");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", swatchClasses);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["conditionalAttribute"])({
                            style: style
                        }, !!color));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        _renderArbitrary(cellContent);
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                    }
                }, {
                    key: "renderStackedHeader",
                    value: function renderStackedHeader(value, rowIndex, width, cellConfig, colIndex) {
                        var _rowHeaderClasses;
                        var isHidden = cellConfig.isHidden, cellData = cellConfig.cellData;
                        var idRowHeader = "row-header-row-".concat(rowIndex + 1, "-column-").concat(colIndex + 1);
                        var rowHeaderClasses = (_rowHeaderClasses = {}, _defineProperty(_rowHeaderClasses, "".concat(this._rootClass, "__row-header"), true), 
                        _defineProperty(_rowHeaderClasses, "".concat(this._rootClass, "__row-header--").concat(this.config.mode), true), 
                        _rowHeaderClasses);
                        if (!cellConfig.checkbox && MDS.isSafari) {
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("th");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRowHeader);
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("scope", "row");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", rowHeaderClasses);
                            _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["conditionalAttribute"])({
                                style: {
                                    width: width
                                }
                            }, width));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("th");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "".concat(this._rootClass, "__row-header-container"), "role", "text");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span");
                            _renderArbitrary(isHidden ? this._renderHiddenCell(value, cellData) : this._renderStackedHeaderValue(value, rowIndex, cellConfig));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                            _renderArbitrary(this._canHaveSecondaryTertiaryText && !isHidden && cellData && cellData.secondaryValue && this._renderSecondaryTertiaryText(cellData));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                            return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("th");
                        }
                        var data = cellData || {
                            value: value
                        };
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("th");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRowHeader);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("scope", "row");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", rowHeaderClasses);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["conditionalAttribute"])({
                            style: {
                                width: width
                            }
                        }, width));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("th");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", `${this._rootClass}__row-header-container`);
                        _renderArbitrary(!isHidden && !!cellConfig.checkbox && cellConfig.checkbox());
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span");
                        _renderArbitrary(isHidden ? this._renderHiddenCell(value, data) : this._renderStackedHeaderValue(data, rowIndex, cellConfig));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        _renderArbitrary(this._canHaveSecondaryTertiaryText && !isHidden && data && data.secondaryValue && this._renderSecondaryTertiaryText(data));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("th");
                    }
                }, {
                    key: "needsExternalStackedCaption",
                    value: function needsExternalStackedCaption(cellData) {
                        var additionalData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        var isApple = MDS.isIOS || MDS.isSafari;
                        var hasComplexContent = this._canHaveSecondaryTertiaryText && cellData.secondaryValue || additionalData.hasCheckboxes;
                        return isApple && hasComplexContent || MDS.isIOS;
                    }
                }, {
                    key: "renderStackedCaption",
                    value: function renderStackedCaption(cellData, rowIndex) {
                        var _captionClasses, _headingContainerClas;
                        var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        var captionClasses = (_captionClasses = {}, _defineProperty(_captionClasses, "".concat(this._rootClass, "__caption"), true), 
                        _defineProperty(_captionClasses, "".concat(this._rootClass, "__caption--stacked"), true), 
                        _captionClasses);
                        var headingContainerClasses = (_headingContainerClas = {}, _defineProperty(_headingContainerClas, "".concat(this._rootClass, "__stacked-caption-heading-container"), true), 
                        _defineProperty(_headingContainerClas, "".concat(this._rootClass, "__stacked-caption-heading-container--with-checkbox"), !!config.checkbox), 
                        _headingContainerClas);
                        if (config.renderAsDiv) {
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", captionClasses, "id", config.captionId, "role", "heading", "aria-level", "3");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div");
                            _renderArbitrary("".concat(this.config.headerValue));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", headingContainerClasses);
                            _renderArbitrary(config.checkbox && config.checkbox());
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div");
                            _renderArbitrary(this._renderCellValue(cellData, rowIndex, this.config));
                            _renderArbitrary(cellData.tagText && _tag__WEBPACK_IMPORTED_MODULE_4__["default"].call(this, cellData.tagText, cellData.tagColor));
                            _renderArbitrary(this._canHaveSecondaryTertiaryText && cellData.secondaryValue && this._renderSecondaryTertiaryText(cellData));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                            return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        }
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("caption", null, null, "class", captionClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div");
                        _renderArbitrary(`${this.config.headerValue}`);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", headingContainerClasses);
                        _renderArbitrary(config.checkbox && config.checkbox());
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div");
                        _renderArbitrary(this._renderCellValue(cellData, rowIndex, this.config));
                        _renderArbitrary(cellData.tagText && _tag__WEBPACK_IMPORTED_MODULE_4__["default"].call(this, cellData.tagText, cellData.tagColor));
                        _renderArbitrary(this._canHaveSecondaryTertiaryText && cellData.secondaryValue && this._renderSecondaryTertiaryText(cellData));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("caption");
                    }
                }, {
                    key: "_renderStackedHeaderValue",
                    value: function _renderStackedHeaderValue(cellData, rowIndex, cellConfig) {
                        if (this._rootClass === "data-table-for-chart" && this.config.swatchShape && !(cellConfig.hasInlineCaption && rowIndex === 0)) {
                            return this._renderSwatch({}, rowIndex, cellConfig, this._cleanDisplayValue(cellData.value));
                        }
                        return this._cleanDisplayValue(cellData.value);
                    }
                }, {
                    key: "renderColumnHeader",
                    value: function renderColumnHeader(additionalClasses, headerConfig) {
                        return _get(_getPrototypeOf(RowHeaderColumn.prototype), "renderColumnHeader", this).call(this, _extends(_defineProperty({}, "".concat(this._rootClass, "__column-header--left"), true), additionalClasses), headerConfig);
                    }
                }, {
                    key: "renderCell",
                    value: function renderCell(cellData, rowIndex) {
                        var _extends3;
                        var cellConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        var _this$config2 = this.config, width = _this$config2.width, colIndex = _this$config2.colIndex, columnType = _this$config2.columnType;
                        var idRowHeader = "row-header-row".concat(rowIndex, "-column").concat(colIndex);
                        var classes = _extends((_extends3 = {}, _defineProperty(_extends3, "".concat(this._rootClass, "__row-header"), true), 
                        _defineProperty(_extends3, "data-table-for-chart__row-header--with-swatch", this._rootClass === "data-table-for-chart" && this.config.swatchShape), 
                        _extends3), cellConfig.additionalClasses);
                        if (MDS.isSafari && columnType !== "rowHeaderLink") {
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("th");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRowHeader);
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("scope", "row");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", classes);
                            _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["conditionalAttribute"])({
                                style: {
                                    width: width
                                }
                            }, width));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("th");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("role", "text");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "".concat(this._rootClass, "__row-value--text"));
                            _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["conditionalAttribute"])({
                                style: {
                                    width: width
                                }
                            }, width));
                            _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["conditionalAttribute"])({
                                style: {
                                    webkitLineClamp: cellData.truncateLineNumber
                                }
                            }, cellData.truncateLineNumber && this._rootClass === "data-table-for-files"));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                            _renderArbitrary(this._renderCellValue(cellData, rowIndex, cellConfig));
                            _renderArbitrary(cellData.tagText && _tag__WEBPACK_IMPORTED_MODULE_4__["default"].call(this, cellData.tagText, cellData.tagColor));
                            _renderArbitrary(cellData.alertMessage && _alert_message_column_AlertMessageColumn__WEBPACK_IMPORTED_MODULE_5__["renderAlertMessage"].call(this, cellData.alertMessage));
                            _renderArbitrary(this._canHaveSecondaryTertiaryText && cellData.secondaryValue && this._renderSecondaryTertiaryText(cellData));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                            return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("th");
                        }
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("th");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRowHeader);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("scope", "row");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", classes);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["conditionalAttribute"])({
                            style: {
                                width: width
                            }
                        }, width));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("th");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", `${this._rootClass}__row-value--text`);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["conditionalAttribute"])({
                            style: {
                                webkitLineClamp: cellData.truncateLineNumber
                            }
                        }, cellData.truncateLineNumber && this._rootClass === "data-table-for-files"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                        _renderArbitrary(this._renderCellValue(cellData, rowIndex, cellConfig));
                        _renderArbitrary(cellData.tagText && _tag__WEBPACK_IMPORTED_MODULE_4__["default"].call(this, cellData.tagTex, cellData.tagColor));
                        _renderArbitrary(cellData.alertMessage && _alert_message_column_AlertMessageColumn__WEBPACK_IMPORTED_MODULE_5__["renderAlertMessage"].call(this, cellData.alertMessage));
                        _renderArbitrary(this._canHaveSecondaryTertiaryText && cellData.secondaryValue && this._renderSecondaryTertiaryText(cellData, !!this.config.swatchShape));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("th");
                    }
                } ]);
                return RowHeaderColumn;
            }(_abstract_column_index__WEBPACK_IMPORTED_MODULE_1__["default"]);
        },
        "./src/abstract-data-table/columns/row-header-link-column/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", (function() {
                return RowHeaderLinkColumn;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _row_header_column_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-data-table/columns/row-header-column/index.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _link$wrapper = function _link$wrapper(_href, _cleanedData, _conditionalAttribute, _$concat, _eventData, _leadingText, _$concat$concat, _eventData2, _trailingText, _$concat2, _trailingIconType, _eventData3, _child) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("a");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("href", _href);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-label", _cleanedData);
                _spreadAttribute(_conditionalAttribute);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", _$concat);
                _spreadAttribute(_eventData);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("a");
                _renderArbitrary(_leadingText);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", _$concat$concat);
                _spreadAttribute(_eventData2);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("span");
                _renderArbitrary(_trailingText);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", _$concat2);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("innerHTML-prop", _trailingIconType);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-hidden", "true");
                _spreadAttribute(_eventData3);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                _renderArbitrary(_child);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("a");
            }, _link$wrapper2 = function _link$wrapper2(_id, _accessibleText) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "id", _id, "class", "accessible-text", "aria-hidden", "true");
                _renderArbitrary(_accessibleText);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            };
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var RowHeaderLinkColumn = function(_RowHeaderColumn) {
                _inherits(RowHeaderLinkColumn, _RowHeaderColumn);
                function RowHeaderLinkColumn() {
                    _classCallCheck(this, RowHeaderLinkColumn);
                    return _possibleConstructorReturn(this, _getPrototypeOf(RowHeaderLinkColumn).apply(this, arguments));
                }
                _createClass(RowHeaderLinkColumn, [ {
                    key: "getInteractiveElement",
                    value: function getInteractiveElement(table, payload) {
                        var rowIndex = payload.rowIndex, colIndex = payload.colIndex;
                        var interactiveElement = table.shadowRoot.querySelector('a[data-row="'.concat(rowIndex, '"][data-column="').concat(colIndex, '"]'));
                        return {
                            interactiveElement: interactiveElement
                        };
                    }
                }, {
                    key: "needsExternalStackedCaption",
                    value: function needsExternalStackedCaption() {
                        var isApple = MDS.isIOS || MDS.isSafari;
                        return isApple;
                    }
                }, {
                    key: "_renderStackedHeaderValue",
                    value: function _renderStackedHeaderValue(cellData, rowIndex, cellConfig) {
                        return this._renderCellValue(cellData, rowIndex, cellConfig);
                    }
                }, {
                    key: "_renderCellValue",
                    value: function _renderCellValue(cellData, rowIndex, cellConfig) {
                        var href = cellData.href, value = cellData.value, accessibleText = cellData.accessibleText, plainText = cellData.plainText, newWindowIcon = cellData.newWindowIcon;
                        var cleanedData = this._cleanDisplayValue(value);
                        if (plainText) {
                            return cleanedData;
                        }
                        var lastIndex = cleanedData.lastIndexOf(" ");
                        var leadingText = cleanedData.substring(0, lastIndex);
                        var trailingText = cleanedData.substring(lastIndex, cleanedData.length);
                        var trailingIconType = newWindowIcon ? MDS.svgs["ico_new_window"] : MDS.svgs["ico_chevron_right"];
                        var eventData = {
                            "data-index": rowIndex + 1,
                            "data-type": "row-header-link",
                            "data-column": this.config.colIndex + 1,
                            "data-row": rowIndex + 1
                        };
                        var link = _jsxWrapper(_link$wrapper, [ href || "javascript:void(0)", cleanedData, Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["conditionalAttribute"])({
                            "aria-describedby": "".concat(rowIndex, "-accessible-text")
                        }, accessibleText), "".concat(this._rootClass, "__link"), eventData, leadingText, "".concat(this._rootClass, "__link ").concat(this._rootClass, "__link--trailing"), eventData, trailingText, "".concat(this._rootClass, "__link-icon"), trailingIconType, eventData, accessibleText && _jsxWrapper(_link$wrapper2, [ "".concat(rowIndex, "-accessible-text"), accessibleText ]) ]);
                        if (this._rootClass === "data-table-for-files" && !href) {
                            return _get(_getPrototypeOf(RowHeaderLinkColumn.prototype), "_renderCellValue", this).call(this, cellData, rowIndex, cellConfig);
                        }
                        if (this._rootClass === "data-table-for-chart" && this.config.swatchShape && !(cellConfig.hasInlineCaption && rowIndex === 0)) {
                            var unsortedSwatchIndex = cellConfig.hasInlineCaption ? rowIndex - 1 : rowIndex;
                            var _this$config = this.config, swatchShape = _this$config.swatchShape, swatchColors = _this$config.swatchColors;
                            var swatchIndex = cellConfig.sortMap ? cellConfig.sortMap[unsortedSwatchIndex] : unsortedSwatchIndex;
                            var color = swatchColors && swatchColors[swatchIndex];
                            var style = "background-color: ".concat(color);
                            var swatchClasses = _defineProperty({
                                "data-table-for-chart__swatch": true
                            }, "data-table-for-chart__swatch--".concat(swatchShape), swatchShape);
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "data-table-for-chart__swatch-container");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", swatchClasses);
                            _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["conditionalAttribute"])({
                                style: style
                            }, !!color));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                            _renderArbitrary(link);
                            return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        }
                        return link;
                    }
                } ]);
                return RowHeaderLinkColumn;
            }(_row_header_column_index__WEBPACK_IMPORTED_MODULE_1__["default"]);
        },
        "./src/abstract-data-table/columns/secondary-tertiary-text/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "_renderSecondaryTertiaryText", (function() {
                return _renderSecondaryTertiaryText;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _renderSecondaryTertiaryText(cellData, hasSwatch) {
                var _listClasses;
                var listClasses = (_listClasses = {}, _defineProperty(_listClasses, "".concat(this._rootClass, "__grouping-for-secondary-tertiary-text"), true), 
                _defineProperty(_listClasses, "".concat(this._rootClass, "__grouping-for-secondary-tertiary-text--with-padding"), hasSwatch), 
                _listClasses);
                if (cellData.tertiaryValue && cellData.secondaryValue) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("ul", null, null, "class", listClasses, "role", "none");
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("li", null, null, "class", "".concat(this._rootClass, "__secondary-text"));
                    _renderArbitrary(this._cleanDisplayValue(cellData.secondaryValue));
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("li");
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("li", null, null, "class", "".concat(this._rootClass, "__tertiary-text"));
                    _renderArbitrary(this._cleanDisplayValue(cellData.tertiaryValue));
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("li");
                    return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("ul");
                } else if (cellData.secondaryValue) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("ul", null, null, "class", listClasses, "role", "none");
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("li", null, null, "class", "".concat(this._rootClass, "__secondary-text"));
                    _renderArbitrary(this._cleanDisplayValue(cellData.secondaryValue));
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("li");
                    return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("ul");
                }
                return "";
            }
        },
        "./src/abstract-data-table/columns/select-column/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", (function() {
                return SelectColumn;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _abstract_column__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-data-table/columns/abstract-column/index.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var SelectColumn = function(_AbstractColumn) {
                _inherits(SelectColumn, _AbstractColumn);
                function SelectColumn() {
                    _classCallCheck(this, SelectColumn);
                    return _possibleConstructorReturn(this, _getPrototypeOf(SelectColumn).apply(this, arguments));
                }
                _createClass(SelectColumn, [ {
                    key: "validateColumn",
                    value: function validateColumn(columnConfigs) {
                        var _this = this;
                        var _columnConfigs$reduce = columnConfigs.reduce(function(conditions, column) {
                            _newArrowCheck(this, _this);
                            conditions.numSelectColumns += column.columnType === "select" ? 1 : 0;
                            if (!missingColumnHeaders && !column.headerValue) {
                                conditions.missingColumnHeaders = true;
                            }
                            return conditions;
                        }.bind(this), {
                            numSelectColumns: 0,
                            missingColumnHeaders: false
                        }), numSelectColumns = _columnConfigs$reduce.numSelectColumns, missingColumnHeaders = _columnConfigs$reduce.missingColumnHeaders;
                        if (!this.config.headerValue) {
                            throw new Error("Select column must have a headerValue");
                        } else {
                            missingColumnHeaders && console.error("A table with column for select must have column headers");
                        }
                        if (this.config.colIndex === 0) {
                            throw new Error("Select column cannot be the first column");
                        }
                        if (numSelectColumns > 1) {
                            console.error("A table may only have one column for select");
                        }
                    }
                }, {
                    key: "getInteractiveElement",
                    value: function getInteractiveElement(table, payload) {
                        return _objectSpread({}, _get(_getPrototypeOf(SelectColumn.prototype), "getInteractiveElement", this).call(this, table, payload), {
                            nextPayload: payload
                        });
                    }
                }, {
                    key: "renderStackedHeader",
                    value: function renderStackedHeader(value, rowIndex, width, cellConfig, colIndex) {
                        var _rowHeaderClasses;
                        var isHidden = cellConfig.isHidden;
                        var idRowHeader = "row-header-row-".concat(rowIndex + 1, "-column-").concat(colIndex + 1);
                        var rowHeaderClasses = (_rowHeaderClasses = {}, _defineProperty(_rowHeaderClasses, "".concat(this._rootClass, "__row-header"), true), 
                        _defineProperty(_rowHeaderClasses, "".concat(this._rootClass, "__row-header--select"), true), 
                        _defineProperty(_rowHeaderClasses, "".concat(this._rootClass, "__row-header--").concat(this.config.mode), true), 
                        _rowHeaderClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("th");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRowHeader);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("scope", "row");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", rowHeaderClasses);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["conditionalAttribute"])({
                            style: {
                                width: width
                            }
                        }, width));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("th");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "".concat(this._rootClass, "__select-header"));
                        _renderArbitrary(isHidden ? this._renderHiddenCell(value) : this._cleanDisplayValue.call(this, value));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("th");
                    }
                }, {
                    key: "handleChange",
                    value: function handleChange(event) {
                        var _this2 = this;
                        var value = event.target.value;
                        var _event$target$dataset = event.target.dataset, type = _event$target$dataset.type, column = _event$target$dataset.column;
                        var row = +event.target.dataset.row - 1;
                        var rowData = this.rowData;
                        var sortedRowIndex = this.sortMap ? this.sortMap[row] : row;
                        rowData[sortedRowIndex][+column - 1].value = value;
                        this.setState({
                            rowData: rowData
                        });
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this2);
                            return "change";
                        }.bind(this), this)(event, _extends({}, event.detail, {
                            type: type,
                            row: row,
                            rowIndex: "".concat(row + 1),
                            value: value,
                            column: +column - 1,
                            columnIndex: column
                        }));
                    }
                }, {
                    key: "renderColumnHeader",
                    value: function renderColumnHeader(additionalClasses, headerConfig) {
                        var _extends2;
                        return _get(_getPrototypeOf(SelectColumn.prototype), "renderColumnHeader", this).call(this, _extends((_extends2 = {}, 
                        _defineProperty(_extends2, "".concat(this._rootClass, "__column-header--left"), true), 
                        _defineProperty(_extends2, "".concat(this._rootClass, "__column-header--select"), true), 
                        _extends2), additionalClasses), headerConfig);
                    }
                }, {
                    key: "renderStackedCell",
                    value: function renderStackedCell(cellData, rowIndex) {
                        var cellConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        return this.renderCell(cellData, rowIndex, cellConfig);
                    }
                }, {
                    key: "renderCell",
                    value: function renderCell(cellData, rowIndex) {
                        var _extends3;
                        var cellConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        var colIndex = this.config.colIndex;
                        var idRowHeader = "value-row-".concat(rowIndex + 1, "-column-").concat(colIndex + 1);
                        var classes = _extends((_extends3 = {}, _defineProperty(_extends3, "".concat(this._rootClass, "__row-value"), true), 
                        _defineProperty(_extends3, "".concat(this._rootClass, "__row-value--select"), true), 
                        _defineProperty(_extends3, "".concat(this._rootClass, "__row-value--left"), true), 
                        _defineProperty(_extends3, "".concat(this._rootClass, "__row-value--stacked"), this.config.stacked), 
                        _extends3), cellConfig.additionalClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("td", null, null, "id", idRowHeader, "class", classes);
                        _renderArbitrary(this._renderCellValue(cellData, rowIndex));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("td");
                    }
                }, {
                    key: "_renderCellValue",
                    value: function _renderCellValue(cellData, rowIndex) {
                        var _this3 = this;
                        var _this$config = this.config, mode = _this$config.mode, colIndex = _this$config.colIndex, headerValue = _this$config.headerValue, stacked = _this$config.stacked;
                        var options = cellData.options, selectedIndex = cellData.selectedIndex, value = cellData.value, labelKey = cellData.labelKey, valueKey = cellData.valueKey, inactive = cellData.inactive, required = cellData.required, accessibleText = cellData.accessibleText, accessibleTextExpanded = cellData.accessibleTextExpanded, accessibleTextCollapsed = cellData.accessibleTextCollapsed, accessibleTextCardinalitySeparator = cellData.accessibleTextCardinalitySeparator, name = cellData.name, placeholder = cellData.placeholder;
                        var defaultValue;
                        if (!value) {
                            var resolvedValueKey = valueKey || "value";
                            var preselectedOption = options.reduce(function(preSelection, option) {
                                _newArrowCheck(this, _this3);
                                return preSelection || option.selected && option[resolvedValueKey];
                            }.bind(this));
                            if (!selectedIndex && !preselectedOption && !placeholder) {
                                for (var i = 0; i < options.length; i += 1) {
                                    if (!!options[i] && !options[i].disabled) {
                                        defaultValue = options[i][resolvedValueKey];
                                        break;
                                    }
                                }
                            } else if (Number.isInteger(selectedIndex) && selectedIndex > -1) {
                                defaultValue = options[selectedIndex][resolvedValueKey];
                            } else if (preselectedOption) {
                                defaultValue = preselectedOption[resolvedValueKey];
                            } else {
                                defaultValue = options[0][resolvedValueKey];
                            }
                        }
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("mds-select");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("options", JSON.stringify(options));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("selected-index", selectedIndex);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("value", value || defaultValue);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("label-key", labelKey);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("value-key", valueKey);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("inactive", inactive);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("required", required);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-column", colIndex + 1);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-row", rowIndex + 1);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-type", "select");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("accessible-text", accessibleText);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("accessible-text-expanded", accessibleTextExpanded);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("accessible-text-collapsed", accessibleTextCollapsed);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("accessible-text-cardinality-separator", accessibleTextCardinalitySeparator);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("name", name);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("placeholder", placeholder);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("_is-in-table", mode);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["conditionalAttribute"])({
                            label: headerValue
                        }, !stacked));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("mds-select");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-select");
                    }
                } ]);
                return SelectColumn;
            }(_abstract_column__WEBPACK_IMPORTED_MODULE_1__["default"]);
        },
        "./src/abstract-data-table/columns/sparkline-column/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", (function() {
                return SparklineColumn;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _abstract_column_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-data-table/columns/abstract-column/index.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/data-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var SparklineColumn = function(_AbstractColumn) {
                _inherits(SparklineColumn, _AbstractColumn);
                function SparklineColumn() {
                    _classCallCheck(this, SparklineColumn);
                    return _possibleConstructorReturn(this, _getPrototypeOf(SparklineColumn).apply(this, arguments));
                }
                _createClass(SparklineColumn, [ {
                    key: "renderColumnHeader",
                    value: function renderColumnHeader(additionalClasses, headerConfig) {
                        return _get(_getPrototypeOf(SparklineColumn.prototype), "renderColumnHeader", this).call(this, _extends(_defineProperty({}, "".concat(this._rootClass, "__column-header--sparkline"), true), additionalClasses), headerConfig);
                    }
                }, {
                    key: "renderStackedCell",
                    value: function renderStackedCell(cellData, rowIndex) {
                        var cellConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        return this.renderCell(cellData, rowIndex, cellConfig);
                    }
                }, {
                    key: "renderCell",
                    value: function renderCell(cellData, rowIndex) {
                        var _extends3;
                        var cellConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        var _this$config = this.config, width = _this$config.width, colIndex = _this$config.colIndex;
                        var idRowValue = "value-row-".concat(rowIndex + 1, "-column-").concat(colIndex + 1);
                        var classes = _extends((_extends3 = {}, _defineProperty(_extends3, "".concat(this._rootClass, "__row-value"), true), 
                        _defineProperty(_extends3, "".concat(this._rootClass, "__row-value--sparkline"), true), 
                        _extends3), cellConfig.additionalClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("td");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRowValue);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", classes);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["conditionalAttribute"])({
                            style: {
                                width: width
                            }
                        }, width));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("td");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["conditionalAttribute"])({
                            style: {
                                width: width
                            }
                        }, width && !Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["isPercent"])(width)));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "".concat(this._rootClass, "__row-value--text"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-sparkline", null, null, "accessible-name", cellData.sparkline.accessibleName, "accessible-description", cellData.sparkline.accessibleDescription, "reference-line-value", cellData.sparkline.referenceLineValue, "line-color", cellData.sparkline.lineColor, "final-value-point", cellData.sparkline.finalValuePoint, "final-value-point-color", cellData.sparkline.finalValuePointColor, "x-range", JSON.stringify(cellData.sparkline.xRange), "y-range", JSON.stringify(cellData.sparkline.yRange), "data-points", JSON.stringify(cellData.sparkline.dataPoints), "chart-height", cellData.sparkline.chartHeight, "no-data-point-text", cellData.sparkline.noDataPointText);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("td");
                    }
                } ]);
                return SparklineColumn;
            }(_abstract_column_index__WEBPACK_IMPORTED_MODULE_1__["default"]);
        },
        "./src/abstract-data-table/columns/tag/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", (function() {
                return renderTag;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var tags = new Set([ "data-table-for-accounts", "data-table-for-transactions", "data-table-for-securities" ]);
            function renderTag(tagText, tagColor) {
                if (tags.has(this._rootClass)) {
                    return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-tag", null, null, "class", "".concat(this._rootClass, "__tag"), "text", tagText, "interactive", "false", "color", tagColor);
                }
                throw Error("Only data-table-for-accounts, data-table-for-transactions and data-table-for-securities are allowed to have tags in columns. Not ".concat(this._rootClass, "."));
            }
        },
        "./src/abstract-data-table/data-table-combo-button/DataTableComboButton.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function generateMenuItem(item, index) {
                var menuItemClasses = _defineProperty({
                    "data-table-combo-button__menu-item": true
                }, "data-table-combo-button__".concat(index, "-button"), true);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("li", null, null, "class", menuItemClasses, "role", "menuitem", "tabIndex", "-1", "value", index, "aria-disabled", item.inactive, "onblur", this._handleMenuBlur);
                _renderArbitrary(item.text);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("li");
            }
            function renderMenu() {
                var _this = this;
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "data-table-combo-button__menu-container");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("ul", null, null, "class", "data-table-combo-button__menu-list", "role", "menu", "aria-hidden", !this.open, "onkeydown", this._handleMenuItemKeydown, "onkeyup", this._handleMenuItemKeyup, "onclick", this._handleMenuClick);
                _renderArbitrary(this.open && this.menuItems.map(function(item, index) {
                    _newArrowCheck(this, _this);
                    return generateMenuItem.call(this, item, index);
                }.bind(this)));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("ul");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function ComboButtonTemplate() {
                var buttonContainerClasses = _defineProperty({
                    "data-table-combo-button__button-container": true
                }, "data-table-combo-button__button-container--tertiary", true);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "data-table-combo-button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", buttonContainerClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-button", null, null, "class", "data-table-combo-button__primary-button", "text", this.text, "variant", "tertiary", "small", "true", "value", "primary", "onclick", this._handleButtonClick, "tab-focusable", !this.open);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "data-table-combo-button__divider");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-button", null, null, "class", "data-table-combo-button__menu-button", "variant", "tertiary", "small", "true", "icon-type", "ico_chevron_down", "icon-position", "icon_only", "accessible-text", this.menuButtonAccessibleText, "aria", {
                    "aria-haspopup": "menu",
                    "aria-expanded": this.open
                }, "value", "menu", "onmousedown", this._handleMenuButtonMousedown, "onmouseup", this.toggleMenu, "onkeydown", this._handleMenuButtonKeydown, "onclick", this._handleButtonClick);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                _renderArbitrary(this.menuItems && renderMenu.call(this));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            __webpack_exports__["default"] = ComboButtonTemplate;
        },
        "./src/abstract-data-table/data-table-combo-button/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _abstract_combo_button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-combo-button/index.jsx");
            var _mds_data_table_combo_button_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/abstract-data-table/data-table-combo-button/mds-data-table-combo-button.scss");
            var _mds_data_table_combo_button_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_data_table_combo_button_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _DataTableComboButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/abstract-data-table/data-table-combo-button/DataTableComboButton.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var arrayOf = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].arrayOf, string = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].stringRequired, satisfies = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].satisfies;
            var menuItemEntity = {
                text: string.defaultsTo("")
            };
            var entity = {
                menuButtonAccessibleText: string.defaultsTo("More options"),
                menuItems: arrayOf(satisfies(menuItemEntity)).withMinLength(1),
                text: stringRequired
            };
            var MdsDataTableComboButton = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AbstractComboButton) {
                _inherits(MdsDataTableComboButton, _AbstractComboButton);
                _createClass(MdsDataTableComboButton, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsDataTableComboButton";
                    }
                } ]);
                function MdsDataTableComboButton() {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsDataTableComboButton);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsDataTableComboButton).call(this));
                    _this._dispatchEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "click";
                    }.bind(this), _assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsDataTableComboButton, [ {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        return {
                            interactiveElement: this.shadowRoot.querySelector(".data-table-combo-button__".concat(payload.value, "-button"))
                        };
                    }
                }, {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsDataTableComboButton.prototype), "connectedCallback", this).call(this, "data-table-combo-button");
                        var _this$getRootNode = this.getRootNode(), host = _this$getRootNode.host;
                        if (!host || !host.tagName.match(/^MDS-DATA-TABLE-.*$/)) {
                            this.throwConstraintError("mds-data-table-combo-button can only be used inside a data table.");
                        }
                    }
                }, {
                    key: "_handleButtonClick",
                    value: function _handleButtonClick(event) {
                        event.stopPropagation();
                        var detail = {
                            value: event.target.value,
                            original: event.detail
                        };
                        this._dispatchEvent(event, detail);
                    }
                }, {
                    key: "_handleMenuClick",
                    value: function _handleMenuClick(event) {
                        event.stopPropagation();
                        var detail = {
                            value: event.target.value,
                            original: event.detail
                        };
                        this._dispatchEvent(event, detail);
                        this.closeMenu(true);
                    }
                }, {
                    key: "render",
                    value: function render() {
                        _DataTableComboButton__WEBPACK_IMPORTED_MODULE_3__["default"].call(this);
                    }
                } ]);
                return MdsDataTableComboButton;
            }(_abstract_combo_button__WEBPACK_IMPORTED_MODULE_1__["default"]), _class2.styles = _mds_data_table_combo_button_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsDataTableComboButton;
        },
        "./src/abstract-data-table/data-table-combo-button/mds-data-table-combo-button.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/abstract-data-table/data-table-combo-button/mds-data-table-combo-button.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/abstract-data-table/data-table-input/MdsDataTableTextInput.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "renderErrorMicrocopy", (function() {
                return renderErrorMicrocopy;
            }));
            __webpack_require__.d(__webpack_exports__, "default", (function() {
                return MdsTextInputTemplate;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _microcopy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/microcopy/index.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function renderErrorMicrocopy(_ref, errorMessageList) {
                var _this = this;
                var errorMessagePrefix = _ref.errorMessagePrefix, id = _ref.id;
                var baseClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "text-input";
                return errorMessageList.map(function(eMessage, i) {
                    _newArrowCheck(this, _this);
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div");
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-error-message", null, null, "class", "".concat(baseClass, "__error-microcopy"), "variant", "error", "alert-title", eMessage, "size", "mini", "accessible-text-icon", "text input error icon", "aria-hidden", "true", "hide-icon", i !== 0);
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "".concat(baseClass, "__error-microcopy-accessible-text"), "id", "".concat(id, "-error-text").concat(i), "aria-hidden", "true");
                    _renderArbitrary("".concat(errorMessagePrefix, " ").concat(eMessage, " "));
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                    return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                }.bind(this));
            }
            function MdsTextInputTemplate() {
                var _this2 = this;
                var autocompleteValue = this.autocompleteValue, errorMessage = this.errorMessage, errorMessages = this.errorMessages, _getEventProps = this._getEventProps, id = this.id, inactive = this.inactive, label = this.label, microcopy = this.microcopy, name = this.name, placeholder = this.placeholder, required = this.required, value = this.value;
                var inputValue = !value ? "" : value;
                var errorMessageList = errorMessages.concat(errorMessage ? [ errorMessage ] : []);
                var labelClasses = {
                    "text-input__label": true,
                    "text-input__label--error": !!errorMessageList.length
                };
                var textElementClasses = {
                    "text-input__input": true,
                    "text-input__input--error": !!errorMessageList.length
                };
                var ariaDescribedbyIds = "";
                if (errorMessageList.length) {
                    ariaDescribedbyIds += errorMessageList.map(function(_, i) {
                        _newArrowCheck(this, _this2);
                        return "".concat(id, "-error-text").concat(i);
                    }.bind(this)).join(" ").concat(" ");
                }
                if (placeholder && !value) {
                    ariaDescribedbyIds += "".concat(id, "-placeholder-text ");
                }
                if (microcopy) {
                    ariaDescribedbyIds += "".concat(id, "-microcopy");
                }
                var textElementProps = _objectSpread({}, _getEventProps(), {}, Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["conditionalAttribute"])({
                    "aria-describedby": ariaDescribedbyIds
                }, ariaDescribedbyIds), {}, Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["conditionalAttribute"])("aria-invalid", !!errorMessageList.length), {
                    class: textElementClasses,
                    id: "".concat(id, "-input"),
                    "disabled-prop": inactive,
                    "value-prop": value,
                    placeholder: placeholder,
                    name: name,
                    autocomplete: autocompleteValue,
                    "required-prop": required
                });
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "text-input");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "text-input__label-wrap");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("label", null, null, "id", "".concat(id, "-input-label"), "class", "accessible-text", "for", "".concat(id, "-input"));
                _renderArbitrary(label);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("label");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "text-input__input-wrap");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("input");
                _spreadAttribute(textElementProps);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-labelledby", "".concat(id, "-input-label"));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("input");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("input");
                _renderArbitrary(renderErrorMicrocopy(this, errorMessageList));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "aria-hidden", "true");
                _renderArbitrary(Object(_microcopy__WEBPACK_IMPORTED_MODULE_1__["default"])(microcopy, "".concat(id, "-microcopy"), "text-input__microcopy"));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "id", "".concat(id, "-placeholder-text"), "class", "accessible-text", "aria-hidden", "true");
                _renderArbitrary(placeholder);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
        },
        "./src/abstract-data-table/data-table-input/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _abstract_text_field__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-text-field/index.js");
            var _mds_data_table_text_input_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/abstract-data-table/data-table-input/mds-data-table-text-input.scss");
            var _mds_data_table_text_input_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_data_table_text_input_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _MdsDataTableTextInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/abstract-data-table/data-table-input/MdsDataTableTextInput.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/common-utils.js");
            var _dec, _class, _class2;
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["mixins"].AttributeMarshallingMixin, arrayOf = _mixins$AttributeMars.arrayOf, stamp = _mixins$AttributeMars.stamp, boolean = _mixins$AttributeMars.boolean, number = _mixins$AttributeMars.number, string = _mixins$AttributeMars.string, enumerables = _mixins$AttributeMars.enumerables;
            var textInputEntity = {
                autocompleteValue: string.defaultsTo("off"),
                value: string.defaultsTo(""),
                inactive: boolean.defaultsTo(false)
            };
            var entity = _objectSpread({}, _abstract_text_field__WEBPACK_IMPORTED_MODULE_1__["entity"], {}, textInputEntity);
            var MdsDataTableTextInput = (_dec = stamp(entity), _dec(_class = (_class2 = function(_AbstractTextField) {
                _inherits(MdsDataTableTextInput, _AbstractTextField);
                _createClass(MdsDataTableTextInput, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsDataTableTextInput";
                    }
                } ]);
                function MdsDataTableTextInput() {
                    var _this;
                    _classCallCheck(this, MdsDataTableTextInput);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsDataTableTextInput).call(this));
                    _this._getEventProps = _this._getEventProps.bind(_assertThisInitialized(_this));
                    _this._validate = _this._validate.bind(_assertThisInitialized(_this));
                    _this._handleBlur = _this._handleBlur.bind(_assertThisInitialized(_this));
                    _this._handleFocus = _this._handleFocus.bind(_assertThisInitialized(_this));
                    _this._preventDefaultOnMousedown = _utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["preventDefault"];
                    return _this;
                }
                _createClass(MdsDataTableTextInput, [ {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        if (!payload.target) {
                            return {
                                interactiveElement: this._textFieldNode
                            };
                        }
                        return _get(_getPrototypeOf(MdsDataTableTextInput.prototype), "_getInteractiveElement", this).call(this, {
                            target: "".concat(payload.target)
                        });
                    }
                }, {
                    key: "_getEventProps",
                    value: function _getEventProps() {
                        return {
                            onclick: this._onclick,
                            onchange: this._onchange,
                            onfocus: this._handleFocus,
                            onblur: this._handleBlur,
                            onkeydown: this._onkeydown,
                            onkeyup: this._onkeyup,
                            onmousedown: this._onmousedown,
                            onmouseup: this._onmouseup,
                            onmouseover: this._onmouseover,
                            onmouseenter: this._onmouseenter,
                            onmouseout: this._onmouseout,
                            oninput: this._oninput
                        };
                    }
                }, {
                    key: "_validate",
                    value: function _validate(event) {
                        var detail = {
                            original: event,
                            target: event.target,
                            id: this.id,
                            name: this.name,
                            value: this.value,
                            row: this.dataset.row,
                            rowIndex: (this.dataset.row - 1) * 1,
                            columnIndex: (this.dataset.column - 1) * 1,
                            column: this.dataset.column
                        };
                        if (event.type === "blur") {
                            var blurEvent = event.detail || event;
                            if (!this.shadowRoot.contains(blurEvent.relatedTarget || document.activeElement)) {
                                this.dispatchEvent(new CustomEvent("validate", {
                                    detail: detail,
                                    bubbles: true,
                                    composed: true
                                }));
                            }
                        } else if (event.type === "input") {
                            this.dispatchEvent(new CustomEvent("validate", {
                                detail: detail,
                                bubbles: true,
                                composed: true
                            }));
                        }
                    }
                }, {
                    key: "_handleBlur",
                    value: function _handleBlur(event) {
                        var _originalEvent = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["originalEvent"])(event), relatedTarget = _originalEvent.relatedTarget;
                        if (!this.shadowRoot.contains(relatedTarget)) {
                            this._validate(event);
                            _utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["setAriaLiveText"].call(this);
                            _get(_getPrototypeOf(MdsDataTableTextInput.prototype), "_onblur", this) && _get(_getPrototypeOf(MdsDataTableTextInput.prototype), "_onblur", this).call(this, event);
                        } else {
                            event.stopPropagation();
                        }
                    }
                }, {
                    key: "_handleFocus",
                    value: function _handleFocus(event) {
                        var _originalEvent2 = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["originalEvent"])(event), target = _originalEvent2.target, relatedTarget = _originalEvent2.relatedTarget;
                        if (!this.shadowRoot.contains(relatedTarget)) {
                            _get(_getPrototypeOf(MdsDataTableTextInput.prototype), "_onfocus", this) && _get(_getPrototypeOf(MdsDataTableTextInput.prototype), "_onfocus", this).call(this, event);
                        } else {
                            event.stopPropagation();
                        }
                    }
                }, {
                    key: "_oninput",
                    value: function _oninput(event) {
                        this.value = event.target.value;
                        _get(_getPrototypeOf(MdsDataTableTextInput.prototype), "_oninput", this) && _get(_getPrototypeOf(MdsDataTableTextInput.prototype), "_oninput", this).call(this, event);
                        if (!!this.errorMessage || !!this.errorMessages.length) {
                            this._validate(event);
                        }
                    }
                }, {
                    key: "render",
                    value: function render() {
                        _MdsDataTableTextInput__WEBPACK_IMPORTED_MODULE_3__["default"].call(this);
                    }
                } ]);
                return MdsDataTableTextInput;
            }(_abstract_text_field__WEBPACK_IMPORTED_MODULE_1__["default"]), _class2.styles = _mds_data_table_text_input_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsDataTableTextInput;
        },
        "./src/abstract-data-table/data-table-input/mds-data-table-text-input.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/abstract-data-table/data-table-input/mds-data-table-text-input.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/abstract-data-table/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "abstractColumnConfigEntity", (function() {
                return abstractColumnConfigEntity;
            }));
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-data-table/AbstractMdsDataTable.jsx");
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/data-utils.js");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class;
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var arrayOf = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].arrayOf, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].boolean, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].enumerables, satisfies = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].satisfies, string = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].stringRequired, number = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].number;
            var rowDataEntity = {
                value: string
            };
            var MultiLevelSortingMenuItemEntity = {
                label: string,
                selected: boolean,
                value: string
            };
            var multiLevelSortingGroupEntity = {
                lable: string,
                menuItems: arrayOf(satisfies(MultiLevelSortingMenuItemEntity)).withMinLength(2).withMaxLength(2)
            };
            var abstractColumnConfigEntity = {
                headerValue: string,
                width: string,
                sortable: boolean,
                initialSortState: enumerables(string, "ascending", "descending"),
                sortState: enumerables(string, "ascending", "descending"),
                sortedAscendingAccessibleText: string,
                sortedDescendingAccessibleText: string,
                unsortedAccessibleText: string,
                date: boolean,
                multiLevelSorting: arrayOf(satisfies(multiLevelSortingGroupEntity)).withMinLength(2).withMaxLength(3)
            };
            var captionBottomMargin = Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_2__["cleanCssToPx"])("16px");
            var entity = {
                rowData: arrayOf(arrayOf(satisfies(rowDataEntity))).defaultsTo([ [ {
                    value: undefined
                }, {
                    value: undefined
                } ] ]).withChangedCallback(),
                nullStateMessage: string.defaultsTo("Data temporarily unavailable."),
                accessibleSingleValueEmpty: string.defaultsTo("blank").withChangedCallback(),
                accessibleSingleValueNegative: string.defaultsTo("negative").withChangedCallback(),
                caption: stringRequired,
                hasVisibleCaption: boolean.defaultsTo("true"),
                mode: enumerables(string, "compact", "relaxed").defaultsTo("relaxed"),
                activated: boolean.defaultsTo("true"),
                summary: string,
                footer: arrayOf(satisfies(rowDataEntity)),
                columnConfigs: arrayOf(satisfies(abstractColumnConfigEntity)).withChangedCallback(),
                stacked: boolean.defaultsTo(false).withChangedCallback(),
                stackedHeaderWidth: string,
                stackedColumnWidth: string,
                stackedCaptionHeadingLevel: number.defaultsTo(2)
            };
            var AbstractDataTable = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = function(_AgaveComponent) {
                _inherits(AbstractDataTable, _AgaveComponent);
                _createClass(AbstractDataTable, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "AbstractDataTable";
                    }
                } ]);
                function AbstractDataTable() {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, AbstractDataTable);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(AbstractDataTable).call(this));
                    _this.rootClass = "abstract-data-table";
                    _this._hasColumnHeaderValues = _this._hasColumnHeaderValues.bind(_assertThisInitialized(_this));
                    _this._hasRowDataValues = _this._hasRowDataValues.bind(_assertThisInitialized(_this));
                    _this.rowDataCleaned = [];
                    _this._prepareData = _this._prepareData.bind(_assertThisInitialized(_this));
                    _this.highlightRow = _this.highlightRow.bind(_assertThisInitialized(_this));
                    _this.highlightRowOff = _this.highlightRowOff.bind(_assertThisInitialized(_this));
                    _this._handleClick = _this._handleClick.bind(_assertThisInitialized(_this));
                    _this.renderEmptyTables = _this.renderEmptyTables.bind(_assertThisInitialized(_this));
                    _this._throttledResizeListener = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["throttle"])(_this._handleJSSpacing.bind(_assertThisInitialized(_this)), 50, true);
                    _this._setAriaLiveText = _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["setAriaLiveText"].bind(_assertThisInitialized(_this));
                    _this._dispatchSortEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "sort";
                    }.bind(this), null, true);
                    _this._dispatchColumnSortEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "columnSort";
                    }.bind(this), null, true);
                    _this.defineObservedProperty("sortMap");
                    _this.defineObservedProperty("_ariaLiveActive");
                    _this.defineObservedProperty("_sortingGroupMenuExpanded", false);
                    _this.defineObservedProperty("_currentSelectedSortingMenuItem");
                    return _this;
                }
                _createClass(AbstractDataTable, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        var _get2, _this3 = this;
                        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                            args[_key] = arguments[_key];
                        }
                        _get(_getPrototypeOf(AbstractDataTable.prototype), "connectedCallback", this) && (_get2 = _get(_getPrototypeOf(AbstractDataTable.prototype), "connectedCallback", this)).call.apply(_get2, [ this ].concat(args));
                        this.stacked && this.columnConfigs && this.columnConfigs.filter(function(e) {
                            _newArrowCheck(this, _this3);
                            return e.columnType === "select";
                        }.bind(this)).length > 0 && this.setSelectPositions();
                        MDS.isSafari && window.addEventListener("resize", this._throttledResizeListener);
                    }
                }, {
                    key: "disconnectedCallback",
                    value: function disconnectedCallback() {
                        var _get3;
                        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                            args[_key2] = arguments[_key2];
                        }
                        _get(_getPrototypeOf(AbstractDataTable.prototype), "disconnectedCallback", this) && (_get3 = _get(_getPrototypeOf(AbstractDataTable.prototype), "disconnectedCallback", this)).call.apply(_get3, [ this ].concat(args));
                        MDS.isSafari && window.removeEventListener("resize", this._throttledResizeListener);
                    }
                }, {
                    key: "setSelectPositions",
                    value: function setSelectPositions() {
                        var _this4 = this;
                        setTimeout(function() {
                            var _this5 = this;
                            _newArrowCheck(this, _this4);
                            this.shadowRoot.querySelectorAll(".".concat(this.rootClass, "__row--select")).forEach(function(row) {
                                _newArrowCheck(this, _this5);
                                var rowWidth = row.getBoundingClientRect().width;
                                var header = row.firstElementChild;
                                var select = row.lastElementChild;
                                var headerTextRectWidth = header.firstElementChild.getBoundingClientRect().width;
                                var selectPadding = Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_2__["cleanCssValue"])("8px");
                                select.style.width = "".concat(rowWidth - headerTextRectWidth - selectPadding, "px");
                                select.style.left = "".concat(headerTextRectWidth + selectPadding, "px");
                                header.style.height = "".concat(select.getBoundingClientRect().height, "px");
                            }.bind(this));
                        }.bind(this));
                    }
                }, {
                    key: "accessibleSingleValueEmptyChangedCallback",
                    value: function accessibleSingleValueEmptyChangedCallback(accessibleSingleValueEmpty) {
                        var _this6 = this;
                        this._columnObjects && this._columnObjects.forEach(function(colObject) {
                            _newArrowCheck(this, _this6);
                            colObject.config.accessibleSingleValueEmpty = accessibleSingleValueEmpty;
                        }.bind(this));
                    }
                }, {
                    key: "accessibleSingleValueNegativeChangedCallback",
                    value: function accessibleSingleValueNegativeChangedCallback(accessibleSingleValueNegative) {
                        var _this7 = this;
                        this._columnObjects && this._columnObjects.forEach(function(colObject) {
                            _newArrowCheck(this, _this7);
                            colObject.config.accessibleSingleValueNegative = accessibleSingleValueNegative;
                        }.bind(this));
                    }
                }, {
                    key: "stackedChangedCallback",
                    value: function stackedChangedCallback(isStacked) {
                        var _this8 = this;
                        this._columnObjects && this._columnObjects.forEach(function(colObject) {
                            _newArrowCheck(this, _this8);
                            colObject.config.stacked = isStacked;
                        }.bind(this));
                    }
                }, {
                    key: "columnConfigsChangedCallback",
                    value: function columnConfigsChangedCallback(columnConfigs) {
                        var _this9 = this;
                        var stacked = this.stacked, accessibleSingleValueEmpty = this.accessibleSingleValueEmpty, accessibleSingleValueNegative = this.accessibleSingleValueNegative, id = this.id, mode = this.mode;
                        this._columnObjects = columnConfigs && columnConfigs.map(function(originalConfig, colIndex) {
                            _newArrowCheck(this, _this9);
                            var config = _extends({}, originalConfig, {
                                colIndex: colIndex,
                                stacked: stacked,
                                accessibleSingleValueEmpty: accessibleSingleValueEmpty,
                                accessibleSingleValueNegative: accessibleSingleValueNegative,
                                tableId: id,
                                mode: mode,
                                tableInstance: this
                            });
                            if (originalConfig.sortable) {
                                if (originalConfig.initialSortState || originalConfig.sortState) {
                                    this._sortedColumn = colIndex;
                                    this._sortedDirection = originalConfig.initialSortState || originalConfig.sortState;
                                }
                                if (originalConfig.multiLevelSorting && originalConfig.multiLevelSorting.length) {
                                    _extends(config, {
                                        multiLevelSortingHeaderClickHandler: this._handleMultiLevelSortingHeaderClick.bind(this, colIndex),
                                        multiLevelSortingMenuItemClickHandler: this._handleMultiLevelSortingMenuItemClick.bind(this, colIndex),
                                        multiLevelSortingMenuBlurHandler: this._handleMultiLevelSortingMenuBlur.bind(this, colIndex),
                                        multiLevelSortingMenuKeyDownHandler: this._handleMultiLevelSortingMenuItemKeyDown.bind(this, colIndex),
                                        multiLevelSortingMenuKeyUpHandler: this._handleMultiLevelSortingMenuItemKeyUp.bind(this, colIndex),
                                        updateSortingMenuDisplayedState: this._updateSortingMenuDisplayedState.bind(this)
                                    });
                                }
                                _extends(config, {
                                    sortClickHandler: this._handleSorting.bind(this, colIndex)
                                });
                            }
                            if (originalConfig.columnType === "checkbox") {
                                _extends(config, {
                                    getNumberOfSelectedCheckboxes: this.getNumberOfSelectedCheckboxes.bind(this)
                                });
                            }
                            return new this._columnTypeConstructorMap[config.columnType](this.rootClass, config);
                        }.bind(this));
                        this._columnObjects.forEach(function(col) {
                            _newArrowCheck(this, _this9);
                            return this._validateColumn(col, columnConfigs);
                        }.bind(this));
                        this._lastRowHeader = "";
                    }
                }, {
                    key: "_validateColumn",
                    value: function _validateColumn(col, columnConfigs) {
                        return col.validateColumn(columnConfigs);
                    }
                }, {
                    key: "_hasCheckboxAndHeaders",
                    value: function _hasCheckboxAndHeaders() {
                        return this._hasColumnHeaderValues() && this.columnConfigs && this.columnConfigs[0] && this.columnConfigs[0].columnType === "checkbox";
                    }
                }, {
                    key: "_handleSorting",
                    value: function _handleSorting(columnIndex, event) {
                        var newDirection = event.target.dataset.direction === "ascending" ? "descending" : "ascending";
                        if (event) {
                            this._dispatchSortEvent(event, {
                                columnIndex: columnIndex,
                                newDirection: newDirection
                            });
                            var columnSortDispatched = this._dispatchColumnSortEvent(event, {
                                columnIndex: columnIndex,
                                newDirection: newDirection
                            });
                            if (columnSortDispatched) {
                                this.sortTable(columnIndex, newDirection);
                            }
                        }
                    }
                }, {
                    key: "sortTable",
                    value: function sortTable() {
                        var _this10 = this;
                        var colIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
                        var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ascending";
                        this._sortedColumn = colIndex;
                        this._sortedDirection = direction;
                        if (!this._columnObjects || colIndex === -1) {
                            this.sortMap = this.rowData.map(function(row, index, rows) {
                                _newArrowCheck(this, _this10);
                                return direction === "ascending" ? index : rows.length - index - 1;
                            }.bind(this));
                        } else {
                            this.sortMap = this._columnObjects[colIndex].createSortMap(this.rowData, direction);
                            this._liveTextType = "sort";
                            this._setAriaLiveText();
                        }
                    }
                }, {
                    key: "_handleMultiLevelSortingHeaderClick",
                    value: function _handleMultiLevelSortingHeaderClick(columnIndex, event) {
                        this._callMultiLevelSortingHandlers(columnIndex, event, "handleMultiLevelSortingHeaderClick");
                    }
                }, {
                    key: "_handleMultiLevelSortingMenuItemClick",
                    value: function _handleMultiLevelSortingMenuItemClick(columnIndex, event) {
                        this._callMultiLevelSortingHandlers(columnIndex, event, "handleMultiLevelSortingMenuItemClick");
                    }
                }, {
                    key: "_handleMultiLevelSortingMenuItemKeyDown",
                    value: function _handleMultiLevelSortingMenuItemKeyDown(columnIndex, event) {
                        this._callMultiLevelSortingHandlers(columnIndex, event, "handleMultiLevelSortingMenuItemKeyDown");
                    }
                }, {
                    key: "_handleMultiLevelSortingMenuItemKeyUp",
                    value: function _handleMultiLevelSortingMenuItemKeyUp(columnIndex, event) {
                        this._callMultiLevelSortingHandlers(columnIndex, event, "handleMultiLevelSortingMenuItemKeyUp");
                    }
                }, {
                    key: "_handleMultiLevelSortingMenuBlur",
                    value: function _handleMultiLevelSortingMenuBlur(columnIndex, event) {
                        this._callMultiLevelSortingHandlers(columnIndex, event, "_handleSortingGroupMenuBlur");
                    }
                }, {
                    key: "_updateSortingMenuDisplayedState",
                    value: function _updateSortingMenuDisplayedState(displayed) {
                        this._sortingGroupMenuExpanded = displayed;
                    }
                }, {
                    key: "_callMultiLevelSortingHandlers",
                    value: function _callMultiLevelSortingHandlers(columnIndex, event, handlerName) {
                        var columnObject = this._columnObjects[columnIndex];
                        columnObject && columnObject[handlerName] && columnObject[handlerName].call(this, event, columnIndex);
                    }
                }, {
                    key: "_hasRowDataValues",
                    value: function _hasRowDataValues() {
                        var _this11 = this;
                        var hasRowData = false;
                        if (this.rowData) {
                            if (this.rowData.length > 0 && this.rowData.some(function(arr) {
                                var _this12 = this;
                                _newArrowCheck(this, _this11);
                                return arr.find(function(obj) {
                                    _newArrowCheck(this, _this12);
                                    return obj.value;
                                }.bind(this));
                            }.bind(this))) {
                                hasRowData = true;
                            }
                        }
                        return hasRowData;
                    }
                }, {
                    key: "_hasColumnHeaderValues",
                    value: function _hasColumnHeaderValues() {
                        var _this13 = this;
                        return !!(this.columnConfigs && this.columnConfigs.find(function(obj) {
                            _newArrowCheck(this, _this13);
                            return obj.headerValue && obj.columnType !== "checkbox";
                        }.bind(this)));
                    }
                }, {
                    key: "_hasRowHeaderValues",
                    value: function _hasRowHeaderValues() {
                        var hasCheckboxes = this.columnConfigs && this.columnConfigs[0].columnType === "checkbox";
                        return this.columnConfigs && !!this.columnConfigs[hasCheckboxes ? 1 : 0].columnType.match(/(h|H)eader/);
                    }
                }, {
                    key: "_hasRepeatRowHeaderValues",
                    value: function _hasRepeatRowHeaderValues() {
                        var hasCheckboxes = this.columnConfigs && this.columnConfigs[0].columnType === "checkbox";
                        return this.columnConfigs && !!this.columnConfigs[hasCheckboxes ? 1 : 0].columnType.match(/repeat/);
                    }
                }, {
                    key: "rowDataChangedCallback",
                    value: function rowDataChangedCallback() {
                        if (this._hasRowDataValues()) {
                            this.sortMap && this.sortTable(this._sortedColumn, this._sortedDirection);
                        }
                    }
                }, {
                    key: "visualHighlightRow",
                    value: function visualHighlightRow(rowIndex) {
                        var highlightedRow = this.shadowRoot.querySelectorAll(".".concat(this.rootClass, "__row:nth-child(").concat(rowIndex, ")"))[0];
                        highlightedRow && highlightedRow.classList.add("".concat(this.rootClass, "__row--highlight"));
                        return highlightedRow && highlightedRow.id;
                    }
                }, {
                    key: "visualHighlightRowOff",
                    value: function visualHighlightRowOff(rowIndex) {
                        var highlightedRow = this.shadowRoot.querySelectorAll(".".concat(this.rootClass, "__row:nth-child(").concat(rowIndex, ")"))[0];
                        highlightedRow && highlightedRow.classList.remove("".concat(this.rootClass, "__row--highlight"));
                        return highlightedRow && highlightedRow.id;
                    }
                }, {
                    key: "highlightRow",
                    value: function highlightRow(event) {
                        var _this14 = this;
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this14);
                            return "mouseenter-row".concat(event.target.dataset.index);
                        }.bind(this), this)(event);
                    }
                }, {
                    key: "highlightRowOff",
                    value: function highlightRowOff(event) {
                        var _this15 = this;
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this15);
                            return "mouseleave-row".concat(event.target.dataset.index);
                        }.bind(this), this)(event);
                    }
                }, {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        var colIndex = payload.colIndex, col = payload.col, row = payload.row, rowIndex = payload.rowIndex, type = payload.type;
                        var updatedPayload = _extends({
                            col: +(colIndex || 1) - 1,
                            row: +(rowIndex || 1) - 1,
                            colIndex: +(col || 0) + 1,
                            rowIndex: +(row || 0) + 1
                        }, payload);
                        if (type === "sort") {
                            return {
                                interactiveElement: this.shadowRoot.getElementById("sort-button-".concat(updatedPayload.col))
                            };
                        }
                        return this._columnObjects[updatedPayload.col].getInteractiveElement(this, updatedPayload);
                    }
                }, {
                    key: "_handleClick",
                    value: function _handleClick(event) {
                        var _this16 = this;
                        event.stopPropagation();
                        if (event.target.dataset.type) {
                            Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                                _newArrowCheck(this, _this16);
                                return "click-".concat(event.target.dataset.type);
                            }.bind(this), this)(event);
                            var detail = event.target.value ? {
                                value: event.target.value,
                                original: event.detail
                            } : event.detail;
                            Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                                _newArrowCheck(this, _this16);
                                return "click";
                            }.bind(this), this)(event, _extends({}, detail, {
                                type: event.target.dataset.type,
                                columnIndex: event.target.dataset.column,
                                rowIndex: event.target.dataset.row,
                                column: +event.target.dataset.column - 1,
                                row: +event.target.dataset.row - 1
                            }));
                        }
                    }
                }, {
                    key: "_prepareData",
                    value: function _prepareData() {
                        var _this17 = this;
                        this.rowDataCleaned = [];
                        this.maxNumberColumns = 0;
                        if (this.rowData.length === 0) {
                            return;
                        }
                        this.rowData.forEach(function(row) {
                            _newArrowCheck(this, _this17);
                            this.maxNumberColumns = row.length > this.maxNumberColumns ? row.length : this.maxNumberColumns;
                        }.bind(this));
                        this.rowData.forEach(function(row, rowIndex) {
                            _newArrowCheck(this, _this17);
                            this.rowDataCleaned[rowIndex] = new Array(this.maxNumberColumns).fill("");
                        }.bind(this));
                        this.rowData.forEach(function(row, rowIndex) {
                            var _this18 = this;
                            _newArrowCheck(this, _this17);
                            row.forEach(function(val, colIndex) {
                                _newArrowCheck(this, _this18);
                                this.rowDataCleaned[rowIndex][colIndex] = val;
                            }.bind(this));
                        }.bind(this));
                    }
                }, {
                    key: "renderEmptyTables",
                    value: function renderEmptyTables() {
                        if (this._hasColumnHeaderValues()) {
                            return _AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_1__["_emptyWithHeadersTemplate"].call(this);
                        }
                        return _AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_1__["_emptyWithoutHeadersTemplate"].call(this);
                    }
                }, {
                    key: "_setCaptionSpacingSafari",
                    value: function _setCaptionSpacingSafari() {
                        var table = this.shadowRoot.querySelector("table");
                        var caption = this.shadowRoot.getElementById("caption");
                        var captionOffsetHeight = caption && caption.offsetHeight;
                        var isNewHeight = this.stashedCaptionHeight !== captionOffsetHeight;
                        if (isNewHeight && !!caption && !!table) {
                            this.stashedCaptionHeight = captionOffsetHeight;
                            table.style.paddingTop = "".concat(this.stashedCaptionHeight + captionBottomMargin, "px");
                        }
                    }
                }, {
                    key: "_handleJSSpacing",
                    value: function _handleJSSpacing() {
                        MDS.isSafari && !MDS.isIOS && this.hasVisibleCaption && this.layout !== "rowInline" && this._setCaptionSpacingSafari();
                    }
                }, {
                    key: "renderedCallback",
                    value: function renderedCallback() {
                        var _get4;
                        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                            args[_key3] = arguments[_key3];
                        }
                        _get(_getPrototypeOf(AbstractDataTable.prototype), "renderedCallback", this) && (_get4 = _get(_getPrototypeOf(AbstractDataTable.prototype), "renderedCallback", this)).call.apply(_get4, [ this ].concat(args));
                        this._handleJSSpacing();
                    }
                }, {
                    key: "render",
                    value: function render() {
                        return this.renderEmptyTables();
                    }
                } ]);
                return AbstractDataTable;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_0___default.a)) || _class);
            __webpack_exports__["default"] = AbstractDataTable;
        },
        "./src/abstract-modal/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].boolean;
            var entity = {
                open: boolean.defaultsTo(false).withChangedCallback()
            };
            var AbstractModal = function(_AgaveComponent) {
                _inherits(AbstractModal, _AgaveComponent);
                function AbstractModal(slotNames, customTag) {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, AbstractModal);
                    var renderTarget = document.createElement("mds-".concat(customTag, "-modal"));
                    renderTarget.setAttribute("data-is-mds-modal-render-target", true);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(AbstractModal).call(this, {
                        renderTarget: renderTarget,
                        hasCustomRenderTarget: true
                    }));
                    _this.processShiftTab = function(event) {
                        _newArrowCheck(this, _this2);
                        var modalChildren = _this._renderTarget.shadowRoot;
                        var isTabPressed = event.key === "Tab" || event.keyCode === 9;
                        if (!isTabPressed) {
                            return;
                        }
                        if (event.shiftKey) {
                            if (_this._renderTarget.shadowRoot.activeElement === _this._firstFocusableChild(modalChildren)) {
                                _this._lastFocusableChild(modalChildren) ? _this._lastFocusableChild(modalChildren) && _this._lastFocusableChild(modalChildren).focus() : modalChildren.querySelector("[class$='__main-content_wrapper']").focus();
                                event.preventDefault();
                            }
                        }
                    }.bind(this);
                    _this._validateCachedStylesFromStorage = function() {
                        var storage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sessionStorage;
                        var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "mds-cachedBodyOverflowStyle";
                        var nullChecker = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                        _newArrowCheck(this, _this2);
                        return nullChecker ? Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["objPropAccessor"])(storage, "getItem", style) === null : Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["objPropAccessor"])(storage, "getItem", style);
                    }.bind(this);
                    var templateShadow = _this.attachShadow({
                        mode: "open"
                    });
                    _this.addSlotsToShadow(templateShadow, slotNames);
                    _this.handleWindowFocusToTrapTab = _this.handleWindowFocusToTrapTab.bind(_assertThisInitialized(_this));
                    _this.trapModal = _this.trapModal.bind(_assertThisInitialized(_this));
                    _this.removeTrap = _this.removeTrap.bind(_assertThisInitialized(_this));
                    _this.isModalTrapped = _this.isModalTrapped.bind(_assertThisInitialized(_this));
                    _this._getModalWithTrap = _this._getModalWithTrap.bind(_assertThisInitialized(_this));
                    _this._elementsThatCanReceiveFocus = 'button:not([disabled]), mds-button, mds-checkbox, mds-chat-input, [href], mds-link, input:not([disabled]):not([type="hidden"]), mds-combo-button, mds-list, mds-drop-zone, mds-text-input, select:not([disabled]), mds-select, mds-multiselect, mds-sticky-footer, mds-switch, mds-accordion, mds-accordion-item, mds-accordion-tile, mds-tile-accordion-item, mds-vertical-navigation-item, mds-list-item, mds-radio-group, mds-chat-input, textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
                    _this._elementsThatAreModals = "mds-dialog-modal, mds-slide-in-panel-modal, mds-bottom-sheet-modal, mds-bottom-sheet-dialog-modal";
                    return _this;
                }
                _createClass(AbstractModal, [ {
                    key: "_focusOnRender",
                    value: function _focusOnRender() {
                        throw new Error("child component must define a focusOnRender method");
                    }
                }, {
                    key: "_focusOnTab",
                    value: function _focusOnTab() {
                        throw new Error("child component must define a _focusOnTab method");
                    }
                }, {
                    key: "addSlotsToShadow",
                    value: function addSlotsToShadow(shadowRoot, slotNames) {
                        var _this3 = this;
                        var template = document.createElement("template");
                        this.slots = slotNames.reduce(function(slots, slotName) {
                            _newArrowCheck(this, _this3);
                            var el = document.createElement("slot");
                            el.setAttribute("name", slotName);
                            template.appendChild(el);
                            slots[slotName] = el;
                            return slots;
                        }.bind(this), {});
                        shadowRoot.appendChild(template);
                    }
                }, {
                    key: "openChangedCallback",
                    value: function openChangedCallback() {
                        this._connected && (this.open ? this._attachModal() : this._detachModal());
                    }
                }, {
                    key: "_attachModal",
                    value: function _attachModal() {
                        document.body.style.overflow = "hidden";
                        this.ariaHideBody();
                        this.transferSlotsToRenderTarget();
                        this._trapFocus(true);
                        document.body.insertBefore(this._renderTarget, document.body.children[0]);
                        this._focusOnRender();
                        this.dispatchEvent(new CustomEvent("open", {
                            bubbles: true,
                            composed: true
                        }));
                        this.trapModal();
                    }
                }, {
                    key: "_isNodeInModal",
                    value: function _isNodeInModal(node) {
                        var slots = this._renderTarget.shadowRoot.querySelectorAll("slot");
                        for (var i = 0; i < slots.length; i++) {
                            if (node === this._renderTarget || slots && slots[i].assignedNodes().length && slots[i].assignedNodes()[0].contains(node)) {
                                return true;
                            }
                        }
                        var childNodes = Array.from(this._renderTarget.shadowRoot.childNodes);
                        for (var _i = 0; _i < childNodes.length; _i++) {
                            if (childNodes[_i].contains(node)) {
                                return true;
                            }
                        }
                        return false;
                    }
                }, {
                    key: "ariaHideBody",
                    value: function ariaHideBody() {
                        var _this4 = this;
                        var domChildren = Array.from(document.body.children);
                        this.hiddenNodes = domChildren.reduce(function(hiddenNodes, node) {
                            _newArrowCheck(this, _this4);
                            if (!node.getAttribute("aria-hidden")) {
                                hiddenNodes.push(node);
                                node.setAttribute("aria-hidden", true);
                            }
                            return hiddenNodes;
                        }.bind(this), []);
                    }
                }, {
                    key: "transferSlotsToRenderTarget",
                    value: function transferSlotsToRenderTarget() {
                        var _this5 = this;
                        this.transferredNodes = this.transferredNodes || [];
                        Object.keys(this.slots).forEach(function(key) {
                            _newArrowCheck(this, _this5);
                            var slottedNode = this.slots[key].assignedNodes()[0];
                            if (slottedNode) {
                                this.transferredNodes.push(slottedNode);
                                this._renderTarget.appendChild(slottedNode);
                            }
                        }.bind(this));
                    }
                }, {
                    key: "_detachModal",
                    value: function _detachModal() {
                        this.transferSlotsBackToModalElement();
                        this.unAriaHideBody();
                        this._renderTarget && this._renderTarget.remove();
                        document.body.style.overflow = MDS.isFigma ? "" : this._validateCachedStylesFromStorage(sessionStorage, "mds-cachedBodyOverflowStyle");
                        this._trapFocus(false);
                        var trigger = document.getElementById(this.triggerId) || this.triggerRef;
                        trigger && trigger.focus();
                        this.dispatchEvent(new CustomEvent("close", {
                            bubbles: true,
                            composed: true
                        }));
                        this.dispatchEvent(new CustomEvent("dismiss", {
                            bubbles: true,
                            composed: true
                        }));
                        this.removeTrap();
                    }
                }, {
                    key: "unAriaHideBody",
                    value: function unAriaHideBody() {
                        var _this6 = this;
                        this.hiddenNodes && this.hiddenNodes.forEach(function(node) {
                            _newArrowCheck(this, _this6);
                            node.removeAttribute("aria-hidden");
                        }.bind(this));
                        this.hiddenNodes = false;
                    }
                }, {
                    key: "_trapFocus",
                    value: function _trapFocus(trap) {
                        if (trap && !this.boundDisableScroll) {
                            this._addScrollAndFocusListeners();
                        } else if (!trap || !this.open) {
                            this._removeScrollAndFocusListeners();
                        }
                    }
                }, {
                    key: "_addScrollAndFocusListeners",
                    value: function _addScrollAndFocusListeners() {
                        this.boundDisableScroll = this.disableScroll.bind(this, document.documentElement.scrollLeft, document.documentElement.scrollTop);
                        document.body.addEventListener("focus", this.handleWindowFocusToTrapTab, true);
                        window.addEventListener("scroll", this.boundDisableScroll);
                    }
                }, {
                    key: "_removeScrollAndFocusListeners",
                    value: function _removeScrollAndFocusListeners() {
                        document.body.removeEventListener("focus", this.handleWindowFocusToTrapTab, true);
                        if (this.boundDisableScroll) {
                            window.removeEventListener("scroll", this.boundDisableScroll);
                            this.boundDisableScroll = false;
                        }
                    }
                }, {
                    key: "disableScroll",
                    value: function disableScroll(scrollX, scrollY, event) {
                        window.scrollTo(scrollX, scrollY);
                        event.stopPropagation();
                    }
                }, {
                    key: "_getFocusableChildren",
                    value: function _getFocusableChildren(element) {
                        var focusableChildren = element.querySelectorAll(this._elementsThatCanReceiveFocus);
                        return focusableChildren;
                    }
                }, {
                    key: "_getFocusableChildrenInShadowRoot",
                    value: function _getFocusableChildrenInShadowRoot(element) {
                        var focusableChildren = element.shadowRoot.querySelectorAll(this._elementsThatCanReceiveFocus);
                        return focusableChildren.length ? focusableChildren[focusableChildren.length - 1] : false;
                    }
                }, {
                    key: "_firstFocusableChild",
                    value: function _firstFocusableChild(element) {
                        var firstFocusableChild = false;
                        if ((!this.backIcon || this._isExitConfirmationVisible) && this._isHeadingFocused(document.activeElement)) {
                            firstFocusableChild = document.activeElement.shadowRoot.activeElement;
                        } else {
                            var focusableChildrenList = this._getFocusableChildren(element);
                            firstFocusableChild = focusableChildrenList[0];
                        }
                        return firstFocusableChild;
                    }
                }, {
                    key: "_isHeadingFocused",
                    value: function _isHeadingFocused(activeElement) {
                        var activeElementInShadowRoot = activeElement.shadowRoot && activeElement.shadowRoot.activeElement;
                        var isHeadingFocused = false;
                        if (this._isExitConfirmationVisible) {
                            isHeadingFocused = this._isExitConfirmationHeadingFocused(activeElementInShadowRoot);
                        } else {
                            isHeadingFocused = this._isMainPanelHeadingFocused(activeElementInShadowRoot);
                        }
                        return isHeadingFocused;
                    }
                }, {
                    key: "_isExitConfirmationHeadingFocused",
                    value: function _isExitConfirmationHeadingFocused(activeElementInShadowRoot) {
                        return !!(activeElementInShadowRoot.id === "confirmation-alert" && activeElementInShadowRoot.tabIndex === -1);
                    }
                }, {
                    key: "_isMainPanelHeadingFocused",
                    value: function _isMainPanelHeadingFocused(activeElementInShadowRoot) {
                        return activeElementInShadowRoot && activeElementInShadowRoot.role === "heading" && activeElementInShadowRoot.tabIndex === -1;
                    }
                }, {
                    key: "_isElementAccordion",
                    value: function _isElementAccordion(element) {
                        return element && element.nodeName === "MDS-ACCORDION";
                    }
                }, {
                    key: "_hasFocusableLastChildAccordion",
                    value: function _hasFocusableLastChildAccordion(lastChild) {
                        var focusableItems = this._elementsThatCanReceiveFocus.split(", ");
                        return lastChild && focusableItems.includes(lastChild.nodeName.toLowerCase());
                    }
                }, {
                    key: "_lastFocusableChildInAccordion",
                    value: function _lastFocusableChildInAccordion(element) {
                        var accordion = this._renderTarget.querySelector("mds-accordion");
                        var lastChild = accordion && accordion.lastElementChild;
                        var accordionItems = element.shadowRoot.querySelectorAll("mds-accordion-item");
                        var lastAccordionItem = accordionItems[accordionItems.length - 1];
                        return lastAccordionItem.expanded && this._hasFocusableLastChildAccordion(lastChild) ? lastChild : lastAccordionItem;
                    }
                }, {
                    key: "_lastFocusableChild",
                    value: function _lastFocusableChild(element) {
                        var focusableChildren = this._getFocusableChildren(element);
                        var focusableChildrenLength = focusableChildren && focusableChildren.length;
                        var lastFocusableChild = focusableChildren && focusableChildren[focusableChildrenLength - 1];
                        if (this._isElementAccordion(element)) {
                            return this._lastFocusableChildInAccordion(element);
                        }
                        if (lastFocusableChild && lastFocusableChild.querySelector("slot")) {
                            return this._lastFocusableChild(this._renderTarget.querySelector("[slot$=Content]"));
                        }
                        if (lastFocusableChild && lastFocusableChild.shadowRoot) {
                            return this._lastFocusableChild(lastFocusableChild.shadowRoot);
                        }
                        if (!lastFocusableChild && element.shadowRoot) {
                            return this._lastFocusableChild(this._getFocusableChildrenInShadowRoot(element));
                        }
                        if (!lastFocusableChild && element.focus) {
                            return element;
                        }
                        return lastFocusableChild;
                    }
                }, {
                    key: "handleWindowFocusToTrapTab",
                    value: function handleWindowFocusToTrapTab(event) {
                        var _this7 = this;
                        if (this.isModalTrapped()) {
                            if (this._isNodeInModal(event.target)) {
                                event.target.addEventListener("keydown", function(event) {
                                    _newArrowCheck(this, _this7);
                                    this.processShiftTab(event);
                                }.bind(this));
                            } else {
                                this._focusOnTab();
                            }
                        }
                    }
                }, {
                    key: "transferSlotsBackToModalElement",
                    value: function transferSlotsBackToModalElement() {
                        var _this8 = this;
                        this.transferredNodes && this.transferredNodes.forEach(function(node) {
                            _newArrowCheck(this, _this8);
                            this.appendChild(node);
                        }.bind(this));
                        this.transferredNodes = [];
                    }
                }, {
                    key: "repropagateEvent",
                    value: function repropagateEvent(event) {
                        var customEvent = new CustomEvent(event.type, {
                            detail: {
                                original: event.detail.original,
                                target: event.detail.target
                            },
                            bubbles: true,
                            composed: true
                        });
                        event.stopPropagation();
                        this.dispatchEvent(customEvent);
                    }
                }, {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(AbstractModal.prototype), "connectedCallback", this).call(this);
                        this._connected = true;
                        var doesNotHaveCachedBodyOverflowStyle = MDS.isFigma ? false : this._validateCachedStylesFromStorage(sessionStorage, "mds-cachedBodyOverflowStyle", true);
                        if (doesNotHaveCachedBodyOverflowStyle) Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["objPropAccessor"])(sessionStorage, "setItem", "mds-cachedBodyOverflowStyle", document.body.style.overflow);
                        if (this.open) {
                            this._attachModal();
                        }
                    }
                }, {
                    key: "trapModal",
                    value: function trapModal() {
                        this.previouslyTrappedModal = this._getModalWithTrap();
                        this.modalTrapped = true;
                        this._renderTarget.trapModal = this.trapModal;
                        this._renderTarget.removeTrap = this.removeTrap;
                        this._renderTarget.isModalTrapped = this.isModalTrapped;
                        this._updateAllTrappedModals(this.previouslyTrappedModal);
                    }
                }, {
                    key: "removeTrap",
                    value: function removeTrap(ignorePreviouslyTrappedModal) {
                        this.modalTrapped = false;
                        if (!ignorePreviouslyTrappedModal && this.previouslyTrappedModal) {
                            this.previouslyTrappedModal.trapModal();
                        }
                    }
                }, {
                    key: "isModalTrapped",
                    value: function isModalTrapped() {
                        return this.modalTrapped;
                    }
                }, {
                    key: "_updateAllTrappedModals",
                    value: function _updateAllTrappedModals(previouslyTrappedModal) {
                        if (previouslyTrappedModal) {
                            previouslyTrappedModal.removeTrap();
                        }
                    }
                }, {
                    key: "_getModalWithTrap",
                    value: function _getModalWithTrap() {
                        var _this9 = this;
                        var modals = _toConsumableArray(document.querySelectorAll(this._elementsThatAreModals));
                        var trappedModal = false;
                        if (modals && modals.length) {
                            var previouslyTrappedModal = modals.filter(function(modal) {
                                _newArrowCheck(this, _this9);
                                return modal.isModalTrapped && modal.isModalTrapped();
                            }.bind(this));
                            if (previouslyTrappedModal.length) {
                                trappedModal = previouslyTrappedModal[0];
                            }
                        }
                        return trappedModal;
                    }
                } ]);
                return AbstractModal;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_0___default.a);
            __webpack_exports__["default"] = AbstractModal;
        },
        "./src/accordion/accordion-item/MdsAccordionItem.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _span$wrapper = function _span$wrapper(_this$leadingIcon, _conditionalAttribute, _conditionalAttribute2, _MDS$svgs$this$leadin) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "accordion-item__leading-visual accordion-item__leading-visual--icon");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("type", _this$leadingIcon);
                _spreadAttribute(_conditionalAttribute);
                _spreadAttribute(_conditionalAttribute2);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("innerHTML-prop", _MDS$svgs$this$leadin);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("role", "img");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            };
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function renderLeadingVisualElement() {
                if (this.leadingImage) {
                    var width = Number(this.leadingImageWidth) ? "".concat(this.leadingImageWidth, "px") : this.leadingImageWidth;
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("img");
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "accordion-item__leading-visual accordion-item__leading-visual--image");
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("src", this.leadingImage);
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("alt", this.accessibleTextLeadingImage || "");
                    _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                        style: {
                            width: width
                        }
                    }, !!width));
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("img");
                    return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("img");
                }
                return !!this.leadingIcon && _jsxWrapper(_span$wrapper, [ this.leadingIcon, Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    "aria-label": this.accessibleTextLeadingIcon
                }, this.accessibleTextLeadingIcon), Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])("aria-hidden", !this.accessibleTextLeadingIcon), MDS.svgs[this.leadingIcon] ]);
            }
            function MdsAccordionItemTemplate() {
                var _classes, _panelClasses;
                var accessibleTextAlertIcon = this.accessibleTextAlertIcon, alertTitle = this.alertTitle, alertVariant = this.alertVariant, name = this.name, variant = this.variant, secondaryTextAlignment = this.secondaryTextAlignment, label = this.label, secondaryText = this.secondaryText, expanded = this.expanded, size = this.size, inactive = this.inactive, _expanding = this._expanding, _collapsing = this._collapsing, _transitioned = this._transitioned, headingLevel = this.headingLevel;
                var classes = (_classes = {
                    "accordion-item": true
                }, _defineProperty(_classes, "accordion-item--".concat(variant), true), _defineProperty(_classes, "accordion-item--disabled", inactive), 
                _classes);
                var headingClasses = {
                    "accordion-item__heading": true,
                    "accordion-item__heading--expanded": expanded,
                    "accordion-item__heading--large": size === "18px",
                    "accordion-item__heading--vertically-centered": this.leadingImage || this.leadingIcon
                };
                var panelClasses = (_panelClasses = {
                    "accordion-item__panel": true
                }, _defineProperty(_panelClasses, "accordion-item__panel--".concat(variant), true), 
                _defineProperty(_panelClasses, "accordion-item__panel--expanded", expanded), _defineProperty(_panelClasses, "accordion-item__panel--expanding", _expanding), 
                _defineProperty(_panelClasses, "accordion-item__panel--collapsing", _transitioned && _collapsing), 
                _defineProperty(_panelClasses, "accordion-item__panel--transitioned", _transitioned), 
                _panelClasses);
                var caretClasses = {
                    "accordion-item__heading-caret-icon": true,
                    "accordion-item__heading-caret-icon--expanded": expanded,
                    "accordion-item__heading-caret-icon--with-leading-visual": this.leadingImage || this.leadingIcon
                };
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "accordion-item__heading-container", "role", "heading", "aria-level", headingLevel);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("button", null, null, "class", headingClasses, "onclick", this._onclick, "onfocus", this._onfocus, "disabled-prop", inactive, "aria-controls", "panel-".concat(name), "aria-expanded", expanded, "aria-disabled", inactive);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", caretClasses, "aria-hidden", "true", "innerHTML-prop", MDS.svgs.ico_caret_right, "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                _renderArbitrary(renderLeadingVisualElement.call(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accordion-item__heading-content-container");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accordion-item__heading-labels accordion-item__heading-labels--".concat(secondaryTextAlignment));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accordion-item__heading-primary-label");
                _renderArbitrary(label);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                _renderArbitrary(secondaryText && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accordion-item__heading-secondary-label accordion-item__heading-secondary-label--".concat(secondaryTextAlignment)), 
                _renderArbitrary(secondaryText), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                _renderArbitrary(alertTitle && accessibleTextAlertIcon && size && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-alert", null, null, "class", "accordion-item__heading-alert", "accessible-text-icon", accessibleTextAlertIcon, "alert-title", alertTitle, "size", size === "18px" ? "small" : "mini", "shows-close-button", "false", "heading-level", "0", "variant", alertVariant, "focusable", "false"));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                _renderArbitrary(this.icon && this.variant !== "borderless" && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("span"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "accordion-item__heading-icon"), 
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    "aria-label": this.iconAccessibleDescription
                }, this.iconAccessibleDescription)), _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])("aria-hidden", !this.iconAccessibleDescription)), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("style", {
                    fill: this.iconColor
                }), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("innerHTML-prop", MDS.svgs[this.icon]), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("__skip", "true"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("span"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", panelClasses, "id", "panel-".concat(name));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "accordion-item__panel-slot");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            __webpack_exports__["default"] = MdsAccordionItemTemplate;
        },
        "./src/accordion/accordion-item/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/data-utils.js");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/common-utils.js");
            var _MdsAccordionItem__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/accordion/accordion-item/MdsAccordionItem.jsx");
            var _mds_accordion_item_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/accordion/accordion-item/mds-accordion-item.scss");
            var _mds_accordion_item_scss__WEBPACK_IMPORTED_MODULE_4___default = __webpack_require__.n(_mds_accordion_item_scss__WEBPACK_IMPORTED_MODULE_4__);
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["mixins"].AttributeMarshallingMixin, boolean = _mixins$AttributeMars.boolean, string = _mixins$AttributeMars.string, stringRequired = _mixins$AttributeMars.stringRequired, number = _mixins$AttributeMars.number, enumerables = _mixins$AttributeMars.enumerables;
            var entity = {
                alertTitle: string,
                alertVariant: enumerables(string, "error", "soft", "success", "informational"),
                name: stringRequired,
                variant: string,
                size: string,
                label: stringRequired,
                secondaryText: string,
                secondaryTextAlignment: string,
                icon: string,
                iconColor: string,
                iconAccessibleDescription: string,
                expanded: boolean.defaultsTo(false).withChangedCallback(),
                inactive: boolean.defaultsTo(false),
                lock: boolean,
                headingLevel: number.defaultsTo(2),
                leadingImage: string,
                leadingImageWidth: string.or(number),
                leadingIcon: enumerables.apply(void 0, [ string ].concat(_toConsumableArray(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["ICON_TYPES"]))),
                accessibleTextAlertIcon: string,
                accessibleTextLeadingIcon: string,
                accessibleTextLeadingImage: string
            };
            var MdsAccordionItem = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsAccordionItem, _AgaveComponent);
                _createClass(MdsAccordionItem, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsAccordionItem";
                    }
                } ]);
                function MdsAccordionItem() {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsAccordionItem);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsAccordionItem).call(this));
                    _this._onclick = _this._onclick.bind(_assertThisInitialized(_this));
                    _this._onblur = _this._onblur.bind(_assertThisInitialized(_this));
                    _this._onfocus = _this._onfocus.bind(_assertThisInitialized(_this));
                    _this._onkeydown = _this._onkeydown.bind(_assertThisInitialized(_this));
                    _this._onmouseover = _this._onmouseover.bind(_assertThisInitialized(_this));
                    _this._handleAccordionState = _this._handleAccordionState.bind(_assertThisInitialized(_this));
                    _this._handleLockedGroup = _this._handleLockedGroup.bind(_assertThisInitialized(_this));
                    _this._expandAccordion = _this._expandAccordion.bind(_assertThisInitialized(_this));
                    _this._collapseAccordion = _this._collapseAccordion.bind(_assertThisInitialized(_this));
                    _this._calculatePanelHeight = _this._calculatePanelHeight.bind(_assertThisInitialized(_this));
                    _this.defineObservedProperty("_expanding", false);
                    _this.defineObservedProperty("_collapsing", false);
                    _this.defineObservedProperty("_transitioned", false);
                    _this._dispatchCollapseEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "click-collapse-".concat(_this.name);
                    }.bind(this), _assertThisInitialized(_this));
                    _this._dispatchGenericCollapseEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "click-collapse";
                    }.bind(this), _assertThisInitialized(_this));
                    _this._dispatchItemCollapseEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "item-collapse";
                    }.bind(this), _assertThisInitialized(_this));
                    _this._dispatchExpandEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "click-expand-".concat(_this.name);
                    }.bind(this), _assertThisInitialized(_this));
                    _this._dispatchGenericExpandEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "click-expand";
                    }.bind(this), _assertThisInitialized(_this));
                    _this._dispatchItemExpandEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "item-expand";
                    }.bind(this), _assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsAccordionItem, [ {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        return {
                            interactiveElement: this.shadowRoot.querySelector(".accordion-item__heading")
                        };
                    }
                }, {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        var _this3 = this;
                        _get(_getPrototypeOf(MdsAccordionItem.prototype), "connectedCallback", this).call(this);
                        this._handleAccordionState();
                        _toConsumableArray(this.parentElement.children).forEach(function(accordion, i) {
                            _newArrowCheck(this, _this3);
                            if (accordion.name === this.name) {
                                this._index = i;
                            }
                        }.bind(this));
                    }
                }, {
                    key: "expandedChangedCallback",
                    value: function expandedChangedCallback() {
                        this._handleAccordionState();
                    }
                }, {
                    key: "_handleLockedGroup",
                    value: function _handleLockedGroup() {
                        var _this4 = this;
                        _toConsumableArray(this.parentElement.children).forEach(function(accordion) {
                            _newArrowCheck(this, _this4);
                            if (accordion.name !== this.name) {
                                accordion.expanded = false;
                            }
                        }.bind(this));
                    }
                }, {
                    key: "_handleAccordionState",
                    value: function _handleAccordionState(event) {
                        this.expanded ? this._expandAccordion(event) : this._collapseAccordion(event);
                    }
                }, {
                    key: "_expandAccordion",
                    value: function _expandAccordion(event) {
                        var _this5 = this;
                        var panelHeight = this._calculatePanelHeight();
                        this.shadowRoot.querySelector(".accordion-item__panel").style.display = this.expanded ? "block" : "none";
                        this.shadowRoot.querySelector(".accordion-item__panel").style.height = 0;
                        window.setTimeout(function() {
                            _newArrowCheck(this, _this5);
                            this._expanding = true;
                            this.shadowRoot.querySelector(".accordion-item__panel").style.height = "".concat(panelHeight, "px");
                        }.bind(this), 10);
                        window.setTimeout(function() {
                            _newArrowCheck(this, _this5);
                            this._expanding = false;
                            this._transitioned = true;
                            this.shadowRoot.querySelector(".accordion-item__panel").style.height = "auto";
                            this.shadowRoot.querySelector(".accordion-item__panel").style.overflow = "unset";
                            if (event) {
                                var eventWithIndex = {
                                    expanded: this.expanded,
                                    index: this._index
                                };
                                if (event.type === "click") {
                                    this._dispatchExpandEvent(event);
                                }
                                this._dispatchGenericExpandEvent({
                                    target: this,
                                    detail: event
                                }, eventWithIndex);
                                this._dispatchItemExpandEvent({
                                    target: this,
                                    detail: event
                                }, eventWithIndex);
                            }
                        }.bind(this), 200);
                    }
                }, {
                    key: "_collapseAccordion",
                    value: function _collapseAccordion(event) {
                        var _this6 = this;
                        var panelHeight = this.shadowRoot.querySelector(".accordion-item__panel").scrollHeight;
                        this.shadowRoot.querySelector(".accordion-item__panel").style.height = "".concat(panelHeight, "px");
                        window.setTimeout(function() {
                            _newArrowCheck(this, _this6);
                            this._collapsing = true;
                            this.shadowRoot.querySelector(".accordion-item__panel").style.height = 0;
                        }.bind(this), 10);
                        window.setTimeout(function() {
                            _newArrowCheck(this, _this6);
                            this._collapsing = false;
                            this._transitioned = false;
                            this.shadowRoot.querySelector(".accordion-item__panel").style.height = "auto";
                            this.shadowRoot.querySelector(".accordion-item__panel").style.display = this.expanded ? "block" : "none";
                            this.shadowRoot.querySelector(".accordion-item__panel").style.overflow = "hidden";
                            if (event) {
                                var eventWithIndex = {
                                    expanded: this.expanded,
                                    index: this._index
                                };
                                if (event.type === "click") {
                                    this._dispatchCollapseEvent(event);
                                }
                                this._dispatchGenericCollapseEvent({
                                    target: this,
                                    detail: event
                                }, eventWithIndex);
                                this._dispatchItemCollapseEvent({
                                    target: this,
                                    detail: event
                                }, eventWithIndex);
                            }
                        }.bind(this), 200);
                    }
                }, {
                    key: "_calculatePanelHeight",
                    value: function _calculatePanelHeight() {
                        var panel = this.shadowRoot.querySelector(".accordion-item__panel");
                        var panelWidth = "".concat(this.shadowRoot.querySelector(".accordion-item__heading-container").scrollWidth, "px");
                        _extends(panel.style, {
                            visibility: "hidden",
                            display: "flex",
                            position: "absolute",
                            width: panelWidth
                        });
                        var height = panel.scrollHeight;
                        _extends(panel.style, {
                            visibility: "",
                            display: "",
                            position: "",
                            width: "auto"
                        });
                        return this.variant === "fullBorder" ? height - Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_1__["cleanCssValue"])("16px") : height;
                    }
                }, {
                    key: "_onclick",
                    value: function _onclick(event) {
                        var _this7 = this;
                        !this.inactive && (this.expanded = !this.expanded);
                        this._handleAccordionState(event);
                        event.stopPropagation();
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this7);
                            return "click";
                        }.bind(this), this)(event, _extends({}, event.detail, {
                            expanded: this.expanded,
                            index: this._index
                        }));
                        this.lock && this._handleLockedGroup();
                    }
                }, {
                    key: "render",
                    value: function render() {
                        _MdsAccordionItem__WEBPACK_IMPORTED_MODULE_3__["default"].call(this);
                    }
                }, {
                    key: "headingLevel",
                    set: function set(headingLevel) {
                        if (Number.isNaN(headingLevel) || headingLevel > 6 || headingLevel < 1) {
                            this._headingLevel = entity.headingLevel.defaultValue;
                            this.throwConstraintError("headingLevel should be between 1 and 6");
                            return;
                        }
                        this._headingLevel = headingLevel;
                    },
                    get: function get() {
                        return this._headingLevel;
                    }
                } ]);
                return MdsAccordionItem;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["AgaveComponent"]), _class2.styles = _mds_accordion_item_scss__WEBPACK_IMPORTED_MODULE_4___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsAccordionItem;
        },
        "./src/accordion/accordion-item/mds-accordion-item.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/accordion/accordion-item/mds-accordion-item.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/accordion/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _accordion_item__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/accordion/accordion-item/index.js");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _dec, _class;
            var _mdsAccordionItem$wrapper = function _mdsAccordionItem$wrapper(_headingLevel, _accordionItem, _variant, _size, _secondaryTextAlignme, _lock, _accordionItem$name) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("mds-accordion-item");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("heading-level", _headingLevel);
                _spreadAttribute(_accordionItem);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("variant", _variant);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("size", _size);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("secondary-text-alignment", _secondaryTextAlignme);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("lock", _lock);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("mds-accordion-item");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "name", _accordionItem$name);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-accordion-item");
            };
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["mixins"].AttributeMarshallingMixin, arrayOf = _mixins$AttributeMars.arrayOf, boolean = _mixins$AttributeMars.boolean, string = _mixins$AttributeMars.string, enumerables = _mixins$AttributeMars.enumerables, satisfies = _mixins$AttributeMars.satisfies, number = _mixins$AttributeMars.number;
            var entity = {
                accordionItems: arrayOf(satisfies(_accordion_item__WEBPACK_IMPORTED_MODULE_2__["entity"])),
                variant: enumerables(string, "borderless", "openBorder", "fullBorder").defaultsTo("borderless"),
                size: enumerables(string, "14px", "18px").defaultsTo("14px"),
                secondaryTextAlignment: enumerables(string, "left", "right", "below").defaultsTo("left"),
                lock: boolean.defaultsTo(false),
                headingLevel: number
            };
            var MdsAccordion = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = function(_AgaveComponent) {
                _inherits(MdsAccordion, _AgaveComponent);
                _createClass(MdsAccordion, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsAccordion";
                    }
                } ]);
                function MdsAccordion() {
                    var _this;
                    _classCallCheck(this, MdsAccordion);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsAccordion).call(this));
                    _this._onclick = _this._onclick.bind(_assertThisInitialized(_this));
                    _this._onblur = _this._onblur.bind(_assertThisInitialized(_this));
                    _this._onfocus = _this._onfocus.bind(_assertThisInitialized(_this));
                    _this._onkeydown = _this._onkeydown.bind(_assertThisInitialized(_this));
                    _this._onmouseover = _this._onmouseover.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsAccordion, [ {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                            index: 0
                        };
                        return {
                            interactiveElement: this.shadowRoot.querySelectorAll("mds-accordion-item")[payload.index]
                        };
                    }
                }, {
                    key: "toggle",
                    value: function toggle() {
                        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                        var accordionItems = this.shadowRoot.querySelectorAll("mds-accordion-item");
                        if (accordionItems[index]) {
                            var expanded = !!accordionItems[index].expanded;
                            accordionItems[index].expanded = !expanded;
                            var itemExpandEvent = new CustomEvent("item-expand");
                            accordionItems[index]._handleAccordionState(itemExpandEvent);
                            this.lock && accordionItems[index]._handleLockedGroup();
                        }
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var _this2 = this;
                        var accordionItems = this.accordionItems, variant = this.variant, size = this.size, secondaryTextAlignment = this.secondaryTextAlignment, lock = this.lock, headingLevel = this.headingLevel;
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "accordion");
                        _renderArbitrary(accordionItems.map(function(accordionItem) {
                            _newArrowCheck(this, _this2);
                            return _jsxWrapper(_mdsAccordionItem$wrapper, [ headingLevel, accordionItem, variant, size, secondaryTextAlignment, lock, accordionItem.name ]);
                        }.bind(this)));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return MdsAccordion;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["AgaveComponent"])) || _class);
            __webpack_exports__["default"] = MdsAccordion;
        },
        "./src/avatar-banner/images/avatar.png": function(module, exports, __webpack_require__) {
            module.exports = __webpack_require__.p + "assets/fonts/avatar.png";
        },
        "./src/avatar-banner/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_avatar_banner_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/avatar-banner/mds-avatar-banner.scss");
            var _mds_avatar_banner_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_avatar_banner_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _images_avatar_png__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/avatar-banner/images/avatar.png");
            var _images_avatar_png__WEBPACK_IMPORTED_MODULE_3___default = __webpack_require__.n(_images_avatar_png__WEBPACK_IMPORTED_MODULE_3__);
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string;
            var entity = {
                avatarIllustration: string,
                avatarTitle: string,
                subtitle: string
            };
            var MdsAvatarBanner = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsAvatarBanner, _AgaveComponent);
                function MdsAvatarBanner() {
                    _classCallCheck(this, MdsAvatarBanner);
                    return _possibleConstructorReturn(this, _getPrototypeOf(MdsAvatarBanner).apply(this, arguments));
                }
                _createClass(MdsAvatarBanner, [ {
                    key: "render",
                    value: function render() {
                        var avatarIllustration = this.avatarIllustration, subtitle = this.subtitle, avatarTitle = this.avatarTitle;
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "avatar-banner");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("img", null, null, "class", "avatar-banner__img", "src", avatarIllustration.trim().length > 0 ? avatarIllustration : _images_avatar_png__WEBPACK_IMPORTED_MODULE_3___default.a, "alt", "");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "avatar-banner__desc");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "avatar-banner__title");
                        _renderArbitrary(avatarTitle);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "avatar-banner__subtitle");
                        _renderArbitrary(subtitle);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ], [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsAvatarBanner";
                    }
                } ]);
                return MdsAvatarBanner;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_avatar_banner_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsAvatarBanner;
        },
        "./src/avatar-banner/mds-avatar-banner.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/avatar-banner/mds-avatar-banner.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/banner-for-employee-messaging/MdsBannerForEmployeeMessaging.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function MdsBannerForEmployeeMessagingTemplate() {
                var variant = this.variant, bannerTitle = this.bannerTitle, bannerMessage = this.bannerMessage, accessibleTextIcon = this.accessibleTextIcon, accessibleTextRegionName = this.accessibleTextRegionName, headingLevel = this.headingLevel, linkText = this.linkText, linkHref = this.linkHref, outline = this.outline, translateButtonText = this.translateButtonText;
                var bannerClasses = _defineProperty({
                    "banner-for-employee-messaging": true,
                    "banner-for-employee-messaging--outline": !!outline
                }, "banner-for-employee-messaging--".concat(variant), true);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", bannerClasses);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    role: "region",
                    "aria-labelledby": "region-heading"
                }, accessibleTextRegionName));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                _renderArbitrary(accessibleTextRegionName && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "id", "region-heading", "class", "accessible-text", "aria-hidden", "true"), 
                _renderArbitrary(accessibleTextRegionName), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "banner-for-employee-messaging__header");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "banner-for-employee-messaging__icon banner-for-employee-messaging__icon--".concat(variant), "innerHTML-prop", MDS.svgs["ico_speech_bubble_empty"], "aria-hidden", "true", "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "banner-for-employee-messaging__title banner-for-employee-messaging__title--".concat(variant));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("role", "heading");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-level", headingLevel);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    tabindex: -1,
                    id: "title-focus-target"
                }, !MDS.isIOS));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "accessible-text banner-for-employee-messaging__title--ada");
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    tabindex: -1,
                    id: "title-focus-target"
                }, MDS.isIOS));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("span");
                _renderArbitrary(accessibleTextIcon);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "banner-for-employee-messaging__title-text");
                _renderArbitrary(bannerTitle);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-button", null, null, "class", "banner-for-employee-messaging__button", "variant", "tertiary", "small", "true", "text", translateButtonText, "onclick", this._onTranslateButtonClick);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "banner-for-employee-messaging__message", "innerHTML-prop", bannerMessage, "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                _renderArbitrary(linkText && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-link", null, null, "class", "banner-for-employee-messaging__link", "href", linkHref, "text", linkText, "end-icon", "ico_chevron_right"));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            __webpack_exports__["default"] = MdsBannerForEmployeeMessagingTemplate;
        },
        "./src/banner-for-employee-messaging/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _MdsBannerForEmployeeMessaging__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/banner-for-employee-messaging/MdsBannerForEmployeeMessaging.jsx");
            var _mds_banner_for_employee_messaging_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/banner-for-employee-messaging/mds-banner-for-employee-messaging.scss");
            var _mds_banner_for_employee_messaging_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_banner_for_employee_messaging_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_allowLists__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/allowLists.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var string = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].stringRequired, number = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].number, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].enumerables, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].boolean;
            var entity = {
                bannerTitle: stringRequired.withHTML(_utils_allowLists__WEBPACK_IMPORTED_MODULE_4__["base"], _utils_allowLists__WEBPACK_IMPORTED_MODULE_4__["interactive"]),
                bannerMessage: stringRequired.withHTML(_utils_allowLists__WEBPACK_IMPORTED_MODULE_4__["base"], _utils_allowLists__WEBPACK_IMPORTED_MODULE_4__["interactive"], _utils_allowLists__WEBPACK_IMPORTED_MODULE_4__["style"], _utils_allowLists__WEBPACK_IMPORTED_MODULE_4__["layout"]),
                variant: enumerables(string, "requiredVerbatim", "required", "optional").defaultsTo("optional"),
                headingLevel: number.defaultsTo(2),
                accessibleTextIcon: stringRequired,
                accessibleTextRegionName: string,
                translateButtonText: stringRequired,
                linkText: string,
                linkHref: string,
                outline: boolean
            };
            var MdsBannerForEmployeeMessaging = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsBannerForEmployeeMessaging, _AgaveComponent);
                _createClass(MdsBannerForEmployeeMessaging, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsBannerForEmployeeMessaging";
                    }
                } ]);
                function MdsBannerForEmployeeMessaging() {
                    var _this;
                    _classCallCheck(this, MdsBannerForEmployeeMessaging);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsBannerForEmployeeMessaging).call(this));
                    _this._onTranslateButtonClick = _this._onTranslateButtonClick.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsBannerForEmployeeMessaging, [ {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement(payload) {
                        var interactiveElement;
                        if (payload && payload.target === "link" && payload.index) {
                            interactiveElement = this.shadowRoot.querySelectorAll("a, mds-link")[+payload.index - 1];
                        } else {
                            interactiveElement = this.shadowRoot.querySelector("#title-focus-target");
                        }
                        return {
                            interactiveElement: interactiveElement
                        };
                    }
                }, {
                    key: "renderedCallback",
                    value: function renderedCallback() {
                        var _this2 = this;
                        this.shadowRoot.querySelector(".banner-for-employee-messaging__title-text").innerHTML = this.bannerTitle;
                        this.shadowRoot.querySelector(".banner-for-employee-messaging__message").innerHTML = this.bannerMessage;
                        this.shadowRoot.querySelectorAll("a, mds-link").forEach(function(link, i) {
                            _newArrowCheck(this, _this2);
                            link.linkIndex = i + 1;
                            link.onclick = this._dispatchLinkClick.bind(this, i + 1);
                        }.bind(this));
                    }
                }, {
                    key: "_dispatchLinkClick",
                    value: function _dispatchLinkClick(index, event) {
                        var _this3 = this;
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this3);
                            return "click-link";
                        }.bind(this))(event, {
                            index: index
                        });
                    }
                }, {
                    key: "_onTranslateButtonClick",
                    value: function _onTranslateButtonClick(event) {
                        var _this4 = this;
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this4);
                            return "click-translate-button";
                        }.bind(this), this)(event);
                    }
                }, {
                    key: "render",
                    value: function render() {
                        if (!this.translateButtonText || !this.accessibleTextIcon || !this.bannerTitle || !this.bannerMessage) {
                            this.throwConstraintError("The banner title, banner message, accessible icon name, translate button text are all required.");
                        }
                        _MdsBannerForEmployeeMessaging__WEBPACK_IMPORTED_MODULE_1__["default"].call(this);
                    }
                } ]);
                return MdsBannerForEmployeeMessaging;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_0___default.a), _class2.styles = _mds_banner_for_employee_messaging_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsBannerForEmployeeMessaging;
        },
        "./src/banner-for-employee-messaging/mds-banner-for-employee-messaging.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/banner-for-employee-messaging/mds-banner-for-employee-messaging.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/banner/MdsBanner.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var _iconTypes = {
                critical: "ico_alert_filled",
                soft: "ico_alert_circle",
                informational: "ico_status_indicator_dot"
            };
            function MdsBannerTemplate() {
                var variant = this.variant, bannerTitle = this.bannerTitle, bannerMessage = this.bannerMessage, showCloseButton = this.showCloseButton, accessibleTextCloseButton = this.accessibleTextCloseButton, accessibleTextIcon = this.accessibleTextIcon, accessibleTextRegionName = this.accessibleTextRegionName, headingLevel = this.headingLevel, background = this.background;
                var bannerClasses = _defineProperty({
                    banner: true,
                    "banner--background-primary": background !== "themed"
                }, "banner--".concat(variant), background === "themed");
                var bannerOuterClasses = {
                    "banner--outer-container": true
                };
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", bannerOuterClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", bannerClasses);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    role: "region",
                    "aria-labelledby": "region-heading"
                }, accessibleTextRegionName));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                _renderArbitrary(accessibleTextRegionName && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "id", "region-heading", "class", "accessible-text", "aria-hidden", "true"), 
                _renderArbitrary(accessibleTextRegionName), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                _renderArbitrary(showCloseButton && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("button", null, null, "class", "banner__close-button", "aria-label", accessibleTextCloseButton, "onclick", this.close), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "banner__close-icon", "innerHTML-prop", MDS.svgs.ico_close, "aria-hidden", "true", "__skip", "true"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("button")));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "banner__header");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "banner__icon banner__icon--".concat(this.variant), "innerHTML-prop", MDS.svgs[_iconTypes[this.variant]], "aria-hidden", "true", "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("h2");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "banner__title banner__title--".concat(variant));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-level", headingLevel);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    tabindex: -1,
                    id: "title-focus-target"
                }, !MDS.isIOS));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("h2");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "accessible-text banner__title--ada");
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    tabindex: -1,
                    id: "title-focus-target"
                }, MDS.isIOS));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("span");
                _renderArbitrary(accessibleTextIcon);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "banner__title-text");
                _renderArbitrary(bannerTitle);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("h2");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "banner__message");
                _renderArbitrary(bannerMessage);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            __webpack_exports__["default"] = MdsBannerTemplate;
        },
        "./src/banner/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _MdsBanner__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/banner/MdsBanner.jsx");
            var _mds_banner_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/banner/mds-banner.scss");
            var _mds_banner_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_banner_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_allowLists__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/allowLists.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var string = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].stringRequired, number = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].number, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].enumerables, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].boolean;
            var entity = {
                bannerTitle: stringRequired.withHTML(_utils_allowLists__WEBPACK_IMPORTED_MODULE_4__["base"], _utils_allowLists__WEBPACK_IMPORTED_MODULE_4__["interactive"]),
                bannerMessage: stringRequired.withHTML(_utils_allowLists__WEBPACK_IMPORTED_MODULE_4__["base"], _utils_allowLists__WEBPACK_IMPORTED_MODULE_4__["interactive"], _utils_allowLists__WEBPACK_IMPORTED_MODULE_4__["layout"], _utils_allowLists__WEBPACK_IMPORTED_MODULE_4__["style"]),
                background: enumerables(string, "themed", "primary").defaultsTo("themed"),
                variant: enumerables(string, "critical", "informational", "soft").defaultsTo("informational"),
                headingLevel: number.defaultsTo(2),
                accessibleTextIcon: stringRequired,
                accessibleTextCloseButton: string,
                showCloseButton: boolean.defaultsTo(true),
                accessibleTextRegionName: string
            };
            var MdsBanner = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsBanner, _AgaveComponent);
                _createClass(MdsBanner, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsBanner";
                    }
                } ]);
                function MdsBanner() {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsBanner);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsBanner).call(this));
                    _this.close = _this.close.bind(_assertThisInitialized(_this));
                    _this._dispatchCloseEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "close";
                    }.bind(this), _assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsBanner, [ {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement(payload) {
                        var interactiveElement;
                        if (payload && payload.target === "link" && payload.index) {
                            interactiveElement = this.shadowRoot.querySelectorAll("a, mds-link")[+payload.index - 1];
                        } else {
                            interactiveElement = this.shadowRoot.querySelector("#title-focus-target");
                        }
                        return {
                            interactiveElement: interactiveElement
                        };
                    }
                }, {
                    key: "close",
                    value: function close(e) {
                        e && this._dispatchCloseEvent(e);
                        this.shadowRoot.querySelector(".banner").style.display = "none";
                    }
                }, {
                    key: "renderedCallback",
                    value: function renderedCallback() {
                        var _this3 = this;
                        this.shadowRoot.querySelector(".banner__title-text").innerHTML = this.bannerTitle;
                        this.shadowRoot.querySelector(".banner__message").innerHTML = this.bannerMessage;
                        this.shadowRoot.querySelectorAll("a, mds-link").forEach(function(link, i) {
                            _newArrowCheck(this, _this3);
                            link.linkIndex = i + 1;
                            link.onclick = this._dispatchLinkClick.bind(this, i + 1);
                        }.bind(this));
                    }
                }, {
                    key: "_dispatchLinkClick",
                    value: function _dispatchLinkClick(index, event) {
                        var _this4 = this;
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this4);
                            return "click-link";
                        }.bind(this))(event, {
                            index: index
                        });
                    }
                }, {
                    key: "render",
                    value: function render() {
                        if (!this.accessibleTextIcon || !this.bannerTitle || !this.bannerMessage) {
                            this.throwConstraintError("The banner title, banner message and accessible text for icon are all required.");
                        }
                        if (this.showCloseButton && !this.accessibleTextCloseButton) {
                            this.throwConstraintError("Accessible text for close button is required if close button is shown.");
                        }
                        _MdsBanner__WEBPACK_IMPORTED_MODULE_1__["default"].call(this);
                    }
                } ]);
                return MdsBanner;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_0___default.a), _class2.styles = _mds_banner_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsBanner;
        },
        "./src/banner/mds-banner.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/banner/mds-banner.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/bottom-sheet-dialog/bottom-sheet-dialog.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/bottom-sheet-dialog/bottom-sheet-dialog.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/bottom-sheet-dialog/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _bottom_sheet_dialog_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/bottom-sheet-dialog/bottom-sheet-dialog.scss");
            var _bottom_sheet_dialog_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_bottom_sheet_dialog_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _abstract_modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/abstract-modal/index.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_allowLists__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/allowLists.js");
            var _dec, _class, _class2;
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["mixins"].AttributeMarshallingMixin, string = _mixins$AttributeMars.string, stringRequired = _mixins$AttributeMars.stringRequired, number = _mixins$AttributeMars.number, enumerables = _mixins$AttributeMars.enumerables;
            var entity = _objectSpread({
                headerText: stringRequired.withHTML(_utils_allowLists__WEBPACK_IMPORTED_MODULE_5__["base"]),
                headingLevel: number.defaultsTo(2),
                idRole: string,
                firstButtonText: string.defaultsTo("button1"),
                secondButtonText: string.defaultsTo("button2"),
                buttonOrientation: enumerables(string, "vertical", "horizontal").defaultsTo("horizontal"),
                dialogWidth: number,
                dialogHeight: number,
                triggerId: stringRequired,
                dialogContent: string.defaultsTo("dialog-content")
            }, _abstract_modal__WEBPACK_IMPORTED_MODULE_3__["entity"]);
            var MdsBottomSheetDialog = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AbstractModal) {
                _inherits(MdsBottomSheetDialog, _AbstractModal);
                _createClass(MdsBottomSheetDialog, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsBottomSheetDialog";
                    }
                } ]);
                function MdsBottomSheetDialog() {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsBottomSheetDialog);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsBottomSheetDialog).call(this, [ "dialog-content" ], "bottom-sheet-dialog"));
                    _this.defineObservedProperty("_isTransitioningOut", true);
                    _this._closeOnEsc = _this._closeOnEsc.bind(_assertThisInitialized(_this));
                    _this._showBottomBoxShadow = false;
                    _this.close = _this.close.bind(_assertThisInitialized(_this));
                    _this.dispatchCustomEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "click-primary-button";
                    }.bind(this), _assertThisInitialized(_this));
                    _this._handleCloseButtonClick = _this._handleCloseButtonClick.bind(_assertThisInitialized(_this));
                    _this._handleCustomEventClick = _this._handleCustomEventClick.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsBottomSheetDialog, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsBottomSheetDialog.prototype), "connectedCallback", this).call(this);
                    }
                }, {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                            target: null
                        };
                        var targetId = "".concat(this.id, "-footer-action");
                        if (payload && (payload.target === "heading" || payload.target === "content")) {
                            targetId = "".concat(this.id, "-").concat(payload.target);
                        }
                        return {
                            nextPayload: payload,
                            interactiveElement: this.open && this._renderTarget.shadowRoot.getElementById(targetId)
                        };
                    }
                }, {
                    key: "_focusOnRender",
                    value: function _focusOnRender() {
                        var timeoutValue = MDS.isIOS ? 400 : 300;
                        window.setTimeout(this.focus.bind(this, {
                            target: "heading"
                        }), timeoutValue);
                    }
                }, {
                    key: "_focusOnTab",
                    value: function _focusOnTab() {
                        this.focus({
                            target: "heading"
                        });
                    }
                }, {
                    key: "_attachModal",
                    value: function _attachModal() {
                        var _this3 = this;
                        _get(_getPrototypeOf(MdsBottomSheetDialog.prototype), "_attachModal", this).call(this);
                        document.body.addEventListener("keyup", this._closeOnEsc);
                        window.setTimeout(function() {
                            _newArrowCheck(this, _this3);
                            this._isTransitioningOut = false;
                        }.bind(this), 10);
                    }
                }, {
                    key: "_closeOnEsc",
                    value: function _closeOnEsc(event) {
                        if (this.modalTrapped && Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["isEscAndShouldClose"])(event)) {
                            this.open = false;
                        }
                    }
                }, {
                    key: "_handleCloseButtonClick",
                    value: function _handleCloseButtonClick(event) {
                        this.close(event);
                    }
                }, {
                    key: "_handleCustomEventClick",
                    value: function _handleCustomEventClick(event) {
                        this.dispatchCustomEvent(event, {
                            value: event.target.value,
                            original: event.detail
                        });
                    }
                }, {
                    key: "close",
                    value: function close() {
                        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        this.open = false;
                    }
                }, {
                    key: "_detachModal",
                    value: function _detachModal() {
                        var _this4 = this;
                        this._isTransitioningOut = true;
                        document.body.removeEventListener("keyup", this._closeOnEsc);
                        window.setTimeout(function() {
                            _newArrowCheck(this, _this4);
                            _get(_getPrototypeOf(MdsBottomSheetDialog.prototype), "_detachModal", this).call(this);
                        }.bind(this), 500);
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var _headingClasses;
                        var headerText = this.headerText, headingLevel = this.headingLevel, buttonOrientation = this.buttonOrientation, id = this.id, _isTransitioningOut = this._isTransitioningOut;
                        var rootClass = "mds-bottom-sheet-dialog";
                        var rootClasses = {
                            "mds-bottom-sheet-dialog": true,
                            "mds-bottom-sheet-dialog--slide-out": _isTransitioningOut
                        };
                        var headingClasses = (_headingClasses = {}, _defineProperty(_headingClasses, "".concat(rootClass, "__heading"), true), 
                        _defineProperty(_headingClasses, "".concat(rootClass, "__heading--hidden"), true), 
                        _headingClasses);
                        var buttonWidth = buttonOrientation === "horizontal" ? "content" : "layout";
                        var firstButtonVariant = buttonOrientation === "horizontal" ? "secondary" : "primary";
                        var secondButtonVariant = buttonOrientation === "horizontal" ? "primary" : "secondary";
                        var firstButtonClickEvent = buttonOrientation === "horizontal" ? this._handleCloseButtonClick : this._handleCustomEventClick;
                        var secondButtonClickEvent = buttonOrientation === "horizontal" ? this._handleCustomEventClick : this._handleCloseButtonClick;
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", rootClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "".concat(rootClass, "__backdrop"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "id", "dialog-panel-container", "class", "".concat(rootClass, "__panel-container"), "role", "dialog", "aria-labelledby", "".concat(id, "-heading"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "id", "".concat(id, "-heading"), "tabIndex", "0", "role", "heading", "aria-level", headingLevel, "className", "".concat(rootClass, "__title-container"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", headingClasses, "innerHTML-prop", headerText, "__skip", "true");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "id", "".concat(id, "-content"), "class", "".concat(rootClass, "__main"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "name", this.dialogContent);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "id", "".concat(id, "-footer-action"), "class", "".concat(rootClass, "__footer-actions__").concat(buttonOrientation));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "".concat(rootClass, "__footer-actions__").concat(buttonOrientation, "__first-button"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-button", null, null, "onclick", firstButtonClickEvent, "small", "true", "variant", firstButtonVariant, "width-type", buttonWidth, "text", this.firstButtonText);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "".concat(rootClass, "__footer-actions__").concat(buttonOrientation, "__second-button"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-button", null, null, "onclick", secondButtonClickEvent, "small", "true", "variant", secondButtonVariant, "width-type", buttonWidth, "text", this.secondButtonText);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return MdsBottomSheetDialog;
            }(_abstract_modal__WEBPACK_IMPORTED_MODULE_3__["default"]), _class2.styles = _bottom_sheet_dialog_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsBottomSheetDialog;
        },
        "./src/bottom-sheet/MdsBottomSheet.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _this = undefined;
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            var renderPrimaryButton = function renderPrimaryButton(_ref) {
                var id = _ref.id, primaryButtonText = _ref.primaryButtonText, _handlePrimaryButtonClick = _ref._handlePrimaryButtonClick, primaryButtonAccessibleText = _ref.primaryButtonAccessibleText;
                _newArrowCheck(this, _this);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "id", "".concat(id, "-footer-action"), "class", "mds-bottom-sheet__footer-actions");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "mds-bottom-sheet__footer-actions__primary-button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-button", null, null, "onclick", _handlePrimaryButtonClick, "text", primaryButtonText, "width-type", "layout", "accessible-text", primaryButtonAccessibleText);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }.bind(undefined);
            var renderIcon = function renderIcon(type, _ref2) {
                var id = _ref2.id, backButtonAccessibleText = _ref2.backButtonAccessibleText, closeButtonAccessibleText = _ref2.closeButtonAccessibleText, _handleBackButtonClick = _ref2._handleBackButtonClick, _closeAll = _ref2._closeAll;
                _newArrowCheck(this, _this);
                var iconType = type === "close" ? "ico_close" : "ico_chevron_left";
                var label = type === "close" ? closeButtonAccessibleText : backButtonAccessibleText;
                var eventHandlerName = type === "close" ? _closeAll : _handleBackButtonClick;
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "mds-bottom-sheet__".concat(type, "--container"));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("button", null, null, "onclick", eventHandlerName, "class", "mds-bottom-sheet__icon-button mds-bottom-sheet__icon-button--".concat(type), "aria-label", label, "type", "button", "id", "".concat(id, "-").concat(type, "-button"));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "id", "".concat(id, "-").concat(type, "-icon"), "innerHTML-prop", MDS.svgs[iconType], "class", "mds-bottom-sheet__icon", "aria-hidden", "true", "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("button");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }.bind(undefined);
            function MdsBottomSheetTemplate() {
                var _this2 = this;
                var headerText = this.headerText, id = this.id, _isTransitioningOut = this._isTransitioningOut, tierTwo = this.tierTwo, bottomSheetContent = this.bottomSheetContent, primaryButtonText = this.primaryButtonText;
                var rootClasses = {
                    "mds-bottom-sheet": true,
                    "mds-bottom-sheet--slide-out": _isTransitioningOut,
                    "mds-bottom-sheet__tier-two": tierTwo
                };
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", rootClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "mds-bottom-sheet__backdrop", "onclick", function(e) {
                    _newArrowCheck(this, _this2);
                    return this._detectClickOutsideModal(e);
                }.bind(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "aria-labelledby", "".concat(id, "-heading"), "id", "dialog-panel-container", "class", "mds-bottom-sheet__panel-container", "role", "dialog");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "mds-bottom-sheet__title-container");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "mds-bottom-sheet__heading");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "id", "".concat(id, "-heading"), "tabIndex", "0", "role", "heading", "aria-level", "2", "innerHTML-prop", headerText, "class", "mds-bottom-sheet__heading--text", "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                _renderArbitrary(tierTwo && renderIcon("back", this));
                _renderArbitrary(renderIcon("close", this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "id", "".concat(id, "-content"), "class", "mds-bottom-sheet__main", "onscroll", this._handleSlotScroll);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "name", bottomSheetContent);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                _renderArbitrary(primaryButtonText && renderPrimaryButton(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            __webpack_exports__["default"] = MdsBottomSheetTemplate;
        },
        "./src/bottom-sheet/bottom-sheet.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/bottom-sheet/bottom-sheet.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/bottom-sheet/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _bottom_sheet_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/bottom-sheet/bottom-sheet.scss");
            var _bottom_sheet_scss__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_bottom_sheet_scss__WEBPACK_IMPORTED_MODULE_1__);
            var _MdsBottomSheet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/bottom-sheet/MdsBottomSheet.jsx");
            var _abstract_modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/abstract-modal/index.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_allowLists__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/allowLists.js");
            var _dec, _class, _class2;
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["mixins"].AttributeMarshallingMixin, string = _mixins$AttributeMars.string, boolean = _mixins$AttributeMars.boolean, stringRequired = _mixins$AttributeMars.stringRequired;
            var entity = _objectSpread({
                headerText: stringRequired.withHTML(_utils_allowLists__WEBPACK_IMPORTED_MODULE_5__["base"]),
                primaryButtonText: string,
                primaryButtonAccessibleText: string.defaultsTo("primary button"),
                closeButtonAccessibleText: string.defaultsTo("close"),
                backButtonAccessibleText: string.defaultsTo("back"),
                bottomSheetContent: string.defaultsTo("bottom-sheet-content"),
                triggerId: stringRequired,
                tierTwo: boolean.defaultsTo(false)
            }, _abstract_modal__WEBPACK_IMPORTED_MODULE_3__["entity"]);
            var MdsBottomSheet = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AbstractModal) {
                _inherits(MdsBottomSheet, _AbstractModal);
                _createClass(MdsBottomSheet, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsBottomSheet";
                    }
                } ]);
                function MdsBottomSheet() {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsBottomSheet);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsBottomSheet).call(this, [ "bottom-sheet-content" ], "bottom-sheet"));
                    _this.defineObservedProperty("_isTransitioningOut", true);
                    _this._closeOnEsc = _this._closeOnEsc.bind(_assertThisInitialized(_this));
                    _this.close = _this.close.bind(_assertThisInitialized(_this));
                    _this._closeAll = _this._closeAll.bind(_assertThisInitialized(_this));
                    _this._handlePrimaryButtonClick = _this._handlePrimaryButtonClick.bind(_assertThisInitialized(_this));
                    _this.dispatchPrimaryButtonCustomEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "click-primary-button";
                    }.bind(this), _assertThisInitialized(_this));
                    _this._handleBackButtonClick = _this._handleBackButtonClick.bind(_assertThisInitialized(_this));
                    _this.dispatchBackButtonCustomEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "click-back-button";
                    }.bind(this), _assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsBottomSheet, [ {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                            target: null
                        };
                        var targetId = "".concat(this.id, "-").concat(payload.target);
                        return {
                            nextPayload: payload,
                            interactiveElement: this.open && this._renderTarget.shadowRoot.getElementById(targetId)
                        };
                    }
                }, {
                    key: "_focusOnRender",
                    value: function _focusOnRender() {
                        var _this3 = this;
                        var timeoutValue = MDS.isIOS ? 400 : 300;
                        window.setTimeout(function() {
                            _newArrowCheck(this, _this3);
                            var modals = document.querySelectorAll("mds-bottom-sheet-modal");
                            if (modals.length) {
                                var lastModal = modals[modals.length - 1];
                                lastModal.shadowRoot.querySelector(".mds-bottom-sheet__heading > span").focus();
                            }
                        }.bind(this), timeoutValue);
                    }
                }, {
                    key: "_focusOnTab",
                    value: function _focusOnTab() {
                        this.focus({
                            target: "heading"
                        });
                    }
                }, {
                    key: "_attachModal",
                    value: function _attachModal() {
                        var _this4 = this;
                        _get(_getPrototypeOf(MdsBottomSheet.prototype), "_attachModal", this).call(this);
                        document.body.addEventListener("keyup", this._closeOnEsc);
                        if (this.tierTwo) {
                            this._isTransitioningOut = false;
                        } else {
                            window.setTimeout(function() {
                                _newArrowCheck(this, _this4);
                                this._isTransitioningOut = false;
                            }.bind(this), 10);
                        }
                        if (!this.tierTwo) {
                            window.modal = this._renderTarget.shadowRoot.querySelector("#dialog-panel-container");
                            window.modalHeight = this._renderTarget.shadowRoot.querySelector("#dialog-panel-container").clientHeight;
                            this._renderTarget.shadowRoot.querySelector("#dialog-panel-container").style.height = "".concat(window.modalHeight, "px");
                        } else if (this.tierTwo) {
                            if (window.modal) {
                                window.modal.style.visibility = "hidden";
                                this._footerHeight = this._renderTarget.shadowRoot.querySelector(".mds-bottom-sheet__footer-actions__primary-button").clientHeight;
                                this._renderTarget.shadowRoot.querySelector("#dialog-panel-container").style.height = "".concat(window.modalHeight, "px");
                            }
                        }
                        this._renderTarget.querySelectorAll(".bottom-sheet-trigger").forEach(function(trigger) {
                            var _this5 = this;
                            _newArrowCheck(this, _this4);
                            trigger.addEventListener("click", function() {
                                _newArrowCheck(this, _this5);
                                _get(_getPrototypeOf(MdsBottomSheet.prototype), "_trapFocus", this).call(this, false);
                            }.bind(this));
                        }.bind(this));
                        this._renderTarget.querySelectorAll(".bottom-sheet-trigger").forEach(function(trigger) {
                            var _this6 = this;
                            _newArrowCheck(this, _this4);
                            trigger.addEventListener("focus", function() {
                                _newArrowCheck(this, _this6);
                                _get(_getPrototypeOf(MdsBottomSheet.prototype), "_trapFocus", this).call(this, true);
                            }.bind(this));
                        }.bind(this));
                        this._setSlotBottomMargin();
                    }
                }, {
                    key: "_restModalHeight",
                    value: function _restModalHeight() {
                        var modalStyles = window.modal.style;
                        var heightPropertyValue = Object.values(modalStyles).indexOf("height") > -1 ? true : "";
                        if (heightPropertyValue) {
                            window.modal.style.removeProperty("height");
                        }
                    }
                }, {
                    key: "_closeOnEsc",
                    value: function _closeOnEsc(event) {
                        if (this.modalTrapped && Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["isEscAndShouldClose"])(event)) {
                            this._closeAll();
                        }
                    }
                }, {
                    key: "_handlePrimaryButtonClick",
                    value: function _handlePrimaryButtonClick(event) {
                        this.dispatchPrimaryButtonCustomEvent(event, {
                            value: event.target.value,
                            original: event.detail
                        });
                        this.close();
                    }
                }, {
                    key: "_handleBackButtonClick",
                    value: function _handleBackButtonClick(event) {
                        this.dispatchBackButtonCustomEvent(event, {
                            value: event.target.value,
                            original: event.detail
                        });
                        this.close();
                        this._focusOnRender();
                    }
                }, {
                    key: "close",
                    value: function close() {
                        this.open = false;
                        if (window.modal) {
                            window.modal.style.visibility = "visible";
                        }
                    }
                }, {
                    key: "_closeAll",
                    value: function _closeAll() {
                        var _this7 = this;
                        document.querySelectorAll("mds-bottom-sheet").forEach(function(sheet) {
                            _newArrowCheck(this, _this7);
                            if (sheet.open === true) {
                                sheet.close();
                            }
                        }.bind(this));
                        this._restModalHeight();
                    }
                }, {
                    key: "_detectClickOutsideModal",
                    value: function _detectClickOutsideModal(e) {
                        if (e.composedPath()[0].classList[0] === "mds-bottom-sheet__backdrop") {
                            this._closeAll();
                        }
                    }
                }, {
                    key: "_detachModal",
                    value: function _detachModal() {
                        var _this8 = this;
                        document.body.removeEventListener("keyup", this._closeOnEsc);
                        if (this.tierTwo) {
                            _get(_getPrototypeOf(MdsBottomSheet.prototype), "_detachModal", this).call(this);
                        } else {
                            this._isTransitioningOut = true;
                            window.setTimeout(function() {
                                _newArrowCheck(this, _this8);
                                _get(_getPrototypeOf(MdsBottomSheet.prototype), "_detachModal", this).call(this);
                            }.bind(this), 500);
                        }
                    }
                }, {
                    key: "_setSlotBottomMargin",
                    value: function _setSlotBottomMargin() {
                        if (this.primaryButtonText) {
                            this._renderTarget.shadowRoot.querySelector(".mds-bottom-sheet__main").style.marginBottom = "".concat(this._footerHeight + 16, "px");
                        }
                    }
                }, {
                    key: "_handleSlotScroll",
                    value: function _handleSlotScroll() {
                        if (this.scrollTop !== 0) {
                            document.querySelector("mds-bottom-sheet-modal").shadowRoot.querySelector(".mds-bottom-sheet__title-container").classList.add("mds-bottom-sheet__heading--scrollable");
                        } else if (this.scrollTop === 0) {
                            document.querySelector("mds-bottom-sheet-modal").shadowRoot.querySelector(".mds-bottom-sheet__title-container").classList.remove("mds-bottom-sheet__heading--scrollable");
                        }
                    }
                }, {
                    key: "render",
                    value: function render() {
                        _MdsBottomSheet__WEBPACK_IMPORTED_MODULE_2__["default"].call(this);
                    }
                } ]);
                return MdsBottomSheet;
            }(_abstract_modal__WEBPACK_IMPORTED_MODULE_3__["default"]), _class2.styles = _bottom_sheet_scss__WEBPACK_IMPORTED_MODULE_1___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsBottomSheet;
        },
        "./src/brand-bar/MdsBrandBar.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _logoImage$wrapper = function _logoImage$wrapper(_this$_currentLogo, _this$logoAccessibleT) {
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("img", null, null, "class", "brand-bar__image", "src", _this$_currentLogo, "alt", _this$logoAccessibleT);
            }, _logoContent$wrapper = function _logoContent$wrapper(_this$logoDestination, _this$_dispatchCustom, _this$_dispatchCustom2, _this$_dispatchCustom3, _deferred, _args) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("a", null, null, "id", "brand_bar_logo", "class", "brand-bar__logo-link", "href", _this$logoDestination, "onclick", _this$_dispatchCustom, "onblur", _this$_dispatchCustom2, "onfocus", _this$_dispatchCustom3);
                _renderArbitrary(_deferred.call(_args));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("a");
            }, _logoContent$wrapper2 = function _logoContent$wrapper2(_conditionalAttribute, _deferred2, _args2) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "brand-bar__logo-link");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "brand_bar_logo");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("tabindex", "-1");
                _spreadAttribute(_conditionalAttribute);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("span");
                _renderArbitrary(_deferred2.call(_args2));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            };
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _slicedToArray(arr, i) {
                return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
            }
            function _nonIterableRest() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            function _iterableToArrayLimit(arr, i) {
                var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
                if (null != _i) {
                    var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
                    try {
                        if (_x = (_i = _i.call(arr)).next, 0 === i) {
                            if (Object(_i) !== _i) return;
                            _n = !1;
                        } else for (;!(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) ;
                    } catch (err) {
                        _d = !0, _e = err;
                    } finally {
                        try {
                            if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
                        } finally {
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
            }
            function _arrayWithHoles(arr) {
                if (Array.isArray(arr)) return arr;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function renderSignInOutButton() {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("mds-button", null, null, "class", "brand-bar__sign-in-out-button mds-button--".concat(this._brand), "id", "brand_bar_sign_in_out", "text", this.signInOutButtonText, "accessible-text", this.signInOutButtonAccessibleText, "variant", "tertiary", "inverse", "true", "small", "true", "icon-type", "", "onclick", this._dispatchCustomEvent, "onblur", this._dispatchCustomEvent, "onfocus", this._dispatchCustomEvent);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-button");
            }
            function renderSearchBox() {
                var inlineClasses = _defineProperty({
                    "brand-bar__search-box": true,
                    "brand-bar__search-box--expanding": this._searchBoxExpanding,
                    "brand-bar__search-box--expanded": this._searchBoxExpanded,
                    "brand-bar__search-box--collapsing": this._searchBoxCollapsing
                }, "mds-search-box--".concat(this._brand), true);
                var overflowClasses = _defineProperty({
                    "brand-bar__search-box": true,
                    "brand-bar__search-box-overflow": true
                }, "mds-search-box--".concat(this._brand), true);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("mds-search-box");
                _spreadAttribute(this.searchBoxData);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", this._searchBoxPosition === "overflow" ? overflowClasses : inlineClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("oninput", this._onSearchBoxInput);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onkeyup", this._onSearchBoxKeyup);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onkeydown", this._onSearchBoxKeydown);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("mds-search-box");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-search-box");
            }
            function renderLogo() {
                var logoImage = _jsxWrapper(_logoImage$wrapper, [ this._currentLogo, this.logoAccessibleText ]);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "brand-bar__logo-container");
                _renderArbitrary(this.logoDestination ? (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("a", null, null, "id", "brand_bar_logo", "class", "brand-bar__logo-link", "href", this.logoDestination, "onclick", this._dispatchCustomEvent, "onblur", this._dispatchCustomEvent, "onfocus", this._dispatchCustomEvent), 
                _renderArbitrary(logoImage), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("a")) : (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("span"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "brand-bar__logo-link"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "brand_bar_logo"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("tabindex", "-1"), 
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    "aria-level": this.headingLevel,
                    role: "heading"
                }, this.headingLevel)), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("span"), 
                _renderArbitrary(logoImage), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function renderDefaultBar() {
                var _searchBoxCancelButto, _securityButtonClasse, _conversationDeckButt, _profileAndSettingsBu, _openAccountButtonCla, _signInOutButtonClass;
                var searchBoxContainerClasses = {
                    "brand-bar__search-box-container": true,
                    "brand-bar__search-box-container--not-expanding": !this._searchBoxExpanding,
                    "brand-bar__search-box-container--expanding": this._searchBoxExpanding,
                    "brand-bar__search-box-container--collapsing": this._searchBoxCollapsing,
                    "brand-bar__search-box-container--slot": this.searchBoxSlot
                };
                var searchBoxButtonClasses = _defineProperty({
                    "brand-bar__search-box-button": true,
                    "brand-bar__search-box-button--expanding": this._searchBoxExpanding,
                    "brand-bar__search-box-button--collapsing": this._searchBoxCollapsing,
                    "brand-bar__search-box-button--expanded": this._searchBoxExpanded
                }, "mds-button--".concat(this._brand), true);
                var searchBoxCancelButtonClasses = (_searchBoxCancelButto = {
                    "brand-bar__search-box-cancel-button": true,
                    "brand-bar__search-box-cancel-button--expanding": this._searchBoxExpanding,
                    "brand-bar__search-box-cancel-button--collapsing": this._searchBoxCollapsing,
                    "brand-bar__search-box-cancel-button--expanded": this._searchBoxExpanded
                }, _defineProperty(_searchBoxCancelButto, "mds-button--".concat(this._brand), true), 
                _defineProperty(_searchBoxCancelButto, "brand-bar__utilities--button-hidden", true), 
                _searchBoxCancelButto);
                var searchBoxSlotClasses = {
                    "brand-bar__search-box-slot": true,
                    "brand-bar__search-box-slot--expanding": this._searchBoxExpanding && !this._searchBoxExpanded,
                    "brand-bar__search-box-slot--collapsing": this._searchBoxCollapsing,
                    "brand-bar__search-box-slot--expanded": this._searchBoxExpanded
                };
                var slotClasses = {
                    "brand-bar__slot": true,
                    "brand-bar__slot--default": true,
                    "brand-bar__slot--expanded": this.slotContainerExpanded && this._slotPlacement === "brand-bar--".concat(this.id),
                    "hide-default-slot": !this._showDefaultSlot
                };
                var securityButtonClasses = (_securityButtonClasse = {
                    "brand-bar__utilities": true,
                    "brand-bar__utilities--security-button": true
                }, _defineProperty(_securityButtonClasse, "mds-button--".concat(this._brand), true), 
                _defineProperty(_securityButtonClasse, "brand-bar__utilities--button-hidden", !this._securityButton), 
                _securityButtonClasse);
                var conversationDeckButtonClasses = (_conversationDeckButt = {
                    "brand-bar__utilities": true,
                    "brand-bar__utilities--conversation-deck-button": true
                }, _defineProperty(_conversationDeckButt, "mds-button--".concat(this._brand), true), 
                _defineProperty(_conversationDeckButt, "brand-bar__utilities--button-hidden", !this._conversationDeckButton), 
                _conversationDeckButt);
                var profileAndSettingsButtonClasses = (_profileAndSettingsBu = {
                    "brand-bar__utilities": true,
                    "brand-bar__utilities--profile-button": true
                }, _defineProperty(_profileAndSettingsBu, "mds-button--".concat(this._brand), true), 
                _defineProperty(_profileAndSettingsBu, "brand-bar__utilities brand-bar__utilities--profile-button", true), 
                _defineProperty(_profileAndSettingsBu, "brand-bar__utilities--button-hidden", !this._profileAndSettingsButton), 
                _profileAndSettingsBu);
                var openAccountButtonClasses = (_openAccountButtonCla = {
                    "brand-bar__utilities": true,
                    "brand-bar__utilities--open_account_button": true
                }, _defineProperty(_openAccountButtonCla, "mds-button--".concat(this._brand), true), 
                _defineProperty(_openAccountButtonCla, "brand-bar__utilities--button-hidden", !this._openAccountButtonText), 
                _openAccountButtonCla);
                var signInOutButtonClasses = (_signInOutButtonClass = {
                    "brand-bar__sign-in-out-button": true
                }, _defineProperty(_signInOutButtonClass, "mds-button--".concat(this._brand), true), 
                _defineProperty(_signInOutButtonClass, "brand-bar__utilities--button-hidden", !this._signInOutButtonText), 
                _signInOutButtonClass);
                var brandBarRightContainerClasses = {
                    "brand-bar__right-container": true,
                    "brand-bar__right-container--hide": this._searchBoxExpanded
                };
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "brand-bar__container-wrap-inner", "style", "max-width: ".concat(this.maxWidth));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "brand-bar__container");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "brand-bar__left-container");
                _renderArbitrary(this.menuButton && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("nav", null, null, "class", "brand-bar__hamburger-wrap", "aria-label", this.accessibleHamburgerMenuName, "aria-expanded", this.expanded), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("mds-button", null, null, "class", "brand-bar__hamburger-button mds-button--".concat(this._brand), "id", "brand_bar_hamburger_menu", "variant", "tertiary", "icon-type", "ico_hamburger_menu", "icon-position", "icon_only", "inverse", "true", "onclick", this._dispatchCustomEvent, "onblur", this._dispatchCustomEvent, "onfocus", this._dispatchCustomEvent, "accessible-text", this.accessibleHamburgerMenuButtonName, "inactive", this.menuButtonInactive), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-tooltip", null, null, "message", this.accessibleHamburgerMenuButtonName), 
                _renderArbitrary(this.menuButtonData && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("mds-menu-button"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "brand_bar_hamburger_menu_button"), 
                _spreadAttribute(this.menuButtonData), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("mds-menu-button"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-menu-button"))), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-button"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("nav")));
                _renderArbitrary(this.logo && renderLogo.call(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "brand-bar__right-container");
                _renderArbitrary(this._searchEnabled && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", searchBoxContainerClasses), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("mds-button", null, null, "class", searchBoxButtonClasses, "id", "brand_bar_search_button", "icon-type", "ico_search", "icon-position", "icon_only", "inverse", "true", "variant", "tertiary", "accessible-text", this.searchButtonAccessibleText, "onclick", this._onSearchButtonClick, "onblur", this._dispatchCustomEvent, "onfocus", this._dispatchCustomEvent, "inactive", this.searchButtonInactive), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-tooltip", null, null, "message", this.searchButtonAccessibleText), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-button"), 
                _renderArbitrary(this.searchBoxSlot ? (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", searchBoxSlotClasses), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "name", "search-box-slot"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")) : renderSearchBox.call(this)), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                _renderArbitrary(this._searchBoxCancelButtonText && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-button", null, null, "class", searchBoxCancelButtonClasses, "id", "brand_bar__search_cancel", "text", this.searchBoxCancelButtonText, "variant", "tertiary", "inverse", "true", "small", "true", "accessible-text", this.searchBoxCancelButtonAccessibleText, "onclick", this._onSearchCancelButtonClick, "onblur", this._dispatchCustomEvent, "onfocus", this._dispatchCustomEvent));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", brandBarRightContainerClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("mds-button", null, null, "class", securityButtonClasses, "id", "brand_bar_security_button", "icon-type", "ico_shield", "icon-position", "icon_only", "inverse", "true", "variant", "tertiary", "accessible-text", this.securityButtonAccessibleText, "onclick", this._dispatchCustomClickEventWrapper, "onblur", this._dispatchCustomEvent, "onfocus", this._dispatchCustomEvent, "inactive", this.securityButtonInactive);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-tooltip", null, null, "message", this.securityButtonAccessibleText);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-button");
                _renderArbitrary(this._slotPlacement === "brand_bar_security_button" && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "brand-bar__slot brand-bar__slot--custom brand-bar__slot--expanded"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("slot", null, null, "name", "conversation-deck-slot"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("slot"), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("mds-button", null, null, "class", conversationDeckButtonClasses, "id", "brand_bar_conversation_deck_button", "icon-type", "ico_flag", "icon-position", "icon_only", "badge", this.conversationDeckNumber, "inverse", "true", "variant", "tertiary", "accessible-text", this.conversationDeckButtonAccessibleText, "onclick", this._dispatchCustomClickEventWrapper, "onblur", this._dispatchCustomEvent, "onfocus", this._dispatchCustomEvent, "inactive", this.conversationDeckButtonInactive);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-tooltip", null, null, "message", this.conversationDeckButtonAccessibleText);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-button");
                _renderArbitrary(this._slotPlacement === "brand_bar_conversation_deck_button" && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "brand-bar__slot brand-bar__slot--custom  brand-bar__slot--expanded"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("slot", null, null, "name", "conversation-deck-slot"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("slot"), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("mds-button", null, null, "class", profileAndSettingsButtonClasses, "id", "brand_bar_profile_and_settings_button", "icon-type", "ico_people_profile", "icon-position", "icon_only", "inverse", "true", "text", "", "variant", "tertiary", "accessible-text", this.profileAndSettingsButtonAccessibleText, "onclick", this._dispatchCustomEvent, "onblur", this._dispatchCustomEvent, "onfocus", this._dispatchCustomEvent, "inactive", this.profileAndSettingsButtonInactive);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-tooltip", null, null, "message", this.profileAndSettingsButtonAccessibleText);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("mds-menu-button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "brand_bar_profile_and_settings_menu_button");
                _spreadAttribute(this.profileAndSettingsData);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("mds-menu-button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-menu-button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-button");
                _renderArbitrary(this._slotPlacement === "brand_bar_profile_and_settings_button" && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "brand-bar__slot brand-bar__slot--custom  brand-bar__slot--expanded"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("slot", null, null, "name", "conversation-deck-slot"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("slot"), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-button", null, null, "class", openAccountButtonClasses, "id", "brand_bar__open_account_button", "text", this.openAccountButtonText, "variant", "primary", "inverse", "true", "small", "true", "accessible-text", this.openAccountButtonAccessibleText, "onclick", this._dispatchCustomClickEventWrapper, "onblur", this._dispatchCustomEvent, "onfocus", this._dispatchCustomEvent, "inactive", this.openAccountButtonInactive);
                _renderArbitrary(this._slotPlacement === "brand_bar__open_account_button" && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "brand-bar__slot brand-bar__slot--custom  brand-bar__slot--expanded"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("slot", null, null, "name", "conversation-deck-slot"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("slot"), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-button", null, null, "class", signInOutButtonClasses, "id", "brand_bar_sign_in_out", "text", this.signInOutButtonText, "accessible-text", this.signInOutButtonAccessibleText, "variant", "tertiary", "inverse", "true", "small", "true", "icon-type", "", "onclick", this._dispatchCustomEvent, "onblur", this._dispatchCustomEvent, "onfocus", this._dispatchCustomEvent);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "id", "brand-bar--".concat(this.id), "class", slotClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "name", "conversation-deck-slot");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function linkOrButton(item) {
                var classes = _defineProperty({
                    "brand-bar__controls--buttons": true
                }, "mds-button--".concat(this._brand), true);
                if (item.linkDestination) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("a", null, null, "href", item.linkDestination, "role", "link", "class", "brand-bar__controls--links", "onclick", this._dispatchCustomEvent, "onblur", this._dispatchCustomEvent, "onfocus", this._dispatchCustomEvent);
                    _renderArbitrary(item.text);
                    return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("a");
                }
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("mds-button");
                _spreadAttribute(item);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", classes);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("variant", "tertiary");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("inverse", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onclick", this._dispatchCustomEvent);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onblur", this._dispatchCustomEvent);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onfocus", this._dispatchCustomEvent);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("mds-button");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-button");
            }
            function renderLogoCustom() {
                var logoContent;
                if (this.logoDestination) {
                    logoContent = _jsxWrapper(_logoContent$wrapper, [ this.logoDestination, this._dispatchCustomEvent, this._dispatchCustomEvent, this._dispatchCustomEvent, renderLogoOrText, this ]);
                } else {
                    logoContent = _jsxWrapper(_logoContent$wrapper2, [ Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                        "aria-level": this.headingLevel,
                        role: "heading"
                    }, this.headingLevel), renderLogoOrText, this ]);
                }
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "brand-bar__logo-container");
                _renderArbitrary(logoContent);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function renderLogoOrText() {
                if (this.logoText) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "brand-bar__logo-text", "id", "brand-bar", "innerHTML-prop", this.logoText, "__skip", "true");
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                    return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                }
                var imgClasses = {
                    "brand-bar__image": true,
                    "brand-bar__image--logo-text": this.logoText
                };
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("img", null, null, "class", imgClasses, "src", this.logo, "alt", this.logoAccessibleText || this.accessibleLogoName);
            }
            function renderCustomBar() {
                var _this = this;
                var searchBoxContainerClasses = {
                    "brand-bar__search-box-container": true,
                    "brand-bar__search-box-container--expanding": this._searchBoxExpanding,
                    "brand-bar__search-box-container--collapsing": this._searchBoxCollapsing
                };
                var searchBoxOverflowContainerClasses = {
                    "brand-bar__search-box-overflow-container": true,
                    "brand-bar__search-box-overflow-container--expand": this._searchBoxOverflowExpand
                };
                var searchBoxButtonClasses = _defineProperty({
                    "brand-bar__search-box-button": true,
                    "brand-bar__search-box-button--expanding": this._searchBoxExpanding,
                    "brand-bar__search-box-button--collapsing": this._searchBoxCollapsing,
                    "brand-bar__search-box-button--expanded": this._searchBoxExpanded
                }, "mds-button--".concat(this._brand), true);
                var _map = [ this.leftControls, this.rightControls ].map(function(controls) {
                    _newArrowCheck(this, _this);
                    return controls ? !!controls.length : false;
                }.bind(this)), _map2 = _slicedToArray(_map, 2), hasLeftControls = _map2[0], hasRightControls = _map2[1];
                var renderLeftContainer = hasLeftControls || this.menuButton || this.conversationDeckButton;
                var renderRightContainer = hasRightControls || this.signInOutButtonText || this.searchEnabled;
                var rightContainerClasses = {
                    "brand-bar__right-container": true,
                    "brand-bar__right-container--without-left": !renderLeftContainer,
                    "brand-bar__right-container--custom": true
                };
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "brand-bar__container-wrap-inner", "style", "max-width: ".concat(this.maxWidth));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "brand-bar__container");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "brand-bar__left-container");
                _renderArbitrary(this.menuButton && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("nav", null, null, "class", "brand-bar__hamburger-wrap", "aria-label", this.accessibleHamburgerMenuName, "aria-expanded", this.expanded), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-button", null, null, "class", "brand-bar__hamburger-button mds-button--".concat(this._brand), "id", "brand_bar_hamburger_menu", "variant", "tertiary", "icon-type", "ico_hamburger_menu", "icon-position", "icon_only", "inverse", "true", "onclick", this._dispatchCustomEvent, "onblur", this._dispatchCustomEvent, "onfocus", this._dispatchCustomEvent, "accessible-text", this.accessibleHamburgerMenuButtonName), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("nav")));
                _renderArbitrary(hasLeftControls && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "brand-bar__left-controls"), 
                _renderArbitrary(this.leftControls.map(function(item) {
                    _newArrowCheck(this, _this);
                    return linkOrButton.call(this, item);
                }.bind(this))), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                _renderArbitrary((this.logo || this.logoText) && renderLogoCustom.call(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", rightContainerClasses);
                _renderArbitrary(hasRightControls && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "brand-bar__right-controls"), 
                _renderArbitrary(this.rightControls.map(function(item) {
                    _newArrowCheck(this, _this);
                    return linkOrButton.call(this, item);
                }.bind(this))), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                _renderArbitrary(this.searchEnabled && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", searchBoxContainerClasses), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-button", null, null, "class", searchBoxButtonClasses, "id", "brand_bar_search_button", "icon-type", "ico_search", "icon-position", "icon_only", "inverse", "true", "variant", "tertiary", "accessible-text", "search", "onclick", this._onSearchButtonClick, "onblur", this._dispatchCustomEvent, "onfocus", this._dispatchCustomEvent), 
                _renderArbitrary(this._searchBoxPosition === "inline" && renderSearchBox.call(this)), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                _renderArbitrary(this._signInOutButtonText && renderSignInOutButton.call(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", searchBoxOverflowContainerClasses);
                _renderArbitrary(this._searchBoxPosition === "overflow" && renderSearchBox.call(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function MdsBrandBarTemplate() {
                var _brandBarClasses;
                var brandBarClasses = (_brandBarClasses = {
                    "brand-bar": true
                }, _defineProperty(_brandBarClasses, "brand-bar--".concat(this.variant), true), 
                _defineProperty(_brandBarClasses, "brand-bar--opaque", this.opaque), _defineProperty(_brandBarClasses, "brand-bar--search-box", this._searchBoxExpanding || this._searchBoxOverflowExpand), 
                _defineProperty(_brandBarClasses, "brand-bar-custom--".concat(this.opacity), this.variant === "custom"), 
                _brandBarClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", brandBarClasses);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    onclick: this._onclick
                }, this.searchEnabled));
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    role: this.containerAccessibleRole
                }, this.containerAccessibleRoleFlag));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "brand-bar__container-wrap");
                _renderArbitrary(this.variant === "default" ? renderDefaultBar.call(this) : renderCustomBar.call(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            __webpack_exports__["default"] = MdsBrandBarTemplate;
        },
        "./src/brand-bar/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_brand_bar_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/brand-bar/mds-brand-bar.scss");
            var _mds_brand_bar_scss__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_brand_bar_scss__WEBPACK_IMPORTED_MODULE_1__);
            var _MdsBrandBar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/brand-bar/MdsBrandBar.jsx");
            var _search_box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/search-box/index.js");
            var _menu_button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/menu-button/index.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/utils/data-utils.js");
            var _utils_allowLists__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/utils/allowLists.js");
            var _dec, _class, _class2;
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _createForOfIteratorHelper(o, allowArrayLike) {
                var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                if (!it) {
                    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                        if (it) o = it;
                        var i = 0;
                        var F = function F() {};
                        return {
                            s: F,
                            n: function n() {
                                if (i >= o.length) return {
                                    done: true
                                };
                                return {
                                    done: false,
                                    value: o[i++]
                                };
                            },
                            e: function e(_e) {
                                throw _e;
                            },
                            f: F
                        };
                    }
                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                var normalCompletion = true, didErr = false, err;
                return {
                    s: function s() {
                        it = it.call(o);
                    },
                    n: function n() {
                        var step = it.next();
                        normalCompletion = step.done;
                        return step;
                    },
                    e: function e(_e2) {
                        didErr = true;
                        err = _e2;
                    },
                    f: function f() {
                        try {
                            if (!normalCompletion && it.return != null) it.return();
                        } finally {
                            if (didErr) throw err;
                        }
                    }
                };
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var string = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].string, arrayOf = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].arrayOf, satisfies = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].satisfies, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].boolean, number = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].number, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].enumerables;
            var componentEntity = {
                linkDestination: string.defaultsTo("javascript:void(0)"),
                text: string
            };
            var customBarEntity = {
                logoText: string.withHTML(_utils_allowLists__WEBPACK_IMPORTED_MODULE_7__["base"]),
                expanded: boolean.defaultsTo(false),
                leftControls: arrayOf(satisfies(componentEntity)).withMaxLength(3).withChangedCallback(setBar),
                rightControls: arrayOf(satisfies(componentEntity)).withMaxLength(3).withChangedCallback(setBar),
                opacity: enumerables(string, "high", "full").defaultsTo("full")
            };
            function setBar() {
                this._leftControl && this._rightControl && this._setBarSizes();
            }
            var entity = _objectSpread({
                variant: enumerables(string, "default", "custom").defaultsTo("default"),
                maxWidth: string,
                containerAccessibleRole: string.defaultsTo("banner"),
                containerAccessibleRoleFlag: boolean.defaultsTo(true),
                headingLevel: number.withMinSize(1).withMaxSize(6),
                logo: string.withChangedCallback(),
                logoMobile: string.withChangedCallback(),
                logoDestination: string,
                logoAccessibleText: string,
                menuButton: boolean.defaultsTo(false),
                menuButtonInactive: boolean.defaultsTo(false),
                menuButtonData: satisfies(_menu_button__WEBPACK_IMPORTED_MODULE_4__["entity"]),
                accessibleHamburgerMenuName: string.defaultsTo("Menu"),
                accessibleHamburgerMenuButtonName: string,
                securityButton: boolean.defaultsTo(false),
                securityButtonInactive: boolean.defaultsTo(false),
                securityButtonAccessibleText: string,
                conversationDeckButton: boolean.defaultsTo(false),
                conversationDeckButtonInactive: boolean.defaultsTo(false),
                conversationDeckNumber: number.withMinSize(1),
                conversationDeckButtonAccessibleText: string,
                profileAndSettingsButton: boolean.defaultsTo(false),
                profileAndSettingsButtonInactive: boolean.defaultsTo(false),
                profileAndSettingsData: satisfies(_menu_button__WEBPACK_IMPORTED_MODULE_4__["entity"]),
                profileAndSettingsButtonAccessibleText: string,
                openAccountButtonText: string,
                openAccountButtonInactive: boolean.defaultsTo(false),
                openAccountButtonAccessibleText: string,
                signInOutButtonText: string,
                signInOutButtonAccessibleText: string,
                searchEnabled: boolean,
                searchButtonAccessibleText: string,
                searchButtonInactive: boolean.defaultsTo(false),
                searchBoxSlot: boolean,
                searchBoxData: satisfies(_search_box__WEBPACK_IMPORTED_MODULE_3__["entity"]),
                searchBoxCancelButtonText: string,
                searchBoxCancelButtonAccessibleText: string,
                opaque: boolean.defaultsTo(true)
            }, customBarEntity);
            var MdsBrandBar = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsBrandBar, _AgaveComponent);
                _createClass(MdsBrandBar, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsBrandBar";
                    }
                } ]);
                function MdsBrandBar() {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsBrandBar);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsBrandBar).call(this));
                    _this._createCustomSlot = function() {
                        _newArrowCheck(this, _this2);
                        return Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["createSlot"])("conversation-deck-slot", [ "brand-bar__slot", "brand-bar__slot--custom" ]);
                    }.bind(this);
                    _this._applyNewCustomSlot = function() {
                        _newArrowCheck(this, _this2);
                        _this._slotPlacement = _this._currentSlotTrigger && _this._currentSlotTrigger.id;
                        if (_this._slotPlacement) {
                            _this.shadowRoot.getElementById(_this._slotPlacement) && _this.shadowRoot.getElementById(_this._slotPlacement).setAttribute("aria-expanded", true);
                            _this._hideDefaultSlot();
                        } else {
                            _this._injectDefaultSlot();
                        }
                        _this._updateSlotTrigger();
                    }.bind(this);
                    _this._updateSlotTrigger = function(event) {
                        _newArrowCheck(this, _this2);
                        _this._currentSlotTrigger = event ? event.target : false;
                    }.bind(this);
                    _this._hideDefaultSlot = function() {
                        _newArrowCheck(this, _this2);
                        _this._showDefaultSlot = false;
                    }.bind(this);
                    _this._injectDefaultSlot = function() {
                        _newArrowCheck(this, _this2);
                        if (_this._slotPlacement) {
                            _this.shadowRoot.getElementById(_this._slotPlacement) && _this.shadowRoot.getElementById(_this._slotPlacement).removeAttribute("aria-expanded");
                        }
                        _this._slotPlacement = "brand-bar--".concat(_this.id);
                        _this._showDefaultSlot = true;
                    }.bind(this);
                    _this._handleHamburgerMenuNodeClick = function(event) {
                        var _this3 = this;
                        _newArrowCheck(this, _this2);
                        event.stopPropagation();
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this3);
                            return "click-menu-hamburger";
                        }.bind(this), _assertThisInitialized(_this))({
                            target: _this._searchBoxNode,
                            detail: event
                        });
                    }.bind(this);
                    _this._handleHamburgerMenuNodeOpen = function(event) {
                        var _this4 = this;
                        _newArrowCheck(this, _this2);
                        event.stopPropagation();
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this4);
                            return "open-hamburger";
                        }.bind(this), _assertThisInitialized(_this))({
                            target: _this._searchBoxNode,
                            detail: event
                        });
                    }.bind(this);
                    _this._handleHamburgerMenuNodeClose = function(event) {
                        var _this5 = this;
                        _newArrowCheck(this, _this2);
                        event.stopPropagation();
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this5);
                            return "close-hamburger";
                        }.bind(this), _assertThisInitialized(_this))({
                            target: _this._searchBoxNode,
                            detail: event
                        });
                    }.bind(this);
                    _this._handleProfileAndSettingsMenuNodeClickMenu = function(event) {
                        var _this6 = this;
                        _newArrowCheck(this, _this2);
                        event.stopPropagation();
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this6);
                            return "click-menu-profile-and-settings";
                        }.bind(this), _assertThisInitialized(_this))({
                            target: _this._searchBoxNode,
                            detail: event
                        });
                    }.bind(this);
                    _this._handleProfileAndSettingsMenuNodeOpen = function(event) {
                        var _this7 = this;
                        _newArrowCheck(this, _this2);
                        event.stopPropagation();
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this7);
                            return "open-profile-and-settings";
                        }.bind(this), _assertThisInitialized(_this))({
                            target: _this._searchBoxNode,
                            detail: event
                        });
                    }.bind(this);
                    _this._handleProfileAndSettingsMenuNodeClose = function(event) {
                        var _this8 = this;
                        _newArrowCheck(this, _this2);
                        event.stopPropagation();
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this8);
                            return "close-profile-and-settings";
                        }.bind(this), _assertThisInitialized(_this))({
                            target: _this._searchBoxNode,
                            detail: event
                        });
                    }.bind(this);
                    _this.resizeSlot = function() {
                        _newArrowCheck(this, _this2);
                        var animatingSlot = _this._currentSlot || _this.shadowRoot.querySelector(".brand-bar__slot");
                        var contentSlot = _this.querySelector('[slot="conversation-deck-slot"]');
                        var contentSlotHeight = contentSlot ? "".concat(contentSlot.offsetHeight, "px") : 0;
                        if (_this._slotPlacement !== "brand-bar--".concat(_this.id)) {
                            animatingSlot.style.height = contentSlotHeight;
                            _this.shadowRoot.querySelector(".brand-bar__container").style.marginBottom = contentSlotHeight;
                        } else {
                            animatingSlot.style.height = "auto";
                        }
                    }.bind(this);
                    _this._animateSlotClosed = function() {
                        _newArrowCheck(this, _this2);
                        var animatingSlot = _this._currentSlot || _this.shadowRoot.querySelector(".brand-bar__slot");
                        animatingSlot.style.height = 0;
                        _this.shadowRoot.querySelector(".brand-bar__container").style.marginBottom = _this._showDefaultSlot ? 0 : "".concat(animatingSlot.offsetHeight, "px");
                    }.bind(this);
                    _this._resizeListener = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["debounce"])(_this._resizeListener.bind(_assertThisInitialized(_this)), 100);
                    window.addEventListener("resize", _this._resizeListener);
                    _this.defineObservedProperty("_currentLogo", Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["getBreakpoint"])() === "xs" || Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["getBreakpoint"])() === "sm" ? _this.logoMobile : _this.logo);
                    _this.defineObservedProperty("_searchBoxPosition", "inline");
                    _this.defineObservedProperty("_searchBoxExpanding", false);
                    _this.defineObservedProperty("_searchBoxExpanded", false);
                    _this.defineObservedProperty("_searchBoxCollapsing", false);
                    _this.defineObservedProperty("_searchBoxOverflowExpand", false);
                    _this.defineObservedProperty("_convoDeckExpanding", false);
                    _this.defineObservedProperty("_convoDeckCollapsing", false);
                    _this.defineObservedProperty("_convoDeckTransitioned", false);
                    _this.defineObservedProperty("_slotPlacement", "");
                    _this.defineObservedProperty("_securityButton", _this.securityButton);
                    _this.defineObservedProperty("_searchEnabled", _this.searchEnabled);
                    _this.defineObservedProperty("_signInOutButtonText", _this.signInOutButtonText);
                    _this.defineObservedProperty("_conversationDeckButton", _this.conversationDeckButton);
                    _this.defineObservedProperty("_openAccountButtonText", _this.openAccountButtonText);
                    _this.defineObservedProperty("_profileAndSettingsButton", _this.profileAndSettingsButton);
                    _this.defineObservedProperty("_searchBoxCancelButtonText", _this.searchBoxCancelButtonText);
                    _this.defineObservedProperty("_showDefaultSlot", true);
                    _this._dispatchCustomEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["createCustomEventDispatcher"])();
                    _this._dispatchCustomClickEventWrapper = _this._dispatchCustomClickEventWrapper.bind(_assertThisInitialized(_this));
                    _this._setBarSizes = _this._setBarSizes.bind(_assertThisInitialized(_this));
                    _this._getLogoWidth = _this._getLogoWidth.bind(_assertThisInitialized(_this));
                    _this._onclick = _this._onclick.bind(_assertThisInitialized(_this));
                    _this.expandContainerSlot = _this.expandContainerSlot.bind(_assertThisInitialized(_this));
                    _this.collapseContainerSlot = _this.collapseContainerSlot.bind(_assertThisInitialized(_this));
                    _this._onSearchButtonClick = _this._onSearchButtonClick.bind(_assertThisInitialized(_this));
                    _this._handleSearchBoxDefault = _this._handleSearchBoxDefault.bind(_assertThisInitialized(_this));
                    _this._handleSearchBoxCustom = _this._handleSearchBoxCustom.bind(_assertThisInitialized(_this));
                    _this._onSearchCancelButtonClick = _this._onSearchCancelButtonClick.bind(_assertThisInitialized(_this));
                    _this._onSearchBoxInput = _this._onSearchBoxInput.bind(_assertThisInitialized(_this));
                    _this._onSearchBoxKeydown = _this._onSearchBoxKeydown.bind(_assertThisInitialized(_this));
                    _this._onSearchBoxKeyup = _this._onSearchBoxKeyup.bind(_assertThisInitialized(_this));
                    _this._closeSearchSlot = _this._closeSearchSlot.bind(_assertThisInitialized(_this));
                    _this.defineObservedProperty("slotContainerExpanded", false);
                    return _this;
                }
                _createClass(MdsBrandBar, [ {
                    key: "_dispatchCustomClickEventWrapper",
                    value: function _dispatchCustomClickEventWrapper(event) {
                        this._updateSlotTrigger(event);
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["createCustomEventDispatcher"])()(event);
                    }
                }, {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        return {
                            interactiveElement: this.shadowRoot.getElementById(payload.target)
                        };
                    }
                }, {
                    key: "_resizeListener",
                    value: function _resizeListener() {
                        this._currentLogo = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["getBreakpoint"])() === "xs" || Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["getBreakpoint"])() === "sm" ? this.logoMobile : this.logo;
                        this.variant === "custom" && this._setBarSizes();
                    }
                }, {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        var _this9 = this;
                        _get(_getPrototypeOf(MdsBrandBar.prototype), "connectedCallback", this).call(this);
                        this._brandBar = this.shadowRoot.querySelector(".brand-bar__container-wrap");
                        this._slotPlacement = "brand-bar--".concat(this.id);
                        this._currentLogo = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["getBreakpoint"])() === "xs" || Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["getBreakpoint"])() === "sm" ? this.logoMobile : this.logo;
                        setTimeout(function() {
                            _newArrowCheck(this, _this9);
                            if (this.searchBoxData) {
                                if (this.searchBoxData.variant && this.searchBoxData.variant !== "box") {
                                    this.throwConstraintError("Only box variant of the search box is allowed inside a brand bar");
                                }
                                if (this.searchBoxData.labelStyle && this.searchBoxData.labelStyle !== "hidden") {
                                    this.throwConstraintError("Only hidden label style of the search box is allowed inside a brand bar");
                                }
                            }
                            if (this._searchBoxNode) {
                                if (MDS.isMobile) {
                                    this._searchBoxNode.ariaHidden = true;
                                } else {
                                    this._searchBoxNode.tabIndex = -1;
                                }
                            }
                        }.bind(this));
                        this.variant === "custom" && window.addEventListener("load", this._setBarSizes);
                    }
                }, {
                    key: "renderedCallback",
                    value: function renderedCallback() {
                        this._removeEventListeners();
                        this._addEventListeners();
                    }
                }, {
                    key: "disconnectedCallback",
                    value: function disconnectedCallback() {
                        _get(_getPrototypeOf(MdsBrandBar.prototype), "disconnectedCallback", this) && _get(_getPrototypeOf(MdsBrandBar.prototype), "disconnectedCallback", this).call(this);
                        window.removeEventListener("resize", this._resizeListener);
                    }
                }, {
                    key: "_closeSearchSlot",
                    value: function _closeSearchSlot(event) {
                        var _this10 = this;
                        if (this._searchBoxExpanded) {
                            this._searchBoxExpanded = false;
                            this._searchBoxCollapsing = false;
                            this._searchBoxExpanding = false;
                            this._searchBoxOverflowExpand = false;
                            document.removeEventListener("click", this._closeSearchSlot);
                            Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["createCustomEventDispatcher"])(function() {
                                _newArrowCheck(this, _this10);
                                return "search-close";
                            }.bind(this), this)(event, {
                                isSearchBoxExpanded: false
                            });
                        }
                        var button = this.shadowRoot.querySelector("#brand_bar_hamburger_menu");
                        button && button.classList.remove("brand-bar__hidden");
                    }
                }, {
                    key: "_removeEventListeners",
                    value: function _removeEventListeners() {
                        if (this._hamburgerMenuNode) {
                            this._hamburgerMenuNode.removeEventListener("click-menu", this._handleHamburgerMenuNodeClick);
                            this._hamburgerMenuNode.removeEventListener("open", this._handleHamburgerMenuNodeOpen);
                            this._hamburgerMenuNode.removeEventListener("close", this._handleHamburgerMenuNodeClose);
                        }
                        if (this._profileAndSettingsMenuNode) {
                            this._profileAndSettingsMenuNode.removeEventListener("click-menu", this._handleProfileAndSettingsMenuNodeClickMenu);
                            this._profileAndSettingsMenuNode.removeEventListener("open", this._handleProfileAndSettingsMenuNodeOpen);
                            this._profileAndSettingsMenuNode.removeEventListener("close", this._handleProfileAndSettingsMenuNodeClose);
                        }
                    }
                }, {
                    key: "_addEventListeners",
                    value: function _addEventListeners() {
                        if (this._hamburgerMenuNode) {
                            this._hamburgerMenuNode.addEventListener("click-menu", this._handleHamburgerMenuNodeClick);
                            this._hamburgerMenuNode.addEventListener("open", this._handleHamburgerMenuNodeOpen);
                            this._hamburgerMenuNode.addEventListener("close", this._handleHamburgerMenuNodeClose);
                        }
                        if (this._profileAndSettingsMenuNode) {
                            this._profileAndSettingsMenuNode.addEventListener("click-menu", this._handleProfileAndSettingsMenuNodeClickMenu);
                            this._profileAndSettingsMenuNode.addEventListener("open", this._handleProfileAndSettingsMenuNodeOpen);
                            this._profileAndSettingsMenuNode.addEventListener("close", this._handleProfileAndSettingsMenuNodeClose);
                        }
                    }
                }, {
                    key: "expandContainerSlot",
                    value: function expandContainerSlot() {
                        var _this11 = this;
                        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                            detail: {}
                        };
                        this._applyNewCustomSlot();
                        this.slotContainerExpanded = true;
                        this.resizeSlot();
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this11);
                            return "expand-container";
                        }.bind(this), this)(event, _extends({}, event.detail, {
                            slotContainerExpanded: true
                        }));
                    }
                }, {
                    key: "collapseContainerSlot",
                    value: function collapseContainerSlot() {
                        var _this12 = this;
                        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                            detail: {}
                        };
                        this.slotContainerExpanded = false;
                        this._injectDefaultSlot();
                        this._animateSlotClosed();
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this12);
                            return "collapse-container";
                        }.bind(this), this)(event, _extends({}, event.detail, {
                            slotContainerExpanded: false
                        }));
                    }
                }, {
                    key: "_onSearchBoxInput",
                    value: function _onSearchBoxInput(event) {
                        var _this13 = this;
                        event.stopPropagation();
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this13);
                            return "input-search-box";
                        }.bind(this), this)({
                            target: this._searchBoxNode,
                            detail: event
                        });
                    }
                }, {
                    key: "_onSearchBoxKeyup",
                    value: function _onSearchBoxKeyup(event) {
                        var _this14 = this;
                        event.stopPropagation();
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this14);
                            return "keyup-search-box";
                        }.bind(this), this)({
                            target: this._searchBoxNode,
                            detail: event
                        });
                    }
                }, {
                    key: "_onSearchBoxKeydown",
                    value: function _onSearchBoxKeydown(event) {
                        var _this15 = this;
                        event.stopPropagation();
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this15);
                            return "keydown-search-box";
                        }.bind(this), this)({
                            target: this._searchBoxNode,
                            detail: event
                        });
                    }
                }, {
                    key: "_onclick",
                    value: function _onclick(event) {
                        var _this16 = this;
                        if (event.target.type === "button" || event.target === this.shadowRoot.querySelector("mds-search-box") || event.target === this.querySelector("mds-search-box")) {
                            event.preventDefault();
                            event.stopPropagation();
                            return;
                        }
                        _get(_getPrototypeOf(MdsBrandBar.prototype), "_onclick", this) && _get(_getPrototypeOf(MdsBrandBar.prototype), "_onclick", this).call(this, event);
                        if (this._searchBoxExpanding) {
                            if (Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["getBreakpoint"])() === "xs" && this.variant === "default") {
                                event.preventDefault();
                                return;
                            }
                            if (this.searchBoxSlot) {
                                this._searchBoxExpanding = false;
                                this._searchBoxCollapsing = true;
                                this._searchBoxExpanded = false;
                                window.setTimeout(function() {
                                    _newArrowCheck(this, _this16);
                                    this._searchBoxCollapsing = false;
                                }.bind(this), 500);
                                return;
                            }
                            this._searchBoxNode.tabIndex = -1;
                            this._searchBoxExpanding = false;
                            this._searchBoxCollapsing = true;
                            window.setTimeout(function() {
                                _newArrowCheck(this, _this16);
                                this._searchBoxExpanded = false;
                                this._searchBoxCollapsing = false;
                            }.bind(this), 500);
                        }
                    }
                }, {
                    key: "_onSearchButtonClick",
                    value: function _onSearchButtonClick(event) {
                        var _this17 = this;
                        document.addEventListener("click", this._closeSearchSlot);
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this17);
                            return "search-open";
                        }.bind(this), this)(event, {
                            isSearchBoxExpanded: true
                        });
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this17);
                            return "click-search_button";
                        }.bind(this), this)(event, {
                            open: !(this._searchBoxExpanding || this._searchBoxOverflowExpand)
                        });
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this17);
                            return "click-brand_bar_search_button";
                        }.bind(this), this)(event, {
                            open: !(this._searchBoxExpanding || this._searchBoxOverflowExpand)
                        });
                        this.variant === "default" ? this._handleSearchBoxDefault(event) : this._handleSearchBoxCustom(event);
                    }
                }, {
                    key: "_onSearchCancelButtonClick",
                    value: function _onSearchCancelButtonClick(event) {
                        var _this18 = this;
                        this._searchBoxNode.tabIndex = -1;
                        this._searchBoxExpanding = false;
                        this._searchBoxCollapsing = true;
                        window.setTimeout(function() {
                            _newArrowCheck(this, _this18);
                            this._searchBoxExpanded = false;
                            this._searchBoxCollapsing = false;
                        }.bind(this), 500);
                        var _iterator = _createForOfIteratorHelper(this.shadowRoot.querySelectorAll("mds-button")), _step;
                        try {
                            for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                                var button = _step.value;
                                if (button.id !== "brand_bar__search_cancel" || button.id !== "brand_bar_search_button") {
                                    button.classList.remove("brand-bar__hidden");
                                }
                            }
                        } catch (err) {
                            _iterator.e(err);
                        } finally {
                            _iterator.f();
                        }
                        this.shadowRoot.querySelector(".brand-bar__logo-container").classList.remove("brand-bar__hidden");
                    }
                }, {
                    key: "_handleSearchBoxDefault",
                    value: function _handleSearchBoxDefault(event) {
                        var _this19 = this;
                        if (Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["getBreakpoint"])() === "xs") {
                            var _iterator2 = _createForOfIteratorHelper(this.shadowRoot.querySelectorAll("mds-button")), _step2;
                            try {
                                for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
                                    var button = _step2.value;
                                    if (button.id !== "brand_bar__search_cancel" || button.id !== "brand_bar_search_button") {
                                        button.classList.add("brand-bar__hidden");
                                    }
                                }
                            } catch (err) {
                                _iterator2.e(err);
                            } finally {
                                _iterator2.f();
                            }
                            var searchBox = this.querySelector("mds-search-box") || this.shadowRoot.querySelector("mds-search-box");
                            if (this._searchBoxCancelButtonText) {
                                searchBox.style.minWidth = "100%";
                            }
                            this.shadowRoot.querySelector(".brand-bar__logo-container").classList.add("brand-bar__hidden");
                        }
                        if (this.searchBoxSlot) {
                            this._searchBoxExpanding = !this._searchBoxExpanding;
                            window.setTimeout(function() {
                                _newArrowCheck(this, _this19);
                                this._searchBoxExpanded = !this._searchBoxExpanded;
                            }.bind(this), 100);
                            this.querySelector(".brand-bar__search-box") && this.querySelector(".brand-bar__search-box").focus();
                            return;
                        }
                        if (this._searchBoxExpanding) {
                            this._searchBoxNode.tabIndex = -1;
                        } else {
                            this._searchBoxNode.removeAttribute("tabIndex");
                        }
                        this._searchBoxExpanding = !this._searchBoxExpanding;
                        window.setTimeout(function() {
                            _newArrowCheck(this, _this19);
                            this._searchBoxExpanded = !this._searchBoxExpanded;
                        }.bind(this), 100);
                        this.shadowRoot.querySelector(".brand-bar__search-box") && this.shadowRoot.querySelector(".brand-bar__search-box").focus();
                    }
                }, {
                    key: "_handleSearchBoxCustom",
                    value: function _handleSearchBoxCustom(event) {
                        var _this20 = this;
                        this._findSearchBoxPosition();
                        if (!MDS.isMobile) {
                            if (this._searchBoxPosition === "inline") {
                                if (this._searchBoxExpanding) {
                                    this._searchBoxNode.tabIndex = -1;
                                } else {
                                    this._searchBoxNode.removeAttribute("tabIndex");
                                }
                                this._searchBoxOverflowExpand = false;
                                this._searchBoxExpanding = !this._searchBoxExpanding;
                                window.setTimeout(function() {
                                    _newArrowCheck(this, _this20);
                                    this._searchBoxExpanded = !this._searchBoxExpanded;
                                }.bind(this), 100);
                                this.shadowRoot.querySelector(".brand-bar__search-box") && this.shadowRoot.querySelector(".brand-bar__search-box").focus();
                            } else {
                                if (this._searchBoxOverflowExpand) {
                                    this._searchBoxNode.tabIndex = -1;
                                } else {
                                    this._searchBoxNode.removeAttribute("tabIndex");
                                }
                                this._searchBoxOverflowExpand = !this._searchBoxOverflowExpand;
                                window.setTimeout(function() {
                                    _newArrowCheck(this, _this20);
                                    var searchBox = this.shadowRoot.querySelector(".brand-bar__search-box-overflow");
                                    if (searchBox) {
                                        searchBox.style.position = "absolute";
                                        searchBox.focus();
                                        searchBox.style.position = "unset";
                                    }
                                }.bind(this), 500);
                            }
                        } else {
                            this._searchBoxOverflowExpand = !this._searchBoxOverflowExpand;
                            if (this._searchBoxOverflowExpand) {
                                this._searchBoxNode.ariaHidden = false;
                                this.shadowRoot.querySelector(".brand-bar__search-box-overflow").focus();
                            } else {
                                this._searchBoxNode.ariaHidden = true;
                            }
                        }
                    }
                }, {
                    key: "_setBarSizes",
                    value: function _setBarSizes() {
                        var leftControlContainer = this._leftControlContainer;
                        var rightControlContainer = this._rightControlContainer;
                        this._leftControlWidth = leftControlContainer ? leftControlContainer.offsetWidth : 0;
                        this._rightControlWidth = rightControlContainer ? rightControlContainer.offsetWidth : 0;
                        this._logoContainer = this.shadowRoot.querySelector(".brand-bar__logo-container");
                        var largerControlContainerWidth = Math.max(this._leftControlWidth, this._rightControlWidth);
                        var total = largerControlContainerWidth * 2 + this._getLogoWidth();
                    }
                }, {
                    key: "_getLogoWidth",
                    value: function _getLogoWidth() {
                        if (this.shadowRoot.querySelector(".brand-bar__image")) {
                            var responsiveLogoHeight = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["getBreakpoint"])() === "xs" ? Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssValue"])("24px") : Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssValue"])("32px");
                            var imageWidth = this.shadowRoot.querySelector(".brand-bar__image").width;
                            var imageHeight = this.shadowRoot.querySelector(".brand-bar__image").height;
                            return imageWidth * responsiveLogoHeight / imageHeight;
                        }
                        return 0;
                    }
                }, {
                    key: "_findSearchBoxPosition",
                    value: function _findSearchBoxPosition() {
                        var leftControlContainer = this._leftControlContainer;
                        var rightControlContainer = this._rightControlContainer;
                        this._leftControlWidth = leftControlContainer ? leftControlContainer.offsetWidth : 0;
                        this._rightControlWidth = rightControlContainer ? rightControlContainer.offsetWidth : 0;
                        var totalWidth = this.shadowRoot.querySelector(".brand-bar__container").offsetWidth;
                        var totalRequiredWidth = this._leftControlWidth + this._rightControlWidth + 600;
                        if (Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["getBreakpoint"])() === "xs" || totalRequiredWidth > totalWidth) {
                            this._searchBoxPosition = "overflow";
                        } else {
                            this._searchBoxPosition = "inline";
                        }
                    }
                }, {
                    key: "logoChangedCallback",
                    value: function logoChangedCallback() {
                        if (Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["getBreakpoint"])() !== "xs" && Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["getBreakpoint"])() !== "sm") {
                            this._currentLogo = this.logo;
                        }
                    }
                }, {
                    key: "logoMobileChangedCallback",
                    value: function logoMobileChangedCallback() {
                        if (Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["getBreakpoint"])() === "xs" || Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["getBreakpoint"])() === "sm") {
                            this._currentLogo = this.logoMobile;
                        }
                    }
                }, {
                    key: "render",
                    value: function render() {
                        _MdsBrandBar__WEBPACK_IMPORTED_MODULE_2__["default"].call(this);
                    }
                }, {
                    key: "_searchBoxNode",
                    get: function get() {
                        return this.shadowRoot.querySelector("mds-search-box") || this.shadowRoot.querySelector(".brand-bar__search-box") || this.shadowRoot.querySelector(".brand-bar__search-box-slot");
                    }
                }, {
                    key: "_hamburgerMenuNode",
                    get: function get() {
                        return this.shadowRoot.getElementById("brand_bar_hamburger_menu_button");
                    }
                }, {
                    key: "_profileAndSettingsMenuNode",
                    get: function get() {
                        return this.shadowRoot.getElementById("brand_bar_profile_and_settings_menu_button");
                    }
                }, {
                    key: "_leftControlContainer",
                    get: function get() {
                        return this.shadowRoot.querySelector(".brand-bar__left-container");
                    }
                }, {
                    key: "_rightControlContainer",
                    get: function get() {
                        return this.shadowRoot.querySelector(".brand-bar__right-container");
                    }
                } ]);
                return MdsBrandBar;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["AgaveComponent"]), _class2.styles = _mds_brand_bar_scss__WEBPACK_IMPORTED_MODULE_1___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsBrandBar;
        },
        "./src/brand-bar/mds-brand-bar.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/brand-bar/mds-brand-bar.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/breadcrumb/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_breadcrumb_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/breadcrumb/mds-breadcrumb.scss");
            var _mds_breadcrumb_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_breadcrumb_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            var _li$wrapper = function _li$wrapper(_child) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("li", null, null, "class", "breadcrumb__list-item", "role", "listitem");
                _renderArbitrary(_child);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "breadcrumb__separator", "aria-hidden", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(" / ");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("li");
            }, _span$wrapper = function _span$wrapper(_link$text) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "breadcrumb__link--inactive", "role", "link", "aria-disabled", "true");
                _renderArbitrary(_link$text);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            }, _mdsLink$wrapper = function _mdsLink$wrapper(_link) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("mds-link");
                _spreadAttribute(_link);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("underline", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "breadcrumb__link");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("mds-link");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-link");
            };
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["mixins"].AttributeMarshallingMixin, arrayOf = _mixins$AttributeMars.arrayOf, boolean = _mixins$AttributeMars.boolean, string = _mixins$AttributeMars.string, stringRequired = _mixins$AttributeMars.stringRequired, satisfies = _mixins$AttributeMars.satisfies;
            var linkEntity = {
                text: stringRequired.withMaxLength(80),
                inactive: boolean.defaultsTo(false),
                href: string.defaultsTo("javascript:void(0)"),
                accessibleText: string.defaultsTo("")
            };
            var entity = {
                links: arrayOf(satisfies(linkEntity)).withMaxLength(2).withChangedCallback(),
                currentPage: string,
                accessibleBreadcrumbName: string.defaultsTo("breadcrumb")
            };
            var MdsBreadcrumb = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsBreadcrumb, _AgaveComponent);
                _createClass(MdsBreadcrumb, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsBreadcrumb";
                    }
                } ]);
                function MdsBreadcrumb() {
                    _classCallCheck(this, MdsBreadcrumb);
                    return _possibleConstructorReturn(this, _getPrototypeOf(MdsBreadcrumb).call(this));
                }
                _createClass(MdsBreadcrumb, [ {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                            index: 0
                        };
                        return {
                            interactiveElement: this.shadowRoot.querySelectorAll("mds-link")[payload.index]
                        };
                    }
                }, {
                    key: "linksChangedCallback",
                    value: function linksChangedCallback(links) {
                        var _this = this;
                        links.forEach(function(link, index) {
                            var _this2 = this;
                            _newArrowCheck(this, _this);
                            if (!link.id) {
                                link.id = "link".concat(index + 1);
                            }
                            link.onclick = function(event) {
                                var _this3 = this;
                                _newArrowCheck(this, _this2);
                                Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                                    _newArrowCheck(this, _this3);
                                    return "click-".concat(link.id);
                                }.bind(this), this)(event, {
                                    index: index
                                });
                                Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                                    _newArrowCheck(this, _this3);
                                    return "click-link";
                                }.bind(this), this)(event, {
                                    index: index
                                });
                            }.bind(this);
                        }.bind(this));
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var _this4 = this;
                        var links = this.links, currentPage = this.currentPage, accessibleBreadcrumbName = this.accessibleBreadcrumbName;
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("nav", null, null, "class", "breadcrumb", "aria-label", accessibleBreadcrumbName);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("ol", null, null, "class", "breadcrumb__list", "role", "list");
                        _renderArbitrary(links.map(function(link) {
                            _newArrowCheck(this, _this4);
                            return _jsxWrapper(_li$wrapper, [ link.inactive ? _jsxWrapper(_span$wrapper, [ link.text ]) : _jsxWrapper(_mdsLink$wrapper, [ link ]) ]);
                        }.bind(this)));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("li", null, null, "class", "breadcrumb__list-item", "role", "listitem");
                        _renderArbitrary(currentPage ? (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "role", "link", "aria-disabled", "true", "aria-current", "page"), 
                        _renderArbitrary(currentPage), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")) : Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "name", "select-slot"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("li");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("ol");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("nav");
                    }
                } ]);
                return MdsBreadcrumb;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["AgaveComponent"]), _class2.styles = _mds_breadcrumb_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsBreadcrumb;
        },
        "./src/breadcrumb/mds-breadcrumb.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/breadcrumb/mds-breadcrumb.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/breadcrumbs/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_breadcrumbs_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/breadcrumbs/mds-breadcrumbs.scss");
            var _mds_breadcrumbs_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_breadcrumbs_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            var _li$wrapper = function _li$wrapper(_child) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("li", null, null, "class", "breadcrumbs__list-item");
                _renderArbitrary(_child);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "breadcrumbs__separator", "aria-hidden", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(" ");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(" /");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(" ");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("li");
            }, _span$wrapper = function _span$wrapper(_link$text) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "breadcrumbs__link--inactive", "role", "link", "aria-disabled", "true");
                _renderArbitrary(_link$text);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            }, _mdsLink$wrapper = function _mdsLink$wrapper(_link, _this$dispatchClickEv) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("mds-link");
                _spreadAttribute(_link);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("underline", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onclick", _this$dispatchClickEv);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "breadcrumbs__link");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("mds-link");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-link");
            };
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["mixins"].AttributeMarshallingMixin, arrayOf = _mixins$AttributeMars.arrayOf, boolean = _mixins$AttributeMars.boolean, string = _mixins$AttributeMars.string, stringRequired = _mixins$AttributeMars.stringRequired, satisfies = _mixins$AttributeMars.satisfies;
            var linkEntity = {
                text: stringRequired.withMaxLength(80),
                inactive: boolean.defaultsTo(false),
                href: string.defaultsTo("javascript:void(0)"),
                accessibleText: string.defaultsTo("")
            };
            var entity = {
                links: arrayOf(satisfies(linkEntity)).withMaxLength(2).withChangedCallback(),
                currentPage: string,
                accessibleBreadcrumbName: string.defaultsTo("breadcrumbs")
            };
            var MdsBreadcrumbs = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsBreadcrumbs, _AgaveComponent);
                _createClass(MdsBreadcrumbs, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsBreadcrumbs";
                    }
                } ]);
                function MdsBreadcrumbs() {
                    var _this;
                    _classCallCheck(this, MdsBreadcrumbs);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsBreadcrumbs).call(this));
                    _this.dispatchClickEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])();
                    return _this;
                }
                _createClass(MdsBreadcrumbs, [ {
                    key: "linksChangedCallback",
                    value: function linksChangedCallback(links) {
                        var _this2 = this;
                        links.forEach(function(link, index) {
                            _newArrowCheck(this, _this2);
                            if (!link.id) {
                                link.id = "link".concat(index + 1);
                            }
                        }.bind(this));
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var _this3 = this;
                        console.error("MdsBreadcrumbs was renamed to MdsBreadcrumb in Nov 2020. This component will be deprecated and removed in Nov 2021. New features and bugfixes will only be available on the MdsBreadcrumb.");
                        var links = this.links, currentPage = this.currentPage, accessibleBreadcrumbName = this.accessibleBreadcrumbName;
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("nav", null, null, "class", "breadcrumbs", "aria-label", accessibleBreadcrumbName);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("ol", null, null, "class", "breadcrumbs__list");
                        _renderArbitrary(links.map(function(link) {
                            _newArrowCheck(this, _this3);
                            return _jsxWrapper(_li$wrapper, [ link.inactive ? _jsxWrapper(_span$wrapper, [ link.text ]) : _jsxWrapper(_mdsLink$wrapper, [ link, this.dispatchClickEvent ]) ]);
                        }.bind(this)));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("li");
                        _renderArbitrary(currentPage ? (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "breadcrumbs__label"), 
                        _renderArbitrary(currentPage), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")) : Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "name", "select-slot"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("li");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("ol");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("nav");
                    }
                } ]);
                return MdsBreadcrumbs;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["AgaveComponent"]), _class2.styles = _mds_breadcrumbs_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsBreadcrumbs;
        },
        "./src/breadcrumbs/mds-breadcrumbs.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/breadcrumbs/mds-breadcrumbs.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/calendar/MdsCalendar.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _span$wrapper = function _span$wrapper() {
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("span", null, null, "class", "activity-indicator");
            }, _div$wrapper = function _div$wrapper(_deferred, _args) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "calendar__body__date-list", "role", "list");
                _renderArbitrary(_deferred.call(_args[0], _args[1]));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }, _div$wrapper2 = function _div$wrapper2(_deferred2, _key, _deferred3, _args2) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "calendar__body__month-heading", "role", "heading", "aria-level", "3");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "aria-hidden", "true");
                _renderArbitrary(_deferred2.toLocaleUpperCase());
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text");
                _renderArbitrary(_key);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "calendar__body__date-list", "role", "list");
                _renderArbitrary(_deferred3.call(_args2[0], _args2[1]));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            };
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            var VIEW_TYPE = {
                MONTH: "month",
                ROLLING: "rolling"
            };
            function renderWeekdayHeaders() {
                var _this = this;
                var weekdayHeaders = this.weekdayHeaders;
                return weekdayHeaders.map(function(weekday) {
                    _newArrowCheck(this, _this);
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "calendar__weekday-header__weekday");
                    _renderArbitrary(weekday);
                    return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                }.bind(this));
            }
            function renderActivityIndicator(date) {
                return date.hasActivity ? _jsxWrapper(_span$wrapper) : "";
            }
            function renderDaysInMonthContent(currentDateMarker, date) {
                var dateCellClasses = "calendar__body__date-list__grid-cell__content";
                if (currentDateMarker && date.dayDiffs === 0) {
                    dateCellClasses = "current-date-indicator ".concat(dateCellClasses);
                } else if (date.dayDiffs > 0) {
                    dateCellClasses = "past-date ".concat(dateCellClasses);
                }
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", dateCellClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "aria-hidden", "true");
                _renderArbitrary(date.dayOfMonth);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                _renderArbitrary(renderActivityIndicator(date));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text");
                _renderArbitrary(date.dayOfMonthAccessibleText);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function renderDaysInMonthGrid(month) {
                var _this2 = this;
                var currentDateMarker = this.currentDateMarker, dates = this.dates;
                dates[month].map(function(date, idx) {
                    _newArrowCheck(this, _this2);
                    var columnOffset = "";
                    if (idx === 0) {
                        columnOffset = "grid-column-start-".concat(date.dayOfWeek);
                    }
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "".concat(columnOffset, " calendar__body__date-list__grid-cell"), "role", "listitem");
                    _renderArbitrary(renderDaysInMonthContent(currentDateMarker, date));
                    return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                }.bind(this));
            }
            function renderMonthlyView() {
                var _this3 = this;
                var dates = this.dates;
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "calendar__body initial-calendar-body-padding");
                _renderArbitrary(Object.keys(dates).map(function(key) {
                    _newArrowCheck(this, _this3);
                    return _jsxWrapper(_div$wrapper, [ renderDaysInMonthGrid, [ this, key ] ]);
                }.bind(this)));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function renderRollingWeeklyView() {
                var _this4 = this;
                var dates = this.dates;
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "calendar__body");
                _renderArbitrary(Object.keys(dates).map(function(key) {
                    _newArrowCheck(this, _this4);
                    return _jsxWrapper(_div$wrapper2, [ key.slice(0, 3), key, renderDaysInMonthGrid, [ this, key ] ]);
                }.bind(this)));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function MdsCalendarTemplate() {
                var viewType = this.viewType, todaysDateLabel = this.todaysDateLabel, upcomingActivityLabel = this.upcomingActivityLabel;
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "calendar");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "calendar__weekday-header", "aria-hidden", "true");
                _renderArbitrary(renderWeekdayHeaders.call(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                _renderArbitrary(viewType === VIEW_TYPE.MONTH ? renderMonthlyView.call(this) : renderRollingWeeklyView.call(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "calendar__legend", "aria-hidden", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "current-date-indicator-legend");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "calendar__legend__label");
                _renderArbitrary(todaysDateLabel);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "activity-indicator-legend");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "calendar__legend__label");
                _renderArbitrary(upcomingActivityLabel);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            __webpack_exports__["default"] = MdsCalendarTemplate;
        },
        "./src/calendar/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var moment_timezone__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/moment-timezone/index.js");
            var moment_timezone__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(moment_timezone__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/common-utils.js");
            var _MdsCalendar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/calendar/MdsCalendar.jsx");
            var _mds_calendar_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/calendar/mds-calendar.scss");
            var _mds_calendar_scss__WEBPACK_IMPORTED_MODULE_4___default = __webpack_require__.n(_mds_calendar_scss__WEBPACK_IMPORTED_MODULE_4__);
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["mixins"].AttributeMarshallingMixin, arrayOf = _mixins$AttributeMars.arrayOf, boolean = _mixins$AttributeMars.boolean, enumerables = _mixins$AttributeMars.enumerables, string = _mixins$AttributeMars.string, stringRequired = _mixins$AttributeMars.stringRequired;
            var WEEKDAY_HEADER_STYLE = {
                SHORT: "short",
                XSHORT: "xshort"
            };
            var entity = {
                viewType: enumerables(string, "month", "rolling").defaultsTo("month"),
                startDate: stringRequired,
                endDate: stringRequired,
                currentDateMarker: boolean.defaultsTo(false),
                activityIndicator: boolean.defaultsTo(false),
                activeDates: arrayOf(string),
                locale: string,
                timeZone: string,
                accessibleCurrentDateText: string,
                accessibleActivityDateText: string,
                accessiblePastDateText: string,
                todaysDateLabel: string,
                upcomingActivityLabel: string
            };
            var MdsCalendar = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsCalendar, _AgaveComponent);
                _createClass(MdsCalendar, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsCalendar";
                    }
                } ]);
                function MdsCalendar() {
                    var _this;
                    _classCallCheck(this, MdsCalendar);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsCalendar).call(this));
                    _this.today = {};
                    _this.dates = {};
                    _this.weekdayHeaders = {};
                    _this.activeDateSet = new Set;
                    _this.defineObservedProperty("weekdayHeaderStyle", WEEKDAY_HEADER_STYLE.SHORT);
                    _this._dayDiff = _this._dayDiff.bind(_assertThisInitialized(_this));
                    _this._getDayOfMonthAccessibleTextPrefix = _this._getDayOfMonthAccessibleTextPrefix.bind(_assertThisInitialized(_this));
                    _this._generateWeekdayHeaders = _this._generateWeekdayHeaders.bind(_assertThisInitialized(_this));
                    _this._generateActiveDateSet = _this._generateActiveDateSet.bind(_assertThisInitialized(_this));
                    _this._generateDates = _this._generateDates.bind(_assertThisInitialized(_this));
                    _this._resizeHandler = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["debounce"])(_this._resizeHandler.bind(_assertThisInitialized(_this)));
                    _this._setToday = _this._setToday.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsCalendar, [ {
                    key: "_dayDiff",
                    value: function _dayDiff(lhs, rhs) {
                        return lhs.startOf("day").diff(rhs.startOf("day"), "days");
                    }
                }, {
                    key: "_getDayOfMonthAccessibleTextPrefix",
                    value: function _getDayOfMonthAccessibleTextPrefix(dayDiffs, hasActivity) {
                        var accessibleCurrentDateText = this.accessibleCurrentDateText, accessibleActivityDateText = this.accessibleActivityDateText, accessiblePastDateText = this.accessiblePastDateText;
                        var prefix = "";
                        if (dayDiffs > 0 && accessiblePastDateText) {
                            prefix += "".concat(accessiblePastDateText, " ");
                        } else if (dayDiffs === 0) {
                            prefix += "".concat(accessibleCurrentDateText, " ");
                        }
                        if (hasActivity && accessibleActivityDateText) {
                            prefix += "".concat(accessibleActivityDateText, " ");
                        }
                        return prefix;
                    }
                }, {
                    key: "_resizeHandler",
                    value: function _resizeHandler() {
                        var rect = this.getBoundingClientRect();
                        this.weekdayHeaderStyle = WEEKDAY_HEADER_STYLE.SHORT;
                        if (rect.width < 360) {
                            this.weekdayHeaderStyle = WEEKDAY_HEADER_STYLE.XSHORT;
                        }
                    }
                }, {
                    key: "renderedCallback",
                    value: function renderedCallback() {
                        var _get2;
                        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                            args[_key] = arguments[_key];
                        }
                        _get(_getPrototypeOf(MdsCalendar.prototype), "renderedCallback", this) && (_get2 = _get(_getPrototypeOf(MdsCalendar.prototype), "renderedCallback", this)).call.apply(_get2, [ this ].concat(args));
                        this._resizeHandler();
                    }
                }, {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        var _get3;
                        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                            args[_key2] = arguments[_key2];
                        }
                        _get(_getPrototypeOf(MdsCalendar.prototype), "connectedCallback", this) && (_get3 = _get(_getPrototypeOf(MdsCalendar.prototype), "connectedCallback", this)).call.apply(_get3, [ this ].concat(args));
                        window.addEventListener("resize", this._resizeHandler);
                    }
                }, {
                    key: "disconnectedCallback",
                    value: function disconnectedCallback() {
                        var _get4;
                        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                            args[_key3] = arguments[_key3];
                        }
                        _get(_getPrototypeOf(MdsCalendar.prototype), "disconnectedCallback", this) && (_get4 = _get(_getPrototypeOf(MdsCalendar.prototype), "disconnectedCallback", this)).call.apply(_get4, [ this ].concat(args));
                        window.removeEventListener("resize", this._resizeHandler);
                    }
                }, {
                    key: "_generateWeekdayHeaders",
                    value: function _generateWeekdayHeaders() {
                        var _this2 = this;
                        var weekdayHeaderStyle = this.weekdayHeaderStyle;
                        this.weekdayHeaders = moment_timezone__WEBPACK_IMPORTED_MODULE_0___default.a.weekdaysShort().map(function(weekday) {
                            _newArrowCheck(this, _this2);
                            var header = weekday.toLocaleUpperCase();
                            if (weekdayHeaderStyle === WEEKDAY_HEADER_STYLE.XSHORT) {
                                header = header.slice(0, 1);
                            }
                            return header;
                        }.bind(this));
                    }
                }, {
                    key: "_generateActiveDateSet",
                    value: function _generateActiveDateSet() {
                        var _this3 = this;
                        var activeDates = this.activeDates, today = this.today, endDate = this.endDate;
                        try {
                            var isInRange = function isInRange(date) {
                                _newArrowCheck(this, _this3);
                                return this._dayDiff(date, today) >= 0 && this._dayDiff(date, moment_timezone__WEBPACK_IMPORTED_MODULE_0___default()(endDate)) <= 0;
                            }.bind(this);
                            activeDates.forEach(function(activeDate) {
                                _newArrowCheck(this, _this3);
                                if (isInRange(moment_timezone__WEBPACK_IMPORTED_MODULE_0___default()(activeDate))) {
                                    this.activeDateSet.add(moment_timezone__WEBPACK_IMPORTED_MODULE_0___default()(activeDate).format("l"));
                                }
                            }.bind(this));
                        } catch (error) {
                            throw new Error("Failed to parse active dates");
                        }
                    }
                }, {
                    key: "_generateDates",
                    value: function _generateDates() {
                        var startDate = this.startDate, endDate = this.endDate, today = this.today, dates = this.dates, activeDateSet = this.activeDateSet, activityIndicator = this.activityIndicator;
                        if (activityIndicator && activeDateSet.size === 0) {
                            this._generateActiveDateSet();
                        }
                        try {
                            var dateDifference = this._dayDiff(moment_timezone__WEBPACK_IMPORTED_MODULE_0___default()(endDate), moment_timezone__WEBPACK_IMPORTED_MODULE_0___default()(startDate));
                            var currentDate = moment_timezone__WEBPACK_IMPORTED_MODULE_0___default()(startDate);
                            for (var i = 0; i <= dateDifference; i += 1) {
                                var month = currentDate.format("MMMM");
                                if (!Object.prototype.hasOwnProperty.call(dates, month)) dates[month] = [];
                                var date = {
                                    dayDiffs: this._dayDiff(today, currentDate),
                                    hasActivity: activeDateSet.has(currentDate.format("l")),
                                    dayOfWeek: currentDate.day() + 1,
                                    dayOfMonth: currentDate.format("DD"),
                                    dayOfMonthAccessibleText: currentDate.format("dddd, MMMM D, YYYY")
                                };
                                date.dayOfMonthAccessibleText = this._getDayOfMonthAccessibleTextPrefix(date.dayDiffs, date.hasActivity) + currentDate.format("dddd, MMMM D, YYYY");
                                dates[month].push(date);
                                currentDate.add(1, "d");
                            }
                        } catch (error) {
                            throw new Error("Unable to generate dates between ".concat(startDate, " - ").concat(endDate));
                        }
                    }
                }, {
                    key: "_setToday",
                    value: function _setToday() {
                        var timeZone = this.timeZone;
                        try {
                            this.today = timeZone ? moment_timezone__WEBPACK_IMPORTED_MODULE_0___default()().tz(timeZone) : moment_timezone__WEBPACK_IMPORTED_MODULE_0___default()();
                        } catch (error) {
                            throw new Error('Invalid timeZone: " '.concat(timeZone));
                        }
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var dates = this.dates, locale = this.locale;
                        if (Object.keys(dates).length === 0) {
                            moment_timezone__WEBPACK_IMPORTED_MODULE_0___default.a.locale(locale);
                            this._setToday();
                            this._generateDates();
                        }
                        this._generateWeekdayHeaders();
                        _MdsCalendar__WEBPACK_IMPORTED_MODULE_3__["default"].call(this);
                    }
                } ]);
                return MdsCalendar;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["AgaveComponent"]), _class2.styles = _mds_calendar_scss__WEBPACK_IMPORTED_MODULE_4___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsCalendar;
        },
        "./src/calendar/mds-calendar.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/calendar/mds-calendar.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/callout/MdsCallout.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _button$wrapper = function _button$wrapper(_calloutButton$conc, _title, _this$_onclick) {
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-button", null, null, "id", _calloutButton$conc, "text", _title, "small", "true", "variant", "tertiary", "class", "callout__button", "onclick", _this$_onclick);
            };
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function renderButtons() {
                var _this = this;
                if (this.buttonTitles) {
                    return this.buttonTitles.map(function(title, index) {
                        _newArrowCheck(this, _this);
                        var button = _jsxWrapper(_button$wrapper, [ "callout-button-".concat(index), title, this._onclick ]);
                        return button;
                    }.bind(this));
                }
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-button", null, null, "id", "callout-button", "text", this.buttonText, "small", "true", "variant", "tertiary", "class", "callout__button", "onclick", this._onclick);
            }
            function MdsCalloutTemplate() {
                var _pointerClasses, _bodyClasses;
                var alignment = this.alignment, message = this.message, tooltipPlacement = this.tooltipPlacement, _isWrapped = this._isWrapped, headerText = this.headerText, calloutTitle = this.calloutTitle, buttonText = this.buttonText, closeAccessiblityText = this.closeAccessiblityText, close = this.close, enterAnnouncement = this.enterAnnouncement, exitAnnouncement = this.exitAnnouncement, variant = this.variant, buttonTitles = this.buttonTitles, icon = this.icon;
                var pointerClasses = (_pointerClasses = {
                    callout__pointer: true
                }, _defineProperty(_pointerClasses, "callout__pointer--".concat(tooltipPlacement), true), 
                _defineProperty(_pointerClasses, "callout__pointer--".concat(variant), true), _defineProperty(_pointerClasses, "callout__pointer--".concat(alignment), true), 
                _pointerClasses);
                var bodyClasses = (_bodyClasses = {
                    callout: true
                }, _defineProperty(_bodyClasses, "callout--".concat(variant), true), _defineProperty(_bodyClasses, "callout--".concat(tooltipPlacement), true), 
                _defineProperty(_bodyClasses, "callout--".concat(alignment), true), _defineProperty(_bodyClasses, "callout--wrapped-trigger", _isWrapped), 
                _defineProperty(_bodyClasses, "callout--safari", MDS.isSafari), _bodyClasses);
                var containerClass = {
                    "callout__content-container": true,
                    "callout__content-container--no-button": !buttonText && !buttonTitles
                };
                var headerId = "".concat(this.id, "-header");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", bodyClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text");
                _renderArbitrary(enterAnnouncement);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "close-button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "callout__close");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-label", closeAccessiblityText);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onclick", close);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    "aria-labelledby": headerId
                }, headerText));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "callout__close-icon", "aria-hidden", "true", "innerHTML-prop", MDS.svgs["ico_close"], "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", containerClass);
                _renderArbitrary(icon && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "callout__icon"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "innerHTML-prop", MDS.svgs[this.icon], "aria-hidden", "true", "__skip", "true"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div");
                _renderArbitrary(calloutTitle || headerText && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("h1", null, null, "class", "callout__title", "id", headerId), 
                _renderArbitrary(calloutTitle || headerText), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("h1")));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("p", null, null, "class", "callout__message", "innerHTML-prop", message, "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("p");
                _renderArbitrary((this.buttonText || this.buttonTitles) && renderButtons.call(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", pointerClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text");
                _renderArbitrary(exitAnnouncement);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            __webpack_exports__["default"] = MdsCalloutTemplate;
        },
        "./src/callout/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _tooltip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/tooltip/index.jsx");
            var _mds_callout_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/callout/mds-callout.scss");
            var _mds_callout_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_callout_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/data-utils.js");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_edge_detection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/edge-detection.js");
            var _MdsCallout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/callout/MdsCallout.jsx");
            var _utils_allowLists__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/utils/allowLists.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["mixins"].AttributeMarshallingMixin, string = _mixins$AttributeMars.string, enumerables = _mixins$AttributeMars.enumerables, arrayOf = _mixins$AttributeMars.arrayOf, boolean = _mixins$AttributeMars.boolean, symbols = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["mixins"].symbols;
            var entity = {
                buttonText: string,
                buttonTitles: arrayOf(string).withMaxLength(2),
                message: string.withHTML(_utils_allowLists__WEBPACK_IMPORTED_MODULE_7__["style"]),
                headerText: string,
                calloutTitle: string,
                closeAccessiblityText: string.defaultsTo("click to close."),
                enterAnnouncement: string.defaultsTo("popup content start"),
                exitAnnouncement: string.defaultsTo("popup content end"),
                variant: enumerables(string, "overlay", "contextual", "web").defaultsTo("overlay"),
                icon: enumerables.apply(void 0, [ string ].concat(_toConsumableArray(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["ICON_TYPES"]))),
                visible: string.defaultsTo("true").withChangedCallback()
            };
            var MdsCallout = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_Tooltip) {
                _inherits(MdsCallout, _Tooltip);
                _createClass(MdsCallout, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsCallout";
                    }
                } ]);
                function MdsCallout() {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsCallout);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsCallout).call(this, "callout"));
                    _this.manualControl = true;
                    _this.openComponent = function() {
                        _newArrowCheck(this, _this2);
                    }.bind(this);
                    _this._onclick = _this._onclick.bind(_assertThisInitialized(_this));
                    _this._handleKeyup = _this._handleKeyup.bind(_assertThisInitialized(_this));
                    _this.open = _this.open.bind(_assertThisInitialized(_this));
                    _this.close = _this.close.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsCallout, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        if (!(this.parentElement instanceof _mds_agave__WEBPACK_IMPORTED_MODULE_0__["AgaveComponent"])) {
                            this[symbols.hasHost] = false;
                            this._host = this.parentElement;
                            this._host.appendChild(this._renderTarget);
                        }
                        _get(_getPrototypeOf(MdsCallout.prototype), "connectedCallback", this).call(this);
                        this.visible === "true" && setTimeout(this.open);
                    }
                }, {
                    key: "visibleChangedCallback",
                    value: function visibleChangedCallback(visible) {
                        var customEvent = new CustomEvent(visible === "true" ? "open" : "close", {
                            bubbles: true,
                            composed: true
                        });
                        this.dispatchEvent(customEvent);
                    }
                }, {
                    key: "_onclick",
                    value: function _onclick(event) {
                        var _this3 = this;
                        var eventTarget = event.target;
                        var detail = {
                            id: eventTarget.id,
                            text: eventTarget.text,
                            original: event
                        };
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this3);
                            return "click";
                        }.bind(this), this)(event, detail);
                    }
                }, {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                            target: "callout-button"
                        };
                        return _get(_getPrototypeOf(MdsCallout.prototype), "_getInteractiveElement", this).call(this, payload);
                    }
                }, {
                    key: "open",
                    value: function open() {
                        this.visible = "true";
                        this._handlePositioning();
                        this._host.addEventListener("keyup", this._handleKeyup);
                    }
                }, {
                    key: "close",
                    value: function close() {
                        this.visible = "false";
                        this._host.removeEventListener("keyup", this._handleKeyup);
                        Object(_utils_edge_detection__WEBPACK_IMPORTED_MODULE_5__["clearStyles"])(this._tooltipBody, this._pointer);
                    }
                }, {
                    key: "_handleKeyup",
                    value: function _handleKeyup(event) {
                        if (this.visible && Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["isEscAndShouldClose"])(event)) {
                            this.close();
                            this._host.focus();
                        }
                    }
                }, {
                    key: "render",
                    value: function render() {
                        _MdsCallout__WEBPACK_IMPORTED_MODULE_6__["default"].call(this);
                    }
                } ]);
                return MdsCallout;
            }(_tooltip__WEBPACK_IMPORTED_MODULE_1__["default"]), _class2.styles = _mds_callout_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2._maxWidth = Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssValue"])("388px"), 
            _class2._oneLineMessageHeight = Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssValue"])("1rem") * 16, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsCallout;
        },
        "./src/callout/mds-callout.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/callout/mds-callout.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/carousel/MdsCarousel.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _li$wrapper = function _li$wrapper(_slideButtonContainer, _id, _this$_handleControlD, _this$_handleControlD2, _this$_preventDefault, _slide$index, _isActive, _conditionalAttribute, _conditionalAttribute2, _conditionalAttribute3, _conditionalAttribute4, _conditionalAttribute5) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("li", null, null, "role", "presentation", "class", _slideButtonContainer);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("mds-button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", _id);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "carousel__control-button carousel__control-button--slide");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onclick", _this$_handleControlD);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onkeydown", _this$_handleControlD2);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onmousedown", _this$_preventDefault);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-index", _slide$index);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("tab-focusable", _isActive);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("small", "true");
                _spreadAttribute(_conditionalAttribute);
                _spreadAttribute(_conditionalAttribute2);
                _spreadAttribute(_conditionalAttribute3);
                _spreadAttribute(_conditionalAttribute4);
                _spreadAttribute(_conditionalAttribute5);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("mds-button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-button");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("li");
            }, _cta$wrapper = function _cta$wrapper(_buttonId, _small, _isActive2, _commonCtaAttrs, _conditionalAttribute6, _conditionalAttribute7, _conditionalAttribute8, _conditionalAttribute9, _conditionalAttribute10, _conditionalAttribute11) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("mds-button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", _buttonId);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("variant", "primary");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("small", _small);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("tab-focusable", _isActive2);
                _spreadAttribute(_commonCtaAttrs);
                _spreadAttribute(_conditionalAttribute6);
                _spreadAttribute(_conditionalAttribute7);
                _spreadAttribute(_conditionalAttribute8);
                _spreadAttribute(_conditionalAttribute9);
                _spreadAttribute(_conditionalAttribute10);
                _spreadAttribute(_conditionalAttribute11);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("mds-button");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-button");
            }, _cta$wrapper2 = function _cta$wrapper2(_linkId, _linkText, _CMB_MDS_CAROUSEL_SLI, _isActive3, _conditionalAttribute12, _commonCtaAttrs2) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("mds-link");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", _linkId);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("text", _linkText);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("end-icon", _CMB_MDS_CAROUSEL_SLI);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("is-button", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("tab-focusable", _isActive3);
                _spreadAttribute(_conditionalAttribute12);
                _spreadAttribute(_commonCtaAttrs2);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("mds-link");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-link");
            }, _div$wrapper = function _div$wrapper(_class, _cta) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", _class);
                _renderArbitrary(_cta);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            };
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function renderControls() {
                var _this = this;
                var slides = this.slides, activeSlideIndex = this.activeSlideIndex;
                var commonArrowButtonAttrs = {
                    class: "carousel__control-button carousel__control-button--arrow",
                    variant: "tertiary",
                    "icon-position": "icon_only",
                    "tab-focusable": "false",
                    onmousedown: this._preventDefault
                };
                var slideButtonsToDisplay = this._hasNumberedControlButtons ? this._visibleSlideButtons : slides;
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("ul", null, null, "class", "carousel__controls carousel__controls--".concat(this.variant), "role", !MDS.isFireFox && !MDS.isAndroid ? "tablist" : "application");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("mds-button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "button-control-left");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onclick", this._handleControlArrowClick);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("inactive", activeSlideIndex === 0);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("icon-type", "ico_chevron_left");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-hidden", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-direction", "left");
                _spreadAttribute(commonArrowButtonAttrs);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("mds-button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-button");
                _renderArbitrary(slides.map(function(slide) {
                    _newArrowCheck(this, _this);
                    var isActive = slide.index === activeSlideIndex;
                    var slideButtonContainerClasses = {
                        "carousel__control-button-container": true,
                        "carousel__control-button-container--hidden": this._hasNumberedControlButtons && (slide.index < slideButtonsToDisplay[0].index || slide.index > slideButtonsToDisplay[this._controlDotButtonLimit - 1].index)
                    };
                    return _jsxWrapper(_li$wrapper, [ slideButtonContainerClasses, "button-".concat(slide.index), this._handleControlDotClick, this._handleControlDotKeydown, this._preventDefault, slide.index, isActive, Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                        text: String(slide.index + 1),
                        variant: isActive ? "primary" : "tertiary"
                    }, slides.length > this._controlDotButtonLimit), Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                        "icon-type": isActive ? "ico_status_indicator_dot" : "ico_alert_circle",
                        "icon-position": "icon_only",
                        variant: "tertiary"
                    }, slides.length <= this._controlDotButtonLimit), Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                        onfocus: this._handleControlDotFocusIOS
                    }, MDS.isIOS), Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                        aria: {
                            "aria-label": slide.accessibleTextSlideTitle,
                            "aria-selected": isActive,
                            role: "tab"
                        }
                    }, !MDS.isAndroid && !MDS.isFireFox), Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                        aria: {
                            "aria-label": "".concat(slide.accessibleTextSlideTitle, ", tab, ").concat(slide.index + 1, " of ").concat(slides.length),
                            "aria-live": MDS.isAndroid && isActive ? "polite" : "off",
                            "aria-describedby": "button-".concat(slide.index, "-accessible-text"),
                            "aria-controls": "".concat(this.id, "-slide-").concat(slide.index)
                        },
                        "accessible-text": isActive ? "selected" : ""
                    }, MDS.isAndroid || MDS.isFireFox) ]);
                }.bind(this)));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("mds-button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "button-control-right");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onclick", this._handleControlArrowClick);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("inactive", activeSlideIndex === slides.length - 1);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("icon-type", "ico_chevron_right");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-hidden", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-direction", "right");
                _spreadAttribute(commonArrowButtonAttrs);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("mds-button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-button");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("ul");
            }
            function renderSlide(slide, imageWidth) {
                var _slideClasses, _imageClasses, _borderClasses;
                var slideId = "".concat(this.id, "-slide-").concat(slide.index);
                var isActive = slide.index === this.activeSlideIndex;
                var slideClasses = (_slideClasses = {
                    carousel__tabpanel: true
                }, _defineProperty(_slideClasses, "carousel__tabpanel--".concat(this.variant), true), 
                _defineProperty(_slideClasses, "carousel__tabpanel--active", isActive), _defineProperty(_slideClasses, "carousel__tabpanel--reverse", this.variant === "hero" && this.heroImagePosition === "right"), 
                _slideClasses);
                var imageClasses = (_imageClasses = {
                    carousel__image: true
                }, _defineProperty(_imageClasses, "carousel__image--".concat(this.variant), true), 
                _defineProperty(_imageClasses, "carousel__image--reverse", this.variant === "hero" && this.heroImagePosition === "right"), 
                _imageClasses);
                var imageHeight = this.imageHeight && "".concat(this.imageHeight, "px");
                var borderClasses = (_borderClasses = {
                    carousel__slide: true
                }, _defineProperty(_borderClasses, "carousel__slide--".concat(this.variant), true), 
                _defineProperty(_borderClasses, "carousel__slide-border", this.variant === "default"), 
                _borderClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", slideId);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", slideClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("role", "tabpanel");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-roledescription", "Slide");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-labelledby", "button-".concat(slide.index));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("tabIndex", "-1");
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    onclick: this._handlePeekClick
                }, this.variant === "default"));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onkeydown", this._handleSlideKeydown);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onblur", this._handleSlideBlur);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-index", slide.index);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])("aria-hidden", !isActive));
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    style: {
                        width: imageWidth
                    }
                }, imageWidth));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("figure", null, null, "class", borderClasses, "style", {
                    width: this.variant === "hero" ? "".concat(this.heroImageWidth, "%") : "auto"
                });
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("img");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", imageClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("src", slide.imageUrl);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("alt", slide.imageAltText);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    style: {
                        height: imageHeight
                    }
                }, this.variant === "slideshow" && imageHeight));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("img");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("img");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("figure");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "carousel__slide-content carousel__slide-content--".concat(this.variant), "style", {
                    width: this.variant === "hero" ? "".concat(100 - this.heroImageWidth, "%") : "auto"
                });
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "role", "heading", "aria-level", this.headingLevel);
                _renderArbitrary(slide.subheadingText && this.variant === "hero" && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "carousel__slide-subheading"), 
                _renderArbitrary(slide.subheadingText), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "carousel__slide-heading carousel__slide-heading--".concat(this.variant));
                _renderArbitrary(slide.headingText);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("p", null, null, "class", "carousel__slide-description carousel__slide-description--".concat(this.variant));
                _renderArbitrary(slide.descriptionText);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("p");
                _renderArbitrary(renderCTA.call(this, slide, isActive));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function renderCarouselTrack() {
                var _this2 = this;
                var activeSlideIndex = this.activeSlideIndex, slides = this.slides;
                var _this$constructor$_in = this.constructor._invariants, peekWidth = _this$constructor$_in.peekWidth, spaceBetweenSlides = _this$constructor$_in.spaceBetweenSlides;
                var imageWidth;
                var translateX;
                if (this.variant === "default") {
                    var peekAndMarginWidth = peekWidth + spaceBetweenSlides;
                    imageWidth = this.parentElement.offsetWidth - 2 * peekAndMarginWidth;
                    var translateMargin = activeSlideIndex > 1 ? (activeSlideIndex - 1) * -peekAndMarginWidth : 0;
                    if (activeSlideIndex === slides.length - 1) {
                        translateMargin += peekAndMarginWidth;
                    }
                    translateX = "translateX(".concat(activeSlideIndex * -(imageWidth - peekWidth) + translateMargin, "px)");
                } else if (this.variant === "hero") {
                    imageWidth = this.parentElement.offsetWidth + spaceBetweenSlides;
                    translateX = "translateX(".concat(activeSlideIndex * -imageWidth, "px)");
                }
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "carousel__track carousel__track--".concat(this.variant));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "carousel__slides-container", "style", {
                    transform: translateX,
                    transition: this._shouldTransition ? "" : "none"
                });
                _renderArbitrary(slides.map(function(slide) {
                    _newArrowCheck(this, _this2);
                    return renderSlide.call(this, slide, "".concat(this.variant === "default" ? imageWidth : this.parentElement.offsetWidth, "px"));
                }.bind(this)));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function renderCTA(slide, isActive) {
                var buttonAccessibleText = slide.buttonAccessibleText, buttonIconPosition = slide.buttonIconPosition, buttonIcon = slide.buttonIcon, buttonText = slide.buttonText, linkHref = slide.linkHref, linkText = slide.linkText, index = slide.index;
                var commonCtaAttrs = {
                    onblur: this._handleCtaBlur,
                    onfocus: this._handleCtaFocus,
                    onclick: this._handleCtaClick,
                    onkeydown: this._handleCtaKeydown,
                    class: "carousel__cta"
                };
                var cta;
                if (slide.buttonText || slide.buttonIcon) {
                    var buttonId = "".concat(this.id, "-slide-").concat(index, "-cta-button");
                    cta = _jsxWrapper(_cta$wrapper, [ buttonId, this.variant !== "hero", isActive, commonCtaAttrs, Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                        text: buttonText
                    }, buttonText), Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                        "icon-type": buttonIcon
                    }, buttonIcon), Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                        "icon-position": buttonIconPosition
                    }, buttonIcon && buttonIconPosition), Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                        "accessible-text": buttonAccessibleText
                    }, buttonAccessibleText), Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                        aria: {
                            "aria-describedby": "".concat(buttonId, "-accessible-text")
                        }
                    }, buttonAccessibleText && buttonIconPosition !== "icon_only"), Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                        "icon-accessible-description": buttonAccessibleText
                    }, buttonAccessibleText && buttonIconPosition === "icon_only") ]);
                } else if (linkText) {
                    var linkId = "".concat(this.id, "-slide-").concat(index, "-cta-link");
                    cta = _jsxWrapper(_cta$wrapper2, [ linkId, linkText, "ico_chevron_right", isActive, Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                        href: linkHref
                    }, linkHref), commonCtaAttrs ]);
                }
                return cta && _jsxWrapper(_div$wrapper, [ "carousel__cta-container carousel__cta-container--".concat(this.variant), cta ]);
            }
            function MdsCarouselTemplate() {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("section", null, null, "class", "carousel carousel--".concat(this.variant), "aria-roledescription", "Carousel", "aria-label", this.accessibleTextCarouselTitle);
                _renderArbitrary(renderControls.call(this));
                _renderArbitrary([ "default", "hero" ].includes(this.variant) ? renderCarouselTrack.call(this) : renderSlide.call(this, this.slides[this.activeSlideIndex]));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("section");
            }
            __webpack_exports__["default"] = MdsCarouselTemplate;
        },
        "./src/carousel/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_carousel_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/carousel/mds-carousel.scss");
            var _mds_carousel_scss__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_carousel_scss__WEBPACK_IMPORTED_MODULE_1__);
            var _MdsCarousel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/carousel/MdsCarousel.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/data-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            var arrayOf = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].arrayOf, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].boolean, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].enumerables, number = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].number, numberRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].numberRequired, satisfies = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].satisfies, string = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].stringRequired;
            var slideEntity = {
                accessibleTextSlideTitle: stringRequired,
                buttonIcon: enumerables.apply(void 0, [ string ].concat(_toConsumableArray(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["ICON_TYPES"]))),
                buttonIconPosition: enumerables(string, "leading", "trailing", "icon_only"),
                buttonText: string,
                buttonAccessibleText: string,
                descriptionText: stringRequired,
                headingText: stringRequired,
                imageAltText: stringRequired,
                imageUrl: stringRequired,
                linkHref: string,
                linkText: string,
                subheadingText: string
            };
            var entity = {
                slides: arrayOf(satisfies(slideEntity)).withMinLength(1).withChangedCallback(),
                slideshow: boolean.withChangedCallback(),
                variant: enumerables(string, "default", "slideshow", "hero").defaultsTo("default").withChangedCallback(),
                accessibleTextCarouselTitle: stringRequired,
                imageHeight: number,
                headingLevel: number.defaultsTo(2).withMinSize(1).withMaxSize(6),
                heroImageWidth: numberRequired.defaultsTo(40).withMinSize(40).withMaxSize(60),
                heroImagePosition: enumerables(string, "left", "right").defaultsTo("left")
            };
            var MdsCarousel = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsCarousel, _AgaveComponent);
                _createClass(MdsCarousel, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsCarousel";
                    }
                } ]);
                function MdsCarousel() {
                    var _this;
                    _classCallCheck(this, MdsCarousel);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsCarousel).call(this));
                    _this.defineObservedProperty("activeSlideIndex", 0);
                    _this.defineObservedProperty("_visibleSlideButtons");
                    _this.defineObservedProperty("_shouldTransition", true);
                    _this.defineObservedProperty("_isHeroVariant", false);
                    _this._handleControlArrowClick = _this._handleControlArrowClick.bind(_assertThisInitialized(_this));
                    _this._handleControlDotClick = _this._handleControlDotClick.bind(_assertThisInitialized(_this));
                    _this._handleControlDotFocusIOS = _this._handleControlDotFocusIOS.bind(_assertThisInitialized(_this));
                    _this._handleControlDotKeydown = _this._handleControlDotKeydown.bind(_assertThisInitialized(_this));
                    _this._handleCtaBlur = _this._handleCtaBlur.bind(_assertThisInitialized(_this));
                    _this._handleCtaClick = _this._handleCtaClick.bind(_assertThisInitialized(_this));
                    _this._handleCtaFocus = _this._handleCtaFocus.bind(_assertThisInitialized(_this));
                    _this._handleCtaKeydown = _this._handleCtaKeydown.bind(_assertThisInitialized(_this));
                    _this._handlePeekClick = _this._handlePeekClick.bind(_assertThisInitialized(_this));
                    _this._handleSlideBlur = _this._handleSlideBlur.bind(_assertThisInitialized(_this));
                    _this._handleSlideKeydown = _this._handleSlideKeydown.bind(_assertThisInitialized(_this));
                    _this._preventDefault = _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["preventDefault"];
                    _this._handleResize = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["debounce"])(_this._forceRerender.bind(_assertThisInitialized(_this)));
                    _this._controlDotButtonLimit = 6;
                    return _this;
                }
                _createClass(MdsCarousel, [ {
                    key: "disconnectedCallback",
                    value: function disconnectedCallback() {
                        _get(_getPrototypeOf(MdsCarousel.prototype), "disconnectedCallback", this) && _get(_getPrototypeOf(MdsCarousel.prototype), "disconnectedCallback", this).call(this);
                        this.variant === "hero" && window.removeEventListener("resize", this._handleResize);
                    }
                }, {
                    key: "_handleControlArrowClick",
                    value: function _handleControlArrowClick(event) {
                        this._activeControlButton().blur();
                        event.target.dataset.direction === "left" ? this.decrementSlide() : this.incrementSlide();
                        this.dispatchEvent(new CustomEvent("click-nav-arrow", {
                            detail: {
                                original: event.detail,
                                target: event.target
                            },
                            bubbles: true,
                            composed: true
                        }));
                    }
                }, {
                    key: "_handleControlDotClick",
                    value: function _handleControlDotClick(event) {
                        this.activeSlideIndex = Number(event.target.dataset.index);
                        this._hasNumberedControlButtons && this._setVisibleSlideButtons();
                        this.dispatchEvent(new CustomEvent("click-nav-dot", {
                            detail: {
                                original: event.detail,
                                target: event.target
                            },
                            bubbles: true,
                            composed: true
                        }));
                    }
                }, {
                    key: "activeSlideIndexChangedCallback",
                    value: function activeSlideIndexChangedCallback(newValue, oldValue) {
                        this.dispatchEvent(new CustomEvent("change-slide", {
                            detail: {
                                target: this,
                                activeSlideIndex: newValue,
                                previousSlideIndex: oldValue
                            },
                            bubbles: true,
                            composed: true
                        }));
                    }
                }, {
                    key: "_handleControlDotFocusIOS",
                    value: function _handleControlDotFocusIOS(event) {
                        var focusIndex = Number(event.target.dataset.index);
                        if (focusIndex > this.activeSlideIndex) {
                            this._setVisibleSlideButtons("right", focusIndex);
                        } else if (focusIndex < this.activeSlideIndex) {
                            this._setVisibleSlideButtons("left", focusIndex);
                        }
                    }
                }, {
                    key: "_handleControlDotKeydown",
                    value: function _handleControlDotKeydown(event) {
                        var _event$detail = event.detail, keyCode = _event$detail.keyCode, shiftKey = _event$detail.shiftKey, detail = event.detail;
                        if (keyCode === 39) {
                            detail.preventDefault();
                            this.incrementSlide(true);
                        } else if (keyCode === 37) {
                            detail.preventDefault();
                            this.decrementSlide(true);
                        } else if (keyCode === 9 && !shiftKey) {
                            detail.preventDefault();
                            this.shadowRoot.querySelector(".carousel__tabpanel--active").focus();
                        }
                    }
                }, {
                    key: "_handleCtaBlur",
                    value: function _handleCtaBlur(event) {
                        this._activeControlButton().tabFocusable = true;
                        this.dispatchEvent(new CustomEvent("blur-cta", {
                            detail: {
                                original: event.detail,
                                target: event.target
                            },
                            bubbles: true,
                            composed: true
                        }));
                    }
                }, {
                    key: "_handleCtaClick",
                    value: function _handleCtaClick(event) {
                        this.dispatchEvent(new CustomEvent("click-cta", {
                            detail: {
                                original: event.detail,
                                target: event.target
                            },
                            bubbles: true,
                            composed: true
                        }));
                    }
                }, {
                    key: "_handleCtaFocus",
                    value: function _handleCtaFocus(event) {
                        this._activeControlButton().tabFocusable = false;
                        this.dispatchEvent(new CustomEvent("focus-cta", {
                            detail: {
                                original: event.detail,
                                target: event.target
                            },
                            bubbles: true,
                            composed: true
                        }));
                    }
                }, {
                    key: "_handleCtaKeydown",
                    value: function _handleCtaKeydown(event) {
                        var _event$detail2 = event.detail, keyCode = _event$detail2.keyCode, shiftKey = _event$detail2.shiftKey, detail = event.detail;
                        if (keyCode === 9 && shiftKey) {
                            detail.preventDefault();
                            this.shadowRoot.querySelector(".carousel__tabpanel--active").focus();
                        }
                    }
                }, {
                    key: "_handlePeekClick",
                    value: function _handlePeekClick(event) {
                        var prevSlide = this.shadowRoot.querySelector('.carousel__tabpanel[data-index="'.concat(this.activeSlideIndex - 1, '"]'));
                        var nextSlide = this.shadowRoot.querySelector('.carousel__tabpanel[data-index="'.concat(this.activeSlideIndex + 1, '"]'));
                        if (prevSlide && prevSlide.contains(event.target)) {
                            this.decrementSlide();
                        } else if (nextSlide && nextSlide.contains(event.target)) {
                            this.incrementSlide();
                        }
                    }
                }, {
                    key: "_handleSlideBlur",
                    value: function _handleSlideBlur() {
                        this._activeControlButton().tabFocusable = true;
                    }
                }, {
                    key: "_handleSlideKeydown",
                    value: function _handleSlideKeydown(event) {
                        var keyCode = event.keyCode, shiftKey = event.shiftKey;
                        if (event.target.id === "".concat(this.id, "-slide-").concat(this.activeSlideIndex) && keyCode === 9) {
                            if (shiftKey) {
                                event.preventDefault();
                                this._activeControlButton().focus();
                            } else {
                                this._activeControlButton().tabFocusable = false;
                            }
                        }
                    }
                }, {
                    key: "incrementSlide",
                    value: function incrementSlide(focusOnDot) {
                        if (this.activeSlideIndex !== this.slides.length - 1) {
                            this.activeSlideIndex++;
                            this._hasNumberedControlButtons && this._setVisibleSlideButtons("right");
                            focusOnDot && this._activeControlButton().focus();
                        }
                    }
                }, {
                    key: "decrementSlide",
                    value: function decrementSlide(focusOnDot) {
                        if (this.activeSlideIndex !== 0) {
                            this.activeSlideIndex--;
                            this._hasNumberedControlButtons && this._setVisibleSlideButtons("left");
                            focusOnDot && this._activeControlButton().focus();
                        }
                    }
                }, {
                    key: "_activeControlButton",
                    value: function _activeControlButton() {
                        return this.shadowRoot.querySelector('.carousel__control-button[data-index="'.concat(this.activeSlideIndex, '"]'));
                    }
                }, {
                    key: "_setVisibleSlideButtons",
                    value: function _setVisibleSlideButtons(direction, currentFocusIndex) {
                        var activeSlideIndex = this.activeSlideIndex, _controlDotButtonLimit = this._controlDotButtonLimit, slides = this.slides, _visibleSlideButtons = this._visibleSlideButtons;
                        var activeIndex = currentFocusIndex !== undefined ? currentFocusIndex : activeSlideIndex;
                        if (direction === "left" && activeIndex === _visibleSlideButtons[0].index - 1) {
                            this._visibleSlideButtons = slides.slice(activeIndex, activeIndex + _controlDotButtonLimit);
                        } else if (direction === "right" && activeIndex === _visibleSlideButtons[_controlDotButtonLimit - 1].index + 1) {
                            this._visibleSlideButtons = slides.slice(activeIndex + 1 - _controlDotButtonLimit, activeIndex + 1);
                        } else if (!direction) {
                            if (activeIndex < _visibleSlideButtons[0].index) {
                                this._visibleSlideButtons = slides.slice(activeIndex, activeIndex + _controlDotButtonLimit);
                            } else if (activeIndex > _visibleSlideButtons[_controlDotButtonLimit - 1].index) {
                                this._visibleSlideButtons = slides.slice(activeIndex + 1 - _controlDotButtonLimit, activeIndex + 1);
                            }
                        }
                    }
                }, {
                    key: "_forceRerender",
                    value: function _forceRerender() {
                        this._shouldTransition = false;
                        this._shouldTransition = true;
                    }
                }, {
                    key: "slidesChangedCallback",
                    value: function slidesChangedCallback(slides) {
                        var _this2 = this;
                        if (slides.length > this._controlDotButtonLimit) {
                            this._hasNumberedControlButtons = true;
                            this._visibleSlideButtons = slides.slice(0, this._controlDotButtonLimit);
                        }
                        slides.forEach(function(slide, index) {
                            _newArrowCheck(this, _this2);
                            slide.index = index;
                        }.bind(this));
                    }
                }, {
                    key: "slideshowChangedCallback",
                    value: function slideshowChangedCallback() {
                        if (this.slideshow) {
                            this.variant = "slideshow";
                        } else if (this._previousVariant) {
                            this.variant = this._previousVariant;
                        }
                    }
                }, {
                    key: "variantChangedCallback",
                    value: function variantChangedCallback(newVariant, oldVariant) {
                        var _this3 = this;
                        this._previousVariant = oldVariant;
                        if (newVariant === "hero") {
                            this.setState(function(prevState) {
                                _newArrowCheck(this, _this3);
                                return _objectSpread({}, prevState, {
                                    _isHeroVariant: true
                                });
                            }.bind(this));
                            window.addEventListener("resize", this._handleResize);
                        } else if (this._previousVariant === "hero") {
                            window.removeEventListener("resize", this._handleResize);
                        }
                    }
                }, {
                    key: "render",
                    value: function render() {
                        return _MdsCarousel__WEBPACK_IMPORTED_MODULE_2__["default"].call(this);
                    }
                } ]);
                return MdsCarousel;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_0___default.a), _class2.styles = _mds_carousel_scss__WEBPACK_IMPORTED_MODULE_1___default.a, 
            _class2._invariants = {
                peekWidth: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_4__["cleanCssValue"])("24px"),
                spaceBetweenSlides: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_4__["cleanCssValue"])("16px")
            }, _class2)) || _class);
            __webpack_exports__["default"] = MdsCarousel;
        },
        "./src/carousel/mds-carousel.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/carousel/mds-carousel.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/chat-bubble/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/common-utils.js");
            var _mds_chat_bubble_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/chat-bubble/mds-chat-bubble.scss");
            var _mds_chat_bubble_scss__WEBPACK_IMPORTED_MODULE_3___default = __webpack_require__.n(_mds_chat_bubble_scss__WEBPACK_IMPORTED_MODULE_3__);
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].boolean, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].enumerables;
            var entity = {
                variant: enumerables(string, "agent", "assistant", "customer"),
                firstInGroup: boolean,
                message: string,
                microcopy: string,
                error: boolean.defaultsTo(false),
                image: string,
                imageWidth: string
            };
            function renderMicrocopy(el) {
                if (el.microcopy && el.variant === "customer") {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "mds-chat-bubble__microcopy-container");
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("p", null, null, "class", "mds-chat-bubble__microcopy");
                    _renderArbitrary(el.microcopy);
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("p");
                    return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                }
            }
            function renderErrorIcon(el) {
                if (el.error && el.variant === "customer") {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "mds-chat-bubble__icon", "aria-hidden", "true", "innerHTML-prop", MDS.svgs["ico_alert_filled"], "__skip", "true");
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                    return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                }
            }
            function renderImage(el) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("img");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "mds-chat-bubble__image");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("src", el.image);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["conditionalAttribute"])({
                    width: el.imageWidth
                }, el.imageWidth));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("alt", "");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("img");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("img");
            }
            var MdsChatBubble = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsChatBubble, _AgaveComponent);
                _createClass(MdsChatBubble, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsChatBubble";
                    }
                } ]);
                function MdsChatBubble() {
                    var _this;
                    _classCallCheck(this, MdsChatBubble);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsChatBubble).call(this));
                    _this._onclick = _this._onclick.bind(_assertThisInitialized(_this));
                    _this._onkeyup = _this._onkeyup.bind(_assertThisInitialized(_this));
                    _this._onkeydown = _this._onkeydown.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsChatBubble, [ {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        return {
                            interactiveElement: this.shadowRoot.getElementById("bubble-container")
                        };
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var variant = this.variant, firstInGroup = this.firstInGroup, message = this.message, error = this.error, image = this.image;
                        var classes = _defineProperty({
                            "mds-chat-bubble__container": true,
                            "mds-chat-bubble__container--first": firstInGroup,
                            "mds-chat-bubble__container--error": error
                        }, "mds-chat-bubble__container--".concat(variant), true);
                        var containerClasses = {
                            "mds-chat-bubble": true,
                            "mds-chat-bubble--customer": variant === "customer"
                        };
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", containerClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "bubble-container");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", classes);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onclick", this._onclick);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onkeyup", this._onkeyup);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onkeydown", this._onkeydown);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["conditionalAttribute"])({
                            tabIndex: 0
                        }, error));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                        _renderArbitrary(renderErrorIcon(this));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "mds-chat-bubble__message-container");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "mds-chat-bubble__message-background");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "mds-chat-bubble__message");
                        _renderArbitrary(image && renderImage(this));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "mds-chat-bubble__message-text");
                        _renderArbitrary(message);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        _renderArbitrary(renderMicrocopy(this));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return MdsChatBubble;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_chat_bubble_scss__WEBPACK_IMPORTED_MODULE_3___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsChatBubble;
        },
        "./src/chat-bubble/mds-chat-bubble.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/chat-bubble/mds-chat-bubble.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/chat-input/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _abstract_text_field__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/abstract-text-field/index.js");
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/data-utils.js");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/common-utils.js");
            var _mds_chat_input_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/chat-input/mds-chat-input.scss");
            var _mds_chat_input_scss__WEBPACK_IMPORTED_MODULE_5___default = __webpack_require__.n(_mds_chat_input_scss__WEBPACK_IMPORTED_MODULE_5__);
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["mixins"].AttributeMarshallingMixin, stamp = _mixins$AttributeMars.stamp, boolean = _mixins$AttributeMars.boolean, string = _mixins$AttributeMars.string;
            var entity = {
                label: string.defaultsTo("Type your message").withMaxLength(200),
                accessibilityText: string.defaultsTo("Type your message").withMaxLength(200),
                accessibilityTextSendButton: string.defaultsTo("Send").withMaxLength(200),
                accessibilityTextSendButtonDisabledText: string.defaultsTo("Disabled").withMaxLength(200),
                inactive: boolean.defaultsTo(false),
                value: string.defaultsTo("").withChangedCallback(),
                hasLeadingButton: boolean.defaultsTo(false),
                leadingButtonEnabled: boolean.defaultsTo(true),
                accessibilityTextLeadingButton: string.defaultsTo("Leading button"),
                sendButtonAlwaysDisabled: boolean.defaultsTo(false)
            };
            var MdsChatInput = (_dec = stamp(entity), _dec(_class = (_class2 = function(_AbstractTextField) {
                _inherits(MdsChatInput, _AbstractTextField);
                _createClass(MdsChatInput, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsChatInput";
                    }
                } ]);
                function MdsChatInput() {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsChatInput);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsChatInput).call(this));
                    _this._getEventProps = _this._getEventProps.bind(_assertThisInitialized(_this));
                    _this._onclick = _this._onclick.bind(_assertThisInitialized(_this));
                    _this._oninput = _this._oninput.bind(_assertThisInitialized(_this));
                    _this._onchange = _this._onchange.bind(_assertThisInitialized(_this));
                    _this._onfocus = _this._onfocus.bind(_assertThisInitialized(_this));
                    _this._onblur = _this._onblur.bind(_assertThisInitialized(_this));
                    _this._onkeyup = _this._onkeyup.bind(_assertThisInitialized(_this));
                    _this._onkeydown = _this._onkeydown.bind(_assertThisInitialized(_this));
                    _this._updateFocusBarWidth = _this._updateFocusBarWidth.bind(_assertThisInitialized(_this));
                    _this._getButtonEventProps = _this._getButtonEventProps.bind(_assertThisInitialized(_this));
                    _this._onButtonClick = _this._onButtonClick.bind(_assertThisInitialized(_this));
                    _this._onButtonFocus = _this._onButtonFocus.bind(_assertThisInitialized(_this));
                    _this._onButtonBlur = _this._onButtonBlur.bind(_assertThisInitialized(_this));
                    _this.defineObservedProperty("_isButtonActive", false);
                    _this.defineObservedProperty("_textAreaHasFocus", false);
                    _this.defineObservedProperty("_secondaryFocus", false);
                    _this.defineObservedProperty("_focusRelatedTarget", false);
                    _this._dispatchLeadingButtonEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "click-leading-button";
                    }.bind(this), _assertThisInitialized(_this));
                    _this._dispatchSubmitButtonEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "click-submit-button";
                    }.bind(this), _assertThisInitialized(_this));
                    _this._textAreaOnBlur = _this._textAreaOnBlur.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsChatInput, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsChatInput.prototype), "connectedCallback", this).call(this);
                        this._currentHeight = this._textFieldNode.scrollHeight;
                        this._textAreaRows = 1;
                        this._textAreaMinHeight = Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssValue"])("56px");
                        this._textAreaMaxHeight = Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssValue"])("156px");
                    }
                }, {
                    key: "valueChangedCallback",
                    value: function valueChangedCallback(newValue, oldValue) {
                        if (this._textFieldNode && newValue !== oldValue) {
                            this._textFieldNode.value = newValue;
                            this._isFloating = false;
                            if (newValue) {
                                this._isFloating = true;
                            }
                        }
                    }
                }, {
                    key: "_textAreaOnBlur",
                    value: function _textAreaOnBlur(evt) {
                        this._handleFloatingLabelStyles(evt);
                        this._onblur(evt);
                    }
                }, {
                    key: "_getEventProps",
                    value: function _getEventProps() {
                        return {
                            onclick: this._onclick,
                            oninput: this._oninput,
                            onchange: this._onchange,
                            onfocus: this._onfocus,
                            onblur: this._textAreaOnBlur,
                            onscroll: this._onscroll,
                            onkeydown: this._onkeydown,
                            onkeyup: this._onkeyup
                        };
                    }
                }, {
                    key: "_getButtonEventProps",
                    value: function _getButtonEventProps() {
                        return {
                            onclick: this._onButtonClick,
                            onfocus: this._onButtonFocus,
                            onblur: this._onButtonBlur
                        };
                    }
                }, {
                    key: "_handleFloatingLabelStyles",
                    value: function _handleFloatingLabelStyles(event) {
                        if ([ "focus", "input", "keydown" ].includes(event.type) || this._textFieldNode.value) {
                            this._isFloating = true;
                        } else {
                            this._isFloating = false;
                        }
                    }
                }, {
                    key: "_handleButtonActivity",
                    value: function _handleButtonActivity() {
                        if (this._textFieldNode.value) {
                            this._isButtonActive = true;
                        } else {
                            this._isButtonActive = false;
                        }
                    }
                }, {
                    key: "_updateFocusBarWidth",
                    value: function _updateFocusBarWidth() {
                        this._currentWidth = this._textFieldNode.scrollWidth;
                        this._buttonWidth = this.shadowRoot.querySelector(".mds-chat-input__button-wrap").clientWidth;
                        this.shadowRoot.querySelector("label").style.width = "".concat(this._currentWidth - this._buttonWidth, "px");
                        this.shadowRoot.querySelector(".mds-chat-input__focus").style.width = "".concat(this._currentWidth - Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssValue"])("12px") * 2, "px");
                    }
                }, {
                    key: "_handleTextAreaHeight",
                    value: function _handleTextAreaHeight(event) {
                        var inputNode = this._textFieldNode;
                        inputNode.style.minHeight = "".concat(this._textAreaMinHeight, "px");
                        inputNode.style.height = "auto";
                        inputNode.value = event.target.value;
                        var currentScrollHeight = event.target.scrollHeight;
                        if (currentScrollHeight <= this._textAreaMaxHeight) {
                            if (currentScrollHeight !== this._currentHeight && currentScrollHeight > this._textAreaMinHeight && inputNode.value) {
                                inputNode.style.height = "".concat(currentScrollHeight + Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssValue"])("4px") * 2, "px");
                                this._currentHeight = currentScrollHeight + Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssValue"])("4px") * 2;
                            }
                        } else {
                            inputNode.style.height = "".concat(this._textAreaMaxHeight, "px");
                            this._currentHeight = this._textAreaMaxHeight;
                        }
                    }
                }, {
                    key: "_onfocus",
                    value: function _onfocus(event) {
                        this._handleFloatingLabelStyles(event);
                        this._handleButtonActivity();
                        this._textAreaHasFocus = true;
                        _get(_getPrototypeOf(MdsChatInput.prototype), "_onfocus", this) && _get(_getPrototypeOf(MdsChatInput.prototype), "_onfocus", this).call(this, event);
                    }
                }, {
                    key: "_onblur",
                    value: function _onblur(event) {
                        if (event.relatedTarget && this.shadowRoot.contains(event.relatedTarget)) {
                            this._handleButtonActivity(event);
                        } else {
                            this._handleFloatingLabelStyles(event);
                            this._handleButtonActivity();
                            this._textAreaHasFocus = false;
                            _get(_getPrototypeOf(MdsChatInput.prototype), "_onblur", this) && _get(_getPrototypeOf(MdsChatInput.prototype), "_onblur", this).call(this, event);
                        }
                    }
                }, {
                    key: "_oninput",
                    value: function _oninput(event) {
                        this.value = this._textFieldNode.value;
                        this._handleTextAreaHeight(event);
                        this._handleFloatingLabelStyles(event);
                        this._handleButtonActivity();
                        _get(_getPrototypeOf(MdsChatInput.prototype), "_oninput", this) && _get(_getPrototypeOf(MdsChatInput.prototype), "_oninput", this).call(this, event);
                    }
                }, {
                    key: "_onclick",
                    value: function _onclick(event) {
                        if (event.target === this._textFieldNode) {
                            _get(_getPrototypeOf(MdsChatInput.prototype), "_onclick", this) && _get(_getPrototypeOf(MdsChatInput.prototype), "_onclick", this).call(this, event);
                        }
                    }
                }, {
                    key: "_onkeydown",
                    value: function _onkeydown(event) {
                        if (event.keyCode === 9) {
                            this._handleFloatingLabelStyles(event);
                        }
                        if (event.keyCode === 13 && !event.shiftKey) {
                            event.preventDefault();
                            if (!this.sendButtonAlwaysDisabled) {
                                this._onButtonClick(event);
                            }
                        }
                        _get(_getPrototypeOf(MdsChatInput.prototype), "_onkeydown", this) && _get(_getPrototypeOf(MdsChatInput.prototype), "_onkeydown", this).call(this, event);
                    }
                }, {
                    key: "_onButtonClick",
                    value: function _onButtonClick(event) {
                        var inputNode = this._textFieldNode;
                        this._dispatchSubmitButtonEvent(event, {
                            text: inputNode.value
                        });
                        inputNode.value = "";
                        this.value = "";
                        this._handleFloatingLabelStyles(event);
                        if (this._focusRelatedTarget) {
                            this._focusRelatedTarget = false;
                            this.shadowRoot.querySelector("button").blur();
                            inputNode.focus();
                        }
                        this._isButtonActive = false;
                    }
                }, {
                    key: "_onButtonFocus",
                    value: function _onButtonFocus(event) {
                        var inputNode = this._textFieldNode;
                        if (event.target === this.shadowRoot.querySelector(".mds-chat-input__voice-button")) {
                            this._secondaryFocus = true;
                        }
                        if (inputNode.value) {
                            this._secondaryFocus = true;
                        }
                    }
                }, {
                    key: "_onButtonBlur",
                    value: function _onButtonBlur(event) {
                        this._secondaryFocus = false;
                        this._handleFloatingLabelStyles(event);
                        if (this._focusRelatedTarget) {
                            this._focusRelatedTarget = false;
                        }
                        this._textAreaHasFocus = false;
                    }
                }, {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                            target: "input"
                        };
                        return _get(_getPrototypeOf(MdsChatInput.prototype), "_getInteractiveElement", this).call(this, {
                            target: payload && payload.target && "".concat(payload.target, "-").concat(this.id)
                        });
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var id = this.id, value = this.value, label = this.label, accessibilityText = this.accessibilityText, accessibilityTextSendButton = this.accessibilityTextSendButton, accessibilityTextSendButtonDisabledText = this.accessibilityTextSendButtonDisabledText, inactive = this.inactive, _getEventProps = this._getEventProps, _getButtonEventProps = this._getButtonEventProps, hasLeadingButton = this.hasLeadingButton, leadingButtonEnabled = this.leadingButtonEnabled, accessibilityTextLeadingButton = this.accessibilityTextLeadingButton, sendButtonAlwaysDisabled = this.sendButtonAlwaysDisabled, _isFloating = this._isFloating, _isButtonActive = this._isButtonActive, _textAreaHasFocus = this._textAreaHasFocus, _secondaryFocus = this._secondaryFocus;
                        var labelClasses = {
                            "mds-chat-input__label": true,
                            "mds-chat-input__label--floating": _isFloating || _isButtonActive
                        };
                        var textAreaClasses = {
                            "mds-chat-input__textarea": true,
                            "mds-chat-input__textarea--active": _secondaryFocus
                        };
                        var buttonClasses = {
                            "mds-chat-input__button": true,
                            "mds-chat-input__button--active": sendButtonAlwaysDisabled ? false : _isButtonActive
                        };
                        var leadingButtonClasses = {
                            "mds-chat-input__questionmark-button": true,
                            "mds-chat-input__questionmark-button--active": leadingButtonEnabled
                        };
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "mds-chat-input");
                        _renderArbitrary(hasLeadingButton && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "mds-chat-input__questionmark-wrap"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("button", null, null, "id", "leading-".concat(id), "type", "button", "class", leadingButtonClasses, "disabled-prop", !leadingButtonEnabled, "onclick", this._dispatchLeadingButtonEvent, "onblur", this._onButtonBlur, "onfocus", this._onButtonFocus, "aria-label", accessibilityTextLeadingButton), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "mds-chat-input__questionmark-button-icon", "aria-hidden", "true", "innerHTML-prop", MDS.svgs["ico_question_mark_circle"], "__skip", "true"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("button"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "mds-chat-input__wrap");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "mds-chat-input__label-wrap");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("label", null, null, "for", "input-".concat(id), "class", labelClasses, "aria-hidden", "true");
                        _renderArbitrary(label);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("label");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "mds-chat-input__text-area-button-container");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("textarea");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", textAreaClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "input-".concat(id));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("name", "input-".concat(id));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("value", value);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("disabled-prop", inactive);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["conditionalAttribute"])(_objectSpread({}, _getEventProps()), !this.inactive));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("rows", this._textAreaRows > 0 ? this._textAreaRows : 1);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-label", label);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("autoComplete", "off");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("textarea");
                        _renderArbitrary(value);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("textarea");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "mds-chat-input__button-wrap");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("button");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "submit-button-".concat(id));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("type", "button");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", buttonClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("disabled-prop", sendButtonAlwaysDisabled || inactive || !_isButtonActive);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["conditionalAttribute"])(_objectSpread({}, _getButtonEventProps()), !this.inactive));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-label", _isButtonActive ? accessibilityTextSendButton : "".concat(accessibilityTextSendButton, " ").concat(accessibilityTextSendButtonDisabledText));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("button");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "mds-chat-input__button-icon", "aria-hidden", "true", "innerHTML-prop", MDS.svgs["ico_arrow_up"], "__skip", "true");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("button");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return MdsChatInput;
            }(_abstract_text_field__WEBPACK_IMPORTED_MODULE_2__["default"]), _class2.styles = _mds_chat_input_scss__WEBPACK_IMPORTED_MODULE_5___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsChatInput;
        },
        "./src/chat-input/mds-chat-input.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/chat-input/mds-chat-input.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/combo-button/ComboButton.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function generateMenuItem(item, index) {
                var _menuItemClasses;
                var menuItemClasses = (_menuItemClasses = {
                    "combo-button__menu-item": true
                }, _defineProperty(_menuItemClasses, "combo-button__".concat(index, "-button"), true), 
                _defineProperty(_menuItemClasses, "combo-button__menu-item--disabled", item.inactive), 
                _defineProperty(_menuItemClasses, "combo-button__menu-item--with-icon", item.iconType), 
                _menuItemClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("li", null, null, "class", menuItemClasses, "role", "menuitem", "tabIndex", "-1", "value", index, "aria-disabled", item.inactive, "onblur", this._handleMenuBlur);
                _renderArbitrary(item.iconType && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "combo-button__menu-item-icon", "aria-hidden", "true", "innerHTML-prop", MDS.svgs[item.iconType], "__skip", "true"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                _renderArbitrary(item.text);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("li");
            }
            function renderMenu() {
                var _this = this;
                if (!this.inactive) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "combo-button__menu-container");
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("ul", null, null, "class", "combo-button__menu-list", "role", "menu", "aria-hidden", !this.open, "onkeydown", this._handleMenuItemKeydown, "onkeyup", this._handleMenuItemKeyup, "onclick", this._handleMenuClick);
                    _renderArbitrary(this.open && this.menuItems.map(function(item, index) {
                        _newArrowCheck(this, _this);
                        return generateMenuItem.call(this, item, index);
                    }.bind(this)));
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("ul");
                    return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                }
                return "";
            }
            function ComboButtonTemplate() {
                var _buttonContainerClass, _dividerClasses;
                var iconType = this.iconType, inactive = this.inactive, variant = this.variant, size = this.size;
                var buttonVariant = variant === "secondary" ? "tertiary" : variant;
                var buttonContainerClasses = (_buttonContainerClass = {
                    "combo-button__button-container": true
                }, _defineProperty(_buttonContainerClass, "combo-button__button-container--".concat(variant), true), 
                _defineProperty(_buttonContainerClass, "combo-button__button-container--disabled", inactive), 
                _buttonContainerClass);
                var dividerClasses = (_dividerClasses = {
                    "combo-button__divider": true
                }, _defineProperty(_dividerClasses, "combo-button__divider--".concat(variant), true), 
                _defineProperty(_dividerClasses, "combo-button__divider--disabled", inactive), _dividerClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "combo-button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", buttonContainerClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("mds-button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "combo-button__primary-button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("text", this.text);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("variant", buttonVariant);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("inactive", inactive);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("icon-type", iconType);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    "icon-position": "leading"
                }, iconType));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("small", size === "small");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("value", "primary");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onclick", this._handleButtonClick);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("tab-focusable", !this.open);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("mds-button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", dividerClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-button", null, null, "class", "combo-button__menu-button", "variant", buttonVariant, "inactive", inactive, "icon-position", "icon_only", "icon-type", "ico_chevron_down", "small", size === "small", "accessible-text", this.menuButtonAccessibleText, "aria", {
                    "aria-haspopup": "menu",
                    "aria-expanded": this.open
                }, "value", "menu", "onmousedown", this._handleMenuButtonMousedown, "onmouseup", this.toggleMenu, "onkeydown", this._handleMenuButtonKeydown, "onclick", this._handleButtonClick);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                _renderArbitrary(renderMenu.call(this));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            __webpack_exports__["default"] = ComboButtonTemplate;
        },
        "./src/combo-button/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_combo_button_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/combo-button/mds-combo-button.scss");
            var _mds_combo_button_scss__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_combo_button_scss__WEBPACK_IMPORTED_MODULE_1__);
            var _abstract_combo_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/abstract-combo-button/index.jsx");
            var _ComboButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/combo-button/ComboButton.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            var arrayOf = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].arrayOf, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].boolean, string = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].stringRequired, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].enumerables, satisfies = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].satisfies;
            var menuItemEntity = {
                text: string.defaultsTo(""),
                inactive: boolean,
                iconType: enumerables.apply(void 0, [ string ].concat(_toConsumableArray(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["ICON_TYPES"])))
            };
            var entity = {
                menuButtonAccessibleText: string.defaultsTo("More options"),
                menuItems: arrayOf(satisfies(menuItemEntity)).withMinLength(1),
                iconType: enumerables.apply(void 0, [ string ].concat(_toConsumableArray(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["ICON_TYPES"]), [ "" ])),
                inactive: boolean.defaultsTo(false),
                size: enumerables(string, "regular", "small").defaultsTo("regular"),
                text: stringRequired,
                variant: enumerables(string, "primary", "secondary", "tertiary").defaultsTo("primary")
            };
            var MdsComboButton = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AbstractComboButton) {
                _inherits(MdsComboButton, _AbstractComboButton);
                function MdsComboButton() {
                    _classCallCheck(this, MdsComboButton);
                    return _possibleConstructorReturn(this, _getPrototypeOf(MdsComboButton).apply(this, arguments));
                }
                _createClass(MdsComboButton, [ {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                            value: "primary"
                        };
                        return {
                            interactiveElement: this.shadowRoot.querySelector(".combo-button__".concat(payload.value, "-button"))
                        };
                    }
                }, {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsComboButton.prototype), "connectedCallback", this).call(this, "combo-button");
                    }
                }, {
                    key: "_handleButtonClick",
                    value: function _handleButtonClick(event) {
                        this._dispatchClickEvent(event, {
                            value: event.target.value,
                            original: event.detail
                        });
                    }
                }, {
                    key: "_handleMenuClick",
                    value: function _handleMenuClick(event) {
                        if (!event.target.classList.contains("combo-button__menu-item--disabled")) {
                            this._dispatchClickEvent(event, {
                                value: event.target.value,
                                original: event
                            });
                            this.closeMenu(true);
                        } else {
                            event.stopPropagation();
                        }
                    }
                }, {
                    key: "_dispatchClickEvent",
                    value: function _dispatchClickEvent(event, detail) {
                        event.stopPropagation();
                        this.dispatchEvent(new CustomEvent("click", {
                            detail: detail,
                            bubbles: true,
                            composed: true,
                            cancelable: true
                        }));
                    }
                }, {
                    key: "render",
                    value: function render() {
                        _ComboButton__WEBPACK_IMPORTED_MODULE_3__["default"].call(this);
                    }
                } ], [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsComboButton";
                    }
                } ]);
                return MdsComboButton;
            }(_abstract_combo_button__WEBPACK_IMPORTED_MODULE_2__["default"]), _class2.styles = _mds_combo_button_scss__WEBPACK_IMPORTED_MODULE_1___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsComboButton;
        },
        "./src/combo-button/mds-combo-button.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/combo-button/mds-combo-button.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/commerce-tile/MdsCommerceTile.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _this = undefined;
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            var renderSlot = function renderSlot(_ref) {
                var interactiveSlot = _ref.interactiveSlot, variant = _ref.variant;
                _newArrowCheck(this, _this);
                var slotClasses = _defineProperty({
                    "commerce-tile--slot": true
                }, "commerce-tile--slot_".concat(variant), true);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", slotClasses, "tabIndex", interactiveSlot ? 0 : -1);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "name", "commerce-tile-slot");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }.bind(undefined);
            var renderImage = function renderImage(_ref2) {
                var _imageClasses;
                var image = _ref2.image, _ref2$imageContainerH = _ref2.imageContainerHeight, imageContainerHeight = _ref2$imageContainerH === void 0 ? "100%" : _ref2$imageContainerH, imageHorizontalAlignment = _ref2.imageHorizontalAlignment, imageVerticalAlignment = _ref2.imageVerticalAlignment, variant = _ref2.variant, _ref2$contentAreaHeig = _ref2.contentAreaHeight, contentAreaHeight = _ref2$contentAreaHeig === void 0 ? 1 : _ref2$contentAreaHeig, gradientHeight = _ref2.gradientHeight, _inverseGradiantFillHeight = _ref2._inverseGradiantFillHeight;
                _newArrowCheck(this, _this);
                var imageClasses = (_imageClasses = {
                    "commerce-tile__image": true
                }, _defineProperty(_imageClasses, "commerce-tile__image_".concat(variant), true), 
                _defineProperty(_imageClasses, "commerce-tile__image_".concat(variant, "_alignment--vertical-").concat(imageVerticalAlignment), true), 
                _defineProperty(_imageClasses, "commerce-tile__image_".concat(variant, "_alignment--horizontal-").concat(imageHorizontalAlignment), true), 
                _defineProperty(_imageClasses, "commerce-tile__image_height_no-img", variant === "regular" && !image && imageContainerHeight), 
                _imageClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", imageClasses);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    style: {
                        backgroundImage: "url(".concat(image, ")"),
                        height: contentAreaHeight > imageContainerHeight ? "100%" : imageContainerHeight < 80 ? "".concat(imageContainerHeight, "px") : "100%"
                    }
                }, image && variant === "inverse"));
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    style: {
                        height: "".concat(imageContainerHeight, "px")
                    }
                }, imageContainerHeight && variant === "regular"));
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    style: {
                        backgroundImage: "url(".concat(image, ")"),
                        height: "".concat(imageContainerHeight, "px")
                    }
                }, imageContainerHeight && image && variant === "regular"));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                _renderArbitrary(variant === "inverse" && gradientHeight === "fill" && image && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "style", {
                    height: "".concat(_inverseGradiantFillHeight, "px")
                }, "class", "commerce-tile--gradient_fill"), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                _renderArbitrary(variant === "inverse" && gradientHeight === "fill" && !image && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "style", {
                    height: "".concat(_inverseGradiantFillHeight, "px")
                }, "class", "commerce-tile--gradient_fill-no--img"), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }.bind(undefined);
            var renderLogo = function renderLogo(_ref3) {
                var _logoClasses;
                var logoSpacing = _ref3.logoSpacing, logo = _ref3.logo, logoAccessibleText = _ref3.logoAccessibleText, image = _ref3.image, variant = _ref3.variant, imageContainerHeight = _ref3.imageContainerHeight;
                _newArrowCheck(this, _this);
                var logoClasses = (_logoClasses = {
                    "commerce-tile-logo": true,
                    "commerce-tile-logo_spacing--condensed": logoSpacing === "condensed",
                    "commerce-tile-logo_spacing--relaxed": logoSpacing === "relaxed"
                }, _defineProperty(_logoClasses, "commerce-tile-logo_spacing--".concat(logoSpacing, "-").concat(variant), true), 
                _defineProperty(_logoClasses, "commerce-tile-logo_spacing--".concat(logoSpacing, "-").concat(variant, "_no-img"), !image || !imageContainerHeight), 
                _logoClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", logoClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("img", null, null, "src", logo, "alt", logoAccessibleText);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }.bind(undefined);
            var renderTag = function renderTag(_ref4) {
                var _tagClasses;
                var tagPlacement = _ref4.tagPlacement, tagText = _ref4.tagText, tagColor = _ref4.tagColor, tagIcon = _ref4.tagIcon, variant = _ref4.variant, imageContainerHeight = _ref4.imageContainerHeight, image = _ref4.image;
                _newArrowCheck(this, _this);
                var tagClasses = (_tagClasses = {
                    "commerce-tile--tag": true
                }, _defineProperty(_tagClasses, "commerce-tile--tag_placement--".concat(tagPlacement), true), 
                _defineProperty(_tagClasses, "commerce-tile--tag_placement--top-set", variant === "inverse" && tagPlacement === "middle"), 
                _defineProperty(_tagClasses, "commerce-tile--tag_placement--middle-set", variant === "regular" && tagPlacement === "middle" && (!imageContainerHeight || !image)), 
                _tagClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", tagClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("mds-tag", null, null, "icon", tagIcon, "text", tagText, "interactive", "false", "color", tagColor);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-tag");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }.bind(undefined);
            var renderContent = function renderContent(props) {
                var _contentClasses, _titleClass, _subtitleClass, _fillGradientClasses;
                _newArrowCheck(this, _this);
                var contentSize = props.contentSize, contentAreaHeight = props.contentAreaHeight, titleText = props.titleText, subtitle = props.subtitle, microcopy = props.microcopy, _shouldFillContentHight = props._shouldFillContentHight, titleProminent = props.titleProminent, variant = props.variant, _props$imageContainer = props.imageContainerHeight, imageContainerHeight = _props$imageContainer === void 0 ? 0 : _props$imageContainer, gradientHeight = props.gradientHeight, logo = props.logo, logoSpacing = props.logoSpacing, tagText = props.tagText, tagPlacement = props.tagPlacement, image = props.image, titleLineTruncation = props.titleLineTruncation, subtitleLineTruncation = props.subtitleLineTruncation, microcopyLineTruncation = props.microcopyLineTruncation, titleCharacterTruncation = props.titleCharacterTruncation, subtitleCharacterTruncation = props.subtitleCharacterTruncation, microcopyCharacterTruncation = props.microcopyCharacterTruncation, removeSlotBottomPadding = props.removeSlotBottomPadding;
                var contentHeightCheck = (contentAreaHeight && contentAreaHeight) > 0 ? contentAreaHeight : 1;
                var hasSlottedContent = !!props.parentElement.querySelector('[slot="commerce-tile-slot"]');
                var contentClasses = (_contentClasses = {
                    "commerce-tile-content": true
                }, _defineProperty(_contentClasses, "commerce-tile-content--".concat(variant), true), 
                _defineProperty(_contentClasses, "commerce-tile-content--".concat(variant, "-with_logo"), logo), 
                _defineProperty(_contentClasses, "commerce-tile-content--".concat(variant, "-with--no_logo"), !logo), 
                _defineProperty(_contentClasses, "commerce-tile-content--".concat(variant, "-with--no_logo-tag-top"), !logo && tagText && tagPlacement === "top"), 
                _defineProperty(_contentClasses, "commerce-tile-content--".concat(variant, "-with_logo-no_height"), logo && !imageContainerHeight), 
                _defineProperty(_contentClasses, "commerce-tile-content--with-content-slot", hasSlottedContent), 
                _defineProperty(_contentClasses, "commerce-tile-content--no-bottom-padding", hasSlottedContent && removeSlotBottomPadding), 
                _contentClasses);
                var titleClass = (_titleClass = {
                    "commerce-tile-content--title": true
                }, _defineProperty(_titleClass, "commerce-tile-content--".concat(contentSize, "-title"), true), 
                _defineProperty(_titleClass, "commerce-tile-content_prominent--".concat(contentSize, "-title"), !titleProminent), 
                _defineProperty(_titleClass, "commerce-tile-content--title--".concat(logoSpacing), variant === "inverse"), 
                _titleClass);
                var subtitleClass = (_subtitleClass = {
                    "commerce-tile-content--subtitle": true
                }, _defineProperty(_subtitleClass, "commerce-tile-content--".concat(contentSize, "-subtitle"), true), 
                _defineProperty(_subtitleClass, "commerce-tile-content_prominent--".concat(contentSize, "-subtitle"), !titleProminent), 
                _subtitleClass);
                var microcopyClass = _defineProperty({}, "commerce-tile-content--".concat(contentSize, "-microcopy"), true);
                var contentRelative = {
                    "commerce-tile-content--relative": variant === "inverse"
                };
                var contentSlotSpaced = _objectSpread({}, contentRelative, {
                    "commerce-tile-content--slot-spaced": contentAreaHeight && hasSlottedContent
                });
                var fixedGradientClasses = {
                    "commerce-tile--gradient_fixed": true,
                    "commerce-tile--gradient_fixed--with_logo": logo,
                    "commerce-tile--gradient_fixed--with_no-logo": !logo,
                    "commerce-tile--gradient_fixed--with-height_no-img": !image && imageContainerHeight,
                    "commerce-tile--gradient_fixed--with-no_height-img": !image && !imageContainerHeight
                };
                var fillGradientClasses = (_fillGradientClasses = {
                    "commerce-tile-content--gradient": true
                }, _defineProperty(_fillGradientClasses, "commerce-tile-content--gradient_".concat(gradientHeight), true), 
                _defineProperty(_fillGradientClasses, "commerce-tile-content--gradient_".concat(gradientHeight, "-").concat(logoSpacing), true), 
                _defineProperty(_fillGradientClasses, "commerce-tile-content--gradient_no-img_height", !image && !imageContainerHeight), 
                _defineProperty(_fillGradientClasses, "commerce-tile-content--gradient_".concat(gradientHeight, "-").concat(logoSpacing, "_no-slot"), variant === "inverse" && !hasSlottedContent), 
                _fillGradientClasses);
                var contentWrapper = _defineProperty({
                    "commerce-tile-content--wrapper": true
                }, "commerce-tile-content--wrapper-".concat(variant), true);
                var titleTextLineClampClass = {
                    titleText: true,
                    "titleText--line-clamp": true,
                    "titleText--line-clamp--hidden": !titleLineTruncation || !CSS.supports("display: -webkit-box")
                };
                var titleTextCharClampClass = {
                    titleText: true,
                    "titleText--character-clamp": true,
                    "titleText--character-clamp--hidden": titleLineTruncation
                };
                var subtitleTextLineClampClass = {
                    subtitleText: true,
                    "subtitleText--line-clamp": true,
                    "subtitleText--line-clamp--hidden": !subtitleLineTruncation || !CSS.supports("display: -webkit-box")
                };
                var subtitleTextCharClampClass = {
                    subtitleText: true,
                    "subtitleText--character-clamp": true,
                    "subtitleText--character-clamp--hidden": subtitleLineTruncation
                };
                var microcopyTextLineClampClass = {
                    microcopyText: true,
                    "microcopyText--line-clamp": true,
                    "microcopyText--line-clamp--hidden": !microcopyLineTruncation || !CSS.supports("display: -webkit-box")
                };
                var microcopyTextCharClampClass = {
                    microcopyText: true,
                    "microcopyText--character-clamp": true,
                    "microcopyText--character-clamp--hidden": microcopyLineTruncation
                };
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", contentClasses);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    style: {
                        height: "".concat(contentAreaHeight, "px")
                    }
                }, variant === "regular" && contentAreaHeight && !_shouldFillContentHight));
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    style: {
                        height: contentHeightCheck > imageContainerHeight ? "".concat(contentAreaHeight, "px") : imageContainerHeight < 80 ? "auto" : "".concat(imageContainerHeight, "px")
                    }
                }, variant === "inverse" && contentHeightCheck && !_shouldFillContentHight));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", contentWrapper);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    style: {
                        height: "".concat(contentAreaHeight, "px")
                    }
                }, contentAreaHeight && variant === "inverse"));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                _renderArbitrary(variant === "inverse" && gradientHeight === "fixed" && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", fixedGradientClasses), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                _renderArbitrary(logo && variant === "inverse" && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "commerce-tile-content--logo-wrapper"), 
                _renderArbitrary(renderLogo(props)), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", contentRelative);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    style: {
                        height: "100%"
                    }
                }, contentAreaHeight && variant === "regular"));
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    style: {
                        height: "100%"
                    }
                }, contentAreaHeight && variant === "inverse"));
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    style: {
                        height: "calc(100% - 48px)"
                    }
                }, contentAreaHeight && variant === "inverse" && logo));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                _renderArbitrary(variant === "inverse" && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", fillGradientClasses), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", contentSlotSpaced);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", titleClass);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("p", null, null, "class", titleTextLineClampClass, "style", {
                    "-webkit-line-clamp": titleLineTruncation
                });
                _renderArbitrary(titleText);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("p");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("p", null, null, "class", titleTextCharClampClass);
                _renderArbitrary(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["charTruncation"])(titleText, titleCharacterTruncation));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("p");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                _renderArbitrary(subtitle && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", subtitleClass), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("p", null, null, "class", subtitleTextLineClampClass, "style", {
                    "-webkit-line-clamp": subtitleLineTruncation
                }), _renderArbitrary(subtitle), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("p"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("p", null, null, "class", subtitleTextCharClampClass), 
                _renderArbitrary(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["charTruncation"])(subtitle, subtitleCharacterTruncation)), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("p"), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                _renderArbitrary(microcopy && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", microcopyClass), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", microcopyTextLineClampClass, "style", {
                    "-webkit-line-clamp": microcopyLineTruncation
                }), _renderArbitrary(microcopy), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", microcopyTextCharClampClass), 
                _renderArbitrary(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["charTruncation"])(microcopy, microcopyCharacterTruncation)), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span"), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                _renderArbitrary(tagText && tagPlacement === "middle" && variant === "regular" && renderTag(props));
                _renderArbitrary(hasSlottedContent && renderSlot(props));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }.bind(undefined);
            var renderCommerceTile = function renderCommerceTile(props) {
                var _commerceTileClasses;
                _newArrowCheck(this, _this);
                var variant = props.variant, logo = props.logo, logoSpacing = props.logoSpacing, image = props.image, imageContainerHeight = props.imageContainerHeight, tileWidth = props.tileWidth, tagText = props.tagText, tagPlacement = props.tagPlacement, gradientHeight = props.gradientHeight, tileAccessibleText = props.tileAccessibleText, id = props.id, interactiveSlot = props.interactiveSlot;
                var commerceTileClasses = (_commerceTileClasses = {
                    "commerce-tile": true
                }, _defineProperty(_commerceTileClasses, "commerce-tile--".concat(variant), true), 
                _defineProperty(_commerceTileClasses, "commerce-tile--gradient-".concat(gradientHeight), variant === "inverse"), 
                _defineProperty(_commerceTileClasses, "commerce-tile--gradient-".concat(gradientHeight, "--no_img-height"), variant === "inverse" && !image && !imageContainerHeight), 
                _defineProperty(_commerceTileClasses, "commerce-tile--with_no-logo--".concat(logoSpacing), variant === "inverse" && !logo && logoSpacing), 
                _defineProperty(_commerceTileClasses, "commerce-tile--with_tag", tagText && tagPlacement), 
                _defineProperty(_commerceTileClasses, "commerce-tile--with_tag--".concat(tagPlacement), tagText && tagPlacement), 
                _defineProperty(_commerceTileClasses, "commerce-tile--interactive", !interactiveSlot), 
                _commerceTileClasses);
                var wrapperClasses = {
                    "commerce-tile__wrapper": true,
                    "commerce-tile--interactive": interactiveSlot
                };
                var tileEvents = {
                    onclick: props._dispatchClickCommerceTileEvent,
                    role: "link",
                    tabIndex: 0
                };
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", commerceTileClasses);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    style: {
                        width: "".concat(tileWidth, "px")
                    }
                }, tileWidth && tileWidth > 80));
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])(tileEvents, !interactiveSlot));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                _renderArbitrary(tileAccessibleText && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text", "id", "accessible-text-".concat(id)), 
                _renderArbitrary(tileAccessibleText), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "commerce-tile__container");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", wrapperClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("tabIndex", "-1");
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])(tileEvents, interactiveSlot));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                _renderArbitrary(renderImage(props));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div");
                _renderArbitrary(logo && variant === "regular" && renderLogo(props));
                _renderArbitrary(renderContent(props));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                _renderArbitrary(tagText && tagPlacement === "top" && variant === "regular" && renderTag(props));
                _renderArbitrary(tagText && variant === "inverse" && renderTag(props));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }.bind(undefined);
            function MdsCommerceTileTemplate() {
                return renderCommerceTile(this);
            }
            __webpack_exports__["default"] = MdsCommerceTileTemplate;
        },
        "./src/commerce-tile/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_commerce_tile_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/commerce-tile/mds-commerce-tile.scss");
            var _mds_commerce_tile_scss__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_commerce_tile_scss__WEBPACK_IMPORTED_MODULE_1__);
            var _MdsCommerceTile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/commerce-tile/MdsCommerceTile.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            var string = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].string, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].boolean, number = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].number, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].enumerables, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].stringRequired;
            var entity = {
                variant: enumerables(string, "regular", "inverse").defaultsTo("regular"),
                tileWidth: number.withMinSize(80),
                contentAreaHeight: number,
                imageContainerHeight: number.withMinSize(80),
                image: string,
                imageHorizontalAlignment: enumerables(string, "left", "center", "right").defaultsTo("center"),
                imageVerticalAlignment: enumerables(string, "top", "center", "bottom").defaultsTo("center"),
                contentSize: enumerables(string, "large", "medium", "small").defaultsTo("small"),
                titleProminent: boolean.defaultsTo(true),
                subtitle: string,
                titleText: stringRequired,
                titleLineTruncation: number,
                subtitleLineTruncation: number,
                microcopyLineTruncation: number,
                titleCharacterTruncation: number,
                subtitleCharacterTruncation: number,
                microcopyCharacterTruncation: number,
                microcopy: string,
                logo: string,
                logoSpacing: enumerables(string, "condensed", "relaxed").defaultsTo("condensed"),
                tagPlacement: enumerables(string, "top", "middle").defaultsTo("top"),
                gradientHeight: enumerables(string, "fill", "fixed").defaultsTo("fill"),
                slotContent: string,
                interactiveSlot: boolean.defaultsTo(false),
                tileAccessibleText: string,
                logoAccessibleText: string,
                tagText: string,
                tagColor: enumerables(string, "base", "accent").defaultsTo("base"),
                tagIcon: enumerables.apply(void 0, [ string ].concat(_toConsumableArray(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["ICON_TYPES"]))),
                removeSlotBottomPadding: boolean.defaultsTo(false)
            };
            var MdsCommerceTile = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsCommerceTile, _AgaveComponent);
                _createClass(MdsCommerceTile, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsCommerceTile";
                    }
                } ]);
                function MdsCommerceTile() {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsCommerceTile);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsCommerceTile).call(this));
                    _this._setPropVal = function(prop, condition, val) {
                        _newArrowCheck(this, _this2);
                        if (!prop || !val) return;
                        if (condition) {
                            _this[prop] = val;
                        }
                    }.bind(this);
                    _this._getNestedEle = function(selector, prop) {
                        _newArrowCheck(this, _this2);
                        if (!prop) {
                            return _this.shadowRoot && _this.shadowRoot.querySelector(selector);
                        }
                        return _this.shadowRoot && _this.shadowRoot.querySelector(selector) && _this.shadowRoot.querySelector(selector)[prop];
                    }.bind(this);
                    _this._getInteractiveElement = function() {
                        _newArrowCheck(this, _this2);
                        return {
                            interactiveElement: _this.shadowRoot.querySelector(".commerce-tile__wrapper")
                        };
                    }.bind(this);
                    _this._dispatchCustomEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])();
                    _this._dispatchClickCommerceTileEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "click-commerce-tile-".concat(_this.id);
                    }.bind(this));
                    _this.defineObservedProperty("_shouldFillContentHight", false);
                    _this.defineObservedProperty("_inverseGradiantFillHeight", 0);
                    return _this;
                }
                _createClass(MdsCommerceTile, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsCommerceTile.prototype), "connectedCallback", this) && _get(_getPrototypeOf(MdsCommerceTile.prototype), "connectedCallback", this).call(this);
                        var variant = this.variant, gradientHeight = this.gradientHeight, contentAreaHeight = this.contentAreaHeight, imageContainerHeight = this.imageContainerHeight;
                        this._setPropVal("_shouldFillContentHight", this._getNestedEle(".commerce-tile-content--wrapper", "offsetHeight") > this._getNestedEle(".commerce-tile-content", "offsetHeight"), true);
                        var commerceTileContentWrapperHeight = this._getNestedEle(".commerce-tile-content--gradient", "offsetHeight");
                        var commerceTileHeight = this._getNestedEle(".commerce-tile", "offsetHeight");
                        var inverseGradiantFillHeight = commerceTileHeight - commerceTileContentWrapperHeight - 1.5;
                        this._setPropVal("_inverseGradiantFillHeight", variant === "inverse" && gradientHeight === "fill", contentAreaHeight || !contentAreaHeight && !imageContainerHeight ? Math.floor(inverseGradiantFillHeight) : inverseGradiantFillHeight);
                    }
                }, {
                    key: "render",
                    value: function render() {
                        _MdsCommerceTile__WEBPACK_IMPORTED_MODULE_2__["default"].call(this);
                    }
                } ]);
                return MdsCommerceTile;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["AgaveComponent"]), _class2.styles = _mds_commerce_tile_scss__WEBPACK_IMPORTED_MODULE_1___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsCommerceTile;
        },
        "./src/commerce-tile/mds-commerce-tile.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/commerce-tile/mds-commerce-tile.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/comparison-table/MdsComparisonTable.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "_ComparisonTableEmptyTemplate", (function() {
                return _ComparisonTableEmptyTemplate;
            }));
            __webpack_require__.d(__webpack_exports__, "default", (function() {
                return _ComparisonTableTemplate;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            var columnHeadersIdentifier = "__column-headers";
            var columnHeaderCellIdentifier = "__column-header";
            var rowIdentifier = "__row";
            var cellIdentifier = "__cell";
            var iconIdentifier = "__icon";
            var emptyTableIdentifier = "__empty-table";
            function _createCleanedRow(header, rowData, numColumns) {
                var _this = this;
                var row = new Array(numColumns).fill("");
                if (header) {
                    row[0] = header;
                }
                if (rowData) {
                    rowData.forEach(function(col, colIndex) {
                        _newArrowCheck(this, _this);
                        var temp = header || header === "" ? colIndex + 1 : colIndex;
                        row[temp] = col;
                    }.bind(this));
                }
                return row;
            }
            function _setAccessibilityLabels(label, rowType) {
                switch (rowType) {
                  case this.rowTypes.CAPTION:
                    this.currentCaptionLabel = label;
                    break;

                  case this.rowTypes.HEADER:
                    this.currentRowHeaderLabel = label;
                    break;

                  default:
                    break;
                }
            }
            function _getAccessibilityLabels(rowType) {
                switch (rowType) {
                  case this.rowTypes.HEADER:
                    return ", ".concat(this.currentCaptionLabel);

                  case this.rowTypes.SUBTOPIC:
                    return ", ".concat(this.currentRowHeaderLabel, ", ").concat(this.currentCaptionLabel);

                  default:
                    return "";
                }
            }
            function _renderSuccessIcon() {
                var iconClass = this.rootClass + iconIdentifier;
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", iconClass);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-icon", null, null, "size", "20", "color", "success", "type", "ico_checkmark_filled", "accessible-text", this.trueIconAccessibleText);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function _renderCellValue(cellValue, rowType) {
                if (cellValue === "true") {
                    return _renderSuccessIcon.call(this);
                } else if (cellValue === "false") {
                    return "";
                } else if (cellValue === "" && rowType !== this.rowTypes.CAPTION) {
                    return "—";
                }
                return cellValue;
            }
            function _renderCell(cell, colIndex, rowType) {
                var _cellClasses;
                var cellId = "".concat(this.rootClass + cellIdentifier, "-row").concat(this.rowIndex + 1, "-column").concat(colIndex + 1);
                var isRowHeader = colIndex === 0;
                var isCaptionRow = rowType === this.rowTypes.CAPTION;
                var isShaded = !this.isXs && this.alternateRowCounter % 2 !== 0;
                var isShadedXs = this.isXs && !isCaptionRow && isRowHeader;
                isRowHeader && _setAccessibilityLabels.call(this, cell, rowType);
                var cellClasses = (_cellClasses = {}, _defineProperty(_cellClasses, "".concat(this.rootClass, "__row-header"), isRowHeader), 
                _defineProperty(_cellClasses, "".concat(this.rootClass, "__xs-hidden"), isCaptionRow && !isRowHeader), 
                _defineProperty(_cellClasses, "".concat(this.rootClass + cellIdentifier, "-value"), !isRowHeader), 
                _defineProperty(_cellClasses, "".concat(this.rootClass + cellIdentifier, "-caption"), isCaptionRow && isRowHeader), 
                _defineProperty(_cellClasses, "".concat(this.rootClass + cellIdentifier, "-header"), rowType === this.rowTypes.HEADER && isRowHeader), 
                _defineProperty(_cellClasses, "".concat(this.rootClass + cellIdentifier, "-subtopic"), rowType === this.rowTypes.SUBTOPIC && isRowHeader), 
                _defineProperty(_cellClasses, "".concat(this.rootClass + cellIdentifier, "-shaded"), isShaded || isShadedXs), 
                _defineProperty(_cellClasses, this.rootClass + cellIdentifier, true), _cellClasses);
                var role = isRowHeader ? "rowheader" : "cell";
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "id", cellId, "class", cellClasses, "role", role);
                _renderArbitrary(_renderCellValue.call(this, cell, rowType));
                _renderArbitrary(isRowHeader && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text"), 
                _renderArbitrary(_getAccessibilityLabels.call(this, rowType)), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function _renderRow(row, rowType) {
                var _rowClasses, _this2 = this;
                var rowId = this.rootClass + rowIdentifier + (this.rowIndex + 1);
                var rowClasses = (_rowClasses = {}, _defineProperty(_rowClasses, this.rootClass + rowIdentifier, true), 
                _defineProperty(_rowClasses, "".concat(this.rootClass + rowIdentifier + (this.maxNumberColumns === 2 ? "-twoColumn" : "-threeColumn")), true), 
                _rowClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "id", rowId, "class", rowClasses, "role", "row", "aria-hidden", rowType === this.rowTypes.CAPTION);
                _renderArbitrary(row.map(function(cell, colIndex) {
                    _newArrowCheck(this, _this2);
                    return _renderCell.call(this, cell, colIndex, rowType);
                }.bind(this)));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function _renderCaptionRow(group) {
                var captionRow = _createCleanedRow(group.caption, null, this.maxNumberColumns + 1);
                _renderRow.call(this, captionRow, this.rowTypes.CAPTION);
            }
            function _renderHeaderRow(row) {
                var rowDataCleaned = [];
                rowDataCleaned = _createCleanedRow(row.rowHeader, row.rowData, this.maxNumberColumns + 1);
                _renderRow.call(this, rowDataCleaned, this.rowTypes.HEADER);
            }
            function _renderSubTopicRow(subTopicRow) {
                var subTopicRowDataCleaned = [];
                subTopicRowDataCleaned = _createCleanedRow(subTopicRow.subTopicRowHeader, subTopicRow.subTopicRowData, this.maxNumberColumns + 1);
                _renderRow.call(this, subTopicRowDataCleaned, this.rowTypes.SUBTOPIC);
            }
            function _renderAllRows() {
                var _this3 = this;
                this.rowIndex = 0;
                return this.series.forEach(function(group) {
                    var _this4 = this;
                    _newArrowCheck(this, _this3);
                    this.alternateRowCounter = 0;
                    if (group.caption) {
                        _renderCaptionRow.call(this, group);
                        this.rowIndex += 1;
                        this.alternateRowCounter += 1;
                    }
                    group.rows.forEach(function(row) {
                        var _this5 = this;
                        _newArrowCheck(this, _this4);
                        _renderHeaderRow.call(this, row);
                        this.rowIndex += 1;
                        this.alternateRowCounter += 1;
                        row.subTopicRows.forEach(function(subTopicRow) {
                            _newArrowCheck(this, _this5);
                            _renderSubTopicRow.call(this, subTopicRow);
                            this.rowIndex += 1;
                            this.alternateRowCounter += 1;
                        }.bind(this));
                    }.bind(this));
                }.bind(this));
            }
            function _renderColumnHeader(columnHeader, colIndex) {
                var _columnHeaderClasses;
                var columnHeaderId = this.rootClass + columnHeaderCellIdentifier + colIndex;
                var isRowHeader = colIndex === 0;
                var columnHeaderClasses = (_columnHeaderClasses = {}, _defineProperty(_columnHeaderClasses, this.rootClass + columnHeaderCellIdentifier, true), 
                _defineProperty(_columnHeaderClasses, this.rootClass + cellIdentifier, true), _defineProperty(_columnHeaderClasses, "".concat(this.rootClass, "__row-header"), isRowHeader), 
                _defineProperty(_columnHeaderClasses, "".concat(this.rootClass, "__xs-hidden"), isRowHeader), 
                _defineProperty(_columnHeaderClasses, "".concat(this.rootClass, "-not-shaded"), true), 
                _defineProperty(_columnHeaderClasses, "".concat(this.rootClass + columnHeaderCellIdentifier + (this.maxNumberColumns === 2 ? "-twoColumn" : "-threeColumn")), !isRowHeader), 
                _columnHeaderClasses);
                var role = isRowHeader ? "cell" : "columnheader";
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "id", columnHeaderId, "class", columnHeaderClasses, "role", role);
                _renderArbitrary(columnHeader);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function _renderAllColumnHeaders() {
                var _columnHeadersClass, _this6 = this;
                var columnHeadersId = this.rootClass + columnHeadersIdentifier;
                var columnHeadersClass = (_columnHeadersClass = {}, _defineProperty(_columnHeadersClass, this.rootClass + rowIdentifier, true), 
                _defineProperty(_columnHeadersClass, "".concat(this.rootClass + rowIdentifier + (this.maxNumberColumns === 2 ? "-twoColumn" : "-threeColumn")), true), 
                _defineProperty(_columnHeadersClass, "".concat(this.rootClass, "__sticky"), this.stickyHeader), 
                _columnHeadersClass);
                var columnHeadersCleaned = [];
                columnHeadersCleaned = _createCleanedRow("", this.columnHeaders, this.maxNumberColumns + 1);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "id", columnHeadersId, "class", columnHeadersClass, "role", "row");
                _renderArbitrary(columnHeadersCleaned.map(function(columnHeader, colIndex) {
                    _newArrowCheck(this, _this6);
                    return _renderColumnHeader.call(this, columnHeader, colIndex);
                }.bind(this)));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function _ComparisonTableEmptyTemplate() {
                var rootClass = this.rootClass, emptyStateHeader = this.emptyStateHeader;
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "id", "".concat(rootClass).concat(emptyTableIdentifier), "class", rootClass);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "".concat(rootClass).concat(emptyTableIdentifier));
                _renderArbitrary(emptyStateHeader);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function _ComparisonTableTemplate() {
                var rootClass = this.rootClass;
                var id = rootClass;
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "id", id, "class", rootClass, "role", "table", "aria-labelledby", "table-accessible-text");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "id", "table-accessible-text", "aria-hidden", "true", "class", "accessible-text");
                _renderArbitrary(this.tableAccessibleText);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                _renderArbitrary(_renderAllColumnHeaders.call(this));
                _renderArbitrary(_renderAllRows.call(this));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
        },
        "./src/comparison-table/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_comparison_table_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/comparison-table/mds-comparison-table.scss");
            var _mds_comparison_table_scss__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_comparison_table_scss__WEBPACK_IMPORTED_MODULE_1__);
            var _MdsComparisonTable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/comparison-table/MdsComparisonTable.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var satisfies = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].satisfies, arrayOf = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].arrayOf, string = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].string, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].boolean;
            var rowTypes = {
                CAPTION: "caption",
                HEADER: "header",
                SUBTOPIC: "subtopic"
            };
            var subTopicRowEntity = {
                subTopicRowHeader: string,
                subTopicRowData: arrayOf(string)
            };
            var rowEntity = {
                rowHeader: string,
                rowData: arrayOf(string),
                subTopicRows: arrayOf(satisfies(subTopicRowEntity))
            };
            var seriesEntity = {
                caption: string,
                rows: arrayOf(satisfies(rowEntity))
            };
            var entity = {
                stickyHeader: boolean.defaultsTo(false),
                emptyStateHeader: string,
                trueIconAccessibleText: string,
                tableAccessibleText: string,
                columnHeaders: arrayOf(string).withMinLength(2).withMaxLength(3),
                series: arrayOf(satisfies(seriesEntity)).withChangedCallback().withMinLength(1)
            };
            var MdsComparisonTable = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsComparisonTable, _AgaveComponent);
                _createClass(MdsComparisonTable, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsComparisonTable";
                    }
                } ]);
                function MdsComparisonTable() {
                    var _this;
                    _classCallCheck(this, MdsComparisonTable);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsComparisonTable).call(this));
                    _this.rootClass = "comparison-table";
                    _this.maxNumberColumns = 0;
                    _this.rowTypes = rowTypes;
                    _this.rowIndex = 0;
                    _this.alternateRowCounter = 0;
                    _this.currentCaptionLabel = "";
                    _this.currentRowHeaderLabel = "";
                    _this.defineObservedProperty("isXs", "");
                    _this._resizeListener = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["debounce"])(_this._resizeListener.bind(_assertThisInitialized(_this)), 100);
                    window.addEventListener("resize", _this._resizeListener);
                    return _this;
                }
                _createClass(MdsComparisonTable, [ {
                    key: "seriesChangedCallback",
                    value: function seriesChangedCallback() {
                        this._hasData() && this._prepareData();
                    }
                }, {
                    key: "_resizeListener",
                    value: function _resizeListener() {
                        this._setLayout();
                    }
                }, {
                    key: "_prepareData",
                    value: function _prepareData() {
                        this._setMaxNumberColumns() && this._setLayout();
                    }
                }, {
                    key: "_hasData",
                    value: function _hasData() {
                        if (!this.series || !this.columnHeaders) {
                            return false;
                        }
                        return true;
                    }
                }, {
                    key: "_setLayout",
                    value: function _setLayout() {
                        this.isXs = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["getBreakpoint"])() === "xs" || Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["getBreakpoint"])() === "sm";
                    }
                }, {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsComparisonTable.prototype), "connectedCallback", this).call(this);
                        this._setLayout();
                    }
                }, {
                    key: "disconnectedCallback",
                    value: function disconnectedCallback() {
                        _get(_getPrototypeOf(MdsComparisonTable.prototype), "disconnectedCallback", this) && _get(_getPrototypeOf(MdsComparisonTable.prototype), "disconnectedCallback", this).call(this);
                        window.removeEventListener("resize", this._resizeListener);
                    }
                }, {
                    key: "_setMaxNumberColumnsHelper",
                    value: function _setMaxNumberColumnsHelper(rowData) {
                        this.maxNumberColumns = rowData.length > this.maxNumberColumns ? rowData.length : this.maxNumberColumns;
                    }
                }, {
                    key: "_setMaxNumberColumns",
                    value: function _setMaxNumberColumns() {
                        var _this2 = this;
                        this.series.forEach(function(group) {
                            var _this3 = this;
                            _newArrowCheck(this, _this2);
                            group.rows.forEach(function(row) {
                                var _this4 = this;
                                _newArrowCheck(this, _this3);
                                this._setMaxNumberColumnsHelper(row.rowData);
                                row.subTopicRows.forEach(function(subTopicRow) {
                                    _newArrowCheck(this, _this4);
                                    this._setMaxNumberColumnsHelper(subTopicRow.subTopicRowData);
                                }.bind(this));
                            }.bind(this));
                        }.bind(this));
                    }
                }, {
                    key: "render",
                    value: function render() {
                        if (this._hasData()) {
                            _MdsComparisonTable__WEBPACK_IMPORTED_MODULE_2__["default"].call(this);
                        } else {
                            _MdsComparisonTable__WEBPACK_IMPORTED_MODULE_2__["_ComparisonTableEmptyTemplate"].call(this);
                        }
                    }
                } ]);
                return MdsComparisonTable;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_0___default.a), _class2.styles = _mds_comparison_table_scss__WEBPACK_IMPORTED_MODULE_1___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsComparisonTable;
        },
        "./src/comparison-table/mds-comparison-table.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/comparison-table/mds-comparison-table.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/data-table-action-bar/MdsDataTableActionBar.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _this = undefined;
            var _div$wrapper = function _div$wrapper(_classes, _$concat, _slotName) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", _classes);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "class", _$concat, "name", _slotName);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }, _slot$wrapper = function _slot$wrapper(_$concat2, _slotName2) {
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "class", _$concat2, "name", _slotName2);
            };
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            var renderSlots = function renderSlots(slotNames, name) {
                var _this2 = this;
                _newArrowCheck(this, _this);
                var classes = "action-bar__".concat(name);
                var container = "action-bar__".concat(name, "-container");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", container);
                _renderArbitrary(slotNames.map(function(slotName) {
                    _newArrowCheck(this, _this2);
                    if (MDS.isFireFox) {
                        return _jsxWrapper(_div$wrapper, [ classes, "".concat(classes, "-slot"), slotName ]);
                    }
                    return _jsxWrapper(_slot$wrapper, [ "".concat(classes, "-slot"), slotName ]);
                }.bind(this)));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }.bind(undefined);
            function MdsDataTableActionBarTemplate() {
                var accessibleName = this.accessibleName, filteringContent = this.filteringContent, utilityActionsContent = this.utilityActionsContent;
                var containerClasses = {
                    "action-bar": true
                };
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", containerClasses, "role", "toolbar", "tabIndex", "-1", "aria-label", accessibleName);
                _renderArbitrary(MDS.isIOS && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text"), 
                _renderArbitrary(accessibleName), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                _renderArbitrary(filteringContent && renderSlots(filteringContent, "filter"));
                _renderArbitrary(utilityActionsContent && renderSlots(utilityActionsContent, "utility"));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            __webpack_exports__["default"] = MdsDataTableActionBarTemplate;
        },
        "./src/data-table-action-bar/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_data_table_action_bar_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/data-table-action-bar/mds-data-table-action-bar.scss");
            var _mds_data_table_action_bar_scss__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_data_table_action_bar_scss__WEBPACK_IMPORTED_MODULE_1__);
            var _MdsDataTableActionBar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/data-table-action-bar/MdsDataTableActionBar.jsx");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["mixins"].AttributeMarshallingMixin, string = _mixins$AttributeMars.string, arrayOf = _mixins$AttributeMars.arrayOf, number = _mixins$AttributeMars.number;
            var entity = {
                accessibleName: string,
                filteringContent: arrayOf(string),
                filterWidth: number.defaultsTo(20),
                utilityActionsContent: arrayOf(string)
            };
            var MdsDataTableActionBar = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsDataTableActionBar, _AgaveComponent);
                _createClass(MdsDataTableActionBar, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsDataTableActionBar";
                    }
                } ]);
                function MdsDataTableActionBar() {
                    var _this;
                    _classCallCheck(this, MdsDataTableActionBar);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsDataTableActionBar).call(this));
                    _this._assignWidthToFilter = _this._assignWidthToFilter.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsDataTableActionBar, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsDataTableActionBar.prototype), "connectedCallback", this).call(this);
                        this._utilitySlots = this.shadowRoot.querySelectorAll(".action-bar__utility-slot");
                        this._filterSlots = this.shadowRoot.querySelectorAll(".action-bar__filter-slot");
                        this._assignWidthToFilter();
                        this._enforceSlotUsage();
                    }
                }, {
                    key: "_enforceSlotUsage",
                    value: function _enforceSlotUsage() {
                        var _this2 = this;
                        _toConsumableArray(this.children).forEach(function(slotted) {
                            _newArrowCheck(this, _this2);
                            if (this.utilityActionsContent.includes(slotted.slot)) {
                                if (!this.constructor._childLocalNames.includes(slotted.localName)) {
                                    slotted.remove();
                                    this.throwConstraintError("The ".concat(this.localName, " only accepts ").concat(this.constructor._childLocalNames.join(", "), " in its utility slots. A ").concat(slotted.localName, " has been detected and removed."));
                                }
                            }
                        }.bind(this));
                    }
                }, {
                    key: "_assignWidthToFilter",
                    value: function _assignWidthToFilter() {
                        var _this3 = this;
                        _toConsumableArray(this.children).forEach(function(slotted) {
                            _newArrowCheck(this, _this3);
                            if (this.filteringContent.includes(slotted.slot)) {
                                slotted.style.width = "".concat(this.filterWidth, "rem");
                            }
                        }.bind(this));
                    }
                }, {
                    key: "render",
                    value: function render() {
                        _MdsDataTableActionBar__WEBPACK_IMPORTED_MODULE_2__["default"].call(this);
                    }
                } ]);
                return MdsDataTableActionBar;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["AgaveComponent"]), _class2.styles = _mds_data_table_action_bar_scss__WEBPACK_IMPORTED_MODULE_1___default.a, 
            _class2._childLocalNames = [ "mds-button" ], _class2)) || _class);
            __webpack_exports__["default"] = MdsDataTableActionBar;
        },
        "./src/data-table-action-bar/mds-data-table-action-bar.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/data-table-action-bar/mds-data-table-action-bar.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/data-table-for-accounts/DataTableForAccounts.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "_dataTableForAccountsTemplate", (function() {
                return _dataTableForAccountsTemplate;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            var _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/abstract-data-table/AbstractMdsDataTable.jsx");
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _generateCell(cellData, colIndex, rowIndex, columnData, isFooter, isLastRowInGroup) {
                if (isFooter) {
                    return this._columnObjects[colIndex].renderFooter({
                        value: cellData.value,
                        firstValue: this.footer[0].value
                    }, rowIndex);
                }
                var isRepeatRow = this.columnConfigs[0].columnType === "repeatRow";
                var isFirstRowHeader = false;
                if (colIndex === 0 && cellData.value !== this._lastRowHeader) {
                    this._lastRowHeader = cellData.value;
                    isFirstRowHeader = true;
                }
                var hasRowHeaderValues = this.columnConfigs[0].columnType === "checkbox" && this._hasRowHeaderValues();
                var config = {
                    additionalClasses: {
                        "data-table-for-accounts__row-value--dashed": isRepeatRow && !isLastRowInGroup && colIndex > 0
                    },
                    isFirstRowHeader: isFirstRowHeader,
                    isRepeatRow: isRepeatRow,
                    mode: this.mode,
                    hasRowHeaderValues: hasRowHeaderValues
                };
                return this._columnObjects[colIndex].renderCell(cellData, rowIndex, config);
            }
            function _generateRow(rowIndex, row) {
                var _rowClasses, _this = this;
                var isFooter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var rows = arguments.length > 3 ? arguments[3] : undefined;
                var footer = this.footer, mode = this.mode, activated = this.activated, rowStyle = this.rowStyle, highlightRow = this.highlightRow, highlightRowOff = this.highlightRowOff, columnConfigs = this.columnConfigs, suppressLastRowBorder = this.suppressLastRowBorder;
                var isLastRowInGroup;
                var isLast;
                var tempRows = this._sortedMap || rows;
                if (!isFooter) {
                    var currentRowValue = tempRows[rowIndex][0].value;
                    var nextRowValue = tempRows[rowIndex + 1] ? tempRows[rowIndex + 1][0].value : undefined;
                    isLastRowInGroup = tempRows && !isFooter && (tempRows.length - 1 === rowIndex ? true : currentRowValue !== nextRowValue);
                    isLast = tempRows && footer && tempRows.length - 1 === rowIndex;
                }
                var isRepeatRow = this.columnConfigs[0].columnType === "repeatRow";
                var idRow = "row-".concat(rowIndex + 1);
                var rowClasses = (_rowClasses = {
                    "data-table-for-accounts__row": true
                }, _defineProperty(_rowClasses, "data-table-for-accounts__row--".concat(mode), true), 
                _defineProperty(_rowClasses, "data-table-for-accounts__row--".concat(rowStyle), !isLast && rowStyle && !isRepeatRow), 
                _defineProperty(_rowClasses, "data-table-for-accounts__row--footer", isFooter), 
                _defineProperty(_rowClasses, "data-table-for-accounts__row--activated", this.activated), 
                _rowClasses);
                if (!isLast && isRepeatRow && isLastRowInGroup) {
                    rowClasses["data-table-for-accounts__row--solid"] = true;
                }
                var isLastRow = tempRows && tempRows.length - 1 === rowIndex;
                if (!footer && isLastRow && suppressLastRowBorder) {
                    rowClasses["data-table-for-accounts__row--solid"] = false;
                    rowClasses["data-table-for-accounts__row--dashed"] = false;
                }
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("tr");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRow);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", rowClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-index", rowIndex + 1);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-values", row.map(function(rowVal) {
                    _newArrowCheck(this, _this);
                    return rowVal.value;
                }.bind(this)).toString());
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    onmouseenter: highlightRow
                }, activated));
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    onmouseleave: highlightRowOff
                }, activated));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("tr");
                _renderArbitrary(row.map(function(rowVal, colIndex) {
                    _newArrowCheck(this, _this);
                    return _generateCell.call(this, rowVal, colIndex, rowIndex, columnConfigs[colIndex], isFooter, isLastRowInGroup);
                }.bind(this)));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tr");
            }
            function _renderFooter(row, index) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("tfoot");
                _renderArbitrary(_generateRow.call(this, index, row, true));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tfoot");
            }
            function _renderAllRows(rows) {
                var _this2 = this;
                if (this.sortMap) {
                    this._lastRowHeader = undefined;
                    this._sortedMap = this.sortMap.map(function(sortIndex) {
                        _newArrowCheck(this, _this2);
                        return rows[sortIndex];
                    }.bind(this));
                    return this.sortMap.map(function(rowIndex, index) {
                        _newArrowCheck(this, _this2);
                        return _generateRow.call(this, index, rows[rowIndex], false, rows);
                    }.bind(this));
                }
                return rows.map(function(row, index, arr) {
                    _newArrowCheck(this, _this2);
                    return _generateRow.call(this, index, row, false, arr);
                }.bind(this));
            }
            function _renderCheckboxHeaderlessRow() {
                if (this._hasColumnHeaderValues() || !this.columnConfigs || this.columnConfigs[0].columnType !== "checkbox") {
                    return "";
                }
                return this._columnObjects[0].renderTopCheckboxNoColumnHeaders({
                    numColumns: this.columnConfigs.length,
                    numRows: this.rowData.length
                });
            }
            function _dataTableForAccountsTemplate() {
                var id = this.id, rowDataCleaned = this.rowDataCleaned, columnConfigs = this.columnConfigs, footer = this.footer, hasVisibleCaption = this.hasVisibleCaption;
                var tableClasses = {
                    "data-table-for-accounts": true,
                    "data-table-for-accounts--checkbox-no-caption": !hasVisibleCaption && this._hasCheckboxAndHeaders()
                };
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div");
                _renderArbitrary(MDS.isIOS && _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_2__["_renderCaption"].call(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("table", null, null, "id", id, "class", tableClasses, "onchange", this._handleChange, "onclick", this._handleClick);
                _renderArbitrary(!MDS.isIOS && _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_2__["_renderCaption"].call(this));
                _renderArbitrary(columnConfigs && _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_2__["_renderColumnHeader"].call(this));
                _renderArbitrary(_renderCheckboxHeaderlessRow.call(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("tbody");
                _renderArbitrary(rowDataCleaned && _renderAllRows.call(this, rowDataCleaned));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tbody");
                _renderArbitrary(footer && _renderFooter.call(this, footer, rowDataCleaned.length));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("table");
                _renderArbitrary(_abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_2__["_renderAriaLive"].call(this));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            __webpack_exports__["default"] = _dataTableForAccountsTemplate;
        },
        "./src/data-table-for-accounts/columnTypeConstructorMap.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var _abstract_data_table_columns_left_aligned_column__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/abstract-data-table/columns/left-aligned-column/index.jsx");
            var _abstract_data_table_columns_right_aligned_column__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-data-table/columns/right-aligned-column/index.jsx");
            var _abstract_data_table_columns_row_header_column__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/abstract-data-table/columns/row-header-column/index.jsx");
            var _abstract_data_table_columns_row_header_link_column__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/abstract-data-table/columns/row-header-link-column/index.jsx");
            var _abstract_data_table_columns_navigation_column__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/abstract-data-table/columns/navigation-column/index.jsx");
            var _abstract_data_table_columns_combo_button_column__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/abstract-data-table/columns/combo-button-column/index.jsx");
            var _abstract_data_table_columns_repeat_row_column__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/abstract-data-table/columns/repeat-row-column/index.jsx");
            var _abstract_data_table_columns_checkbox_column__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/abstract-data-table/columns/checkbox-column/index.jsx");
            var _abstract_data_table_columns_menu_button_column__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("./src/abstract-data-table/columns/menu-button-column/index.jsx");
            var _abstract_data_table_columns_buttons_column__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("./src/abstract-data-table/columns/buttons-column/index.jsx");
            var _abstract_data_table_columns_select_column__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("./src/abstract-data-table/columns/select-column/index.jsx");
            var columnTypeConstructorMap = {
                leftAligned: _abstract_data_table_columns_left_aligned_column__WEBPACK_IMPORTED_MODULE_0__["default"],
                rightAligned: _abstract_data_table_columns_right_aligned_column__WEBPACK_IMPORTED_MODULE_1__["default"],
                rowHeader: _abstract_data_table_columns_row_header_column__WEBPACK_IMPORTED_MODULE_2__["default"],
                rowHeaderLink: _abstract_data_table_columns_row_header_link_column__WEBPACK_IMPORTED_MODULE_3__["default"],
                navigation: _abstract_data_table_columns_navigation_column__WEBPACK_IMPORTED_MODULE_4__["default"],
                comboButton: _abstract_data_table_columns_combo_button_column__WEBPACK_IMPORTED_MODULE_5__["default"],
                repeatRow: _abstract_data_table_columns_repeat_row_column__WEBPACK_IMPORTED_MODULE_6__["default"],
                checkbox: _abstract_data_table_columns_checkbox_column__WEBPACK_IMPORTED_MODULE_7__["default"],
                menuButton: _abstract_data_table_columns_menu_button_column__WEBPACK_IMPORTED_MODULE_8__["default"],
                buttons: _abstract_data_table_columns_buttons_column__WEBPACK_IMPORTED_MODULE_9__["default"],
                select: _abstract_data_table_columns_select_column__WEBPACK_IMPORTED_MODULE_10__["default"]
            };
            __webpack_exports__["default"] = columnTypeConstructorMap;
        },
        "./src/data-table-for-accounts/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _abstract_data_table__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-data-table/index.js");
            var _DataTableForAccounts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/data-table-for-accounts/DataTableForAccounts.jsx");
            var _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/abstract-data-table/AbstractMdsDataTable.jsx");
            var _mds_data_table_for_accounts_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/data-table-for-accounts/mds-data-table-for-accounts.scss");
            var _mds_data_table_for_accounts_scss__WEBPACK_IMPORTED_MODULE_4___default = __webpack_require__.n(_mds_data_table_for_accounts_scss__WEBPACK_IMPORTED_MODULE_4__);
            var _columnTypeConstructorMap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/data-table-for-accounts/columnTypeConstructorMap.js");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/utils/common-utils.js");
            var _dec, _class, _class2;
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["mixins"].AttributeMarshallingMixin, enumerables = _mixins$AttributeMars.enumerables, satisfies = _mixins$AttributeMars.satisfies, arrayOf = _mixins$AttributeMars.arrayOf, stringRequired = _mixins$AttributeMars.stringRequired, string = _mixins$AttributeMars.string, boolean = _mixins$AttributeMars.boolean;
            var columnConfigEntity = _objectSpread({
                columnType: enumerables(stringRequired, "leftAligned", "rightAligned", "rowHeader", "rowHeaderLink", "navigation", "comboButton", "repeatRow", "checkbox", "menuButton", "buttons", "select")
            }, _abstract_data_table__WEBPACK_IMPORTED_MODULE_1__["abstractColumnConfigEntity"]);
            var entity = _objectSpread({}, _abstract_data_table__WEBPACK_IMPORTED_MODULE_1__["entity"], {
                columnConfigs: arrayOf(satisfies(columnConfigEntity)).withChangedCallback(),
                rowStyle: enumerables(string, "solid", "dashed"),
                suppressLastRowBorder: boolean.defaultsTo(false)
            });
            var MdsDataTableForAccounts = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AbstractDataTable) {
                _inherits(MdsDataTableForAccounts, _AbstractDataTable);
                _createClass(MdsDataTableForAccounts, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsDataTableForAccounts";
                    }
                } ]);
                function MdsDataTableForAccounts() {
                    var _this;
                    _classCallCheck(this, MdsDataTableForAccounts);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsDataTableForAccounts).call(this));
                    _this.rootClass = "data-table-for-accounts";
                    _this._columnTypeConstructorMap = _columnTypeConstructorMap__WEBPACK_IMPORTED_MODULE_5__["default"];
                    _this._handleChange = _this._handleChange.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsDataTableForAccounts, [ {
                    key: "rowDataChangedCallback",
                    value: function rowDataChangedCallback() {
                        this._hasRowDataValues() && this._prepareData();
                        this.sortMap && this.sortTable(this._sortedColumn, this._sortedDirection);
                    }
                }, {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        var _this2 = this;
                        _get(_getPrototypeOf(MdsDataTableForAccounts.prototype), "connectedCallback", this).call(this);
                        this._columnObjects && this._columnObjects.forEach(function(column) {
                            _newArrowCheck(this, _this2);
                            return column.addEventListeners && column.addEventListeners(this);
                        }.bind(this));
                    }
                }, {
                    key: "_handleChange",
                    value: function _handleChange(event) {
                        event.stopPropagation();
                        var columnObject = this._columnObjects[+event.target.dataset.column - 1];
                        columnObject && columnObject.handleChange && columnObject.handleChange.call(this, event);
                    }
                }, {
                    key: "getNumberOfSelectedCheckboxes",
                    value: function getNumberOfSelectedCheckboxes() {
                        var _this3 = this;
                        if (this.columnConfigs && this.columnConfigs[0].columnType === "checkbox") {
                            return this.rowData && this.rowData.reduce(function(numSelected, rowData) {
                                _newArrowCheck(this, _this3);
                                return rowData[0].state === "true" || rowData[0].state === true ? numSelected + 1 : numSelected;
                            }.bind(this), 0) || 0;
                        }
                        return 0;
                    }
                }, {
                    key: "render",
                    value: function render() {
                        this.alertMessageColumn = undefined;
                        if (this._hasRowDataValues()) {
                            if (this.stacked) {
                                _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_3__["_renderAllStackedTables"].call(this);
                            } else {
                                _DataTableForAccounts__WEBPACK_IMPORTED_MODULE_2__["default"].call(this);
                            }
                        } else {
                            return this.renderEmptyTables();
                        }
                    }
                } ]);
                return MdsDataTableForAccounts;
            }(_abstract_data_table__WEBPACK_IMPORTED_MODULE_1__["default"]), _class2.styles = _mds_data_table_for_accounts_scss__WEBPACK_IMPORTED_MODULE_4___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsDataTableForAccounts;
        },
        "./src/data-table-for-accounts/mds-data-table-for-accounts.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/data-table-for-accounts/mds-data-table-for-accounts.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/data-table-for-chart/DataTableForChart.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "_DataTableForChartTemplate", (function() {
                return _DataTableForChartTemplate;
            }));
            __webpack_require__.d(__webpack_exports__, "_DataTableForChartStackedTemplate", (function() {
                return _DataTableForChartStackedTemplate;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            var _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/abstract-data-table/AbstractMdsDataTable.jsx");
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _generateCell(cellData, colIndex, isInlineCaptionRow, rowIndex, isFooter) {
                if (this.columnConfigs) {
                    if (isFooter) {
                        return this._columnObjects[colIndex].renderFooter({
                            value: cellData.value,
                            firstValue: this.footer[0].value
                        }, rowIndex);
                    }
                    var config = {
                        additionalClasses: {
                            "data-table-for-chart__row-value": !isInlineCaptionRow && (colIndex !== 0 || this.stacked),
                            "data-table-for-chart__inline-caption-row": isInlineCaptionRow
                        },
                        hasInlineCaption: this.layout === "rowInline",
                        isInlineCaption: isInlineCaptionRow && colIndex === 0,
                        sortMap: this.sortMap
                    };
                    return this._columnObjects[colIndex].renderCell(cellData, rowIndex, config);
                }
            }
            function _generateRow(rowIndex, row, swatchColors) {
                var _rowClasses, _this = this;
                var isFooter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                var rows = arguments.length > 4 ? arguments[4] : undefined;
                var isLast = rows && this.footer && rows.length - 1 === rowIndex;
                var separators = this.stacked ? undefined : this.separators;
                var layout = this.stacked ? "row" : this.layout;
                var rowStyle = this.stacked || isLast ? "" : this.rowStyle;
                var isInlineCaptionRow = layout === "rowInline" && rowIndex === 0;
                var isSolid = separators && separators.solidRows && separators.solidRows.includes(rowIndex);
                var isDashed = separators && separators.dashedRows && separators.dashedRows.includes(rowIndex);
                var separatorType = isSolid ? "solid" : isDashed ? "dashed" : false;
                var idRow = "row-".concat(this.layout === "rowInline" ? rowIndex : rowIndex + 1);
                var rowClasses = (_rowClasses = {
                    "data-table-for-chart__row": !isInlineCaptionRow
                }, _defineProperty(_rowClasses, "data-table-for-chart__row--".concat(this.mode), true), 
                _defineProperty(_rowClasses, "data-table-for-chart__row--".concat(rowStyle || separatorType), rowStyle || separatorType), 
                _defineProperty(_rowClasses, "data-table-for-chart__row--footer", isFooter), _defineProperty(_rowClasses, "data-table-for-chart__row--inline-caption-row", isInlineCaptionRow), 
                _defineProperty(_rowClasses, "data-table-for-chart__row--activated", this.activated), 
                _defineProperty(_rowClasses, "data-table-for-chart__row--highlight", this.highlightedIndex === rowIndex), 
                _rowClasses);
                var isLastRow = rows && rows.length - 1 === rowIndex;
                if (!this.footer && isLastRow && this.suppressLastRowBorder) {
                    rowClasses["data-table-for-chart__row--solid"] = false;
                    rowClasses["data-table-for-chart__row--dashed"] = false;
                }
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("tr");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRow);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", rowClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-index", this.layout === "rowInline" ? rowIndex : rowIndex + 1);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-values", row.map(function(rowVal) {
                    _newArrowCheck(this, _this);
                    return Object.prototype.hasOwnProperty.call(rowVal, "value") ? rowVal.value : rowVal.headerValue;
                }.bind(this)).toString());
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    onmouseenter: this.highlightRow
                }, !isInlineCaptionRow && this.activated));
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    onmouseleave: this.highlightRowOff
                }, !isInlineCaptionRow && this.activated));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("tr");
                _renderArbitrary(row.map(function(rowVal, colIndex) {
                    _newArrowCheck(this, _this);
                    return _generateCell.call(this, rowVal, colIndex, isInlineCaptionRow, rowIndex, isFooter);
                }.bind(this)));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tr");
            }
            function _renderFooter(row, index, swatchColors) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("tfoot");
                _renderArbitrary(_generateRow.call(this, index, row, swatchColors, true));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tfoot");
            }
            function _renderAllRows(rows, swatchColors) {
                var _this2 = this;
                if (this.sortMap) {
                    return this.sortMap.map(function(rowIndex, index) {
                        _newArrowCheck(this, _this2);
                        return _generateRow.call(this, index, rows[rowIndex], swatchColors, false, rows);
                    }.bind(this));
                }
                return rows.map(function(row, index, arr) {
                    _newArrowCheck(this, _this2);
                    return _generateRow.call(this, index, row, swatchColors, false, arr);
                }.bind(this));
            }
            function _DataTableForChartTemplate() {
                var id = this.id, rowDataCleaned = this.rowDataCleaned, swatchColors = this.swatchColors, columnConfigs = this.columnConfigs, footer = this.footer;
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div");
                _renderArbitrary(MDS.isIOS && _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_2__["_renderCaption"].call(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("table", null, null, "id", id, "class", "data-table-for-chart", "onclick", this._handleClick);
                _renderArbitrary(!MDS.isIOS && _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_2__["_renderCaption"].call(this));
                _renderArbitrary(columnConfigs && _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_2__["_renderColumnHeader"].call(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("tbody");
                _renderArbitrary(rowDataCleaned && _renderAllRows.call(this, rowDataCleaned, swatchColors));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tbody");
                _renderArbitrary(this.footer && _renderFooter.call(this, footer, rowDataCleaned.length, swatchColors));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("table");
                _renderArbitrary(_abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_2__["_renderAriaLive"].call(this));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function _renderSingleStackedTable(caption, columnIndex, singleTableData, rowHeaders) {
                var stackedCaption = "".concat(caption, ":\n").concat(rowHeaders[columnIndex].value);
                var idTable = "".concat(this.id, "-subtable-").concat(columnIndex);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("table", null, null, "id", idTable, "class", "data-table-for-chart", "onclick", this._handleClick);
                _renderArbitrary(_abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_2__["_renderStackedCaption"].call(this, stackedCaption));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("tbody");
                _renderArbitrary(singleTableData && _renderAllRows.call(this, singleTableData));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tbody");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("table");
            }
            function _DataTableForChartStackedTemplate() {
                return _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_2__["_renderAllStackedTables"].call(this);
            }
            __webpack_exports__["default"] = _DataTableForChartTemplate;
        },
        "./src/data-table-for-chart/columnTypeConstructorMap.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var _abstract_data_table_columns_left_aligned_column__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/abstract-data-table/columns/left-aligned-column/index.jsx");
            var _abstract_data_table_columns_right_aligned_column__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-data-table/columns/right-aligned-column/index.jsx");
            var _abstract_data_table_columns_row_header_column__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/abstract-data-table/columns/row-header-column/index.jsx");
            var _abstract_data_table_columns_row_header_link_column__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/abstract-data-table/columns/row-header-link-column/index.jsx");
            var _abstract_data_table_columns_navigation_column__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/abstract-data-table/columns/navigation-column/index.jsx");
            var columnTypeConstructorMap = {
                leftAligned: _abstract_data_table_columns_left_aligned_column__WEBPACK_IMPORTED_MODULE_0__["default"],
                rightAligned: _abstract_data_table_columns_right_aligned_column__WEBPACK_IMPORTED_MODULE_1__["default"],
                rowHeader: _abstract_data_table_columns_row_header_column__WEBPACK_IMPORTED_MODULE_2__["default"],
                rowHeaderLink: _abstract_data_table_columns_row_header_link_column__WEBPACK_IMPORTED_MODULE_3__["default"],
                navigation: _abstract_data_table_columns_navigation_column__WEBPACK_IMPORTED_MODULE_4__["default"]
            };
            __webpack_exports__["default"] = columnTypeConstructorMap;
        },
        "./src/data-table-for-chart/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _abstract_data_table__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-data-table/index.js");
            var _DataTableForChart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/data-table-for-chart/DataTableForChart.jsx");
            var _mds_data_table_for_chart_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/data-table-for-chart/mds-data-table-for-chart.scss");
            var _mds_data_table_for_chart_scss__WEBPACK_IMPORTED_MODULE_3___default = __webpack_require__.n(_mds_data_table_for_chart_scss__WEBPACK_IMPORTED_MODULE_3__);
            var _columnTypeConstructorMap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/data-table-for-chart/columnTypeConstructorMap.js");
            var _dec, _class, _class2;
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var arrayOf = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].arrayOf, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].enumerables, number = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].number, satisfies = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].satisfies, string = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].stringRequired, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].boolean, object = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].object;
            var separatorEntity = {
                dashedRows: arrayOf(number),
                solidRows: arrayOf(number)
            };
            var columnConfigEntity = _objectSpread({
                columnType: enumerables(stringRequired, "leftAligned", "rightAligned", "rowHeader", "rowHeaderLink", "navigation")
            }, _abstract_data_table__WEBPACK_IMPORTED_MODULE_1__["abstractColumnConfigEntity"]);
            var entity = _objectSpread({}, _abstract_data_table__WEBPACK_IMPORTED_MODULE_1__["entity"], {
                columnConfigs: arrayOf(satisfies(columnConfigEntity)).withChangedCallback(),
                swatchShape: enumerables(string, "circle", "square").withChangedCallback(),
                swatchColors: arrayOf(string).withChangedCallback(),
                hiddenAccessibleTotalSumText: string,
                rowStyle: enumerables(string, "solid", "dashed"),
                layout: enumerables(string, "columnRow", "row", "rowInline").defaultsTo("columnRow"),
                separators: satisfies(separatorEntity),
                highlightedIndex: number,
                suppressLastRowBorder: boolean.defaultsTo(false)
            });
            var MdsDataTableForChart = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AbstractDataTable) {
                _inherits(MdsDataTableForChart, _AbstractDataTable);
                _createClass(MdsDataTableForChart, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsDataTableForChart";
                    }
                } ]);
                function MdsDataTableForChart() {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsDataTableForChart);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsDataTableForChart).call(this));
                    _this.rootClass = "data-table-for-chart";
                    _this._checkErrors = function() {
                        _newArrowCheck(this, _this2);
                        if (_this._hasColumnHeaderValues() && _this.layout === "rowInline") {
                            _this.throwConstraintError("MDS Data Table For Chart should not use columnHeaders property to render row headers or first row; accesibility requires usage of specific html tags (td, th, tr, caption)");
                        }
                    }.bind(this);
                    _this._columnTypeConstructorMap = _columnTypeConstructorMap__WEBPACK_IMPORTED_MODULE_4__["default"];
                    return _this;
                }
                _createClass(MdsDataTableForChart, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsDataTableForChart.prototype), "connectedCallback", this).call(this);
                        this._checkErrors();
                    }
                }, {
                    key: "visualHighlightRow",
                    value: function visualHighlightRow(rowIndex) {
                        this.highlightRow = rowIndex;
                        return _get(_getPrototypeOf(MdsDataTableForChart.prototype), "visualHighlightRow", this).call(this, rowIndex);
                    }
                }, {
                    key: "visualHighlightRowOff",
                    value: function visualHighlightRowOff(rowIndex) {
                        this.highlightRow = -1;
                        return _get(_getPrototypeOf(MdsDataTableForChart.prototype), "visualHighlightRowOff", this).call(this, rowIndex);
                    }
                }, {
                    key: "columnConfigsChangedCallback",
                    value: function columnConfigsChangedCallback(columnConfigs) {
                        _get(_getPrototypeOf(MdsDataTableForChart.prototype), "columnConfigsChangedCallback", this).call(this, columnConfigs);
                        if (columnConfigs && this.swatchShape && this._columnObjects[0]) {
                            this._columnObjects[0].config.swatchShape = this.swatchShape;
                            this._columnObjects[0].config.swatchColors = this.swatchColors;
                        }
                    }
                }, {
                    key: "swatchShapeChangedCallback",
                    value: function swatchShapeChangedCallback(swatchShape) {
                        if (this._columnObjects && this._columnObjects[0]) {
                            this._columnObjects[0].config.swatchShape = swatchShape;
                        }
                    }
                }, {
                    key: "swatchColorsChangedCallback",
                    value: function swatchColorsChangedCallback(swatchColors) {
                        if (this._columnObjects && this._columnObjects[0]) {
                            this._columnObjects[0].config.swatchColors = swatchColors;
                        }
                    }
                }, {
                    key: "rowDataChangedCallback",
                    value: function rowDataChangedCallback() {
                        this._hasRowDataValues() && this._prepareData();
                        this.sortMap && this.sortTable(this._sortedColumn, this._sortedDirection);
                    }
                }, {
                    key: "render",
                    value: function render() {
                        if (this._hasRowDataValues()) {
                            if (this.stacked) {
                                _DataTableForChart__WEBPACK_IMPORTED_MODULE_2__["_DataTableForChartStackedTemplate"].call(this);
                            } else {
                                _DataTableForChart__WEBPACK_IMPORTED_MODULE_2__["default"].call(this);
                            }
                        } else {
                            this.renderEmptyTables();
                        }
                    }
                } ]);
                return MdsDataTableForChart;
            }(_abstract_data_table__WEBPACK_IMPORTED_MODULE_1__["default"]), _class2.styles = _mds_data_table_for_chart_scss__WEBPACK_IMPORTED_MODULE_3___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsDataTableForChart;
        },
        "./src/data-table-for-chart/mds-data-table-for-chart.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/data-table-for-chart/mds-data-table-for-chart.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/data-table-for-files/DataTableForFiles.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "_DataTableForFilesTemplate", (function() {
                return _DataTableForFilesTemplate;
            }));
            __webpack_require__.d(__webpack_exports__, "_renderEmptyTable", (function() {
                return _renderEmptyTable;
            }));
            __webpack_require__.d(__webpack_exports__, "_DataTableForFilesStackedTemplate", (function() {
                return _DataTableForFilesStackedTemplate;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-data-table/AbstractMdsDataTable.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/common-utils.js");
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _generateCell(cellData, colIndex, rowIndex) {
                if (this.columnConfigs) {
                    var config = {
                        additionalClasses: {
                            "data-table-for-files__row-value": colIndex !== 0 || this.stacked,
                            "data-table-for-files__row--buttons": colIndex === 2
                        }
                    };
                    return this._columnObjects[colIndex].renderCell(cellData, rowIndex, config);
                }
            }
            function _generateRow(rowIndex, row) {
                var _rowClasses, _this = this;
                var isFooter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var rows = arguments.length > 3 ? arguments[3] : undefined;
                var tempRows = this._sortedMap || rows;
                var currentRowValue = tempRows[rowIndex][0].value;
                var nextRowValue = tempRows[rowIndex + 1] ? tempRows[rowIndex + 1][0].value : undefined;
                var isLastRowInGroup = tempRows && !isFooter && (tempRows.length - 1 === rowIndex ? true : currentRowValue !== nextRowValue);
                var isLast = tempRows && tempRows.length - 1 === rowIndex;
                var idRow = "row-".concat(this.layout === "rowInline" ? rowIndex : rowIndex + 1);
                var rowClasses = (_rowClasses = {
                    "data-table-for-files__row": true
                }, _defineProperty(_rowClasses, "data-table-for-files__row--".concat(this.mode), true), 
                _defineProperty(_rowClasses, "data-table-for-files__row--solid", !isLast || !isLastRowInGroup), 
                _rowClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("tr", null, null, "id", idRow, "class", rowClasses, "data-index", rowIndex + 1, "data-values", row.map(function(rowVal) {
                    _newArrowCheck(this, _this);
                    return Object.prototype.hasOwnProperty.call(rowVal, "value") ? rowVal.value : rowVal.headerValue;
                }.bind(this)).toString());
                _renderArbitrary(row.map(function(rowVal, colIndex) {
                    _newArrowCheck(this, _this);
                    return _generateCell.call(this, rowVal, colIndex, rowIndex);
                }.bind(this)));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tr");
            }
            function _renderAllRows(rows) {
                var _this2 = this;
                if (this.sortMap) {
                    return this.sortMap.map(function(rowIndex, index) {
                        _newArrowCheck(this, _this2);
                        return _generateRow.call(this, index, rows[rowIndex], false, rows);
                    }.bind(this));
                }
                return rows.map(function(row, index, arr) {
                    _newArrowCheck(this, _this2);
                    return _generateRow.call(this, index, row, false, arr);
                }.bind(this));
            }
            function _DataTableForFilesTemplate() {
                var id = this.id, rowDataCleaned = this.rowDataCleaned;
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div");
                _renderArbitrary(MDS.isIOS && _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_1__["_renderCaption"].call(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("table");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", id);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "data-table-for-files");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onclick", this._handleClick);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["conditionalAttribute"])({
                    style: {
                        width: this.tableWidth
                    }
                }, this.tableWidth));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("table");
                _renderArbitrary(!MDS.isIOS && _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_1__["_renderCaption"].call(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("tbody");
                _renderArbitrary(rowDataCleaned && _renderAllRows.call(this, rowDataCleaned));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tbody");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("table");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function _renderAllStackedTables() {
                var _this3 = this, _captionClasses;
                var rootClass = this.rootClass, id = this.id, sortMap = this.sortMap, rowDataCleaned = this.rowDataCleaned, hasVisibleCaption = this.hasVisibleCaption, stackedCaptionHeadingLevel = this.stackedCaptionHeadingLevel, caption = this.caption;
                var data = sortMap ? sortMap.map(function(index) {
                    _newArrowCheck(this, _this3);
                    return rowDataCleaned[index];
                }.bind(this)) : rowDataCleaned;
                var captionClasses = (_captionClasses = {}, _defineProperty(_captionClasses, "".concat(rootClass, "__stacked-caption-heading"), true), 
                _defineProperty(_captionClasses, "".concat(rootClass, "__stacked-caption-heading--hidden"), !hasVisibleCaption), 
                _captionClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("section", null, null, "id", id, "class", "".concat(rootClass, "__stacked-container"), "aria-labelledby", "".concat(id, "-stacked-caption-heading"), "onclick", this._handleClick);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("h2", null, null, "id", "".concat(id, "-stacked-caption-heading"), "aria-level", stackedCaptionHeadingLevel, "class", captionClasses);
                _renderArbitrary(caption);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("h2");
                _renderArbitrary(data.map(_renderSingleStackedTable.bind(this)));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("section");
            }
            function _renderSingleStackedTable(row, rowIndex) {
                var _rowClasses2;
                var idTable = "".concat(this.id, "-subtable-").concat(rowIndex);
                var rowClasses = (_rowClasses2 = {}, _defineProperty(_rowClasses2, "".concat(this.rootClass, "__row"), true), 
                _defineProperty(_rowClasses2, "".concat(this.rootClass, "__row--").concat(this.mode), true), 
                _rowClasses2);
                var headerIndex = 0;
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("table", null, null, "id", idTable, "class", "data-table-for-files", "onclick", this._handleClick);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("tbody");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("tr", null, null, "id", "table-".concat(rowIndex + 1, "-row-").concat(rowIndex + 1, "-stacked-row-0"), "class", rowClasses, "data-index", rowIndex + 1, "data-values", [ row[headerIndex].value ].toString());
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("th", null, null, "id", "row-header-".concat(rowIndex + 1, "-row-").concat(rowIndex + 1, "-stacked-row-0"), "class", "".concat(this.rootClass, "__row-").concat(rowIndex + 1), "scope", "row");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "".concat(this.rootClass, "__row-header-container"));
                _renderArbitrary(this._columnObjects[headerIndex]._renderStackedHeaderValue(row[headerIndex], rowIndex, this.columnConfigs[0]));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("th");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tr");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("tr", null, null, "id", "table-".concat(rowIndex + 1, "-row-").concat(rowIndex + 1, "-stacked-row-1"), "class", rowClasses, "data-index", rowIndex + 1, "data-values", [ row[headerIndex].value ].toString());
                _renderArbitrary(this._columnObjects[1].renderStackedCell(row[1], rowIndex, this.stackedCellWidth || this.columnConfigs[1].width, 1));
                _renderArbitrary(this._columnObjects[2].renderStackedCell(row[2], rowIndex, this.stackedCellWidth || this.columnConfigs[1].width, 2));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tr");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tbody");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("table");
                _renderArbitrary(rowIndex !== this.rowDataCleaned.length - 1 && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "".concat(this.rootClass, "__separator")));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function _renderEmptyTable() {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", this.rootClass);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "".concat(this.rootClass, "__empty-table ").concat(this.rootClass, "__empty-table--block"));
                _renderArbitrary(this.nullStateMessage);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function _DataTableForFilesStackedTemplate() {
                return _renderAllStackedTables.call(this);
            }
            __webpack_exports__["default"] = _DataTableForFilesTemplate;
        },
        "./src/data-table-for-files/columnTypeConstructorMap.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var _abstract_data_table_columns_row_header_link_column__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/abstract-data-table/columns/row-header-link-column/index.jsx");
            var _abstract_data_table_columns_left_aligned_column__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-data-table/columns/left-aligned-column/index.jsx");
            var _abstract_data_table_columns_buttons_column__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/abstract-data-table/columns/buttons-column/index.jsx");
            var columnTypeConstructorMap = {
                rowHeaderLink: _abstract_data_table_columns_row_header_link_column__WEBPACK_IMPORTED_MODULE_0__["default"],
                leftAligned: _abstract_data_table_columns_left_aligned_column__WEBPACK_IMPORTED_MODULE_1__["default"],
                buttons: _abstract_data_table_columns_buttons_column__WEBPACK_IMPORTED_MODULE_2__["default"]
            };
            __webpack_exports__["default"] = columnTypeConstructorMap;
        },
        "./src/data-table-for-files/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _abstract_data_table__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-data-table/index.js");
            var _DataTableForFiles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/data-table-for-files/DataTableForFiles.jsx");
            var _mds_data_table_for_files_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/data-table-for-files/mds-data-table-for-files.scss");
            var _mds_data_table_for_files_scss__WEBPACK_IMPORTED_MODULE_3___default = __webpack_require__.n(_mds_data_table_for_files_scss__WEBPACK_IMPORTED_MODULE_3__);
            var _columnTypeConstructorMap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/data-table-for-files/columnTypeConstructorMap.js");
            var _dec, _class, _class2;
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["mixins"].AttributeMarshallingMixin, enumerables = _mixins$AttributeMars.enumerables, satisfies = _mixins$AttributeMars.satisfies, arrayOf = _mixins$AttributeMars.arrayOf, stringRequired = _mixins$AttributeMars.stringRequired, string = _mixins$AttributeMars.string;
            var columnConfigEntity = _objectSpread({
                columnType: enumerables(stringRequired, "leftAligned", "rowHeaderLink", "buttons")
            }, _abstract_data_table__WEBPACK_IMPORTED_MODULE_1__["abstractColumnConfigEntity"]);
            var entity = _objectSpread({}, _abstract_data_table__WEBPACK_IMPORTED_MODULE_1__["entity"], {
                columnConfigs: arrayOf(satisfies(columnConfigEntity)).withChangedCallback(),
                tableWidth: string,
                mode: string.defaultsTo("relaxed").withChangedCallback()
            });
            var MdsDataTableForFiles = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AbstractDataTable) {
                _inherits(MdsDataTableForFiles, _AbstractDataTable);
                _createClass(MdsDataTableForFiles, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsDataTableForFiles";
                    }
                } ]);
                function MdsDataTableForFiles() {
                    var _this;
                    _classCallCheck(this, MdsDataTableForFiles);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsDataTableForFiles).call(this));
                    _this.rootClass = "data-table-for-files";
                    _this._columnTypeConstructorMap = _columnTypeConstructorMap__WEBPACK_IMPORTED_MODULE_4__["default"];
                    return _this;
                }
                _createClass(MdsDataTableForFiles, [ {
                    key: "rowDataChangedCallback",
                    value: function rowDataChangedCallback() {
                        this._hasRowDataValues() && this._prepareData();
                        this.sortMap && this.sortTable(this._sortedColumn, this._sortedDirection);
                    }
                }, {
                    key: "columnConfigsChangedCallback",
                    value: function columnConfigsChangedCallback(columnConfigs) {
                        _get(_getPrototypeOf(MdsDataTableForFiles.prototype), "columnConfigsChangedCallback", this).call(this, columnConfigs);
                        if (columnConfigs[0].columnType !== "rowHeaderLink" || columnConfigs[1].columnType !== "leftAligned" || columnConfigs[2].columnType !== "buttons") {
                            throw new TypeError("columnConfigs has a specific order for column types: 1st column - rowHeaderLink, 2nd column - leftAligned, 3rd column - buttons");
                        }
                    }
                }, {
                    key: "modeChangedCallback",
                    value: function modeChangedCallback() {
                        this.mode = "relaxed";
                    }
                }, {
                    key: "render",
                    value: function render() {
                        this.alertMessageColumn = undefined;
                        if (this._hasRowDataValues()) {
                            if (this.stacked) {
                                _DataTableForFiles__WEBPACK_IMPORTED_MODULE_2__["_DataTableForFilesStackedTemplate"].call(this);
                            } else {
                                _DataTableForFiles__WEBPACK_IMPORTED_MODULE_2__["default"].call(this);
                            }
                        } else {
                            return _DataTableForFiles__WEBPACK_IMPORTED_MODULE_2__["_renderEmptyTable"].call(this);
                        }
                    }
                } ]);
                return MdsDataTableForFiles;
            }(_abstract_data_table__WEBPACK_IMPORTED_MODULE_1__["default"]), _class2.styles = _mds_data_table_for_files_scss__WEBPACK_IMPORTED_MODULE_3___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsDataTableForFiles;
        },
        "./src/data-table-for-files/mds-data-table-for-files.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/data-table-for-files/mds-data-table-for-files.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/data-table-for-securities/DataTableForSecurities.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "_dataTableForSecuritiesTemplate", (function() {
                return _dataTableForSecuritiesTemplate;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            var _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/abstract-data-table/AbstractMdsDataTable.jsx");
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _generateCell(cellData, colIndex, rowIndex, columnData, isFooter, isLastRowInGroup) {
                if (isFooter) {
                    return this._columnObjects[colIndex].renderFooter({
                        value: cellData.value,
                        firstValue: this.footer[0].value
                    }, rowIndex);
                }
                var isRepeatRow = this.columnConfigs[0].columnType === "repeatRow";
                var isFirstRowHeader = false;
                if (colIndex === 0 && cellData.value !== this._lastRowHeader) {
                    this._lastRowHeader = cellData.value;
                    isFirstRowHeader = true;
                }
                var hasRowHeaderValues = this.columnConfigs[0].columnType === "checkbox" && this._hasRowHeaderValues();
                var config = {
                    additionalClasses: {
                        "data-table-for-securities__row-value--dashed": isRepeatRow && !isLastRowInGroup && colIndex > 0
                    },
                    isFirstRowHeader: isFirstRowHeader,
                    isRepeatRow: isRepeatRow,
                    mode: this.mode,
                    hasRowHeaderValues: hasRowHeaderValues
                };
                return this._columnObjects[colIndex].renderCell(cellData, rowIndex, config);
            }
            function _generateRow(rowIndex, row) {
                var _rowClasses, _this = this;
                var isFooter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var rows = arguments.length > 3 ? arguments[3] : undefined;
                var idRow = "row-".concat(rowIndex + 1);
                var isRepeat = this.columnConfigs[0].columnType === "repeatRow";
                var isLastRowInGroup;
                var isLast;
                var tempRows = this._sortedMap || rows;
                if (!isFooter) {
                    var currentRowValue = tempRows[rowIndex][0].value;
                    var nextRowValue = tempRows[rowIndex + 1] ? tempRows[rowIndex + 1][0].value : undefined;
                    isLastRowInGroup = tempRows && !isFooter && (tempRows.length - 1 === rowIndex ? true : currentRowValue !== nextRowValue);
                    isLast = tempRows && this.footer && tempRows.length - 1 === rowIndex;
                }
                var rowClasses = (_rowClasses = {
                    "data-table-for-securities__row": true
                }, _defineProperty(_rowClasses, "data-table-for-securities__row--".concat(this.mode), true), 
                _defineProperty(_rowClasses, "data-table-for-securities__row--solid", !isLast && (!isRepeat || isRepeat && isLastRowInGroup)), 
                _defineProperty(_rowClasses, "data-table-for-securities__row--footer", isFooter), 
                _defineProperty(_rowClasses, "data-table-for-securities__row--activated", this.activated), 
                _rowClasses);
                var isLastRow = tempRows && tempRows.length - 1 === rowIndex;
                if (!this.footer && isLastRow && this.suppressLastRowBorder) {
                    rowClasses["data-table-for-securities__row--solid"] = false;
                }
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("tr");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRow);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", rowClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-index", rowIndex + 1);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-values", row.map(function(rowVal) {
                    _newArrowCheck(this, _this);
                    return rowVal.value;
                }.bind(this)).toString());
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    onmouseenter: this.highlightRow
                }, this.activated));
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    onmouseleave: this.highlightRowOff
                }, this.activated));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("tr");
                _renderArbitrary(row.map(function(rowVal, colIndex) {
                    _newArrowCheck(this, _this);
                    return _generateCell.call(this, rowVal, colIndex, rowIndex, this.columnConfigs[colIndex], isFooter, isLastRowInGroup);
                }.bind(this)));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tr");
            }
            function _renderFooter(row, index) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("tfoot");
                _renderArbitrary(_generateRow.call(this, index, row, true));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tfoot");
            }
            function _renderAllRows(rows) {
                var _this2 = this;
                if (this.sortMap) {
                    this._lastRowHeader = undefined;
                    this._sortedMap = this.sortMap.map(function(sortIndex) {
                        _newArrowCheck(this, _this2);
                        return rows[sortIndex];
                    }.bind(this));
                    return this.sortMap.map(function(rowIndex, index) {
                        _newArrowCheck(this, _this2);
                        return _generateRow.call(this, index, rows[rowIndex], false, rows);
                    }.bind(this));
                }
                return rows.map(function(row, index, arr) {
                    _newArrowCheck(this, _this2);
                    return _generateRow.call(this, index, row, false, arr);
                }.bind(this));
            }
            function _renderCheckboxHeaderlessRow() {
                if (this._hasColumnHeaderValues() || !this.columnConfigs || this.columnConfigs[0].columnType !== "checkbox") {
                    return "";
                }
                return this._columnObjects[0].renderTopCheckboxNoColumnHeaders({
                    numColumns: this.columnConfigs.length,
                    numRows: this.rowData.length
                });
            }
            function _dataTableForSecuritiesTemplate() {
                var id = this.id, rowDataCleaned = this.rowDataCleaned, columnConfigs = this.columnConfigs, footer = this.footer, hasVisibleCaption = this.hasVisibleCaption;
                var tableClasses = {
                    "data-table-for-securities": true,
                    "data-table-for-securities--checkbox-no-caption": !hasVisibleCaption && this._hasCheckboxAndHeaders()
                };
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div");
                _renderArbitrary(MDS.isIOS && _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_2__["_renderCaption"].call(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("table", null, null, "id", id, "class", tableClasses, "onchange", this._handleChange, "onclick", this._handleClick);
                _renderArbitrary(!MDS.isIOS && _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_2__["_renderCaption"].call(this));
                _renderArbitrary(columnConfigs && _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_2__["_renderColumnHeader"].call(this));
                _renderArbitrary(_renderCheckboxHeaderlessRow.call(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("tbody");
                _renderArbitrary(rowDataCleaned && _renderAllRows.call(this, rowDataCleaned));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tbody");
                _renderArbitrary(footer && _renderFooter.call(this, footer, rowDataCleaned.length));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("table");
                _renderArbitrary(_abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_2__["_renderAriaLive"].call(this));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            __webpack_exports__["default"] = _dataTableForSecuritiesTemplate;
        },
        "./src/data-table-for-securities/columnTypeConstructorMap.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var _abstract_data_table_columns_left_aligned_column__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/abstract-data-table/columns/left-aligned-column/index.jsx");
            var _abstract_data_table_columns_right_aligned_column__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-data-table/columns/right-aligned-column/index.jsx");
            var _abstract_data_table_columns_repeat_row_column__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/abstract-data-table/columns/repeat-row-column/index.jsx");
            var _abstract_data_table_columns_row_header_column__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/abstract-data-table/columns/row-header-column/index.jsx");
            var _abstract_data_table_columns_row_header_link_column__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/abstract-data-table/columns/row-header-link-column/index.jsx");
            var _abstract_data_table_columns_combo_button_column__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/abstract-data-table/columns/combo-button-column/index.jsx");
            var _abstract_data_table_columns_checkbox_column__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/abstract-data-table/columns/checkbox-column/index.jsx");
            var _abstract_data_table_columns_menu_button_column__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/abstract-data-table/columns/menu-button-column/index.jsx");
            var _abstract_data_table_columns_buttons_column__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("./src/abstract-data-table/columns/buttons-column/index.jsx");
            var _abstract_data_table_columns_sparkline_column__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("./src/abstract-data-table/columns/sparkline-column/index.jsx");
            var _abstract_data_table_columns_input_column__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("./src/abstract-data-table/columns/input-column/index.jsx");
            var columnTypeConstructorMap = {
                leftAligned: _abstract_data_table_columns_left_aligned_column__WEBPACK_IMPORTED_MODULE_0__["default"],
                rightAligned: _abstract_data_table_columns_right_aligned_column__WEBPACK_IMPORTED_MODULE_1__["default"],
                repeatRow: _abstract_data_table_columns_repeat_row_column__WEBPACK_IMPORTED_MODULE_2__["default"],
                rowHeader: _abstract_data_table_columns_row_header_column__WEBPACK_IMPORTED_MODULE_3__["default"],
                rowHeaderLink: _abstract_data_table_columns_row_header_link_column__WEBPACK_IMPORTED_MODULE_4__["default"],
                comboButton: _abstract_data_table_columns_combo_button_column__WEBPACK_IMPORTED_MODULE_5__["default"],
                checkbox: _abstract_data_table_columns_checkbox_column__WEBPACK_IMPORTED_MODULE_6__["default"],
                menuButton: _abstract_data_table_columns_menu_button_column__WEBPACK_IMPORTED_MODULE_7__["default"],
                buttons: _abstract_data_table_columns_buttons_column__WEBPACK_IMPORTED_MODULE_8__["default"],
                sparkline: _abstract_data_table_columns_sparkline_column__WEBPACK_IMPORTED_MODULE_9__["default"],
                input: _abstract_data_table_columns_input_column__WEBPACK_IMPORTED_MODULE_10__["default"]
            };
            __webpack_exports__["default"] = columnTypeConstructorMap;
        },
        "./src/data-table-for-securities/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _abstract_data_table__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-data-table/index.js");
            var _DataTableForSecurities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/data-table-for-securities/DataTableForSecurities.jsx");
            var _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/abstract-data-table/AbstractMdsDataTable.jsx");
            var _mds_data_table_for_securities_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/data-table-for-securities/mds-data-table-for-securities.scss");
            var _mds_data_table_for_securities_scss__WEBPACK_IMPORTED_MODULE_4___default = __webpack_require__.n(_mds_data_table_for_securities_scss__WEBPACK_IMPORTED_MODULE_4__);
            var _columnTypeConstructorMap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/data-table-for-securities/columnTypeConstructorMap.js");
            var _dec, _class, _class2;
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["mixins"].AttributeMarshallingMixin, enumerables = _mixins$AttributeMars.enumerables, satisfies = _mixins$AttributeMars.satisfies, arrayOf = _mixins$AttributeMars.arrayOf, stringRequired = _mixins$AttributeMars.stringRequired, boolean = _mixins$AttributeMars.boolean;
            var columnConfigEntity = _objectSpread({
                columnType: enumerables(stringRequired, "leftAligned", "rightAligned", "repeatRow", "rowHeader", "rowHeaderLink", "comboButton", "menuButton", "repeatRow", "checkbox", "buttons", "sparkline", "input")
            }, _abstract_data_table__WEBPACK_IMPORTED_MODULE_1__["abstractColumnConfigEntity"]);
            var entity = _objectSpread({}, _abstract_data_table__WEBPACK_IMPORTED_MODULE_1__["entity"], {
                columnConfigs: arrayOf(satisfies(columnConfigEntity)).withChangedCallback(),
                suppressLastRowBorder: boolean.defaultsTo(false)
            });
            var MdsDataTableForSecurities = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AbstractDataTable) {
                _inherits(MdsDataTableForSecurities, _AbstractDataTable);
                _createClass(MdsDataTableForSecurities, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsDataTableForSecurities";
                    }
                } ]);
                function MdsDataTableForSecurities() {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsDataTableForSecurities);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsDataTableForSecurities).call(this));
                    _this.rootClass = "data-table-for-securities";
                    _this._checkErrors = function() {
                        _newArrowCheck(this, _this2);
                        if (!(_this._hasColumnHeaderValues() && (_this._hasRepeatRowHeaderValues() || _this._hasRowHeaderValues()))) {
                            _this.throwConstraintError("MDS Data Table For Securities should have Row Headers(including row header link and repeat row types) and Column Headers");
                        }
                    }.bind(this);
                    _this._columnTypeConstructorMap = _columnTypeConstructorMap__WEBPACK_IMPORTED_MODULE_5__["default"];
                    _this._handleChange = _this._handleChange.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsDataTableForSecurities, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsDataTableForSecurities.prototype), "connectedCallback", this).call(this);
                        this._checkErrors();
                    }
                }, {
                    key: "rowDataChangedCallback",
                    value: function rowDataChangedCallback() {
                        this._hasRowDataValues() && this._prepareData();
                        this.sortMap && this.sortTable(this._sortedColumn, this._sortedDirection);
                    }
                }, {
                    key: "_handleChange",
                    value: function _handleChange(event) {
                        event.stopPropagation();
                        var columnObject = this._columnObjects[+event.target.dataset.column - 1];
                        columnObject && columnObject.handleChange && columnObject.handleChange.call(this, event);
                    }
                }, {
                    key: "getNumberOfSelectedCheckboxes",
                    value: function getNumberOfSelectedCheckboxes() {
                        var _this3 = this;
                        if (this.columnConfigs && this.columnConfigs[0].columnType === "checkbox") {
                            return this.rowData && this.rowData.reduce(function(numSelected, rowData) {
                                _newArrowCheck(this, _this3);
                                return rowData[0].state === "true" || rowData[0].state === true ? numSelected + 1 : numSelected;
                            }.bind(this), 0) || 0;
                        }
                        return 0;
                    }
                }, {
                    key: "render",
                    value: function render() {
                        if (this._hasRowDataValues()) {
                            if (this.stacked) {
                                _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_3__["_renderAllStackedTables"].call(this);
                            } else {
                                _DataTableForSecurities__WEBPACK_IMPORTED_MODULE_2__["default"].call(this);
                            }
                        } else {
                            return this.renderEmptyTables();
                        }
                    }
                } ]);
                return MdsDataTableForSecurities;
            }(_abstract_data_table__WEBPACK_IMPORTED_MODULE_1__["default"]), _class2.styles = _mds_data_table_for_securities_scss__WEBPACK_IMPORTED_MODULE_4___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsDataTableForSecurities;
        },
        "./src/data-table-for-securities/mds-data-table-for-securities.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/data-table-for-securities/mds-data-table-for-securities.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/data-table-for-transactions/DataTableForTransactions.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "_dataTableForTransactionsTemplate", (function() {
                return _dataTableForTransactionsTemplate;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            var _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/abstract-data-table/AbstractMdsDataTable.jsx");
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _generateCell(cellData, colIndex, rowIndex, columnData, isFooter, isLastRowInGroup) {
                if (isFooter) {
                    return this._columnObjects[colIndex].renderFooter({
                        value: cellData.value,
                        firstValue: this.footer[0].value
                    }, rowIndex);
                }
                var isRepeatRow = this.columnConfigs[0].columnType === "repeatRow";
                var isFirstRowHeader = false;
                if (colIndex === 0 && cellData.value !== this._lastRowHeader) {
                    this._lastRowHeader = cellData.value;
                    isFirstRowHeader = true;
                }
                var hasRowHeaderValues = this.columnConfigs[0].columnType === "checkbox" && this._hasRowHeaderValues();
                var config = {
                    additionalClasses: {
                        "data-table-for-transactions__row-value--dashed": isRepeatRow && !isLastRowInGroup && colIndex > 0
                    },
                    isFirstRowHeader: isFirstRowHeader,
                    isRepeatRow: isRepeatRow,
                    mode: this.mode,
                    hasRowHeaderValues: hasRowHeaderValues
                };
                return this._columnObjects[colIndex].renderCell(cellData, rowIndex, config);
            }
            function _generateRow(rowIndex, row) {
                var _rowClasses, _this = this;
                var isFooter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var rows = arguments.length > 3 ? arguments[3] : undefined;
                var idRow = "row-".concat(rowIndex + 1);
                var isRepeat = this.columnConfigs[0].columnType === "repeatRow";
                var isLastRowInGroup;
                var isLast;
                var tempRows = this._sortedMap || rows;
                if (!isFooter) {
                    var currentRowValue = tempRows[rowIndex][0].value;
                    var nextRowValue = tempRows[rowIndex + 1] ? tempRows[rowIndex + 1][0].value : undefined;
                    isLastRowInGroup = tempRows && !isFooter && (tempRows.length - 1 === rowIndex ? true : currentRowValue !== nextRowValue);
                    isLast = tempRows && this.footer && tempRows.length - 1 === rowIndex;
                }
                var rowClasses = (_rowClasses = {
                    "data-table-for-transactions__row": true
                }, _defineProperty(_rowClasses, "data-table-for-transactions__row--".concat(this.mode), true), 
                _defineProperty(_rowClasses, "data-table-for-transactions__row--solid", !isLast && (!isRepeat || isRepeat && isLastRowInGroup)), 
                _defineProperty(_rowClasses, "data-table-for-transactions__row--footer", isFooter), 
                _defineProperty(_rowClasses, "data-table-for-transactions__row--activated", this.activated), 
                _rowClasses);
                var isLastRow = tempRows && tempRows.length - 1 === rowIndex;
                if (!this.footer && isLastRow && this.suppressLastRowBorder) {
                    rowClasses["data-table-for-transactions__row--solid"] = false;
                }
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("tr");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRow);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", rowClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-index", rowIndex + 1);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-values", row.map(function(rowVal) {
                    _newArrowCheck(this, _this);
                    return rowVal.value;
                }.bind(this)).toString());
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    onmouseenter: this.highlightRow
                }, this.activated));
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    onmouseleave: this.highlightRowOff
                }, this.activated));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("tr");
                _renderArbitrary(row.map(function(rowVal, colIndex) {
                    _newArrowCheck(this, _this);
                    return _generateCell.call(this, rowVal, colIndex, rowIndex, this.columnConfigs[colIndex], isFooter, isLastRowInGroup);
                }.bind(this)));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tr");
            }
            function _renderFooter(row, index) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("tfoot");
                _renderArbitrary(_generateRow.call(this, index, row, true));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tfoot");
            }
            function _renderAllRows(rows) {
                var _this2 = this;
                if (this.sortMap) {
                    this._lastRowHeader = undefined;
                    this._sortedMap = this.sortMap.map(function(sortIndex) {
                        _newArrowCheck(this, _this2);
                        return rows[sortIndex];
                    }.bind(this));
                    return this.sortMap.map(function(rowIndex, index) {
                        _newArrowCheck(this, _this2);
                        return _generateRow.call(this, index, rows[rowIndex], false, rows);
                    }.bind(this));
                }
                return rows.map(function(row, index, arr) {
                    _newArrowCheck(this, _this2);
                    return _generateRow.call(this, index, row, false, arr);
                }.bind(this));
            }
            function _renderCheckboxHeaderlessRow() {
                if (this._hasColumnHeaderValues() || !this.columnConfigs || this.columnConfigs[0].columnType !== "checkbox") {
                    return "";
                }
                return this._columnObjects[0].renderTopCheckboxNoColumnHeaders({
                    numColumns: this.columnConfigs.length,
                    numRows: this.rowData.length
                });
            }
            function _dataTableForTransactionsTemplate() {
                var id = this.id, rowDataCleaned = this.rowDataCleaned, columnConfigs = this.columnConfigs, footer = this.footer, hasVisibleCaption = this.hasVisibleCaption;
                var tableClasses = {
                    "data-table-for-transactions": true,
                    "data-table-for-transactions--checkbox-no-caption": !hasVisibleCaption && this._hasCheckboxAndHeaders()
                };
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div");
                _renderArbitrary(MDS.isIOS && _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_2__["_renderCaption"].call(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("table", null, null, "id", id, "class", tableClasses, "onchange", this._handleChange, "onclick", this._handleClick);
                _renderArbitrary(!MDS.isIOS && _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_2__["_renderCaption"].call(this));
                _renderArbitrary(columnConfigs && _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_2__["_renderColumnHeader"].call(this));
                _renderArbitrary(_renderCheckboxHeaderlessRow.call(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("tbody");
                _renderArbitrary(rowDataCleaned && _renderAllRows.call(this, rowDataCleaned));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tbody");
                _renderArbitrary(footer && _renderFooter.call(this, footer, rowDataCleaned.length));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("table");
                _renderArbitrary(_abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_2__["_renderAriaLive"].call(this));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            __webpack_exports__["default"] = _dataTableForTransactionsTemplate;
        },
        "./src/data-table-for-transactions/columnTypeConstructorMap.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var _abstract_data_table_columns_left_aligned_column__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/abstract-data-table/columns/left-aligned-column/index.jsx");
            var _abstract_data_table_columns_right_aligned_column__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-data-table/columns/right-aligned-column/index.jsx");
            var _abstract_data_table_columns_row_header_column__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/abstract-data-table/columns/row-header-column/index.jsx");
            var _abstract_data_table_columns_navigation_column__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/abstract-data-table/columns/navigation-column/index.jsx");
            var _abstract_data_table_columns_row_header_link_column__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/abstract-data-table/columns/row-header-link-column/index.jsx");
            var _abstract_data_table_columns_repeat_row_column__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/abstract-data-table/columns/repeat-row-column/index.jsx");
            var _abstract_data_table_columns_combo_button_column__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/abstract-data-table/columns/combo-button-column/index.jsx");
            var _abstract_data_table_columns_checkbox_column__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/abstract-data-table/columns/checkbox-column/index.jsx");
            var _abstract_data_table_columns_buttons_column__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("./src/abstract-data-table/columns/buttons-column/index.jsx");
            var _abstract_data_table_columns_select_column__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("./src/abstract-data-table/columns/select-column/index.jsx");
            var columnTypeConstructorMap = {
                leftAligned: _abstract_data_table_columns_left_aligned_column__WEBPACK_IMPORTED_MODULE_0__["default"],
                rightAligned: _abstract_data_table_columns_right_aligned_column__WEBPACK_IMPORTED_MODULE_1__["default"],
                rowHeader: _abstract_data_table_columns_row_header_column__WEBPACK_IMPORTED_MODULE_2__["default"],
                rowHeaderLink: _abstract_data_table_columns_row_header_link_column__WEBPACK_IMPORTED_MODULE_4__["default"],
                navigation: _abstract_data_table_columns_navigation_column__WEBPACK_IMPORTED_MODULE_3__["default"],
                comboButton: _abstract_data_table_columns_combo_button_column__WEBPACK_IMPORTED_MODULE_6__["default"],
                repeatRow: _abstract_data_table_columns_repeat_row_column__WEBPACK_IMPORTED_MODULE_5__["default"],
                checkbox: _abstract_data_table_columns_checkbox_column__WEBPACK_IMPORTED_MODULE_7__["default"],
                buttons: _abstract_data_table_columns_buttons_column__WEBPACK_IMPORTED_MODULE_8__["default"],
                select: _abstract_data_table_columns_select_column__WEBPACK_IMPORTED_MODULE_9__["default"]
            };
            __webpack_exports__["default"] = columnTypeConstructorMap;
        },
        "./src/data-table-for-transactions/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _abstract_data_table__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-data-table/index.js");
            var _DataTableForTransactions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/data-table-for-transactions/DataTableForTransactions.jsx");
            var _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/abstract-data-table/AbstractMdsDataTable.jsx");
            var _mds_data_table_for_transactions_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/data-table-for-transactions/mds-data-table-for-transactions.scss");
            var _mds_data_table_for_transactions_scss__WEBPACK_IMPORTED_MODULE_4___default = __webpack_require__.n(_mds_data_table_for_transactions_scss__WEBPACK_IMPORTED_MODULE_4__);
            var _columnTypeConstructorMap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/data-table-for-transactions/columnTypeConstructorMap.js");
            var _dec, _class, _class2;
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["mixins"].AttributeMarshallingMixin, enumerables = _mixins$AttributeMars.enumerables, satisfies = _mixins$AttributeMars.satisfies, arrayOf = _mixins$AttributeMars.arrayOf, stringRequired = _mixins$AttributeMars.stringRequired, boolean = _mixins$AttributeMars.boolean;
            var columnConfigEntity = _objectSpread({
                columnType: enumerables(stringRequired, "leftAligned", "rightAligned", "rowHeader", "rowHeaderLink", "navigation", "comboButton", "repeatRow", "checkbox", "buttons", "select")
            }, _abstract_data_table__WEBPACK_IMPORTED_MODULE_1__["abstractColumnConfigEntity"]);
            var entity = _objectSpread({}, _abstract_data_table__WEBPACK_IMPORTED_MODULE_1__["entity"], {
                columnConfigs: arrayOf(satisfies(columnConfigEntity)).withChangedCallback(),
                suppressLastRowBorder: boolean.defaultsTo(false)
            });
            var MdsDataTableForTransactions = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AbstractDataTable) {
                _inherits(MdsDataTableForTransactions, _AbstractDataTable);
                _createClass(MdsDataTableForTransactions, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsDataTableForTransactions";
                    }
                } ]);
                function MdsDataTableForTransactions() {
                    var _this;
                    _classCallCheck(this, MdsDataTableForTransactions);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsDataTableForTransactions).call(this));
                    _this.rootClass = "data-table-for-transactions";
                    _this._columnTypeConstructorMap = _columnTypeConstructorMap__WEBPACK_IMPORTED_MODULE_5__["default"];
                    _this._handleChange = _this._handleChange.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsDataTableForTransactions, [ {
                    key: "rowDataChangedCallback",
                    value: function rowDataChangedCallback() {
                        this._hasRowDataValues() && this._prepareData();
                        this.sortMap && this.sortTable(this._sortedColumn, this._sortedDirection);
                    }
                }, {
                    key: "columnConfigsChangedCallback",
                    value: function columnConfigsChangedCallback(columnConfigs) {
                        var _this2 = this;
                        _get(_getPrototypeOf(MdsDataTableForTransactions.prototype), "columnConfigsChangedCallback", this).call(this, columnConfigs);
                        columnConfigs.forEach(function(row) {
                            _newArrowCheck(this, _this2);
                            if (row.columnType === "comboButton") {
                                console.warn("Combo Button is deprecated in data table transactions, use data table accounts");
                            }
                        }.bind(this));
                    }
                }, {
                    key: "_handleChange",
                    value: function _handleChange(event) {
                        event.stopPropagation();
                        var columnObject = this._columnObjects[+event.target.dataset.column - 1];
                        columnObject && columnObject.handleChange && columnObject.handleChange.call(this, event);
                    }
                }, {
                    key: "getNumberOfSelectedCheckboxes",
                    value: function getNumberOfSelectedCheckboxes() {
                        var _this3 = this;
                        if (this.columnConfigs && this.columnConfigs[0].columnType === "checkbox") {
                            return this.rowData && this.rowData.reduce(function(numSelected, rowData) {
                                _newArrowCheck(this, _this3);
                                return rowData[0].state === "true" || rowData[0].state === true ? numSelected + 1 : numSelected;
                            }.bind(this), 0) || 0;
                        }
                        return 0;
                    }
                }, {
                    key: "render",
                    value: function render() {
                        this.alertMessageColumn = undefined;
                        if (this._hasRowDataValues()) {
                            if (this.stacked) {
                                _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_3__["_renderAllStackedTables"].call(this);
                            } else {
                                _DataTableForTransactions__WEBPACK_IMPORTED_MODULE_2__["default"].call(this);
                            }
                        } else {
                            return this.renderEmptyTables();
                        }
                    }
                } ]);
                return MdsDataTableForTransactions;
            }(_abstract_data_table__WEBPACK_IMPORTED_MODULE_1__["default"]), _class2.styles = _mds_data_table_for_transactions_scss__WEBPACK_IMPORTED_MODULE_4___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsDataTableForTransactions;
        },
        "./src/data-table-for-transactions/mds-data-table-for-transactions.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/data-table-for-transactions/mds-data-table-for-transactions.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/data-table-simple/DataTableSimple.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "_DataTableSimpleTemplate", (function() {
                return _DataTableSimpleTemplate;
            }));
            __webpack_require__.d(__webpack_exports__, "_DataTableSimpleStackedTemplate", (function() {
                return _DataTableSimpleStackedTemplate;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_table_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/table-utils.jsx");
            var _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/abstract-data-table/AbstractMdsDataTable.jsx");
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _generateCell(cellData, colIndex, rowIndex, isFooter) {
                if (this.columnConfigs) {
                    if (isFooter) {
                        return this._columnObjects[colIndex].renderFooter({
                            value: cellData.value,
                            firstValue: this.footer[0].value
                        }, rowIndex);
                    }
                    return this._columnObjects[colIndex].renderCell(cellData, rowIndex);
                }
            }
            function _generateRow(rowIndex, row) {
                var _rowClasses, _this = this;
                var isFooter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var rows = arguments.length > 3 ? arguments[3] : undefined;
                var separators = this.stacked ? undefined : this.separators;
                var isLast = rows && this.footer && rows.length - 1 === rowIndex;
                var rowStyle = this.stacked || isLast ? "" : this.rowStyle;
                var isSolid = separators && separators.solidRows && separators.solidRows.includes(rowIndex);
                var isDashed = separators && separators.dashedRows && separators.dashedRows.includes(rowIndex);
                var separatorType = isSolid ? "solid" : isDashed ? "dashed" : false;
                var idRow = "row-".concat(rowIndex + 1);
                var rowClasses = (_rowClasses = {
                    "data-table-simple__row": true
                }, _defineProperty(_rowClasses, "data-table-simple__row--".concat(this.mode), true), 
                _defineProperty(_rowClasses, "data-table-simple__row--".concat(rowStyle || separatorType), rowStyle || separatorType), 
                _defineProperty(_rowClasses, "data-table-simple__row--footer", isFooter), _defineProperty(_rowClasses, "data-table-simple__row--activated", this.activated), 
                _rowClasses);
                var isLastRow = rows && rows.length - 1 === rowIndex;
                if (!this.footer && isLastRow && this.suppressLastRowBorder) {
                    rowClasses["data-table-simple__row--solid"] = false;
                    rowClasses["data-table-simple__row--dashed"] = false;
                }
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("tr");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", idRow);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", rowClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-index", rowIndex + 1);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-values", row.map(function(rowVal) {
                    _newArrowCheck(this, _this);
                    return Object.prototype.hasOwnProperty.call(rowVal, "value") ? rowVal.value : rowVal.headerValue;
                }.bind(this)).toString());
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    onmouseenter: this.highlightRow
                }, this.activated));
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    onmouseleave: this.highlightRowOff
                }, this.activated));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("tr");
                _renderArbitrary(row.map(function(rowVal, colIndex) {
                    _newArrowCheck(this, _this);
                    return _generateCell.call(this, rowVal, colIndex, rowIndex, isFooter);
                }.bind(this)));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tr");
            }
            function _renderFooter(row, index) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("tfoot");
                _renderArbitrary(_generateRow.call(this, index, row, true));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tfoot");
            }
            function _renderAllRows(rows) {
                var _this2 = this;
                if (this.sortMap) {
                    return this.sortMap.map(function(rowIndex, index) {
                        _newArrowCheck(this, _this2);
                        return _generateRow.call(this, index, rows[rowIndex], false, rows);
                    }.bind(this));
                }
                return rows.map(function(row, index, arr) {
                    _newArrowCheck(this, _this2);
                    return _generateRow.call(this, index, row, false, arr);
                }.bind(this));
            }
            function _DataTableSimpleTemplate() {
                var id = this.id, rowDataCleaned = this.rowDataCleaned, columnConfigs = this.columnConfigs, footer = this.footer;
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div");
                _renderArbitrary(MDS.isIOS && _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_3__["_renderCaption"].call(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("table", null, null, "id", id, "class", "data-table-simple");
                _renderArbitrary(!MDS.isIOS && _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_3__["_renderCaption"].call(this));
                _renderArbitrary(columnConfigs && _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_3__["_renderColumnHeader"].call(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("tbody");
                _renderArbitrary(rowDataCleaned && _renderAllRows.call(this, rowDataCleaned));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tbody");
                _renderArbitrary(footer && _renderFooter.call(this, footer, rowDataCleaned.length));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("table");
                _renderArbitrary(_abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_3__["_renderAriaLive"].call(this));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function _renderSingleStackedTable(caption, columnIndex, singleTableData, rowHeaders) {
                var hasRowHeaders = this._hasRowHeaderValues();
                var stackedCaption = "".concat(caption, ":\n").concat(rowHeaders[columnIndex].value);
                var idTable = "".concat(this.id, "-subtable-").concat(columnIndex);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("table", null, null, "id", idTable, "class", "data-table-simple");
                _renderArbitrary(hasRowHeaders && this._hasColumnHeaderValues() && _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_3__["_renderStackedCaption"].call(this, stackedCaption));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("tbody");
                _renderArbitrary(singleTableData && _renderAllRows.call(this, singleTableData));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tbody");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("table");
            }
            function _DataTableSimpleStackedTemplate() {
                return _abstract_data_table_AbstractMdsDataTable__WEBPACK_IMPORTED_MODULE_3__["_renderAllStackedTables"].call(this);
            }
            __webpack_exports__["default"] = _DataTableSimpleTemplate;
        },
        "./src/data-table-simple/columnTypeConstructorMap.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var _abstract_data_table_columns_left_aligned_column__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/abstract-data-table/columns/left-aligned-column/index.jsx");
            var _abstract_data_table_columns_right_aligned_column__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-data-table/columns/right-aligned-column/index.jsx");
            var _abstract_data_table_columns_row_header_column__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/abstract-data-table/columns/row-header-column/index.jsx");
            var _abstract_data_table_columns_alert_message_column__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/abstract-data-table/columns/alert-message-column/index.js");
            var columnTypeConstructorMap = {
                leftAligned: _abstract_data_table_columns_left_aligned_column__WEBPACK_IMPORTED_MODULE_0__["default"],
                rightAligned: _abstract_data_table_columns_right_aligned_column__WEBPACK_IMPORTED_MODULE_1__["default"],
                rowHeader: _abstract_data_table_columns_row_header_column__WEBPACK_IMPORTED_MODULE_2__["default"],
                alertMessage: _abstract_data_table_columns_alert_message_column__WEBPACK_IMPORTED_MODULE_3__["default"]
            };
            __webpack_exports__["default"] = columnTypeConstructorMap;
        },
        "./src/data-table-simple/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _abstract_data_table__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-data-table/index.js");
            var _DataTableSimple__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/data-table-simple/DataTableSimple.jsx");
            var _mds_data_table_simple_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/data-table-simple/mds-data-table-simple.scss");
            var _mds_data_table_simple_scss__WEBPACK_IMPORTED_MODULE_3___default = __webpack_require__.n(_mds_data_table_simple_scss__WEBPACK_IMPORTED_MODULE_3__);
            var _columnTypeConstructorMap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/data-table-simple/columnTypeConstructorMap.js");
            var _dec, _class, _class2;
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["mixins"].AttributeMarshallingMixin, enumerables = _mixins$AttributeMars.enumerables, satisfies = _mixins$AttributeMars.satisfies, arrayOf = _mixins$AttributeMars.arrayOf, string = _mixins$AttributeMars.string, stringRequired = _mixins$AttributeMars.stringRequired, boolean = _mixins$AttributeMars.boolean, object = _mixins$AttributeMars.object;
            var columnConfigEntity = _objectSpread({
                columnType: enumerables(stringRequired, "leftAligned", "rightAligned", "rowHeader", "alertMessage")
            }, _abstract_data_table__WEBPACK_IMPORTED_MODULE_1__["abstractColumnConfigEntity"]);
            var entity = _objectSpread({}, _abstract_data_table__WEBPACK_IMPORTED_MODULE_1__["entity"], {
                columnConfigs: arrayOf(satisfies(columnConfigEntity)).withChangedCallback(),
                rowStyle: enumerables(string, "solid", "dashed"),
                layout: enumerables(string, "column", "columnRow", "row").defaultsTo("columnRow"),
                suppressLastRowBorder: boolean.defaultsTo(false)
            });
            var MdsDataTableSimple = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AbstractDataTable) {
                _inherits(MdsDataTableSimple, _AbstractDataTable);
                _createClass(MdsDataTableSimple, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsDataTableSimple";
                    }
                } ]);
                function MdsDataTableSimple() {
                    var _this;
                    _classCallCheck(this, MdsDataTableSimple);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsDataTableSimple).call(this));
                    _this.rootClass = "data-table-simple";
                    _this._columnTypeConstructorMap = _columnTypeConstructorMap__WEBPACK_IMPORTED_MODULE_4__["default"];
                    return _this;
                }
                _createClass(MdsDataTableSimple, [ {
                    key: "rowDataChangedCallback",
                    value: function rowDataChangedCallback() {
                        this._hasRowDataValues() && this._prepareData();
                        this.sortMap && this.sortTable(this._sortedColumn, this._sortedDirection);
                    }
                }, {
                    key: "render",
                    value: function render() {
                        if (this._hasRowDataValues()) {
                            if (this.stacked) {
                                _DataTableSimple__WEBPACK_IMPORTED_MODULE_2__["_DataTableSimpleStackedTemplate"].call(this);
                            } else {
                                _DataTableSimple__WEBPACK_IMPORTED_MODULE_2__["default"].call(this);
                            }
                        } else {
                            this.renderEmptyTables();
                        }
                    }
                } ]);
                return MdsDataTableSimple;
            }(_abstract_data_table__WEBPACK_IMPORTED_MODULE_1__["default"]), _class2.styles = _mds_data_table_simple_scss__WEBPACK_IMPORTED_MODULE_3___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsDataTableSimple;
        },
        "./src/data-table-simple/mds-data-table-simple.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/data-table-simple/mds-data-table-simple.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/date-badge/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_date_badge_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/date-badge/mds-date-badge.scss");
            var _mds_date_badge_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_date_badge_scss__WEBPACK_IMPORTED_MODULE_2__);
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string, number = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].number, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].enumerables;
            var entity = {
                level: enumerables(string, "error", "soft", "success", "informational").defaultsTo("informational"),
                month: number.defaultsTo(1).withMinSize(1).withMaxSize(12),
                day: number.defaultsTo(1).withMinSize(1).withMaxSize(31),
                layout: enumerables(string, "horizontal", "vertical").defaultsTo("vertical"),
                statusLabel: string,
                monthFormat: enumerables(string, "short", "full").defaultsTo("short"),
                accessibleIconText: string
            };
            var MdsDateBadge = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsDateBadge, _AgaveComponent);
                function MdsDateBadge() {
                    _classCallCheck(this, MdsDateBadge);
                    return _possibleConstructorReturn(this, _getPrototypeOf(MdsDateBadge).apply(this, arguments));
                }
                _createClass(MdsDateBadge, [ {
                    key: "_getAccessibleIconText",
                    value: function _getAccessibleIconText() {
                        if (this.accessibleIconText) {
                            return this.accessibleIconText;
                        } else if (this.level !== "informational") {
                            return MdsDateBadge.icon[this.level].defaultAccessibleText;
                        }
                        return "";
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var date = new Date(2008, this.month - 1, this.day);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "date-badge date-badge--".concat(this.layout, " date-badge--").concat(this.level), "role", "img", "aria-label", [ date.toLocaleString(this.localeCode, {
                            month: "long",
                            day: "numeric"
                        }), this._getAccessibleIconText(), this.statusLabel ].filter(Boolean).join(", "));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "date-badge__frame");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "date-badge__month", "aria-hidden", "true");
                        _renderArbitrary(date.toLocaleString(this.localeCode, {
                            month: this.monthFormat === "short" ? "short" : "long"
                        }).toUpperCase());
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "date-badge__day", "aria-hidden", "true");
                        _renderArbitrary(this.day);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        _renderArbitrary(this.level !== "informational" && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "date-badge__icon", "innerHTML-prop", MDS.svgs[MdsDateBadge.icon[this.level].iconName], "aria-hidden", "true", "__skip", "true"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        _renderArbitrary(this.statusLabel && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "date-badge__status", "aria-hidden", "true"), 
                        _renderArbitrary(this.statusLabel), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ], [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsDateBadge";
                    }
                } ]);
                return MdsDateBadge;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_date_badge_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2.icon = {
                error: {
                    defaultAccessibleText: "Alert",
                    iconName: "ico_alert_filled"
                },
                soft: {
                    defaultAccessibleText: "Note",
                    iconName: "ico_alert_circle"
                },
                success: {
                    defaultAccessibleText: "Done",
                    iconName: "ico_checkmark_filled"
                }
            }, _class2)) || _class);
            __webpack_exports__["default"] = MdsDateBadge;
        },
        "./src/date-badge/mds-date-badge.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/date-badge/mds-date-badge.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/datepicker/MdsDatepicker.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_date_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/date-utils.js");
            var _Monthpicker__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/datepicker/Monthpicker.jsx");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _th$wrapper = function _th$wrapper(_day$) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("th", null, null, "class", "datepicker__calendar-table-heading-day");
                _renderArbitrary(_day$);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("th");
            }, _tr$wrapper = function _tr$wrapper(_deferred, _args) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("tr", null, null, "class", "datepicker__calendar-table-row");
                _renderArbitrary(_deferred.map(_args));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tr");
            };
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function renderHeaderButton(direction, unit) {
                var icon;
                var accessibleText;
                var disabled = false;
                if (unit === "month") {
                    icon = direction === "right" ? "ico_chevron_right" : "ico_chevron_left";
                    accessibleText = direction === "left" ? this.accessibleTextPreviousMonth : this.accessibleTextNextMonth;
                    disabled = direction === "left" ? this._minimumDate && this._lastDayOfPrevMonth < this._minimumDate : this._maximumDate && this._firstDayofNextMonth > this._maximumDate;
                } else {
                    icon = direction === "right" ? "ico_double_arrow_right" : "ico_double_arrow_left";
                    accessibleText = direction === "left" ? this.accessibleTextPreviousYear : this.accessibleTextNextYear;
                    disabled = direction === "left" ? this._minimumDate && this._minimumDate > new Date(this._year - 1, Object(_utils_date_utils__WEBPACK_IMPORTED_MODULE_2__["getNextMonthIndex"])(this._monthIndex), 0) : this._maximumDate && this._maximumDate < new Date(this._year + 1, this._monthIndex);
                }
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-button", null, null, "id", "".concat(this.id, "-").concat(unit, "-button-").concat(direction), "class", "datepicker__calendar-heading-button", "icon-position", "icon_only", "icon-type", icon, "inactive", disabled, "variant", "tertiary", "onclick", this._handleHeaderButtonClick, "accessible-text", accessibleText, "data-direction", direction);
            }
            function renderHeaderButtons(direction) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "datepicker__calendar-heading-button-container");
                _renderArbitrary(this._isMonthpicker ? [ _Monthpicker__WEBPACK_IMPORTED_MODULE_3__["renderMonthpickerHeaderButton"].call(this, direction, direction === "left" ? 10 : 1), _Monthpicker__WEBPACK_IMPORTED_MODULE_3__["renderMonthpickerHeaderButton"].call(this, direction, direction === "left" ? 1 : 10) ] : [ renderHeaderButton.call(this, direction, direction === "left" ? "year" : "month"), renderHeaderButton.call(this, direction, direction === "left" ? "month" : "year") ]);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function renderCalendarHeader() {
                var classes = {
                    "datepicker__calendar-heading": true,
                    "datepicker__calendar-heading--monthpicker": this._isMonthpicker
                };
                var calendarTable = this._calendarTable();
                var datepickerCalendarHeadingText = this._date.toLocaleDateString(this.localeCode || undefined, {
                    year: "numeric",
                    month: "long"
                });
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes);
                _renderArbitrary(renderHeaderButtons.call(this, "left"));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("h2", null, null, "id", "".concat(this.id, "-calender-heading"), "class", "datepicker__calendar-heading-title", "aria-live", calendarTable && calendarTable.activeElement ? "off" : "polite", "aria-atomic", "true");
                _renderArbitrary(!this._isMonthpicker ? datepickerCalendarHeadingText : this._year);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("h2");
                _renderArbitrary(renderHeaderButtons.call(this, "right"));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function renderCalendarTable() {
                var _this = this;
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("table", null, null, "class", "datepicker__calendar-table", "role", "presentation");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("thead", null, null, "class", "datepicker__calendar-table-heading");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("tr", null, null, "aria-hidden", "true");
                _renderArbitrary(this.dayNames.map(function(day) {
                    _newArrowCheck(this, _this);
                    return _jsxWrapper(_th$wrapper, [ day[0] ]);
                }.bind(this)));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tr");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("tr");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("th", null, null, "class", "datepicker__calendar-table-heading-separator", "colspan", "7");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("th");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tr");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("thead");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("tbody");
                _renderArbitrary(this._dates.map(function(row) {
                    var _this2 = this;
                    _newArrowCheck(this, _this);
                    return _jsxWrapper(_tr$wrapper, [ row, function(date) {
                        _newArrowCheck(this, _this2);
                        return generateTableCell.call(this, date);
                    }.bind(this) ]);
                }.bind(this)));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("tbody");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("table");
            }
            function generateTableCell(dateObj) {
                var date = dateObj.date, disabled = dateObj.disabled, isDueDate = dateObj.isDueDate, isToday = dateObj.isToday, message = dateObj.message, shortDate = dateObj.shortDate, day = dateObj.day;
                var accessibleTextDueDate = this.accessibleTextDueDate, accessibleTextSelectedDate = this.accessibleTextSelectedDate, accessibleTextTodayDate = this.accessibleTextTodayDate, accessibleTextUnavailableDate = this.accessibleTextUnavailableDate;
                var text;
                var accessibleText = "";
                if (date) {
                    if (isToday) {
                        text = this.todayButtonLabel;
                        accessibleText += "".concat(accessibleTextTodayDate, " ");
                    }
                    if (isDueDate) {
                        text = this.dueLabel;
                        accessibleText += "".concat(accessibleTextDueDate, " ");
                    }
                    accessibleText += "".concat(date.toLocaleDateString(this.localeCode || undefined, {
                        weekday: "long",
                        year: "numeric",
                        month: "long",
                        day: "numeric"
                    }), " ");
                    if (shortDate === this._appliedSelectedDate) {
                        accessibleText += "".concat(accessibleTextSelectedDate, " ");
                    } else if (disabled) {
                        accessibleText += "".concat(accessibleTextUnavailableDate, " ");
                    }
                    if (message) {
                        accessibleText += message;
                    }
                }
                var tableCellCircleClasses = {
                    "datepicker__calendar-table-cell-circle": true,
                    "datepicker__calendar-table-cell-circle--today": dateObj.isToday,
                    "datepicker__calendar-table-cell-circle--due": dateObj.isDueDate,
                    "datepicker__calendar-table-cell-circle--selected": this._appliedSelectedDate === shortDate,
                    "datepicker__calendar-table-cell-circle--disabled": disabled,
                    "datepicker__calendar-table-cell-circle--enabled": !disabled,
                    "datepicker__calendar-table-cell-circle--due--today": dateObj.isToday && dateObj.isDueDate && disabled
                };
                var tooltipClasses = {
                    "datepicker__calendar-table-cell-tooltip": true,
                    "datepicker__calendar-table-cell-tooltip--text-below": text
                };
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("td");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "datepicker__calendar-table-cell datepicker__calendar-table-cell--".concat(disabled ? "disabled" : "enabled"));
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    "data-date": shortDate
                }, date));
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    onmouseenter: this._toggleDateTooltip,
                    onmouseleave: this._toggleDateTooltip
                }, message));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("td");
                _renderArbitrary(date && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("button"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", tableCellCircleClasses), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("tabindex", "-1"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("type", "button"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-date", shortDate), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-day", day), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-label", accessibleText), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-disabled", disabled), 
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    onfocus: this._toggleDateTooltip,
                    onblur: this._toggleDateTooltip
                }, message)), _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])("disabled", disabled)), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("button"), 
                _renderArbitrary(date.getDate()), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("button"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("span", null, null, "class", "datepicker__accessible-text", "aria-live", "polite", "aria-atomic", "true"), 
                _renderArbitrary(message && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("abstract-tooltip", null, null, "id", "tooltip-".concat(shortDate), "class", tooltipClasses, "message", message)), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                _renderArbitrary(text && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "datepicker__calendar-table-cell-text", "aria-hidden", "true"), 
                _renderArbitrary(text), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("td");
            }
            function renderCalendar() {
                var calendarClasses = {
                    datepicker__calendar: true,
                    "datepicker__calendar--monthpicker": this._isMonthpicker
                };
                var footerClasses = {
                    "datepicker__calendar-footer": true,
                    "datepicker__calendar-footer--monthpicker": this._isMonthpicker
                };
                var todayOrThisMonthButtonAccessibleText;
                if (this._isMonthpicker) {
                    todayOrThisMonthButtonAccessibleText = this.monthIsAvailable(this._currentMonth) ? this.accessibleTextThisMonthButtonAvailable : this.accessibleTextThisMonthButtonUnavailable;
                } else {
                    todayOrThisMonthButtonAccessibleText = this.dateIsAvailable(this._currentDate) ? this.accessibleTextTodayButtonAvailable : this.accessibleTextTodayButtonUnavailable;
                }
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", calendarClasses, "role", "application", "aria-labelledby", "".concat(this.id, "-calender-heading"), "aria-roledescription", this.accessibleTextRoleDescription, "onkeydown", this._handleCalendarKeydown, "onkeyup", this._handleCalendarKeyup, "onclick", this._handleDateClick, "tabindex", "-1");
                _renderArbitrary(renderCalendarHeader.call(this));
                _renderArbitrary(this._isMonthpicker ? _Monthpicker__WEBPACK_IMPORTED_MODULE_3__["renderMonthGrid"].call(this) : renderCalendarTable.call(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", footerClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-button", null, null, "id", "".concat(this.id, "-").concat(this._isMonthpicker ? "this-month" : "today", "-button"), "onclick", this._isMonthpicker ? this._handleThisMonthButtonClick : this._handleTodayButtonClick, "accessible-text", todayOrThisMonthButtonAccessibleText, "variant", "secondary", "text", this._isMonthpicker ? this.thisMonthButtonLabel : this.todayButtonLabel, "small", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-button", null, null, "id", "".concat(this.id, "-cancel-button"), "onclick", this._closeWithFocusOnInput, "variant", "tertiary", "text", this.cancelButtonLabel, "small", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function MdsDatepickerTemplate() {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "datepicker");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-text-input", null, null, "id", "".concat(this.id, "-input"), "name", "".concat(this.id, "-input"), "variant", this.variant, "placeholder", this.placeholder, "field-suffix", "ico_calendar", "field-suffix-accessible-text", this._visible ? this.accessibleTextIconClose : this.accessibleTextIconOpen, "inactive", this.inactive, "label-style", this.labelStyle, "label", this.label, "label-columns", this.labelColumns, "input-columns", this.inputColumns, "microcopy", this.microcopy, "error-message", this.errorMessage, "error-messages", JSON.stringify(this.errorMessages), "error-message-prefix", this.errorMessagePrefix, "required", this.required, "autocomplete-value", this.autocompleteValue, "onclick", this._handleInputClick, "onkeydown", this._handleInputKeydown, "onkeyup", this._handleInputKeyup, "onchange", this._handleInputChange, "onblur", this._handleInputBlur, "oninput", this._handleInputInput);
                _renderArbitrary(this._visible && renderCalendar.call(this));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            __webpack_exports__["default"] = MdsDatepickerTemplate;
        },
        "./src/datepicker/Monthpicker.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "renderMonthpickerHeaderButton", (function() {
                return renderMonthpickerHeaderButton;
            }));
            __webpack_require__.d(__webpack_exports__, "renderMonthButton", (function() {
                return renderMonthButton;
            }));
            __webpack_require__.d(__webpack_exports__, "renderMonthGrid", (function() {
                return renderMonthGrid;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_date_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/date-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _div$wrapper = function _div$wrapper(_deferred, _args) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "datepicker__month-grid-row");
                _renderArbitrary(_deferred.map(_args));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            };
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function renderMonthpickerHeaderButton(direction, years) {
                var disabled = false;
                if (this._maximumDate && direction === "right") {
                    disabled = this._maximumDate < new Date(this._year + years, 0);
                } else if (this._minimumDate && direction === "left") {
                    disabled = this._minimumDate > new Date(this._year - years, 12, 0);
                }
                var icon;
                var accessibleText;
                if (years === 1) {
                    icon = direction === "right" ? "ico_chevron_right" : "ico_chevron_left";
                    accessibleText = direction === "left" ? this.accessibleTextPreviousYear : this.accessibleTextNextYear;
                } else {
                    icon = direction === "right" ? "ico_double_arrow_right" : "ico_double_arrow_left";
                    accessibleText = direction === "left" ? this.accessibleTextPreviousTenYear : this.accessibleTextNextTenYear;
                }
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-button", null, null, "id", "".concat(this.id, "-").concat(years === 1 ? "one" : "ten", "-year-button-").concat(direction), "class", "datepicker__calendar-heading-button", "icon-position", "icon_only", "icon-type", icon, "inactive", disabled, "variant", "tertiary", "onclick", this._handleHeaderButtonClick, "accessible-text", accessibleText, "data-direction", direction);
            }
            function renderMonthButton(monthIndex, rowIndex, colIndex) {
                var dateInstance = new Date("".concat(monthIndex + 1, "/1/").concat(this._year));
                var monthDisplayName = dateInstance.toLocaleDateString(this.localeCode, {
                    month: "short"
                });
                var monthDate = Object(_utils_date_utils__WEBPACK_IMPORTED_MODULE_2__["toMonthDate"])(dateInstance);
                var isCurrentMonth = this._currentMonth === monthDate;
                var isDueMonth = this.dueDate && this._dueMonthIndex === monthIndex && this._dueYear === this._year;
                var disabled = !this.monthIsAvailable(dateInstance);
                var buttonClasses = {
                    "datepicker__month-button": true,
                    "datepicker__month-button--selected": this.selectedMonth === monthDate,
                    "datepicker__month-button--current": isCurrentMonth,
                    "datepicker__month-button--due": isDueMonth,
                    "datepicker__month-button--enabled": !disabled
                };
                var captionText;
                var accessibleText = "";
                if (isCurrentMonth) {
                    captionText = this.currentMonthLabel;
                    accessibleText += "".concat(this.accessibleTextCurrentMonth, " ");
                }
                if (isDueMonth) {
                    captionText = this.dueLabel;
                    accessibleText += "".concat(this.accessibleTextDueDate, " ");
                }
                accessibleText += "".concat(dateInstance.toLocaleDateString(this.localeCode, {
                    year: "numeric",
                    month: "long"
                }), " ");
                if (this.selectedMonth === monthDate) {
                    accessibleText += "".concat(this.accessibleTextSelectedDate);
                } else if (disabled) {
                    accessibleText += "".concat(this.accessibleTextUnavailableDate);
                }
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "datepicker__month");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", buttonClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onclick", this._handleDateClick);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("type", "button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("tabindex", "-1");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-label", accessibleText);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-disabled", disabled);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])("disabled", disabled));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-month-date", monthDate);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-row-index", rowIndex);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-col-index", colIndex);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-index", monthIndex);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("button");
                _renderArbitrary(monthDisplayName);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("button");
                _renderArbitrary(captionText && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "datepicker__month-caption", "aria-hidden", "true"), 
                _renderArbitrary(captionText), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("span", null, null, "class", "datepicker__accessible-text", "aria-live", "polite", "aria-atomic", "true");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function renderMonthGrid() {
                var _this = this;
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "datepicker__month-grid");
                _renderArbitrary(this._monthGridArray.map(function(row, rowIndex) {
                    var _this2 = this;
                    _newArrowCheck(this, _this);
                    return _jsxWrapper(_div$wrapper, [ row, function(monthIndex, colIndex) {
                        _newArrowCheck(this, _this2);
                        return renderMonthButton.call(this, monthIndex, rowIndex, colIndex);
                    }.bind(this) ]);
                }.bind(this)));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
        },
        "./src/datepicker/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "datepickerEntity", (function() {
                return datepickerEntity;
            }));
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _MdsDatepicker__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/datepicker/MdsDatepicker.jsx");
            var _mds_datepicker_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/datepicker/mds-datepicker.scss");
            var _mds_datepicker_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_datepicker_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _abstract_text_field__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/abstract-text-field/index.js");
            var _utils_date_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/date-utils.js");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_edge_detection__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/utils/edge-detection.js");
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/utils/data-utils.js");
            var _dec, _class, _class2;
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var touchOrMousedown = "ontouchstart" in window ? "touchstart" : "mousedown";
            var date = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].date, arrayOf = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].arrayOf, string = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].string, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].boolean, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].stringRequired, satisfies = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].satisfies, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].enumerables;
            var dateMessageEntity = {
                date: date.toShortDate(),
                message: string
            };
            var datepickerEntity = {
                accessibleTextThisMonthButtonAvailable: string.defaultsTo(". Focus on current month"),
                accessibleTextThisMonthButtonUnavailable: string.defaultsTo(". Current month, unavailable."),
                accessibleTextTodayButtonAvailable: string.defaultsTo("Focus on today's date"),
                accessibleTextTodayButtonUnavailable: string.defaultsTo("Today's date, unavailable."),
                accessibleTextUnavailableDate: string.defaultsTo("Unavailable."),
                accessibleTextDueDate: string.defaultsTo("Due date."),
                accessibleTextTodayDate: string.defaultsTo("Today."),
                accessibleTextCurrentMonth: string.defaultsTo("Current month."),
                accessibleTextIconOpen: stringRequired,
                accessibleTextIconClose: stringRequired,
                accessibleTextNextDay: string.defaultsTo("next day"),
                accessibleTextNextMonth: string.defaultsTo("next month"),
                accessibleTextNextYear: string.defaultsTo("next year"),
                accessibleTextNextTenYear: string.defaultsTo("ten years forward"),
                accessibleTextNoText: string.defaultsTo("No"),
                accessibleTextRoleDescription: string.defaultsTo("Datepicker"),
                accessibleTextPreviousDay: string.defaultsTo("previous day"),
                accessibleTextPreviousMonth: string.defaultsTo("previous month"),
                accessibleTextPreviousYear: string.defaultsTo("previous year"),
                accessibleTextPreviousTenYear: string.defaultsTo("ten years backward"),
                accessibleTextSelectedDate: string.defaultsTo("Selected"),
                autocompleteValue: string.defaultsTo("off"),
                blackoutDates: arrayOf(date).withChangedCallback(),
                calendarType: enumerables(string, "date", "month").defaultsTo("date"),
                cancelButtonLabel: string.defaultsTo("Cancel"),
                currentMonthLabel: string.defaultsTo("Current"),
                dayNames: arrayOf(string),
                dateMessages: arrayOf(satisfies(dateMessageEntity)).withChangedCallback(),
                defaultDate: date.withChangedCallback(),
                dueDate: date.toShortDate().withChangedCallback(),
                dueLabel: string.defaultsTo("due"),
                excludeWeekends: boolean.defaultsTo(false),
                inactive: boolean.defaultsTo(false),
                label: stringRequired,
                localeCode: string.withChangedCallback(),
                minDate: date.toShortDate().withChangedCallback(),
                maxDate: date.toShortDate().withChangedCallback(),
                monthNames: arrayOf(string).withChangedCallback(),
                monthNameAbbreviations: arrayOf(string),
                placeholder: stringRequired.defaultsTo("mm/dd/yyyy"),
                selectedDate: string.withChangedCallback(),
                selectedMonth: string.withChangedCallback(),
                thisMonthButtonLabel: string.defaultsTo("This month"),
                todayButtonLabel: string.defaultsTo("Today"),
                value: string.withChangedCallback(),
                whiteoutDates: arrayOf(date).withChangedCallback(),
                labelStyle: enumerables(string, "horizontal", "vertical", "floating", "hidden").defaultsTo("vertical").withChangedCallback(),
                disableEdgeDetection: boolean.defaultsTo(false)
            };
            var entity = _objectSpread({}, _abstract_text_field__WEBPACK_IMPORTED_MODULE_3__["entity"], {}, datepickerEntity);
            var MdsDatepicker = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AbstractTextField) {
                _inherits(MdsDatepicker, _AbstractTextField);
                _createClass(MdsDatepicker, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsDatepicker";
                    }
                } ]);
                function MdsDatepicker() {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsDatepicker);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsDatepicker).call(this));
                    _this._isSupportedMinCalenderWidth = function(width) {
                        _newArrowCheck(this, _this2);
                        return width <= 320;
                    }.bind(this);
                    _this._handleCalenderHorizontalPositioning = function(calendar, windowWidth) {
                        _newArrowCheck(this, _this2);
                        var _getEdges = Object(_utils_edge_detection__WEBPACK_IMPORTED_MODULE_6__["getEdges"])(calendar), left = _getEdges.left;
                        if (_this._isSupportedMinCalenderWidth(windowWidth)) calendar.style.left = "-".concat(left, "px");
                    }.bind(this);
                    _this.defineObservedProperty("_date", new Date);
                    _this.defineObservedProperty("_appliedSelectedDate", false);
                    _this.defineObservedProperty("_visible", false);
                    _this._monthIndex = _this._date.getMonth();
                    _this._year = _this._date.getFullYear();
                    _this._currentDate = Object(_utils_date_utils__WEBPACK_IMPORTED_MODULE_4__["toShortDate"])(_this._date);
                    _this._currentMonth = Object(_utils_date_utils__WEBPACK_IMPORTED_MODULE_4__["toMonthDate"])(_this._date);
                    _this._closeWithFocusOnInput = _this._closeWithFocusOnInput.bind(_assertThisInitialized(_this));
                    _this._handleCalendarKeydown = _this._handleCalendarKeydown.bind(_assertThisInitialized(_this));
                    _this._handleCalendarKeyup = _this._handleCalendarKeyup.bind(_assertThisInitialized(_this));
                    _this._handleDateClick = _this._handleDateClick.bind(_assertThisInitialized(_this));
                    _this._handleIconButtonClick = _this._handleIconButtonClick.bind(_assertThisInitialized(_this));
                    _this._handleInputBlur = _this._handleInputBlur.bind(_assertThisInitialized(_this));
                    _this._handleInputChange = _this._handleInputChange.bind(_assertThisInitialized(_this));
                    _this._handleInputClick = _this._handleInputClick.bind(_assertThisInitialized(_this));
                    _this._handleInputInput = _this._handleInputInput.bind(_assertThisInitialized(_this));
                    _this._handleInputKeydown = _this._handleInputKeydown.bind(_assertThisInitialized(_this));
                    _this._handleInputKeyup = _this._handleInputKeyup.bind(_assertThisInitialized(_this));
                    _this._handleHeaderButtonClick = _this._handleHeaderButtonClick.bind(_assertThisInitialized(_this));
                    _this._handleThisMonthButtonClick = _this._handleThisMonthButtonClick.bind(_assertThisInitialized(_this));
                    _this._handleTodayButtonClick = _this._handleTodayButtonClick.bind(_assertThisInitialized(_this));
                    _this._handleTouchOrMousedown = _this._handleTouchOrMousedown.bind(_assertThisInitialized(_this));
                    _this._removeAriaLiveRegion = _this._removeAriaLiveRegion.bind(_assertThisInitialized(_this));
                    _this._setCalendarHorizontalPosition = _this._setCalendarHorizontalPosition.bind(_assertThisInitialized(_this));
                    _this._toggleDateTooltip = _this._toggleDateTooltip.bind(_assertThisInitialized(_this));
                    _this._dateMessageMap = {};
                    return _this;
                }
                _createClass(MdsDatepicker, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        var _this3 = this;
                        _get(_getPrototypeOf(MdsDatepicker.prototype), "connectedCallback", this).call(this);
                        this._calendar = function() {
                            _newArrowCheck(this, _this3);
                            return this.shadowRoot.querySelector(".datepicker__calendar");
                        }.bind(this);
                        this._calendarButton = function() {
                            _newArrowCheck(this, _this3);
                            return this.shadowRoot.querySelector("mds-text-input").shadowRoot.querySelector("#field-suffix");
                        }.bind(this);
                        this._calendarTable = function() {
                            _newArrowCheck(this, _this3);
                            return this.shadowRoot.querySelector(".datepicker__calendar-table");
                        }.bind(this);
                        this._prevYearButton = function() {
                            _newArrowCheck(this, _this3);
                            return this.shadowRoot.querySelector("#".concat(this.id, "-").concat(this._isMonthpicker ? "ten-" : "", "year-button-left"));
                        }.bind(this);
                        this._nextYearButton = function() {
                            _newArrowCheck(this, _this3);
                            return this.shadowRoot.querySelector("#".concat(this.id, "-").concat(this._isMonthpicker ? "ten-" : "", "year-button-right"));
                        }.bind(this);
                        this._prevMonthButton = function() {
                            _newArrowCheck(this, _this3);
                            return this.shadowRoot.querySelector("#".concat(this.id, "-").concat(this._isMonthpicker ? "one-year" : "month", "-button-left"));
                        }.bind(this);
                        this._nextMonthButton = function() {
                            _newArrowCheck(this, _this3);
                            return this.shadowRoot.querySelector("#".concat(this.id, "-").concat(this._isMonthpicker ? "one-year" : "month", "-button-right"));
                        }.bind(this);
                        this._cancelButton = function() {
                            _newArrowCheck(this, _this3);
                            return this.shadowRoot.querySelector("#".concat(this.id, "-cancel-button"));
                        }.bind(this);
                        this._todayButton = function() {
                            _newArrowCheck(this, _this3);
                            return this.shadowRoot.querySelector("#".concat(this.id, "-").concat(this._isMonthpicker ? "this-month" : "today", "-button"));
                        }.bind(this);
                        this._textInput = this.shadowRoot.querySelector("mds-text-input");
                        this._textInput.addEventListener("click-field-suffix", this._handleIconButtonClick);
                        this._textInput._validate = this._validate.bind(this._textInput, this);
                        this._textInput._hideFormattedValue = true;
                        setTimeout(function() {
                            _newArrowCheck(this, _this3);
                            if (this._isMonthpicker) {
                                this.selectedMonth && this.selectedMonthChangedCallback();
                            } else if (this.selectedDate) {
                                this.selectedDateChangedCallback();
                            }
                            this._hasConnected = true;
                            this.localeCodeChangedCallback();
                            this._calendarButton()._getInteractiveElement().interactiveElement.setAttribute("aria-expanded", false);
                            if (!this.accessibleTextIconOpen || !this.accessibleTextIconClose) {
                                this.remove();
                                this.throwConstraintError("As of @mds/web-3.0.0, accessibleTextIconOpen and accessibleTextIconClose are required properties.");
                            }
                            this._textLabel = this._textInput.shadowRoot.querySelector(".mds-text-input__label-wrap");
                        }.bind(this));
                    }
                }, {
                    key: "disconnectedCallback",
                    value: function disconnectedCallback() {
                        _get(_getPrototypeOf(MdsDatepicker.prototype), "disconnectedCallback", this) && _get(_getPrototypeOf(MdsDatepicker.prototype), "disconnectedCallback", this).call(this);
                        this._textInput.removeEventListener("click-field-suffix", this._handleIconButtonClick);
                        window.removeEventListener(touchOrMousedown, this._handleTouchOrMousedown);
                        this.labelStyle === "horizontal" && window.removeEventListener("resize", this._setCalendarHorizontalPosition);
                    }
                }, {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        if (payload.date) {
                            return {
                                interactiveElement: this.shadowRoot.querySelector("[data-".concat(this._isMonthpicker ? "month-" : "", 'date="').concat(payload.date, '"]'))
                            };
                        }
                        if (payload.target) {
                            return payload.target === "calendar-button" ? this._textInput._getInteractiveElement({
                                target: "field-suffix"
                            }) : _get(_getPrototypeOf(MdsDatepicker.prototype), "_getInteractiveElement", this).call(this, payload);
                        }
                        return {
                            interactiveElement: this._textInput._textFieldNode
                        };
                    }
                }, {
                    key: "_handleCalendarKeydown",
                    value: function _handleCalendarKeydown(customEvent) {
                        var event = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["originalEvent"])(customEvent);
                        if ([ 38, 40, 37, 39 ].includes(event.keyCode)) {
                            event.preventDefault();
                            if (customEvent.target.tagName === "MDS-BUTTON") {
                                [ this._cancelButton(), this._todayButton() ].includes(customEvent.target) ? this._focusOnLastValidDate() : this._focusOnFirstValidDate();
                            } else if (event.target.dataset.date || event.target.dataset.monthDate) {
                                [ 38, 40 ].includes(event.keyCode) ? this._shiftFocusVertically(event) : this._shiftFocusHorizontally(event);
                            }
                        } else if (event.keyCode === 9) {
                            this._handleCalendarTabKeydown(customEvent);
                        } else if (event.keyCode === 33) {
                            this._handleCalendarPageUpKeydown(event);
                        } else if (event.keyCode === 34) {
                            this._handleCalendarPageDownKeydown(event);
                        }
                    }
                }, {
                    key: "_handleCalendarKeyup",
                    value: function _handleCalendarKeyup(event) {
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["isEscAndShouldClose"])(event) && this._closeWithFocusOnInput(true);
                    }
                }, {
                    key: "_handleCalendarPageDownKeydown",
                    value: function _handleCalendarPageDownKeydown(event) {
                        event.preventDefault();
                        if (event.altKey && !this._nextYearButton().inactive) {
                            this._setYear(this._year + (this._isMonthpicker ? 10 : 1));
                            this._focusOnFirstValidDate();
                        } else if (!event.altKey && !this._nextMonthButton().inactive) {
                            this._isMonthpicker ? this._setYear(this._year + 1) : this._incrementMonth();
                            this._focusOnFirstValidDate();
                        } else if (event.altKey) {
                            this._setAriaLiveRegion(this._isMonthpicker ? this.accessibleTextNextTenYear : this.accessibleTextNextYear);
                        } else {
                            this._setAriaLiveRegion(this._isMonthpicker ? this.accessibleTextNextYear : this.accessibleTextNextMonth);
                        }
                    }
                }, {
                    key: "_handleCalendarPageUpKeydown",
                    value: function _handleCalendarPageUpKeydown(event) {
                        event.preventDefault();
                        if (event.altKey && !this._prevYearButton().inactive) {
                            this._setYear(this._year - (this._isMonthpicker ? 10 : 1));
                            this._focusOnLastValidDate();
                        } else if (!event.altKey && !this._prevMonthButton().inactive) {
                            this._isMonthpicker ? this._setYear(this._year - 1) : this._decrementMonth();
                            this._focusOnLastValidDate();
                        } else if (event.altKey) {
                            this._setAriaLiveRegion(this._isMonthpicker ? this.accessibleTextPreviousTenYear : this.accessibleTextPreviousYear);
                        } else {
                            this._setAriaLiveRegion(this._isMonthpicker ? this.accessibleTextPreviousYear : this.accessibleTextPreviousMonth);
                        }
                    }
                }, {
                    key: "_handleCalendarTabKeydown",
                    value: function _handleCalendarTabKeydown(customEvent) {
                        var _this4 = this;
                        var event = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["originalEvent"])(customEvent);
                        var focusableButtons = [ this._prevYearButton(), this._prevMonthButton(), this._nextMonthButton(), this._nextYearButton(), this._todayButton(), this._cancelButton() ].filter(function(button) {
                            _newArrowCheck(this, _this4);
                            return !button.inactive;
                        }.bind(this));
                        if (!event.target.dataset.date && !event.target.dataset.monthDate) {
                            event.preventDefault();
                            var currentIndex = focusableButtons.indexOf(customEvent.target);
                            if (!event.shiftKey) {
                                var targetButton = currentIndex === focusableButtons.length - 1 ? focusableButtons[0] : focusableButtons[currentIndex + 1];
                                if (targetButton.id === this._todayButton().id || customEvent.target.id === "".concat(this.id, "-cancel-button") && focusableButtons.length === 2) {
                                    this._focusOnFirstValidDate(event);
                                } else {
                                    targetButton.focus();
                                }
                            } else if (customEvent.target.id === this._todayButton().id) {
                                this._focusOnLastValidDate(event);
                            } else {
                                currentIndex === 0 ? focusableButtons[focusableButtons.length - 1].focus() : focusableButtons[currentIndex - 1].focus();
                            }
                        } else if (event.shiftKey && focusableButtons.length === 2) {
                            event.preventDefault();
                            this._cancelButton().focus();
                        }
                    }
                }, {
                    key: "_handleDateClick",
                    value: function _handleDateClick(event) {
                        if (event.target.dataset.date || event.target.dataset.monthDate) {
                            event.preventDefault();
                            if (this.selectedMonth && this.selectedMonth === event.target.dataset.monthDate) {
                                this.selectedMonthChangedCallback(this.selectedMonth);
                            } else if (this.selectedDate && this.selectedDate === event.target.dataset.date) {
                                this.selectedDateChangedCallback(this.selectedDate);
                            } else if (event.target.dataset.monthDate) {
                                this.selectedMonth = event.target.dataset.monthDate;
                            } else {
                                this.selectedDate = event.target.dataset.date;
                            }
                            this._closeWithFocusOnInput();
                            this.dispatchEvent(new CustomEvent("date-click", {
                                detail: {
                                    original: event,
                                    target: event.target
                                },
                                bubbles: true,
                                composed: true
                            }));
                            event.stopPropagation();
                        }
                    }
                }, {
                    key: "_handleIconButtonClick",
                    value: function _handleIconButtonClick() {
                        this._visible ? this._closeWithFocusOnInput() : this.open();
                    }
                }, {
                    key: "_handleInputClick",
                    value: function _handleInputClick(event) {
                        if (!this._visible && !MDS.isMobile && event.detail.target === this._textInput._textFieldNode) {
                            this.open(false);
                        }
                        _get(_getPrototypeOf(MdsDatepicker.prototype), "_onclick", this) && _get(_getPrototypeOf(MdsDatepicker.prototype), "_onclick", this).call(this, event);
                    }
                }, {
                    key: "_handleInputBlur",
                    value: function _handleInputBlur(event) {
                        var relatedTarget = event.detail.relatedTarget;
                        if (relatedTarget && !this.shadowRoot.contains(relatedTarget)) {
                            this.close();
                            _get(_getPrototypeOf(MdsDatepicker.prototype), "_onblur", this) && _get(_getPrototypeOf(MdsDatepicker.prototype), "_onblur", this).call(this, event);
                        } else if (relatedTarget) {
                            this._textInput._isFloating = true;
                        }
                    }
                }, {
                    key: "_handleInputChange",
                    value: function _handleInputChange(event) {
                        var parsedInput = this._isMonthpicker ? Object(_utils_date_utils__WEBPACK_IMPORTED_MODULE_4__["interpretMonth"])(event.target.value) : Object(_utils_date_utils__WEBPACK_IMPORTED_MODULE_4__["interpretDate"])(event.target.value);
                        if (parsedInput === null) {
                            this.setState({
                                errorMessage: this.errorMessage,
                                errorMessages: this.errorMessages
                            });
                            if (this.selectedDate === null || this.selectedMonth === null) {
                                var changeEvent = new CustomEvent("change", {
                                    bubbles: true,
                                    composed: true
                                });
                                this.dispatchEvent(changeEvent);
                            }
                            this.selectedMonth = null;
                            this.selectedDate = null;
                            event.stopPropagation();
                            return;
                        }
                        if (parsedInput) {
                            if (this._isMonthpicker) {
                                this._textInput.value = parsedInput;
                                this.value = parsedInput;
                            } else {
                                this._textInput.value = Object(_utils_date_utils__WEBPACK_IMPORTED_MODULE_4__["toShortDate"])(parsedInput);
                                this.value = Object(_utils_date_utils__WEBPACK_IMPORTED_MODULE_4__["toShortDate"])(parsedInput);
                                this._refreshCalendarDates(parsedInput);
                            }
                            if (this._isMonthpicker ? this.monthIsAvailable(parsedInput) : this.dateIsAvailable(parsedInput)) {
                                var _this$setState;
                                this.setState((_this$setState = {}, _defineProperty(_this$setState, "".concat(this._isMonthpicker ? "selectedMonth" : "selectedDate"), this._textInput.value), 
                                _defineProperty(_this$setState, "errorMessage", ""), _defineProperty(_this$setState, "errorMessages", []), 
                                _this$setState));
                                event.stopPropagation();
                            }
                        } else if (this.selectedDate || this.selectedMonth) {
                            this[this._isMonthpicker ? "selectedMonth" : "selectedDate"] = null;
                            event.stopPropagation();
                        }
                    }
                }, {
                    key: "_handleInputInput",
                    value: function _handleInputInput(event) {
                        this.value = event.target.value;
                    }
                }, {
                    key: "_handleInputKeydown",
                    value: function _handleInputKeydown(event) {
                        var eventObj = event.detail || event;
                        if (eventObj.keyCode === 40) {
                            eventObj.preventDefault();
                            this._textInput.value && this._handleInputChange(eventObj);
                            !this._visible && this.open();
                            if (this.selectedDate && this._monthIndex === new Date(this.selectedDate).getMonth() && this._year === new Date(this.selectedDate).getFullYear()) {
                                this.shadowRoot.querySelector('.datepicker__calendar-table-cell-circle[data-date="'.concat(this.selectedDate, '"]')).focus();
                            } else if (this.selectedMonth && this._year === Number(this.selectedMonth.slice(3))) {
                                this.shadowRoot.querySelector(".datepicker__month-button--selected").focus();
                            }
                        }
                    }
                }, {
                    key: "_handleInputKeyup",
                    value: function _handleInputKeyup(event) {
                        this._visible && Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["isEscAndShouldClose"])(event) && this._closeWithFocusOnInput();
                    }
                }, {
                    key: "_handleHeaderButtonClick",
                    value: function _handleHeaderButtonClick(event) {
                        var accessibleText;
                        if (event.target.id === "".concat(this.id, "-month-button-left")) {
                            this._decrementMonth();
                            accessibleText = this.accessibleTextPreviousMonth;
                        } else if (event.target.id === "".concat(this.id, "-month-button-right")) {
                            this._incrementMonth();
                            accessibleText = this.accessibleTextNextMonth;
                        } else if (event.target.id === "".concat(this.id, "-year-button-left") || event.target.id === "".concat(this.id, "-one-year-button-left")) {
                            this._setYear(this._year - 1);
                            accessibleText = this.accessibleTextPreviousYear;
                        } else if (event.target.id === "".concat(this.id, "-year-button-right") || event.target.id === "".concat(this.id, "-one-year-button-right")) {
                            this._setYear(this._year + 1);
                            accessibleText = this.accessibleTextNextYear;
                        } else if (event.target.id === "".concat(this.id, "-ten-year-button-left")) {
                            this._setYear(this._year - 10);
                            accessibleText = this.accessibleTextPreviousTenYear;
                        } else if (event.target.id === "".concat(this.id, "-ten-year-button-right")) {
                            this._setYear(this._year + 10);
                            accessibleText = this.accessibleTextNextTenYear;
                        }
                        if (event.target.inactive) {
                            event.target.dataset.direction === "left" ? this._focusOnLastValidDate(event) : this._focusOnFirstValidDate(event);
                            this._setAriaLiveRegion(accessibleText);
                        }
                    }
                }, {
                    key: "_handleThisMonthButtonClick",
                    value: function _handleThisMonthButtonClick() {
                        var _this5 = this;
                        var currentDate = new Date;
                        this._monthIndex = currentDate.getMonth();
                        this._setYear(currentDate.getFullYear());
                        var monthButton = this.shadowRoot.querySelector('.datepicker__month-button[data-index="'.concat(this._monthIndex, '"]'));
                        !monthButton.inactive && monthButton.focus();
                        if (!this.selectedMonth || Object(_utils_date_utils__WEBPACK_IMPORTED_MODULE_4__["toMonthDate"])(this._date) !== this.selectedMonth) {
                            monthButton.style.animation = "none";
                            requestAnimationFrame(function() {
                                _newArrowCheck(this, _this5);
                                monthButton.style.animation = "flash ".concat(400, "ms ").concat("cubic-bezier(1.00, 0.00, 1.00, 1.00)");
                            }.bind(this));
                        }
                    }
                }, {
                    key: "_handleTodayButtonClick",
                    value: function _handleTodayButtonClick() {
                        var _this6 = this;
                        this._refreshCalendarDates();
                        var todayCell = this.shadowRoot.querySelector('.datepicker__calendar-table-cell-circle[data-date="'.concat(this._currentDate, '"]'));
                        this._validDateMap[this._currentDate] && todayCell.focus();
                        if (this.selectedDate !== this._currentDate) {
                            todayCell.style.animation = "none";
                            requestAnimationFrame(function() {
                                _newArrowCheck(this, _this6);
                                todayCell.style.animation = "flash ".concat(400, "ms ").concat("cubic-bezier(1.00, 0.00, 1.00, 1.00)");
                            }.bind(this));
                        }
                    }
                }, {
                    key: "_handleTouchOrMousedown",
                    value: function _handleTouchOrMousedown(event) {
                        var isTargetInDatepicker;
                        if (event.composedPath) {
                            isTargetInDatepicker = this.deepContains(event.composedPath()[0]);
                        } else {
                            isTargetInDatepicker = this === event.target;
                        }
                        if (!isTargetInDatepicker) {
                            this.close();
                            if (this.labelStyle === "floating") {
                                this._textInput._isFloating = !!this.value;
                            }
                            _get(_getPrototypeOf(MdsDatepicker.prototype), "_onblur", this) && _get(_getPrototypeOf(MdsDatepicker.prototype), "_onblur", this).call(this, event);
                        }
                    }
                }, {
                    key: "_toggleDateTooltip",
                    value: function _toggleDateTooltip(event) {
                        var tooltip = this.shadowRoot.getElementById("tooltip-".concat(event.target.dataset.date));
                        var trigger = this.shadowRoot.querySelector('.datepicker__calendar-table-cell-circle[data-date="'.concat(event.target.dataset.date, '"]'));
                        if (tooltip && this.shadowRoot.activeElement !== trigger) {
                            tooltip.visible ? tooltip.close() : this._openTooltip(tooltip, trigger);
                        } else if (tooltip) {
                            this._openTooltip(tooltip, trigger);
                        }
                    }
                }, {
                    key: "_refreshCalendarDates",
                    value: function _refreshCalendarDates() {
                        var currentDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date;
                        var currentMonthIndex = currentDate.getMonth();
                        var currentYear = currentDate.getFullYear();
                        if (this._monthIndex !== currentMonthIndex || this._year !== currentYear) {
                            this._populateDates(currentYear, currentMonthIndex);
                            this._monthIndex = currentMonthIndex;
                            this._year = currentYear;
                            this._date = new Date(this._year, this._monthIndex);
                        }
                    }
                }, {
                    key: "_openTooltip",
                    value: function _openTooltip(tooltip, trigger) {
                        var overlay = tooltip.shadowRoot.querySelector('[class*="tooltip"]');
                        tooltip.open();
                        var positionFlags = Object(_utils_edge_detection__WEBPACK_IMPORTED_MODULE_6__["getPositionFlags"])(trigger.getBoundingClientRect(), overlay, Object(_utils_edge_detection__WEBPACK_IMPORTED_MODULE_6__["getEdges"])(this._calendar()));
                        tooltip.tooltipPlacement = positionFlags.vertical;
                        tooltip.alignment = positionFlags.horizontal;
                    }
                }, {
                    key: "minDateChangedCallback",
                    value: function minDateChangedCallback() {
                        this._minimumDate = this.minDate ? new Date(this.minDate) : null;
                    }
                }, {
                    key: "maxDateChangedCallback",
                    value: function maxDateChangedCallback() {
                        this._maximumDate = this.maxDate ? new Date(this.maxDate) : null;
                    }
                }, {
                    key: "dateIsAvailable",
                    value: function dateIsAvailable(dateToValidate) {
                        var dateInstance = new Date(dateToValidate);
                        var shortDate = Object(_utils_date_utils__WEBPACK_IMPORTED_MODULE_4__["toShortDate"])(dateInstance);
                        if (this.blackoutDates && this.blackoutDates.length && this._blackoutDateMap[shortDate]) {
                            return false;
                        } else if (this.whiteoutDates && this.whiteoutDates.length && !this._whiteoutDateMap[shortDate]) {
                            return false;
                        } else if (this._minimumDate && this._minimumDate > dateInstance) {
                            return false;
                        } else if (this._maximumDate && this._maximumDate < dateInstance) {
                            return false;
                        } else if (this.excludeWeekends && [ 0, 6 ].includes(dateInstance.getDay())) {
                            return false;
                        }
                        return true;
                    }
                }, {
                    key: "monthIsAvailable",
                    value: function monthIsAvailable(monthToValidate) {
                        if (this._minimumDate || this._maximumDate) {
                            var dateInstance;
                            if (monthToValidate instanceof Date) {
                                dateInstance = monthToValidate;
                            } else if (typeof monthToValidate === "string") {
                                var monthDateMatch = monthToValidate.match(/^(0?[1-9]|10|11|12)\D([0-9]{2}|[0-9]{4})$/);
                                if (monthDateMatch) {
                                    dateInstance = new Date("".concat(monthDateMatch[1], "/1/").concat(monthDateMatch[2]));
                                } else {
                                    console.warn("The date passed to monthIsAvailable, ".concat(monthToValidate, ", is not a valid format. Use m/yy, m/yyyy, mm/yy, or mm/yyyy."));
                                }
                            } else {
                                throw Error("The method, monthIsAvailable, accepts a JavaScript Date object or a string in monthDate format.");
                            }
                            var firstDayOfMinDateMonth = this._minimumDate && new Date(this._minimumDate.getFullYear(), this._minimumDate.getMonth());
                            var lastDayOfMaxDateMonth = this._maximumDate && new Date(this._maximumDate.getFullYear(), this._maximumDate.getMonth() + 1, 0);
                            if (firstDayOfMinDateMonth && dateInstance < firstDayOfMinDateMonth || lastDayOfMaxDateMonth && dateInstance > lastDayOfMaxDateMonth) {
                                return false;
                            }
                        }
                        return true;
                    }
                }, {
                    key: "_generateDates",
                    value: function _generateDates() {
                        var _this7 = this;
                        var year = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._year;
                        var monthIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._monthIndex;
                        var daysInMonth = Object(_utils_date_utils__WEBPACK_IMPORTED_MODULE_4__["getDaysInMonth"])(monthIndex, year);
                        var firstDayOfMonthIndex = new Date(year, monthIndex).getDay();
                        var allDates = new Array(daysInMonth + firstDayOfMonthIndex).fill(null).map(function(el, i) {
                            _newArrowCheck(this, _this7);
                            if (i < firstDayOfMonthIndex || i > daysInMonth + firstDayOfMonthIndex - 1) {
                                return {
                                    disabled: true
                                };
                            }
                            var dateInstance = new Date(year, monthIndex, i - firstDayOfMonthIndex + 1);
                            var shortDate = Object(_utils_date_utils__WEBPACK_IMPORTED_MODULE_4__["toShortDate"])(dateInstance);
                            return {
                                date: dateInstance,
                                day: dateInstance.getDay(),
                                disabled: !this.dateIsAvailable(shortDate),
                                isDueDate: this.dueDate === shortDate,
                                isToday: Object(_utils_date_utils__WEBPACK_IMPORTED_MODULE_4__["isToday"])(dateInstance),
                                message: this._dateMessageMap[shortDate],
                                shortDate: shortDate
                            };
                        }.bind(this));
                        var _validDates = allDates.filter(function(dateObj) {
                            _newArrowCheck(this, _this7);
                            return dateObj.date && !dateObj.disabled;
                        }.bind(this));
                        var _validDateMap = _validDates.reduce(function(acc, el) {
                            _newArrowCheck(this, _this7);
                            acc[el.shortDate] = el;
                            return acc;
                        }.bind(this), {});
                        return {
                            _validDates: _validDates,
                            _validDateMap: _validDateMap,
                            _dates: Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["chunkArray"])(allDates, 7),
                            _firstDayofNextMonth: new Date(year, monthIndex + 1),
                            _lastDayOfPrevMonth: new Date(year, monthIndex, 0)
                        };
                    }
                }, {
                    key: "_populateDates",
                    value: function _populateDates() {
                        var year = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._year;
                        var monthIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._monthIndex;
                        _extends(this, this._generateDates(year, monthIndex), {
                            _nextMonthValidDates: this._getNextMonthValidDates(year, monthIndex),
                            _prevMonthValidDates: this._getPreviousMonthValidDates(year, monthIndex)
                        });
                    }
                }, {
                    key: "_incrementMonth",
                    value: function _incrementMonth(focusOnFirstValidDate) {
                        if (this._monthIndex === 11) {
                            this._monthIndex = 0;
                            this._year++;
                        } else {
                            this._monthIndex++;
                        }
                        this._populateDates();
                        this._date = new Date(this._year, this._monthIndex);
                        focusOnFirstValidDate && this._focusOnFirstValidDate();
                    }
                }, {
                    key: "_decrementMonth",
                    value: function _decrementMonth(focusOnLastValidDate) {
                        if (this._monthIndex === 0) {
                            this._monthIndex = 11;
                            this._year--;
                        } else {
                            this._monthIndex--;
                        }
                        this._populateDates();
                        this._date = new Date(this._year, this._monthIndex);
                        focusOnLastValidDate && this._focusOnLastValidDate();
                    }
                }, {
                    key: "_getNextMonthValidDates",
                    value: function _getNextMonthValidDates() {
                        var currentYear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._year;
                        var currentMonthIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._monthIndex;
                        var nextMonthIndex = Object(_utils_date_utils__WEBPACK_IMPORTED_MODULE_4__["getNextMonthIndex"])(currentMonthIndex);
                        var year = nextMonthIndex === 0 ? currentYear + 1 : currentYear;
                        return this._generateDates(year, nextMonthIndex)._validDates;
                    }
                }, {
                    key: "_getPreviousMonthValidDates",
                    value: function _getPreviousMonthValidDates() {
                        var currentYear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._year;
                        var currentMonthIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._monthIndex;
                        var prevMonthIndex = Object(_utils_date_utils__WEBPACK_IMPORTED_MODULE_4__["getPrevMonthIndex"])(currentMonthIndex);
                        var year = prevMonthIndex === 11 ? currentYear - 1 : currentYear;
                        return this._generateDates(year, prevMonthIndex)._validDates;
                    }
                }, {
                    key: "_setYear",
                    value: function _setYear(year) {
                        this._year = year;
                        !this._isMonthpicker && this._populateDates();
                        this._date = new Date(this._year, this._monthIndex);
                    }
                }, {
                    key: "_shiftFocusHorizontally",
                    value: function _shiftFocusHorizontally(event) {
                        var keyCode = event.keyCode;
                        var dateDiff = keyCode === 39 ? 1 : -1;
                        if (this._isMonthpicker) {
                            var currentMonthIndex = Number(event.target.dataset.index);
                            var targetIndex = keyCode === 37 ? Object(_utils_date_utils__WEBPACK_IMPORTED_MODULE_4__["getPrevMonthIndex"])(currentMonthIndex) : Object(_utils_date_utils__WEBPACK_IMPORTED_MODULE_4__["getNextMonthIndex"])(currentMonthIndex);
                            if (keyCode === 37 && targetIndex === 11 || keyCode === 39 && targetIndex === 0) {
                                var canChangeYear = keyCode === 37 ? !this._prevMonthButton().inactive : !this._nextMonthButton().inactive;
                                if (canChangeYear) {
                                    this._setYear(this._year + dateDiff);
                                    this.shadowRoot.querySelector('.datepicker__month-button[data-index="'.concat(targetIndex, '"]')).focus();
                                } else {
                                    this._setAriaLiveRegion(keyCode === 37 ? this.accessibleTextPreviousYear : this.accessibleTextNextYear);
                                }
                            } else {
                                var target = this.shadowRoot.querySelector('.datepicker__month-button[data-index="'.concat(targetIndex, '"]'));
                                target.disabled ? this._setAriaLiveRegion(keyCode === 37 ? this.accessibleTextPreviousMonth : this.accessibleTextNextMonth) : target.focus();
                            }
                        } else {
                            var currentDateIndex = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["nestedIndexOf"])(this._validDates, "shortDate", event.target.dataset.date);
                            var nextDate = this._validDates[currentDateIndex + dateDiff];
                            if (nextDate) {
                                this.shadowRoot.querySelector('.datepicker__calendar-table-cell-circle[data-date="'.concat(nextDate.shortDate, '"]')).focus();
                            } else if (keyCode === 39 && (!this._maximumDate || this._firstDayofNextMonth <= this._maximumDate)) {
                                this._getNextMonthValidDates().length && this._incrementMonth(true);
                            } else if (keyCode === 37 && (!this._minimumDate || this._lastDayOfPrevMonth >= this._minimumDate)) {
                                this._getPreviousMonthValidDates().length && this._decrementMonth(true);
                            } else {
                                this._setAriaLiveRegion(keyCode === 39 ? this.accessibleTextNextDay : this.accessibleTextPreviousDay);
                            }
                        }
                    }
                }, {
                    key: "_shiftFocusVertically",
                    value: function _shiftFocusVertically(event) {
                        var keyCode = event.keyCode;
                        if (this._isMonthpicker) {
                            var currentRowIndex = Number(event.target.dataset.rowIndex);
                            var dateDiff = keyCode === 40 ? 1 : -1;
                            var targetRowIndex;
                            if (keyCode === 40 && currentRowIndex === 2 || keyCode === 38 && currentRowIndex === 0) {
                                var canChangeYear = keyCode === 40 ? !this._nextMonthButton().inactive : !this._prevMonthButton().inactive;
                                if (canChangeYear) {
                                    this._setYear(this._year + dateDiff);
                                    targetRowIndex = keyCode === 40 ? 0 : 2;
                                    var target = this.shadowRoot.querySelector('.datepicker__month-button[data-row-index="'.concat(targetRowIndex, '"][data-col-index="').concat(event.target.dataset.colIndex, '"]'));
                                    if (target.disabled) {
                                        keyCode === 40 ? this._focusOnFirstValidDate() : this._focusOnLastValidDate();
                                    } else {
                                        target.focus();
                                    }
                                } else {
                                    this._setAriaLiveRegion(keyCode === 40 ? this.accessibleTextNextYear : this.accessibleTextPreviousYear);
                                }
                            } else {
                                targetRowIndex = currentRowIndex + dateDiff;
                                this.shadowRoot.querySelector('.datepicker__month-button[data-row-index="'.concat(targetRowIndex, '"][data-col-index="').concat(event.target.dataset.colIndex, '"]')).focus();
                            }
                        } else {
                            var currentDateIndex = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["nestedIndexOf"])(this._validDates, "shortDate", event.target.dataset.date);
                            var currentDay = new Date(event.target.dataset.date).getUTCDay();
                            var nextDate = keyCode === 40 ? this._nextValidDayOfWeek(currentDateIndex, currentDay) : this._previousValidDayOfWeek(currentDateIndex, currentDay);
                            if (nextDate) {
                                this.shadowRoot.querySelector('.datepicker__calendar-table-cell-circle[data-date="'.concat(nextDate.shortDate, '"]')).focus();
                            } else if (keyCode === 40 && (!this._maximumDate || this._firstDayofNextMonth <= this._maximumDate)) {
                                this._getNextMonthValidDates().length && this._incrementMonth();
                                var validDays = this.shadowRoot.querySelectorAll('.datepicker__calendar-table-cell-circle--enabled[data-day="'.concat(currentDay, '"]'));
                                validDays.length ? validDays[0].focus() : this._focusOnFirstValidDate();
                            } else if (keyCode === 38 && (!this._minimumDate || this._lastDayOfPrevMonth >= this._minimumDate)) {
                                this._getPreviousMonthValidDates().length && this._decrementMonth();
                                var _validDays = this.shadowRoot.querySelectorAll('.datepicker__calendar-table-cell-circle--enabled[data-day="'.concat(currentDay, '"]'));
                                _validDays.length ? _validDays[_validDays.length - 1].focus() : this._focusOnLastValidDate();
                            } else {
                                this._setAriaLiveRegion(keyCode === 40 ? this.accessibleTextNextDay : this.accessibleTextPreviousDay);
                            }
                        }
                    }
                }, {
                    key: "_nextValidDayOfWeek",
                    value: function _nextValidDayOfWeek(currentDateIndex, currentDay) {
                        for (var i = currentDateIndex + 1; i < this._validDates.length; i++) {
                            if (this._validDates[i].day === currentDay) {
                                return this._validDates[i];
                            }
                        }
                        return null;
                    }
                }, {
                    key: "_previousValidDayOfWeek",
                    value: function _previousValidDayOfWeek(currentDateIndex, currentDay) {
                        for (var i = currentDateIndex - 1; i >= 0; i--) {
                            if (this._validDates[i].day === currentDay) {
                                return this._validDates[i];
                            }
                        }
                        return null;
                    }
                }, {
                    key: "_focusOnFirstValidDate",
                    value: function _focusOnFirstValidDate(event) {
                        event && event.preventDefault();
                        var validDate = this.shadowRoot.querySelector(this._isMonthpicker ? ".datepicker__month-button--enabled" : ".datepicker__calendar-table-cell-circle--enabled");
                        validDate ? validDate.focus() : this._todayButton().focus();
                    }
                }, {
                    key: "_focusOnLastValidDate",
                    value: function _focusOnLastValidDate(event) {
                        event && event.preventDefault();
                        var validDates = this.shadowRoot.querySelectorAll(this._isMonthpicker ? ".datepicker__month-button--enabled" : ".datepicker__calendar-table-cell-circle--enabled");
                        var lastValidDate = validDates[validDates.length - 1];
                        lastValidDate ? lastValidDate.focus() : this._todayButton().focus();
                    }
                }, {
                    key: "blackoutDatesChangedCallback",
                    value: function blackoutDatesChangedCallback(dates) {
                        var _this8 = this;
                        if (this.whiteoutDates && this.whiteoutDates.length) {
                            this.whiteoutDates = [];
                        }
                        this._blackoutDateMap = dates.reduce(function(acc, dateObj) {
                            _newArrowCheck(this, _this8);
                            acc[Object(_utils_date_utils__WEBPACK_IMPORTED_MODULE_4__["toShortDate"])(dateObj)] = dateObj;
                            return acc;
                        }.bind(this), {});
                    }
                }, {
                    key: "labelStyleChangedCallback",
                    value: function labelStyleChangedCallback() {
                        this._visible && this.close();
                    }
                }, {
                    key: "localeCodeChangedCallback",
                    value: function localeCodeChangedCallback() {
                        var _this9 = this;
                        var localeCode = this.localeCode || undefined;
                        try {
                            this._localeCodeUsed = true;
                            this.monthNames = Array(12).fill().map(function(el, i) {
                                _newArrowCheck(this, _this9);
                                return new Date("".concat(i + 1, "/1/").concat(this._year)).toLocaleDateString(localeCode, {
                                    month: "long"
                                });
                            }.bind(this));
                            if (!this._isMonthpicker) {
                                this._localeCodeUsed = true;
                                this.dayNames = Array(7).fill().map(function(el, i) {
                                    _newArrowCheck(this, _this9);
                                    var date = new Date("1/".concat(i + 1, "/").concat(this._year));
                                    return {
                                        index: date.getDay(),
                                        name: date.toLocaleDateString(localeCode, {
                                            weekday: "long"
                                        })
                                    };
                                }.bind(this)).sort(function(a, b) {
                                    _newArrowCheck(this, _this9);
                                    return a.index - b.index;
                                }.bind(this)).map(function(el) {
                                    _newArrowCheck(this, _this9);
                                    return el.name;
                                }.bind(this));
                            }
                        } catch (error) {
                            if (error instanceof RangeError) {
                                this.throwConstraintError("The localeCode ".concat(this.localeCode, " is invalid. Check the following link for a complete list of valid codes:\n          https://docs.microsoft.com/en-us/openspecs/windows_protocols/ms-lcid/a9eac961-e77d-41a6-90a5-ce1a8b0cdb9c"));
                            } else {
                                throw error;
                            }
                        }
                    }
                }, {
                    key: "monthNamesChangedCallback",
                    value: function monthNamesChangedCallback() {
                        var _this10 = this;
                        this._presetMonthNames = false;
                        this._monthGridArray = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["chunkArray"])(this.monthNames.map(function(el, i) {
                            _newArrowCheck(this, _this10);
                            return i;
                        }.bind(this)), 4);
                    }
                }, {
                    key: "whiteoutDatesChangedCallback",
                    value: function whiteoutDatesChangedCallback(dates) {
                        var _this11 = this;
                        if (this.blackoutDates && this.blackoutDates.length) {
                            this.blackoutDates = [];
                        }
                        this._whiteoutDateMap = dates.reduce(function(acc, dateObj) {
                            _newArrowCheck(this, _this11);
                            acc[Object(_utils_date_utils__WEBPACK_IMPORTED_MODULE_4__["toShortDate"])(dateObj)] = dateObj;
                            return acc;
                        }.bind(this), {});
                    }
                }, {
                    key: "valueChangedCallback",
                    value: function valueChangedCallback() {
                        if (!this.shadowRoot.activeElement || this.shadowRoot.activeElement.nodeName !== "MDS-TEXT-INPUT") {
                            if (this._isMonthpicker && this.selectedMonth !== this.value) {
                                this.selectedMonth = this.value;
                            } else if (this.selectedDate !== this.value) {
                                this.selectedDate = this.value;
                            }
                        }
                    }
                }, {
                    key: "selectedDateChangedCallback",
                    value: function selectedDateChangedCallback() {
                        if (!this._isMonthpicker) {
                            this.setAppliedSelectedDate(Object(_utils_date_utils__WEBPACK_IMPORTED_MODULE_4__["interpretDate"])(this.selectedDate));
                        }
                    }
                }, {
                    key: "isValidDate",
                    value: function isValidDate(newDate) {
                        return !!(newDate && Object(_utils_date_utils__WEBPACK_IMPORTED_MODULE_4__["toShortDate"])(newDate));
                    }
                }, {
                    key: "setAppliedSelectedDate",
                    value: function setAppliedSelectedDate(newDate) {
                        if (this.isValidDate(newDate)) {
                            this.updateAppliedSelectedDate(newDate);
                        } else {
                            this._appliedSelectedDate = "";
                            this._textInput.value = this.value;
                            var changeEvent = new CustomEvent("change", {
                                bubbles: true,
                                composed: true
                            });
                            this.dispatchEvent(changeEvent);
                        }
                    }
                }, {
                    key: "updateAppliedSelectedDate",
                    value: function updateAppliedSelectedDate(newDate) {
                        var _this12 = this;
                        this._appliedSelectedDate = Object(_utils_date_utils__WEBPACK_IMPORTED_MODULE_4__["toShortDate"])(newDate);
                        var changeEvent = new CustomEvent("change", {
                            bubbles: true,
                            composed: true
                        });
                        if (this._textInput) {
                            this._textInput.value = this._appliedSelectedDate;
                        }
                        this._monthIndex = new Date(this._appliedSelectedDate).getMonth();
                        this._year = new Date(this._appliedSelectedDate).getFullYear();
                        this.setState(_objectSpread({}, this.value !== this._appliedSelectedDate && {
                            value: this._appliedSelectedDate
                        }, {
                            _date: new Date(this._year, this._monthIndex),
                            errorMessage: "",
                            errorMessages: []
                        })).then(function() {
                            _newArrowCheck(this, _this12);
                            return this._hasConnected && this.dispatchEvent(changeEvent);
                        }.bind(this));
                    }
                }, {
                    key: "selectedMonthChangedCallback",
                    value: function selectedMonthChangedCallback() {
                        if (this._isMonthpicker) {
                            this.setAppliedSelectedMonth(Object(_utils_date_utils__WEBPACK_IMPORTED_MODULE_4__["interpretMonth"])(this.selectedMonth));
                        }
                    }
                }, {
                    key: "isValidMonth",
                    value: function isValidMonth(newMonth) {
                        return !!(newMonth && Object(_utils_date_utils__WEBPACK_IMPORTED_MODULE_4__["interpretMonth"])(newMonth));
                    }
                }, {
                    key: "setAppliedSelectedMonth",
                    value: function setAppliedSelectedMonth(newMonth) {
                        var _this13 = this;
                        if (newMonth && this.isValidMonth(newMonth)) {
                            this._appliedSelectedMonth = newMonth;
                            var changeEvent = new CustomEvent("change", {
                                bubbles: true,
                                composed: true
                            });
                            if (this._textInput) {
                                this._textInput.value = this._appliedSelectedMonth;
                            }
                            this._monthIndex = Number(this._appliedSelectedMonth.slice(0, 2)) - 1;
                            this._year = Number(this._appliedSelectedMonth.slice(3));
                            this.setState(_objectSpread({}, this.value !== this._appliedSelectedMonth && {
                                value: this._appliedSelectedMonth
                            }, {
                                _date: new Date(this._year, this._monthIndex),
                                errorMessage: "",
                                errorMessages: []
                            })).then(function() {
                                _newArrowCheck(this, _this13);
                                return this._hasConnected && this.dispatchEvent(changeEvent);
                            }.bind(this));
                        } else {
                            this._textInput.value = this.value;
                            var _changeEvent = new CustomEvent("change", {
                                bubbles: true,
                                composed: true
                            });
                            if (this._hasConnected) {
                                this.dispatchEvent(_changeEvent);
                            }
                        }
                    }
                }, {
                    key: "defaultDateChangedCallback",
                    value: function defaultDateChangedCallback() {
                        if (this.defaultDate) {
                            var _date = new Date(this.defaultDate);
                            this._monthIndex = _date.getMonth();
                            this._year = _date.getFullYear();
                            this._date = _date;
                        }
                    }
                }, {
                    key: "dateMessagesChangedCallback",
                    value: function dateMessagesChangedCallback(dateMessages) {
                        var _this14 = this;
                        this._dateMessageMap = dateMessages.reduce(function(acc, obj) {
                            _newArrowCheck(this, _this14);
                            acc[obj.date] = obj.message;
                            return acc;
                        }.bind(this), {});
                    }
                }, {
                    key: "dueDateChangedCallback",
                    value: function dueDateChangedCallback(dueDate) {
                        if (dueDate) {
                            var dueDateObj = new Date(this.dueDate);
                            this._dueMonthIndex = dueDateObj.getMonth();
                            this._dueYear = dueDateObj.getFullYear();
                        }
                    }
                }, {
                    key: "_validate",
                    value: function _validate(datepicker, event) {
                        if (event.type === "blur") {
                            var blurEvent = event.detail || event;
                            var focusedNode = blurEvent.relatedTarget || document.activeElement;
                            if (!this.shadowRoot.contains(focusedNode) && !datepicker.shadowRoot.contains(focusedNode)) {
                                this.dispatchEvent(new CustomEvent("validate", {
                                    detail: event,
                                    bubbles: true,
                                    composed: true
                                }));
                            }
                        }
                        if (event.type === "input") {
                            this.dispatchEvent(new CustomEvent("validate", {
                                detail: event,
                                bubbles: true,
                                composed: true
                            }));
                        }
                    }
                }, {
                    key: "clear",
                    value: function clear() {
                        var resetSelectedDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                        this._textInput.value = "";
                        if (resetSelectedDate) {
                            this.value = "";
                            _extends(this, _defineProperty({}, "".concat(this._isMonthpicker ? "selectedMonth" : "selectedDate"), null));
                        }
                    }
                }, {
                    key: "open",
                    value: function open() {
                        var focusOnSelectedOrFirstValidDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                        var _window = window, innerWidth = _window.innerWidth;
                        !this._isMonthpicker && this._populateDates();
                        this._visible = true;
                        this._calendarButton()._getInteractiveElement().interactiveElement.setAttribute("aria-expanded", true);
                        this._handleCalenderHorizontalPositioning(this._calendar(), innerWidth);
                        if (this.labelStyle === "horizontal") {
                            this._setCalendarHorizontalPosition();
                            window.addEventListener("resize", this._setCalendarHorizontalPosition);
                        }
                        this._handleOverlowPositioning();
                        if (focusOnSelectedOrFirstValidDate) {
                            var selectedDate = this._isMonthpicker ? this.shadowRoot.querySelector('.datepicker__month-button[data-month-date="'.concat(this.selectedMonth, '"]')) : this.shadowRoot.querySelector('.datepicker__calendar-table-cell-circle[data-date="'.concat(this._appliedSelectedDate, '"]'));
                            selectedDate ? selectedDate.focus() : this._focusOnFirstValidDate();
                        }
                        var input = {
                            label: this._textLabel,
                            inputTrigger: this._textInput._textFieldNode,
                            textField: true
                        };
                        _utils_edge_detection__WEBPACK_IMPORTED_MODULE_6__["setOverlayVerticalPosition"].call(this, this._calendar(), input, this.disableEdgeDetection, Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_7__["cleanCssValue"])("4px"));
                        this.dispatchEvent(new CustomEvent("open", {
                            bubbles: true,
                            composed: true
                        }));
                        window.addEventListener(touchOrMousedown, this._handleTouchOrMousedown);
                    }
                }, {
                    key: "_handleOverlowPositioning",
                    value: function _handleOverlowPositioning() {
                        var windowWidth = window.innerWidth;
                        var calendarPosition = Object(_utils_edge_detection__WEBPACK_IMPORTED_MODULE_6__["getEdges"])(this._calendar());
                        if (calendarPosition.right > windowWidth) {
                            var distanceOffscreen = calendarPosition.right - windowWidth;
                            if (this._calendar().style.left === "") {
                                this._calendar().style.left = "".concat(0 - distanceOffscreen, "px");
                            } else {
                                this._calendar().style.left = "".concat(this._calendar().style.left - distanceOffscreen, "px");
                            }
                        }
                    }
                }, {
                    key: "close",
                    value: function close() {
                        if (this._visible) {
                            window.removeEventListener(touchOrMousedown, this._handleTouchOrMousedown);
                            this._visible = false;
                            this.dispatchEvent(new CustomEvent("close", {
                                bubbles: true,
                                composed: true
                            }));
                            this.labelStyle === "horizontal" && window.removeEventListener("resize", this._setCalendarHorizontalPosition);
                            this._calendarButton()._getInteractiveElement().interactiveElement.setAttribute("aria-expanded", false);
                        }
                    }
                }, {
                    key: "_closeWithFocusOnInput",
                    value: function _closeWithFocusOnInput(select) {
                        this.close();
                        this._textInput.focus();
                        select && this._textInput.select();
                    }
                }, {
                    key: "_setCalendarHorizontalPosition",
                    value: function _setCalendarHorizontalPosition() {
                        this._calendar().style.left = "".concat(this._textInput._labelNode.parentElement.offsetWidth, "px");
                    }
                }, {
                    key: "_setAriaLiveRegion",
                    value: function _setAriaLiveRegion(accessibleText) {
                        var focusedDate = this.shadowRoot.activeElement;
                        if (focusedDate) {
                            this._liveRegion = focusedDate.parentElement.querySelector(".datepicker__accessible-text");
                            if (this._liveRegion) {
                                this._liveRegion.innerText = "".concat(this.accessibleTextNoText, " ").concat(accessibleText);
                                setTimeout(this._removeAriaLiveRegion, 2e3);
                            }
                        }
                    }
                }, {
                    key: "_removeAriaLiveRegion",
                    value: function _removeAriaLiveRegion() {
                        this._liveRegion.innerText = "";
                    }
                }, {
                    key: "render",
                    value: function render() {
                        _MdsDatepicker__WEBPACK_IMPORTED_MODULE_1__["default"].call(this);
                    }
                }, {
                    key: "_isMonthpicker",
                    get: function get() {
                        return this.calendarType === "month";
                    }
                } ]);
                return MdsDatepicker;
            }(_abstract_text_field__WEBPACK_IMPORTED_MODULE_3__["default"]), _class2.styles = _mds_datepicker_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsDatepicker;
        },
        "./src/datepicker/mds-datepicker.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/datepicker/mds-datepicker.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/definition-link/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _abstract_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/abstract-link/index.js");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_allowLists__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/allowLists.js");
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _dec, _class;
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["mixins"].AttributeMarshallingMixin, stamp = _mixins$AttributeMars.stamp, string = _mixins$AttributeMars.string, enumerables = _mixins$AttributeMars.enumerables, boolean = _mixins$AttributeMars.boolean;
            var definitionLinkEntity = {
                accessibleText: string.defaultsTo(""),
                alignment: enumerables(string, "center", "left", "right", "").defaultsTo("").withChangedCallback(),
                tooltipAlignment: enumerables(string, "center", "left", "right", "").defaultsTo("left").withChangedCallback(),
                definitionText: string.withHTML(_utils_allowLists__WEBPACK_IMPORTED_MODULE_4__["base"]),
                tooltipMessage: string,
                tooltipPlacement: enumerables(string, "above", "below", "").defaultsTo("below"),
                edgeDetection: boolean.defaultsTo(false)
            };
            var entity = _objectSpread({}, _abstract_link__WEBPACK_IMPORTED_MODULE_2__["entity"], {}, definitionLinkEntity);
            var MdsDefinitionLink = (_dec = stamp(entity), _dec(_class = function(_AbstractLink) {
                _inherits(MdsDefinitionLink, _AbstractLink);
                _createClass(MdsDefinitionLink, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsDefinitionLink";
                    }
                } ]);
                function MdsDefinitionLink() {
                    var _this;
                    _classCallCheck(this, MdsDefinitionLink);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsDefinitionLink).call(this));
                    _this._handleTouchstart = _this._handleTouchstart.bind(_assertThisInitialized(_this));
                    _this.defineObservedProperty("_ariaLiveActive", false);
                    return _this;
                }
                _createClass(MdsDefinitionLink, [ {
                    key: "_setAlignmentToTooltipAlignment",
                    value: function _setAlignmentToTooltipAlignment() {
                        if (this.alignment && this.alignment !== this.tooltipAlignment) {
                            this.tooltipAlignment = this.alignment;
                            console.warn("alignment attribute will be deprecated in June 2023, please use tooltip-alignment instead. Currently, value in alignment overrides tooltipAlignment");
                        }
                    }
                }, {
                    key: "alignmentChangedCallback",
                    value: function alignmentChangedCallback() {
                        this._setAlignmentToTooltipAlignment();
                    }
                }, {
                    key: "tooltipAlignmentChangedCallback",
                    value: function tooltipAlignmentChangedCallback() {
                        this._setAlignmentToTooltipAlignment();
                    }
                }, {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        return {
                            interactiveElement: this._link
                        };
                    }
                }, {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsDefinitionLink.prototype), "connectedCallback", this).call(this);
                        this._tooltip = this.shadowRoot.querySelector("mds-tooltip");
                        this._link = this.shadowRoot.querySelector("mds-link");
                        this._tooltip._topLevelParent = this;
                        this._tooltip._overlayIsClickable = true;
                    }
                }, {
                    key: "disconnectedCallback",
                    value: function disconnectedCallback() {
                        _get(_getPrototypeOf(MdsDefinitionLink.prototype), "disconnectedCallback", this) && _get(_getPrototypeOf(MdsDefinitionLink.prototype), "disconnectedCallback", this).call(this);
                        MDS.isIOS && document.removeEventListener("touchstart", this._handleTouchstart);
                    }
                }, {
                    key: "open",
                    value: function open() {
                        this._tooltip.open();
                        MDS.isIOS && document.addEventListener("touchstart", this._handleTouchstart);
                    }
                }, {
                    key: "close",
                    value: function close() {
                        this._tooltip.close();
                    }
                }, {
                    key: "_onblur",
                    value: function _onblur(event) {
                        _get(_getPrototypeOf(MdsDefinitionLink.prototype), "_onblur", this) && _get(_getPrototypeOf(MdsDefinitionLink.prototype), "_onblur", this).call(this, event);
                        event.detail.relatedTarget !== this._tooltip._renderTarget && this.close();
                        MDS.isIOS && document.removeEventListener("touchstart", this.handleTouchstart);
                    }
                }, {
                    key: "_onclick",
                    value: function _onclick(event) {
                        _get(_getPrototypeOf(MdsDefinitionLink.prototype), "_onclick", this) && _get(_getPrototypeOf(MdsDefinitionLink.prototype), "_onclick", this).call(this, event);
                        if (this._tooltip.visible) {
                            event.detail.target === this._link._anchorNode && this.close();
                        } else {
                            this.open();
                        }
                    }
                }, {
                    key: "_handleTouchstart",
                    value: function _handleTouchstart(event) {
                        if (event.target !== this) {
                            this._tooltip.visible && this.close();
                            this.blur();
                        }
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var accessibleText = this.accessibleText, tooltipAlignment = this.tooltipAlignment, definitionText = this.definitionText, edgeDetection = this.edgeDetection, endIcon = this.endIcon, id = this.id, startIcon = this.startIcon, tooltipMessage = this.tooltipMessage, tooltipPlacement = this.tooltipPlacement, _onblur = this._onblur, _onfocus = this._onfocus, _onclick = this._onclick, _onkeydown = this._onkeydown, _onkeyup = this._onkeyup;
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "definition-link");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("mds-link", null, null, "id", "".concat(id, "-mds-link"), "text", definitionText, "start-icon", startIcon, "end-icon", endIcon, "is-button", "true", "onblur", _onblur, "onfocus", _onfocus, "onclick", _onclick, "onkeydown", _onkeydown, "onkeyup", _onkeyup, "label-aria-text", accessibleText, "class", "definition-link");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("mds-tooltip");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("message", tooltipMessage);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("alignment", tooltipAlignment);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("tooltip-placement", tooltipPlacement);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                            "edge-detection": false
                        }, (tooltipAlignment || tooltipPlacement) && !edgeDetection));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("manual-control", "true");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("detect-trigger-wrap", "true");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("mds-tooltip");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-tooltip");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-link");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return MdsDefinitionLink;
            }(_abstract_link__WEBPACK_IMPORTED_MODULE_2__["default"])) || _class);
            __webpack_exports__["default"] = MdsDefinitionLink;
        },
        "./src/description-list/MdsDescriptionList.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_table_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/table-utils.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _span$wrapper = function _span$wrapper(_termContentClasses, _item$term) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", _termContentClasses);
                _renderArbitrary(_item$term);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            }, _slot$wrapper = function _slot$wrapper(_termContentClasses2, _item$termSlotName, _index) {
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "class", _termContentClasses2, "name", _item$termSlotName, "data-type", "term", "data-index", _index);
            }, _mdsTag$wrapper = function _mdsTag$wrapper(_item$tagText) {
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-tag", null, null, "class", "description-list__item-term-tag", "text", _item$tagText);
            }, _span$wrapper2 = function _span$wrapper2(_child) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span");
                _renderArbitrary(_child);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            }, _br$wrapper = function _br$wrapper() {
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("br");
            }, _span$wrapper3 = function _span$wrapper3() {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "description-list__item-separator", "aria-hidden", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(" ｜ ");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            }, _mdsButton$wrapper = function _mdsButton$wrapper(_id, _text2, _index2, _this$_handleMaskingB, _conditionalAttribute) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("mds-button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", _id);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("text", _text2);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("variant", "tertiary");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("small", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-index", _index2);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onclick", _this$_handleMaskingB);
                _spreadAttribute(_conditionalAttribute);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("mds-button");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-button");
            }, _span$wrapper4 = function _span$wrapper4(_line, _child2) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "description-list__item-description-text");
                _renderArbitrary(_line);
                _renderArbitrary(_child2);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            }, _br$wrapper2 = function _br$wrapper2() {
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("br");
            };
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function renderTerm(item, index) {
                var termContentClasses = {
                    "description-list__item-term-content": true,
                    "description-list__item-term-content--tagged": item.tagText
                };
                var termElements = [];
                if (item.term) {
                    termElements.push(_jsxWrapper(_span$wrapper, [ termContentClasses, item.term ]));
                } else if (item.termSlotName) {
                    termElements.push(_jsxWrapper(_slot$wrapper, [ termContentClasses, item.termSlotName, index ]));
                }
                if (termElements.length && item.tagText) {
                    termElements.push(_jsxWrapper(_mdsTag$wrapper, [ item.tagText ]));
                }
                return termElements;
            }
            function renderDescription(item, index) {
                var _this = this;
                if (item.descriptionSlotName) {
                    return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "name", item.descriptionSlotName, "data-type", "description", "data-index", index);
                }
                if (item.buttonShowText && item.buttonHideText) {
                    return [ _jsxWrapper(_span$wrapper2, [ this._maskingState[index] ? item.description : item.descriptionMasked ]), item.stacked ? _jsxWrapper(_br$wrapper) : _jsxWrapper(_span$wrapper3), _jsxWrapper(_mdsButton$wrapper, [ "masking-button-".concat(index), this._maskingState[index] ? item.buttonHideText : item.buttonShowText, index, this._handleMaskingButtonClick, Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["conditionalAttribute"])({
                        "accessible-text": item.buttonAccessibleText
                    }, item.buttonAccessibleText) ]) ];
                }
                var text = _utils_table_utils__WEBPACK_IMPORTED_MODULE_1__["cleanDisplayValue"].call(this, item.description);
                return text.tagName ? text : text.split("\n").map(function(line, i, lines) {
                    _newArrowCheck(this, _this);
                    return _jsxWrapper(_span$wrapper4, [ line, i < lines.length - 1 && _jsxWrapper(_br$wrapper2) ]);
                }.bind(this));
            }
            function renderListItem(item, index) {
                var _itemClasses, _itemDescriptionClass;
                var itemClasses = (_itemClasses = {
                    "description-list__item": true,
                    "description-list__item--horizontal-rule": item.horizontalRule || this.horizontalRuleAll
                }, _defineProperty(_itemClasses, "description-list__item--".concat(this.mode), this.itemLayout === "horizontal"), 
                _defineProperty(_itemClasses, "description-list__item--".concat(this.itemLayout), true), 
                _itemClasses);
                var itemTermClasses = {
                    "description-list__item-term": true,
                    "description-list__item-term--bold": item.boldTerm || this.boldTermAll
                };
                var itemDescriptionClasses = (_itemDescriptionClass = {
                    "description-list__item-description": true
                }, _defineProperty(_itemDescriptionClass, "description-list__item-description--alignment-".concat(this.descriptionAlignment), this.itemLayout === "horizontal"), 
                _defineProperty(_itemDescriptionClass, "description-list__item-description--bold", item.boldDescription || this.boldDescriptionAll), 
                _defineProperty(_itemDescriptionClass, "description-list__item-description--negative", item.applyNegativeColor), 
                _defineProperty(_itemDescriptionClass, "description-list__item-description--positive", item.applyPositiveColor), 
                _itemDescriptionClass);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", itemClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("dt", null, null, "class", itemTermClasses, "style", {
                    flexBasis: "".concat(this.termWidth, "%")
                });
                _renderArbitrary(renderTerm(item, index));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("dt");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("dd", null, null, "class", itemDescriptionClasses, "style", {
                    flexBasis: "".concat(this.descriptionWidth, "%")
                });
                _renderArbitrary(renderDescription.call(this, item, index));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("dd");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function MdsDescriptionListTemplate() {
                var _this2 = this;
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("dl", null, null, "class", "description-list");
                _renderArbitrary(this.items.map(function(item, index) {
                    _newArrowCheck(this, _this2);
                    return renderListItem.call(this, item, index);
                }.bind(this)));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("dl");
            }
            __webpack_exports__["default"] = MdsDescriptionListTemplate;
        },
        "./src/description-list/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_description_list_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/description-list/mds-description-list.scss");
            var _mds_description_list_scss__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_description_list_scss__WEBPACK_IMPORTED_MODULE_1__);
            var _MdsDescriptionList__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/description-list/MdsDescriptionList.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            var _tooltip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/tooltip/index.jsx");
            var _tag__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/tag/index.jsx");
            var _link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/link/index.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var arrayOf = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].arrayOf, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].boolean, number = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].number, satisfies = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].satisfies, string = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].string, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].enumerables;
            var itemEntity = {
                applyNegativeColor: boolean,
                applyPositiveColor: boolean,
                boldDescription: boolean,
                boldTerm: boolean,
                buttonAccessibleText: string,
                buttonHideText: string,
                buttonShowText: string,
                description: string,
                descriptionMasked: string,
                descriptionSlotName: string,
                horizontalRule: boolean,
                stacked: boolean,
                tagText: string,
                term: string,
                termSlotName: string
            };
            var entity = {
                accessibleSingleValueEmpty: string.defaultsTo("blank"),
                accessibleSingleValueNegative: string.defaultsTo("negative"),
                boldTermAll: boolean,
                boldDescriptionAll: boolean,
                descriptionAlignment: enumerables(string, "left", "right").defaultsTo("left"),
                descriptionWidth: number.defaultsTo(50),
                termWidth: number.defaultsTo(50),
                horizontalRuleAll: boolean,
                items: arrayOf(satisfies(itemEntity)).withMinLength(1).withChangedCallback(),
                mode: enumerables(string, "compact", "relaxed").defaultsTo("relaxed"),
                itemLayout: enumerables(string, "horizontal", "vertical").defaultsTo("horizontal")
            };
            var MdsDescriptionList = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsDescriptionList, _AgaveComponent);
                _createClass(MdsDescriptionList, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsDescriptionList";
                    }
                } ]);
                function MdsDescriptionList() {
                    var _this;
                    _classCallCheck(this, MdsDescriptionList);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsDescriptionList).call(this));
                    _this._handleMaskingButtonClick = _this._handleMaskingButtonClick.bind(_assertThisInitialized(_this));
                    _this._handleSlotChange = _this._handleSlotChange.bind(_assertThisInitialized(_this));
                    _this.shadowRoot.addEventListener("slotchange", _this._handleSlotChange);
                    _this.defineObservedProperty("_maskingState", []);
                    return _this;
                }
                _createClass(MdsDescriptionList, [ {
                    key: "_handleSlotChange",
                    value: function _handleSlotChange(event) {
                        var _event$target$dataset = event.target.dataset, type = _event$target$dataset.type, index = _event$target$dataset.index;
                        var slotContainer = event.target.assignedElements()[0];
                        if (slotContainer) {
                            this._enforceSlotContainerConstraints(type, slotContainer, index);
                            type === "description" && this._enforceSlottedElementConstraints(slotContainer, index);
                        }
                    }
                }, {
                    key: "_handleMaskingButtonClick",
                    value: function _handleMaskingButtonClick(event) {
                        var _this2 = this;
                        var itemIndex = parseInt(event.target.dataset.index, 10);
                        this._maskingState[itemIndex] = !this._maskingState[itemIndex];
                        this._maskingState = _toConsumableArray(this._maskingState);
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this2);
                            return "click-masking-button";
                        }.bind(this), this)(event, {
                            itemIndex: itemIndex,
                            item: this.items[itemIndex],
                            isMasked: !this._maskingState[itemIndex]
                        });
                    }
                }, {
                    key: "itemsChangedCallback",
                    value: function itemsChangedCallback(items) {
                        var _this3 = this;
                        items && items.forEach(function(item) {
                            _newArrowCheck(this, _this3);
                            if (!item.term && !item.termSlotName) {
                                this.throwConstraintError('Description List items must have either a "term" or "termSlotName" property.');
                            }
                            if ([ item.buttonShowText, item.buttonHideText ].filter(Boolean).length === 1) {
                                this.throwConstraintError('Both "buttonHideText" and "buttonShowText" are required for description masking.');
                            }
                            if (item.descriptionMasked && !item.description) {
                                this.throwConstraintError('If using "descriptionMasked", "description" must also be provided.');
                            }
                        }.bind(this));
                    }
                }, {
                    key: "_enforceSlotContainerConstraints",
                    value: function _enforceSlotContainerConstraints(type, slotContainer, slotIndex) {
                        var _this4 = this;
                        var localName = slotContainer.localName;
                        if (!MdsDescriptionList["_".concat(type, "SlotContainers")].includes(localName)) {
                            slotContainer.remove();
                            var validList = MdsDescriptionList["_".concat(type, "SlotContainers")].map(function(allowedEl) {
                                _newArrowCheck(this, _this4);
                                return "<".concat(allowedEl, ">");
                            }.bind(this)).join(" or ");
                            this.throwConstraintError("The ".concat(type, " slot's container must be a ").concat(validList, ". A <").concat(localName, "> was detected."));
                        }
                        if (type === "term") {
                            this["_termSlot".concat(slotIndex)] = localName;
                        } else if (this["_termSlot".concat(slotIndex)] && this["_termSlot".concat(slotIndex)] === localName) {
                            slotContainer.remove();
                            this.throwConstraintError("An item description cannot consist of only an mds-definition-link if the item term has an mds-definition-link.");
                        }
                    }
                }, {
                    key: "_enforceSlottedElementConstraints",
                    value: function _enforceSlottedElementConstraints(slotContainer, slotIndex) {
                        var _this5 = this;
                        var invalidElements = [];
                        var errorMessage;
                        var isLinkSlotted;
                        _toConsumableArray(slotContainer.childNodes).forEach(function(childNode, index, childNodes) {
                            _newArrowCheck(this, _this5);
                            if (MdsDescriptionList._descriptionChildLocalNames.includes(childNode.localName)) {
                                if (childNode.localName === "mds-definition-link") {
                                    if (childNode !== slotContainer.children[0]) {
                                        errorMessage = "The mds-definition-link must be the first slotted element in a description slot's container.";
                                        slotContainer.remove();
                                    } else if (this["_termSlot".concat(slotIndex)] && this["_termSlot".concat(slotIndex)] === childNode.localName && childNodes.length === 1) {
                                        errorMessage = "An item description cannot consist of only an mds-definition-link if the item term has an mds-definition-link.";
                                        slotContainer.remove();
                                    }
                                } else if (childNode.localName === "mds-link") {
                                    childNode.setAttribute("end-icon", "ico_chevron_right");
                                    isLinkSlotted = true;
                                }
                            } else if (childNode.nodeName !== "#text") {
                                invalidElements.push(childNode.localName);
                                slotContainer.remove();
                            } else if (index === childNodes.length - 1 && /\S/.test(childNode.textContent) && isLinkSlotted) {
                                errorMessage = "An mds-link in a description slot cannot have trailing text.";
                                slotContainer.remove();
                            }
                        }.bind(this));
                        if (invalidElements.length) {
                            var validList = MdsDescriptionList._descriptionChildLocalNames.map(function(localName) {
                                _newArrowCheck(this, _this5);
                                return "<".concat(localName, ">");
                            }.bind(this)).join(", ");
                            var invalidList = invalidElements.map(function(localName) {
                                _newArrowCheck(this, _this5);
                                return "<".concat(localName, ">");
                            }.bind(this)).join(", ");
                            this.throwConstraintError("Description slots only accept ".concat(validList, ". The following elements were detected in a description slot: ").concat(invalidList, "."));
                        }
                        errorMessage && this.throwConstraintError(errorMessage);
                    }
                }, {
                    key: "render",
                    value: function render() {
                        _MdsDescriptionList__WEBPACK_IMPORTED_MODULE_2__["default"].call(this);
                    }
                } ]);
                return MdsDescriptionList;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["AgaveComponent"]), _class2.styles = _mds_description_list_scss__WEBPACK_IMPORTED_MODULE_1___default.a, 
            _class2._termSlotContainers = [ "mds-definition-link" ], _class2._descriptionSlotContainers = [ "div", "mds-definition-link" ], 
            _class2._descriptionChildLocalNames = [ "mds-definition-link", "mds-link", "br" ], 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsDescriptionList;
        },
        "./src/description-list/mds-description-list.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/description-list/mds-description-list.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/dialog/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_dialog_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/dialog/mds-dialog.scss");
            var _mds_dialog_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_dialog_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _abstract_modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/abstract-modal/index.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_allowLists__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/allowLists.js");
            var _sticky_footer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/sticky-footer/index.jsx");
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _dec, _class, _class2;
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].stringRequired, number = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].number, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].boolean, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].enumerables;
            function buttonTextChangeCallback() {
                this._stickyButtons && this._createStickyButtons();
            }
            var entity = _objectSpread({
                headerText: string.withHTML(_utils_allowLists__WEBPACK_IMPORTED_MODULE_5__["base"]),
                dialogContent: string,
                dialogWidth: number,
                dialogHeight: number,
                heightType: enumerables(string, "absolute", "contentFit").defaultsTo("absolute"),
                contentHorizontalPadding: number.defaultsTo(16),
                dialogHeaderIconName: string,
                dialogFooterText: string.withHTML(_utils_allowLists__WEBPACK_IMPORTED_MODULE_5__["base"], _utils_allowLists__WEBPACK_IMPORTED_MODULE_5__["interactive"]),
                dialogHeaderIconAccessibleName: string,
                primaryButtonText: string.withChangedCallback(buttonTextChangeCallback),
                secondaryButtonOneText: string.withChangedCallback(buttonTextChangeCallback),
                secondaryButtonTwoText: string.withChangedCallback(buttonTextChangeCallback),
                buttonOrientation: enumerables(string, "vertical", "horizontal").defaultsTo("vertical"),
                headingLevel: number.defaultsTo(2),
                closeOnOverlayClick: boolean.defaultsTo(false),
                triggerId: string,
                hideHeader: boolean.defaultsTo(false)
            }, _abstract_modal__WEBPACK_IMPORTED_MODULE_3__["entity"]);
            var MdsDialog = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AbstractModal) {
                _inherits(MdsDialog, _AbstractModal);
                _createClass(MdsDialog, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsDialog";
                    }
                } ]);
                function MdsDialog() {
                    var _this;
                    _classCallCheck(this, MdsDialog);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsDialog).call(this, [ "dialogContent" ], "dialog"));
                    _this.close = _this.close.bind(_assertThisInitialized(_this));
                    _this._closeOnEsc = _this._closeOnEsc.bind(_assertThisInitialized(_this));
                    _this._addShadowOnScroll = _this._addShadowOnScroll.bind(_assertThisInitialized(_this));
                    _this.defineObservedProperty("_showTopBoxShadow", false);
                    _this.defineObservedProperty("_showBottomBoxShadow", false);
                    _this.repropagateEvent = _this.repropagateEvent.bind(_assertThisInitialized(_this));
                    _this._preventFocusChangeOnMainPanelScrollBarClick = _this._preventFocusChangeOnMainPanelScrollBarClick.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsDialog, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsDialog.prototype), "connectedCallback", this).call(this);
                        if (!this.primaryButtonText && !this.secondaryButtonOneTex && !this.secondaryButtonTwoText) {
                            console.warn("Buttons are required by the sticky footer.");
                        }
                    }
                }, {
                    key: "_focusOnRender",
                    value: function _focusOnRender() {
                        var timeoutValue = MDS.isIOS ? 400 : 300;
                        window.setTimeout(this.focus.bind(this, {
                            target: "heading"
                        }), timeoutValue);
                    }
                }, {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                            target: null
                        };
                        var targetId = "".concat(this.id, "-sticky-footer");
                        if (payload && (payload.target === "heading" || payload.target === "content")) {
                            targetId = "".concat(this.id, "-").concat(payload.target);
                        }
                        return {
                            nextPayload: payload,
                            interactiveElement: this.open && this._renderTarget.shadowRoot.getElementById(targetId)
                        };
                    }
                }, {
                    key: "_focusOnTab",
                    value: function _focusOnTab() {
                        this.focus({
                            target: "heading"
                        });
                    }
                }, {
                    key: "disconnectedCallback",
                    value: function disconnectedCallback() {
                        _get(_getPrototypeOf(MdsDialog.prototype), "disconnectedCallback", this) && _get(_getPrototypeOf(MdsDialog.prototype), "disconnectedCallback", this).call(this);
                        this._detachModal();
                    }
                }, {
                    key: "_closeOnEsc",
                    value: function _closeOnEsc(event) {
                        if (Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["isEscAndShouldClose"])(event)) {
                            this.close(event);
                        }
                    }
                }, {
                    key: "close",
                    value: function close() {
                        this.open = false;
                    }
                }, {
                    key: "_detachModal",
                    value: function _detachModal() {
                        var _this2 = this;
                        document.body.removeEventListener("keyup", this._closeOnEsc);
                        var stickyFooter = this._renderTarget.shadowRoot.querySelector("mds-sticky-footer");
                        Array.from(stickyFooter.shadowRoot.querySelectorAll("MDS-BUTTON")).forEach(function(button, i) {
                            _newArrowCheck(this, _this2);
                            stickyFooter.removeEventListener("click-button".concat(i), this.repropagateEvent);
                            button.remove();
                        }.bind(this));
                        _get(_getPrototypeOf(MdsDialog.prototype), "_detachModal", this).call(this);
                        this._showTopBoxShadow = false;
                    }
                }, {
                    key: "_attachModal",
                    value: function _attachModal() {
                        _get(_getPrototypeOf(MdsDialog.prototype), "_attachModal", this).call(this);
                        document.body.addEventListener("keyup", this._closeOnEsc);
                        var slotContainer = this._renderTarget.shadowRoot.querySelector(".mds-dialog__main");
                        this._showBottomBoxShadow = slotContainer.scrollHeight > slotContainer.clientHeight;
                        this._contentFocus = this._showBottomBoxShadow;
                        this._stickyFooter = this._renderTarget.shadowRoot.querySelector("mds-sticky-footer");
                        for (var i = 1; i <= this._numButtons; i++) {
                            this._stickyFooter.addEventListener("click-button".concat(i), this.repropagateEvent);
                        }
                    }
                }, {
                    key: "forceRerender",
                    value: function forceRerender() {
                        this._stickyFooter._forceRerender();
                    }
                }, {
                    key: "_isNodeInModal",
                    value: function _isNodeInModal(node) {
                        var slots = this._renderTarget.shadowRoot.querySelectorAll("slot");
                        for (var i = 0; i < slots.length; i++) {
                            if (node === this._renderTarget || slots[i].assignedNodes().length > 0 && slots[i].assignedNodes()[0].contains(node)) {
                                return true;
                            }
                        }
                        return false;
                    }
                }, {
                    key: "_addShadowOnScroll",
                    value: function _addShadowOnScroll(event) {
                        var _event$target = event.target, scrollTop = _event$target.scrollTop, scrollHeight = _event$target.scrollHeight, clientHeight = _event$target.clientHeight;
                        this._showTopBoxShadow = scrollTop > 0;
                        this._showBottomBoxShadow = scrollHeight - scrollTop !== clientHeight;
                    }
                }, {
                    key: "_createStickyButtons",
                    value: function _createStickyButtons() {
                        var stickyButtons = [];
                        this.primaryButtonText && stickyButtons.push({
                            text: this.primaryButtonText
                        });
                        this.secondaryButtonOneText && stickyButtons.push({
                            text: this.secondaryButtonOneText
                        });
                        this.secondaryButtonTwoText && stickyButtons.push({
                            text: this.secondaryButtonTwoText
                        });
                        this._numButtons = stickyButtons.length;
                        this._stickyButtons = JSON.stringify(stickyButtons);
                        if (this.open) {
                            this._stickyFooter = this._renderTarget.shadowRoot.querySelector("mds-sticky-footer");
                            for (var i = 1; i <= this._numButtons; i++) {
                                this._stickyFooter && this._stickyFooter.removeEventListener("click-button".concat(i), this.repropagateEvent);
                                this._stickyFooter && this._stickyFooter.addEventListener("click-button".concat(i), this.repropagateEvent);
                            }
                        }
                    }
                }, {
                    key: "_preventFocusChangeOnMainPanelScrollBarClick",
                    value: function _preventFocusChangeOnMainPanelScrollBarClick(e) {
                        if (this._isClickInMainPanel(e) && this._isClickOnScrollBar(e)) {
                            e.preventDefault();
                        }
                    }
                }, {
                    key: "_isClickInMainPanel",
                    value: function _isClickInMainPanel(e) {
                        return e.target.tagName.toLowerCase() === "div" && e.target.id === "".concat(this.id, "-content");
                    }
                }, {
                    key: "_isClickOnScrollBar",
                    value: function _isClickOnScrollBar(e) {
                        var rect = e.target.getBoundingClientRect();
                        var x = e.clientX - rect.left;
                        return e.target.clientWidth <= x && x < rect.width;
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var _headerClasses, _headingClasses;
                        var headerText = this.headerText, dialogContent = this.dialogContent, dialogHeaderIconName = this.dialogHeaderIconName, dialogFooterText = this.dialogFooterText, dialogHeaderIconAccessibleName = this.dialogHeaderIconAccessibleName, id = this.id, dialogWidth = this.dialogWidth, dialogHeight = this.dialogHeight, contentHorizontalPadding = this.contentHorizontalPadding, _showBottomBoxShadow = this._showBottomBoxShadow, _showTopBoxShadow = this._showTopBoxShadow, _contentFocus = this._contentFocus, headingLevel = this.headingLevel, closeOnOverlayClick = this.closeOnOverlayClick, buttonOrientation = this.buttonOrientation, hideHeader = this.hideHeader;
                        var rootClass = "mds-dialog";
                        var headerClasses = (_headerClasses = {}, _defineProperty(_headerClasses, "".concat(rootClass, "__header-container"), true), 
                        _defineProperty(_headerClasses, "".concat(rootClass, "__header-container--scrolled"), _showTopBoxShadow), 
                        _defineProperty(_headerClasses, "".concat(rootClass, "__header-container--hidden"), hideHeader), 
                        _headerClasses);
                        var headingClasses = (_headingClasses = {}, _defineProperty(_headingClasses, "".concat(rootClass, "__heading"), true), 
                        _defineProperty(_headingClasses, "".concat(rootClass, "__heading--hidden"), hideHeader), 
                        _headingClasses);
                        var dialogStyles = {};
                        if (!MDS.isMobile) {
                            if (dialogWidth) {
                                dialogStyles["max-width"] = "".concat(dialogWidth, "px");
                            }
                            if (dialogHeight && this.heightType === "absolute") {
                                dialogStyles.height = "".concat(dialogHeight, "px");
                            }
                        }
                        if (!this._stickyButtons) {
                            this._createStickyButtons();
                        }
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", rootClass);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "".concat(rootClass, "__backdrop"));
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["conditionalAttribute"])({
                            onclick: this.close
                        }, closeOnOverlayClick));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "id", "dialog-panel-container", "class", "".concat(rootClass, "__panel-container"), "role", "dialog", "aria-labelledby", "".concat(id, "-heading"), "style", dialogStyles);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", headerClasses);
                        _renderArbitrary(dialogHeaderIconName && !hideHeader && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "".concat(rootClass, "__icon"), "innerHTML-prop", MDS.svgs[dialogHeaderIconName], "aria-hidden", "true", "__skip", "true"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "id", "".concat(id, "-heading"), "tabIndex", "0", "role", "heading", "aria-level", headingLevel, "class", "".concat(rootClass, "__title-container"));
                        _renderArbitrary(!hideHeader && !!dialogHeaderIconAccessibleName && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text"), 
                        _renderArbitrary(dialogHeaderIconAccessibleName), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", headingClasses, "innerHTML-prop", headerText, "__skip", "true");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "".concat(id, "-content"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "".concat(rootClass, "__main"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onscroll", this._addShadowOnScroll);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onmousedown", this._preventFocusChangeOnMainPanelScrollBarClick);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["conditionalAttribute"])({
                            tabindex: 0
                        }, _contentFocus));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                        _renderArbitrary(dialogContent);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "name", "dialogContent");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-sticky-footer", null, null, "class", "".concat(rootClass, "__sticky-footer"), "id", "".concat(id, "-sticky-footer"), "sticky-footer-buttons", this._stickyButtons, "show-box-shadow", _showBottomBoxShadow, "horizontal-layout", buttonOrientation === "horizontal", "footer-text", dialogFooterText);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return MdsDialog;
            }(_abstract_modal__WEBPACK_IMPORTED_MODULE_3__["default"]), _class2.styles = _mds_dialog_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsDialog;
        },
        "./src/dialog/mds-dialog.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/dialog/mds-dialog.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/document-viewer/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_document_viewer_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/document-viewer/mds-document-viewer.scss");
            var _mds_document_viewer_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_document_viewer_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _dec, _class, _class2;
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var arrayOf = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].arrayOf, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].boolean, string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].stringRequired, number = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].number, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].enumerables;
            var entity = {
                viewerAccessibleName: stringRequired,
                viewerHeight: number.defaultsTo(300),
                htmlEncoded: boolean.defaultsTo(false),
                bytearray: boolean.defaultsTo(false),
                componentTitle: stringRequired,
                content: string,
                contentType: enumerables(stringRequired, "html", "pdf"),
                hideTitle: boolean.defaultsTo(false),
                headingLevel: number.defaultsTo(2),
                description: string,
                actionButtonText: string,
                actionButtonAccessibleText: string,
                actionButtonIcon: enumerables(string, "download", "print"),
                languages: arrayOf(string).withMinLength(2).withMaxLength(2),
                selectedTab: number.defaultsTo(0).withMinSize(0).withMaxSize(1).withChangedCallback()
            };
            var MdsDocumentViewer = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsDocumentViewer, _AgaveComponent);
                _createClass(MdsDocumentViewer, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsDocumentViewer";
                    }
                } ]);
                function MdsDocumentViewer() {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsDocumentViewer);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsDocumentViewer).call(this));
                    _this.blobRefs = {};
                    _this._printHTML = _this._printHTML.bind(_assertThisInitialized(_this));
                    _this._fillIFrame = _this._fillIFrame.bind(_assertThisInitialized(_this));
                    _this.addEventListener("click-tab1", function(e) {
                        _newArrowCheck(this, _this2);
                        e.target.selectedTab = 0;
                    }.bind(this));
                    _this.addEventListener("click-tab2", function(e) {
                        _newArrowCheck(this, _this2);
                        e.target.selectedTab = 1;
                    }.bind(this));
                    return _this;
                }
                _createClass(MdsDocumentViewer, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsDocumentViewer.prototype), "connectedCallback", this).call(this);
                        this._connected = true;
                        if (!this.viewerAccessibleName) {
                            this.throwConstraintError("viewerAccessibleName is required.");
                        }
                        if (this.actionButtonIcon && !this.actionButtonAccessibleText && !this.actionButtonText) {
                            this.throwConstraintError("Either actionButtonAccessibleText or actionButtonText is required if actionButtonIcon is provided.");
                        }
                        if (this.contentType === "pdf" && this.viewerHeight < 300) {
                            this.throwConstraintError("The viewer frame height (viewerHeight) should be at minimum 300px to account for the toolbar" + "with action buttons to appear in the Chrome browser PDF viewer.");
                        }
                    }
                }, {
                    key: "disconnectedCallback",
                    value: function disconnectedCallback() {
                        var _this3 = this;
                        _get(_getPrototypeOf(MdsDocumentViewer.prototype), "disconnectedCallback", this) && _get(_getPrototypeOf(MdsDocumentViewer.prototype), "disconnectedCallback", this).call(this);
                        if (this.bytearray) {
                            Object.values(this.blobRefs).forEach(function(blobRef) {
                                _newArrowCheck(this, _this3);
                                return URL.revokeObjectURL(blobRef);
                            }.bind(this));
                        }
                    }
                }, {
                    key: "selectedTabChangedCallback",
                    value: function selectedTabChangedCallback() {
                        if (this._connected) {
                            this.shadowRoot.querySelector("mds-tab-bar").selectedTab = this.selectedTab;
                        }
                    }
                }, {
                    key: "_printHTML",
                    value: function _printHTML(e) {
                        e.stopPropagation();
                        this.dispatchEvent(new CustomEvent("click-action-button", {
                            detail: e.detail,
                            bubbles: true,
                            composed: true,
                            cancelable: true
                        }));
                        var viewer = this.shadowRoot.getElementById("i-frame-".concat(this.selectedTab));
                        viewer.contentWindow.print();
                    }
                }, {
                    key: "_renderIFrame",
                    value: function _renderIFrame(iFrameNumber, slot) {
                        var frameHeight = "height: ".concat(this.viewerHeight, "px");
                        var frameID = "i-frame-".concat(iFrameNumber);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("iframe");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", frameID);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                            slot: slot
                        }, slot));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "document-viewer__iframe");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("style", frameHeight);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("tabIndex", "0");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("title", this.viewerAccessibleName);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                            type: "application/x-pdf",
                            toolbar: 1
                        }, this.contentType === "pdf"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("iframe");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("iframe");
                    }
                }, {
                    key: "decodeHTML",
                    value: function decodeHTML(htmlString) {
                        var temporaryTextArea = document.createElement("textarea");
                        temporaryTextArea.innerHTML = htmlString;
                        return temporaryTextArea.value;
                    }
                }, {
                    key: "_base64toBlob",
                    value: function _base64toBlob(base64Data) {
                        var byteCharacters = atob(base64Data);
                        var byteNumbers = [];
                        for (var i = 0; i < byteCharacters.length; i += 1) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        return new Blob([ new Uint8Array(byteNumbers) ], {
                            type: "application/pdf"
                        });
                    }
                }, {
                    key: "_fillIFrame",
                    value: function _fillIFrame() {
                        var viewerID = this.languages ? "i-frame-".concat(this.selectedTab) : "i-frame-0";
                        var viewer = this.shadowRoot.getElementById(viewerID);
                        if (this.contentType === "pdf") {
                            if (this.bytearray) {
                                if (!this.blobRefs[this.content]) {
                                    this.blobRefs[this.content] = URL.createObjectURL(this._base64toBlob(this.content));
                                }
                                viewer.src = this.blobRefs[this.content];
                            } else {
                                viewer.src = this.content;
                            }
                        } else {
                            var contentWindow = viewer.contentWindow;
                            var _document = contentWindow.document;
                            _document.open();
                            if (this.htmlEncoded && this.contentType === "html") {
                                _document.write(this.decodeHTML(this.content));
                            } else {
                                _document.write(this.content);
                            }
                            _document.close();
                        }
                    }
                }, {
                    key: "renderedCallback",
                    value: function renderedCallback() {
                        this._fillIFrame();
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var titleClasses = {
                            "document-viewer__title": true,
                            "document-viewer__title--hidden": this.hideTitle
                        };
                        var languageTabs = this.languages ? '[{"text":"'.concat(this.languages[0], '"}, {"text": "').concat(this.languages[1], '"}]') : "";
                        var actionIcon = this.actionButtonIcon === "download" ? "ico_download" : "ico_printer";
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "document-viewer");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", titleClasses, "aria-level", this.headingLevel, "role", "heading");
                        _renderArbitrary(this.componentTitle);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "document-viewer__description");
                        _renderArbitrary(this.description);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        _renderArbitrary(this.contentType === "html" && (this.actionButtonText || this.actionButtonIcon) && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("mds-button"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "document-viewer__button"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("variant", "tertiary"), 
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                            "icon-type": actionIcon
                        }, this.actionButtonIcon)), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("icon-position", this.actionButtonText ? "trailing" : "icon_only"), 
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                            text: this.actionButtonText
                        }, this.actionButtonText)), _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                            "accessible-text": this.actionButtonAccessibleText
                        }, this.actionButtonAccessibleText)), _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                            onclick: this._printHTML
                        }, this.contentType === "html")), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("mds-button"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-button")));
                        _renderArbitrary(!this.languages && (this.actionButtonIcon || this.actionButtonText) && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "document-viewer__empty-tab-bar", "aria-hidden", "true"));
                        _renderArbitrary(this.languages && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("mds-tab-bar"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "document-viewer__tab-bar"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("selected-tab", this.selectedTab), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("indicator-position", "top"), 
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                            tabs: languageTabs
                        }, !!this.languages)), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("mds-tab-bar"), 
                        _renderArbitrary(this._renderIFrame(0, "panel-0")), _renderArbitrary(this._renderIFrame(1, "panel-1")), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-tab-bar")));
                        _renderArbitrary(!this.languages && this._renderIFrame(0));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return MdsDocumentViewer;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_document_viewer_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsDocumentViewer;
        },
        "./src/document-viewer/mds-document-viewer.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/document-viewer/mds-document-viewer.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/drop-zone/MdsDropZone.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function DropZoneTemplate() {
                var _this = this;
                var exceedsMaxNumberOfFiles = this.displayedFiles && this.displayedFiles.filter(function(file) {
                    _newArrowCheck(this, _this);
                    return !file.error;
                }.bind(this)).length >= this._getMaxNumberOfFiles();
                var dropZoneClasses = {
                    "drop-zone": true,
                    "drop-zone--disabled": this.inactive || exceedsMaxNumberOfFiles,
                    "drop-zone--drag": this._state !== "default"
                };
                var uploadButtonClasses = {
                    "drop-zone__button": true,
                    "drop-zone__button--drag": this._state !== "default"
                };
                var dropZoneAccessibleText = [ " ", this.label, this.microcopy[0], this.microcopy[1] ].filter(Boolean).join(", ");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", dropZoneClasses);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    style: {
                        width: this.containerWidth
                    }
                }, this.containerWidth));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "drop-zone__label");
                _renderArbitrary(this.label);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "drop-zone__border");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "drop-zone__input-wrapper");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("input", null, null, "id", "".concat(this.id, "-input"), "class", "drop-zone__input", "name", this.name, "accept", this.fileTypes.join(", "), "type", "file", "multiple", "true", "onchange", this._handleInputChange, "ondragenter", this._handleDragEnter, "ondragleave", this._handleDragLeave, "ondrop", this._handleDrop, "disabled-prop", this.inactive, "aria-label", this.uploadFileButtonText || this.uploadButtonText, "tabindex", "-1", "aria-hidden", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-button", null, null, "class", uploadButtonClasses, "text", this.uploadFileButtonText || this.uploadButtonText, "icon-position", "leading", "icon-type", "ico_upload", "variant", "tertiary", "small", "true", "accessible-text", dropZoneAccessibleText, "id", "drop-zone__button-".concat(this.id), "inactive", this.inactive);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "drop-zone__microcopy");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "id", "".concat(this.id, "-microcopy-text"), "class", "drop-zone__microcopy-text");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("p", null, null, "class", "drop-zone__microcopy-key");
                _renderArbitrary(this.microcopy[0]);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("p");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("p", null, null, "class", "drop-zone__microcopy-value");
                _renderArbitrary(this.microcopy[1]);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("p");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            __webpack_exports__["default"] = DropZoneTemplate;
        },
        "./src/drop-zone/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_drop_zone_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/drop-zone/mds-drop-zone.scss");
            var _mds_drop_zone_scss__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_drop_zone_scss__WEBPACK_IMPORTED_MODULE_1__);
            var _MdsDropZone__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/drop-zone/MdsDropZone.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].boolean, string = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].stringRequired, arrayOf = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].arrayOf, number = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].number;
            var entity = {
                label: stringRequired,
                fileTypes: arrayOf(string),
                microcopy: arrayOf(string),
                inactive: boolean,
                uploadButtonText: stringRequired,
                uploadFileButtonText: stringRequired,
                maxFileSize: number.withChangedCallback(),
                maxFileSizeErrorMessage: string.defaultsTo("File size exceeds"),
                maxNumberOfFiles: number,
                maxNumberOfFilesErrorMessage: string,
                name: string,
                containerWidth: string.withChangedCallback()
            };
            var MdsDropZone = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsDropZone, _AgaveComponent);
                _createClass(MdsDropZone, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsDropZone";
                    }
                } ]);
                function MdsDropZone() {
                    var _this;
                    _classCallCheck(this, MdsDropZone);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsDropZone).call(this));
                    _this._handleDragEnter = _this._handleDragEnter.bind(_assertThisInitialized(_this));
                    _this._handleDragLeave = _this._handleDragLeave.bind(_assertThisInitialized(_this));
                    _this._handleDrop = _this._handleDrop.bind(_assertThisInitialized(_this));
                    _this._handleInputChange = _this._handleInputChange.bind(_assertThisInitialized(_this));
                    _this._uploadButtonClickEvent = _this._uploadButtonClickEvent.bind(_assertThisInitialized(_this));
                    _this.defineObservedProperty("selectedFiles", []);
                    _this.defineObservedProperty("_state", "default");
                    _this.defineObservedProperty("displayedFiles", []);
                    _this.defineObservedProperty("_isLoading", false);
                    _this.defineObservedProperty("_ariaLiveActive", false);
                    _this._readers = [];
                    _this._isMobileXsScreen = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["getBreakpoint"])() === "xs" && MDS.isMobile;
                    return _this;
                }
                _createClass(MdsDropZone, [ {
                    key: "_setUploadButtonClickHandler",
                    value: function _setUploadButtonClickHandler() {
                        this._inputNode = this.shadowRoot.querySelector("input");
                        this._uploadButton = this.shadowRoot.getElementById("drop-zone__button-".concat(this.id));
                        this._uploadButton.addEventListener("click", this._uploadButtonClickEvent);
                    }
                }, {
                    key: "_uploadButtonClickEvent",
                    value: function _uploadButtonClickEvent(event) {
                        event.stopImmediatePropagation();
                        this._inputNode.click();
                    }
                }, {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsDropZone.prototype), "connectedCallback", this).call(this);
                        this._setUploadButtonClickHandler();
                    }
                }, {
                    key: "containerWidthChangedCallback",
                    value: function containerWidthChangedCallback() {
                        var cw = this.containerWidth;
                        var suffix = this.containerWidth.substring(cw.length - 2, cw.length);
                        var number = parseInt(cw, 10);
                        if (suffix === "px" && number < 280) {
                            throw new Error("container's width should be 280px or greater");
                        }
                    }
                }, {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        return {
                            interactiveElement: this.shadowRoot.getElementById("".concat(this.id, "-input"))
                        };
                    }
                }, {
                    key: "_getMaxNumberOfFiles",
                    value: function _getMaxNumberOfFiles() {
                        return typeof this.maxNumberOfFiles === "number" ? this.maxNumberOfFiles : Number.POSITIVE_INFINITY;
                    }
                }, {
                    key: "_handleDragEnter",
                    value: function _handleDragEnter(event) {
                        var _this2 = this;
                        this._fileCount = this.displayedFiles ? this.displayedFiles.filter(function(file) {
                            _newArrowCheck(this, _this2);
                            return !file.error;
                        }.bind(this)).length + event.dataTransfer.items.length : 0;
                        var allItemsAreValid = Array.from(event.dataTransfer.items).every(function(item) {
                            _newArrowCheck(this, _this2);
                            return this.fileTypes.includes(item.type);
                        }.bind(this)) && this._fileCount <= this._getMaxNumberOfFiles();
                        this._state = allItemsAreValid ? "valid" : "error";
                        var eventName = allItemsAreValid ? "valid" : "invalid";
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this2);
                            return eventName;
                        }.bind(this), this)(event);
                    }
                }, {
                    key: "_handleDragLeave",
                    value: function _handleDragLeave() {
                        this._state = "default";
                    }
                }, {
                    key: "_handleDrop",
                    value: function _handleDrop(event) {
                        event.preventDefault();
                        this._readFiles(event);
                        _get(_getPrototypeOf(MdsDropZone.prototype), "_ondrop", this) && _get(_getPrototypeOf(MdsDropZone.prototype), "_ondrop", this).call(this, event);
                    }
                }, {
                    key: "_handleInputChange",
                    value: function _handleInputChange(event) {
                        event.target.files.length && this._readFiles(event);
                    }
                }, {
                    key: "_readFiles",
                    value: function _readFiles(event) {
                        var _this3 = this;
                        var newFiles = event.type === "drop" ? event.dataTransfer.files : event.target.files;
                        this._fileCount = this.displayedFiles ? this.displayedFiles.filter(function(file) {
                            _newArrowCheck(this, _this3);
                            return !file.error;
                        }.bind(this)).length + newFiles.length : 0;
                        if (this._fileCount > this._getMaxNumberOfFiles()) {
                            var detail = _extends({
                                "error message": this.maxNumberOfFilesErrorMessage
                            }, newFiles);
                            Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                                _newArrowCheck(this, _this3);
                                return "error";
                            }.bind(this), this)(event, detail);
                            this._state = "default";
                            this._inputNode.value = "";
                            return;
                        }
                        var typeValidFiles = Array.from(newFiles).filter(function(file) {
                            _newArrowCheck(this, _this3);
                            var type = file.type;
                            if (!type || type.length === 0) {
                                type = ".".concat(file.name.split(".").pop());
                            }
                            return this.fileTypes.includes(type);
                        }.bind(this)).map(function(file) {
                            _newArrowCheck(this, _this3);
                            if (this.maxFileSize && file.size > this._maxBytes) {
                                file.error = true;
                                file.message = "".concat(this.maxFileSizeErrorMessage, " ").concat(this.maxFileSize, "MB");
                            } else {
                                file.isLoading = true;
                            }
                            return file;
                        }.bind(this));
                        var sizeValidFiles = typeValidFiles.filter(function(file) {
                            _newArrowCheck(this, _this3);
                            return !file.error;
                        }.bind(this));
                        this.displayedFiles = [].concat(_toConsumableArray(this.displayedFiles), _toConsumableArray(typeValidFiles));
                        var sizeUnvalidFiles = typeValidFiles.filter(function(file) {
                            _newArrowCheck(this, _this3);
                            return file.error;
                        }.bind(this));
                        sizeUnvalidFiles.forEach(function(file) {
                            var _this4 = this;
                            _newArrowCheck(this, _this3);
                            var detail = {
                                name: file.name,
                                message: file.message
                            };
                            Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                                _newArrowCheck(this, _this4);
                                return "error";
                            }.bind(this), this)(event, detail);
                        }.bind(this));
                        this._state = "valid";
                        Promise.all(sizeValidFiles.map(function(file, i) {
                            var _this5 = this;
                            _newArrowCheck(this, _this3);
                            return new Promise(function(resolve) {
                                var _this6 = this;
                                _newArrowCheck(this, _this5);
                                var reader = new FileReader;
                                var customEvent = new CustomEvent("custom-validate", {
                                    detail: file,
                                    bubbles: true,
                                    composed: true
                                });
                                this.dispatchEvent(customEvent);
                                file = customEvent.detail;
                                reader.onprogress = function(progressEvent) {
                                    var _this7 = this;
                                    _newArrowCheck(this, _this6);
                                    this._isLoading = true;
                                    Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                                        _newArrowCheck(this, _this7);
                                        return "progress";
                                    }.bind(this), this)(event, progressEvent);
                                }.bind(this);
                                reader.onload = function() {
                                    var _this8 = this;
                                    _newArrowCheck(this, _this6);
                                    file.contents = reader.result;
                                    setTimeout(function() {
                                        _newArrowCheck(this, _this8);
                                        file.isLoading = false;
                                        this._isLoading = false;
                                        this.selectedFiles.push(file);
                                        resolve(file);
                                    }.bind(this), 350);
                                }.bind(this);
                                reader.onerror = function() {
                                    _newArrowCheck(this, _this6);
                                    file.isLoading = false;
                                    file.error = true;
                                    this._isLoading = false;
                                    resolve();
                                }.bind(this);
                                reader.onabort = function() {
                                    _newArrowCheck(this, _this6);
                                    this._isLoading = false;
                                    resolve();
                                }.bind(this);
                                this._readers.push(reader);
                                reader.readAsArrayBuffer(file);
                            }.bind(this));
                        }.bind(this))).then(function(addedFiles) {
                            var _this9 = this;
                            _newArrowCheck(this, _this3);
                            this._state = "default";
                            this._inputNode.value = "";
                            Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                                _newArrowCheck(this, _this9);
                                return "change";
                            }.bind(this), this)(event, {
                                addedFiles: addedFiles
                            });
                        }.bind(this));
                    }
                }, {
                    key: "maxFileSizeChangedCallback",
                    value: function maxFileSizeChangedCallback(maxFileSize) {
                        this._maxBytes = maxFileSize * 1e6;
                    }
                }, {
                    key: "deleteFile",
                    value: function deleteFile(index) {
                        if (index === undefined) {
                            throw new Error("The deleteFile method's first argument must be the index of a file from selectedFiles.");
                        }
                        this.displayedFiles.splice(index, 1);
                        this._readers.splice(index, 1);
                        this._isLoading ? this.addEventListener("change", this._setSelectedFromValidDisplayed) : this._setSelectedFromValidDisplayed();
                    }
                }, {
                    key: "deleteAllFiles",
                    value: function deleteAllFiles() {
                        while (this.displayedFiles.length) {
                            this.deleteFile(0);
                        }
                    }
                }, {
                    key: "_setSelectedFromValidDisplayed",
                    value: function _setSelectedFromValidDisplayed() {
                        var _this10 = this;
                        this.selectedFiles = this.displayedFiles.filter(function(file) {
                            _newArrowCheck(this, _this10);
                            return !file.error;
                        }.bind(this));
                        this.removeEventListener("change", this._setSelectedFromValidDisplayed);
                    }
                }, {
                    key: "render",
                    value: function render() {
                        if (typeof this.maxNumberOfFiles === "number" && !this.maxNumberOfFilesErrorMessage) {
                            this.throwConstraintError("maxNumberOfFilesErrorMessage must be set when maxNumberOfFiles is a number.");
                        }
                        if (this.uploadButtonText) {
                            console.warn("Propery uploadButtonText is deprecated, please use 'uploadFileButtonText' property");
                        }
                        _MdsDropZone__WEBPACK_IMPORTED_MODULE_2__["default"].call(this);
                    }
                } ]);
                return MdsDropZone;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_0___default.a), _class2.styles = _mds_drop_zone_scss__WEBPACK_IMPORTED_MODULE_1___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsDropZone;
        },
        "./src/drop-zone/mds-drop-zone.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/drop-zone/mds-drop-zone.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/expandable-text/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/common-utils.js");
            var _mds_expandable_text_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/expandable-text/mds-expandable-text.scss");
            var _mds_expandable_text_scss__WEBPACK_IMPORTED_MODULE_3___default = __webpack_require__.n(_mds_expandable_text_scss__WEBPACK_IMPORTED_MODULE_3__);
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["mixins"].AttributeMarshallingMixin, string = _mixins$AttributeMars.string, stringRequired = _mixins$AttributeMars.stringRequired, enumerables = _mixins$AttributeMars.enumerables, boolean = _mixins$AttributeMars.boolean;
            var entity = {
                leadingTextContent: string,
                label: stringRequired,
                name: string.defaultsTo("expandable-text"),
                textColor: enumerables(string, "textColorLink", "textColorRegular").defaultsTo("textColorLink"),
                inactive: boolean.defaultsTo(false)
            };
            var MdsExpandableText = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsExpandableText, _AgaveComponent);
                _createClass(MdsExpandableText, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsExpandableText";
                    }
                } ]);
                function MdsExpandableText() {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsExpandableText);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsExpandableText).call(this));
                    _this._onclick = _this._onclick.bind(_assertThisInitialized(_this));
                    _this.expand = _this.expand.bind(_assertThisInitialized(_this));
                    _this.collapse = _this.collapse.bind(_assertThisInitialized(_this));
                    _this._calculatePanelHeight = _this._calculatePanelHeight.bind(_assertThisInitialized(_this));
                    _this._renderExpandableTextLabel = _this._renderExpandableTextLabel.bind(_assertThisInitialized(_this));
                    _this.defineObservedProperty("_expanded", false);
                    _this.defineObservedProperty("_expanding", false);
                    _this.defineObservedProperty("_collapsing", false);
                    _this.defineObservedProperty("_transitioned", false);
                    _this._dispatchCollapseEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "click-collapse";
                    }.bind(this), _assertThisInitialized(_this));
                    _this._dispatchExpandEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "click-expand";
                    }.bind(this), _assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsExpandableText, [ {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        return {
                            interactiveElement: this.shadowRoot.querySelector(".expandable-text-button")
                        };
                    }
                }, {
                    key: "expand",
                    value: function expand(event) {
                        var _this3 = this;
                        var panelHeight = this._calculatePanelHeight();
                        this._expanded = true;
                        this.shadowRoot.querySelector(".expandable-text-revealed-content-container").style.display = this._expanded ? "block" : "none";
                        this.shadowRoot.querySelector(".expandable-text-revealed-content-container").style.height = 0;
                        window.setTimeout(function() {
                            _newArrowCheck(this, _this3);
                            this._expanding = true;
                            this.shadowRoot.querySelector(".expandable-text-revealed-content-container").style.height = "".concat(panelHeight, "px");
                        }.bind(this), 10);
                        window.setTimeout(function() {
                            _newArrowCheck(this, _this3);
                            this._expanding = false;
                            this._transitioned = true;
                            this.shadowRoot.querySelector(".expandable-text-revealed-content-container").style.height = "auto";
                            this.shadowRoot.querySelector(".expandable-text-revealed-content-container").style.overflow = "unset";
                            event && this._dispatchExpandEvent(event);
                        }.bind(this), 200);
                    }
                }, {
                    key: "collapse",
                    value: function collapse(event) {
                        var _this4 = this;
                        var panelHeight = this.shadowRoot.querySelector(".expandable-text-revealed-content-container").scrollHeight;
                        this._expanded = false;
                        this.shadowRoot.querySelector(".expandable-text-revealed-content-container").style.height = "".concat(panelHeight, "px");
                        window.setTimeout(function() {
                            _newArrowCheck(this, _this4);
                            this._collapsing = true;
                            this.shadowRoot.querySelector(".expandable-text-revealed-content-container").style.height = 0;
                        }.bind(this), 10);
                        window.setTimeout(function() {
                            _newArrowCheck(this, _this4);
                            this._collapsing = false;
                            this._transitioned = false;
                            this.shadowRoot.querySelector(".expandable-text-revealed-content-container").style.height = "auto";
                            this.shadowRoot.querySelector(".expandable-text-revealed-content-container").style.display = this._expanded ? "block" : "none";
                            event && this._dispatchCollapseEvent(event);
                        }.bind(this), 200);
                    }
                }, {
                    key: "_calculatePanelHeight",
                    value: function _calculatePanelHeight() {
                        var content = this.shadowRoot.querySelector(".expandable-text-revealed-content-container");
                        var contentWidth = "".concat(this.shadowRoot.querySelector(".expandable-text-container").scrollWidth, "px");
                        _extends(content.style, {
                            visibility: "hidden",
                            display: "flex",
                            position: "absolute",
                            width: contentWidth
                        });
                        var height = content.scrollHeight;
                        _extends(content.style, {
                            visibility: "",
                            display: "",
                            position: "",
                            width: "auto"
                        });
                        return height;
                    }
                }, {
                    key: "_onclick",
                    value: function _onclick(event) {
                        var _this5 = this;
                        if (!this.inactive) {
                            this._expanded = !this._expanded;
                            this._expanded ? this.expand(event) : this.collapse(event);
                            event.stopPropagation();
                            Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["createCustomEventDispatcher"])(function() {
                                _newArrowCheck(this, _this5);
                                return "click";
                            }.bind(this), this)(event, _extends({}, event.detail, {
                                expanded: this._expanded
                            }));
                        }
                    }
                }, {
                    key: "_renderExpandableTextLabel",
                    value: function _renderExpandableTextLabel() {
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "expandable-text-label");
                        _renderArbitrary(this.label);
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var leadingTextContent = this.leadingTextContent, label = this.label, _expanded = this._expanded, _expanding = this._expanding, _transitioned = this._transitioned, _collapsing = this._collapsing, inactive = this.inactive, textColor = this.textColor;
                        var buttonClasses = {
                            "expandable-text-button": true,
                            "expandable-text-label--button": _expanded,
                            "expandable-text-button--disabled": !!inactive,
                            "expandable-text-button--regular": textColor === "textColorRegular"
                        };
                        var contentClasses = {
                            "expandable-text-revealed-content-container": true,
                            "expandable-text-revealed-content-container--expanded": _expanded,
                            "expandable-text-revealed-content-container--expanding": _expanding,
                            "expandable-text-revealed-content-container--collapsing": _transitioned && _collapsing,
                            "expandable-text-revealed-content-container--transitioned": _transitioned
                        };
                        var iconClasses = {
                            "expandable-text-icon": true,
                            "expandable-text-icon--expanded": _expanded
                        };
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "expandable-text");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "expandable-text-container");
                        _renderArbitrary(leadingTextContent && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "expandable-text-leading-text-content"), 
                        _renderArbitrary(leadingTextContent), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("button", null, null, "class", buttonClasses, "onclick", this._onclick, "aria-expanded", _expanded, "disabled-prop", !!inactive, "aria-disabled", !!inactive);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", iconClasses, "innerHTML-prop", MDS.svgs["ico_caret_right"], "aria-hidden", "true", "__skip", "true");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        _renderArbitrary(this._renderExpandableTextLabel());
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("button");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", contentClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "expandable-text-revealed-content-slot");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "name", this.name);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return MdsExpandableText;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["AgaveComponent"]), _class2.styles = _mds_expandable_text_scss__WEBPACK_IMPORTED_MODULE_3___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsExpandableText;
        },
        "./src/expandable-text/mds-expandable-text.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/expandable-text/mds-expandable-text.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/fieldset/MdsFieldset.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", (function() {
                return FieldsetTemplate;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function renderErrorMessages() {
                var _this = this;
                var errorMessageClasses = _defineProperty({
                    "fieldset__error-message": true
                }, "fieldset__error-message--".concat(this.labelAlignment), this.layout === "horizontal");
                return !!this.errorMessages.length && this.errorMessages.map(function(errorMessage, i) {
                    _newArrowCheck(this, _this);
                    return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-error-message", null, null, "class", errorMessageClasses, "variant", "error", "size", "small", "alert-title", errorMessage, "hide-icon", i !== 0, "accessible-text-icon", "_", "aria-hidden", "true");
                }.bind(this));
            }
            function FieldsetTemplate() {
                var _legendClasses, _labelClasses, _inputWrapClasses, _this2 = this;
                var fieldsetWrapClasses = {
                    fieldset: true,
                    "mds-row": this.layout === "horizontal"
                };
                var legendClasses = (_legendClasses = {
                    fieldset__legend: true
                }, _defineProperty(_legendClasses, "fieldset__legend--".concat(this.layout), true), 
                _defineProperty(_legendClasses, "fieldset__legend--".concat(this.labelAlignment), this.layout === "horizontal"), 
                _defineProperty(_legendClasses, "".concat(this.labelColumns || "mds-col-3"), this.layout === "horizontal"), 
                _defineProperty(_legendClasses, "fieldset__legend--".concat(this.layout, "--").concat(this.labelSize), true), 
                _legendClasses);
                var labelClasses = (_labelClasses = {
                    "fieldset__legend-label": true
                }, _defineProperty(_labelClasses, "fieldset__legend-label--".concat(this.layout), true), 
                _defineProperty(_labelClasses, "fieldset__legend-label--error", this.errorMessages.length), 
                _defineProperty(_labelClasses, "fieldset__legend-label--".concat(this.layout, "--").concat(this.labelSize), true), 
                _defineProperty(_labelClasses, "fieldset__legend-label--error--".concat(this.layout, "--").concat(this.labelSize), this.errorMessages.length && this.labelSize === "regular"), 
                _labelClasses);
                var inputWrapClasses = (_inputWrapClasses = {}, _defineProperty(_inputWrapClasses, "fieldset__content-container fieldset__content-container--".concat(this.layout), true), 
                _defineProperty(_inputWrapClasses, "".concat(this.inputColumns || "mds-col-9"), this.layout === "horizontal"), 
                _inputWrapClasses);
                var microcopyClasses = _defineProperty({
                    "fieldset__legend-microcopy": true
                }, "fieldset__legend-microcopy--".concat(this.layout, "--").concat(this.labelSize), this.labelSize === "prominent");
                if (this.layout === "horizontal" && this.labelSize !== "regular") {
                    console.error("Horizontal layout size must be used with regular label size.");
                }
                var errorMessageString = this.errorMessages.map(function(message) {
                    _newArrowCheck(this, _this2);
                    return "".concat(this.errorMessagePrefixAccessibleText, " ").concat(message);
                }.bind(this)).join(", ");
                var legendInnerText = [ this.legendText, this.microcopy, errorMessageString ].filter(Boolean).join(", ");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("fieldset", null, null, "class", fieldsetWrapClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("legend", null, null, "class", legendClasses, "tabindex", "-1", "id", "legend-inner-text");
                _renderArbitrary(renderErrorMessages.call(this));
                _renderArbitrary(!this.hideLegend && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", labelClasses, "aria-hidden", "true"), 
                _renderArbitrary(this.legendText), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                _renderArbitrary(this.microcopy && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", microcopyClasses, "aria-hidden", "true"), 
                _renderArbitrary(this.microcopy), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "fieldset__accessible-text");
                _renderArbitrary(legendInnerText);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("legend");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", inputWrapClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("fieldset");
            }
        },
        "./src/fieldset/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_fieldset_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/fieldset/mds-fieldset.scss");
            var _mds_fieldset_scss__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_fieldset_scss__WEBPACK_IMPORTED_MODULE_1__);
            var _MdsFieldset__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/fieldset/MdsFieldset.jsx");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var arrayOf = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].arrayOf, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].boolean, string = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].stringRequired, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].enumerables;
            var entity = {
                errorMessages: arrayOf(string).defaultsTo([]),
                errorMessagePrefixAccessibleText: string.defaultsTo("Error:"),
                focusOnError: boolean.defaultsTo(false),
                hideLegend: boolean.defaultsTo(false),
                labelAlignment: enumerables(string, "left", "right").defaultsTo("left"),
                layout: enumerables(string, "horizontal", "vertical").defaultsTo("vertical"),
                legendText: stringRequired,
                microcopy: string,
                labelSize: enumerables(string, "regular", "medium", "prominent").defaultsTo("regular"),
                labelColumns: string.defaultsTo(""),
                inputColumns: string.defaultsTo("")
            };
            var MdsFieldset = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsFieldset, _AgaveComponent);
                function MdsFieldset() {
                    _classCallCheck(this, MdsFieldset);
                    return _possibleConstructorReturn(this, _getPrototypeOf(MdsFieldset).apply(this, arguments));
                }
                _createClass(MdsFieldset, [ {
                    key: "focus",
                    value: function focus() {
                        var legend = this.shadowRoot.querySelector("fieldset > div > legend");
                        legend && legend.focus();
                    }
                }, {
                    key: "renderedCallback",
                    value: function renderedCallback() {
                        if (this.errorMessages.length && !!this.focusOnError) {
                            this.focus();
                        }
                    }
                }, {
                    key: "render",
                    value: function render() {
                        if (this.hideLegend && this.microcopy) {
                            this.throwConstraintError("The mds-fieldset must have a visible legend if it has microcopy.");
                        }
                        _MdsFieldset__WEBPACK_IMPORTED_MODULE_2__["default"].call(this);
                    }
                } ], [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsFieldset";
                    }
                } ]);
                return MdsFieldset;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_0___default.a), _class2.styles = _mds_fieldset_scss__WEBPACK_IMPORTED_MODULE_1___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsFieldset;
        },
        "./src/fieldset/mds-fieldset.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/fieldset/mds-fieldset.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/hero-header/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_hero_header_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/hero-header/mds-hero-header.scss");
            var _mds_hero_header_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_hero_header_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_allowLists__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/allowLists.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].enumerables, number = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].number, string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].stringRequired;
            var entity = {
                variant: enumerables(string, "iconAndText", "textOnly", "customImage", "confirmationAnimation", "leading").defaultsTo("iconAndText"),
                heading: stringRequired.withHTML(_utils_allowLists__WEBPACK_IMPORTED_MODULE_4__["base"]),
                headingLevel: number.defaultsTo(2),
                descriptionText: string.withHTML(_utils_allowLists__WEBPACK_IMPORTED_MODULE_4__["base"]),
                icon: string.withChangedCallback(),
                iconColor: enumerables(string, "success", "regular").defaultsTo("success"),
                iconAccessibleName: string,
                maxWidth: string.or(number).defaultsTo("396px")
            };
            var MdsHeroHeader = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsHeroHeader, _AgaveComponent);
                function MdsHeroHeader() {
                    _classCallCheck(this, MdsHeroHeader);
                    return _possibleConstructorReturn(this, _getPrototypeOf(MdsHeroHeader).apply(this, arguments));
                }
                _createClass(MdsHeroHeader, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsHeroHeader.prototype), "connectedCallback", this).call(this);
                        this.variant === "iconAndText" && this._validateIcon();
                        this.variant === "confirmationAnimation" && console.warn("variant - 'confirmationAnimation' is deprecated to 'leading'");
                    }
                }, {
                    key: "variantChangedCallback",
                    value: function variantChangedCallback() {
                        this.variant === "confirmationAnimation" && console.warn("variant - 'confirmationAnimation' is deprecated to 'leading'");
                    }
                }, {
                    key: "focus",
                    value: function focus() {
                        this.shadowRoot.querySelector("#hero-header-focus-target").focus();
                    }
                }, {
                    key: "iconChangedCallback",
                    value: function iconChangedCallback() {
                        if (this.variant === "iconAndText") {
                            this._validateIcon();
                        }
                    }
                }, {
                    key: "_validateIcon",
                    value: function _validateIcon() {
                        if (!_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["ICON_TYPES"].includes(this.icon)) {
                            this.throwConstraintError("Must be a valid icon type.");
                        }
                    }
                }, {
                    key: "_renderIconOrImage",
                    value: function _renderIconOrImage() {
                        if (this.variant === "iconAndText" || this.variant === "confirmationAnimation" || this.variant === "leading") {
                            var _iconClasses;
                            var iconName = this.variant === "confirmationAnimation" ? "ico_checkmark_filled" : this.icon;
                            var iconClasses = (_iconClasses = {
                                "hero-header__icon": true
                            }, _defineProperty(_iconClasses, "hero-header__icon--".concat(this.variant === "confirmationAnimation" || this.variant === "leading" ? "success" : this.iconColor), true), 
                            _defineProperty(_iconClasses, "hero-header__icon--leading", this.variant === "confirmationAnimation" || this.variant === "leading"), 
                            _iconClasses);
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", iconClasses, "innerHTML-prop", MDS.svgs[iconName], "aria-hidden", "true", "__skip", "true");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                            return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        }
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("img", null, null, "class", "hero-header__image", "src", this.icon, "aria-hidden", "true", "alt", "");
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var variant = this.variant, headingLevel = this.headingLevel, heading = this.heading, iconAccessibleName = this.iconAccessibleName, descriptionText = this.descriptionText;
                        var containerClasses = {
                            "hero-header__heading-container": true,
                            "hero-header__heading-container--leading": variant === "confirmationAnimation" || variant === "leading"
                        };
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", variant === "confirmationAnimation" || this.variant === "leading" ? "hero-header__leading" : "hero-header", "style", {
                            maxWidth: Number(this.maxWidth) ? "".concat(this.maxWidth, "px") : this.maxWidth
                        });
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", containerClasses);
                        _renderArbitrary(variant !== "textOnly" && this._renderIconOrImage());
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", variant === "confirmationAnimation" || this.variant === "leading" ? "hero-header__heading--leading" : "hero-header__heading", "id", "hero-header-focus-target", "role", "heading", "aria-level", headingLevel, "tabindex", "-1");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "hero-header__heading-text", "aria-hidden", "true", "innerHTML-prop", heading, "__skip", "true");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text");
                        _renderArbitrary(iconAccessibleName ? "".concat(iconAccessibleName, " ").concat(heading) : heading);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", variant === "confirmationAnimation" || this.variant === "leading" ? "hero-header__description--leading" : "hero-header__description", "innerHTML-prop", descriptionText, "__skip", "true");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        _renderArbitrary((variant === "confirmationAnimation" || this.variant === "leading") && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "hero-header__progress-bar"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "hero-header__progress-bar--animation"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ], [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsHeroHeader";
                    }
                } ]);
                return MdsHeroHeader;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_hero_header_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsHeroHeader;
        },
        "./src/hero-header/mds-hero-header.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/hero-header/mds-hero-header.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/icon/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_icon_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/icon/mds-icon.scss");
            var _mds_icon_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_icon_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            var enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].enumerables, string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string, number = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].number, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].boolean;
            var entity = {
                type: enumerables.apply(void 0, [ string ].concat(_toConsumableArray(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["ICON_TYPES"]))),
                size: enumerables(number, 16, 20, 24, 48).defaultsTo(16),
                color: enumerables(string, "default", "inverse", "error", "warning", "success", "interactive").defaultsTo("default"),
                accessibleText: string,
                removeHorizontalMargin: boolean.defaultsTo(false).withChangedCallback()
            };
            var MdsIcon = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsIcon, _AgaveComponent);
                function MdsIcon() {
                    _classCallCheck(this, MdsIcon);
                    return _possibleConstructorReturn(this, _getPrototypeOf(MdsIcon).apply(this, arguments));
                }
                _createClass(MdsIcon, [ {
                    key: "removeHorizontalMarginChangedCallback",
                    value: function removeHorizontalMarginChangedCallback() {
                        this._toggleMargin();
                    }
                }, {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsIcon.prototype), "connectedCallback", this).call(this);
                        this._toggleMargin();
                    }
                }, {
                    key: "_toggleMargin",
                    value: function _toggleMargin() {
                        this.classList.toggle("horizontal-margin", !this.removeHorizontalMargin);
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var _classes;
                        var isMd = /_md$/.test(this.type);
                        if (isMd && this.size !== 48) {
                            console.warn('MdsIcon: Icons ending in "_md" can only be rendered in size 48. The icon type '.concat(this.type, ' ends in "_md" but size is ').concat(this.size, "."));
                        }
                        var classes = (_classes = {
                            icon: true
                        }, _defineProperty(_classes, "icon--".concat(this.color), true), _defineProperty(_classes, "icon--".concat(this.size), true), 
                        _defineProperty(_classes, "icon--md", isMd), _classes);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "icon-container");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes, "innerHTML-prop", MDS.svgs[this.type], "aria-hidden", "true", "__skip", "true");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        _renderArbitrary(this.accessibleText && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text", "role", "img", "aria-labelledby", "icon"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "aria-hidden", "true", "id", "icon"), 
                        _renderArbitrary(this.accessibleText), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ], [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsIcon";
                    }
                } ]);
                return MdsIcon;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_icon_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsIcon;
        },
        "./src/icon/mds-icon.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/icon/mds-icon.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/image/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_image_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/image/mds-image.scss");
            var _mds_image_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_image_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _dec, _class, _class2;
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var arrayOf = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].arrayOf, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].enumerables, number = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].number, satisfies = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].satisfies, string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].stringRequired;
            var breakPoints = {
                xs: 0,
                sm: 576,
                md: 768,
                lg: 992,
                xl: 1200
            };
            var imageSourceEntity = {
                minBreakpoint: enumerables(number, 0, 576, 768, 992, 1200).defaultsTo(0),
                imageSource: stringRequired,
                height: string.or(number),
                width: string.or(number)
            };
            var entity = {
                imageSources: arrayOf(satisfies(imageSourceEntity)).withChangedCallback(),
                alt: string,
                backgroundSize: enumerables(string, "cover", "contain", "fill").defaultsTo("fill"),
                verticalPosition: enumerables(string, "center", "top", "bottom"),
                horizontalPosition: enumerables(string, "center", "left", "right")
            };
            var MdsImage = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsImage, _AgaveComponent);
                _createClass(MdsImage, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsImage";
                    }
                } ]);
                function MdsImage() {
                    var _this;
                    _classCallCheck(this, MdsImage);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsImage).call(this));
                    _this._resizeListener = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["debounce"])(_this._resizeListener.bind(_assertThisInitialized(_this)), 100);
                    window.addEventListener("resize", _this._resizeListener);
                    _this._setImageSource = _this._setImageSource.bind(_assertThisInitialized(_this));
                    _this.defineObservedProperty("_imageData", {});
                    return _this;
                }
                _createClass(MdsImage, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsImage.prototype), "connectedCallback", this).call(this);
                        this._setImageSource(breakPoints[Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["getBreakpoint"])()]);
                    }
                }, {
                    key: "disconnectedCallback",
                    value: function disconnectedCallback() {
                        _get(_getPrototypeOf(MdsImage.prototype), "disconnectedCallback", this) && _get(_getPrototypeOf(MdsImage.prototype), "disconnectedCallback", this).call(this);
                        window.removeEventListener("resize", this._resizeListener);
                    }
                }, {
                    key: "imageSourcesChangedCallback",
                    value: function imageSourcesChangedCallback() {
                        this._setImageSource(breakPoints[Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["getBreakpoint"])()]);
                    }
                }, {
                    key: "_resizeListener",
                    value: function _resizeListener() {
                        this._setImageSource(breakPoints[Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["getBreakpoint"])()]);
                    }
                }, {
                    key: "_setImageSource",
                    value: function _setImageSource(currentWidth) {
                        var _this2 = this;
                        var nextBreakpoint = 0;
                        var imageDataSet = false;
                        this.imageSources.forEach(function(element) {
                            _newArrowCheck(this, _this2);
                            if (element.minBreakpoint === currentWidth) {
                                this._imageData = element;
                                imageDataSet = true;
                            } else if (element.minBreakpoint < currentWidth) {
                                nextBreakpoint = Math.max(element.minBreakpoint, nextBreakpoint);
                            }
                        }.bind(this));
                        if (!imageDataSet) {
                            this.imageSources.forEach(function(element) {
                                _newArrowCheck(this, _this2);
                                if (element.minBreakpoint === nextBreakpoint) {
                                    this._imageData = element;
                                }
                            }.bind(this));
                        }
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var _imgClasses;
                        var backgroundSize = this.backgroundSize, horizontalPosition = this.horizontalPosition, verticalPosition = this.verticalPosition;
                        var imgClasses = (_imgClasses = {}, _defineProperty(_imgClasses, "image", true), 
                        _defineProperty(_imgClasses, "image--".concat(backgroundSize), !!backgroundSize), 
                        _defineProperty(_imgClasses, "image--position_".concat(horizontalPosition), !!horizontalPosition), 
                        _defineProperty(_imgClasses, "image--position_".concat(verticalPosition), !!verticalPosition), 
                        _defineProperty(_imgClasses, "image--position_".concat(horizontalPosition, "-").concat(verticalPosition), !!horizontalPosition && !!verticalPosition), 
                        _imgClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("img");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", imgClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("src", this._imageData.imageSource);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("alt", this.alt ? this.alt : "");
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                            height: this._imageData.height
                        }, this._imageData.height));
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                            width: this._imageData.width
                        }, this._imageData.width));
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                            "aria-hidden": "true"
                        }, !this.alt));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("img");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("img");
                    }
                } ]);
                return MdsImage;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_image_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsImage;
        },
        "./src/image/mds-image.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/image/mds-image.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/index-common.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var _polyfills__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/polyfills.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _index_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/index-core.js");
            var _accordion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/accordion/index.jsx");
            var _avatar_banner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/avatar-banner/index.jsx");
            var _badge__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/badge/index.jsx");
            var _banner__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/banner/index.js");
            var _banner_for_employee_messaging__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/banner-for-employee-messaging/index.js");
            var _bottom_sheet_dialog__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("./src/bottom-sheet-dialog/index.jsx");
            var _bottom_sheet__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("./src/bottom-sheet/index.js");
            var _brand_bar__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("./src/brand-bar/index.js");
            var _breadcrumb__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("./src/breadcrumb/index.jsx");
            var _breadcrumbs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("./src/breadcrumbs/index.jsx");
            var _calendar__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("./src/calendar/index.js");
            var _callout__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("./src/callout/index.jsx");
            var _carousel__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("./src/carousel/index.js");
            var _chat_bubble__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("./src/chat-bubble/index.jsx");
            var _chat_input__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("./src/chat-input/index.jsx");
            var _combo_button__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("./src/combo-button/index.js");
            var _commerce_tile__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("./src/commerce-tile/index.jsx");
            var _data_table_action_bar__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("./src/data-table-action-bar/index.jsx");
            var _abstract_data_table_data_table_combo_button__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("./src/abstract-data-table/data-table-combo-button/index.jsx");
            var _data_table_for_accounts__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("./src/data-table-for-accounts/index.js");
            var _data_table_for_chart__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("./src/data-table-for-chart/index.js");
            var _data_table_for_files__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("./src/data-table-for-files/index.js");
            var _data_table_for_securities__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("./src/data-table-for-securities/index.js");
            var _data_table_for_transactions__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("./src/data-table-for-transactions/index.js");
            var _abstract_data_table_data_table_input__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("./src/abstract-data-table/data-table-input/index.js");
            var _data_table_simple__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("./src/data-table-simple/index.js");
            var _date_badge__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__("./src/date-badge/index.jsx");
            var _datepicker__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__("./src/datepicker/index.js");
            var _definition_link__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__("./src/definition-link/index.jsx");
            var _dialog__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__("./src/dialog/index.jsx");
            var _description_list__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__("./src/description-list/index.js");
            var _document_viewer__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__("./src/document-viewer/index.jsx");
            var _drop_zone__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__("./src/drop-zone/index.js");
            var _text_input_error_message__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__("./src/text-input/error-message/index.jsx");
            var _expandable_text__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__("./src/expandable-text/index.jsx");
            var _status_tracker_expandable_step__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__("./src/status-tracker/expandable-step/index.jsx");
            var _fieldset__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__("./src/fieldset/index.js");
            var _hero_header__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__("./src/hero-header/index.jsx");
            var _icon__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__("./src/icon/index.jsx");
            var _image__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__("./src/image/index.jsx");
            var _inline_form__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__("./src/inline-form/index.js");
            var _inline_form_inline_input__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__("./src/inline-form/inline-input/index.jsx");
            var _inline_form_inline_select__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__("./src/inline-form/inline-select/index.js");
            var _list__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__("./src/list/index.jsx");
            var _loading_bubble__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__("./src/loading-bubble/index.jsx");
            var _load_more__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__("./src/load-more/index.jsx");
            var _map__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__("./src/map/index.jsx");
            var _map_map_marker__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__("./src/map/map-marker/index.jsx");
            var _map_map_marker_map_marker_overlay__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__("./src/map/map-marker/map-marker-overlay/index.jsx");
            var _map_static__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__("./src/map-static/index.jsx");
            var _comparison_table__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__("./src/comparison-table/index.jsx");
            var _menu__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__("./src/menu/index.js");
            var _message_drawer__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__("./src/message-drawer/index.jsx");
            var _multiselect__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__("./src/multiselect/index.js");
            var _multiselect_multiselect_option__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__("./src/multiselect/multiselect-option/index.js");
            var _navigation_bar__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__("./src/navigation-bar/index.jsx");
            var _navigation_bar_navigation_bar_bottom__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__("./src/navigation-bar/navigation-bar-bottom/index.jsx");
            var _navigation_bar_navigation_bar_item__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__("./src/navigation-bar/navigation-bar-item/index.js");
            var _navigation_bar_navigation_bar_menu__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__("./src/navigation-bar/navigation-bar-menu/index.jsx");
            var _navigation_bar_navigation_bar_menu_navigation_bar_menu_item__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__("./src/navigation-bar/navigation-bar-menu/navigation-bar-menu-item/index.js");
            var _progress_bar__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__("./src/progress-bar/index.jsx");
            var _progress_spinner__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__("./src/progress-spinner/index.jsx");
            var _progress_spinner_inline__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__("./src/progress-spinner-inline/index.jsx");
            var _progress_steps__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__("./src/progress-steps/index.jsx");
            var _progress_bar_radial__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__("./src/progress-bar-radial/index.jsx");
            var _quick_action_bar__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__("./src/quick-action-bar/index.jsx");
            var _quick_reply_bar__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__("./src/quick-reply-bar/index.js");
            var _quick_reply_button__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__("./src/quick-reply-button/index.js");
            var _radio_group__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__("./src/radio-group/index.jsx");
            var _rating_indicator__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__("./src/rating-indicator/index.jsx");
            var _search_box__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__("./src/search-box/index.js");
            var _selectable_tile__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__("./src/selectable-tile/index.jsx");
            var _skeleton_loader__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__("./src/skeleton-loader/index.jsx");
            var _skip_link__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__("./src/skip-link/index.jsx");
            var _slide_in_panel__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__("./src/slide-in-panel/index.jsx");
            var _slider__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__("./src/slider/index.js");
            var _status_block__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__("./src/status-block/index.jsx");
            var _status_tracker__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__("./src/status-tracker/index.jsx");
            var _sticky_footer__WEBPACK_IMPORTED_MODULE_81__ = __webpack_require__("./src/sticky-footer/index.jsx");
            var _switch__WEBPACK_IMPORTED_MODULE_82__ = __webpack_require__("./src/switch/index.jsx");
            var _tab_bar__WEBPACK_IMPORTED_MODULE_83__ = __webpack_require__("./src/tab-bar/index.jsx");
            var _text_input__WEBPACK_IMPORTED_MODULE_84__ = __webpack_require__("./src/text-input/index.js");
            var _text_input_text_input_button__WEBPACK_IMPORTED_MODULE_85__ = __webpack_require__("./src/text-input/text-input-button/index.jsx");
            var _text_input_secure__WEBPACK_IMPORTED_MODULE_86__ = __webpack_require__("./src/text-input-secure/index.js");
            var _tile__WEBPACK_IMPORTED_MODULE_87__ = __webpack_require__("./src/tile/index.js");
            var _tile_accordion__WEBPACK_IMPORTED_MODULE_88__ = __webpack_require__("./src/tile-accordion/index.jsx");
            var _vertical_navigation__WEBPACK_IMPORTED_MODULE_89__ = __webpack_require__("./src/vertical-navigation/index.jsx");
            var _vertical_navigation_vertical_navigation_item__WEBPACK_IMPORTED_MODULE_90__ = __webpack_require__("./src/vertical-navigation/vertical-navigation-item/index.js");
            var _vertical_navigation_vertical_navigation_footer__WEBPACK_IMPORTED_MODULE_91__ = __webpack_require__("./src/vertical-navigation/vertical-navigation-footer/index.jsx");
            var _video_player__WEBPACK_IMPORTED_MODULE_92__ = __webpack_require__("./src/video-player/index.jsx");
            __webpack_exports__["default"] = {
                indexCore: _index_core__WEBPACK_IMPORTED_MODULE_2__,
                Accordion: _accordion__WEBPACK_IMPORTED_MODULE_3__["default"],
                AvatarBanner: _avatar_banner__WEBPACK_IMPORTED_MODULE_4__["default"],
                Badge: _badge__WEBPACK_IMPORTED_MODULE_5__["default"],
                Banner: _banner__WEBPACK_IMPORTED_MODULE_6__["default"],
                BannerForEmployeeMessaging: _banner_for_employee_messaging__WEBPACK_IMPORTED_MODULE_7__["default"],
                BottomSheetDialog: _bottom_sheet_dialog__WEBPACK_IMPORTED_MODULE_8__["default"],
                BottomSheet: _bottom_sheet__WEBPACK_IMPORTED_MODULE_9__["default"],
                BrandBar: _brand_bar__WEBPACK_IMPORTED_MODULE_10__["default"],
                Breadcrumb: _breadcrumb__WEBPACK_IMPORTED_MODULE_11__["default"],
                Breadcrumbs: _breadcrumbs__WEBPACK_IMPORTED_MODULE_12__["default"],
                Calendar: _calendar__WEBPACK_IMPORTED_MODULE_13__["default"],
                Callout: _callout__WEBPACK_IMPORTED_MODULE_14__["default"],
                Carousel: _carousel__WEBPACK_IMPORTED_MODULE_15__["default"],
                ChatBubble: _chat_bubble__WEBPACK_IMPORTED_MODULE_16__["default"],
                ChatInput: _chat_input__WEBPACK_IMPORTED_MODULE_17__["default"],
                ComboButton: _combo_button__WEBPACK_IMPORTED_MODULE_18__["default"],
                CommerceTile: _commerce_tile__WEBPACK_IMPORTED_MODULE_19__["default"],
                DataTableActionBar: _data_table_action_bar__WEBPACK_IMPORTED_MODULE_20__["default"],
                DataTableComboButton: _abstract_data_table_data_table_combo_button__WEBPACK_IMPORTED_MODULE_21__["default"],
                DataTableForAccounts: _data_table_for_accounts__WEBPACK_IMPORTED_MODULE_22__["default"],
                DataTableForChart: _data_table_for_chart__WEBPACK_IMPORTED_MODULE_23__["default"],
                DataTableForFiles: _data_table_for_files__WEBPACK_IMPORTED_MODULE_24__["default"],
                DataTableForSecurities: _data_table_for_securities__WEBPACK_IMPORTED_MODULE_25__["default"],
                DataTableForTransactions: _data_table_for_transactions__WEBPACK_IMPORTED_MODULE_26__["default"],
                DataTableTextInput: _abstract_data_table_data_table_input__WEBPACK_IMPORTED_MODULE_27__["default"],
                DataTableSimple: _data_table_simple__WEBPACK_IMPORTED_MODULE_28__["default"],
                DateBadge: _date_badge__WEBPACK_IMPORTED_MODULE_29__["default"],
                Datepicker: _datepicker__WEBPACK_IMPORTED_MODULE_30__["default"],
                Dialog: _dialog__WEBPACK_IMPORTED_MODULE_32__["default"],
                DefinitionLink: _definition_link__WEBPACK_IMPORTED_MODULE_31__["default"],
                DescriptionList: _description_list__WEBPACK_IMPORTED_MODULE_33__["default"],
                DocumentViewer: _document_viewer__WEBPACK_IMPORTED_MODULE_34__["default"],
                DropZone: _drop_zone__WEBPACK_IMPORTED_MODULE_35__["default"],
                ExpandableText: _expandable_text__WEBPACK_IMPORTED_MODULE_37__["default"],
                ExpandableStep: _status_tracker_expandable_step__WEBPACK_IMPORTED_MODULE_38__["default"],
                Fieldset: _fieldset__WEBPACK_IMPORTED_MODULE_39__["default"],
                HeroHeader: _hero_header__WEBPACK_IMPORTED_MODULE_40__["default"],
                Icon: _icon__WEBPACK_IMPORTED_MODULE_41__["default"],
                Image: _image__WEBPACK_IMPORTED_MODULE_42__["default"],
                InlineForm: _inline_form__WEBPACK_IMPORTED_MODULE_43__["default"],
                InlineInput: _inline_form_inline_input__WEBPACK_IMPORTED_MODULE_44__["default"],
                InlineSelect: _inline_form_inline_select__WEBPACK_IMPORTED_MODULE_45__["default"],
                List: _list__WEBPACK_IMPORTED_MODULE_46__["default"],
                LoadingBubble: _loading_bubble__WEBPACK_IMPORTED_MODULE_47__["default"],
                LoadMore: _load_more__WEBPACK_IMPORTED_MODULE_48__["default"],
                Map: _map__WEBPACK_IMPORTED_MODULE_49__["default"],
                MapMarker: _map_map_marker__WEBPACK_IMPORTED_MODULE_50__["default"],
                MapStatic: _map_static__WEBPACK_IMPORTED_MODULE_52__["default"],
                MdsComparisonTable: _comparison_table__WEBPACK_IMPORTED_MODULE_53__["default"],
                Menu: _menu__WEBPACK_IMPORTED_MODULE_54__["default"],
                MessageDrawer: _message_drawer__WEBPACK_IMPORTED_MODULE_55__["default"],
                Multiselect: _multiselect__WEBPACK_IMPORTED_MODULE_56__["default"],
                MultiselectOption: _multiselect_multiselect_option__WEBPACK_IMPORTED_MODULE_57__["default"],
                NavigationBar: _navigation_bar__WEBPACK_IMPORTED_MODULE_58__["default"],
                NavigationBarBottom: _navigation_bar_navigation_bar_bottom__WEBPACK_IMPORTED_MODULE_59__["default"],
                NavigationBarItem: _navigation_bar_navigation_bar_item__WEBPACK_IMPORTED_MODULE_60__["default"],
                NavigationBarMenu: _navigation_bar_navigation_bar_menu__WEBPACK_IMPORTED_MODULE_61__["default"],
                NavigationBarMenuItem: _navigation_bar_navigation_bar_menu_navigation_bar_menu_item__WEBPACK_IMPORTED_MODULE_62__["default"],
                ProgressBar: _progress_bar__WEBPACK_IMPORTED_MODULE_63__["default"],
                ProgressSpinner: _progress_spinner__WEBPACK_IMPORTED_MODULE_64__["default"],
                ProgressSpinnerInline: _progress_spinner_inline__WEBPACK_IMPORTED_MODULE_65__["default"],
                ProgressSteps: _progress_steps__WEBPACK_IMPORTED_MODULE_66__["default"],
                ProgressBarRadial: _progress_bar_radial__WEBPACK_IMPORTED_MODULE_67__["default"],
                QuickActionBar: _quick_action_bar__WEBPACK_IMPORTED_MODULE_68__["default"],
                QuickReplyBar: _quick_reply_bar__WEBPACK_IMPORTED_MODULE_69__["default"],
                QuickReplyButton: _quick_reply_button__WEBPACK_IMPORTED_MODULE_70__["default"],
                RadioGroup: _radio_group__WEBPACK_IMPORTED_MODULE_71__["default"],
                RatingIndicator: _rating_indicator__WEBPACK_IMPORTED_MODULE_72__["default"],
                SearchBox: _search_box__WEBPACK_IMPORTED_MODULE_73__["default"],
                SelectableTile: _selectable_tile__WEBPACK_IMPORTED_MODULE_74__["default"],
                SkeletonLoader: _skeleton_loader__WEBPACK_IMPORTED_MODULE_75__["default"],
                SkipLink: _skip_link__WEBPACK_IMPORTED_MODULE_76__["default"],
                SlideInPanel: _slide_in_panel__WEBPACK_IMPORTED_MODULE_77__["default"],
                Slider: _slider__WEBPACK_IMPORTED_MODULE_78__["default"],
                StatusBlock: _status_block__WEBPACK_IMPORTED_MODULE_79__["default"],
                StatusTracker: _status_tracker__WEBPACK_IMPORTED_MODULE_80__["default"],
                StickyFooter: _sticky_footer__WEBPACK_IMPORTED_MODULE_81__["default"],
                Switch: _switch__WEBPACK_IMPORTED_MODULE_82__["default"],
                TabBar: _tab_bar__WEBPACK_IMPORTED_MODULE_83__["default"],
                TextInput: _text_input__WEBPACK_IMPORTED_MODULE_84__["default"],
                TextInputSecure: _text_input_secure__WEBPACK_IMPORTED_MODULE_86__["default"],
                Tile: _tile__WEBPACK_IMPORTED_MODULE_87__["default"],
                TileAccordion: _tile_accordion__WEBPACK_IMPORTED_MODULE_88__["default"],
                VerticalNavigation: _vertical_navigation__WEBPACK_IMPORTED_MODULE_89__["default"],
                VerticalNavigationItem: _vertical_navigation_vertical_navigation_item__WEBPACK_IMPORTED_MODULE_90__["default"],
                VerticalNavigationFooter: _vertical_navigation_vertical_navigation_footer__WEBPACK_IMPORTED_MODULE_91__["default"],
                VideoPlayer: _video_player__WEBPACK_IMPORTED_MODULE_92__["default"]
            };
        },
        "./src/inline-form/MdsInlineForm.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "renderLeadingText", (function() {
                return renderLeadingText;
            }));
            __webpack_require__.d(__webpack_exports__, "renderTrailingText", (function() {
                return renderTrailingText;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _text_input_MdsTextInput__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/text-input/MdsTextInput.jsx");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _span$wrapper = function _span$wrapper(_this$leadingText) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "inline-form__text inline-form__text--leading");
                _renderArbitrary(_this$leadingText);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            }, _span$wrapper2 = function _span$wrapper2(_this$trailingText) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "inline-form__text inline-form__text--trailing");
                _renderArbitrary(_this$trailingText);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            };
            function renderLeadingText() {
                return this.leadingText && _jsxWrapper(_span$wrapper, [ this.leadingText ]);
            }
            function renderTrailingText() {
                return this.trailingText && _jsxWrapper(_span$wrapper2, [ this.trailingText ]);
            }
            function MdsInlineFormTemplate() {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "inline-form");
                _renderArbitrary(_text_input_MdsTextInput__WEBPACK_IMPORTED_MODULE_1__["renderErrorMicrocopy"].call(this, this._errorMessageList, "inline-form", "base"));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            __webpack_exports__["default"] = MdsInlineFormTemplate;
        },
        "./src/inline-form/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _MdsInlineForm__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/inline-form/MdsInlineForm.jsx");
            var _mds_inline_form_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/inline-form/mds-inline-form.scss");
            var _mds_inline_form_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_inline_form_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _utils_slot_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/slot-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var MdsInlineForm = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])({}), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsInlineForm, _AgaveComponent);
                _createClass(MdsInlineForm, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsInlineForm";
                    }
                } ]);
                function MdsInlineForm() {
                    var _this;
                    _classCallCheck(this, MdsInlineForm);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsInlineForm).call(this));
                    _this.defineObservedProperty("_errorMessageList", {});
                    _this._handleSlotChange = _this._handleSlotChange.bind(_assertThisInitialized(_this));
                    _this._errorMessages = new Map;
                    _this._errorMessageList = [];
                    return _this;
                }
                _createClass(MdsInlineForm, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsInlineForm.prototype), "connectedCallback", this).call(this);
                        this.shadowRoot.querySelector("slot").addEventListener("slotchange", this._handleSlotChange);
                    }
                }, {
                    key: "_handleSlotChange",
                    value: function _handleSlotChange(event) {
                        var _this2 = this;
                        _utils_slot_utils__WEBPACK_IMPORTED_MODULE_3__["enforceSlotUsage"].call(this);
                        this._slottedComponents = event.target.assignedNodes().filter(function(node) {
                            _newArrowCheck(this, _this2);
                            return node instanceof _mds_agave__WEBPACK_IMPORTED_MODULE_0___default.a;
                        }.bind(this));
                        this._slottedComponents.length && this._slottedComponents.forEach(function(child, index) {
                            _newArrowCheck(this, _this2);
                            child._slotParent = this;
                            child._slotIndex = index;
                            if (child._errorMessage) {
                                this._errorMessageList.push(child._errorMessage);
                            }
                            if (child.errorMessage) {
                                this._errorMessages.set(index, {
                                    errorMessage: child._errorMessage,
                                    errorMessagePrefix: child.errorMessagePrefix
                                });
                                this.errorMessageChangedCallback();
                            }
                        }.bind(this));
                    }
                }, {
                    key: "errorMessageChangedCallback",
                    value: function errorMessageChangedCallback() {
                        var _this3 = this;
                        var tempArr = [];
                        this._errorMessages.forEach(function(msg) {
                            _newArrowCheck(this, _this3);
                            tempArr.push(msg.errorMessage);
                        }.bind(this));
                        this._errorMessageList = tempArr;
                    }
                }, {
                    key: "render",
                    value: function render() {
                        return _MdsInlineForm__WEBPACK_IMPORTED_MODULE_1__["default"].call(this);
                    }
                } ]);
                return MdsInlineForm;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_0___default.a), _class2.styles = _mds_inline_form_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2._childLocalNames = [ "mds-inline-select", "mds-inline-input" ], _class2)) || _class);
            __webpack_exports__["default"] = MdsInlineForm;
        },
        "./src/inline-form/inline-input/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_inline_input_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/inline-form/inline-input/mds-inline-input.scss");
            var _mds_inline_input_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_inline_input_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _text_input_formatters__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/text-input/formatters.js");
            var _utils_slot_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/slot-utils.js");
            var _utils_form_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/form-utils.js");
            var _MdsInlineForm__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/inline-form/MdsInlineForm.jsx");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["mixins"].AttributeMarshallingMixin, stamp = _mixins$AttributeMars.stamp, boolean = _mixins$AttributeMars.boolean, enumerables = _mixins$AttributeMars.enumerables, string = _mixins$AttributeMars.string, stringRequired = _mixins$AttributeMars.stringRequired;
            var entity = {
                value: string.defaultsTo("").withChangedCallback(),
                label: stringRequired,
                name: string,
                placeholder: string,
                required: boolean.defaultsTo(false),
                leadingText: string,
                trailingText: string,
                accessibleText: string,
                errorMessage: string.withChangedCallback(),
                errorMessagePrefix: string.defaultsTo("Error:"),
                autocompleteValue: string.defaultsTo("off"),
                format: enumerables(string, "moneyInteger", ""),
                currencySymbol: string.defaultsTo("")
            };
            var MdsInlineInput = (_dec = stamp(entity), _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsInlineInput, _AgaveComponent);
                _createClass(MdsInlineInput, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsInlineInput";
                    }
                } ]);
                function MdsInlineInput() {
                    var _this;
                    _classCallCheck(this, MdsInlineInput);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsInlineInput).call(this));
                    _this._handleInput = _this._handleInput.bind(_assertThisInitialized(_this));
                    _this._setInputWidth = _this._setInputWidth.bind(_assertThisInitialized(_this));
                    _this._oninput = _this._oninput.bind(_assertThisInitialized(_this));
                    _this._onchange = _this._onchange.bind(_assertThisInitialized(_this));
                    _this._onclick = _this._onclick.bind(_assertThisInitialized(_this));
                    _this._onfocus = _this._onfocus.bind(_assertThisInitialized(_this));
                    _this._onblur = _this._onblur.bind(_assertThisInitialized(_this));
                    _this._onkeydown = _this._onkeydown.bind(_assertThisInitialized(_this));
                    _this._onkeyup = _this._onkeyup.bind(_assertThisInitialized(_this));
                    _this._cursorWidth = MDS.isIOS ? 2 : 1;
                    return _this;
                }
                _createClass(MdsInlineInput, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        var _this2 = this;
                        _get(_getPrototypeOf(MdsInlineInput.prototype), "connectedCallback", this).call(this);
                        _utils_slot_utils__WEBPACK_IMPORTED_MODULE_4__["enforceSlottedComponentUsage"].call(this);
                        this._inputNode = this.shadowRoot.querySelector("input");
                        this._inputMirror = this.shadowRoot.querySelector(".inline-input__width-mirror");
                        this.formattedValue = "";
                        this._setInputWidth();
                        setTimeout(function() {
                            _newArrowCheck(this, _this2);
                            !this._formAssociatedInput && _utils_form_utils__WEBPACK_IMPORTED_MODULE_5__["createFormAssociatedInput"].call(this, {
                                disabled: !this.value
                            });
                            if (this.value && this._setFormattedValue(this.value)) {
                                this._setTextFieldValue();
                            }
                            this._styleObserver = new MutationObserver(this._setInputWidth);
                            this._styleObserver.observe(this._inputNode, {
                                attributeFilter: [ "style" ]
                            });
                        }.bind(this));
                    }
                }, {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        return {
                            interactiveElement: this._inputNode
                        };
                    }
                }, {
                    key: "_setFormattedValue",
                    value: function _setFormattedValue(value) {
                        if (this.format) {
                            var formatMaxLength = 15;
                            if (value.length <= formatMaxLength) {
                                this.formattedValue = _text_input_formatters__WEBPACK_IMPORTED_MODULE_3__["default"][this.format](value);
                                return true;
                            }
                        }
                        return false;
                    }
                }, {
                    key: "_setTextFieldValue",
                    value: function _setTextFieldValue() {
                        if (this._inputNode) {
                            this._inputNode.value = this.formattedValue.length ? this.currencySymbol + this.formattedValue : this.value;
                            this._setInputWidth();
                        }
                    }
                }, {
                    key: "_handleTextFieldFormatting",
                    value: function _handleTextFieldFormatting() {
                        if (this.formattedValue.length) {
                            this.value = _text_input_formatters__WEBPACK_IMPORTED_MODULE_3__["default"]["".concat(this.format, "Clean")](this.value);
                        }
                        this._setTextFieldValue();
                    }
                }, {
                    key: "valueChangedCallback",
                    value: function valueChangedCallback(newValue) {
                        this._formAssociatedInput && _utils_form_utils__WEBPACK_IMPORTED_MODULE_5__["syncFormAssociatedInputValue"].call(this, newValue);
                    }
                }, {
                    key: "errorMessageChangedCallback",
                    value: function errorMessageChangedCallback(errorMessage) {
                        if (this._slotParent) {
                            if (errorMessage) {
                                this._slotParent._errorMessages.set(this._slotIndex, {
                                    errorMessage: errorMessage,
                                    errorMessagePrefix: this.errorMessagePrefix
                                });
                            } else {
                                this._slotParent._errorMessages.delete(this._slotIndex);
                            }
                            this._slotParent.errorMessageChangedCallback();
                        }
                    }
                }, {
                    key: "_onblur",
                    value: function _onblur(event) {
                        this.format && this._handleTextFieldFormatting(event);
                        _get(_getPrototypeOf(MdsInlineInput.prototype), "_onblur", this) && _get(_getPrototypeOf(MdsInlineInput.prototype), "_onblur", this).call(this, event);
                    }
                }, {
                    key: "_handleInput",
                    value: function _handleInput(event) {
                        this._inputFired = true;
                        this.value = event.target.value;
                        _get(_getPrototypeOf(MdsInlineInput.prototype), "_oninput", this) && _get(_getPrototypeOf(MdsInlineInput.prototype), "_oninput", this).call(this, event);
                    }
                }, {
                    key: "_setInputWidth",
                    value: function _setInputWidth() {
                        if (this._inputNode && this._inputMirror) {
                            this._styleObserver && this._styleObserver.disconnect();
                            this._inputMirror.innerHTML = (this._inputNode.value || this._inputNode.placeholder || "").replace(/\s/g, "&nbsp");
                            this._inputNode.style.width = "".concat(this._inputMirror.offsetWidth + this._cursorWidth, "px");
                            this._styleObserver && this._styleObserver.observe(this._inputNode, {
                                attributeFilter: [ "style" ]
                            });
                        }
                    }
                }, {
                    key: "renderedCallback",
                    value: function renderedCallback() {
                        if (this.value && this._setFormattedValue(this.value) && !this._inputFired) {
                            this._setTextFieldValue();
                        } else {
                            if (!this.value) {
                                this.formattedValue = "";
                            }
                            this._setInputWidth();
                        }
                        this._inputFired = false;
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var inputClasses = {
                            "inline-input__input": true,
                            "inline-input__input--trailing-text": this.trailingText,
                            "inline-input__input--error": this.errorMessage
                        };
                        var hiddenAccessibleText = this.errorMessage ? "".concat(this.errorMessagePrefix, " ").concat(this.errorMessage, " ") : "";
                        if (this.accessibleText) {
                            hiddenAccessibleText += this.accessibleText;
                        }
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "inline-input");
                        _renderArbitrary(_MdsInlineForm__WEBPACK_IMPORTED_MODULE_6__["renderLeadingText"].call(this));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("input", null, null, "class", inputClasses, "type", "text", "value-prop", this.value, "required-prop", this.required, "aria-invalid", !!this.errorMessage, "aria-label", this.label, "aria-describedby", "input-accessible-text-".concat(this.id), "placeholder", this.placeholder, "autoComplete", this.autocompleteValue, "oninput", this._handleInput, "onchange", this._onchange, "onclick", this._onclick, "onfocus", this._onfocus, "onblur", this._onblur, "onkeydown", this._onkeydown, "onkeyup", this._onkeyup);
                        _renderArbitrary(_MdsInlineForm__WEBPACK_IMPORTED_MODULE_6__["renderTrailingText"].call(this));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "id", "input-accessible-text-".concat(this.id), "class", "inline-input__accessible-text", "aria-hidden", "true");
                        _renderArbitrary(hiddenAccessibleText);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("span", null, null, "class", "inline-input__width-mirror", "aria-hidden", "true");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return MdsInlineInput;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["AgaveComponent"]), _class2.styles = _mds_inline_input_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2._parentLocalNames = [ "mds-inline-form" ], _class2)) || _class);
            __webpack_exports__["default"] = MdsInlineInput;
        },
        "./src/inline-form/inline-input/mds-inline-input.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/inline-form/inline-input/mds-inline-input.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/inline-form/inline-select/MdsInlineSelect.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _MdsInlineForm__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/inline-form/MdsInlineForm.jsx");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _this = undefined;
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            var renderOption = function renderOption(optionItem, context, index) {
                _newArrowCheck(this, _this);
                var optionClasses = {
                    "inline-select__option": true,
                    "inline-select__option--selected": index === context.selectedIndex
                };
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("li", null, null, "class", optionClasses, "onblur", context._handleMenuBlur, "data-index", index, "role", "menuitem", "tabindex", "-1");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "inline-select__option-label", "data-index", index);
                _renderArbitrary(optionItem[context.labelKey]);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("li");
            }.bind(undefined);
            var renderMenu = function renderMenu(context) {
                var _this2 = this;
                _newArrowCheck(this, _this);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "inline-select__menu");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("ul", null, null, "class", "inline-select__menu-list", "role", "menu", "onclick", context._handleMenuClick, "onkeydown", context._handleMenuKeydown, "onkeyup", context._handleMenuKeyup);
                _renderArbitrary(context.options.map(function(optionItem, index) {
                    _newArrowCheck(this, _this2);
                    return renderOption(optionItem, context, index);
                }.bind(this)));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("ul");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }.bind(undefined);
            function MdsInlineFormSelectTemplate() {
                var selectClasses = {
                    "inline-select__select": true,
                    "inline-select__select--placeholder": !this.value && !this.selectedIndex && this.placeholder,
                    "inline-select__select--error": this.errorMessage
                };
                var containerClasses = {
                    "inline-select__select-container": true,
                    "inline-select__select-container--trailing-text": this.trailingText
                };
                var inputValue;
                if (this.options[this.selectedIndex]) {
                    var label = this.options[this.selectedIndex][this.labelKey];
                    inputValue = label;
                }
                var hiddenAccessibleText = this.errorMessage ? "".concat(this.errorMessagePrefix, " ").concat(this.errorMessage, " ") : "";
                if (this.accessibleText) {
                    hiddenAccessibleText += this.accessibleText;
                }
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "inline-select");
                _renderArbitrary(_MdsInlineForm__WEBPACK_IMPORTED_MODULE_1__["renderLeadingText"].call(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", containerClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "inline-select__icon", "innerHTML-prop", MDS.svgs["ico_chevron_down"], "aria-hidden", "true", "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("input", null, null, "type", "button", "value", inputValue || this.placeholder, "class", selectClasses, "name", this.name, "required-prop", this.required, "aria-invalid", !!this.errorMessage, "aria-label", [ this.label, inputValue || this.placeholder ].join(", "), "aria-describedby", "select-accessible-text-".concat(this.id), "aria-haspopup", "true", "aria-expanded", this._visible, "onclick", this._handleInputClick, "onblur", this._handleMenuBlur, "onfocus", this._onfocus, "onkeydown", this._handleInputKeydown, "onkeyup", this._handleInputKeyup);
                _renderArbitrary(this._visible && renderMenu(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "id", "select-accessible-text-".concat(this.id), "class", "inline-select__accessible-text", "aria-hidden", "true");
                _renderArbitrary(hiddenAccessibleText);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                _renderArbitrary(_MdsInlineForm__WEBPACK_IMPORTED_MODULE_1__["renderTrailingText"].call(this));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            __webpack_exports__["default"] = MdsInlineFormSelectTemplate;
        },
        "./src/inline-form/inline-select/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_inline_select_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/inline-form/inline-select/mds-inline-select.scss");
            var _mds_inline_select_scss__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_inline_select_scss__WEBPACK_IMPORTED_MODULE_1__);
            var _MdsInlineSelect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/inline-form/inline-select/MdsInlineSelect.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_slot_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/slot-utils.js");
            var _utils_form_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/form-utils.js");
            var _select_select_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/select/select-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["mixins"].AttributeMarshallingMixin, stamp = _mixins$AttributeMars.stamp, boolean = _mixins$AttributeMars.boolean, string = _mixins$AttributeMars.string, stringRequired = _mixins$AttributeMars.stringRequired, number = _mixins$AttributeMars.number, arrayOf = _mixins$AttributeMars.arrayOf, object = _mixins$AttributeMars.object;
            var entity = {
                options: arrayOf(object).withMinLength(2).withChangedCallback(),
                selectedIndex: number.withChangedCallback(),
                label: stringRequired,
                labelKey: string.defaultsTo("label"),
                valueKey: string.defaultsTo("value"),
                value: string.defaultsTo("").withChangedCallback(),
                name: string,
                placeholder: string,
                required: boolean.defaultsTo(false),
                leadingText: string,
                trailingText: string,
                accessibleText: string,
                errorMessage: string.withChangedCallback(),
                errorMessagePrefix: string.defaultsTo("Error:")
            };
            var MdsInlineSelect = (_dec = stamp(entity), _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsInlineSelect, _AgaveComponent);
                _createClass(MdsInlineSelect, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsInlineSelect";
                    }
                } ]);
                function MdsInlineSelect() {
                    var _this;
                    _classCallCheck(this, MdsInlineSelect);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsInlineSelect).call(this));
                    _this.defineObservedProperty("_visible", false);
                    _this._onclick = _this._onclick.bind(_assertThisInitialized(_this));
                    _this._onfocus = _this._onfocus.bind(_assertThisInitialized(_this));
                    _this._onmousedown = _this._onmousedown.bind(_assertThisInitialized(_this));
                    _this._onkeydown = _this._onkeydown.bind(_assertThisInitialized(_this));
                    _this._onkeyup = _this._onkeyup.bind(_assertThisInitialized(_this));
                    _this._handleInputClick = _this._handleInputClick.bind(_assertThisInitialized(_this));
                    _this._handleMenuClick = _this._handleMenuClick.bind(_assertThisInitialized(_this));
                    _this._handleMenuKeydown = _this._handleMenuKeydown.bind(_assertThisInitialized(_this));
                    _this._handleMenuKeyup = _this._handleMenuKeyup.bind(_assertThisInitialized(_this));
                    _this._handleMenuBlur = _this._handleMenuBlur.bind(_assertThisInitialized(_this));
                    _this._iosCloseOnBlur = _select_select_utils__WEBPACK_IMPORTED_MODULE_6__["iosCloseOnBlur"].bind(_assertThisInitialized(_this));
                    _this._handleInputKeyup = _this._handleInputKeyup.bind(_assertThisInitialized(_this));
                    _this._handleInputKeydown = _this._handleInputKeydown.bind(_assertThisInitialized(_this));
                    _this.open = _this.open.bind(_assertThisInitialized(_this));
                    _this.close = _this.close.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsInlineSelect, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        var _this2 = this;
                        _get(_getPrototypeOf(MdsInlineSelect.prototype), "connectedCallback", this).call(this);
                        _utils_slot_utils__WEBPACK_IMPORTED_MODULE_4__["enforceSlottedComponentUsage"].call(this);
                        this._inputNode = this.shadowRoot.querySelector("input");
                        setTimeout(function() {
                            _newArrowCheck(this, _this2);
                            if (!this.value && !this.selectedIndex && !this.placeholder) {
                                this.value = this.options[0][this.valueKey];
                            } else if (this.selectedIndex > -1) {
                                this.value = this.options[this.selectedIndex][this.valueKey];
                            } else if (this._preselectedOption) {
                                this.value = this._preselectedOption[this.valueKey];
                            }
                            this._isInitialValueAssigned = true;
                            !this._formAssociatedInput && _utils_form_utils__WEBPACK_IMPORTED_MODULE_5__["createFormAssociatedInput"].call(this, {
                                disabled: !this.value
                            });
                        }.bind(this));
                    }
                }, {
                    key: "disconnectedCallback",
                    value: function disconnectedCallback() {
                        _get(_getPrototypeOf(MdsInlineSelect.prototype), "disconnectedCallback", this) && _get(_getPrototypeOf(MdsInlineSelect.prototype), "disconnectedCallback", this).call(this);
                        MDS.isIOS && document.body.removeEventListener("touchstart", this.iosCloseOnBlur);
                    }
                }, {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        return {
                            interactiveElement: this._inputNode
                        };
                    }
                }, {
                    key: "errorMessageChangedCallback",
                    value: function errorMessageChangedCallback(errorMessage) {
                        if (this._slotParent) {
                            if (errorMessage) {
                                this._slotParent._errorMessages.set(this._slotIndex, {
                                    errorMessage: errorMessage,
                                    errorMessagePrefix: this.errorMessagePrefix
                                });
                            } else {
                                this._slotParent._errorMessages.delete(this._slotIndex);
                            }
                            this._slotParent.errorMessageChangedCallback();
                        }
                    }
                }, {
                    key: "optionsChangedCallback",
                    value: function optionsChangedCallback(newOptions) {
                        var _this3 = this;
                        this._valueMap = {};
                        newOptions.length && newOptions.forEach(function(option, index) {
                            _newArrowCheck(this, _this3);
                            if (option.selected) {
                                this._preselectedOption = option;
                            }
                            this._valueMap[option[this.valueKey]] = index;
                        }.bind(this));
                    }
                }, {
                    key: "selectedIndexChangedCallback",
                    value: function selectedIndexChangedCallback(newSelectedIndex) {
                        if (newSelectedIndex >= 0 && newSelectedIndex < this.options.length) {
                            this.value = this.options[newSelectedIndex][this.valueKey];
                        } else {
                            this.value = "";
                        }
                    }
                }, {
                    key: "valueChangedCallback",
                    value: function valueChangedCallback(newValue) {
                        if (this._valueMap && this._valueMap[newValue] > -1) {
                            this.selectedIndex = this._valueMap[newValue];
                        } else {
                            this.selectedIndex = -1;
                        }
                        this._isInitialValueAssigned && this.dispatchEvent(new CustomEvent("change", {
                            bubbles: true,
                            composed: true
                        }));
                        this._formAssociatedInput && _utils_form_utils__WEBPACK_IMPORTED_MODULE_5__["syncFormAssociatedInputValue"].call(this, newValue);
                    }
                }, {
                    key: "_handleInputClick",
                    value: function _handleInputClick(event) {
                        this._visible ? this.close() : this.open();
                        _get(_getPrototypeOf(MdsInlineSelect.prototype), "_onclick", this) && _get(_getPrototypeOf(MdsInlineSelect.prototype), "_onclick", this).call(this, event);
                    }
                }, {
                    key: "_handleMenuClick",
                    value: function _handleMenuClick(event) {
                        if (event.target.dataset.index) {
                            this.selectedIndex = event.target.dataset.index;
                            this.close(true);
                        }
                        _get(_getPrototypeOf(MdsInlineSelect.prototype), "_onclick", this) && _get(_getPrototypeOf(MdsInlineSelect.prototype), "_onclick", this).call(this, event);
                    }
                }, {
                    key: "_handleMenuBlur",
                    value: function _handleMenuBlur(event) {
                        if (!this.shadowRoot.contains(event.relatedTarget || event.explicitOriginalTarget)) {
                            this.close();
                            _get(_getPrototypeOf(MdsInlineSelect.prototype), "_onblur", this) && _get(_getPrototypeOf(MdsInlineSelect.prototype), "_onblur", this).call(this, event);
                        }
                    }
                }, {
                    key: "_handleInputKeyup",
                    value: function _handleInputKeyup(event) {
                        event.keyCode === 32 && event.preventDefault();
                        _get(_getPrototypeOf(MdsInlineSelect.prototype), "_onkeyup", this) && _get(_getPrototypeOf(MdsInlineSelect.prototype), "_onkeyup", this).call(this, event);
                    }
                }, {
                    key: "_handleInputKeydown",
                    value: function _handleInputKeydown(event) {
                        if (event.keyCode === 32) {
                            event.preventDefault();
                            this.open();
                        }
                        _get(_getPrototypeOf(MdsInlineSelect.prototype), "_onkeydown", this) && _get(_getPrototypeOf(MdsInlineSelect.prototype), "_onkeydown", this).call(this, event);
                    }
                }, {
                    key: "_handleMenuKeydown",
                    value: function _handleMenuKeydown(event) {
                        if ([ 32, 13 ].includes(event.keyCode)) {
                            event.preventDefault();
                            event.target.click();
                        } else if (event.keyCode === 38) {
                            event.preventDefault();
                            this._shiftFocusUp.call(this, parseInt(event.target.dataset.index, 10));
                        } else if (event.keyCode === 40) {
                            event.preventDefault();
                            this._shiftFocusDown.call(this, parseInt(event.target.dataset.index, 10));
                        } else if (event.keyCode === 9) {
                            this.close(true);
                        }
                        _get(_getPrototypeOf(MdsInlineSelect.prototype), "_onkeydown", this) && _get(_getPrototypeOf(MdsInlineSelect.prototype), "_onkeydown", this).call(this, event);
                    }
                }, {
                    key: "_handleMenuKeyup",
                    value: function _handleMenuKeyup(event) {
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["isEscAndShouldClose"])(event) && this.close(true);
                        _get(_getPrototypeOf(MdsInlineSelect.prototype), "_onkeyup", this) && _get(_getPrototypeOf(MdsInlineSelect.prototype), "_onkeyup", this).call(this, event);
                    }
                }, {
                    key: "_shiftFocusDown",
                    value: function _shiftFocusDown(targetIndex) {
                        targetIndex === this._optionNodes.length - 1 ? this._optionNodes[0].focus() : this._optionNodes[targetIndex + 1].focus();
                    }
                }, {
                    key: "_shiftFocusUp",
                    value: function _shiftFocusUp(targetIndex) {
                        targetIndex === 0 ? this._optionNodes[this._optionNodes.length - 1].focus() : this._optionNodes[targetIndex - 1].focus();
                    }
                }, {
                    key: "open",
                    value: function open() {
                        this._visible = true;
                        this._optionNodes = this.shadowRoot.querySelectorAll(".inline-select__option");
                        this._optionNodes.length && this._optionNodes[this.selectedIndex >= 0 ? this.selectedIndex : 0].focus();
                        MDS.isIOS && document.body.addEventListener("touchstart", this._iosCloseOnBlur);
                    }
                }, {
                    key: "close",
                    value: function close(refocus) {
                        this._visible = false;
                        refocus && this._inputNode.focus();
                        MDS.isIOS && document.body.removeEventListener("touchstart", this._iosCloseOnBlur);
                    }
                }, {
                    key: "render",
                    value: function render() {
                        _MdsInlineSelect__WEBPACK_IMPORTED_MODULE_2__["default"].call(this);
                    }
                } ]);
                return MdsInlineSelect;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_0___default.a), _class2.styles = _mds_inline_select_scss__WEBPACK_IMPORTED_MODULE_1___default.a, 
            _class2._parentLocalNames = [ "mds-inline-form" ], _class2)) || _class);
            __webpack_exports__["default"] = MdsInlineSelect;
        },
        "./src/inline-form/inline-select/mds-inline-select.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/inline-form/inline-select/mds-inline-select.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/inline-form/mds-inline-form.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/inline-form/mds-inline-form.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/list/MdsList.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", (function() {
                return renderList;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/data-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _li$wrapper = function _li$wrapper(_listItem$concat, _deferred, _args) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("li", null, null, "class", _listItem$concat);
                _renderArbitrary(_deferred.call(_args[0], _args[1], _args[2]));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("li");
            }, _div$wrapper = function _div$wrapper(_deferred2, _args2) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "list-item--selectable");
                _renderArbitrary(_deferred2.call(_args2[0], _args2[1], _args2[2]));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            };
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function renderHeader() {
                var header = this.header, collapsible = this.collapsible, defaultCollapsed = this.defaultCollapsed, _expanded = this._expanded, _listId = this._listId;
                var expanded = _expanded === undefined ? !defaultCollapsed : _expanded;
                var headerClasses = {
                    list__header: true,
                    "list__header--collapsible": collapsible,
                    "list__header--collapsed": defaultCollapsed
                };
                var chevronClasses = {
                    "list-header__chevron-icon": true,
                    "list-header__chevron-icon--expanded": expanded
                };
                if (collapsible) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("button", null, null, "class", headerClasses, "onclick", this._handleHeaderClick, "aria-expanded", expanded, "aria-controls", _listId);
                    _renderArbitrary(header);
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", chevronClasses, "innerHTML-prop", MDS.svgs.ico_chevron_right, "aria-hidden", "true", "__skip", "true");
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                    return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("button");
                }
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", headerClasses);
                _renderArbitrary(header);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function renderText(listItem, additionalProps) {
                var _secondaryContainerCl;
                var description = listItem.description, descriptionColor = listItem.descriptionColor, label = listItem.label, secondaryDescription = listItem.secondaryDescription, secondaryDescriptionColor = listItem.secondaryDescriptionColor, secondaryLabel = listItem.secondaryLabel, secondaryLabelColor = listItem.secondaryLabelColor, _tagTextValue = listItem._tagTextValue, tagIcon = listItem.tagIcon, tagColor = listItem.tagColor, badge = listItem.badge;
                var condensed = additionalProps.condensed, _showDivider = additionalProps._showDivider, listIsCondensedWithDividers = additionalProps.listIsCondensedWithDividers;
                var textClasses = {
                    "list-item__text": true,
                    "list-item__text--condensed": condensed,
                    "list-item__text--condensed-with-divider": listIsCondensedWithDividers,
                    "list-item__text--primary": true
                };
                var textSecondaryClasses = {
                    "list-item__text": true,
                    "list-item__text--condensed": condensed,
                    "list-item__text--condensed-with-divider": listIsCondensedWithDividers,
                    "list-item__text--secondary": true
                };
                var containerTextClasses = {
                    "list-item__text-container": true,
                    "list-item__text-container--divider": _showDivider
                };
                var secondaryContainerClasses = (_secondaryContainerCl = {}, _defineProperty(_secondaryContainerCl, "list-item__secondary-container--".concat(this.listType), true), 
                _defineProperty(_secondaryContainerCl, "list-item__secondary-container", true), 
                _secondaryContainerCl);
                var listItemBadgeContainer = {
                    "list-item__badge": true,
                    "list-item__badge--withBadgeLabel": badge && badge.labelValue
                };
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", containerTextClasses, "aria-hidden", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", textClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("label", null, null, "innerHTML-prop", label, "for", this.id, "class", "list-item__label", "aria-hidden", "true", "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("label");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "innerHTML-prop", description, "class", "list-item__description list-item__description--".concat(descriptionColor), "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                _renderArbitrary(_tagTextValue && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-tag", null, null, "text", _tagTextValue, "icon", tagIcon, "color", tagColor, "interactive", "false"));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", secondaryContainerClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", textSecondaryClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "innerHTML-prop", secondaryLabel, "class", "list-item__label list-item__label--".concat(secondaryLabelColor), "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "innerHTML-prop", secondaryDescription, "class", "list-item__description list-item__description--".concat(secondaryDescriptionColor), "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                _renderArbitrary(renderBadge(badge, this._selectableListTypes, secondaryDescription, secondaryLabel) && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", listItemBadgeContainer), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-badge", null, null, "label-value", badge.labelValue, "is-animated", badge.isAnimated, "icon", badge.icon, "accessible-name", badge.accessibleName), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function renderBadge(badge, isSelectable, secondaryDescription, secondaryLabel) {
                return badge && !isSelectable && !(secondaryDescription || secondaryLabel);
            }
            function renderListItem(listItem, additionalProps) {
                var icon = listItem.icon, imageUrl = listItem.imageUrl, iconAccessibleDescription = listItem.iconAccessibleDescription, imageAltText = listItem.imageAltText, label = listItem.label, description = listItem.description, _tagTextValue = listItem._tagTextValue, tagAccessibleText = listItem.tagAccessibleText, badge = listItem.badge, secondaryLabel = listItem.secondaryLabel, secondaryDescription = listItem.secondaryDescription, href = listItem.href, navigationalAccessibleDescription = listItem.navigationalAccessibleDescription, imageWidth = listItem.imageWidth, _onclick = listItem._onclick, _onblur = listItem._onblur, _onfocus = listItem._onfocus, _onkeydown = listItem._onkeydown, _onkeyup = listItem._onkeyup, _onmouseout = listItem._onmouseout, _onmouseover = listItem._onmouseover;
                var condensed = additionalProps.condensed, _showDivider = additionalProps._showDivider, listItemNumber = additionalProps.listItemNumber, _multiColumnEnabled = additionalProps._multiColumnEnabled, listIsCondensedWithDividers = additionalProps.listIsCondensedWithDividers;
                var visualClasses = {
                    "list-item__visual-element": true,
                    "list-item__visual-element--condensed": condensed,
                    "list-item__visual-element--divider": _showDivider || _multiColumnEnabled,
                    "list-item__visual-element--condensed-with-divider": listIsCondensedWithDividers
                };
                var navClasses = {
                    "list-item__navigational": true,
                    "list-item__navigational--condensed": condensed,
                    "list-item__navigational--divider": _showDivider || _multiColumnEnabled,
                    "list-item__navigational--condensed-with-divider": listIsCondensedWithDividers,
                    "list-item__navigational--multiColumn": Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["getBreakpoint"])() === "xl" || Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["getBreakpoint"])() === "lg" ? _multiColumnEnabled : false
                };
                this._hideAccessibleText = this.listType !== "navigational" && this.listType !== "read-only";
                var badgeAccessibleText = renderBadge(badge, this._selectableListTypes, secondaryDescription, secondaryLabel) ? badge.accessibleName || badge.labelValue : false;
                var accessibleVisual = imageUrl ? imageAltText : iconAccessibleDescription;
                var tagAccessibleDescription = tagAccessibleText || _tagTextValue;
                var accessibleText = [ accessibleVisual, label, description, tagAccessibleDescription, badgeAccessibleText, secondaryLabel, secondaryDescription ].filter(Boolean).join(", ");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "list-item__container");
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    onclick: _onclick
                }, this._selectableListTypes));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "list-item__input-label-".concat(this.id, "-").concat(listItemNumber));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "accessible-text");
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])("aria-hidden", this._hideAccessibleText));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("span");
                _renderArbitrary(Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_2__["cleanHTML"])(accessibleText));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                _renderArbitrary((imageUrl || icon) && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", visualClasses, "aria-hidden", "true"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("img"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "list-item__image"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("src", imageUrl), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("alt", ""), 
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    width: imageWidth
                }, imageWidth)), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("img"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("img"), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("span"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "list-item__icon"), 
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])("aria-hidden", iconAccessibleDescription)), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("innerHTML-prop", MDS.svgs[icon]), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("__skip", "true"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("span"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                _renderArbitrary(renderText.call(this, listItem, additionalProps));
                _renderArbitrary(this.listType === "navigational" && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("a", null, null, "class", navClasses, "href", href || "javascript:void(0)", "aria-label", navigationalAccessibleDescription, "onclick", _onclick, "onblur", _onblur, "onfocus", _onfocus, "onkeydown", _onkeydown, "onkeyup", _onkeyup, "onmouseover", _onmouseover, "onmouseout", _onmouseout), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "list-item__navigational-icon", "innerHTML-prop", MDS.svgs.ico_chevron_right, "aria-hidden", "true", "__skip", "true"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("a")));
                _renderArbitrary(this._selectableListTypes && renderInputButton.call(this, listItem, additionalProps, this.header));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function renderInputButton(listItem, additionalProps, header) {
                var condensed = additionalProps.condensed, _showDivider = additionalProps._showDivider, listIsCondensedWithDividers = additionalProps.listIsCondensedWithDividers, index = additionalProps.index, listItemNumber = additionalProps.listItemNumber;
                var _onblur = listItem._onblur, _onfocus = listItem._onfocus, _onkeydown = listItem._onkeydown, _onkeyup = listItem._onkeyup, _onclick = listItem._onclick, value = listItem.value, selected = listItem.selected;
                var inputButtonClasses = {
                    "list-item__input-button": true,
                    "list-item__input-button--condensed": condensed,
                    "list-item__input-button--divider": _showDivider,
                    "list-item__input-button--condensed-with-divider": listIsCondensedWithDividers
                };
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", inputButtonClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("input");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "list-item__input");
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    "aria-labelledby": "list-item__input-label-".concat(this.id, "-").concat(listItemNumber)
                }, this._hideAccessibleText));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("type", this.listType === "multi-select" ? "checkbox" : "radio");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "list-item__input-button-".concat(this.id, "-").concat(index));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("name", header);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("value", value);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onchange", this._onchange);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onfocus", _onfocus);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onblur", _onblur);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onkeydown", _onkeydown);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onkeyup", _onkeyup);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onclick", _onclick);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-index", index);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])("checked", selected));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("input");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("input");
                _renderArbitrary((this.listType === "selectable" || this.listType === "single-select") && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "list-item__outer-circle", "aria-hidden", "true"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "list-item__inner-circle"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                _renderArbitrary(this.listType === "quick-select" && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "list-item__quick-select-checkmark", "innerHTML-prop", MDS.svgs.ico_checkmark, "aria-hidden", "true", "__skip", "true"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                _renderArbitrary(this.listType === "multi-select" && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "list-item__multi-select-container", "aria-hidden", "true"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "list-item__multi-select-input", "innerHTML-prop", MDS.svgs.ico_checkmark, "aria-hidden", "true", "__skip", "true"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function renderListItems(panelClasses) {
                var _this = this;
                var condensed = this.condensed, _displayDividers = this._displayDividers, _displayLastDivider = this._displayLastDivider, _listId = this._listId;
                var items = this._itemNodes;
                var total = items.length;
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("ul", null, null, "class", panelClasses, "id", _listId);
                _renderArbitrary(items.map(function(listItem, i) {
                    _newArrowCheck(this, _this);
                    var isLast = items.length === i + 1;
                    var _showDivider = !isLast && _displayDividers || isLast && _displayLastDivider;
                    var listIsCondensedWithDividers = condensed && _showDivider || isLast && condensed && _displayDividers && !_displayLastDivider;
                    var listItemAdditionalProps = {
                        condensed: condensed,
                        _displayLastDivider: _displayLastDivider,
                        _displayDividers: _displayDividers,
                        isLast: isLast,
                        _showDivider: _showDivider,
                        listIsCondensedWithDividers: listIsCondensedWithDividers,
                        total: total,
                        listItemNumber: i + 1
                    };
                    return _jsxWrapper(_li$wrapper, [ "list-item--".concat(this.listType), renderListItem, [ this, listItem, listItemAdditionalProps ] ]);
                }.bind(this)));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("ul");
            }
            function renderSelectable(panelClasses) {
                var _this2 = this;
                var condensed = this.condensed, _displayDividers = this._displayDividers, _displayLastDivider = this._displayLastDivider, _listId = this._listId;
                var items = this._itemNodes;
                var total = items.length;
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("fieldset", null, null, "class", panelClasses, "id", _listId);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("legend", null, null, "class", "accessible-text");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("legend");
                _renderArbitrary(items.map(function(listItem, index) {
                    _newArrowCheck(this, _this2);
                    var isLast = items.length === index + 1;
                    var _showDivider = !isLast && _displayDividers || isLast && _displayLastDivider;
                    var listIsCondensedWithDividers = condensed && _showDivider || isLast && condensed && _displayDividers && !_displayLastDivider;
                    var listItemAdditionalProps = {
                        condensed: condensed,
                        _displayLastDivider: _displayLastDivider,
                        _displayDividers: _displayDividers,
                        _showDivider: _showDivider,
                        listIsCondensedWithDividers: listIsCondensedWithDividers,
                        isLast: isLast,
                        index: index,
                        total: total,
                        listItemNumber: index + 1
                    };
                    return _jsxWrapper(_div$wrapper, [ renderListItem, [ this, listItem, listItemAdditionalProps ] ]);
                }.bind(this)));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("fieldset");
            }
            function renderList() {
                var header = this.header, expanded = this.expanded, _expanding = this._expanding, _collapsing = this._collapsing, _transitioned = this._transitioned, listType = this.listType, _multiColumnEnabled = this._multiColumnEnabled;
                var panelClasses = {
                    "list-item": true,
                    "list-item__multiColumn": Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["getBreakpoint"])() === "xl" || Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["getBreakpoint"])() === "lg" ? _multiColumnEnabled : false,
                    "list-item__panel": true,
                    "list-item__panel--expanded": expanded,
                    "list-item__panel--expanding": _expanding,
                    "list-item__panel--collapsing": _collapsing,
                    "list-item__panel--transitioned": _transitioned,
                    "list-item__panel--multiColumn": Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["getBreakpoint"])() === "xl" || Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["getBreakpoint"])() === "lg" ? _multiColumnEnabled : false
                };
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "list__container");
                _renderArbitrary(header && renderHeader.call(this));
                _renderArbitrary(listType === "read-only" && renderListItems.call(this, panelClasses));
                _renderArbitrary(this._selectableListTypes && renderSelectable.call(this, panelClasses));
                _renderArbitrary(listType === "navigational" && renderListItems.call(this, panelClasses));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "hidden", "true");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
        },
        "./src/list/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_list_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/list/mds-list.scss");
            var _mds_list_scss__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_list_scss__WEBPACK_IMPORTED_MODULE_1__);
            var _list_item__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/list/list-item/index.js");
            var _utils_form_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/form-utils.js");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/common-utils.js");
            var _MdsList__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/list/MdsList.jsx");
            var _tag__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/tag/index.jsx");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["mixins"].AttributeMarshallingMixin, arrayOf = _mixins$AttributeMars.arrayOf, boolean = _mixins$AttributeMars.boolean, string = _mixins$AttributeMars.string, number = _mixins$AttributeMars.number, enumerables = _mixins$AttributeMars.enumerables;
            var entity = {
                header: string,
                collapsible: boolean.defaultsTo(false),
                defaultCollapsed: boolean.defaultsTo(false).withChangedCallback(),
                listType: enumerables(string, "read-only", "navigational", "selectable", "single-select", "multi-select", "quick-select").defaultsTo("read-only"),
                selectedIndex: number.defaultsTo(-1).withChangedCallback(),
                selectedIndices: arrayOf(number).defaultsTo([]).withChangedCallback(),
                selectedRadio: string.defaultsTo("").withChangedCallback(),
                condensed: boolean.defaultsTo(false).withChangedCallback(),
                showDividers: boolean.withChangedCallback(),
                showLastDivider: boolean.defaultsTo(false).withChangedCallback(),
                multiColumnEnabled: boolean.defaultsTo(false)
            };
            var MdsList = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsList, _AgaveComponent);
                _createClass(MdsList, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsList";
                    }
                } ]);
                function MdsList() {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsList);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsList).call(this));
                    _this.defineObservedProperty("_listId", "mds-list__list-items");
                    _this.defineObservedProperty("_multiColumnEnabled", false);
                    _this.defineObservedProperty("_expanding", false);
                    _this.defineObservedProperty("_collapsing", false);
                    _this.defineObservedProperty("_transitioned", false);
                    _this.defineObservedProperty("_slotChanged", false);
                    _this.defineObservedProperty("_displayDividers", false);
                    _this.defineObservedProperty("_displayLastDivider", false);
                    _this.defineObservedProperty("rerender", false);
                    _this.defineObservedProperty("selectedItems", new Map);
                    _this._handleHeaderClick = _this._handleHeaderClick.bind(_assertThisInitialized(_this));
                    _this._handleSelection = _this._handleSelection.bind(_assertThisInitialized(_this));
                    _this._handleUnselection = _this._handleUnselection.bind(_assertThisInitialized(_this));
                    _this._handleSlotChange = _this._handleSlotChange.bind(_assertThisInitialized(_this));
                    _this._onchange = _this._onchange.bind(_assertThisInitialized(_this));
                    _this._onfocus = _this._onfocus.bind(_assertThisInitialized(_this));
                    _this._onblur = _this._onblur.bind(_assertThisInitialized(_this));
                    _this._onkeydown = _this._onkeydown.bind(_assertThisInitialized(_this));
                    _this._onkeyup = _this._onkeyup.bind(_assertThisInitialized(_this));
                    _this._dispatchExpandEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "expand";
                    }.bind(this), _assertThisInitialized(_this));
                    _this._dispatchCollapseEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "collapse";
                    }.bind(this), _assertThisInitialized(_this));
                    _this._validateShowDividers = _this._validateShowDividers.bind(_assertThisInitialized(_this));
                    _this._validateShowLastDivider = _this._validateShowLastDivider.bind(_assertThisInitialized(_this));
                    _this._validateDividerLogic = _this._validateDividerLogic.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsList, [ {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        var interactiveElement;
                        if (typeof payload.index === "number") {
                            interactiveElement = this.shadowRoot.querySelectorAll("a")[payload.index] || this.shadowRoot.querySelectorAll("input")[payload.index];
                        } else {
                            interactiveElement = this.shadowRoot.querySelector("button");
                        }
                        return {
                            interactiveElement: interactiveElement
                        };
                    }
                }, {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsList.prototype), "connectedCallback", this).call(this);
                        this.shadowRoot.addEventListener("slotchange", this._handleSlotChange);
                        this.addEventListener("selected", this._handleSelection);
                        this.addEventListener("unselected", this._handleUnselection);
                        this._expanded = this._expanded || !this.defaultCollapsed;
                        this.listType === "selectable" && console.warn("The 'selectable' list type is deprecated to 'single-select'.");
                        this._singleSelectListTypes && !this._formAssociatedInput && _utils_form_utils__WEBPACK_IMPORTED_MODULE_3__["createFormAssociatedInput"].call(this, {
                            value: this.selectedRadio,
                            name: this.header
                        });
                        this.listType === "multi-select" && !this._formAssociatedInput && _utils_form_utils__WEBPACK_IMPORTED_MODULE_3__["createFormAssociatedInput"].call(this, {
                            value: this.selectedIndices,
                            name: this.header
                        });
                        this._panel = this.shadowRoot.querySelector(".list-item__panel");
                        if (!this._expanded) {
                            this._panel.style.display = "none";
                        }
                        this._validateShowDividers();
                    }
                }, {
                    key: "_validateShowDividers",
                    value: function _validateShowDividers() {
                        if (this.showDividers !== undefined) {
                            this._displayDividers = this.showDividers;
                        } else {
                            this._displayDividers = !this.condensed;
                        }
                    }
                }, {
                    key: "_validateShowLastDivider",
                    value: function _validateShowLastDivider() {
                        if (!this._displayDividers && this.showLastDivider) {
                            console.warn("The showLastDivider property can only be set to true, if showDividers = true.");
                            this._displayLastDivider = false;
                        } else {
                            this._displayLastDivider = this.showLastDivider;
                        }
                    }
                }, {
                    key: "_validateDividerLogic",
                    value: function _validateDividerLogic() {
                        this._validateShowDividers();
                        this._validateShowLastDivider();
                    }
                }, {
                    key: "condensedChangedCallback",
                    value: function condensedChangedCallback() {
                        this._validateDividerLogic();
                    }
                }, {
                    key: "showDividersChangedCallback",
                    value: function showDividersChangedCallback() {
                        this._validateDividerLogic();
                    }
                }, {
                    key: "showLastDividerChangedCallback",
                    value: function showLastDividerChangedCallback() {
                        this._validateShowLastDivider();
                    }
                }, {
                    key: "defaultCollapsedChangedCallback",
                    value: function defaultCollapsedChangedCallback(newValue) {
                        if (!this._expanded) {
                            this._expanded = !newValue;
                        }
                    }
                }, {
                    key: "selectedIndexChangedCallback",
                    value: function selectedIndexChangedCallback(newValue) {
                        var _this3 = this;
                        var items = this.querySelectorAll("mds-list-item");
                        if (newValue <= -1 || newValue >= items.length) {
                            this.selectIndex = -1;
                            this.selectedRadio = "";
                            if (newValue !== -1) {
                                console.warn("selectedIndex not found in list");
                            }
                        }
                        items.forEach(function(item, index) {
                            _newArrowCheck(this, _this3);
                            item.setAttribute("selected", !!(index === newValue));
                            if (index === newValue) {
                                this.selectedRadio = item.value;
                            }
                        }.bind(this));
                    }
                }, {
                    key: "selectedRadioChangedCallback",
                    value: function selectedRadioChangedCallback(newValue) {
                        var _this4 = this;
                        var selectedRadio = this._itemNodes.findIndex(function(input) {
                            _newArrowCheck(this, _this4);
                            return input.value === newValue;
                        }.bind(this));
                        if (this.selectedIndex !== selectedRadio) {
                            this.selectedIndex = selectedRadio;
                        }
                    }
                }, {
                    key: "selectedIndicesChangedCallback",
                    value: function selectedIndicesChangedCallback(newValue) {
                        var items = this._itemNodes;
                        if (this._singleSelectListTypes && newValue.length && this.selectedIndex !== newValue[0]) {
                            this.selectedIndex = newValue[0];
                        }
                    }
                }, {
                    key: "_onchange",
                    value: function _onchange(event) {
                        event.type !== "change" && _get(_getPrototypeOf(MdsList.prototype), "_onchange", this) && _get(_getPrototypeOf(MdsList.prototype), "_onchange", this).call(this, event);
                    }
                }, {
                    key: "_handleHeaderClick",
                    value: function _handleHeaderClick(event) {
                        !this._expanded ? this.expand(event) : this.collapse(event);
                        _get(_getPrototypeOf(MdsList.prototype), "_onclick", this) && _get(_getPrototypeOf(MdsList.prototype), "_onclick", this).call(this, event);
                    }
                }, {
                    key: "_handleSelection",
                    value: function _handleSelection(event) {
                        var _this5 = this;
                        var targetIndex = this._itemNodes.indexOf(event.target);
                        if (this._singleSelectListTypes) {
                            this.selectedItems.forEach(function(item) {
                                _newArrowCheck(this, _this5);
                                return item.selected = false;
                            }.bind(this));
                        }
                        this.selectedItems.set(targetIndex, event.target);
                        this._setSelectedItems();
                    }
                }, {
                    key: "_handleUnselection",
                    value: function _handleUnselection(event) {
                        var targetIndex = this._itemNodes.indexOf(event.target);
                        this.selectedItems.delete(targetIndex);
                        this._setSelectedItems();
                    }
                }, {
                    key: "_setSelectedItems",
                    value: function _setSelectedItems() {
                        this.selectedItems = new Map(this.selectedItems);
                    }
                }, {
                    key: "selectedItemsChangedCallback",
                    value: function selectedItemsChangedCallback() {
                        this.selectedIndices = _toConsumableArray(this.selectedItems.keys()).sort();
                        this._singleSelectListTypes && this._formAssociatedInput && _utils_form_utils__WEBPACK_IMPORTED_MODULE_3__["syncFormAssociatedInputValue"].call(this, this.selectedRadio);
                        this.listType === "multi-select" && this._formAssociatedInput && _utils_form_utils__WEBPACK_IMPORTED_MODULE_3__["syncFormAssociatedInputValue"].call(this, this.selectedIndices);
                    }
                }, {
                    key: "_handleSlotChange",
                    value: function _handleSlotChange() {
                        var _this6 = this;
                        if (this._selectableListTypes) {
                            this.selectedItems.clear();
                            this._itemNodes.forEach(function(item, index) {
                                _newArrowCheck(this, _this6);
                                if (item.selected === true || item.selected === "true") {
                                    this.selectedItems.set(index, item);
                                }
                            }.bind(this));
                            this._setSelectedItems();
                        }
                        this._slotChanged = !this._slotChanged;
                    }
                }, {
                    key: "expand",
                    value: function expand(event) {
                        var _this7 = this;
                        if (!this._expanded) {
                            this._expanded = true;
                            if (this._multiColumnEnabled) {
                                this._panel.style.display = "grid";
                            } else {
                                this._panel.style.display = "block";
                            }
                            this._panel.style.height = 0;
                            window.setTimeout(function() {
                                _newArrowCheck(this, _this7);
                                this._expanding = false;
                                this._transitioned = true;
                                this._calculatePanelHeight();
                                event && this._dispatchExpandEvent({
                                    target: this,
                                    detail: event
                                });
                                event && this.focus();
                            }.bind(this), 50);
                        }
                    }
                }, {
                    key: "collapse",
                    value: function collapse(event) {
                        var _this8 = this;
                        if (this._expanded) {
                            this._expanded = false;
                            var panelHeight = this._panel.scrollHeight;
                            this._panel.style.height = "".concat(panelHeight, "px");
                            window.setTimeout(function() {
                                _newArrowCheck(this, _this8);
                                this._collapsing = true;
                                this._panel.style.height = 0;
                            }.bind(this), 10);
                            window.setTimeout(function() {
                                _newArrowCheck(this, _this8);
                                this._collapsing = false;
                                this._transitioned = false;
                                this._panel.style.height = "auto";
                                this._panel.style.display = "none";
                                event && this._dispatchCollapseEvent({
                                    target: this,
                                    detail: event
                                });
                                event && this.focus();
                            }.bind(this), 200);
                        }
                    }
                }, {
                    key: "_calculatePanelHeight",
                    value: function _calculatePanelHeight() {
                        if (this._multiColumnEnabled) {
                            this._panel.style.display = "grid";
                        } else {
                            this._panel.style.display = "block";
                        }
                        this._panel.style.height = "initial";
                    }
                }, {
                    key: "render",
                    value: function render() {
                        return _MdsList__WEBPACK_IMPORTED_MODULE_5__["default"].call(this);
                    }
                }, {
                    key: "_itemNodes",
                    get: function get() {
                        return _toConsumableArray(this.querySelectorAll("mds-list-item"));
                    }
                }, {
                    key: "_selectableListTypes",
                    get: function get() {
                        return this.listType === "multi-select" || this._singleSelectListTypes;
                    }
                }, {
                    key: "_singleSelectListTypes",
                    get: function get() {
                        return this.listType === "selectable" || this.listType === "single-select" || this.listType === "quick-select";
                    }
                } ]);
                return MdsList;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["AgaveComponent"]), _class2.styles = _mds_list_scss__WEBPACK_IMPORTED_MODULE_1___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsList;
        },
        "./src/list/list-item/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            var _badge__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/badge/index.jsx");
            var _utils_allowLists__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/allowLists.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["mixins"].AttributeMarshallingMixin, boolean = _mixins$AttributeMars.boolean, satisfies = _mixins$AttributeMars.satisfies, string = _mixins$AttributeMars.string, enumerables = _mixins$AttributeMars.enumerables, number = _mixins$AttributeMars.number;
            var entity = {
                label: string.withHTML(_utils_allowLists__WEBPACK_IMPORTED_MODULE_3__["base"]),
                description: string.withHTML(_utils_allowLists__WEBPACK_IMPORTED_MODULE_3__["base"], _utils_allowLists__WEBPACK_IMPORTED_MODULE_3__["layout"]),
                descriptionColor: enumerables(string, "regular", "subdued", "gain", "loss").defaultsTo("subdued"),
                secondaryLabel: string.withHTML(_utils_allowLists__WEBPACK_IMPORTED_MODULE_3__["base"]),
                secondaryLabelColor: enumerables(string, "regular", "subdued", "gain", "loss").defaultsTo("regular"),
                secondaryDescription: string.withHTML(_utils_allowLists__WEBPACK_IMPORTED_MODULE_3__["base"]),
                secondaryDescriptionColor: enumerables(string, "regular", "subdued", "gain", "loss").defaultsTo("subdued"),
                imageUrl: string,
                imageWidth: number.withMaxSize(96),
                icon: string,
                iconAccessibleDescription: string,
                imageAltText: string,
                value: string,
                selected: boolean.defaultsTo(false).withChangedCallback(),
                tag: string.defaultsTo(null).withChangedCallback(),
                tagText: string.defaultsTo(null).withChangedCallback(),
                tagColor: enumerables(string, "base", "accent").defaultsTo("base"),
                tagIcon: string.defaultsTo(null),
                tagAccessibleText: string.defaultsTo(null),
                href: string,
                navigationalAccessibleDescription: string,
                accessibleTextCardinalitySeparator: string.defaultsTo("of"),
                badge: satisfies(_badge__WEBPACK_IMPORTED_MODULE_2__["entity"])
            };
            var MdsListItem = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsListItem, _AgaveComponent);
                _createClass(MdsListItem, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsListItem";
                    }
                } ]);
                function MdsListItem() {
                    var _this;
                    _classCallCheck(this, MdsListItem);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsListItem).call(this));
                    _this._onchange = _this._onchange.bind(_assertThisInitialized(_this));
                    _this._onfocus = _this._onfocus.bind(_assertThisInitialized(_this));
                    _this._onblur = _this._onblur.bind(_assertThisInitialized(_this));
                    _this._onkeydown = _this._onkeydown.bind(_assertThisInitialized(_this));
                    _this._onkeyup = _this._onkeyup.bind(_assertThisInitialized(_this));
                    _this._onclick = _this._onclick.bind(_assertThisInitialized(_this));
                    _this._onmousedown = _this._onmousedown.bind(_assertThisInitialized(_this));
                    _this._onmouseup = _this._onmouseup.bind(_assertThisInitialized(_this));
                    _this._onmouseover = _this._onmouseover.bind(_assertThisInitialized(_this));
                    _this._onmouseenter = _this._onmouseenter.bind(_assertThisInitialized(_this));
                    _this._onmouseout = _this._onmouseout.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsListItem, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        var _this2 = this;
                        _get(_getPrototypeOf(MdsListItem.prototype), "connectedCallback", this).call(this);
                        setTimeout(function() {
                            _newArrowCheck(this, _this2);
                            if (this.imageUrl && this.icon) {
                                this.throwConstraintError("Image and icon can not be passed in together");
                            }
                        }.bind(this));
                        this._parent = this.parentElement;
                    }
                }, {
                    key: "renderedCallback",
                    value: function renderedCallback() {
                        if (this._parent) {
                            this._parent.rerender = !this._parent.rerender;
                        }
                    }
                }, {
                    key: "_onclick",
                    value: function _onclick(event) {
                        var _this3 = this;
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this3);
                            return "click";
                        }.bind(this), this)({
                            target: this
                        });
                        if (this._parent._selectableListTypes) {
                            if (this._parent._singleSelectListTypes && this.selected === false || this._parent.listType === "multi-select") {
                                _get(_getPrototypeOf(MdsListItem.prototype), "_onchange", this) && _get(_getPrototypeOf(MdsListItem.prototype), "_onchange", this).call(this, event);
                            }
                            this.selected = this._parent.listType === "multi-select" ? !this.selected : true;
                            var currentTarget = event.currentTarget;
                            var selectedInput = currentTarget.type === "radio" || currentTarget.type === "checkbox" ? currentTarget : currentTarget.querySelector("input");
                            selectedInput.focus();
                        }
                    }
                }, {
                    key: "selectedChangedCallback",
                    value: function selectedChangedCallback(selected) {
                        var _this4 = this;
                        if (this._parent) {
                            Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["createCustomEventDispatcher"])(function() {
                                _newArrowCheck(this, _this4);
                                return selected ? "selected" : "unselected";
                            }.bind(this), this)({
                                target: this
                            });
                        }
                    }
                }, {
                    key: "tagChangedCallback",
                    value: function tagChangedCallback() {
                        if (this.tagText === null) {
                            this._tagTextValue = this.tag;
                        }
                        console.warn('"tag" is deprecated since v10.0.0, use "tagText" instead.');
                    }
                }, {
                    key: "tagTextChangedCallback",
                    value: function tagTextChangedCallback() {
                        this._tagTextValue = this.tagText;
                    }
                } ]);
                return MdsListItem;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["AgaveComponent"]), _class2._parentLocalNames = [ "mds-list" ], 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsListItem;
        },
        "./src/list/mds-list.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/list/mds-list.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/load-more/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_load_more_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/load-more/mds-load-more.scss");
            var _mds_load_more_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_load_more_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].boolean, string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].stringRequired;
            var entity = {
                ctaText: stringRequired,
                hideCta: boolean.defaultsTo(false).withChangedCallback(),
                horizontalRule: boolean.defaultsTo(false),
                statusText: string,
                statusAccessibleText: string
            };
            var MdsLoadMore = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsLoadMore, _AgaveComponent);
                _createClass(MdsLoadMore, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsLoadMore";
                    }
                } ]);
                function MdsLoadMore() {
                    var _this;
                    _classCallCheck(this, MdsLoadMore);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsLoadMore).call(this));
                    _this._handleButtonClick = _this._handleButtonClick.bind(_assertThisInitialized(_this));
                    _this._onblur = _this._onblur.bind(_assertThisInitialized(_this));
                    _this._onfocus = _this._onfocus.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsLoadMore, [ {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        var query = payload.target ? "#".concat(payload.target) : "mds-button";
                        return {
                            interactiveElement: this.shadowRoot.querySelector(query)
                        };
                    }
                }, {
                    key: "_handleButtonClick",
                    value: function _handleButtonClick(event) {
                        _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["setAriaLiveText"].call(this);
                        _get(_getPrototypeOf(MdsLoadMore.prototype), "_onclick", this) && _get(_getPrototypeOf(MdsLoadMore.prototype), "_onclick", this).call(this, event);
                    }
                }, {
                    key: "hideCtaChangedCallback",
                    value: function hideCtaChangedCallback() {
                        var _this2 = this;
                        this.hideCta && setTimeout(function() {
                            _newArrowCheck(this, _this2);
                            var statusText = this.shadowRoot.querySelector(".load-more__status-text");
                            statusText ? statusText.focus({
                                preventScroll: true
                            }) : this.throwConstraintError("statusText is required if the CTA is hidden.");
                        }.bind(this));
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var containerCasses = {
                            "load-more": true,
                            "load-more__horizontal-rule": this.horizontalRule
                        };
                        var buttonClasses = {
                            "load-more__button": true,
                            "load-more__button--without-status-text": !this.statusText
                        };
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", containerCasses, "onclick", _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["stopPropagation"]);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "load-more__accessible-text", "aria-live", "polite", "aria-atomic", "true");
                        _renderArbitrary(this._ariaLiveActive && this.statusText || this.statusAccessibleText);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        _renderArbitrary(this.statusText && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "load-more__status-text", "id", "status-text", "aria-hidden", "true", "tabindex", "-1"), 
                        _renderArbitrary(this.statusText), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        _renderArbitrary(!this.hideCta && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-button", null, null, "class", buttonClasses, "text", this.ctaText, "variant", "secondary", "accessible-text", this.statusText || this.statusAccessibleText, "onclick", this._handleButtonClick, "onfocus", this._onfocus, "onblur", this._onblur));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return MdsLoadMore;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_load_more_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsLoadMore;
        },
        "./src/load-more/mds-load-more.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/load-more/mds-load-more.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/loading-bubble/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_loading_bubble_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/loading-bubble/mds-loading-bubble.scss");
            var _mds_loading_bubble_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_loading_bubble_scss__WEBPACK_IMPORTED_MODULE_2__);
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].boolean, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].enumerables;
            var entity = {
                variant: enumerables(string, "agent", "assistant").defaultsTo("assistant"),
                firstInGroup: boolean
            };
            var MdsLoadingBubble = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsLoadingBubble, _AgaveComponent);
                function MdsLoadingBubble() {
                    _classCallCheck(this, MdsLoadingBubble);
                    return _possibleConstructorReturn(this, _getPrototypeOf(MdsLoadingBubble).apply(this, arguments));
                }
                _createClass(MdsLoadingBubble, [ {
                    key: "render",
                    value: function render() {
                        var _classes;
                        var variant = this.variant, firstInGroup = this.firstInGroup;
                        var classes = (_classes = {
                            "mds-loading-bubble": true
                        }, _defineProperty(_classes, "mds-loading-bubble--".concat(variant), true), _defineProperty(_classes, "mds-loading-bubble--first", firstInGroup), 
                        _classes);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "mds-loading-bubble__dot");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "mds-loading-bubble__dot");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "mds-loading-bubble__dot");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ], [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsLoadingBubble";
                    }
                } ]);
                return MdsLoadingBubble;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_loading_bubble_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsLoadingBubble;
        },
        "./src/loading-bubble/mds-loading-bubble.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/loading-bubble/mds-loading-bubble.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/map-static/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_map_static_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/map-static/mds-map-static.scss");
            var _mds_map_static_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_map_static_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/data-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _dec, _class, _class2;
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var arrayOf = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].arrayOf, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].boolean, number = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].number, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].enumerables, satisfies = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].satisfies, string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].stringRequired;
            var mapDimensions = {
                minHeight: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_4__["cleanCssToPx"])("128px"),
                maxHeight: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_4__["cleanCssToPx"])("640px"),
                minWidth: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_4__["cleanCssToPx"])("128px"),
                maxWidth: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_4__["cleanCssToPx"])("640px")
            };
            var markerEntity = {
                address: string,
                latitude: number,
                longitude: number
            };
            var entity = {
                accessibleText: stringRequired,
                accessibleDescription: string,
                apiKey: stringRequired,
                channel: string,
                centerAddress: string,
                centerCoordinates: arrayOf(number).withMinLength(2).withMaxLength(2),
                scale: enumerables(number, 1, 2).defaultsTo(2),
                format: enumerables(string, "png", "png32", "jpg", "gif").defaultsTo("png"),
                markers: arrayOf(satisfies(markerEntity)),
                height: number.withMinSize(mapDimensions.minHeight).withMaxSize(mapDimensions.maxHeight).defaultsTo(mapDimensions.minHeight),
                width: number.withMinSize(mapDimensions.minWidth).withMaxSize(mapDimensions.maxWidth).defaultsTo(mapDimensions.minWidth),
                zoom: number.defaultsTo(10).withMinSize(1).withMaxSize(20),
                manualInitialRender: boolean
            };
            var MdsMapStatic = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsMapStatic, _AgaveComponent);
                _createClass(MdsMapStatic, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsMapStatic";
                    }
                } ]);
                function MdsMapStatic() {
                    var _this;
                    _classCallCheck(this, MdsMapStatic);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsMapStatic).call(this));
                    _this.defineObservedProperty("_renderTriggered");
                    return _this;
                }
                _createClass(MdsMapStatic, [ {
                    key: "renderMap",
                    value: function renderMap() {
                        this._renderTriggered = true;
                    }
                }, {
                    key: "_isMapReady",
                    value: function _isMapReady() {
                        this._hasCenter = this.centerAddress || this.centerCoordinates || this.markers && this.markers.length;
                        return [ this.apiKey, this.accessibleText, this._hasCenter, this.format, this.scale, this.height, this.width, this.zoom ].every(Boolean);
                    }
                }, {
                    key: "_generateMarkerString",
                    value: function _generateMarkerString() {
                        var _this2 = this;
                        return this.markers.reduce(function(acc, _ref) {
                            var latitude = _ref.latitude, longitude = _ref.longitude, address = _ref.address;
                            _newArrowCheck(this, _this2);
                            var position;
                            if (address) {
                                position = encodeURI(address);
                            } else if (latitude && longitude) {
                                position = "".concat(latitude, ",").concat(longitude);
                            } else {
                                this.throwConstraintError("Each marker must have either address or latitude + longitude.");
                            }
                            acc += "markers=size:mid%7Ccolor:0x".concat(MdsMapStatic._markerColors[MDS.brand || "cmb"].slice(1), "%7C").concat(position, "&");
                            return acc;
                        }.bind(this), "");
                    }
                }, {
                    key: "_generateCenterString",
                    value: function _generateCenterString() {
                        var center = this.centerCoordinates ? this.centerCoordinates.join() : encodeURI(this.centerAddress);
                        return "center=".concat(center, "&");
                    }
                }, {
                    key: "_generateSrc",
                    value: function _generateSrc() {
                        return "https://maps.googleapis.com/maps/api/staticmap?\n      ".concat(this.centerAddress || this.centerCoordinates ? this._generateCenterString() : "", "\n      ").concat(this.markers && this.markers.length ? this._generateMarkerString() : "", "\n      format=").concat(this.format, "&\n      scale=").concat(this.scale, "&\n      size=").concat(this.width, "x").concat(this.height, "&\n      zoom=").concat(this.zoom, "&\n      maptype=roadmap&\n      style=feature:poi|visibility:off&\n      style=feature:transit|visibility:off&\n      key=").concat(this.apiKey, "\n      ").concat(this.channel ? "&channel=".concat(this.channel) : "", "\n    ").replace(/\s/g, "");
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var shouldRender = this.manualInitialRender ? this._renderTriggered : this._isMapReady();
                        if (shouldRender) {
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "map-static");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("img");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("alt", this.accessibleText);
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("src", this._generateSrc());
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("height", this.height);
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("width", this.width);
                            _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                                "aria-describedby": "".concat(this.id, "-accessible-description")
                            }, this.accessibleDescription));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("img");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("img");
                            _renderArbitrary(this.accessibleDescription && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text", "id", "".concat(this.id, "-accessible-description")), 
                            _renderArbitrary(this.accessibleDescription), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                            return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        }
                        return null;
                    }
                } ]);
                return MdsMapStatic;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["AgaveComponent"]), _class2.styles = _mds_map_static_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2._markerColors = {
                bcb: "#0b366a",
                cmb: "#005eb8",
                cpc: "#223853",
                cpo: "#0846a8",
                jpo: "#3a2206"
            }, _class2)) || _class);
            __webpack_exports__["default"] = MdsMapStatic;
        },
        "./src/map-static/mds-map-static.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/map-static/mds-map-static.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/map/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _marker_manager__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/map/marker-manager.js");
            var _map_marker_marker_wrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/map/map-marker/marker-wrapper.js");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/data-utils.js");
            var _mds_map_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/map/mds-map.scss");
            var _mds_map_scss__WEBPACK_IMPORTED_MODULE_6___default = __webpack_require__.n(_mds_map_scss__WEBPACK_IMPORTED_MODULE_6__);
            var _map_marker__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/map/map-marker/index.jsx");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            function _construct(Parent, args, Class) {
                if (_isNativeReflectConstruct()) {
                    _construct = Reflect.construct.bind();
                } else {
                    _construct = function _construct(Parent, args, Class) {
                        var a = [ null ];
                        a.push.apply(a, args);
                        var Constructor = Function.bind.apply(Parent, a);
                        var instance = new Constructor;
                        if (Class) _setPrototypeOf(instance, Class.prototype);
                        return instance;
                    };
                }
                return _construct.apply(null, arguments);
            }
            function _isNativeReflectConstruct() {
                if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                if (Reflect.construct.sham) return false;
                if (typeof Proxy === "function") return true;
                try {
                    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function() {})));
                    return true;
                } catch (e) {
                    return false;
                }
            }
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            var arrayOf = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].arrayOf, number = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].number, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].enumerables, string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].stringRequired, satisfies = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].satisfies;
            var restrictedBoundsEntity = {
                north: number,
                south: number,
                west: number,
                east: number
            };
            var entity = {
                accessibleText: stringRequired,
                apiKey: string.withChangedCallback(),
                channel: string,
                defaultCenter: arrayOf(number).withMinLength(2).withMaxLength(2).withChangedCallback(),
                defaultZoom: number.defaultsTo(10).withMinSize(1).withMaxSize(20).withChangedCallback(),
                markerIcon: enumerables.apply(void 0, [ string ].concat(_toConsumableArray(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["ICON_TYPES"]))).withChangedCallback(),
                restrictedBounds: satisfies(restrictedBoundsEntity),
                zoomInAccessibleText: stringRequired,
                zoomOutAccessibleText: stringRequired,
                height: number.withMinSize(Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_5__["cleanCssValue"])("320px")),
                width: number.withMinSize(Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_5__["cleanCssValue"])("280px"))
            };
            var MdsMap = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsMap, _AgaveComponent);
                _createClass(MdsMap, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsMap";
                    }
                }, {
                    key: "_init",
                    value: function _init() {
                        MDS._map.googleMaps = google.maps;
                        MDS._map.Marker = Object(_map_marker_marker_wrapper__WEBPACK_IMPORTED_MODULE_3__["default"])();
                        window.dispatchEvent(new CustomEvent("googlemapsload"));
                    }
                } ]);
                function MdsMap() {
                    var _this;
                    _classCallCheck(this, MdsMap);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsMap).call(this));
                    _this._handleGoogleMapsLoad = _this._handleGoogleMapsLoad.bind(_assertThisInitialized(_this));
                    _this._isMobileXsScreen = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["getBreakpoint"])() === "xs" && MDS.isMobile;
                    _this._createMap = _this._createMap.bind(_assertThisInitialized(_this));
                    _this._handleChildAddOrRemove = _this._handleChildAddOrRemove.bind(_assertThisInitialized(_this));
                    _this._handleInitialRender = _this._handleInitialRender.bind(_assertThisInitialized(_this));
                    _this._handleToastClick = _this._handleToastClick.bind(_assertThisInitialized(_this));
                    _this._openMobileOverlay = _this._openMobileOverlay.bind(_assertThisInitialized(_this));
                    _this._closeMobileOverlay = _this._closeMobileOverlay.bind(_assertThisInitialized(_this));
                    _this.apiKeyChangedCallback = _this.apiKeyChangedCallback.bind(_assertThisInitialized(_this));
                    _this.defineObservedProperty("_containerHasFocus");
                    _this.defineObservedProperty("_toastOverlay", {});
                    _this._observer = new MutationObserver(_this._handleChildAddOrRemove);
                    _this.addEventListener("maprendered", _this._handleInitialRender);
                    window.addEventListener("googlemapsload", _this._handleGoogleMapsLoad);
                    if (_this._isMobileXsScreen) {
                        _this.addEventListener("open", _this._openMobileOverlay);
                        _this.addEventListener("close", _this._closeMobileOverlay);
                    }
                    return _this;
                }
                _createClass(MdsMap, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsMap.prototype), "connectedCallback", this).call(this);
                        this._hasConnected = true;
                    }
                }, {
                    key: "disconnectedCallback",
                    value: function disconnectedCallback() {
                        _get(_getPrototypeOf(MdsMap.prototype), "disconnectedCallback", this) && _get(_getPrototypeOf(MdsMap.prototype), "disconnectedCallback", this).call(this);
                        MDS._map.loadScript && MDS._map.loadScript.remove();
                        MDS._map = null;
                    }
                }, {
                    key: "_createMap",
                    value: function _createMap() {
                        var _this2 = this;
                        this._mapTarget = this.shadowRoot.getElementById("map-target");
                        this._markerManager = new _marker_manager__WEBPACK_IMPORTED_MODULE_2__["default"](this._mapTarget);
                        var mapConfig = {
                            center: {
                                lat: this.defaultCenter[0],
                                lng: this.defaultCenter[1]
                            },
                            zoom: this.defaultZoom,
                            streetViewControl: false,
                            mapTypeControl: false,
                            clickableIcons: false,
                            fullscreenControl: false,
                            styles: MdsMap._mapContentStyles
                        };
                        if (this.restrictedBounds) {
                            mapConfig.restriction = {
                                latLngBounds: this.restrictedBounds,
                                strictBounds: true
                            };
                        }
                        this._map = new MDS._map.googleMaps.Map(this._mapTarget, mapConfig);
                        MDS._map.googleMaps.event.addListenerOnce(this._map, "idle", function() {
                            var _this3 = this;
                            _newArrowCheck(this, _this2);
                            return Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["createCustomEventDispatcher"])(function() {
                                _newArrowCheck(this, _this3);
                                return "mapready";
                            }.bind(this), this)({
                                target: this
                            });
                        }.bind(this));
                        MDS._map.googleMaps.event.addListenerOnce(this._map, "tilesloaded", function() {
                            var _this4 = this;
                            _newArrowCheck(this, _this2);
                            return Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["createCustomEventDispatcher"])(function() {
                                _newArrowCheck(this, _this4);
                                return "maprendered";
                            }.bind(this), this)({
                                target: this
                            });
                        }.bind(this));
                        this._initializeMarkers();
                        this._observer.observe(this, {
                            childList: true
                        });
                    }
                }, {
                    key: "_initializeMarkers",
                    value: function _initializeMarkers() {
                        var _this5 = this;
                        var markers = _toConsumableArray(this.children);
                        this._labeledMarkerCount = 0;
                        this._markerWrapperMap = new Map;
                        this._observeChildList = false;
                        var markerAttachedPromises = markers.map(function(markerEl) {
                            var _this6 = this;
                            _newArrowCheck(this, _this5);
                            this._setChildProps(markerEl);
                            var attachedResolver;
                            var attachedPromise = new Promise(function(resolve) {
                                _newArrowCheck(this, _this6);
                                return attachedResolver = resolve;
                            }.bind(this));
                            if (markerEl.address) {
                                if (!this._geocoder) {
                                    this._geocoder = new MDS._map.googleMaps.Geocoder;
                                }
                                this._geocoder.geocode({
                                    address: markerEl.address
                                }, function(results, status) {
                                    _newArrowCheck(this, _this6);
                                    if (status === "OK") {
                                        markerEl._computedLatitude = results[0].geometry.location.lat();
                                        markerEl._computedLongitude = results[0].geometry.location.lng();
                                        this._markerWrapperMap.set(markerEl, new MDS._map.Marker({
                                            map: this._map,
                                            markerEl: markerEl,
                                            attachedResolver: attachedResolver
                                        }));
                                    } else {
                                        markerEl.remove();
                                        attachedResolver();
                                        console.error("Google Maps Geocoder error for address ".concat(markerEl.address, ": ").concat(status));
                                    }
                                }.bind(this));
                            } else {
                                this._markerWrapperMap.set(markerEl, new MDS._map.Marker({
                                    map: this._map,
                                    markerEl: markerEl,
                                    attachedResolver: attachedResolver
                                }));
                            }
                            return attachedPromise;
                        }.bind(this));
                        Promise.all(markerAttachedPromises).then(function() {
                            _newArrowCheck(this, _this5);
                            this._observeChildList = true;
                        }.bind(this));
                    }
                }, {
                    key: "_setChildProps",
                    value: function _setChildProps(markerEl) {
                        if (!markerEl.icon && !this.markerIcon) {
                            this._labeledMarkerCount += 1;
                        }
                        markerEl.setState({
                            _markerIcon: this.markerIcon,
                            _label: this._labeledMarkerCount,
                            _mapContainer: this._mapTarget,
                            _parent: this,
                            _map: this._map,
                            _isMobileXsScreen: this._isMobileXsScreen
                        });
                    }
                }, {
                    key: "_handleChildAddOrRemove",
                    value: function _handleChildAddOrRemove() {
                        if (this._observeChildList) {
                            this.clearMarkers();
                            this._initializeMarkers();
                        }
                    }
                }, {
                    key: "_handleGoogleMapsLoad",
                    value: function _handleGoogleMapsLoad() {
                        this.apiKey = null;
                        this._hasConnected ? this._createMap() : this.addEventListener("connect", this._createMap);
                        window.removeEventListener("googlemapsload", this._handleGoogleMapsLoad);
                    }
                }, {
                    key: "_handleInitialRender",
                    value: function _handleInitialRender() {
                        var _this7 = this;
                        this._setControlButtonAccessibleText();
                        this._tabFocusableMapContainer = this.shadowRoot.querySelector('[tabindex="0"]');
                        if (this._tabFocusableMapContainer) {
                            this._tabFocusableMapContainer.classList.add("map__focusable-container");
                            this._markerManager._mapFocusTarget = this._tabFocusableMapContainer;
                            this._tabFocusableMapContainer.ariaLabel = this.accessibleText;
                            [ "focus", "blur" ].forEach(function(eventType) {
                                var _this8 = this;
                                _newArrowCheck(this, _this7);
                                this._tabFocusableMapContainer.addEventListener(eventType, function() {
                                    _newArrowCheck(this, _this8);
                                    this._containerHasFocus = this.shadowRoot.activeElement === this._tabFocusableMapContainer;
                                }.bind(this));
                            }.bind(this));
                            var iframe = this.shadowRoot.querySelector("iframe");
                            var focusBorderContainer = iframe && iframe.nextElementSibling;
                            if (focusBorderContainer) {
                                focusBorderContainer.style.border = "";
                            }
                        }
                    }
                }, {
                    key: "_setControlButtonAccessibleText",
                    value: function _setControlButtonAccessibleText() {
                        var _this9 = this;
                        setTimeout(function() {
                            var _this10 = this;
                            _newArrowCheck(this, _this9);
                            var zoomInButton = this.shadowRoot.querySelector('[title="Zoom in"]');
                            var zoomOutButton = this.shadowRoot.querySelector('[title="Zoom out"]');
                            zoomInButton && zoomOutButton && [ "ariaLabel", "title" ].forEach(function(attribute) {
                                _newArrowCheck(this, _this10);
                                zoomInButton[attribute] = this.zoomInAccessibleText;
                                zoomOutButton[attribute] = this.zoomOutAccessibleText;
                            }.bind(this));
                        }.bind(this), 1e3);
                    }
                }, {
                    key: "_openMobileOverlay",
                    value: function _openMobileOverlay(event) {
                        var _event$detail$target = event.detail.target, landmarkTitle = _event$detail$target.landmarkTitle, landmarkDetail = _event$detail$target.landmarkDetail;
                        this._toastOverlay = {
                            landmarkTitle: landmarkTitle,
                            landmarkDetail: landmarkDetail,
                            markerRef: event.detail.target
                        };
                    }
                }, {
                    key: "_closeMobileOverlay",
                    value: function _closeMobileOverlay() {
                        this._toastOverlay = {};
                    }
                }, {
                    key: "_handleToastClick",
                    value: function _handleToastClick(event) {
                        if (event.detail.target.id === "overlay-close-button") {
                            this._toastOverlay.markerRef.close();
                        }
                    }
                }, {
                    key: "_setMarkerLabels",
                    value: function _setMarkerLabels() {
                        var _this11 = this;
                        this._labeledMarkerCount = 0;
                        this.markerRefs.forEach(function(markerEl) {
                            _newArrowCheck(this, _this11);
                            if (!markerEl._renderedIcon) {
                                this._labeledMarkerCount += 1;
                                markerEl._label = this._labeledMarkerCount;
                            }
                        }.bind(this));
                    }
                }, {
                    key: "clearMarkers",
                    value: function clearMarkers() {
                        var _this12 = this;
                        this._markerWrapperMap.forEach(function(wrapper) {
                            _newArrowCheck(this, _this12);
                            return wrapper.setMap(null);
                        }.bind(this));
                        this._markerWrapperMap.clear();
                        this._labeledMarkerCount = 0;
                    }
                }, {
                    key: "fitBounds",
                    value: function fitBounds(bounds) {
                        try {
                            this._map.fitBounds(bounds);
                        } catch (e) {
                            console.error("".concat(e.name, ' in MDS Map: Valid argument has north, south, east, west properties of type "number". See https://developers.google.com/maps/documentation/javascript/reference/coordinates#LatLngBoundsLiteral for more information.'));
                        }
                    }
                }, {
                    key: "panTo",
                    value: function panTo(latLng) {
                        try {
                            this._map.panTo(latLng);
                        } catch (e) {
                            console.error("".concat(e.name, ' in MDS Map: Valid argument has lat & lng properties of type "number". See https://developers.google.com/maps/documentation/javascript/reference/coordinates#LatLngBoundsLiteral for more information.'));
                        }
                    }
                }, {
                    key: "addMarker",
                    value: function addMarker(config) {
                        if (!config) {
                            this.throwConstraintError('The "addMarker" method was called without the required "config" argument.');
                        }
                        var markerEl = document.createElement("mds-map-marker");
                        _extends(markerEl, config);
                        this._setChildProps(markerEl);
                        this._markerWrapperMap.set(markerEl, new MDS._map.Marker({
                            map: this._map,
                            markerEl: markerEl
                        }));
                    }
                }, {
                    key: "removeMarker",
                    value: function removeMarker(markerRef) {
                        if (!markerRef) {
                            this.throwConstraintError('The "removeMarker" method was called without the required "markerRef" argument.');
                        }
                        markerRef._wrapper.setMap(null);
                        !markerRef._renderedIcon && this._setMarkerLabels();
                        this._markerWrapperMap.delete(markerRef);
                    }
                }, {
                    key: "apiKeyChangedCallback",
                    value: function apiKeyChangedCallback(apiKey) {
                        if (!MDS._map) {
                            var loadScript = document.createElement("script");
                            loadScript.src = "https://maps.googleapis.com/maps/api/js?v=quarterly&key=".concat(apiKey, "&callback=MDS._map.init");
                            if (this.channel) {
                                loadScript.src += "&channel=".concat(this.channel);
                            }
                            loadScript.defer = true;
                            loadScript.async = true;
                            MDS._map = {
                                init: MdsMap._init,
                                loadScript: loadScript
                            };
                            document.head.appendChild(loadScript);
                        } else if (apiKey) {
                            this._handleGoogleMapsLoad();
                        }
                    }
                }, {
                    key: "defaultCenterChangedCallback",
                    value: function defaultCenterChangedCallback() {
                        this._map && this._map.setCenter(_construct(MDS._map.googleMaps.LatLng, _toConsumableArray(this.defaultCenter)));
                    }
                }, {
                    key: "defaultZoomChangedCallback",
                    value: function defaultZoomChangedCallback() {
                        this._map && this._map.setZoom(this.defaultZoom);
                    }
                }, {
                    key: "markerIconChangedCallback",
                    value: function markerIconChangedCallback() {
                        var _this13 = this;
                        this.markerRefs.forEach(function(marker) {
                            _newArrowCheck(this, _this13);
                            marker._markerIcon = this.markerIcon;
                        }.bind(this));
                        !this.markerIcon && this._setMarkerLabels();
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var mapStyles = {
                            height: "".concat(this.height, "px"),
                            width: "".concat(this.width, "px")
                        };
                        var mapClasses = {
                            map: true,
                            "map--focused": this._containerHasFocus
                        };
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", mapClasses, "style", mapStyles);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "map__container", "id", "map-target", "__skip", "true");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        _renderArbitrary(this._toastOverlay.landmarkTitle && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-map-marker-overlay", null, null, "heading", this._toastOverlay.landmarkTitle, "content", this._toastOverlay.landmarkDetail, "is-mobile", "true", "onclick", this._handleToastClick));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "markerRefs",
                    get: function get() {
                        return _toConsumableArray(this.shadowRoot.querySelectorAll("mds-map-marker"));
                    }
                }, {
                    key: "visibleMarkerRefs",
                    get: function get() {
                        return _toConsumableArray(this.shadowRoot.querySelectorAll("mds-map-marker:not([hidden])"));
                    }
                }, {
                    key: "hiddenMarkerRefs",
                    get: function get() {
                        return _toConsumableArray(this.shadowRoot.querySelectorAll("mds-map-marker[hidden]"));
                    }
                } ]);
                return MdsMap;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["AgaveComponent"]), _class2.styles = _mds_map_scss__WEBPACK_IMPORTED_MODULE_6___default.a, 
            _class2._mapContentStyles = [ {
                featureType: "poi",
                stylers: [ {
                    visibility: "off"
                } ]
            }, {
                featureType: "transit",
                stylers: [ {
                    visibility: "off"
                } ]
            } ], _class2)) || _class);
            __webpack_exports__["default"] = MdsMap;
        },
        "./src/map/map-marker/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_map_marker_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/map/map-marker/mds-map-marker.scss");
            var _mds_map_marker_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_map_marker_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_allowLists__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/allowLists.js");
            var _utils_edge_detection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/edge-detection.js");
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/utils/data-utils.js");
            var _map_marker_overlay__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/map/map-marker/map-marker-overlay/index.jsx");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            var enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].enumerables, number = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].number, string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string;
            var entity = {
                address: string,
                icon: enumerables.apply(void 0, [ string ].concat(_toConsumableArray(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["ICON_TYPES"]))).withChangedCallback(),
                latitude: number,
                longitude: number,
                landmarkTitle: string.withHTML(_utils_allowLists__WEBPACK_IMPORTED_MODULE_4__["base"]),
                landmarkDetail: string.withHTML(_utils_allowLists__WEBPACK_IMPORTED_MODULE_4__["base"], _utils_allowLists__WEBPACK_IMPORTED_MODULE_4__["interactive"], _utils_allowLists__WEBPACK_IMPORTED_MODULE_4__["layout"], _utils_allowLists__WEBPACK_IMPORTED_MODULE_4__["style"]),
                overlayWidth: number.or(string)
            };
            var MdsMapMarker = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsMapMarker, _AgaveComponent);
                _createClass(MdsMapMarker, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsMapMarker";
                    }
                } ]);
                function MdsMapMarker() {
                    var _this;
                    _classCallCheck(this, MdsMapMarker);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsMapMarker).call(this));
                    _this.defineObservedProperty("_positionFlags", {});
                    _this.defineObservedProperty("_showOverlay", false);
                    _this.defineObservedProperty("_markerIcon");
                    _this.defineObservedProperty("_label");
                    _this.defineObservedProperty("_selected");
                    _this._handleCloseButtonClick = _this._handleCloseButtonClick.bind(_assertThisInitialized(_this));
                    _this._handlePinClick = _this._handlePinClick.bind(_assertThisInitialized(_this));
                    _this._onblur = _this._onblur.bind(_assertThisInitialized(_this));
                    _this.close = _this.close.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsMapMarker, [ {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        return {
                            interactiveElement: this.shadowRoot.querySelector("button")
                        };
                    }
                }, {
                    key: "_handlePinClick",
                    value: function _handlePinClick(event) {
                        this.toggle();
                        _get(_getPrototypeOf(MdsMapMarker.prototype), "_onclick", this) && _get(_getPrototypeOf(MdsMapMarker.prototype), "_onclick", this).call(this, event);
                    }
                }, {
                    key: "_handleCloseButtonClick",
                    value: function _handleCloseButtonClick(event) {
                        event.detail.target.id === "overlay-close-button" && this.close(true);
                        _get(_getPrototypeOf(MdsMapMarker.prototype), "_onclick", this) && _get(_getPrototypeOf(MdsMapMarker.prototype), "_onclick", this).call(this, event);
                    }
                }, {
                    key: "_handleOverlayPositioning",
                    value: function _handleOverlayPositioning() {
                        var _this2 = this;
                        var overlay = this.shadowRoot.querySelector("mds-map-marker-overlay");
                        var overlayCloseButton = overlay.shadowRoot.querySelector(".map-marker-overlay__close-button");
                        var pointer = overlay.shadowRoot.querySelector(".map-marker-overlay__caret");
                        var buffer = Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssValue"])("16px");
                        var triggerPosition = this.getBoundingClientRect();
                        var edges = Object(_utils_edge_detection__WEBPACK_IMPORTED_MODULE_5__["getEdges"])(this._mapContainer);
                        this._positionFlags = Object(_utils_edge_detection__WEBPACK_IMPORTED_MODULE_5__["getPositionFlags"])(triggerPosition, overlay, edges, pointer.offsetHeight, 8, "center", "above");
                        if (this._positionFlags.horizontalEdgeCrossed) {
                            var overlayPosition = overlay.getBoundingClientRect();
                            var crossedEdge = triggerPosition.left - edges.left > edges.right - triggerPosition.right ? "right" : "left";
                            var panByX = crossedEdge === "left" ? overlayPosition.left - edges.left - buffer : overlayPosition.right - edges.right + buffer;
                            this._map.panBy(panByX, 0);
                            MDS._map.googleMaps.event.addListenerOnce(this._map, "idle", function() {
                                _newArrowCheck(this, _this2);
                                return overlayCloseButton.focus();
                            }.bind(this));
                        } else {
                            overlayCloseButton.focus();
                        }
                    }
                }, {
                    key: "iconChangedCallback",
                    value: function iconChangedCallback() {
                        this._parent && this._parent._setMarkerLabels();
                    }
                }, {
                    key: "open",
                    value: function open() {
                        var _this3 = this;
                        if (this.landmarkTitle && !this._showOverlay || !this.landmarkTitle && !this._selected) {
                            if (this.landmarkTitle) {
                                this._showOverlay = true;
                                !this._isMobileXsScreen && this._handleOverlayPositioning();
                            } else {
                                this._selected = true;
                            }
                            Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                                _newArrowCheck(this, _this3);
                                return "open";
                            }.bind(this), this)({
                                target: this
                            }, {
                                map: this._parent,
                                target: this
                            });
                        }
                    }
                }, {
                    key: "close",
                    value: function close(focusOnContainer) {
                        var _this4 = this;
                        if (this._showOverlay || this._selected) {
                            if (this.landmarkTitle) {
                                this._showOverlay = false;
                                focusOnContainer && this._parent._tabFocusableMapContainer && this._parent._tabFocusableMapContainer.focus();
                            } else {
                                this._selected = false;
                            }
                            Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                                _newArrowCheck(this, _this4);
                                return "close";
                            }.bind(this), this)({
                                target: this
                            }, {
                                map: this._parent
                            });
                        }
                    }
                }, {
                    key: "toggle",
                    value: function toggle() {
                        this._showOverlay ? this.close() : this.open();
                    }
                }, {
                    key: "bringToCenter",
                    value: function bringToCenter() {
                        this._map.panTo(this._wrapper._position);
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var _MdsMapMarker$_pinSvg = MdsMapMarker._pinSvgStyles, width = _MdsMapMarker$_pinSvg.width, height = _MdsMapMarker$_pinSvg.height;
                        var isOverlayVisible = !this._isMobileXsScreen && this._showOverlay && !!this.landmarkTitle;
                        var buttonClasses = {
                            "map-marker__button": true,
                            "map-marker__button--open": this._showOverlay || this._selected,
                            "map-marker__button--closde": !this._showOverlay
                        };
                        var icon = this._renderedIcon;
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "map-marker", "aria-hidden", "true");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("button", null, null, "class", buttonClasses, "id", "pin-button", "onblur", this._onblur, "onclick", this._handlePinClick, "tabIndex", "-1");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("svg", null, null, "class", "map-marker__pin", "viewBox", "0 0 ".concat(width, " ").concat(height), "version", "1.1", "xmlns", "http://www.w3.org/2000/svg");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("g");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("path", null, null, "d", "M16,0 C24.836556,0 32,7.14662252 32,15.9624282 C32,23.3266049 27.0014245,29.5260433 20.2045329,31.3679988 L15.7804849,38.4 L11.150474,31.1784852 C4.68469288,29.1292563 0,23.0916419 0,15.9624282 C0,7.14662252 7.163444,0 16,0 Z");
                        _renderArbitrary(!icon && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("text", null, null, "x", width / 2, "y", height / 2), 
                        _renderArbitrary(this._label), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("text")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("g");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("svg");
                        _renderArbitrary(!!icon && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "map-marker__icon", "innerHTML-prop", MDS.svgs[icon], "__skip", "true"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("button");
                        _renderArbitrary(isOverlayVisible && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-map-marker-overlay", null, null, "heading", this.landmarkTitle, "content", this.landmarkDetail, "width", this.overlayWidth, "is-mobile", !!this._isMobileXsScreen, "horizontal-position", this._positionFlags.horizontal, "vertical-position", this._positionFlags.vertical, "onclick", this._handleCloseButtonClick));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "_renderedIcon",
                    get: function get() {
                        return this.icon || this._markerIcon;
                    }
                } ]);
                return MdsMapMarker;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_map_marker_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2._pinSvgStyles = {
                height: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssValue"])("39px"),
                width: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssValue"])("32px")
            }, _class2)) || _class);
            __webpack_exports__["default"] = MdsMapMarker;
        },
        "./src/map/map-marker/map-marker-overlay/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_map_marker_overlay_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/map/map-marker/map-marker-overlay/mds-map-marker-overlay.scss");
            var _mds_map_marker_overlay_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_map_marker_overlay_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _dec, _class, _class2;
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].boolean, number = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].number, string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string;
            var entity = {
                heading: string,
                content: string,
                width: number.or(string),
                isMobile: boolean
            };
            var MdsMapMarkerOverlay = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsMapMarkerOverlay, _AgaveComponent);
                _createClass(MdsMapMarkerOverlay, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsMapMarkerOverlay";
                    }
                } ]);
                function MdsMapMarkerOverlay() {
                    var _this;
                    _classCallCheck(this, MdsMapMarkerOverlay);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsMapMarkerOverlay).call(this));
                    _this._onblur = _this._onblur.bind(_assertThisInitialized(_this));
                    _this._onclick = _this._onclick.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsMapMarkerOverlay, [ {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        return {
                            interactiveElement: this.shadowRoot.getElementById("overlay-close-button")
                        };
                    }
                }, {
                    key: "render",
                    value: function render() {
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "map-marker-overlay");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onmousedown", _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["stopPropagation"]);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onmouseup", _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["stopPropagation"]);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onclick", this._onclick);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onblur", this._onblur);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("tabIndex", "-1");
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                            style: {
                                width: Number(this.width) ? "".concat(this.width, "px") : this.width
                            }
                        }, !!this.width && !this.isMobile));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("button", null, null, "id", "overlay-close-button", "class", "map-marker-overlay__close-button", "onblur", this._onblur);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "map-marker-overlay__close-icon", "innerHTML-prop", MDS.svgs["ico_close"], "__skip", "true");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("button");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("p", null, null, "class", "map-marker-overlay__title", "innerHTML-prop", this.heading, "__skip", "true");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("p");
                        _renderArbitrary(this.content && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("p", null, null, "class", "map-marker-overlay__detail", "innerHTML-prop", this.content, "__skip", "true"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("p")));
                        _renderArbitrary(!this.isMobile && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "map-marker-overlay__caret"));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return MdsMapMarkerOverlay;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_map_marker_overlay_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsMapMarkerOverlay;
        },
        "./src/map/map-marker/map-marker-overlay/mds-map-marker-overlay.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/map/map-marker/map-marker-overlay/mds-map-marker-overlay.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/map/map-marker/marker-wrapper.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", (function() {
                return createMarkerWrapper;
            }));
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function createMarkerWrapper() {
                return function(_MDS$_map$googleMaps$) {
                    _inherits(Marker, _MDS$_map$googleMaps$);
                    function Marker(config) {
                        var _this;
                        _classCallCheck(this, Marker);
                        _this = _possibleConstructorReturn(this, _getPrototypeOf(Marker).call(this));
                        var map = config.map, markerEl = config.markerEl, attachedResolver = config.attachedResolver;
                        _this.setMap(map);
                        _this._markerEl = markerEl;
                        _this._markerEl._wrapper = _assertThisInitialized(_this);
                        _this._position = new MDS._map.googleMaps.LatLng({
                            lat: markerEl.latitude || markerEl._computedLatitude,
                            lng: markerEl.longitude || markerEl._computedLongitude
                        });
                        _this._attachedResolver = attachedResolver;
                        Marker.preventMapHitsAndGesturesFrom(_this._markerEl);
                        return _this;
                    }
                    _createClass(Marker, [ {
                        key: "onAdd",
                        value: function onAdd() {
                            this.getPanes().overlayMouseTarget.appendChild(this._markerEl);
                            this._attachedResolver && this._attachedResolver();
                        }
                    }, {
                        key: "draw",
                        value: function draw() {
                            var markerPosition = this.getProjection().fromLatLngToDivPixel(this._position);
                            if (this.map.getBounds().contains(this._position)) {
                                this._markerEl.style.left = "".concat(markerPosition.x, "px");
                                this._markerEl.style.top = "".concat(markerPosition.y, "px");
                                this._markerEl.hidden = false;
                            } else {
                                this._markerEl.hidden = true;
                            }
                        }
                    }, {
                        key: "onRemove",
                        value: function onRemove() {
                            this._markerEl && this._markerEl.remove();
                        }
                    } ]);
                    return Marker;
                }(MDS._map.googleMaps.OverlayView);
            }
        },
        "./src/map/map-marker/mds-map-marker.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/map/map-marker/mds-map-marker.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/map/marker-manager.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", (function() {
                return MarkerManager;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var MarkerManager = function() {
                function MarkerManager(container) {
                    _classCallCheck(this, MarkerManager);
                    this.setOpenMarker = this.setOpenMarker.bind(this);
                    this.closeOpenMarker = this.closeOpenMarker.bind(this);
                    this.handleBlur = this.handleBlur.bind(this);
                    this.handleKeyup = this.handleKeyup.bind(this);
                    this.handleMousedown = this.handleMousedown.bind(this);
                    this.handleMouseup = this.handleMouseup.bind(this);
                    container.addEventListener("open", this.setOpenMarker);
                    container.addEventListener("close", this.closeOpenMarker);
                    container.addEventListener("blur", this.handleBlur);
                    container.addEventListener("keyup", this.handleKeyup);
                    if (MDS.isMobile) {
                        container.addEventListener("touchstart", this.handleMousedown);
                        container.addEventListener("touchend", this.handleMouseup);
                    } else {
                        container.addEventListener("mousedown", this.handleMousedown);
                        container.addEventListener("mouseup", this.handleMouseup);
                    }
                }
                _createClass(MarkerManager, [ {
                    key: "handleBlur",
                    value: function handleBlur(event) {
                        if (event.target.localName === "mds-map-marker") {
                            var relatedTarget = event.detail.relatedTarget;
                            if (relatedTarget && !relatedTarget.localName.includes("mds-map-marker") && !event.target.deepContains(relatedTarget)) {
                                this.closeOpenMarker();
                            }
                        }
                    }
                }, {
                    key: "handleKeyup",
                    value: function handleKeyup(event) {
                        if (event.target.localName === "mds-map-marker") {
                            Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["isEscAndShouldClose"])(Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["originalEvent"])(event)) && this.closeOpenMarker(true);
                        }
                    }
                }, {
                    key: "handleMousedown",
                    value: function handleMousedown(event) {
                        this.mousePosition = {
                            x: event.clientX || event.changedTouches[0].clientX,
                            y: event.clientY || event.changedTouches[0].clientY
                        };
                        !MDS.isMobile && event.preventDefault();
                        if (event.target.localName === "mds-map-marker" && event.target !== this.openMarker) {
                            this.closeOpenMarker();
                        }
                    }
                }, {
                    key: "handleMouseup",
                    value: function handleMouseup(event) {
                        if (!event.target.classList.contains("gm-control-active") && event.target.localName !== "mds-map-marker") {
                            var clientX = event.clientX || event.changedTouches[0].clientX;
                            var clientY = event.clientY || event.changedTouches[0].clientY;
                            if (this.mousePosition.x === clientX && this.mousePosition.y === clientY) {
                                this.closeOpenMarker();
                                this._mapFocusTarget && this._mapFocusTarget.focus();
                            }
                        }
                    }
                }, {
                    key: "setOpenMarker",
                    value: function setOpenMarker(event) {
                        if (this.openMarker && event.target !== this.openMarker) {
                            this.openMarker.close();
                        }
                        this.openMarker = event.target;
                        this.openMarker.style.zIndex = 1;
                    }
                }, {
                    key: "closeOpenMarker",
                    value: function closeOpenMarker() {
                        var focusOnContainer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                        if (this.openMarker) {
                            this.openMarker.style.zIndex = "";
                            this.openMarker.close(focusOnContainer);
                            this.openMarker = null;
                        }
                    }
                } ]);
                return MarkerManager;
            }();
        },
        "./src/map/mds-map.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/map/mds-map.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/menu/MdsMenu.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function MdsMenu() {
                var _bodyClasses, _pointerClasses;
                var footnoteText = this.footnoteText, columnWidth = this.columnWidth, menuAlignment = this.menuAlignment, menuPosition = this.menuPosition, showPointer = this.showPointer, _componentName = this._componentName;
                var bodyClasses = (_bodyClasses = {}, _defineProperty(_bodyClasses, "".concat(_componentName), true), 
                _defineProperty(_bodyClasses, "".concat(_componentName, "--").concat(menuPosition), true), 
                _defineProperty(_bodyClasses, "".concat(_componentName, "--").concat(menuAlignment), true), 
                _bodyClasses);
                var pointerClasses = (_pointerClasses = {}, _defineProperty(_pointerClasses, "".concat(_componentName, "__pointer"), true), 
                _defineProperty(_pointerClasses, "".concat(_componentName, "__pointer--").concat(menuPosition), true), 
                _defineProperty(_pointerClasses, "".concat(_componentName, "__pointer--").concat(menuAlignment), true), 
                _defineProperty(_pointerClasses, "menu__pointer--noShow", !showPointer), _pointerClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", bodyClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", pointerClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "class", "".concat(_componentName, "__slot"), "onkeydown", this._handleMenuItemKeydown);
                _renderArbitrary(this.footnoteText && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "menu__footnote"), 
                _renderArbitrary(footnoteText), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            __webpack_exports__["default"] = MdsMenu;
        },
        "./src/menu/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_menu_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/menu/mds-menu.scss");
            var _mds_menu_scss__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_menu_scss__WEBPACK_IMPORTED_MODULE_1__);
            var _utils_slot_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/slot-utils.js");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_edge_detection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/edge-detection.js");
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/data-utils.js");
            var _menu_column__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/menu/menu-column/index.jsx");
            var _MdsMenu__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/menu/MdsMenu.jsx");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _dec2, _class, _class2;
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["mixins"].AttributeMarshallingMixin, enumerables = _mixins$AttributeMars.enumerables, string = _mixins$AttributeMars.string, number = _mixins$AttributeMars.number, boolean = _mixins$AttributeMars.boolean;
            var withOneOpen = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["behaviors"].withOneOpen;
            var entity = {
                footnoteText: string,
                columnWidth: number.defaultsTo(),
                menuAlignment: enumerables(string, "left", "right", "center").defaultsTo("left"),
                menuPosition: enumerables(string, "above", "below").defaultsTo("below"),
                showPointer: boolean.defaultsTo(false),
                visible: boolean.defaultsTo(false)
            };
            var MdsMenu = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec2 = withOneOpen(), _dec(_class = _dec2(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsMenu, _AgaveComponent);
                _createClass(MdsMenu, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsMenu";
                    }
                } ]);
                function MdsMenu(componentName) {
                    var _this2 = this, _this$_keyCodeActionM;
                    var _this;
                    _classCallCheck(this, MdsMenu);
                    var renderTarget = document.createElement("mds-".concat(componentName || "menu", "-overlay"));
                    renderTarget.setAttribute("data-is-mds-menu-render-target", true);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsMenu).call(this, {
                        renderTarget: renderTarget,
                        hasCustomRenderTarget: true,
                        hasHost: true
                    }));
                    _this._componentName = componentName || "menu";
                    _this.open = _this.open.bind(_assertThisInitialized(_this));
                    _this.close = _this.close.bind(_assertThisInitialized(_this));
                    _this._onclick = _this._onclick.bind(_assertThisInitialized(_this));
                    _this._onfocus = _this._onfocus.bind(_assertThisInitialized(_this));
                    _this._onblur = _this._onblur.bind(_assertThisInitialized(_this));
                    _this._closeOnEsc = _this._closeOnEsc.bind(_assertThisInitialized(_this));
                    _this._handleTouchstart = _this._handleTouchstart.bind(_assertThisInitialized(_this));
                    _this._onSelected = _this._onSelected.bind(_assertThisInitialized(_this));
                    _this._getNumColumns = _this._getNumColumns.bind(_assertThisInitialized(_this));
                    _this._menuColumns = _this._getNumColumns();
                    _this._setColumnsWidth = _this._setColumnsWidth.bind(_assertThisInitialized(_this));
                    _this._isHeaderRequired = _this._isHeaderRequired.bind(_assertThisInitialized(_this));
                    _this._shouldChildrenRender = _this._shouldChildrenRender.bind(_assertThisInitialized(_this));
                    _this._dispatchEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "click-menu";
                    }.bind(this), _assertThisInitialized(_this));
                    _this._shiftFocusDown = _this._shiftFocusDown.bind(_assertThisInitialized(_this));
                    _this._shiftFocusUp = _this._shiftFocusUp.bind(_assertThisInitialized(_this));
                    _this._handleItemActivation = _this._handleItemActivation.bind(_assertThisInitialized(_this));
                    _this._handleTabKeydown = _this._handleTabKeydown.bind(_assertThisInitialized(_this));
                    _this._handleMenuItemKeydown = _this._handleMenuItemKeydown.bind(_assertThisInitialized(_this));
                    _this._keyCodeActionMap = (_this$_keyCodeActionM = {}, _defineProperty(_this$_keyCodeActionM, 27, _this._closeOnEsc), 
                    _defineProperty(_this$_keyCodeActionM, 9, _this._handleTabKeydown), _defineProperty(_this$_keyCodeActionM, 38, _this._shiftFocusUp), 
                    _defineProperty(_this$_keyCodeActionM, 40, _this._shiftFocusDown), _defineProperty(_this$_keyCodeActionM, 37, _this._shiftFocusUp), 
                    _defineProperty(_this$_keyCodeActionM, 39, _this._shiftFocusDown), _defineProperty(_this$_keyCodeActionM, 32, _this._handleItemActivation), 
                    _defineProperty(_this$_keyCodeActionM, 13, _this._handleItemActivation), _this$_keyCodeActionM);
                    return _this;
                }
                _createClass(MdsMenu, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        var _this3 = this;
                        _get(_getPrototypeOf(MdsMenu.prototype), "connectedCallback", this).call(this);
                        console.warn("WORK IN PROGRESS -- MdsMenu is an internal subcomponent to be used in Mds Components that have menus. It is not to be used as a standalone component.");
                        this._host.style.position = "relative";
                        this._menu = this._renderTarget.shadowRoot.querySelector(".".concat(this._componentName));
                        this._pointer = this._menu && this._menu.querySelector(".".concat(this._componentName, "__pointer"));
                        this._host.rerenderOnSlotChange = function() {
                            _newArrowCheck(this, _this3);
                            var slot = _extends(document.createElement("slot"), {
                                name: this._renderTarget.slot
                            });
                            this._host.shadowRoot.appendChild(slot);
                        }.bind(this);
                        var lastColumn = this.querySelector("mds-menu-column:last-of-type");
                        if (lastColumn) {
                            lastColumn.setAttribute("show-divider", "false");
                        }
                        this._shouldChildrenRender();
                        this._isHeaderRequired();
                        this._setColumnsWidth();
                        this._host.addEventListener("click", this.open);
                    }
                }, {
                    key: "disconnectedCallback",
                    value: function disconnectedCallback() {
                        _get(_getPrototypeOf(MdsMenu.prototype), "disconnectedCallback", this) && _get(_getPrototypeOf(MdsMenu.prototype), "disconnectedCallback", this).call(this);
                        this._removeEventListeners();
                    }
                }, {
                    key: "_addEventListeners",
                    value: function _addEventListeners() {
                        this._host.addEventListener("closeMenu", this.close);
                        this._host.addEventListener("unselectItems", this._onSelected);
                        document.addEventListener(MDS.isIOS ? "touchstart" : "mousedown", this._handleTouchstart);
                    }
                }, {
                    key: "_handleTouchstart",
                    value: function _handleTouchstart(event) {
                        if (!this._host.deepContains(event.composedPath()[0])) {
                            this.close();
                        }
                    }
                }, {
                    key: "_handleMouseleave",
                    value: function _handleMouseleave() {
                        !this._hostHasFocus && this.close();
                    }
                }, {
                    key: "_removeEventListeners",
                    value: function _removeEventListeners() {
                        this._host.removeEventListener("closeMenu", this.close);
                        document.removeEventListener(MDS.isIOS ? "touchstart" : "mousedown", this._handleTouchstart);
                    }
                }, {
                    key: "_closeOnEsc",
                    value: function _closeOnEsc(event) {
                        if (this.visible && Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["isEscAndShouldClose"])(event)) {
                            var parentElement = event.target.parentElement;
                            if (parentElement.localName == "mds-menu-group") {
                                parentElement.expanded = false;
                                parentElement.focus();
                            } else {
                                this._host.focus();
                                this.close();
                            }
                        }
                    }
                }, {
                    key: "_handleTabKeydown",
                    value: function _handleTabKeydown(event) {
                        this.visible && !this.close();
                    }
                }, {
                    key: "_getNumColumns",
                    value: function _getNumColumns() {
                        var _this4 = this;
                        var columns = this.childNodes;
                        var filterColumns = Array.from(columns).filter(function(node) {
                            _newArrowCheck(this, _this4);
                            return node.nodeName === "MDS-MENU-COLUMN";
                        }.bind(this));
                        return filterColumns.length;
                    }
                }, {
                    key: "_setColumnsWidth",
                    value: function _setColumnsWidth() {
                        var _this5 = this;
                        var columns = this.childNodes;
                        var columnItems = Array.from(columns);
                        if (this.columnWidth < 120) {
                            this.columnWidth = 120;
                            console.warn("The column width cannot be less than 120px");
                        }
                        columnItems.forEach(function(node) {
                            _newArrowCheck(this, _this5);
                            if (node.nodeName === "MDS-MENU-COLUMN") {
                                node._columnWidth = this.columnWidth;
                                node._bottomPadding = this.footnoteText && this.footnoteText != "" ? "0px" : "4px";
                            }
                        }.bind(this));
                    }
                }, {
                    key: "_handlePositioning",
                    value: function _handlePositioning() {
                        var triggerPosition = this._host.getBoundingClientRect();
                        if (this.constructor._maxWidth) {
                            this._menu.style.maxWidth = "".concat(Math.min(window.innerWidth - 32, this.constructor._maxWidth) / 16, "rem");
                        }
                        var edges;
                        if (this.edgeDetection) {
                            var edgeDetectionContainer = this.edgeDetectionContainerId && document.getElementById(this.edgeDetectionContainerId);
                            edges = Object(_utils_edge_detection__WEBPACK_IMPORTED_MODULE_4__["getEdges"])(edgeDetectionContainer);
                        }
                        this._menu.style.display = "flex";
                        if (this.edgeDetection) {
                            var positionFlags = Object(_utils_edge_detection__WEBPACK_IMPORTED_MODULE_4__["getPositionFlags"])(triggerPosition, this._menu, edges);
                            this.menuAlignment = positionFlags.horizontal;
                            this.menuPosition = positionFlags.vertical;
                            this.detectTriggerWrap && this._setTriggerWrapFlag(triggerPosition);
                        }
                    }
                }, {
                    key: "_onSelected",
                    value: function _onSelected(event) {
                        var _this6 = this;
                        var itemList = Array.from(this._renderTarget.querySelectorAll("mds-menu-item"));
                        itemList.forEach(function(item) {
                            _newArrowCheck(this, _this6);
                            item.selected = false;
                        }.bind(this));
                    }
                }, {
                    key: "_shouldChildrenRender",
                    value: function _shouldChildrenRender() {
                        if (this._menuColumns > 4 || this._menuColumns < 1) {
                            this.throwConstraintError("You cannot have more than 4 columns or less than 1 column.");
                        }
                        if (this._menuColumns > 1 && this.querySelectorAll("mds-menu-group").length > 0) {
                            this.throwConstraintError("You cannot use menu groups if you are using more than 1 column.");
                        }
                    }
                }, {
                    key: "_isHeaderRequired",
                    value: function _isHeaderRequired() {
                        var _this7 = this;
                        var columns = this.childNodes;
                        var filterColumns = Array.from(columns).filter(function(node) {
                            _newArrowCheck(this, _this7);
                            return node.nodeName === "MDS-MENU-COLUMN";
                        }.bind(this));
                        if (this._menuColumns === 1 && filterColumns.length && filterColumns[0]._header) {
                            this.throwConstraintError("A single column cannot have a header.");
                        } else if (this._menuColumns > 1) {
                            var columnsWithHeaders = filterColumns.filter(function(node) {
                                _newArrowCheck(this, _this7);
                                return node._header;
                            }.bind(this));
                            var columnsWithoutHeaders = filterColumns.filter(function(node) {
                                _newArrowCheck(this, _this7);
                                return !node._header;
                            }.bind(this));
                            if (columnsWithHeaders.length > 0 && columnsWithoutHeaders.length > 0 && this._menuColumns > 1) {
                                this.throwConstraintError("If there are more than 1 column with a header, all columns need to have a header present.");
                            }
                        }
                    }
                }, {
                    key: "_setTriggerWrapFlag",
                    value: function _setTriggerWrapFlag(triggerPosition) {
                        var triggerLineHeight = (Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_5__["cleanCssValue"])(getComputedStyle(this._host._anchorNode).fontSize) + 12) * 1.25;
                        this._isWrapped = triggerPosition.height > triggerLineHeight;
                        if (this._isWrapped) {
                            this.menuAlignment = "left";
                            this.menuPosition = "below";
                        }
                    }
                }, {
                    key: "open",
                    value: function open(event) {
                        var _this8 = this;
                        var hostMenu = this._host.querySelector("mds-".concat(this._componentName));
                        var hostHasOpenMenuButton = hostMenu && hostMenu.visible;
                        if (!this.visible && !this._host.inactive && !hostHasOpenMenuButton && !this._isHeaderRequired() && !this._shouldChildrenRender()) {
                            Array.from(this.children).forEach(function(child) {
                                _newArrowCheck(this, _this8);
                                return this._renderTarget.appendChild(child);
                            }.bind(this));
                            this._handlePositioning();
                            this.openComponent();
                            this.visible = true;
                            var firstItem = this._menu.querySelector(".menu-item");
                            firstItem && firstItem.focus();
                            this._addEventListeners();
                        } else if (this.visible && event && this._host == event.composedPath()[0]) {
                            this.close(true);
                        }
                    }
                }, {
                    key: "close",
                    value: function close(focusHost) {
                        this._restoreStyles();
                        this._removeEventListeners();
                        if (focusHost) {
                            this._focusHost();
                        }
                    }
                }, {
                    key: "_restoreStyles",
                    value: function _restoreStyles() {
                        var _this9 = this;
                        this.visible = false;
                        Object(_utils_edge_detection__WEBPACK_IMPORTED_MODULE_4__["clearStyles"])(this._menu, this._pointer);
                        Array.from(this._menu.querySelectorAll("mds-menu-item")).forEach(function(item) {
                            _newArrowCheck(this, _this9);
                            item.expanded = false;
                            item._handleExpandedState();
                        }.bind(this));
                    }
                }, {
                    key: "_focusHost",
                    value: function _focusHost() {
                        var _this10 = this;
                        if (this._host) {
                            MDS.isIOS ? setTimeout(function() {
                                _newArrowCheck(this, _this10);
                                return this._host.focus();
                            }.bind(this), 10) : this._host.focus();
                        } else {
                            return false;
                        }
                    }
                }, {
                    key: "_handleMenuItemKeydown",
                    value: function _handleMenuItemKeydown(customEvent) {
                        var event = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["originalEvent"])(customEvent);
                        if (this._keyCodeActionMap[event.keyCode]) {
                            event.preventDefault();
                            this._keyCodeActionMap[event.keyCode](event);
                        }
                    }
                }, {
                    key: "_getCurrentTarget",
                    value: function _getCurrentTarget(event) {
                        var currentTarget = event.target;
                        return this._getInteractiveElementsList.indexOf(currentTarget);
                    }
                }, {
                    key: "_shiftFocusDown",
                    value: function _shiftFocusDown(event) {
                        var currentIndex = this._getCurrentTarget(event);
                        var nextIndex = currentIndex + 1;
                        if (this._getInteractiveElementsList.length <= nextIndex) {
                            this._getInteractiveElementsList[0].focus();
                        } else {
                            this._getInteractiveElementsList[nextIndex].focus();
                        }
                    }
                }, {
                    key: "_shiftFocusUp",
                    value: function _shiftFocusUp(event) {
                        var currentIndex = this._getCurrentTarget(event);
                        var nextIndex = currentIndex - 1;
                        var interactiveElements = this._getInteractiveElementsList;
                        if (nextIndex < 0) {
                            interactiveElements[interactiveElements.length - 1].focus();
                        } else {
                            this._getInteractiveElementsList[nextIndex].focus();
                        }
                    }
                }, {
                    key: "_handleItemActivation",
                    value: function _handleItemActivation(event) {
                        var activeTarget = event.target;
                        if (activeTarget.localName == "mds-menu-group") {
                            activeTarget._toggleExpanded(event);
                        } else if (activeTarget.localName == "mds-menu-item") {
                            activeTarget.select(event);
                        }
                    }
                }, {
                    key: "render",
                    value: function render() {
                        _MdsMenu__WEBPACK_IMPORTED_MODULE_7__["default"].call(this);
                    }
                }, {
                    key: "_getInteractiveElementsList",
                    get: function get() {
                        var _this11 = this;
                        var itemsArr = [];
                        Array.from(this._renderTarget.querySelectorAll("mds-menu-column")).forEach(function(columns) {
                            var _this12 = this;
                            _newArrowCheck(this, _this11);
                            Array.from(columns.children).forEach(function(item) {
                                var _this13 = this;
                                _newArrowCheck(this, _this12);
                                if (item.localName == "mds-menu-item" && !item.disabled) {
                                    itemsArr.push(item);
                                }
                                if (item.localName == "mds-menu-group") {
                                    itemsArr.push(item);
                                    if (item.localName == "mds-menu-group" && item.expanded) {
                                        itemsArr.push.apply(itemsArr, _toConsumableArray(Array.from(item.children).filter(function(item) {
                                            _newArrowCheck(this, _this13);
                                            return !item.disabled;
                                        }.bind(this))));
                                    }
                                }
                            }.bind(this));
                        }.bind(this));
                        return itemsArr;
                    }
                } ]);
                return MdsMenu;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_0___default.a), _class2.styles = _mds_menu_scss__WEBPACK_IMPORTED_MODULE_1___default.a, 
            _class2._maxWidth = "", _class2)) || _class) || _class);
            __webpack_exports__["default"] = MdsMenu;
        },
        "./src/menu/mds-menu.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/menu/mds-menu.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/menu/menu-column/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _menu_item__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/menu/menu-item/index.jsx");
            var _menu_group__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/menu/menu-group/index.jsx");
            var _mds_menu_column_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/menu/menu-column/mds-menu-column.scss");
            var _mds_menu_column_scss__WEBPACK_IMPORTED_MODULE_4___default = __webpack_require__.n(_mds_menu_column_scss__WEBPACK_IMPORTED_MODULE_4__);
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].boolean;
            var entity = {
                header: string,
                showDivider: boolean.defaultsTo(true)
            };
            var MdsMenuColumn = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsMenuColumn, _AgaveComponent);
                _createClass(MdsMenuColumn, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsMenuColumn";
                    }
                } ]);
                function MdsMenuColumn() {
                    var _this;
                    _classCallCheck(this, MdsMenuColumn);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsMenuColumn).call(this));
                    _this.defineObservedProperty("_columnWidth", 0);
                    _this.defineObservedProperty("_bottomPadding", "0px");
                    _this._closeOtherGroups = _this._closeOtherGroups.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsMenuColumn, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        this.addEventListener("closeOtherGroups", this._closeOtherGroups);
                        if (this.childElementCount > 0) {
                            var childElements = Array.from(this.children);
                            var columnLastChildComponent = childElements[childElements.length - 1];
                            columnLastChildComponent._isLastElement = true;
                        }
                        _get(_getPrototypeOf(MdsMenuColumn.prototype), "connectedCallback", this).call(this);
                    }
                }, {
                    key: "_closeOtherGroups",
                    value: function _closeOtherGroups(event) {
                        var _this2 = this;
                        var groupsList = Array.from(this.querySelectorAll("mds-menu-group"));
                        groupsList.forEach(function(group) {
                            _newArrowCheck(this, _this2);
                            if (!group.deepContains(event.target)) {
                                group.expanded = false;
                            }
                        }.bind(this));
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var columnClasses = {
                            "menu-column": true,
                            "menu-column__container": true,
                            "menu-column__divider": this.showDivider
                        };
                        var columnStyles = {
                            width: "".concat(this._columnWidth, "px"),
                            paddingBottom: this._bottomPadding
                        };
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", columnClasses, "style", columnStyles);
                        _renderArbitrary(this.header && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "menu-column__header"), 
                        _renderArbitrary(this.header), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return MdsMenuColumn;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_menu_column_scss__WEBPACK_IMPORTED_MODULE_4___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsMenuColumn;
        },
        "./src/menu/menu-column/mds-menu-column.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/menu/menu-column/mds-menu-column.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/menu/menu-group/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/common-utils.js");
            var _mds_menu_group_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/menu/menu-group/mds-menu-group.scss");
            var _mds_menu_group_scss__WEBPACK_IMPORTED_MODULE_3___default = __webpack_require__.n(_mds_menu_group_scss__WEBPACK_IMPORTED_MODULE_3__);
            var _badge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/badge/index.jsx");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].boolean, satisfies = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].satisfies;
            var entity = {
                expanded: boolean.defaultsTo(false),
                showDivider: boolean.defaultsTo(false),
                headerLabel: string,
                badge: satisfies(_badge__WEBPACK_IMPORTED_MODULE_4__["entity"]),
                tagText: string,
                tagIcon: string
            };
            var MdsMenuGroup = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsMenuGroup, _AgaveComponent);
                _createClass(MdsMenuGroup, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsMenuGroup";
                    }
                } ]);
                function MdsMenuGroup() {
                    var _this;
                    _classCallCheck(this, MdsMenuGroup);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsMenuGroup).call(this));
                    _this.defineObservedProperty("_isLastElement", false);
                    _this._toggleExpanded = _this._toggleExpanded.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsMenuGroup, [ {
                    key: "focus",
                    value: function focus() {
                        var focusNode = this.shadowRoot.querySelector("button");
                        focusNode.focus();
                    }
                }, {
                    key: "_toggleExpanded",
                    value: function _toggleExpanded(event) {
                        var _this2 = this;
                        this.expanded = !this.expanded;
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this2);
                            return "closeOtherGroups";
                        }.bind(this), this)({
                            target: this
                        });
                    }
                }, {
                    key: "invalidConfiguration",
                    value: function invalidConfiguration() {
                        if (this.querySelectorAll("mds-menu-item").length == 0) {
                            this.throwConstraintError("A menu group must contain at least 1 menu item.");
                        }
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var headerClasses = {
                            "menu-group__header": true,
                            "menu-group__header--expanded": this.expanded,
                            "menu-group__header--divider": !this.expanded && this.showDivider
                        };
                        var chevronClasses = {
                            "menu-group__chevron-icon": true,
                            "menu-group__chevron-icon--expanded": this.expanded
                        };
                        var slotClasses = {
                            "menu-group__slot--indented-divider": !this.showDivider && !this._isLastElement,
                            "menu-group__slot--full-divider": this.showDivider && !this._isLastElement
                        };
                        if (this.invalidConfiguration()) {
                            return;
                        }
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "menu-group");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("button", null, null, "class", headerClasses, "onclick", this._toggleExpanded);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "menu-group__header-label");
                        _renderArbitrary(this.headerLabel);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "menu-group__trailing-content");
                        _renderArbitrary(this.tagText && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "menu-group__tag"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-tag", null, null, "text", this.tagText, "icon", this.tagIcon, "interactive", "false"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        _renderArbitrary(this.badge && this.badge.labelValue && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "menu-group__badge"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-badge", null, null, "label-value", this.badge.labelValue, "is-animated", this.badge.isAnimated, "icon", this.badge.icon, "accessible-name", this.badge.accessibleName), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", chevronClasses, "innerHTML-prop", MDS.svgs.ico_chevron_down, "aria-hidden", "true", "__skip", "true");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("button");
                        _renderArbitrary(this.expanded && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", slotClasses), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot"), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return MdsMenuGroup;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_menu_group_scss__WEBPACK_IMPORTED_MODULE_3___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsMenuGroup;
        },
        "./src/menu/menu-group/mds-menu-group.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/menu/menu-group/mds-menu-group.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/menu/menu-item/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/common-utils.js");
            var _mds_menu_item_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/menu/menu-item/mds-menu-item.scss");
            var _mds_menu_item_scss__WEBPACK_IMPORTED_MODULE_3___default = __webpack_require__.n(_mds_menu_item_scss__WEBPACK_IMPORTED_MODULE_3__);
            var _badge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/badge/index.jsx");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var satisfies = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].satisfies, string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].boolean;
            var entity = {
                label: string,
                value: string,
                showDivider: boolean.defaultsTo(false),
                icon: string,
                badge: satisfies(_badge__WEBPACK_IMPORTED_MODULE_4__["entity"]),
                tagText: string,
                tagIcon: string,
                disabled: boolean.defaultsTo(false),
                selected: boolean.defaultsTo(false)
            };
            var MdsMenuItem = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsMenuItem, _AgaveComponent);
                _createClass(MdsMenuItem, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsMenuItem";
                    }
                } ]);
                function MdsMenuItem() {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsMenuItem);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsMenuItem).call(this));
                    _this.defineObservedProperty("_isLastElement", false);
                    _this.select = _this.select.bind(_assertThisInitialized(_this));
                    _this._dispatchEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "menu-item-selected";
                    }.bind(this), _assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsMenuItem, [ {
                    key: "focus",
                    value: function focus() {
                        var focusNode = this.shadowRoot.querySelector("button");
                        focusNode.focus();
                    }
                }, {
                    key: "select",
                    value: function select(event) {
                        var _this3 = this;
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this3);
                            return "unselectItems";
                        }.bind(this), this)({
                            target: this
                        });
                        this.selected = true;
                        if (this.parentElement.localName == "mds-menu-group") {
                            this.parentElement.expanded = false;
                        } else {
                            Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["createCustomEventDispatcher"])(function() {
                                _newArrowCheck(this, _this3);
                                return "closeOtherGroups";
                            }.bind(this), this)({
                                target: this
                            });
                        }
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this3);
                            return "closeMenu";
                        }.bind(this), this)({
                            target: this
                        });
                        var detail = {
                            label: this.label,
                            value: this.value,
                            original: event
                        };
                        this._dispatchEvent(event, detail);
                        event.stopPropagation();
                    }
                }, {
                    key: "invalidConfiguration",
                    value: function invalidConfiguration() {
                        if (this.parentElement.localName == "mds-menu-group" && this.showDivider) {
                            this.throwConstraintError("Nested Menu items cannot have a divider.");
                        }
                        if (this.parentElement.localName == "mds-menu-group" && (this.icon || this.badge || this.tagText || this.tagIcon)) {
                            this.throwConstraintError("Nested Menu items cannot have icon, badges, or tags.");
                        }
                        if (this.badge && (this.tagText || this.tagIcon)) {
                            this.throwConstraintError("Menu items cannot have both a badge and a tag.");
                        }
                    }
                }, {
                    key: "render",
                    value: function render() {
                        if (this.invalidConfiguration()) {
                            return;
                        }
                        var itemClasses = {
                            "menu-item": true,
                            "menu-item--nested": this.parentElement.localName == "mds-menu-group",
                            "menu-item--selected": this.selected && this.parentElement.localName != "mds-menu-group",
                            "menu-item--disabled": this.disabled,
                            "menu-item__divider": this.showDivider && !this._isLastElement
                        };
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("button", null, null, "class", itemClasses, "onclick", this.select, "aria-disabled", this.disabled, "disabled-prop", this.disabled);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "menu-item__leading-content");
                        _renderArbitrary(this.icon && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "menu-item__icon", "innerHTML-prop", MDS.svgs[this.icon], "__skip", "true"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "menu-item__label");
                        _renderArbitrary(this.label);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        _renderArbitrary(this.tagText && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "menu-item__tag"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-tag", null, null, "text", this.tagText, "icon", this.tagIcon, "interactive", "false"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        _renderArbitrary(this.badge && this.badge.labelValue && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "menu-item__badge"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-badge", null, null, "label-value", this.badge.labelValue, "is-animated", this.badge.isAnimated, "icon", this.badge.icon, "accessible-name", this.badge.accessibleName), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("button");
                    }
                } ]);
                return MdsMenuItem;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_menu_item_scss__WEBPACK_IMPORTED_MODULE_3___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsMenuItem;
        },
        "./src/menu/menu-item/mds-menu-item.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/menu/menu-item/mds-menu-item.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/message-drawer/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            __webpack_require__.d(__webpack_exports__, "_getExpandedHeight", (function() {
                return _getExpandedHeight;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_message_drawer_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/message-drawer/mds-message-drawer.scss");
            var _mds_message_drawer_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_message_drawer_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _utils_slot_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/slot-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _dec, _class, _class2;
            var _li$wrapper = function _li$wrapper(_slotName) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("li", null, null, "class", "message-drawer__list-item");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "name", _slotName);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("li");
            };
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            var string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string, arrayOf = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].arrayOf, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].boolean, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].stringRequired, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].enumerables;
            var entity = {
                accessibleText: stringRequired,
                contentSlots: arrayOf(string),
                expanded: boolean.defaultsTo(true).withChangedCallback(),
                sortType: enumerables(string, "specified", "severity").defaultsTo("specified")
            };
            function _getExpandedHeight(messageDrawer) {
                _extends(messageDrawer.style, {
                    visibility: "hidden",
                    display: "block",
                    position: "absolute"
                });
                var height = messageDrawer.scrollHeight;
                _extends(messageDrawer.style, {
                    visibility: "",
                    display: "",
                    position: ""
                });
                return height;
            }
            var MdsMessageDrawer = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsMessageDrawer, _AgaveComponent);
                _createClass(MdsMessageDrawer, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsMessageDrawer";
                    }
                } ]);
                function MdsMessageDrawer() {
                    var _this;
                    _classCallCheck(this, MdsMessageDrawer);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsMessageDrawer).call(this));
                    _this._handleSlotchange = _this._handleSlotchange.bind(_assertThisInitialized(_this));
                    _this._sortBanner = _this._sortBanner.bind(_assertThisInitialized(_this));
                    _this._getContentSlots = _this._getContentSlots.bind(_assertThisInitialized(_this));
                    _this.defineObservedProperty("_closedBanners", {});
                    _this.defineObservedProperty("_isAnimating", false);
                    return _this;
                }
                _createClass(MdsMessageDrawer, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        var _this2 = this;
                        _get(_getPrototypeOf(MdsMessageDrawer.prototype), "connectedCallback", this).call(this);
                        var messageDrawer = this.shadowRoot.querySelector(".message-drawer");
                        messageDrawer && messageDrawer.addEventListener("slotchange", this._handleSlotchange);
                        this.addEventListener("close", function(e) {
                            _newArrowCheck(this, _this2);
                            this._closedBanners = _extends({}, this._closedBanners, _defineProperty({}, e.target.slot, true));
                        }.bind(this));
                    }
                }, {
                    key: "expandedChangedCallback",
                    value: function expandedChangedCallback() {
                        if (this._hasRendered) {
                            window.clearTimeout(this._animationTimeout);
                            var messageDrawer = this.shadowRoot.querySelector(".message-drawer");
                            this["_animate".concat(this.expanded ? "Open" : "Closed")](messageDrawer);
                        }
                    }
                }, {
                    key: "_sortBanner",
                    value: function _sortBanner() {
                        var criticalSlots = [];
                        var softSlots = [];
                        var informationalSlots = [];
                        for (var i = 0; i < this.children.length; i++) {
                            if (this.children[i].variant === "critical" || this.children[i].variant === "requiredVerbatim") {
                                criticalSlots.push(this.children[i].slot);
                            }
                            if (this.children[i].variant === "warning" || this.children[i].variant === "soft" || this.children[i].variant === "required") {
                                softSlots.push(this.children[i].slot);
                            }
                            if (this.children[i].variant === "informational" || this.children[i].variant === "optional") {
                                informationalSlots.push(this.children[i].slot);
                            }
                        }
                        return criticalSlots.concat(softSlots, informationalSlots);
                    }
                }, {
                    key: "_getContentSlots",
                    value: function _getContentSlots() {
                        if (this.sortType === "severity") {
                            return this._sortBanner();
                        }
                        return this.contentSlots;
                    }
                }, {
                    key: "_animateOpen",
                    value: function _animateOpen(messageDrawer) {
                        var _this3 = this;
                        if (!(this._isAnimating && this._expandedHeight)) {
                            this._expandedHeight = _getExpandedHeight(messageDrawer);
                        }
                        window.requestAnimationFrame(function() {
                            var _this4 = this;
                            _newArrowCheck(this, _this3);
                            if (!this._isAnimating) {
                                messageDrawer.style.maxHeight = 0;
                            }
                            this._isAnimating = true;
                            window.requestAnimationFrame(function() {
                                var _this5 = this;
                                _newArrowCheck(this, _this4);
                                messageDrawer.style.maxHeight = "".concat(this._expandedHeight, "px");
                                this._animationTimeout = window.setTimeout(function() {
                                    _newArrowCheck(this, _this5);
                                    messageDrawer.style.maxHeight = "";
                                    this._isAnimating = false;
                                }.bind(this), 500);
                            }.bind(this));
                        }.bind(this));
                    }
                }, {
                    key: "_animateClosed",
                    value: function _animateClosed(messageDrawer) {
                        var _this6 = this;
                        this._isAnimating = true;
                        var panelHeight = messageDrawer.scrollHeight;
                        window.requestAnimationFrame(function() {
                            var _this7 = this;
                            _newArrowCheck(this, _this6);
                            messageDrawer.style.maxHeight = "".concat(panelHeight, "px");
                            window.requestAnimationFrame(function() {
                                var _this8 = this;
                                _newArrowCheck(this, _this7);
                                messageDrawer.style.maxHeight = 0;
                                this._animationTimeout = window.setTimeout(function() {
                                    _newArrowCheck(this, _this8);
                                    messageDrawer.style.maxHeight = "";
                                    this._isAnimating = false;
                                }.bind(this), 500);
                            }.bind(this));
                        }.bind(this));
                    }
                }, {
                    key: "_handleSlotchange",
                    value: function _handleSlotchange() {
                        _utils_slot_utils__WEBPACK_IMPORTED_MODULE_3__["enforceSlotUsage"].call(this);
                        for (var i = 0; i < this.children.length; i += 1) {
                            if (this.children[i].background && this.children[i].background !== "primary") {
                                this.children[i].background = "primary";
                                this.throwConstraintError("Banners inside a Message Box must have background set to primary");
                            }
                        }
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var _this9 = this;
                        this._hasRendered = true;
                        var accessibleText = this.accessibleText, contentSlots = this.contentSlots, _closedBanners = this._closedBanners, expanded = this.expanded, _isAnimating = this._isAnimating;
                        var messageDrawerClasses = {
                            "message-drawer": true,
                            "message-drawer--closed": !expanded && !_isAnimating
                        };
                        var currentContentSlots = this._getContentSlots();
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "role", "region", "aria-label", accessibleText, "class", messageDrawerClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("ul", null, null, "class", "message-drawer__list");
                        _renderArbitrary(currentContentSlots && currentContentSlots.length && currentContentSlots.map(function(slotName) {
                            _newArrowCheck(this, _this9);
                            return !_closedBanners[slotName] && _jsxWrapper(_li$wrapper, [ slotName ]);
                        }.bind(this)));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("ul");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return MdsMessageDrawer;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_message_drawer_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2._childLocalNames = [ "mds-banner", "mds-banner-for-employee-messaging" ], 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsMessageDrawer;
        },
        "./src/message-drawer/mds-message-drawer.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/message-drawer/mds-message-drawer.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/multiselect/MdsMultiselect.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _microcopy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/microcopy/index.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/common-utils.js");
            var _text_input_MdsTextInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/text-input/MdsTextInput.jsx");
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function renderPill(_ref) {
                var _classes;
                var label = _ref.label, value = _ref.value;
                var classes = (_classes = {
                    multiselect__pill: true
                }, _defineProperty(_classes, "multiselect__pill--".concat(this.variant), true), 
                _defineProperty(_classes, "multiselect__pill--disabled", this.inactive), _classes);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "role", "listitem", "class", "multiselect__pill-container");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes, "role", "button", "data-value", value, "onclick", this._handlePillClick, "onkeydown", this._handlePillKeydown, "onkeyup", this._handleKeyup, "onfocus", this._handlePillFocus, "onblur", this._handleInputBlur, "tabindex", this.inactive ? -1 : 0, "aria-label", "".concat(label, ", ").concat(this.accessibleTextPill));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "multiselect__pill-text");
                _renderArbitrary(label);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "multiselect__pill-icon", "innerHTML-prop", MDS.svgs.ico_close, "aria-hidden", "true", "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function renderOption() {
                var classes = {
                    "multiselect-option": true,
                    "multiselect-option--active": this._active,
                    "multiselect-option--hidden": this._hidden
                };
                var iconClasses = {
                    "multiselect-option__icon": true,
                    "multiselect-option__icon--checked": this.selected
                };
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "id", this.value, "class", classes, "tabindex", "-1", "onclick", this._toggleSelected, "role", "option", "aria-selected", !!this.selected, "data-value", this.value, "data-active", !this._hidden);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", iconClasses, "innerHTML-prop", MDS.svgs["ico_checkmark"], "aria-hidden", "true", "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "multiselect-option__label");
                _renderArbitrary(this.label);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function renderMenu() {
                var _this = this;
                var menuClasses = {
                    multiselect__menu: true,
                    "multiselect__menu--visible": this._visible
                };
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", menuClasses, "id", "".concat(this.id, "-listbox"), "role", "listbox", "aria-multiselectable", "true", "aria-labelledby", "label-".concat(this.id), "tabindex", "-1", "onmousedown", this._handleMenuMousedown, "onmouseup", this._handleMenuMouseup);
                _renderArbitrary(this._optionNodes.map(function(child) {
                    _newArrowCheck(this, _this);
                    return renderOption.call(child);
                }.bind(this)));
                _renderArbitrary((!this._filteredOptions.length || !this._visibleNodes.length) && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "multiselect__menu-no-options", "onmousedown", _utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["preventDefault"]), 
                _renderArbitrary(this.noOptionsText), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function MdsMultiselectTemplate() {
                var _this2 = this, _containerClasses, _headerClasses, _inputClasses, _labelClasses;
                var errorMessageList = this.errorMessages;
                if (this.errorMessage) {
                    errorMessageList = [].concat(_toConsumableArray(errorMessageList), [ this.errorMessage ]);
                }
                var ariaDescribedbyIds = [];
                if (errorMessageList.length) {
                    ariaDescribedbyIds = _toConsumableArray(errorMessageList.map(function(_, i) {
                        _newArrowCheck(this, _this2);
                        return "".concat(this.id, "-error-text").concat(i);
                    }.bind(this)));
                }
                if (this.microcopy) {
                    ariaDescribedbyIds.push("".concat(this.id, "-microcopy "));
                }
                ariaDescribedbyIds = ariaDescribedbyIds.length ? ariaDescribedbyIds.join(" ") : undefined;
                var containerClasses = (_containerClasses = {
                    multiselect: true
                }, _defineProperty(_containerClasses, "multiselect--".concat(this.labelStyle), true), 
                _defineProperty(_containerClasses, "mds-row", this.labelStyle === "horizontal"), 
                _containerClasses);
                var labelWrapClasses = _defineProperty({
                    "multiselect__label-wrap": true
                }, "".concat(this.labelColumns || "mds-col-3"), this.labelStyle === "horizontal");
                var headerClasses = (_headerClasses = {
                    multiselect__header: true
                }, _defineProperty(_headerClasses, "multiselect__header--".concat(this.variant), true), 
                _defineProperty(_headerClasses, "multiselect__header--no-selection", this.variant === "box" && !this.selectedOptions.size), 
                _defineProperty(_headerClasses, "multiselect__header--".concat(this.labelStyle), true), 
                _defineProperty(_headerClasses, "multiselect__header--focused", this._inputHasFocus || this._visible), 
                _defineProperty(_headerClasses, "multiselect__header--error", errorMessageList.length), 
                _defineProperty(_headerClasses, "multiselect__header--disabled", this.inactive), 
                _headerClasses);
                var inputWrapClasses = _defineProperty({
                    "multiselect__input-wrap": true
                }, "".concat(this.inputColumns || "mds-col-9"), this.labelStyle === "horizontal");
                var inputClasses = (_inputClasses = {
                    multiselect__input: true
                }, _defineProperty(_inputClasses, "multiselect__input--".concat(this.variant), true), 
                _defineProperty(_inputClasses, "multiselect__input--no-selection", this.variant === "box" && !this.selectedOptions.size), 
                _inputClasses);
                var labelClasses = (_labelClasses = {
                    multiselect__label: true
                }, _defineProperty(_labelClasses, "multiselect__label--".concat(this.variant), true), 
                _defineProperty(_labelClasses, "multiselect__label--".concat(this.labelStyle), true), 
                _defineProperty(_labelClasses, "multiselect__label--error", errorMessageList.length), 
                _defineProperty(_labelClasses, "multiselect__label--floating-above", this.labelStyle === "floating" && (this.inputValue || this.selectedOptions.size || this._inputHasFocus || this._visible)), 
                _labelClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", containerClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", labelWrapClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("label", null, null, "class", labelClasses, "id", "label-".concat(this.id), "for", "input-".concat(this.id), "onmousedown", _utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["preventDefault"], "onclick", _utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["stopPropagation"]);
                _renderArbitrary(this.label);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("label");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", inputWrapClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", headerClasses, "onclick", this.inactive ? _utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["stopPropagation"] : this._handleHeaderClick, "onmousedown", this._handleHeaderMousedown);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "multiselect__pill-list", "aria-label", this.accessibleTextPillGroup, "role", "list", "aria-hidden", !this.selectedOptions.size);
                _renderArbitrary(this.selectedOptions.forEach(function(option) {
                    _newArrowCheck(this, _this2);
                    return renderPill.call(this, option);
                }.bind(this)));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "multiselect__input-mirror-wrap", "style", {
                    width: this.selectedOptions.size ? this._inputWidth : "100%"
                });
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("input", null, null, "id", "input-".concat(this.id), "class", inputClasses, "type", "text", "name", this.name || this.id, "value-prop", this.inputValue, "required-prop", !!this.required, "disabled-prop", !!this.inactive, "placeholder", !this.selectedOptions.size ? this.placeholder : "", "autocomplete", "off", "role", "combobox", "aria-haspopup", "listbox", "aria-autocomplete", "both", "aria-activedescendant", this._activeOption ? this._activeOption.value : "", "aria-controls", "".concat(this.id, "-listbox"), "aria-expanded", this._visible, "aria-labelledby", "input-label-".concat(this.id), "aria-describedby", ariaDescribedbyIds, "aria-invalid", !!errorMessageList.length, "aria-disabled", !!this.inactive, "oninput", this._handleInputInput, "onkeydown", this._handleInputKeydown, "onkeyup", this._handleKeyup, "onfocus", this._handleInputFocus, "onblur", this._handleInputBlur);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("span", null, null, "class", "multiselect__input-mirror");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "multiselect__header-icon multiselect__header-icon--".concat(this.variant), "innerHTML-prop", MDS.svgs["ico_chevron_down"], "aria-hidden", "true", "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                _renderArbitrary(renderMenu.call(this));
                _renderArbitrary(_text_input_MdsTextInput__WEBPACK_IMPORTED_MODULE_3__["renderErrorMicrocopy"].call(this, errorMessageList, "multiselect"));
                _renderArbitrary(Object(_microcopy__WEBPACK_IMPORTED_MODULE_1__["default"])(this.microcopy, "".concat(this.id, "-microcopy"), "multiselect__microcopy"));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "id", "input-label-".concat(this.id), "class", "multiselect__accessible-text", "aria-hidden", "true");
                _renderArbitrary("".concat(this.label, ", ").concat(this.accessibleTextInput));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "multiselect__accessible-text", "aria-live", "polite", "aria-atomic", "true", "role", "status");
                _renderArbitrary(this._ariaLiveFilteredOptions && (this._filteredOptions.length ? "".concat(this._filteredOptions.length, " ").concat(this.accessibleTextOptionCount) : this.noOptionsText));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "multiselect__accessible-text", "aria-live", "polite", "aria-atomic", "true");
                _renderArbitrary(this._selectionStatusAriaLiveActive && this.accessibleTextSelectionStatus);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "name", "form-associated-input");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            __webpack_exports__["default"] = MdsMultiselectTemplate;
        },
        "./src/multiselect/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _abstract_text_field__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-text-field/index.js");
            var _mds_multiselect_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/multiselect/mds-multiselect.scss");
            var _mds_multiselect_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_multiselect_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _MdsMultiselect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/multiselect/MdsMultiselect.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_form_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/form-utils.js");
            var _select_select_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/select/select-utils.js");
            var _utils_slot_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/utils/slot-utils.js");
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("./src/utils/data-utils.js");
            var _dec, _class, _class2, _this13 = undefined;
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var arrayOf = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].arrayOf, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].boolean, string = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].stringRequired;
            var entity = _objectSpread({}, _abstract_text_field__WEBPACK_IMPORTED_MODULE_1__["entity"], {
                inactive: boolean.defaultsTo(false).withChangedCallback(),
                value: arrayOf(string).defaultsTo([]),
                inputValue: string.withChangedCallback(),
                noOptionsText: stringRequired.defaultsTo("No options"),
                accessibleTextInput: stringRequired.defaultsTo("type to filter list"),
                accessibleTextPillGroup: stringRequired.defaultsTo("selected options"),
                accessibleTextPill: stringRequired.defaultsTo("click to remove"),
                accessibleTextOptionCount: stringRequired.defaultsTo("options"),
                accessibleTextSelectionStatus: string.withChangedCallback()
            });
            var MdsMultiselect = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AbstractTextField) {
                _inherits(MdsMultiselect, _AbstractTextField);
                _createClass(MdsMultiselect, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsMultiselect";
                    }
                } ]);
                function MdsMultiselect() {
                    var _this;
                    _classCallCheck(this, MdsMultiselect);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsMultiselect).call(this));
                    _this.defineObservedProperty("_visible", false);
                    _this.defineObservedProperty("_activeOption");
                    _this.defineObservedProperty("_cachedActiveOption");
                    _this.defineObservedProperty("_ariaLiveFilteredOptions", false);
                    _this.defineObservedProperty("_inputHasFocus", false);
                    _this.defineObservedProperty("_inputWidth", "".concat(MdsMultiselect._defaultInputWidth, "px"));
                    _this.defineObservedProperty("_selectionStatusAriaLiveActive", false);
                    _this.defineObservedProperty("selectedOptions", new Map);
                    _this.clearSelected = _this._pauseChangeEvents(_this.clearSelected.bind(_assertThisInitialized(_this)));
                    _this._hiddenOptions = [];
                    _this._filteredOptions = [];
                    _this._handleAdd = _this._handleAdd.bind(_assertThisInitialized(_this));
                    _this._handleRemove = _this._handleRemove.bind(_assertThisInitialized(_this));
                    _this._handleHeaderClick = _this._handleHeaderClick.bind(_assertThisInitialized(_this));
                    _this._handleHeaderMousedown = _this._handleHeaderMousedown.bind(_assertThisInitialized(_this));
                    _this._handleInputBlur = _this._handleInputBlur.bind(_assertThisInitialized(_this));
                    _this._handleInputFocus = _this._handleInputFocus.bind(_assertThisInitialized(_this));
                    _this._handleInputInput = _this._handleInputInput.bind(_assertThisInitialized(_this));
                    _this._handleInputKeydown = _this._handleInputKeydown.bind(_assertThisInitialized(_this));
                    _this._handleKeyup = _this._handleKeyup.bind(_assertThisInitialized(_this));
                    _this._handleMenuMousedown = _this._handleMenuMousedown.bind(_assertThisInitialized(_this));
                    _this._handleMenuMouseup = _this._handleMenuMouseup.bind(_assertThisInitialized(_this));
                    _this._handlePillClick = _this._handlePillClick.bind(_assertThisInitialized(_this));
                    _this._handlePillFocus = _this._handlePillFocus.bind(_assertThisInitialized(_this));
                    _this._handlePillKeydown = _this._handlePillKeydown.bind(_assertThisInitialized(_this));
                    _this._handleSlotChange = _this._pauseChangeEvents(_this._handleSlotChange.bind(_assertThisInitialized(_this)));
                    _this._iosCloseOnBlur = _select_select_utils__WEBPACK_IMPORTED_MODULE_6__["iosCloseOnBlur"].bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsMultiselect, [ {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        if (!payload.value) {
                            return {
                                interactiveElement: this._textFieldNode
                            };
                        }
                        return {
                            interactiveElement: this.shadowRoot.getElementById(payload.value)
                        };
                    }
                }, {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        var _this2 = this;
                        _get(_getPrototypeOf(MdsMultiselect.prototype), "connectedCallback", this).call(this);
                        var slot = this.shadowRoot.querySelector("slot:not([name])");
                        slot.addEventListener("slotchange", this._handleSlotChange);
                        this.addEventListener("add", this._handleAdd);
                        this.addEventListener("remove", this._handleRemove);
                        this._menu = this.shadowRoot.querySelector(".multiselect__menu");
                        this._container = this.shadowRoot.querySelector(".multiselect");
                        this._header = this.shadowRoot.querySelector(".multiselect__header");
                        this._inputMirror = this.shadowRoot.querySelector(".multiselect__input-mirror");
                        setTimeout(function() {
                            _newArrowCheck(this, _this2);
                            !this._formAssociatedInput && _utils_form_utils__WEBPACK_IMPORTED_MODULE_5__["createFormAssociatedInput"].call(this, {
                                disabled: this.inactive || !this.value.length,
                                slotName: "form-associated-input"
                            });
                            this.inactive && this._container.addEventListener("click", _utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["stopPropagation"]);
                            this._filterOptions(this.inputValue);
                            this._ariaLiveFlag = true;
                        }.bind(this));
                    }
                }, {
                    key: "disconnectedCallback",
                    value: function disconnectedCallback() {
                        _get(_getPrototypeOf(MdsMultiselect.prototype), "disconnectedCallback", this).call(this);
                        MDS.isIOS && document.body.removeEventListener("touchstart", this._iosCloseOnBlur);
                    }
                }, {
                    key: "_focusOnFirstOption",
                    value: function _focusOnFirstOption() {
                        var _this3 = this;
                        this._filteredOptions[0] && setTimeout(function() {
                            _newArrowCheck(this, _this3);
                            return this._setActiveOption(this._filteredOptions[0]);
                        }.bind(this));
                    }
                }, {
                    key: "focus",
                    value: function focus() {
                        this._textFieldNode.focus();
                    }
                }, {
                    key: "_filterOptions",
                    value: function _filterOptions(value) {
                        var _this4 = this;
                        var regExp = new RegExp(value, "i");
                        this._hiddenOptions = [];
                        this._filteredOptions = [];
                        this._optionNodes.forEach(function(child) {
                            _newArrowCheck(this, _this4);
                            if (!regExp.test(child.label)) {
                                child._hidden = true;
                                this._hiddenOptions.push(child);
                            } else {
                                child._hidden = false;
                                this._filteredOptions.push(child);
                            }
                        }.bind(this));
                    }
                }, {
                    key: "_clearHiddenOptions",
                    value: function _clearHiddenOptions() {
                        var _this5 = this;
                        this._hiddenOptions.forEach(function(child) {
                            _newArrowCheck(this, _this5);
                            child._hidden = false;
                        }.bind(this));
                        this._hiddenOptions = [];
                    }
                }, {
                    key: "_setSelectedOptions",
                    value: function _setSelectedOptions() {
                        this.selectedOptions = new Map(this.selectedOptions);
                    }
                }, {
                    key: "_setActiveOption",
                    value: function _setActiveOption(targetNode) {
                        var _this6 = this;
                        var setInputValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                        if (this._activeOption) {
                            this._activeOption._active = false;
                        }
                        if (targetNode) {
                            this.setState({
                                _activeOption: _extends(targetNode, {
                                    _active: true
                                }),
                                inputValue: setInputValue ? targetNode.label : this.inputValue
                            }).then(function() {
                                _newArrowCheck(this, _this6);
                                if (this._activeOption) {
                                    this._activeOption._active = true;
                                }
                                this._positionListbox(targetNode);
                            }.bind(this));
                        } else {
                            this._activeOption = null;
                        }
                    }
                }, {
                    key: "_resizeInput",
                    value: function _resizeInput() {
                        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
                        this._inputMirror.innerHTML = value.replace(/\s+/g, "&nbsp");
                        var maxWidth = this._header.offsetWidth - MdsMultiselect["_".concat(this.variant, "InputPadding")];
                        this._inputWidth = "".concat(Math.min(maxWidth, this._inputMirror.offsetWidth + MdsMultiselect._defaultInputWidth), "px");
                    }
                }, {
                    key: "_positionListbox",
                    value: function _positionListbox(slottedOption) {
                        var optionNode = this.shadowRoot.querySelector('.multiselect-option[data-value="'.concat(slottedOption.value, '"]'));
                        if (MDS.isChrome || MDS.isSafari) {
                            optionNode.scrollIntoViewIfNeeded(false);
                        } else if (optionNode.offsetParent === this._menu) {
                            if (optionNode.offsetTop >= this._menu.offsetHeight + this._menu.scrollTop) {
                                this._menu.scrollTop = optionNode.offsetTop - (this._menu.offsetHeight - optionNode.offsetHeight);
                            } else if (optionNode.offsetTop < this._menu.scrollTop) {
                                this._menu.scrollTop = optionNode.offsetTop;
                            }
                        }
                    }
                }, {
                    key: "_handleAdd",
                    value: function _handleAdd(event) {
                        this.selectedOptions.set(event.target.value, event.target);
                        this._setSelectedOptions();
                        this._setActiveOption(event.target, false);
                        this.inputValue = "";
                        this.focus();
                    }
                }, {
                    key: "_handleRemove",
                    value: function _handleRemove(event) {
                        var targetValue = event.target.value || event.target.dataset.value;
                        this.selectedOptions.get(targetValue).selected = false;
                        this._positionListbox(event.target);
                        this.selectedOptions.delete(targetValue);
                        this._setSelectedOptions();
                        this.inputValue = "";
                    }
                }, {
                    key: "_handleHeaderClick",
                    value: function _handleHeaderClick(event) {
                        this.focus();
                        !this._visible && this.open();
                        _get(_getPrototypeOf(MdsMultiselect.prototype), "_onclick", this) && _get(_getPrototypeOf(MdsMultiselect.prototype), "_onclick", this).call(this, event);
                    }
                }, {
                    key: "_handleHeaderMousedown",
                    value: function _handleHeaderMousedown(event) {
                        if (this.inactive || !event.target.dataset.value && event.target !== this._textFieldNode) {
                            event.preventDefault();
                        }
                    }
                }, {
                    key: "_handleInputBlur",
                    value: function _handleInputBlur(event) {
                        if (!this.deepContains(event.relatedTarget)) {
                            if (this._visible) {
                                this.close();
                            } else {
                                this._inputHasFocus = false;
                            }
                            _get(_getPrototypeOf(MdsMultiselect.prototype), "_onblur", this) && _get(_getPrototypeOf(MdsMultiselect.prototype), "_onblur", this).call(this, event);
                        } else if (this._activeOption && event.relatedTarget === this._lastPillNode) {
                            this._cachedActiveOption = this._activeOption;
                            this._activeOption && this._setActiveOption();
                        }
                    }
                }, {
                    key: "_handleInputFocus",
                    value: function _handleInputFocus() {
                        this._inputHasFocus = true;
                        if (this._cachedActiveOption) {
                            this._setActiveOption(this._cachedActiveOption);
                            this._cachedActiveOption = null;
                        }
                    }
                }, {
                    key: "_handleInputInput",
                    value: function _handleInputInput(event) {
                        if (event.target.value) {
                            _utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["setAriaLiveText"].call(this, "_ariaLiveFilteredOptions", 2e3);
                            this._filterOptions(event.target.value);
                            this._setActiveOption();
                        }
                        this.inputValue = event.target.value;
                        !this._visible && this.inputValue && this.open();
                        _get(_getPrototypeOf(MdsMultiselect.prototype), "_oninput", this) && _get(_getPrototypeOf(MdsMultiselect.prototype), "_oninput", this).call(this, event);
                    }
                }, {
                    key: "_handleInputKeydown",
                    value: function _handleInputKeydown(event) {
                        if (this._activeOption && [ 13, 32 ].includes(event.keyCode)) {
                            event.preventDefault();
                            this._activeOption._toggleSelected(event);
                        } else if ([ 40, 38 ].includes(event.keyCode)) {
                            event.preventDefault();
                            if (!this._activeOption) {
                                if (!this._visible && event.keyCode === 40) {
                                    this.open(true);
                                } else if (event.keyCode === 40) {
                                    this._focusOnFirstOption();
                                }
                            } else {
                                var _filteredOptions = this._filteredOptions;
                                var activeIndex = _filteredOptions.indexOf(this._activeOption);
                                if (event.keyCode === 40) {
                                    activeIndex === _filteredOptions.length - 1 ? this._setActiveOption(_filteredOptions[0]) : this._setActiveOption(_filteredOptions[activeIndex + 1]);
                                } else {
                                    activeIndex === 0 ? this._setActiveOption(_filteredOptions[_filteredOptions.length - 1]) : this._setActiveOption(_filteredOptions[activeIndex - 1]);
                                }
                            }
                        } else if (event.target.selectionStart === 0 && event.target.selectionEnd === 0) {
                            var lastPill = this._lastPillNode;
                            if (event.keyCode === 8) {
                                lastPill && lastPill.click();
                            } else if (event.keyCode === 37) {
                                lastPill && lastPill.focus();
                            }
                        }
                        _get(_getPrototypeOf(MdsMultiselect.prototype), "_onkeydown", this) && _get(_getPrototypeOf(MdsMultiselect.prototype), "_onkeydown", this).call(this, event);
                    }
                }, {
                    key: "_handleKeyup",
                    value: function _handleKeyup(event) {
                        this._visible && Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["isEscAndShouldClose"])(event) && this.close(true);
                        _get(_getPrototypeOf(MdsMultiselect.prototype), "_onkeyup", this) && _get(_getPrototypeOf(MdsMultiselect.prototype), "_onkeyup", this).call(this, event);
                    }
                }, {
                    key: "_handleMenuMousedown",
                    value: function _handleMenuMousedown(event) {
                        if (this._activeOption && event.target.dataset.value !== this._activeOption.value) {
                            this._setActiveOption();
                        }
                    }
                }, {
                    key: "_handleMenuMouseup",
                    value: function _handleMenuMouseup(event) {
                        var slottedNode = this.querySelector('mds-multiselect-option[value="'.concat(event.target.dataset.value, '"]'));
                        this._setActiveOption(slottedNode, false);
                        this.focus();
                    }
                }, {
                    key: "_handlePillClick",
                    value: function _handlePillClick(event) {
                        var _this7 = this;
                        this.focus();
                        this._setActiveOption();
                        var slottedOption = this.selectedOptions.get(event.target.dataset.value);
                        slottedOption.selected = false;
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this7);
                            return "click";
                        }.bind(this), this)(event, {
                            label: slottedOption.label,
                            value: slottedOption.value
                        });
                        event.stopPropagation();
                    }
                }, {
                    key: "_handlePillFocus",
                    value: function _handlePillFocus() {
                        this._inputHasFocus = true;
                    }
                }, {
                    key: "_handlePillKeydown",
                    value: function _handlePillKeydown(event) {
                        if ([ 13, 32, 8, 46 ].includes(event.keyCode)) {
                            event.preventDefault();
                            var selectedValues = _toConsumableArray(this.selectedOptions.keys());
                            var optionIndex = selectedValues.indexOf(event.target.dataset.value);
                            var slottedOption = this.selectedOptions.get(event.target.dataset.value);
                            var pills = this._pillNodes;
                            if (pills.length - 1 > optionIndex) {
                                pills[optionIndex].focus();
                            } else if (pills.length - 1) {
                                pills[optionIndex - 1].focus();
                            } else {
                                this.focus();
                            }
                            slottedOption.selected = false;
                        } else if (event.keyCode === 9 && event.shiftKey) {
                            var _selectedValues = _toConsumableArray(this.selectedOptions.keys());
                            _selectedValues.indexOf(event.target.dataset.value) === 0 && this.close();
                        } else if (event.keyCode === 37 || event.keyCode === 39) {
                            event.preventDefault();
                            var _pills = this._pillNodes;
                            var currentIndex = _pills.indexOf(event.target);
                            var nextIndex = currentIndex + (event.keyCode === 37 ? -1 : 1);
                            var nextPill = _pills[nextIndex];
                            if (nextPill) {
                                nextPill.focus();
                            } else if (event.keyCode === 39) {
                                this.focus();
                            }
                        }
                        _get(_getPrototypeOf(MdsMultiselect.prototype), "_onkeydown", this) && _get(_getPrototypeOf(MdsMultiselect.prototype), "_onkeydown", this).call(this, event);
                    }
                }, {
                    key: "_handleSlotChange",
                    value: function _handleSlotChange() {
                        var _this8 = this;
                        this._formAssociatedInput = this.querySelector("input");
                        _utils_slot_utils__WEBPACK_IMPORTED_MODULE_7__["enforceSlotUsage"].call(this);
                        this.selectedOptions.clear();
                        this._optionNodes.forEach(function(child) {
                            _newArrowCheck(this, _this8);
                            child.selected && this.selectedOptions.set(child.value, child);
                        }.bind(this));
                        if (this.selectedOptions.size !== this.value.length || !this.value.every(function(key) {
                            _newArrowCheck(this, _this8);
                            return this.selectedOptions.has(key);
                        }.bind(this))) {
                            this._setSelectedOptions();
                        }
                    }
                }, {
                    key: "_pauseChangeEvents",
                    value: function _pauseChangeEvents(cb) {
                        var _this9 = this;
                        return function() {
                            _newArrowCheck(this, _this9);
                            this._shouldFireChangeEvents = false;
                            cb();
                            this._shouldFireChangeEvents = true;
                        }.bind(this);
                    }
                }, {
                    key: "accessibleTextSelectionStatusChangedCallback",
                    value: function accessibleTextSelectionStatusChangedCallback() {
                        !!this.accessibleTextSelectionStatus && this._ariaLiveFlag && _utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["setAriaLiveText"].call(this, "_selectionStatusAriaLiveActive", 2e3);
                    }
                }, {
                    key: "inactiveChangedCallback",
                    value: function inactiveChangedCallback(inactive) {
                        if (this._container) {
                            inactive ? this._container.addEventListener("click", _utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["stopPropagation"]) : this._container.removeEventListener("click", _utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["stopPropagation"]);
                        }
                        this._formAssociatedInput && _utils_form_utils__WEBPACK_IMPORTED_MODULE_5__["syncFormAssociatedInputDisabledValue"].call(this, inactive);
                    }
                }, {
                    key: "inputValueChangedCallback",
                    value: function inputValueChangedCallback(inputValue) {
                        this._inputMirror && this._resizeInput(inputValue);
                        if (!inputValue) {
                            this._filterOptions();
                        }
                    }
                }, {
                    key: "_inputHasFocusChangedCallback",
                    value: function _inputHasFocusChangedCallback(inputHasFocus) {
                        if (inputHasFocus && !this._visible) {
                            this.dispatchEvent(new CustomEvent("focus", {
                                bubbles: true,
                                composed: true
                            }));
                        }
                    }
                }, {
                    key: "selectedOptionsChangedCallback",
                    value: function selectedOptionsChangedCallback() {
                        var _this10 = this;
                        this.value = _toConsumableArray(this.selectedOptions.keys());
                        this._formAssociatedInput && _utils_form_utils__WEBPACK_IMPORTED_MODULE_5__["syncFormAssociatedInputValue"].call(this, this.value.join());
                        this._shouldFireChangeEvents && Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this10);
                            return "change";
                        }.bind(this), this)({
                            target: this
                        });
                    }
                }, {
                    key: "open",
                    value: function open(focusOnFirstOption) {
                        this._visible = true;
                        focusOnFirstOption && this._focusOnFirstOption();
                        this.dispatchEvent(new CustomEvent("open", {
                            bubbles: true,
                            composed: true
                        }));
                        MDS.isIOS && document.body.addEventListener("touchstart", this._iosCloseOnBlur);
                    }
                }, {
                    key: "close",
                    value: function close(refocus) {
                        var _this11 = this;
                        if (refocus) {
                            this.focus();
                        } else {
                            this._inputHasFocus = false;
                        }
                        this.setState({
                            _visible: false,
                            inputValue: "",
                            _filteredOptions: this._optionNodes
                        }).then(function() {
                            _newArrowCheck(this, _this11);
                            this._clearHiddenOptions();
                            this._setActiveOption();
                        }.bind(this));
                        this.dispatchEvent(new CustomEvent("close", {
                            bubbles: true,
                            composed: true
                        }));
                        MDS.isIOS && document.body.removeEventListener("touchstart", this._iosCloseOnBlur);
                    }
                }, {
                    key: "clearSelected",
                    value: function clearSelected() {
                        var _this12 = this;
                        if (this.value.length) {
                            this.value.forEach(function(key) {
                                _newArrowCheck(this, _this12);
                                this.selectedOptions.get(key).selected = false;
                            }.bind(this));
                            this.selectedOptions = new Map;
                            Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["createCustomEventDispatcher"])(function() {
                                _newArrowCheck(this, _this12);
                                return "change";
                            }.bind(this), this)({
                                target: this
                            });
                        }
                    }
                }, {
                    key: "render",
                    value: function render() {
                        _MdsMultiselect__WEBPACK_IMPORTED_MODULE_3__["default"].call(this);
                    }
                }, {
                    key: "_optionNodes",
                    get: function get() {
                        return _toConsumableArray(this.querySelectorAll("mds-multiselect-option"));
                    }
                }, {
                    key: "_pillNodes",
                    get: function get() {
                        return _toConsumableArray(this.shadowRoot.querySelectorAll(".multiselect__pill"));
                    }
                }, {
                    key: "_lastPillNode",
                    get: function get() {
                        var pills = this._pillNodes;
                        return pills.length ? pills[pills.length - 1] : null;
                    }
                }, {
                    key: "_visibleNodes",
                    get: function get() {
                        return _toConsumableArray(this.shadowRoot.querySelectorAll('.multiselect-option[data-active="true"]'));
                    }
                } ]);
                return MdsMultiselect;
            }(_abstract_text_field__WEBPACK_IMPORTED_MODULE_1__["default"]), _class2.styles = _mds_multiselect_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2._childLocalNames = [ "mds-multiselect-option" ], _class2._defaultInputWidth = 3, 
            _class2._boxInputPadding = [ "8px", "12px", "12px", "16px" ].reduce(function(acc, el) {
                _newArrowCheck(this, _this13);
                return acc + Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_8__["cleanCssValue"])(el);
            }.bind(undefined), 0), _class2._lineInputPadding = Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_8__["cleanCssValue"])("12px") + Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_8__["cleanCssValue"])("16px"), 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsMultiselect;
        },
        "./src/multiselect/mds-multiselect.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/multiselect/mds-multiselect.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/multiselect/multiselect-option/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_slot_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/slot-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].boolean, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].stringRequired;
            var entity = {
                label: stringRequired,
                value: stringRequired,
                selected: boolean.defaultsTo(false).withChangedCallback()
            };
            var MdsMultiselectOption = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsMultiselectOption, _AgaveComponent);
                _createClass(MdsMultiselectOption, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsMultiselectOption";
                    }
                } ]);
                function MdsMultiselectOption() {
                    var _this;
                    _classCallCheck(this, MdsMultiselectOption);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsMultiselectOption).call(this));
                    _this._toggleSelected = _this._toggleSelected.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsMultiselectOption, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsMultiselectOption.prototype), "connectedCallback", this).call(this);
                        this._connected = true;
                        _utils_slot_utils__WEBPACK_IMPORTED_MODULE_2__["enforceSlottedComponentUsage"].call(this);
                    }
                }, {
                    key: "_toggleSelected",
                    value: function _toggleSelected(event) {
                        var _this2 = this;
                        this.selected = !this.selected;
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this2);
                            return "click";
                        }.bind(this), this)(event, {
                            label: this.label,
                            value: this.value
                        });
                    }
                }, {
                    key: "selectedChangedCallback",
                    value: function selectedChangedCallback(selected) {
                        var _this3 = this;
                        if (this._connected) {
                            Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["createCustomEventDispatcher"])(function() {
                                _newArrowCheck(this, _this3);
                                return selected ? "add" : "remove";
                            }.bind(this), this)({
                                target: this
                            });
                        }
                    }
                } ]);
                return MdsMultiselectOption;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_0___default.a), _class2._parentLocalNames = [ "mds-multiselect" ], 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsMultiselectOption;
        },
        "./src/navigation-bar/abstract-navigation-bar-row/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var AbstractNavigationBarRow = function(_AgaveComponent) {
                _inherits(AbstractNavigationBarRow, _AgaveComponent);
                _createClass(AbstractNavigationBarRow, [ {
                    key: "itemNodes",
                    get: function get() {
                        return _toConsumableArray(this.querySelectorAll(":scope > mds-navigation-bar-item"));
                    }
                }, {
                    key: "defaultSlotItemNodes",
                    get: function get() {
                        return this.shadowRoot.querySelector("slot").assignedElements();
                    }
                }, {
                    key: "cumulativeElementWidth",
                    get: function get() {
                        var _this2 = this;
                        return [].concat(_toConsumableArray(this.itemNodes), [ this.shadowRoot.querySelector('slot[name="product-marker"]') ]).reduce(function(totalWidth, el) {
                            _newArrowCheck(this, _this2);
                            if (el) {
                                totalWidth += el.offsetWidth;
                            }
                            return totalWidth;
                        }.bind(this), 0);
                    }
                } ], [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "AbstractNavigationBarRow";
                    }
                } ]);
                function AbstractNavigationBarRow() {
                    var _this;
                    _classCallCheck(this, AbstractNavigationBarRow);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(AbstractNavigationBarRow).call(this));
                    _this._activeItem = null;
                    _this._handleChange = _this._handleChange.bind(_assertThisInitialized(_this));
                    _this._handleSlotChange = _this._handleSlotChange.bind(_assertThisInitialized(_this));
                    _this._addEventListeners = _this._addEventListeners.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(AbstractNavigationBarRow, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(AbstractNavigationBarRow.prototype), "connectedCallback", this).call(this);
                        !this._hasConnected && this._addEventListeners();
                        this._hasConnected = true;
                    }
                }, {
                    key: "_addEventListeners",
                    value: function _addEventListeners() {
                        var _this3 = this;
                        var container = this.shadowRoot.querySelector(".".concat(this.localName.slice(4)));
                        if (container) {
                            container.addEventListener("slotchange", this._handleSlotChange);
                            container.addEventListener("click", function(event) {
                                _newArrowCheck(this, _this3);
                                !(event instanceof CustomEvent) && event.stopPropagation();
                            }.bind(this));
                        }
                        this.addEventListener("change", this._handleChange);
                    }
                }, {
                    key: "_handleChange",
                    value: function _handleChange(event) {
                        var isItemActive;
                        var navBarItem;
                        if (event.target.localName === "mds-navigation-bar-menu") {
                            isItemActive = !!event.target._activeItem;
                            navBarItem = event.target.parentElement;
                        } else if (event.target.localName === "mds-navigation-bar-item") {
                            isItemActive = !!event.target.active;
                            navBarItem = event.target;
                        }
                        if (isItemActive && navBarItem !== this._activeItem) {
                            this.activeIndex = navBarItem._index;
                        } else if (!isItemActive && navBarItem === this._activeItem) {
                            this.activeIndex = -1;
                        }
                    }
                }, {
                    key: "activeIndexChangedCallback",
                    value: function activeIndexChangedCallback() {
                        var _this4 = this;
                        this._activeItem = this.itemNodes[this.activeIndex] || null;
                        if (this._hasConnected) {
                            (this.variant === "primary" || this.variant === "global") && this.setPointerPosition();
                            this._isSlotInitialized && this.itemNodes.forEach(function(child) {
                                _newArrowCheck(this, _this4);
                                child.active = child._index === this.activeIndex;
                                if (!child.active && child._menu) {
                                    child._menu.activeIndex = -1;
                                }
                            }.bind(this));
                        } else if (this._activeItem) {
                            this._activeItem.setAttribute("active", true);
                            this.activeBottomSlot = this._activeItem.getAttribute("bottom-slot-key") || null;
                        }
                    }
                } ]);
                return AbstractNavigationBarRow;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_0___default.a);
            __webpack_exports__["default"] = AbstractNavigationBarRow;
        },
        "./src/navigation-bar/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _abstract_navigation_bar_row__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/navigation-bar/abstract-navigation-bar-row/index.js");
            var _search_box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/search-box/index.js");
            var _mds_navigation_bar_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/navigation-bar/mds-navigation-bar.scss");
            var _mds_navigation_bar_scss__WEBPACK_IMPORTED_MODULE_4___default = __webpack_require__.n(_mds_navigation_bar_scss__WEBPACK_IMPORTED_MODULE_4__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/utils/data-utils.js");
            var _utils_allowLists__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/utils/allowLists.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _dec, _class, _class2;
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var number = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].number, satisfies = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].satisfies, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].boolean, string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].stringRequired, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].enumerables;
            var entity = {
                activeIndex: number.defaultsTo(-1).withChangedCallback(),
                accessibleText: stringRequired,
                activeBottomSlot: string,
                actionButtonText: string,
                actionButtonAccessibleText: string,
                sticky: boolean,
                maxWidth: number,
                variant: enumerables(string, "primary", "secondary", "back", "inApp", "global").defaultsTo("global"),
                backgroundColor: enumerables(string, "primary", "secondary").defaultsTo("primary").withChangedCallback(),
                experienceName: string.withHTML(_utils_allowLists__WEBPACK_IMPORTED_MODULE_7__["base"]),
                productMarker: string,
                productMarkerAccessibleText: string,
                pageName: string.withHTML(_utils_allowLists__WEBPACK_IMPORTED_MODULE_7__["base"]),
                backButtonText: string,
                backButtonAccessibleText: string,
                secondaryXsButtonText: string,
                secondaryXsButtonAccessibleText: string,
                searchBoxData: satisfies(_search_box__WEBPACK_IMPORTED_MODULE_3__["entity"]),
                experienceNameHeadingLevel: number.withMinSize(1).withMaxSize(6),
                pageNameHeadingLevel: number.withMinSize(1).withMaxSize(6)
            };
            var MdsNavigationBar = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AbstractNavigationBa) {
                _inherits(MdsNavigationBar, _AbstractNavigationBa);
                _createClass(MdsNavigationBar, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsNavigationBar";
                    }
                } ]);
                function MdsNavigationBar() {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsNavigationBar);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsNavigationBar).call(this));
                    _this.updateNodeAttributes = function(nodes, attrToUpdate, attrVal, childElementName) {
                        var _this3 = this;
                        _newArrowCheck(this, _this2);
                        nodes.forEach(function(node) {
                            _newArrowCheck(this, _this3);
                            if (node.localName === childElementName) {
                                node[attrToUpdate] = attrVal;
                            }
                        }.bind(this));
                    }.bind(this);
                    _this.defineObservedProperty("_pointerPosition", null);
                    _this.defineObservedProperty("_isBottomSlotUsed", false);
                    _this.defineObservedProperty("_isbackNavBarSlotUsed", false);
                    _this.defineObservedProperty("_showBottomSheetTrigger", Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["getBreakpoint"])() === "xs" || Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["getBreakpoint"])() === "sm");
                    _this._onfocus = _this._onfocus.bind(_assertThisInitialized(_this));
                    _this._onblur = _this._onblur.bind(_assertThisInitialized(_this));
                    _this.setPointerPosition = _this.setPointerPosition.bind(_assertThisInitialized(_this));
                    _this._handleChange = _this._handleChange.bind(_assertThisInitialized(_this));
                    _this._handleResize = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["throttle"])(_this.setPointerPosition, 50, true);
                    _this._handleMenuCaret = _this._handleMenuCaret.bind(_assertThisInitialized(_this));
                    _this._dispatchCustomEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["createCustomEventDispatcher"])();
                    _this._handleBottomSheetTriggerDisplayDebounce = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["debounce"])(_this._handleBottomSheetTriggerDisplay.bind(_assertThisInitialized(_this)), 100);
                    _this._handleBottomSheetTriggerDisplay = _this._handleBottomSheetTriggerDisplay.bind(_assertThisInitialized(_this));
                    _this.focusOnExperienceName = _this.focusOnExperienceName.bind(_assertThisInitialized(_this));
                    _this._getExperienceOrPageName = _this._getExperienceOrPageName.bind(_assertThisInitialized(_this));
                    _this._updateTabIndex = _this._updateTabIndex.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsNavigationBar, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        var _this4 = this;
                        _get(_getPrototypeOf(MdsNavigationBar.prototype), "connectedCallback", this).call(this);
                        (this.variant === "primary" || this.variant === "global") && setTimeout(this.setPointerPosition, 1e3);
                        [ "open", "close" ].forEach(function(eventName) {
                            _newArrowCheck(this, _this4);
                            return this.addEventListener(eventName, this._handleMenuCaret);
                        }.bind(this));
                        this.variant === "inApp" && console.warn("ATTN MDS DEVS: This variant is deprecated, but still needs to be mantained. Ensure the following is maintained for the inApp variant:\n    1) the list items (items & overflow button) should be centered on the bar, \n    2) in screens that are 768px or smaller, the overflow menu button should be right aligned,\n    3) the right and left padding on the bar is always 24px, regardless of screen-size, \n    4) the vertical padding is 10px.");
                    }
                }, {
                    key: "disconnectedCallback",
                    value: function disconnectedCallback() {
                        _get(_getPrototypeOf(MdsNavigationBar.prototype), "disconnectedCallback", this) && _get(_getPrototypeOf(MdsNavigationBar.prototype), "disconnectedCallback", this).call(this);
                        (this.variant === "primary" || this.variant === "global") && window.removeEventListener("resize", this._handleResize);
                        this.variant === "secondary" && window.removeEventListener("resize", this._handleBottomSheetTriggerDisplayDebounce);
                    }
                }, {
                    key: "_addEventListeners",
                    value: function _addEventListeners() {
                        _get(_getPrototypeOf(MdsNavigationBar.prototype), "_addEventListeners", this).call(this);
                        (this.variant === "primary" || this.variant === "global") && window.addEventListener("resize", this._handleResize);
                        this.variant === "secondary" && window.addEventListener("resize", this._handleBottomSheetTriggerDisplayDebounce);
                    }
                }, {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        return {
                            interactiveElement: this.shadowRoot.getElementById(payload.target)
                        };
                    }
                }, {
                    key: "_handleBottomSheetTriggerDisplay",
                    value: function _handleBottomSheetTriggerDisplay() {
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["getBreakpoint"])() === "xs" || Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["getBreakpoint"])() === "sm" ? this._showBottomSheetTrigger = true : this._showBottomSheetTrigger = false;
                    }
                }, {
                    key: "_handleMenuCaret",
                    value: function _handleMenuCaret(event) {
                        this._hasOpenMenu = event.type === "open";
                        this.setPointerPosition();
                    }
                }, {
                    key: "_handleChange",
                    value: function _handleChange(event) {
                        _get(_getPrototypeOf(MdsNavigationBar.prototype), "_handleChange", this).call(this, event);
                        if (this._activeItem && this._activeItem.contains(event.target)) {
                            if (this._activeItem.bottomSlotKey) {
                                this.activeBottomSlot = this._activeItem.bottomSlotKey;
                            } else if (this._activeItem._menu && this._activeItem._menu._activeItem) {
                                this.activeBottomSlot = this._activeItem._menu._activeItem.bottomSlotKey;
                            }
                        } else {
                            this.activeBottomSlot = null;
                        }
                    }
                }, {
                    key: "_handleSlotChange",
                    value: function _handleSlotChange(event) {
                        var _this5 = this;
                        this._isSlotInitialized = false;
                        if (event.target.name === "backNavBar") {
                            this._isbackNavBarSlotUsed = true;
                        }
                        if (!event.target.name || event.target.name === "overflow") {
                            var invalidElements = [];
                            var preselectedItem = null;
                            var itemCount = 0;
                            _toConsumableArray(this.children).forEach(function(child) {
                                _newArrowCheck(this, _this5);
                                if (child.assignedSlot && child.assignedSlot.name !== "product-marker") {
                                    if (!this.constructor._childLocalNames.includes(child.localName)) {
                                        invalidElements.push(child.localName);
                                        child.remove();
                                    } else if (child.localName === "mds-navigation-bar-item") {
                                        child._index = itemCount;
                                        child._variant = this.variant;
                                        child._backgroundColor = this.backgroundColor;
                                        itemCount++;
                                        if (child.active) {
                                            preselectedItem = child;
                                            this.activeIndex = child._index;
                                        }
                                    }
                                }
                            }.bind(this));
                            if (!preselectedItem) {
                                var items = this.itemNodes;
                                if (items.length && items[this.activeIndex]) {
                                    this._activeItem = items[this.activeIndex];
                                    this._activeItem.active = true;
                                } else {
                                    this.activeIndex = -1;
                                }
                            }
                            if (invalidElements.length) {
                                var validList = this.constructor._childLocalNames.map(function(localName) {
                                    _newArrowCheck(this, _this5);
                                    return "<".concat(localName, ">");
                                }.bind(this)).join(", ");
                                var invalidList = invalidElements.map(function(localName) {
                                    _newArrowCheck(this, _this5);
                                    return "<".concat(localName, ">");
                                }.bind(this)).join(", ");
                                this.throwConstraintError("Only ".concat(validList, " is accepted in the default or overflow slots. The following elements were detected: ").concat(invalidList, "."));
                            }
                        } else if (event.target.name === "bottom") {
                            var slottedElements = event.target.assignedElements();
                            var slottedElLocalName = slottedElements[0] ? slottedElements[0].localName : null;
                            if (slottedElements.length && (slottedElements.length > 1 || slottedElLocalName !== "mds-navigation-bar-bottom")) {
                                slottedElements[0].remove();
                                this.throwConstraintError('The "bottom" slot only accepts a single mds-navigation-bar-bottom.');
                            }
                        }
                        this._isSlotInitialized = true;
                    }
                }, {
                    key: "setPointerPosition",
                    value: function setPointerPosition() {
                        if (this._isbackNavBarSlotUsed) {
                            this._pointerPosition = null;
                            return;
                        }
                        if (this._activeItem && (this.variant !== "secondary" || this.variant !== "inApp") && !this._hasOpenMenu) {
                            var firstItemLeftPosition = this.itemNodes[0].getBoundingClientRect().left;
                            var _this$itemNodes$this$ = this.itemNodes[this.activeIndex].getBoundingClientRect(), width = _this$itemNodes$this$.width, left = _this$itemNodes$this$.left;
                            var translateValue = left + width / 2 - Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssValue"])("14px") - firstItemLeftPosition;
                            this._pointerPosition = {
                                transform: "translateX(".concat(translateValue, "px)")
                            };
                        } else {
                            this._pointerPosition = null;
                        }
                    }
                }, {
                    key: "focusOnExperienceName",
                    value: function focusOnExperienceName() {
                        var navbarBottom = this.activeBottomSlot ? this.querySelector('mds-navigation-bar-bottom[slot="'.concat(this.activeBottomSlot, '"]')) : this.querySelector("mds-navigation-bar-bottom");
                        if (navbarBottom) {
                            navbarBottom.focusOnExperienceName();
                        } else {
                            var header = this._getExperienceOrPageName();
                            header.focus();
                        }
                    }
                }, {
                    key: "_getExperienceOrPageName",
                    value: function _getExperienceOrPageName() {
                        var experienceName = this.shadowRoot.querySelector(".navigation-bar__experience-name");
                        var pageName = this.shadowRoot.querySelector(".navigation-bar__page-name");
                        return experienceName || pageName;
                    }
                }, {
                    key: "_updateTabIndex",
                    value: function _updateTabIndex(element, tabindex) {
                        element.setAttribute("tabindex", tabindex);
                    }
                }, {
                    key: "_onfocus",
                    value: function _onfocus() {
                        this._updateTabIndex(this._getExperienceOrPageName(), "0");
                    }
                }, {
                    key: "_onblur",
                    value: function _onblur() {
                        this._updateTabIndex(this._getExperienceOrPageName(), "-1");
                    }
                }, {
                    key: "backgroundColorChangedCallback",
                    value: function backgroundColorChangedCallback(newColor) {
                        this.updateNodeAttributes(_toConsumableArray(this.children), "_backgroundColor", newColor, "mds-navigation-bar-item");
                    }
                }, {
                    key: "renderExperience",
                    value: function renderExperience() {
                        var experienceNameClasses = {
                            "navigation-bar__experience-name": this.variant == "secondary",
                            "navigation-bar__experience-name--sticky": this.variant === "secondary" && this.sticky === true,
                            "navigation-bar__page-name": this.variant == "back"
                        };
                        var areaLabelVal = this.experienceNameHeadingLevel || this.pageNameHeadingLevel;
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "navigation-bar__experience navigation-bar__experience--".concat(this.variant));
                        _renderArbitrary((this.experienceName || this.pageName) && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("span"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", experienceNameClasses), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("tabindex", "-1"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onblur", this._onblur), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onfocus", this._onfocus), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("innerHTML-prop", this.experienceName || this.pageName), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "mds-navigation-bar-exp-heading"), 
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["conditionalAttribute"])({
                            "aria-level": areaLabelVal
                        }, areaLabelVal)), _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["conditionalAttribute"])({
                            role: "heading"
                        }, areaLabelVal)), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("__skip", "true"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("span"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        _renderArbitrary(this.productMarker && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "navigation-bar__product-container"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("img", null, null, "class", "navigation-bar__product-marker", "src", this.productMarker, "alt", this.productMarkerAccessibleText), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                        _renderArbitrary(this._showBottomSheetTrigger && this.variant === "secondary" && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("button", null, null, "id", "bottom-sheet-trigger", "type", "button", "class", "navigation-bar__xs-button", "onclick", this._dispatchCustomEvent, "onblur", this._dispatchCustomEvent, "onfocus", this._dispatchCustomEvent), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "navigation-bar__xs-button-content"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "navigation-bar__xs-button-text"), 
                        _renderArbitrary(this.secondaryXsButtonText), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "navigation-bar__xs-button-icon", "innerHTML-prop", MDS.svgs.ico_chevron_down, "aria-hidden", "true", "__skip", "true"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text"), 
                        _renderArbitrary(this.secondaryXsButtonAccessibleText), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span"), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("button")));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "renderBackButton",
                    value: function renderBackButton() {
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "navigation-bar__back-button-container");
                        _renderArbitrary((this.backButtonText || this.backButtonAccessibleText) && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("button", null, null, "id", "back-button", "class", "navigation-bar__back-button", "aria-label", this.backButtonAccessibleText, "type", "button", "onclick", this._dispatchCustomEvent, "onblur", this._dispatchCustomEvent, "onfocus", this._dispatchCustomEvent), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "navigation-bar__back-button-icon", "innerHTML-prop", MDS.svgs.ico_chevron_left, "aria-hidden", "true", "__skip", "true"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span"), 
                        _renderArbitrary(this.backButtonText && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "navigation-bar__back-button-text"), 
                        _renderArbitrary(this.backButtonText), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span"))), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("button")));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var _navigationBarClasses;
                        if (!this.accessibleText) {
                            this.throwConstraintError('The "accessibleText" property must have a value (e.g. "Main").');
                        }
                        var navigationBarClasses = (_navigationBarClasses = {
                            "navigation-bar": true
                        }, _defineProperty(_navigationBarClasses, "navigation-bar--".concat(this.variant), true), 
                        _defineProperty(_navigationBarClasses, "navigation-bar--sticky", this.sticky), _defineProperty(_navigationBarClasses, "navigation-bar--secondary-background", this.backgroundColor === "secondary"), 
                        _navigationBarClasses);
                        var topContainerClasses = {
                            "navigation-bar__top-row-container": true,
                            "navigation-bar__top-row-container--with-productMarker": !!this.productMarker
                        };
                        var bottomRowContainerClasses = {
                            "navigation-bar__bottom-row-container": true,
                            "navigation-bar__bottom-row-container--with-border": !!this.activeBottomSlot || !!this._isBottomSlotUsed
                        };
                        var isPrimaryVariant = this.variant === "primary" || this.variant === "global";
                        var isSecondaryVariant = this.variant === "secondary";
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("nav", null, null, "class", navigationBarClasses, "aria-label", this.accessibleText);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", topContainerClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "navigation-bar__row");
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["conditionalAttribute"])({
                            style: {
                                maxWidth: "".concat(this.maxWidth, "px")
                            }
                        }, this.maxWidth));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                        _renderArbitrary(this.variant === "back" && this.renderBackButton());
                        _renderArbitrary((isSecondaryVariant || this.variant === "back") && this.renderExperience());
                        _renderArbitrary(this.variant !== "back" && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "navigation-bar__list", "role", "list"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "class", "navigation-bar__items"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "name", "overflow"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                        _renderArbitrary(isPrimaryVariant && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "name", "product-marker"));
                        _renderArbitrary(isSecondaryVariant && this.searchBoxData && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "navigation-bar__search-box-container"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("mds-search-box"), 
                        _spreadAttribute(this.searchBoxData), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "navigation-bar__search-box"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("mds-search-box"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-search-box"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                        _renderArbitrary(this.variant === "back" && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "navigation-bar__action-button-container"), 
                        _renderArbitrary(this.actionButtonText && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-button", null, null, "text", this.actionButtonText, "accessible-text", this.actionButtonAccessibleText, "variant", "tertiary", "width-type", "content", "type", "button", "small", "true", "id", "action-button", "onclick", this._dispatchCustomEvent, "onfocus", this._dispatchCustomEvent, "onblur", this._dispatchCustomEvent)), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                        _renderArbitrary(!!this._pointerPosition && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "navigation-bar__caret", "style", this._pointerPosition, "aria-hidden", "true"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        _renderArbitrary(isPrimaryVariant && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", bottomRowContainerClasses), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "name", "backNavBar"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "navigation-bar__row"), 
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["conditionalAttribute"])({
                            style: {
                                maxWidth: "".concat(this.maxWidth, "px")
                            }
                        }, this.maxWidth)), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "name", this.activeBottomSlot || "bottom"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div"), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("nav");
                    }
                } ]);
                return MdsNavigationBar;
            }(_abstract_navigation_bar_row__WEBPACK_IMPORTED_MODULE_2__["default"]), _class2.styles = _mds_navigation_bar_scss__WEBPACK_IMPORTED_MODULE_4___default.a, 
            _class2._childLocalNames = [ "mds-navigation-bar-item", "mds-navigation-bar-bottom", "mds-navigation-bar" ], 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsNavigationBar;
        },
        "./src/navigation-bar/mds-navigation-bar.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/navigation-bar/mds-navigation-bar.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/navigation-bar/navigation-bar-bottom/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_navigation_bar_bottom_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/navigation-bar/navigation-bar-bottom/mds-navigation-bar-bottom.scss");
            var _mds_navigation_bar_bottom_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_navigation_bar_bottom_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _abstract_navigation_bar_row__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/navigation-bar/abstract-navigation-bar-row/index.js");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_slot_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/slot-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            function _slicedToArray(arr, i) {
                return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
            }
            function _nonIterableRest() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _iterableToArrayLimit(arr, i) {
                var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
                if (null != _i) {
                    var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
                    try {
                        if (_x = (_i = _i.call(arr)).next, 0 === i) {
                            if (Object(_i) !== _i) return;
                            _n = !1;
                        } else for (;!(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) ;
                    } catch (err) {
                        _d = !0, _e = err;
                    } finally {
                        try {
                            if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
                        } finally {
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
            }
            function _arrayWithHoles(arr) {
                if (Array.isArray(arr)) return arr;
            }
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].stringRequired, number = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].number;
            var entity = {
                accessibleText: stringRequired,
                activeIndex: number.defaultsTo(0).withChangedCallback(),
                experienceName: string,
                journeyMarkerText: string
            };
            var MdsNavigationBarBottom = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AbstractNavigationBa) {
                _inherits(MdsNavigationBarBottom, _AbstractNavigationBa);
                _createClass(MdsNavigationBarBottom, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsNavigationBarBottom";
                    }
                } ]);
                function MdsNavigationBarBottom() {
                    var _this;
                    _classCallCheck(this, MdsNavigationBarBottom);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsNavigationBarBottom).call(this));
                    _this.defineObservedProperty("_isSlotInitialized", false);
                    _this.focusOnExperienceName = _this.focusOnExperienceName.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsNavigationBarBottom, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        var _this2 = this;
                        _get(_getPrototypeOf(MdsNavigationBarBottom.prototype), "connectedCallback", this).call(this);
                        _utils_slot_utils__WEBPACK_IMPORTED_MODULE_5__["enforceSlottedComponentUsage"].call(this);
                        setTimeout(function() {
                            _newArrowCheck(this, _this2);
                            return this.activeIndexChangedCallback();
                        }.bind(this));
                        if (this.journeyMarkerText && this.experienceName !== this.journeyMarkerText) {
                            this.experienceName = this.journeyMarkerText;
                        }
                    }
                }, {
                    key: "_addEventListeners",
                    value: function _addEventListeners() {
                        _get(_getPrototypeOf(MdsNavigationBarBottom.prototype), "_addEventListeners", this).call(this);
                        this.addEventListener("activate", _utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["stopPropagation"]);
                    }
                }, {
                    key: "_handleChange",
                    value: function _handleChange(event) {
                        _get(_getPrototypeOf(MdsNavigationBarBottom.prototype), "_handleChange", this).call(this, event);
                        event.stopPropagation();
                    }
                }, {
                    key: "_handleSlotChange",
                    value: function _handleSlotChange() {
                        var _this3 = this;
                        this._isSlotInitialized = false;
                        var invalidElements = [];
                        var preselectedItem = null;
                        var itemCount = 0;
                        _toConsumableArray(this.children).forEach(function(child) {
                            _newArrowCheck(this, _this3);
                            if (!this.constructor._childLocalNames.includes(child.localName)) {
                                invalidElements.push(child.localName);
                                child.remove();
                            } else {
                                child._index = itemCount;
                                child._experienceName = this.experienceName;
                                itemCount++;
                                if (child.active) {
                                    preselectedItem = child;
                                    this.activeIndex = child._index;
                                }
                            }
                        }.bind(this));
                        if (this.slot === "bottom") {
                            this.parentElement._isBottomSlotUsed = !!this.children.length;
                        }
                        if (!preselectedItem) {
                            if (this.children.length) {
                                this.activeIndex = 0;
                                var _this$children = _slicedToArray(this.children, 1);
                                this._activeItem = _this$children[0];
                                this._activeItem.active = true;
                            } else {
                                this.activeIndex = -1;
                            }
                        }
                        if (invalidElements.length) {
                            var validList = this.constructor._childLocalNames.map(function(localName) {
                                _newArrowCheck(this, _this3);
                                return "<".concat(localName, ">");
                            }.bind(this)).join(", ");
                            var invalidList = invalidElements.map(function(localName) {
                                _newArrowCheck(this, _this3);
                                return "<".concat(localName, ">");
                            }.bind(this)).join(", ");
                            this.throwConstraintError("Only ".concat(validList, " is accepted in the default or overflow slots. The following elements were detected: ").concat(invalidList, "."));
                        }
                        this._isSlotInitialized = true;
                    }
                }, {
                    key: "focusOnExperienceName",
                    value: function focusOnExperienceName() {
                        var experienceName = this.shadowRoot.querySelector(".navigation-bar-bottom__experience-name");
                        experienceName.focus();
                    }
                }, {
                    key: "render",
                    value: function render() {
                        if (!this.accessibleText) {
                            this.throwConstraintError('The "accessibleText" property must have a value (e.g. "Accounts").');
                        }
                        var classes = {
                            "navigation-bar-bottom": true,
                            "navigation-bar-bottom--secondary-background": this.parentElement.backgroundColor === "secondary",
                            "navigation-bar-bottom--hidden": !this.children.length
                        };
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("nav", null, null, "class", classes, "aria-label", this.accessibleText);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "navigation-bar-bottom__main-content");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("role", "list");
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["conditionalAttribute"])({
                            "aria-label": this.experienceName
                        }, !!this.experienceName));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                        _renderArbitrary(this.experienceName && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "navigation-bar-bottom__experience-name", "tabindex", "-1"), 
                        _renderArbitrary(this.experienceName), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "navigation-bar-bottom__slot");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "name", "overflow");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("nav");
                    }
                } ]);
                return MdsNavigationBarBottom;
            }(_abstract_navigation_bar_row__WEBPACK_IMPORTED_MODULE_3__["default"]), _class2.styles = _mds_navigation_bar_bottom_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2._parentLocalNames = [ "mds-navigation-bar" ], _class2._childLocalNames = [ "mds-navigation-bar-item" ], 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsNavigationBarBottom;
        },
        "./src/navigation-bar/navigation-bar-bottom/mds-navigation-bar-bottom.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/navigation-bar/navigation-bar-bottom/mds-navigation-bar-bottom.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/navigation-bar/navigation-bar-item/MdsNavigationBarItem.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", (function() {
                return NavigationBarItemTemplate;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function renderOverflowButton() {
                var _buttonClasses, _iconClasses;
                if (!this.accessibleText) {
                    this.throwConstraintError('The overflow menu button must have an accessible name. Pass a value to the "accessibleText" property.');
                }
                var buttonClasses = (_buttonClasses = {
                    "navigation-bar-item__button": true
                }, _defineProperty(_buttonClasses, "navigation-bar-item__button--".concat(this._barLevel), true), 
                _defineProperty(_buttonClasses, "navigation-bar-item__button--".concat(this._variant), !!this._variant), 
                _defineProperty(_buttonClasses, "navigation-bar-item__button--active", this.active), 
                _defineProperty(_buttonClasses, "navigation-bar-item__button--secondary-background", this._backgroundColor === "secondary"), 
                _defineProperty(_buttonClasses, "navigation-bar-item__button--open-menu", this._isMenuOpen), 
                _buttonClasses);
                var iconClasses = (_iconClasses = {
                    "navigation-bar-item__button-icon": true
                }, _defineProperty(_iconClasses, "navigation-bar-item__button-icon--".concat(this._barLevel), true), 
                _defineProperty(_iconClasses, "navigation-bar-item__button-icon--".concat(this._variant), !!this._variant), 
                _iconClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("button", null, null, "class", buttonClasses, "onclick", this._onclick, "onblur", this._handleBlur, "onfocus", this._onfocus, "onkeydown", this._onkeydown, "onmousedown", this._handleMousedown, "onkeyup", this._onkeyup, "aria-label", this.accessibleText);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", iconClasses, "innerHTML-prop", MDS.svgs["ico_ellipsis"], "aria-hidden", "true", "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("button");
            }
            function renderLink() {
                var _anchorClasses;
                if (!this.label && !this.assignedSlot.name) {
                    this.throwConstraintError("L1 items must have a label if they are in the default slot.");
                }
                if (this.badgeIcon && !this.badgeAccessibleText) {
                    this.throwConstraintError("If using a badgeIcon, badgeAccessibleText must be provided.");
                }
                var anchorClasses = (_anchorClasses = {
                    "navigation-bar-item__link": true
                }, _defineProperty(_anchorClasses, "navigation-bar-item__link--".concat(this._barLevel), true), 
                _defineProperty(_anchorClasses, "navigation-bar-item__link--".concat(this._variant), !!this._variant), 
                _defineProperty(_anchorClasses, "navigation-bar-item__link--active", this.active), 
                _defineProperty(_anchorClasses, "navigation-bar-item__link--secondary-background", this._backgroundColor === "secondary"), 
                _defineProperty(_anchorClasses, "navigation-bar-item__link--open-menu", this._isMenuOpen), 
                _defineProperty(_anchorClasses, "navigation-bar-item__link--no-menu", !this._menu), 
                _anchorClasses);
                var ariaCurrentValue = this._barLevel === "top" ? true : "page";
                var ariaDescribedByIds = "";
                if (this.accessibleText) {
                    ariaDescribedByIds += "link-accessible-text ";
                }
                if (this.badgeAccessibleText || this.badgeLabel) {
                    ariaDescribedByIds += "badge-text ";
                }
                if (this._experienceName) {
                    ariaDescribedByIds += "experience-name";
                }
                var trailingIconClasses = {
                    "navigation-bar-item__link-trailing-icon": true,
                    "navigation-bar-item__link-trailing-icon--secondary": this.parentElement.localName === "mds-navigation-bar-bottom" || this._variant === "secondary" || this._variant === "inApp"
                };
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("a");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", anchorClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("href", this.href);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onclick", this._handleLinkClick);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onblur", this._handleBlur);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onfocus", this._onfocus);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onkeydown", this._onkeydown);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onkeyup", this._onkeyup);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])(!!ariaDescribedByIds));
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    "aria-current": ariaCurrentValue
                }, this.active));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("tabindex", "0");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("a");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "navigation-bar-item__link-content");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "navigation-bar-item__link-text", "innerHTML-prop", this.label, "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                _renderArbitrary((this.badgeLabel || this.badgeIcon) && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-badge", null, null, "class", "navigation-bar-item__link-badge", "label-value", this.badgeLabel, "icon", this.badgeIcon, "is-animated", "true", "aria-hidden", "true"));
                _renderArbitrary(this.trailingIcon && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", trailingIconClasses, "innerHTML-prop", MDS.svgs[this.trailingIcon], "aria-hidden", "true", "__skip", "true"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                _renderArbitrary(!!this.accessibleText && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "id", "link-accessible-text", "class", "accessible-text", "aria-hidden", "true"), 
                _renderArbitrary(this.accessibleText), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                _renderArbitrary(this._experienceName && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "id", "experience-name", "class", "accessible-text", "aria-hidden", "true"), 
                _renderArbitrary(this._experienceName), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                _renderArbitrary((this.badgeAccessibleText || this.badgeLabel) && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "id", "badge-text", "class", "accessible-text"), 
                _renderArbitrary(this.badgeAccessibleText || this.badgeLabel), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("a");
            }
            function NavigationBarItemTemplate() {
                var _navBarItemClasses;
                var navBarItemClasses = (_navBarItemClasses = {
                    "navigation-bar-item": true
                }, _defineProperty(_navBarItemClasses, "navigation-bar-item__overflow--".concat(this._variant), this._isOverflowMenu), 
                _defineProperty(_navBarItemClasses, "navigation-bar-item--bottom", this.parentElement.localName === "mds-navigation-bar-bottom"), 
                _navBarItemClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", navBarItemClasses, "role", "listitem");
                _renderArbitrary(this._isOverflowMenu ? renderOverflowButton.call(this) : renderLink.call(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
        },
        "./src/navigation-bar/navigation-bar-item/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_navigation_bar_item_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/navigation-bar/navigation-bar-item/mds-navigation-bar-item.scss");
            var _mds_navigation_bar_item_scss__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_navigation_bar_item_scss__WEBPACK_IMPORTED_MODULE_1__);
            var _utils_slot_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/slot-utils.js");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_allowLists__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/allowLists.js");
            var _MdsNavigationBarItem__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/navigation-bar/navigation-bar-item/MdsNavigationBarItem.jsx");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            var boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].boolean, string = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].string, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].enumerables, number = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].number;
            var entity = {
                label: string.withHTML(_utils_allowLists__WEBPACK_IMPORTED_MODULE_4__["base"]),
                href: string.defaultsTo("javascript:void(0)"),
                active: boolean.defaultsTo(false).withChangedCallback(),
                accessibleText: string,
                bottomSlotKey: string,
                badgeLabel: string.or(number),
                badgeIcon: enumerables(string, "ico_star_filled"),
                trailingIcon: enumerables.apply(void 0, [ string ].concat(_toConsumableArray(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["ICON_TYPES"]))),
                badgeAccessibleText: string
            };
            var MdsNavigationBarItem = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsNavigationBarItem, _AgaveComponent);
                _createClass(MdsNavigationBarItem, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsNavigationBarItem";
                    }
                } ]);
                function MdsNavigationBarItem() {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsNavigationBarItem);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsNavigationBarItem).call(this));
                    _this.defineObservedProperty("_isMenuOpen", false);
                    _this.defineObservedProperty("_isOverflowMenu", false);
                    _this.defineObservedProperty("_barLevel");
                    _this.defineObservedProperty("_variant");
                    _this.defineObservedProperty("_experienceName");
                    _this.defineObservedProperty("_backgroundColor");
                    _this._dispatchChangeEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "change";
                    }.bind(this), _assertThisInitialized(_this));
                    _this._handleBlur = _this._handleBlur.bind(_assertThisInitialized(_this));
                    _this._handleChange = _this._handleChange.bind(_assertThisInitialized(_this));
                    _this._handleLinkClick = _this._handleLinkClick.bind(_assertThisInitialized(_this));
                    _this._handleMenuToggle = _this._handleMenuToggle.bind(_assertThisInitialized(_this));
                    _this._handleSlotChange = _this._handleSlotChange.bind(_assertThisInitialized(_this));
                    _this._onclick = _this._onclick.bind(_assertThisInitialized(_this));
                    _this._onfocus = _this._onfocus.bind(_assertThisInitialized(_this));
                    _this._onkeydown = _this._onkeydown.bind(_assertThisInitialized(_this));
                    _this._onkeyup = _this._onkeyup.bind(_assertThisInitialized(_this));
                    _this._handleMousedown = _this._handleMousedown.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsNavigationBarItem, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        var _this3 = this;
                        _get(_getPrototypeOf(MdsNavigationBarItem.prototype), "connectedCallback", this).call(this);
                        _utils_slot_utils__WEBPACK_IMPORTED_MODULE_2__["enforceSlottedComponentUsage"].call(this);
                        this._barLevel = this.parentElement.localName === "mds-navigation-bar" ? "top" : "bottom";
                        this._variant = this.parentElement.variant;
                        if (!this._hasConnected) {
                            this.shadowRoot.querySelector("slot") && this.shadowRoot.querySelector("slot").addEventListener("slotchange", this._handleSlotChange);
                            this.addEventListener("change", this._handleChange);
                            [ "open", "close" ].forEach(function(eventName) {
                                _newArrowCheck(this, _this3);
                                return this.addEventListener(eventName, this._handleMenuToggle);
                            }.bind(this));
                        }
                        this._hasConnected = true;
                    }
                }, {
                    key: "_dispatchActivateEvent",
                    value: function _dispatchActivateEvent() {
                        var _this4 = this;
                        var menu = this.firstElementChild;
                        var activeMenuItem = menu ? menu._activeItem : null;
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this4);
                            return "activate";
                        }.bind(this), this)({
                            target: this
                        }, {
                            menu: menu,
                            activeMenuItem: activeMenuItem
                        });
                    }
                }, {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        return {
                            interactiveElement: this.shadowRoot.querySelector("button, a")
                        };
                    }
                }, {
                    key: "_handleBlur",
                    value: function _handleBlur(event) {
                        if (!this.deepContains(event.relatedTarget)) {
                            this._menu && this._menu.close(false);
                            _get(_getPrototypeOf(MdsNavigationBarItem.prototype), "_onblur", this) && _get(_getPrototypeOf(MdsNavigationBarItem.prototype), "_onblur", this).call(this, event);
                        }
                    }
                }, {
                    key: "_handleMousedown",
                    value: function _handleMousedown(event) {
                        event.preventDefault();
                        this.focus();
                    }
                }, {
                    key: "_handleChange",
                    value: function _handleChange(event) {
                        if (event.target !== this && this.active) {
                            this._dispatchActivateEvent();
                        }
                    }
                }, {
                    key: "_handleLinkClick",
                    value: function _handleLinkClick(event) {
                        if (!this._menu) {
                            this.active = true;
                        }
                        _get(_getPrototypeOf(MdsNavigationBarItem.prototype), "_onclick", this) && _get(_getPrototypeOf(MdsNavigationBarItem.prototype), "_onclick", this).call(this, event);
                    }
                }, {
                    key: "_handleMenuToggle",
                    value: function _handleMenuToggle(event) {
                        this._isMenuOpen = event.type === "open";
                    }
                }, {
                    key: "_handleSlotChange",
                    value: function _handleSlotChange() {
                        var _this5 = this;
                        _utils_slot_utils__WEBPACK_IMPORTED_MODULE_2__["enforceSlotUsage"].call(this);
                        if (this.firstElementChild) {
                            this._menu = this.firstElementChild;
                            this._menu.trigger = this._getInteractiveElement().interactiveElement;
                            this._isOverflowMenu = this._menu.variant === "overflow";
                            if (!this._isOverflowMenu && this.assignedSlot) {
                                if (this.assignedSlot.name === "overflow") {
                                    this.remove();
                                    this.throwConstraintError('The item within the mds-navigation-bar\'s "overflow" slot must contain an mds-navigation-bar-menu of variant "overflow".');
                                } else if (this.parentElement.localName === "mds-navigation-bar-bottom") {
                                    this.remove();
                                    this.throwConstraintError("Items in the mds-navigation-bar-bottom's default slot cannot contain an mds-navigation-bar-menu.");
                                }
                            } else if (this._isOverflowMenu && this.assignedSlot.name !== "overflow") {
                                this.remove();
                                this.throwConstraintError('An item containing an mds-navigation-bar-menu of variant "overflow" must be slotted into the mds-navigation-bar\'s "overflow" slot.');
                            }
                        }
                        if (this.children.length > 1) {
                            _toConsumableArray(this.children).forEach(function(child, index) {
                                _newArrowCheck(this, _this5);
                                return index > 0 && child.remove();
                            }.bind(this));
                            this.throwConstraintError("Only one element can be slotted into the mds-navigation-bar-item. It must be an mds-navigation-bar menu.");
                        }
                    }
                }, {
                    key: "activeChangedCallback",
                    value: function activeChangedCallback() {
                        if (this._hasConnected) {
                            this._dispatchChangeEvent({
                                target: this
                            }, {
                                activeBottomSlot: this.active ? this.bottomSlotKey : null
                            });
                            this.active && this._dispatchActivateEvent();
                        }
                    }
                }, {
                    key: "render",
                    value: function render() {
                        _MdsNavigationBarItem__WEBPACK_IMPORTED_MODULE_5__["default"].call(this);
                    }
                } ]);
                return MdsNavigationBarItem;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_0___default.a), _class2.styles = _mds_navigation_bar_item_scss__WEBPACK_IMPORTED_MODULE_1___default.a, 
            _class2._parentLocalNames = [ "mds-navigation-bar", "mds-navigation-bar-bottom" ], 
            _class2._childLocalNames = [ "mds-navigation-bar-menu" ], _class2)) || _class);
            __webpack_exports__["default"] = MdsNavigationBarItem;
        },
        "./src/navigation-bar/navigation-bar-item/mds-navigation-bar-item.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/navigation-bar/navigation-bar-item/mds-navigation-bar-item.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/navigation-bar/navigation-bar-menu/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_navigation_bar_menu_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/navigation-bar/navigation-bar-menu/mds-navigation-bar-menu.scss");
            var _mds_navigation_bar_menu_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_navigation_bar_menu_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_edge_detection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/edge-detection.js");
            var _utils_slot_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/slot-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _dec, _class, _class2;
            var _slot$wrapper = function _slot$wrapper(_column$concat) {
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "name", _column$concat);
            };
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _slicedToArray(arr, i) {
                return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
            }
            function _nonIterableRest() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _iterableToArrayLimit(arr, i) {
                var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
                if (null != _i) {
                    var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
                    try {
                        if (_x = (_i = _i.call(arr)).next, 0 === i) {
                            if (Object(_i) !== _i) return;
                            _n = !1;
                        } else for (;!(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) ;
                    } catch (err) {
                        _d = !0, _e = err;
                    } finally {
                        try {
                            if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
                        } finally {
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
            }
            function _arrayWithHoles(arr) {
                if (Array.isArray(arr)) return arr;
            }
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var number = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].number, string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].enumerables;
            var entity = {
                activeIndex: number.defaultsTo(-1).withChangedCallback(),
                variant: enumerables(string, "single", "mega", "overflow").defaultsTo("single"),
                inactiveMessage: string
            };
            var MdsNavigationBarMenu = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsNavigationBarMenu, _AgaveComponent);
                _createClass(MdsNavigationBarMenu, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsNavigationBarMenu";
                    }
                } ]);
                function MdsNavigationBarMenu() {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsNavigationBarMenu);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsNavigationBarMenu).call(this));
                    _this.defineObservedProperty("_visible", false);
                    _this._dispatchChangeEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "change";
                    }.bind(this), _assertThisInitialized(_this));
                    _this._handleActivate = _this._handleActivate.bind(_assertThisInitialized(_this));
                    _this._handleInactiveItem = _this._handleInactiveItem.bind(_assertThisInitialized(_this));
                    _this._handleMenuBlur = _this._handleMenuBlur.bind(_assertThisInitialized(_this));
                    _this._handleMenuClick = _this._handleMenuClick.bind(_assertThisInitialized(_this));
                    _this._handleMenuKeydown = _this._handleMenuKeydown.bind(_assertThisInitialized(_this));
                    _this._handleDefaultSlotChange = _this._handleDefaultSlotChange.bind(_assertThisInitialized(_this));
                    _this._handleNamedSlotChange = _this._handleNamedSlotChange.bind(_assertThisInitialized(_this));
                    _this._handleTouchstart = _this._handleTouchstart.bind(_assertThisInitialized(_this));
                    _this.toggleVisible = _this.toggleVisible.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsNavigationBarMenu, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        var _this3 = this;
                        _get(_getPrototypeOf(MdsNavigationBarMenu.prototype), "connectedCallback", this).call(this);
                        this._hasConnected = true;
                        this._menu = this.shadowRoot.querySelector(".navigation-bar-menu");
                        var defaultSlot = this.shadowRoot.querySelector("slot:not([name])");
                        this._menu.addEventListener("slotchange", this["_handle".concat(defaultSlot ? "Default" : "Named", "SlotChange")]);
                        this.addEventListener("activate", this._handleActivate);
                        this.addEventListener("inactive", this._handleInactiveItem);
                        setTimeout(function() {
                            _newArrowCheck(this, _this3);
                            if (this.trigger) {
                                this.trigger.addEventListener("click", this.toggleVisible);
                                if (this.trigger.tagName === "BUTTON" || this.trigger.tagName === "A") {
                                    this._triggerButton = this.trigger;
                                } else {
                                    this._triggerButton = this.trigger.shadowRoot.querySelector("button") || this.trigger.shadowRoot.querySelector("a");
                                }
                                this._triggerButton.setAttribute("aria-expanded", this._visible);
                            } else {
                                this.throwConstraintError('No element ref was passed to the "trigger" property. Ensure that you pass the component a trigger ref.');
                            }
                        }.bind(this));
                    }
                }, {
                    key: "disconnectedCallback",
                    value: function disconnectedCallback() {
                        _get(_getPrototypeOf(MdsNavigationBarMenu.prototype), "disconnectedCallback", this) && _get(_getPrototypeOf(MdsNavigationBarMenu.prototype), "disconnectedCallback", this).call(this);
                        MDS.isIOS && document.removeEventListener("touchstart", this._handleTouchstart);
                    }
                }, {
                    key: "_handleActivate",
                    value: function _handleActivate(event) {
                        this.activeIndex = event.target._index;
                        this.close();
                        event.stopPropagation();
                    }
                }, {
                    key: "_handleInactiveItem",
                    value: function _handleInactiveItem(event) {
                        var _this4 = this;
                        this._hasInactiveItem = this.items.some(function(item) {
                            _newArrowCheck(this, _this4);
                            return item.inactive;
                        }.bind(this));
                        event.target._inactiveMessage = event.target.inactive ? this.inactiveMessage : "";
                        if (!this._hasInactiveItem && this.inactiveMessage) {
                            console.warn("Inactive message does not show if there is not at least 1 inactive item.");
                        }
                        event.stopPropagation();
                    }
                }, {
                    key: "_handleMenuBlur",
                    value: function _handleMenuBlur(event) {
                        if (!MDS.isIOS && !this.parentElement.contains(Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["originalEvent"])(event).relatedTarget)) {
                            this.close(false);
                        }
                    }
                }, {
                    key: "_handleMenuClick",
                    value: function _handleMenuClick(event) {
                        if (!event.target.inactive) {
                            event.preventDefault();
                            if (event.target.type === "collapsible") {
                                event.target.expanded = !event.target.expanded;
                            } else if (this.activeIndex === event.target._index) {
                                this.close();
                            } else {
                                this.activeIndex = event.target._index;
                            }
                        }
                    }
                }, {
                    key: "_handleMenuKeydown",
                    value: function _handleMenuKeydown(event) {
                        var keyCode = event.detail.keyCode;
                        if ([ 38, 40, 9 ].includes(keyCode)) {
                            var nodes = this._focusableNodes;
                            var targetIndex = nodes.indexOf(event.target);
                            if (keyCode === 38 || keyCode === 9 && event.detail.shiftKey) {
                                if (targetIndex !== 0) {
                                    event.detail.preventDefault();
                                    nodes[targetIndex - 1].focus();
                                }
                            } else if (keyCode === 40 || keyCode === 9) {
                                if (targetIndex !== nodes.length - 1) {
                                    event.detail.preventDefault();
                                    nodes[targetIndex + 1].focus();
                                }
                            }
                        } else if (Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["isEscAndShouldClose"])(event.detail)) {
                            this.close();
                        }
                    }
                }, {
                    key: "_handleDefaultSlotChange",
                    value: function _handleDefaultSlotChange() {
                        var _this5 = this;
                        _utils_slot_utils__WEBPACK_IMPORTED_MODULE_5__["enforceSlotUsage"].call(this);
                        this._activeItemExists = false;
                        var linkCount = 0;
                        this.items.forEach(function(item) {
                            _newArrowCheck(this, _this5);
                            item.addEventListener("blur", this._handleMenuBlur);
                            if (item.type === "link") {
                                item._index = linkCount;
                                linkCount++;
                                if (this.variant === "single" && linkCount > 10) {
                                    item.remove();
                                    this.throwConstraintError('The "single" menu variant can have a maximum of ten items.');
                                }
                                this._setActiveIndex(item);
                            } else if (item.type === "heading") {
                                item.remove();
                                this.throwConstraintError('The "heading" item type can only be used within the "mega" menu variant.');
                            } else if (this.variant === "single") {
                                item.remove();
                                this.throwConstraintError('The "single" variant only accepts items of type "link" in its slot.');
                            }
                        }.bind(this));
                    }
                }, {
                    key: "_handleNamedSlotChange",
                    value: function _handleNamedSlotChange(event) {
                        var _this6 = this;
                        if (this.children.length > 4) {
                            _toConsumableArray(this.children).slice(4).forEach(function(child) {
                                _newArrowCheck(this, _this6);
                                return child.remove();
                            }.bind(this));
                            this.throwConstraintError('The "mega" menu variant can have a maximum of four columns.');
                        }
                        this.linkItems.forEach(function(item, i) {
                            _newArrowCheck(this, _this6);
                            item._index = i;
                            item.addEventListener("blur", this._handleMenuBlur);
                        }.bind(this));
                        this._activeItemExists = false;
                        var slotContainer = event.target.assignedNodes()[0];
                        if (slotContainer) {
                            var columnLinkCount = 0;
                            var currentHeadingLabel;
                            var currentListItemContainer;
                            slotContainer.querySelectorAll("mds-navigation-bar-menu-item").forEach(function(item) {
                                _newArrowCheck(this, _this6);
                                if (item.type === "heading") {
                                    currentHeadingLabel = item.label;
                                    currentListItemContainer = document.createElement("div");
                                    currentListItemContainer.setAttribute("role", "list");
                                    currentListItemContainer.setAttribute("aria-label", item.label);
                                    item.parentElement.insertBefore(currentListItemContainer, item.nextElementSibling);
                                } else if (item.type === "link") {
                                    columnLinkCount++;
                                    if (columnLinkCount > 8) {
                                        item.remove();
                                        this.throwConstraintError("A mega menu column can have a maximum of eight items.");
                                    }
                                    item._headingLabel = currentHeadingLabel;
                                    currentListItemContainer && currentListItemContainer.appendChild(item);
                                    this._setActiveIndex(item);
                                } else if (item.type === "collapsible") {
                                    item.remove();
                                    this.throwConstraintError('The "mega" variant only accepts items of type "link" and "heading".');
                                }
                            }.bind(this));
                        }
                    }
                }, {
                    key: "_setActiveIndex",
                    value: function _setActiveIndex(item) {
                        if (item.active) {
                            if (this._activeItemExists) {
                                item.active = false;
                                this.throwConstraintError("Only one link item can be initialized in an active state.");
                            } else {
                                this.activeIndex = item._index;
                                this._activeItemExists = true;
                            }
                        }
                    }
                }, {
                    key: "_handleTouchstart",
                    value: function _handleTouchstart(event) {
                        if (!this.parentElement.deepContains(event.target)) {
                            this.close();
                        }
                    }
                }, {
                    key: "open",
                    value: function open() {
                        var _this7 = this;
                        var topLevelItems = this.variant === "overflow" ? _toConsumableArray(this.children) : this.linkItems;
                        topLevelItems.forEach(function(child) {
                            _newArrowCheck(this, _this7);
                            child._visible = true;
                        }.bind(this));
                        var innerWidthBeforeOpening = window.innerWidth;
                        this._visible = true;
                        this._triggerButton.setAttribute("aria-expanded", true);
                        this._setAlignmentStyles({
                            visible: true,
                            innerWidth: innerWidthBeforeOpening
                        });
                        this.dispatchEvent(new CustomEvent("open", {
                            bubbles: true,
                            composed: true
                        }));
                        MDS.isIOS && document.addEventListener("touchstart", this._handleTouchstart);
                        var _this$_focusableNodes = _slicedToArray(this._focusableNodes, 1), firstFocusable = _this$_focusableNodes[0];
                        firstFocusable && setTimeout(function() {
                            _newArrowCheck(this, _this7);
                            return firstFocusable.focus();
                        }.bind(this));
                    }
                }, {
                    key: "close",
                    value: function close() {
                        var _this8 = this;
                        var refocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                        this._visible = false;
                        refocus && this.trigger.focus();
                        this.dispatchEvent(new CustomEvent("close", {
                            bubbles: true,
                            composed: true
                        }));
                        this._setAlignmentStyles({
                            visible: false
                        });
                        this._triggerButton.setAttribute("aria-expanded", false);
                        this._activeItem && this._resetCollapsibleItems();
                        var topLevelItems = this.variant === "overflow" ? _toConsumableArray(this.children) : this.linkItems;
                        topLevelItems.forEach(function(child) {
                            _newArrowCheck(this, _this8);
                            child._visible = false;
                        }.bind(this));
                        MDS.isIOS && document.removeEventListener("touchstart", this._handleTouchstart);
                    }
                }, {
                    key: "toggleVisible",
                    value: function toggleVisible() {
                        var refocusOnClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                        this._visible ? this.close(refocusOnClose) : this.open();
                    }
                }, {
                    key: "_resetCollapsibleItems",
                    value: function _resetCollapsibleItems() {
                        var _this9 = this;
                        var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.children;
                        var activeItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._activeItem;
                        _toConsumableArray(children).forEach(function(child) {
                            _newArrowCheck(this, _this9);
                            if (child.type === "collapsible" && child !== activeItem.parentElement) {
                                this._resetCollapsibleItems(child.children, activeItem);
                                if (!child.contains(activeItem.parentElement)) {
                                    child.expanded = false;
                                }
                            }
                        }.bind(this));
                    }
                }, {
                    key: "_setAlignmentStyles",
                    value: function _setAlignmentStyles(_ref) {
                        var visible = _ref.visible, innerWidth = _ref.innerWidth;
                        if (visible) {
                            var edges = Object(_utils_edge_detection__WEBPACK_IMPORTED_MODULE_4__["getEdges"])();
                            var _this$_menu$getBoundi = this._menu.getBoundingClientRect(), overlayWidth = _this$_menu$getBoundi.width, overlayRightEdge = _this$_menu$getBoundi.right;
                            var triggerPosition = this.trigger.getBoundingClientRect();
                            var crossesRightEdge = edges.right < overlayRightEdge;
                            if (crossesRightEdge) {
                                var wouldCrossLeftEdge = overlayWidth > triggerPosition.right - edges.left;
                                if (wouldCrossLeftEdge) {
                                    _extends(this.style, {
                                        left: "".concat(innerWidth - overlayRightEdge, "px"),
                                        right: ""
                                    });
                                } else {
                                    _extends(this.style, {
                                        left: "initial",
                                        right: 0
                                    });
                                }
                            } else {
                                _extends(this.style, {
                                    left: 0,
                                    right: ""
                                });
                            }
                        } else if (!visible) {
                            _extends(this.style, {
                                left: "",
                                right: ""
                            });
                        }
                        this.style.pointerEvents = visible ? "auto" : "";
                    }
                }, {
                    key: "_setStyle",
                    value: function _setStyle(_ref2) {
                        var left = _ref2.left, right = _ref2.right;
                        this.style.left = left;
                        this.style.right = right;
                    }
                }, {
                    key: "activeIndexChangedCallback",
                    value: function activeIndexChangedCallback(activeIndex) {
                        if (this._activeItem) {
                            this._activeItem.active = false;
                        }
                        var items = this.linkItems;
                        if (items[activeIndex]) {
                            this._activeItem = items[activeIndex];
                            this._activeItem.active = true;
                        } else {
                            this._activeItem = null;
                        }
                        var activeBottomSlot = this._activeItem ? this._activeItem.bottomSlotKey : null;
                        this._hasConnected && this._dispatchChangeEvent({
                            target: this
                        }, {
                            activeBottomSlot: activeBottomSlot
                        });
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var _classes, _this10 = this;
                        var classes = (_classes = {
                            "navigation-bar-menu": true
                        }, _defineProperty(_classes, "navigation-bar-menu--".concat(this.variant), true), 
                        _defineProperty(_classes, "navigation-bar-menu--visible", this._visible), _classes);
                        var columnClasses = {
                            "navigation-bar-menu__column-container": true,
                            "navigation-bar-menu__column-container--inactive": this._hasInactiveItem && this.inactiveMessage
                        };
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes, "onkeydown", this._handleMenuKeydown, "onclick", this._handleMenuClick);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "navigation-bar-menu__menu-items");
                        _renderArbitrary(this.variant === "mega" ? (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", columnClasses), 
                        _renderArbitrary(_toConsumableArray(Array(4)).map(function(_, i) {
                            _newArrowCheck(this, _this10);
                            return _jsxWrapper(_slot$wrapper, [ "column-".concat(i) ]);
                        }.bind(this))), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")) : Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        _renderArbitrary(this._hasInactiveItem && this.inactiveMessage && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("p", null, null, "class", "navigation-bar-menu__inactive-message"), 
                        _renderArbitrary(this.inactiveMessage), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("p")));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "items",
                    get: function get() {
                        return _toConsumableArray(this.querySelectorAll("mds-navigation-bar-menu-item"));
                    }
                }, {
                    key: "linkItems",
                    get: function get() {
                        return _toConsumableArray(this.querySelectorAll('mds-navigation-bar-menu-item[type="link"]'));
                    }
                }, {
                    key: "collapsibleItems",
                    get: function get() {
                        return _toConsumableArray(this.querySelectorAll('mds-navigation-bar-menu-item[type="collapsible"]'));
                    }
                }, {
                    key: "_focusableNodes",
                    get: function get() {
                        var _this11 = this;
                        return _toConsumableArray(this.querySelectorAll('mds-navigation-bar-menu-item:not([type="heading"])')).filter(function(el) {
                            _newArrowCheck(this, _this11);
                            return el._visible;
                        }.bind(this));
                    }
                } ]);
                return MdsNavigationBarMenu;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_navigation_bar_menu_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2._childLocalNames = [ "mds-navigation-bar-menu-item" ], _class2)) || _class);
            __webpack_exports__["default"] = MdsNavigationBarMenu;
        },
        "./src/navigation-bar/navigation-bar-menu/mds-navigation-bar-menu.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/navigation-bar/navigation-bar-menu/mds-navigation-bar-menu.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/navigation-bar/navigation-bar-menu/navigation-bar-menu-item/MdsNavigationBarMenuItem.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "renderCollapsibleItem", (function() {
                return renderCollapsibleItem;
            }));
            __webpack_require__.d(__webpack_exports__, "renderHeadingItem", (function() {
                return renderHeadingItem;
            }));
            __webpack_require__.d(__webpack_exports__, "renderLinkItem", (function() {
                return renderLinkItem;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _content$wrapper = function _content$wrapper(_this$label) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "navigation-bar-menu-item__text", "innerHTML-prop", _this$label, "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            }, _content$wrapper2 = function _content$wrapper2(_this$_headingLabel) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text", "id", "heading-label", "aria-hidden", "true");
                _renderArbitrary(_this$_headingLabel);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            }, _content$wrapper3 = function _content$wrapper3(_this$_inactiveMessag) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text", "id", "inactive-message", "aria-hidden", "true");
                _renderArbitrary(_this$_inactiveMessag);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            };
            function renderCollapsibleItem() {
                var buttonClasses = {
                    "navigation-bar-menu-item": true,
                    "navigation-bar-menu-item--collapsible": true,
                    "navigation-bar-menu-item--nested": this._nested,
                    "navigation-bar-menu-item--hidden": this._nested && !this._visible,
                    "navigation-bar-menu-item--interactive": true
                };
                var iconClasses = {
                    "navigation-bar-menu-item__icon": true,
                    "navigation-bar-menu-item__icon--collapsible": true,
                    "navigation-bar-menu-item__icon--expanded": this.expanded
                };
                var slotClasses = {
                    "navigation-bar-menu-item__submenu": true,
                    "navigation-bar-menu-item__submenu--expanded": this.expanded
                };
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "aria-level", this._nested ? 4 : 3);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", buttonClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onclick", this._onclick);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onfocus", this._onfocus);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onblur", this._onblur);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onkeydown", this._onkeydown);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onkeyup", this._onkeyup);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("tabindex", "-1");
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    onmousedown: this._handleButtonMousedown
                }, MDS.isSafari || MDS.isFireFox));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", iconClasses, "innerHTML-prop", MDS.svgs["ico_caret_right"], "aria-hidden", "true", "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "navigation-bar-menu-item__text", "innerHTML-prop", this.label, "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", slotClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function renderHeadingItem() {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "navigation-bar-menu-item navigation-bar-menu-item--heading", "role", "heading", "aria-level", "2", "onclick", _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["stopPropagation"], "onmousedown", _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["preventDefault"]);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "navigation-bar-menu-item__text", "innerHTML-prop", this.label, "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function renderLinkItem() {
                var content = [ _jsxWrapper(_content$wrapper, [ this.label ]), this._headingLabel && _jsxWrapper(_content$wrapper2, [ this._headingLabel ]), this._inactiveMessage && _jsxWrapper(_content$wrapper3, [ this._inactiveMessage ]) ];
                var classes = {
                    "navigation-bar-menu-item": true,
                    "navigation-bar-menu-item--nested": this._nested && !this.parentElement._nested,
                    "navigation-bar-menu-item--nested-twice": this._nested && this.parentElement._nested,
                    "navigation-bar-menu-item--hidden": this._nested && !this._visible,
                    "navigation-bar-menu-item--active": this.active,
                    "navigation-bar-menu-item--inactive": this.inactive,
                    "navigation-bar-menu-item--interactive": true
                };
                var commonAttributes = {
                    class: classes,
                    onfocus: this._onfocus,
                    onblur: this._onblur,
                    onkeydown: this._onkeydown,
                    onkeyup: this._onkeyup,
                    tabindex: "-1"
                };
                var ariaDescribedByIds = "";
                if (this._headingLabel) {
                    ariaDescribedByIds += "heading-label ";
                }
                if (this._inactiveMessage) {
                    ariaDescribedByIds += "inactive-message";
                }
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div");
                _renderArbitrary(this.inactive ? (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("span"), 
                _spreadAttribute(commonAttributes), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-disabled", "true"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("role", "link"), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onclick", _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["stopPropagation"]), 
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    "aria-describedby": ariaDescribedByIds
                }, !!ariaDescribedByIds)), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("span"), 
                _renderArbitrary(content), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")) : (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("a"), 
                _spreadAttribute(commonAttributes), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("href", this.href), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onclick", this._onclick), 
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    "aria-current": true
                }, this.active)), _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    "aria-describedby": "heading-label"
                }, !!this._headingLabel)), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("a"), 
                _renderArbitrary(content), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("a")));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
        },
        "./src/navigation-bar/navigation-bar-menu/navigation-bar-menu-item/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_navigation_bar_menu_item_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/navigation-bar/navigation-bar-menu/navigation-bar-menu-item/mds-navigation-bar-menu-item.scss");
            var _mds_navigation_bar_menu_item_scss__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_navigation_bar_menu_item_scss__WEBPACK_IMPORTED_MODULE_1__);
            var _MdsNavigationBarMenuItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/navigation-bar/navigation-bar-menu/navigation-bar-menu-item/MdsNavigationBarMenuItem.jsx");
            var _utils_slot_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/slot-utils.js");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_allowLists__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/allowLists.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var string = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].stringRequired, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].boolean, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].enumerables;
            var entity = {
                label: stringRequired.withHTML(_utils_allowLists__WEBPACK_IMPORTED_MODULE_5__["base"]),
                href: stringRequired.defaultsTo("javascript:void(0)"),
                active: boolean.defaultsTo(false).withChangedCallback(),
                inactive: boolean.defaultsTo(false).withChangedCallback(),
                expanded: boolean.defaultsTo(false).withChangedCallback(),
                type: enumerables(stringRequired, "link", "collapsible", "heading").defaultsTo("link"),
                bottomSlotKey: string
            };
            var MdsNavigationBarMenuItem = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsNavigationBarMenuItem, _AgaveComponent);
                _createClass(MdsNavigationBarMenuItem, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsNavigationBarMenuItem";
                    }
                } ]);
                function MdsNavigationBarMenuItem() {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsNavigationBarMenuItem);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsNavigationBarMenuItem).call(this));
                    _this.defineObservedProperty("_nested", false);
                    _this.defineObservedProperty("_visible", false);
                    _this.defineObservedProperty("_headingLabel");
                    _this._dispatchActivateEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "activate";
                    }.bind(this), _assertThisInitialized(_this));
                    _this._dispatchInactiveEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "inactive";
                    }.bind(this), _assertThisInitialized(_this));
                    _this._onclick = _this._onclick.bind(_assertThisInitialized(_this));
                    _this._onfocus = _this._onfocus.bind(_assertThisInitialized(_this));
                    _this._onblur = _this._onblur.bind(_assertThisInitialized(_this));
                    _this._onkeydown = _this._onkeydown.bind(_assertThisInitialized(_this));
                    _this._onkeyup = _this._onkeyup.bind(_assertThisInitialized(_this));
                    _this._handleButtonMousedown = _this._handleButtonMousedown.bind(_assertThisInitialized(_this));
                    _this._handleSlotChange = _this._handleSlotChange.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsNavigationBarMenuItem, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        var _this3 = this;
                        _get(_getPrototypeOf(MdsNavigationBarMenuItem.prototype), "connectedCallback", this).call(this);
                        this._hasConnected = true;
                        _utils_slot_utils__WEBPACK_IMPORTED_MODULE_3__["enforceSlottedComponentUsage"].call(this);
                        this._interactiveNode = this._getInteractiveElement().interactiveElement;
                        if (this.type === "collapsible") {
                            this._menu = this.shadowRoot.querySelector(".navigation-bar-menu-item__submenu");
                            this.shadowRoot.querySelector("slot").addEventListener("slotchange", this._handleSlotChange);
                        }
                        setTimeout(function() {
                            _newArrowCheck(this, _this3);
                            return this.expanded && this.expandedChangedCallback();
                        }.bind(this));
                    }
                }, {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        return {
                            interactiveElement: this.shadowRoot.querySelector(".navigation-bar-menu-item--interactive")
                        };
                    }
                }, {
                    key: "_handleSlotChange",
                    value: function _handleSlotChange() {
                        var _this4 = this;
                        _toConsumableArray(this.children).forEach(function(child) {
                            _newArrowCheck(this, _this4);
                            if (this._nested && child.type === "collapsible") {
                                child.remove();
                                this.throwConstraintError("Collapsible items can only be nested one level.");
                            }
                            child._nested = true;
                        }.bind(this));
                    }
                }, {
                    key: "_handleButtonMousedown",
                    value: function _handleButtonMousedown(event) {
                        event.preventDefault();
                        this.focus();
                    }
                }, {
                    key: "activeChangedCallback",
                    value: function activeChangedCallback(active) {
                        if (active && this._hasConnected) {
                            this._dispatchActivateEvent({
                                target: this
                            });
                        }
                    }
                }, {
                    key: "inactiveChangedCallback",
                    value: function inactiveChangedCallback() {
                        this._dispatchInactiveEvent({
                            target: this
                        });
                    }
                }, {
                    key: "expandedChangedCallback",
                    value: function expandedChangedCallback() {
                        var _this5 = this;
                        var expanded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.expanded;
                        if (this._hasConnected) {
                            var menuHeight = _toConsumableArray(this.children).reduce(function(acc, child) {
                                var _this6 = this;
                                _newArrowCheck(this, _this5);
                                if (expanded) {
                                    acc += child.offsetHeight;
                                    child._visible = true;
                                } else {
                                    setTimeout(function() {
                                        _newArrowCheck(this, _this6);
                                        child._visible = false;
                                    }.bind(this), 200);
                                }
                                return acc;
                            }.bind(this), 0);
                            if (this._nested) {
                                this.parentElement.expanded = true;
                                this._setParentMenuHeight(menuHeight + this._interactiveNode.offsetHeight);
                            }
                            this._menu.style.height = "".concat(menuHeight, "px");
                        }
                    }
                }, {
                    key: "_setParentMenuHeight",
                    value: function _setParentMenuHeight(thisHeight) {
                        var _this7 = this;
                        var menuHeight = _toConsumableArray(this.parentElement.children).reduce(function(acc, child) {
                            _newArrowCheck(this, _this7);
                            if (child !== this) {
                                acc += child.expanded ? child.offsetHeight : child._interactiveNode.offsetHeight;
                            }
                            return acc;
                        }.bind(this), 0);
                        this.parentElement._menu.style.height = "".concat(menuHeight + thisHeight, "px");
                    }
                }, {
                    key: "_visibleChangedCallback",
                    value: function _visibleChangedCallback(visible) {
                        var _this8 = this;
                        _toConsumableArray(this.children).forEach(function(child) {
                            _newArrowCheck(this, _this8);
                            child._visible = !visible ? false : !!this.expanded;
                        }.bind(this));
                    }
                }, {
                    key: "render",
                    value: function render() {
                        if (this.type === "link") {
                            _MdsNavigationBarMenuItem__WEBPACK_IMPORTED_MODULE_2__["renderLinkItem"].call(this);
                        } else if (this.type === "collapsible") {
                            _MdsNavigationBarMenuItem__WEBPACK_IMPORTED_MODULE_2__["renderCollapsibleItem"].call(this);
                        } else {
                            _MdsNavigationBarMenuItem__WEBPACK_IMPORTED_MODULE_2__["renderHeadingItem"].call(this);
                        }
                    }
                } ]);
                return MdsNavigationBarMenuItem;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_0___default.a), _class2.styles = _mds_navigation_bar_menu_item_scss__WEBPACK_IMPORTED_MODULE_1___default.a, 
            _class2._parentLocalNames = [ "mds-navigation-bar-menu", "mds-navigation-bar-menu-item" ], 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsNavigationBarMenuItem;
        },
        "./src/navigation-bar/navigation-bar-menu/navigation-bar-menu-item/mds-navigation-bar-menu-item.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/navigation-bar/navigation-bar-menu/navigation-bar-menu-item/mds-navigation-bar-menu-item.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/progress-bar-radial/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_progress_bar_radial_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/progress-bar-radial/mds-progress-bar-radial.scss");
            var _mds_progress_bar_radial_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_progress_bar_radial_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/data-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _dec, _class, _class2;
            var _circle$wrapper = function _circle$wrapper(_center, _center2, _innerCircleRadius, _circumference, _strokeDashoffset$tra, _dataStrokeDashoffs) {
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("circle", null, null, "class", "progress-bar-radial__indicator-border", "cx", _center, "cy", _center2, "r", _innerCircleRadius, "stroke-dasharray", _circumference, "style", _strokeDashoffset$tra, "data-stroke-dashoffset", _dataStrokeDashoffs);
            }, _circle$wrapper2 = function _circle$wrapper2(_class3, _center3, _center4, _innerCircleRadius2, _circumference2, _strokeDashoffset$tra2, _offset) {
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("circle", null, null, "class", _class3, "cx", _center3, "cy", _center4, "r", _innerCircleRadius2, "stroke-dasharray", _circumference2, "style", _strokeDashoffset$tra2, "data-stroke-dashoffset", _offset);
            };
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string, number = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].number, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].enumerables, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].stringRequired;
            var entity = {
                accessibleText: stringRequired,
                progressPercentage: number.withMinSize(0).withMaxSize(100),
                size: enumerables(string, "regular", "small").defaultsTo("regular").withChangedCallback(),
                key: string,
                text: string,
                percentSign: string
            };
            var MdsProgressBarRadial = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsProgressBarRadial, _AgaveComponent);
                function MdsProgressBarRadial() {
                    _classCallCheck(this, MdsProgressBarRadial);
                    return _possibleConstructorReturn(this, _getPrototypeOf(MdsProgressBarRadial).apply(this, arguments));
                }
                _createClass(MdsProgressBarRadial, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsProgressBarRadial.prototype), "connectedCallback", this).call(this);
                        this.text && this.textChangedCallback(this.text);
                    }
                }, {
                    key: "renderedCallback",
                    value: function renderedCallback() {
                        if (typeof this.progressPercentage === "number") {
                            var radialBarTextValElemWidth = this.shadowRoot.querySelector(".progress-bar-radial__text-value").offsetWidth;
                            var radialBarPercentElem = this.shadowRoot.querySelector(".progress-bar-radial__percent-sign");
                            radialBarPercentElem.style.left = "calc(50% + ".concat(Math.ceil(radialBarTextValElemWidth / 1.6), "px)");
                            var radialBarIndicatorElem = this.shadowRoot.querySelector(".progress-bar-radial__indicator");
                            radialBarIndicatorElem.style.strokeDashoffset = radialBarIndicatorElem.dataset.strokeDashoffset;
                            radialBarIndicatorElem.style.transform = "rotate(".concat(MdsProgressBarRadial._GRAPH_ROTATION_ANGLE + 1, "deg)");
                            var radialBarIndicatorBorderElem = this.shadowRoot.querySelector(".progress-bar-radial__indicator-border");
                            radialBarIndicatorBorderElem.style.strokeDashoffset = radialBarIndicatorBorderElem.dataset.strokeDashoffset;
                            radialBarIndicatorBorderElem.style.transform = "rotate(".concat(MdsProgressBarRadial._GRAPH_ROTATION_ANGLE, "deg)");
                        }
                    }
                }, {
                    key: "sizeChangedCallback",
                    value: function sizeChangedCallback() {
                        var _MdsProgressBarRadial = MdsProgressBarRadial["_".concat(this.size)], diameter = _MdsProgressBarRadial.diameter, indicatorBorderWidth = _MdsProgressBarRadial.indicatorBorderWidth;
                        var innerCircleRadius = diameter / 2 - MdsProgressBarRadial._trackWidth / 2;
                        var innerCircleDiameter = innerCircleRadius * 2;
                        var circumference = Math.floor(2 * Math.PI * innerCircleRadius);
                        this._sizedBasedValues = {
                            diameter: diameter,
                            indicatorBorderWidth: indicatorBorderWidth,
                            center: diameter / 2,
                            innerCircleDiameter: innerCircleDiameter,
                            innerCircleRadius: innerCircleRadius,
                            circumference: circumference
                        };
                    }
                }, {
                    key: "textChangedCallback",
                    value: function textChangedCallback(newValue) {
                        if (this.key !== newValue) {
                            this.key = newValue;
                        }
                    }
                }, {
                    key: "render",
                    value: function render() {
                        !this._sizedBasedValues && this.sizeChangedCallback();
                        var _this$_sizedBasedValu = this._sizedBasedValues, diameter = _this$_sizedBasedValu.diameter, center = _this$_sizedBasedValu.center, innerCircleRadius = _this$_sizedBasedValu.innerCircleRadius, circumference = _this$_sizedBasedValu.circumference, indicatorBorderWidth = _this$_sizedBasedValu.indicatorBorderWidth;
                        var offset = this.progressPercentage > 1 ? Math.floor((100 - this.progressPercentage) / 100 * circumference) : circumference - this.progressPercentage;
                        var strokeLineCapClass = this.progressPercentage === 99 ? "with-straight-border" : "with-round-border";
                        var completeAccessibleText = "".concat(this.accessibleText ? "".concat(this.accessibleText, " ") : "").concat(this.progressPercentage >= 0 ? "".concat(this.progressPercentage).concat(this.percentSign) : "").concat(this.key ? " ".concat(this.key) : "");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "progress-bar-radial__container progress-bar-radial__container--".concat(this.size), "aria-label", completeAccessibleText, "aria-live", "polite", "aria-atomic", "true", "role", "img");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("svg", null, null, "class", "progress-bar-radial progress-bar-radial--".concat(this.size), "width", diameter, "height", diameter, "xmlns", "http://www.w3.org/2000/svg", "preserveAspectRatio", "none", "aria-hidden", "true");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("circle", null, null, "class", "progress-bar-radial__track", "cx", center, "cy", center, "r", innerCircleRadius);
                        _renderArbitrary(this.progressPercentage !== undefined && [ _jsxWrapper(_circle$wrapper, [ center, center, innerCircleRadius, circumference, {
                            strokeDashoffset: circumference,
                            transform: "rotate(0deg)"
                        }, this.progressPercentage > 0 ? offset - indicatorBorderWidth * 2 : offset ]), _jsxWrapper(_circle$wrapper2, [ "progress-bar-radial__indicator progress-bar-radial__indicator--".concat(strokeLineCapClass), center, center, innerCircleRadius, circumference, {
                            strokeDashoffset: circumference,
                            transform: "rotate(0deg)"
                        }, offset ]) ]);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("svg");
                        _renderArbitrary(this.progressPercentage !== undefined && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "progress-bar-radial__text-value ".concat(this.key ? "progress-bar-radial__text-value--with-key" : "", " progress-bar-radial__text-value--").concat(this.size), "aria-hidden", "true"), 
                        _renderArbitrary(this.progressPercentage), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                        _renderArbitrary(this.progressPercentage !== undefined && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "progress-bar-radial__percent-sign ".concat(this.key ? "progress-bar-radial__percent-sign--with-key" : "", " progress-bar-radial__percent-sign--").concat(this.size), "aria-hidden", "true"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(" "), _renderArbitrary(this.percentSign), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                        _renderArbitrary(this.progressPercentage === undefined && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "progress-bar-radial__icon-dash", "aria-hidden", "true"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(" — "), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        _renderArbitrary(typeof this.key === "string" && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "progress-bar-radial__text-key progress-bar-radial__text-key--".concat(this.size), "aria-hidden", "true"), 
                        _renderArbitrary(this.key), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ], [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsProgressBarRadial";
                    }
                } ]);
                return MdsProgressBarRadial;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_progress_bar_radial_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2._trackWidth = Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssToPx"])("8px"), 
            _class2._GRAPH_ROTATION_ANGLE = -90, _class2._small = {
                diameter: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssToPx"])("108px"),
                indicatorBorderWidth: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssToPx"])("1px")
            }, _class2._regular = {
                diameter: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssToPx"])("188px"),
                indicatorBorderWidth: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssToPx"])("2px")
            }, _class2)) || _class);
            __webpack_exports__["default"] = MdsProgressBarRadial;
        },
        "./src/progress-bar-radial/mds-progress-bar-radial.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/progress-bar-radial/mds-progress-bar-radial.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/progress-bar/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_progress_bar_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/progress-bar/mds-progress-bar.scss");
            var _mds_progress_bar_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_progress_bar_scss__WEBPACK_IMPORTED_MODULE_2__);
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string, numberRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].numberRequired;
            var entity = {
                accessibleText: string,
                progressPercentage: numberRequired.withMaxSize(100),
                roleName: string.defaultsTo("progress bar")
            };
            var MdsProgressBar = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsProgressBar, _AgaveComponent);
                function MdsProgressBar() {
                    _classCallCheck(this, MdsProgressBar);
                    return _possibleConstructorReturn(this, _getPrototypeOf(MdsProgressBar).apply(this, arguments));
                }
                _createClass(MdsProgressBar, [ {
                    key: "render",
                    value: function render() {
                        if (this.progressPercentage < 0) {
                            this.progressPercentage = 0;
                        }
                        var accessibleText = this.accessibleText, progressPercentage = this.progressPercentage, roleName = this.roleName;
                        var indicatorClasses = {
                            "progress-bar__indicator": true,
                            "progress-bar__indicator--empty": !progressPercentage
                        };
                        var indicatorOuterBorderClasses = {
                            "progress-bar__indicator-outer-border": progressPercentage !== 100,
                            "progress-bar__indicator-outer-border--empty": !progressPercentage
                        };
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "progress-bar");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "progress-bar__accessible-text");
                        _renderArbitrary("".concat(accessibleText, ", ").concat(roleName));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "progress-bar__track");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", indicatorOuterBorderClasses, "style", "width: calc((".concat("2px", " * 2) + ").concat(progressPercentage, "%)"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", indicatorClasses, "style", "width: ".concat(progressPercentage, "%"));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ], [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsProgressBar";
                    }
                } ]);
                return MdsProgressBar;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_progress_bar_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsProgressBar;
        },
        "./src/progress-bar/mds-progress-bar.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/progress-bar/mds-progress-bar.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/progress-spinner/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_progress_spinner_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/progress-spinner/mds-progress-spinner.scss");
            var _mds_progress_spinner_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_progress_spinner_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _abstract_modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/abstract-modal/index.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/data-utils.js");
            var _progress_spinner_inline__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/progress-spinner-inline/index.jsx");
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].boolean, string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string;
            var entity = _objectSpread({
                loadingLabel: string.defaultsTo("Loading"),
                triggerId: string,
                inverse: boolean.defaultsTo(false)
            }, _abstract_modal__WEBPACK_IMPORTED_MODULE_3__["entity"]);
            var MdsProgressSpinner = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AbstractModal) {
                _inherits(MdsProgressSpinner, _AbstractModal);
                _createClass(MdsProgressSpinner, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsProgressSpinner";
                    }
                } ]);
                function MdsProgressSpinner() {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsProgressSpinner);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsProgressSpinner).call(this, [ "panelContent" ], "progress-spinner"));
                    _this.addLoadingLabelAnnounced = function() {
                        var _this3 = this;
                        _newArrowCheck(this, _this2);
                        setTimeout(function() {
                            _newArrowCheck(this, _this3);
                            _this.loadingLabelAnnounced = _this.loadingLabel;
                            _this.removeLoadingLabelAnnounced();
                        }.bind(this), 400);
                    }.bind(this);
                    _this.removeLoadingLabelAnnounced = function() {
                        var _this4 = this;
                        _newArrowCheck(this, _this2);
                        setTimeout(function() {
                            _newArrowCheck(this, _this4);
                            _this.loadingLabelAnnounced = "";
                        }.bind(this), 1e3);
                    }.bind(this);
                    _this.close = _this.close.bind(_assertThisInitialized(_this));
                    _this._resizeListener = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["debounce"])(_this._resizeListener.bind(_assertThisInitialized(_this)), 100);
                    _this.loadingLabelAnnouncedOnce = false;
                    window.addEventListener("resize", _this._resizeListener);
                    _this.defineObservedProperty("_spinnerSize", "medium");
                    _this.defineObservedProperty("loadingLabelAnnounced", "");
                    _this._spinnerSize = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["getBreakpoint"])() === "lg" || Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["getBreakpoint"])() === "xl" ? "large" : "medium";
                    return _this;
                }
                _createClass(MdsProgressSpinner, [ {
                    key: "_resizeListener",
                    value: function _resizeListener() {
                        this._setSpinnerAlignment();
                        this._spinnerSize = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["getBreakpoint"])() === "lg" || Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["getBreakpoint"])() === "xl" ? "large" : "medium";
                    }
                }, {
                    key: "_setSpinnerAlignment",
                    value: function _setSpinnerAlignment() {
                        var labelHeight = this._renderTarget.shadowRoot.querySelector("#".concat(this.id, "-progress-spinner-label")).offsetHeight;
                        if (labelHeight > Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_5__["cleanCssValue"])("1.5rem") * 16) {
                            this._renderTarget.shadowRoot.querySelector("#".concat(this.id, "-progress-spinner-container"));
                        } else {
                            this._renderTarget.shadowRoot.querySelector("#".concat(this.id, "-progress-spinner-container")).style.alignItems = "center";
                        }
                    }
                }, {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsProgressSpinner.prototype), "connectedCallback", this) && _get(_getPrototypeOf(MdsProgressSpinner.prototype), "connectedCallback", this).call(this);
                        this._renderTarget.shadowRoot.querySelector("#".concat(this.id, "-progress-spinner-label")) && this._setSpinnerAlignment();
                    }
                }, {
                    key: "renderedCallback",
                    value: function renderedCallback() {
                        this._renderTarget.shadowRoot.querySelector("#".concat(this.id, "-progress-spinner-label")) && this._setSpinnerAlignment();
                        if (this.open && this.loadingLabelAnnouncedOnce === false) {
                            this.loadingLabelAnnouncedOnce = true;
                            this.addLoadingLabelAnnounced();
                        }
                    }
                }, {
                    key: "disconnectedCallback",
                    value: function disconnectedCallback() {
                        _get(_getPrototypeOf(MdsProgressSpinner.prototype), "disconnectedCallback", this) && _get(_getPrototypeOf(MdsProgressSpinner.prototype), "disconnectedCallback", this).call(this);
                        window.removeEventListener("resize", this._resizeListener);
                        this.close();
                    }
                }, {
                    key: "_focusOnRender",
                    value: function _focusOnRender() {
                        window.setTimeout(this.focus.bind(this), 100);
                    }
                }, {
                    key: "_focusOnTab",
                    value: function _focusOnTab() {
                        this.focus();
                    }
                }, {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        return {
                            interactiveElement: this.open && this._renderTarget.shadowRoot.querySelector("#".concat(this.id, "-progress-spinner-label"))
                        };
                    }
                }, {
                    key: "close",
                    value: function close() {
                        this.open = false;
                        this.loadingLabelAnnouncedOnce = false;
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var progressSpinnerContainerClasses = {
                            "progress-spinner__container": true,
                            "progress-spinner__container--inverse": this.inverse
                        };
                        var progressSpinnerLabelClasses = {
                            "progress-spinner__label": true,
                            "progress-spinner__label--inverse": this.inverse
                        };
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "progress-spinner");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "progress-spinner__backdrop");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "id", "".concat(this.id, "-progress-spinner-container"), "class", progressSpinnerContainerClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "progress-spinner__spinner", "aria-hidden", "true");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-progress-spinner-inline", null, null, "id", "".concat(this.id, "-progress-spinner"), "size", this._spinnerSize, "inverse", this.inverse);
                        _renderArbitrary(this.accessibleText && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "id", "".concat(this.id, "-progress-spinner-accessible-text"), "class", "accessible-text", "aria-live", "polite", "aria-atomic", "true"), 
                        _renderArbitrary(this.accessibleText), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("p", null, null, "id", "".concat(this.id, "-progress-spinner-label"), "class", progressSpinnerLabelClasses);
                        _renderArbitrary(this.loadingLabel);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("p");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "progress-spinner__accessible-text", "aria-live", "polite", "aria-atomic", "true");
                        _renderArbitrary(this.loadingLabelAnnounced);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return MdsProgressSpinner;
            }(_abstract_modal__WEBPACK_IMPORTED_MODULE_3__["default"]), _class2.styles = _mds_progress_spinner_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsProgressSpinner;
        },
        "./src/progress-spinner/mds-progress-spinner.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/progress-spinner/mds-progress-spinner.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/progress-steps/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_progress_steps_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/progress-steps/mds-progress-steps.scss");
            var _mds_progress_steps_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_progress_steps_scss__WEBPACK_IMPORTED_MODULE_2__);
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            var _div$wrapper = function _div$wrapper(_class3) {
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", _class3);
            };
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].stringRequired, numberRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].numberRequired, number = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].number;
            var entity = {
                accessibleText: stringRequired,
                activeStep: number.defaultsTo(1),
                numSteps: numberRequired.withMinSize(3).withMaxSize(6)
            };
            var MdsProgressSteps = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsProgressSteps, _AgaveComponent);
                function MdsProgressSteps() {
                    _classCallCheck(this, MdsProgressSteps);
                    return _possibleConstructorReturn(this, _getPrototypeOf(MdsProgressSteps).apply(this, arguments));
                }
                _createClass(MdsProgressSteps, [ {
                    key: "getModifierByStepNumber",
                    value: function getModifierByStepNumber(stepNumber) {
                        var modifier = "unvisited";
                        if (stepNumber < this.activeStep) {
                            modifier = "visited";
                        } else if (stepNumber === this.activeStep) {
                            modifier = "current";
                        }
                        return modifier;
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var _this = this;
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "progress-steps");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "progress-steps__accessible-text");
                        _renderArbitrary(this.accessibleText);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        _renderArbitrary(new Array(this.numSteps).fill().map(function(_, stepNumber) {
                            _newArrowCheck(this, _this);
                            return _jsxWrapper(_div$wrapper, [ "progress-steps__step progress-steps__step--".concat(this.getModifierByStepNumber(stepNumber + 1)) ]);
                        }.bind(this)));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ], [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsProgressSteps";
                    }
                } ]);
                return MdsProgressSteps;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_progress_steps_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsProgressSteps;
        },
        "./src/progress-steps/mds-progress-steps.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/progress-steps/mds-progress-steps.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/quick-action-bar/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_quick_action_bar_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/quick-action-bar/mds-quick-action-bar.scss");
            var _mds_quick_action_bar_scss__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_quick_action_bar_scss__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_quick_action_bar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/quick-action-bar/mds-quick-action-bar.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var arrayOf = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].arrayOf, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].enumerables, string = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].stringRequired, satisfies = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].satisfies, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].boolean, number = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].number;
            var quickActionButtonEntity = {
                id: string,
                text: string,
                adaText: string,
                moreButton: boolean.defaultsTo(false),
                moreButtonVariant: enumerables(string, "plus", "ellipsis").defaultsTo("plus")
            };
            var entity = {
                quickActionButtons: arrayOf(satisfies(quickActionButtonEntity)).withMaxLength(6).withMinLength(1),
                buttonSetAlignment: enumerables(string, "leading", "trailing", "center").defaultsTo("leading"),
                leadingPadding: stringRequired.defaultsTo("0px"),
                trailingPadding: stringRequired.defaultsTo("0px"),
                accessibleHeadingName: stringRequired,
                headingLevel: number.defaultsTo(2)
            };
            var MdsQuickActionBar = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsQuickActionBar, _AgaveComponent);
                _createClass(MdsQuickActionBar, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsQuickActionBar";
                    }
                } ]);
                function MdsQuickActionBar() {
                    var _this;
                    _classCallCheck(this, MdsQuickActionBar);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsQuickActionBar).call(this));
                    _this._dispatchCustomClickEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])();
                    return _this;
                }
                _createClass(MdsQuickActionBar, [ {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                            target: "button1"
                        };
                        return _get(_getPrototypeOf(MdsQuickActionBar.prototype), "_getInteractiveElement", this).call(this, payload);
                    }
                }, {
                    key: "_quickActionPaddingAdjustment",
                    value: function _quickActionPaddingAdjustment() {
                        var firstButton = this.shadowRoot.querySelector(".mds-quick-action-bar__button-container:first-child");
                        var lastButton = this.shadowRoot.querySelector(".mds-quick-action-bar__button-container:last-child");
                        if (window.getComputedStyle(this.shadowRoot.querySelector(".mds-quick-action-bar")).textAlign !== "center") {
                            firstButton.style.paddingLeft = this.leadingPadding;
                            lastButton.style.paddingRight = this.trailingPadding;
                        } else {
                            var mdsQuickActionBarDiv = this.shadowRoot.querySelector(".mds-quick-action-bar");
                            var leadingPadding = parseFloat(this.leadingPadding);
                            var trailingPadding = parseFloat(this.trailingPadding);
                            var marginChanged = false;
                            var offsetRightButton = lastButton.getBoundingClientRect().right;
                            var currentPaddingLeft = firstButton.offsetLeft - mdsQuickActionBarDiv.offsetLeft;
                            var currentPaddingRight = offsetRightButton ? mdsQuickActionBarDiv.getBoundingClientRect().right - offsetRightButton : -1;
                            currentPaddingLeft < leadingPadding && (firstButton.style.paddingLeft = this.leadingPadding) && (marginChanged = true);
                            currentPaddingRight < trailingPadding && (lastButton.style.paddingRight = this.trailingPadding) && (marginChanged = true);
                            marginChanged && (mdsQuickActionBarDiv.style.textAlign = "left");
                        }
                    }
                }, {
                    key: "renderedCallback",
                    value: function renderedCallback() {
                        var _this2 = this;
                        setTimeout(function() {
                            _newArrowCheck(this, _this2);
                            !(this.trailingPadding === "0px" && this.leadingPadding === "0px") && this._quickActionPaddingAdjustment();
                        }.bind(this));
                    }
                }, {
                    key: "render",
                    value: function render() {
                        _mds_quick_action_bar__WEBPACK_IMPORTED_MODULE_2__["default"].call(this);
                    }
                }, {
                    key: "_quickActionButtons",
                    get: function get() {
                        return this._quickActionButtonsObject;
                    },
                    set: function set(quickActionButtons) {
                        var _this3 = this;
                        quickActionButtons.forEach(function(quickActionButton, i) {
                            _newArrowCheck(this, _this3);
                            if (quickActionButton.moreButton && i < quickActionButtons.length - 1) {
                                this.throwConstraintError("MDS Quick Action Bar can only have a More button at the end of the quickActionButtons list");
                            }
                            if (quickActionButton.moreButton && !quickActionButton.adaText) {
                                this.throwConstraintError("MDS Quick Action Bar More button must have ADA text");
                            }
                        }.bind(this));
                        this._quickActionButtonsObject = quickActionButtons;
                    }
                } ]);
                return MdsQuickActionBar;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_0___default.a), _class2.styles = _mds_quick_action_bar_scss__WEBPACK_IMPORTED_MODULE_1___default.a, 
            _class2._iconNames = {
                plus: "ico_add",
                ellipsis: "ico_ellipsis"
            }, _class2)) || _class);
            __webpack_exports__["default"] = MdsQuickActionBar;
        },
        "./src/quick-action-bar/mds-quick-action-bar.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _this = undefined;
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            var renderIcon = function renderIcon(iconType) {
                _newArrowCheck(this, _this);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "mds-quick-action-bar__icon", "innerHTML-prop", MDS.svgs[iconType], "aria-hidden", "true", "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            }.bind(undefined);
            var renderMoreButtonVariantAriaLabel = function renderMoreButtonVariantAriaLabel(quickReplyButton) {
                _newArrowCheck(this, _this);
                return quickReplyButton.moreButton ? quickReplyButton.adaText : quickReplyButton.text;
            }.bind(undefined);
            function renderButton(quickActionButton, buttonIndex) {
                var classes = {
                    "mds-quick-action-bar__button": true,
                    "mds-quick-action-bar__button--more": !!quickActionButton.moreButton
                };
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("li", null, null, "role", "listitem", "class", "mds-quick-action-bar__button-container");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("button", null, null, "class", classes, "id", "button".concat(buttonIndex + 1), "aria-label", renderMoreButtonVariantAriaLabel(quickActionButton), "onclick", this._dispatchCustomClickEvent);
                _renderArbitrary(!quickActionButton.moreButton && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "mds-quick-action-bar__label", "aria-hidden", "true"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(" "), _renderArbitrary(quickActionButton.text), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(" "), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                _renderArbitrary(quickActionButton.moreButton && renderIcon(this.constructor._iconNames[quickActionButton.moreButtonVariant]));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("button");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("li");
            }
            function MdsQuickActionBarTemplate() {
                var _this2 = this;
                var tempQuickActionButtons = this.quickActionButtons.map(function(button) {
                    _newArrowCheck(this, _this2);
                    return _extends({}, button);
                }.bind(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "role", "heading", "aria-level", this.headingLevel, "id", "quick-action-heading", "class", "accessible-text");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(" ");
                _renderArbitrary(this.accessibleHeadingName);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(" ");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("ul", null, null, "aria-labelledby", "quick-action-heading", "role", "list", "class", "mds-quick-action-bar mds-quick-action-bar--".concat(this.buttonSetAlignment));
                _renderArbitrary(tempQuickActionButtons.map(function(quickActionButton, i) {
                    _newArrowCheck(this, _this2);
                    return renderButton.call(this, quickActionButton, i);
                }.bind(this)));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("ul");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            __webpack_exports__["default"] = MdsQuickActionBarTemplate;
        },
        "./src/quick-action-bar/mds-quick-action-bar.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/quick-action-bar/mds-quick-action-bar.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/quick-reply-bar/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_quick_reply_bar_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/quick-reply-bar/mds-quick-reply-bar.scss");
            var _mds_quick_reply_bar_scss__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_quick_reply_bar_scss__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_quick_reply_bar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/quick-reply-bar/mds-quick-reply-bar.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            var arrayOf = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].arrayOf, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].enumerables, string = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].stringRequired, satisfies = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].satisfies, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].boolean;
            var quickReplyButtonEntity = {
                label: stringRequired,
                secondaryLabel: string,
                imageURL: string,
                iconType: enumerables.apply(void 0, [ string ].concat(_toConsumableArray(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["ICON_TYPES"])))
            };
            var entity = {
                quickReplyButtons: arrayOf(satisfies(quickReplyButtonEntity)).withMaxLength(8).withMinLength(1).withChangedCallback(),
                quickReplyAlignment: enumerables(string, "leading", "trailing", "centered").defaultsTo("centered"),
                leadingPadding: string.defaultsTo("0px"),
                trailingPadding: string.defaultsTo("0px"),
                imageWidth: string,
                imageHeight: string,
                multiline: boolean.defaultsTo(false)
            };
            var MdsQuickReplyBar = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsQuickReplyBar, _AgaveComponent);
                _createClass(MdsQuickReplyBar, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsQuickReplyBar";
                    }
                } ]);
                function MdsQuickReplyBar() {
                    var _this;
                    _classCallCheck(this, MdsQuickReplyBar);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsQuickReplyBar).call(this));
                    _this.buttonFocus = _this.buttonFocus.bind(_assertThisInitialized(_this));
                    _this.buttonBlur = _this.buttonBlur.bind(_assertThisInitialized(_this));
                    _this.shiftFocus = _this.shiftFocus.bind(_assertThisInitialized(_this));
                    _this._dispatchCustomEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])();
                    return _this;
                }
                _createClass(MdsQuickReplyBar, [ {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                            target: "button1"
                        };
                        return _get(_getPrototypeOf(MdsQuickReplyBar.prototype), "_getInteractiveElement", this).call(this, payload);
                    }
                }, {
                    key: "quickReplyPaddingAdjustment",
                    value: function quickReplyPaddingAdjustment() {
                        var _this2 = this;
                        var firstButton = this.shadowRoot.querySelector("li:first-child");
                        var lastButton = this.shadowRoot.querySelector("li:last-child");
                        var firstRowLastButton;
                        var secRowFirstButton;
                        this.multiline && (firstRowLastButton = this.shadowRoot.querySelector("li:nth-child(".concat(this._midpointIndex + 1, ")"))) && (secRowFirstButton = this.shadowRoot.querySelector("li:nth-child(".concat(this._midpointIndex + 3, ")")));
                        if (window.getComputedStyle(this.shadowRoot.querySelector(".mds-quick-reply-bar"), null).textAlign !== "center") {
                            firstButton.style.marginLeft = this.leadingPadding;
                            lastButton.style.marginRight = this.trailingPadding;
                            this.multiline && (secRowFirstButton.style.marginLeft = this.leadingPadding) && (firstRowLastButton.style.marginRight = this.trailingPadding);
                        } else {
                            var mdsQuickReplyBarDiv = this.shadowRoot.querySelector(".mds-quick-reply-bar");
                            var leadingPadding = parseFloat(this.leadingPadding);
                            var trailingPadding = parseFloat(this.trailingPadding);
                            var marginChanged = false;
                            var rows = [ {
                                rowFirstButton: firstButton,
                                rowLastButton: lastButton
                            } ];
                            this.multiline && rows.push({
                                rowFirstButton: secRowFirstButton,
                                rowLastButton: firstRowLastButton
                            });
                            rows.forEach(function(_ref) {
                                var rowFirstButton = _ref.rowFirstButton, rowLastButton = _ref.rowLastButton;
                                _newArrowCheck(this, _this2);
                                var offsetRightButton = rowLastButton.getBoundingClientRect().right;
                                var currentMarginLeft = rowFirstButton.offsetLeft - mdsQuickReplyBarDiv.offsetLeft;
                                var currentMarginRight = offsetRightButton ? mdsQuickReplyBarDiv.getBoundingClientRect().right - offsetRightButton : -1;
                                currentMarginLeft < leadingPadding && (rowFirstButton.style.marginLeft = this.leadingPadding) && (marginChanged = true);
                                currentMarginRight < trailingPadding && (rowLastButton.style.marginRight = this.trailingPadding) && (marginChanged = true);
                            }.bind(this));
                            marginChanged && (mdsQuickReplyBarDiv.style.textAlign = "left");
                        }
                    }
                }, {
                    key: "shiftFocus",
                    value: function shiftFocus(e) {
                        if ([ 37, 39 ].includes(e.keyCode)) {
                            e.preventDefault();
                            var i = parseInt(e.target.dataset.index, 10);
                            var direction = e.keyCode - 38;
                            var newIndex = direction + i;
                            if (![ -1, this.quickReplyButtons.length ].includes(newIndex)) {
                                this.focus({
                                    target: "button".concat(newIndex + 1)
                                });
                            }
                        }
                    }
                }, {
                    key: "buttonFocus",
                    value: function buttonFocus() {
                        this.shadowRoot.querySelector(".mds-quick-reply-bar__button-container:first-child .mds-quick-reply-bar__button").setAttribute("tabIndex", -1);
                    }
                }, {
                    key: "buttonBlur",
                    value: function buttonBlur() {
                        this.shadowRoot.querySelector(".mds-quick-reply-bar__button-container:first-child .mds-quick-reply-bar__button").setAttribute("tabIndex", 0);
                    }
                }, {
                    key: "renderedCallback",
                    value: function renderedCallback() {
                        var _this3 = this;
                        setTimeout(function() {
                            _newArrowCheck(this, _this3);
                            if (this.multiline) {
                                var container = this.shadowRoot.querySelector(".mds-quick-reply-bar");
                                container.scrollWidth > container.clientWidth && (container.style.textAlign = "left");
                            }
                            !(this.trailingPadding === "0px" && this.leadingPadding === "0px") && this.quickReplyPaddingAdjustment();
                        }.bind(this));
                    }
                }, {
                    key: "render",
                    value: function render() {
                        if (this.multiline && this.quickReplyButtons[0].imageURL) {
                            this.throwConstraintError("MDS Quick Reply Bar Buttons cannot have imageURL when multiline is true");
                        }
                        _mds_quick_reply_bar__WEBPACK_IMPORTED_MODULE_2__["default"].call(this);
                    }
                }, {
                    key: "quickReplyButtons",
                    get: function get() {
                        return this._quickReplyButtons;
                    },
                    set: function set(quickReplyButtons) {
                        var _this4 = this;
                        var hasSecondaryLabel = !!quickReplyButtons[0].secondaryLabel;
                        var hasImageURL = !!quickReplyButtons[0].imageURL;
                        var hasIcon = false;
                        quickReplyButtons.forEach(function(quickReplyButton) {
                            _newArrowCheck(this, _this4);
                            if (hasSecondaryLabel !== !!quickReplyButton.secondaryLabel) {
                                this.throwConstraintError("MDS Quick Reply Bar Buttons must either all have secondary labels or none");
                            }
                            if (hasImageURL !== !!quickReplyButton.imageURL) {
                                this.throwConstraintError("MDS Quick Reply Bar Buttons must either all have image URL or none");
                            }
                            hasIcon = hasIcon || !!quickReplyButton.iconType;
                        }.bind(this));
                        if (hasSecondaryLabel && !hasImageURL) {
                            this.throwConstraintError("MDS Quick Reply Bar Buttons must have imageURL to set secondary label");
                        }
                        if (hasIcon && hasImageURL) {
                            this.throwConstraintError("MDS Quick Reply Bar Buttons cannot have both IconType and ImageURL");
                        }
                        this._quickReplyButtons = quickReplyButtons;
                    }
                } ]);
                return MdsQuickReplyBar;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_0___default.a), _class2.styles = _mds_quick_reply_bar_scss__WEBPACK_IMPORTED_MODULE_1___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsQuickReplyBar;
        },
        "./src/quick-reply-bar/mds-quick-reply-bar.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _this = undefined;
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            var renderIcon = function renderIcon(iconType) {
                _newArrowCheck(this, _this);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "mds-quick-reply-bar__icon", "innerHTML-prop", MDS.svgs[iconType], "aria-hidden", "true", "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            }.bind(undefined);
            var renderBaseVariant = function renderBaseVariant(quickReplyButton, i, context) {
                _newArrowCheck(this, _this);
                var classes = {
                    "mds-quick-reply-bar__button": true,
                    "mds-quick-reply-bar__button--base": true,
                    "mds-quick-reply-bar__button--multiline-first-row": context.multiline && context._midpointIndex + 1 > i
                };
                var buttonIndex = context.multiline && context._midpointIndex + 1 < i ? i - 1 : i;
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("li", null, null, "class", "mds-quick-reply-bar__button-container");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("button", null, null, "id", "button".concat(buttonIndex + 1), "class", classes, "aria-label", quickReplyButton.label, "onkeydown", context.shiftFocus, "data-index", buttonIndex, "tabIndex", buttonIndex === 0 ? 0 : -1, "onfocus", context.buttonFocus, "onblur", context.buttonBlur, "onclick", context._dispatchCustomEvent);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "mds-quick-reply-bar__label", "aria-hidden", "true");
                _renderArbitrary(quickReplyButton.label);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                _renderArbitrary(quickReplyButton.iconType && renderIcon(quickReplyButton.iconType));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("button");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("li");
            }.bind(undefined);
            var renderImageVariantAriaLabel = function renderImageVariantAriaLabel(quickReplyButton) {
                _newArrowCheck(this, _this);
                return quickReplyButton.label + (quickReplyButton.secondaryLabel && ", ".concat(quickReplyButton.secondaryLabel));
            }.bind(undefined);
            var renderImageVariant = function renderImageVariant(quickReplyButton, i, context) {
                _newArrowCheck(this, _this);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("li", null, null, "class", "mds-quick-reply-bar__button-container");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "button".concat(i + 1));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "mds-quick-reply-bar__button mds-quick-reply-bar__button--image");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-label", renderImageVariantAriaLabel(quickReplyButton));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onkeydown", context.shiftFocus);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-index", i);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("tabIndex", i === 0 ? 0 : -1);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onfocus", context.buttonFocus);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onblur", context.buttonBlur);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onclick", context._dispatchCustomEvent);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    style: {
                        maxWidth: context.imageWidth
                    }
                }, context.imageWidth));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "mds-quick-reply-bar__image-container");
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    style: {
                        minWidth: context.imageWidth,
                        minHeight: context.imageHeight
                    }
                }, context.imageWidth || context.imageHeight));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("img");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "mds-quick-reply-bar__image");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("src", quickReplyButton.imageURL);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("alt", "");
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    width: context.imageWidth
                }, context.imageWidth));
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    style: {
                        maxHeight: context.imageHeight
                    }
                }, context.imageHeight));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-hidden", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("img");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("img");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "mds-quick-reply-bar__label", "aria-hidden", "true");
                _renderArbitrary(quickReplyButton.label);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "aria-hidden", "true", "class", "mds-quick-reply-bar__label mds-quick-reply-bar__label--secondary");
                _renderArbitrary(quickReplyButton.secondaryLabel);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("button");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("li");
            }.bind(undefined);
            function MdsQuickReplyBarTemplate() {
                var _classes, _this2 = this;
                var renderVariant = this.quickReplyButtons[0].imageURL ? renderImageVariant : renderBaseVariant;
                var classes = (_classes = {
                    "mds-quick-reply-bar": true
                }, _defineProperty(_classes, "mds-quick-reply-bar--".concat(this.quickReplyAlignment), true), 
                _defineProperty(_classes, "mds-quick-reply-bar--multiline", this.multiline), _classes);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("ul", null, null, "class", classes);
                _renderArbitrary(this.quickReplyButtons.map(function(quickReplyButton, i) {
                    _newArrowCheck(this, _this2);
                    return renderVariant(quickReplyButton, i, this);
                }.bind(this)));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("ul");
            }
            __webpack_exports__["default"] = MdsQuickReplyBarTemplate;
        },
        "./src/quick-reply-bar/mds-quick-reply-bar.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/quick-reply-bar/mds-quick-reply-bar.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/quick-reply-button/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_quick_reply_button_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/quick-reply-button/mds-quick-reply-button.scss");
            var _mds_quick_reply_button_scss__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_quick_reply_button_scss__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_quick_reply_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/quick-reply-button/mds-quick-reply-button.jsx");
            var _button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/button/index.js");
            var _dec, _class, _class2;
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var string = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].string, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].boolean;
            var buttonEntity = {
                type: string.defaultsTo("button"),
                value: string,
                text: string.withMaxLength(200),
                label: string,
                small: boolean.defaultsTo(false),
                image: string,
                icon: string
            };
            var entity = _objectSpread({}, _button__WEBPACK_IMPORTED_MODULE_3__["entity"], {}, buttonEntity);
            var MdsQuickReplyButton = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_MdsButton) {
                _inherits(MdsQuickReplyButton, _MdsButton);
                function MdsQuickReplyButton() {
                    _classCallCheck(this, MdsQuickReplyButton);
                    return _possibleConstructorReturn(this, _getPrototypeOf(MdsQuickReplyButton).apply(this, arguments));
                }
                _createClass(MdsQuickReplyButton, [ {
                    key: "render",
                    value: function render() {
                        this.label = this.label || this.text;
                        this.text && console.warn("'text' attribute will be deprecated in ".concat(this.tagName, ", use 'label' attribute instead."));
                        this.variant && console.warn("".concat(this.tagName, " does not support 'variant' attribute."));
                        this.inactive && console.warn("".concat(this.tagName, " does not support 'inactive' attribute."));
                        this.widthType && console.warn("".concat(this.tagName, " does not support 'width type' attribute."));
                        this.small && console.warn("".concat(this.tagName, " does not support 'small' attribute."));
                        _mds_quick_reply_button__WEBPACK_IMPORTED_MODULE_2__["default"].call(this);
                    }
                } ], [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsQuickReplyButton";
                    }
                } ]);
                return MdsQuickReplyButton;
            }(_button__WEBPACK_IMPORTED_MODULE_3__["default"]), _class2.styles = _mds_quick_reply_button_scss__WEBPACK_IMPORTED_MODULE_1___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsQuickReplyButton;
        },
        "./src/quick-reply-button/mds-quick-reply-button.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _span$wrapper = function _span$wrapper(_MDS$svgs$iconType) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "mds-quick-reply-button__icon", "innerHTML-prop", _MDS$svgs$iconType, "aria-hidden", "true", "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            };
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            var MdsQuickReplyButtonTemplate = function MdsQuickReplyButtonTemplate() {
                var _this = this;
                var label = this.label, type = this.type, value = this.value, image = this.image, icon = this.icon;
                var renderIcon = function renderIcon(iconType) {
                    _newArrowCheck(this, _this);
                    return _jsxWrapper(_span$wrapper, [ MDS.svgs[iconType] ]);
                }.bind(this);
                if (image) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("button", null, null, "class", "mds-quick-reply-button__base mds-quick-reply-button", "type", type, "value-prop", value, "onclick", this._onclick, "onblur", this._onblur, "onfocus", this._onfocus, "onkeydown", this._onkeydown, "onkeyup", this._onkeyup, "onmouseover", this._onmouseover, "onmouseenter", this._onmouseenter, "onmouseout", this._onmouseout);
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("img", null, null, "class", "mds-quick-reply-button-image", "src", image, "alt", "", "aria-hidden", "true");
                    _renderArbitrary(label);
                    return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("button");
                }
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("button", null, null, "class", "mds-quick-reply-button__base mds-quick-reply-button", "type", type, "value-prop", value, "onclick", this._onclick, "onblur", this._onblur, "onfocus", this._onfocus, "onkeydown", this._onkeydown, "onkeyup", this._onkeyup, "onmouseover", this._onmouseover, "onmouseenter", this._onmouseenter, "onmouseout", this._onmouseout);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span");
                _renderArbitrary(label);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                _renderArbitrary(icon && renderIcon(icon));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("button");
            };
            __webpack_exports__["default"] = MdsQuickReplyButtonTemplate;
        },
        "./src/quick-reply-button/mds-quick-reply-button.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/quick-reply-button/mds-quick-reply-button.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/radio-group/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _radio_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/radio-group/radio-button.jsx");
            var _mds_radio_group_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/radio-group/mds-radio-group.scss");
            var _mds_radio_group_scss__WEBPACK_IMPORTED_MODULE_3___default = __webpack_require__.n(_mds_radio_group_scss__WEBPACK_IMPORTED_MODULE_3__);
            var _utils_form_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/form-utils.js");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["mixins"].AttributeMarshallingMixin, stamp = _mixins$AttributeMars.stamp, arrayOf = _mixins$AttributeMars.arrayOf, string = _mixins$AttributeMars.string, stringRequired = _mixins$AttributeMars.stringRequired, boolean = _mixins$AttributeMars.boolean, satisfies = _mixins$AttributeMars.satisfies, enumerables = _mixins$AttributeMars.enumerables, number = _mixins$AttributeMars.number;
            var radioButtonEntity = {
                label: stringRequired,
                secondaryLabel: string,
                value: stringRequired,
                inactive: boolean,
                accessibleTextBeforeLabel: string,
                accessibleTextAfterLabel: string,
                leadingIcon: enumerables.apply(void 0, [ string ].concat(_toConsumableArray(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["ICON_TYPES"])))
            };
            var entity = {
                radioButtons: arrayOf(satisfies(radioButtonEntity)).withMinLength(2).withChangedCallback(),
                radioType: enumerables(string, "base", "button").defaultsTo("base"),
                layout: enumerables(string, "vertical", "horizontal"),
                fieldGroupLayout: enumerables(string, "vertical", "horizontal").defaultsTo("vertical"),
                name: stringRequired,
                radioFieldGroupLabelText: stringRequired,
                fieldGroupMicrocopy: string,
                selectedRadio: string.defaultsTo("").withChangedCallback(),
                selectedIndex: number.defaultsTo(-1).withChangedCallback(),
                inactive: boolean.defaultsTo(false).withChangedCallback(),
                error: boolean.defaultsTo(false).withChangedCallback(),
                errorMessage: string,
                errorIconAccessibleText: string.defaultsTo(""),
                required: boolean,
                labelSize: enumerables(string, "regular", "medium", "prominent").defaultsTo("regular"),
                labelColumns: string.defaultsTo(""),
                inputColumns: string.defaultsTo(""),
                buttonSize: enumerables(string, "regular", "small").defaultsTo("regular"),
                removeBottomMargin: boolean.defaultsTo(false)
            };
            var MdsRadioGroup = (_dec = stamp(entity), _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsRadioGroup, _AgaveComponent);
                _createClass(MdsRadioGroup, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsRadioGroup";
                    }
                } ]);
                function MdsRadioGroup() {
                    var _this;
                    _classCallCheck(this, MdsRadioGroup);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsRadioGroup).call(this));
                    _this._onchange = _this._onchange.bind(_assertThisInitialized(_this));
                    _this._onfocus = _this._onfocus.bind(_assertThisInitialized(_this));
                    _this._onblur = _this._onblur.bind(_assertThisInitialized(_this));
                    _this._onkeydown = _this._onkeydown.bind(_assertThisInitialized(_this));
                    _this._onkeyup = _this._onkeyup.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsRadioGroup, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsRadioGroup.prototype), "connectedCallback", this).call(this);
                        !this._formAssociatedInput && _utils_form_utils__WEBPACK_IMPORTED_MODULE_4__["createFormAssociatedInput"].call(this, {
                            value: this.selectedRadio
                        });
                        this.error && console.warn("error is deprecated, please use errorMessage");
                    }
                }, {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        if (!payload.index) {
                            return {
                                interactiveElement: this.shadowRoot.getElementById("".concat(this.id, "-fieldset"))
                            };
                        }
                        return {
                            interactiveElement: this.shadowRoot.querySelectorAll("input")[payload.index]
                        };
                    }
                }, {
                    key: "selectedIndexChangedCallback",
                    value: function selectedIndexChangedCallback(newValue) {
                        var _this2 = this;
                        if (this.radioButtons) {
                            this.selectedRadio = this.radioButtons[newValue] ? this.radioButtons[newValue].value : "";
                        } else {
                            setTimeout(function() {
                                _newArrowCheck(this, _this2);
                                this.selectedRadio = this.radioButtons[newValue] ? this.radioButtons[newValue].value : "";
                            }.bind(this), 0);
                        }
                        this.checked = this.selectedRadio;
                        this.value = this.selectedRadio;
                    }
                }, {
                    key: "selectedRadioChangedCallback",
                    value: function selectedRadioChangedCallback(newValue) {
                        var _this3 = this;
                        if (this.radioButtons) {
                            this.selectedIndex = this.radioButtons.findIndex(function(input) {
                                _newArrowCheck(this, _this3);
                                return input.value === newValue;
                            }.bind(this));
                        } else {
                            setTimeout(function() {
                                var _this4 = this;
                                _newArrowCheck(this, _this3);
                                this.selectedIndex = this.radioButtons.findIndex(function(input) {
                                    _newArrowCheck(this, _this4);
                                    return input.value === newValue;
                                }.bind(this));
                            }.bind(this), 0);
                        }
                        this._formAssociatedInput && _utils_form_utils__WEBPACK_IMPORTED_MODULE_4__["syncFormAssociatedInputValue"].call(this, newValue);
                    }
                }, {
                    key: "radioButtonsChangedCallback",
                    value: function radioButtonsChangedCallback() {
                        var _this5 = this;
                        this._allButtonsHaveLeadingIcons = this.radioButtons.every(function(button) {
                            _newArrowCheck(this, _this5);
                            return button.leadingIcon;
                        }.bind(this));
                        if (this.radioButtons.some(function(button) {
                            _newArrowCheck(this, _this5);
                            return button.leadingIcon;
                        }.bind(this)) && !this._allButtonsHaveLeadingIcons) {
                            this._inconsistantLeadingIconError = true;
                            this.throwConstraintError("If at least one button has a leadingIcon then all buttons are required to have leadingIcons");
                        }
                    }
                }, {
                    key: "inactiveChangedCallback",
                    value: function inactiveChangedCallback(newValue) {
                        this._formAssociatedInput && _utils_form_utils__WEBPACK_IMPORTED_MODULE_4__["syncFormAssociatedInputDisabledValue"].call(this, newValue, !this.selectedRadio);
                    }
                }, {
                    key: "errorChangedCallback",
                    value: function errorChangedCallback() {
                        this.error && console.warn("error is deprecated, please use errorMessage");
                    }
                }, {
                    key: "_onchange",
                    value: function _onchange(event) {
                        this.selectedRadio = event.target.value;
                        this.checked = event.target.value;
                        _get(_getPrototypeOf(MdsRadioGroup.prototype), "_onchange", this) && _get(_getPrototypeOf(MdsRadioGroup.prototype), "_onchange", this).call(this, event);
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var _this6 = this;
                        if (this.errorMessage && !this.errorIconAccessibleText) {
                            this.throwConstraintError('As of @mds/web version 4.0.0, the property "errorIconAccessibleText" is required if the Radio Group is in error state.');
                        }
                        if (!this.radioFieldGroupLabelText) {
                            console.warn("radioFieldGroupLabelText is required.");
                        }
                        var errorMessages = this.errorMessage ? '["'.concat(this.errorMessage, '"]') : "[]";
                        var layout = this.layout;
                        if (this._allButtonsHaveLeadingIcons && this.radioType !== "button") {
                            console.warn("LeadingIcons are only displayed if radio-type is button");
                        }
                        if (!this.layout) {
                            layout = this.radioType === "button" ? "horizontal" : "vertical";
                        }
                        var radioButtonContainerClasses = {
                            "radio-group__radio-buttons": true,
                            "radio-group__radio-buttons--horizontal": this.fieldGroupLayout === "horizontal" && this.layout === "horizontal"
                        };
                        var radioButtonInnerContainerClasses = {
                            "radio-group__radio-buttons--inner-container": true,
                            "radio-group__radio-buttons--inner-container-horizontal": this.fieldGroupLayout === "horizontal",
                            "radio-group__radio-buttons--inner-container-layout-horizontal": this.layout !== "vertical",
                            "radio-group__radio-buttons--remove-bottom-margin": this.removeBottomMargin,
                            "radio-group__radio-buttons--remove-bottom-margin-horizontal": this.removeBottomMargin && this.layout !== "vertical"
                        };
                        var getLabelColumns = function getLabelColumns() {
                            _newArrowCheck(this, _this6);
                            if (this.fieldGroupLayout === "horizontal" && this.layout === "horizontal") {
                                return this.labelColumns || "mds-col-3";
                            }
                        }.bind(this);
                        var getInputColumns = function getInputColumns() {
                            _newArrowCheck(this, _this6);
                            if (this.fieldGroupLayout === "horizontal" && this.layout === "horizontal") {
                                return this.inputColumns || "mds-col-9";
                            }
                        }.bind(this);
                        if (this._inconsistantLeadingIconError) {
                            return;
                        }
                        if (this.layout === "horizontal" && this.labelSize !== "regular") {
                            console.error("Horizontal layout size must be used with regular label size.");
                        }
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("mds-fieldset");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "radio-group radio-group--".concat(this.radioType));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("legend-text", this.radioFieldGroupLabelText);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("microcopy", this.fieldGroupMicrocopy);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("error-messages", errorMessages);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("error-message-prefix-accessible-text", this.errorIconAccessibleText);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("label-size", this.labelSize);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("layout", layout === "horizontal" ? this.fieldGroupLayout : "vertical");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("label-columns", getLabelColumns());
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("input-columns", getInputColumns());
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["conditionalAttribute"])({
                            "label-alignment": "right"
                        }, layout === "horizontal"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "".concat(this.id, "-fieldset"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("mds-fieldset");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", radioButtonContainerClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", radioButtonInnerContainerClasses);
                        _renderArbitrary(this.radioButtons.map(function(button, index) {
                            _newArrowCheck(this, _this6);
                            return Object(_radio_button__WEBPACK_IMPORTED_MODULE_2__["default"])(this, _objectSpread({}, button, {
                                buttonPosinset: index
                            }), index, layout);
                        }.bind(this)));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-fieldset");
                    }
                } ]);
                return MdsRadioGroup;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_radio_group_scss__WEBPACK_IMPORTED_MODULE_3___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsRadioGroup;
        },
        "./src/radio-group/mds-radio-group.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/radio-group/mds-radio-group.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/radio-group/radio-button.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _this = undefined;
            var _span$wrapper = function _span$wrapper(_text) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text");
                _renderArbitrary(_text);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            }, _label$wrapper = function _label$wrapper(_inputId, _radioButtonLabelClas, _child, _deferred, _args, _radioButtonLabelCont, _deferred2, _b, _args2, _button$label, _deferred3, _args3, _deferred4, _args4) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("label", null, null, "for", _inputId, "class", _radioButtonLabelClas);
                _renderArbitrary(_child);
                _renderArbitrary(_deferred(_args));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", _radioButtonLabelCont);
                _renderArbitrary(_b == 1 ? _deferred2(_args2) : _deferred2);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "radio-button__primary-label");
                _renderArbitrary(_button$label);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                _renderArbitrary(_deferred3(_args3[0], _args3[1], _args3[2]));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                _renderArbitrary(_deferred4(_args4));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("label");
            }, _div$wrapper = function _div$wrapper() {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "radio-button__outer-circle", "aria-hidden", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "radio-button__inner-circle");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            };
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            var renderAccessibleText = function renderAccessibleText(text) {
                _newArrowCheck(this, _this);
                return text ? _jsxWrapper(_span$wrapper, [ text ]) : "";
            }.bind(undefined);
            var renderSecondaryLabel = function renderSecondaryLabel(radioType, layout, button) {
                _newArrowCheck(this, _this);
                if (radioType === "base" && layout === "vertical" && button.secondaryLabel) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "radio-button__secondary-label");
                    _renderArbitrary(button.secondaryLabel);
                    return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                }
                return "";
            }.bind(undefined);
            var renderInput = function renderInput(radioGroup, button, buttonIndex, layout) {
                var _this2 = this;
                _newArrowCheck(this, _this);
                if (radioGroup.radioType === "button" && button.label.length > 200) {
                    radioGroup.throwConstraintError('Maximum label length exceeded. If using "button" radioType, label must be 200 or fewer characters.');
                }
                var name = radioGroup.name, radioType = radioGroup.radioType, selectedIndex = radioGroup.selectedIndex, required = radioGroup.required, _onchange = radioGroup._onchange, _onfocus = radioGroup._onfocus, _onblur = radioGroup._onblur, _onkeydown = radioGroup._onkeydown, _onkeyup = radioGroup._onkeyup, radioButtons = radioGroup.radioButtons, buttonSize = radioGroup.buttonSize;
                if (radioGroup.layout === "vertical" && radioGroup.buttonSize === "small") {
                    radioGroup.throwConstraintError("Small button size is only available in horizontal layout");
                }
                var radioButtonLeadingIconClasses = {
                    "radio-button__leading-icon": true,
                    "radio-button__leading-icon--small": buttonSize === "small"
                };
                var radioButtonLabelClasses = {
                    "radio-button__label": true,
                    "radio-button__label--small": buttonSize === "small"
                };
                var radioButtonLabelContentClasses = {
                    "radio-button__label-content": true,
                    "radio-button__label-content--small": buttonSize === "small"
                };
                var renderIcon = function renderIcon(leadingIcon) {
                    _newArrowCheck(this, _this2);
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", radioButtonLeadingIconClasses, "aria-hidden", "true", "innerHTML-prop", MDS.svgs[leadingIcon], "__skip", "true");
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                    return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                }.bind(this);
                var renderRadioButton = function renderRadioButton(radioType, inputId, button, layout) {
                    var _b = 0;
                    _newArrowCheck(this, _this2);
                    return _jsxWrapper(_label$wrapper, [ inputId, radioButtonLabelClasses, radioType === "base" && _jsxWrapper(_div$wrapper), renderAccessibleText, button.accessibleTextBeforeLabel, radioButtonLabelContentClasses, button.leadingIcon && radioType === "button" && (_b = 1, 
                    renderIcon), _b, _b == 1 ? button.leadingIcon : null, button.label, renderSecondaryLabel, [ radioType, layout, button ], renderAccessibleText, button.accessibleTextAfterLabel ]);
                }.bind(this);
                var inputId = "".concat(radioGroup.id, "-input-").concat(buttonIndex);
                var disabled = radioGroup.inactive || button.inactive;
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "radio-button radio-button--".concat(layout));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("input");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", inputId);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "radio-button__input");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("type", "radio");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("name", name);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("value", button.value);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("disabled-prop", disabled);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("required-prop", required);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-setsize", radioButtons.length);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-posinset", Number(++button.buttonPosinset));
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    onchange: _onchange,
                    onfocus: _onfocus,
                    onblur: _onblur,
                    onkeydown: _onkeydown,
                    onkeyup: _onkeyup
                }, !disabled));
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])("checked", buttonIndex === selectedIndex));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("input");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("input");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "radio-button__a11y-dot", "aria-hidden", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(" ● ");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                _renderArbitrary(renderRadioButton(radioType, inputId, button, layout));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }.bind(undefined);
            __webpack_exports__["default"] = renderInput;
        },
        "./src/rating-indicator/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_rating_indicator_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/rating-indicator/mds-rating-indicator.scss");
            var _mds_rating_indicator_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_rating_indicator_scss__WEBPACK_IMPORTED_MODULE_2__);
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            var _span$wrapper = function _span$wrapper(_MDS$svgs$ico_star_fi) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "rating-indicator__filled-star", "innerHTML-prop", _MDS$svgs$ico_star_fi, "aria-hidden", "true", "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            }, _div$wrapper = function _div$wrapper(_MDS$svgs$ico_star_ha, _MDS$svgs$ico_star_ou) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "rating-indicator__half-star-wrap", "aria-hidden", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "rating-indicator__half-star", "innerHTML-prop", _MDS$svgs$ico_star_ha, "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "rating-indicator__half-star-outline", "innerHTML-prop", _MDS$svgs$ico_star_ou, "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }, _span$wrapper2 = function _span$wrapper2(_MDS$svgs$ico_star_ou2) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "rating-indicator__outline-star", "innerHTML-prop", _MDS$svgs$ico_star_ou2, "aria-hidden", "true", "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            };
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var number = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].number, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].stringRequired, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].enumerables;
            var entity = {
                rating: enumerables(number, 0, .5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5),
                accessibleText: stringRequired
            };
            var MdsRatingIndicator = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsRatingIndicator, _AgaveComponent);
                function MdsRatingIndicator() {
                    _classCallCheck(this, MdsRatingIndicator);
                    return _possibleConstructorReturn(this, _getPrototypeOf(MdsRatingIndicator).apply(this, arguments));
                }
                _createClass(MdsRatingIndicator, [ {
                    key: "render",
                    value: function render() {
                        var _this = this;
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "rating-indicator");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text");
                        _renderArbitrary(this.accessibleText);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        _renderArbitrary(Array(5).fill(null).map(function(el, i) {
                            _newArrowCheck(this, _this);
                            if (this.rating >= i + 1) {
                                return _jsxWrapper(_span$wrapper, [ MDS.svgs.ico_star_filled ]);
                            }
                            if (this.rating === i + .5) {
                                return _jsxWrapper(_div$wrapper, [ MDS.svgs.ico_star_half, MDS.svgs.ico_star_outline ]);
                            }
                            return _jsxWrapper(_span$wrapper2, [ MDS.svgs.ico_star_outline ]);
                        }.bind(this)));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ], [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsRatingIndicator";
                    }
                } ]);
                return MdsRatingIndicator;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["AgaveComponent"]), _class2.styles = _mds_rating_indicator_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsRatingIndicator;
        },
        "./src/rating-indicator/mds-rating-indicator.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/rating-indicator/mds-rating-indicator.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/search-box/MdsSearchBox.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", (function() {
                return MdsSearchBoxTemplate;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _this = undefined;
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            var renderBoldText = function renderBoldText(item, type) {
                var match = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : item.match;
                _newArrowCheck(this, _this);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span");
                _renderArbitrary(match.index > 0 && item["".concat(type, "Text")].slice(0, match.index));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("strong");
                _renderArbitrary(match[0]);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("strong");
                _renderArbitrary(item["".concat(type, "Text")].slice(match.index + match[0].length));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            }.bind(undefined);
            var renderItemText = function renderItemText(item, type, index) {
                var _textClasses;
                var match = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : item.match;
                _newArrowCheck(this, _this);
                var renderBold = match && match[0].length && match.property === type;
                var textClasses = (_textClasses = {
                    "search-box__menu-option-text": true
                }, _defineProperty(_textClasses, "search-box__menu-option-text--".concat(type), true), 
                _defineProperty(_textClasses, "search-box__menu-option-text--primary-no-tertiary", !item.tertiaryText && type === "primary"), 
                _defineProperty(_textClasses, "search-box__menu-option-text--primary-no-secondary", !item.secondaryText && type === "primary"), 
                _defineProperty(_textClasses, "search-box__menu-option-text--secondary-no-tertiary", !item.tertiaryText && type === "secondary"), 
                _defineProperty(_textClasses, "search-box__menu-option-text--decorator", item.imageSize), 
                _textClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", textClasses, "aria-hidden", "true");
                _renderArbitrary(renderBold ? renderBoldText(item, type) : item["".concat(type, "Text")]);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            }.bind(undefined);
            function renderDecorator(item) {
                this._checkForDecoratorAccessibleText(item);
                if (item.leadingImage) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "search-box__menu-option--image-wrapper");
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("img", null, null, "class", "search-box__menu-option--image", "src", item.leadingImage, "alt", item.leadingDecoratorAccessibleText);
                    return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                }
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-icon", null, null, "type", item.leadingIcon, "size", "24px", "accessible-text", item.leadingDecoratorAccessibleText, "class", "search-box__menu-option--icon");
            }
            function renderOption(item, index) {
                var _this2 = this;
                var classes = {
                    "search-box__menu-option": true,
                    "search-box__menu-option--group-item": item.parentLabel
                };
                var accessibleName = [ item.primaryText, item.secondaryText, item.tertiaryText, item.parentLabel ].filter(Boolean).join(", ");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("li", null, null, "class", classes, "role", "option", "tabindex", "-1", "data-index", index, "onclick", this._handleMenuItemClick, "onblur", this._handleBlur, "aria-posinset", index + 1, "aria-setsize", this._optionResultList.length);
                _renderArbitrary((item.leadingImage || item.leadingIcon) && renderDecorator.call(this, item));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "search-box__accessible-text");
                _renderArbitrary(accessibleName);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                _renderArbitrary(this._propertyMatchList.map(function(property) {
                    _newArrowCheck(this, _this2);
                    return item["".concat(property, "Text")] && renderItemText(item, property, index);
                }.bind(this)));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("li");
            }
            function renderGroupLabel(item) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("li", null, null, "class", "search-box__menu-group-label", "aria-hidden", "true", "onmousedown", this._preventDefault);
                _renderArbitrary(item.groupLabel);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("li");
            }
            function renderNoResultsBlock() {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "search-box__menu-empty-block");
                _renderArbitrary(this.noResultsText);
                _renderArbitrary(this.showQueryIfNoResults && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("strong"), 
                _renderArbitrary(' "'.concat(this.inputValue, '"')), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("strong")));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function renderResults() {
                var _this3 = this;
                var optionCount = 0;
                this._searchResults.map(function(item) {
                    _newArrowCheck(this, _this3);
                    if (item.groupLabel) {
                        return renderGroupLabel.call(this, item);
                    }
                    optionCount++;
                    return renderOption.call(this, item, optionCount - 1);
                }.bind(this));
            }
            function renderMenu() {
                var menuClasses = {
                    "search-box__menu": true,
                    "search-box__menu--visible": this._isMenuVisible
                };
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("ul", null, null, "class", menuClasses, "id", "".concat(this.id, "-search-box-menu"), "role", "listbox", "tabindex", "-1", "style", "z-index: ".concat(this.zIndex), "onkeydown", this._handleMenuKeydown, "onkeyup", this._handleMenuKeyup, "onblur", this._handleBlur, "aria-label", this.label);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "search-box__accessible-text", "aria-live", "polite", "aria-atomic", "true", "role", "status");
                _renderArbitrary(this._ariaLiveFilteredOptions && (this._optionResultList.length ? "".concat(this._optionResultList.length, " ").concat(this.resultCountAccessibleText) : this.noResultsText));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                _renderArbitrary(this._searchResults.length ? renderResults.call(this) : renderNoResultsBlock.call(this));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("ul");
            }
            function MdsSearchBoxTemplate() {
                var fieldSuffix;
                if (!this.waitingState) {
                    fieldSuffix = this.variant === "line" ? "ico_close" : "ico_close_circle_filled";
                }
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "search-box");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("mds-text-input");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "search-box__input");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "".concat(this.id, "-search-box-input"));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("name", this.name);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("field-prefix", "ico_search");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("field-suffix", fieldSuffix);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("variant", this.variant);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("value", this.inputValue);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("label", this.label);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("placeholder", this.placeholder);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("label-style", this.labelStyle);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("microcopy", this.microcopy);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("inactive", this.inactive);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("field-suffix-accessible-text", this.clearButtonAccessibleText);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("label-columns", this.labelColumns);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("input-columns", this.inputColumns);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("oninput", this._handleInputInput);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onclick", this._handleInputClick);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onkeydown", this._handleInputKeydown);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onkeyup", this._handleInputKeyup);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onmouseenter", this._handleInputHover);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onmouseleave", this._handleInputHover);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onfocus", this._handleInputFocus);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("autocomplete-value", "off");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("waiting-state-accessible-text", this.waitingStateAccessibleText);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("waiting-state", !!this.waitingState);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onblur", this._handleBlur);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    tabindex: -1
                }, this._isMenuVisible));
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    aria: {
                        "aria-haspopup": "listbox"
                    }
                }, this.options));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("mds-text-input");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-text-input");
                _renderArbitrary(renderMenu.call(this));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
        },
        "./src/search-box/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_search_box_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/search-box/mds-search-box.scss");
            var _mds_search_box_scss__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_search_box_scss__WEBPACK_IMPORTED_MODULE_1__);
            var _MdsSearchBox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/search-box/MdsSearchBox.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            var _select_select_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/select/select-utils.js");
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/data-utils.js");
            var _utils_edge_detection__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/utils/edge-detection.js");
            var _text_input__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/text-input/index.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var arrayOf = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].arrayOf, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].boolean, number = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].number, satisfies = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].satisfies, string = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].stringRequired, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].enumerables;
            var optionEntity = {
                primaryText: stringRequired,
                secondaryText: string,
                tertiaryText: string,
                value: stringRequired,
                leadingImage: string,
                leadingIcon: string,
                leadingImageWidth: string.defaultsTo("32px"),
                leadingDecoratorAccessibleText: string
            };
            var groupItemEntity = {
                groupLabel: stringRequired,
                groupItems: arrayOf(satisfies(optionEntity)).withMinLength(1)
            };
            var entity = {
                options: arrayOf(satisfies(groupItemEntity).or(satisfies(optionEntity))).withChangedCallback(),
                placeholder: string,
                variant: enumerables(string, "box", "line").defaultsTo("box"),
                inputValue: string.defaultsTo("").withChangedCallback(),
                label: stringRequired,
                inactive: boolean.defaultsTo(false),
                inputColumns: string.defaultsTo(""),
                labelColumns: string.defaultsTo(""),
                labelStyle: enumerables(string, "horizontal", "vertical", "floating", "hidden").defaultsTo("hidden"),
                microcopy: string,
                name: string,
                noResultsText: string,
                showQueryIfNoResults: boolean.defaultsTo(true),
                menuWidth: number,
                clearButtonAccessibleText: string.defaultsTo("Clear search query"),
                resultCountAccessibleText: string.defaultsTo("results"),
                searchMode: enumerables(string, "simple", "advanced").defaultsTo("simple"),
                waitingState: boolean,
                waitingStateAccessibleText: string,
                zIndex: number,
                disableEdgeDetection: boolean.defaultsTo(false)
            };
            var MdsSearchBox = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsSearchBox, _AgaveComponent);
                _createClass(MdsSearchBox, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsSearchBox";
                    }
                } ]);
                function MdsSearchBox() {
                    var _this$_keyCodeActionM;
                    var _this;
                    _classCallCheck(this, MdsSearchBox);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsSearchBox).call(this));
                    _this.defineObservedProperty("_isMenuVisible", false);
                    _this.defineObservedProperty("_searchResults", []);
                    _this.defineObservedProperty("_ariaLiveFilteredOptions", false);
                    _this.value = "";
                    _this._optionResultList = [];
                    _this._propertyMatchList = [ "primary", "secondary", "tertiary" ];
                    _this.focus = _this.focus.bind(_assertThisInitialized(_this));
                    _this._handleBlur = _this._handleBlur.bind(_assertThisInitialized(_this));
                    _this._handleIconButtonClick = _this._handleIconButtonClick.bind(_assertThisInitialized(_this));
                    _this._handleInputInput = _this._handleInputInput.bind(_assertThisInitialized(_this));
                    _this._handleInputClick = _this._handleInputClick.bind(_assertThisInitialized(_this));
                    _this._handleInputFocus = _this._handleInputFocus.bind(_assertThisInitialized(_this));
                    _this._handleInputHover = _this._handleInputHover.bind(_assertThisInitialized(_this));
                    _this._handleInputKeydown = _this._handleInputKeydown.bind(_assertThisInitialized(_this));
                    _this._handleInputKeyup = _this._handleInputKeyup.bind(_assertThisInitialized(_this));
                    _this._handleMenuItemClick = _this._handleMenuItemClick.bind(_assertThisInitialized(_this));
                    _this._handleMenuKeydown = _this._handleMenuKeydown.bind(_assertThisInitialized(_this));
                    _this._handleMenuKeyup = _this._handleMenuKeyup.bind(_assertThisInitialized(_this));
                    _this._iosCloseOnBlur = _select_select_utils__WEBPACK_IMPORTED_MODULE_4__["iosCloseOnBlur"].bind(_assertThisInitialized(_this));
                    _this._setMenuHorizontalPosition = _this._setMenuHorizontalPosition.bind(_assertThisInitialized(_this));
                    _this._shiftFocusUp = _this._shiftFocusUp.bind(_assertThisInitialized(_this));
                    _this._shiftFocusDown = _this._shiftFocusDown.bind(_assertThisInitialized(_this));
                    _this._showClearButton = _this._showClearButton.bind(_assertThisInitialized(_this));
                    _this._hideClearButton = _this._hideClearButton.bind(_assertThisInitialized(_this));
                    _this._setTextToDecoratorClass - _this._setTextToDecoratorClass.bind(_assertThisInitialized(_this));
                    _this._preventDefault = _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["preventDefault"];
                    _this._keyCodeActionMap = (_this$_keyCodeActionM = {}, _defineProperty(_this$_keyCodeActionM, 13, _this._handleMenuItemClick), 
                    _defineProperty(_this$_keyCodeActionM, 32, _this._handleMenuItemClick), _defineProperty(_this$_keyCodeActionM, 37, _this.focus), 
                    _defineProperty(_this$_keyCodeActionM, 39, _this.focus), _defineProperty(_this$_keyCodeActionM, 38, _this._shiftFocusUp), 
                    _defineProperty(_this$_keyCodeActionM, 40, _this._shiftFocusDown), _this$_keyCodeActionM);
                    return _this;
                }
                _createClass(MdsSearchBox, [ {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        if (payload.index) {
                            return {
                                interactiveElement: this.shadowRoot.querySelectorAll('.search-box__menu-option[tabindex="-1"]')[payload.index]
                            };
                        }
                        return {
                            nextPayload: payload,
                            interactiveElement: this._textInput
                        };
                    }
                }, {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        var _this2 = this;
                        _get(_getPrototypeOf(MdsSearchBox.prototype), "connectedCallback", this).call(this);
                        this._menu = this.shadowRoot.querySelector(".search-box__menu");
                        this._textInput = this.shadowRoot.querySelector("mds-text-input");
                        this._textInput.addEventListener("click-field-suffix", this._handleIconButtonClick);
                        setTimeout(function() {
                            _newArrowCheck(this, _this2);
                            this._textLabel = this._textInput.shadowRoot.querySelector(".mds-text-input__label-wrap");
                        }.bind(this));
                        this._setTextToDecoratorClass();
                    }
                }, {
                    key: "disconnectedCallback",
                    value: function disconnectedCallback() {
                        _get(_getPrototypeOf(MdsSearchBox.prototype), "disconnectedCallback", this) && _get(_getPrototypeOf(MdsSearchBox.prototype), "disconnectedCallback", this).call(this);
                        MDS.isIOS && document.body.removeEventListener("touchstart", this._iosCloseOnBlur);
                        this.labelStyle === "horizontal" && window.removeEventListener("resize", this._setMenuHorizontalPosition);
                    }
                }, {
                    key: "focus",
                    value: function focus() {
                        this._textInput.focus();
                    }
                }, {
                    key: "_generateAdvancedSearchResults",
                    value: function _generateAdvancedSearchResults() {
                        var _this3 = this;
                        var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.inputValue;
                        this._optionResultList = [];
                        var searchResults = [];
                        query = query.replace(this.constructor._specialCharPattern, this.constructor._escapeMatchedPattern);
                        this._regExp = new RegExp(query, "i");
                        var _loop = function _loop() {
                            var _this4 = this;
                            var item = _objectSpread({}, _this3.options[i], {
                                match: null
                            });
                            if (item.groupItems) {
                                var _this3$_optionResultL;
                                item.groupItems.forEach(function(subItem) {
                                    var _this5 = this;
                                    _newArrowCheck(this, _this4);
                                    subItem.match = null;
                                    [ subItem.primaryText, subItem.secondaryText, subItem.tertiaryText ].forEach(function(text, subIndex) {
                                        _newArrowCheck(this, _this5);
                                        !subItem.match && _this3._getTextMatch(subItem, text, subIndex, item.groupLabel);
                                    }.bind(this));
                                }.bind(this));
                                searchResults.push.apply(searchResults, [ {
                                    groupLabel: item.groupLabel
                                } ].concat(_toConsumableArray(item.groupItems)));
                                (_this3$_optionResultL = _this3._optionResultList).push.apply(_this3$_optionResultL, _toConsumableArray(item.groupItems));
                            } else {
                                [ item.primaryText, item.secondaryText, item.tertiaryText ].forEach(function(text, index) {
                                    _newArrowCheck(this, _this4);
                                    return !item.match && _this3._getTextMatch(item, text, index);
                                }.bind(this));
                                searchResults.push(item);
                                _this3._optionResultList.push(item);
                            }
                        };
                        for (var i = 0; i < this.options.length; i++) {
                            _loop();
                        }
                        this._searchResults = searchResults;
                        this._setTextToDecoratorClass();
                    }
                }, {
                    key: "_fireSelectionEvent",
                    value: function _fireSelectionEvent(event) {
                        this.dispatchEvent(new CustomEvent("selection", {
                            detail: {
                                original: event,
                                target: this,
                                value: this.value
                            },
                            bubbles: true,
                            composed: true
                        }));
                    }
                }, {
                    key: "_generateSearchResults",
                    value: function _generateSearchResults() {
                        var _this6 = this;
                        var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.inputValue;
                        this._optionResultList = [];
                        var searchResults = [];
                        if (!query) {
                            this.options.forEach(function(option) {
                                var _this7 = this;
                                _newArrowCheck(this, _this6);
                                var item = _objectSpread({}, option);
                                if (item.groupItems) {
                                    var _this$_optionResultLi;
                                    var groupItems = item.groupItems.map(function(groupItem) {
                                        _newArrowCheck(this, _this7);
                                        return _objectSpread({}, groupItem, {
                                            parentLabel: item.groupLabel
                                        });
                                    }.bind(this));
                                    searchResults.push.apply(searchResults, [ {
                                        groupLabel: item.groupLabel
                                    } ].concat(_toConsumableArray(groupItems)));
                                    (_this$_optionResultLi = this._optionResultList).push.apply(_this$_optionResultLi, _toConsumableArray(groupItems));
                                } else {
                                    searchResults.push(item);
                                    this._optionResultList.push(item);
                                }
                            }.bind(this));
                            this._searchResults = searchResults;
                            return;
                        }
                        query = query.replace(this.constructor._specialCharPattern, this.constructor._escapeMatchedPattern);
                        this._regExp = new RegExp(query, "i");
                        var _loop2 = function _loop2() {
                            var _this8 = this;
                            var item = _objectSpread({}, _this6.options[i]);
                            if (item.groupItems) {
                                var groupItems = item.groupItems.map(function(groupItem) {
                                    _newArrowCheck(this, _this8);
                                    return _objectSpread({}, groupItem);
                                }.bind(this));
                                var filteredItems = groupItems.filter(function(subItem) {
                                    var _this9 = this;
                                    _newArrowCheck(this, _this8);
                                    return [ subItem.primaryText, subItem.secondaryText, subItem.tertiaryText ].some(function(text, subIndex) {
                                        _newArrowCheck(this, _this9);
                                        return _this6._getTextMatch(subItem, text, subIndex, item.groupLabel);
                                    }.bind(this));
                                }.bind(this));
                                if (filteredItems.length) {
                                    var _this6$_optionResultL;
                                    searchResults.push.apply(searchResults, [ {
                                        groupLabel: item.groupLabel
                                    } ].concat(_toConsumableArray(filteredItems)));
                                    (_this6$_optionResultL = _this6._optionResultList).push.apply(_this6$_optionResultL, _toConsumableArray(filteredItems));
                                }
                            } else if ([ item.primaryText, item.secondaryText, item.tertiaryText ].some(function(text, index) {
                                _newArrowCheck(this, _this8);
                                return _this6._getTextMatch(item, text, index);
                            }.bind(this))) {
                                searchResults.push(item);
                                _this6._optionResultList.push(item);
                            }
                        };
                        for (var i = 0; i < this.options.length; i++) {
                            _loop2();
                        }
                        this._searchResults = searchResults;
                        this._setTextToDecoratorClass();
                    }
                }, {
                    key: "_checkForDecoratorAccessibleText",
                    value: function _checkForDecoratorAccessibleText(item) {
                        if ((item.leadingIcon || item.leadingImage) && !item.leadingDecoratorAccessibleText) {
                            this.throwConstraintError("When providing a leading icon or leading image, you must provide a leadingDecoratorAccessibleText");
                        }
                    }
                }, {
                    key: "_setTextToDecoratorClass",
                    value: function _setTextToDecoratorClass() {
                        if (this._menu) {
                            this._images = this._menu.querySelectorAll(".search-box__menu-option--image-wrapper");
                            this._setTextAlignmentForImage();
                        }
                    }
                }, {
                    key: "_setTextAlignmentForImage",
                    value: function _setTextAlignmentForImage() {
                        var _this10 = this;
                        this._images.forEach(function(image) {
                            _newArrowCheck(this, _this10);
                            var listEl = image.parentElement;
                            var cs = getComputedStyle(listEl);
                            var heightOfLi = parseFloat(cs.height) - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
                            var heightOfImage = parseFloat(getComputedStyle(image).height);
                            if (heightOfLi <= heightOfImage) {
                                this._optionResultList[listEl.dataset.index].imageSize = "true";
                            }
                        }.bind(this));
                    }
                }, {
                    key: "_getTextMatch",
                    value: function _getTextMatch(item) {
                        var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                        var index = arguments.length > 2 ? arguments[2] : undefined;
                        var groupItemLabel = arguments.length > 3 ? arguments[3] : undefined;
                        var match = text.match(this._regExp) || [];
                        if (match.length) {
                            match.property = this._propertyMatchList[index];
                            item.match = match;
                            item.parentLabel = groupItemLabel;
                            return true;
                        }
                        return false;
                    }
                }, {
                    key: "_handleIconButtonClick",
                    value: function _handleIconButtonClick() {
                        var _this11 = this;
                        this.setState({
                            value: "",
                            inputValue: ""
                        }).then(function() {
                            _newArrowCheck(this, _this11);
                            this._textInput.focus();
                            this._hideClearButton();
                        }.bind(this));
                    }
                }, {
                    key: "_handleBlur",
                    value: function _handleBlur(eventDetail) {
                        var event = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["originalEvent"])(eventDetail);
                        if (!event.relatedTarget || event.relatedTarget && !this.deepContains(event.relatedTarget)) {
                            this.close();
                            this._hideClearButton();
                            _get(_getPrototypeOf(MdsSearchBox.prototype), "_onblur", this) && _get(_getPrototypeOf(MdsSearchBox.prototype), "_onblur", this).call(this, event);
                        }
                        eventDetail.stopPropagation();
                    }
                }, {
                    key: "_handleInputClick",
                    value: function _handleInputClick(_ref) {
                        var event = _ref.detail;
                        if (event.target === this._textInput._textFieldNode) {
                            !this._isMenuVisible && this.inputValue && this.open();
                        }
                    }
                }, {
                    key: "_handleInputInput",
                    value: function _handleInputInput(event) {
                        var _this12 = this;
                        this.inputValue = event.target.value;
                        if (this.inputValue) {
                            !this._isMenuVisible && this.open();
                            this._showClearButton();
                            this._ariaLiveFilteredOptions = false;
                            clearTimeout(this._timeout);
                            this._timeout = setTimeout(function() {
                                _newArrowCheck(this, _this12);
                                this._ariaLiveFilteredOptions = true;
                            }.bind(this), 2e3);
                        } else {
                            this._hideClearButton();
                        }
                    }
                }, {
                    key: "_handleInputFocus",
                    value: function _handleInputFocus() {
                        this.inputValue && this._showClearButton();
                    }
                }, {
                    key: "_handleInputHover",
                    value: function _handleInputHover(event) {
                        if (!this.inactive && this.inputValue && !this.shadowRoot.activeElement) {
                            event.type === "mouseenter" ? this._showClearButton() : this._hideClearButton();
                        }
                    }
                }, {
                    key: "_handleInputKeydown",
                    value: function _handleInputKeydown(eventDetail) {
                        var _this13 = this;
                        var event = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["originalEvent"])(eventDetail);
                        if (event.keyCode === 13) {
                            if (event.target.localName === "button") {
                                event.target.click();
                            } else if (this._optionResultList.length === 1) {
                                this.setState({
                                    value: this._optionResultList[0].value,
                                    inputValue: this._optionResultList[0].primaryText
                                }).then(function() {
                                    _newArrowCheck(this, _this13);
                                    return this._fireSelectionEvent(event);
                                }.bind(this));
                            } else if (this.inputValue) {
                                var searchMatch = this._optionResultList.find(function(item) {
                                    var _this14 = this;
                                    _newArrowCheck(this, _this13);
                                    return Object.values(item).some(function(text) {
                                        _newArrowCheck(this, _this14);
                                        return this._regExp.test(text);
                                    }.bind(this));
                                }.bind(this));
                                searchMatch && this.setState({
                                    value: searchMatch.value,
                                    inputValue: searchMatch.primaryText
                                });
                            }
                            this.close(true);
                        } else if (event.keyCode === 40 || event.keyCode === 38) {
                            event.preventDefault();
                            !this._isMenuVisible && this.open();
                            this._searchResults.length && this._getOptionNode(0).focus();
                        }
                    }
                }, {
                    key: "_handleInputKeyup",
                    value: function _handleInputKeyup(event) {
                        this._isMenuVisible && Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["isEscAndShouldClose"])(event) && this.close(true);
                    }
                }, {
                    key: "_handleMenuItemClick",
                    value: function _handleMenuItemClick(event) {
                        var _this15 = this;
                        var _this$_optionResultLi2 = this._optionResultList[event.target.dataset.index], primaryText = _this$_optionResultLi2.primaryText, value = _this$_optionResultLi2.value;
                        this.setState({
                            value: value,
                            inputValue: primaryText
                        }).then(function() {
                            _newArrowCheck(this, _this15);
                            _get(_getPrototypeOf(MdsSearchBox.prototype), "_onclick", this) && _get(_getPrototypeOf(MdsSearchBox.prototype), "_onclick", this).call(this, event);
                            this._fireSelectionEvent(event);
                            this.close(true);
                        }.bind(this));
                    }
                }, {
                    key: "_handleMenuKeydown",
                    value: function _handleMenuKeydown(event) {
                        if (this._keyCodeActionMap[event.keyCode]) {
                            event.preventDefault();
                            this._keyCodeActionMap[event.keyCode](event);
                        }
                        _get(_getPrototypeOf(MdsSearchBox.prototype), "_onkeydown", this) && _get(_getPrototypeOf(MdsSearchBox.prototype), "_onkeydown", this).call(this, event);
                    }
                }, {
                    key: "_handleMenuKeyup",
                    value: function _handleMenuKeyup(event) {
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["isEscAndShouldClose"])(event) && this.close(true);
                    }
                }, {
                    key: "_hideClearButton",
                    value: function _hideClearButton() {
                        if (!this._textInput._hideIconButton) {
                            this._textInput._hideIconButton = true;
                        }
                    }
                }, {
                    key: "_showClearButton",
                    value: function _showClearButton() {
                        if (this._textInput._hideIconButton) {
                            this._textInput._hideIconButton = false;
                        }
                    }
                }, {
                    key: "_shiftFocusDown",
                    value: function _shiftFocusDown(event) {
                        var currentIndex = Number(event.target.dataset.index);
                        var target = currentIndex === this._optionResultList.length - 1 ? this._getOptionNode(0) : this._getOptionNode(currentIndex + 1);
                        target && target.focus();
                    }
                }, {
                    key: "_shiftFocusUp",
                    value: function _shiftFocusUp(event) {
                        var currentIndex = Number(event.target.dataset.index);
                        var target = currentIndex === 0 ? this._getOptionNode(this._optionResultList.length - 1) : this._getOptionNode(currentIndex - 1);
                        target && target.focus();
                    }
                }, {
                    key: "_getOptionNode",
                    value: function _getOptionNode(index) {
                        return this._menu.querySelector('[data-index="'.concat(index, '"]'));
                    }
                }, {
                    key: "_setMenuHorizontalPosition",
                    value: function _setMenuHorizontalPosition() {
                        this._menu.style.left = "".concat(this._textInput._labelNode.offsetWidth, "px");
                        if (!this.menuWidth) {
                            this._menu.style.width = "".concat(this._textInput._textFieldNode.offsetWidth, "px");
                        }
                    }
                }, {
                    key: "open",
                    value: function open() {
                        if (this.options) {
                            this._menu = this.shadowRoot.querySelector(".search-box__menu");
                            this._isMenuVisible = true;
                            if (this.labelStyle === "horizontal") {
                                this._setMenuHorizontalPosition();
                                window.addEventListener("resize", this._setMenuHorizontalPosition);
                            }
                            if (this.menuWidth) {
                                this._menu.style.width = "".concat(this.menuWidth, "px");
                            }
                            var input = {
                                label: this._textLabel,
                                inputTrigger: this._textInput._textFieldNode,
                                textField: true
                            };
                            _utils_edge_detection__WEBPACK_IMPORTED_MODULE_6__["setOverlayVerticalPosition"].call(this, this._menu, input, this.disableEdgeDetection, Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_5__["cleanCssValue"])("4px"));
                            MDS.isIOS && document.body.addEventListener("touchstart", this._iosCloseOnBlur);
                            this.dispatchEvent(new CustomEvent("open", {
                                detail: {
                                    target: this,
                                    value: this.value
                                },
                                bubbles: true,
                                composed: true
                            }));
                        }
                        this._setTextToDecoratorClass();
                    }
                }, {
                    key: "close",
                    value: function close(refocus) {
                        this._isMenuVisible = false;
                        refocus && this.focus();
                        MDS.isIOS && document.body.removeEventListener("touchstart", this._iosCloseOnBlur);
                        this.labelStyle === "horizontal" && window.removeEventListener("resize", this._setMenuHorizontalPosition);
                        this.dispatchEvent(new CustomEvent("close", {
                            detail: {
                                target: this,
                                value: this.value
                            },
                            bubbles: true,
                            composed: true
                        }));
                    }
                }, {
                    key: "inputValueChangedCallback",
                    value: function inputValueChangedCallback(newValue, oldValue) {
                        if (this.options) {
                            this.searchMode === "advanced" ? this._generateAdvancedSearchResults() : this._generateSearchResults();
                            if (!newValue && oldValue && this._isMenuVisible) {
                                this.value = "";
                                this.close(true);
                            }
                        }
                    }
                }, {
                    key: "optionsChangedCallback",
                    value: function optionsChangedCallback() {
                        if (this.options && this.options.length) {
                            this.searchMode === "advanced" ? this._generateAdvancedSearchResults() : this._generateSearchResults();
                        } else {
                            this._optionResultList = [];
                            this._searchResults = [];
                        }
                    }
                }, {
                    key: "render",
                    value: function render() {
                        _MdsSearchBox__WEBPACK_IMPORTED_MODULE_2__["default"].call(this);
                    }
                } ]);
                return MdsSearchBox;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_0___default.a), _class2.styles = _mds_search_box_scss__WEBPACK_IMPORTED_MODULE_1___default.a, 
            _class2._specialCharPattern = /[.*+?^${}()|[\]\\]/g, _class2._escapeMatchedPattern = "\\$&", 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsSearchBox;
        },
        "./src/search-box/mds-search-box.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/search-box/mds-search-box.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/selectable-tile/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_selectable_tile_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/selectable-tile/mds-selectable-tile.scss");
            var _mds_selectable_tile_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_selectable_tile_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _dec, _class, _class2;
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].enumerables, string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].boolean, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].stringRequired, number = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].number;
            var entity = {
                label: stringRequired,
                fullWidth: boolean,
                width: number,
                height: number,
                checked: boolean.defaultsTo(false),
                contentArea: string,
                inactive: boolean.defaultsTo(false),
                error: boolean.defaultsTo(false),
                variant: enumerables(string, "checkbox", "radio").defaultsTo("checkbox"),
                accessibleName: string
            };
            var MdsSelectableTile = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsSelectableTile, _AgaveComponent);
                _createClass(MdsSelectableTile, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsSelectableTile";
                    }
                } ]);
                function MdsSelectableTile() {
                    var _this;
                    _classCallCheck(this, MdsSelectableTile);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsSelectableTile).call(this));
                    _this._onclick = _this._onclick.bind(_assertThisInitialized(_this));
                    _this._onblur = _this._onblur.bind(_assertThisInitialized(_this));
                    _this._onfocus = _this._onfocus.bind(_assertThisInitialized(_this));
                    _this._onkeydown = _this._onkeydown.bind(_assertThisInitialized(_this));
                    _this._onmouseover = _this._onmouseover.bind(_assertThisInitialized(_this));
                    _this.defineObservedProperty("_isFocused", false);
                    return _this;
                }
                _createClass(MdsSelectableTile, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsSelectableTile.prototype), "connectedCallback", this).call(this);
                        if (this.width && this.height) {
                            this.fullWidth && (this.fullWidth = false);
                        }
                        this._input = this.shadowRoot.querySelector("input:not(:disabled)");
                    }
                }, {
                    key: "focus",
                    value: function focus() {
                        this._input && this._input.focus();
                    }
                }, {
                    key: "_onclick",
                    value: function _onclick(event) {
                        var _this2 = this;
                        !this.inactive && (this.checked = !this.checked);
                        this.checked && (this.error = false);
                        _get(_getPrototypeOf(MdsSelectableTile.prototype), "_onclick", this) && _get(_getPrototypeOf(MdsSelectableTile.prototype), "_onclick", this).call(this, event);
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this2);
                            return "change";
                        }.bind(this), this)(event);
                        this._input && this._input.focus();
                    }
                }, {
                    key: "_onLabelClick",
                    value: function _onLabelClick(event) {
                        event.preventDefault();
                    }
                }, {
                    key: "_onfocus",
                    value: function _onfocus(event) {
                        _get(_getPrototypeOf(MdsSelectableTile.prototype), "_onfocus", this) && _get(_getPrototypeOf(MdsSelectableTile.prototype), "_onfocus", this).call(this, event);
                        this._isFocused = true;
                    }
                }, {
                    key: "_onblur",
                    value: function _onblur(event) {
                        _get(_getPrototypeOf(MdsSelectableTile.prototype), "_onblur", this) && _get(_getPrototypeOf(MdsSelectableTile.prototype), "_onblur", this).call(this, event);
                        this._isFocused = false;
                    }
                }, {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        return {
                            interactiveElement: this.shadowRoot.querySelector("input")
                        };
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var id = this.id, width = this.width, height = this.height, fullWidth = this.fullWidth, contentArea = this.contentArea, label = this.label, inactive = this.inactive, checked = this.checked, error = this.error, _isFocused = this._isFocused, variant = this.variant, accessibleName = this.accessibleName;
                        var accessibleInputText;
                        if (label) {
                            accessibleInputText = label;
                        } else {
                            accessibleInputText = accessibleName;
                        }
                        var classes = {
                            "selectable-tile": true,
                            "selectable-tile--active": checked,
                            "selectable-tile--disabled": inactive,
                            "selectable-tile--error": error,
                            "selectable-tile--focused": _isFocused
                        };
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", classes);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                            onclick: this._onclick
                        }, !inactive));
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                            style: "width: ".concat(width, "px; height: ").concat(height, "px;")
                        }, width && height));
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                            style: "width: 100%;"
                        }, !(width && height) && fullWidth));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "selectable-tile__label-wrap");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("label");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("for", "input-".concat(id));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "selectable-tile__label");
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                            onclick: this._onLabelClick
                        }, !inactive));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-hidden", "true");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("label");
                        _renderArbitrary(label);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("label");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "selectable-tile__icon-wrap");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("input");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "input-".concat(id));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("type", "checkbox");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "selectable-tile__input");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("disabled-prop", inactive);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("checked", checked);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-checked", checked);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-label", accessibleInputText);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-describedby", "tile-".concat(id));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-invalid", error);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                            onblur: this._onblur,
                            onfocus: this._onfocus,
                            onkeydown: this._onkeydown,
                            onmouseover: this._onmouseover
                        }, !inactive));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("input");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("input");
                        _renderArbitrary(variant === "radio" ? (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "radio-button__outer-circle", "aria-hidden", "true"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "radio-button__inner-circle"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div"), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")) : (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "selectable-tile__icon", "innerHTML-prop", MDS.svgs["ico_checkmark"], "aria-hidden", "true", "__skip", "true"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        _renderArbitrary(!!accessibleName && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "selectable-tile__accessible-text"), 
                        _renderArbitrary(accessibleName), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "selectable-tile__content", "id", "tile-".concat(id));
                        _renderArbitrary(contentArea ? (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "id", "content-".concat(id), "innerHTML-prop", contentArea, "__skip", "true"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")) : Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "name", "selectable-tile-content"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return MdsSelectableTile;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_selectable_tile_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsSelectableTile;
        },
        "./src/selectable-tile/mds-selectable-tile.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/selectable-tile/mds-selectable-tile.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/skeleton-loader/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _abstract_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/abstract-modal/index.jsx");
            var _mds_skeleton_loader_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/skeleton-loader/mds-skeleton-loader.scss");
            var _mds_skeleton_loader_scss__WEBPACK_IMPORTED_MODULE_3___default = __webpack_require__.n(_mds_skeleton_loader_scss__WEBPACK_IMPORTED_MODULE_3__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _this = undefined, _dec, _class, _class2;
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            var arrayOf = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].arrayOf, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].boolean, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].enumerables, number = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].number, string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].stringRequired;
            var entity = {
                isAnimated: boolean.defaultsTo(true),
                accessibleIsLoadingText: string,
                accessibleHasLoadedText: string,
                variant: enumerables(stringRequired, "list", "content-block", "image-and-content"),
                suppressedVisualShapes: arrayOf(boolean),
                height: number
            };
            var isModal = function isModal(el) {
                _newArrowCheck(this, _this);
                return el.dataset.isMdsModalRenderTarget || el instanceof _abstract_modal__WEBPACK_IMPORTED_MODULE_2__["default"];
            }.bind(undefined);
            var MdsSkeletonLoader = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsSkeletonLoader, _AgaveComponent);
                function MdsSkeletonLoader() {
                    _classCallCheck(this, MdsSkeletonLoader);
                    return _possibleConstructorReturn(this, _getPrototypeOf(MdsSkeletonLoader).apply(this, arguments));
                }
                _createClass(MdsSkeletonLoader, [ {
                    key: "_renderRectangle",
                    value: function _renderRectangle(width, hidden, zeroMargin) {
                        var _rectClasses;
                        var rectClasses = (_rectClasses = {
                            "skeleton-loader__rectangle": true
                        }, _defineProperty(_rectClasses, "skeleton-loader__rectangle-width".concat(width), true), 
                        _defineProperty(_rectClasses, "skeleton-loader__rectangle--hidden", hidden), _defineProperty(_rectClasses, "skeleton-loader__rectangle--zero-margin", zeroMargin), 
                        _defineProperty(_rectClasses, "skeleton-loader__rectangle--no-animation", !this.isAnimated), 
                        _rectClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", rectClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "skeleton-loader__shape-animate");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "skeleton-loader__shape-animate__inner");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "_renderCircle",
                    value: function _renderCircle() {
                        var circleClasses = {
                            "skeleton-loader__circle": true,
                            "skeleton-loader__circle--no-animation": !this.isAnimated
                        };
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", circleClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "skeleton-loader__shape-animate");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "skeleton-loader__shape-animate__inner");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "_templateList",
                    value: function _templateList() {
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "skeleton-loader__template-list");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "skeleton-loader__template-list-heading-wrapper");
                        _renderArbitrary(this._renderRectangle(40, this.suppressedVisualShapes && this.suppressedVisualShapes[0], true));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "skeleton-loader__template-list-wrapper");
                        _renderArbitrary(this._renderRectangle(30, this.suppressedVisualShapes && this.suppressedVisualShapes[1]));
                        _renderArbitrary(this._renderRectangle(36, this.suppressedVisualShapes && this.suppressedVisualShapes[2]));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "skeleton-loader__template-list-wrapper");
                        _renderArbitrary(this._renderRectangle(36, this.suppressedVisualShapes && this.suppressedVisualShapes[3]));
                        _renderArbitrary(this._renderRectangle(30, this.suppressedVisualShapes && this.suppressedVisualShapes[4]));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "_templateContentBlock",
                    value: function _templateContentBlock() {
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "skeleton-loader__template-content-block");
                        _renderArbitrary(this._renderRectangle(95));
                        _renderArbitrary(this._renderRectangle(70, this.suppressedVisualShapes && this.suppressedVisualShapes[1]));
                        _renderArbitrary(this._renderRectangle(35, this.suppressedVisualShapes && this.suppressedVisualShapes[2]));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "_templateImageAndContent",
                    value: function _templateImageAndContent() {
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "skeleton-loader__template-image-and-content");
                        _renderArbitrary(this._renderCircle());
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "skeleton-loader__template-image-and-content-wrapper");
                        _renderArbitrary(this._renderRectangle(100, this.suppressedVisualShapes && this.suppressedVisualShapes[1]));
                        _renderArbitrary(this._renderRectangle(70, this.suppressedVisualShapes && this.suppressedVisualShapes[2]));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "fadeOut",
                    value: function fadeOut() {
                        var _this2 = this;
                        var visualShapes = this.shadowRoot.querySelectorAll(".skeleton-loader__rectangle, .skeleton-loader__circle");
                        visualShapes.forEach(function(shape) {
                            _newArrowCheck(this, _this2);
                            return shape.classList.add("fadeout");
                        }.bind(this));
                    }
                }, {
                    key: "_renderLiveRegion",
                    value: function _renderLiveRegion() {
                        if (!this._liveRegionRenderTarget) {
                            var _this$_isInModal = this._isInModal(), isInModal = _this$_isInModal.isInModal, modal = _this$_isInModal.modal, modalSlot = _this$_isInModal.modalSlot;
                            this._liveRegionRenderTarget = modalSlot || document.body;
                            this._liveRegionId = isInModal ? "mds-skeleton-loader-live-region-".concat(modal.id) : "mds-skeleton-loader-live-region";
                        }
                        if (!document.getElementById(this._liveRegionId)) {
                            var liveRegion = document.createElement("div");
                            liveRegion.id = this._liveRegionId;
                            liveRegion.setAttribute("aria-live", "polite");
                            liveRegion.setAttribute("aria-atomic", "true");
                            liveRegion.setAttribute("style", "clip: rect(0.0625rem, 0.0625rem, 0.0625rem, 0.0625rem); position: absolute !important; padding: 0 !important; border: 0 !important; height: 0.0625rem !important; width: 0.0625rem !important; overflow: hidden;");
                            this._liveRegionRenderTarget.appendChild(liveRegion);
                        }
                    }
                }, {
                    key: "_isInModal",
                    value: function _isInModal() {
                        var el = this;
                        var prevEl = this;
                        while (el && el.tagName !== "BODY") {
                            if (isModal(el)) {
                                return {
                                    isInModal: true,
                                    modal: el,
                                    modalSlot: prevEl
                                };
                            }
                            prevEl = el;
                            el = el.parentElement;
                        }
                        return {
                            isInModal: false
                        };
                    }
                }, {
                    key: "readAccessibleIsLoadingText",
                    value: function readAccessibleIsLoadingText() {
                        var _this3 = this;
                        var liveRegion = document.getElementById(this._liveRegionId);
                        var message = document.createElement("span");
                        message.innerHTML = this.accessibleIsLoadingText;
                        liveRegion.appendChild(message);
                        setTimeout(function() {
                            _newArrowCheck(this, _this3);
                            liveRegion.removeChild(message);
                        }.bind(this), 4e3);
                    }
                }, {
                    key: "readAccessibleHasLoadedText",
                    value: function readAccessibleHasLoadedText() {
                        var _this4 = this;
                        var liveRegion = document.getElementById(this._liveRegionId);
                        var message = document.createElement("span");
                        message.innerHTML = this.accessibleHasLoadedText;
                        liveRegion.appendChild(message);
                        setTimeout(function() {
                            _newArrowCheck(this, _this4);
                            liveRegion.removeChild(message);
                        }.bind(this), 4e3);
                        this.fadeOut();
                    }
                }, {
                    key: "render",
                    value: function render() {
                        this._renderLiveRegion();
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "skeleton-loader");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-hidden", "true");
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["conditionalAttribute"])({
                            style: "height: ".concat(this.height, "px;")
                        }, this.height));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                        _renderArbitrary(this.variant === "image-and-content" && this._templateImageAndContent());
                        _renderArbitrary(this.variant === "content-block" && this._templateContentBlock());
                        _renderArbitrary(this.variant === "list" && this._templateList());
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ], [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsSkeletonLoader";
                    }
                } ]);
                return MdsSkeletonLoader;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_skeleton_loader_scss__WEBPACK_IMPORTED_MODULE_3___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsSkeletonLoader;
        },
        "./src/skeleton-loader/mds-skeleton-loader.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/skeleton-loader/mds-skeleton-loader.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/skip-link/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_skip_link_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/skip-link/mds-skip-link.scss");
            var _mds_skip_link_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_skip_link_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _utils_dom_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/dom-utils.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            var _li$wrapper = function _li$wrapper(_utils$noHref, _link$label, _this$skipToLink, _link$target, _this$expandSkipLinks, _this$collapseSkipLin) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("li", null, null, "class", "skip-link__item");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-link", null, null, "href", _utils$noHref, "text", _link$label, "onclick", _this$skipToLink, "data-target", _link$target, "onfocus", _this$expandSkipLinks, "onblur", _this$collapseSkipLin);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("li");
            };
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].stringRequired, satisfies = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].satisfies, arrayOf = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].arrayOf, string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string;
            var linkEntity = {
                label: stringRequired,
                target: stringRequired
            };
            var entity = {
                skipTo: string.defaultsTo("Skip to:"),
                links: arrayOf(satisfies(linkEntity)).withMinLength(1)
            };
            var MdsSkipLink = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsSkipLink, _AgaveComponent);
                _createClass(MdsSkipLink, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsSkipLink";
                    }
                } ]);
                function MdsSkipLink() {
                    var _this;
                    _classCallCheck(this, MdsSkipLink);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsSkipLink).call(this));
                    _this.skipToLink = _this.skipToLink.bind(_assertThisInitialized(_this));
                    _this.expandSkipLinks = _this.expandSkipLinks.bind(_assertThisInitialized(_this));
                    _this.collapseSkipLinks = _this.collapseSkipLinks.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsSkipLink, [ {
                    key: "skipToLink",
                    value: function skipToLink(e) {
                        var skipLinkTarget = document.querySelector(e.target.dataset.target);
                        skipLinkTarget.focus();
                        skipLinkTarget.scrollIntoView(skipLinkTarget.getBoundingClientRect().top >= this.getBoundingClientRect().top);
                    }
                }, {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                            index: 0
                        };
                        return {
                            interactiveElement: this.shadowRoot.querySelectorAll("mds-link")[payload.index]
                        };
                    }
                }, {
                    key: "expandSkipLinks",
                    value: function expandSkipLinks() {
                        this.shadowRoot.querySelector(".skip-link__container").className = "skip-link__container skip-link__container--expanded";
                    }
                }, {
                    key: "collapseSkipLinks",
                    value: function collapseSkipLinks(e) {
                        var skipLinkContainer = this.shadowRoot.querySelector(".skip-link__container");
                        !skipLinkContainer.contains(e.detail.relatedTarget) && (skipLinkContainer.className = "skip-link__container skip-link__container--collapsed");
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var _this2 = this;
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "skip-link__container");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("ul", null, null, "class", "skip-link");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("li", null, null, "class", "skip-link__item");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span");
                        _renderArbitrary(this.skipTo);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("li");
                        _renderArbitrary(this.links && this.links.map(function(link) {
                            _newArrowCheck(this, _this2);
                            return _jsxWrapper(_li$wrapper, [ _utils_dom_utils__WEBPACK_IMPORTED_MODULE_3__["default"].noHref, link.label, this.skipToLink, link.target, this.expandSkipLinks, this.collapseSkipLinks ]);
                        }.bind(this)));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("ul");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return MdsSkipLink;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_skip_link_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsSkipLink;
        },
        "./src/skip-link/mds-skip-link.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/skip-link/mds-skip-link.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/slide-in-panel/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_slide_in_panel_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/slide-in-panel/mds-slide-in-panel.scss");
            var _mds_slide_in_panel_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_slide_in_panel_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _abstract_modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/abstract-modal/index.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_allowLists__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/allowLists.js");
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            var _stickyFooter$wrapper = function _stickyFooter$wrapper(_stickyButtons2, _isMobile, _stickyFooterClasses, _this$_handleExitConf) {
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-sticky-footer", null, null, "id", "confirmation-sticky-buttons", "sticky-footer-buttons", _stickyButtons2, "show-box-shadow", _isMobile, "stick-to-parent-container", "true", "horizontal-layout", "true", "class", _stickyFooterClasses, "onkeydown", _this$_handleExitConf);
            };
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].stringRequired, number = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].number, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].enumerables, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].boolean;
            function updateButtons() {
                this._stickyButtons = JSON.stringify([ {
                    text: this.exitConfirmationOkayButtonLabel,
                    variant: "primary"
                }, {
                    text: this.exitConfirmationCancelButtonLabel,
                    variant: "secondary"
                } ]);
            }
            var entity = _objectSpread({
                titleText: stringRequired.withHTML(_utils_allowLists__WEBPACK_IMPORTED_MODULE_5__["base"]),
                subtitle: string.withHTML(_utils_allowLists__WEBPACK_IMPORTED_MODULE_5__["base"]),
                icon: enumerables.apply(void 0, [ string ].concat(_toConsumableArray(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["ICON_TYPES"]))),
                widthType: enumerables(string, "extraSmall", "small", "large").defaultsTo("large"),
                accessibleCloseLabelText: string.defaultsTo("close"),
                accessibleBackLabelText: string.defaultsTo("back"),
                backIcon: boolean.defaultsTo(false),
                headingLevel: number.defaultsTo(2),
                triggerId: stringRequired,
                backTriggerId: string,
                hideHeader: boolean,
                exitConfirmationOkayButtonLabel: string.withChangedCallback(updateButtons),
                exitConfirmationCancelButtonLabel: string.withChangedCallback(updateButtons),
                exitConfirmationRequired: boolean.defaultsTo(false),
                exitConfirmationAlertTitle: string,
                exitConfirmationAlertMessage: string,
                exitConfirmationAlertAccessibleTextIcon: string,
                exitConfirmationContentWidth: number
            }, _abstract_modal__WEBPACK_IMPORTED_MODULE_3__["entity"]);
            var MdsSlideInPanel = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AbstractModal) {
                _inherits(MdsSlideInPanel, _AbstractModal);
                _createClass(MdsSlideInPanel, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsSlideInPanel";
                    }
                } ]);
                function MdsSlideInPanel() {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsSlideInPanel);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsSlideInPanel).call(this, [ "panelContent" ], "slide-in-panel"));
                    _this.defineObservedProperty("_isScrolled", false);
                    _this.defineObservedProperty("_isTransitioningOut", true);
                    _this.defineObservedProperty("_isExitConfirmationVisible", false);
                    _this._addShadowOnScroll = _this._addShadowOnScroll.bind(_assertThisInitialized(_this));
                    _this._back = _this._back.bind(_assertThisInitialized(_this));
                    _this._closeOnEsc = _this._closeOnEsc.bind(_assertThisInitialized(_this));
                    _this._clickCancel = _this._clickCancel.bind(_assertThisInitialized(_this));
                    _this._clickConfirm = _this._clickConfirm.bind(_assertThisInitialized(_this));
                    _this.close = _this.close.bind(_assertThisInitialized(_this));
                    _this._preventFocusChangeOnMainPanelScrollBarClick = _this._preventFocusChangeOnMainPanelScrollBarClick.bind(_assertThisInitialized(_this));
                    _this._dispatchCloseEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "click-close-button";
                    }.bind(this), _assertThisInitialized(_this));
                    _this.focusHeading = _this.focusHeading.bind(_assertThisInitialized(_this));
                    _this._handleExitConfirmationKeydown = _this._handleExitConfirmationKeydown.bind(_assertThisInitialized(_this));
                    _this._dispatchBackEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "click-back-button";
                    }.bind(this), _assertThisInitialized(_this));
                    _this._dispatchSlideInEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "slideIn";
                    }.bind(this), _assertThisInitialized(_this));
                    _this._dispatchSlideOutEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "slideOut";
                    }.bind(this), _assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsSlideInPanel, [ {
                    key: "_focusOnRender",
                    value: function _focusOnRender() {
                        var _this3 = this;
                        window.setTimeout(function() {
                            _newArrowCheck(this, _this3);
                            if (this.open) {
                                this._dispatchSlideInEvent({
                                    target: "heading"
                                });
                            }
                            this.focus.bind(this, {
                                target: "heading"
                            });
                            this.focus({
                                target: "heading"
                            });
                        }.bind(this), 350);
                    }
                }, {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                            target: null
                        };
                        var target = payload && payload.target;
                        if (this._isExitConfirmationVisible) {
                            if (target === "confirm-exit" || target === "cancel-exit") {
                                return {
                                    interactiveElement: this.open ? this._stickyFooter : null,
                                    nextPayload: {
                                        target: target === "confirm-exit" ? "button1" : "button2"
                                    }
                                };
                            }
                            return {
                                interactiveElement: this.open && this._renderTarget.shadowRoot.getElementById("confirmation-alert")
                            };
                        }
                        var targetId = "".concat(this.id, "-heading");
                        if (target === "back-button" || target === "close-button") {
                            targetId = "".concat(this.id, "-").concat(target);
                        }
                        return {
                            interactiveElement: this.open && this._renderTarget.shadowRoot.getElementById(targetId)
                        };
                    }
                }, {
                    key: "focusHeading",
                    value: function focusHeading() {
                        console.warn("the ref.focusHeading() method is deprecated. Use ref.focus({ target: 'heading'}) instead");
                        this.focus({
                            target: "heading"
                        });
                    }
                }, {
                    key: "_focusOnTab",
                    value: function _focusOnTab() {
                        if (!this._isExitConfirmationVisible) {
                            var target = "heading";
                            if (!this.hideHeader) {
                                target = this.backIcon ? "back-button" : "close-button";
                            }
                            this.focus({
                                target: target
                            });
                        }
                    }
                }, {
                    key: "disconnectedCallback",
                    value: function disconnectedCallback() {
                        _get(_getPrototypeOf(MdsSlideInPanel.prototype), "disconnectedCallback", this) && _get(_getPrototypeOf(MdsSlideInPanel.prototype), "disconnectedCallback", this).call(this);
                        this._detachModal();
                    }
                }, {
                    key: "_handleExitConfirmationKeydown",
                    value: function _handleExitConfirmationKeydown(event) {
                        var stickyFooter = this._stickyFooter;
                        if (event.detail.keyCode === 9) {
                            var target = stickyFooter.shadowRoot.activeElement.id === this._focusableNodes[0].id ? "confirm-exit" : "cancel-exit";
                            event.detail.preventDefault();
                            this.focus({
                                target: target
                            });
                        }
                    }
                }, {
                    key: "_closeOnEsc",
                    value: function _closeOnEsc(event) {
                        this.modalTrapped && !this._isExitConfirmationVisible && Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["isEscAndShouldClose"])(event) && this.close(event);
                    }
                }, {
                    key: "close",
                    value: function close() {
                        var _this4 = this;
                        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        if (this.exitConfirmationRequired) {
                            if (this._isExitConfirmationVisible) {
                                if (event.target && event.target.id === "backdrop") {
                                    return;
                                }
                                window.setTimeout(function() {
                                    _newArrowCheck(this, _this4);
                                    this._isExitConfirmationVisible = false;
                                }.bind(this), 250);
                                this.open = false;
                                this._dispatchCloseEvent(event);
                                this._dispatchSlideOutEvent(event);
                            } else {
                                this.showExitConfirmation();
                            }
                        } else {
                            this.open = false;
                            this._dispatchCloseEvent(event);
                            this._dispatchSlideOutEvent(event);
                        }
                    }
                }, {
                    key: "_back",
                    value: function _back(event) {
                        var _this5 = this;
                        this._dispatchBackEvent(event);
                        setTimeout(function() {
                            _newArrowCheck(this, _this5);
                            if (!this.backTriggerId) {
                                this.focus({
                                    target: "heading"
                                });
                                return;
                            }
                            var element = this._renderTarget.querySelector("#".concat(this.backTriggerId)) || this._renderTarget.shadowRoot.getElementById(this.backTriggerId);
                            if (element && typeof element.focus === "function") {
                                element.focus();
                            } else {
                                this.focus({
                                    target: "heading"
                                });
                            }
                        }.bind(this), 300);
                    }
                }, {
                    key: "showExitConfirmation",
                    value: function showExitConfirmation() {
                        if (this.exitConfirmationRequired) {
                            this._isExitConfirmationVisible = true;
                            this._focusableNodes = _toConsumableArray(this._stickyFooter.shadowRoot.querySelectorAll("mds-button"));
                        }
                    }
                }, {
                    key: "_detachModal",
                    value: function _detachModal() {
                        var _this6 = this;
                        this._isTransitioningOut = true;
                        document.body.removeEventListener("keyup", this._closeOnEsc);
                        window.setTimeout(function() {
                            _newArrowCheck(this, _this6);
                            _get(_getPrototypeOf(MdsSlideInPanel.prototype), "_detachModal", this).call(this);
                            this._isScrolled = false;
                        }.bind(this), 250);
                    }
                }, {
                    key: "_attachModal",
                    value: function _attachModal() {
                        var _this7 = this;
                        _get(_getPrototypeOf(MdsSlideInPanel.prototype), "_attachModal", this).call(this);
                        document.body.addEventListener("keyup", this._closeOnEsc);
                        this._renderTarget.shadowRoot.querySelector(".mds-slide-in-panel").setAttribute("style", "top: ".concat(window.scrollY, "px;"));
                        window.setTimeout(function() {
                            _newArrowCheck(this, _this7);
                            this._isTransitioningOut = false;
                        }.bind(this), 10);
                    }
                }, {
                    key: "_addShadowOnScroll",
                    value: function _addShadowOnScroll(event) {
                        this._isScrolled = event.target.scrollTop > 0;
                    }
                }, {
                    key: "_renderIcon",
                    value: function _renderIcon(type) {
                        var iconType = type === "close" ? "ico_close" : "ico_chevron_left";
                        var label = type === "close" ? this.accessibleCloseLabelText : this.accessibleBackLabelText;
                        var eventHandlerName = type === "close" ? "close" : "_back";
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("button", null, null, "onclick", this[eventHandlerName], "class", "mds-slide-in-panel__icon-button mds-slide-in-panel__icon-button--".concat(type), "aria-label", label, "type", "button", "id", "".concat(this.id, "-").concat(type, "-button"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "id", "".concat(this.id, "-").concat(type), "innerHTML-prop", MDS.svgs[iconType], "class", "mds-slide-in-panel__icon", "aria-hidden", "true", "__skip", "true");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("button");
                    }
                }, {
                    key: "_renderHeader",
                    value: function _renderHeader() {
                        var titleText = this.titleText, subtitle = this.subtitle, icon = this.icon, id = this.id, _isScrolled = this._isScrolled, backIcon = this.backIcon, headingLevel = this.headingLevel;
                        var classes = {
                            header: {
                                "mds-slide-in-panel__header-container": true,
                                "mds-slide-in-panel__header-container--scrolled": _isScrolled
                            },
                            heading: {
                                "mds-slide-in-panel__heading": true,
                                "mds-slide-in-panel__heading--with-subtitle": !!subtitle
                            }
                        };
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes.header);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "mds-slide-in-panel__header-top-border");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "mds-slide-in-panel__header");
                        _renderArbitrary(backIcon && this._renderIcon("back"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "mds-slide-in-panel__title-container");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "mds-slide-in-panel__heading-container");
                        _renderArbitrary(icon && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "mds-slide-in-panel__heading-icon", "innerHTML-prop", MDS.svgs[icon], "aria-hidden", "true", "__skip", "true"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "tabIndex", "-1", "role", "heading", "aria-level", headingLevel, "id", "".concat(id, "-heading"), "class", classes.heading, "innerHTML-prop", titleText, "__skip", "true");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        _renderArbitrary(subtitle && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("p", null, null, "class", "mds-slide-in-panel__subtitle", "innerHTML-prop", subtitle, "__skip", "true"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("p")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        _renderArbitrary(this._renderIcon("close"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "_clickConfirm",
                    value: function _clickConfirm(event) {
                        var _this8 = this;
                        if (Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this8);
                            return "click-confirm-exit";
                        }.bind(this), this, true)(event)) {
                            this.close();
                        }
                    }
                }, {
                    key: "_clickCancel",
                    value: function _clickCancel(event) {
                        var _this9 = this;
                        if (Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this9);
                            return "click-cancel-exit";
                        }.bind(this), this, true)(event)) {
                            this._isExitConfirmationVisible = false;
                            setTimeout(function() {
                                _newArrowCheck(this, _this9);
                                this.focus({
                                    target: "heading"
                                });
                            }.bind(this), 200);
                        }
                    }
                }, {
                    key: "_preventFocusChangeOnMainPanelScrollBarClick",
                    value: function _preventFocusChangeOnMainPanelScrollBarClick(e) {
                        if (this._isClickInMainPanel(e) && this._isClickOnScrollBar(e)) {
                            e.preventDefault();
                        }
                    }
                }, {
                    key: "_isClickInMainPanel",
                    value: function _isClickInMainPanel(e) {
                        return e.target.tagName.toLowerCase() === "div" && e.target.classList.contains("mds-slide-in-panel__main");
                    }
                }, {
                    key: "_isClickOnScrollBar",
                    value: function _isClickOnScrollBar(e) {
                        var rect = e.target.getBoundingClientRect();
                        var x = e.clientX - rect.left;
                        return e.target.clientWidth <= x && x < rect.width;
                    }
                }, {
                    key: "renderedCallback",
                    value: function renderedCallback(prop) {
                        var _this10 = this;
                        if (prop === "_isExitConfirmationVisible" && this._isExitConfirmationVisible) {
                            var stickyFooter = this._stickyFooter;
                            var stickyFooterHeight = stickyFooter.offsetHeight + 40;
                            var alert = this._renderTarget.shadowRoot.getElementById("confirmation-alert");
                            this._panelContainer = this._panelContainer || this._renderTarget.shadowRoot.querySelector(".mds-slide-in-panel__panel-container div");
                            var panelContainerHeight = this._panelContainer.offsetHeight;
                            this._panelContainerChild = this._panelContainerChild || this._renderTarget.shadowRoot.querySelector(".mds-slide-in-panel__alert-container").parentNode;
                            if (panelContainerHeight + stickyFooterHeight >= window.innerHeight) {
                                this._panelContainerChild.style.padding = "0 0 ".concat(stickyFooterHeight, "px 0");
                                this._panelContainer.style.justifyContent = "flex-start";
                                this._panelContainer.style.overflowY = "auto";
                            } else {
                                this._panelContainerChild.style.padding = "";
                                this._panelContainer.style.justifyContent = "";
                                this._panelContainer.style.overflowY = "";
                            }
                            stickyFooter.addEventListener("click-button1", this._clickConfirm);
                            stickyFooter.addEventListener("click-button2", this._clickCancel);
                            setTimeout(function() {
                                _newArrowCheck(this, _this10);
                                alert.focus();
                            }.bind(this), 200);
                        }
                    }
                }, {
                    key: "_renderExitConfirmation",
                    value: function _renderExitConfirmation() {
                        var exitConfirmationAlertTitle = this.exitConfirmationAlertTitle, exitConfirmationAlertMessage = this.exitConfirmationAlertMessage, exitConfirmationAlertAccessibleTextIcon = this.exitConfirmationAlertAccessibleTextIcon, _stickyButtons = this._stickyButtons, exitConfirmationContentWidth = this.exitConfirmationContentWidth;
                        var isMobile = MDS.isMobile || Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["getBreakpoint"])() === "xs";
                        var stickyFooterClasses = {
                            "mds-slide-in-panel__sticky-footer": true,
                            "mds-slide-in-panel__sticky-footer--mobile": isMobile
                        };
                        var stickyFooter = _jsxWrapper(_stickyFooter$wrapper, [ _stickyButtons, !!isMobile, stickyFooterClasses, this._handleExitConfirmationKeydown ]);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "mds-slide-in-panel__panel-container mds-slide-in-panel__panel-container--exit-confirmation");
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["conditionalAttribute"])({
                            role: "alertdialog",
                            "aria-label": exitConfirmationAlertTitle
                        }, !MDS.isSafari));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "mds-slide-in-panel__alert-container");
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["conditionalAttribute"])({
                            style: `width: ${exitConfirmationContentWidth}px`
                        }, !!exitConfirmationContentWidth));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-alert", null, null, "id", "confirmation-alert", "variant", "soft", "full-width", "true", "alert-title", exitConfirmationAlertTitle, "message", exitConfirmationAlertMessage, "accessible-text-icon", exitConfirmationAlertAccessibleTextIcon);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        _renderArbitrary(!isMobile && stickyFooter);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        _renderArbitrary(isMobile && stickyFooter);
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "_renderPanelContents",
                    value: function _renderPanelContents() {
                        var hideHeader = this.hideHeader, headingLevel = this.headingLevel, id = this.id, titleText = this.titleText;
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "mds-slide-in-panel__panel-container", "role", "dialog", "aria-labelledby", "".concat(id, "-heading"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "mds-slide-in-panel__main", "onScroll", this._addShadowOnScroll, "onmousedown", this._preventFocusChangeOnMainPanelScrollBarClick);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "mds-slide-in-panel__main-content");
                        _renderArbitrary(hideHeader ? (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "tabIndex", "-1", "role", "heading", "aria-level", headingLevel, "id", "".concat(id, "-heading"), "class", "accessible-text", "innerHTML-prop", titleText, "__skip", "true"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")) : this._renderHeader());
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "mds-slide-in-panel__main-content_wrapper", "tabIndex", "0", "role", "region", "aria-labelledby", "".concat(id, "-heading"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "name", "panelContent");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var _rootClasses;
                        var widthType = this.widthType, _isTransitioningOut = this._isTransitioningOut, _isExitConfirmationVisible = this._isExitConfirmationVisible;
                        var rootClasses = (_rootClasses = {
                            "mds-slide-in-panel": true
                        }, _defineProperty(_rootClasses, "mds-slide-in-panel--".concat(widthType), true), 
                        _defineProperty(_rootClasses, "mds-slide-in-panel--slide-out", _isTransitioningOut), 
                        _rootClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", rootClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "mds-slide-in-panel__backdrop", "id", "backdrop", "onclick", this.close);
                        _renderArbitrary(_isExitConfirmationVisible ? this._renderExitConfirmation() : this._renderPanelContents());
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "_stickyFooter",
                    get: function get() {
                        return this._renderTarget.shadowRoot.getElementById("confirmation-sticky-buttons");
                    }
                } ]);
                return MdsSlideInPanel;
            }(_abstract_modal__WEBPACK_IMPORTED_MODULE_3__["default"]), _class2.styles = _mds_slide_in_panel_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsSlideInPanel;
        },
        "./src/slide-in-panel/mds-slide-in-panel.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/slide-in-panel/mds-slide-in-panel.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/slider/MdsSlider.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_dom_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/dom-utils.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _this = undefined;
            var _span$wrapper = function _span$wrapper(_class) {
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("span", null, null, "class", _class);
            }, _span$wrapper2 = function _span$wrapper2(_class2) {
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("span", null, null, "class", _class2);
            }, _span$wrapper3 = function _span$wrapper3(_class3) {
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("span", null, null, "class", _class3);
            }, _span$wrapper4 = function _span$wrapper4(_tickLabel, _el$endingValue) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", _tickLabel, "aria-hidden", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(" ");
                _renderArbitrary(_el$endingValue);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(" ");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            }, _span$wrapper5 = function _span$wrapper5(_tickLabel2, _child) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", _tickLabel2, "aria-hidden", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(" ");
                _renderArbitrary(_child);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(" ");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            };
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            var bemify = _utils_dom_utils__WEBPACK_IMPORTED_MODULE_1__["default"].bemify;
            var renderMicropy = function renderMicropy(el) {
                _newArrowCheck(this, _this);
                var microcopyClass = "slider__microcopy";
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", microcopyClass, "style", "margin-left: ".concat(el.leadingLabelWidth, "%; margin-right:").concat(el.leadingLabelWidth, "%; "), "aria-hidden", "true", "id", "".concat(el.id, "-microcopy"));
                _renderArbitrary(el.microcopy);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            }.bind(undefined);
            var renderRangeTrack = function renderRangeTrack(el, classes, track) {
                var _this2 = this;
                _newArrowCheck(this, _this);
                var percent = (el.trailingSelectedValue - el.leadingSelectedValue) / (el.endingValue - el.startingValue) * 100;
                var trackWidth = el.shadowRoot.getElementById("".concat(el.id, "-input-container")).offsetWidth;
                var left = (el.leadingSelectedValue - el.startingValue) / (el.endingValue - el.startingValue) * trackWidth;
                var elid = "".concat(el.id, "-track");
                var trackSegment = 100 / el.numIntervals;
                var tickWidth = Number("4px".replace(/px$/, ""));
                var segmentLength = (trackWidth - ((el.numIntervals + 1) * tickWidth + tickWidth / 2)) / el.numIntervals;
                var total = 0;
                var selectedTrack = Array.from(track).map(function(segment, index) {
                    var _this3 = this;
                    _newArrowCheck(this, _this2);
                    if (index === 0) {
                        total += tickWidth;
                        return segment;
                    }
                    var classTrack = segment.args[0];
                    var selected = classTrack === "slider__track-segment" ? "slider__track-segment--selected" : "slider__track-tick--selected";
                    total += classTrack === "slider__track-segment" ? segmentLength : tickWidth;
                    if (total > left && percent > 0) {
                        segment.args[0] = selected;
                        percent = classTrack === "slider__track-segment" ? percent - trackSegment : percent;
                    } else {
                        segment.args = segment.args.filter(function(e) {
                            _newArrowCheck(this, _this3);
                            return e !== selected;
                        }.bind(this));
                    }
                    return segment;
                }.bind(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes.segmentContainer, "id", elid);
                _renderArbitrary(selectedTrack);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }.bind(undefined);
            var renderTrack = function renderTrack(el, classes) {
                _newArrowCheck(this, _this);
                var segment = "slider__track-segment";
                var trackTick = "slider__track-tick";
                var track = [];
                var elid = "".concat(el.id, "-track");
                track.push(_jsxWrapper(_span$wrapper, [ el.sliderType === "single" ? "".concat(trackTick, "--selected") : trackTick ]));
                for (var i = 0; i < el.numIntervals; i++) {
                    var selected = el.sliderType === "single" && (i + 1) * ((el.endingValue - el.startingValue) / el.numIntervals) + el.startingValue <= el.selectedValue;
                    track.push(_jsxWrapper(_span$wrapper2, [ selected ? "".concat(segment, "--selected") : segment ]));
                    track.push(_jsxWrapper(_span$wrapper3, [ selected ? "".concat(trackTick, "--selected") : trackTick ]));
                }
                if (el.sliderType === "range") {
                    return renderRangeTrack(el, classes, track);
                }
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes.segmentContainer, "id", elid);
                _renderArbitrary(track);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }.bind(undefined);
            var renderTicks = function renderTicks(el) {
                _newArrowCheck(this, _this);
                var ticks = [];
                var step = Math.round((el.endingValue - el.startingValue) / el.numRangeLabelIntervals);
                var tickLabel = "slider__tick-label";
                for (var i = 0; i <= el.numRangeLabelIntervals; i++) {
                    if (i === el.numRangeLabelIntervals) {
                        ticks.push(_jsxWrapper(_span$wrapper4, [ tickLabel, el.endingValue ]));
                    } else {
                        ticks.push(_jsxWrapper(_span$wrapper5, [ tickLabel, step * i + el.startingValue ]));
                    }
                }
                var classesDefn = "".concat(tickLabel, "s");
                var styleDefn = "width:".concat(el.trackWidth, "%;\n      margin-left: ").concat(el.leadingLabelWidth, "%;\n      margin-right:").concat(el.trailingLabelWidth, "%;");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classesDefn, "style", styleDefn);
                _renderArbitrary(ticks);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }.bind(undefined);
            var getIcon = function getIcon(el, side) {
                _newArrowCheck(this, _this);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "slider__icon", "innerHTML-prop", MDS.svgs[el["".concat(side, "Icon")]], "aria-hidden", "true", "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            }.bind(undefined);
            var getLabel = function getLabel(el, label, classes, side) {
                _newArrowCheck(this, _this);
                var leadingTrailingLabel = "slider__leading-trailing-label";
                var labelIconContainer = "slider__label-icon-container";
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", leadingTrailingLabel, "aria-hidden", "true");
                _renderArbitrary((el.leadingIcon || el.leadingIcon) && getIcon(el, side));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", labelIconContainer, "aria-hidden", "true");
                _renderArbitrary(label);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }.bind(undefined);
            var renderAlert = function renderAlert(el) {
                _newArrowCheck(this, _this);
                var alertId = "".concat(el.id, "--editable-alert");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "id", alertId, "class", "slider__editable-alert", "role", "alert");
                _renderArbitrary(el._msg);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            }.bind(undefined);
            var getTextInput = function getTextInput(el, classes, ids, valuePrefix, valueSuffix, side) {
                var _this4 = this;
                _newArrowCheck(this, _this);
                var place = side || "";
                var inputId = "".concat(el.id, "-number-input");
                var value = el.selectedValue;
                var editable = "slider__editable";
                if (side) {
                    value = side === "leading" ? el.leadingSelectedValue : el.trailingSelectedValue;
                    inputId += "--".concat(side);
                }
                var inputSideId = "".concat(el.id, "-input--").concat(side);
                var renderInputSide = function renderInputSide() {
                    _newArrowCheck(this, _this4);
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "id", inputSideId, "class", classes.accessibleText, "aria-hidden", "true");
                    _renderArbitrary(place);
                    return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                }.bind(this);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "".concat(editable, "-container"));
                _renderArbitrary(renderAlert(el));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "aria-hidden", "true");
                _renderArbitrary(valuePrefix);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("input");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("inputMode", "numeric");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("type", "number");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", editable);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", inputId);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("name", inputId);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("step", el._steps);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("min", el.startingValue);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("max", el.endingValue);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("placeholder", value);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("value", value);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-side", place);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-describedby", ids.sliderAccessibleDescription);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-labelledby", "".concat(inputSideId, " ").concat(ids.labelName));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("disabled-prop", el.states === "disabled");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-invalid", "false");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-required", "true");
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["conditionalAttribute"])({
                    onchange: el._handleInputChange,
                    onblur: el._handleInputBlur,
                    onfocus: el._handleInputFocus,
                    oninput: el._handleInputInput,
                    onclick: el._onclick
                }, el.states !== "disabled"));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("input");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("input");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "".concat(editable, "-suffix"), "aria-hidden", "true", "id", "".concat(el.id, "-title"));
                _renderArbitrary(valueSuffix);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                _renderArbitrary(side && renderInputSide());
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            }.bind(undefined);
            var getLabelValues = function getLabelValues(el, ids, editable, classes, side) {
                _newArrowCheck(this, _this);
                if (el.sliderType === "single") {
                    if (el.selectedValueDescriptors) {
                        var _el$selectedValueDesc = el.selectedValueDescriptors, _el$selectedValueDesc2 = _el$selectedValueDesc.valuePrefix, valuePrefix = _el$selectedValueDesc2 === void 0 ? "" : _el$selectedValueDesc2, _el$selectedValueDesc3 = _el$selectedValueDesc.valueSuffix, valueSuffix = _el$selectedValueDesc3 === void 0 ? "" : _el$selectedValueDesc3;
                        if (el.isSelectedValueEditable && editable) {
                            return getTextInput(el, classes, ids, valuePrefix, valueSuffix);
                        }
                        return "".concat(valuePrefix).concat(el.selectedValue).concat(valueSuffix);
                    }
                    if (el.isSelectedValueEditable && editable) {
                        return getTextInput(el, classes, ids, "", "");
                    }
                    if (el.labels && el.numIntervals) {
                        var selectedStep = (el.selectedValue - el.startingValue) / el._steps;
                        return el.labels[selectedStep] ? "".concat(el.labels[selectedStep]) : "".concat(el.selectedValue);
                    }
                    if (el.numIntervals === 0 && el.customLabel) {
                        return "".concat(el.customLabel);
                    }
                    return "".concat(el.selectedValue);
                }
                var rangeSeparator = " ".concat(el.accessibleRangeSeparator);
                if (el.selectedValueDescriptors) {
                    var _el$selectedValueDesc4 = el.selectedValueDescriptors, _el$selectedValueDesc5 = _el$selectedValueDesc4.minValuePrefix, minValuePrefix = _el$selectedValueDesc5 === void 0 ? "" : _el$selectedValueDesc5, _el$selectedValueDesc6 = _el$selectedValueDesc4.maxValuePrefix, maxValuePrefix = _el$selectedValueDesc6 === void 0 ? "" : _el$selectedValueDesc6, _el$selectedValueDesc7 = _el$selectedValueDesc4.minValueSuffix, minValueSuffix = _el$selectedValueDesc7 === void 0 ? "" : _el$selectedValueDesc7, _el$selectedValueDesc8 = _el$selectedValueDesc4.maxValueSuffix, maxValueSuffix = _el$selectedValueDesc8 === void 0 ? "" : _el$selectedValueDesc8;
                    if (el.isSelectedValueEditable && editable) {
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "slider__range-textInput-container");
                        _renderArbitrary(getTextInput(el, classes, ids, minValuePrefix, minValueSuffix, "leading"));
                        _renderArbitrary(rangeSeparator);
                        _renderArbitrary(getTextInput(el, classes, ids, maxValuePrefix, maxValueSuffix, "trailing"));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                    if (side) {
                        var position = side === "leading" ? "min" : "max";
                        return "".concat(el.selectedValueDescriptors["".concat(position, "ValuePrefix")]).concat(el["".concat(side, "SelectedValue")]).concat(el.selectedValueDescriptors["".concat(position, "ValueSuffix")]);
                    }
                    return "".concat(minValuePrefix).concat(el.leadingSelectedValue).concat(minValueSuffix, "\n    ").concat(el.accessibleRangeSeparator, " ").concat(maxValuePrefix).concat(el.trailingSelectedValue).concat(maxValueSuffix);
                }
                if (el.isSelectedValueEditable && editable) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "slider__range-textInput-container");
                    _renderArbitrary(getTextInput(el, classes, ids, "", "", "leading"));
                    _renderArbitrary(rangeSeparator);
                    _renderArbitrary(getTextInput(el, classes, ids, "", "", "trailing"));
                    return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                }
                if (side) {
                    return "".concat(el["".concat(side, "SelectedValue")]);
                }
                return "".concat(el.leadingSelectedValue, " ").concat(el.accessibleRangeSeparator, " ").concat(el.trailingSelectedValue);
            }.bind(undefined);
            var renderLabelContainer = function renderLabelContainer(el, classes, ids) {
                _newArrowCheck(this, _this);
                var label = "".concat(el.sliderLabel, ": ");
                var valuesLabel = " ".concat(el.selectedValuesLabel);
                var labelContainer = "slider__label-container";
                var accessibleLabel = "".concat(el.sliderLabel, ":").concat(getLabelValues(el, ids, false, classes), " ").concat(el.selectedValuesLabel);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", labelContainer, "style", "margin-left: ".concat(el.leadingLabelWidth, "%; margin-right:").concat(el.trailingLabelWidth, "%; "));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", classes.labelName, "aria-hidden", "true");
                _renderArbitrary(label);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "id", ids.labelName, "class", classes.labelValue, "aria-hidden", !el.isSelectedValueEditable);
                _renderArbitrary(el.isSelectedValueEditable ? getLabelValues(el, ids, true, classes) : getLabelValues(el, ids, false, classes));
                _renderArbitrary(el.selectedValuesLabel && valuesLabel);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "id", ids.labelValue, "class", "slider__accessible-text");
                _renderArbitrary(accessibleLabel);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }.bind(undefined);
            var getEventProps = function getEventProps(el, classes, className) {
                _newArrowCheck(this, _this);
                if (el.inactive) {
                    return {};
                }
                if (className === classes.inputContainer) {
                    return MDS.isMobile ? {
                        ontouchstart: el._handleBarPress
                    } : {
                        onmousedown: el._handleBarPress
                    };
                }
                return MDS.isMobile ? {
                    ontouchstart: el._handleThumbPress
                } : {
                    onmousedown: el._handleThumbPress,
                    onclick: el._onclick
                };
            }.bind(undefined);
            var renderSingleSlider = function renderSingleSlider(el, classes, ids) {
                var _this5 = this;
                _newArrowCheck(this, _this);
                var inactive = el.states === "disabled";
                var singleSliderIds = {
                    input: "".concat(el.id, "-single-input"),
                    inputContainer: "".concat(el.id, "-input-container"),
                    progressBar: "".concat(el.id, "-progress-bar")
                };
                var ariaValueText = "".concat(getLabelValues(el, ids, false, classes));
                var renderProgressBar = function renderProgressBar(barWidth) {
                    _newArrowCheck(this, _this5);
                    return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "id", singleSliderIds.progressBar, "class", "slider__progress-bar", "style", "width:".concat(barWidth, "%"));
                }.bind(this);
                var barWidth = (el.selectedValue - el.startingValue) * 100 / (el.endingValue - el.startingValue);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", singleSliderIds.inputContainer);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", classes.inputContainer);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("style", "width:".concat(el.trackWidth, "%"));
                _spreadAttribute(getEventProps(el, classes, classes.inputContainer));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes.trackContainer);
                _renderArbitrary(el.numIntervals === 0 && renderProgressBar(barWidth));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("input", null, null, "id", singleSliderIds.input, "class", classes.input, "type", "range", "value-prop", el.selectedValue, "value", el.selectedValue, "valuemap-prop", "selectedValue", "min", el.startingValue, "max", el.endingValue, "step", el._steps, "disabled-prop", inactive, "aria-describedby", "".concat(ids.sliderAccessibleDescription, " ").concat(el.id, "-microcopy"), "aria-labelledby", ids.labelName, "aria-valuetext", ariaValueText, "aria-valuemin", el.startingValue, "aria-valuemax", el.endingValue, "aria-valuenow", el.selectedValue, "onmouseup", function(e) {
                    _newArrowCheck(this, _this5);
                    return e.target.blur();
                }.bind(this), "oninput", el._syncSingleSliderValue, "onchange", el._syncSingleSliderValue, "onclick", el._onclick, "onfocus", el._focusThumb, "onblur", el._blurThumb);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "slider__pseudo-track");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "".concat(el.id, "-pseudo-thumb"));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "slider__pseudo-thumb");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("valuemap-prop", "selectedValue");
                _spreadAttribute(getEventProps(el, classes));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-side", "_input");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                _renderArbitrary(el.numIntervals > 0 && renderTrack(el, classes));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                _renderArbitrary(el.microcopy && renderMicropy(el));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }.bind(undefined);
            var renderRangeSlider = function renderRangeSlider(el, classes, ids) {
                var _this6 = this;
                _newArrowCheck(this, _this);
                var inactive = el.states === "disabled";
                var inputContainerId = "".concat(el.id, "-input-container");
                var getInputId = function getInputId(side) {
                    _newArrowCheck(this, _this6);
                    return "".concat(el.id, "-").concat(side, "-input");
                }.bind(this);
                var getInputClass = function getInputClass(side) {
                    _newArrowCheck(this, _this6);
                    return "slider__input slider__input--".concat(side, " slider__").concat(el.sliderType);
                }.bind(this);
                var pseudoClasses = function pseudoClasses(element, side) {
                    var _ref;
                    _newArrowCheck(this, _this6);
                    return _ref = {}, _defineProperty(_ref, "slider__pseudo-".concat(element), true), 
                    _defineProperty(_ref, "slider__pseudo-".concat(element, "--activated"), !el.inactive), 
                    _defineProperty(_ref, "slider__pseudo-".concat(element, "--disabled"), el.inactive), 
                    _defineProperty(_ref, "slider__pseudo-".concat(element, "--intervals"), el.numIntervals > 0), 
                    _defineProperty(_ref, "slider__pseudo-thumb--".concat(side), side), _ref;
                }.bind(this);
                var pseudoRangeId = "".concat(el.id, "-pseudo-range");
                var pseudoTrackId = "".concat(el.id, "-pseudo-track");
                var getPseudoThumbId = function getPseudoThumbId(side) {
                    _newArrowCheck(this, _this6);
                    return "".concat(el.id, "-pseudo-thumb-").concat(side);
                }.bind(this);
                var getAccessibleText = function getAccessibleText(side) {
                    _newArrowCheck(this, _this6);
                    return "  ".concat(getLabelValues(el, ids, false, classes, side));
                }.bind(this);
                var renderInputSide = function renderInputSide(side) {
                    _newArrowCheck(this, _this6);
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "id", "".concat(el.id, "-thumb--").concat(side), "class", classes.accessibleText, "aria-hidden", "true");
                    _renderArbitrary("".concat(side, ",  ").concat(getLabelValues(el, ids, false, classes)));
                    return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                }.bind(this);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", classes.inputContainer);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("style", "width: ".concat(el.trackWidth, "%"));
                _spreadAttribute(getEventProps(el, classes, classes.inputContainer));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "slider__track-container slider__track-container--range", "id", inputContainerId);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("input", null, null, "id", getInputId("min"), "class", getInputClass("leading"), "type", "range", "value-prop", el.leadingSelectedValue, "aria-valuetext", getAccessibleText("leading"), "aria-labelledby", "".concat(el.id, "-thumb--leading ").concat(ids.labelName), "aria-describedby", "".concat(ids.sliderAccessibleDescription, " ").concat(el.id, "-microcopy"), "aria-valuemin", el.startingValue, "aria-valuemax", el.endingValue, "aria-valuenow", el.leadingSelectedValue, "min", el.startingValue, "max", el.endingValue, "step", el._steps, "disabled-prop", inactive, "onchange", el._syncRangeSliderValues, "oninput", el._syncRangeSliderValues, "onmousedown", el.preventDefault, "ontouchstart", el.preventDefault, "onclick", el.preventDefault, "onfocus", el._focusThumb, "onblur", el._blurThumb, "data-side", "min");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("input", null, null, "id", getInputId("max"), "class", getInputClass("trailing"), "type", "range", "value-prop", el.trailingSelectedValue, "aria-valuetext", getAccessibleText("trailing"), "aria-labelledby", "".concat(el.id, "-thumb--trailing ").concat(ids.labelName), "aria-describedby", "".concat(ids.sliderAccessibleDescription, " ").concat(el.id, "-microcopy"), "aria-valuemin", el.startingValue, "aria-valuemax", el.endingValue, "aria-valuenow", el.trailingSelectedValue, "min", el.startingValue, "max", el.endingValue, "step", el._steps, "disabled-prop", inactive, "onchange", el._syncRangeSliderValues, "oninput", el._syncRangeSliderValues, "onmousedown", el.preventDefault, "ontouchstart", el.preventDefault, "onclick", el.preventDefault, "onfocus", el._focusThumb, "onblur", el._blurThumb, "data-side", "max");
                _renderArbitrary(el.numIntervals > 0 && renderTrack(el, classes));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "id", pseudoRangeId, "class", pseudoClasses("range"));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "id", pseudoTrackId, "class", pseudoClasses("track"));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", getPseudoThumbId("min"));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", pseudoClasses("thumb", "min"));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("valuemap-prop", "leadingSelectedValue");
                _spreadAttribute(getEventProps(el, classes));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-side", "_minInput");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", getPseudoThumbId("max"));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", pseudoClasses("thumb", "max"));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("valuemap-prop", "trailingSelectedValue");
                _spreadAttribute(getEventProps(el, classes));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-side", "_maxInput");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                _renderArbitrary(renderInputSide("leading"));
                _renderArbitrary(renderInputSide("trailing"));
                _renderArbitrary(el.microcopy && renderMicropy(el));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }.bind(undefined);
            var renderSlider = function renderSlider(el, classes, ids) {
                _newArrowCheck(this, _this);
                return el.sliderType === "single" ? renderSingleSlider(el, classes, ids) : renderRangeSlider(el, classes, ids);
            }.bind(undefined);
            var renderNarrow = function renderNarrow(el, classes, ids) {
                _newArrowCheck(this, _this);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div");
                _renderArbitrary(el.numRangeLabelIntervals > 0 && renderTicks(el));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes.valueContainer);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "id", ids.labelName, "class", classes.labelName, "aria-hidden", "true", "style", "width: ".concat(el.leadingLabelWidth, "%"));
                _renderArbitrary("".concat(el.sliderLabel, ":"));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                _renderArbitrary(el.sliderType && renderSlider(el, classes, ids));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "aria-hidden", !el.isSelectedValueEditable, "class", classes.labelValue, "style", "width: ".concat(el.trailingLabelWidth, "%"));
                _renderArbitrary(el.isSelectedValueEditable ? getLabelValues(el, ids, true, classes) : getLabelValues(el, ids, false, classes));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }.bind(undefined);
            var renderSliderNormal = function renderSliderNormal(el, classes, ids) {
                _newArrowCheck(this, _this);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div");
                _renderArbitrary(renderLabelContainer(el, classes, ids));
                _renderArbitrary(el.numRangeLabelIntervals > 0 && renderTicks(el));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes.valueContainer);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes.valueMin, "aria-hidden", "true", "style", "width: ".concat(el.leadingLabelWidth, "%"));
                _renderArbitrary(getLabel(el, el.leadingLabel, classes, "leading"));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                _renderArbitrary(el.sliderType && renderSlider(el, classes, ids));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes.valueMax, "aria-hidden", "true", "style", "width: ".concat(el.trailingLabelWidth, "%"));
                _renderArbitrary(getLabel(el, el.trailingLabel, classes, "trailing"));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }.bind(undefined);
            var renderNarrowType = function renderNarrowType(el, classes, ids) {
                _newArrowCheck(this, _this);
                if (el.narrow) {
                    return renderNarrow(el, classes, ids);
                }
                return renderSliderNormal(el, classes, ids);
            }.bind(undefined);
            var renderSliderDescription = function renderSliderDescription(el, classes, ids) {
                _newArrowCheck(this, _this);
                var accessibleSteps = el.numIntervals > 0 ? ", ".concat(el.accessibleInterval, " ").concat(el._steps) : "";
                var accessibleText = "".concat(el.accessibleRangePremodifier, " ").concat(el.accessibleMin, " ").concat(el.startingValue, ",\n    ").concat(el.accessibleMax, " ").concat(el.endingValue).concat(accessibleSteps);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "id", ids.sliderAccessibleDescription, "class", classes.accessibleText, "aria-hidden", "true");
                _renderArbitrary(accessibleText);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            }.bind(undefined);
            function MdsSlider(el) {
                var _componentContainer, _input;
                var inactive = el.states === "disabled";
                var bem = bemify("slider");
                var classes = {
                    accessibleText: bem({
                        el: "accessible-text"
                    }),
                    componentContainer: (_componentContainer = {
                        slider: true
                    }, _defineProperty(_componentContainer, "slider--".concat(el.sliderType), true), 
                    _defineProperty(_componentContainer, "slider--narrow", el.narrow), _defineProperty(_componentContainer, "slider--disabled", inactive), 
                    _defineProperty(_componentContainer, "".concat(el.classes), el.classes), _defineProperty(_componentContainer, "slider--segment", el.numIntervals > 0), 
                    _defineProperty(_componentContainer, "slider--editable", el.isSelectedValueEditable), 
                    _componentContainer),
                    input: (_input = {
                        slider__input: true
                    }, _defineProperty(_input, "slider__".concat(el.sliderType), true), _defineProperty(_input, "slider__".concat(el.sliderType, "--disabled"), inactive), 
                    _defineProperty(_input, "slider__".concat(el.sliderType, "--active"), !inactive && el.selectedValue > el.minValue), 
                    _input),
                    inputContainer: [ bem({
                        el: "input-container"
                    }), bem({
                        el: "input-container",
                        mod: el.sliderType
                    }) ],
                    labelValue: bem({
                        el: "label-value"
                    }),
                    labelName: bem({
                        el: "label-name"
                    }),
                    valueContainer: bem({
                        el: "data-value-container"
                    }),
                    valueMin: [ bem({
                        el: "data-value"
                    }), bem({
                        el: "data-value",
                        mod: "min"
                    }) ],
                    valueMax: [ bem({
                        el: "data-value"
                    }), bem({
                        el: "data-value",
                        mod: "max"
                    }) ],
                    trackContainer: bem({
                        el: "track-container"
                    }),
                    segmentContainer: bem({
                        el: "segment-container"
                    }),
                    editable: bem({
                        el: "editable"
                    })
                };
                var ids = {
                    labelName: "".concat(el.id, "-label-name"),
                    labelValue: "".concat(el.id, "-label-value"),
                    sliderAccessibleDescription: "".concat(el.id, "-slider-description")
                };
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes.componentContainer, "onclick", _utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["stopPropagation"]);
                _renderArbitrary(renderNarrowType(el, classes, ids));
                _renderArbitrary(renderSliderDescription(el, classes, ids));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            __webpack_exports__["default"] = MdsSlider;
        },
        "./src/slider/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_slider_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/slider/mds-slider.scss");
            var _mds_slider_scss__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_slider_scss__WEBPACK_IMPORTED_MODULE_1__);
            var _MdsSlider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/slider/MdsSlider.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            var string = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].stringRequired, number = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].number, numberRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].numberRequired, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].boolean, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].enumerables, array = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].array;
            function updateInputValues() {
                if (this._input) this._input.value = this.selectedValue;
                if (this._minInput) this._minInput.value = this.leadingSelectedValue;
                if (this._maxInput) this._maxInput.value = this.trailingSelectedValue;
            }
            function styleCallbackController() {
                this.sliderType === "single" ? singleSliderStyleCallback.call(this) : rangeSliderStyleCallback.call(this);
            }
            function singleSliderStyleCallback() {
                this._enforceValueRange();
                if (this._input) {
                    this._totalSteps = (this.endingValue - this.startingValue) / this._steps;
                }
                if (this._sliderTextInput) {
                    this._sliderTextInput.value = this.selectedValue;
                }
                if (this._singleSelectedThumb && this._totalSteps) {
                    this._updatePseudoElementStyles();
                }
                updateInputValues.call(this);
            }
            function rangeSliderStyleCallback(newValue, oldValue, property) {
                this._totalSteps = (this.endingValue - this.startingValue) / this._steps;
                this._enforceValueRange(property);
                if (this._minThumb && this._totalSteps) {
                    this._updatePseudoElementStyles();
                }
                this._defaultPosition = this.leadingSelectedValue === this.startingValue && this.trailingSelectedValue === this.endingValue;
                updateInputValues.call(this);
            }
            function enforceWidthConstraint() {
                var _this = this;
                setTimeout(function() {
                    var _this2 = this;
                    _newArrowCheck(this, _this);
                    if (this.trackWidth !== 60 || this.leadingLabelWidth !== 20 || this.trailingLabelWidth !== 20) {
                        var total = this.trackWidth + this.leadingLabelWidth + this.trailingLabelWidth;
                        if (total > 100) {
                            this.setState({
                                trackWidth: 60,
                                leadingLabelWidth: 20,
                                trailingLabelWidth: 20
                            }).then(function() {
                                _newArrowCheck(this, _this2);
                                this.throwConstraintError("The sum of trackWidth, leadingLabelWidth and trailingLabelWidth must be less than or equal to 100. Their total is ".concat(total, "."));
                            }.bind(this));
                        }
                    }
                }.bind(this));
            }
            var entity = {
                sliderType: enumerables(string, "range", "single").defaultsTo("single"),
                sliderLabel: stringRequired,
                selectedValuesLabel: stringRequired,
                numIntervals: number.defaultsTo(0).withChangedCallback(),
                startingValue: numberRequired,
                endingValue: numberRequired,
                selectedValue: number.withChangedCallback(singleSliderStyleCallback),
                leadingSelectedValue: number.withChangedCallback(rangeSliderStyleCallback),
                trailingSelectedValue: number.withChangedCallback(rangeSliderStyleCallback),
                leadingLabel: string,
                trailingLabel: string,
                leadingLabelWidth: number.defaultsTo(20).withChangedCallback(enforceWidthConstraint),
                trailingLabelWidth: number.defaultsTo(20).withChangedCallback(enforceWidthConstraint),
                trackWidth: number.defaultsTo(60).withChangedCallback(enforceWidthConstraint),
                leadingIcon: string,
                trailingIcon: string,
                microcopy: string,
                numRangeLabelIntervals: number,
                narrow: boolean.defaultsTo(false),
                accessibleValueText: string,
                states: enumerables(string, "disabled", ""),
                isSelectedValueEditable: boolean.defaultsTo(false).withChangedCallback(),
                accessibleInput: string.defaultsTo("edit slider number"),
                accessibleSliderPremodifier: string.defaultsTo("Slider value"),
                accessibleRangeSeparator: string.defaultsTo("to"),
                accessibleSliderValue: string.defaultsTo(""),
                accessibleRangePremodifier: string.defaultsTo("Slider range"),
                accessibleMin: string.defaultsTo("minimum"),
                accessibleMax: string.defaultsTo("maximum"),
                accessibleInterval: string.defaultsTo("increments of"),
                accessibleErrorAdjust: string.defaultsTo("Slider value adjusted to"),
                accessibleErrorNearest: string.defaultsTo("the nearest valid"),
                inputSize: number.defaultsTo(3),
                labels: array,
                customLabel: string
            };
            var MdsSlider = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsSlider, _AgaveComponent);
                _createClass(MdsSlider, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsSlider";
                    }
                } ]);
                function MdsSlider() {
                    var _this4 = this;
                    var _this3;
                    _classCallCheck(this, MdsSlider);
                    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(MdsSlider).call(this));
                    _this3._syncSingleSliderValue = _this3._syncSingleSliderValue.bind(_assertThisInitialized(_this3));
                    _this3._syncRangeSliderValues = _this3._syncRangeSliderValues.bind(_assertThisInitialized(_this3));
                    _this3._handleThumbPress = _this3._handleThumbPress.bind(_assertThisInitialized(_this3));
                    _this3._handleBarPress = _this3._handleBarPress.bind(_assertThisInitialized(_this3));
                    _this3._moveThumb = _this3._moveThumb.bind(_assertThisInitialized(_this3));
                    _this3._activateThumb = _this3._activateThumb.bind(_assertThisInitialized(_this3));
                    _this3._releaseThumb = _this3._releaseThumb.bind(_assertThisInitialized(_this3));
                    _this3.styleCallbackController = styleCallbackController.bind(_assertThisInitialized(_this3));
                    _this3.brandChangedCallback = _this3.styleCallbackController;
                    _this3._onfocus = _this3._onfocus.bind(_assertThisInitialized(_this3));
                    _this3._onclick = _this3._onclick.bind(_assertThisInitialized(_this3));
                    _this3._onblur = _this3._onblur.bind(_assertThisInitialized(_this3));
                    _this3._handleInputInput = _this3._handleInputInput.bind(_assertThisInitialized(_this3));
                    _this3._focusThumb = _this3._focusThumb.bind(_assertThisInitialized(_this3));
                    _this3._blurThumb = _this3._blurThumb.bind(_assertThisInitialized(_this3));
                    _this3._handleInputBlur = _this3._handleInputBlur.bind(_assertThisInitialized(_this3));
                    _this3._handleInputChange = _this3._handleInputChange.bind(_assertThisInitialized(_this3));
                    _this3._handleInputFocus = _this3._handleInputFocus.bind(_assertThisInitialized(_this3));
                    _this3._changeSliderInput = _this3._changeSliderInput.bind(_assertThisInitialized(_this3));
                    _this3.preventDefault = _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["preventDefault"];
                    _this3._steps = 1;
                    _this3.defineObservedProperty("_msg");
                    _this3._dispatchEventChange = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this4);
                        return "change";
                    }.bind(this), _assertThisInitialized(_this3));
                    _this3._dispatchEventInput = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this4);
                        return "input";
                    }.bind(this), _assertThisInitialized(_this3));
                    _this3._dispatchEventThumbBlur = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this4);
                        return "blur-thumb";
                    }.bind(this), _assertThisInitialized(_this3));
                    _this3._dispatchEventThumbFocus = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this4);
                        return "focus-thumb";
                    }.bind(this), _assertThisInitialized(_this3));
                    return _this3;
                }
                _createClass(MdsSlider, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsSlider.prototype), "connectedCallback", this).call(this);
                        if (this.sliderType === "range") {
                            this._minThumb = this.shadowRoot.getElementById("".concat(this.id, "-pseudo-thumb-min"));
                            this._maxThumb = this.shadowRoot.getElementById("".concat(this.id, "-pseudo-thumb-max"));
                            this._pseudoRange = this.shadowRoot.getElementById("".concat(this.id, "-pseudo-range"));
                            this._minInput = this.shadowRoot.getElementById("".concat(this.id, "-min-input"));
                            this._maxInput = this.shadowRoot.getElementById("".concat(this.id, "-max-input"));
                            this._track = this.shadowRoot.getElementById("".concat(this.id, "-input-container"));
                            this._leadingSliderTextInput = this.shadowRoot.getElementById("".concat(this.id, "-number-input--leading"));
                            this._trailingSliderTextInput = this.shadowRoot.getElementById("".concat(this.id, "-number-input--trailing"));
                        } else {
                            this._input = this.shadowRoot.getElementById("".concat(this.id, "-single-input"));
                            this._singleSelectedThumb = this.shadowRoot.getElementById("".concat(this.id, "-pseudo-thumb"));
                            this._progressBar = this.shadowRoot.getElementById("".concat(this.id, "-progress-bar"));
                            this._input.disabled = this.states === "disabled";
                            this._sliderTextInput = this.shadowRoot.getElementById("".concat(this.id, "-number-input"));
                        }
                        this._inactive = this.states === "disabled";
                        styleCallbackController.call(this);
                        this._invalidFlag = false;
                        this._sliderTextInput && this._changeSliderInput();
                        this._leadingSliderTextInput && this._changeSliderInput("leading");
                        this._trailingSliderTextInput && this._changeSliderInput("trailing");
                        window.addEventListener("resize", this.styleCallbackController);
                    }
                }, {
                    key: "disconnectedCallback",
                    value: function disconnectedCallback() {
                        _get(_getPrototypeOf(MdsSlider.prototype), "disconnecedCallback", this) && _get(_getPrototypeOf(MdsSlider.prototype), "disconnectedCallback", this).call(this);
                        window.removeEventListener("resize", this.styleCallbackController);
                    }
                }, {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        if (!payload.target) {
                            return {
                                interactiveElement: this.shadowRoot.querySelector(".slider__input")
                            };
                        }
                        return _get(_getPrototypeOf(MdsSlider.prototype), "_getInteractiveElement", this).call(this, {
                            target: "".concat(this.id, "-").concat(payload.target, "-input")
                        });
                    }
                }, {
                    key: "isSelectedValueEditableChangedCallback",
                    value: function isSelectedValueEditableChangedCallback() {
                        var _this5 = this;
                        if (this.isSelectedValueEditable) {
                            if (this.sliderType === "range") {
                                setTimeout(function() {
                                    _newArrowCheck(this, _this5);
                                    this._leadingSliderTextInput = this.shadowRoot.getElementById("".concat(this.id, "-number-input--leading"));
                                    this._trailingSliderTextInput = this.shadowRoot.getElementById("".concat(this.id, "-number-input--trailing"));
                                }.bind(this));
                            }
                        }
                    }
                }, {
                    key: "numIntervalsChangedCallback",
                    value: function numIntervalsChangedCallback() {
                        if (!this.endingValue || !this.selectedValue && !this.leadingSelectedValue) {
                            return;
                        }
                        if (this.numIntervals >= this.endingValue - this.startingValue) {
                            this.throwConstraintError("Number of intervals should be smaller than ending value.");
                        }
                        this._steps = Math.round((this.endingValue - this.startingValue) / this.numIntervals);
                        if (this.numIntervals === 1) {
                            this.selectedValue = this.startingValue;
                        }
                        styleCallbackController.call(this);
                    }
                }, {
                    key: "_syncSingleSliderValue",
                    value: function _syncSingleSliderValue(event) {
                        var _this6 = this;
                        var detail = {
                            value: this.selectedValue
                        };
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this6);
                            return event.type;
                        }.bind(this), this)(event, detail);
                        event.stopPropagation();
                        this.selectedValue = event.target.value;
                        if (this._sliderTextInput) {
                            this._sliderTextInput.value = this.selectedValue;
                            this._sliderTextInput.placeholder = this.selectedValue;
                        }
                    }
                }, {
                    key: "_getLength",
                    value: function _getLength(selected, valTarget) {
                        var valLen = selected < 100 ? this.inputSize : selected.toString().length;
                        if (valTarget && valTarget > valLen) {
                            valLen = valTarget;
                        }
                        return "".concat((valLen + 1) * 10 + 8, "px");
                    }
                }, {
                    key: "_changeSliderInput",
                    value: function _changeSliderInput(side, valTarget) {
                        var selected = this.selectedValue;
                        var length = "";
                        if (side === "leading" || side === "trailing") {
                            selected = this["".concat(side, "SelectedValue")];
                            length = this._getLength(selected, valTarget);
                            this["_".concat(side, "SliderTextInput")].style.width = length;
                        }
                        if (this._sliderTextInput) {
                            length = this._getLength(selected, valTarget);
                            this._sliderTextInput.style.width = length;
                        }
                    }
                }, {
                    key: "_syncRangeSliderValues",
                    value: function _syncRangeSliderValues(event, target) {
                        var _this7 = this;
                        var currentTarget = target || event.currentTarget;
                        var valueTarget = target ? target.value : event.target.value;
                        var detail = {
                            value: valueTarget
                        };
                        if (currentTarget === this._input) {
                            this.selectedValue = valueTarget;
                            detail.selectedValue = "selectedValue";
                            if (this._sliderTextInput) {
                                this._sliderTextInput.value = valueTarget;
                            }
                        } else if (currentTarget === this._minInput) {
                            this.leadingSelectedValue = valueTarget;
                            detail.selectedValue = "leadingSelectedValue";
                            if (this._leadingSliderTextInput) {
                                this._leadingSliderTextInput.value = valueTarget;
                            }
                        } else {
                            this.trailingSelectedValue = valueTarget;
                            detail.selectedValue = "trailingSelectedValue";
                            if (this._trailingSliderTextInput) {
                                this._trailingSliderTextInput.value = valueTarget;
                            }
                        }
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this7);
                            return event.type;
                        }.bind(this), this)(event, detail);
                        event.stopPropagation();
                    }
                }, {
                    key: "_enforceValueRange",
                    value: function _enforceValueRange(property) {
                        if (this.sliderType === "single" && (this.selectedValue < this.startingValue || this.selectedValue > this.endingValue)) {
                            this.selectedValue = Math.min(this.endingValue, Math.max(this.startingValue, this.selectedValue));
                        } else if (this.sliderType === "range") {
                            if (this.leadingSelectedValue < this.startingValue) {
                                this.leadingSelectedValue = this.startingValue;
                            } else if (this.trailingSelectedValue > this.endingValue) {
                                this.trailingSelectedValue = this.endingValue;
                            } else if (property === "leadingSelectedValue" && this.leadingSelectedValue > this.trailingSelectedValue) {
                                this.trailingSelectedValue = this.leadingSelectedValue;
                                this._minInput.value = this._maxInput.value;
                                if (this._trailingSliderTextInput) {
                                    this._trailingSliderTextInput.value = this._maxInput.value;
                                }
                            } else if (property === "trailingSelectedValue" && this.trailingSelectedValue < this.leadingSelectedValue) {
                                this.leadingSelectedValue = this.trailingSelectedValue;
                                this._maxInput.value = this._minInput.value;
                                if (this._leadingSliderTextInput) {
                                    this._leadingSliderTextInput.value = this._minInput.value;
                                }
                            }
                        }
                    }
                }, {
                    key: "_checkInterval",
                    value: function _checkInterval(event, selectedValue) {
                        var targetValue = event.target.value;
                        if (targetValue) {
                            if (targetValue > this.endingValue) {
                                targetValue = this.endingValue;
                                this._invalidFlag = true;
                                return targetValue;
                            }
                            if (targetValue < this.startingValue) {
                                targetValue = this.startingValue;
                                this._invalidFlag = true;
                                return targetValue;
                            }
                        } else {
                            targetValue = this.selectedValue;
                        }
                        targetValue = parseInt(targetValue, 10);
                        if (this.numIntervals > 0) {
                            var intervalLength = this.endingValue / this.numIntervals;
                            var midpoint = intervalLength / 2;
                            var start = this.startingValue;
                            var end = start + intervalLength;
                            while (start <= targetValue) {
                                if (start + intervalLength < targetValue) {
                                    start += intervalLength;
                                    end += intervalLength;
                                } else {
                                    if (start === targetValue || start + intervalLength === targetValue) {
                                        this._invalidFlag = false;
                                    } else {
                                        this._invalidFlag = true;
                                    }
                                    break;
                                }
                            }
                            if (targetValue < start + midpoint) {
                                selectedValue = start;
                            } else {
                                selectedValue = end;
                            }
                        } else {
                            selectedValue = targetValue;
                        }
                        return selectedValue;
                    }
                }, {
                    key: "_enforceIntervals",
                    value: function _enforceIntervals(event) {
                        var selectedValue = 0;
                        var side = event.target.dataset.side;
                        if (side === "leading" || side === "trailing") {
                            selectedValue = this._checkInterval(event, this["".concat(side, "SelectedValue")]);
                            this["".concat(side, "SelectedValue")] = selectedValue;
                            this._changeSliderInput(side, selectedValue.length);
                        } else {
                            selectedValue = this._checkInterval(event, this.selectedValue);
                            this.selectedValue = selectedValue;
                            this._changeSliderInput("", selectedValue.length);
                        }
                        event.target.placeholder = selectedValue;
                        event.target.value = selectedValue;
                    }
                }, {
                    key: "_handleInputFocus",
                    value: function _handleInputFocus(event) {
                        this._onfocus(event);
                        event.target.select();
                    }
                }, {
                    key: "_getInputDetail",
                    value: function _getInputDetail(event) {
                        var detail = {
                            value: this.selectedValue
                        };
                        if (this.sliderType === "range") {
                            detail.value = this["".concat(event.target.dataset.side, "SelectedValue")];
                            detail.selectedSide = event.target.dataset.side;
                        }
                        event.stopPropagation();
                        return detail;
                    }
                }, {
                    key: "_handleInputInput",
                    value: function _handleInputInput(event) {
                        var valLen = event.target.value.length;
                        var side = event.target.dataset.side;
                        this._changeSliderInput(side, valLen);
                        var detail = this._getInputDetail(event);
                        event.type === "input" && this._dispatchEventInput(event, detail);
                    }
                }, {
                    key: "_handleInputChange",
                    value: function _handleInputChange(event) {
                        this._enforceIntervals(event);
                        event.target.select();
                        var detail = this._getInputDetail(event);
                        event.type === "change" && this._dispatchEventChange(event, detail);
                    }
                }, {
                    key: "_handleInputBlur",
                    value: function _handleInputBlur(event) {
                        this._onblur(event);
                        var side = event.target.dataset.side;
                        if (this._invalidFlag) {
                            if (side === "trailing" || side === "leading") {
                                this["_".concat(side, "SliderTextInput")].setAttribute("aria-invalid", "true");
                                this._msg = "".concat(this.accessibleErrorAdjust, " ").concat(this["".concat(side, "SelectedValue")], " ").concat(this.accessibleErrorNearest);
                            } else {
                                this._sliderTextInput.setAttribute("aria-invalid", "true");
                                this._msg = "".concat(this.accessibleErrorAdjust, " ").concat(this.selectedValue, " ").concat(this.accessibleErrorNearest);
                            }
                        }
                        if (side === "trailing" || side === "leading") {
                            this["_".concat(side, "SliderTextInput")].setAttribute("aria-invalid", "false");
                        } else {
                            this._sliderTextInput.setAttribute("aria-invalid", "false");
                        }
                        this._invalidFlag = false;
                    }
                }, {
                    key: "_updatePseudoElementStyles",
                    value: function _updatePseudoElementStyles() {
                        if (this.sliderType === "single") {
                            this._updateSinglePseudoElementStyles();
                            return;
                        }
                        var percentFilled = (this.trailingSelectedValue - this.leadingSelectedValue) / (this.endingValue - this.startingValue);
                        var leftPosition = (this.leadingSelectedValue - this.startingValue) / (this.endingValue - this.startingValue);
                        var rightPosition = (this.trailingSelectedValue - this.startingValue) / (this.endingValue - this.startingValue);
                        var thumbWidth = Number("24px".replace(/px$/, ""));
                        var adjustedInputWidth = this._minInput.offsetWidth - thumbWidth;
                        var stepWidth = adjustedInputWidth / this._totalSteps;
                        var leftThumbSteps = Math.round(leftPosition * adjustedInputWidth / stepWidth);
                        var rightThumbSteps = Math.round((leftPosition + percentFilled) * adjustedInputWidth / stepWidth);
                        this._minThumb.style.left = "".concat(leftThumbSteps * stepWidth + thumbWidth / 2 * leftPosition, "px");
                        this._maxThumb.style.left = "".concat(rightThumbSteps * stepWidth + thumbWidth / 2 * rightPosition, "px");
                        this._pseudoRange.style.width = "".concat(percentFilled * 100, "%");
                        this._pseudoRange.style.left = "".concat(leftPosition * 100, "%");
                    }
                }, {
                    key: "_updateSinglePseudoElementStyles",
                    value: function _updateSinglePseudoElementStyles() {
                        var leftPosition = (this.selectedValue - this.startingValue) / (this.endingValue - this.startingValue);
                        var thumbWidth = Number("24px".replace(/px$/, ""));
                        var adjustedInputWidth = this._input.offsetWidth - thumbWidth;
                        var stepWidth = adjustedInputWidth / this._totalSteps;
                        var thumbSteps = Math.round(leftPosition * adjustedInputWidth / stepWidth);
                        this._singleSelectedThumb.style.left = "".concat(thumbSteps * stepWidth + thumbWidth / 2 * leftPosition, "px");
                    }
                }, {
                    key: "_activateThumb",
                    value: function _activateThumb() {
                        var _this8 = this;
                        var inputPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._minInput.getBoundingClientRect();
                        this._inputPosition = inputPosition;
                        this._tempValue = this[this._selectedThumb.valuemap];
                        window.addEventListener("".concat(MDS.isMobile ? "touchmove" : "mousemove"), this._moveThumb);
                        window.addEventListener("".concat(MDS.isMobile ? "touchend" : "mouseup"), this._releaseThumb);
                        if (MDS.isFireFox) {
                            this._pseudoElementsActive = true;
                            if (this.sliderType === "range") {
                                [ this._minThumb, this._maxThumb ].forEach(function(thumb) {
                                    _newArrowCheck(this, _this8);
                                    return thumb.classList.add("slider__pseudo-thumb--activated");
                                }.bind(this));
                            } else {
                                this._singleSelectedThumb.classList.add("slider__pseudo-thumb--activated");
                            }
                            this.sliderType === "range" && this._pseudoRange.classList.add("slider__pseudo-range--activated");
                        }
                    }
                }, {
                    key: "_focusThumb",
                    value: function _focusThumb(event) {
                        this._dispatchEventThumbFocus(event);
                        var thumb = this._singleSelectedThumb;
                        if (this.sliderType === "range") {
                            var side = event.target.dataset.side;
                            thumb = this["_".concat(side, "Thumb")];
                        }
                        thumb.classList.add("slider__pseudo-thumb--focus");
                    }
                }, {
                    key: "_blurThumb",
                    value: function _blurThumb(event) {
                        this._dispatchEventThumbBlur(event);
                        var thumb = this._singleSelectedThumb;
                        if (this.sliderType === "range") {
                            var side = event.target.dataset.side;
                            thumb = this["_".concat(side, "Thumb")];
                        }
                        thumb.classList.remove("slider__pseudo-thumb--focus");
                    }
                }, {
                    key: "_releaseThumb",
                    value: function _releaseThumb() {
                        var _this9 = this;
                        if (this._tempValue !== this[this._selectedThumb.valuemap]) {
                            this._syncRangeSliderValues(new Event("change"), this[this._selectedThumb.dataset.side]);
                        }
                        window.removeEventListener("".concat(MDS.isMobile ? "touchmove" : "mousemove"), this._moveThumb);
                        window.removeEventListener("".concat(MDS.isMobile ? "touchend" : "mouseup"), this._releaseThumb);
                        if (MDS.isFireFox && this._defaultPosition) {
                            if (this.sliderType === "range") {
                                [ this._minThumb, this._maxThumb ].forEach(function(thumb) {
                                    _newArrowCheck(this, _this9);
                                    return thumb.classList.remove("slider__pseudo-thumb--activated");
                                }.bind(this));
                            } else {
                                this._singleSelectedThumb.classList.remove("slider__pseudo-thumb--activated");
                            }
                            this.sliderType === "range" && this._pseudoRange.classList.remove("slider__pseudo-range--activated");
                            this._pseudoElementsActive = false;
                        }
                    }
                }, {
                    key: "_handleThumbPress",
                    value: function _handleThumbPress(event) {
                        if (event.type === "mousedown" && event.button !== 0 || this._inactive) {
                            return false;
                        }
                        event.stopPropagation();
                        event.preventDefault();
                        if (this._minThumb && this.leadingSelectedValue === this.endingValue && this.trailingSelectedValue === this.endingValue) {
                            this._selectedThumb = this._minThumb;
                        } else if (this._maxThumb && this.leadingSelectedValue === this.startingValue && this.trailingSelectedValue === this.startingValue) {
                            this._selectedThumb = this._maxThumb;
                        } else {
                            this._selectedThumb = event.target;
                        }
                        this[this._selectedThumb.dataset.side].focus();
                        this._singleSelectedThumb ? this._activateThumb(this._input.getBoundingClientRect()) : this._activateThumb();
                        return null;
                    }
                }, {
                    key: "_handleBarPress",
                    value: function _handleBarPress(event) {
                        if (event.type === "mousedown" && event.button !== 0 || this._inactive) {
                            return false;
                        }
                        this._onclick();
                        event.preventDefault();
                        var selectionPoint = MDS.isMobile ? event.touches[0].clientX : event.clientX;
                        if (!this._singleSelectedThumb) {
                            var minThumbPosition = this._minThumb.getBoundingClientRect().left;
                            var maxThumbPosition = this._maxThumb.getBoundingClientRect().right;
                            this._selectedThumb = Math.abs(maxThumbPosition - selectionPoint) < Math.abs(minThumbPosition - selectionPoint) ? this._maxThumb : this._minThumb;
                        } else {
                            this._selectedThumb = this._singleSelectedThumb;
                        }
                        this._singleSelectedThumb ? this._activateThumb(this._input.getBoundingClientRect()) : this._activateThumb();
                        this._moveThumb(event);
                        return null;
                    }
                }, {
                    key: "_moveThumb",
                    value: function _moveThumb(event) {
                        var inputPosition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._inputPosition;
                        var selectionPoint = MDS.isMobile ? event.touches[0].clientX : event.clientX;
                        var selectedValuePercentage = (selectionPoint - inputPosition.left) / inputPosition.width;
                        var stepNumbers = this.numIntervals > 0 ? 0 : this.endingValue - this.startingValue - this._totalSteps;
                        var stepNumbersStartingValues = this.numIntervals > 0 ? this.startingValue : 0;
                        var selectedStepValue = Math.round(selectedValuePercentage * this._totalSteps) + stepNumbers;
                        var startingValues = this.numIntervals > 0 ? stepNumbersStartingValues : this.startingValue;
                        var selectedValue = selectedStepValue * ((this.endingValue - this.startingValue) / this._totalSteps) + startingValues;
                        if (selectedValue >= this.startingValue && selectedValue <= this.endingValue) {
                            if (this[this._selectedThumb.valuemap] !== selectedValue) {
                                this._syncRangeSliderValues(new Event("input"), this[this._selectedThumb.dataset.side]);
                            }
                            this[this._selectedThumb.valuemap] = selectedValue;
                            if (this.isSelectedValueEditable) {
                                if (this._selectedThumb.valuemap === "leadingSelectedValue") {
                                    this._leadingSliderTextInput.value = selectedValue;
                                } else {
                                    this._trailingSliderTextInput.value = selectedValue;
                                }
                            }
                        } else if (selectedValue > this.endingValue) {
                            this[this._selectedThumb.valuemap] = this.endingValue;
                        } else if (selectedValue < this.startingValue) {
                            this[this._selectedThumb.valuemap] = this.startingValue;
                        }
                    }
                }, {
                    key: "render",
                    value: function render() {
                        if (Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["isNonZeroFalsy"])(this.startingValue) || Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["isNonZeroFalsy"])(this.endingValue)) {
                            throw new Error("sliders starting/ending value should contain a number.");
                        }
                        Object(_MdsSlider__WEBPACK_IMPORTED_MODULE_2__["default"])(this);
                    }
                } ]);
                return MdsSlider;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_0___default.a), _class2.styles = _mds_slider_scss__WEBPACK_IMPORTED_MODULE_1___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsSlider;
        },
        "./src/slider/mds-slider.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/slider/mds-slider.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/status-block/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_status_block_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/status-block/mds-status-block.scss");
            var _mds_status_block_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_status_block_scss__WEBPACK_IMPORTED_MODULE_2__);
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].boolean, string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].stringRequired;
            var entity = {
                isAnimated: boolean.defaultsTo(false),
                avatar: string,
                message: stringRequired,
                accessibleName: stringRequired
            };
            var MdsStatusBlock = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsStatusBlock, _AgaveComponent);
                function MdsStatusBlock() {
                    _classCallCheck(this, MdsStatusBlock);
                    return _possibleConstructorReturn(this, _getPrototypeOf(MdsStatusBlock).apply(this, arguments));
                }
                _createClass(MdsStatusBlock, [ {
                    key: "render",
                    value: function render() {
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "status-block");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "status-block__top-bar");
                        _renderArbitrary(this.isAnimated && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "status-block__top-bar-animating"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "status-block__content-container");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "status-block__message-container");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("p", null, null, "class", "accessible-text");
                        _renderArbitrary(this.accessibleName);
                        _renderArbitrary(this.message);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("p");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("p", null, null, "class", "status-block__message", "aria-hidden", "true");
                        _renderArbitrary(this.message);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("p");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        _renderArbitrary(this.avatar && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "status-block__avatar"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("img", null, null, "class", "status-block__avatar-img", "src", this.avatar, "alt", ""), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ], [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsStatusBlock";
                    }
                } ]);
                return MdsStatusBlock;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_status_block_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsStatusBlock;
        },
        "./src/status-block/mds-status-block.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/status-block/mds-status-block.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/status-tracker/expandable-step/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _expandable_text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/expandable-text/index.jsx");
            var _mds_expandable_step_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/status-tracker/expandable-step/mds-expandable-step.scss");
            var _mds_expandable_step_scss__WEBPACK_IMPORTED_MODULE_3___default = __webpack_require__.n(_mds_expandable_step_scss__WEBPACK_IMPORTED_MODULE_3__);
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["mixins"].AttributeMarshallingMixin.stringRequired;
            var entity = _objectSpread({}, _expandable_text__WEBPACK_IMPORTED_MODULE_2__["entity"], {
                status: stringRequired
            });
            var MdsExpandableStep = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_ExpandableText) {
                _inherits(MdsExpandableStep, _ExpandableText);
                function MdsExpandableStep() {
                    _classCallCheck(this, MdsExpandableStep);
                    return _possibleConstructorReturn(this, _getPrototypeOf(MdsExpandableStep).apply(this, arguments));
                }
                _createClass(MdsExpandableStep, [ {
                    key: "_renderExpandableTextLabel",
                    value: function _renderExpandableTextLabel() {
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "innerHTML-prop", this.label, "aria-hidden", "true", "class", "expandable-text-label", "__skip", "true");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text");
                        _renderArbitrary("".concat(this.label, ", ").concat(this.status));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                    }
                }, {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsExpandableStep.prototype), "connectedCallback", this).call(this);
                        var _this$getRootNode = this.getRootNode(), host = _this$getRootNode.host;
                        if (!host || !host.tagName.match(/^MDS-STATUS-TRACKER/)) {
                            this.remove();
                            this.throwConstraintError("This component should only be used inside status tracker.");
                        }
                    }
                } ], [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsExpandableStep";
                    }
                } ]);
                return MdsExpandableStep;
            }(_expandable_text__WEBPACK_IMPORTED_MODULE_2__["default"]), _class2.styles = _mds_expandable_step_scss__WEBPACK_IMPORTED_MODULE_3___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsExpandableStep;
        },
        "./src/status-tracker/expandable-step/mds-expandable-step.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/status-tracker/expandable-step/mds-expandable-step.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/status-tracker/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "stepEntity", (function() {
                return stepEntity;
            }));
            __webpack_require__.d(__webpack_exports__, "expandableStepEntity", (function() {
                return expandableStepEntity;
            }));
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_status_tracker_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/status-tracker/mds-status-tracker.scss");
            var _mds_status_tracker_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_status_tracker_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            var _expandable_step__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/status-tracker/expandable-step/index.jsx");
            var _utils_allowLists__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/allowLists.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var arrayOf = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].arrayOf, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].enumerables, satisfies = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].satisfies, string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].stringRequired, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].boolean;
            var lookupAccessibleText = {
                upcoming: "accessibleTextUpcoming",
                completed: "accessibleTextCompleted",
                inProgress: "accessibleTextIncoming"
            };
            var _iconTypes = {
                critical: "ico_alert",
                success: "ico_checkmark"
            };
            var stepEntity = {
                label: string.withHTML(_utils_allowLists__WEBPACK_IMPORTED_MODULE_5__["layout"]),
                status: enumerables(string, "upcoming", "inProgress", "completed").defaultsTo("upcoming")
            };
            var expandableStepEntity = {
                label: stringRequired.withHTML(_utils_allowLists__WEBPACK_IMPORTED_MODULE_5__["layout"]),
                name: stringRequired,
                status: enumerables(string, "upcoming", "inProgress", "completed").defaultsTo("upcoming")
            };
            var entity = {
                layout: enumerables(string, "vertical", "horizontal", "").defaultsTo(""),
                variant: enumerables(string, "success", "critical").defaultsTo("success"),
                statusSteps: arrayOf(satisfies(stepEntity)).withMinLength(3).withMaxLength(5),
                accessibleName: stringRequired,
                accessibleTextCompleted: string.defaultsTo("completed"),
                accessibleTextIncoming: string.defaultsTo("in progress"),
                accessibleTextUpcoming: string.defaultsTo("upcoming"),
                accessibleTextGroupEnd: string.defaultsTo("end of group"),
                cancelled: boolean.defaultsTo(false),
                expandable: boolean.defaultsTo(false),
                expandableSteps: arrayOf(satisfies(expandableStepEntity)).withMinLength(3).withMaxLength(5)
            };
            var MdsStatusTracker = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsStatusTracker, _AgaveComponent);
                _createClass(MdsStatusTracker, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsStatusTracker";
                    }
                } ]);
                function MdsStatusTracker() {
                    var _this;
                    _classCallCheck(this, MdsStatusTracker);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsStatusTracker).call(this));
                    _this._expandableStepClickHandler = _this._expandableStepClickHandler.bind(_assertThisInitialized(_this));
                    _this.defineObservedProperty("_currentLayout", "");
                    _this._resizeListener = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["debounce"])(_this._resizeListener.bind(_assertThisInitialized(_this)), 100);
                    window.addEventListener("resize", _this._resizeListener);
                    return _this;
                }
                _createClass(MdsStatusTracker, [ {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        return {
                            interactiveElement: this.shadowRoot.getElementById("expandable-step-".concat(payload.name))
                        };
                    }
                }, {
                    key: "_resizeListener",
                    value: function _resizeListener() {
                        this._setLayout();
                    }
                }, {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsStatusTracker.prototype), "connectedCallback", this).call(this);
                        if (this.expandable) {
                            this.layout = "vertical";
                        }
                        this._setLayout();
                    }
                }, {
                    key: "disconnectedCallback",
                    value: function disconnectedCallback() {
                        _get(_getPrototypeOf(MdsStatusTracker.prototype), "disconnectedCallback", this) && _get(_getPrototypeOf(MdsStatusTracker.prototype), "disconnectedCallback", this).call(this);
                        window.removeEventListener("resize", this._resizeListener);
                    }
                }, {
                    key: "_setLayout",
                    value: function _setLayout() {
                        if (this.layout) {
                            this._currentLayout = this.layout;
                        } else {
                            this._currentLayout = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["getBreakpoint"])() === "xs" || Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["getBreakpoint"])() === "sm" ? "vertical" : "horizontal";
                        }
                    }
                }, {
                    key: "_expandableStepClickHandler",
                    value: function _expandableStepClickHandler(event) {
                        var _this2 = this;
                        event.stopPropagation();
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this2);
                            return "click";
                        }.bind(this), this)(event, _extends({}, event.detail, {
                            name: event.target.name
                        }));
                        if (event.detail.expanded) {
                            var expandedStepId = "expandable-step-".concat(event.target.name);
                            var expandableTextElements = this.shadowRoot.querySelectorAll("mds-expandable-step");
                            for (var i = 0; i < expandableTextElements.length; i++) {
                                if (expandableTextElements[i]._expanded && expandableTextElements[i].id !== expandedStepId) {
                                    expandableTextElements[i]._expanded = false;
                                    expandableTextElements[i]._collapse(event);
                                }
                            }
                        }
                    }
                }, {
                    key: "_generateLabels",
                    value: function _generateLabels() {
                        var _this3 = this;
                        return this.statusSteps.map(function(statusStep) {
                            _newArrowCheck(this, _this3);
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("li");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "mds-status-tracker__list-item");
                            _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                                role: "listitem"
                            }, MDS.isSafari));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("li");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "innerHTML-prop", statusStep.label, "class", "mds-status-tracker__label mds-status-tracker__label--".concat(statusStep.status.toLowerCase()), "aria-hidden", "true", "__skip", "true");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text");
                            _renderArbitrary("".concat(statusStep.label, ", ").concat(this[lookupAccessibleText[statusStep.status]]));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                            return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("li");
                        }.bind(this));
                    }
                }, {
                    key: "_generateSteps",
                    value: function _generateSteps() {
                        var _this4 = this;
                        var lastStep = this.statusSteps.length - 1;
                        return this.statusSteps.map(function(statusStep, i) {
                            _newArrowCheck(this, _this4);
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "mds-status-tracker__step");
                            _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                                role: "listitem"
                            }, this._currentLayout === "vertical"));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "mds-status-tracker__decoration");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "mds-status-tracker__circle mds-status-tracker__circle--".concat(statusStep.status.toLowerCase(), " mds-status-tracker__circle--").concat(this.variant));
                            _renderArbitrary(statusStep.status === "completed" && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "mds-status-tracker__icon mds-status-tracker__icon--".concat(this.variant), "innerHTML-prop", MDS.svgs[_iconTypes[this.variant]], "aria-hidden", "true", "__skip", "true"), 
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                            _renderArbitrary(i !== lastStep && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "mds-status-tracker__line mds-status-tracker__line--".concat(statusStep.status.toLowerCase(), " mds-status-tracker__line--").concat(this.variant)));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                            _renderArbitrary(this._currentLayout === "vertical" && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "mds-status-tracker__vertical-label"), 
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "innerHTML-prop", statusStep.label, "class", "mds-status-tracker__label mds-status-tracker__label--".concat(statusStep.status.toLowerCase()), "aria-hidden", "true", "__skip", "true"), 
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span"), 
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text"), 
                            _renderArbitrary("".concat(statusStep.label, ", ").concat(this[lookupAccessibleText[statusStep.status]])), 
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span"), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                            return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        }.bind(this));
                    }
                }, {
                    key: "_generateExpandableSteps",
                    value: function _generateExpandableSteps() {
                        var _this5 = this;
                        var lastStep = this.expandableSteps.length - 1;
                        return this.expandableSteps.map(function(expandableStep, i) {
                            _newArrowCheck(this, _this5);
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "mds-status-tracker__step", "role", "listitem");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "mds-status-tracker__decoration");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "mds-status-tracker__circle mds-status-tracker__circle--".concat(expandableStep.status.toLowerCase(), " mds-status-tracker__circle--").concat(this.variant));
                            _renderArbitrary(expandableStep.status === "completed" && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "mds-status-tracker__icon mds-status-tracker__icon--".concat(this.variant), "innerHTML-prop", MDS.svgs[_iconTypes[this.variant]], "aria-hidden", "true", "__skip", "true"), 
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                            _renderArbitrary(i !== lastStep && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "mds-status-tracker__line mds-status-tracker__line--".concat(expandableStep.status.toLowerCase(), " mds-status-tracker__line--").concat(this.variant)));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                            _renderArbitrary(this._currentLayout === "vertical" && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "mds-status-tracker__vertical-label"), 
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "mds-status-tracker__label mds-status-tracker__label--".concat(expandableStep.status.toLowerCase())), 
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("mds-expandable-step"), 
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "expandable-step-".concat(expandableStep.name)), 
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "mds-status-tracker__expandable-text"), 
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("label", expandableStep.label), 
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("text-color", "textColorRegular"), 
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("name", expandableStep.name), 
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("inactive", expandableStep.status === "upcoming"), 
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("status", this[lookupAccessibleText[expandableStep.status]]), 
                            _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                                onclick: this._expandableStepClickHandler
                            }, expandableStep.status !== "upcoming")), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("mds-expandable-step"), 
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "slot", expandableStep.name, "name", expandableStep.name), 
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-expandable-step"), 
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span"), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                            return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        }.bind(this));
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var _root;
                        var accessibleName = this.accessibleName, layout = this.layout, statusSteps = this.statusSteps, cancelled = this.cancelled, expandable = this.expandable, expandableSteps = this.expandableSteps;
                        var noOfSteps = expandable ? expandableSteps.length : statusSteps.length;
                        var classes = {
                            root: (_root = {
                                "mds-status-tracker": true
                            }, _defineProperty(_root, "mds-status-tracker--layout-".concat(layout), layout !== ""), 
                            _defineProperty(_root, "mds-status-tracker--layout-".concat(this._currentLayout), true), 
                            _defineProperty(_root, "mds-status-tracker--cancelled", cancelled), _root),
                            stepClasses: _defineProperty({
                                "mds-status-tracker__list-circles-lines": true
                            }, "mds-status-tracker__".concat(noOfSteps, "-step-list"), true),
                            labelClasses: _defineProperty({
                                "mds-status-tracker__list-labels": true
                            }, "mds-status-tracker__".concat(noOfSteps, "-step-list"), true)
                        };
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes.root);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text");
                        _renderArbitrary(cancelled ? "".concat(accessibleName, ", cancelled") : accessibleName);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", classes.stepClasses);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                            role: "list"
                        }, this._currentLayout === "vertical"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                        _renderArbitrary(this.expandable ? this._generateExpandableSteps() : this._generateSteps());
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        _renderArbitrary(this._currentLayout !== "vertical" && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("ol"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", classes.labelClasses), 
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                            role: "list"
                        }, MDS.isSafari)), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("ol"), 
                        _renderArbitrary(!this.expandable && this._generateLabels()), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("ol")));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return MdsStatusTracker;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_status_tracker_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsStatusTracker;
        },
        "./src/status-tracker/mds-status-tracker.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/status-tracker/mds-status-tracker.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/sticky-footer/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/button/index.js");
            var _mds_sticky_footer_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/sticky-footer/mds-sticky-footer.scss");
            var _mds_sticky_footer_scss__WEBPACK_IMPORTED_MODULE_3___default = __webpack_require__.n(_mds_sticky_footer_scss__WEBPACK_IMPORTED_MODULE_3__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_allowLists__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/allowLists.js");
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _dec, _class, _class2;
            var _mdsButton$wrapper = function _mdsButton$wrapper(_this$_buttonClickEve, _this$_buttonBlurEven, _button) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("mds-button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "sticky-footer__button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onclick", _this$_buttonClickEve);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onblur", _this$_buttonBlurEven);
                _spreadAttribute(_button);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("mds-button");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-button");
            };
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["mixins"].AttributeMarshallingMixin, arrayOf = _mixins$AttributeMars.arrayOf, boolean = _mixins$AttributeMars.boolean, enumerables = _mixins$AttributeMars.enumerables, satisfies = _mixins$AttributeMars.satisfies, string = _mixins$AttributeMars.string;
            var buttonEntity = _objectSpread({}, _button__WEBPACK_IMPORTED_MODULE_2__["entity"], {
                variant: enumerables(string, "primary", "secondary").defaultsTo("primary")
            });
            var entity = {
                horizontalLayout: boolean.defaultsTo(false).withChangedCallback(),
                stickToParentContainer: boolean.defaultsTo(true),
                stickyFooterButtons: arrayOf(satisfies(buttonEntity)).withMinLength(1).withMaxLength(3).withChangedCallback(),
                showBoxShadow: boolean.defaultsTo(true),
                footerText: string.withHTML(_utils_allowLists__WEBPACK_IMPORTED_MODULE_5__["base"], _utils_allowLists__WEBPACK_IMPORTED_MODULE_5__["interactive"])
            };
            var MdsStickyFooter = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsStickyFooter, _AgaveComponent);
                _createClass(MdsStickyFooter, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsStickyFooter";
                    }
                } ]);
                function MdsStickyFooter() {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsStickyFooter);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsStickyFooter).call(this));
                    _this._dispatchEvent = function(event, eventType, element, index) {
                        var _this3 = this;
                        _newArrowCheck(this, _this2);
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this3);
                            return "".concat(eventType, "-").concat(element.id);
                        }.bind(this), _assertThisInitialized(_this))(event, {
                            index: index + 1
                        });
                        if (element.id !== "button") {
                            Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["createCustomEventDispatcher"])(function() {
                                _newArrowCheck(this, _this3);
                                return "".concat(eventType, "-button");
                            }.bind(this), _assertThisInitialized(_this))(event, {
                                index: index + 1
                            });
                        }
                    }.bind(this);
                    _this.defineObservedProperty("_shouldRerender", true);
                    _this._resizeListener = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["debounce"])(_this._resizeListener.bind(_assertThisInitialized(_this)), 200);
                    window.addEventListener("resize", _this._resizeListener);
                    _this.breakPoint = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["getBreakpoint"])();
                    _this._isMobileScreen = _this.breakPoint === "xs" && MDS.isMobile || _this.breakPoint === "xs";
                    _this._updateMobileScreen = _this._updateMobileScreen.bind(_assertThisInitialized(_this));
                    _this._buttonClickEvent = _this._buttonClickEvent.bind(_assertThisInitialized(_this));
                    _this._buttonBlurEvent = _this._buttonBlurEvent.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsStickyFooter, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsStickyFooter.prototype), "connectedCallback", this).call(this);
                        window.addEventListener("resize", this._resizeListener);
                    }
                }, {
                    key: "disconnectedCallback",
                    value: function disconnectedCallback() {
                        _get(_getPrototypeOf(MdsStickyFooter.prototype), "disconnectedCallback", this) && _get(_getPrototypeOf(MdsStickyFooter.prototype), "disconnectedCallback", this).call(this);
                        window.removeEventListener("resize", this._resizeListener);
                    }
                }, {
                    key: "horizontalLayoutChangedCallback",
                    value: function horizontalLayoutChangedCallback() {
                        this._updateMobileScreen();
                    }
                }, {
                    key: "stickyFooterButtonsChangedCallback",
                    value: function stickyFooterButtonsChangedCallback(buttons) {
                        var _this4 = this;
                        if (buttons.length > 1) {
                            buttons[0].variant = "primary";
                        }
                        if (buttons.length !== 2 && this.breakPoint === "xs") {
                            this.horizontalLayout = false;
                        }
                        this._buttonList = [];
                        buttons.forEach(function(button, index) {
                            _newArrowCheck(this, _this4);
                            button.variant = index > 0 ? "secondary" : button.variant || "primary";
                            if (this._isMobileScreen) {
                                button["width-type"] = "layout";
                            } else {
                                button["width-type"] = "content";
                            }
                            if (!button.id) {
                                button.id = "button".concat(index + 1);
                            }
                            this._buttonList.push(button.id);
                        }.bind(this));
                    }
                }, {
                    key: "_buttonClickEvent",
                    value: function _buttonClickEvent(event) {
                        this._dispatchEvent(event, "click", event.target, this._buttonList.indexOf(event.target.id));
                    }
                }, {
                    key: "_buttonBlurEvent",
                    value: function _buttonBlurEvent(event) {
                        this._dispatchEvent(event, "blur", event.target, this._buttonList.indexOf(event.target.id));
                    }
                }, {
                    key: "_updateMobileScreen",
                    value: function _updateMobileScreen() {
                        var _this5 = this;
                        this.breakPoint = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["getBreakpoint"])();
                        this._isMobileScreen = this.breakPoint === "xs" && MDS.isMobile || this.breakPoint === "xs";
                        this.stickyFooterButtons && this.stickyFooterButtons.forEach(function(button) {
                            _newArrowCheck(this, _this5);
                            if (this._isMobileScreen) {
                                button["width-type"] = "layout";
                            } else {
                                button["width-type"] = "content";
                            }
                        }.bind(this));
                    }
                }, {
                    key: "_forceRerender",
                    value: function _forceRerender() {
                        this._shouldRerender = false;
                        this._shouldRerender = true;
                    }
                }, {
                    key: "_resizeListener",
                    value: function _resizeListener() {
                        this.isConnected && this._forceRerender();
                    }
                }, {
                    key: "renderedCallback",
                    value: function renderedCallback() {
                        var _this6 = this;
                        var buttons = this.shadowRoot.querySelectorAll("mds-button");
                        if (this._isMobileScreen) {
                            buttons.forEach(function(button) {
                                _newArrowCheck(this, _this6);
                                button.suppressTextWrap = this.horizontalLayout && buttons.length === 2;
                            }.bind(this));
                        } else {
                            buttons.forEach(function(button) {
                                _newArrowCheck(this, _this6);
                                button.suppressTextWrap = true;
                            }.bind(this));
                        }
                        var footerElement = this.shadowRoot.querySelector(".sticky-footer__text");
                        !!this.footerText && footerElement && (footerElement.innerHTML = this.footerText);
                        this.shadowRoot.querySelectorAll("a, mds-link").forEach(function(link, index) {
                            var _this7 = this;
                            _newArrowCheck(this, _this6);
                            link.onclick = function(event) {
                                var _this8 = this;
                                _newArrowCheck(this, _this7);
                                Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["createCustomEventDispatcher"])(function() {
                                    _newArrowCheck(this, _this8);
                                    return "click-link";
                                }.bind(this), this)(event, {
                                    index: index
                                });
                            }.bind(this);
                        }.bind(this));
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var _this9 = this;
                        this._updateMobileScreen();
                        if (!this.stickyFooterButtons || !this.stickyFooterButtons.length) {
                            return;
                        }
                        var buttons = this._isMobileScreen ? this.stickyFooterButtons : this.stickyFooterButtons.slice().reverse();
                        var subcontainerButtons = buttons.length === 3 ? buttons.slice(1) : buttons;
                        if (this.horizontalLayout && buttons.length >= 2 && this._isMobileScreen) {
                            subcontainerButtons = subcontainerButtons.slice().reverse();
                        }
                        var containerClasses = {
                            "sticky-footer": true,
                            "sticky-footer--column": this._isMobileScreen,
                            "sticky-footer--three-buttons": buttons.length === 3,
                            "sticky-footer--with-box-shadow": this.showBoxShadow,
                            "sticky-footer--ios": MDS.isIOS
                        };
                        var subcontainerClasses = {
                            "sticky-footer__subcontainer": true,
                            "sticky-footer__subcontainer--column": this._isMobileScreen,
                            "sticky-footer__subcontainer--one-button": buttons.length === 1,
                            "sticky-footer__subcontainer--two-buttons": buttons.length === 2,
                            "sticky-footer__subcontainer--mobile-horizontal-layout": this.horizontalLayout && buttons.length === 2 && this._isMobileScreen
                        };
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "sticky-footer__container");
                        _renderArbitrary(!!this.footerText && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "sticky-footer__text"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", containerClasses);
                        _renderArbitrary(buttons.length === 3 && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("mds-button"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "sticky-footer__button"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onclick", this._buttonClickEvent), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onblur", this._buttonBlurEvent), 
                        _spreadAttribute(buttons[0]), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("mds-button"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-button")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", subcontainerClasses);
                        _renderArbitrary(subcontainerButtons.map(function(button) {
                            _newArrowCheck(this, _this9);
                            return _jsxWrapper(_mdsButton$wrapper, [ this._buttonClickEvent, this._buttonBlurEvent, button ]);
                        }.bind(this)));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return MdsStickyFooter;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["AgaveComponent"]), _class2.styles = _mds_sticky_footer_scss__WEBPACK_IMPORTED_MODULE_3___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsStickyFooter;
        },
        "./src/sticky-footer/mds-sticky-footer.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/sticky-footer/mds-sticky-footer.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/switch/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_switch_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/switch/mds-switch.scss");
            var _mds_switch_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_switch_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].boolean, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].enumerables;
            var entity = {
                variant: enumerables(string, "narrow", "wide").defaultsTo("narrow"),
                label: string,
                labelSize: enumerables(string, "large", "medium").defaultsTo("large"),
                checked: boolean.defaultsTo(false),
                isStateVisible: boolean.defaultsTo(true),
                stateLabelOn: string.defaultsTo("On"),
                stateLabelOff: string.defaultsTo("Off"),
                inactive: boolean.defaultsTo(false)
            };
            var MdsSwitch = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsSwitch, _AgaveComponent);
                _createClass(MdsSwitch, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsSwitch";
                    }
                } ]);
                function MdsSwitch() {
                    var _this;
                    _classCallCheck(this, MdsSwitch);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsSwitch).call(this));
                    _this._onclick = _this._onclick.bind(_assertThisInitialized(_this));
                    _this._onfocus = _this._onfocus.bind(_assertThisInitialized(_this));
                    _this._onblur = _this._onblur.bind(_assertThisInitialized(_this));
                    _this._onkeydown = _this._onkeydown.bind(_assertThisInitialized(_this));
                    _this._removeAriaLiveRegion = _this._removeAriaLiveRegion.bind(_assertThisInitialized(_this));
                    _this.focus = _this.focus.bind(_assertThisInitialized(_this));
                    _this.preventDefaultOnMousedown = _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["preventDefault"];
                    _this.defineObservedProperty("_isFocused", false);
                    return _this;
                }
                _createClass(MdsSwitch, [ {
                    key: "focus",
                    value: function focus(target) {
                        if (target) {
                            _get(_getPrototypeOf(MdsSwitch.prototype), "focus", this).call(this);
                        } else {
                            var focusNode = this.shadowRoot.querySelector("button");
                            focusNode.focus();
                            this._isFocused = true;
                        }
                    }
                }, {
                    key: "_onclick",
                    value: function _onclick(event) {
                        var _this2 = this;
                        this.checked = !this.checked;
                        this.shadowRoot.querySelector(".switch__checkbox").focus();
                        _get(_getPrototypeOf(MdsSwitch.prototype), "_onclick", this) && _get(_getPrototypeOf(MdsSwitch.prototype), "_onclick", this).call(this, event);
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this2);
                            return "change";
                        }.bind(this), this)(event);
                        this._setAriaLiveRegion();
                    }
                }, {
                    key: "_onfocus",
                    value: function _onfocus(event) {
                        _get(_getPrototypeOf(MdsSwitch.prototype), "_onfocus", this) && _get(_getPrototypeOf(MdsSwitch.prototype), "_onfocus", this).call(this, event);
                        this._isFocused = true;
                    }
                }, {
                    key: "_onblur",
                    value: function _onblur(event) {
                        _get(_getPrototypeOf(MdsSwitch.prototype), "_onblur", this) && _get(_getPrototypeOf(MdsSwitch.prototype), "_onblur", this).call(this, event);
                        this._isFocused = false;
                    }
                }, {
                    key: "_onkeydown",
                    value: function _onkeydown(event) {
                        if (!this.inactive && event.keyCode === 13) {
                            event.preventDefault();
                            this.checked = !this.checked;
                            _get(_getPrototypeOf(MdsSwitch.prototype), "_onkeydown", this) && _get(_getPrototypeOf(MdsSwitch.prototype), "_onkeydown", this).call(this, event);
                            this._setAriaLiveRegion();
                            return;
                        }
                        _get(_getPrototypeOf(MdsSwitch.prototype), "_onkeydown", this) && _get(_getPrototypeOf(MdsSwitch.prototype), "_onkeydown", this).call(this, event);
                    }
                }, {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        return {
                            interactiveElement: this.shadowRoot.querySelector("input")
                        };
                    }
                }, {
                    key: "_setAriaLiveRegion",
                    value: function _setAriaLiveRegion() {
                        var checked = this.checked, stateLabelOn = this.stateLabelOn, stateLabelOff = this.stateLabelOff;
                        var liveElm = this.shadowRoot.getElementById("live-region");
                        liveElm.innerText = checked ? stateLabelOn : stateLabelOff;
                        this.isStateVisible && setTimeout(this._removeAriaLiveRegion, 1e3);
                    }
                }, {
                    key: "_removeAriaLiveRegion",
                    value: function _removeAriaLiveRegion() {
                        var liveElm = this.shadowRoot.getElementById("live-region");
                        !MDS.isMobile && liveElm && (liveElm.innerText = "");
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var _labelClasses;
                        var id = this.id, label = this.label, labelSize = this.labelSize, stateLabelOn = this.stateLabelOn, stateLabelOff = this.stateLabelOff, isStateVisible = this.isStateVisible, checked = this.checked, inactive = this.inactive, _isFocused = this._isFocused, variant = this.variant;
                        var switchClasses = {
                            switch: true,
                            "switch--disabled": inactive,
                            "switch--focus": _isFocused
                        };
                        var trackClasses = {
                            "switch__label-wrapper": true,
                            "switch__label-wrapper--wide": variant === "wide",
                            "switch__label-wrapper--on": !inactive && checked,
                            "switch__label-wrapper--off": !inactive && !checked,
                            "switch__label-wrapper--disabled-on": inactive && checked,
                            "switch__label-wrapper--disabled-off": inactive && !checked
                        };
                        var thumbClasses = {
                            switch__slider: !inactive,
                            "switch__slider--checked": checked,
                            "switch__thumb--disabled": variant === "narrow" && inactive,
                            "switch__slider--wide": variant === "wide",
                            "switch__thumb-wide--disabled": variant === "wide" && inactive
                        };
                        var labelClasses = (_labelClasses = {
                            switch__label: true
                        }, _defineProperty(_labelClasses, "switch__label--".concat(labelSize), true), _defineProperty(_labelClasses, "switch__label--disabled", inactive), 
                        _labelClasses);
                        var stateLabelClasses = {
                            switch__state: true,
                            "switch__state--disabled": inactive
                        };
                        var checkboxClasses = {
                            switch__checkbox: true,
                            "switch__checkbox--wide": variant === "wide"
                        };
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", switchClasses);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                            tabIndex: -1
                        }, inactive));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("label", null, null, "for", "input-".concat(id), "class", labelClasses, "onfocus", this._onfocus, "onblur", this._onblur, "onmousedown", this.preventDefaultOnMousedown, "aria-hidden", "true");
                        _renderArbitrary(label);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("label");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "switch__wrap");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                            onclick: this._onclick
                        }, !inactive));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", trackClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onmousedown", this.preventDefaultOnMousedown);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("button", null, null, "id", "input-".concat(id), "class", checkboxClasses, "aria-label", label, "checked", checked, "onclick", this._onclick, "onblur", this._onblur, "onkeydown", this._onkeydown, "onfocus", this._onfocus, "aria-checked", checked, "disabled-prop", inactive, "role", "switch");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("span", null, null, "class", thumbClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        _renderArbitrary(isStateVisible && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("span"), 
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                            onclick: this._onclick
                        }, !inactive)), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", stateLabelClasses), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-hidden", "true"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onfocus", this._onfocus), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onblur", this._onblur), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onmousedown", this.preventDefaultOnMousedown), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("span"), 
                        _renderArbitrary(checked ? stateLabelOn : stateLabelOff), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        _renderArbitrary((isStateVisible || MDS.isMobile) && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("span", null, null, "id", "live-region", "class", "accessible-text", "aria-live", "polite"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return MdsSwitch;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_switch_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsSwitch;
        },
        "./src/switch/mds-switch.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/switch/mds-switch.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/text-input-secure/MdsTextInputSecure.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", (function() {
                return MdsTextInputSecureTemplate;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _microcopy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/microcopy/index.jsx");
            var _text_input_MdsTextInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/text-input/MdsTextInput.jsx");
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function renderShowHideButton(_ref) {
                var _classes;
                var inactive = _ref.inactive, _handleBlur = _ref._handleBlur, _handleFocus = _ref._handleFocus, _toggleSecureView = _ref._toggleSecureView, currentButtonText = _ref.currentButtonText, variant = _ref.variant, label = _ref.label, labelStyle = _ref.labelStyle;
                var classes = (_classes = {
                    "mds-text-input__icon": true
                }, _defineProperty(_classes, "mds-text-input__icon--".concat(variant), true), _defineProperty(_classes, "text-input-secure__icon--field-suffix", true), 
                _defineProperty(_classes, "mds-text-input__icon--".concat(variant, "--").concat(labelStyle), true), 
                _classes);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-button", null, null, "class", classes, "id", "show-hide-button", "small", "true", "text", currentButtonText, "onclick", _toggleSecureView, "accessible-text", label, "inactive", inactive, "variant", "tertiary", "onblur", _handleBlur, "onfocus", _handleFocus);
            }
            function renderCapsLockTooltip(_ref2) {
                var capsLockMessage = _ref2.capsLockMessage, brand = _ref2.brand;
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("abstract-tooltip", null, null, "class", "caps-lock-tooltip", "message", capsLockMessage, "variant", "base", "tooltip-placement", "above", "alignment", "right");
            }
            function MdsTextInputSecureTemplate() {
                var _containerClasses, _labelWrapClasses, _labelClasses, _textElementClasses, _this = this;
                var errorMessage = this.errorMessage, errorMessages = this.errorMessages, _getEventProps = this._getEventProps, id = this.id, inactive = this.inactive, inputColumns = this.inputColumns, _isFloating = this._isFloating, _isFocused = this._isFocused, label = this.label, labelColumns = this.labelColumns, labelStyle = this.labelStyle, microcopy = this.microcopy, placeholder = this.placeholder, required = this.required, value = this.value, variant = this.variant, autocompleteValue = this.autocompleteValue;
                var errorMessageList = errorMessages.concat(errorMessage ? [ errorMessage ] : []);
                var containerClasses = (_containerClasses = {
                    "mds-text-input": true
                }, _defineProperty(_containerClasses, "mds-text-input--".concat(this.labelStyle, "-label"), true), 
                _defineProperty(_containerClasses, "mds-row", labelStyle === "horizontal"), _containerClasses);
                var labelWrapClasses = (_labelWrapClasses = {
                    "mds-text-input__label-wrap": true
                }, _defineProperty(_labelWrapClasses, "mds-text-input__label-wrap--".concat(variant), true), 
                _defineProperty(_labelWrapClasses, "".concat(labelColumns || "mds-col-3"), labelStyle === "horizontal"), 
                _labelWrapClasses);
                var labelClasses = (_labelClasses = {
                    "mds-text-input__label": true
                }, _defineProperty(_labelClasses, "mds-text-input__label--".concat(variant), true), 
                _defineProperty(_labelClasses, "mds-text-input__label--error", !!errorMessageList.length), 
                _defineProperty(_labelClasses, "mds-text-input__label--floating", _isFloating), 
                _labelClasses);
                var inputWrapClasses = _defineProperty({
                    "mds-text-input__input-wrap": true
                }, "".concat(inputColumns || "mds-col-9"), labelStyle === "horizontal");
                var textElementClasses = (_textElementClasses = {
                    "mds-text-input__input": true,
                    "mds-text-input__input--error": !!errorMessageList.length
                }, _defineProperty(_textElementClasses, "mds-text-input__input--".concat(variant), true), 
                _defineProperty(_textElementClasses, "mds-text-input__input--trailing-icon", true), 
                _defineProperty(_textElementClasses, "mds-text-input__input--focused", _isFocused), 
                _textElementClasses);
                var ariaDescribedbyList = errorMessageList.map(function(_, i) {
                    _newArrowCheck(this, _this);
                    return "".concat(id, "-error-text").concat(i);
                }.bind(this)).join(" ").concat(microcopy ? " ".concat(id, "-microcopy") : "");
                var textElementProps = _objectSpread({}, _getEventProps(), {
                    class: textElementClasses,
                    id: "".concat(id, "-input"),
                    name: "".concat(id, "-input"),
                    "aria-describedby": ariaDescribedbyList,
                    "disabled-prop": inactive,
                    "required-prop": required,
                    autocomplete: autocompleteValue,
                    value: value,
                    placeholder: placeholder
                });
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", containerClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", labelWrapClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("label", null, null, "for", "".concat(id, "-input"), "class", labelClasses);
                _renderArbitrary(label);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("label");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", inputWrapClasses);
                _renderArbitrary(Object(_text_input_MdsTextInput__WEBPACK_IMPORTED_MODULE_2__["renderTextElementInput"])(textElementProps));
                _renderArbitrary(renderShowHideButton(this));
                _renderArbitrary(renderCapsLockTooltip(this));
                _renderArbitrary(_text_input_MdsTextInput__WEBPACK_IMPORTED_MODULE_2__["renderErrorMicrocopy"].call(this, errorMessageList));
                _renderArbitrary(Object(_microcopy__WEBPACK_IMPORTED_MODULE_1__["default"])(microcopy, "".concat(id, "-microcopy"), "mds-text-input__microcopy"));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
        },
        "./src/text-input-secure/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _text_input__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/text-input/index.js");
            var _abstract_text_field__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/abstract-text-field/index.js");
            var _mds_text_input_secure_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/text-input-secure/mds-text-input-secure.scss");
            var _mds_text_input_secure_scss__WEBPACK_IMPORTED_MODULE_3___default = __webpack_require__.n(_mds_text_input_secure_scss__WEBPACK_IMPORTED_MODULE_3__);
            var _MdsTextInputSecure__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/text-input-secure/MdsTextInputSecure.jsx");
            var _text_input_formatters__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/text-input/formatters.js");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/utils/common-utils.js");
            var _dec, _class, _class2;
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["mixins"].AttributeMarshallingMixin, stamp = _mixins$AttributeMars.stamp, string = _mixins$AttributeMars.string, enumerables = _mixins$AttributeMars.enumerables;
            var entity = _objectSpread({}, _abstract_text_field__WEBPACK_IMPORTED_MODULE_2__["entity"], {
                autocompleteValue: string.defaultsTo("off"),
                value: string.defaultsTo("").withChangedCallback(),
                showButtonText: string.defaultsTo("Show"),
                hideButtonText: string.defaultsTo("Hide"),
                capsLockMessage: string.defaultsTo("Caps lock is on."),
                format: enumerables(string, "password", "pin", "ssn", "taxid", "dl", "credit", "numeric", "").withChangedCallback()
            });
            var MdsTextInputSecure = (_dec = stamp(entity), _dec(_class = (_class2 = function(_MdsTextInput) {
                _inherits(MdsTextInputSecure, _MdsTextInput);
                _createClass(MdsTextInputSecure, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsTextInputSecure";
                    }
                } ]);
                function MdsTextInputSecure() {
                    var _this;
                    _classCallCheck(this, MdsTextInputSecure);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsTextInputSecure).call(this));
                    _this._isSecure = true;
                    _this._toggleSecureView = _this._toggleSecureView.bind(_assertThisInitialized(_this));
                    _this._handleCapslock = _this._handleCapslock.bind(_assertThisInitialized(_this));
                    _this._addDynamicButtonPadding = _this._addDynamicButtonPadding.bind(_assertThisInitialized(_this));
                    _this.ssn = "";
                    _this._handleSSN = _this._handleSSN.bind(_assertThisInitialized(_this));
                    _this._createFormattedSSNDots = _this._createFormattedSSNDots.bind(_assertThisInitialized(_this));
                    _this._onfocus = _this._onfocus.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsTextInputSecure, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsTextInputSecure.prototype), "connectedCallback", this) && _get(_getPrototypeOf(MdsTextInputSecure.prototype), "connectedCallback", this).call(this);
                        this._textFieldNode.type = "password";
                        this._showHideButton = this.shadowRoot.querySelector("mds-button");
                        this._showHideButton.text = this.showButtonText;
                        this._addDynamicButtonPadding();
                        this._textFieldNode.addEventListener("keyup", this._handleCapslock);
                        this._capsLockTooltip = this.shadowRoot.querySelector(".caps-lock-tooltip");
                    }
                }, {
                    key: "disconnectedCallback",
                    value: function disconnectedCallback() {
                        _get(_getPrototypeOf(MdsTextInputSecure.prototype), "disconnectedCallback", this) && _get(_getPrototypeOf(MdsTextInputSecure.prototype), "disconnectedCallback", this).call(this);
                        this._textFieldNode.removeEventListener("keyup", this._handleCapslock);
                    }
                }, {
                    key: "valueChangedCallback",
                    value: function valueChangedCallback() {
                        _get(_getPrototypeOf(MdsTextInputSecure.prototype), "valueChangedCallback", this).call(this);
                        this._setTextFieldValue();
                    }
                }, {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        if (!payload.target) {
                            return {
                                interactiveElement: this._textFieldNode
                            };
                        }
                        return _get(_getPrototypeOf(MdsTextInputSecure.prototype), "_getInteractiveElement", this).call(this, {
                            target: "".concat(payload.target)
                        });
                    }
                }, {
                    key: "_toggleSecureView",
                    value: function _toggleSecureView(event) {
                        var _this2 = this;
                        this._showHideButton.text = this._showHideButton.text === this.showButtonText ? this.hideButtonText : this.showButtonText;
                        if (this.format !== "ssn") {
                            this._textFieldNode.type = this._textFieldNode.type === "password" ? "text" : "password";
                        }
                        if (this.format === "ssn") {
                            if (this._showHideButton.text === this.showButtonText) {
                                this._textFieldNode.value = this._createFormattedSSNDots();
                            } else if (this._showHideButton.text === this.hideButtonText) {
                                this._textFieldNode.type = "text";
                                this._textFieldNode.value = _text_input_formatters__WEBPACK_IMPORTED_MODULE_5__["default"][this.format](this.ssn) || this.value;
                            }
                        }
                        this._addDynamicButtonPadding();
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_6__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this2);
                            return "click-show-hide-button";
                        }.bind(this), this)(event);
                    }
                }, {
                    key: "_handleBlur",
                    value: function _handleBlur(event) {
                        _get(_getPrototypeOf(MdsTextInputSecure.prototype), "_handleBlur", this).call(this, event);
                        this.format === "ssn" && this._handleSSN(event);
                        this._escapeCapsLockTooltip = false;
                        this._capsLockTooltip && this._capsLockTooltip.close();
                    }
                }, {
                    key: "_handleFocus",
                    value: function _handleFocus(event) {
                        var _originalEvent = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["originalEvent"])(event), target = _originalEvent.target;
                        if (target.id === "".concat(this.id, "-input")) {
                            this.format === "ssn" && this._handleSSN(event);
                        }
                        _get(_getPrototypeOf(MdsTextInputSecure.prototype), "_handleFocus", this).call(this, event);
                    }
                }, {
                    key: "_oninput",
                    value: function _oninput(event) {
                        _get(_getPrototypeOf(MdsTextInputSecure.prototype), "_oninput", this) && _get(_getPrototypeOf(MdsTextInputSecure.prototype), "_oninput", this).call(this, event);
                        this.format === "ssn" && this._handleSSN(event);
                    }
                }, {
                    key: "_handleFormatting",
                    value: function _handleFormatting(event) {
                        if (event.type === "blur" && this.format !== "ssn") {
                            var formattedValue = _text_input_formatters__WEBPACK_IMPORTED_MODULE_5__["default"][this.format](this.value);
                            this._textFieldNode.value = formattedValue === "" || formattedValue.length ? formattedValue : this.value;
                            if ([ "pin", "taxid", "dl", "numeric", "credit", "moneyCommaFloat", "moneyDecimalFloat", "phone", "ssn" ].includes(this.format)) {
                                this.value = this.value.replace(/\D+/g, "");
                            }
                        }
                        if (this.format === "ssn") {
                            this._handleSSN(event);
                        }
                        if (event.type === "keydown" && event.key !== "Backspace" && event.keyCode !== 9) {
                            /^[a-zA-Z]$/.test(event.key) && !event.metaKey && event.preventDefault();
                        }
                    }
                }, {
                    key: "_createFormattedSSNDots",
                    value: function _createFormattedSSNDots() {
                        var ssnLength = this.ssn.replace(/-/g, "").length;
                        if (ssnLength > 0 && ssnLength < 4) {
                            return "•".repeat(ssnLength);
                        } else if (ssnLength === 4 || ssnLength === 5) {
                            return "".concat("•".repeat(3), "-").concat("•".repeat(ssnLength - 3));
                        } else if (ssnLength > 5) {
                            return "".concat("•".repeat(3), "-").concat("•".repeat(2), "-").concat("•".repeat(ssnLength - 5));
                        }
                        return "";
                    }
                }, {
                    key: "_handleSSN",
                    value: function _handleSSN(event) {
                        if (event.type === "blur") {
                            if (this._showHideButton.text === this.showButtonText) {
                                this.value = this.value.replace(/-/g, "");
                                this._textFieldNode.value = this._createFormattedSSNDots();
                                this._textFieldNode.type = "text";
                            } else {
                                var formattedValue = _text_input_formatters__WEBPACK_IMPORTED_MODULE_5__["default"][this.format](this.ssn) || "";
                                this._textFieldNode.value = formattedValue.length ? formattedValue : this.value;
                                this.ssn = this._textFieldNode.value.replace(/-/g, "");
                                this.value = this.ssn;
                            }
                        } else if (event.type === "focus") {
                            if (this._showHideButton.text === this.showButtonText && this._textFieldNode.type !== "password") {
                                this._textFieldNode.type = "password";
                                this._textFieldNode.value = this.ssn;
                            }
                        } else if (event.type === "input") {
                            if (this._showHideButton.text === this.showButtonText && this._textFieldNode.type !== "password") {
                                this.ssn = this._textFieldNode.value;
                            } else if (this.value.length === 0) {
                                this.ssn = "";
                            } else if (this._showHideButton.text === this.hideButtonText) {
                                this.ssn = this.value;
                            } else {
                                this.ssn = this._textFieldNode.value;
                            }
                        } else if (event.type === "keydown" && event.key === "Backspace") {
                            if (this._showHideButton.text === this.showButtonText) {
                                this.ssn = this.ssn.substring(0, event.target.selectionStart - 1) + this.ssn.substring(event.target.selectionStart);
                            }
                        }
                    }
                }, {
                    key: "_handleCapslock",
                    value: function _handleCapslock(event) {
                        if (event.getModifierState && event.getModifierState("CapsLock")) {
                            if (event.keyCode === 27) {
                                this._capsLockTooltip.close();
                                this._escapeCapsLockTooltip = true;
                            } else if (!this._capsLockTooltip.visible && !this._escapeCapsLockTooltip) {
                                this._capsLockTooltip.open();
                            }
                        } else if (this._capsLockTooltip.visible) {
                            this._capsLockTooltip.close();
                        }
                    }
                }, {
                    key: "_addDynamicButtonPadding",
                    value: function _addDynamicButtonPadding() {
                        var buttonWidth = this.shadowRoot.querySelector(".text-input-secure__icon--field-suffix").offsetWidth;
                        var paddedButtonWidthBox = buttonWidth + parseInt("16px", 10) + parseInt("8px", 10);
                        var paddedButtonWidthLine = buttonWidth + parseInt("16px", 10) + parseInt("0px", 10);
                        var paddedButtonWidth = this.variant === "line" ? paddedButtonWidthLine : paddedButtonWidthBox;
                        this._textFieldNode.style.paddingRight = "".concat(paddedButtonWidth, "px");
                    }
                }, {
                    key: "render",
                    value: function render() {
                        _MdsTextInputSecure__WEBPACK_IMPORTED_MODULE_4__["default"].call(this);
                    }
                } ]);
                return MdsTextInputSecure;
            }(_text_input__WEBPACK_IMPORTED_MODULE_1__["default"]), _class2.styles = _mds_text_input_secure_scss__WEBPACK_IMPORTED_MODULE_3___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsTextInputSecure;
        },
        "./src/text-input-secure/mds-text-input-secure.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/text-input-secure/mds-text-input-secure.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/text-input/error-message/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _alert__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/alert/index.js");
            var _mds_error_message_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/text-input/error-message/mds-error-message.scss");
            var _mds_error_message_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_error_message_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _dec, _class, _class2;
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].boolean;
            var entity = _objectSpread({}, _alert__WEBPACK_IMPORTED_MODULE_1__["entity"], {
                hideIcon: boolean.defaultsTo(false)
            });
            var MdsErrorMessage = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_Alert) {
                _inherits(MdsErrorMessage, _Alert);
                function MdsErrorMessage() {
                    _classCallCheck(this, MdsErrorMessage);
                    return _possibleConstructorReturn(this, _getPrototypeOf(MdsErrorMessage).apply(this, arguments));
                }
                _createClass(MdsErrorMessage, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsErrorMessage.prototype), "connectedCallback", this).call(this);
                        if (!(this.getRootNode().host instanceof _mds_agave__WEBPACK_IMPORTED_MODULE_0___default.a)) {
                            this.throwConstraintError("this component needs to be in the shadowRoot of an AgaveComponent");
                        }
                    }
                } ], [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsErrorMessage";
                    }
                } ]);
                return MdsErrorMessage;
            }(_alert__WEBPACK_IMPORTED_MODULE_1__["default"]), _class2.styles = _mds_error_message_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsErrorMessage;
        },
        "./src/text-input/error-message/mds-error-message.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/text-input/error-message/mds-error-message.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/text-input/formatters.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", (function() {
                return Formatters;
            }));
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var Formatters = function() {
                function Formatters() {
                    _classCallCheck(this, Formatters);
                }
                _createClass(Formatters, null, [ {
                    key: "credit",
                    value: function credit(value) {
                        return value.replace(/\D+/g, "").replace(/(.{4})/g, "$1 ").trim();
                    }
                }, {
                    key: "moneyInteger",
                    value: function moneyInteger(value) {
                        var _this = this;
                        if (!/^(\d|,)/.test(value)) {
                            value = value.substr(1);
                        }
                        var testFormatWithComma = /^\$?((\d{1,3})+(,?\d{3})*)?(^\.)?$/.test(value);
                        var testDigits = /\d/g.test(value);
                        if (testFormatWithComma && testDigits && value.length) {
                            value = parseInt(value.replace(/[^0-9.]/g, ""));
                            return "".concat(value.toString().split("").reverse().reduce(function(acc, value, i) {
                                _newArrowCheck(this, _this);
                                return value === "-" ? acc : value + (i && !(i % 3) ? "," : "") + acc;
                            }.bind(this), ""));
                        }
                        return "";
                    }
                }, {
                    key: "moneyIntegerClean",
                    value: function moneyIntegerClean(value) {
                        return value.replace(/[^0-9]/g, "");
                    }
                }, {
                    key: "moneyCommaFloat",
                    value: function moneyCommaFloat(inputValue) {
                        var _this2 = this;
                        var testFormatWithDecimal = /^\$?((\d{1,3})+(\.?\d{3})*)?(,)?(\d{1,2})?$/.test(inputValue);
                        var hasDigit = /\d/g.test(inputValue);
                        if (testFormatWithDecimal && hasDigit) {
                            var value = inputValue.replace(/[^0-9,]/g, "").replace(/\./g, ",").split("").reverse("");
                            var decimalString = "";
                            if (value.includes(",")) {
                                decimalString = value.splice(0, value.indexOf(",") + 1).reverse().join("");
                                while (decimalString.length !== decimalString.indexOf(",") + 3) {
                                    decimalString += "0";
                                }
                            } else {
                                decimalString = ",00";
                            }
                            var result = [ [] ];
                            for (var i = 0; i < value.length; i++) {
                                if (result[result.length - 1].length === 0 || result[result.length - 1].length % 3) {
                                    result[result.length - 1].push(value[i]);
                                } else {
                                    result.push([ value[i] ]);
                                }
                            }
                            return result.map(function(el) {
                                _newArrowCheck(this, _this2);
                                return el.reverse().join("");
                            }.bind(this)).reverse().join(".") + decimalString;
                        }
                        return "";
                    }
                }, {
                    key: "moneyCommaFloatClean",
                    value: function moneyCommaFloatClean(value) {
                        return value.replace(/[^0-9,]/g, "");
                    }
                }, {
                    key: "moneyDecimalFloat",
                    value: function moneyDecimalFloat(inputValue) {
                        var _this3 = this;
                        var preFormattedValue = inputValue;
                        var hasExtraDecimalPoints = preFormattedValue.split(".").length > 2;
                        var testFormatWithDecimal = /^\$?((\d{1,3})+(,?\d{3})*)?(\.)?(\d{1,2})?$/.test(preFormattedValue);
                        var hasDigit = /\d/g.test(preFormattedValue);
                        if (testFormatWithDecimal && hasDigit && !hasExtraDecimalPoints) {
                            var value = preFormattedValue.replace(/[^0-9.]/g, "").split("").reverse("");
                            var decimalString = "";
                            if (value.includes(".")) {
                                decimalString = value.splice(0, value.indexOf(".") + 1).reverse().join("");
                                while (decimalString.length !== decimalString.indexOf(".") + 3) {
                                    decimalString += "0";
                                }
                            } else {
                                decimalString = ".00";
                            }
                            var result = [ [] ];
                            for (var i = 0; i < value.length; i++) {
                                if (result[result.length - 1].length === 0 || result[result.length - 1].length % 3) {
                                    result[result.length - 1].push(value[i]);
                                } else {
                                    result.push([ value[i] ]);
                                }
                            }
                            return result.map(function(el) {
                                _newArrowCheck(this, _this3);
                                return el.reverse().join("");
                            }.bind(this)).reverse().join(",") + decimalString;
                        }
                        return "";
                    }
                }, {
                    key: "moneyDecimalFloatClean",
                    value: function moneyDecimalFloatClean(value) {
                        return value.replace(/[^0-9.]/g, "");
                    }
                }, {
                    key: "decimalFloatToCommaFloat",
                    value: function decimalFloatToCommaFloat(value) {
                        var _this4 = this;
                        return value.replace(/[,.]/g, function($1) {
                            _newArrowCheck(this, _this4);
                            return $1 === "." ? "," : "";
                        }.bind(this));
                    }
                }, {
                    key: "percentageCommaInteger",
                    value: function percentageCommaInteger(value) {
                        var _this5 = this;
                        if (!/^(\d|,)/.test(value)) {
                            value = value.substr(1);
                        }
                        var testFormatWithComma = /^((\d{1,3})+(,?\d{3})*)?(^\.)?\%?$/.test(value);
                        var testDigits = /\d/g.test(value);
                        if (testFormatWithComma && testDigits && value.length) {
                            value = parseInt(value.replace(/[^0-9]/g, ""));
                            return "".concat(value.toString().split("").reverse().reduce(function(acc, value, i) {
                                _newArrowCheck(this, _this5);
                                return value === "-" ? acc : value + (i && !(i % 3) ? "," : "") + acc;
                            }.bind(this), ""));
                        }
                        return "";
                    }
                }, {
                    key: "percentageCommaIntegerClean",
                    value: function percentageCommaIntegerClean(value) {
                        return value.replace(/[^0-9]/g, "");
                    }
                }, {
                    key: "percentageDecimalInteger",
                    value: function percentageDecimalInteger(value) {
                        var _this6 = this;
                        if (!/^(\d|,)/.test(value)) {
                            value = value.substr(1);
                        }
                        var testFormatWithDecimal = /^((\d{1,3})+(.?\d{3})*)?(^\,)?\%?$/.test(value);
                        var testDigits = /\d/g.test(value);
                        if (testFormatWithDecimal && testDigits && value.length) {
                            value = parseInt(value.replace(/[^0-9]/g, ""));
                            return "".concat(value.toString().split("").reverse().reduce(function(acc, value, i) {
                                _newArrowCheck(this, _this6);
                                return value === "-" ? acc : value + (i && !(i % 3) ? "." : "") + acc;
                            }.bind(this), ""));
                        }
                        return "";
                    }
                }, {
                    key: "percentageDecimalIntegerClean",
                    value: function percentageDecimalIntegerClean(value) {
                        return value.replace(/[^0-9]/g, "");
                    }
                }, {
                    key: "percentageCommaFloat",
                    value: function percentageCommaFloat(value, floatDigits) {
                        var _this7 = this;
                        if (!/^(\d|,)/.test(value)) {
                            value = value.substr(1);
                        }
                        var regExp = new RegExp("^((\\d{1,3})+(\\.?\\d{3})*)?(,)?(\\d{1,".concat(floatDigits, "})?\\%?$"));
                        console.log(regExp);
                        var testFormatWithComma = regExp.test(value);
                        var test2 = /\d/g.test(value);
                        if (testFormatWithComma && test2 && value.length) {
                            value = value.replace(/[^0-9,]/g, "").replace(/,/g, ".");
                            value = (value > 0 ? Math.floor(value * 1e3) / 1e3 : Math.ceil(value * 1e3) / 1e3).toFixed(floatDigits).split(".");
                            return "".concat(value[0].split("").reverse().reduce(function(acc, value, i) {
                                _newArrowCheck(this, _this7);
                                return value === "-" ? acc : value + (i && !(i % 3) ? "." : "") + acc;
                            }.bind(this), ""), ",").concat(value[1]);
                        }
                        return "";
                    }
                }, {
                    key: "percentageCommaFloatClean",
                    value: function percentageCommaFloatClean(value) {
                        return value.replace(/[^0-9,]/g, "");
                    }
                }, {
                    key: "percentageDecimalFloat",
                    value: function percentageDecimalFloat(value, floatDigits) {
                        var _this8 = this;
                        if (!/^(\d|\.)/.test(value)) {
                            value = value.substr(1);
                        }
                        var regExp = new RegExp("^((\\d{1,3})+(,?\\d{3})*)?(\\.)?(\\d{1,".concat(floatDigits, "})?\\%?$"));
                        var testFormatWithDecimal = regExp.test(value);
                        var test2 = /\d/g.test(value);
                        if (testFormatWithDecimal && test2 && value.length) {
                            value = parseFloat(value.replace(/[^0-9.]/g, ""));
                            value = (value > 0 ? Math.floor(value * 1e3) / 1e3 : Math.ceil(value * 1e3) / 1e3).toFixed(floatDigits).split(".");
                            return "".concat(value[0].split("").reverse().reduce(function(acc, value, i) {
                                _newArrowCheck(this, _this8);
                                return value === "-" ? acc : value + (i && !(i % 3) ? "," : "") + acc;
                            }.bind(this), ""), ".").concat(value[1]);
                        }
                        return "";
                    }
                }, {
                    key: "percentageDecimalFloatClean",
                    value: function percentageDecimalFloatClean(value) {
                        return value.replace(/[^0-9.]/g, "");
                    }
                }, {
                    key: "phone",
                    value: function phone(value) {
                        value = value.replace(/\D+/g, "");
                        if (value.length <= 3) {
                            return value;
                        }
                        if (value.length <= 6) {
                            return "".concat(value.substring(0, 3), "-").concat(value.substring(3, 6));
                        }
                        return "".concat(value.substring(0, 3), "-").concat(value.substring(3, 6), "-").concat(value.substring(6));
                    }
                }, {
                    key: "ssn",
                    value: function ssn(value) {
                        value = value.replace(/\D+/g, "");
                        if (value.length <= 3) {
                            return value;
                        }
                        if (value.length <= 5) {
                            return "".concat(value.substring(0, 3), "-").concat(value.substring(3, 5));
                        }
                        return "".concat(value.substring(0, 3), "-").concat(value.substring(3, 5), "-").concat(value.substring(5));
                    }
                }, {
                    key: "password",
                    value: function password(value) {
                        return value;
                    }
                }, {
                    key: "pin",
                    value: function pin(value) {
                        return value.replace(/\D+/g, "");
                    }
                }, {
                    key: "taxid",
                    value: function taxid(value) {
                        return value.replace(/\D+/g, "");
                    }
                }, {
                    key: "dl",
                    value: function dl(value) {
                        return value.replace(/\D+/g, "");
                    }
                }, {
                    key: "numeric",
                    value: function numeric(value) {
                        return value.replace(/\D+/g, "");
                    }
                } ]);
                return Formatters;
            }();
        },
        "./src/text-input/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _abstract_text_field__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/abstract-text-field/index.js");
            var _mds_text_input_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/text-input/mds-text-input.scss");
            var _mds_text_input_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_text_input_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _MdsTextInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/text-input/MdsTextInput.jsx");
            var _formatters__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/text-input/formatters.js");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_form_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/utils/form-utils.js");
            var _error_message__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/text-input/error-message/index.jsx");
            var _text_input_button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("./src/text-input/text-input-button/index.jsx");
            var _dec, _class, _class2;
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["mixins"].AttributeMarshallingMixin, arrayOf = _mixins$AttributeMars.arrayOf, stamp = _mixins$AttributeMars.stamp, boolean = _mixins$AttributeMars.boolean, number = _mixins$AttributeMars.number, string = _mixins$AttributeMars.string, enumerables = _mixins$AttributeMars.enumerables;
            var textInputEntity = {
                autocompleteValue: string.defaultsTo("off"),
                centered: boolean.defaultsTo(false),
                characterCountText: arrayOf(string).defaultsTo([ "of", "characters remaining.", "Character overlimit:" ]),
                currencySymbol: string.defaultsTo(""),
                hero: boolean.defaultsTo(false),
                fieldPrefix: string,
                fieldSuffix: string,
                floatDigits: enumerables(number, 1, 2, 3),
                format: enumerables(string, "credit", "moneyCommaFloat", "moneyDecimalFloat", "moneyInteger", "percentageCommaFloat", "percentageDecimalFloat", "percentageCommaInteger", "percentageDecimalInteger", "phone", "ssn", "email", "").withChangedCallback(),
                labelStyle: enumerables(string, "horizontal", "vertical", "floating", "hidden").defaultsTo("vertical").withChangedCallback(),
                maxLength: number,
                multiline: boolean.defaultsTo(false),
                defaultHeight: string.withChangedCallback(),
                value: string.defaultsTo("").withChangedCallback(),
                inactive: boolean.defaultsTo(false).withChangedCallback(),
                fieldSuffixAccessibleText: string,
                waitingState: boolean,
                waitingStateAccessibleText: string
            };
            var entity = _objectSpread({}, _abstract_text_field__WEBPACK_IMPORTED_MODULE_1__["entity"], {}, textInputEntity);
            var MdsTextInput = (_dec = stamp(entity), _dec(_class = (_class2 = function(_AbstractTextField) {
                _inherits(MdsTextInput, _AbstractTextField);
                _createClass(MdsTextInput, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsTextInput";
                    }
                } ]);
                function MdsTextInput() {
                    var _this;
                    _classCallCheck(this, MdsTextInput);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsTextInput).call(this));
                    _this._getEventProps = _this._getEventProps.bind(_assertThisInitialized(_this));
                    _this._validate = _this._validate.bind(_assertThisInitialized(_this));
                    _this._dispatchIconButtonClickEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["createCustomEventDispatcher"])();
                    _this._handleBlur = _this._handleBlur.bind(_assertThisInitialized(_this));
                    _this._handleFocus = _this._handleFocus.bind(_assertThisInitialized(_this));
                    _this._preventDefaultOnMousedown = _utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["preventDefault"];
                    _this._handleButtonKeydown = _this._handleButtonKeydown.bind(_assertThisInitialized(_this));
                    _this.defineObservedProperty("_ariaLiveActive", false);
                    _this.defineObservedProperty("_isFocused", false);
                    _this.defineObservedProperty("_hideFormattedValue", true);
                    _this.defineObservedProperty("formattedValue", "");
                    _this.defineObservedProperty("aria", {});
                    _this.defineObservedProperty("_maxLengthExceeded", false);
                    _this.defineObservedProperty("_hideIconButton", false);
                    return _this;
                }
                _createClass(MdsTextInput, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        var _this2 = this;
                        _get(_getPrototypeOf(MdsTextInput.prototype), "connectedCallback", this).call(this);
                        var _this$getRootNode = this.getRootNode(), host = _this$getRootNode.host;
                        this._hostName = host ? host.localName : null;
                        this._hideIconButton = this._hostName === "mds-search-box";
                        setTimeout(function() {
                            _newArrowCheck(this, _this2);
                            this._connected = true;
                            this.formatChangedCallback(this.format);
                            !this._formAssociatedInput && _utils_form_utils__WEBPACK_IMPORTED_MODULE_6__["createFormAssociatedInput"].call(this, {
                                disabled: this.inactive || !this.value
                            });
                            if (this.value && this._setFormattedValue(this.value)) {
                                this._setTextFieldValue();
                            }
                            this.defaultHeightChangedCallback();
                        }.bind(this));
                    }
                }, {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        if (!payload.target) {
                            return {
                                interactiveElement: this._textFieldNode
                            };
                        }
                        return _get(_getPrototypeOf(MdsTextInput.prototype), "_getInteractiveElement", this).call(this, {
                            target: "".concat(payload.target)
                        });
                    }
                }, {
                    key: "_getEventProps",
                    value: function _getEventProps() {
                        return {
                            onclick: this._onclick,
                            onchange: this._onchange,
                            onfocus: this._handleFocus,
                            onblur: this._handleBlur,
                            onkeydown: this._onkeydown,
                            onkeyup: this._onkeyup,
                            onmousedown: this._onmousedown,
                            onmouseup: this._onmouseup,
                            onmouseover: this._onmouseover,
                            onmouseenter: this._onmouseenter,
                            onmouseout: this._onmouseout,
                            oninput: this._oninput
                        };
                    }
                }, {
                    key: "formatChangedCallback",
                    value: function formatChangedCallback(format) {
                        if (format) {
                            this._formattedTextNode = this.shadowRoot.querySelector(".mds-text-input__formatted-text");
                            if (format === "ssn") {
                                this.ssn = this.value;
                            }
                        }
                    }
                }, {
                    key: "_validate",
                    value: function _validate(event) {
                        if (event.type === "blur") {
                            var blurEvent = event.detail || event;
                            if (!this.shadowRoot.contains(blurEvent.relatedTarget || document.activeElement)) {
                                this.dispatchEvent(new CustomEvent("validate", {
                                    detail: {
                                        original: event,
                                        target: event.target
                                    },
                                    bubbles: true,
                                    composed: true
                                }));
                            }
                        } else if (event.type === "input") {
                            this.dispatchEvent(new CustomEvent("validate", {
                                detail: {
                                    original: event,
                                    target: event.target
                                },
                                bubbles: true,
                                composed: true
                            }));
                        }
                    }
                }, {
                    key: "_setFormattedValue",
                    value: function _setFormattedValue(value) {
                        var formattedValueIsSet = false;
                        if (this.format && ![ "email" ].includes(this.format)) {
                            if (this._maxLengthExceeded) {
                                this.formattedValue = "";
                            } else if (this.format.includes("money") || this.format.includes("percentage")) {
                                this.formattedValue = _formatters__WEBPACK_IMPORTED_MODULE_4__["default"][this.format](value, this.floatDigits || 3);
                            } else {
                                this.formattedValue = _formatters__WEBPACK_IMPORTED_MODULE_4__["default"][this.format](value);
                            }
                            formattedValueIsSet = true;
                        }
                        return formattedValueIsSet;
                    }
                }, {
                    key: "_setTextFieldValue",
                    value: function _setTextFieldValue() {
                        if (this._textFieldNode) {
                            if (this.format && this.format.includes("percentage")) {
                                this._textFieldNode.value = this.formattedValue.length ? "".concat(this.formattedValue, "%") : this.value;
                            } else {
                                this._textFieldNode.value = this.formattedValue.length ? this.currencySymbol + this.formattedValue : this.value;
                            }
                        }
                    }
                }, {
                    key: "_handleTextFieldFormatting",
                    value: function _handleTextFieldFormatting() {
                        this._hideFormattedValue = true;
                        if ((this.format.includes("money") || this.format.includes("percentage")) && this.formattedValue.length) {
                            this.value = _formatters__WEBPACK_IMPORTED_MODULE_4__["default"]["".concat(this.format, "Clean")](this.formattedValue);
                        }
                        this._setTextFieldValue();
                    }
                }, {
                    key: "_handleBlur",
                    value: function _handleBlur(event) {
                        var _originalEvent = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["originalEvent"])(event), relatedTarget = _originalEvent.relatedTarget;
                        if (this.format && relatedTarget !== this._textFieldNode) {
                            this._handleTextFieldFormatting();
                        }
                        if (!this.shadowRoot.contains(relatedTarget)) {
                            this._validate(event);
                            _utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["setAriaLiveText"].call(this);
                            this._isFocused = false;
                            _get(_getPrototypeOf(MdsTextInput.prototype), "_onblur", this) && _get(_getPrototypeOf(MdsTextInput.prototype), "_onblur", this).call(this, event);
                        } else {
                            event.stopPropagation();
                        }
                    }
                }, {
                    key: "_selectValue",
                    value: function _selectValue(e) {
                        if (e.detail.key === "Tab") {
                            this.select();
                            this.removeEventListener("keyup", this._selectValue);
                        }
                    }
                }, {
                    key: "_handleFocus",
                    value: function _handleFocus(event) {
                        var _originalEvent2 = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["originalEvent"])(event), target = _originalEvent2.target, relatedTarget = _originalEvent2.relatedTarget;
                        if (this.format && target === this._textFieldNode) {
                            this._hideFormattedValue = false;
                            this._textFieldNode.value = this.value;
                            this.addEventListener("keyup", this._selectValue);
                        }
                        if (!this.shadowRoot.contains(relatedTarget)) {
                            this._isFocused = true;
                            _get(_getPrototypeOf(MdsTextInput.prototype), "_onfocus", this) && _get(_getPrototypeOf(MdsTextInput.prototype), "_onfocus", this).call(this, event);
                        } else {
                            event.stopPropagation();
                        }
                    }
                }, {
                    key: "_handleButtonKeydown",
                    value: function _handleButtonKeydown(event) {
                        var _this3 = this;
                        var originEvent = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["originalEvent"])(event);
                        if (originEvent.keyCode == 9 && originEvent.shiftKey) {
                            var textInput = this.closest("mds-text-input");
                            setTimeout(function() {
                                _newArrowCheck(this, _this3);
                                textInput.focus();
                                this._isFocused = true;
                            }.bind(this));
                        }
                    }
                }, {
                    key: "valueChangedCallback",
                    value: function valueChangedCallback() {
                        if (this.value) {
                            if (this.maxLength) {
                                this._maxLengthExceeded = this.value.length > this.maxLength;
                            }
                            if (this._setFormattedValue(this.value) && !this._inputFired && !this._isFocused) {
                                this._setTextFieldValue();
                            }
                        } else {
                            this._maxLengthExceeded = false;
                            this.formattedValue = "";
                        }
                        if (this.labelStyle === "floating") {
                            this._isFloating = !!this.value || !!this.shadowRoot.activeElement;
                        }
                        this._inputFired = false;
                        this._formAssociatedInput && _utils_form_utils__WEBPACK_IMPORTED_MODULE_6__["syncFormAssociatedInputValue"].call(this, this.value);
                    }
                }, {
                    key: "inactiveChangedCallback",
                    value: function inactiveChangedCallback(newValue) {
                        this._formAssociatedInput && _utils_form_utils__WEBPACK_IMPORTED_MODULE_6__["syncFormAssociatedInputDisabledValue"].call(this, newValue);
                    }
                }, {
                    key: "labelStyleChangedCallback",
                    value: function labelStyleChangedCallback() {
                        if (this.labelStyle === "floating") {
                            this.placeholder = "";
                        }
                    }
                }, {
                    key: "defaultHeightChangedCallback",
                    value: function defaultHeightChangedCallback() {
                        if (this._connected && this.multiline && this.defaultHeight) {
                            this._textFieldNode.style.height = this.defaultHeight;
                        }
                    }
                }, {
                    key: "_oninput",
                    value: function _oninput(event) {
                        var target = event.target;
                        if (target && target.selectionEnd) {
                            var currentPosition = target.selectionStart;
                            target.selectionEnd = currentPosition;
                        }
                        if (target) {
                            this.value = target.value;
                        }
                        this._inputFired = true;
                        _get(_getPrototypeOf(MdsTextInput.prototype), "_oninput", this) && _get(_getPrototypeOf(MdsTextInput.prototype), "_oninput", this).call(this, event);
                        if (!!this.errorMessage || !!this.errorMessages.length || this._maxLengthExceeded) {
                            this._validate(event);
                        }
                    }
                }, {
                    key: "_onkeydown",
                    value: function _onkeydown(event) {
                        _get(_getPrototypeOf(MdsTextInput.prototype), "_onkeydown", this) && _get(_getPrototypeOf(MdsTextInput.prototype), "_onkeydown", this).call(this, event);
                    }
                }, {
                    key: "render",
                    value: function render() {
                        if (this.labelStyle === "hidden" && !this.fieldPrefix) {
                            this.throwConstraintError('The mds-text-input must have a fieldPrefix in order to have labelStyle "hidden".');
                        }
                        if (this.waitingState && !this.waitingStateAccessibleText) {
                            this.throwConstraintError("The mds-text-input must have a waiting-state-accessible-text when in waiting state.");
                        }
                        _MdsTextInput__WEBPACK_IMPORTED_MODULE_3__["default"].call(this);
                    }
                } ]);
                return MdsTextInput;
            }(_abstract_text_field__WEBPACK_IMPORTED_MODULE_1__["default"]), _class2.styles = _mds_text_input_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsTextInput;
        },
        "./src/text-input/mds-text-input.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/text-input/mds-text-input.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/text-input/text-input-button/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_text_input_button_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/text-input/text-input-button/mds-text-input-button.scss");
            var _mds_text_input_button_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_text_input_button_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/button/index.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].enumerables;
            var entity = {
                textInputHost: string,
                textInputVariant: enumerables(string, "box", "line")
            };
            var MdsTextInputButton = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_MdsButton) {
                _inherits(MdsTextInputButton, _MdsButton);
                function MdsTextInputButton() {
                    _classCallCheck(this, MdsTextInputButton);
                    return _possibleConstructorReturn(this, _getPrototypeOf(MdsTextInputButton).apply(this, arguments));
                }
                _createClass(MdsTextInputButton, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsTextInputButton.prototype), "connectedCallback", this).call(this);
                        var _this$getRootNode = this.getRootNode(), host = _this$getRootNode.host;
                        if (!host || host.localName !== "mds-text-input") {
                            this.remove();
                            this.throwConstraintError("The MdsTextInputButton can only be used inside of the MdsTextInput.");
                        }
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var _this = this, _classes;
                        var classes = (_classes = {
                            "text-input-button": true
                        }, _defineProperty(_classes, "text-input-button--".concat(this.textInputVariant), true), 
                        _defineProperty(_classes, "text-input-button--clear", [ "mds-search-box", "mds-select" ].some(function(component) {
                            _newArrowCheck(this, _this);
                            return component === this.textInputHost;
                        }.bind(this))), _classes);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("button", null, null, "type", this.type, "class", classes, "disabled-prop", !!this.inactive, "aria-label", this.accessibleText, "onclick", this._onclick, "onblur", this._onblur, "onfocus", this._onfocus, "onkeydown", this._onkeydown, "onkeyup", this._onkeyup, "onmouseover", this._onmouseover, "onmouseenter", this._onmouseenter, "onmouseout", this._onmouseout);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "text-input-button__icon", "aria-label", this.iconAccessibleDescription, "innerHTML-prop", MDS.svgs[this.iconType], "__skip", "true");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("button");
                    }
                } ], [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsTextInputButton";
                    }
                } ]);
                return MdsTextInputButton;
            }(_button__WEBPACK_IMPORTED_MODULE_3__["default"]), _class2.styles = _mds_text_input_button_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsTextInputButton;
        },
        "./src/text-input/text-input-button/mds-text-input-button.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/text-input/text-input-button/mds-text-input-button.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/tile-accordion/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _tile_accordion_item__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/tile-accordion/tile-accordion-item/index.jsx");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _dec, _class;
            var _mdsTileAccordionItem$wrapper = function _mdsTileAccordionItem$wrapper(_accordionItem, _lock, _accordionItem$name) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("mds-tile-accordion-item");
                _spreadAttribute(_accordionItem);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("lock", _lock);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("mds-tile-accordion-item");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "name", _accordionItem$name);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-tile-accordion-item");
            };
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["mixins"].AttributeMarshallingMixin, arrayOf = _mixins$AttributeMars.arrayOf, boolean = _mixins$AttributeMars.boolean, string = _mixins$AttributeMars.string, enumerables = _mixins$AttributeMars.enumerables, satisfies = _mixins$AttributeMars.satisfies;
            var entity = {
                accordionItems: arrayOf(satisfies(_tile_accordion_item__WEBPACK_IMPORTED_MODULE_2__["entity"])),
                lock: boolean.defaultsTo(false)
            };
            var MdsTileAccordion = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = function(_AgaveComponent) {
                _inherits(MdsTileAccordion, _AgaveComponent);
                _createClass(MdsTileAccordion, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsTileAccordion";
                    }
                } ]);
                function MdsTileAccordion() {
                    var _this;
                    _classCallCheck(this, MdsTileAccordion);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsTileAccordion).call(this));
                    _this._onclick = _this._onclick.bind(_assertThisInitialized(_this));
                    _this._onblur = _this._onblur.bind(_assertThisInitialized(_this));
                    _this._onfocus = _this._onfocus.bind(_assertThisInitialized(_this));
                    _this._onkeydown = _this._onkeydown.bind(_assertThisInitialized(_this));
                    _this._onmouseover = _this._onmouseover.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsTileAccordion, [ {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                            index: 0
                        };
                        return {
                            interactiveElement: this.shadowRoot.querySelectorAll("mds-tile-accordion-item")[payload.index]
                        };
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var _this2 = this;
                        var accordionItems = this.accordionItems, lock = this.lock;
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "tile-accordion");
                        _renderArbitrary(accordionItems.map(function(accordionItem) {
                            _newArrowCheck(this, _this2);
                            return _jsxWrapper(_mdsTileAccordionItem$wrapper, [ accordionItem, lock, accordionItem.name ]);
                        }.bind(this)));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return MdsTileAccordion;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["AgaveComponent"])) || _class);
            __webpack_exports__["default"] = MdsTileAccordion;
        },
        "./src/tile-accordion/tile-accordion-item/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/common-utils.js");
            var _mds_tile_accordion_item_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/tile-accordion/tile-accordion-item/mds-tile-accordion-item.scss");
            var _mds_tile_accordion_item_scss__WEBPACK_IMPORTED_MODULE_3___default = __webpack_require__.n(_mds_tile_accordion_item_scss__WEBPACK_IMPORTED_MODULE_3__);
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["mixins"].AttributeMarshallingMixin, boolean = _mixins$AttributeMars.boolean, string = _mixins$AttributeMars.string, stringRequired = _mixins$AttributeMars.stringRequired, number = _mixins$AttributeMars.number;
            var entity = {
                name: stringRequired,
                label: stringRequired,
                tag: string,
                errorMessage: string,
                secondaryLabel: string,
                expanded: boolean.defaultsTo(false).withChangedCallback(),
                inactive: boolean.defaultsTo(false),
                lock: boolean,
                headingLevel: number.defaultsTo(2)
            };
            var MdsTileAccordionItem = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsTileAccordionItem, _AgaveComponent);
                _createClass(MdsTileAccordionItem, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsTileAccordionItem";
                    }
                } ]);
                function MdsTileAccordionItem() {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsTileAccordionItem);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsTileAccordionItem).call(this));
                    _this._onclick = _this._onclick.bind(_assertThisInitialized(_this));
                    _this._onblur = _this._onblur.bind(_assertThisInitialized(_this));
                    _this._onfocus = _this._onfocus.bind(_assertThisInitialized(_this));
                    _this._onkeydown = _this._onkeydown.bind(_assertThisInitialized(_this));
                    _this._onmouseover = _this._onmouseover.bind(_assertThisInitialized(_this));
                    _this.handleAccordionState = _this.handleAccordionState.bind(_assertThisInitialized(_this));
                    _this.handleLockedGroup = _this.handleLockedGroup.bind(_assertThisInitialized(_this));
                    _this.expandAccordion = _this.expandAccordion.bind(_assertThisInitialized(_this));
                    _this.collapseAccordion = _this.collapseAccordion.bind(_assertThisInitialized(_this));
                    _this.calculatePanelHeight = _this.calculatePanelHeight.bind(_assertThisInitialized(_this));
                    _this._resizeListener = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["debounce"])(_this._resizeListener.bind(_assertThisInitialized(_this)), 100);
                    window.addEventListener("resize", _this._resizeListener);
                    _this.defineObservedProperty("_expanding", false);
                    _this.defineObservedProperty("_collapsing", false);
                    _this.defineObservedProperty("_transitioned", false);
                    _this.defineObservedProperty("_tileSize", Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["getBreakpoint"])() === "xs");
                    _this.dispatchCollapseEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "click-collapse-".concat(_this.name);
                    }.bind(this), _assertThisInitialized(_this));
                    _this.dispatchExpandEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "click-expand-".concat(_this.name);
                    }.bind(this), _assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsTileAccordionItem, [ {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        return {
                            interactiveElement: this.shadowRoot.querySelector(".tile-accordion-item__heading")
                        };
                    }
                }, {
                    key: "_resizeListener",
                    value: function _resizeListener() {
                        this._tileSize = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["getBreakpoint"])() === "xs";
                    }
                }, {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        var _this3 = this;
                        _get(_getPrototypeOf(MdsTileAccordionItem.prototype), "connectedCallback", this).call(this);
                        this.handleAccordionState();
                        _toConsumableArray(this.parentElement.children).forEach(function(accordion, i) {
                            _newArrowCheck(this, _this3);
                            if (accordion.name === this.name) {
                                this._index = i;
                            }
                        }.bind(this));
                    }
                }, {
                    key: "disconnectedCallback",
                    value: function disconnectedCallback() {
                        _get(_getPrototypeOf(MdsTileAccordionItem.prototype), "disconnectedCallback", this) && _get(_getPrototypeOf(MdsTileAccordionItem.prototype), "disconnectedCallback", this).call(this);
                        window.removeEventListener("resize", this._resizeListener);
                    }
                }, {
                    key: "expandedChangedCallback",
                    value: function expandedChangedCallback() {
                        this.handleAccordionState();
                    }
                }, {
                    key: "handleLockedGroup",
                    value: function handleLockedGroup() {
                        var _this4 = this;
                        _toConsumableArray(this.parentElement.children).forEach(function(accordion) {
                            _newArrowCheck(this, _this4);
                            if (accordion.name !== this.name) {
                                accordion.expanded = false;
                            }
                        }.bind(this));
                    }
                }, {
                    key: "handleAccordionState",
                    value: function handleAccordionState(event) {
                        this.expanded ? this.expandAccordion(event) : this.collapseAccordion(event);
                    }
                }, {
                    key: "expandAccordion",
                    value: function expandAccordion(event) {
                        var _this5 = this;
                        var panelHeight = this.calculatePanelHeight();
                        this.shadowRoot.querySelector(".tile-accordion-item__panel").style.display = this.expanded ? "block" : "none";
                        this.shadowRoot.querySelector(".tile-accordion-item__panel").style.height = 0;
                        window.setTimeout(function() {
                            _newArrowCheck(this, _this5);
                            this._expanding = true;
                            this.shadowRoot.querySelector(".tile-accordion-item__panel").style.height = "".concat(panelHeight, "px");
                        }.bind(this), 10);
                        window.setTimeout(function() {
                            _newArrowCheck(this, _this5);
                            this._expanding = false;
                            this._transitioned = true;
                            var panel = this.shadowRoot.querySelector(".tile-accordion-item__panel");
                            panel.style.height = "auto";
                            panel.style.overflow = "unset";
                            event && this.dispatchExpandEvent(event);
                        }.bind(this), 200);
                    }
                }, {
                    key: "collapseAccordion",
                    value: function collapseAccordion(event) {
                        var _this6 = this;
                        var panel = this.shadowRoot.querySelector(".tile-accordion-item__panel");
                        var panelHeight = panel.scrollHeight;
                        panel.style.height = "".concat(panelHeight, "px");
                        window.setTimeout(function() {
                            _newArrowCheck(this, _this6);
                            this._collapsing = true;
                            panel.style.overflow = "";
                            panel.style.height = 0;
                        }.bind(this), 10);
                        window.setTimeout(function() {
                            _newArrowCheck(this, _this6);
                            this._collapsing = false;
                            this._transitioned = false;
                            panel.style.height = "auto";
                            panel.style.display = this.expanded ? "block" : "none";
                            event && this.dispatchCollapseEvent(event);
                        }.bind(this), 200);
                    }
                }, {
                    key: "calculatePanelHeight",
                    value: function calculatePanelHeight() {
                        var panel = this.shadowRoot.querySelector(".tile-accordion-item__panel");
                        var panelWidth = "".concat(this.shadowRoot.querySelector(".tile-accordion-item__heading-container").scrollWidth, "px");
                        _extends(panel.style, {
                            visibility: "hidden",
                            display: "flex",
                            position: "absolute",
                            width: panelWidth
                        });
                        var height = panel.scrollHeight;
                        _extends(panel.style, {
                            visibility: "",
                            display: "",
                            position: "",
                            width: "auto"
                        });
                        return height;
                    }
                }, {
                    key: "_onclick",
                    value: function _onclick(event) {
                        var _this7 = this;
                        _get(_getPrototypeOf(MdsTileAccordionItem.prototype), "_onclick", this) && _get(_getPrototypeOf(MdsTileAccordionItem.prototype), "_onclick", this).call(this, event);
                        !this.inactive && (this.expanded = !this.expanded);
                        event.stopPropagation();
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_2__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this7);
                            return "click";
                        }.bind(this), this)(event, _extends({}, event.detail, {
                            expanded: this.expanded,
                            index: this._index
                        }));
                        this.handleAccordionState(event);
                        this.lock && this.handleLockedGroup();
                    }
                }, {
                    key: "renderErrorMessage",
                    value: function renderErrorMessage() {
                        if (this.errorMessage) {
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("p", null, null, "class", "tile-accordion__error-message");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "tile-accordion__error-message-icon", "innerHTML-prop", MDS.svgs["ico_alert_filled"], "aria-hidden", "true", "__skip", "true");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "id", "".concat(this.name, "-error-message"));
                            _renderArbitrary(this.errorMessage);
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                            return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("p");
                        }
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var name = this.name, secondaryLabel = this.secondaryLabel, label = this.label, tag = this.tag, expanded = this.expanded, inactive = this.inactive, _tileSize = this._tileSize, _expanding = this._expanding, _collapsing = this._collapsing, _transitioned = this._transitioned, headingLevel = this.headingLevel;
                        var classes = {
                            "tile-accordion-item": true,
                            "tile-accordion-item--disabled": inactive
                        };
                        var headingClasses = {
                            "tile-accordion-item__heading": true,
                            "tile-accordion-item__heading--xs": _tileSize,
                            "tile-accordion-item__heading--expanded": expanded
                        };
                        var panelClasses = {
                            "tile-accordion-item__panel": true,
                            "tile-accordion-item__panel--xs": _tileSize,
                            "tile-accordion-item__panel--expanded": expanded,
                            "tile-accordion-item__panel--expanding": _expanding,
                            "tile-accordion-item__panel--collapsing": _transitioned && _collapsing,
                            "tile-accordion-item__panel--transitioned": _transitioned
                        };
                        var caretClasses = {
                            "tile-accordion-item__heading-caret-icon": true,
                            "tile-accordion-item__heading-caret-icon--expanded": expanded
                        };
                        var ruleClasses = {
                            "tile-accordion-item__rule": true,
                            "tile-accordion-item__rule--xs": _tileSize,
                            "tile-accordion-item__rule--expanded": expanded
                        };
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "tile-accordion-item__heading-container", "role", "heading", "aria-level", headingLevel);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("button", null, null, "class", headingClasses, "onclick", this._onclick, "disabled-prop", inactive, "aria-controls", "panel-".concat(name), "aria-expanded", expanded, "aria-disabled", inactive);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", caretClasses, "innerHTML-prop", MDS.svgs["ico_caret_right"], "aria-hidden", "true", "__skip", "true");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "tile-accordion-item__heading-labels");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "tile-accordion-item__heading-container");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "tile-accordion-item__heading-primary-label-container");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "tile-accordion-item__heading-primary-label");
                        _renderArbitrary(label);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        _renderArbitrary(tag && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-tag", null, null, "class", "tile-accordion-item__tag", "text", tag));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        _renderArbitrary(secondaryLabel && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "tile-accordion-item__heading-secondary-label"), 
                        _renderArbitrary(secondaryLabel), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        _renderArbitrary(this.renderErrorMessage());
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("button");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", ruleClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", panelClasses, "id", "panel-".concat(name));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "tile-accordion-item__panel-slot");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return MdsTileAccordionItem;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["AgaveComponent"]), _class2.styles = _mds_tile_accordion_item_scss__WEBPACK_IMPORTED_MODULE_3___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsTileAccordionItem;
        },
        "./src/tile-accordion/tile-accordion-item/mds-tile-accordion-item.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/tile-accordion/tile-accordion-item/mds-tile-accordion-item.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/tile/MdsTile.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _titleContent$wrapper = function _titleContent$wrapper(_conditionalAttribute, _headingClasses2, _this$tileTitleHeadin, _child, _class, _this$tileTitle, _child2, _child3) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "tile__title-container");
                _spreadAttribute(_conditionalAttribute);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", _headingClasses2, "aria-level", _this$tileTitleHeadin, "role", "heading");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "tile__title-text-container");
                _renderArbitrary(_child);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", _class);
                _renderArbitrary(_this$tileTitle);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                _renderArbitrary(_child2);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                _renderArbitrary(_child3);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }, _titleContent$wrapper2 = function _titleContent$wrapper2(_color, _this$titleIcon, _this$iconAccessibleD) {
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-icon", null, null, "size", "24", "color", _color, "type", _this$titleIcon, "accessible-text", _this$iconAccessibleD);
            }, _titleContent$wrapper3 = function _titleContent$wrapper3(_badgeClasses, _this$badge$labelValu, _this$badge$isAnimate, _this$badge$icon, _this$badge$accessibl) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "tile__badge-container");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-badge", null, null, "class", _badgeClasses, "label-value", _this$badge$labelValu, "is-animated", _this$badge$isAnimate, "icon", _this$badge$icon, "accessible-name", _this$badge$accessibl);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }, _titleContent$wrapper4 = function _titleContent$wrapper4(_subtitleClasses2, _this$tileSubtitle) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", _subtitleClasses2);
                _renderArbitrary(_this$tileSubtitle);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            }, _chevronContainer$wrapper = function _chevronContainer$wrapper(_chevronClasses, _MDS$svgs$CMB_MDS_TIL) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", _chevronClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "innerHTML-prop", _MDS$svgs$CMB_MDS_TIL, "aria-hidden", "true", "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }, _mdsButton$wrapper = function _mdsButton$wrapper(_conditionalAttribute2, _button, _tile__buttonTile__b, _this$_dispatchCustom, _this$_dispatchCustom2, _this$_dispatchCustom3, _this$_getCtaVariant, _widthType) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("mds-button");
                _spreadAttribute(_conditionalAttribute2);
                _spreadAttribute(_button);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", _tile__buttonTile__b);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onclick", _this$_dispatchCustom);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onblur", _this$_dispatchCustom2);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onfocus", _this$_dispatchCustom3);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("small", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("variant", _this$_getCtaVariant);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("width-type", _widthType);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("mds-button");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-button");
            }, _div$wrapper = function _div$wrapper(_mdsButton) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "tile__button-container");
                _renderArbitrary(_mdsButton);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            };
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _slicedToArray(arr, i) {
                return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
            }
            function _nonIterableRest() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            function _iterableToArrayLimit(arr, i) {
                var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
                if (null != _i) {
                    var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
                    try {
                        if (_x = (_i = _i.call(arr)).next, 0 === i) {
                            if (Object(_i) !== _i) return;
                            _n = !1;
                        } else for (;!(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) ;
                    } catch (err) {
                        _d = !0, _e = err;
                    } finally {
                        try {
                            if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
                        } finally {
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
            }
            function _arrayWithHoles(arr) {
                if (Array.isArray(arr)) return arr;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function renderTitle() {
                var _headingClasses, _subtitleClasses;
                var headingClasses = (_headingClasses = {
                    tile__title: true
                }, _defineProperty(_headingClasses, "tile__title--".concat(this.variant), true), 
                _defineProperty(_headingClasses, "tile__title--disabled", !this.interactive), _defineProperty(_headingClasses, "tile__title--inverse", this.variant === "hero" && this.inverse), 
                _headingClasses);
                var chevronClasses = {
                    "tile__title-chevron": true,
                    "tile__title-chevron--next": this.variant === "next",
                    "tile__title-chevron--inverse": this.variant === "hero" && this.inverse
                };
                var badgeClasses = {
                    "tile__title-badge": true,
                    "tile__title-badge-interactive": this.interactive
                };
                var subtitleClasses = (_subtitleClasses = {
                    "tile__title-sub": true
                }, _defineProperty(_subtitleClasses, "tile__title-sub--".concat(this.variant), true), 
                _defineProperty(_subtitleClasses, "tile__title-sub-with-icon", this.titleIcon), 
                _subtitleClasses);
                var shouldRenderSubtitle = (this.variant === "next" || this.variant === "hero") && this.tileTitle && this.tileSubtitle;
                var titleContent = _jsxWrapper(_titleContent$wrapper, [ Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    class: "tile__title--non-interactive"
                }, this.variant === "next" && !this.interactive), headingClasses, this.tileTitleHeadingLevel, this.titleIcon && _jsxWrapper(_titleContent$wrapper2, [ this.titleIconColor === "regular" ? "default" : this.titleIconColor, this.titleIcon, this.iconAccessibleDescription ]), "tile__title-primary tile__title-primary--".concat(this.variant), this.tileTitle, this.badge && this.badge.labelValue && (this.variant === "next" || this.variant === "hero") && _jsxWrapper(_titleContent$wrapper3, [ badgeClasses, this.badge.labelValue, this.badge.isAnimated, this.badge.icon, this.badge.accessibleName ]), shouldRenderSubtitle && _jsxWrapper(_titleContent$wrapper4, [ subtitleClasses, this.tileSubtitle ]) ]);
                var chevronContainer = _jsxWrapper(_chevronContainer$wrapper, [ chevronClasses, MDS.svgs["ico_chevron_right"] ]);
                if ((this.variant === "classic" || !this.interactive) && this.variant !== "hero") {
                    return titleContent;
                }
                var anchorClasses = {
                    "tile__heading-anchor": true,
                    "tile__heading-anchor--disabled": !this.interactive
                };
                var HEADING_ID = "heading";
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div");
                _renderArbitrary(this.interactive ? (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("a"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", anchorClasses), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", HEADING_ID), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("href", this.titleHref), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onclick", this._dispatchClickHeadingEvent), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onblur", this._dispatchBlurHeadingEvent), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onfocus", this._dispatchFocusHeadingEvent), 
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    tabindex: -1
                }, !this.interactive)), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("a"), 
                _renderArbitrary(titleContent), _renderArbitrary(this.interactive && chevronContainer), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("a")) : (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("span"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", anchorClasses), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", HEADING_ID), 
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    tabindex: -1
                }, !this.interactive)), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("span"), 
                _renderArbitrary(titleContent), _renderArbitrary(this.interactive && chevronContainer), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function renderButtons() {
                var _this = this;
                var buttons = this.buttons;
                var widthType = this._getCtaWidthType(buttons);
                return buttons.map(function(button, i) {
                    _newArrowCheck(this, _this);
                    var mdsButton = _jsxWrapper(_mdsButton$wrapper, [ Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                        id: "button".concat(i + 1)
                    }, !button.id), button, "tile__button tile__button--".concat(widthType), this._dispatchCustomEvent, this._dispatchCustomEvent, this._dispatchCustomEvent, this._getCtaVariant(button), widthType ]);
                    return this.variant === "next" ? mdsButton : _jsxWrapper(_div$wrapper, [ mdsButton ]);
                }.bind(this));
            }
            function renderLinks() {
                var _this2 = this;
                var links = this.links;
                var widthType = this._getCtaWidthType(links);
                return links.map(function(link, i) {
                    _newArrowCheck(this, _this2);
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "tile__link-container tile__link-container--".concat(widthType));
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("a", null, null, "id", "link".concat(i + 1), "class", "tile__link tile__link--".concat(this._getCtaVariant(link)), "href", link.href || "javascript:void(0)", "onclick", this._dispatchCustomEvent, "onblur", this._dispatchCustomEvent, "onfocus", this._dispatchCustomEvent);
                    _renderArbitrary(link.text);
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("a");
                    return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                }.bind(this));
            }
            function renderTileImage() {
                var imageClasses = _defineProperty({
                    tile__image: true
                }, "tile__image--".concat(this.imagePositionHorizontal, "-").concat(this.imagePositionVertical), true);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("img");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", imageClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("src", this.image);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("alt", this.imageAltText);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    style: {
                        height: "".concat(this.imageHeight, "px")
                    }
                }, this.imageHeight));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("img");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("img");
            }
            function renderNextFooter() {
                var ctaConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var helpButtonEnabled = this.helpButtonEnabled, helpButtonLabel = this.helpButtonLabel, helpButtonAccessibleText = this.helpButtonAccessibleText;
                var hasValidCTAs = ctaConfig.items && ctaConfig.items.length < 3;
                var isMissingHelpButtonLabel = helpButtonEnabled && !helpButtonLabel && !hasValidCTAs;
                var isMissingHelpButtonAccessibleText = helpButtonEnabled && !helpButtonAccessibleText && hasValidCTAs;
                var isMissingHelpButtonTooltip = helpButtonEnabled && hasValidCTAs && !helpButtonLabel;
                if (ctaConfig.items && !hasValidCTAs) {
                    this.throwConstraintError('The "next" tileStyle allows up to 2 CTA '.concat(ctaConfig.type, "s but ").concat(ctaConfig.items.length, " were provided."));
                }
                if (isMissingHelpButtonLabel) {
                    this.throwConstraintError("If helpButtonEnabled is true but no CTA buttons or links are provided, helpButtonLabel must be passed a value.");
                }
                if (isMissingHelpButtonAccessibleText) {
                    this.throwConstraintError("If helpButtonEnabled is true and CTA buttons or links are provided, helpButtonAccessibleText must be passed a value.");
                }
                if (isMissingHelpButtonTooltip) {
                    this.throwConstraintError("If helpButtonEnabled is true and CTA buttons or links are provided, helpButtonLabel must be passed a value.");
                }
                var footerClasses = {
                    tile__footer: true,
                    "tile__footer--with-help-button": helpButtonEnabled
                };
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", footerClasses);
                _renderArbitrary(helpButtonEnabled && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("mds-button"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "button-help"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "tile__help-button"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("icon-position", hasValidCTAs ? "icon_only" : "leading"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("icon-type", "ico_question_mark_circle"), 
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    text: helpButtonLabel
                }, !hasValidCTAs)), _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    "accessible-text": helpButtonAccessibleText
                }, hasValidCTAs)), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("variant", "tertiary"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("small", "true"), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onclick", this._dispatchCustomEvent), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onblur", this._dispatchCustomEvent), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onfocus", this._dispatchCustomEvent), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("mds-button"), 
                _renderArbitrary(hasValidCTAs && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-tooltip", null, null, "message", helpButtonLabel)), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("mds-button")));
                _renderArbitrary(hasValidCTAs && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "tile__cta-container tile__cta-container--".concat(this.tileCtaOrientation)), 
                _renderArbitrary(ctaConfig.type === "button" && renderButtons.call(this)), _renderArbitrary(ctaConfig.type === "link" && renderLinks.call(this)), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function renderClassicFooter() {
                var ctaConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var _moreButtonEnabled = this._moreButtonEnabled, iconAccessibleDescription = this.iconAccessibleDescription;
                var shouldRenderMoreButton = _moreButtonEnabled && ctaConfig.items && ctaConfig.items.length < 4;
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "tile__buttons");
                _renderArbitrary(ctaConfig.type === "button" && renderButtons.call(this));
                _renderArbitrary(ctaConfig.type === "link" && renderLinks.call(this));
                _renderArbitrary(shouldRenderMoreButton && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "tile__button-container"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-button", null, null, "id", "button-more", "onclick", this._dispatchCustomEvent, "onblur", this._dispatchCustomEvent, "onfocus", this._dispatchCustomEvent, "variant", "tertiary", "icon-position", "icon_only", "icon-type", "ico_ellipsis", "icon-accessible-description", iconAccessibleDescription, "accessible-text", iconAccessibleDescription), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function renderFooterContent() {
                var _this3 = this;
                var buttons = this.buttons, links = this.links, variant = this.variant;
                var _map = [ buttons, links ].map(function(el) {
                    _newArrowCheck(this, _this3);
                    return el && el.length > 0;
                }.bind(this)), _map2 = _slicedToArray(_map, 2), hasButtons = _map2[0], hasLinks = _map2[1];
                if (hasButtons && hasLinks) {
                    this.throwConstraintError("Buttons and Links cannot both be used for CTAs.");
                }
                if (hasButtons || hasLinks) {
                    var ctaConfig = {
                        type: hasButtons ? "button" : "link",
                        items: hasButtons ? buttons : links
                    };
                    return variant === "classic" ? renderClassicFooter.call(this, ctaConfig) : renderNextFooter.call(this, ctaConfig);
                }
                if (variant === "next" && this.helpButtonEnabled) {
                    return renderNextFooter.call(this);
                }
                return "";
            }
            function renderTile() {
                var _classes, _tileWrapperClasses;
                var tileTitle = this.tileTitle, hideTitle = this.hideTitle, inverse = this.inverse, tileStyle = this.tileStyle, _this$variant = this.variant, variant = _this$variant === void 0 ? tileStyle : _this$variant, stackedTile = this.stackedTile, image = this.image;
                var isClassicInteractive = variant === "classic" && this.interactive;
                var isFootContentSupported = variant !== "hero";
                var classes = (_classes = {
                    tile: true
                }, _defineProperty(_classes, "tile--".concat(variant), true), _defineProperty(_classes, "tile--inverse", variant === "hero" && inverse), 
                _defineProperty(_classes, "tile--hero--stacked", variant === "hero" && stackedTile), 
                _classes);
                var tileWrapperClasses = (_tileWrapperClasses = {
                    tile__wrapper: true
                }, _defineProperty(_tileWrapperClasses, "tile__wrapper--".concat(variant), true), 
                _defineProperty(_tileWrapperClasses, "tile__wrapper--interactive", isClassicInteractive), 
                _defineProperty(_tileWrapperClasses, "tile__wrapper--without-title", hideTitle || !tileTitle), 
                _defineProperty(_tileWrapperClasses, "tile__wrapper--with-badge", this.badge && this.badge.labelValue && this.variant === "next"), 
                _tileWrapperClasses);
                var contentClasses = _defineProperty({
                    tile__content: true
                }, "tile__content--".concat(this.horizontalPadding), variant === "next" || variant === "hero");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes, "style", this._getTileBackground());
                _renderArbitrary(this._isImage && renderTileImage.call(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "tile");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", tileWrapperClasses);
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    onblur: this._dispatchBlurTileEvent,
                    onclick: this._dispatchClickTileEvent,
                    onfocus: this._dispatchFocusTileEvent,
                    onkeyup: this._fireClickTileOnSpace,
                    tabIndex: 0,
                    role: "link"
                }, isClassicInteractive));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                _renderArbitrary(!hideTitle && tileTitle && renderTitle.call(this));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", contentClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "name", "tile-content");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                _renderArbitrary(isFootContentSupported && renderFooterContent.call(this));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function renderStackedTile() {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "stacked-tile");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "name", "stacked-tile-content");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function MdsTileTemplate() {
                this._setVariantToTileStyle();
                var stackedTile = this.stackedTile, variant = this.variant;
                if (variant === "hero") {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div");
                    _renderArbitrary(renderTile.call(this));
                    _renderArbitrary(stackedTile && renderStackedTile.call(this));
                    return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                }
                return renderTile.call(this);
            }
            __webpack_exports__["default"] = MdsTileTemplate;
        },
        "./src/tile/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/button/index.js");
            var _badge__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/badge/index.jsx");
            var _mds_tile_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/tile/mds-tile.scss");
            var _mds_tile_scss__WEBPACK_IMPORTED_MODULE_3___default = __webpack_require__.n(_mds_tile_scss__WEBPACK_IMPORTED_MODULE_3__);
            var _MdsTile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/tile/MdsTile.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _slicedToArray(arr, i) {
                return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
            }
            function _nonIterableRest() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _iterableToArrayLimit(arr, i) {
                var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
                if (null != _i) {
                    var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
                    try {
                        if (_x = (_i = _i.call(arr)).next, 0 === i) {
                            if (Object(_i) !== _i) return;
                            _n = !1;
                        } else for (;!(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) ;
                    } catch (err) {
                        _d = !0, _e = err;
                    } finally {
                        try {
                            if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
                        } finally {
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
            }
            function _arrayWithHoles(arr) {
                if (Array.isArray(arr)) return arr;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["mixins"].AttributeMarshallingMixin, arrayOf = _mixins$AttributeMars.arrayOf, boolean = _mixins$AttributeMars.boolean, satisfies = _mixins$AttributeMars.satisfies, string = _mixins$AttributeMars.string, stringRequired = _mixins$AttributeMars.stringRequired, enumerables = _mixins$AttributeMars.enumerables, number = _mixins$AttributeMars.number;
            var linkEntity = {
                text: string,
                href: string,
                variant: enumerables(string, "secondary", "primary")
            };
            var gradientColorEntity = {
                color: string,
                position: number
            };
            var entity = {
                buttons: arrayOf(satisfies(_button__WEBPACK_IMPORTED_MODULE_1__["entity"])).withMaxLength(4).defaultsTo([]),
                helpButtonAccessibleText: string,
                helpButtonEnabled: boolean,
                helpButtonLabel: string,
                hideTitle: boolean.defaultsTo(false),
                horizontalPadding: enumerables(string, "regular", "none").defaultsTo("regular"),
                iconAccessibleDescription: string.defaultsTo("More"),
                interactive: boolean.defaultsTo(true),
                links: arrayOf(satisfies(linkEntity)).withMaxLength(4).defaultsTo([]),
                tileCtaOrientation: enumerables(string, "horizontal", "vertical").defaultsTo("horizontal"),
                tileStyle: enumerables(string, "classic", "next").defaultsTo("classic"),
                tileSubtitle: string,
                tileTitle: stringRequired,
                tileTitleHeadingLevel: number.defaultsTo(2).withMinSize(1).withMaxSize(6),
                titleHref: string.defaultsTo("javascript:void(0)"),
                titleIcon: enumerables.apply(void 0, [ string ].concat(_toConsumableArray(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["ICON_TYPES"]))),
                titleIconColor: enumerables(string, "regular", "interactive").defaultsTo("regular"),
                moreButton: boolean.defaultsTo(false).withChangedCallback(),
                moreButtonEnabled: boolean.defaultsTo(false).withChangedCallback(),
                variant: enumerables(string, "classic", "hero", "next"),
                stackedTile: boolean.defaultsTo(false),
                inverse: boolean.defaultsTo(false),
                backgroundColor: string,
                backgroundImage: string,
                gradientColors: arrayOf(satisfies(gradientColorEntity)).withMaxLength(2).defaultsTo([]),
                badge: satisfies(_badge__WEBPACK_IMPORTED_MODULE_2__["entity"]),
                image: string,
                imagePositionVertical: enumerables(string, "top", "center", "bottom").defaultsTo("center"),
                imagePositionHorizontal: enumerables(string, "left", "center", "right").defaultsTo("center"),
                imageHeight: number,
                imageAltText: string,
                minimumHeight: number
            };
            var MdsTile = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsTile, _AgaveComponent);
                _createClass(MdsTile, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsTile";
                    }
                } ]);
                function MdsTile() {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsTile);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsTile).call(this));
                    _this._dispatchCustomEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["createCustomEventDispatcher"])();
                    _this._dispatchClickHeadingEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "click-heading";
                    }.bind(this));
                    _this._dispatchFocusHeadingEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "focus-heading";
                    }.bind(this));
                    _this._dispatchBlurHeadingEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "blur-heading";
                    }.bind(this));
                    _this._dispatchClickTileEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "click-tile";
                    }.bind(this));
                    _this._dispatchBlurTileEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "blur-tile";
                    }.bind(this));
                    _this._dispatchFocusTileEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "focus-tile";
                    }.bind(this));
                    _this._fireClickTileOnSpace = _this._fireClickTileOnSpace.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsTile, [ {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        var interactiveElement = payload.target ? this.shadowRoot.getElementById(payload.target) : this.shadowRoot.querySelector("mds-button, a");
                        return {
                            interactiveElement: interactiveElement
                        };
                    }
                }, {
                    key: "moreButtonChangedCallback",
                    value: function moreButtonChangedCallback() {
                        if (this.moreButton) {
                            console.warn("moreButton is deprecated since Sept-1-2022, use moreButtonEnabled instead.");
                        }
                        this.moreButtonEnabled = this.moreButton;
                    }
                }, {
                    key: "moreButtonEnabledChangedCallback",
                    value: function moreButtonEnabledChangedCallback() {
                        this._setMoreButtonEnabled();
                    }
                }, {
                    key: "_fireClickTileOnSpace",
                    value: function _fireClickTileOnSpace(event) {
                        if (event.keyCode === 32) {
                            this._dispatchClickTileEvent(event);
                        }
                    }
                }, {
                    key: "_getCtaVariant",
                    value: function _getCtaVariant(cta) {
                        if (this.variant === "classic") {
                            return "tertiary";
                        }
                        return cta.variant === "primary" ? "primary" : "secondary";
                    }
                }, {
                    key: "_getCtaWidthType",
                    value: function _getCtaWidthType(ctas) {
                        var _this3 = this;
                        if (this.variant === "classic") {
                            return "content";
                        }
                        if (this.tileCtaOrientation === "vertical") {
                            return "layout";
                        }
                        return ctas.some(function(cta) {
                            _newArrowCheck(this, _this3);
                            return cta["width-type"] === "layout";
                        }.bind(this)) ? "layout" : "content";
                    }
                }, {
                    key: "_setVariantToTileStyle",
                    value: function _setVariantToTileStyle() {
                        if (!this.variant && this.tileStyle) {
                            this.variant = this.tileStyle;
                            console.warn("tileStyle is deprecated, use variant instead.");
                        }
                    }
                }, {
                    key: "_setMoreButtonEnabled",
                    value: function _setMoreButtonEnabled() {
                        this._moreButtonEnabled = this.moreButtonEnabled;
                    }
                }, {
                    key: "_getTileBackgroundColorStyle",
                    value: function _getTileBackgroundColorStyle() {
                        return "background-color: ".concat(this.backgroundColor, "; border-width: 1px;");
                    }
                }, {
                    key: "_getTileBackgroundImageOrBackgroundGradientStyle",
                    value: function _getTileBackgroundImageOrBackgroundGradientStyle() {
                        var _this$gradientColors = _slicedToArray(this.gradientColors, 2), gradientColorStart = _this$gradientColors[0], gradientColorEnd = _this$gradientColors[1];
                        if (!this.backgroundImage && gradientColorStart && gradientColorEnd) {
                            return "background-image: linear-gradient(180deg, ".concat(gradientColorStart.color, " ").concat(gradientColorStart.position, "%, ").concat(gradientColorEnd.color, " ").concat(gradientColorEnd.position, "%); border: 0;");
                        } else if (this.backgroundImage && gradientColorStart && gradientColorEnd) {
                            return "background-image: url(".concat(this.backgroundImage, "), linear-gradient(180deg, ").concat(gradientColorStart.color, " ").concat(gradientColorStart.position, "%, ").concat(gradientColorEnd.color, " ").concat(gradientColorEnd.position, "%);\n              background-size: 100%;\n              background-repeat: no-repeat;\n              background-position: top;\n              border: 0;");
                        } else if (this.backgroundImage && (!gradientColorStart || !gradientColorEnd)) {
                            return "background-image: url(".concat(this.backgroundImage, ");\n              background-size: 100%;\n              background-repeat: no-repeat;\n              background-position: top;\n              border: 0;");
                        }
                    }
                }, {
                    key: "_getTileBackground",
                    value: function _getTileBackground() {
                        var tileBackgroundStyle = "";
                        if (this.variant && this.variant === "hero") {
                            if (this.backgroundColor) {
                                tileBackgroundStyle = this._getTileBackgroundColorStyle();
                            }
                            if (this.backgroundImage || this.gradientColors && this.gradientColors.length === 2) {
                                tileBackgroundStyle = tileBackgroundStyle + this._getTileBackgroundImageOrBackgroundGradientStyle();
                            }
                        }
                        if (this.variant === "next" && this.minimumHeight) {
                            tileBackgroundStyle = "min-height: ".concat(this.minimumHeight, "px;");
                        }
                        return tileBackgroundStyle;
                    }
                }, {
                    key: "renderedCallback",
                    value: function renderedCallback() {
                        this.resizeBadgeWidth();
                    }
                }, {
                    key: "resizeBadgeWidth",
                    value: function resizeBadgeWidth() {
                        if (this.badge && this.badge.labelValue) {
                            var titleContainerWidth = this.shadowRoot.querySelector(".tile__title").offsetWidth;
                            var badgeWidth = this.shadowRoot.querySelector(".tile__badge-container").offsetWidth;
                            var titleWidth = this.shadowRoot.querySelector(".tile__title-text-container").offsetWidth;
                            if (badgeWidth >= titleContainerWidth || badgeWidth > titleWidth && badgeWidth + titleWidth > titleContainerWidth) {
                                this.shadowRoot.querySelector(".tile__title").classList.add("tile__title-column");
                            } else {
                                this.shadowRoot.querySelector(".tile__title").classList.remove("tile__title-column");
                            }
                        }
                    }
                }, {
                    key: "render",
                    value: function render() {
                        if (this.variant == "next" && this.image && !this.imageAltText) {
                            this.throwConstraintError("When supplying an image, imageAltText is required");
                        }
                        _MdsTile__WEBPACK_IMPORTED_MODULE_4__["default"].call(this);
                    }
                }, {
                    key: "_isImage",
                    get: function get() {
                        return this.variant === "next" && !!this.image;
                    }
                } ]);
                return MdsTile;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["AgaveComponent"]), _class2.styles = _mds_tile_scss__WEBPACK_IMPORTED_MODULE_3___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsTile;
        },
        "./src/tile/mds-tile.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/tile/mds-tile.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/utils/date-utils.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "isToday", (function() {
                return isToday;
            }));
            __webpack_require__.d(__webpack_exports__, "toShortDate", (function() {
                return toShortDate;
            }));
            __webpack_require__.d(__webpack_exports__, "toMonthDate", (function() {
                return toMonthDate;
            }));
            __webpack_require__.d(__webpack_exports__, "getNextMonthIndex", (function() {
                return getNextMonthIndex;
            }));
            __webpack_require__.d(__webpack_exports__, "getPrevMonthIndex", (function() {
                return getPrevMonthIndex;
            }));
            __webpack_require__.d(__webpack_exports__, "getDaysInMonth", (function() {
                return getDaysInMonth;
            }));
            __webpack_require__.d(__webpack_exports__, "getMonthFromString", (function() {
                return getMonthFromString;
            }));
            __webpack_require__.d(__webpack_exports__, "getDayFromString", (function() {
                return getDayFromString;
            }));
            __webpack_require__.d(__webpack_exports__, "getYearFromString", (function() {
                return getYearFromString;
            }));
            __webpack_require__.d(__webpack_exports__, "checkCharacters", (function() {
                return checkCharacters;
            }));
            __webpack_require__.d(__webpack_exports__, "interpretDate", (function() {
                return interpretDate;
            }));
            __webpack_require__.d(__webpack_exports__, "interpretMonth", (function() {
                return interpretMonth;
            }));
            function _createForOfIteratorHelper(o, allowArrayLike) {
                var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                if (!it) {
                    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                        if (it) o = it;
                        var i = 0;
                        var F = function F() {};
                        return {
                            s: F,
                            n: function n() {
                                if (i >= o.length) return {
                                    done: true
                                };
                                return {
                                    done: false,
                                    value: o[i++]
                                };
                            },
                            e: function e(_e) {
                                throw _e;
                            },
                            f: F
                        };
                    }
                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                var normalCompletion = true, didErr = false, err;
                return {
                    s: function s() {
                        it = it.call(o);
                    },
                    n: function n() {
                        var step = it.next();
                        normalCompletion = step.done;
                        return step;
                    },
                    e: function e(_e2) {
                        didErr = true;
                        err = _e2;
                    },
                    f: function f() {
                        try {
                            if (!normalCompletion && it.return != null) it.return();
                        } finally {
                            if (didErr) throw err;
                        }
                    }
                };
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            function isToday(date) {
                var today = new Date;
                return date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
            }
            function toShortDate(date) {
                var month = (date.getMonth() + 1).toString().padStart(2, "0");
                var day = date.getDate().toString().padStart(2, "0");
                return "".concat(month, "/").concat(day, "/").concat(date.getFullYear());
            }
            function toMonthDate(date) {
                var month = (date.getMonth() + 1).toString().padStart(2, "0");
                return "".concat(month, "/").concat(date.getFullYear());
            }
            function getNextMonthIndex(monthIndex) {
                return (monthIndex + 1) % 12;
            }
            function getPrevMonthIndex(monthIndex) {
                return monthIndex === 0 ? 11 : monthIndex - 1;
            }
            function getDaysInMonth(monthIndex) {
                var year = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (new Date).getFullYear();
                return new Date(year, monthIndex + 1, 0).getDate();
            }
            function getMonthFromString(value) {
                if (typeof value !== "string" || value.length < 2) {
                    throw Error("Argument must be a string with a minimum length of 2");
                }
                var firstTwoDigits = value.slice(0, 2);
                var monthNumber = Number(firstTwoDigits);
                var month;
                if (monthNumber < 1) {
                    month = "01";
                } else if (monthNumber > 12) {
                    month = "0".concat(firstTwoDigits[0]);
                }
                return month || firstTwoDigits;
            }
            function getDayFromString(value, month) {
                if (typeof value !== "string" || value.length > 2) {
                    throw Error("Argument must be a string with a maximum length of 2");
                }
                if (Number(value) === 0) {
                    return "01";
                }
                if (value.length === 1) {
                    return "0".concat(value);
                }
                var daysInMonth = getDaysInMonth(Number(month) - 1);
                if (daysInMonth >= Number(value)) {
                    return value;
                }
                return "0".concat(value[0]);
            }
            function getYearFromString(value) {
                var numberYear = Number(value);
                if (numberYear === 0) {
                    return (new Date).getFullYear();
                } else if (numberYear <= 999) {
                    return 2e3 + numberYear;
                }
                return numberYear;
            }
            function checkCharacters(str) {
                var charArr = [];
                var excludeChar = [ "/", "-", "0", " ", "." ];
                var _iterator = _createForOfIteratorHelper(str), _step;
                try {
                    for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                        var char = _step.value;
                        if (excludeChar.includes(char)) {
                            continue;
                        }
                        var isNumber = Number(char);
                        if (!isNumber) {
                            charArr.push(char);
                        }
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally {
                    _iterator.f();
                }
                if (charArr.length) {
                    return null;
                }
            }
            function interpretDate(inputValue) {
                if (!inputValue) {
                    return null;
                }
                if (!inputValue.replace(/\s+/g, "")) {
                    return null;
                }
                if (checkCharacters(inputValue) === null) {
                    return null;
                }
                var cleanValue = inputValue.replace(/\D+/g, "");
                var currentYear = (new Date).getFullYear();
                if (Number(cleanValue) === 0) {
                    return new Date("1/1/".concat(currentYear));
                }
                if (cleanValue.length === 1) {
                    return new Date("".concat(cleanValue, "/1/").concat(currentYear));
                }
                var month = inputValue.search(/\W/) === 1 ? getMonthFromString("0".concat(cleanValue[0])) : getMonthFromString(cleanValue);
                var date = new Date;
                date.setDate(1);
                date.setMonth(Number(month) - 1);
                if (cleanValue.length === 2) {
                    date.setFullYear(currentYear);
                    if (month !== cleanValue) {
                        date.setDate(getDayFromString(cleanValue[1]));
                    }
                    return isNaN(Date.parse(date)) ? null : date;
                }
                var separators = inputValue.match(/\W/g) || [];
                if (separators.length > 1 && !/\W/.test(inputValue[inputValue.length - 1])) {
                    var validDate = new Date(inputValue);
                    return isNaN(Date.parse(validDate)) ? null : validDate;
                }
                var yearStartingIndex;
                var day;
                if (month !== cleanValue.slice(0, 2)) {
                    day = getDayFromString(cleanValue.slice(1, 3), month);
                    yearStartingIndex = Number(cleanValue.slice(1, 3)) > Number(day) ? 2 : 3;
                } else {
                    day = getDayFromString(cleanValue.slice(2, 4), month);
                    yearStartingIndex = Number(cleanValue.slice(2, 4)) > Number(day) ? 3 : 4;
                }
                var year = getYearFromString(cleanValue.slice(yearStartingIndex));
                date.setFullYear(year);
                date.setDate(day);
                return isNaN(Date.parse(date)) ? null : date;
            }
            function interpretMonth(inputValue) {
                if (!inputValue) {
                    return null;
                }
                if (!inputValue.replace(/\s+/g, "")) {
                    return null;
                }
                if (checkCharacters(inputValue) === null) {
                    return null;
                }
                var cleanValue = inputValue.replace(/\D+/g, "");
                if (Number(cleanValue) === 0) {
                    return "01/".concat((new Date).getFullYear());
                }
                var separator = inputValue.match(/\W/);
                var month;
                var year;
                if (separator) {
                    if (separator.index === 1) {
                        month = getMonthFromString("0".concat(inputValue[0]));
                    } else if (separator.index === 2) {
                        month = getMonthFromString(inputValue.slice(0, 2));
                    }
                } else {
                    month = cleanValue.length === 1 ? getMonthFromString("0".concat(cleanValue)) : getMonthFromString(cleanValue);
                }
                if (cleanValue.length === 1) {
                    year = (new Date).getFullYear();
                } else if (cleanValue.length >= 2) {
                    var yearStartingIndex = month !== cleanValue.slice(0, 2) ? 1 : 2;
                    year = getYearFromString(cleanValue.slice(yearStartingIndex));
                }
                var dateForValidation = new Date("".concat(month, "/1/").concat(year));
                return isNaN(Date.parse(dateForValidation)) ? null : "".concat(month, "/").concat(year);
            }
        },
        "./src/utils/table-utils.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "isNumeric", (function() {
                return isNumeric;
            }));
            __webpack_require__.d(__webpack_exports__, "cleanNegativeNum", (function() {
                return cleanNegativeNum;
            }));
            __webpack_require__.d(__webpack_exports__, "isEmptyValue", (function() {
                return isEmptyValue;
            }));
            __webpack_require__.d(__webpack_exports__, "cleanNumber", (function() {
                return cleanNumber;
            }));
            __webpack_require__.d(__webpack_exports__, "cleanDisplayValue", (function() {
                return cleanDisplayValue;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _this = undefined;
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            var isNumeric = function isNumeric(string) {
                _newArrowCheck(this, _this);
                var hasLetters = /[a-z]+/gi.test(string);
                var isNumericFinance = /\$?[0-9]+(\.[0-9]+)?|(\u2014){1}/.test(string);
                return (!string || isNumericFinance) && !hasLetters;
            }.bind(undefined);
            var cleanNegativeNum = function cleanNegativeNum(string) {
                _newArrowCheck(this, _this);
                return string.replace(/-/g, "−");
            }.bind(undefined);
            var isEmptyValue = function isEmptyValue(val) {
                _newArrowCheck(this, _this);
                return val === "" || val === undefined || val === null || val === "—";
            }.bind(undefined);
            function cleanNumber(num) {
                var withMinus = num.replace(/\u2212/g, "-");
                return parseFloat(withMinus.replace(/[^0-9.-]+/g, ""));
            }
            function cleanDisplayValue(val, isFooter) {
                if (isEmptyValue(val) && !isFooter) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span");
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "aria-hidden", "true");
                    _renderArbitrary("—");
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text");
                    _renderArbitrary(this.accessibleSingleValueEmpty);
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                    return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                }
                var isNegativeValue = val[0] === "-" || val[0] === "−";
                if (isNegativeValue) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span");
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "aria-hidden", "true", "class", "negative");
                    _renderArbitrary(cleanNegativeNum(val));
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text");
                    _renderArbitrary("".concat(this.accessibleSingleValueNegative, " ").concat(val.slice(1)));
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                    return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                }
                return val;
            }
        },
        "./src/vertical-navigation/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_vertical_navigation_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/vertical-navigation/mds-vertical-navigation.scss");
            var _mds_vertical_navigation_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_vertical_navigation_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_slot_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/slot-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].boolean, number = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].number;
            var entity = {
                inverse: boolean.defaultsTo(false).withChangedCallback(),
                accessibleName: string,
                activeItem: string.withChangedCallback(),
                activeIndex: number.defaultsTo(-1).withChangedCallback()
            };
            var MdsVerticalNavigation = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsVerticalNavigation, _AgaveComponent);
                _createClass(MdsVerticalNavigation, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsVerticalNavigation";
                    }
                } ]);
                function MdsVerticalNavigation() {
                    var _this;
                    _classCallCheck(this, MdsVerticalNavigation);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsVerticalNavigation).call(this));
                    _this._calculateMenuHeights = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["throttle"])(_this._calculateMenuHeights.bind(_assertThisInitialized(_this)), 100, true);
                    _this._handleActivate = _this._handleActivate.bind(_assertThisInitialized(_this));
                    _this._handleSlotChange = _this._handleSlotChange.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsVerticalNavigation, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsVerticalNavigation.prototype), "connectedCallback", this).call(this);
                        this.shadowRoot.querySelector("slot").addEventListener("slotchange", this._handleSlotChange);
                        this.addEventListener("activate", this._handleActivate);
                        window.addEventListener("resize", this._calculateMenuHeights);
                    }
                }, {
                    key: "disconnectedCallback",
                    value: function disconnectedCallback() {
                        _get(_getPrototypeOf(MdsVerticalNavigation.prototype), "disconnectedCallback", this) && _get(_getPrototypeOf(MdsVerticalNavigation.prototype), "disconnectedCallback", this).call(this);
                        window.removeEventListener("resize", this._calculateMenuHeights);
                    }
                }, {
                    key: "_calculateMenuHeights",
                    value: function _calculateMenuHeights() {
                        var _this2 = this;
                        this.querySelectorAll('mds-vertical-navigation-item[type="collapsible"][expanded="true"]').forEach(function(item) {
                            _newArrowCheck(this, _this2);
                            item.expandedChangedCallback();
                        }.bind(this));
                    }
                }, {
                    key: "_handleSlotChange",
                    value: function _handleSlotChange() {
                        var _this3 = this;
                        _utils_slot_utils__WEBPACK_IMPORTED_MODULE_4__["enforceSlotUsage"].call(this);
                        this.inverse && this.inverseChangedCallback();
                        var footers = this.querySelectorAll("mds-vertical-navigation-footer");
                        if (footers.length > 1) {
                            footers.forEach(function(el) {
                                _newArrowCheck(this, _this3);
                                return el.remove();
                            }.bind(this));
                            this.throwConstraintError("Only one mds-vertical-navigation-footer can be used in the mds-vertical-navigation.");
                        } else if (footers.length && this.children[this.children.length - 1] !== footers[0]) {
                            footers[0].remove();
                            this.throwConstraintError("The mds-vertical-navigation-footer must be the last slotted element in the mds-vertical-navigation.");
                        }
                        var items = this.querySelectorAll("mds-vertical-navigation-item");
                        if (items[items.length - 1].type === "heading") {
                            items[items.length - 1].remove();
                            this.throwConstraintError("The last mds-vertical-navigation-item in the mds-vertical-navigation's slot cannot be a heading.");
                        }
                        this._linkItems.forEach(function(item, i) {
                            _newArrowCheck(this, _this3);
                            item._index = i;
                        }.bind(this));
                        if (this.activeIndex > -1) {
                            this.activeIndexChangedCallback();
                        } else if (this.activeItem) {
                            this.activeItemChangedCallback();
                        }
                    }
                }, {
                    key: "_handleActivate",
                    value: function _handleActivate(event) {
                        this.activeIndex = event.target._index;
                    }
                }, {
                    key: "activeIndexChangedCallback",
                    value: function activeIndexChangedCallback() {
                        if (this._activeLink) {
                            this._activeLink._active = false;
                        }
                        var _linkItems = this._linkItems;
                        if (_linkItems.length) {
                            this._activeIndexChanged = true;
                            if (this.activeIndex > -1 && this.activeIndex < _linkItems.length) {
                                this._activeLink = _linkItems[this.activeIndex];
                                this._activeLink._active = true;
                                this.activeItem = _linkItems[this.activeIndex].label;
                            } else {
                                this.activeItem = null;
                            }
                        }
                    }
                }, {
                    key: "activeItemChangedCallback",
                    value: function activeItemChangedCallback() {
                        if (!this._activeIndexChanged) {
                            var itemNode = this.querySelector('mds-vertical-navigation-item[label="'.concat(this.activeItem, '"]'));
                            this.activeIndex = itemNode ? itemNode._index : -1;
                        }
                        this._activeIndexChanged = false;
                    }
                }, {
                    key: "inverseChangedCallback",
                    value: function inverseChangedCallback() {
                        var _this4 = this;
                        this.querySelectorAll("mds-vertical-navigation-item, mds-vertical-navigation-footer").forEach(function(item) {
                            _newArrowCheck(this, _this4);
                            item._inverse = this.inverse;
                        }.bind(this));
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var navClasses = {
                            "vertical-navigation": true,
                            "vertical-navigation--inverse": this.inverse
                        };
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("nav", null, null, "class", navClasses, "aria-label", this.accessibleName);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("nav");
                    }
                }, {
                    key: "_linkItems",
                    get: function get() {
                        return _toConsumableArray(this.querySelectorAll('mds-vertical-navigation-item[type="link"]'));
                    }
                } ]);
                return MdsVerticalNavigation;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_vertical_navigation_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2._childLocalNames = [ "mds-vertical-navigation-item", "mds-vertical-navigation-footer" ], 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsVerticalNavigation;
        },
        "./src/vertical-navigation/mds-vertical-navigation.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/vertical-navigation/mds-vertical-navigation.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/vertical-navigation/vertical-navigation-footer/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_vertical_navigation_footer_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/vertical-navigation/vertical-navigation-footer/mds-vertical-navigation-footer.scss");
            var _mds_vertical_navigation_footer_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_vertical_navigation_footer_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _utils_slot_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/slot-utils.js");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var MdsVerticalNavigationFooter = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])({}), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsVerticalNavigationFooter, _AgaveComponent);
                _createClass(MdsVerticalNavigationFooter, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsVerticalNavigationFooter";
                    }
                } ]);
                function MdsVerticalNavigationFooter() {
                    var _this;
                    _classCallCheck(this, MdsVerticalNavigationFooter);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsVerticalNavigationFooter).call(this));
                    _this.defineObservedProperty("_inverse", false);
                    _this._handleSlotChange = _utils_slot_utils__WEBPACK_IMPORTED_MODULE_3__["enforceSlotUsage"].bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsVerticalNavigationFooter, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsVerticalNavigationFooter.prototype), "connectedCallback", this).call(this);
                        _utils_slot_utils__WEBPACK_IMPORTED_MODULE_3__["enforceSlottedComponentUsage"].call(this);
                        this.shadowRoot.querySelector("slot").addEventListener("slotchange", this._handleSlotChange);
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var classes = {
                            "vertical-navigation-footer": true,
                            "vertical-navigation-footer--inverse": this._inverse
                        };
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("footer", null, null, "class", classes, "onclick", _utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["stopPropagation"], "onkeydown", _utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["stopPropagation"], "onkeyup", _utils_common_utils__WEBPACK_IMPORTED_MODULE_4__["stopPropagation"]);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("footer");
                    }
                } ]);
                return MdsVerticalNavigationFooter;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_vertical_navigation_footer_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2._parentLocalNames = [ "mds-vertical-navigation" ], _class2._childLocalNames = [ "a", "span" ], 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsVerticalNavigationFooter;
        },
        "./src/vertical-navigation/vertical-navigation-footer/mds-vertical-navigation-footer.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/vertical-navigation/vertical-navigation-footer/mds-vertical-navigation-footer.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/vertical-navigation/vertical-navigation-item/MdsVerticalNavigationItem.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "renderCollapsibleItem", (function() {
                return renderCollapsibleItem;
            }));
            __webpack_require__.d(__webpack_exports__, "renderHeadingItem", (function() {
                return renderHeadingItem;
            }));
            __webpack_require__.d(__webpack_exports__, "renderLinkItem", (function() {
                return renderLinkItem;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            function renderCollapsibleItem() {
                var buttonClasses = {
                    "vertical-navigation-item": true,
                    "vertical-navigation-item--collapsible": true,
                    "vertical-navigation-item--nested": this._nested,
                    "vertical-navigation-item--active": this._active,
                    "vertical-navigation-item--inverse": this._inverse
                };
                var iconClasses = {
                    "vertical-navigation-item__icon": true,
                    "vertical-navigation-item__icon--collapsible": true,
                    "vertical-navigation-item__icon--expanded": this.expanded,
                    "vertical-navigation-item__icon--inverse": this._inverse
                };
                var slotClasses = {
                    "vertical-navigation-item__submenu": true,
                    "vertical-navigation-item__submenu--expanded": this.expanded
                };
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "role", "heading", "aria-level", this._nested ? 3 : 2);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text");
                _renderArbitrary(this.label);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("button", null, null, "class", buttonClasses, "aria-expanded", this.expanded, "onclick", this._handleButtonClick, "onfocus", this._onfocus, "onblur", this._onblur, "onkeydown", this._onkeydown, "onkeyup", this._onkeyup);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", iconClasses, "innerHTML-prop", MDS.svgs["ico_caret_right"], "aria-hidden", "true", "__skip", "true");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                _renderArbitrary(this.label);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("button");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", slotClasses);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function renderHeadingItem() {
                var classes = {
                    "vertical-navigation-item": true,
                    "vertical-navigation-item--heading": true,
                    "vertical-navigation-item--inverse": this._inverse
                };
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes, "role", "heading", "aria-level", "2", "onclick", _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["stopPropagation"], "onmousedown", _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["preventDefault"]);
                _renderArbitrary(this.label);
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            function renderLinkItem() {
                var anchorClasses = {
                    "vertical-navigation-item": true,
                    "vertical-navigation-item--nested": this._nested && !this.parentElement._nested,
                    "vertical-navigation-item--nested-twice": this._nested && this.parentElement._nested,
                    "vertical-navigation-item--active": this._active,
                    "vertical-navigation-item--inverse": this._inverse
                };
                var labelClasses = {
                    "vertical-navigation-item__label": true,
                    "vertical-navigation-item__label--with-leading-icon": this.icon,
                    "vertical-navigation-item__label--with-badge": this.badgeLabel
                };
                var iconClasses = {
                    "vertical-navigation-item__icon": true,
                    "vertical-navigation-item__icon--leading": true,
                    "vertical-navigation-item__icon--inverse": this._inverse
                };
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("a", null, null, "class", anchorClasses, "href", this.href, "onclick", this._handleLinkClick, "onfocus", this._onfocus, "onblur", this._onblur, "onkeydown", this._onkeydown, "onkeyup", this._onkeyup, "aria-current", this._active ? "page" : false);
                _renderArbitrary(this.icon && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", iconClasses, "innerHTML-prop", MDS.svgs[this.icon], "aria-hidden", "true", "__skip", "true"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", labelClasses);
                _renderArbitrary(this.label);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                _renderArbitrary(this.badgeLabel && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("mds-badge", null, null, "class", "vertical-navigation-item__badge", "label-value", this.badgeLabel, "accessible-name", ", ".concat(this.badgeAccessibleText || this.badgeLabel)));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("a");
            }
        },
        "./src/vertical-navigation/vertical-navigation-item/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_vertical_navigation_item_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/vertical-navigation/vertical-navigation-item/mds-vertical-navigation-item.scss");
            var _mds_vertical_navigation_item_scss__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_vertical_navigation_item_scss__WEBPACK_IMPORTED_MODULE_1__);
            var _utils_slot_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/slot-utils.js");
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/data-utils.js");
            var _MdsVerticalNavigationItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/vertical-navigation/vertical-navigation-item/MdsVerticalNavigationItem.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            var boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].boolean, string = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].stringRequired, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["MarshalerTypes"].enumerables;
            var entity = {
                badgeLabel: string,
                badgeAccessibleText: string,
                expanded: boolean.defaultsTo(false).withChangedCallback(),
                href: string.defaultsTo("javascript:void(0)"),
                icon: enumerables.apply(void 0, [ string ].concat(_toConsumableArray(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["ICON_TYPES"]), [ "" ])),
                label: stringRequired,
                type: enumerables(string, "link", "heading", "collapsible").defaultsTo("link")
            };
            var MdsVerticalNavigationItem = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsVerticalNavigationItem, _AgaveComponent);
                _createClass(MdsVerticalNavigationItem, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsVerticalNavigationItem";
                    }
                } ]);
                function MdsVerticalNavigationItem() {
                    var _this;
                    _classCallCheck(this, MdsVerticalNavigationItem);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsVerticalNavigationItem).call(this));
                    _this.defineObservedProperty("_nested", false);
                    _this.defineObservedProperty("_inverse", false);
                    _this.defineObservedProperty("_active", false);
                    _this._handleSlotChange = _this._handleSlotChange.bind(_assertThisInitialized(_this));
                    _this._handleButtonClick = _this._handleButtonClick.bind(_assertThisInitialized(_this));
                    _this._handleLinkClick = _this._handleLinkClick.bind(_assertThisInitialized(_this));
                    _this._onfocus = _this._onfocus.bind(_assertThisInitialized(_this));
                    _this._onblur = _this._onblur.bind(_assertThisInitialized(_this));
                    _this._onkeydown = _this._onkeydown.bind(_assertThisInitialized(_this));
                    _this._onkeyup = _this._onkeyup.bind(_assertThisInitialized(_this));
                    _this._bottomMargin = 1;
                    return _this;
                }
                _createClass(MdsVerticalNavigationItem, [ {
                    key: "_getInteractiveElement",
                    value: function _getInteractiveElement() {
                        return {
                            interactiveElement: this.shadowRoot.querySelector("button, a")
                        };
                    }
                }, {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsVerticalNavigationItem.prototype), "connectedCallback", this).call(this);
                        _utils_slot_utils__WEBPACK_IMPORTED_MODULE_2__["enforceSlottedComponentUsage"].call(this);
                        if (this.type === "collapsible") {
                            this._menu = this.shadowRoot.querySelector(".vertical-navigation-item__submenu");
                            this.shadowRoot.querySelector("slot").addEventListener("slotchange", this._handleSlotChange);
                        }
                        this._itemNode = this.shadowRoot.querySelector(".vertical-navigation-item");
                    }
                }, {
                    key: "expandedChangedCallback",
                    value: function expandedChangedCallback() {
                        var _this2 = this;
                        var expanded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.expanded;
                        if (this.parentElement && !this.parentElement.expanded && this.parentElement.type === "collapsible") {
                            this.parentElement.expanded = true;
                        }
                        var menuHeight = _toConsumableArray(this.children).reduce(function(acc, child) {
                            _newArrowCheck(this, _this2);
                            if (expanded) {
                                acc += child.type === "collapsible" ? child.offsetHeight + this._bottomMargin : child.offsetHeight;
                            }
                            return acc;
                        }.bind(this), 0);
                        this._nested && this._setParentMenuHeight(menuHeight + this._itemNode.offsetHeight + this._bottomMargin);
                        if (this._menu) {
                            this._menu.style.height = "".concat(menuHeight, "px");
                        }
                    }
                }, {
                    key: "_setParentMenuHeight",
                    value: function _setParentMenuHeight(thisHeight) {
                        var _this3 = this;
                        var menuHeight = _toConsumableArray(this.parentElement.children).reduce(function(acc, child) {
                            _newArrowCheck(this, _this3);
                            if (child !== this) {
                                acc += this._bottomMargin + child.expanded ? child.offsetHeight : child._itemNode.offsetHeight;
                            }
                            return acc;
                        }.bind(this), 0);
                        this.parentElement._menu.style.height = "".concat(menuHeight + thisHeight, "px");
                    }
                }, {
                    key: "_handleSlotChange",
                    value: function _handleSlotChange() {
                        var _this4 = this;
                        _toConsumableArray(this.children).forEach(function(child) {
                            _newArrowCheck(this, _this4);
                            if (child.type === "heading") {
                                child.remove();
                                this.throwConstraintError("Heading items cannot be nested.");
                            }
                            if (this._nested && child.type === "collapsible") {
                                child.remove();
                                this.throwConstraintError("Collapsible items can only be nested one level.");
                            }
                            child._nested = true;
                        }.bind(this));
                    }
                }, {
                    key: "_handleButtonClick",
                    value: function _handleButtonClick(event) {
                        this.expanded = !this.expanded;
                        _get(_getPrototypeOf(MdsVerticalNavigationItem.prototype), "_onclick", this) && _get(_getPrototypeOf(MdsVerticalNavigationItem.prototype), "_onclick", this).call(this, event);
                    }
                }, {
                    key: "_handleLinkClick",
                    value: function _handleLinkClick(event) {
                        !this._active && this.dispatchEvent(new CustomEvent("activate", {
                            bubbles: true,
                            composed: true
                        }));
                        _get(_getPrototypeOf(MdsVerticalNavigationItem.prototype), "_onclick", this) && _get(_getPrototypeOf(MdsVerticalNavigationItem.prototype), "_onclick", this).call(this, event);
                    }
                }, {
                    key: "render",
                    value: function render() {
                        if (this.type === "collapsible") {
                            _MdsVerticalNavigationItem__WEBPACK_IMPORTED_MODULE_4__["renderCollapsibleItem"].call(this);
                        } else if (this.type === "heading") {
                            _MdsVerticalNavigationItem__WEBPACK_IMPORTED_MODULE_4__["renderHeadingItem"].call(this);
                        } else {
                            _MdsVerticalNavigationItem__WEBPACK_IMPORTED_MODULE_4__["renderLinkItem"].call(this);
                        }
                    }
                } ]);
                return MdsVerticalNavigationItem;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_0___default.a), _class2.styles = _mds_vertical_navigation_item_scss__WEBPACK_IMPORTED_MODULE_1___default.a, 
            _class2._parentLocalNames = [ "mds-vertical-navigation", "mds-vertical-navigation-item" ], 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsVerticalNavigationItem;
        },
        "./src/vertical-navigation/vertical-navigation-item/mds-vertical-navigation-item.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/vertical-navigation/vertical-navigation-item/mds-vertical-navigation-item.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/video-player/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _brightcove_player_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/@brightcove/player-loader/dist/brightcove-player-loader.es.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_2__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            var _mds_video_player_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/video-player/mds-video-player.scss");
            var _mds_video_player_scss__WEBPACK_IMPORTED_MODULE_4___default = __webpack_require__.n(_mds_video_player_scss__WEBPACK_IMPORTED_MODULE_4__);
            var _mds_video_player_icon_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/video-player/mds-video-player-icon.scss");
            var _mds_video_player_icon_scss__WEBPACK_IMPORTED_MODULE_5___default = __webpack_require__.n(_mds_video_player_icon_scss__WEBPACK_IMPORTED_MODULE_5__);
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _dec, _class, _class2;
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_2__["MarshalerTypes"].stringRequired, object = _mds_agave__WEBPACK_IMPORTED_MODULE_2__["MarshalerTypes"].object;
            var entity = {
                accountId: stringRequired,
                playerId: stringRequired,
                videoId: stringRequired,
                config: object.defaultsTo({})
            };
            var MdsVideoPlayer = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_2__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsVideoPlayer, _AgaveComponent);
                _createClass(MdsVideoPlayer, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsVideoPlayer";
                    }
                } ]);
                function MdsVideoPlayer() {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsVideoPlayer);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsVideoPlayer).call(this));
                    _this.playerLoaded = new Promise(function(res, reject) {
                        _newArrowCheck(this, _this2);
                        _this._videoLoaderResolve = res;
                        _this._videoLoaderReject = reject;
                    }.bind(this));
                    _this._parentShadowRoot = _this._checkForParentShadowRoot(_assertThisInitialized(_this));
                    _this._handleTimeupdate = _this._handleTimeupdate.bind(_assertThisInitialized(_this));
                    _this._handleVolumeChange = _this._handleVolumeChange.bind(_assertThisInitialized(_this));
                    _this._getProgressCompleteEventDispatcher = _this._getProgressCompleteEventDispatcher.bind(_assertThisInitialized(_this));
                    _this._timeupdateDispatcher = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "timeupdate";
                    }.bind(this), _assertThisInitialized(_this));
                    _this._dispatchPlayEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "play";
                    }.bind(this), _assertThisInitialized(_this));
                    _this._dispatchPauseEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "pause";
                    }.bind(this), _assertThisInitialized(_this));
                    _this._dispatchVolumeChangeEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "volumechange";
                    }.bind(this), _assertThisInitialized(_this));
                    _this._dispatchMuteEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "mute";
                    }.bind(this), _assertThisInitialized(_this));
                    _this._progressCompleteEventPercents = [ 0, 25, 50, 75, 100 ];
                    _this._lastTimeupdateTimestamp = null;
                    _this._lastPercentageEventDispatched = 0;
                    _this._muted = !!_this.config.muted;
                    return _this;
                }
                _createClass(MdsVideoPlayer, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsVideoPlayer.prototype), "connectedCallback", this).call(this);
                        var element = this;
                        MdsVideoPlayer._appendIconStyle(element);
                    }
                }, {
                    key: "_getProgressCompleteEventDispatcher",
                    value: function _getProgressCompleteEventDispatcher(eventPercent) {
                        var _this3 = this;
                        if (!this._progressCompleteEventDispatchers) {
                            this._progressCompleteEventDispatchers = new Map;
                        }
                        if (this._progressCompleteEventDispatchers.has(eventPercent)) {
                            return this._progressCompleteEventDispatchers.get(eventPercent);
                        }
                        var dispatcher = eventPercent === 0 ? null : Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this3);
                            return "progress".concat(eventPercent, "PercentComplete");
                        }.bind(this), this);
                        this._progressCompleteEventDispatchers.set(eventPercent, function(event, additionalDetails) {
                            _newArrowCheck(this, _this3);
                            this._lastPercentageEventDispatched = eventPercent;
                            dispatcher && dispatcher(event, additionalDetails);
                        }.bind(this));
                        return this._progressCompleteEventDispatchers.get(eventPercent);
                    }
                }, {
                    key: "_processParentShadowRoot",
                    value: function _processParentShadowRoot() {
                        var _this4 = this;
                        _toConsumableArray(document.getElementsByTagName("style")).slice(0, 2).forEach(function(styleNode) {
                            _newArrowCheck(this, _this4);
                            var node = styleNode.cloneNode(true);
                            this._parentShadowRoot.appendChild(node);
                        }.bind(this));
                        MdsVideoPlayer._appendIconStyle(this._parentShadowRoot);
                    }
                }, {
                    key: "_checkForParentShadowRoot",
                    value: function _checkForParentShadowRoot(element) {
                        if (element instanceof ShadowRoot) return element;
                        if (!element.parentNode) return null;
                        return this._checkForParentShadowRoot(element.parentNode);
                    }
                }, {
                    key: "_handleTimeupdate",
                    value: function _handleTimeupdate(event) {
                        var _this5 = this;
                        var now = Date.now();
                        var _MdsVideoPlayer$_getP = MdsVideoPlayer._getPlayerFromEvent(event).cache_, currentTime = _MdsVideoPlayer$_getP.currentTime, duration = _MdsVideoPlayer$_getP.duration;
                        var additionalDetails = {
                            currentTime: currentTime,
                            duration: duration,
                            percent: currentTime / duration * 100
                        };
                        if (!this._lastTimeupdateTimestamp || now > this._lastTimeupdateTimestamp + 1e3) {
                            this._lastTimeupdateTimestamp = now;
                            this._timeupdateDispatcher(event, additionalDetails);
                        }
                        var eventPercent = Math.max.apply(Math, _toConsumableArray(this._progressCompleteEventPercents.filter(function(x) {
                            _newArrowCheck(this, _this5);
                            return x <= additionalDetails.percent;
                        }.bind(this))));
                        if (this._lastPercentageEventDispatched !== eventPercent) {
                            this._getProgressCompleteEventDispatcher(eventPercent)(event, additionalDetails);
                        }
                    }
                }, {
                    key: "_handleVolumeChange",
                    value: function _handleVolumeChange(event) {
                        var player = MdsVideoPlayer._getPlayerFromEvent(event);
                        if (this._muted && !player.muted() && player.volume() > 0) {
                            this._muted = false;
                            this._dispatchMuteEvent(event, {
                                muted: false
                            });
                        } else if (!this._muted && (player.muted() || player.volume() === 0)) {
                            this._muted = true;
                            this._dispatchMuteEvent(event, {
                                muted: true
                            });
                        }
                        var additionalDetails = {
                            volume: player.volume(),
                            muted: this._muted
                        };
                        this._dispatchVolumeChangeEvent(event, additionalDetails);
                    }
                }, {
                    key: "_renderVideo",
                    value: function _renderVideo() {
                        var _this6 = this;
                        var params = {
                            accountId: this.accountId,
                            playerId: this.playerId,
                            videoId: this.videoId,
                            refNode: this,
                            options: this.config
                        };
                        if (window.default) {
                            delete window.default;
                        }
                        Object(_brightcove_player_loader__WEBPACK_IMPORTED_MODULE_1__["default"])(params).then(function(success) {
                            _newArrowCheck(this, _this6);
                            this.player = success.ref;
                            this.player.on("timeupdate", this._handleTimeupdate);
                            this.player.on("play", this._dispatchPlayEvent);
                            this.player.on("pause", this._dispatchPauseEvent);
                            this.player.on("volumechange", this._handleVolumeChange);
                            this._videoLoaderResolve(success);
                            if (this._parentShadowRoot) {
                                this._processParentShadowRoot();
                            }
                            console.debug("BC Success::", success, " The BC Player Ref::", this.player);
                        }.bind(this)).catch(function(err) {
                            _newArrowCheck(this, _this6);
                            console.error("BC Error:", err);
                            this._videoLoaderReject(err);
                        }.bind(this));
                    }
                }, {
                    key: "renderedCallback",
                    value: function renderedCallback() {
                        this._renderVideo();
                    }
                }, {
                    key: "render",
                    value: function render() {
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot");
                    }
                } ], [ {
                    key: "_appendIconStyle",
                    value: function _appendIconStyle(element) {
                        var styleNode = document.createElement("style");
                        styleNode.innerHTML = _mds_video_player_icon_scss__WEBPACK_IMPORTED_MODULE_5___default.a;
                        element.appendChild(styleNode);
                    }
                }, {
                    key: "_getPlayerFromEvent",
                    value: function _getPlayerFromEvent(event) {
                        var playerSelector = event.manuallyTriggered ? "player_" : "player";
                        return event.target[playerSelector];
                    }
                } ]);
                return MdsVideoPlayer;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_2___default.a), _class2.styles = _mds_video_player_scss__WEBPACK_IMPORTED_MODULE_4___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsVideoPlayer;
        },
        "./src/video-player/mds-video-player-icon.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/video-player/mds-video-player-icon.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/video-player/mds-video-player.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/video-player/mds-video-player.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        0: function(module, exports) {},
        d3: function(module, exports) {
            module.exports = __WEBPACK_EXTERNAL_MODULE_d3__;
        }
    });
}));